export const TWILIO_ERROR_CODES = {
  22225: {
    code: 22225,
    message: 'From Bundle to Replace Items does not exist',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 22225\r\n\r\n### From Bundle to Replace Items does not exist\r\n\r\n The FromBundleSid specified does not exist.\r\n\r\n#### Possible Causes\r\nThe FromBundleSid specified does not exist.\r\n\r\n#### Possible Solutions\r\nPlease review the FromBundleSid specified to ensure it is correctly referencing the account's BundleSid and not another account.",
    causes: 'The FromBundleSid specified does not exist.',
    solutions:
      "Please review the FromBundleSid specified to ensure it is correctly referencing the account's BundleSid and not another account.",
    description: 'The FromBundleSid specified does not exist.',
    product: 'Phone Numbers',
    date_created: '2022-03-10T23:34:59Z',
    last_updated: '2022-03-10T23:34:59Z',
  },
  80612: {
    code: 80612,
    message: 'Duplicate Entry',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80612\r\n\r\n### Duplicate Entry\r\n\r\n \r\n\r\n#### Possible Causes\r\nYou tried to add a participant with an identifier that already exists, or existed for a participant that was deleted.\r\n\r\n#### Possible Solutions\r\nYou may not add a participant with the same identifier as a previously removed participant.',
    causes:
      'You tried to add a participant with an identifier that already exists, or existed for a participant that was deleted.',
    solutions:
      'You may not add a participant with the same identifier as a previously removed participant.',
    description: null,
    product: 'Proxy',
    date_created: '2018-04-10T03:31:44Z',
    last_updated: '2020-08-04T10:00:13.908Z',
  },
  13000: {
    code: 13000,
    message: 'Conference Noun cannot be mixed with Number nouns',
    log_level: 'WARNING',
    secondary_message: 'The Conference noun can only be used once inside a Dial verb',
    log_type: null,
    docs: null,
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:30Z',
    last_updated: '2020-08-04T10:00:29.095Z',
  },
  11750: {
    code: 11750,
    message: 'TwiML response body too large',
    log_level: 'ERROR',
    secondary_message:
      'In your response to Twilio’s request, the response body is larger than 64 kB.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 11750\r\n\r\n### TwiML response body too large\r\n\r\nIn your response to Twilio’s request, the response body is larger than 64 kB. ## Error - 11750\r\n\r\n## TwiML response body too large\r\n\r\nIn your response to Twilio\'s request, the response body is larger than 64 kB.\r\n\r\n#### Possible Causes\r\n*   The TwiML that you are serving is larger than 64 kB\r\n*   You are serving non-TwiML content in your response; e.g. error message output\r\n\r\n#### Possible Solutions\r\n*  Verify that you are serving TwiML in your response to Twilio\'s request. \r\n*  Verify that you are including this header in your TwiML response: `<?xml version="1.0" encoding="UTF-8"?>`  \r\n*  Limit your TwiML response to 64 kB or less.\r\n*  Does your TwiML include the [Play verb](https://www.twilio.com/docs/voice/twiml/play)? Double-check the encoding and MIME type to ensure they are supported.\r\n*  Check that your TwiML is formatted properly. To quickly verify your TwiML, you can copy and paste it into a new [TwiML bin in the Twilio Console](https://www.twilio.com/console/runtime/twiml-bins/create).\r\n*   Check to see if your application is throwing errors. This may cause your application to send a large debug output back to Twilio instead of the expected TwiML.\r\n*  If you are trying to send a `200` response in a status callback, use an empty TwiML response: `<Response/>`',
    causes:
      '*   The TwiML that you are serving is larger than 64 kB\r\n*   You are serving non-TwiML content in your response; e.g. error message output',
    solutions:
      '*  Verify that you are serving TwiML in your response to Twilio\'s request. \r\n*  Verify that you are including this header in your TwiML response: `<?xml version="1.0" encoding="UTF-8"?>`  \r\n*  Limit your TwiML response to 64 kB or less.\r\n*  Does your TwiML include the [Play verb](https://www.twilio.com/docs/voice/twiml/play)? Double-check the encoding and MIME type to ensure they are supported.\r\n*  Check that your TwiML is formatted properly. To quickly verify your TwiML, you can copy and paste it into a new [TwiML bin in the Twilio Console](https://www.twilio.com/console/runtime/twiml-bins/create).\r\n*   Check to see if your application is throwing errors. This may cause your application to send a large debug output back to Twilio instead of the expected TwiML.\r\n*  If you are trying to send a `200` response in a status callback, use an empty TwiML response: `<Response/>`',
    description:
      "## Error - 11750\r\n\r\n## TwiML response body too large\r\n\r\nIn your response to Twilio's request, the response body is larger than 64 kB.",
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:14:30Z',
    last_updated: '2021-08-23T20:58:15.1019Z',
  },
  95112: {
    code: 95112,
    message: 'Invalid sample rate found on media',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95112\r\n\r\n### Invalid sample rate found on media\r\n\r\n The media sample rate is less than the minimum required to transcribe.\r\n\r\n#### Possible Causes\r\nThe media file sample rate is less than 8KHz.\r\n\r\n#### Possible Solutions\r\nUse media with a higher sample rate.',
    causes: 'The media file sample rate is less than 8KHz.',
    solutions: 'Use media with a higher sample rate.',
    description: 'The media sample rate is less than the minimum required to transcribe.',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:37:25Z',
    last_updated: '2024-04-16T17:37:25Z',
  },
  62034: {
    code: 62034,
    message: 'Interconnect: No useful parameters provided.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 62034 \r\n\r\n#### Possible Causes \r\n*  No useful parameters provided\r\n\r\n#### Possible Solutions\r\n*  The request you made expected at least 1 optional parameter, but none was provided. Please add a parameter and/or confirm that is was not misspelled.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:52:34Z',
    last_updated: '2020-08-04T10:00:20.655Z',
  },
  82001: {
    code: 82001,
    message: 'Function invocation resulted in StatusCode 4xx',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 82001\r\n\r\n### Function invocation resulted in StatusCode 4xx\r\n\r\n Your Function invocation returned a 4xx StatusCode.\r\n\r\n#### Possible Causes\r\n* Function route does not exist.\r\n* Function is set to Private and invocation request is not signed.\r\n\r\n#### Possible Solutions\r\n* Check the Function route you are invoking exists.\r\n* Check whether the Function's *Access Control* is set to Private and whether you intended to have it set as so. If it is Private, then your request must be properly signed.",
    causes:
      '* Function route does not exist.\r\n* Function is set to Private and invocation request is not signed.',
    solutions:
      "* Check the Function route you are invoking exists.\r\n* Check whether the Function's *Access Control* is set to Private and whether you intended to have it set as so. If it is Private, then your request must be properly signed.",
    description: 'Your Function invocation returned a 4xx StatusCode.',
    product: 'Functions',
    date_created: '2018-09-12T03:00:55Z',
    last_updated: '2023-11-02T21:26:51.366571Z',
  },
  60616: {
    code: 60616,
    message: 'Lookup rate limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60616\r\n\r\n### Lookup rate limit exceeded\r\n\r\n The rate of lookup requests exceeds allowable limits for the requested package.\r\n\r\n#### Possible Causes\r\nYour application is making lookups at a rate higher than allowed for the requested package. This may be intentional or the result of an unexpected condition in your code.\r\n\r\n#### Possible Solutions\r\nOur downstream providers do not have uniform rate limits. Confirm the published rate limits for the requested package and debug your application to ensure your lookup request rate remains under allowed limits.',
    causes:
      'Your application is making lookups at a rate higher than allowed for the requested package. This may be intentional or the result of an unexpected condition in your code.',
    solutions:
      'Our downstream providers do not have uniform rate limits. Confirm the published rate limits for the requested package and debug your application to ensure your lookup request rate remains under allowed limits.',
    description: 'The rate of lookup requests exceeds allowable limits for the requested package.',
    product: 'Lookup',
    date_created: '2022-03-15T17:23:36Z',
    last_updated: '2022-03-15T17:23:36Z',
  },
  30111: {
    code: 30111,
    message: 'Url is on a deny list',
    log_level: 'ERROR',
    secondary_message: 'The URL provided is blocked.',
    log_type: 'TWILIO',
    docs: '## ERROR - 30111\r\n\r\n### Url is on a deny list\r\n\r\nThe URL provided is blocked. The URL provided is blocked.\r\n\r\n#### Possible Causes\r\n- Fraudulent activity has been detected on this url\r\n- Domain owner has requested Twilio not link to their site\r\n\r\n#### Possible Solutions\r\nPlease reach out to Twilio support',
    causes:
      '- Fraudulent activity has been detected on this url\r\n- Domain owner has requested Twilio not link to their site',
    solutions: 'Please reach out to Twilio support',
    description: 'The URL provided is blocked.',
    product: 'Programmable SMS',
    date_created: '2020-05-05T20:42:51Z',
    last_updated: '2023-11-01T19:28:53.416952Z',
  },
  60367: {
    code: 60367,
    message: 'Invalid entity identity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60367\r\n\r\n### Invalid entity identity\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Entity identity in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Entity identity in the request body is correct.',
    causes: 'The Entity identity in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Entity identity in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-19T11:29:59Z',
    last_updated: '2023-12-19T11:29:59Z',
  },
  53628: {
    code: 53628,
    message: 'Room recordings deleted',
    log_level: 'ERROR',
    secondary_message: 'The recordings for the room have been deleted from the system',
    log_type: null,
    docs: "## Error -  53628\r\n\r\n### Room recordings deleted\r\n\r\nThe recordings for the room specified in your composition job have been deleted. Although the metadata for the recordings is present, the media has been removed from the Twilio Cloud and can't be recovered.\r\n\r\n#### Causes\r\n\r\n * You have deleted your Room Recordings, either from the console or the API.\r\n\r\n#### Solutions\r\n\r\n * There's no solution for this. Once the recorded media files are deleted from the system, they are gone forever.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-07-02T13:45:27Z',
    last_updated: '2020-08-04T10:00:12.983Z',
  },
  60699: {
    code: 60699,
    message: 'Lookup Usage Disabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60699\r\n\r\n### Lookup Usage Disabled\r\n\r\n \r\n\r\n#### Possible Causes\r\nOur systems have detected abnormal behavior and have disabled Lookup on your account.\r\n\r\n#### Possible Solutions\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to re-activate your account.',
    causes: 'Our systems have detected abnormal behavior and have disabled Lookup on your account.',
    solutions:
      '- [Contact Twilio Support](https://www.twilio.com/help/contact) to re-activate your account.',
    description: 'Usage of Lookup has been disabled on your account',
    product: 'Lookup',
    date_created: '2022-02-04T21:45:13Z',
    last_updated: '2023-01-06T00:51:58.24002Z',
  },
  82009: {
    code: 82009,
    message: 'Multi-valued headers not supported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 82009\r\n\r\n### Multi-valued headers not supported\r\n\r\n Twilio was unable to process the correct response to your Function invocation because your version of Functions is incompatible with multi-valued HTTP response headers.\r\n\r\n#### Possible Causes\r\nA Function invocation has resulted in a Twilio Response with multi-valued headers (i.e. the header value is an array). Multi-valued headers are not supported in Classic Functions, or in @twilio/runtime-handler dependency versions below 1.2.0.\r\n\r\n#### Possible Solutions\r\nUse the new Functions/Assets UI or Serverless API, and upgrade your @twilio/runtime-handler dependency version to 1.2.0 or higher. Please refer to [this](https://www.twilio.com/docs/serverless/functions-assets/handler) for more information about the Runtime Handler, how to upgrade the version, and the currently available versions.\r\nFor Classic Functions, or incompatible Runtime Handler versions, only String-valued headers are permitted.',
    causes:
      'A Function invocation has resulted in a Twilio Response with multi-valued headers (i.e. the header value is an array). Multi-valued headers are not supported in Classic Functions, or in @twilio/runtime-handler dependency versions below 1.2.0.',
    solutions:
      'Use the new Functions/Assets UI or Serverless API, and upgrade your @twilio/runtime-handler dependency version to 1.2.0 or higher. Please refer to [this](https://www.twilio.com/docs/serverless/functions-assets/handler) for more information about the Runtime Handler, how to upgrade the version, and the currently available versions.\r\nFor Classic Functions, or incompatible Runtime Handler versions, only String-valued headers are permitted.',
    description:
      'Twilio was unable to process the correct response to your Function invocation because your version of Functions is incompatible with multi-valued HTTP response headers.',
    product: 'Functions',
    date_created: '2022-01-27T00:50:47Z',
    last_updated: '2023-08-09T13:42:36.741228Z',
  },
  50304: {
    code: 50304,
    message: 'Programmable Chat: Attributes not valid JSON',
    log_level: 'ERROR',
    secondary_message: "Specified Channel's Attributes are not valid JSON.",
    log_type: null,
    docs: "## Error - 50304\r\n\r\n### Programmable Chat: Attributes not valid JSON\t \r\n\r\n#### Possible Causes \r\n*  Specified Channel's Attributes are not valid JSON.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel's Attributes in JSON format are being passed in request. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:50Z',
    last_updated: '2020-08-04T10:00:23.149Z',
  },
  22152: {
    code: 22152,
    message: 'Port In Error - Phone number is inactive or disconnected',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: "## ERROR - 22152\r\n\r\n### Port In Error - Phone number is inactive or disconnected\r\n\r\n The phone number is inactive or disconnected on the losing carrier and so cannot be ported. \r\n\r\n#### Possible Causes\r\nThe phone number is inactive or disconnected on the losing carrier and so cannot be ported. \r\n\r\n#### Possible Solutions\r\nContact the phone number's current carrier to reactivate the phone number, so that you can port it to Twilio.",
    causes:
      'The phone number is inactive or disconnected on the losing carrier and so cannot be ported. ',
    solutions:
      "Contact the phone number's current carrier to reactivate the phone number, so that you can port it to Twilio.",
    description:
      'The phone number is inactive or disconnected on the losing carrier and so cannot be ported. ',
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:02:22Z',
    last_updated: '2024-04-22T23:02:22Z',
  },
  21616: {
    code: 21616,
    message: "The 'From' number matches multiple numbers for your account",
    log_level: 'ERROR',
    secondary_message:
      "You have attempted to send a SMS with a 'From' number that matches more than one number belonging to your account. Please submit the 'From' number in E.164 format to resolve the ambiguity.",
    log_type: null,
    docs: "## Error - 21616\n\n### The 'From' number matches multiple numbers for your account\n\nYou have attempted to send a SMS with a 'From' number that matches more\nthan one number belonging to your account. Please submit the 'From'\nnumber in E.164 format to resolve the ambiguity.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:27Z',
    last_updated: '2020-08-04T10:00:25.025Z',
  },
  13612: {
    code: 13612,
    message: 'Record: Invalid maxLength value',
    log_level: 'WARNING',
    secondary_message:
      "The maxLength attribute must be a positive integer in seconds. See the <a href='/docs/api/twiml/record#maxLength'>Record Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13612 \n\n### Record: Invalid maxLength value\n\nThe maxLength attribute must be a positive integer in seconds. See the <a href='/docs/api/twiml/record#maxLength'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:44Z',
    last_updated: '2020-08-04T10:00:27.839Z',
  },
  19023: {
    code: 19023,
    message: 'Invalid channel type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19023\r\n\r\n### Invalid channel type\r\n\r\n Request with an invalid channel type\r\n\r\n#### Possible Causes\r\nChannel type other than: work, home, other\r\n\r\n#### Possible Solutions\r\nOnly work, home or other are valid channels types',
    causes: 'Channel type other than: work, home, other',
    solutions: 'Only work, home or other are valid channels types',
    description: 'Request with an invalid channel type',
    product: null,
    date_created: '2020-07-21T20:16:40Z',
    last_updated: '2020-08-04T10:00:01.711Z',
  },
  81002: {
    code: 81002,
    message: 'Unexpected event while processing Widget',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 81002\r\n\r\n### Unexpected event while processing Widget\r\n\r\n An unexpected event was received while processing a widget. Studio ignored this event and did not transition to another widget because there was no matching transition available to handle the event. \r\n\r\n*Note:* If the Execution ended correctly, this warning can be ignored.\r\n\r\n#### Possible Causes\r\n* A new call, message, or REST API Execution was initiated for a contact address (e.g. phone number) that already has an active Execution.\r\n* An event came in while processing a widget that cannot handle that event (e.g. incoming message received during Run Function widget).\r\n* A hangup for a phone call was detected while processing a widget that does not have a "Hangup" transition (e.g. HTTP Request or Send Message).\r\n* There was no transition that matched the received event.\r\n\r\n#### Possible Solutions\r\n* Incoming Calls only: Enable [Concurrent Calls](https://www.twilio.com/docs/studio/user-guide#handling-concurrent-calls-from-the-same-number-in-studio) in the Flow\'s Trigger widget.\r\n* REST API-triggered Executions: Use [Studio REST API v2](https://www.twilio.com/docs/studio/rest-api/v2/execution#create-a-new-execution) to create Executions and end any that are still active for the same contact.\r\n* Return results for Function calls and HTTP requests quickly.\r\n* End any [stuck Executions](https://support.twilio.com/hc/en-us/articles/360019383714-Understanding-and-Avoiding-Stuck-Executions-in-Twilio-Studio) via Twilio Console.',
    causes:
      '* A new call, message, or REST API Execution was initiated for a contact address (e.g. phone number) that already has an active Execution.\r\n* An event came in while processing a widget that cannot handle that event (e.g. incoming message received during Run Function widget).\r\n* A hangup for a phone call was detected while processing a widget that does not have a "Hangup" transition (e.g. HTTP Request or Send Message).\r\n* There was no transition that matched the received event.',
    solutions:
      "* Incoming Calls only: Enable [Concurrent Calls](https://www.twilio.com/docs/studio/user-guide#handling-concurrent-calls-from-the-same-number-in-studio) in the Flow's Trigger widget.\r\n* REST API-triggered Executions: Use [Studio REST API v2](https://www.twilio.com/docs/studio/rest-api/v2/execution#create-a-new-execution) to create Executions and end any that are still active for the same contact.\r\n* Return results for Function calls and HTTP requests quickly.\r\n* End any [stuck Executions](https://support.twilio.com/hc/en-us/articles/360019383714-Understanding-and-Avoiding-Stuck-Executions-in-Twilio-Studio) via Twilio Console.",
    description:
      'An unexpected event was received while processing a widget. Studio ignored this event and did not transition to another widget because there was no matching transition available to handle the event. \r\n\r\n*Note:* If the Execution ended correctly, this warning can be ignored.',
    product: 'Studio',
    date_created: '2018-06-26T23:14:17Z',
    last_updated: '2021-07-23T00:43:00.581256Z',
  },
  52108: {
    code: 52108,
    message: 'GCM/FCM device message rate exceeded',
    log_level: 'ERROR',
    secondary_message: 'Too many requests were sent to GCM/FCM service',
    log_type: null,
    docs: '## Error - 52108\r\n\r\n### GCM/FCM device message rate exceeded\r\n\r\n#### Possible Causes \r\n*  The rate of messages to a particular device via GCM/FCM is too high.\r\n\r\n#### Possible Solutions\r\n*  Reduce the number of messages sent to this device and do not immediately retry sending to this device.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:31:02Z',
    last_updated: '2020-08-04T10:00:22.274Z',
  },
  57016: {
    code: 57016,
    message: "'Topic' is empty",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57016\r\n\r\n### 'Topic' is empty\r\n\r\n 'Topic' is not specified\r\n\r\n#### Possible Causes\r\n'Topic' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Topic' is being passed in request. ",
    causes: "'Topic' is not specified",
    solutions: "Confirm a valid 'Topic' is being passed in request. ",
    description: "'Topic' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-06-11T19:04:47Z',
    last_updated: '2021-06-11T19:04:47Z',
  },
  30118: {
    code: 30118,
    message: 'Private key is invalid',
    log_level: 'ERROR',
    secondary_message: 'Unable to parse private key',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30118\r\n\r\n### Private key is invalid\r\n\r\nUnable to parse private key We could not parse the private key uploaded in your request.\r\n\r\n#### Possible Causes\r\n- Data in private key may be corrupted\r\n- Private key info could incorrectly formatted\r\n- Private key data could be missing\r\n\r\n#### Possible Solutions\r\nRe-generate and re-upload private key.',
    causes:
      '- Data in private key may be corrupted\r\n- Private key info could incorrectly formatted\r\n- Private key data could be missing',
    solutions: 'Re-generate and re-upload private key.',
    description: 'We could not parse the private key uploaded in your request.',
    product: 'Programmable SMS',
    date_created: '2020-09-03T19:43:06Z',
    last_updated: '2022-07-15T00:03:53.558779Z',
  },
  60215: {
    code: 60215,
    message: 'Max number of mailers per account reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60215\r\n\r\n### Max number of mailers per account reached\r\n\r\n Max number of mailers per account reached\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nYour account has reached the max number of Mailers\r\n\r\n#### Possible Solutions\r\nDelete/update Mailers that you are not using at the moment',
    causes: 'Your account has reached the max number of Mailers',
    solutions: 'Delete/update Mailers that you are not using at the moment',
    description: 'Max number of mailers per account reached\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-11-27T21:52:13Z',
    last_updated: '2021-05-18T04:47:04.063Z',
  },
  22155: {
    code: 22155,
    message: 'Port In Error - Invalid Pin',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 22155\r\n\r\n### Port In Error - Invalid Pin\r\n\r\n The PIN submitted in the port in request for this phone number does not match the losing carrier's information. \r\n\r\n#### Possible Causes\r\nAn invalid or no PIN for this phone number was submitted as part of the port in request.\r\n\r\n#### Possible Solutions\r\nUpdate PIN in the port in request to one that matches the losing carrier's information. \r\n\r\nPINs are unique to a single phone numbers, so you should not need a new request to change the PIN for just this phone number. Instead update the port in request with the correct PIN.",
    causes:
      'An invalid or no PIN for this phone number was submitted as part of the port in request.',
    solutions:
      "Update PIN in the port in request to one that matches the losing carrier's information. \r\n\r\nPINs are unique to a single phone numbers, so you should not need a new request to change the PIN for just this phone number. Instead update the port in request with the correct PIN.",
    description:
      "The PIN submitted in the port in request for this phone number does not match the losing carrier's information. ",
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:05:08Z',
    last_updated: '2024-04-22T23:05:08Z',
  },
  25008: {
    code: 25008,
    message: 'The requested SCIM user was not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25008\r\n\r\n### The requested SCIM user was not found\r\n\r\n The requested SCIM user was not found.\r\n\r\n#### Possible Causes\r\nOnly managed users can be retrieved using this operation.\r\n\r\n#### Possible Solutions\r\nDouble-check the user's ID for accuracy. Ensure that the user is a managed user, and if the issue persists, consider that the user's data may have been deleted.",
    causes: 'Only managed users can be retrieved using this operation.',
    solutions:
      "Double-check the user's ID for accuracy. Ensure that the user is a managed user, and if the issue persists, consider that the user's data may have been deleted.",
    description: 'The requested SCIM user was not found.',
    product: 'Organizations API',
    date_created: '2023-12-04T09:54:44Z',
    last_updated: '2023-12-04T14:15:37.041183Z',
  },
  51109: {
    code: 51109,
    message: 'Twilsock: Service instance is under legal hold',
    log_level: 'ERROR',
    secondary_message: 'Specified service instance is under legal hold.',
    log_type: null,
    docs: '## Error - 51109\r\n\r\n### Service instance is under legal hold\r\n\r\n#### Possible Causes \r\nSpecified service instance is under legal hold.\r\n\r\n#### Possible Solutions\r\nPlease use a different service instance.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:13:23Z',
    last_updated: '2020-08-04T10:00:09.771Z',
  },
  80611: {
    code: 80611,
    message: 'Proxy Number In Active Sessions',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 80611\r\n\r\n### Proxy Number In Active Sessions\r\n\r\n The Proxy Number cannot be removed from Service. \r\n\r\n#### Possible Causes\r\nIt is in use by one or more Sessions.\r\n\r\n#### Possible Solutions\r\nThe number can be removed from the Service once it's not in use.",
    causes: 'It is in use by one or more Sessions.',
    solutions: "The number can be removed from the Service once it's not in use.",
    description: 'The Proxy Number cannot be removed from Service. ',
    product: 'Proxy',
    date_created: '2018-01-12T17:09:14Z',
    last_updated: '2020-08-04T10:00:15.312Z',
  },
  21227: {
    code: 21227,
    message: 'Headers portion of SIP URI must be fewer than 1024 chars',
    log_level: 'WARNING',
    secondary_message: 'The headers you are sending must be fewer than 1024 characters.',
    log_type: null,
    docs: '## Warning - 21227\n\n### Headers portion of SIP URI must be fewer than 1024 chars\n\nThe headers you are sending must be fewer than 1024 characters.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:19Z',
    last_updated: '2020-08-04T10:00:25.635Z',
  },
  21504: {
    code: 21504,
    message: 'RecordingSid is required.',
    log_level: 'ERROR',
    secondary_message:
      'You POSTed to the /Accounts/{AccountSid}/Transcriptions resource, but you did not include a RecordingSid.',
    log_type: null,
    docs: '## Error - 21504 \n\n### RecordingSid is required.\n\nYou POSTed to the /Accounts/{AccountSid}/Transcriptions resource, but you did not include a RecordingSid.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:02Z',
    last_updated: '2020-08-04T10:00:26.764Z',
  },
  40114: {
    code: 40114,
    message: 'TaskRouter->Call',
    log_level: 'ERROR',
    secondary_message: 'Call Instruction can only be issued on a currently pending reservation.',
    log_type: null,
    docs: '## Error - 40114\r\n\r\n### The Reservation must currently be Pending - Call Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-08-22T22:59:40Z',
    last_updated: '2020-08-04T10:00:21.31Z',
  },
  21406: {
    code: 21406,
    message: 'Cannot set SmsFallbackUrl without setting SmsUrl',
    log_level: 'ERROR',
    secondary_message: 'You cannot set a fallback URL without specifying a primary URL',
    log_type: null,
    docs: '## Error - 21406 \n\n### Cannot set SmsFallbackUrl without setting SmsUrl\n\nYou cannot set a fallback URL without specifying a primary URL\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:20Z',
    last_updated: '2020-08-04T10:00:25.558Z',
  },
  51106: {
    code: 51106,
    message: "Twilsock: Active product doesn't match with service instance product",
    log_level: 'ERROR',
    secondary_message: 'Passed service instance belongs to another product.',
    log_type: null,
    docs: "## Error - 51106\r\n\r\n### Active product doesn't match with service instance product\r\n\r\n#### Possible Causes \r\nPassed service instance belongs to another product.\r\n\r\n#### Possible Solutions\r\nVerify matching product and service instance is selected.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:09:36Z',
    last_updated: '2020-08-04T10:00:09.826Z',
  },
  33010: {
    code: 33010,
    message: 'Conflicting update',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 33010\r\n\r\n### Conflicting update\r\n\r\n Raised whenever an update is requested while another update is already in progress.\t\r\n\r\n#### Possible Causes\r\n * You cannot change a SIM's status or its Rate Plan while another update is already in progress.\r\n\r\n#### Possible Solutions\r\n * Verify that there is not an update already in progress for the SIM. If an update is in progress, the SIM's status will be either `scheduled` or `updating` and you will need to wait for it to finish before you can make additional updates to the SIM's status or Rate Plan.\r\n",
    causes:
      " * You cannot change a SIM's status or its Rate Plan while another update is already in progress.",
    solutions:
      " * Verify that there is not an update already in progress for the SIM. If an update is in progress, the SIM's status will be either `scheduled` or `updating` and you will need to wait for it to finish before you can make additional updates to the SIM's status or Rate Plan.\r\n",
    description:
      'Raised whenever an update is requested while another update is already in progress.\t',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:13:10Z',
    last_updated: '2020-09-15T11:27:49.036Z',
  },
  40121: {
    code: 40121,
    message: 'TaskRouter->Direct',
    log_level: 'ERROR',
    secondary_message: "Redirect Instruction does not have a valid 'call_sid' parameter provided.",
    log_type: null,
    docs: '## Error - 40121\r\n\r\n### Missing or Invalid \'call_sid\' parameter - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "call_sid" parameter on your \'redirect\' instruction.\r\n*  You provided an invalid value for the "call_sid" parameter. \r\n\r\n#### Possible Solutions\r\n*  Make certain "call_sid" is provided an is a 34char string starting with CA that represents a live call. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:41Z',
    last_updated: '2020-08-04T10:00:23.934Z',
  },
  91003: {
    code: 91003,
    message: 'Account reached the max sink limit',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91003\r\n\r\n### Account reached the max sink limit\r\n\r\n Account reached the max sink limit\r\n\r\n#### Possible Causes\r\n* Have 100 sinks created\r\n\r\n#### Possible Solutions\r\n* Cannot have more than 100 sinks. Make sure to delete at least one sinks before creating another.',
    causes: '* Have 100 sinks created',
    solutions:
      '* Cannot have more than 100 sinks. Make sure to delete at least one sinks before creating another.',
    description: 'Account reached the max sink limit',
    product: 'Events',
    date_created: '2020-09-16T15:47:48Z',
    last_updated: '2021-01-06T16:25:32.743Z',
  },
  52202: {
    code: 52202,
    message: 'Facebook page is not connected to Twilio',
    log_level: 'ERROR',
    secondary_message: 'Facebook page configured in Service is not connected to Twilio',
    log_type: null,
    docs: '## Error - 52202\r\n\r\n### Facebook page ID is not connected to Twilio\r\n\r\n#### Possible Causes \r\n* Facebook page configured in Notify Service instance is not connected to Twilio\r\n* The connection may have been removed after the Notify Service had been configured\r\n\r\n#### Possible Solutions\r\n* [Configure a new Facebook page](https://www.twilio.com/console/notify/services) for your Notify Service\r\n* [Connect the Facebook page](https://www.twilio.com/console/channels) to your Twilio account',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-07-06T13:09:20Z',
    last_updated: '2020-08-04T10:00:18.164Z',
  },
  45357: {
    code: 45357,
    message: 'Downstream error configuring Channel.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45357\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'An error occurred retrieving Participant data from conversations api.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to retrieve Participant(s) for Conversation <conversation sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:33.450816Z',
  },
  16026: {
    code: 16026,
    message: 'Participant label is in use by another participant',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16026\r\n\r\n### Participant label is in use by another participant\r\n\r\n The participant label specified in an API call to create a voice conference participant is already in use by another active participant in the same conference.\r\n\r\n#### Possible Causes\r\n1. The specified label was already used in another API call to add a participant to the conference.\r\n2. The specified label was already used in twiml (Dial Conference) to add an inbound participant to the conference\r\n\r\n#### Possible Solutions\r\nUse a label value which uniquely identifies this participant within the conference.',
    causes:
      '1. The specified label was already used in another API call to add a participant to the conference.\r\n2. The specified label was already used in twiml (Dial Conference) to add an inbound participant to the conference',
    solutions:
      'Use a label value which uniquely identifies this participant within the conference.',
    description:
      'The participant label specified in an API call to create a voice conference participant is already in use by another active participant in the same conference.',
    product: 'Programmable Voice',
    date_created: '2020-04-23T21:41:52Z',
    last_updated: '2020-08-04T10:00:03.799Z',
  },
  22205: {
    code: 22205,
    message: 'Attempting to assign invalid object_sid to Bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22205\r\n\r\n### Attempting to assign invalid object_sid to Bundle\r\n\r\n You are attempting to add an invalid object_sid to the Bundle.\r\n\r\n#### Possible Causes\r\nThe object_sid may be malformed or belonging to a different account.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.',
    causes: 'The object_sid may be malformed or belonging to a different account.',
    solutions:
      'Please refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.',
    description: 'You are attempting to add an invalid object_sid to the Bundle.',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:44:35Z',
    last_updated: '2020-08-04T10:00:05.617Z',
  },
  13802: {
    code: 13802,
    message: 'Dial: No referUrl attribute specified',
    log_level: 'ERROR',
    secondary_message:
      'Twilio received a REFER on an established <Dial> session, but there was no referUrl attribute specified.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 13802\r\n\r\n### Dial: No referUrl attribute specified\r\n\r\nTwilio received a REFER on an established <Dial> session, but there was no referUrl attribute specified. In order to send a SIP REFER message to an established `<Dial>` call, the `referUrl` attribute must be specified in the TwiML. In this case, a REFER was received on a `<Dial>` call without a `referUrl` attribute present.\r\n\r\n#### Possible Causes\r\n* Your `<Dial>` verb did not include a `referUrl` attribute or the attribute was misspelled\r\n\r\n#### Possible Solutions\r\n* Add a valid `referUrl` attribute to your `<Dial>` verb\r\n* For more information on sending REFER to Twilio, see [Refer to Twilio](https://www.twilio.com/docs/voice/api/refer-to-twilio)',
    causes:
      '* Your `<Dial>` verb did not include a `referUrl` attribute or the attribute was misspelled',
    solutions:
      '* Add a valid `referUrl` attribute to your `<Dial>` verb\r\n* For more information on sending REFER to Twilio, see [Refer to Twilio](https://www.twilio.com/docs/voice/api/refer-to-twilio)',
    description:
      'In order to send a SIP REFER message to an established `<Dial>` call, the `referUrl` attribute must be specified in the TwiML. In this case, a REFER was received on a `<Dial>` call without a `referUrl` attribute present.',
    product: 'Programmable Voice',
    date_created: '2020-07-31T22:06:27Z',
    last_updated: '2020-08-04T10:00:00.76Z',
  },
  13241: {
    code: 13241,
    message: 'Dial->SIP: Invalid method value',
    log_level: 'WARNING',
    secondary_message: 'The method attribute of Number must be GET or POST',
    log_type: null,
    docs: '## Warning - 13241 \n\n### Dial->SIP: Invalid method value\n\nThe method attribute of Number must be GET or POST\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:38Z',
    last_updated: '2020-08-04T10:00:28.285Z',
  },
  16002: {
    code: 16002,
    message: 'Failed to validate conference attributes',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16002\r\n\r\n### Failed to validate conference attributes\r\n\r\nThe provided conference attributes are invalid.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:02:11Z',
    last_updated: '2020-08-04T10:00:10.137Z',
  },
  21725: {
    code: 21725,
    message: 'Brand can only be updated when in FAILED state',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21725\r\n\r\n### Brand can only be updated when in FAILED state\r\n\r\n Brand can only be updated when in FAILED state. Contact support for help.\r\n\r\n#### Possible Causes\r\nInvalid Brand status\r\n\r\n#### Possible Solutions\r\n- If Brand is REGISTERED, and needs to be updated, contact Twilio support\r\n- If Brand is IN_PROGRESS, wait for it to exit IN_PROGRESS',
    causes: 'Invalid Brand status',
    solutions:
      '- If Brand is REGISTERED, and needs to be updated, contact Twilio support\r\n- If Brand is IN_PROGRESS, wait for it to exit IN_PROGRESS',
    description: 'Brand can only be updated when in FAILED state. Contact support for help.',
    product: 'Programmable SMS',
    date_created: '2021-11-18T18:23:59Z',
    last_updated: '2021-11-18T18:23:59Z',
  },
  21244: {
    code: 21244,
    message: 'Maximum Number of Trunks reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21244\r\n\r\n### Maximum Number of Trunks reached\r\n\r\n \r\n\r\n#### Possible Causes\r\n*   Maximum Number of Trunks reached.\r\n\r\n#### Possible Solutions\r\n*  Please see limits allowed, visit [Trunking Key Concepts](/docs/sip-trunking/scale-and-limits).',
    causes: '*   Maximum Number of Trunks reached.',
    solutions:
      '*  Please see limits allowed, visit [Trunking Key Concepts](/docs/sip-trunking/scale-and-limits).',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:05:16Z',
    last_updated: '2023-07-28T17:05:29.744518Z',
  },
  16003: {
    code: 16003,
    message: 'Could not recognize conference sid or friendly name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16003\r\n\r\n### Could not recognize conference sid or friendly name\r\n\r\nTwilio could not recognize the provided conference sid or friendly name.  Please see https://www.twilio.com/docs/voice/twiml/conference for more documentation.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:07:56Z',
    last_updated: '2020-08-04T10:00:10.12Z',
  },
  21602: {
    code: 21602,
    message: 'Message body is required',
    log_level: 'ERROR',
    secondary_message: 'You must specify content (text or media) for your message.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 21602\r\n\r\n### Message body is required\r\n\r\nYou must specify content (text or media) for your message. The `Body` OR `MediaURL` parameter is required to send a Message with Twilio.\r\n\r\n#### Possible Causes\r\nYou may have attempted to send a message without a `Body` or `MediaURL` parameter.\r\n\r\n#### Possible Solutions\r\n Retry your message including a body or a link to some media. For sample code that shows how to send an SMS message with Twilio's supported helper libraries, cURL, or the Twilio CLI, please see [this short tutorial](https://www.twilio.com/docs/sms/send-messages)",
    causes: 'You may have attempted to send a message without a `Body` or `MediaURL` parameter.',
    solutions:
      " Retry your message including a body or a link to some media. For sample code that shows how to send an SMS message with Twilio's supported helper libraries, cURL, or the Twilio CLI, please see [this short tutorial](https://www.twilio.com/docs/sms/send-messages)",
    description: 'The `Body` OR `MediaURL` parameter is required to send a Message with Twilio.',
    product: null,
    date_created: '2016-03-31T17:14:02Z',
    last_updated: '2020-08-04T10:00:26.745Z',
  },
  62015: {
    code: 62015,
    message: 'Connection in transition',
    log_level: 'ERROR',
    secondary_message:
      'The connection SID in the request is currently in a state of transition. A connection cannot be transitioned from inactive to active unless if the connection is currently in an inactive state. To transition the connection to an active state, please wait for the connection to be inactive again. ',
    log_type: null,
    docs: '## Error - 62015\r\n\r\n### Connection in transition\r\n\r\nThe connection SID in the request is currently in a state of transition. A connection cannot be transitioned from inactive to active unless if the connection is currently in an inactive state. To transition the connection to an active state, please wait for the connection to be inactive again. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:42:03Z',
    last_updated: '2020-08-04T10:00:20.915Z',
  },
  60378: {
    code: 60378,
    message: 'Authenticator response invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60378\r\n\r\n### Authenticator response invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Authenticator response in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Authenticator response in the request body is correct.',
    causes: 'The Authenticator response in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Authenticator response in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:42:29Z',
    last_updated: '2023-12-27T09:42:29Z',
  },
  30006: {
    code: 30006,
    message: 'Landline or unreachable carrier',
    log_level: 'ERROR',
    secondary_message:
      'The destination number is unable to receive this message. Potential reasons could include trying to reach a landline or, in the case of short codes, an unreachable carrier.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30006\r\n\r\n### Landline or unreachable carrier\r\n\r\nThe destination number is unable to receive this message. Potential reasons could include trying to reach a landline or, in the case of short codes, an unreachable carrier. ### Message Delivery - Landline or unreachable carrier\r\n\r\nThe destination number is unable to receive this message.\r\n\r\n\r\n#### Possible Causes\r\n*  The destination number is unable to receive this message. Potential reasons\r\ncould include trying to reach a landline or, in the case of short codes, an\r\nunreachable carrier.\r\n* Your message was sent to a landline, or an unreachable carrier for this phone number type.\r\n\r\n#### Possible Solutions\r\n* Use [Lookup](https://www.twilio.com/docs/lookup/v2-api/line-type-intelligence) to determine if the number is indeed a landline. If not, try again with a different phone number type. Check out the video linked below for more information. \r\n\r\nhttps://www.youtube.com/watch?v=d8GfbPBaSuM',
    causes:
      '*  The destination number is unable to receive this message. Potential reasons\r\ncould include trying to reach a landline or, in the case of short codes, an\r\nunreachable carrier.\r\n* Your message was sent to a landline, or an unreachable carrier for this phone number type.',
    solutions:
      '* Use [Lookup](https://www.twilio.com/docs/lookup/v2-api/line-type-intelligence) to determine if the number is indeed a landline. If not, try again with a different phone number type. Check out the video linked below for more information. \r\n\r\nhttps://www.youtube.com/watch?v=d8GfbPBaSuM',
    description:
      '### Message Delivery - Landline or unreachable carrier\r\n\r\nThe destination number is unable to receive this message.\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:34Z',
    last_updated: '2024-02-20T19:27:48.521897Z',
  },
  14233: {
    code: 14233,
    message: 'Dial->Conference: Invalid Timeout',
    log_level: 'ERROR',
    secondary_message: 'Provided timeout is not a valid integer',
    log_type: null,
    docs: '## Error - 14233\r\n\r\n### Conference: Provided Timeout was not a valid integer\r\n\r\nProvided Timeout is invalid.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:46:24Z',
    last_updated: '2020-08-04T10:00:21.81Z',
  },
  50412: {
    code: 50412,
    message: 'Participant proxy address is empty',
    log_level: 'ERROR',
    secondary_message: 'The provided participant proxy address parameter must not be empty.',
    log_type: null,
    docs: '\n## Error - 50412\n\n### Conversations: Participant proxy address is empty\nThe provided participant proxy address parameter must not be empty.\n\n#### Possible Causes\n* MessagingBinding.ProxyAddress parameter provided with the request contains an empty string.\n\n#### Possible Solutions\n* Add a non-empty MessagingBinding.ProxyAddress parameter to the API request and supply a valid participant proxy address matching your desired channel, e.g. SMS, MMS or WhatsApp.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.493Z',
  },
  80911: {
    code: 80911,
    message: 'Call To Message Only Session Rejected',
    log_level: 'WARNING',
    secondary_message: 'Example Message: Inbound call to message-only session rejected.',
    log_type: null,
    docs: '## Warning\r\n\r\n### Call To Message Only Session Rejected\r\n\r\nExample Message: Inbound call to message-only session rejected.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-03-12T15:29:05Z',
    last_updated: '2020-08-04T10:00:14.569Z',
  },
  84004: {
    code: 84004,
    message: 'Error while creating execution via REST API.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 84004\r\n\r\n### Error while creating execution via REST API.\r\n\r\n Required values to create execution might not have been provided.\r\n\r\n#### Possible Causes\r\n- The Create Execution endpoint was called with parameters that could not be processed.\r\n\r\n#### Possible Solutions\r\n- Double-check the provided parameters for syntax errors.',
    causes:
      '- The Create Execution endpoint was called with parameters that could not be processed.',
    solutions: '- Double-check the provided parameters for syntax errors.',
    description: 'Required values to create execution might not have been provided.',
    product: null,
    date_created: '2024-01-10T18:11:15Z',
    last_updated: '2024-01-10T18:11:15Z',
  },
  30117: {
    code: 30117,
    message: 'Certificate cannot be parsed',
    log_level: 'ERROR',
    secondary_message: 'Certificate cannot be parsed',
    log_type: 'APPLICATION',
    docs: "## ERROR - 30117\r\n\r\n### Certificate cannot be parsed\r\n\r\nCertificate cannot be parsed We could not parse the certificate uploaded in your request.\r\n\r\n#### Possible Causes\r\n- Data in Certificate may be corrupted\r\n- Certificate info could incorrectly formatted\r\n- Certificate data could be missing\r\n\r\n#### Possible Solutions\r\nRe-generate certificate ensuring it's in PEM format: https://en.wikipedia.org/wiki/Privacy-Enhanced_Mail",
    causes:
      '- Data in Certificate may be corrupted\r\n- Certificate info could incorrectly formatted\r\n- Certificate data could be missing',
    solutions:
      "Re-generate certificate ensuring it's in PEM format: https://en.wikipedia.org/wiki/Privacy-Enhanced_Mail",
    description: 'We could not parse the certificate uploaded in your request.',
    product: 'Programmable SMS',
    date_created: '2020-09-01T18:49:12Z',
    last_updated: '2022-07-15T00:03:20.485543Z',
  },
  21477: {
    code: 21477,
    message: 'Unable to update Status for parent accounts',
    log_level: 'ERROR',
    secondary_message:
      'Unable to update Status for parent accounts, status updates restricted to subaccounts only',
    log_type: null,
    docs: '## Error - 21477\n\n### Unable to update Status for parent accounts\n\nUnable to update Status for parent accounts, status updates restricted to subaccounts only\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:24Z',
    last_updated: '2020-08-04T10:00:25.235Z',
  },
  50417: {
    code: 50417,
    message: 'Participants limit exceeded',
    log_level: 'ERROR',
    secondary_message:
      'The total number of participants in this conversation exceeds the allowed limit.',
    log_type: null,
    docs: '\n## Error - 50417\n\n### Conversations: Participants limit exceeded\nThe total number of participants in this conversation exceeds the limit.\n\n#### Possible Causes\n* You are trying to add more native Programmable Chat participants than allowed in this conversation. Maximum number of conversation participants is 100 by default, can be increased to 1000 programmatically.\n\n#### Possible Solutions\n* Increase the [maximum limit](https://www.twilio.com/docs/chat/rest/service-resource#update-a-service-resource) by using Developer Console or REST API. Up to [1000 participants](https://www.twilio.com/docs/conversations/conversations-limits) are supported.\n* Retrieve a [list of current participants](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) in this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource) the ones that are no longer required.\n* Consider reusing participant identity across multiple clients, if user behavior is similar and data may be shared.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.405Z',
  },
  54011: {
    code: 54011,
    message: 'Invalid TTL',
    log_level: 'ERROR',
    secondary_message:
      'The TTL value in seconds must either be empty or an integer between 0 and 31 536 000 (1 year).',
    log_type: null,
    docs: '## Error - 54011\r\n\r\n### Sync: Invalid TTL\r\nThe TTL value in seconds must either be empty or an integer between 0 and 31 536 000 (1 year).\r\n\r\n#### Possible Causes\r\n* The value supplied for the TTL parameter does not fall into the valid range.\r\n\r\n#### Possible Solutions\r\n* Confirm a valid TTL parameter is being passed in your request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2019-01-07T13:50:02Z',
    last_updated: '2020-08-04T10:00:11.544Z',
  },
  30107: {
    code: 30107,
    message: 'Domain private certificate has not been uploaded',
    log_level: 'ERROR',
    secondary_message:
      'The private certificate required for Twilio to process shortening requests through this domain has not been uploaded',
    log_type: 'APPLICATION',
    docs: "## ERROR - 30107\r\n\r\n### Domain private certificate has not been uploaded\r\n\r\nThe private certificate required for Twilio to process shortening requests through this domain has not been uploaded Twilio requires a private certificate for us to generate and process shortened HTTPS links on your domain. This certificate has not been provided for this domain.\r\n\r\n#### Possible Causes\r\nSetup and configuration wasn't completed for this domain\r\n\r\n#### Possible Solutions\r\nPlease go to the organizations view for your account and ensure that the private certificate has been uploaded for this domain",
    causes: "Setup and configuration wasn't completed for this domain",
    solutions:
      'Please go to the organizations view for your account and ensure that the private certificate has been uploaded for this domain',
    description:
      'Twilio requires a private certificate for us to generate and process shortened HTTPS links on your domain. This certificate has not been provided for this domain.',
    product: 'Programmable SMS',
    date_created: '2020-05-05T19:13:32Z',
    last_updated: '2020-08-04T10:00:03.555Z',
  },
  45784: {
    code: 45784,
    message: 'Internal Error. Failed to get deployment keys.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45784\r\n\r\n### Internal Error. Failed to get deployment keys.\r\n\r\n An unexpected error occurred when processing get all deployment keys request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when processing get all deployment keys request.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when processing get all deployment keys request.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing get all deployment keys request.',
    product: 'Flex',
    date_created: '2023-11-23T04:11:46Z',
    last_updated: '2023-11-23T04:11:46Z',
  },
  70156: {
    code: 70156,
    message: 'Request Hash Is Invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70156\r\n\r\n### Request Hash Is Invalid\r\nThe request hash that is declared in the JWT does not match the given request’s hash calculated by Twilio. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest Twilio helper library. If not using the library, make sure the request hash is calculated on the canonicalized HTTP request and the same canonicalization is used.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:39:55Z',
    last_updated: '2020-08-04T10:00:18.701Z',
  },
  60374: {
    code: 60374,
    message: 'Invalid page token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60374\r\n\r\n### Invalid page token\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Page token in the request is incorrectly formatted\r\n\r\n#### Possible Solutions\r\nCheck that the Page token in the request body is correct.',
    causes: 'The Page token in the request is incorrectly formatted',
    solutions: 'Check that the Page token in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:35:03Z',
    last_updated: '2023-12-27T09:35:03Z',
  },
  64017: {
    code: 64017,
    message: 'Pay: BankAccountType Parameter not supported with PaymentMethod = "credit-card"',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64017\r\n\r\n### Pay: BankAccountType Parameter not supported with PaymentMethod = "credit-card"\r\n\r\n A 64017 Error is an indication there is an unexpected value for the BankAccountNumber parameter.\r\n\r\n#### Possible Causes\r\n* PaymentMethod selected is "credit-card" and a value is provided for BankAccountNumber Parameter\r\n\r\n#### Possible Solutions\r\n* Have PaymentMethod as "ach-debit" when capturing ACH payments which require a BankAccountNumber\r\n* Do not provide BankAccountNumber when collecting a credit card payment',
    causes:
      '* PaymentMethod selected is "credit-card" and a value is provided for BankAccountNumber Parameter',
    solutions:
      '* Have PaymentMethod as "ach-debit" when capturing ACH payments which require a BankAccountNumber\r\n* Do not provide BankAccountNumber when collecting a credit card payment',
    description:
      'A 64017 Error is an indication there is an unexpected value for the BankAccountNumber parameter.',
    product: 'Programmable Voice',
    date_created: '2020-05-05T22:58:17Z',
    last_updated: '2020-08-04T10:00:03.425Z',
  },
  54006: {
    code: 54006,
    message: 'Request entity too large',
    log_level: 'ERROR',
    secondary_message: "The size of the specified 'Data' parameter exceeds the size limit.",
    log_type: null,
    docs: "\n## Error - 54006\n\n### Sync: Request entity too large\nThe size of the specified 'Data' parameter exceeds the size limit.\n\n#### Possible Causes\n* The size of a serialized JSON payload stored in a Sync Document, List Item, or Map Item cannot exceed 16KB; attempting to submit a larger object will yield this error.\n\n#### Possible Solutions\n* Reduce the size of the submitted JSON object by removing or compressing data.\n* Split your data across multiple Map Items, List Items, or Documents.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.809Z',
  },
  94601: {
    code: 94601,
    message: 'Date range is not valid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94601\r\n\r\n### Date range is not valid\r\n\r\n The action could not be performed because the date range provided is not valid.\r\n\r\n#### Possible Causes\r\n * UntilDate is equal or more recent than FromDate.\r\n\r\n#### Possible Solutions\r\n * FromDate should be a recent date than UntilDate.',
    causes: ' * UntilDate is equal or more recent than FromDate.',
    solutions: ' * FromDate should be a recent date than UntilDate.',
    description: 'The action could not be performed because the date range provided is not valid.',
    product: null,
    date_created: '2022-05-09T16:05:49Z',
    last_updated: '2022-05-09T16:05:49Z',
  },
  19041: {
    code: 19041,
    message: 'Invalid or missing Custom Field input',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19041\r\n\r\n### Invalid or missing Custom Field input\r\n\r\n Request body is not valid\r\n\r\n#### Possible Causes\r\nCustom field value is missing, Custom Field value is invalid and/or Custom Field is duplicated\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes:
      'Custom field value is missing, Custom Field value is invalid and/or Custom Field is duplicated',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'Request body is not valid',
    product: null,
    date_created: '2020-07-21T20:33:19Z',
    last_updated: '2020-08-04T10:00:01.241Z',
  },
  25013: {
    code: 25013,
    message: 'Updating the username is unsupported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25013\r\n\r\n### Updating the username is unsupported\r\n\r\n Updating the username is unsupported.\r\n\r\n#### Possible Causes\r\nThe system does not allow updates to the user's username.\r\n\r\n#### Possible Solutions\r\nUsername updates are not permitted. If changes to the username are necessary, reach out to support for guidance on handling specific scenarios.",
    causes: "The system does not allow updates to the user's username.",
    solutions:
      'Username updates are not permitted. If changes to the username are necessary, reach out to support for guidance on handling specific scenarios.',
    description: 'Updating the username is unsupported.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:14:38Z',
    last_updated: '2023-12-04T14:17:48.919294Z',
  },
  45796: {
    code: 45796,
    message:
      'Failed to perform this operation. There  was a conflict with the state of the  resource.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45796\r\n\r\n### Failed to perform this operation. There  was a conflict with the state of the  resource.\r\n\r\n Failed to perform this operation. There  was a conflict with the state of the  resource.\r\n\r\n#### Possible Causes\r\nConflict in the state of target resource possibly because of concurrent requests.\r\n\r\n#### Possible Solutions\r\nRetry the request.',
    causes: 'Conflict in the state of target resource possibly because of concurrent requests.',
    solutions: 'Retry the request.',
    description:
      'Failed to perform this operation. There  was a conflict with the state of the  resource.',
    product: 'Flex',
    date_created: '2023-11-23T04:40:21Z',
    last_updated: '2023-11-23T04:40:21Z',
  },
  95105: {
    code: 95105,
    message: 'Failed to download audio file',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95105\r\n\r\n### Failed to download audio file\r\n\r\n Twilio failed to transcribe audio due to download failure. The transcription resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\nTimeout trying to download the file. Connection problem.\r\n\r\n#### Possible Solutions\r\nEnsure the file exist and accessible in the provided url',
    causes: 'Timeout trying to download the file. Connection problem.',
    solutions: 'Ensure the file exist and accessible in the provided url',
    description:
      'Twilio failed to transcribe audio due to download failure. The transcription resource has been marked as “failed”',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:33:20Z',
    last_updated: '2024-04-19T11:24:58.39525Z',
  },
  21235: {
    code: 21235,
    message: 'IP Access Control List Validation Error',
    log_level: 'ERROR',
    secondary_message:
      'One of the parameters passed when creating or updating an IP Access Control List was incorrect.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21235\r\n\r\n### IP Access Control List Validation Error\r\n\r\nOne of the parameters passed when creating or updating an IP Access Control List was incorrect. \r\n\r\n#### Possible Causes\r\n* An IP Access Control List or IP Address with the same FriendlyName may already exist.\r\n* The IP Access Control List may already contain that IP Address\r\n\r\n#### Possible Solutions\r\n* Use a different FriendlyName\r\n* Make sure the IP Access Control List does not already contain that IP Address.',
    causes:
      '* An IP Access Control List or IP Address with the same FriendlyName may already exist.\r\n* The IP Access Control List may already contain that IP Address',
    solutions:
      '* Use a different FriendlyName\r\n* Make sure the IP Access Control List does not already contain that IP Address.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:02:35Z',
    last_updated: '2020-08-04T10:00:00.618Z',
  },
  80308: {
    code: 80308,
    message: 'Session with the unique name not found.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80308\r\n\r\n### Session with the unique name not found.\r\n\r\n Session with the given unique name not found in database.\r\n\r\n#### Possible Causes\r\nWrong unique name.\r\n\r\n#### Possible Solutions\r\nRetry operation with the correct unique name.',
    causes: 'Wrong unique name.',
    solutions: 'Retry operation with the correct unique name.',
    description: 'Session with the given unique name not found in database.',
    product: 'Proxy',
    date_created: '2020-03-10T20:51:41Z',
    last_updated: '2020-08-04T10:00:04.482Z',
  },
  57013: {
    code: 57013,
    message: "'Topic' is absent",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57013\r\n\r\n### 'Topic' is absent\r\n\r\n 'Topic' is not specified\r\n\r\n#### Possible Causes\r\n'Topic' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Topic' is being passed in request. ",
    causes: "'Topic' is not specified",
    solutions: "Confirm a valid 'Topic' is being passed in request. ",
    description: "'Topic' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-06-11T19:01:53Z',
    last_updated: '2021-06-11T19:01:53Z',
  },
  21222: {
    code: 21222,
    message: 'Invalid SipAuthUsername. Illegal chars',
    log_level: 'WARNING',
    secondary_message: 'The SipAuthUsername you specified contained characters not allowed in SIP.',
    log_type: null,
    docs: '## Warning - 21222\n\n### Invalid SipAuthUsername. Illegal chars\n\nThe SipAuthUsername you specified contained characters not allowed in SIP.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:17Z',
    last_updated: '2020-08-04T10:00:25.732Z',
  },
  91203: {
    code: 91203,
    message: 'Method Not Allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91203\r\n\r\n### Method Not Allowed\r\n\r\n This operation is not allowed against the resource\r\n\r\n#### Possible Causes\r\n* Deleting a schema is not allowed\r\n\r\n#### Possible Solutions\r\n* Avoid executing a DELETE action against the Schema resource',
    causes: '* Deleting a schema is not allowed',
    solutions: '* Avoid executing a DELETE action against the Schema resource',
    description: 'This operation is not allowed against the resource',
    product: null,
    date_created: '2020-09-21T21:18:47Z',
    last_updated: '2020-09-21T21:18:57.19Z',
  },
  60373: {
    code: 60373,
    message: 'Invalid page size',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60373\r\n\r\n### Invalid page size\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Page size in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Page size in the request body is correct.',
    causes: 'The Page size in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Page size in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-20T09:29:30Z',
    last_updated: '2023-12-20T09:29:30Z',
  },
  22212: {
    code: 22212,
    message: 'Invalid End-User Type in request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22212\r\n\r\n### Invalid End-User Type in request\r\n\r\n An invalid End-User Type is included in the request to filter the Regulations LIST resource.\r\n\r\n#### Possible Causes\r\nThe End-User Type is malformed or is not an acceptable value.\r\n\r\n#### Possible Solutions\r\nEnsure that the End-User Type value is spelled correctly or is present in the End-User Type LIST resource.',
    causes: 'The End-User Type is malformed or is not an acceptable value.',
    solutions:
      'Ensure that the End-User Type value is spelled correctly or is present in the End-User Type LIST resource.',
    description:
      'An invalid End-User Type is included in the request to filter the Regulations LIST resource.',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:50:51Z',
    last_updated: '2020-08-04T10:00:05.49Z',
  },
  57020: {
    code: 57020,
    message: 'Authorization failed',
    log_level: 'ERROR',
    secondary_message: 'Authorization failed',
    log_type: 'APPLICATION',
    docs: "## ERROR - 57020\r\n\r\n### Authorization failed\r\n\r\nAuthorization failed Authorization failed\r\n\r\n#### Possible Causes\r\nAuthorization failed\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Authorisation' header is being passed in the request",
    causes: 'Authorization failed',
    solutions: "Confirm a valid 'Authorisation' header is being passed in the request",
    description: 'Authorization failed',
    product: 'Programmable SMS',
    date_created: '2021-06-28T14:18:58Z',
    last_updated: '2021-06-28T14:18:58Z',
  },
  21237: {
    code: 21237,
    message: 'Maximum IP Addresses Reached for List',
    log_level: 'ERROR',
    secondary_message: 'IP Access control lists cannot contain more than 25 Addresses.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21237\r\n\r\n### Maximum IP Addresses Reached for List\r\n\r\nIP Access control lists cannot contain more than 25 Addresses. \r\n\r\n#### Possible Causes\r\n* IP Access control lists cannot contain more than 25 Addresses.\r\n\r\n#### Possible Solutions\r\n* Remove IP Addresses from your IP Access Control List if you must create new ones.',
    causes: '* IP Access control lists cannot contain more than 25 Addresses.',
    solutions:
      '* Remove IP Addresses from your IP Access Control List if you must create new ones.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:14:19Z',
    last_updated: '2020-08-04T10:00:00.548Z',
  },
  22112: {
    code: 22112,
    message: 'Unable to Update Hosted Number Order Status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22112\r\n\r\n#### Unable to Update Hosted Number Order Status\r\n\r\nThe status provided in a request to update Hosted Number Order instance cannot be applied to the current Hosted Number Order state.\r\n\r\n#### Possible Causes\r\n\r\n* Trying to update a Hosted Number Order that has been completed or failed.\r\n\r\n* Trying to update the status of a Hosted Number Order to a status that cannot be user-initiated.\r\n\r\n#### Possible Solutions\r\n\r\n* If a Hosted Number Order is in a terminal state (failed or completed), create a new instance.\r\n\r\n* If a Hosted Number Order is in "action-required" state, reach out to support to remediate.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:58:25Z',
    last_updated: '2020-08-04T10:00:15.062Z',
  },
  53405: {
    code: 53405,
    message: 'Media connection failed or Media activity ceased',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53405\r\n\r\n### Media connection failed or Media activity ceased\r\n\r\n Raised by the Client or Server whenever a media connection fails or raised by the Client whenever it detects that media has stopped flowing.\r\n\r\n#### Possible Causes\r\n* The Client was unable to establish a media connection.\r\n* A media connection which was active failed liveliness checks.\r\n* The flow of media on the connection has ceased.\r\n* The Participant declined permission to use the local network in a Peer to Peer Room.\r\n\r\n#### Possible Solutions\r\n* If the problem persists in a Group Room, try connecting to another region.\r\n* Check your Client's network connectivity.\r\n* Ensure that Network Traversal Service is enabled for your Configuration Profile and/or Room.\r\n* If you've provided custom ICE Servers then ensure that the URLs and credentials are valid.\r\n* Select LocalNetworkPrivacyPolicy.blockAll on iOS 14+ unless you have permission to use the local network.",
    causes:
      '* The Client was unable to establish a media connection.\r\n* A media connection which was active failed liveliness checks.\r\n* The flow of media on the connection has ceased.\r\n* The Participant declined permission to use the local network in a Peer to Peer Room.',
    solutions:
      "* If the problem persists in a Group Room, try connecting to another region.\r\n* Check your Client's network connectivity.\r\n* Ensure that Network Traversal Service is enabled for your Configuration Profile and/or Room.\r\n* If you've provided custom ICE Servers then ensure that the URLs and credentials are valid.\r\n* Select LocalNetworkPrivacyPolicy.blockAll on iOS 14+ unless you have permission to use the local network.",
    description:
      'Raised by the Client or Server whenever a media connection fails or raised by the Client whenever it detects that media has stopped flowing.',
    product: 'Programmable Video',
    date_created: '2019-02-01T15:37:51Z',
    last_updated: '2020-11-16T17:47:54.283Z',
  },
  30019: {
    code: 30019,
    message: 'Content size exceeds carrier limit',
    log_level: 'ERROR',
    secondary_message:
      'Message failed because the size of the content associated with the message exceeded carrier limit',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30019\r\n\r\n### Content size exceeds carrier limit\r\n\r\nMessage failed because the size of the content associated with the message exceeded carrier limit \r\n\r\n#### Possible Causes\r\nContent size exceeded carrier limit could be caused by to many characters, or bytes in the message. UCS-2 encoded messages could have different limitations than GSM encoded messages. \r\n\r\n\r\n\r\n#### Possible Solutions\r\nContent size should be within [carrier limits](https://support.twilio.com/hc/en-us/articles/360018832773-Twilio-Programmable-SMS-Supported-File-Types-and-Size-Limits-for-MMS-Media-Messages). \r\n\r\nMessage size should be within the [carrier limits](https://support.twilio.com/hc/en-us/articles/360033806753-Maximum-Message-Length-with-Twilio-Programmable-Messaging). ',
    causes:
      'Content size exceeded carrier limit could be caused by to many characters, or bytes in the message. UCS-2 encoded messages could have different limitations than GSM encoded messages. \r\n\r\n',
    solutions:
      'Content size should be within [carrier limits](https://support.twilio.com/hc/en-us/articles/360018832773-Twilio-Programmable-SMS-Supported-File-Types-and-Size-Limits-for-MMS-Media-Messages). \r\n\r\nMessage size should be within the [carrier limits](https://support.twilio.com/hc/en-us/articles/360033806753-Maximum-Message-Length-with-Twilio-Programmable-Messaging). ',
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-09-05T22:28:53Z',
    last_updated: '2023-06-23T19:39:10.485421Z',
  },
  50208: {
    code: 50208,
    message: 'Programmable Chat: User channel limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 50208\r\n\r\n### Programmable Chat: User channel limit exceeded\r\n\r\n#### Possible Causes \r\n*  User has joined too many channels\r\n\r\n#### Possible Solutions\r\n*  Increase user channel limit for service instance\r\n*  Remove user from channels',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-03-30T11:28:06Z',
    last_updated: '2020-08-04T10:00:20.018Z',
  },
  60213: {
    code: 60213,
    message: 'A Messaging Configuration already exists for the given country',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60213\r\n\r\n### A Messaging Configuration already exists for the given country\r\n\r\n * You have already configured the given country.\r\n\r\nHTTP status: 400\r\n\r\n\r\n#### Possible Causes\r\n* You have already configured the given country.\r\n\r\n#### Possible Solutions\r\n* Try updating the Messaging Configuration instead.',
    causes: '* You have already configured the given country.',
    solutions: '* Try updating the Messaging Configuration instead.',
    description: '* You have already configured the given country.\r\n\r\nHTTP status: 400\r\n',
    product: 'Verify',
    date_created: '2019-06-07T17:35:16Z',
    last_updated: '2021-05-18T04:45:40.854Z',
  },
  21229: {
    code: 21229,
    message: 'Invalid SIP Header. Illegal chars in header value',
    log_level: 'WARNING',
    secondary_message: 'The header value you passed has characters not allowed in SIP.',
    log_type: null,
    docs: '## Warning - 21229\n\n### Invalid SIP Header. Illegal chars in header value\n\nThe header value you passed has characters not allowed in SIP.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:19Z',
    last_updated: '2020-08-04T10:00:25.597Z',
  },
  19045: {
    code: 19045,
    message:
      'Field definition type is invalid; data types that are supported are text, date, and number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19045\r\n\r\n### Field definition type is invalid; data types that are supported are text, date, and number\r\n\r\n The custom field type provided in the request is not valid\r\n\r\n#### Possible Causes\r\nRequest with a custom field type other than Text, Number or Date\r\n\r\n#### Possible Solutions\r\nCustom field type can be only Text, Number or Date',
    causes: 'Request with a custom field type other than Text, Number or Date',
    solutions: 'Custom field type can be only Text, Number or Date',
    description: 'The custom field type provided in the request is not valid',
    product: 'Contacts',
    date_created: '2020-07-21T20:36:29Z',
    last_updated: '2020-08-31T06:05:01.902Z',
  },
  52052: {
    code: 52052,
    message: 'Client connection not created or closed',
    log_level: 'WARNING',
    secondary_message:
      'Websocket gateway could not find connection to user for sending notification',
    log_type: null,
    docs: '## Warning - 52052\r\n\r\n### Client connection not found\r\n\r\n#### Possible Causes \r\n*  Client connection not found.\r\n\r\n#### Possible Solutions\r\n*  No action needed. The client will automatically reconnect when possible.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:02:55Z',
    last_updated: '2020-08-04T10:00:22.451Z',
  },
  32702: {
    code: 32702,
    message: 'Voice User-Defined Message: Invalid Content',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32702\r\n\r\n### Voice User-Defined Message: Invalid Content\r\n\r\n Invalid content in the POST request to the UserDefinedMessage Resource. Only data in JSON format is supported.\r\n\r\n#### Possible Causes\r\n* Content data in the POST request to the UserDefinedMessage Resource is not as expected, or there is no content in the request.\r\n\r\n#### Possible Solutions\r\n* Make sure to include content data in JSON format in the POST request to the UserDefinedMessage Resource.',
    causes:
      '* Content data in the POST request to the UserDefinedMessage Resource is not as expected, or there is no content in the request.',
    solutions:
      '* Make sure to include content data in JSON format in the POST request to the UserDefinedMessage Resource.',
    description:
      'Invalid content in the POST request to the UserDefinedMessage Resource. Only data in JSON format is supported.',
    product: 'Programmable Voice',
    date_created: '2022-08-18T21:49:44Z',
    last_updated: '2022-08-18T22:01:30.219144Z',
  },
  13234: {
    code: 13234,
    message: 'Dial->Conference: Invalid waitMethod',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Warning - 13234\n\n### Dial->Conference: Invalid waitMethod value\n\nwaitMethod must be either GET or POST\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:37Z',
    last_updated: '2020-08-04T10:00:28.419Z',
  },
  50052: {
    code: 50052,
    message: 'Programmable Chat: Invalid consumption interval format',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain valid consumption interval.',
    log_type: null,
    docs: '## Error - 50052\r\n\r\n### Programmable Chat: Invalid consumption interval format\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain valid consumption interval.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid consumption interval format is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:44Z',
    last_updated: '2020-08-04T10:00:23.634Z',
  },
  32303: {
    code: 32303,
    message: 'Interconnect: Multiple SIP Dials with Interconnect Connection (TNX) SID',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: "#### Possible Causes \r\n*   Multiple SIP outbound dials with TNX parameter\r\n\r\n\r\n#### Possible Solutions\r\n*  We don't support multiple SIP outbound dials with TNX parameter, please ensure you Response only includes one.\r\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-11-16T21:54:51Z',
    last_updated: '2020-08-04T10:00:20.384Z',
  },
  32652: {
    code: 32652,
    message: 'Real-time Transcriptions: Unsupported <Config> attribute(s) in TwiML',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32652\r\n\r\n### Real-time Transcriptions: Unsupported <Config> attribute(s) in TwiML\r\n\r\n A 32652 Error is an indication that &lt;Transcription&gt; TwiML contains invalid or unsupported &lt;Config&gt; attributes. \r\n\r\n#### Possible Causes\r\n* Some of the &lt;Config&gt; attribute(s) referenced in the &lt;Transcription&gt; TwiML are not supported by the Transcription provider\r\n\r\n#### Possible Solutions\r\n* Review the Debugger message in console and update or remove the offending attributes',
    causes:
      '* Some of the &lt;Config&gt; attribute(s) referenced in the &lt;Transcription&gt; TwiML are not supported by the Transcription provider',
    solutions:
      '* Review the Debugger message in console and update or remove the offending attributes',
    description:
      'A 32652 Error is an indication that &lt;Transcription&gt; TwiML contains invalid or unsupported &lt;Config&gt; attributes. ',
    product: 'Programmable Voice',
    date_created: '2024-05-10T20:03:47Z',
    last_updated: '2024-05-10T20:03:47Z',
  },
  15002: {
    code: 15002,
    message: 'Call Progress: Queue Timeout',
    log_level: 'ERROR',
    secondary_message: 'A callback request timed out in the callback queue.',
    log_type: null,
    docs: '## Error - 15002\n\n### Call Progress: Queue Timeout\n\nA callback request timed out in the callback queue.\n\n#### Possible Causes\n\n*  Your application is not responding to Call Progress Events in a timely manner leading to queued callbacks expiring before they are sent.\n*  There was a network disruption between Twilio and your web server.\n\n#### Possible Solutions\n\n*   Please ensure your application is responding to callbacks in a timely manner.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:14Z',
    last_updated: '2020-08-04T10:00:26.008Z',
  },
  60365: {
    code: 60365,
    message: 'Entity SID invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60365\r\n\r\n### Entity SID invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Entity SID in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Entity SID in the request parameter/body is correct.',
    causes: 'The Entity SID in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Entity SID in the request parameter/body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-13T10:21:50Z',
    last_updated: '2023-12-13T10:21:50Z',
  },
  50205: {
    code: 50205,
    message: 'Programmable Chat: User unauthorized to set role',
    log_level: 'ERROR',
    secondary_message: 'Specified User does not have Role or Permissions to set the Role.',
    log_type: null,
    docs: '## Error - 50205\r\n\r\n### Programmable Chat: User unauthorized to set role\r\n\r\n#### Possible Causes \r\n*  Specified User does not have Role or Permissions to set the Role.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User having valid Role and Permissions is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:49Z',
    last_updated: '2020-08-04T10:00:23.246Z',
  },
  50207: {
    code: 50207,
    message: 'Programmable Chat: Identity too long',
    log_level: 'ERROR',
    secondary_message: "Specified User's Identity parameter is too long",
    log_type: null,
    docs: "## Error - 50207\r\n\r\n### Programmable Chat: Identity too long\r\n\r\n#### Possible Causes \r\n*  Specified User's Identity parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length User's Identity is being passed in request. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-04-15T11:23:18Z',
    last_updated: '2020-08-04T10:00:22.538Z',
  },
  51108: {
    code: 51108,
    message: 'Twilsock: Service instance disabled',
    log_level: 'ERROR',
    secondary_message: 'Service instance is disabled.',
    log_type: null,
    docs: '## Error - 51108\r\n\r\n### Service instance disabled\r\n\r\n#### Possible Causes \r\nService instance is disabled.\r\n\r\n#### Possible Solutions\r\nPlease use a different service instance.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:12:36Z',
    last_updated: '2020-08-04T10:00:09.789Z',
  },
  30884: {
    code: 30884,
    message: 'Campaign vetting rejection - Spam/Phishing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30884\r\n\r\n### Campaign vetting rejection - Spam/Phishing\r\n\r\n The campaign submission has been reviewed and it was rejected because it was found to be a known Spam or Phishing campaign.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because it found to be a known Spam or Phishing campaign.\r\n\r\n#### Possible Solutions\r\nThe rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because it found to be a known Spam or Phishing campaign.',
    solutions:
      'The rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because it was found to be a known Spam or Phishing campaign.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:34:23Z',
    last_updated: '2023-04-18T11:34:23Z',
  },
  22213: {
    code: 22213,
    message: 'Invalid Number Type in request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22213\r\n\r\n### Invalid Number Type in request\r\n\r\n An invalid End-User Type is included in the request to filter the Regulations LIST resource.\r\n\r\n#### Possible Causes\r\nThe Number Type is malformed or is not an acceptable value.\r\n\r\n#### Possible Solutions\r\nEnsure that the Number Type value is spelled correctly or is an acceptable Number Type in the Regulations LIST resource',
    causes: 'The Number Type is malformed or is not an acceptable value.',
    solutions:
      'Ensure that the Number Type value is spelled correctly or is an acceptable Number Type in the Regulations LIST resource',
    description:
      'An invalid End-User Type is included in the request to filter the Regulations LIST resource.',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:51:35Z',
    last_updated: '2020-08-04T10:00:05.473Z',
  },
  22210: {
    code: 22210,
    message: 'Cannot create a Supporting Document with no Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22210\r\n\r\n### Cannot create a Supporting Document with no Type\r\n\r\n A Supporting Document instance was requested to be created with no `Type` specified\r\n\r\n#### Possible Causes\r\nEither the Type string was malformed or the Supporting Document Type name does not exist.\r\n\r\n#### Possible Solutions\r\nRefer to the Supporting Document Types LIST resource to find the correct name type for your request.',
    causes:
      'Either the Type string was malformed or the Supporting Document Type name does not exist.',
    solutions:
      'Refer to the Supporting Document Types LIST resource to find the correct name type for your request.',
    description:
      'A Supporting Document instance was requested to be created with no `Type` specified',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:48:41Z',
    last_updated: '2020-08-04T10:00:05.527Z',
  },
  60237: {
    code: 60237,
    message: 'The given domain is on a deny list',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60237\r\n\r\n### The given domain is on a deny list\r\n\r\n \r\n\r\n#### Possible Causes\r\nSome generic domains have been blocked for specific functionalities. The domains in the deny list are: Gmail, Yahoo, Hotmail, Outlook.\r\n\r\n#### Possible Solutions\r\nPlease use a different email with a custom domain.',
    causes:
      'Some generic domains have been blocked for specific functionalities. The domains in the deny list are: Gmail, Yahoo, Hotmail, Outlook.',
    solutions: 'Please use a different email with a custom domain.',
    description: null,
    product: 'Verify',
    date_created: '2023-09-20T15:14:13Z',
    last_updated: '2023-11-01T19:27:32.165203Z',
  },
  32301: {
    code: 32301,
    message: 'Interconnect: Invalid Connection (TNX) SID',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '#### Possible Causes \r\n*  The Interconnect Connection (TNX) SID is invalid.\r\n\r\n#### Possible Solutions\r\n*  Please verify your Interconnect Connection SID, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-11-16T21:52:51Z',
    last_updated: '2020-08-04T10:00:20.43Z',
  },
  53000: {
    code: 53000,
    message: 'Signaling connection error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53000\r\n\r\n### Signaling connection error\r\n\r\n Raised whenever a signaling connection error occurs that is not covered by a more specific error code.\r\n\r\n#### Possible Causes\r\nThe signaling communication path could not be established or has been lost.\r\n\r\n#### Possible Solutions\r\n* Try connecting again.\r\n* If the problem persists, try connecting to another region.',
    causes: 'The signaling communication path could not be established or has been lost.',
    solutions:
      '* Try connecting again.\r\n* If the problem persists, try connecting to another region.',
    description:
      'Raised whenever a signaling connection error occurs that is not covered by a more specific error code.',
    product: 'Programmable Video',
    date_created: '2017-04-21T22:58:09Z',
    last_updated: '2021-10-28T22:58:19.472884Z',
  },
  64009: {
    code: 64009,
    message: 'Pay: Twilio is no longer authorized to initiate transactions on your behalf.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64009\r\n\r\n### Pay: Twilio is no longer authorized to initiate transactions on your behalf.\r\n\r\n ## Error - 64009\r\n\r\n### Pay: Twilio is no longer authorized to initiate transactions on your behalf.\r\n\r\nA 64009 Error is an indication that the credentials provided in connector configuration no longer allow Twilio\r\nto perform requests on behalf of your account.\r\n\r\n\r\n#### Possible Causes\r\n* The Twilio application had its privileges revoked from your account.\r\n\r\n#### Possible Solutions\r\n* Create a new connector configuration and run through the scenario where you authorize Twilio to make requests on your behalf again.',
    causes: '* The Twilio application had its privileges revoked from your account.',
    solutions:
      '* Create a new connector configuration and run through the scenario where you authorize Twilio to make requests on your behalf again.',
    description:
      '## Error - 64009\r\n\r\n### Pay: Twilio is no longer authorized to initiate transactions on your behalf.\r\n\r\nA 64009 Error is an indication that the credentials provided in connector configuration no longer allow Twilio\r\nto perform requests on behalf of your account.\r\n',
    product: 'Programmable Voice',
    date_created: '2019-02-26T22:03:48Z',
    last_updated: '2020-08-04T10:00:10.225Z',
  },
  35133: {
    code: 35133,
    message: "Invalid 'Messages' array provided in the request",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 35133\r\n\r\n### Invalid 'Messages' array provided in the request\r\n\r\n The 'Messages' array provided in the request in invalid. It is either empty or contains too many items\r\n\r\n#### Possible Causes\r\nThe Messages array is either empty or contains too many items\r\n\r\n#### Possible Solutions\r\nCheck if the Messages array is empty. If not, please ensure it doesn't contain too many items",
    causes: 'The Messages array is either empty or contains too many items',
    solutions:
      "Check if the Messages array is empty. If not, please ensure it doesn't contain too many items",
    description:
      "The 'Messages' array provided in the request in invalid. It is either empty or contains too many items",
    product: 'Programmable Messaging',
    date_created: '2023-05-30T22:22:42Z',
    last_updated: '2023-06-05T15:24:31.899732Z',
  },
  53203: {
    code: 53203,
    message:
      'The maximum number of published tracks allowed in the Room at the same time has been reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53203\r\n\r\n### The maximum number of published tracks allowed in the Room at the same time has been reached\r\n\r\n The maximum number of published tracks allowed in the Room at the same time has been reached\r\n\r\n\r\n#### Possible Causes\r\n* A client added more than the maximum number of Tracks allowed per Participant.\r\n* A client added more than the maximum number of Tracks allowed per Room.\r\n\r\n\r\n#### Possible Solutions\r\n * Have the Client remove one or more Tracks.\r\n * Have the Client publish Tracks only if the number of Tracks in a Room is less than the maximum number of Tracks allowed per Room.',
    causes:
      '* A client added more than the maximum number of Tracks allowed per Participant.\r\n* A client added more than the maximum number of Tracks allowed per Room.\r\n',
    solutions:
      ' * Have the Client remove one or more Tracks.\r\n * Have the Client publish Tracks only if the number of Tracks in a Room is less than the maximum number of Tracks allowed per Room.',
    description:
      'The maximum number of published tracks allowed in the Room at the same time has been reached\r\n',
    product: 'Programmable Video',
    date_created: '2017-04-24T15:48:42Z',
    last_updated: '2021-02-17T20:00:38.075Z',
  },
  30043: {
    code: 30043,
    message: 'International SMS via Domestic Gateway',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 30043\r\n\r\n### International SMS via Domestic Gateway\r\n\r\n Message Misrouted as Domestic\r\n\r\n#### Possible Causes\r\nThe mobile operator flagged the SMS as an international message sent through the domestic gateway.\r\n\r\n#### Possible Solutions\r\nCheck the SMS Guidelines for the destination country for any restrictions on domestic or international traffic:\r\n- If the message is genuinely domestic, open a support request and provide evidence to clarify.\r\n- If the message is international, open a support request  and request to move your messages to appropriate international gateways.',
    causes:
      'The mobile operator flagged the SMS as an international message sent through the domestic gateway.',
    solutions:
      'Check the SMS Guidelines for the destination country for any restrictions on domestic or international traffic:\r\n- If the message is genuinely domestic, open a support request and provide evidence to clarify.\r\n- If the message is international, open a support request  and request to move your messages to appropriate international gateways.',
    description: 'Message Misrouted as Domestic',
    product: 'Programmable SMS',
    date_created: '2024-02-08T20:45:17Z',
    last_updated: '2024-02-08T21:18:06.747332Z',
  },
  50054: {
    code: 50054,
    message: 'Programmable Chat: Invalid webhook format',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correctly formatted parameters for webhooks.',
    log_type: null,
    docs: '## Error - 50054\r\n\r\n### Programmable Chat: Invalid webhook format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameters for webhooks.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid webhook parameters are being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:45Z',
    last_updated: '2020-08-04T10:00:23.589Z',
  },
  90009: {
    code: 90009,
    message: 'The message SID already exists.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90009\r\n\r\n### The message SID already exists.\r\n\r\n Message SID already exists\r\n\r\n#### Possible Causes\r\n* Message with the same SID already exists. Conflict when creating a new message.\r\n\r\n#### Possible Solutions\r\n* Change or generate new message SID.',
    causes: '* Message with the same SID already exists. Conflict when creating a new message.',
    solutions: '* Change or generate new message SID.',
    description: 'Message SID already exists',
    product: 'Programmable SMS',
    date_created: '2020-07-14T06:41:07Z',
    last_updated: '2020-08-04T10:00:02.189Z',
  },
  64016: {
    code: 64016,
    message: 'Pay: Invalid Action URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64016\r\n\r\n### Pay: Invalid Action URL\r\n\r\n A 64016 Error is an indication there is something wrong with the value provided for the action parameter.\r\n\r\n#### Possible Causes\r\n* Action URL does not use https://\r\n\r\n#### Possible Solutions\r\n* Start your action URL with "https://"',
    causes: '* Action URL does not use https://',
    solutions: '* Start your action URL with "https://"',
    description:
      'A 64016 Error is an indication there is something wrong with the value provided for the action parameter.',
    product: 'Programmable Voice',
    date_created: '2020-05-05T22:54:08Z',
    last_updated: '2020-08-04T10:00:03.444Z',
  },
  45770: {
    code: 45770,
    message: 'Failed to create InteractionChannel. Downstream Error. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45770\r\n\r\n### Failed to create InteractionChannel. Downstream Error. \r\n\r\n An error occurred while creating an interactionChannel. Downstream Error.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error while processing createInteractionChannel Request, Downstream Error.\r\n\r\n#### Possible Solutions\r\n"Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate."',
    causes:
      'We encountered an unexpected error while processing createInteractionChannel Request, Downstream Error.',
    solutions:
      '"Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate."',
    description: 'An error occurred while creating an interactionChannel. Downstream Error.',
    product: 'Flex',
    date_created: '2023-03-24T16:09:04Z',
    last_updated: '2023-03-24T16:09:04Z',
  },
  21264: {
    code: 21264,
    message: '‘From’ phone number not verified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21264\r\n\r\n### ‘From’ phone number not verified\r\n\r\n You received an inbound phone call to a Twilio phone number owned by your trial account, but the 'From' number is not a [Verified Caller ID](https://support.twilio.com/hc/en-us/articles/223180048-How-to-Add-and-Remove-a-Verified-Phone-Number-or-Caller-ID-with-Twilio) on your account. In order to receive calls to a Twilio number during a free trial, you must first verify your ownership of the phone number that is placing the call.\r\n\r\n#### Possible Causes\r\nThe ‘From’ number of the inbound call is not a [Verified Caller ID](https://support.twilio.com/hc/en-us/articles/223180048-How-to-Add-and-Remove-a-Verified-Phone-Number-or-Caller-ID-with-Twilio). Trial accounts can only receive inbound calls from verified phone numbers.\r\n\r\n#### Possible Solutions\r\nYou can verify phone numbers from the [phone numbers section](https://www.twilio.com/user/account/phone-numbers) of your account portal.",
    causes:
      'The ‘From’ number of the inbound call is not a [Verified Caller ID](https://support.twilio.com/hc/en-us/articles/223180048-How-to-Add-and-Remove-a-Verified-Phone-Number-or-Caller-ID-with-Twilio). Trial accounts can only receive inbound calls from verified phone numbers.',
    solutions:
      'You can verify phone numbers from the [phone numbers section](https://www.twilio.com/user/account/phone-numbers) of your account portal.',
    description:
      "You received an inbound phone call to a Twilio phone number owned by your trial account, but the 'From' number is not a [Verified Caller ID](https://support.twilio.com/hc/en-us/articles/223180048-How-to-Add-and-Remove-a-Verified-Phone-Number-or-Caller-ID-with-Twilio) on your account. In order to receive calls to a Twilio number during a free trial, you must first verify your ownership of the phone number that is placing the call.",
    product: null,
    date_created: '2023-09-27T00:07:29Z',
    last_updated: '2023-09-27T00:07:29Z',
  },
  50074: {
    code: 50074,
    message: 'Global actions per second limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'Service instance global actions per second limit exceeded.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50074\r\n\r\n### Global actions per second limit exceeded\r\n\r\nService instance global actions per second limit exceeded. \r\n\r\n#### Possible Causes\r\n*  Your application is generating too many actions per second (APS) for Chat service instance either to a specific Chat API endpoint or across different Chat API endpoints\r\n*  Note that the APS limit is enforced for commands such as sending a Message or creating a Channel - not Read actions\r\n\r\n#### Possible Solutions\r\n*  Make sure your application (client or backend) uses a good exponential back-off algorithm like the [one advocated by Amazon](https://www.awsarchitectureblog.com/2015/03/backoff.html) to retry on HTTP 429 (rate limiting) responses\r\n*  Reduce the rate of requests and introduce basic rate control, e.g. for user or channel provisioning use-cases\r\n*  Reduce number of concurrent requests',
    causes:
      '*  Your application is generating too many actions per second (APS) for Chat service instance either to a specific Chat API endpoint or across different Chat API endpoints\r\n*  Note that the APS limit is enforced for commands such as sending a Message or creating a Channel - not Read actions',
    solutions:
      '*  Make sure your application (client or backend) uses a good exponential back-off algorithm like the [one advocated by Amazon](https://www.awsarchitectureblog.com/2015/03/backoff.html) to retry on HTTP 429 (rate limiting) responses\r\n*  Reduce the rate of requests and introduce basic rate control, e.g. for user or channel provisioning use-cases\r\n*  Reduce number of concurrent requests',
    description: null,
    product: 'Programmable Chat',
    date_created: '2020-05-07T08:09:56Z',
    last_updated: '2020-08-04T10:00:03.343Z',
  },
  80623: {
    code: 80623,
    message: 'Duplicate Participant Request',
    log_level: 'ERROR',
    secondary_message: 'Possible duplicate Participant created in multiple Sessions.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 80623\r\n\r\n### Duplicate Participant Request\r\n\r\nPossible duplicate Participant created in multiple Sessions. Possible duplicate Participant created in multiple Sessions.\r\n\r\n#### Possible Causes\r\nA request to create a Participant for an Identifier was made while another ongoing request was in progress for the same Identifier in a different Session.  This can result in the same proxy identifier being assigned in multiple sessions for the same Identifier, causing incorrect behavior.\r\n\r\n#### Possible Solutions\r\nIf you need to add the same person to multiple Sessions, ensure that the Participant Create requests are made one at a time.  To allow Proxy to enforce this, please pass the ReturnErrorOnDuplicateRequest=true parameter in your Participant Create requests and/or Session Create requests (if participant parameters are included).  This will be the default behavior for all requests in the future, and will enable us to use more efficient logic to find ProxyIdentifiers for your participants, thus reducing Participant Create latency.',
    causes:
      'A request to create a Participant for an Identifier was made while another ongoing request was in progress for the same Identifier in a different Session.  This can result in the same proxy identifier being assigned in multiple sessions for the same Identifier, causing incorrect behavior.',
    solutions:
      'If you need to add the same person to multiple Sessions, ensure that the Participant Create requests are made one at a time.  To allow Proxy to enforce this, please pass the ReturnErrorOnDuplicateRequest=true parameter in your Participant Create requests and/or Session Create requests (if participant parameters are included).  This will be the default behavior for all requests in the future, and will enable us to use more efficient logic to find ProxyIdentifiers for your participants, thus reducing Participant Create latency.',
    description: 'Possible duplicate Participant created in multiple Sessions.',
    product: 'Proxy',
    date_created: '2020-08-03T22:41:11Z',
    last_updated: '2020-08-04T10:00:00.691Z',
  },
  92008: {
    code: 92008,
    message: 'Unsupported Content Type',
    log_level: 'ERROR',
    secondary_message: 'Creating new twilio/button templates is no longer supported.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 92008\r\n\r\n### Unsupported Content Type\r\n\r\nCreating new twilio/button templates is no longer supported. Creating new twilio/button templates is no longer supported.\r\n\r\n#### Possible Causes\r\nYou attempted to create template of type twilio/button which is no longer supported. \r\n\r\n#### Possible Solutions\r\nTo create button templates, please use the twilio/call-to-action or twilio/quick-reply template types.',
    causes: 'You attempted to create template of type twilio/button which is no longer supported. ',
    solutions:
      'To create button templates, please use the twilio/call-to-action or twilio/quick-reply template types.',
    description: 'Creating new twilio/button templates is no longer supported.',
    product: 'Programmable SMS',
    date_created: '2022-08-04T17:10:56Z',
    last_updated: '2022-08-04T17:10:56Z',
  },
  94403: {
    code: 94403,
    message: 'Transcriptions: Invalid encryption credentials',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 94403\r\n\r\n### Transcriptions: Invalid encryption credentials\r\n\r\n Public key credentials to encrypt transcription results are invalid. Twilio will attempt operation again shortly. \r\n\r\n#### Possible Causes\r\n* Public key specified in Transcription Settings is not found in Twilio Credentials Storage\r\n* Public key defined in credentials resource is invalid and can’t be used to encrypt transcription files\r\n* Public key defined in credentials resource is expired and can’t be used to encrypt transcription files\r\n\r\n#### Possible Solutions\r\n* Ensure public key is correct in credentials resource\r\n* Set a different public key that can be used to encrypt transcription results or disable encryption',
    causes:
      '* Public key specified in Transcription Settings is not found in Twilio Credentials Storage\r\n* Public key defined in credentials resource is invalid and can’t be used to encrypt transcription files\r\n* Public key defined in credentials resource is expired and can’t be used to encrypt transcription files',
    solutions:
      '* Ensure public key is correct in credentials resource\r\n* Set a different public key that can be used to encrypt transcription results or disable encryption',
    description:
      'Public key credentials to encrypt transcription results are invalid. Twilio will attempt operation again shortly. ',
    product: null,
    date_created: '2021-07-27T09:49:57Z',
    last_updated: '2021-08-03T13:43:36.380901Z',
  },
  18605: {
    code: 18605,
    message: 'Unable to verify Authorized representative #2. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18605\r\n\r\n### Unable to verify Authorized representative #2. \r\n\r\n Unable to verify Authorized representative #2\r\n\r\n#### Possible Causes\r\nUnable to verify Authorized representative #2’s identity or their affiliation with the business.\r\n\r\n#### Possible Solutions\r\nPlease feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    causes:
      'Unable to verify Authorized representative #2’s identity or their affiliation with the business.',
    solutions:
      'Please feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    description: 'Unable to verify Authorized representative #2',
    product: 'Phone Numbers',
    date_created: '2024-02-22T03:33:42Z',
    last_updated: '2024-02-22T03:33:42Z',
  },
  83602: {
    code: 83602,
    message: 'Request StartTime and/or EndTime must be aligned to UTC hour boundaries.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83602\r\n\r\n### Request StartTime and/or EndTime must be aligned to UTC hour boundaries.\r\n\r\n Certain requests for Usage Records can only be made with StartTime and EndTime parameters that align to a UTC hour cutoff (e.g. "2021-07-15T04:00:00Z").\r\n\r\n#### Possible Causes\r\n  * This happens if you request Usage Records with StartTime or EndTime parameters that do not fall on an hour cutoff for certain UsageRecord requests.\r\n\r\n#### Possible Solutions\r\n  * Adjust your StartTime or EndTime parameters so that they are on a UTC hour cutoff (e.g. "2021-07-15T04:00:00Z").',
    causes:
      '  * This happens if you request Usage Records with StartTime or EndTime parameters that do not fall on an hour cutoff for certain UsageRecord requests.',
    solutions:
      '  * Adjust your StartTime or EndTime parameters so that they are on a UTC hour cutoff (e.g. "2021-07-15T04:00:00Z").',
    description:
      'Certain requests for Usage Records can only be made with StartTime and EndTime parameters that align to a UTC hour cutoff (e.g. "2021-07-15T04:00:00Z").',
    product: 'Super SIM',
    date_created: '2021-08-19T13:14:34Z',
    last_updated: '2021-08-19T13:42:27.695207Z',
  },
  52211: {
    code: 52211,
    message: 'Too many Alexa notifications',
    log_level: 'ERROR',
    secondary_message: 'You are sending Alexa notifications too fast',
    log_type: null,
    docs: '## Error 52211\r\n\r\n### Too many Alexa notifications\r\n\r\nYour message has been rejected by the Alexa channel due too many messages.\r\n\r\n### Possible causes\r\n- You are making Send Notification requests too fast.\r\n- You have made some bulk notification requests that created too many Alexa messages too fast.\r\n\r\n### Possible solutions\r\n- Slow down the rate of Send Notification requests.\r\n- Target less recipients per bulk notification request and send the bulk requests more slowly.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-06-22T15:10:46Z',
    last_updated: '2020-08-04T10:00:18.259Z',
  },
  52102: {
    code: 52102,
    message: 'Invalid GCM/FCM registration token',
    log_level: 'ERROR',
    secondary_message: 'GCM/FCM service responded with InvalidRegistration error',
    log_type: null,
    docs: '## Error - 52102\r\n\r\n### Invalid GCM/FCM registration token\r\n\r\n#### Possible Causes \r\n*  Invalid GCM/FCM registration token provided via the Android SDK or the REST API.\r\n\r\n#### Possible Solutions\r\n*  Make sure you do not modify the registration token before providing it to Twilio via the SDK or the REST API.\r\n*  If you are using a command line tool to provide the registration token, make sure that it is URL-encoded.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:06:11Z',
    last_updated: '2020-08-04T10:00:22.38Z',
  },
  21302: {
    code: 21302,
    message: 'Approaching application creation limit ',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 21302\r\n\r\n### Approaching application creation limit \r\n\r\n Approaching application creation limit\r\n\r\n#### Possible Causes\r\nYou are approaching the limit of 1000 TwiML\t applications.\r\n\r\n#### Possible Solutions\r\nDelete or update existing applications instead of creating new applications.',
    causes: 'You are approaching the limit of 1000 TwiML\t applications.',
    solutions: 'Delete or update existing applications instead of creating new applications.',
    description: 'Approaching application creation limit',
    product: 'Programmable Voice',
    date_created: '2020-04-27T22:13:38Z',
    last_updated: '2020-08-04T10:00:03.656Z',
  },
  20011: {
    code: 20011,
    message: 'Invalid TLS version',
    log_level: 'ERROR',
    secondary_message: 'Service requires TLSv1.2 ',
    log_type: null,
    docs: '## Error Code 20011\r\n\r\n### Invalid TLS version\r\n\r\nThe request was rejected because it was not correctly configured to use TLSv1.2. All new accounts are [required to use TLSv1.2 with supported ciphers suites](https://support.twilio.com/hc/en-us/articles/360007724794). \r\n\r\n#### Possible Solutions:\r\n* Reconfigure request to use a supported cipher suite for TLSv1.2\r\n* Review these [tips for upgrading your environment to TLSv1.2](https://support.twilio.com/hc/en-us/articles/360006751753)',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-30T22:44:42Z',
    last_updated: '2020-08-04T10:00:10.883Z',
  },
  45782: {
    code: 45782,
    message: 'Internal Error. Failed to delete deployment key.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45782\r\n\r\n### Internal Error. Failed to delete deployment key.\r\n\r\n An unexpected error occurred when processing delete deployment key request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when deleting deployment key. \r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when deleting deployment key. ',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing delete deployment key request.',
    product: 'Flex',
    date_created: '2023-11-23T04:10:28Z',
    last_updated: '2023-11-23T04:10:28Z',
  },
  40142: {
    code: 40142,
    message:
      "Failed to issue Conference instruction due to missing 'call_sid' or 'outbound_to' properties",
    log_level: 'ERROR',
    secondary_message: ' ',
    log_type: 'APPLICATION',
    docs: "## ERROR - 40142\r\n\r\n### Failed to issue Conference instruction due to missing 'call_sid' or 'outbound_to' properties\r\n\r\n  \r\n\r\n#### Possible Causes\r\n*  The Task was not created via the `<Enqueue>` verb. (Inbound Voice call)\r\n* The `call_sid` property is missing the Task’s attributes. (Inbound Voice call)\r\n* The `outbound_to` property is missing in the Task’s attributes. (Outbound Voice call)\r\n\r\n\r\n#### Possible Solutions\r\n* Ensure that the Conference instruction is issued on an `<Enqueue>` created Task. (Inbound Voice call)\r\n* Ensure that ‘outbound_to’ property is present in the Task’s attributes. (Outbound Voice call)",
    causes:
      '*  The Task was not created via the `<Enqueue>` verb. (Inbound Voice call)\r\n* The `call_sid` property is missing the Task’s attributes. (Inbound Voice call)\r\n* The `outbound_to` property is missing in the Task’s attributes. (Outbound Voice call)\r\n',
    solutions:
      '* Ensure that the Conference instruction is issued on an `<Enqueue>` created Task. (Inbound Voice call)\r\n* Ensure that ‘outbound_to’ property is present in the Task’s attributes. (Outbound Voice call)',
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:40:40Z',
    last_updated: '2020-09-14T23:41:29.602Z',
  },
  51113: {
    code: 51113,
    message: 'Twilsock: Product usage is not enabled',
    log_level: 'ERROR',
    secondary_message: 'Product usage is not enabled.',
    log_type: null,
    docs: '## Error - 51113\r\n\r\n### Product usage is not enabled\r\n\r\n#### Possible Causes \r\nProduct usage is not enabled.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:47:41Z',
    last_updated: '2020-08-04T10:00:09.7Z',
  },
  90007: {
    code: 90007,
    message: 'Invalid validity period value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90007\r\n\r\n### Invalid validity period value\r\n\r\n ## Error - 90007\r\n\r\n### Invalid validity period value\r\n\r\nValidity period can only be set to integers between 1 and 14,400 seconds (4 hours max).\r\n\r\n#### Possible Causes\r\nInvalid validity period value\r\n\r\n#### Possible Solutions\r\nFix validity period value',
    causes: 'Invalid validity period value',
    solutions: 'Fix validity period value',
    description:
      '## Error - 90007\r\n\r\n### Invalid validity period value\r\n\r\nValidity period can only be set to integers between 1 and 14,400 seconds (4 hours max).',
    product: 'Programmable SMS',
    date_created: '2020-06-08T13:02:29Z',
    last_updated: '2020-08-04T10:00:02.876Z',
  },
  21402: {
    code: 21402,
    message: 'Invalid Url',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to update the URL handler associated with a phone number, but the URL you specified was not valid.  You must specify a valid URL, beginning with http or https, such as http://mycompany.com/callHandler',
    log_type: null,
    docs: '## Error - 21402 \n\n### Invalid URL\n\nYou attempted to update the URL handler associated with a phone number, but the URL you specified was not valid. \n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:58Z',
    last_updated: '2020-08-04T10:00:27.046Z',
  },
  30124: {
    code: 30124,
    message: 'MessagingServiceSID cannot be empty or null',
    log_level: 'ERROR',
    secondary_message: 'MessagingServiceSID is missing',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30124\r\n\r\n### MessagingServiceSID cannot be empty or null\r\n\r\nMessagingServiceSID is missing MessagingServiceSID is missing\r\n\r\n#### Possible Causes\r\nUser did not include messagingServiceSid field\r\n\r\n#### Possible Solutions\r\nPlease follow doc for setting up messaging service sid',
    causes: 'User did not include messagingServiceSid field',
    solutions: 'Please follow doc for setting up messaging service sid',
    description: 'MessagingServiceSID is missing',
    product: 'Programmable SMS',
    date_created: '2022-03-08T00:31:33Z',
    last_updated: '2022-07-15T00:12:13.783619Z',
  },
  13616: {
    code: 13616,
    message: 'Record: playBeep must be true or false',
    log_level: 'WARNING',
    secondary_message: 'The playBeep attribute must have a value of "true" or "false"',
    log_type: null,
    docs: '## Warning - 13616 \n\n### Record: playBeep must be true or false\n\nThe playBeep attribute must have a value of "true" or "false"\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:09Z',
    last_updated: '2020-08-04T10:00:26.367Z',
  },
  31429: {
    code: 31429,
    message: 'Too Many Requests',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31429\r\n\r\n### Too Many Requests\r\n\r\nToo many requests were sent in a given amount of time.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:34:37Z',
    last_updated: '2020-08-04T10:00:08.374Z',
  },
  70252: {
    code: 70252,
    message: 'Bad Saml Response',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70252\r\n\r\n### Bad Saml Response\r\nThe Request tries to authenticate through SSO. The request is well-formed, but the response from the Identity Provider is missing necessary attributes. \r\n\r\n#### Possible Causes \r\n* Misconfigured Identity Provider settings\r\n\r\n#### Possible Solution\r\n* Reconfigure the Identity Provider settings and retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-07-26T21:27:33Z',
    last_updated: '2020-08-04T10:00:12.86Z',
  },
  13801: {
    code: 13801,
    message: 'Refer not allowed on non-SIP call legs',
    log_level: 'ERROR',
    secondary_message: 'The Refer verb can only be invoked on a SIP call leg.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 13801\r\n\r\n### Refer not allowed on non-SIP call legs\r\n\r\nThe Refer verb can only be invoked on a SIP call leg. The Refer verb is only allowed on SIP call legs, e.g. you can refer an incoming SIP call that originate from SIP infrastructure or an outbound call to a SIP destination. Calls to or from other destinations, such as a phone number or Twilio Client cannot be referred.\r\n\r\n#### Possible Causes\r\n* Your application attempted to invoke the Refer verb on a PSTN or Twilio Client call leg.\r\n\r\n#### Possible Solutions\r\n* For more information on understanding what does and does not constitute a SIP call leg, please see [Understanding SIP Call Legs](https://www.twilio.com/docs/voice/twiml/refer#understanding-call-legs).\r\n* While invoking Refer on a SIP leg is unique in that it removes Twilio from the call path, the effect of transferring a call to another party can be accomplished on all leg types by simply using the Dial verb to call the other party.',
    causes:
      '* Your application attempted to invoke the Refer verb on a PSTN or Twilio Client call leg.',
    solutions:
      '* For more information on understanding what does and does not constitute a SIP call leg, please see [Understanding SIP Call Legs](https://www.twilio.com/docs/voice/twiml/refer#understanding-call-legs).\r\n* While invoking Refer on a SIP leg is unique in that it removes Twilio from the call path, the effect of transferring a call to another party can be accomplished on all leg types by simply using the Dial verb to call the other party.',
    description:
      'The Refer verb is only allowed on SIP call legs, e.g. you can refer an incoming SIP call that originate from SIP infrastructure or an outbound call to a SIP destination. Calls to or from other destinations, such as a phone number or Twilio Client cannot be referred.',
    product: 'Programmable Voice',
    date_created: '2019-08-29T17:37:50Z',
    last_updated: '2020-08-04T10:00:07.154Z',
  },
  14220: {
    code: 14220,
    message: 'Enqueue: Provided Workflow was not a valid sid',
    log_level: 'ERROR',
    secondary_message: 'Provided workflow sid was not valid.',
    log_type: null,
    docs: '## Error - 14220\n\n### Enqueue: Provided Workflow was not a valid sid\n\nProvided Workflow is invalid.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:13Z',
    last_updated: '2020-08-04T10:00:26.099Z',
  },
  50384: {
    code: 50384,
    message: "Initial state can't be 'closed",
    log_level: 'ERROR',
    secondary_message: "It's not allowed to set 'closed' state for newly created converastion",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50384\r\n\r\n### Initial state can't be 'closed\r\n\r\nIt's not allowed to set 'closed' state for newly created converastion You are trying to set 'closed' state during conversation creation which is not allowed\r\n\r\n#### Possible Causes\r\n* 'State' parameter value is set to 'closed' which is not allowed during conversation creation\r\n\r\n#### Possible Solutions\r\n* Change 'State' parameter value to either 'active' or 'inactive' during conversation creation",
    causes:
      "* 'State' parameter value is set to 'closed' which is not allowed during conversation creation",
    solutions:
      "* Change 'State' parameter value to either 'active' or 'inactive' during conversation creation",
    description:
      "You are trying to set 'closed' state during conversation creation which is not allowed",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:31:23Z',
    last_updated: '2020-09-24T12:31:26.65Z',
  },
  25004: {
    code: 25004,
    message: "The provided user's external ID is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25004\r\n\r\n### The provided user's external ID is invalid\r\n\r\n The provided user's external ID is invalid.\r\n\r\n#### Possible Causes\r\nThe external ID is either less than 2 characters or exceeds 255 characters.\r\n\r\n#### Possible Solutions\r\nEnsure the user's external ID is between 2 and 255 characters in length.",
    causes: 'The external ID is either less than 2 characters or exceeds 255 characters.',
    solutions: "Ensure the user's external ID is between 2 and 255 characters in length.",
    description: "The provided user's external ID is invalid.",
    product: 'Organizations API',
    date_created: '2023-12-04T09:48:06Z',
    last_updated: '2023-12-04T14:09:28.983573Z',
  },
  18609: {
    code: 18609,
    message: 'Ineligible Business Registration Authority',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18609\r\n\r\n### Ineligible Business Registration Authority\r\n\r\n The provided business registration authority is not an EIN (Employer Identification Number) or DUN (Data Universal Numbering System) number.\r\n\r\n#### Possible Causes\r\nThe submitted business registration authority does not meet the eligibility requirements for the US Voice Integrity/CNAM trust product.\r\n\r\n#### Possible Solutions\r\nPlease resubmit your registration using either an EIN or a DUN number.',
    causes:
      'The submitted business registration authority does not meet the eligibility requirements for the US Voice Integrity/CNAM trust product.',
    solutions: 'Please resubmit your registration using either an EIN or a DUN number.',
    description:
      'The provided business registration authority is not an EIN (Employer Identification Number) or DUN (Data Universal Numbering System) number.',
    product: 'Phone Numbers',
    date_created: '2024-04-21T22:59:27Z',
    last_updated: '2024-04-21T22:59:27Z',
  },
  70105: {
    code: 70105,
    message: 'Invalid Type Specified in the Request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70105\r\n\r\n### Invalid Type Specified in the Request\r\nWhen using a Twilio Resource that supports working with different types of Twilio Credentials (Public Key Credentials, Push Credentials) the request must contain type(s) that is recognized by the resource.\r\n\r\n#### Possible Solution:\r\n* Check the API documents to verify the correct credential type(s) were used in the request.\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:59:28Z',
    last_updated: '2020-08-04T10:00:19.782Z',
  },
  22171: {
    code: 22171,
    message: 'Port In Error - Missing required fields',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22171\r\n\r\n### Port In Error - Missing required fields\r\n\r\n Missing required fields, please review which fields are required for each country.\r\n\r\n#### Possible Causes\r\nThere are missing required fields for the country your phone numbers are related to.\r\n\r\n#### Possible Solutions\r\nCheck what fields are required for each country and update those fields with valid values.',
    causes: 'There are missing required fields for the country your phone numbers are related to.',
    solutions:
      'Check what fields are required for each country and update those fields with valid values.',
    description:
      'Missing required fields, please review which fields are required for each country.',
    product: 'Phone Numbers',
    date_created: '2024-05-03T16:59:10Z',
    last_updated: '2024-05-03T16:59:10Z',
  },
  31904: {
    code: 31904,
    message: 'Stream - WebSocket - Host Unreachable',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31904\r\n\r\n### Stream - WebSocket - Host Unreachable\r\n\r\n The WebSocket connection cannot be created because the server is unreachable.\r\n\r\n#### Possible Causes\r\n* Wrong IP address or DNS name\r\n* IP address belongs to the private domain and it is non-routable\r\n* Host is down or disconnected from router\r\n\r\n#### Possible Solutions\r\n* Validate the IP address or DNS names are valid and belongs to the public domain\r\n* Validate the host is running and properly connected to the Internet',
    causes:
      '* Wrong IP address or DNS name\r\n* IP address belongs to the private domain and it is non-routable\r\n* Host is down or disconnected from router',
    solutions:
      '* Validate the IP address or DNS names are valid and belongs to the public domain\r\n* Validate the host is running and properly connected to the Internet',
    description: 'The WebSocket connection cannot be created because the server is unreachable.',
    product: 'Programmable Voice',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-02-03T10:23:53Z',
  },
  50434: {
    code: 50434,
    message: 'Participant projected address not provided',
    log_level: 'ERROR',
    secondary_message: 'No Projected Address provided for this participant the group conversation.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50434\r\n\r\n### Participant projected address not provided\r\n\r\nNo Projected Address provided for this participant the group conversation. This is a Group MMS conversation, but the given participant has neither an Address nor a ProjectedAddress.\r\n\r\n#### Possible Causes\r\n* You may have inadvertently provided an Identity (chat user), rather than an Address (mobile phone).\r\n* You may have mistyped or inadvertently left out the ProjectedAddress parameter.\r\n\r\n#### Possible Solutions\r\n* [Provide a Projected Address](https://www.twilio.com/docs/conversations/group-texting#scenario-1-set-up-a-group-message-with-one-chat-participant-and-two-sms-participants) when adding this Participant to the Group Conversation. This is the correct path when adding Chat participants to a Group MMS conversation.',
    causes:
      '* You may have inadvertently provided an Identity (chat user), rather than an Address (mobile phone).\r\n* You may have mistyped or inadvertently left out the ProjectedAddress parameter.',
    solutions:
      '* [Provide a Projected Address](https://www.twilio.com/docs/conversations/group-texting#scenario-1-set-up-a-group-message-with-one-chat-participant-and-two-sms-participants) when adding this Participant to the Group Conversation. This is the correct path when adding Chat participants to a Group MMS conversation.',
    description:
      'This is a Group MMS conversation, but the given participant has neither an Address nor a ProjectedAddress.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T11:55:21Z',
    last_updated: '2021-08-16T11:55:21Z',
  },
  60312: {
    code: 60312,
    message: 'Challenge creation limit reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60312\r\n\r\n### Challenge creation limit reached\r\n\r\n The maximum number of Challenge creations for a Factor has been reached.\r\n\r\nMax. number of attempts for a Factor with `Config.CodeLength` less or equal to 4: 10 every 24 hours.\r\n\r\nMax. number of attempts for a Factor with `Config.CodeLength` greater or equal to 5: 50 every hour, and up to 100 every 24 hours.\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\nToo many Challenges created within a time period.\r\n\r\n#### Possible Solutions\r\n- Create a new Factor and verify it. Then create new Challenges under the new Factor.\r\n- Depending on the Factor's `Config.CodeLength` parameter, await rate limit cooldown period between 1 hour and 24 hours.",
    causes: 'Too many Challenges created within a time period.',
    solutions:
      "- Create a new Factor and verify it. Then create new Challenges under the new Factor.\r\n- Depending on the Factor's `Config.CodeLength` parameter, await rate limit cooldown period between 1 hour and 24 hours.",
    description:
      'The maximum number of Challenge creations for a Factor has been reached.\r\n\r\nMax. number of attempts for a Factor with `Config.CodeLength` less or equal to 4: 10 every 24 hours.\r\n\r\nMax. number of attempts for a Factor with `Config.CodeLength` greater or equal to 5: 50 every hour, and up to 100 every 24 hours.\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2021-05-21T16:36:38Z',
    last_updated: '2021-06-30T22:25:45.672441Z',
  },
  32653: {
    code: 32653,
    message: 'Real-time Transcriptions: Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 32653\r\n\r\n### Real-time Transcriptions: Internal Error\r\n\r\n A 32653 Error is an indication that there is an internal server error and some internal services failed\r\n\r\n#### Possible Causes\r\n* Some error occurred during communication with Twilio internal services\r\n\r\n#### Possible Solutions\r\n* If this is a continuous experience, please contact Twilio Support',
    causes: '* Some error occurred during communication with Twilio internal services',
    solutions: '* If this is a continuous experience, please contact Twilio Support',
    description:
      'A 32653 Error is an indication that there is an internal server error and some internal services failed',
    product: 'Programmable Voice',
    date_created: '2024-05-10T20:05:39Z',
    last_updated: '2024-05-10T20:05:39Z',
  },
  50509: {
    code: 50509,
    message: 'Programmable Chat: Media message body cannot be updated',
    log_level: 'ERROR',
    secondary_message: 'Media message body cannot be updated',
    log_type: null,
    docs: '## Error - 50509\r\n\r\n### Programmable Chat: Media message body update not allowed\r\n\r\n#### Possible Causes \r\n*  Media message body cannot be updated. \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:43:01Z',
    last_updated: '2020-08-04T10:00:16.391Z',
  },
  64002: {
    code: 64002,
    message: 'Pay: Service unavailable.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 64002\r\n\r\n### Pay: Service unavailable.\r\n\r\n ## Error - 64002\r\n\r\n### Pay: Service unavailable.\r\n\r\nA 64002 Error is an indication that there is an internal server error and some internal services failed.\r\n\r\n#### Possible Causes\r\n* Some internal services in Twilio were not available.\r\n* Payment provider not available.\r\n\r\n#### Possible Solutions\r\n* Try to retry the request.\r\n*   If the error persists, please <a href="/help/contact">contact us</a> and we can help you resolve the issue. \r\n*   Note the time of the error and what you were trying to do when it occurred.',
    causes:
      '* Some internal services in Twilio were not available.\r\n* Payment provider not available.',
    solutions:
      '* Try to retry the request.\r\n*   If the error persists, please <a href="/help/contact">contact us</a> and we can help you resolve the issue. \r\n*   Note the time of the error and what you were trying to do when it occurred.',
    description:
      '## Error - 64002\r\n\r\n### Pay: Service unavailable.\r\n\r\nA 64002 Error is an indication that there is an internal server error and some internal services failed.',
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:53:28Z',
    last_updated: '2020-08-04T10:00:10.354Z',
  },
  13618: {
    code: 13618,
    message: 'Record: Recording not available for transcription',
    log_level: 'WARNING',
    secondary_message:
      'The recording was not available when Twilio fetched the recording for transcription',
    log_type: null,
    docs: '## Warning - 13618\n\n### Record: Recording not available for transcription\n\n#### Possible Causes \n* The recording was deleted before before Twilio was able to fetch the recording for transcription.\n\n#### Possible Solutions\n* Make a request to delete the recording once you receive the transcribe callback instead of the record callback. This ensures that the recording is available for Twilio to transcribe and still allows you to delete recordings from Twilio.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:46Z',
    last_updated: '2020-08-04T10:00:27.735Z',
  },
  94400: {
    code: 94400,
    message: 'Transcriptions: transcription internal error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 94400\r\n\r\n### Transcriptions: transcription internal error\r\n\r\n Twilio failed to transcribe audio due to an internal issue. The transcription files have been deleted and the resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\n* Twilio failed to process transcription request and all retries attempts were exhausted\r\n* Twilio failed to normalize and/or store transcription results and all retries attempts were exhausted\r\n\r\n#### Possible Solutions\r\n ',
    causes:
      '* Twilio failed to process transcription request and all retries attempts were exhausted\r\n* Twilio failed to normalize and/or store transcription results and all retries attempts were exhausted',
    solutions: ' ',
    description:
      'Twilio failed to transcribe audio due to an internal issue. The transcription files have been deleted and the resource has been marked as “failed”',
    product: null,
    date_created: '2021-07-21T09:10:20Z',
    last_updated: '2021-07-21T09:10:20Z',
  },
  25015: {
    code: 25015,
    message: 'The SCIM PATCH request is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25015\r\n\r\n### The SCIM PATCH request is invalid\r\n\r\n The `SCIM PATCH` request is invalid.\r\n\r\n#### Possible Causes\r\nThe syntax of the `PATCH` request is incorrect.\r\n\r\n#### Possible Solutions\r\nVerify that the `PATCH` request adheres to the specified format guidelines. Ensure that the request structure aligns with the SCIM standards for PATCH requests to resolve this issue.',
    causes: 'The syntax of the `PATCH` request is incorrect.',
    solutions:
      'Verify that the `PATCH` request adheres to the specified format guidelines. Ensure that the request structure aligns with the SCIM standards for PATCH requests to resolve this issue.',
    description: 'The `SCIM PATCH` request is invalid.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:32:07Z',
    last_updated: '2023-12-04T14:20:17.087986Z',
  },
  14236: {
    code: 14236,
    message: 'Dial->Conference: Invalid ReservationSid',
    log_level: 'ERROR',
    secondary_message: 'Provided ReservationSid on Conference is invalid',
    log_type: null,
    docs: '## Error - 14236\r\n\r\n### Conference: Invalid ReservationSid\r\n\r\nThe provided ReservationSid on the Conference TwiML was invalid.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:47:38Z',
    last_updated: '2020-08-04T10:00:21.759Z',
  },
  21475: {
    code: 21475,
    message: 'Unable to update Status, invalid Status.',
    log_level: 'ERROR',
    secondary_message:
      "The Status you specified must be one of the following strings: 'active', 'suspended', or 'closed'.",
    log_type: null,
    docs: "## Error - 21475\n\n### Unable to update Status, invalid Status.\n\nThe Status you specified must be one of the following strings: 'active', 'suspended', or 'closed'.\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:23Z',
    last_updated: '2020-08-04T10:00:25.294Z',
  },
  25203: {
    code: 25203,
    message: 'Listing role assignments requires query parameters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25203\r\n\r\n### Listing role assignments requires query parameters\r\n\r\n Listing role assignments requires query parameters.\r\n\r\n#### Possible Causes\r\nThe role assignment listing call did not include any query parameters.\r\n\r\n#### Possible Solutions\r\nWhen listing role assignments, the call must include at least one of the following query parameters: "identity," "scope," or both.',
    causes: 'The role assignment listing call did not include any query parameters.',
    solutions:
      'When listing role assignments, the call must include at least one of the following query parameters: "identity," "scope," or both.',
    description: 'Listing role assignments requires query parameters.',
    product: 'Organizations API',
    date_created: '2023-12-04T12:04:15Z',
    last_updated: '2023-12-04T14:28:32.571731Z',
  },
  50077: {
    code: 50077,
    message: 'Invalid pre-webhook url',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain a valid url for pre-webhook.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 50077\r\n\r\n### Invalid pre-webhook url\r\n\r\nRequest does not contain a valid url for pre-webhook. \r\n\r\n#### Possible Causes\r\n*  Provided url has the wrong format. \r\n\r\n#### Possible Solutions\r\n*  Make sure that url is complete and properly encoded.\r\n*  Make sure that url contains valid protocol and hostname and doesn't contain invalid characters.",
    causes: '*  Provided url has the wrong format. ',
    solutions:
      "*  Make sure that url is complete and properly encoded.\r\n*  Make sure that url contains valid protocol and hostname and doesn't contain invalid characters.",
    description: null,
    product: 'Programmable Chat',
    date_created: '2024-01-29T21:51:18Z',
    last_updated: '2024-01-29T21:51:18Z',
  },
  54201: {
    code: 54201,
    message: 'Map Item not found',
    log_level: 'ERROR',
    secondary_message: 'The specified Map Item does not exist.',
    log_type: null,
    docs: '\n## Error - 54201\n\n### Sync: Map Item not found\nThe specified Map Item does not exist.\n\n#### Possible Causes\n* The specified Sync Map item key is incorrect.\n* The requested item of a Sync Map has been deleted.\n\n#### Possible Solutions\nConfirm a valid Sync Map key is being passed in your request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.479Z',
  },
  63016: {
    code: 63016,
    message:
      'Failed to send freeform message because you are outside the allowed window. If you are using WhatsApp, please use a Message Template.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 63016\r\n\r\n### Failed to send freeform message because you are outside the allowed window. If you are using WhatsApp, please use a Message Template.\r\n\r\n \r\n\r\n#### Possible Causes\r\n* This message failed to be delivered to the user because it was sent outside the messaging channel\'s allowed conversation window. For WhatsApp messages initiated by the business, you must use a pre-defined template. \r\n* If the message was created with Content API or Content Editor it may be one of the following 3 issues: \r\n * The customer has not included a messaging service SID\r\n * The customer is still using "body" instead of "Content SID" and "Content Variables"\r\n * The customer is using content type that is not supported for business initiated conversations, e.g. listpicker or location\r\n* For Facebook Messenger messages initiated by the business, only publishers registered with the Facebook News Page Index (NPI) are allowed to send notification messages outside the 24-hour window.\r\n\r\n#### Possible Solutions\r\n* [Send a WhatsApp message using a template](https://www.twilio.com/docs/whatsapp/api#send-a-whatsapp-message-using-a-template)\r\n* [Include all the necessary parameters for a Content API or Content Editor Template and make sure you aren\'t sending with the wrong parameters](https://www.twilio.com/docs/content/send-templates-created-with-the-content-editor)\r\n* If you are a publisher, register your Facebook Page with the [Facebook News Page Index](https://www.facebook.com/business/help/316333835842972?id=644465919618833)',
    causes:
      '* This message failed to be delivered to the user because it was sent outside the messaging channel\'s allowed conversation window. For WhatsApp messages initiated by the business, you must use a pre-defined template. \r\n* If the message was created with Content API or Content Editor it may be one of the following 3 issues: \r\n * The customer has not included a messaging service SID\r\n * The customer is still using "body" instead of "Content SID" and "Content Variables"\r\n * The customer is using content type that is not supported for business initiated conversations, e.g. listpicker or location\r\n* For Facebook Messenger messages initiated by the business, only publishers registered with the Facebook News Page Index (NPI) are allowed to send notification messages outside the 24-hour window.',
    solutions:
      "* [Send a WhatsApp message using a template](https://www.twilio.com/docs/whatsapp/api#send-a-whatsapp-message-using-a-template)\r\n* [Include all the necessary parameters for a Content API or Content Editor Template and make sure you aren't sending with the wrong parameters](https://www.twilio.com/docs/content/send-templates-created-with-the-content-editor)\r\n* If you are a publisher, register your Facebook Page with the [Facebook News Page Index](https://www.facebook.com/business/help/316333835842972?id=644465919618833)",
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-01-30T19:26:43Z',
    last_updated: '2023-08-09T13:35:32.97829Z',
  },
  48028: {
    code: 48028,
    message: 'Outgoing conversation: Unauthorized use of the proxy address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48028\r\n\r\n### Outgoing conversation: Unauthorized use of the proxy address\r\n\r\n A conversation could not be created because your Twilio account is not authorized to use the provided Twilio proxy address.\r\n\r\n#### Possible Causes\r\n* The outgoing conversation callback returned a Twilio proxy number that was created under a different Twilio account.\r\n\r\n#### Possible Solutions\r\n* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback belongs to the Twilio account under which the conversation is being created.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#configure-the-twilio-frontline-integration-service) on how to configure your Twilio credentials in the integration service.',
    causes:
      '* The outgoing conversation callback returned a Twilio proxy number that was created under a different Twilio account.',
    solutions:
      '* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback belongs to the Twilio account under which the conversation is being created.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#configure-the-twilio-frontline-integration-service) on how to configure your Twilio credentials in the integration service.',
    description:
      'A conversation could not be created because your Twilio account is not authorized to use the provided Twilio proxy address.',
    product: 'Frontline',
    date_created: '2022-04-20T15:53:25Z',
    last_updated: '2022-04-20T15:53:25Z',
  },
  13310: {
    code: 13310,
    message: 'Gather: Invalid finishOnKey value',
    log_level: 'WARNING',
    secondary_message:
      'The value of the finishOnKey attribute must be one of the following characters "0123456789#*". See the <a href=\'/docs/api/twiml/gather#finishOnKey\'>Gather Verb</a> API Reference for more information.',
    log_type: null,
    docs: '## Warning - 13310 \n\n### Gather: Invalid finishOnKey value\n\nThe value of the finishOnKey attribute must be one of the following characters "0123456789#*". See the <a href=\'/docs/api/twiml/gather#finishOnKey\'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:40Z',
    last_updated: '2020-08-04T10:00:28.184Z',
  },
  90403: {
    code: 90403,
    message: '[Autopilot] Signature validation failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90403\r\n\r\n### [Autopilot] Signature validation failed\r\n\r\n Signature validation is failed. \r\n\r\n#### Possible Causes\r\nThe account owns the messaging/voice service does not have any parent/sub-account relationship with the account owns the Autopilot assistant. \r\n\r\n#### Possible Solutions\r\nMoving the assistant (export and import) into the service account or service account's one of the sub-accounts would solve the problem.  \r\n",
    causes:
      'The account owns the messaging/voice service does not have any parent/sub-account relationship with the account owns the Autopilot assistant. ',
    solutions:
      "Moving the assistant (export and import) into the service account or service account's one of the sub-accounts would solve the problem.  \r\n",
    description: 'Signature validation is failed. ',
    product: 'Understand',
    date_created: '2021-12-13T21:35:13Z',
    last_updated: '2021-12-13T21:35:13Z',
  },
  30897: {
    code: 30897,
    message: 'Campaign vetting rejection - Disallowed Content',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30897\r\n\r\n### Campaign vetting rejection - Disallowed Content\r\n\r\n The campaign submission has been reviewed and it was rejected due to Disallowed Content.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because it has disallowed content types, such as Loan Marketing, 3rd party debt collection, gambling, sweepstakes, stock alerts, cryptocurrency, risk investments, debt reduction, credit repair, 3rd party lead generation, federally illegal substances.\r\n\r\n#### Possible Solutions\r\nThe rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada ) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because it has disallowed content types, such as Loan Marketing, 3rd party debt collection, gambling, sweepstakes, stock alerts, cryptocurrency, risk investments, debt reduction, credit repair, 3rd party lead generation, federally illegal substances.',
    solutions:
      'The rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada ) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected due to Disallowed Content.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:44:01Z',
    last_updated: '2023-04-18T11:44:01Z',
  },
  31922: {
    code: 31922,
    message: 'Stream - WebSocket - URL Schema Not Supported',
    log_level: 'ERROR',
    secondary_message: 'The URL schema is not supported by Programmable Streams',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31922\r\n\r\n### Stream - WebSocket - URL Schema Not Supported\r\n\r\nThe URL schema is not supported by Programmable Streams \r\n\r\n#### Possible Causes\r\n* URL schema is not supported\r\n\r\n#### Possible Solutions\r\n* Verify the schema in TwiML URL is wss',
    causes: '* URL schema is not supported',
    solutions: '* Verify the schema in TwiML URL is wss',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:55:53Z',
    last_updated: '2020-08-04T10:00:07.346Z',
  },
  19035: {
    code: 19035,
    message: 'Invalid page size, it must be between 1 and 25 if specified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19035\r\n\r\n### Invalid page size, it must be between 1 and 25 if specified\r\n\r\n The page size provided in the request is not valid\r\n\r\n#### Possible Causes\r\nPage size specified greater than 25 or less than 1\r\n\r\n#### Possible Solutions\r\nPage size must be between 1 and 25',
    causes: 'Page size specified greater than 25 or less than 1',
    solutions: 'Page size must be between 1 and 25',
    description: 'The page size provided in the request is not valid',
    product: null,
    date_created: '2020-07-21T20:26:47Z',
    last_updated: '2020-08-04T10:00:01.326Z',
  },
  53112: {
    code: 53112,
    message: 'Status is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53112: Status is invalid\r\n\r\nRaised in the REST API when Status is not valid or the Room is not in-progress.\r\n\r\n#### Causes\r\n\r\n * REST API call to Update Room instance with Status that is invalid or cannot be applied to the current Room state.\r\n\r\n#### Solutions\r\n\r\n * Set Status to completed and only apply to a Room that is in-progress.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:59:42Z',
    last_updated: '2020-08-04T10:00:19.347Z',
  },
  16020: {
    code: 16020,
    message: 'Conference is full',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16020\r\n\r\n### Conference is full\r\n\r\nA participant has attempted to join a conference that has reached its maximum participant capacity.\r\n\r\nPlease refer to https://www.twilio.com/docs/voice/twiml/conference for documentation on conference participant capacity.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:15:13Z',
    last_updated: '2020-08-04T10:00:10.054Z',
  },
  60704: {
    code: 60704,
    message: 'Phone number not branded by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60704\r\n\r\n### Phone number not branded by Twilio\r\n\r\n The origination number (`From`) used was not found as a valid branded phone number\r\n\r\n#### Possible Causes\r\n- The origination number does not belong to the account\r\n- The origination number is incorrect\r\n- The origination number is not correctly branded, or linked to a business/brand\r\n- The origination number is linked to a deactivated business/brand\r\n- The origination number is linked to a business/brand that's not vetted, or the vetting was rejected\r\n\r\n#### Possible Solutions\r\n- Make sure the origination number belongs to the account and is in the correct E.164 format\r\n- Make sure the origination number is correctly linked to a business/brand, that's vetting-approved, and that's active",
    causes:
      "- The origination number does not belong to the account\r\n- The origination number is incorrect\r\n- The origination number is not correctly branded, or linked to a business/brand\r\n- The origination number is linked to a deactivated business/brand\r\n- The origination number is linked to a business/brand that's not vetted, or the vetting was rejected",
    solutions:
      "- Make sure the origination number belongs to the account and is in the correct E.164 format\r\n- Make sure the origination number is correctly linked to a business/brand, that's vetting-approved, and that's active",
    description:
      'The origination number (`From`) used was not found as a valid branded phone number',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:37:39Z',
    last_updated: '2020-08-04T10:00:05.127Z',
  },
  50707: {
    code: 50707,
    message: 'Virtual Agent participant creation is not available for your account.',
    log_level: 'ERROR',
    secondary_message: 'Virtual Agent participant creation is not available for your account.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50707\r\n\r\n### Virtual Agent participant creation is not available for your account.\r\n\r\nVirtual Agent participant creation is not available for your account. \r\n\r\n#### Possible Causes\r\nYou are trying to create virtual agent participant for account that is not allowed to use it.\r\n\r\n#### Possible Solutions\r\n* Please contact Twilio support to enable Virtual Agent participant creation for your account.',
    causes:
      'You are trying to create virtual agent participant for account that is not allowed to use it.',
    solutions:
      '* Please contact Twilio support to enable Virtual Agent participant creation for your account.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:05:05Z',
    last_updated: '2023-10-11T18:05:05Z',
  },
  62028: {
    code: 62028,
    message: 'Interconnect: Connection expired.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 62028\r\n\r\n#### Possible Causes \r\n* Connection expired.\r\n\r\n#### Possible Solutions\r\n*  The connection SID in the request has expired, and may no longer be used. Please create a new connection. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:51:26Z',
    last_updated: '2020-08-04T10:00:20.676Z',
  },
  31901: {
    code: 31901,
    message: 'Stream - WebSocket - Connection Timeout',
    log_level: 'ERROR',
    secondary_message:
      "The WebSocket connection request sent by the stream didn't receive any response from the server",
    log_type: 'APPLICATION',
    docs: "## ERROR - 31901\r\n\r\n### Stream - WebSocket - Connection Timeout\r\n\r\nThe WebSocket connection request sent by the stream didn't receive any response from the server \r\n\r\n#### Possible Causes\r\n* WebSocket server is not connected to any network\r\n* Bad IP address provided in the TwiML URL\r\n* Intermediate elements (like ngrok) are not routing traffic\r\n* There is a firewall blocking the traffic\r\n\r\n#### Possible Solutions\r\n* Verify server connectivity\r\n* Verify the TwiML URL is correct\r\n* Verify intermediate elements are routing traffic and firewall are not blocking ports",
    causes:
      '* WebSocket server is not connected to any network\r\n* Bad IP address provided in the TwiML URL\r\n* Intermediate elements (like ngrok) are not routing traffic\r\n* There is a firewall blocking the traffic',
    solutions:
      '* Verify server connectivity\r\n* Verify the TwiML URL is correct\r\n* Verify intermediate elements are routing traffic and firewall are not blocking ports',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:54:00Z',
    last_updated: '2020-08-04T10:00:07.443Z',
  },
  50451: {
    code: 50451,
    message:
      'One user identifier parameter for lookup at a time is allowed. Please, use either Identity or Address.',
    log_level: 'ERROR',
    secondary_message: 'Request should contain either Identity or Address parameter, not both.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50451\r\n\r\n### One user identifier parameter for lookup at a time is allowed. Please, use either Identity or Address.\r\n\r\nRequest should contain either Identity or Address parameter, not both. \r\n\r\n#### Possible Causes\r\n*  Both Identity and Address were provided\r\n\r\n#### Possible Solutions\r\n*  Please, provide either Identity or Address',
    causes: '*  Both Identity and Address were provided',
    solutions: '*  Please, provide either Identity or Address',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-07-26T10:50:54Z',
    last_updated: '2021-07-26T10:50:54Z',
  },
  21654: {
    code: 21654,
    message: 'ContentSid Required',
    log_level: 'ERROR',
    secondary_message:
      'A ContentSid must be specified if ContentVariables are provided in the request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21654\r\n\r\n### ContentSid Required\r\n\r\n A ContentSid must be specified if ContentVariables are provided in the request.\r\n\r\n#### Possible Causes\r\nYou attempted to send a message with the ContentVariables parameter but without ContentSid.\r\n\r\n#### Possible Solutions\r\nPlease provide a ContentSid when the request includes the ContentVariables parameter. Review [this documentation](https://www.twilio.com/docs/content/send-templates-created-with-the-content-template-builder) for how to send Content Templates.',
    causes:
      'You attempted to send a message with the ContentVariables parameter but without ContentSid.',
    solutions:
      'Please provide a ContentSid when the request includes the ContentVariables parameter. Review [this documentation](https://www.twilio.com/docs/content/send-templates-created-with-the-content-template-builder) for how to send Content Templates.',
    description: 'A ContentSid must be specified if ContentVariables are provided in the request.',
    product: 'Programmable SMS',
    date_created: '2021-09-29T15:21:17Z',
    last_updated: '2024-02-12T12:05:02.43387Z',
  },
  25106: {
    code: 25106,
    message: 'Failed to complete request due to a bad request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25106\r\n\r\n### Failed to complete request due to a bad request\r\n\r\n Failed to complete request due to a bad request\r\n\r\n#### Possible Causes\r\n- The resource to be modified has moved into a state that is no longer valid.\r\n- Input on the request did not pass validation.\r\n\r\n#### Possible Solutions\r\n- Retry the request after confirming the request is valid.\r\n- Verify if the resource to be modified exists and is in a valid state.',
    causes:
      '- The resource to be modified has moved into a state that is no longer valid.\r\n- Input on the request did not pass validation.',
    solutions:
      '- Retry the request after confirming the request is valid.\r\n- Verify if the resource to be modified exists and is in a valid state.',
    description: 'Failed to complete request due to a bad request',
    product: 'Organizations API',
    date_created: '2023-12-04T11:33:41Z',
    last_updated: '2023-12-04T11:36:22.248325Z',
  },
  80621: {
    code: 80621,
    message: 'Requests Rate Limited on Endpoint',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 80621\r\n\r\n### Requests Rate Limited on Endpoint\r\n\r\n You have reached the limit on the number of requests for this endpoint\r\n\r\n#### Possible Causes\r\nThere is high increase of number of requests for this endpoint within a short span of time.\r\n\r\n#### Possible Solutions\r\nYou can retry the requests with a random exponential backoff or can follow any of the other techniques to avoid rate limiting.',
    causes:
      'There is high increase of number of requests for this endpoint within a short span of time.',
    solutions:
      'You can retry the requests with a random exponential backoff or can follow any of the other techniques to avoid rate limiting.',
    description: 'You have reached the limit on the number of requests for this endpoint',
    product: 'Proxy',
    date_created: '2023-11-30T08:39:55Z',
    last_updated: '2023-11-30T08:39:55Z',
  },
  21702: {
    code: 21702,
    message: 'The Messaging Service is not available to send new messages',
    log_level: 'ERROR',
    secondary_message: 'The Messaging Service is not available to send new messages',
    log_type: null,
    docs: '## Error - 21702\n\n### The Messaging Service is not available to send new messages.\n\nThe Messaging Service is not available to send new messages.\n\n#### Possible Solutions\n*  Retry your API call\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:29Z',
    last_updated: '2020-08-04T10:00:24.881Z',
  },
  31940: {
    code: 31940,
    message: 'Stream - Invalid connectorName attribute in TwiML.',
    log_level: 'ERROR',
    secondary_message:
      'connectorName attribute provided does not reference a connector configuration.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31940\r\n\r\n### Stream - Invalid connectorName attribute in TwiML.\r\n\r\nconnectorName attribute provided does not reference a connector configuration. Invalid connectorName attribute in TwiML.\r\n\r\n\r\n#### Possible Causes\r\nA 31940 Error is an indication that the value provided with connectorName attribute does not match to an installed configuration.\r\n\r\n\r\n#### Possible Solutions\r\n* Make sure that the connectorName matches a Unique Name in an installed connector.',
    causes:
      'A 31940 Error is an indication that the value provided with connectorName attribute does not match to an installed configuration.\r\n',
    solutions:
      '* Make sure that the connectorName matches a Unique Name in an installed connector.',
    description: 'Invalid connectorName attribute in TwiML.\r\n',
    product: 'Programmable Voice',
    date_created: '2020-02-13T15:17:17Z',
    last_updated: '2021-03-16T07:58:51.775Z',
  },
  17000: {
    code: 17000,
    message: 'Forbidden to access data',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 17000\r\n\r\n### Forbidden to access data\r\n\r\n This error code is returned when an account is trying to access a resource created by another account. Note: parent accounts can access subaccount resources, but subaccounts cannot access parent account resources, or other subaccounts under the same parent account. \r\n\r\n#### Possible Causes\r\nThis error code is also returned when an account is attempting to access a resource where Voice Insights Advanced Features has not been enabled on that account.\r\n\r\n#### Possible Solutions\r\nOnce enabled future calls will be retrievable via API.',
    causes:
      'This error code is also returned when an account is attempting to access a resource where Voice Insights Advanced Features has not been enabled on that account.',
    solutions: 'Once enabled future calls will be retrievable via API.',
    description:
      'This error code is returned when an account is trying to access a resource created by another account. Note: parent accounts can access subaccount resources, but subaccounts cannot access parent account resources, or other subaccounts under the same parent account. ',
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:23:26Z',
    last_updated: '2020-09-29T19:23:26Z',
  },
  60606: {
    code: 60606,
    message: 'Lookup Package is Not Enabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60606\r\n\r\n### Lookup Package is Not Enabled\r\n\r\n Your account is not enabled to call the requested package.\r\n\r\n#### Possible Causes\r\nThe request was received but failed due to the Account not being enabled to access the requested Lookup package.\r\n\r\n#### Possible Solutions\r\n- Check that the Account SID provided is correct.\r\n- If the requested package requires it, complete the [Account Security Registration form](https://twlo.my.salesforce-sites.com/countrycarrier/SN_CarrierRegistration_VFP) to enable the package on your Account.\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to rule out other issues.',
    causes:
      'The request was received but failed due to the Account not being enabled to access the requested Lookup package.',
    solutions:
      '- Check that the Account SID provided is correct.\r\n- If the requested package requires it, complete the [Account Security Registration form](https://twlo.my.salesforce-sites.com/countrycarrier/SN_CarrierRegistration_VFP) to enable the package on your Account.\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to rule out other issues.',
    description: 'Your account is not enabled to call the requested package.',
    product: 'Lookup',
    date_created: '2020-12-28T19:48:36Z',
    last_updated: '2023-08-08T17:18:02.159162Z',
  },
  22122: {
    code: 22122,
    message: 'Invalid Authorization Document Status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22122\r\n\r\n#### Invalid Authorization Document Status\r\n\r\nStatus must be one of "opened" or "signing."',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-16T00:42:10Z',
    last_updated: '2020-08-04T10:00:14.816Z',
  },
  13328: {
    code: 13328,
    message: 'Gather: Invalid maxSpeechTime value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13328 \r\n\r\n### Gather: Invalid maxSpeechTime value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-08-21T21:41:13Z',
    last_updated: '2020-08-04T10:00:17.961Z',
  },
  13332: {
    code: 13332,
    message: 'Gather: Invalid bargeIn value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13332\r\n\r\n### Gather: Invalid bargeIn value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-05-01T22:48:24Z',
    last_updated: '2020-08-04T10:00:19.199Z',
  },
  64011: {
    code: 64011,
    message: 'Pay: Connector does not support the requested currency.',
    log_level: 'ERROR',
    secondary_message: 'The currency attribute had a value that the Connector did not support.',
    log_type: null,
    docs: '## Error - 64011\r\n\r\n### Pay: Connector does not support the requested currency.\r\n\r\nA 64011 Error is an indication that the value provided in the currency attribute is not supported by this &lt;Pay&gt; Connector.\r\n\r\n#### Possible Causes\r\n* currency is an invalid currency code.\r\n* currency is not supported by the &lt;Pay&gt; Connector.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-02-26T22:05:45Z',
    last_updated: '2020-08-04T10:00:10.189Z',
  },
  52143: {
    code: 52143,
    message: 'The push notification was rejected by APNs',
    log_level: 'ERROR',
    secondary_message: 'Request was malformed',
    log_type: 'TWILIO',
    docs: '## ERROR - 52143\r\n\r\n### The push notification was rejected by APNs\r\n\r\n The push notification was rejected by APNs for some reason.\r\n\r\nNB: Twilio push infrastructure does not support the notifications to not main certificate topic. So application device token and certificate subject must have the same bundle id. For instance, for VoIP notifications the certificate subject must end with "*.voip" and the device token app bundle ends with "*.voip".\r\n\r\n#### Possible Causes\r\n* The push notification subject in the certificate is incorrect\r\n* The device token cannot be used with the specified subject\r\n* Pushing to the specified topic is not allowed\r\n* An internal Twilio error has occurred\r\n\r\n#### Possible Solutions\r\n* Verify that your certificate is correct\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes:
      '* The push notification subject in the certificate is incorrect\r\n* The device token cannot be used with the specified subject\r\n* Pushing to the specified topic is not allowed\r\n* An internal Twilio error has occurred',
    solutions:
      '* Verify that your certificate is correct\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    description:
      'The push notification was rejected by APNs for some reason.\r\n\r\nNB: Twilio push infrastructure does not support the notifications to not main certificate topic. So application device token and certificate subject must have the same bundle id. For instance, for VoIP notifications the certificate subject must end with "*.voip" and the device token app bundle ends with "*.voip".',
    product: 'Notifications',
    date_created: '2018-01-04T11:20:33Z',
    last_updated: '2020-08-04T10:00:15.367Z',
  },
  19026: {
    code: 19026,
    message: 'Maximum number of channels allowed reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19026\r\n\r\n### Maximum number of channels allowed reached\r\n\r\n Maximum number of channels of the same type  allowed reached\r\n\r\n#### Possible Causes\r\nAttempt to create more than 5 channels of the same type\r\n\r\n#### Possible Solutions\r\nOnly 5 channels of the same type are allowed',
    causes: 'Attempt to create more than 5 channels of the same type',
    solutions: 'Only 5 channels of the same type are allowed',
    description: 'Maximum number of channels of the same type  allowed reached',
    product: null,
    date_created: '2020-07-21T20:19:01Z',
    last_updated: '2020-08-04T10:00:01.62Z',
  },
  63103: {
    code: 63103,
    message: 'Cannot assign payment method to WABA provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63103\r\n\r\n### Cannot assign payment method to WABA provided\r\n\r\n The WhatsApp Business Account (WABA) provided is unable to use Twilio's credit line. Due to technical limitations within Meta's systems, once a payment method is added to a WABA it can only be revoked but never fully removed.\r\n\r\n#### Possible Causes\r\n* Using a WABA currently assigned to another payment method\r\n* Using a WABA that has been used with another provider\r\n\r\n#### Possible Solutions\r\n* Create a new WABA to use with Twilio",
    causes:
      '* Using a WABA currently assigned to another payment method\r\n* Using a WABA that has been used with another provider',
    solutions: '* Create a new WABA to use with Twilio',
    description:
      "The WhatsApp Business Account (WABA) provided is unable to use Twilio's credit line. Due to technical limitations within Meta's systems, once a payment method is added to a WABA it can only be revoked but never fully removed.",
    product: 'Channels',
    date_created: '2024-02-09T22:26:13Z',
    last_updated: '2024-02-09T22:26:13Z',
  },
  64005: {
    code: 64005,
    message: 'Pay: Connector does not support tokenization.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64005\r\n\r\n### Pay: Connector does not support tokenization.\r\n\r\n ## Error - 64005\r\n\r\n### Pay: Connector does not support tokenization.\r\n\r\nA 64005 Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\n#### Possible Causes\r\n* The paymentConnector attribute points to Connector that does not support tokenization.\r\n* The chargeAmount attribute in the Pay Verb TwiML was 0 (or omitted) and you intended to charge.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports tokenization.\r\n* If a charge was intended, please change the chargeAmount attribute and provided a positive value. Please see <A HREF="/docs/voice/twiml/pay#chargeamount">this API documentation</A> for more details.',
    causes:
      '* The paymentConnector attribute points to Connector that does not support tokenization.\r\n* The chargeAmount attribute in the Pay Verb TwiML was 0 (or omitted) and you intended to charge.',
    solutions:
      '* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports tokenization.\r\n* If a charge was intended, please change the chargeAmount attribute and provided a positive value. Please see <A HREF="/docs/voice/twiml/pay#chargeamount">this API documentation</A> for more details.',
    description:
      '## Error - 64005\r\n\r\n### Pay: Connector does not support tokenization.\r\n\r\nA 64005 Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.',
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:56:31Z',
    last_updated: '2020-08-04T10:00:10.299Z',
  },
  13335: {
    code: 13335,
    message: 'Gather: speechTimeout auto cannot be used with model default',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13335\r\n\r\n### Gather: speechTimeout auto cannot be used with model default\r\n\r\n Gather: speechTimeout auto cannot be used with model default\r\n\r\n#### Possible Causes\r\nspeechTimeout value invalid\r\n\r\n#### Possible Solutions\r\nspeechTimeout value change',
    causes: 'speechTimeout value invalid',
    solutions: 'speechTimeout value change',
    description: 'Gather: speechTimeout auto cannot be used with model default',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:33:06Z',
    last_updated: '2020-08-04T10:00:04.444Z',
  },
  45351: {
    code: 45351,
    message: 'Invalid Channel Participant properties.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45351\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'A create Conversation or add Participant request was made with a Participant having both or neither of identity and address specified.',
    solutions: 'Specify either identity or address for Participants\r',
    description:
      'Failed to add Participant <participant sid> to Channel <meeting sid>. Channel Participant properties must contain exactly one of "identity" or an "address"/"proxy_address" pair.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:25.690371Z',
  },
  21628: {
    code: 21628,
    message: 'Address Validation Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 21628\r\n\r\n### Address Validation Error\r\n\r\nThe address you have provided cannot be validated. \r\n\r\n#### Possible Causes\r\n- Address misspelling\r\n- Address cannot be found in third-party data source \r\n\r\n#### Possible Solutions\r\n- Ensure the address is spelled correctly \r\n- Contact Twilio Support',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2016-12-07T05:05:24Z',
    last_updated: '2020-08-04T10:00:20.308Z',
  },
  31952: {
    code: 31952,
    message: 'Stream Extension not found: ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31952\r\n\r\n### Stream Extension not found: \r\n\r\n Stream Extension not found\r\n\r\n#### Possible Causes\r\nStream Extension not found\r\n\r\n#### Possible Solutions\r\nTry using stream extension in another realm or checking that you are using a valid stream extension.',
    causes: 'Stream Extension not found',
    solutions:
      'Try using stream extension in another realm or checking that you are using a valid stream extension.',
    description: 'Stream Extension not found',
    product: 'Programmable Voice',
    date_created: '2020-08-31T17:10:44Z',
    last_updated: '2020-08-31T17:10:44Z',
  },
  21456: {
    code: 21456,
    message: 'Invalid CallbackUrl',
    log_level: 'ERROR',
    secondary_message: 'CallbackUrl must be a valid URL using the HTTP or HTTPS protol.',
    log_type: null,
    docs: "## Error - 21456 \n\n### Invalid CallbackUrl\n\nThe callback URL given to callback after validation isn't a valid URL.\n\n#### Possible Causes \n\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:01Z',
    last_updated: '2020-08-04T10:00:26.835Z',
  },
  52171: {
    code: 52171,
    message: 'Webhook Credentials request signature was not verified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52171\r\n\r\n### Webhook Credentials request signature was not verified\r\n\r\n#### Possible Causes \r\n*  Your token endpoint was not able to verify the request signature\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credentials are configured with the correct values\r\n*  Verify that your signature verification logic is working as expected',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T12:07:22Z',
    last_updated: '2020-08-04T10:00:14.198Z',
  },
  40143: {
    code: 40143,
    message: 'TaskRouter->Conference',
    log_level: 'ERROR',
    secondary_message:
      "Conference Instruction does not have a valid 'post_work_activity_sid' provided.",
    log_type: null,
    docs: '## Error - 40143\r\n\r\n### Invalid Activity Sid - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  You provided a \'post_work_activity_sid\' that was invalid or no longer exists.  \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid ActivitySid is being passed in the \'post_work_activity_sid\' parameter and it exists in your workspace. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:42:29Z',
    last_updated: '2020-08-04T10:00:21.917Z',
  },
  34004: {
    code: 34004,
    message: 'Error during fax transmission',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 34004\r\n### Fax: Error during fax transmission\r\n\r\nEither poor connection quality to the recipient or the recipient terminated the fax early.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Fax',
    date_created: '2017-09-15T19:46:44Z',
    last_updated: '2020-08-04T10:00:17.043Z',
  },
  60318: {
    code: 60318,
    message: 'Factor is unverified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60318\r\n\r\n### Factor is unverified\r\n\r\n HTTP status: 403\r\n\r\n#### Possible Causes\r\nThe Factor has not been verified.\r\n\r\n#### Possible Solutions\r\nVerify the Factor first.',
    causes: 'The Factor has not been verified.',
    solutions: 'Verify the Factor first.',
    description: 'HTTP status: 403',
    product: 'Verify',
    date_created: '2020-06-30T21:31:32Z',
    last_updated: '2021-06-30T03:46:02.53917Z',
  },
  60234: {
    code: 60234,
    message: 'Sender id can not be set as not default',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60234\r\n\r\n### Sender id can not be set as not default\r\n\r\n Sender id can not be set as not default\r\n\r\n#### Possible Causes\r\nThe sender id that's being updated is default and it's not allowed to set default as false\r\n\r\n#### Possible Solutions\r\nSet another sender id as default",
    causes:
      "The sender id that's being updated is default and it's not allowed to set default as false",
    solutions: 'Set another sender id as default',
    description: 'Sender id can not be set as not default',
    product: 'Verify',
    date_created: '2023-08-15T21:55:41Z',
    last_updated: '2023-08-15T21:55:41Z',
  },
  20101: {
    code: 20101,
    message: 'Invalid Access Token',
    log_level: 'ERROR',
    secondary_message: 'Twilio was unable to validate your Access Token',
    log_type: null,
    docs: "# Error - 20101\r\n\r\n## Twilio was unable to validate your Access Token\r\n\r\nThe Access Token provided to the Twilio API was invalid.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation, see\r\n[the documentation](/docs/api/rest/access-tokens).\r\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T06:43:22Z',
    last_updated: '2020-08-04T10:00:22.77Z',
  },
  30409: {
    code: 30409,
    message: 'This message cannot be canceled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30409\r\n\r\n### This message cannot be canceled\r\n\r\n \r\n\r\n#### Possible Causes\r\nAttempted to cancel the message after it has reached a [finalized state](https://support.twilio.com/hc/en-us/articles/223134347-What-are-the-Possible-SMS-and-MMS-Message-Statuses-and-What-do-They-Mean-#:~:text=Finalized%20Message%20Delivery%20Status&text=Twilio%20has%20not%20received%20updated%20delivery%20information%20for%20your%20message.&text=Twilio%20has%20received%20a%20delivery,of%20the%20destination%20handset%2C%20etc.).\r\n\r\n#### Possible Solutions\r\nN/A',
    causes:
      'Attempted to cancel the message after it has reached a [finalized state](https://support.twilio.com/hc/en-us/articles/223134347-What-are-the-Possible-SMS-and-MMS-Message-Statuses-and-What-do-They-Mean-#:~:text=Finalized%20Message%20Delivery%20Status&text=Twilio%20has%20not%20received%20updated%20delivery%20information%20for%20your%20message.&text=Twilio%20has%20received%20a%20delivery,of%20the%20destination%20handset%2C%20etc.).',
    solutions: 'N/A',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-08-06T22:34:55Z',
    last_updated: '2021-08-06T22:34:55Z',
  },
  83603: {
    code: 83603,
    message: 'The maximum allowed query period is 31 days for group by sim queries',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83603\r\n\r\n### The maximum allowed query period is 31 days for group by sim queries\r\n\r\n Requests for Usage Records grouping by "sim" can query a maximum time period of 31 days.\r\n\r\n#### Possible Causes\r\n * This happens if you request Usage Records grouped by SIM with StartTime or EndTime parameters that span more than 31 days.\r\n\r\n#### Possible Solutions\r\n * Adjust your StartTime or EndTime parameters so that the time range is less than or equal to 31 days.',
    causes:
      ' * This happens if you request Usage Records grouped by SIM with StartTime or EndTime parameters that span more than 31 days.',
    solutions:
      ' * Adjust your StartTime or EndTime parameters so that the time range is less than or equal to 31 days.',
    description:
      'Requests for Usage Records grouping by "sim" can query a maximum time period of 31 days.',
    product: 'Super SIM',
    date_created: '2021-08-19T13:15:17Z',
    last_updated: '2021-08-19T13:42:33.007687Z',
  },
  22118: {
    code: 22118,
    message: 'Invalid Verification Document SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22118\r\n\r\n#### Invalid Verification Document SID\r\n\r\nThe Verification Document SID specified is not a valid identity document identifier. \r\n\r\n#### Possible Causes\r\n\r\n* The Verification Document SID is not a 34-character string that is prefixed with "RI".\r\n\r\n* The identity document represented by the Verification DocumentSID is not of type "phone-bill".\r\n\r\n* The identity document represented by the Verification Document SID does not exist anymore or does not belong to your account.\r\n\r\n#### Possible Solutions\r\n\r\nPlease specify a Verification Document SID you’ve created in your [Account Dashboard](https://www.twilio.com/console/phone-numbers/identities).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-07T19:45:13Z',
    last_updated: '2020-08-04T10:00:14.94Z',
  },
  63036: {
    code: 63036,
    message: 'The specified phone number cannot be reached by RBM at this time.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63036\r\n\r\n### The specified phone number cannot be reached by RBM at this time.\r\n\r\n The specified phone number cannot be reached by RBM at this time.\r\n\r\n#### Possible Causes\r\nDevice is switched off\r\n\r\n#### Possible Solutions\r\nTurn on the device and enable RCS',
    causes: 'Device is switched off',
    solutions: 'Turn on the device and enable RCS',
    description: 'The specified phone number cannot be reached by RBM at this time.',
    product: 'Programmable SMS',
    date_created: '2019-10-10T20:34:31Z',
    last_updated: '2020-08-04T10:00:06.092Z',
  },
  32017: {
    code: 32017,
    message: 'PSTN: Carrier blocked call due to calling number (caller ID)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 32017\r\n\r\n### PSTN: Carrier blocked call due to calling number (caller ID)\r\n\r\n Intermediary / Carrier Analytics blocked call due to poor reputation score on the telephone number\r\n\r\n#### Possible Causes\r\n* The calling number has a low answer rate from end users\r\n* The calling number generates low duration calls\r\n* The calling number is responsible for large volumes of unwanted calls\r\n\r\n#### Possible Solutions\r\nRegister the telephone numbers with the analytic providers. To reach the major mobile carrier's analytic providers, please register the telephone numbers at www.freecallerregistry.com . To reach T-Mobile's analytic provider directly to register numbers, please go to https://portal.firstorion.com to register numbers. Going direct to the analytic provider has a faster turnaround of being registered / call being delivered to end user",
    causes:
      '* The calling number has a low answer rate from end users\r\n* The calling number generates low duration calls\r\n* The calling number is responsible for large volumes of unwanted calls',
    solutions:
      "Register the telephone numbers with the analytic providers. To reach the major mobile carrier's analytic providers, please register the telephone numbers at www.freecallerregistry.com . To reach T-Mobile's analytic provider directly to register numbers, please go to https://portal.firstorion.com to register numbers. Going direct to the analytic provider has a faster turnaround of being registered / call being delivered to end user",
    description:
      'Intermediary / Carrier Analytics blocked call due to poor reputation score on the telephone number',
    product: null,
    date_created: '2019-08-14T23:43:57Z',
    last_updated: '2023-01-29T23:36:23.360948Z',
  },
  30119: {
    code: 30119,
    message: 'Certificate and private key pair is invalid',
    log_level: 'ERROR',
    secondary_message: 'Private key and certificate mismatch',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30119\r\n\r\n### Certificate and private key pair is invalid\r\n\r\nPrivate key and certificate mismatch The provided private key and certificate are both are valid but they do not match\r\n\r\n#### Possible Causes\r\n- Certificate and key are for differing domains\r\n\r\n#### Possible Solutions\r\nPlease regenerated and reupload key and certificate ensuring they are both for the correct domain.',
    causes: '- Certificate and key are for differing domains',
    solutions:
      'Please regenerated and reupload key and certificate ensuring they are both for the correct domain.',
    description:
      'The provided private key and certificate are both are valid but they do not match',
    product: 'Programmable SMS',
    date_created: '2020-09-03T19:45:14Z',
    last_updated: '2022-07-15T00:04:22.853365Z',
  },
  68006: {
    code: 68006,
    message: 'Initialization Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 68006\r\n\r\n### Initialization Error\r\n\r\n An error occurred while initializing a class.\r\n\r\n#### Possible Causes\r\nMissing arguments to initialize a class.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'Missing arguments to initialize a class.',
    solutions: 'Check parameters and retry.',
    description: 'An error occurred while initializing a class.',
    product: 'Verify',
    date_created: '2020-09-15T18:15:32Z',
    last_updated: '2020-09-15T18:15:32Z',
  },
  16099: {
    code: 16099,
    message: 'Unexpected conference status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16099\r\n\r\n### Unexpected conference status\r\n\r\nThe requested conference is in an unexpected state for the desired operation.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:24:07Z',
    last_updated: '2020-08-04T10:00:10.002Z',
  },
  40001: {
    code: 40001,
    message:
      'Could not parse Assignment Instruction response as JSON. Ensure your JSON is not escaped',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 40001\r\n\r\n### Could not parse Assignment Instruction response as JSON. Ensure your JSON is not escaped\r\n\r\n  \r\n#### Example\r\n\r\n##### Valid JSON (Not Escaped)\r\n~~~.json\r\n{\r\n  "instruction": "call",\r\n  "from": "+15558675309",\r\n  "url": "http://example.com/agent_answer",   \r\n  "status_callback_url":\r\n    "http://example.com/agent_answer_status_callback"\r\n}\r\n~~~\r\n\r\n##### Invalid JSON (Escaped)\r\n~~~.json\r\n{\\r\\n  \\"instruction\\": \\"call\\",\\r\\n  \\"from\\": \\"+15558675309\\",\\r\\n  \\"url\\": \\"http:\\/\\/example.com\\/agent_answer\\",   \\r\\n  \\"status_callback_url\\":\\r\\n    \\"http:\\/\\/example.com\\/agent_answer_status_callback\\"\\r\\n}\r\n~~~\r\n\r\n\r\n\r\n#### Possible Causes\r\nJSON is escaped\r\n\r\n#### Possible Solutions\r\nEnsure your JSON is not escaped',
    causes: 'JSON is escaped',
    solutions: 'Ensure your JSON is not escaped',
    description:
      ' \r\n#### Example\r\n\r\n##### Valid JSON (Not Escaped)\r\n~~~.json\r\n{\r\n  "instruction": "call",\r\n  "from": "+15558675309",\r\n  "url": "http://example.com/agent_answer",   \r\n  "status_callback_url":\r\n    "http://example.com/agent_answer_status_callback"\r\n}\r\n~~~\r\n\r\n##### Invalid JSON (Escaped)\r\n~~~.json\r\n{\\r\\n  \\"instruction\\": \\"call\\",\\r\\n  \\"from\\": \\"+15558675309\\",\\r\\n  \\"url\\": \\"http:\\/\\/example.com\\/agent_answer\\",   \\r\\n  \\"status_callback_url\\":\\r\\n    \\"http:\\/\\/example.com\\/agent_answer_status_callback\\"\\r\\n}\r\n~~~\r\n\r\n',
    product: 'TaskRouter',
    date_created: '2020-07-15T22:41:36Z',
    last_updated: '2020-08-04T10:00:02.133Z',
  },
  60235: {
    code: 60235,
    message: 'Sender Definitions does not match with requirements',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60235\r\n\r\n### Sender Definitions does not match with requirements\r\n\r\n Sender definitions does not match with requirements\r\n\r\n#### Possible Causes\r\nThe sender definitions contains invalid properties\r\n\r\n#### Possible Solutions\r\nValidate the object, it contains invalid requirements such as an invalid name. Sender id must have at least 3 characters and up to 11 characters.',
    causes: 'The sender definitions contains invalid properties',
    solutions:
      'Validate the object, it contains invalid requirements such as an invalid name. Sender id must have at least 3 characters and up to 11 characters.',
    description: 'Sender definitions does not match with requirements',
    product: 'Verify',
    date_created: '2023-08-16T21:48:52Z',
    last_updated: '2023-08-16T21:48:52Z',
  },
  32701: {
    code: 32701,
    message: 'Voice User-Defined Message: Invalid Content-Type',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32701\r\n\r\n### Voice User-Defined Message: Invalid Content-Type\r\n\r\n Invalid Content-Type in the POST request to the UserDefinedMessage Resource. Only `application/json` is supported.\r\n\r\n#### Possible Causes\r\n* Value of Content-Type in the POST request to the UserDefinedMessage Resource is not as expected, or there is no Content-Type header in the request.\r\n\r\n#### Possible Solutions\r\n* Make sure that Content-Type Header is included in the POST request to the UserDefinedMessage Resource and the value of the Content-Type Header is `application/json`.',
    causes:
      '* Value of Content-Type in the POST request to the UserDefinedMessage Resource is not as expected, or there is no Content-Type header in the request.',
    solutions:
      '* Make sure that Content-Type Header is included in the POST request to the UserDefinedMessage Resource and the value of the Content-Type Header is `application/json`.',
    description:
      'Invalid Content-Type in the POST request to the UserDefinedMessage Resource. Only `application/json` is supported.',
    product: 'Programmable Voice',
    date_created: '2022-08-18T21:48:15Z',
    last_updated: '2022-08-18T22:02:04.092387Z',
  },
  13330: {
    code: 13330,
    message: 'Gather: Invalid hints value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13330\r\n\r\n### Gather: Invalid hints value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-05-01T22:46:50Z',
    last_updated: '2020-08-04T10:00:19.238Z',
  },
  50059: {
    code: 50059,
    message: 'Programmable Chat: Notification sound name too long',
    log_level: 'ERROR',
    secondary_message: 'Specified notification sound parameter is too long',
    log_type: null,
    docs: '## Error - 50059\r\n\r\n### Programmable Chat: Notification sound name too long\r\n\r\n#### Possible Causes \r\n*  Specified notification sound parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length notification sound parameter is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T07:50:30Z',
    last_updated: '2020-08-04T10:00:16.787Z',
  },
  51107: {
    code: 51107,
    message: "Twilsock: Service can't be used",
    log_level: 'ERROR',
    secondary_message: "Service can't be used",
    log_type: null,
    docs: "## Error - 51107\r\n\r\n### Service can't be used",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:10:58Z',
    last_updated: '2020-08-04T10:00:09.807Z',
  },
  60407: {
    code: 60407,
    message: 'Authentication Token Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60407\r\n\r\n### Authentication Token Error\r\n\r\n An error occurred while generating a token.\r\n\r\n#### Possible Causes\r\nUnsupported factor type.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'Unsupported factor type.',
    solutions: 'Check parameters and retry.',
    description: 'An error occurred while generating a token.',
    product: 'Verify',
    date_created: '2021-03-15T20:47:45Z',
    last_updated: '2021-03-15T20:47:45Z',
  },
  45376: {
    code: 45376,
    message: 'Failed to add a participant.  Conversation was closed or not found.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45376\r\n\r\n### Failed to add a participant.  Conversation was closed or not found.\r\n\r\n Failed to add Participant <participant_sid>. Conversation <conversation_sid> was closed or not found.\r\n\r\n#### Possible Causes\r\nWe did not add a Participant to a Channel because the Channel has either been closed or deleted.\r\n\r\n#### Possible Solutions\r\nEnsure that the target Conversation is in the correct state.',
    causes:
      'We did not add a Participant to a Channel because the Channel has either been closed or deleted.',
    solutions: 'Ensure that the target Conversation is in the correct state.',
    description:
      'Failed to add Participant <participant_sid>. Conversation <conversation_sid> was closed or not found.',
    product: 'Flex',
    date_created: '2022-03-22T22:56:51Z',
    last_updated: '2022-03-22T22:56:51Z',
  },
  83003: {
    code: 83003,
    message: 'The Super SIM already belongs to the requesting Account.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83003\r\n\r\n### The Super SIM already belongs to the requesting Account.\r\n\r\n Raised whenever you try to register a Super SIM that is already registered to your Account.\r\n\r\n#### Possible Causes\r\nYou tried to register a Super SIM that already belongs to your Account.\r\n\r\n#### Possible Solutions\r\nYou do not need to register the Super SIM as it is already associated to your Account. The error message contains the Super SIM SID that you can use to look it up.',
    causes: 'You tried to register a Super SIM that already belongs to your Account.',
    solutions:
      'You do not need to register the Super SIM as it is already associated to your Account. The error message contains the Super SIM SID that you can use to look it up.',
    description:
      'Raised whenever you try to register a Super SIM that is already registered to your Account.',
    product: 'Super SIM',
    date_created: '2021-03-22T00:02:20Z',
    last_updated: '2021-03-22T00:02:20Z',
  },
  31409: {
    code: 31409,
    message: 'Conflict',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31409\r\n\r\n### Conflict\r\n\r\nThe request could not be processed because of a conflict in the current state of the resource. Another request may be in progress.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:21:23Z',
    last_updated: '2020-08-04T10:00:08.415Z',
  },
  22217: {
    code: 22217,
    message: 'Missing Supporting Document field',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22217\r\n\r\n### Missing Supporting Document field\r\n\r\n A Supporting Document field is missing from the regulatory bundle.\r\n\r\n#### Possible Causes\r\nThe Regulation requires a Supporting Document field which is missing from your Regulatory Bundle.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Regulations API resource to ensure that all required fields are present in the Supporting Document.',
    causes:
      'The Regulation requires a Supporting Document field which is missing from your Regulatory Bundle.',
    solutions:
      'Please refer to the Regulations API resource to ensure that all required fields are present in the Supporting Document.',
    description: 'A Supporting Document field is missing from the regulatory bundle.',
    product: 'Phone Numbers',
    date_created: '2020-04-23T22:12:33Z',
    last_updated: '2020-08-04T10:00:03.738Z',
  },
  21606: {
    code: 21606,
    message:
      "The 'From' phone number provided is not a valid message-capable Twilio phone number for this destination/account",
    log_level: 'ERROR',
    secondary_message:
      'You can only send SMS messages from a phone number provided by Twilio, and that phone number must be SMS enabled. Visit the phone numbers page on your account portal to view a list of phone numbers that you own, and whether or not they are enabled for SMS.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21606\r\n\r\n### The \'From\' phone number provided is not a valid message-capable Twilio phone number for this destination/account\r\n\r\n You can only send SMS messages from a phone number, Alphanumeric Sender ID or [short code](https://www.twilio.com/docs/glossary/what-is-a-short-code) provided by or ported to Twilio. Phone numbers must be SMS-capable. For Short Codes, the `From` number must be in the same country as the `To` number.\r\n\r\nVisit the [phone numbers page](https://www.twilio.com/console/phone-numbers/incoming) of your account portal to view a list of phone numbers that you own and to determine whether they are SMS-capable.\r\n\r\n#### Possible Causes\r\n* The number you are using may not be capable of sending messages.\r\n* The number may be formatted incorrectly. Twilio accepts numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).\r\n* If the number is a Short Code, it must be associated with the same country as the destination address.\r\n* The number you are using is in the process of porting/hosting.\r\n* The number you are using does not belong to the account whose credentials are present in the API request.\r\n\r\n\r\n#### Possible Solutions\r\n* Check that you are using a Twilio phone number with SMS capabilities. You can see your purchased phone numbers and their capabilities in the [Twilio console](https://www.twilio.com/console/phone-numbers/incoming).\r\n* Ensure the number you are using is in [E.164 format](https://www.twilio.com/docs/glossary/what-e164). \r\n* If you are sending from a Short Code, verify that the country you are sending to matches the country of the Short Code.\r\n* If you have ported/hosted the `From` number, ensure that the process is complete. You can follow up on this in the Twilio console for [porting](https://console.twilio.com/us1/develop/phone-numbers/port-host/porting-requests?frameUrl=%2Fconsole%2Fphone-numbers%2Fporting-requests%3Fx-target-region%3Dus1) and [hosting](https://console.twilio.com/us1/develop/phone-numbers/port-host/hosted-numbers?frameUrl=%2Fconsole%2Fphone-numbers%2Fhosted%3Fx-target-region%3Dus1).\r\n* Check that you are using account credentials that correspond with the account that owns the phone number.\r\n* If you are sending messages with test credentials, verify that you are using one of the [available test credential "magic phone numbers"](https://www.twilio.com/docs/iam/test-credentials#test-sms-messages-parameters-From).\r\n',
    causes:
      '* The number you are using may not be capable of sending messages.\r\n* The number may be formatted incorrectly. Twilio accepts numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).\r\n* If the number is a Short Code, it must be associated with the same country as the destination address.\r\n* The number you are using is in the process of porting/hosting.\r\n* The number you are using does not belong to the account whose credentials are present in the API request.\r\n',
    solutions:
      '* Check that you are using a Twilio phone number with SMS capabilities. You can see your purchased phone numbers and their capabilities in the [Twilio console](https://www.twilio.com/console/phone-numbers/incoming).\r\n* Ensure the number you are using is in [E.164 format](https://www.twilio.com/docs/glossary/what-e164). \r\n* If you are sending from a Short Code, verify that the country you are sending to matches the country of the Short Code.\r\n* If you have ported/hosted the `From` number, ensure that the process is complete. You can follow up on this in the Twilio console for [porting](https://console.twilio.com/us1/develop/phone-numbers/port-host/porting-requests?frameUrl=%2Fconsole%2Fphone-numbers%2Fporting-requests%3Fx-target-region%3Dus1) and [hosting](https://console.twilio.com/us1/develop/phone-numbers/port-host/hosted-numbers?frameUrl=%2Fconsole%2Fphone-numbers%2Fhosted%3Fx-target-region%3Dus1).\r\n* Check that you are using account credentials that correspond with the account that owns the phone number.\r\n* If you are sending messages with test credentials, verify that you are using one of the [available test credential "magic phone numbers"](https://www.twilio.com/docs/iam/test-credentials#test-sms-messages-parameters-From).\r\n',
    description:
      'You can only send SMS messages from a phone number, Alphanumeric Sender ID or [short code](https://www.twilio.com/docs/glossary/what-is-a-short-code) provided by or ported to Twilio. Phone numbers must be SMS-capable. For Short Codes, the `From` number must be in the same country as the `To` number.\r\n\r\nVisit the [phone numbers page](https://www.twilio.com/console/phone-numbers/incoming) of your account portal to view a list of phone numbers that you own and to determine whether they are SMS-capable.',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:05Z',
    last_updated: '2024-02-05T10:09:40.020865Z',
  },
  63031: {
    code: 63031,
    message: "Channels message cannot have same 'From' and 'To'",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63031\r\n\r\n### Channels message cannot have same 'From' and 'To'\r\n\r\n Channels message should not have same `From` and `To` number\r\n\r\n#### Possible Causes\r\nIncorrect `To` and `From` number in your API Request\r\n\r\n#### Possible Solutions\r\nReview your `To` and `From` parameters and include the correct values. ",
    causes: 'Incorrect `To` and `From` number in your API Request',
    solutions: 'Review your `To` and `From` parameters and include the correct values. ',
    description: 'Channels message should not have same `From` and `To` number',
    product: 'Programmable SMS',
    date_created: '2019-07-12T21:33:41Z',
    last_updated: '2024-02-05T12:22:19.391849Z',
  },
  13111: {
    code: 13111,
    message: 'Annotate: Annotate must contain only one of element X',
    log_level: 'ERROR',
    secondary_message: 'Annotate must contain only one of element X',
    log_type: null,
    docs: '## Error - 13111 \n\n### Annotate: Annotate must contain only one of element X\n\nAnnotate must contain only one of element X\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:30Z',
    last_updated: '2020-08-04T10:00:29.06Z',
  },
  21233: {
    code: 21233,
    message: 'Domain still has subdomains',
    log_level: 'ERROR',
    secondary_message: 'You cannot delete a domain while subdomains of it exist.',
    log_type: null,
    docs: '# Error - 21233\n\n### Domain still has subdomains  \n\nYou cannot delete a domain while subdomains of it exist.  \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:32Z',
    last_updated: '2020-08-04T10:00:24.664Z',
  },
  30447: {
    code: 30447,
    message: 'Toll Free verification rejection - phone number not provisioned to Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30447\r\n\r\n### Toll Free verification rejection - phone number not provisioned to Twilio\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe Toll-Free phone number phone number is already in use. It may not be a Twilio Toll-Free number.\r\n\r\n#### Possible Solutions\r\n* Ensure that the Toll-Free phone number you want to verify is fully provisioned at Twilio for your organization. \r\n* If you are an ISV, ensure that the Toll-Free phone number is not already assigned to another vendor. \r\n\r\nSee [Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada) for resources on how to implement Toll-Free messaging.\r\n\r\nSee [what happens to traffic](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected-#:~:text=deceptive%20marketing%20tactics-,What%20happens%20to%20my%20traffic%20if%20my%20Toll%2DFree%20number%20is%20rejected%3F,-If%20your%20Toll) if a Toll-Free verification is rejected',
    causes:
      'The Toll-Free phone number phone number is already in use. It may not be a Twilio Toll-Free number.',
    solutions:
      '* Ensure that the Toll-Free phone number you want to verify is fully provisioned at Twilio for your organization. \r\n* If you are an ISV, ensure that the Toll-Free phone number is not already assigned to another vendor. \r\n\r\nSee [Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada) for resources on how to implement Toll-Free messaging.\r\n\r\nSee [what happens to traffic](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected-#:~:text=deceptive%20marketing%20tactics-,What%20happens%20to%20my%20traffic%20if%20my%20Toll%2DFree%20number%20is%20rejected%3F,-If%20your%20Toll) if a Toll-Free verification is rejected',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:16:10Z',
    last_updated: '2024-04-16T16:26:40.181332Z',
  },
  60306: {
    code: 60306,
    message: 'Invalid Request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60306\r\n\r\n### Invalid Request\r\n\r\n The request is invalid.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nOne or more parameters are in an invalid format:\r\n\r\n- Invalid `AccountSid`.\r\n- Invalid `ServiceSid`.\r\n- Invalid `Identity`.\r\n- Invalid Factor parameters: Invalid `FriendlyName`, `Binding`, etc.\r\n- Invalid `AuthPayload` when verifying a factor or challenge.\r\n- Invalid `FactorSid`.\r\n- Invalid list parameters: Invalid `Page`, `PageSize` or `PageToken`.\r\n- Invalid Challenge parameters: Invalid `FactorSid`, `ExpirationDate`, `Details` or `HiddenDetails`.\r\n- Invalid `ChallengeSid`.\r\n- Invalid Factor configuration.\r\n- Invalid `JWT`.\r\n- Invalid Webhooks parameters: Invalid `EventTypes`\r\n\r\n#### Possible Solutions\r\nReview the parameters you are passing from the list above and try again. Accepted parameters are detailed in the [API reference](https://www.twilio.com/docs/verify/api).',
    causes:
      'One or more parameters are in an invalid format:\r\n\r\n- Invalid `AccountSid`.\r\n- Invalid `ServiceSid`.\r\n- Invalid `Identity`.\r\n- Invalid Factor parameters: Invalid `FriendlyName`, `Binding`, etc.\r\n- Invalid `AuthPayload` when verifying a factor or challenge.\r\n- Invalid `FactorSid`.\r\n- Invalid list parameters: Invalid `Page`, `PageSize` or `PageToken`.\r\n- Invalid Challenge parameters: Invalid `FactorSid`, `ExpirationDate`, `Details` or `HiddenDetails`.\r\n- Invalid `ChallengeSid`.\r\n- Invalid Factor configuration.\r\n- Invalid `JWT`.\r\n- Invalid Webhooks parameters: Invalid `EventTypes`',
    solutions:
      'Review the parameters you are passing from the list above and try again. Accepted parameters are detailed in the [API reference](https://www.twilio.com/docs/verify/api).',
    description: 'The request is invalid.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-06-30T16:53:02Z',
    last_updated: '2021-06-30T03:40:51.308103Z',
  },
  20409: {
    code: 20409,
    message: 'Conflict',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 20409\r\n\r\n### Conflict\r\n\r\n The request could not be completed due to a conflict with the current state of the target resource.\r\n\r\n#### Possible Causes\r\nThe resource is not in a state that allows this modification.\r\n\r\n#### Possible Solutions\r\nWait until the resource is in a modifiable state.',
    causes: 'The resource is not in a state that allows this modification.',
    solutions: 'Wait until the resource is in a modifiable state.',
    description:
      'The request could not be completed due to a conflict with the current state of the target resource.',
    product: 'Platform',
    date_created: '2020-04-03T19:50:57Z',
    last_updated: '2020-08-04T10:00:04.118Z',
  },
  53102: {
    code: 53102,
    message: 'Room name contains invalid characters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53102: Room name contains invalid characters\r\n\r\nRaised whenever a Room name contains invalid characters.\r\n\r\n#### Causes\r\n\r\n * The Room name contains an invalid UTF-8 byte sequence.\r\n\r\n#### Solutions\r\n\r\n * Choose a Room name that is a valid UTF-8 string.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:56:17Z',
    last_updated: '2020-08-04T10:00:19.384Z',
  },
  19033: {
    code: 19033,
    message: 'Location validation error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19033\r\n\r\n### Location validation error\r\n\r\n The request body has invalid inputs\r\n\r\n#### Possible Causes\r\nInvalid length, invalid data type\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'Invalid length, invalid data type',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'The request body has invalid inputs',
    product: null,
    date_created: '2020-07-21T20:25:13Z',
    last_updated: '2020-08-04T10:00:01.403Z',
  },
  95201: {
    code: 95201,
    message: 'Status callback response timed out',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 95201\r\n\r\n### Status callback response timed out\r\n\r\n Twilio attempted to send a transcript event to the callback URL specified and your application didn’t respond before time out\r\n\r\n#### Possible Causes\r\nThe server receiving status callbacks sent by Twilio takes too long to respond\r\n\r\n#### Possible Solutions\r\nEnsure that your callback server can handle the request and responds within a reasonable time',
    causes: 'The server receiving status callbacks sent by Twilio takes too long to respond',
    solutions:
      'Ensure that your callback server can handle the request and responds within a reasonable time',
    description:
      'Twilio attempted to send a transcript event to the callback URL specified and your application didn’t respond before time out',
    product: 'Voice Intelligence',
    date_created: '2024-04-18T16:36:09Z',
    last_updated: '2024-04-18T16:36:09Z',
  },
  60236: {
    code: 60236,
    message: 'The domain could not be obtained from the given email',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60236\r\n\r\n### The domain could not be obtained from the given email\r\n\r\n The domain could not be obtained from the given email\r\n\r\n#### Possible Causes\r\nCould not obtain the domain from the email provided\r\n\r\n#### Possible Solutions\r\nPlease review the email provided or the email registered of your account administrator users',
    causes: 'Could not obtain the domain from the email provided',
    solutions:
      'Please review the email provided or the email registered of your account administrator users',
    description: 'The domain could not be obtained from the given email',
    product: 'Verify',
    date_created: '2023-09-19T22:07:03Z',
    last_updated: '2023-09-19T22:07:03Z',
  },
  16102: {
    code: 16102,
    message: 'Voice Recording: Unavailable because recording is silent',
    log_level: 'WARNING',
    secondary_message:
      'Recording was detected as silent and not stored.  As a result, it is unavailable for access.',
    log_type: null,
    docs: '## Warning - 16102\r\n\r\n### Voice Recording: Unavailable because recording is silent\r\n\r\nRecording was detected as silent and not stored.  As a result, it is unavailable for access.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2018-11-28T16:42:38Z',
    last_updated: '2020-08-04T10:00:11.687Z',
  },
  50431: {
    code: 50431,
    message: 'Participant SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Conversation participant SID parameter is required but was not provided.',
    log_type: null,
    docs: '\n## Error - 50431\n\n### Conversations: Participant SID not provided\nConversation participant SID parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected a participant SID input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid participant SID parameter to the API request and confirm that it is not misspelled.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.351Z',
  },
  50375: {
    code: 50375,
    message: 'TimeToInactive should be greater or equal to 1 minute',
    log_level: 'ERROR',
    secondary_message:
      "Duration to transfer channel to inactive state can't be shorter than 1 minute.",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50375\r\n\r\n### TimeToInactive should be greater or equal to 1 minute\r\n\r\nDuration to transfer channel to inactive state can't be shorter than 1 minute. 'TimeToInactive' duration should be greater or equal to 1 minute.\r\n\r\n#### Possible Causes\r\n* 'TimeToInactive' field is set to duration which is less than 1 minute.\r\n\r\n#### Possible Solutions\r\n* Set 'TimeToInactive' field to duration which is longer than 1 minute.",
    causes: "* 'TimeToInactive' field is set to duration which is less than 1 minute.",
    solutions: "* Set 'TimeToInactive' field to duration which is longer than 1 minute.",
    description: "'TimeToInactive' duration should be greater or equal to 1 minute.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:20:35Z',
    last_updated: '2020-09-24T12:20:48.673Z',
  },
  94402: {
    code: 94402,
    message: 'Transcriptions: Encryption failed and transcription result files deleted',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94402\r\n\r\n### Transcriptions: Encryption failed and transcription result files deleted\r\n\r\n Twilio failed to encrypt and securely store transcription results. The transcription files have been deleted and the resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\n* Twilio failed to encrypt transcription results and all retries attempts were exhausted\r\n\r\n#### Possible Solutions\r\n* Set a public key that can be used to encrypt transcription results or disable encryption so future transcriptions can be successfully processed and stored',
    causes:
      '* Twilio failed to encrypt transcription results and all retries attempts were exhausted',
    solutions:
      '* Set a public key that can be used to encrypt transcription results or disable encryption so future transcriptions can be successfully processed and stored',
    description:
      'Twilio failed to encrypt and securely store transcription results. The transcription files have been deleted and the resource has been marked as “failed”',
    product: null,
    date_created: '2021-07-27T09:48:49Z',
    last_updated: '2021-07-27T10:58:19.568709Z',
  },
  90002: {
    code: 90002,
    message: 'Too Many Errors',
    log_level: 'ERROR',
    secondary_message:
      'Your Flex application has exceeded the publish rate limit of errors per second. Only a partial set of errors have been published instead.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 90002\r\n\r\n### Too Many Errors\r\n\r\nYour Flex application has exceeded the publish rate limit of errors per second. Only a partial set of errors have been published instead. \r\n\r\n#### Possible Causes\r\n* Your Flex Application is sending too many errors to the Twilio Debugger\r\n* Your Flex Plugin is misconfigured causing a lot of errors to be published\r\n\r\n#### Possible Solutions\r\n* Ensure that you have put log messages appropriately in your plugin to reduce the number errors being published\r\n* There could be errors outside of your plugins, within Twilio that are causing it to throw errors\r\n* Use `try/catch` around methods and handle exceptions gracefully\r\n* Use `.catch` for all HTTP requests to handle exceptions gracefully',
    causes:
      '* Your Flex Application is sending too many errors to the Twilio Debugger\r\n* Your Flex Plugin is misconfigured causing a lot of errors to be published',
    solutions:
      '* Ensure that you have put log messages appropriately in your plugin to reduce the number errors being published\r\n* There could be errors outside of your plugins, within Twilio that are causing it to throw errors\r\n* Use `try/catch` around methods and handle exceptions gracefully\r\n* Use `.catch` for all HTTP requests to handle exceptions gracefully',
    description: null,
    product: 'Flex',
    date_created: '2019-08-20T19:14:59Z',
    last_updated: '2020-08-04T10:00:07.192Z',
  },
  19053: {
    code: 19053,
    message: 'Field definition name cannot be a duplicate of an existing Twilio-defined field',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19053\r\n\r\n### Field definition name cannot be a duplicate of an existing Twilio-defined field\r\n\r\n Request with input field names using reserved words\r\n\r\n#### Possible Causes\r\nAttempt to create custom field definition using reserved words\r\n\r\n#### Possible Solutions\r\nUpdate input field name with unreserved words',
    causes: 'Attempt to create custom field definition using reserved words',
    solutions: 'Update input field name with unreserved words',
    description: 'Request with input field names using reserved words',
    product: 'Contacts',
    date_created: '2020-08-17T18:32:44Z',
    last_updated: '2020-08-31T06:10:51.735Z',
  },
  54155: {
    code: 54155,
    message: 'List Item revision mismatch',
    log_level: 'ERROR',
    secondary_message: 'The actual revision of the List Item does not match the expected revision.',
    log_type: null,
    docs: '\n## Error - 54155\n\n### Sync: List Item revision mismatch\nThe actual revision of the List Item does not match the expected revision.\n\n#### Possible Causes\n* Your update to this Sync List Item has conflicted with a request submitted elsewhere.\n* The value specified in the If-Match header is erroneous.\n\n#### Possible Solutions\nIf your update conflicts with a concurrent update elsewhere, the correct solution is to read the latest data (on the client SDK: wait for an update) and then re-attempt your update until you succeed. Consider that, since the data has changed, you may not want to submit the exact same update a second time. On the JavaScript SDK, we suggest using the [mutate](https://www.twilio.com/docs/api/sync/mutation-and-conflict-resolution#javascript-sdk-conflict-walkthrough) convenience function.\n\nThe value you provide in the If-Match header should be a revision assigned by the Sync service when interacting with the object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.535Z',
  },
  50534: {
    code: 50534,
    message: 'Failed to Read ChannelMetadata',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50534\r\n\r\n### Failed to Read ChannelMetadata\r\n\r\n Unable to read Channel Metadata for Message\r\n\r\n#### Possible Causes\r\n* Channel Metadata was in an invalid format\r\n* Channel Metadata required keys were missing\r\n* Error querying for Channel Metadata\r\n* Confirm the channel type provides Channel Metadata\r\n\r\n#### Possible Solutions\r\n* Retry Channel Metadata query',
    causes:
      '* Channel Metadata was in an invalid format\r\n* Channel Metadata required keys were missing\r\n* Error querying for Channel Metadata\r\n* Confirm the channel type provides Channel Metadata',
    solutions: '* Retry Channel Metadata query',
    description: 'Unable to read Channel Metadata for Message',
    product: 'Conversations',
    date_created: '2024-02-27T16:25:09Z',
    last_updated: '2024-02-27T16:25:09Z',
  },
  33101: {
    code: 33101,
    message: 'Invalid Parameter Value\t',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33101\r\n\r\n### Invalid Parameter Value\t\r\n\r\n Raised when an invalid parameter is provided. Please refer to the [API docs](https://www.twilio.com/docs/iot/wireless/api) for more details.\r\n\r\n#### Possible Causes\r\n* Your request contained invalid parameters. Please refer to the actual error response to get more details.\r\n* While removing the Rate Plan of a SIM, your SIM must not be in status `active` or `ready`.\r\n* While updating the Rate Plan of a SIM, you cannot move from NB-Annual to NB-developer.\r\n* While updating the Rate Plan of a SIM, you can only move the Rate Plan to a different Data Limit Strategy while your SIM is `new` or `deactivated`.\r\n* While updating the Rate Plan of a SIM, Narrowband SIMs cannot be paired with a non-narrowband enabled Rate Plan, or vice versa.\r\n* While creating or updating a Rate Plan, `UniqueName` is invalid.\r\n* While creating a Rate Plan, the limits (e.g. `DataLimit`, `NationalRoamingDataLimit`, `InternationalRoamingDataLimit`) you defined are out of range.\r\n\r\n#### Possible Solutions\r\n* While removing the Rate Plan from a SIM, ensure the SIM is neither in status `ready` nor `active`.\r\n* While updating the Rate Plan of a SIM, ensure that the SIM is in status `new` or `deactivated` while moving the SIM to a Rate Plan with a different Data Limit Strategy.\r\n* While updating the Rate Plan of a SIM, ensure that a Narrowband SIM has a narrowband-enabled Rate Plan, or a non-narrowband SIM has a corresponding Rate Plan.\r\n* While creating or updating a Rate Plan, ensure `UniqueName` has a different format than a Rate Plan SID, has a maximum length of 64 characters and does not exist yet.\r\n* While creating a Rate Plan, ensure that the limits (e.g. `DataLimit`, `NationalRoamingDataLimit`, `InternationalRoamingDataLimit`) are equal or between `0` and `2000000` (2TB).',
    causes:
      '* Your request contained invalid parameters. Please refer to the actual error response to get more details.\r\n* While removing the Rate Plan of a SIM, your SIM must not be in status `active` or `ready`.\r\n* While updating the Rate Plan of a SIM, you cannot move from NB-Annual to NB-developer.\r\n* While updating the Rate Plan of a SIM, you can only move the Rate Plan to a different Data Limit Strategy while your SIM is `new` or `deactivated`.\r\n* While updating the Rate Plan of a SIM, Narrowband SIMs cannot be paired with a non-narrowband enabled Rate Plan, or vice versa.\r\n* While creating or updating a Rate Plan, `UniqueName` is invalid.\r\n* While creating a Rate Plan, the limits (e.g. `DataLimit`, `NationalRoamingDataLimit`, `InternationalRoamingDataLimit`) you defined are out of range.',
    solutions:
      '* While removing the Rate Plan from a SIM, ensure the SIM is neither in status `ready` nor `active`.\r\n* While updating the Rate Plan of a SIM, ensure that the SIM is in status `new` or `deactivated` while moving the SIM to a Rate Plan with a different Data Limit Strategy.\r\n* While updating the Rate Plan of a SIM, ensure that a Narrowband SIM has a narrowband-enabled Rate Plan, or a non-narrowband SIM has a corresponding Rate Plan.\r\n* While creating or updating a Rate Plan, ensure `UniqueName` has a different format than a Rate Plan SID, has a maximum length of 64 characters and does not exist yet.\r\n* While creating a Rate Plan, ensure that the limits (e.g. `DataLimit`, `NationalRoamingDataLimit`, `InternationalRoamingDataLimit`) are equal or between `0` and `2000000` (2TB).',
    description:
      'Raised when an invalid parameter is provided. Please refer to the [API docs](https://www.twilio.com/docs/iot/wireless/api) for more details.',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:14:35Z',
    last_updated: '2020-09-15T11:15:30.252Z',
  },
  34003: {
    code: 34003,
    message: 'Callee did not answer',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 34003\r\n### Fax: Callee did not answer\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Fax',
    date_created: '2017-09-15T19:46:33Z',
    last_updated: '2020-08-04T10:00:17.068Z',
  },
  31009: {
    code: 31009,
    message: 'Transport error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31009\r\n\r\n### Transport error\r\n\r\nNo transport available to send or receive messages.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-16T23:55:54Z',
    last_updated: '2020-08-04T10:00:08.603Z',
  },
  80619: {
    code: 80619,
    message: 'Chat Channel Attribute Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 80619\r\n\r\n### Chat Channel Attribute Error\r\n\r\nChat Channel was not found or did not have expected attributes (twilioNumber, serviceNumber, status, proxySession) required for Proxy integration.  If you are using the same Chat service for both Flex and non-Flex use-cases, this is expected for non-flex messages and you can probably ignore this event.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2019-02-12T23:56:58Z',
    last_updated: '2020-08-04T10:00:10.597Z',
  },
  63101: {
    code: 63101,
    message: 'WABA ID provided is not valid or unable to be used',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63101\r\n\r\n### WABA ID provided is not valid or unable to be used\r\n\r\n Twilio cannot access the WhatsApp Business Account (WABA) with the ID provided.\r\n\r\n#### Possible Causes\r\n* The WABA has been deleted\r\n* The WABA has not been shared with Twilio\r\n* The WABA has already been linked to another Twilio account\r\n\r\n#### Possible Solutions\r\n* Check that the WABA ID provided is correct\r\n* Check that the SolutionID corresponding to Twilio's Partner Solution is correctly provided in the Embedded Signup implementation\r\n* Check that this WABA has not been linked to other Twilio accounts you own. For security purposes, Twilio cannot provide you details if the WABA is linked to another Twilio Account that you do not own.",
    causes:
      '* The WABA has been deleted\r\n* The WABA has not been shared with Twilio\r\n* The WABA has already been linked to another Twilio account',
    solutions:
      "* Check that the WABA ID provided is correct\r\n* Check that the SolutionID corresponding to Twilio's Partner Solution is correctly provided in the Embedded Signup implementation\r\n* Check that this WABA has not been linked to other Twilio accounts you own. For security purposes, Twilio cannot provide you details if the WABA is linked to another Twilio Account that you do not own.",
    description: 'Twilio cannot access the WhatsApp Business Account (WABA) with the ID provided.',
    product: 'Channels',
    date_created: '2024-02-09T22:24:40Z',
    last_updated: '2024-02-09T22:24:40Z',
  },
  16101: {
    code: 16101,
    message: 'Voice Recording : Unavailable because duration is too short',
    log_level: 'WARNING',
    secondary_message:
      'Recording is unavailable because the duration was shorter than the minimum required duration.',
    log_type: null,
    docs: '## Warning - 16101\r\n\r\n### Voice Recording : Unavailable because duration is too short\r\n\r\nRecording is unavailable because the duration was shorter than the minimum required duration.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2018-11-28T16:47:44Z',
    last_updated: '2020-08-04T10:00:11.667Z',
  },
  23004: {
    code: 23004,
    message: 'Message Redaction Incompatible Configuration: Advanced Opt-Out',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 23004\r\n\r\n### Message Redaction Incompatible Configuration: Advanced Opt-Out\r\n\r\n Phone Number Redaction is enabled for your account. Advanced Opt-Out is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* You have Advanced Opt-Out enabled on your Messaging Service. Advanced Opt-Out requires Twilio to save non-redacted phone numbers of customers who have opted out, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a block list in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" block list so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please contact Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) to disable all Twilio keyword handling for your account, including Advanced Opt-Out.',
    causes:
      '* You have Advanced Opt-Out enabled on your Messaging Service. Advanced Opt-Out requires Twilio to save non-redacted phone numbers of customers who have opted out, and is incompatible with Phone Number Redaction.',
    solutions:
      '* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a block list in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" block list so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please contact Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) to disable all Twilio keyword handling for your account, including Advanced Opt-Out.',
    description:
      'Phone Number Redaction is enabled for your account. Advanced Opt-Out is not compatible with Phone Number Redaction and should be disabled.',
    product: 'Programmable SMS',
    date_created: '2019-11-21T19:22:03Z',
    last_updated: '2023-11-01T04:32:46.848144Z',
  },
  20162: {
    code: 20162,
    message: 'A conflicting resource update is in progress',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 20162\r\n\r\n### A conflicting resource update is in progress\r\n\r\n The requested resource is already being updated simultaneously by another API request. The last request will be rejected to avoid inconsistent state.\r\n\r\n#### Possible Causes\r\nThe same API resource is being updated by multiple simultaneous API requests from  different threads in a conflicting fashion.\r\n\r\n#### Possible Solutions\r\n* Implement an operation retrier and repeat the failed API requests after an interval of time using, exponential backoff algorithm.\r\n* Serialize your API requests that modify the same resources, and wait until the original request completes and returns an API response, before sending any successive modifications.',
    causes:
      'The same API resource is being updated by multiple simultaneous API requests from  different threads in a conflicting fashion.',
    solutions:
      '* Implement an operation retrier and repeat the failed API requests after an interval of time using, exponential backoff algorithm.\r\n* Serialize your API requests that modify the same resources, and wait until the original request completes and returns an API response, before sending any successive modifications.',
    description:
      'The requested resource is already being updated simultaneously by another API request. The last request will be rejected to avoid inconsistent state.',
    product: 'Platform',
    date_created: '2020-02-27T11:18:50Z',
    last_updated: '2020-08-04T10:00:04.563Z',
  },
  80403: {
    code: 80403,
    message: 'Interaction Sid Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Interaction Sid',
    log_type: null,
    docs: '## Warning\n\n### Interaction Sid Invalid\n\nExample Message: Invalid Interaction Sid',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:15.997Z',
  },
  15004: {
    code: 15004,
    message:
      'Action Callback URL must be an absolute URL when using TwiML to update in-progress calls',
    log_level: 'ERROR',
    secondary_message: 'Use absolute URLs when updating in-progress calls with TwiML',
    log_type: 'APPLICATION',
    docs: '## ERROR - 15004\r\n\r\n### Action Callback URL must be an absolute URL when using TwiML to update in-progress calls\r\n\r\nUse absolute URLs when updating in-progress calls with TwiML The TwiML provided for updating the in-progress call must use absolute URL for action callback.\r\n\r\n#### Possible Causes\r\nA relative URL is provided for action callbacks when updating in-progress call with TwiML.\r\n\r\n#### Possible Solutions\r\nProvide an absolute URL for the action attribute when updating in-progress call with TwiML.',
    causes:
      'A relative URL is provided for action callbacks when updating in-progress call with TwiML.',
    solutions:
      'Provide an absolute URL for the action attribute when updating in-progress call with TwiML.',
    description:
      'The TwiML provided for updating the in-progress call must use absolute URL for action callback.',
    product: 'Programmable Voice',
    date_created: '2021-01-13T19:35:32Z',
    last_updated: '2021-01-13T19:35:32Z',
  },
  45308: {
    code: 45308,
    message: 'Add Participant Not Allowed',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45308\r\n\r\n### Add Participant Not Allowed\r\n\r\n Adding participant to the meeting is not allowed in the current meeting state\r\n\r\n#### Possible Causes\r\nMeeting is not in the right state for adding the participants\r\n\r\n#### Possible Solutions\r\nRetry operation',
    causes: 'Meeting is not in the right state for adding the participants',
    solutions: 'Retry operation',
    description: 'Adding participant to the meeting is not allowed in the current meeting state',
    product: 'Flex',
    date_created: '2022-09-17T01:43:39Z',
    last_updated: '2022-09-17T01:43:39Z',
  },
  54451: {
    code: 54451,
    message: "Invalid 'Order' query parameter",
    log_level: 'ERROR',
    secondary_message: "The 'Order' query parameter must be one of {'asc', 'desc'}.",
    log_type: null,
    docs: "\n## Error - 54451\n\n### Sync: Invalid 'Order' query parameter\nThe 'Order' query parameter must be one of {'asc', 'desc'}.\n\n#### Possible Causes\n* The value supplied by the Order query string parameter does not match _asc_ or _desc_ designators.\n\n#### Possible Solutions\nConfirm a valid Order query parameter is being passed in request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.23Z',
  },
  11751: {
    code: 11751,
    message: 'Media Message - Media exceeds messaging provider size limit',
    log_level: 'ERROR',
    secondary_message:
      'The total size of the media message request exceeds the maximum size limit for the channel.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 11751\r\n\r\n### Media Message - Media exceeds messaging provider size limit\r\n\r\nThe total size of the media message request exceeds the maximum size limit for the channel. ## Error - 11751\r\n\r\n### Media Message -> Media exceeds messaging provider size limit\r\n\r\nMaximum size limit depends on the messaging channel. \r\n* For an MMS message, the size limit is [5MB](https://www.twilio.com/docs/sms/accepted-mime-types).\r\n* For a WhatsApp message, the size limit is [16MB](https://www.twilio.com/docs/whatsapp/guidance-whatsapp-media-messages).\r\n\r\n\r\n#### Possible Causes\r\nThe total size of the media message request exceeds the maximum size limit for the channel.\r\n\r\n#### Possible Solutions\r\nIf you are sending multiple media files on a message, split them into multiple requests to reduce the size of each request.',
    causes:
      'The total size of the media message request exceeds the maximum size limit for the channel.',
    solutions:
      'If you are sending multiple media files on a message, split them into multiple requests to reduce the size of each request.',
    description:
      '## Error - 11751\r\n\r\n### Media Message -> Media exceeds messaging provider size limit\r\n\r\nMaximum size limit depends on the messaging channel. \r\n* For an MMS message, the size limit is [5MB](https://www.twilio.com/docs/sms/accepted-mime-types).\r\n* For a WhatsApp message, the size limit is [16MB](https://www.twilio.com/docs/whatsapp/guidance-whatsapp-media-messages).\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:33Z',
    last_updated: '2020-08-04T10:00:24.646Z',
  },
  20157: {
    code: 20157,
    message: 'Expiration Time Exceeds Maximum Time Allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20157 \r\n\r\n### Expiration Time Exceeds Maximum Time Allowed\r\nThe expiration time provided when creating the JWT exceeds 24 hours, which is the maximum duration allowed.\r\n\r\n#### Possible Solution:\r\n* Provide a shorter expiration time, which does not exceed the maximum.\r\n\r\nSee [the capability token docs](https://www.twilio.com/docs/voice/client/capability-tokens) to learn more.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:12:57Z',
    last_updated: '2020-08-04T10:00:18.995Z',
  },
  53104: {
    code: 53104,
    message: 'Unable to connect to Room',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53104: Unable to connect to Room\r\n\r\nRaised whenever a Client is unable to connect to a Room, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\n * A server-side error has occurred.\r\n\r\n#### Solutions\r\n\r\n * If the problem persists, try connecting to another region.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:57:53Z',
    last_updated: '2020-08-04T10:00:19.365Z',
  },
  18008: {
    code: 18008,
    message: 'Name mismatch on identity document.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 18008\r\n\r\n### Name mismatch on identity document.\r\n\r\n The individual’s name on the Supporting Document does not match the information entered in the Bundle.\r\n\r\n#### Possible Causes\r\nThe individual’s name on the Supporting Document does not match the information entered in the Bundle.\r\n\r\n#### Possible Solutions\r\nPlease ensure the names match exactly and that all the individual's last names are provided. Please amend firstly the name in the Business & legal representative information / Individual information section of the bundle, and then in the Bundle fields under the uploaded supporting document.",
    causes:
      'The individual’s name on the Supporting Document does not match the information entered in the Bundle.',
    solutions:
      "Please ensure the names match exactly and that all the individual's last names are provided. Please amend firstly the name in the Business & legal representative information / Individual information section of the bundle, and then in the Bundle fields under the uploaded supporting document.",
    description:
      'The individual’s name on the Supporting Document does not match the information entered in the Bundle.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:01:40Z',
    last_updated: '2024-07-04T10:01:40Z',
  },
  19028: {
    code: 19028,
    message: 'Channel value can not be updated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19028\r\n\r\n### Channel value can not be updated\r\n\r\n Channel value can not be updated\r\n\r\n#### Possible Causes\r\nThe channel value provided in the request is different from the existing one\r\n\r\n#### Possible Solutions\r\nRemove channel value from the request or Delete the existing channel and create a then new one with the new value',
    causes: 'The channel value provided in the request is different from the existing one',
    solutions:
      'Remove channel value from the request or Delete the existing channel and create a then new one with the new value',
    description: 'Channel value can not be updated',
    product: null,
    date_created: '2020-07-21T20:21:34Z',
    last_updated: '2020-08-04T10:00:01.542Z',
  },
  30444: {
    code: 30444,
    message: 'Toll Free verification rejection - Disallowed: Fraud',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30444\r\n\r\n### Toll Free verification rejection - Disallowed: Fraud\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated Fraud. \r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated Fraud. ',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:12:16Z',
    last_updated: '2024-04-16T15:56:05.631444Z',
  },
  50380: {
    code: 50380,
    message: 'TimeToClosed format is invalid',
    log_level: 'ERROR',
    secondary_message: "'TimeToClosed' parameter format should be ISO8601 duration",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50380\r\n\r\n### TimeToClosed format is invalid\r\n\r\n'TimeToClosed' parameter format should be ISO8601 duration 'TimeToClosed' parameter supported values are ISO8601 durations.\r\n\r\n#### Possible Causes\r\n* 'TimeToClosed' parameter value is not ISO8601 duration.\r\n\r\n#### Possible Solutions\r\n* Use ISO8601 duration format value for 'TimeToInactive' parameter. For example PT0S, PT10M, P1D etc..",
    causes: "* 'TimeToClosed' parameter value is not ISO8601 duration.",
    solutions:
      "* Use ISO8601 duration format value for 'TimeToInactive' parameter. For example PT0S, PT10M, P1D etc..",
    description: "'TimeToClosed' parameter supported values are ISO8601 durations.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:28:51Z',
    last_updated: '2021-02-22T12:51:01.883Z',
  },
  30474: {
    code: 30474,
    message: 'Toll Free verification rejection - Need end business',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30474\r\n\r\n### Toll Free verification rejection - Need end business\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the ISV information was submitted instead of the end business. For ISVs or systems & software powering SMS: If your software enables other businesses to send SMS/MMS to their customers, it’s expected that the information provided represents the end-business (your customer) that is engaging with the opted-in consumer, since they have the relationship with the end consumer (the receiver of the messages). \r\n\r\nWhen you submit a Verification, you need to collect and disclose the information of the business. As a best practice, this should become part of your onboarding process and customer education. Note that there is no trial experience supported on toll-free phone numbers within the industry, so if you have a trial product that includes SMS/MMS, you must collect for a full verification to send messages. \r\n\r\nSubmissions that are missing information for the end-business, or are populated with ISV/aggregator information may be rejected. Exceptions may apply when the use case clearly showcases that the ISV manages opt-in mechanisms and is the sole message content creator.\r\n\r\nNote: If you are an ISV, prior to submitting a Toll-Free Verification request with Twilio, you will need to create a TrustHub primary Customer Profile for your business within your parent account and get it approved. A primary customer profile must have the business identity set to ISV, and then submitted and approved before registering end businesses. For step-by-step guidance, see [Create a Primary Customer Profile](https://www.twilio.com/docs/trust-hub/trusthub-rest-api/console-create-a-primary-customer-profile).\r\n\r\n#### Possible Solutions\r\nRe-submit the toll-free verification with your end-business’s information (address, website, etc)\r\n\r\n\r\nResources:\r\n\r\n[Toll-free verification for ISVs]( https://support.twilio.com/hc/en-us/articles/13263383206299-Toll-Free-Verification-for-ISVs) \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the ISV information was submitted instead of the end business. For ISVs or systems & software powering SMS: If your software enables other businesses to send SMS/MMS to their customers, it’s expected that the information provided represents the end-business (your customer) that is engaging with the opted-in consumer, since they have the relationship with the end consumer (the receiver of the messages). \r\n\r\nWhen you submit a Verification, you need to collect and disclose the information of the business. As a best practice, this should become part of your onboarding process and customer education. Note that there is no trial experience supported on toll-free phone numbers within the industry, so if you have a trial product that includes SMS/MMS, you must collect for a full verification to send messages. \r\n\r\nSubmissions that are missing information for the end-business, or are populated with ISV/aggregator information may be rejected. Exceptions may apply when the use case clearly showcases that the ISV manages opt-in mechanisms and is the sole message content creator.\r\n\r\nNote: If you are an ISV, prior to submitting a Toll-Free Verification request with Twilio, you will need to create a TrustHub primary Customer Profile for your business within your parent account and get it approved. A primary customer profile must have the business identity set to ISV, and then submitted and approved before registering end businesses. For step-by-step guidance, see [Create a Primary Customer Profile](https://www.twilio.com/docs/trust-hub/trusthub-rest-api/console-create-a-primary-customer-profile).',
    solutions:
      'Re-submit the toll-free verification with your end-business’s information (address, website, etc)\r\n\r\n\r\nResources:\r\n\r\n[Toll-free verification for ISVs]( https://support.twilio.com/hc/en-us/articles/13263383206299-Toll-Free-Verification-for-ISVs) \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:52:44Z',
    last_updated: '2024-02-22T21:52:44Z',
  },
  22133: {
    code: 22133,
    message: 'Not Portable API - Manual porting available',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22133\r\n\r\n### Not Portable API - Manual porting available\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe phone number cannot be ported using the Twilio porting API. \r\n\r\n#### Possible Solutions\r\nIf the number is an US phone number, please open a porting request through the Console. See this [support page](https://support.twilio.com/hc/en-us/articles/223179348-Porting-a-Phone-Number-to-Twilio) for more information on US porting.\r\n\r\nOtherwise create a support ticket to port in a phone number from another country. See this [support page](https://support.twilio.com/hc/en-us/articles/115000781088-International-Porting-Process) for more information on international porting.',
    causes: 'The phone number cannot be ported using the Twilio porting API. ',
    solutions:
      'If the number is an US phone number, please open a porting request through the Console. See this [support page](https://support.twilio.com/hc/en-us/articles/223179348-Porting-a-Phone-Number-to-Twilio) for more information on US porting.\r\n\r\nOtherwise create a support ticket to port in a phone number from another country. See this [support page](https://support.twilio.com/hc/en-us/articles/115000781088-International-Porting-Process) for more information on international porting.',
    description: null,
    product: 'Phone Numbers',
    date_created: '2023-06-22T18:45:03Z',
    last_updated: '2023-06-28T15:30:53.91452Z',
  },
  13804: {
    code: 13804,
    message: 'AddOns are not supported in this realm',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13804\r\n\r\n### AddOns are not supported in this realm\r\n\r\n AddOns are not supported in this realm\r\n\r\n#### Possible Causes\r\nAddOns are not supported in this realm\r\n\r\n#### Possible Solutions\r\nuse AddOns in another realm',
    causes: 'AddOns are not supported in this realm',
    solutions: 'use AddOns in another realm',
    description: 'AddOns are not supported in this realm',
    product: 'Programmable Voice',
    date_created: '2020-08-31T17:06:59Z',
    last_updated: '2020-08-31T17:06:59Z',
  },
  21623: {
    code: 21623,
    message: 'Number of media files exceeds allowed limit',
    log_level: 'ERROR',
    secondary_message:
      'The number of media URLs exceeds the maximum allowed. You may send up to 10 media files in a single message.',
    log_type: null,
    docs: '## Error - 21623\n\n### Number of media files exceeds allowed limit\n\nThe number of media URLs exceeds the maximum allowed. You may send up to 10 media files in a single message. \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:29Z',
    last_updated: '2020-08-04T10:00:24.917Z',
  },
  19012: {
    code: 19012,
    message: 'When updating a contact at least one field should be updated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19012\r\n\r\n### When updating a contact at least one field should be updated\r\n\r\n No contact updates provided in the request\r\n\r\n#### Possible Causes\r\nUser has not provided contact updates\r\n\r\n#### Possible Solutions\r\nWhen updating a contact at least one field should be updated',
    causes: 'User has not provided contact updates',
    solutions: 'When updating a contact at least one field should be updated',
    description: 'No contact updates provided in the request',
    product: null,
    date_created: '2020-08-07T22:46:42Z',
    last_updated: '2020-08-07T22:46:42Z',
  },
  60218: {
    code: 60218,
    message: 'SendGrid Template is not active',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60218\r\n\r\n### SendGrid Template is not active\r\n\r\n SendGrid Template is not active\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nThe provided template is not active\r\n\r\n#### Possible Solutions\r\nLog into SendGrid's dashboard and activate the template, or select a different template",
    causes: 'The provided template is not active',
    solutions:
      "Log into SendGrid's dashboard and activate the template, or select a different template",
    description: 'SendGrid Template is not active\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-11-27T22:01:05Z',
    last_updated: '2021-05-18T04:50:17.552Z',
  },
  16106: {
    code: 16106,
    message: 'Voice Recording: Unavailable due to internal encryption error',
    log_level: 'ERROR',
    secondary_message:
      'Recording was not stored due to a transient internal encryption error  (only applicable if call recording encryption feature enabled)',
    log_type: null,
    docs: '## Error - 16106\r\n\r\n### Voice Recording: Unavailable due to internal encryption error\r\n\r\nRecording was not stored due to a transient internal encryption error  (only applicable if call recording encryption feature enabled)',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-08-25T22:29:47Z',
    last_updated: '2020-08-04T10:00:17.871Z',
  },
  60002: {
    code: 60002,
    message: 'End User Identification Timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60002\r\n\r\n### End User Identification Timeout\r\n\r\n End User Identification Timeout\r\n\r\n#### Possible Causes\r\nThe request was received but failed during processing due to a timeout. If using Silent Network Auth, this can happen when the device does not invoke the SNA URL within the timeout period. The default timeout period is 10 minutes.\r\n\r\n#### Possible Solutions\r\nResend request for this phone number to restart timeout period.',
    causes:
      'The request was received but failed during processing due to a timeout. If using Silent Network Auth, this can happen when the device does not invoke the SNA URL within the timeout period. The default timeout period is 10 minutes.',
    solutions: 'Resend request for this phone number to restart timeout period.',
    description: 'End User Identification Timeout',
    product: null,
    date_created: '2022-09-06T13:09:20.027384Z',
    last_updated: '2022-09-06T13:09:20.027398Z',
  },
  45731: {
    code: 45731,
    message: 'Pre-engagement data too large. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45731\r\n\r\n### Pre-engagement data too large. \r\n\r\n Failed to create webchat conversation. Pre-engagement data too large. \r\n\r\n#### Possible Causes\r\nPre engagment data is over the maximum allowed size of 16KB. \r\n\r\n#### Possible Solutions\r\nEnsure pre-engagement data is less than 16KB. \r\n\r\nRead more about creating valid attributes [here.](https://www.twilio.com/docs/conversations/attributes)',
    causes: 'Pre engagment data is over the maximum allowed size of 16KB. ',
    solutions:
      'Ensure pre-engagement data is less than 16KB. \r\n\r\nRead more about creating valid attributes [here.](https://www.twilio.com/docs/conversations/attributes)',
    description: 'Failed to create webchat conversation. Pre-engagement data too large. ',
    product: 'Flex',
    date_created: '2022-10-03T21:21:13Z',
    last_updated: '2022-10-03T21:21:13Z',
  },
  45601: {
    code: 45601,
    message: 'Custom Flex UI error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45601\r\n\r\n### Custom Flex UI error\r\n\r\n Error thrown by a user’s custom code/plugin. \r\n\r\n#### Possible Causes\r\n* Custom code has been written to throw and report a Flex error event\r\n\r\n#### Possible Solutions\r\n* Fix custom code so that the error is not thrown\r\n* Remove code which throws and reports a custom Flex error event',
    causes: '* Custom code has been written to throw and report a Flex error event',
    solutions:
      '* Fix custom code so that the error is not thrown\r\n* Remove code which throws and reports a custom Flex error event',
    description: 'Error thrown by a user’s custom code/plugin. ',
    product: 'Flex',
    date_created: '2021-04-30T09:13:54Z',
    last_updated: '2021-04-30T09:14:30.763Z',
  },
  62200: {
    code: 62200,
    message: 'Provisioning failure - Network-API is unavailable!',
    log_level: 'ERROR',
    secondary_message: 'Network API is not available to perform the provisioning task',
    log_type: 'APPLICATION',
    docs: '## ERROR - 62200\r\n\r\n### Provisioning failure - Network-API is unavailable!\r\n\r\nNetwork API is not available to perform the provisioning task Network provisioning calls are traced by network API which at the moment are not available.\r\n\r\n#### Possible Causes\r\nnetwork connectivity, or the NSO server down\r\n\r\n#### Possible Solutions\r\ncheck the status of the NSO if the network is fine.',
    causes: 'network connectivity, or the NSO server down',
    solutions: 'check the status of the NSO if the network is fine.',
    description:
      'Network provisioning calls are traced by network API which at the moment are not available.',
    product: 'Interconnect',
    date_created: '2020-04-13T22:21:52Z',
    last_updated: '2020-08-04T10:00:04.076Z',
  },
  62001: {
    code: 62001,
    message: 'Invalid SID',
    log_level: 'ERROR',
    secondary_message:
      'A SID that was provided in the request was not valid. Ensure that any SIDs are complete and valid.',
    log_type: null,
    docs: '## Error - 62001\r\n\r\n### Invalid SID\r\n\r\nA SID that was provided in the request was not valid. Ensure that any SIDs\r\nare complete and valid.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T20:26:23Z',
    last_updated: '2020-08-04T10:00:21.218Z',
  },
  31103: {
    code: 31103,
    message: 'Length of parameters cannot exceed MAX_PARAM_LENGTH.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31103\r\n\r\n### Length of parameters cannot exceed MAX_PARAM_LENGTH.\r\n\r\nLength of parameters cannot exceed MAX_PARAM_LENGTH.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:43:12Z',
    last_updated: '2020-08-04T10:00:11.185Z',
  },
  36005: {
    code: 36005,
    message: 'Broadcast File Type Invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 36005\r\n\r\n### Broadcast File Type Invalid\r\n\r\n Uploaded file is of an invalid type\r\n\r\n#### Possible Causes\r\n* You attempted to upload a file that isn't of type .json.gz\r\n\r\n#### Possible Solutions\r\n* Upload a file of type .json.gz (G-Zipped JSON)",
    causes: "* You attempted to upload a file that isn't of type .json.gz",
    solutions: '* Upload a file of type .json.gz (G-Zipped JSON)',
    description: 'Uploaded file is of an invalid type',
    product: 'Programmable Messaging',
    date_created: '2023-12-15T21:53:10Z',
    last_updated: '2023-12-15T21:53:10Z',
  },
  30440: {
    code: 30440,
    message: 'Toll Free verification rejection - Unknown Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30440\r\n\r\n### Toll Free verification rejection - Unknown Error\r\n\r\n The toll-free phone number cannot be verified due to an unknown error. Messaging traffic on this Toll-Free phone number is blocked.\r\n\r\n#### Possible Causes\r\nUnknown\r\n\r\n#### Possible Solutions\r\n* Contact [Twilio Customer Support](https://www.twilio.com/console/support/tickets/create)\r\n\r\nSee [Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada) for resources on how to implement Toll-Free messaging.\r\n\r\nSee [what happens to traffic](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected-#:~:text=deceptive%20marketing%20tactics-,What%20happens%20to%20my%20traffic%20if%20my%20Toll%2DFree%20number%20is%20rejected%3F,-If%20your%20Toll) if a Toll-Free verification is rejected',
    causes: 'Unknown',
    solutions:
      '* Contact [Twilio Customer Support](https://www.twilio.com/console/support/tickets/create)\r\n\r\nSee [Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada) for resources on how to implement Toll-Free messaging.\r\n\r\nSee [what happens to traffic](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected-#:~:text=deceptive%20marketing%20tactics-,What%20happens%20to%20my%20traffic%20if%20my%20Toll%2DFree%20number%20is%20rejected%3F,-If%20your%20Toll) if a Toll-Free verification is rejected',
    description:
      'The toll-free phone number cannot be verified due to an unknown error. Messaging traffic on this Toll-Free phone number is blocked.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:06:03Z',
    last_updated: '2024-02-27T18:04:47.744755Z',
  },
  61001: {
    code: 61001,
    message: 'Add-ons: Request timed out',
    log_level: 'ERROR',
    secondary_message:
      ' The Add-on Provider failed to respond in the allotted time. The request was terminated and no further processing was attempted.',
    log_type: null,
    docs: '## Error - 61001\r\n\r\n### Add-ons: Request timed out\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider failed to respond in the allotted time. The request was terminated and no further processing was attempted.\r\n\r\n#### Possible Solutions\r\n*  Contact Add-on Provider if this error persists',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:36:03Z',
    last_updated: '2020-08-04T10:00:21.598Z',
  },
  60310: {
    code: 60310,
    message: 'Factor verification attempts reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60310\r\n\r\n### Factor verification attempts reached\r\n\r\n The maximum number of verification attempts for a Factor has been reached.\r\n\r\nMax. Number of attempts for a TOTP Factor: 5.\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\nToo many incorrect TOTP codes have been provided in the AuthPayload\r\n\r\n#### Possible Solutions\r\n- Create a new Factor and verify that one..\r\n- For a TOTP Factor, ask the user to provide the correct TOTP code or create a new Factor if they are unable to generate the correct codes for the Factor they are verifying.',
    causes: 'Too many incorrect TOTP codes have been provided in the AuthPayload',
    solutions:
      '- Create a new Factor and verify that one..\r\n- For a TOTP Factor, ask the user to provide the correct TOTP code or create a new Factor if they are unable to generate the correct codes for the Factor they are verifying.',
    description:
      'The maximum number of verification attempts for a Factor has been reached.\r\n\r\nMax. Number of attempts for a TOTP Factor: 5.\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2021-05-11T19:20:57Z',
    last_updated: '2021-06-30T03:42:38.752829Z',
  },
  60381: {
    code: 60381,
    message: 'Signature invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60381\r\n\r\n### Signature invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Signature in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Signature in the request body is correct.',
    causes: 'The Signature in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Signature in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:48:08Z',
    last_updated: '2023-12-27T09:48:08Z',
  },
  21242: {
    code: 21242,
    message: 'Maximum Credentials Reached for List',
    log_level: 'ERROR',
    secondary_message: 'Credential Lists cannot contain more than 1000 Credentials.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21242\r\n\r\n### Maximum Credentials Reached for List\r\n\r\nCredential Lists cannot contain more than 1000 Credentials. \r\n\r\n#### Possible Causes\r\n* Credential Lists cannot contain more than 1000 Credentials.\r\n\r\n#### Possible Solutions\r\n* Delete Credentials from your Credential List if you must create more.',
    causes: '* Credential Lists cannot contain more than 1000 Credentials.',
    solutions: '* Delete Credentials from your Credential List if you must create more.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:35:59Z',
    last_updated: '2020-08-04T10:00:00.343Z',
  },
  25100: {
    code: 25100,
    message: 'The organization was not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25100\r\n\r\n### The organization was not found\r\n\r\n The organization was not found.\r\n\r\n#### Possible Causes\r\nNo organization was found for the provided Organization Sid.\r\n\r\n#### Possible Solutions\r\nVerify the Organization Sid.',
    causes: 'No organization was found for the provided Organization Sid.',
    solutions: 'Verify the Organization Sid.',
    description: 'The organization was not found.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:57:16Z',
    last_updated: '2023-12-04T14:24:55.234509Z',
  },
  30036: {
    code: 30036,
    message: 'Validity Period Expired',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30036\r\n\r\n### Validity Period Expired\r\n\r\n The specified validity period on this message has elapsed.\r\n\r\n#### Possible Causes\r\nThe message has spent more than the specified amount of time in Twilio's system. This can be due to a long time spent in the queue due to a combination of your [messaging rate limits](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues), the number of messages submitted in rapid succession, and the amount of time you have allotted via the [ValidityPeriod setting](https://www.twilio.com/blog/validity-period-promotional-verification-use-cases) in your messaging service or on the message itself.\r\n\r\n#### Possible Solutions\r\nYou can retry the message with a longer validity period and avoid sending very large batches of messages at a rate that far exceeds your messaging rate limits.",
    causes:
      "The message has spent more than the specified amount of time in Twilio's system. This can be due to a long time spent in the queue due to a combination of your [messaging rate limits](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues), the number of messages submitted in rapid succession, and the amount of time you have allotted via the [ValidityPeriod setting](https://www.twilio.com/blog/validity-period-promotional-verification-use-cases) in your messaging service or on the message itself.",
    solutions:
      'You can retry the message with a longer validity period and avoid sending very large batches of messages at a rate that far exceeds your messaging rate limits.',
    description: 'The specified validity period on this message has elapsed.',
    product: 'Programmable SMS',
    date_created: '2023-09-06T10:50:11Z',
    last_updated: '2023-09-06T10:50:11Z',
  },
  32019: {
    code: 32019,
    message: 'Twiml and Voice URL are both set. Using Voice URL.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32019\r\n\r\n### Twiml and Voice URL are both set. Using Voice URL.\r\n\r\n Twiml and Voice URL are both set. Using Voice URL.\r\n\r\n#### Possible Causes\r\nBoth Voice URL and embedded twiml are provided in the request\r\n\r\n#### Possible Solutions\r\nUse only Voice URL or embedded twiml, not both, in the request',
    causes: 'Both Voice URL and embedded twiml are provided in the request',
    solutions: 'Use only Voice URL or embedded twiml, not both, in the request',
    description: 'Twiml and Voice URL are both set. Using Voice URL.',
    product: 'Programmable Voice',
    date_created: '2019-08-29T18:32:59Z',
    last_updated: '2020-08-04T10:00:07.113Z',
  },
  32102: {
    code: 32102,
    message: 'SIP: Bad SDP',
    log_level: 'WARNING',
    secondary_message: 'The SDP is not correctly formatted.',
    log_type: null,
    docs: '## Error - 32102\n\n###  SIP: Bad SDP\n\n#### Possible Causes \n*  The SDP is not correctly formatted.\n\n#### Possible Solutions\n*  Please see [RFC 2327 - SDP: Session Description Protocol](https://www.ietf.org/rfc/rfc2327.txt).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:37Z',
    last_updated: '2020-08-04T10:00:24.374Z',
  },
  90015: {
    code: 90015,
    message: 'Body and Template (Body, Sid, Language, Args) are provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90015\r\n\r\n### Body and Template (Body, Sid, Language, Args) are provided\r\n\r\n Body and Template (Body, Sid, Language, Args) are provided together.\r\n\r\n#### Possible Causes\r\nSingle create message request has Body and one of Template's field: Template or TemplateSid or TemplateLanguage or TemplateArgs\r\n\r\n#### Possible Solutions\r\nChoose which type of message would you like to use: templated message or plain message.",
    causes:
      "Single create message request has Body and one of Template's field: Template or TemplateSid or TemplateLanguage or TemplateArgs",
    solutions:
      'Choose which type of message would you like to use: templated message or plain message.',
    description: 'Body and Template (Body, Sid, Language, Args) are provided together.',
    product: null,
    date_created: '2020-12-11T08:36:54Z',
    last_updated: '2020-12-11T08:36:54Z',
  },
  30121: {
    code: 30121,
    message: 'Fallback URL is missing',
    log_level: 'ERROR',
    secondary_message: 'Fallback URL is missing, please add an URL.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30121\r\n\r\n### Fallback URL is missing\r\n\r\nFallback URL is missing, please add an URL. Fallback URL is missing\r\n\r\n#### Possible Causes\r\nUser did not include fallbackUrl field\r\n\r\n#### Possible Solutions\r\nPlease follow doc for setting up fallback URL.',
    causes: 'User did not include fallbackUrl field',
    solutions: 'Please follow doc for setting up fallback URL.',
    description: 'Fallback URL is missing',
    product: 'Programmable SMS',
    date_created: '2022-02-09T19:28:28Z',
    last_updated: '2022-02-09T19:28:28Z',
  },
  62005: {
    code: 62005,
    message: ' Bandwidth reserve not found.',
    log_level: 'ERROR',
    secondary_message: 'The bandwidth reserve SID in the request could not be found.',
    log_type: null,
    docs: '## Error - 62005\r\n\r\n### Bandwidth reserve not found\r\n\r\nThe bandwidth reserve SID in the request could not be found.\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:35:36Z',
    last_updated: '2020-08-04T10:00:21.107Z',
  },
  21611: {
    code: 21611,
    message: "This 'From' number has exceeded the maximum number of queued messages",
    log_level: 'ERROR',
    secondary_message: "You have attempted to enqueue too many messages for a given 'From' number.",
    log_type: 'APPLICATION',
    docs: "## ERROR - 21611\r\n\r\n### This 'From' number has exceeded the maximum number of queued messages\r\n\r\n Twilio queues messages based on the sending rate of a sender or an account. For example a US long code number can send one message [segment](https://www.twilio.com/blog/what-the-heck-is-a-segment.html) per second, and a short code may send over 100 message segments per second.\r\n\r\nMessages can only be queued for 4 hours and then they automatically fail. This queue length limit can be reduced by setting a lower [Validity Period](https://www.twilio.com/en-us/blog/validity-period-promotional-verification-use-cases) within your Messaging Service settings or in your API requests to send messages.\r\n\r\nYou can monitor the length on your queue via the [Queue Insights dashboard](https://www.twilio.com/console/sms/insights/queue).\r\n\r\nFor more information please view this [FAQ](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues).\r\n\r\nWhen a queue for a particular 'From' number exceeds 4 hours, this error will be thrown when attempting to create additional messages on the same number.\r\n\r\nNote: If you are using a Messaging Service and the numbers in the pool experience queue overload, messages will instead fail after creation with [error 30001](https://www.twilio.com/docs/api/errors/30001).\r\n\r\n\r\n#### Possible Causes\r\nYou have attempted to enqueue more than 4 hours' worth of messages on a single Twilio phone number or sender (based on that number's [MPS rate limit](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues)).\r\n\r\n#### Possible Solutions\r\n* Slow down your sending rate to avoid queuing on your Twilio number.\r\n* Consider using a [Messaging Service](https://www.twilio.com/docs/messaging/services) to better distribute message throughput, if appropriate for your use case.\r\n* Increase your [validity period](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource) if you have it set to lower than 4 hours\r\n",
    causes:
      "You have attempted to enqueue more than 4 hours' worth of messages on a single Twilio phone number or sender (based on that number's [MPS rate limit](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues)).",
    solutions:
      '* Slow down your sending rate to avoid queuing on your Twilio number.\r\n* Consider using a [Messaging Service](https://www.twilio.com/docs/messaging/services) to better distribute message throughput, if appropriate for your use case.\r\n* Increase your [validity period](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource) if you have it set to lower than 4 hours\r\n',
    description:
      "Twilio queues messages based on the sending rate of a sender or an account. For example a US long code number can send one message [segment](https://www.twilio.com/blog/what-the-heck-is-a-segment.html) per second, and a short code may send over 100 message segments per second.\r\n\r\nMessages can only be queued for 4 hours and then they automatically fail. This queue length limit can be reduced by setting a lower [Validity Period](https://www.twilio.com/en-us/blog/validity-period-promotional-verification-use-cases) within your Messaging Service settings or in your API requests to send messages.\r\n\r\nYou can monitor the length on your queue via the [Queue Insights dashboard](https://www.twilio.com/console/sms/insights/queue).\r\n\r\nFor more information please view this [FAQ](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues).\r\n\r\nWhen a queue for a particular 'From' number exceeds 4 hours, this error will be thrown when attempting to create additional messages on the same number.\r\n\r\nNote: If you are using a Messaging Service and the numbers in the pool experience queue overload, messages will instead fail after creation with [error 30001](https://www.twilio.com/docs/api/errors/30001).\r\n",
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:25Z',
    last_updated: '2024-02-12T12:08:57.951705Z',
  },
  52131: {
    code: 52131,
    message: 'Invalid APNs credentials',
    log_level: 'ERROR',
    secondary_message: 'APN certificate or Private Key are invalid',
    log_type: null,
    docs: '## Error - 52131\r\n\r\n### Invalid APNs credentials\r\n\r\n#### Possible Causes \r\n*  Credential (certificate and private key) is invalid.\r\n*  Certificate expired.\r\n\r\n#### Possible Solutions\r\n*  Make sure you have valid certificate and private key provided in your Credential.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:34:09Z',
    last_updated: '2020-08-04T10:00:22.193Z',
  },
  60004: {
    code: 60004,
    message: 'Invalid Configuration ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60004\r\n\r\n### Invalid Configuration \r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received but failed due to an invalid configuration.\r\n\r\n#### Possible Solutions\r\n- Check that the Account SID provided is correct.\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to confirm that access to this endpoint is enabled for the given Account SID.',
    causes: 'The request was received but failed due to an invalid configuration.',
    solutions:
      '- Check that the Account SID provided is correct.\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to confirm that access to this endpoint is enabled for the given Account SID.',
    description: null,
    product: null,
    date_created: '2022-09-06T13:12:33.151985Z',
    last_updated: '2022-09-06T13:12:33.151994Z',
  },
  21263: {
    code: 21263,
    message: 'Invalid Answering Machine Detection Parameters',
    log_level: 'WARNING',
    secondary_message:
      'Answering Machine Detection parameters specific to POST to /Calls API have been passed in POST to /Participants, <Dial><Number>, or <Dial><Sip>',
    log_type: 'APPLICATION',
    docs: '## WARNING - 21263\r\n\r\n### Invalid Answering Machine Detection Parameters\r\n\r\nAnswering Machine Detection parameters specific to POST to /Calls API have been passed in POST to /Participants, <Dial><Number>, or <Dial><Sip> Invalid Answering Machine Detection Parameters\r\n\r\n#### Possible Causes\r\nAsyncAmd, AsyncAmdStatusCallback, and/or AsyncAmdStatusCallbackMethod parameters from POST to /Calls API have been passed in a POST to /Participants API, or added to <Dial><Number> or <Dial><Sip> TwiML.\r\n\r\n#### Possible Solutions\r\nDo not include AsyncAmd, AsyncAmdStatusCallback, or AsyncAmdStatusCallbackMethod parameters in POST requests made to /Participants API and in TwiML responses that include <Dial><Number> or <Dial><Sip> with Answering Machine Detection enabled.',
    causes:
      'AsyncAmd, AsyncAmdStatusCallback, and/or AsyncAmdStatusCallbackMethod parameters from POST to /Calls API have been passed in a POST to /Participants API, or added to <Dial><Number> or <Dial><Sip> TwiML.',
    solutions:
      'Do not include AsyncAmd, AsyncAmdStatusCallback, or AsyncAmdStatusCallbackMethod parameters in POST requests made to /Participants API and in TwiML responses that include <Dial><Number> or <Dial><Sip> with Answering Machine Detection enabled.',
    description: 'Invalid Answering Machine Detection Parameters',
    product: 'Programmable Voice',
    date_created: '2022-08-25T01:47:01Z',
    last_updated: '2022-08-25T01:51:29.197739Z',
  },
  30901: {
    code: 30901,
    message: 'Campaign rejection - The campaign registration request timed out.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30901\r\n\r\n### Campaign rejection - The campaign registration request timed out.\r\n\r\n The campaign registration request timed out due to an error.\r\n\r\n#### Possible Causes\r\nReasons for this failure can be:\r\n\r\n* Review was not completed\r\n* Third parties involved in campaign registration did not respond within defined SLA\r\n\r\n#### Possible Solutions\r\nPlease retry with a new campaign registration.',
    causes:
      'Reasons for this failure can be:\r\n\r\n* Review was not completed\r\n* Third parties involved in campaign registration did not respond within defined SLA',
    solutions: 'Please retry with a new campaign registration.',
    description: 'The campaign registration request timed out due to an error.',
    product: 'Programmable Messaging',
    date_created: '2023-06-07T15:23:46Z',
    last_updated: '2023-06-07T15:23:46Z',
  },
  51110: {
    code: 51110,
    message: 'Twilsock: Token contains multiple grants of same product',
    log_level: 'ERROR',
    secondary_message: 'Duplication of grants for the same product.',
    log_type: null,
    docs: '## Error - 51110\r\n\r\n### Token contains multiple grants of same product\r\n\r\n#### Possible Causes \r\nDuplication of grants for the same product.\r\n\r\n#### Possible Solutions\r\nRemove duplications of products from grants section in the token. \r\n\r\nTo verify the token being passed, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:14:32Z',
    last_updated: '2020-08-04T10:00:09.754Z',
  },
  40120: {
    code: 40120,
    message: 'TaskRouter->Direct',
    log_level: 'ERROR',
    secondary_message: "Redirect Instruction does not have a valid 'url' parameter provided.",
    log_type: null,
    docs: '## Error - 40120\r\n\r\n### Missing or Invalid \'url\' parameter - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "url" parameter on your \'redirect\' instruction.\r\n*  You provided an invalid format in your "url" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "url" is provided and contains a well formed HTTP or HTTPS URL. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:41Z',
    last_updated: '2020-08-04T10:00:23.952Z',
  },
  31502: {
    code: 31502,
    message: 'Bad Gateway',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31502\r\n\r\n### Bad Gateway \r\n\r\nThe server is acting as a gateway or proxy, and received an invalid response from a downstream server while attempting to fulfill the request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:44:55Z',
    last_updated: '2020-08-04T10:00:08.252Z',
  },
  31206: {
    code: 31206,
    message: 'Rate exceeded authorized limit.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31206\r\n\r\n### Rate exceeded authorized limit.\r\n\r\nRate exceeded authorized limit.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:48:09Z',
    last_updated: '2020-08-04T10:00:11.061Z',
  },
  30749: {
    code: 30749,
    message: 'Brand Registration Failure: Email address duplicate threshold reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30749\r\n\r\n### Brand Registration Failure: Email address duplicate threshold reached\r\n\r\n Brand can not be registered with provided email address since duplicate threshold limit has been reached for it.\r\n\r\n#### Possible Causes\r\nAn email address can not be used multiple times for Sole Proprietor Brand registrations. It is possible that the Starter customer profile bundle used for Sole Proprietor brand registration contains email address which has been used to register one or more Sole Proprietor Brands already. \r\n\r\n#### Possible Solutions\r\nPlease edit the starter customer profile and use a different email address. Once submitted for review, you can resubmit the brand registration request. \r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes:
      'An email address can not be used multiple times for Sole Proprietor Brand registrations. It is possible that the Starter customer profile bundle used for Sole Proprietor brand registration contains email address which has been used to register one or more Sole Proprietor Brands already. ',
    solutions:
      'Please edit the starter customer profile and use a different email address. Once submitted for review, you can resubmit the brand registration request. \r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description:
      'Brand can not be registered with provided email address since duplicate threshold limit has been reached for it.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:42:07Z',
    last_updated: '2024-02-13T15:58:32.193107Z',
  },
  16011: {
    code: 16011,
    message: 'Conference Event: Error Response to Callback URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16011\r\n\r\n### Conference Event: Error Response to Callback URL\r\n\r\nTwilio received an error response when attempting to send a conference event to the provided callback URL.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:13:16Z',
    last_updated: '2020-08-04T10:00:10.083Z',
  },
  30027: {
    code: 30027,
    message: 'US A2P 10DLC - T-Mobile Daily Message Limit Reached',
    log_level: 'ERROR',
    secondary_message:
      'As part of the US A2P 10DLC initiative, T-Mobile has instituted a daily message limit. You are receiving this error code because you have reached this limit.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30027\r\n\r\n### US A2P 10DLC - T-Mobile Daily Message Limit Reached\r\n\r\nAs part of the US A2P 10DLC initiative, T-Mobile has instituted a daily message limit. You are receiving this error code because you have reached this limit. Please note that this daily limit is based on the sum of SMS segments and MMS messages you send to T-Mobile subscribers on a 24-hour basis, and is reset daily at midnight PT. As you have consumed 100% of your limit, subsequent messages you send to T-Mobile are likely to be filtered. When filtering happens, you will start to receive 30023 error codes and must wait until midnight PT to resume message sending.\r\n\r\nFor more information on T-Mobile daily limit, please refer to [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more information on US A2P 10DLC, please refer to [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\nNote: this error may not be accurate for certain customers such as those who have been approved of the unlimited tier via the [T-Mobile Special Business Review process](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC), those who run non-profit campaigns, and others.\r\n\r\n#### Possible Causes\r\n* You have consumed 100% of your T-Mobile daily message limit for the day.\r\n\r\n#### Possible Solutions\r\n* If you infrequently exceed your T-Mobile daily message limit, you can consider prioritizing messages (e.g., OTP codes over marketing materials).\r\n* If you frequently exceed your T-Mobile daily message limit, you may be able to increase your daily limit: \r\n  * For unregistered customers, please consider registering in the [Twilio Console - Trust Hub](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%2Fwizard%3Fx-target-region%3Dus1&currentFrameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%2Fwizard%3F__override_layout__%3Dembed%26x-target-region%3Dus1%26activeStep%3DbusinessProfile%253AbusinessProfile%253AcreateBusinessProfileAddress%26bifrost%3Dtrue).\r\n * For registered customers, if you need to send more than 200,000 message segments to T-Mobile per day, please consider submitting a [Special Business Review](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC).\r\n* Other useful links:\r\n * To view the warning and errors, please visit the [debugger](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n * To view your daily T-Mobile message limit, please visit [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1).\r\n * To view your daily T-Mobile usage, please use the Messaging Insights tool.',
    causes: '* You have consumed 100% of your T-Mobile daily message limit for the day.',
    solutions:
      '* If you infrequently exceed your T-Mobile daily message limit, you can consider prioritizing messages (e.g., OTP codes over marketing materials).\r\n* If you frequently exceed your T-Mobile daily message limit, you may be able to increase your daily limit: \r\n  * For unregistered customers, please consider registering in the [Twilio Console - Trust Hub](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%2Fwizard%3Fx-target-region%3Dus1&currentFrameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%2Fwizard%3F__override_layout__%3Dembed%26x-target-region%3Dus1%26activeStep%3DbusinessProfile%253AbusinessProfile%253AcreateBusinessProfileAddress%26bifrost%3Dtrue).\r\n * For registered customers, if you need to send more than 200,000 message segments to T-Mobile per day, please consider submitting a [Special Business Review](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC).\r\n* Other useful links:\r\n * To view the warning and errors, please visit the [debugger](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n * To view your daily T-Mobile message limit, please visit [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1).\r\n * To view your daily T-Mobile usage, please use the Messaging Insights tool.',
    description:
      'Please note that this daily limit is based on the sum of SMS segments and MMS messages you send to T-Mobile subscribers on a 24-hour basis, and is reset daily at midnight PT. As you have consumed 100% of your limit, subsequent messages you send to T-Mobile are likely to be filtered. When filtering happens, you will start to receive 30023 error codes and must wait until midnight PT to resume message sending.\r\n\r\nFor more information on T-Mobile daily limit, please refer to [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more information on US A2P 10DLC, please refer to [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\nNote: this error may not be accurate for certain customers such as those who have been approved of the unlimited tier via the [T-Mobile Special Business Review process](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC), those who run non-profit campaigns, and others.',
    product: 'Programmable SMS',
    date_created: '2021-10-18T21:12:48Z',
    last_updated: '2022-01-10T22:34:55.568908Z',
  },
  45356: {
    code: 45356,
    message: 'Failed to create a channel. Downstream error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45356\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'An error occurred retrieving Conversation data from conversations api.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to retrieve Conversation <conversation sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:32.189393Z',
  },
  22223: {
    code: 22223,
    message: 'Regulatory Bundle is not eligible to be Copied',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22223\r\n\r\n### Regulatory Bundle is not eligible to be Copied\r\n\r\n The Regulatory Bundle requested is not eligible to be Copied.\r\n\r\n#### Possible Causes\r\nThe Regulatory Bundle is either in not in a twilio-approved status or does not have a valid_until date\r\n\r\n#### Possible Solutions\r\nSelect a Regulatory Bundle that is eligible to be Copied by filtering the Regulatory Bundle list with a valid_until date and in the twilio-approved status.',
    causes:
      'The Regulatory Bundle is either in not in a twilio-approved status or does not have a valid_until date',
    solutions:
      'Select a Regulatory Bundle that is eligible to be Copied by filtering the Regulatory Bundle list with a valid_until date and in the twilio-approved status.',
    description: 'The Regulatory Bundle requested is not eligible to be Copied.',
    product: null,
    date_created: '2022-03-10T23:27:33Z',
    last_updated: '2022-03-10T23:27:33Z',
  },
  13420: {
    code: 13420,
    message: 'Play: Invalid Content-Type',
    log_level: 'ERROR',
    secondary_message: 'Play requires an audio Content-Type',
    log_type: null,
    docs: "## Error - 13420 \n\n### Play: Invalid Content-Type\n\nPlay requires an audio Content-Type\n\n#### Possible Causes \n*  Play references a URL that does not return audio or is returning an invalid Content-Type.\n\n\n#### Possible Solutions\n*  Make certain the URL returns an audio file\t\n*   See the <a href='/docs/api/twiml/play'>Play Verb</a> API Reference for more information on valid Content-Types.\t\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:42Z',
    last_updated: '2020-08-04T10:00:27.989Z',
  },
  50526: {
    code: 50526,
    message: 'Invalid content SID',
    log_level: 'ERROR',
    secondary_message: 'Specified Content SID does not match pattern HX[0-9a-f]{32}',
    log_type: 'TWILIO',
    docs: '## ERROR - 50526\r\n\r\n### Invalid content SID\r\n\r\nSpecified Content SID does not match pattern HX[0-9a-f]{32} An invalid value was specified for the message content sid\r\n\r\n#### Possible Causes\r\nContent SID does not match the pattern HX[0-9a-f]{32}\r\n\r\n#### Possible Solutions\r\nProper message Content SID value should be provided.',
    causes: 'Content SID does not match the pattern HX[0-9a-f]{32}',
    solutions: 'Proper message Content SID value should be provided.',
    description: 'An invalid value was specified for the message content sid',
    product: 'Conversations',
    date_created: '2022-11-23T13:34:12Z',
    last_updated: '2022-11-23T13:34:12Z',
  },
  22130: {
    code: 22130,
    message: 'Not Portable - Unsupported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22130\r\n\r\n### Not Portable - Unsupported\r\n\r\n \r\n\r\n#### Possible Causes\r\nPhone number is in a country or rate center that is not supported by Twilio\r\n\r\n#### Possible Solutions\r\nNot Action Required',
    causes: 'Phone number is in a country or rate center that is not supported by Twilio',
    solutions: 'Not Action Required',
    description: null,
    product: 'Phone Numbers',
    date_created: '2023-06-22T18:44:14Z',
    last_updated: '2023-06-22T18:44:14Z',
  },
  48005: {
    code: 48005,
    message: 'Callback failed due to timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48005\r\n\r\n### Callback failed due to timeout\r\n\r\n \r\n\r\n#### Possible Causes\r\nYour Frontline Integration Service side processing is exceeding 6 seconds.\r\n\r\n#### Possible Solutions\r\nMake sure that callback processing time is less than 6 seconds.',
    causes: 'Your Frontline Integration Service side processing is exceeding 6 seconds.',
    solutions: 'Make sure that callback processing time is less than 6 seconds.',
    description: null,
    product: 'Frontline',
    date_created: '2021-10-26T09:16:05Z',
    last_updated: '2021-12-06T15:41:13.094356Z',
  },
  63008: {
    code: 63008,
    message:
      'Could not execute the request because the channel module has been misconfigured. Please check the Channel configuration in Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel misconfigured\r\n\r\n#### Possible Causes \r\n*   Could not execute the request or send a message because the Channel has been misconfigured. Please check the Channel instance configuration in Twilio.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:22:45Z',
    last_updated: '2020-08-04T10:00:14.472Z',
  },
  60377: {
    code: 60377,
    message: 'Authenticator attachment invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60377\r\n\r\n### Authenticator attachment invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Authenticator attachment in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Authenticator attachment in the request body is correct.',
    causes: 'The Authenticator attachment in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Authenticator attachment in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:40:39Z',
    last_updated: '2023-12-27T09:40:39Z',
  },
  90104: {
    code: 90104,
    message: 'Invalid Collect Field Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90104\r\n\r\n### Invalid Collect Field Type\r\n\r\n The Field Type in Collect JSON is Invalid\r\n\r\n#### Possible Causes\r\nCollect Question has an Invalid Field Type\r\n\r\n#### Possible Solutions\r\nPlease ensure the type in the Collect Question is valid.',
    causes: 'Collect Question has an Invalid Field Type',
    solutions: 'Please ensure the type in the Collect Question is valid.',
    description: 'The Field Type in Collect JSON is Invalid',
    product: 'Understand',
    date_created: '2020-07-14T19:19:55Z',
    last_updated: '2023-11-27T16:29:02.30022Z',
  },
  30112: {
    code: 30112,
    message: 'Account is not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30112\r\n\r\n### Account is not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nWrong account is given\r\n\r\n#### Possible Solutions\r\nSpecify the correct account',
    causes: 'Wrong account is given',
    solutions: 'Specify the correct account',
    description: null,
    product: null,
    date_created: '2020-05-07T17:05:01Z',
    last_updated: '2020-08-04T10:00:03.324Z',
  },
  34108: {
    code: 34108,
    message: 'Other End Incompatible',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 34108\r\n### Fax: Other End Incompatible\r\n\r\nThe receiving fax machine answered, but then rejected your incoming media.\r\n\r\nTry reducing the size of your pdf or sending at a lower quality or resolution. Make sure your pdf is a standard size (US Letter, A4) and portrait-oriented.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Fax',
    date_created: '2017-09-15T19:47:56Z',
    last_updated: '2020-08-04T10:00:17.02Z',
  },
  33004: {
    code: 33004,
    message: 'Service is unavailable\t',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 33004\r\n\r\n### Service is unavailable\t\r\n\r\n Raised whenever a service is temporarily unavailable.\r\n\r\n#### Possible Causes\r\nThe requested service or any of its downstreams is temporarily unavailable.\r\n\r\n#### Possible Solutions\r\nTry again later.',
    causes: 'The requested service or any of its downstreams is temporarily unavailable.',
    solutions: 'Try again later.',
    description: 'Raised whenever a service is temporarily unavailable.',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:12:25Z',
    last_updated: '2020-09-15T11:12:25Z',
  },
  33102: {
    code: 33102,
    message: 'Parameter missing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33102\r\n\r\n### Parameter missing\r\n\r\n Raised whenever a required parameter was not passed with the request. The error object’s detail field will indicate which parameter was not provided.\r\n\r\n#### Possible Causes\r\n * While sending a Command, you did not indicate the `Sim` to send it to.\r\n * While transferring a SIM to another Account, you need to provide a new Rate Plan present in the target Account or remove the current Rate Plan if the SIM to move is currently assigned to a Rate Plan.\r\n * While transferring a SIM to another Account, you cannot transfer a SIM in status `ready`.\r\n\r\n\r\n#### Possible Solutions\r\n * While sending a Command, ensure `Sim` parameter is provided.\r\n * While transferring a SIM to another Account, ensure a `RatePlan` is provided that present in the target Account.\r\n * While transferring a SIM to another Account, ensure the SIM to transfer is not in status `ready`.',
    causes:
      ' * While sending a Command, you did not indicate the `Sim` to send it to.\r\n * While transferring a SIM to another Account, you need to provide a new Rate Plan present in the target Account or remove the current Rate Plan if the SIM to move is currently assigned to a Rate Plan.\r\n * While transferring a SIM to another Account, you cannot transfer a SIM in status `ready`.\r\n',
    solutions:
      ' * While sending a Command, ensure `Sim` parameter is provided.\r\n * While transferring a SIM to another Account, ensure a `RatePlan` is provided that present in the target Account.\r\n * While transferring a SIM to another Account, ensure the SIM to transfer is not in status `ready`.',
    description:
      'Raised whenever a required parameter was not passed with the request. The error object’s detail field will indicate which parameter was not provided.',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:16:29Z',
    last_updated: '2020-09-15T11:16:29Z',
  },
  23002: {
    code: 23002,
    message: 'Message Redaction Incompatible Configuration: Short code "STOP" filtering',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 23002\r\n\r\n### Message Redaction Incompatible Configuration: Short code "STOP" filtering\r\n\r\n Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* Twilio is currently set to handle opt-out keywords for short code numbers on your account. Twilio\'s opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blocklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blocklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) to disable Twilio\'s built-in opt-out keyword handling for your account.',
    causes:
      "* Twilio is currently set to handle opt-out keywords for short code numbers on your account. Twilio's opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.",
    solutions:
      '* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blocklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blocklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) to disable Twilio\'s built-in opt-out keyword handling for your account.',
    description:
      'Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.',
    product: 'Programmable SMS',
    date_created: '2019-11-21T19:18:52Z',
    last_updated: '2023-11-01T04:44:31.867663Z',
  },
  30011: {
    code: 30011,
    message: 'MMS not supported by the receiving phone number in this region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: "## ERROR - 30011\r\n\r\n### MMS not supported by the receiving phone number in this region\r\n\r\n ## Error - 30011 \r\n\r\n### MMS not supported by the receiving phone number\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\nIf you received this error code on an inbound message, there was a failure attempting to receive an incoming MMS, as your Twilio phone number was sent an MMS in a region where Twilio does not support incoming MMS.\r\n\r\nIf you received this error code on an outbound message, the destination handset either doesn't support MMS, or MMS is not currently enabled on the device.\r\n\r\n#### Possible Solutions\r\nFor Inbound, it is recommended that you respond to the user sending the MMS to let them know that you cannot receive MMS in this region.",
    causes:
      "If you received this error code on an inbound message, there was a failure attempting to receive an incoming MMS, as your Twilio phone number was sent an MMS in a region where Twilio does not support incoming MMS.\r\n\r\nIf you received this error code on an outbound message, the destination handset either doesn't support MMS, or MMS is not currently enabled on the device.",
    solutions:
      'For Inbound, it is recommended that you respond to the user sending the MMS to let them know that you cannot receive MMS in this region.',
    description:
      '## Error - 30011 \r\n\r\n### MMS not supported by the receiving phone number\r\n\r\n\r\n\r\n',
    product: 'Programmable SMS',
    date_created: '2017-03-30T21:11:14Z',
    last_updated: '2022-10-24T22:18:03.797549Z',
  },
  30130: {
    code: 30130,
    message: 'Messaging Service SID already belongs in another domain configuration.',
    log_level: 'ERROR',
    secondary_message:
      'Messaging Service SID is already associated with a domain configuration in the account',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30130\r\n\r\n### Messaging Service SID already belongs in another domain configuration.\r\n\r\nMessaging Service SID is already associated with a domain configuration in the account Messaging Service SID is already associated with a domain configuration in the account\r\n\r\n#### Possible Causes\r\nOne of the messaging service SID in the request body is already associated with a domain in the account\r\n\r\n#### Possible Solutions\r\nTry to use any other messaging service SID',
    causes:
      'One of the messaging service SID in the request body is already associated with a domain in the account',
    solutions: 'Try to use any other messaging service SID',
    description:
      'Messaging Service SID is already associated with a domain configuration in the account',
    product: 'Programmable SMS',
    date_created: '2022-08-02T00:33:45Z',
    last_updated: '2022-08-02T00:33:45Z',
  },
  45797: {
    code: 45797,
    message: 'Support Access Token Generated',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 45797\r\n\r\n### Support Access Token Generated\r\n\r\n A support access token was generated for this account, providing read-only access to this member of Twilio Support to account data, including worker, task, interaction and configuration data. \r\n\r\n#### Possible Causes\r\nA member of Twilio Support obtained customer approval to generate a support access token in order to provide support to the customer. \r\n\r\n#### Possible Solutions\r\nThis support access token will expire after 1hr.',
    causes:
      'A member of Twilio Support obtained customer approval to generate a support access token in order to provide support to the customer. ',
    solutions: 'This support access token will expire after 1hr.',
    description:
      'A support access token was generated for this account, providing read-only access to this member of Twilio Support to account data, including worker, task, interaction and configuration data. ',
    product: 'Flex',
    date_created: '2024-06-18T21:40:46Z',
    last_updated: '2024-06-18T21:40:46Z',
  },
  53408: {
    code: 53408,
    message: 'ICE connection restart was attempted, but it is not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 53408\r\n\r\n### ICE connection restart was attempted, but it is not allowed\r\n\r\n ICE restarts are only allowed on SDP offers, not answers\r\n\r\n#### Possible Causes\r\n* The client has attempted an ICE restart in a SDP answer.\r\n\r\n#### Possible Solutions\r\n* Ensure that the ICE restart happens only in SDP offers.',
    causes: '* The client has attempted an ICE restart in a SDP answer.',
    solutions: '* Ensure that the ICE restart happens only in SDP offers.',
    description: 'ICE restarts are only allowed on SDP offers, not answers',
    product: 'Programmable Video',
    date_created: '2021-03-09T08:15:14Z',
    last_updated: '2021-03-09T08:15:14Z',
  },
  54351: {
    code: 54351,
    message: 'Invalid identity',
    log_level: 'ERROR',
    secondary_message: 'Identity must be a string with length 1-256.',
    log_type: null,
    docs: '\n## Error - 54351\n\n### Sync: Invalid identity\nIdentity must be a string with length 1-256.\n\n#### Possible Causes\n* The value supplied by the Identity parameter is an empty string.\n* The value supplied by the Identity parameter exceeds 256 characters.\n\n#### Possible Solutions\nConfirm than an Identity string parameter of 1-256 characters is being passed in request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.286Z',
  },
  60382: {
    code: 60382,
    message: 'Factor does not match the relying party of the challenge',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60382\r\n\r\n### Factor does not match the relying party of the challenge\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Relying party is specified in the request, but it is incorrect.\r\n\r\n#### Possible Solutions\r\nCheck that the Relying party in the request body is correct.',
    causes: 'The Relying party is specified in the request, but it is incorrect.',
    solutions: 'Check that the Relying party in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:49:43Z',
    last_updated: '2023-12-27T09:49:43Z',
  },
  51114: {
    code: 51114,
    message: 'Twilsock: Invalid access token header',
    log_level: 'ERROR',
    secondary_message: 'The token has an invalid header.',
    log_type: null,
    docs: '## Error - 51114\r\n\r\n### Invalid access token header\r\n\r\n#### Possible Causes \r\nThe token has an invalid header.\r\n\r\n#### Possible Solutions\r\nConfirm a valid token is being passed in the request.\r\n\r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:48:37Z',
    last_updated: '2020-08-04T10:00:09.68Z',
  },
  22114: {
    code: 22114,
    message: 'Unable to Verify Code',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22114\r\n\r\n#### Unable to Verify Code\r\n\r\nA verification code was provided but the Hosted Number Order instance is not in a valid state for handling caller ID verification.\r\n\r\n#### Possible Solutions\r\n\r\n* Update the status of the Hosted Number Order instance to "pending-verification".\r\n\r\n* Remove VerificationCode from the request body if verification call has already been completed.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:59:54Z',
    last_updated: '2020-08-04T10:00:15.027Z',
  },
  21407: {
    code: 21407,
    message: 'This Phone Number type does not support SMS',
    log_level: 'ERROR',
    secondary_message:
      'This phone number type does not support SMS.  You cannot set SmsUrl, SmsMethod, SmsFallbackUrl, or SmsFallbackMethod',
    log_type: null,
    docs: '## Error - 21407 \n\n### This Phone Number type does not support SMS\n\nThis phone number type does not support SMS.  You cannot set SmsUrl, SmsMethod, SmsFallbackUrl, or SmsFallbackMethod\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:20Z',
    last_updated: '2020-08-04T10:00:25.541Z',
  },
  21627: {
    code: 21627,
    message: 'Max Price must be a valid float',
    log_level: 'ERROR',
    secondary_message: 'Max Price must be a valid positive float',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21627\r\n\r\n### Max Price must be a valid float\r\n\r\n Max Price must be a valid positive float\r\n\r\n#### Possible Causes\r\nMax Price has a zero or negative value or not a float\r\n\r\n#### Possible Solutions\r\nSet Max Price to positive float value',
    causes: 'Max Price has a zero or negative value or not a float',
    solutions: 'Set Max Price to positive float value',
    description: 'Max Price must be a valid positive float',
    product: 'Programmable SMS',
    date_created: '2020-05-26T10:40:52Z',
    last_updated: '2020-08-04T10:00:02.982Z',
  },
  21457: {
    code: 21457,
    message: 'AreaCode Parameter not Supported',
    log_level: 'ERROR',
    secondary_message:
      'The AreaCode parameter for provisioning numbers is not supported on the IncomingPhoneNumbers/Local & IncomingPhoneNumbers/TollFree sub-resources.',
    log_type: null,
    docs: '## Error - 21457\n\n### AreaCode Parameter not Supported\n\nThe AreaCode parameter for provisioning numbers is not supported on the IncomingPhoneNumbers/Local & IncomingPhoneNumbers/TollFree sub-resources.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:21Z',
    last_updated: '2020-08-04T10:00:25.443Z',
  },
  23005: {
    code: 23005,
    message: 'Phone Number Redaction Incompatible Configuration: Fallback to Long Code',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 23005\r\n\r\n### Phone Number Redaction Incompatible Configuration: Fallback to Long Code\r\n\r\n Phone Number Redaction is enabled for your account. Fallback to Long Code is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* You have Fallback to Long Code enabled on your Messaging Service. Fallback to Long Code requires Twilio to retain non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* Disable Fallback to Long Code on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/messaging/services/api).\r\n* If Fallback to Long Code functionality is needed, implement this functionality in your own application.',
    causes:
      '* You have Fallback to Long Code enabled on your Messaging Service. Fallback to Long Code requires Twilio to retain non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.',
    solutions:
      '* Disable Fallback to Long Code on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/messaging/services/api).\r\n* If Fallback to Long Code functionality is needed, implement this functionality in your own application.',
    description:
      'Phone Number Redaction is enabled for your account. Fallback to Long Code is not compatible with Phone Number Redaction and should be disabled.',
    product: 'Programmable SMS',
    date_created: '2019-11-21T19:23:09Z',
    last_updated: '2023-07-31T21:38:48.546268Z',
  },
  25201: {
    code: 25201,
    message: 'The identity for role assignments must be a managed user',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25201\r\n\r\n### The identity for role assignments must be a managed user\r\n\r\n The identity for role assignments must be a managed user.\r\n\r\n#### Possible Causes\r\nThe role assignments identity was set for an independent user.\r\n\r\n#### Possible Solutions\r\nVerify the role assignments identity is a managed user.',
    causes: 'The role assignments identity was set for an independent user.',
    solutions: 'Verify the role assignments identity is a managed user.',
    description: 'The identity for role assignments must be a managed user.',
    product: 'Organizations API',
    date_created: '2023-12-04T11:51:12Z',
    last_updated: '2023-12-04T14:28:13.220551Z',
  },
  90014: {
    code: 90014,
    message: 'Validity Period should be positive integer',
    log_level: 'ERROR',
    secondary_message: 'Validity Period should be positive integer',
    log_type: 'APPLICATION',
    docs: '## ERROR - 90014\r\n\r\n### Validity Period should be positive integer\r\n\r\n Validity Period should be positive integer\r\n\r\n#### Possible Causes\r\nValidity Period is not positive integer\r\n\r\n#### Possible Solutions\r\nChange the Validity Period to be positive integer',
    causes: 'Validity Period is not positive integer',
    solutions: 'Change the Validity Period to be positive integer',
    description: 'Validity Period should be positive integer',
    product: 'Programmable SMS',
    date_created: '2020-05-16T15:24:44Z',
    last_updated: '2020-08-04T10:00:03.02Z',
  },
  60211: {
    code: 60211,
    message: 'Bucket with the given Interval already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60211\r\n\r\n### Bucket with the given Interval already exists\r\n\r\n You have already configured that Max number of requests for this `Interval`\r\n\r\nHTTP status: 400\r\n\r\n\r\n#### Possible Causes\r\nYou have already configured that Max number of requests for this `Interval`\r\n\r\n#### Possible Solutions\r\n* Delete/Update Bucket that has this same `Interval`',
    causes: 'You have already configured that Max number of requests for this `Interval`',
    solutions: '* Delete/Update Bucket that has this same `Interval`',
    description:
      'You have already configured that Max number of requests for this `Interval`\r\n\r\nHTTP status: 400\r\n',
    product: 'Verify',
    date_created: '2019-05-08T15:28:24Z',
    last_updated: '2021-05-18T04:43:22.329Z',
  },
  80607: {
    code: 80607,
    message: 'Session Closed',
    log_level: 'WARNING',
    secondary_message: 'Session is closed and cannot be updated',
    log_type: 'APPLICATION',
    docs: '## WARNING - 80607\r\n\r\n### Session Closed\r\n\r\nSession is closed and cannot be updated ## Warning\r\n\r\n### Session Closed\r\n\r\nExample Message: Session is closed and cannot be updated\r\n\r\n#### Possible Causes\r\nYou tried to update a Session that is closed.\r\n\r\n#### Possible Solutions\r\nNone',
    causes: 'You tried to update a Session that is closed.',
    solutions: 'None',
    description:
      '## Warning\r\n\r\n### Session Closed\r\n\r\nExample Message: Session is closed and cannot be updated',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2022-02-24T01:26:50.176262Z',
  },
  30888: {
    code: 30888,
    message: 'Campaign vetting rejection - Age Gate Not Present / Not Acceptable',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30888\r\n\r\n### Campaign vetting rejection - Age Gate Not Present / Not Acceptable\r\n\r\n The campaign submission has been reviewed and it was rejected due to Age Gate issues.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because you indicated that the campaign includes age-gated content, but an Age Gate is not present or is not acceptable on your website and/or opt-in policy.\r\n\r\n#### Possible Solutions\r\nPlease verify and add a robust age gate to your website or opt-in policy. Resubmit the campaign with the updated age gate information for review.\r\n \r\nAdditional help resources\r\n\r\n* [Age Gating](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=Age%20and%20Geographic%20Gating&text=In%20addition%20to%20obtaining%20consent,where%20the%20recipient%20is%20located)\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because you indicated that the campaign includes age-gated content, but an Age Gate is not present or is not acceptable on your website and/or opt-in policy.',
    solutions:
      'Please verify and add a robust age gate to your website or opt-in policy. Resubmit the campaign with the updated age gate information for review.\r\n \r\nAdditional help resources\r\n\r\n* [Age Gating](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=Age%20and%20Geographic%20Gating&text=In%20addition%20to%20obtaining%20consent,where%20the%20recipient%20is%20located)\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected due to Age Gate issues.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:37:35Z',
    last_updated: '2023-05-25T23:10:56.165352Z',
  },
  51004: {
    code: 51004,
    message: 'Client Connection: endpoint_id too long',
    log_level: 'ERROR',
    secondary_message: 'error',
    log_type: null,
    docs: '## Error - 51004\n\n### Client Connection: `endpoint_id` string too long\n\n#### Possible Causes \n\n`endpoint_id` field in the Access Token is too long.\n\n#### Possible Solutions\n\nConsult the product documentation for maximum allowed length of `endpoint_id` field.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:55Z',
    last_updated: '2020-08-04T10:00:22.82Z',
  },
  50449: {
    code: 50449,
    message: 'Conflicting channel modification',
    log_level: 'ERROR',
    secondary_message:
      'The requested channel is already being added or removed by a concurrent API request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50449\r\n\r\n### Conflicting channel modification\r\n\r\nThe requested channel is already being added or removed by a concurrent API request. The requested channel is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.\r\n\r\n#### Possible Causes\r\n* You might be adding a new channel to the service instance while the channel with the same unique name is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a channel with the same unique name to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same channel by SID or unique name from the service instance.\r\n\r\n#### Possible Solutions\r\n* Implement an operation retrier and repeat the failed channel API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that add or remove channels. Wait until the original request completes and returns an API response, before sending any successive channel requests.',
    causes:
      '* You might be adding a new channel to the service instance while the channel with the same unique name is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a channel with the same unique name to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same channel by SID or unique name from the service instance.',
    solutions:
      '* Implement an operation retrier and repeat the failed channel API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that add or remove channels. Wait until the original request completes and returns an API response, before sending any successive channel requests.',
    description:
      'The requested channel is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.',
    product: 'Programmable Chat',
    date_created: '2020-04-20T11:38:57Z',
    last_updated: '2020-08-04T10:00:04.003Z',
  },
  45776: {
    code: 45776,
    message: 'Failed to fetch Configuration for deployment key.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45776\r\n\r\n### Failed to fetch Configuration for deployment key.\r\n\r\n Failed to fetch Configuration for deployment key.\r\n\r\n#### Possible Causes\r\nAn unexpected error occurred while fetching configuration associated with the given deployment key.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes:
      'An unexpected error occurred while fetching configuration associated with the given deployment key.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'Failed to fetch Configuration for deployment key.',
    product: 'Flex',
    date_created: '2023-11-22T15:52:05Z',
    last_updated: '2023-11-22T15:52:05Z',
  },
  81026: {
    code: 81026,
    message: 'Studio Execution failed because Flow exceeds maximum allowed widgets',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 81026\r\n\r\n### Studio Execution failed because Flow exceeds maximum allowed widgets\r\n\r\n The Execution failed because the cumulative number of widgets in your Studio Flow and all its linked Subflows exceeds the maximum allowed widget count of 2,000. All Executions for this Flow will fail until you reduce the number of widgets to 2,000 or fewer.\r\n\r\n#### Possible Causes\r\n* Too many widgets in your Subflows\r\n* Subflows reused too many times in a parent Flow\r\n\r\n#### Possible Solutions\r\n* Reduce the number of widgets in your Subflows',
    causes:
      '* Too many widgets in your Subflows\r\n* Subflows reused too many times in a parent Flow',
    solutions: '* Reduce the number of widgets in your Subflows',
    description:
      'The Execution failed because the cumulative number of widgets in your Studio Flow and all its linked Subflows exceeds the maximum allowed widget count of 2,000. All Executions for this Flow will fail until you reduce the number of widgets to 2,000 or fewer.',
    product: 'Studio',
    date_created: '2021-08-19T22:22:22Z',
    last_updated: '2021-09-28T16:45:50.278012Z',
  },
  95104: {
    code: 95104,
    message: 'Invalid media type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95104\r\n\r\n### Invalid media type\r\n\r\n Twilio failed to transcribe audio due to an invalid media type. The transcription resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\nMedia type is not supported.\r\n\r\n#### Possible Solutions\r\nConvert the file into one of the supported media types: wav, mp3 or FLAC.',
    causes: 'Media type is not supported.',
    solutions: 'Convert the file into one of the supported media types: wav, mp3 or FLAC.',
    description:
      'Twilio failed to transcribe audio due to an invalid media type. The transcription resource has been marked as “failed”',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:32:18Z',
    last_updated: '2024-04-19T11:25:27.047563Z',
  },
  22111: {
    code: 22111,
    message: 'Invalid Hosted Number Order Status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22111\r\n\r\n#### Invalid Hosted Number Order Status\r\n\r\nThe status you specified is not a valid Hosted Number Order status.\r\n\r\n#### Possible Causes\r\n\r\n* Attempting to filter a list of Hosted Number Orders on a status that does not exist.\r\n\r\n* Attempting to update a Hosted Number Order instance with a status that cannot be applied to the current Hosted Number Order state.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:55:51Z',
    last_updated: '2020-08-04T10:00:15.098Z',
  },
  94303: {
    code: 94303,
    message: 'Transcriptions Configurations: Language is required',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94303\r\n\r\n### Transcriptions Configurations: Language is required\r\n\r\n A language is required to create a new configuration\r\n\r\n#### Possible Causes\r\n* "Language" value is blank\r\n* "Language" value is null\r\n\r\n#### Possible Solutions\r\n* Specify a valid "language" as a BCP-47 code',
    causes: '* "Language" value is blank\r\n* "Language" value is null',
    solutions: '* Specify a valid "language" as a BCP-47 code',
    description: 'A language is required to create a new configuration',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-02T10:58:33Z',
  },
  60324: {
    code: 60324,
    message: 'Challenge verification failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60324\r\n\r\n### Challenge verification failed\r\n\r\n Verification attempt was unsuccessful, AuthPayload is invalid.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\n- For a Push Challenge, the signature in AuthPayload is invalid.  \r\n- For a TOTP Challenge, the OTP code in AuthPayload is invalid.\r\n\r\n#### Possible Solutions\r\n- For a Push Challenge, check the signature sent in AuthPayload and retry.  \r\n- For a TOTP Challenge, check the OTP code sent in AuthPayload and retry.',
    causes:
      '- For a Push Challenge, the signature in AuthPayload is invalid.  \r\n- For a TOTP Challenge, the OTP code in AuthPayload is invalid.',
    solutions:
      '- For a Push Challenge, check the signature sent in AuthPayload and retry.  \r\n- For a TOTP Challenge, check the OTP code sent in AuthPayload and retry.',
    description:
      'Verification attempt was unsuccessful, AuthPayload is invalid.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-06-30T21:45:43Z',
    last_updated: '2021-06-30T03:47:19.104317Z',
  },
  92005: {
    code: 92005,
    message: 'ContentSid Required',
    log_level: 'ERROR',
    secondary_message:
      'A ContentSid must be specified if content variables are provided in the request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 92005\r\n\r\n### ContentSid Required\r\n\r\nA ContentSid must be specified if content variables are provided in the request. \r\n\r\n#### Possible Causes\r\nYou attempted to send a message with the ContentVariables parameter but without ContentSid\r\n\r\n#### Possible Solutions\r\nPlease provide a ContentSid when the request includes the ContentVariables parameter',
    causes:
      'You attempted to send a message with the ContentVariables parameter but without ContentSid',
    solutions:
      'Please provide a ContentSid when the request includes the ContentVariables parameter',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-11-08T19:59:40Z',
    last_updated: '2021-11-08T19:59:40Z',
  },
  40130: {
    code: 40130,
    message: 'TaskRouter->Dequeue',
    log_level: 'ERROR',
    secondary_message:
      "Dequeue Instruction does not have a valid 'post_work_activity_sid' provided.",
    log_type: null,
    docs: '## Error - 40130\r\n\r\n### Invalid Activity Sid - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You provided a "post_work_activity_sid"" that was invalid or no longer exists.  \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid ActivitySid is being passed in the "post_work_activity_sid" parameter exists in your workspace. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:42Z',
    last_updated: '2020-08-04T10:00:23.898Z',
  },
  53106: {
    code: 53106,
    message: 'Room not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53106: Room not found\r\n\r\nRaised whenever attempting operation on a non-existent Room.\r\n\r\n#### Causes\r\n\r\n * Attempted to perform operation on non-existent Room.\r\n\r\n#### Solutions\r\n\r\n * Make sure Room exists before re-attempting operation.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:43:26Z',
    last_updated: '2020-08-04T10:00:19.586Z',
  },
  21408: {
    code: 21408,
    message:
      "Permission to send an SMS or MMS has not been enabled for the region indicated by the 'To' number",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21408\r\n\r\n### Permission to send an SMS or MMS has not been enabled for the region indicated by the 'To' number\r\n\r\n You have attempted to send an SMS or MMS to a region that has not been enabled in your account's [Messaging Geo-Permissions](https://console.twilio.com/us1/develop/sms/settings/geo-permissions) settings. These settings exist to help you ensure you only send SMS or MMS to the countries or regions you operate in, and avoid unexpected charges.\r\n\r\n#### Possible Causes\r\n* You have attempted to send an SMS or MMS to a region that has not been enabled in your account's [Geo-Permissions](https://console.twilio.com/us1/develop/sms/settings/geo-permissions) settings. \r\n\r\n#### Possible Solutions\r\nIf you wish to send messages to this region, please enable the relevant permissions on your account using the [Messaging Geographic Permissions](https://console.twilio.com/us1/develop/sms/settings/geo-permissions) page.",
    causes:
      "* You have attempted to send an SMS or MMS to a region that has not been enabled in your account's [Geo-Permissions](https://console.twilio.com/us1/develop/sms/settings/geo-permissions) settings. ",
    solutions:
      'If you wish to send messages to this region, please enable the relevant permissions on your account using the [Messaging Geographic Permissions](https://console.twilio.com/us1/develop/sms/settings/geo-permissions) page.',
    description:
      "You have attempted to send an SMS or MMS to a region that has not been enabled in your account's [Messaging Geo-Permissions](https://console.twilio.com/us1/develop/sms/settings/geo-permissions) settings. These settings exist to help you ensure you only send SMS or MMS to the countries or regions you operate in, and avoid unexpected charges.",
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:20Z',
    last_updated: '2024-02-05T09:25:35.585936Z',
  },
  64023: {
    code: 64023,
    message: 'Pay: Invalid Test Bank Account Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64023\r\n\r\n### Pay: Invalid Test Bank Account Number\r\n\r\n A 64023 error is an indication that your Pay Connector is in TEST mode, but you did not provide a valid test bank account number when testing an ACH payment.\r\n\r\n#### Possible Causes\r\n* Your pay connector is in TEST mode and you provided an invalid test bank account number when testing an ACH payment. For compliance reasons, we can only allow certain test bank account numbers in TEST mode.\r\n\r\n#### Possible Solutions\r\n* Check the documentation for the pay connector in the Twilio Console or in our Twilio docs for valid bank account numbers that can be used when in TEST mode.',
    causes:
      '* Your pay connector is in TEST mode and you provided an invalid test bank account number when testing an ACH payment. For compliance reasons, we can only allow certain test bank account numbers in TEST mode.',
    solutions:
      '* Check the documentation for the pay connector in the Twilio Console or in our Twilio docs for valid bank account numbers that can be used when in TEST mode.',
    description:
      'A 64023 error is an indication that your Pay Connector is in TEST mode, but you did not provide a valid test bank account number when testing an ACH payment.',
    product: 'Programmable Voice',
    date_created: '2023-04-12T16:27:48Z',
    last_updated: '2023-04-12T16:27:48Z',
  },
  54156: {
    code: 54156,
    message: 'Invalid List Item data',
    log_level: 'ERROR',
    secondary_message: "The 'Data' parameter cannot be null.",
    log_type: null,
    docs: "\n## Error - 54156\n\n### Sync: Invalid List Item Data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\n* Your request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.517Z',
  },
  22151: {
    code: 22151,
    message: 'Port In Error - Number with carrier restrictions',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: "## ERROR - 22151\r\n\r\n### Port In Error - Number with carrier restrictions\r\n\r\n Phone number has carrier restrictions with the losing carrier that must be resolved before porting the phone number.\r\n\r\n#### Possible Causes\r\nA carrier may place a restriction on a phone number to prevent porting for many reasons, common ones include service freezes to prevent unauthorized transfers or billing problems.\r\n\r\n#### Possible Solutions\r\nContact the phone number's current carrier and resolve any outstanding issues that is preventing them from approving the port.",
    causes:
      'A carrier may place a restriction on a phone number to prevent porting for many reasons, common ones include service freezes to prevent unauthorized transfers or billing problems.',
    solutions:
      "Contact the phone number's current carrier and resolve any outstanding issues that is preventing them from approving the port.",
    description:
      'Phone number has carrier restrictions with the losing carrier that must be resolved before porting the phone number.',
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:01:36Z',
    last_updated: '2024-04-22T23:01:36Z',
  },
  54450: {
    code: 54450,
    message: "Invalid 'Direction' query parameter",
    log_level: 'ERROR',
    secondary_message: "The 'Direction' query parameter must be one of {'forward', 'backward'}.",
    log_type: null,
    docs: "\n## Error - 54450\n\n### Sync: Invalid 'Direction' query parameter\nThe 'Direction' query parameter must be one of {'forward', 'backward'}.\n\n#### Possible Causes\n* The value supplied by the Direction query string parameter does not match _forward_ or _backward_ designators.\n\n#### Possible Solutions\nConfirm that a valid Direction query parameter is being passed in request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.249Z',
  },
  45309: {
    code: 45309,
    message: 'Modify Participant Not Allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45309\r\n\r\n### Modify Participant Not Allowed\r\n\r\n Error occurred when trying to modify a participant\r\n\r\n#### Possible Causes\r\nMeeting is not setup successfully for the operation\r\n\r\n#### Possible Solutions\r\nRetry operation.',
    causes: 'Meeting is not setup successfully for the operation',
    solutions: 'Retry operation.',
    description: 'Error occurred when trying to modify a participant',
    product: 'Flex',
    date_created: '2020-05-08T21:29:35Z',
    last_updated: '2020-08-04T10:00:03.239Z',
  },
  45373: {
    code: 45373,
    message: 'Failed to remove Participant.  Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45373\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'We failed to remove a Participant from a Channel due to an unexpected error condition.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to remove Participant <participant sid> l due to an internal error.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:11.798982Z',
  },
  31408: {
    code: 31408,
    message: 'Request Timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31408\r\n\r\n### Request Timeout\r\n\r\nA request timeout occurred.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:20:33Z',
    last_updated: '2020-08-04T10:00:08.433Z',
  },
  60240: {
    code: 60240,
    message: 'Templates not allowed',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 60240\r\n\r\n### Templates not allowed\r\n\r\n Your account does not have enough permissions to use templates\r\n\r\n#### Possible Causes\r\nSome countries have special requirements that can override the message to be compliant with the country thus preventing the use of templates.\r\n\r\n#### Possible Solutions\r\nPlease contact the support team to validate the requirements needed to be compliant with the country and avoid the override of the message. ',
    causes:
      'Some countries have special requirements that can override the message to be compliant with the country thus preventing the use of templates.',
    solutions:
      'Please contact the support team to validate the requirements needed to be compliant with the country and avoid the override of the message. ',
    description: 'Your account does not have enough permissions to use templates',
    product: 'Verify',
    date_created: '2023-11-03T19:27:55Z',
    last_updated: '2023-11-03T19:27:55Z',
  },
  53616: {
    code: 53616,
    message: 'Deleted a recording with custom configuration as time for retries was depleted',
    log_level: 'WARNING',
    secondary_message: 'The recording has been removed and will not be available',
    log_type: null,
    docs: "## Warning - 53616\r\n\r\n### Deleted a recording with custom configuration as time for retries was depleted\r\n\r\nTwilio gave up on uploading your recording with custom configuration, as time for retries was depleted. The recording has been removed and will not be available.\r\n\r\n#### Causes\r\n\r\n * There was an error with your account's recording settings, either due to the access credentials for your own bucket or to the encryption key.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).\r\n\r\n* In the recording settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-09-28T16:02:46Z',
    last_updated: '2020-08-04T10:00:12.568Z',
  },
  52133: {
    code: 52133,
    message: 'Invalid APNs device token size',
    log_level: 'ERROR',
    secondary_message: 'APN token size is invalid',
    log_type: null,
    docs: '## Error - 52133\r\n\r\n### Invalid APNs device token size\r\n\r\n#### Possible Causes \r\n*  Invalid APNs token was provided.\r\n\r\n#### Possible Solutions\r\n*  Make sure you do not modify the APNs device token before providing it to Twilio.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:34:46Z',
    last_updated: '2020-08-04T10:00:22.176Z',
  },
  35125: {
    code: 35125,
    message: 'Maximum limit reached in the account for scheduling messages',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35125\r\n\r\n### Maximum limit reached in the account for scheduling messages\r\n\r\n There is a soft limit of 500,000 scheduled messages at any given time, per account_sid, that can be guaranteed. As each scheduled message is sent, more messages can be scheduled up to that limit.\r\n\r\n#### Possible Causes\r\nThe account_sid already has at least 500,000 messages scheduled.\r\n\r\n#### Possible Solutions\r\nWait for the scheduled messages to be sent. At the send_at time, as the messages are sent (or canceled) the limit will free up. If this limitation is a blocker, kindly contact Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes: 'The account_sid already has at least 500,000 messages scheduled.',
    solutions:
      'Wait for the scheduled messages to be sent. At the send_at time, as the messages are sent (or canceled) the limit will free up. If this limitation is a blocker, kindly contact Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description:
      'There is a soft limit of 500,000 scheduled messages at any given time, per account_sid, that can be guaranteed. As each scheduled message is sent, more messages can be scheduled up to that limit.',
    product: 'Programmable SMS',
    date_created: '2021-11-22T23:10:25Z',
    last_updated: '2023-11-01T04:30:59.896205Z',
  },
  53301: {
    code: 53301,
    message: 'Track name is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53301: Track name is invalid\r\n\r\nRaised whenever a Track name is invalid, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\n * The Track name does not adhere to the Track name requirements.\r\n\r\n#### Solutions\r\n\r\n * Choose a Track name adheres to the Track name requirements.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-10-12T19:59:08Z',
    last_updated: '2020-08-04T10:00:16.93Z',
  },
  52163: {
    code: 52163,
    message: 'Incorrect URL used to retrieve Webhook Credentials',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52163\r\n\r\n### Incorrect URL used to retrieve Webhook Credentials\r\n\r\n#### Possible Causes \r\n*  An incorrect URL was specified in your Webhook Credentials URL field\r\n*  The URL was correct, but returned a 404 response\r\n\r\n#### Possible Solutions\r\n*  Verify your Webhook Credential URL and response',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T11:49:19Z',
    last_updated: '2020-08-04T10:00:14.342Z',
  },
  51118: {
    code: 51118,
    message: 'Twilsock: Invalid claim set',
    log_level: 'ERROR',
    secondary_message: 'Claim set provided in token is invalid.',
    log_type: null,
    docs: '## Error - 51118\r\n\r\n### Invalid claim set\r\n\r\n#### Possible Causes \r\nClaim set provided in token is invalid.\r\n\r\n#### Possible Solutions\r\nVerify the token has a valid claim set.\r\n\r\nTo check whether the token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:08:56Z',
    last_updated: '2020-08-04T10:00:09.587Z',
  },
  60205: {
    code: 60205,
    message: 'SMS is not supported by landline phone number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60205\r\n\r\n### SMS is not supported by landline phone number\r\n\r\n You have attempted to send the verification code to phone number that does not support SMS.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nYou have attempted to send the verification code to phone number that does not support SMS.\r\n\r\n#### Possible Solutions\r\n* Make sure the number you are sending a verification to is a valid mobile phone number\r\n* Disable validating phone numbers using the Twilio API setting `SkipSmsToLandlines` on your Verification Service to `false`.',
    causes:
      'You have attempted to send the verification code to phone number that does not support SMS.',
    solutions:
      '* Make sure the number you are sending a verification to is a valid mobile phone number\r\n* Disable validating phone numbers using the Twilio API setting `SkipSmsToLandlines` on your Verification Service to `false`.',
    description:
      'You have attempted to send the verification code to phone number that does not support SMS.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2018-12-06T20:10:12Z',
    last_updated: '2021-05-18T04:36:54.438Z',
  },
  21607: {
    code: 21607,
    message: "The 'from' phone number must be the sandbox phone number for trial accounts.",
    log_level: 'ERROR',
    secondary_message:
      'You can only send SMS messages from the sandbox phone number while your account is in the free trial.  Upgrade your account to a Full Twilio account to send and receive from your own phone numbers.',
    log_type: null,
    docs: "## Error - 21607\n\n### The 'From' number is not a valid, SMS-capable Twilio number\n\nWhile your account is in Trial mode, you can only send SMS messages from your\nfree trial number, or the Twilio Sandbox Number. To remove this restriction,\n[upgrade to a full account](/user/billing/upgrade).\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:05Z',
    last_updated: '2020-08-04T10:00:26.644Z',
  },
  21204: {
    code: 21204,
    message: 'Call already initiated',
    log_level: 'ERROR',
    secondary_message: 'You should never receive this error',
    log_type: null,
    docs: '## Error - 21204 \n\n### Call already initiated\n\nYou should never receive this error\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:54Z',
    last_updated: '2020-08-04T10:00:27.241Z',
  },
  60519: {
    code: 60519,
    message: 'SNA Verification Result Pending',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60519\r\n\r\n### SNA Verification Result Pending\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received and is still pending completion. \r\n\r\nThis can happen when:\r\n\r\n- A Verification Check is performed on a Verification that is still in progress.\r\n- A Verification was created for a phone number whose carrier is not supported for the selected Twilio Region. For example, if an SNA Verification was created for a UK phone number using the US1 Region instead of the IE1 Region. In this case, the Verification request will never complete.\r\n\r\n#### Possible Solutions\r\n- Confirm the Verification Check is performed only after a HTTP 200 Response is received from invoking the SNA URL.\r\n- Retry if the Verification is still in its validity window and has not expired.\r\n- Confirm the Verification was created in the correct Twilio Region for the phone number, see [Using Verify Silent Network Auth with Twilio Regions\r\n](https://www.twilio.com/docs/verify/using-verify-silent-network-auth-with-twilio-regions) for more detailed information. If it was not, retry Verification using correct Region.',
    causes:
      'The Verification request was received and is still pending completion. \r\n\r\nThis can happen when:\r\n\r\n- A Verification Check is performed on a Verification that is still in progress.\r\n- A Verification was created for a phone number whose carrier is not supported for the selected Twilio Region. For example, if an SNA Verification was created for a UK phone number using the US1 Region instead of the IE1 Region. In this case, the Verification request will never complete.',
    solutions:
      '- Confirm the Verification Check is performed only after a HTTP 200 Response is received from invoking the SNA URL.\r\n- Retry if the Verification is still in its validity window and has not expired.\r\n- Confirm the Verification was created in the correct Twilio Region for the phone number, see [Using Verify Silent Network Auth with Twilio Regions\r\n](https://www.twilio.com/docs/verify/using-verify-silent-network-auth-with-twilio-regions) for more detailed information. If it was not, retry Verification using correct Region.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T16:50:11Z',
    last_updated: '2022-10-17T18:17:14.910435Z',
  },
  19057: {
    code: 19057,
    message: 'Server unavailable or busy',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 19057\r\n\r\n### Server unavailable or busy\r\n\r\n Server is busy or unavailable\r\n\r\n#### Possible Causes\r\nWe're having trouble completing your request \r\n\r\n#### Possible Solutions\r\nPlease retry again",
    causes: "We're having trouble completing your request ",
    solutions: 'Please retry again',
    description: 'Server is busy or unavailable',
    product: 'Contacts',
    date_created: '2020-09-23T19:22:25Z',
    last_updated: '2020-09-23T19:22:25Z',
  },
  21712: {
    code: 21712,
    message: 'Phone Number or Short Code is associated with another Messaging Service.',
    log_level: 'ERROR',
    secondary_message:
      'You have tried to assign a Twilio phone number or short code to a Messaging Service, but the number is already associated with a different Messaging Service.',
    log_type: null,
    docs: '## Error - 21712\r\n\r\n### Phone Number or Short Code is associated with another Messaging Service.\r\n\r\nA Twilio phone number or short code can only be associated with one Messaging Service at a time.\r\n\r\nPlease delete the number from its existing Messaging Service before attempting to add it to a new Messaging Service. [See here](https://www.twilio.com/docs/sms/services/api/phonenumber-resource?code-sample=code-delete-phone-number&code-language=curl&code-sdk-version=json) for a code sample. Removing a Twilio number from a Messaging Service will not remove the number from your account.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-03-11T18:43:55Z',
    last_updated: '2020-08-04T10:00:09.984Z',
  },
  30480: {
    code: 30480,
    message: 'Toll-Free phone number verification rejection - Disallowed - Phishing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30480\r\n\r\n### Toll-Free phone number verification rejection - Disallowed - Phishing\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Messaging traffic on this Toll-Free phone number is blocked.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the business or message content was found to be associated with a known Phishing campaign. \r\n\r\n#### Possible Solutions\r\nContact Twilio Support to provide Additional Information that explains your use case.\r\n\r\nResources: \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    causes:
      'The toll-free phone number cannot be verified because the business or message content was found to be associated with a known Phishing campaign. ',
    solutions:
      'Contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\nResources: \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Messaging traffic on this Toll-Free phone number is blocked.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T22:20:48Z',
    last_updated: '2024-02-22T22:20:48Z',
  },
  91004: {
    code: 91004,
    message: 'Test event cannot be found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91004\r\n\r\n### Test event cannot be found\r\n\r\n Test event cannot be found\r\n\r\n#### Possible Causes\r\n* Test event does not exist\r\n\r\n#### Possible Solutions\r\n* Make sure you send the test event before validating.',
    causes: '* Test event does not exist',
    solutions: '* Make sure you send the test event before validating.',
    description: 'Test event cannot be found',
    product: 'Events',
    date_created: '2020-09-16T15:51:47Z',
    last_updated: '2021-01-06T16:27:02.794Z',
  },
  19029: {
    code: 19029,
    message: 'When updating a channel at least one field should be updated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19029\r\n\r\n### When updating a channel at least one field should be updated\r\n\r\n No channel updates provided in the request\r\n\r\n#### Possible Causes\r\nUser has not provided channel updates\r\n\r\n#### Possible Solutions\r\nWhen updating a channel at least one field should be updated',
    causes: 'User has not provided channel updates',
    solutions: 'When updating a channel at least one field should be updated',
    description: 'No channel updates provided in the request',
    product: null,
    date_created: '2020-08-07T22:50:51Z',
    last_updated: '2020-08-07T22:50:51Z',
  },
  81007: {
    code: 81007,
    message: 'Connecting to a Call timed out',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81007\r\n\r\n### Connecting to a Call timed out\r\nStudio timed out while executing the Connect Caller widget in the Flow.\r\n\r\n#### Possible Causes\r\n* The call could not be completed before the end of the timeout period.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:15:34Z',
    last_updated: '2020-08-04T10:00:13.177Z',
  },
  13230: {
    code: 13230,
    message: 'Dial->Conference: Invalid muted value',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Warning - 13230 \n\n### Dial->Conference: Invalid muted value\n\nmuted must be either "true" or false".\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:35Z',
    last_updated: '2020-08-04T10:00:28.523Z',
  },
  30750: {
    code: 30750,
    message: 'Brand Registration Failure: Mobile phone number duplicate threshold reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30750\r\n\r\n### Brand Registration Failure: Mobile phone number duplicate threshold reached\r\n\r\n Brand can not be registered with provided mobile phone number since duplicate threshold limit has been reached for it.\r\n\r\n#### Possible Causes\r\nEach Sole Proprietor Brand registration requires a unique active wireless mobile phone number. It is possible that the Sole Proprietor A2P profile bundle used for brand registration contains a mobile number which has been used to register a Sole Proprietor Brand already. \r\n\r\n#### Possible Solutions\r\nPlease use a different mobile phone number.\r\nPlease edit the Sole Proprietor A2P profile bundle and use a different active wireless mobile number for OTP verification. Once submitted for review, you can resubmit the brand registration request. \r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes:
      'Each Sole Proprietor Brand registration requires a unique active wireless mobile phone number. It is possible that the Sole Proprietor A2P profile bundle used for brand registration contains a mobile number which has been used to register a Sole Proprietor Brand already. ',
    solutions:
      'Please use a different mobile phone number.\r\nPlease edit the Sole Proprietor A2P profile bundle and use a different active wireless mobile number for OTP verification. Once submitted for review, you can resubmit the brand registration request. \r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description:
      'Brand can not be registered with provided mobile phone number since duplicate threshold limit has been reached for it.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:42:43Z',
    last_updated: '2024-02-13T16:06:53.301775Z',
  },
  21102: {
    code: 21102,
    message: 'Reached maximum number of Services',
    log_level: 'ERROR',
    secondary_message: 'Reached maximum number of Services per parent account and product',
    log_type: null,
    docs: '## Error - 21102\r\n\r\n### Reached maximum number of Services\r\n\r\n#### Possible Causes\r\nYou have attempted to create a Service, but your parent account already has the maximum amount for this product.\r\n\r\n#### Possible Solutions\r\n* Contact support to increase your Service limit\r\n* Delete some of your Services',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2018-01-19T11:42:55Z',
    last_updated: '2020-08-04T10:00:15.261Z',
  },
  20159: {
    code: 20159,
    message: 'Invalid Signature',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20159 \r\n\r\n### Invalid Signature\r\nThe JWT provided to the Twilio API has an invalid or mismatching signature.\r\n\r\n#### Possible Causes \r\n* Public key in the JWT does not match the actual private key used for signing the request.\r\n\r\n#### Possible Solution:\r\n* Make sure the private key used for signing the JWT matches the public key identifier in JWT.\r\n* To check whether the JWT is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:14:06Z',
    last_updated: '2020-08-04T10:00:18.972Z',
  },
  13222: {
    code: 13222,
    message: 'Dial->Number: Invalid sendDigits value',
    log_level: 'WARNING',
    secondary_message:
      'sendDigits attribute may only contain the following characters "0123456789*#w". See the <a href=\'/docs/api/twiml/dial\'>Dial Verb</a> API Reference for more information.',
    log_type: null,
    docs: '## Warning - 13222 \n\n### Dial->Number: Invalid sendDigits value\n\nsendDigits attribute may only contain the following characters "0123456789*#w". See the <a href=\'/docs/api/twiml/dial\'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:34Z',
    last_updated: '2020-08-04T10:00:28.707Z',
  },
  50057: {
    code: 50057,
    message: 'Programmable Chat: Webhook call failed to execute successfully',
    log_level: 'ERROR',
    secondary_message: 'The event triggered webhook call failed to execute successfully',
    log_type: null,
    docs: '## Error - 50057\r\n\r\n### Programmable Chat: Webhook call failed to execute successfully\r\n\r\n#### Possible Causes \r\n*  The Webhook endpoint called returned an error code\r\n\r\n#### Possible Solutions\r\n* Check your Webhook execution logic to ensure it is processing the webhook calls correctly and passing back 200 OK',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-04-01T11:43:41Z',
    last_updated: '2020-08-04T10:00:22.648Z',
  },
  40138: {
    code: 40138,
    message: "Missing 'from' parameter when issuing Conference instruction",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40138\r\n\r\n### Missing \'from\' parameter when issuing Conference instruction\r\n\r\n A valid \'from\' parameter was not passed to the \'conference\' instruction\r\n\r\n#### Possible Causes\r\n* A \'from\' parameter was not passed when issuing the Conference instruction\r\n* The \'from\' parameter supplied to the Conference instruction was invalid\r\n\r\n#### Possible Solutions\r\n* Supply a valid \'from\' parameter when issuing the Conference instruction\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "+18001234567"\r\n}\r\n```',
    causes:
      "* A 'from' parameter was not passed when issuing the Conference instruction\r\n* The 'from' parameter supplied to the Conference instruction was invalid",
    solutions:
      '* Supply a valid \'from\' parameter when issuing the Conference instruction\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "+18001234567"\r\n}\r\n```',
    description: "A valid 'from' parameter was not passed to the 'conference' instruction",
    product: 'TaskRouter',
    date_created: '2020-08-21T00:09:55Z',
    last_updated: '2020-08-21T00:09:55Z',
  },
  93104: {
    code: 93104,
    message: 'There is an issue with the Kinesis Stream Name or Region',
    log_level: 'ERROR',
    secondary_message: 'The ARN provided for your Kinesis Stream is invalid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 93104\r\n\r\n### There is an issue with the Kinesis Stream Name or Region\r\n\r\nThe ARN provided for your Kinesis Stream is invalid The ARN for your Kinesis Stream is invalid\r\n\r\n#### Possible Causes\r\nBad ARN was provided when creating the sink\r\n\r\n#### Possible Solutions\r\nCreate a new sink and put in a valid ARN',
    causes: 'Bad ARN was provided when creating the sink',
    solutions: 'Create a new sink and put in a valid ARN',
    description: 'The ARN for your Kinesis Stream is invalid',
    product: 'Events',
    date_created: '2021-01-13T18:27:31Z',
    last_updated: '2021-02-04T17:37:49.332Z',
  },
  57006: {
    code: 57006,
    message: "'EventType' is empty",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57006\r\n\r\n### 'EventType' is empty\r\n\r\n 'EventType' is not specified\r\n\r\n#### Possible Causes\r\n'EventType' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'EventType' is being passed in request.",
    causes: "'EventType' is not specified",
    solutions: "Confirm a valid 'EventType' is being passed in request.",
    description: "'EventType' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:51:57Z',
    last_updated: '2021-05-07T08:51:57Z',
  },
  63041: {
    code: 63041,
    message: 'Template paused',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63041\r\n\r\n### Template paused\r\n\r\n WhatsApp has reported that the template has been temporarily paused due to recurring negative feedback from customers. Message templates with this status cannot be sent to customers. For the most updated guidelines, please view [WhatsApp’s documentation](https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/#template-pausing). \r\n\r\n#### Possible Causes\r\n* Negative customer feedback (i.e. multiple customers reporting messages or blocking number)\r\n\r\n#### Possible Solutions\r\n* Use a different template\r\n* Edit this template and re-submit for review',
    causes:
      '* Negative customer feedback (i.e. multiple customers reporting messages or blocking number)',
    solutions: '* Use a different template\r\n* Edit this template and re-submit for review',
    description:
      'WhatsApp has reported that the template has been temporarily paused due to recurring negative feedback from customers. Message templates with this status cannot be sent to customers. For the most updated guidelines, please view [WhatsApp’s documentation](https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/#template-pausing). ',
    product: 'Programmable Messaging',
    date_created: '2022-10-25T20:54:18Z',
    last_updated: '2022-10-25T20:55:03.127446Z',
  },
  45101: {
    code: 45101,
    message: 'Configuration Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45101\r\n\r\n### Configuration Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nQueried configuration is not yet created for specified account.\r\n\r\n#### Possible Solutions\r\nEnsure, that configuration for specific account is created, create one if not.',
    causes: 'Queried configuration is not yet created for specified account.',
    solutions: 'Ensure, that configuration for specific account is created, create one if not.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:54:26Z',
    last_updated: '2020-08-04T10:00:12.395Z',
  },
  53300: {
    code: 53300,
    message: 'Track is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53300: Track is invalid\r\n\r\nRaised whenever a Track is invalid, and the scenario is not covered by a more specific error code.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-10-12T19:58:28Z',
    last_updated: '2020-08-04T10:00:16.954Z',
  },
  30890: {
    code: 30890,
    message: 'Campaign vetting rejection - Subscriber Help',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30890\r\n\r\n### Campaign vetting rejection - Subscriber Help\r\n\r\n The campaign submission has been reviewed and it was rejected because of provided Subscriber Help information.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because it was indicated that you have a HELP message reply but it does not contain brand name, phone number, or email address.\r\n\r\n#### Possible Solutions\r\nPlease verify that subscriber help message contains brand name, phone number, or email address. Message needs to guide customers on who them can contact after replying ""help"".\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because it was indicated that you have a HELP message reply but it does not contain brand name, phone number, or email address.',
    solutions:
      'Please verify that subscriber help message contains brand name, phone number, or email address. Message needs to guide customers on who them can contact after replying ""help"".\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because of provided Subscriber Help information.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:39:03Z',
    last_updated: '2023-04-18T11:39:03Z',
  },
  32112: {
    code: 32112,
    message: 'SIP: Invalid header value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32112\r\n\r\n### SIP: Invalid header value\r\n\r\n The header you asked Twilio to stamp was omitted because it contains illegal characters in its _value_. Including this header would have resulting in Twilio generating a message that runs contrary to the SIP specification.\r\n\r\n#### Possible Causes\r\n* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.\r\n\r\n#### Possible Solutions\r\n* If you are generating SIP headers from user input, ensure your application properly accounts for non-alphanumeric characters such as punctuation and whitespace, as well as international characters.',
    causes:
      '* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.',
    solutions:
      '* If you are generating SIP headers from user input, ensure your application properly accounts for non-alphanumeric characters such as punctuation and whitespace, as well as international characters.',
    description:
      'The header you asked Twilio to stamp was omitted because it contains illegal characters in its _value_. Including this header would have resulting in Twilio generating a message that runs contrary to the SIP specification.',
    product: null,
    date_created: '2019-06-13T20:37:16Z',
    last_updated: '2020-08-04T10:00:07.927Z',
  },
  64018: {
    code: 64018,
    message: 'Pay: Value needed for either Capture or Status parameters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64018\r\n\r\n### Pay: Value needed for either Capture or Status parameters\r\n\r\n A 64018 Error is an indication that it is not clear whether to capture a piece of payment information or to complete/cancel the transaction.\r\n\r\n#### Possible Causes\r\n* Parameter value not provided for both Capture and Status \r\n* Parameter value provided for both Capture and Status\r\n\r\n#### Possible Solutions\r\n* Ensure either Capture or Status parameters have a value but not both',
    causes:
      '* Parameter value not provided for both Capture and Status \r\n* Parameter value provided for both Capture and Status',
    solutions: '* Ensure either Capture or Status parameters have a value but not both',
    description:
      'A 64018 Error is an indication that it is not clear whether to capture a piece of payment information or to complete/cancel the transaction.',
    product: 'Programmable Voice',
    date_created: '2020-05-05T23:00:24Z',
    last_updated: '2020-08-04T10:00:03.405Z',
  },
  57007: {
    code: 57007,
    message: "'EventType' is absent",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57007\r\n\r\n### 'EventType' is absent\r\n\r\n 'EventType' is not being passed in request\r\n\r\n#### Possible Causes\r\n'EventType' is not being passed in request\r\n\r\n#### Possible Solutions\r\nConfirm a 'EventType' is being passed in request.",
    causes: "'EventType' is not being passed in request",
    solutions: "Confirm a 'EventType' is being passed in request.",
    description: "'EventType' is not being passed in request",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:53:47Z',
    last_updated: '2021-05-07T08:53:47Z',
  },
  53601: {
    code: 53601,
    message: 'AWS credentials for recording upload are invalid',
    log_level: 'ERROR',
    secondary_message: 'The recording will not be processed',
    log_type: null,
    docs: "## Error - 53601\r\n\r\n### AWS credentials for recording upload are invalid\r\n\r\nThe recording will not be processed.\r\n\r\nRaised when the AWS credentials provided in the recording's metadata for uploading the media to S3 are not valid.\r\n\r\n#### Causes\r\n\r\n * Providing invalid AWS credentials for S3 access.\r\n\r\n#### Solutions\r\n\r\n * Set AWS credentials to a correct value.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:36:18Z',
    last_updated: '2020-08-04T10:00:14.779Z',
  },
  45377: {
    code: 45377,
    message: 'Account SID not authorized. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45377\r\n\r\n### Account SID not authorized. \r\n\r\n The account sid provided is not authorized to make changes to this Channel.\r\n\r\n#### Possible Causes\r\nThe request was not completed because the AccountSid provided does not match the credentials in our records. \r\n\r\n#### Possible Solutions\r\nEnsure the AccountSid being used is the same as the one used to create the resource. ',
    causes:
      'The request was not completed because the AccountSid provided does not match the credentials in our records. ',
    solutions:
      'Ensure the AccountSid being used is the same as the one used to create the resource. ',
    description: 'The account sid provided is not authorized to make changes to this Channel.',
    product: 'Flex',
    date_created: '2022-12-15T21:48:27Z',
    last_updated: '2022-12-15T21:51:35.850177Z',
  },
  60620: {
    code: 60620,
    message: 'Lookup SIM Swap Information is Incomplete From Carrier',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 60620\r\n\r\n### Lookup SIM Swap Information is Incomplete From Carrier\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe carrier failed to provide SIM Swap information for this phone number.\r\n\r\n#### Possible Solutions\r\nDo not retry request for this end user.',
    causes: 'The carrier failed to provide SIM Swap information for this phone number.',
    solutions: 'Do not retry request for this end user.',
    description: 'Lookup Carrier Information Not Available',
    product: 'Lookup',
    date_created: '2022-11-01T17:03:09Z',
    last_updated: '2023-01-06T00:27:08.814319Z',
  },
  20004: {
    code: 20004,
    message: 'Method not allowed',
    log_level: 'ERROR',
    secondary_message:
      'The resource you accessed is valid, but the HTTP method you attempted to use is not supported for the resource.  For example, you cannot DELETE your own account.',
    log_type: null,
    docs: '## Error - 20004 \n\n### Method not allowed\n\nThe resource you accessed is valid, but the HTTP method you attempted to use is not supported for the resource.  For example, you cannot DELETE your own account.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:51Z',
    last_updated: '2020-08-04T10:00:27.409Z',
  },
  13617: {
    code: 13617,
    message: 'Record: Recording length is out of range for transcription',
    log_level: 'WARNING',
    secondary_message:
      'Twilio could not process the transcription because the duration of the recording is either too short or too long. The recording itself will not be affected.',
    log_type: null,
    docs: "## Warning - 13617\n\n### Record: Recording length is out of range for transcription\n\nTwilio could not process the transcription because the duration of the recording is either too short or too long. The recording itself will not be affected. \n\n\n#### Possible Solutions\n*  Transcription is currently limited to recordings with a duration greater than 2 seconds and less than 120 seconds. Consider using the maxLength parameter for `<Record>` to limit the duration of the recording. See <a href='/docs/api/twiml/record#attributes-transcribe'>transcription TwiML reference</a> for more information. \n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:46Z',
    last_updated: '2020-08-04T10:00:27.752Z',
  },
  52162: {
    code: 52162,
    message: 'Credentials do not belong to used account',
    log_level: 'ERROR',
    secondary_message:
      'Account sid from credentials is not equal account sid which is used for sending notification',
    log_type: null,
    docs: '## Error - 52162\r\n\r\n### Credentials do not belong to used account\r\n\r\n#### Possible Causes \r\n*  The credential you have tried to use does not belong to the account.\r\n\r\n#### Possible Solutions\r\n*  Use a credential that belongs to the account.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:40:33Z',
    last_updated: '2020-08-04T10:00:22.005Z',
  },
  21257: {
    code: 21257,
    message: 'Invalid SIP Manipulation Policy SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21257\r\n\r\n### Invalid SIP Manipulation Policy SID\r\n\r\n Operation could not be performed because the SIP Manipulation Policy SID does not exist.\r\n\r\n#### Possible Causes\r\nSIP Manipulation Policy SID is incorrect.\r\n\r\n#### Possible Solutions\r\nVerify the SIP Manipulation Policy SID is valid.',
    causes: 'SIP Manipulation Policy SID is incorrect.',
    solutions: 'Verify the SIP Manipulation Policy SID is valid.',
    description:
      'Operation could not be performed because the SIP Manipulation Policy SID does not exist.',
    product: 'Elastic SIP Trunking',
    date_created: '2021-09-16T19:31:45Z',
    last_updated: '2021-09-27T18:47:12.65733Z',
  },
  45711: {
    code: 45711,
    message: 'Failed to create webchat participant. Unauthorized ',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45711\r\n\r\n### Failed to create webchat participant. Unauthorized \r\n\r\n Failed to create webchat participant. Credentials provided in request are invalid for the action. \r\n\r\n#### Possible Causes\r\nRequest is attempting to access resource where access is not allowed for given credentials.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly or apply for permissions.',
    causes:
      'Request is attempting to access resource where access is not allowed for given credentials.',
    solutions: 'Check that accessed resource is set correctly or apply for permissions.',
    description:
      'Failed to create webchat participant. Credentials provided in request are invalid for the action. ',
    product: 'Flex',
    date_created: '2022-10-03T21:42:06Z',
    last_updated: '2022-10-03T21:42:06Z',
  },
  21650: {
    code: 21650,
    message: 'Phone Number Requires a Verified Identity Document',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 21650\r\n\r\n### Phone Number Requires a Verified Identity Document\r\n\r\nTo purchase this number you must have a verified identity document on your account. \r\n\r\n#### Possible Causes\r\n- There is no verified identity document on your account or subaccount. Due to local regulations, some phone numbers require a verified identity document associated with your Twilio account.\r\n\r\n#### Possible Solutions\r\n- In the Phone Numbers > Documents section in Console, provide the name of the individual or business registering the phone numbers and a scanned copy of supporting identification documents.\r\n- Ensure that the verification status of the identity document record is “Passed”. If “Pending”, wait 48 business hours for Twilio to verify the document. If “Failed”, please refer to the failure reason to address the issue. \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2017-06-28T22:21:51Z',
    last_updated: '2020-08-04T10:00:18.182Z',
  },
  30108: {
    code: 30108,
    message: 'Twilio account does not belong to an organization',
    log_level: 'ERROR',
    secondary_message:
      'Domains are managed at the Organization level. Please attach this account to an organization and proceed with setup for Click Tracking prior to use.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30108\r\n\r\n### Twilio account does not belong to an organization\r\n\r\nDomains are managed at the Organization level. Please attach this account to an organization and proceed with setup for Click Tracking prior to use. Domains are managed at the Organization level. Please attach this account to an organization and proceed with setup for Click Tracking prior to use.\r\n\r\n#### Possible Causes\r\nNecessary setup steps for Click Tracking, including creation of an organization have not been completed.\r\n\r\n#### Possible Solutions\r\nPlease follow setup guides for Click Tracking.',
    causes:
      'Necessary setup steps for Click Tracking, including creation of an organization have not been completed.',
    solutions: 'Please follow setup guides for Click Tracking.',
    description:
      'Domains are managed at the Organization level. Please attach this account to an organization and proceed with setup for Click Tracking prior to use.',
    product: 'Programmable SMS',
    date_created: '2020-05-05T19:13:34Z',
    last_updated: '2020-08-04T10:00:03.534Z',
  },
  10003: {
    code: 10003,
    message: 'Incoming call rejected due to inactive account',
    log_level: 'ERROR',
    secondary_message:
      'An incoming call was made to your application, but was not answered because your account was not active at the time.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 10003\r\n\r\n### Incoming call rejected due to inactive account\r\n\r\nAn incoming call was made to your application, but was not answered because your account was not active at the time. \r\n\r\n#### Possible Causes\r\n*  Lack of funds\r\n*  Violation of the Terms of Service or Acceptable Use Policy\r\n\r\n#### Possible Solutions\r\n*  Check your account balance.  Refill funds if necessary.\t\r\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.',
    causes: '*  Lack of funds\r\n*  Violation of the Terms of Service or Acceptable Use Policy',
    solutions:
      '*  Check your account balance.  Refill funds if necessary.\t\r\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.',
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:22Z',
    last_updated: '2023-07-31T21:26:30.972239Z',
  },
  19014: {
    code: 19014,
    message: 'Can fetch contact either by unique_customer_provided_id or channel ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19014\r\n\r\n### Can fetch contact either by unique_customer_provided_id or channel \r\n\r\n Contact fetch request should contain unique_customer_provided_id or channel, not both\r\n\r\n#### Possible Causes\r\nContact fetch request contains both unique_customer_provided_id and channel\r\n\r\n#### Possible Solutions\r\nContact can be fetched either by unique_customer_provided_id or by channel',
    causes: 'Contact fetch request contains both unique_customer_provided_id and channel',
    solutions: 'Contact can be fetched either by unique_customer_provided_id or by channel',
    description:
      'Contact fetch request should contain unique_customer_provided_id or channel, not both',
    product: null,
    date_created: '2020-08-07T22:48:55Z',
    last_updated: '2020-08-07T22:48:55Z',
  },
  54251: {
    code: 54251,
    message: 'Invalid Message Stream Message data',
    log_level: 'ERROR',
    secondary_message: "The 'Data' parameter cannot be null.",
    log_type: null,
    docs: "\n## Error - 54251\n\n### Sync: Invalid Stream Message data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\n* Your request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.363Z',
  },
  50340: {
    code: 50340,
    message: 'Messaging service SID not provided',
    log_level: 'ERROR',
    secondary_message:
      'Messaging service SID parameter is required but was not provided with an API request.',
    log_type: null,
    docs: '\n## Error - 50340\n\n### Conversations: Messaging service SID not provided\nMessaging service SID parameter is required but was not provided with an API request.\n\n#### Possible Causes\n* The API expected a MessagingServiceSid input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid MessagingServiceSid parameter to the API request and confirm that it is not misspelled.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:22:28Z',
    last_updated: '2020-08-04T10:00:11.899Z',
  },
  53404: {
    code: 53404,
    message: 'No supported codec',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 53404\r\n\r\n### No supported codec\r\n\r\nRaised whenever the intersection of codecs supported by the Client and the Server (or, in peer-to-peer, the Client and another Participant) is empty.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:53:50Z',
    last_updated: '2020-08-04T10:00:08.058Z',
  },
  60229: {
    code: 60229,
    message: 'Template translation was not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60229\r\n\r\n### Template translation was not found\r\n\r\n ## Error - 60229\r\n\r\n### Invalid Parameter\r\n\r\nThe translation locale for the template was not found\r\n\r\n#### Possible Causes\r\nThe user has provide a translation for a templated that not exists\r\n\r\n#### Possible Solutions\r\nCreate a translation or use a existent translation for the template',
    causes: 'The user has provide a translation for a templated that not exists',
    solutions: 'Create a translation or use a existent translation for the template',
    description:
      '## Error - 60229\r\n\r\n### Invalid Parameter\r\n\r\nThe translation locale for the template was not found',
    product: 'Verify',
    date_created: '2022-08-30T18:46:38Z',
    last_updated: '2022-08-30T18:46:38Z',
  },
  25001: {
    code: 25001,
    message: 'The specified filter for listing organization users is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25001\r\n\r\n### The specified filter for listing organization users is invalid\r\n\r\n The specified filter for listing organization users is invalid.\r\n\r\n#### Possible Causes\r\nThe filter value is either unsupported or missing.\r\n\r\n#### Possible Solutions\r\nFiltering is only supported using the user\'s externalId or username. Only "eq" operator is supported. Ensure that the provided filter complies with these supported parameters.',
    causes: 'The filter value is either unsupported or missing.',
    solutions:
      'Filtering is only supported using the user\'s externalId or username. Only "eq" operator is supported. Ensure that the provided filter complies with these supported parameters.',
    description: 'The specified filter for listing organization users is invalid.',
    product: 'Organizations API',
    date_created: '2023-12-04T09:39:33Z',
    last_updated: '2023-12-04T14:07:27.373224Z',
  },
  16023: {
    code: 16023,
    message:
      "Dial->Conference: Invalid participant label, must not exceed 128 characters, must not be a CallSid, must not contain '/'",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 16023\r\n\r\n### Dial->Conference: Invalid participant label, must not exceed 128 characters, must not be a CallSid, must not contain '/'\r\n\r\n The participant label specified in an API call to create a voice conference participant was invalid. It may not exceed 128 characters, it may not be a CallSid, and it may not contain a ‘/’ (even in URL encoded form %2F).\r\n\r\n#### Possible Causes\r\nA POST to conference participants call to the Twilio API specified a participant label which is greater than 128 characters or which resembles a CallSid (“CA” followed by 32 lowercase hexadecimal characters), or contains the ‘/’ character or URL encoded ‘/’ character (%2F).\r\n\r\n#### Possible Solutions\r\nShorten the length of the ParticipantLabel parameter, avoid using a call SID and avoid including ‘/’ characters.",
    causes:
      'A POST to conference participants call to the Twilio API specified a participant label which is greater than 128 characters or which resembles a CallSid (“CA” followed by 32 lowercase hexadecimal characters), or contains the ‘/’ character or URL encoded ‘/’ character (%2F).',
    solutions:
      'Shorten the length of the ParticipantLabel parameter, avoid using a call SID and avoid including ‘/’ characters.',
    description:
      'The participant label specified in an API call to create a voice conference participant was invalid. It may not exceed 128 characters, it may not be a CallSid, and it may not contain a ‘/’ (even in URL encoded form %2F).',
    product: 'Programmable Voice',
    date_created: '2020-04-23T21:37:19Z',
    last_updated: '2020-08-04T10:00:03.879Z',
  },
  53620: {
    code: 53620,
    message: 'Invalid URL for external S3 bucket in composition settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53620\r\n\r\n### Invalid URL for external S3 bucket in composition settings\r\n\r\nThe S3 bucket URL configured in your account's composition settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, set a valid S3 URL for uploading media or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-11T14:35:17Z',
    last_updated: '2020-08-04T10:00:13.514Z',
  },
  21403: {
    code: 21403,
    message: 'Invalid Method',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to update the HTTP method that Twilio uses when somebody calls your phone number, but the <span class='rest-attribute'>Method</span> you supplied was not valid.  Valid <span class='rest-attribute'>Method</span> values are GET or POST.",
    log_type: null,
    docs: "## Error - 21403 \n\n### Invalid Method\n\nYou attempted to update the HTTP method that Twilio uses when somebody calls your phone number, but the <span class='rest-attribute'>Method</span> you supplied was not valid.  Valid <span class='rest-attribute'>Method</span> values are GET or POST.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:59Z',
    last_updated: '2020-08-04T10:00:27.028Z',
  },
  63105: {
    code: 63105,
    message: 'Channel does not support this action',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63105\r\n\r\n### Channel does not support this action\r\n\r\n Channel does not currently support the requested action\r\n\r\n#### Possible Causes\r\n- API Request for unsupported functionality on the given channel\r\n\r\n#### Possible Solutions\r\n- Open a support ticket to accomplish the desired action',
    causes: '- API Request for unsupported functionality on the given channel',
    solutions: '- Open a support ticket to accomplish the desired action',
    description: 'Channel does not currently support the requested action',
    product: 'Programmable Messaging',
    date_created: '2024-07-01T17:34:57Z',
    last_updated: '2024-07-01T17:34:57Z',
  },
  21253: {
    code: 21253,
    message: 'Max Connection Policies Reached',
    log_level: 'ERROR',
    secondary_message: 'An account cannot have more than 10000 Connection Policies.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21253\r\n\r\n### Max Connection Policies Reached\r\n\r\nAn account cannot have more than 10000 Connection Policies. \r\n\r\n#### Possible Causes\r\n* An account cannot have more than 10000 Connection Policies.\r\n\r\n#### Possible Solutions\r\n* Delete an existing Connection Policy if you must create more.',
    causes: '* An account cannot have more than 10000 Connection Policies.',
    solutions: '* Delete an existing Connection Policy if you must create more.',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2020-08-21T20:41:42Z',
    last_updated: '2020-08-21T20:41:42Z',
  },
  21473: {
    code: 21473,
    message:
      'AccountSid you are transferring to is not related to the originating owner of the phone number',
    log_level: 'ERROR',
    secondary_message:
      'The AccountSid you specified is neither parent nor child of the originating Account owner.  Please make sure that the subaccount or parent account is related to the current owner you are transferring from or to.',
    log_type: null,
    docs: '## Error - 21473\n\n### AccountSid you are transferring to is not related to the originating owner of the phone number\n\nThe AccountSid you specified is neither parent nor child of the originating Account owner.  Please make sure that the subaccount or parent account is related to the current owner you are transferring from or to.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:23Z',
    last_updated: '2020-08-04T10:00:25.329Z',
  },
  90030: {
    code: 90030,
    message: "Broadcast 'CorrelationId' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90030\r\n\r\n### Broadcast 'CorrelationId' is too long\r\n\r\n Broadcast 'CorrelationId' is too long\r\n\r\n#### Possible Causes\r\n'CorrelationId' field has too long length\r\n\r\n#### Possible Solutions\r\nUse shorter 'CorrelationId' valuer",
    causes: "'CorrelationId' field has too long length",
    solutions: "Use shorter 'CorrelationId' valuer",
    description: "Broadcast 'CorrelationId' is too long",
    product: null,
    date_created: '2020-12-11T13:20:18Z',
    last_updated: '2020-12-11T13:20:18Z',
  },
  53627: {
    code: 53627,
    message: 'Internal failure when updating the composition resource',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 53627\r\n\r\n### Internal failure when updating the composition resource\r\n\r\nRaised when an error prevented us from updating the resource tracking the media composition.\r\n\r\nThe media will not be accessible directly from Twilio until we remediate the situation but the composition media file has probably been stored safely to S3.\r\n\r\n#### Causes\r\n\r\n * An internal error prevented us from updating a resource. Sorry!\r\n\r\n#### Solutions\r\n\r\n*   Please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n*   Note the time of the error and what you were trying to do when it occurred!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-25T10:21:51Z',
    last_updated: '2020-08-04T10:00:13.362Z',
  },
  32208: {
    code: 32208,
    message: 'SIP: Secure media required',
    log_level: 'ERROR',
    secondary_message:
      'This secure SIP trunk cannot accept insecure media (RTP). Please use SRTP. See more on [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).',
    log_type: null,
    docs: '## Error - 32208\r\n\r\n###  SIP: Secure media required\r\n\r\n#### Possible Causes \r\n*    This secure SIP trunk cannot accept insecure media (RTP). \r\n\r\n#### Possible Solutions\r\n*  Please use SRTP. See more on [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:39Z',
    last_updated: '2020-08-04T10:00:24.118Z',
  },
  19022: {
    code: 19022,
    message: 'Invalid channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19022\r\n\r\n### Invalid channel\r\n\r\n Request with a channel that is not supported\r\n\r\n#### Possible Causes\r\nChannel other than: email, sms, voice, messenger, whatsapp\r\n\r\n#### Possible Solutions\r\nOnly email, sms, voice, messenger or whatsapp are valid channels',
    causes: 'Channel other than: email, sms, voice, messenger, whatsapp',
    solutions: 'Only email, sms, voice, messenger or whatsapp are valid channels',
    description: 'Request with a channel that is not supported',
    product: null,
    date_created: '2020-07-21T20:15:54Z',
    last_updated: '2020-08-04T10:00:01.745Z',
  },
  60246: {
    code: 60246,
    message: 'Service already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60246\r\n\r\n### Service already exists\r\n\r\n Service already exists\r\n\r\n#### Possible Causes\r\n* You tried to create a service with a UniqueName that already exists.\r\n\r\n#### Possible Solutions\r\n* Use a different UniqueName.',
    causes: '* You tried to create a service with a UniqueName that already exists.',
    solutions: '* Use a different UniqueName.',
    description: 'Service already exists',
    product: 'Verify',
    date_created: '2024-06-11T14:08:57Z',
    last_updated: '2024-06-26T14:37:13.441624Z',
  },
  45362: {
    code: 45362,
    message: 'Failed to remove Participant.  Not found.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45362\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'The Participant may have already been removed.',
    solutions: 'No Action.\r',
    description:
      'Failed to remove Participant <participant sid> from Channel <channel sid> because the Participant was not found.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:40.363138Z',
  },
  14213: {
    code: 14213,
    message: 'Dial->Queue: queue name too long',
    log_level: 'ERROR',
    secondary_message: 'The name of the queue must be shorter than 64 characters.',
    log_type: null,
    docs: '## Error - 14213 \n\n### Dial->Queue: queue name too long\n\nThe name of the queue must be shorter than 64 characters.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:12Z',
    last_updated: '2020-08-04T10:00:26.148Z',
  },
  21478: {
    code: 21478,
    message: 'Unable to update Status for subaccount, subaccount has been suspended by Twilio',
    log_level: 'ERROR',
    secondary_message:
      'Unable to update Status for subaccounts that have been suspended externally by Twilio.  Please contact customer support: http://www.twilio.com/help',
    log_type: null,
    docs: '## Error - 21478\n\n### Unable to update Status for subaccount, subaccount has been suspended by Twilio\n\nUnable to update Status for subaccounts that have been suspended externally by Twilio.  Please contact customer support: http://www.twilio.com/help\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:24Z',
    last_updated: '2020-08-04T10:00:25.219Z',
  },
  60614: {
    code: 60614,
    message: 'Lookup Request Must Be Completed in Different Twilio Region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60614\r\n\r\n### Lookup Request Must Be Completed in Different Twilio Region\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received but failed due to the Lookup request not being supported by the selected Twilio Region due to data residency requirements. This can happen when a request for an EU or GB phone number is made outside of the IE1 Region. Learn more at [Twilio Regions](https://www.twilio.com/docs/global-infrastructure/understanding-twilio-regions) and [Using Lookup with Twilio Regions](https://www.twilio.com/docs/lookup/using-lookup-with-twilio-regions).\r\n\r\n#### Possible Solutions\r\n- Confirm that the request is selecting the expected Region.\r\n- Confirm that the request is using an API key generated for the expected Region.',
    causes:
      'The request was received but failed due to the Lookup request not being supported by the selected Twilio Region due to data residency requirements. This can happen when a request for an EU or GB phone number is made outside of the IE1 Region. Learn more at [Twilio Regions](https://www.twilio.com/docs/global-infrastructure/understanding-twilio-regions) and [Using Lookup with Twilio Regions](https://www.twilio.com/docs/lookup/using-lookup-with-twilio-regions).',
    solutions:
      '- Confirm that the request is selecting the expected Region.\r\n- Confirm that the request is using an API key generated for the expected Region.',
    description:
      'Lookup package requested is not supported in your Twilio Region.\r\n\r\n[Learn more about Twilio Regions here](https://www.twilio.com/docs/global-infrastructure/understanding-twilio-regions).',
    product: 'Lookup',
    date_created: '2022-01-13T20:43:17Z',
    last_updated: '2023-01-06T00:29:29.268972Z',
  },
  31209: {
    code: 31209,
    message: 'Call Message Event Payload size exceeded authorized limit.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31209\r\n\r\n### Call Message Event Payload size exceeded authorized limit.\r\n\r\n Call Message Event Payload size exceeded authorized limit.\r\n\r\n#### Possible Causes\r\nThe payload size of Call Message Event exceeds the authorized limit.\r\n\r\n#### Possible Solutions\r\nReduce payload size of Call Message Event to be within the authorized limit and try again.',
    causes: 'The payload size of Call Message Event exceeds the authorized limit.',
    solutions:
      'Reduce payload size of Call Message Event to be within the authorized limit and try again.',
    description: 'Call Message Event Payload size exceeded authorized limit.',
    product: 'Programmable Voice',
    date_created: '2022-11-07T23:45:21Z',
    last_updated: '2022-11-07T23:45:21Z',
  },
  53215: {
    code: 53215,
    message: 'Invalid Subscribe Rule(s)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53215\r\n\r\n### Invalid Subscribe Rule(s)\r\n\r\n Raised by the server when a Subscribe Rule is invalid.\r\n\r\n#### Possible Causes\r\n- An empty set of rules `[]` is not allowed\r\n- A rule containing `all` must have a value of `true` and must not contain any other expression.\r\n- A rule must contain a `type` field.\r\n- If `kind` is used, it must be one of `audio`, `video` or `data`.\r\n- A maximum of 20 rules are allowed per subscriber.\r\n\r\n#### Possible Solutions\r\n- Ensure the set of rules has at least one rule.\r\n- If you include `all` in a rule, the only other allowed field is `type`.\r\n- Ensure every rule has a `type` field.\r\n- Ensure `kind` is one of the valid enum values.\r\n- Limit the number of rules to 20 or fewer.',
    causes:
      '- An empty set of rules `[]` is not allowed\r\n- A rule containing `all` must have a value of `true` and must not contain any other expression.\r\n- A rule must contain a `type` field.\r\n- If `kind` is used, it must be one of `audio`, `video` or `data`.\r\n- A maximum of 20 rules are allowed per subscriber.',
    solutions:
      '- Ensure the set of rules has at least one rule.\r\n- If you include `all` in a rule, the only other allowed field is `type`.\r\n- Ensure every rule has a `type` field.\r\n- Ensure `kind` is one of the valid enum values.\r\n- Limit the number of rules to 20 or fewer.',
    description: 'Raised by the server when a Subscribe Rule is invalid.',
    product: 'Programmable Video',
    date_created: '2019-05-07T22:18:42Z',
    last_updated: '2022-08-03T07:35:32.898328Z',
  },
  50377: {
    code: 50377,
    message: "Can't update conversation as it's in final closed state",
    log_level: 'ERROR',
    secondary_message: "Conversation is in closed state and can't be used anymore",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50377\r\n\r\n### Can't update conversation as it's in final closed state\r\n\r\nConversation is in closed state and can't be used anymore Conversation state is 'closed' so it can't be used for chatting anymore.\r\n\r\n#### Possible Causes\r\n* Conversation state is set manually or by timer to 'closed' which means that conversation can't be updated anymore.\r\n\r\n#### Possible Solutions\r\n* Create new conversation in 'active' state without 'TimeToClosed' or with some big duration to avoid unexpected movement to 'closed' state.",
    causes:
      "* Conversation state is set manually or by timer to 'closed' which means that conversation can't be updated anymore.",
    solutions:
      "* Create new conversation in 'active' state without 'TimeToClosed' or with some big duration to avoid unexpected movement to 'closed' state.",
    description: "Conversation state is 'closed' so it can't be used for chatting anymore.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:23:02Z',
    last_updated: '2020-09-24T12:23:17.511Z',
  },
  52103: {
    code: 52103,
    message: 'GCM/FCM client uninstalled or turned off notifications',
    log_level: 'ERROR',
    secondary_message: 'GCM/FCM service marked used registration id as unusable anymore',
    log_type: null,
    docs: '## Error - 52103\r\n\r\n### GCM/FCM client uninstalled or turned off notifications\r\n\r\n#### Possible Causes \r\n*  GCM/FCM client application was uninstalled or the user turned off push notifications.\r\n\r\n#### Possible Solutions\r\n*  No action needed. We have disabled the registration token and we will not send new notifications to it.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:25:08Z',
    last_updated: '2020-08-04T10:00:22.362Z',
  },
  32219: {
    code: 32219,
    message: 'SIP: Redirect failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32219\r\n\r\n### SIP: Redirect failed\r\n\r\n Twilio could not process the SIP 30x response from your SIP server.\r\n\r\n\r\n#### Possible Causes\r\n*    Max redirect limit reached.\r\n*    Redirection is not allowed in the call to the registered SIP endpoint.\r\n*    Redirect target in the Contact header of the SIP 30x response is not a valid SIP URI.\r\n*    Redirect target is a private IP address.\r\n*    Redirect target is a Twilio domain such as \\*.sip.twilio.com or \\*.pstn.twilio.com.\r\n*    Redirect target is an IP in a deny list.\r\n\r\n#### Possible Solutions\r\nReview the Possible Causes and update the redirect target as needed.',
    causes:
      '*    Max redirect limit reached.\r\n*    Redirection is not allowed in the call to the registered SIP endpoint.\r\n*    Redirect target in the Contact header of the SIP 30x response is not a valid SIP URI.\r\n*    Redirect target is a private IP address.\r\n*    Redirect target is a Twilio domain such as \\*.sip.twilio.com or \\*.pstn.twilio.com.\r\n*    Redirect target is an IP in a deny list.',
    solutions: 'Review the Possible Causes and update the redirect target as needed.',
    description: 'Twilio could not process the SIP 30x response from your SIP server.\r\n',
    product: 'Elastic SIP Trunking',
    date_created: '2019-03-12T20:46:41Z',
    last_updated: '2023-11-01T19:33:07.461915Z',
  },
  30016: {
    code: 30016,
    message: "'To' and 'From' channel types are incompatible",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "## Error - 30016\r\n\r\n### 'To' and 'From' channel types are incompatible\r\n\r\nThe To or From attributes have channel prefixes what are incompatible\r\n\r\n#### Possible Causes \r\n*  Attempt to send a message to one channel but use 'From' address for another channel\r\n\r\n#### Possible Solutions\r\n*  Check the To and From attributes channel prefixes",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-02-07T13:07:42Z',
    last_updated: '2020-08-04T10:00:10.691Z',
  },
  50506: {
    code: 50506,
    message: 'Programmable Chat: Media SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Media SID parameter.',
    log_type: null,
    docs: '## Error - 50506\r\n\r\n### Programmable Chat: Media SID not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Media SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Media SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:27:32Z',
    last_updated: '2020-08-04T10:00:16.468Z',
  },
  20422: {
    code: 20422,
    message: 'Invalid Parameter',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20422\r\n\r\n### Invalid Parameter\r\n\r\nThe request contained malformed or semantically incorrect parameters.\r\n\r\nCommon occurrences:\r\n\r\n* Lacking a specified `Content-Type` header field\r\n* Invalid or missing XML data\r\n* Invalid parameter type or value\r\n\r\n#### Is the request safe to retry?\r\n\r\nA 422 request is never processed and is always safe to retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-30T16:11:48Z',
    last_updated: '2020-08-04T10:00:10.994Z',
  },
  53204: {
    code: 53204,
    message: 'Participant not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53204: Participant not found\r\n\r\nRaised whenever attempting operation on a non-existent Participant.\r\n\r\n#### Causes\r\n\r\n * Attempting operation on an non-existent Participant.\r\n\r\n#### Solutions\r\n\r\n * Make sure participant exists before re-attempting operation.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:49:31Z',
    last_updated: '2020-08-04T10:00:19.403Z',
  },
  50101: {
    code: 50101,
    message: 'Programmable Chat: Channel role not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Channel Role does not exist.',
    log_type: null,
    docs: '## Error - 50101\r\n\r\n### Programmable Chat: Channel role not found\r\n\r\n#### Possible Causes \r\n*  Specified Channel Role does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel Role is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:46Z',
    last_updated: '2020-08-04T10:00:23.481Z',
  },
  13805: {
    code: 13805,
    message: 'Trial account call duration exceeded 10 minute limit',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13805\r\n\r\n### Trial account call duration exceeded 10 minute limit\r\n\r\n Trial account call duration exceeded 10 minute limit\r\n\r\n#### Possible Causes\r\nAccount is a trial account\r\n\r\n#### Possible Solutions\r\nUpgrade trial account',
    causes: 'Account is a trial account',
    solutions: 'Upgrade trial account',
    description: 'Trial account call duration exceeded 10 minute limit',
    product: 'Programmable Voice',
    date_created: '2021-03-09T18:16:22Z',
    last_updated: '2021-03-11T18:00:45.822Z',
  },
  91101: {
    code: 91101,
    message: 'Subscription could not be created',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91101\r\n\r\n### Subscription could not be created\r\n\r\n Subscription creation failed\r\n\r\n#### Possible Causes\r\n* Event types are duplicated\r\n* Description is empty\r\n\r\n#### Possible Solutions\r\n* Ensure event types are not duplicated\r\n* Description is not empty',
    causes: '* Event types are duplicated\r\n* Description is empty',
    solutions: '* Ensure event types are not duplicated\r\n* Description is not empty',
    description: 'Subscription creation failed',
    product: 'Events',
    date_created: '2020-09-16T14:38:18Z',
    last_updated: '2021-01-06T16:34:11.059Z',
  },
  95110: {
    code: 95110,
    message: 'Failed to download media: file was not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95110\r\n\r\n### Failed to download media: file was not found\r\n\r\n Failed to download media file was not found\r\n\r\n#### Possible Causes\r\nMedia file was deleted.\r\nMisspelled URL.\r\n\r\n#### Possible Solutions\r\nVerify the media file was not deleted and the URL is correct.',
    causes: 'Media file was deleted.\r\nMisspelled URL.',
    solutions: 'Verify the media file was not deleted and the URL is correct.',
    description: 'Failed to download media file was not found',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:35:23Z',
    last_updated: '2024-06-12T17:46:27.226867Z',
  },
  18036: {
    code: 18036,
    message: 'One or more of the required information is missing.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18036\r\n\r\n### One or more of the required information is missing.\r\n\r\n One or more of the following required information is missing: Birth Date, Birth Place, Tax Number, Document Number, Issue Date.\r\n\r\n#### Possible Causes\r\nYou may have missed to input the required information.\r\n\r\n#### Possible Solutions\r\nPlease fill out the required fields in the form.',
    causes: 'You may have missed to input the required information.',
    solutions: 'Please fill out the required fields in the form.',
    description:
      'One or more of the following required information is missing: Birth Date, Birth Place, Tax Number, Document Number, Issue Date.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:50:05Z',
    last_updated: '2024-07-04T09:50:05Z',
  },
  60624: {
    code: 60624,
    message: 'Maximum rate limit for Trial Accounts',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60624\r\n\r\n### Maximum rate limit for Trial Accounts\r\n\r\n The account has reached the maximum rate limit for Trial Accounts.\r\n\r\n#### Possible Causes\r\nThe error message indicates either excessive usage within a short period or exceeding the established request limit\r\n\r\n#### Possible Solutions\r\nA possible solution to mitigate this issue is to transition to a paid account that offers higher rate limits and unrestricted access to the services.',
    causes:
      'The error message indicates either excessive usage within a short period or exceeding the established request limit',
    solutions:
      'A possible solution to mitigate this issue is to transition to a paid account that offers higher rate limits and unrestricted access to the services.',
    description: 'The account has reached the maximum rate limit for Trial Accounts.',
    product: 'Lookup',
    date_created: '2024-05-21T15:57:11Z',
    last_updated: '2024-05-21T15:57:11Z',
  },
  18608: {
    code: 18608,
    message: 'Customer Profile or Trust Product is already copied',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18608\r\n\r\n### Customer Profile or Trust Product is already copied\r\n\r\n You already copied the customer profile or trust product\r\n\r\n#### Possible Causes\r\nYou already copied.\r\n\r\n#### Possible Solutions\r\nSince the customer profile or trust product is already copied, please move forward without any additional action',
    causes: 'You already copied.',
    solutions:
      'Since the customer profile or trust product is already copied, please move forward without any additional action',
    description: 'You already copied the customer profile or trust product',
    product: 'Phone Numbers',
    date_created: '2024-02-27T02:29:42Z',
    last_updated: '2024-02-27T02:29:42Z',
  },
  45374: {
    code: 45374,
    message: 'Failed to delete Channel.  Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45374\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'We failed to delete a Channel due to an unexpected error condition.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to delete Channel <channel sid> due to an internal error.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:13.157029Z',
  },
  57009: {
    code: 57009,
    message: "'EventType' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57009\r\n\r\n### 'EventType' is too long\r\n\r\n Specified 'EventType' is too long\r\n\r\n#### Possible Causes\r\nSpecified 'EventType' is too long\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'EventType' is being passed in request.",
    causes: "Specified 'EventType' is too long",
    solutions: "Confirm a valid 'EventType' is being passed in request.",
    description: "Specified 'EventType' is too long",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:57:15Z',
    last_updated: '2021-05-07T08:57:15Z',
  },
  20105: {
    code: 20105,
    message: 'Access Token not yet valid',
    log_level: 'ERROR',
    secondary_message: 'Access Token not yet valid',
    log_type: null,
    docs: "# Error - 20105\r\n\r\n## Access Token not yet valid\r\n\r\nThe Access Token provided to the Twilio API is not yet valid.\r\n\r\nTwilio Access Tokens are generated with a `nbf` field that determines the\r\nstart of the token's lifetime. Normally this is set to the current time\r\nwhen the token is generated; check whether your computer's clock has drifted.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation and the\r\nrequirements of the issuer and subject fields, see [the\r\ndocumentation](/docs/api/rest/access-tokens).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T06:57:16Z',
    last_updated: '2020-08-04T10:00:22.702Z',
  },
  21248: {
    code: 21248,
    message: 'Trunk Domain already taken',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21248\r\n\r\n### Trunk Domain already taken\r\n\r\n \r\n\r\n#### Possible Causes\r\n*   This Termination URI (Domain) is not available.\r\n\r\n#### Possible Solutions\r\n*  Please review your Termination URI (Domain name) and select a different one.',
    causes: '*   This Termination URI (Domain) is not available.',
    solutions: '*  Please review your Termination URI (Domain name) and select a different one.',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:08:25Z',
    last_updated: '2020-08-04T10:00:20.106Z',
  },
  60005: {
    code: 60005,
    message: 'Downstream Carrier Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60005\r\n\r\n### Downstream Carrier Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received but failed during processing due to an error while communicating with the carrier.\r\n\r\n#### Possible Solutions\r\n- Retry request to rule out transient carrier connection issues. \r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    causes:
      'The request was received but failed during processing due to an error while communicating with the carrier.',
    solutions:
      '- Retry request to rule out transient carrier connection issues. \r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    description: null,
    product: null,
    date_created: '2022-09-06T13:13:51.90861Z',
    last_updated: '2022-09-06T13:13:51.908619Z',
  },
  53621: {
    code: 53621,
    message: 'Invalid AWS credentials to access external S3 bucket in composition settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53621\r\n\r\n### Invalid AWS credentials to access external S3 bucket in composition settings\r\n\r\nThe AWS credentials configured in your account's composition settings are not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the AWS Access Key ID and Secret Access Key are not correct.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, set some valid credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-11T14:36:28Z',
    last_updated: '2020-08-04T10:00:13.496Z',
  },
  50332: {
    code: 50332,
    message: 'Programmable Chat: Channel webhook url too long',
    log_level: 'ERROR',
    secondary_message: 'Channel webhook url provided in request is too long',
    log_type: null,
    docs: '## Error - 50332\r\n\r\n### Programmable Chat: Channel webhook url too long\r\n\r\n#### Possible Causes \r\n*  Channel webhook url provided in request is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:18:32Z',
    last_updated: '2020-08-04T10:00:11.917Z',
  },
  30022: {
    code: 30022,
    message: 'US A2P 10DLC - Rate Limits Exceeded',
    log_level: 'ERROR',
    secondary_message:
      'Your messages to this particular carrier has exceeded the maximum allowable limits for your phone number and/or campaign.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30022\r\n\r\n### US A2P 10DLC - Rate Limits Exceeded\r\n\r\nYour messages to this particular carrier has exceeded the maximum allowable limits for your phone number and/or campaign. * Your message was rejected by the downstream carriers for exceeding the rate limits allowed by your campaign.\r\n* Rarely, you may receive this error for sending too many messages to the same phone number in a short time frame.\r\n\r\n#### Possible Causes\r\n* You are sending messages at a rate higher than allowed by the carriers for your campaign type.\r\n* You might be sending too many messages to the same phone number in a short timeframe.\r\n\r\n#### Possible Solutions\r\n* Slow down your rate of message sending.',
    causes:
      '* You are sending messages at a rate higher than allowed by the carriers for your campaign type.\r\n* You might be sending too many messages to the same phone number in a short timeframe.',
    solutions: '* Slow down your rate of message sending.',
    description:
      '* Your message was rejected by the downstream carriers for exceeding the rate limits allowed by your campaign.\r\n* Rarely, you may receive this error for sending too many messages to the same phone number in a short time frame.',
    product: 'Programmable SMS',
    date_created: '2021-03-08T21:07:12Z',
    last_updated: '2021-03-08T21:09:03.522Z',
  },
  80306: {
    code: 80306,
    message: 'Not Found Chat Service',
    log_level: 'ERROR',
    secondary_message: 'Found no chat instance associated with service {ProxyServiceSid}',
    log_type: null,
    docs: '## Warning\r\n\r\n### Not Found Chat Service\r\n\r\nFound no chat instance associated with service {ProxyServiceSid}',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-09-25T20:45:28Z',
    last_updated: '2020-08-04T10:00:12.59Z',
  },
  50393: {
    code: 50393,
    message: "Type value should be 'private'.",
    log_level: 'ERROR',
    secondary_message:
      "Type parameter value is required and should be 'private'. Migration to 'public' type is not allowed.",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50393\r\n\r\n### Type value should be 'private'.\r\n\r\nType parameter value is required and should be 'private'. Migration to 'public' type is not allowed. \r\n\r\n#### Possible Causes\r\n*  No Type parameter provided\r\n*  Provided Type parameter not equal to 'private'\r\n\r\n#### Possible Solutions\r\n* Change Type parameter to 'private'",
    causes: "*  No Type parameter provided\r\n*  Provided Type parameter not equal to 'private'",
    solutions: "* Change Type parameter to 'private'",
    description: null,
    product: 'Programmable Chat',
    date_created: '2022-03-08T16:40:13Z',
    last_updated: '2022-03-08T16:40:13Z',
  },
  21218: {
    code: 21218,
    message: 'Invalid ApplicationSid',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call with an invalid ApplicationSid. The application may not exist anymore or may not be available within your account.',
    log_type: null,
    docs: '## Error - 21218\n\n### Invalid ApplicationSid\n\nYou attempted to initiate an outbound phone call with an invalid ApplicationSid.\nThe application may not exist anymore or may not be available within your\naccount.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:16Z',
    last_updated: '2020-08-04T10:00:25.804Z',
  },
  16022: {
    code: 16022,
    message: 'Conference does not exist or is completed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16022\r\n\r\n### Conference does not exist or is completed\r\n\r\nThe requested conference sid or friendly name refers to a non-existent or completed conference.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:22:31Z',
    last_updated: '2020-08-04T10:00:10.02Z',
  },
  20404: {
    code: 20404,
    message: 'Not Found',
    log_level: 'ERROR',
    secondary_message: 'The resource was not found.',
    log_type: null,
    docs: '## Not Found\r\n\r\nThe resource was not found. Here are some examples of cases that may trigger\r\na 404 error.\r\n\r\n- Requesting a resource for a sid that does not exist, for example\r\n\r\n        GET /2010-04-01/Accounts/AC123/Calls/CA123\r\n\r\n    where CA123 is not a call sid that exists for your account\r\n\r\n- Trying to retrieve a resource that doesn\'t exist, for example\r\n\r\n        GET /2010-04-01/Accounts/AC123/TwilioCalls/CA123\r\n\r\n    where the resource name is Calls, not TwilioCalls. Note that the API is\r\n    case sensitive, so requesting "calls" instead of "Calls" will also return a\r\n    404.\r\n\r\n- Missing a sid in the request path. For example, let\'s say I accidentally\r\ndon\'t set a value for a call sid, using the PHP helper library:\r\n\r\n        $callSid = null;\r\n        $client->account->calls->get($callSid);\r\n\r\n    This may turn into\r\n\r\n        GET /2010-04-01/Accounts/AC123/Calls/.json\r\n\r\n    because of the nonexistent sid, which may 404 your request or give you back\r\n    a result you were not expecting. Or, you may initialize the client with an\r\n    empty string for an account sid, which means the URL will get truncated in\r\n    the middle (note the consecutive slashes):\r\n\r\n        GET /2010-04-01/Accounts//Calls/CA123.json\r\n\r\n- Using a base URL that is not `https://api.twilio.com`. For example, making\r\n  requests to `https://twilio.com` or `https://www.twilio.com` will not work.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-03T21:16:28Z',
    last_updated: '2020-08-04T10:00:19.179Z',
  },
  52402: {
    code: 52402,
    message: 'General rendering problem with variables in a parsed template',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 52402\r\n\r\n### General rendering problem with variables in a parsed template\r\n\r\n The error pertains to a general rendering issue with variables in an successfully parsed template.\r\n\r\n#### Possible Causes\r\nVarious limitations such as reaching the maximum allowed template size of 6400 bytes or encountering a rendering timeout of 3000 milliseconds might contribute to this error.\r\n\r\n#### Possible Solutions\r\nTo pinpoint the underlying cause, customers should inspect the debugger logs in the console for further details.',
    causes:
      'Various limitations such as reaching the maximum allowed template size of 6400 bytes or encountering a rendering timeout of 3000 milliseconds might contribute to this error.',
    solutions:
      'To pinpoint the underlying cause, customers should inspect the debugger logs in the console for further details.',
    description:
      'The error pertains to a general rendering issue with variables in an successfully parsed template.',
    product: 'Notify',
    date_created: '2024-03-19T15:54:43Z',
    last_updated: '2024-03-19T15:54:43Z',
  },
  20021: {
    code: 20021,
    message: 'Phone number rejected by T-Mobile SDG Service Provisioning API',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 20021\r\n\r\n### Phone number rejected by T-Mobile SDG Service Provisioning API\r\n\r\n Exception received while creating application address in SDG Service Provisioning API: Invalid short code And enum server status is: FAILURE\r\n\r\n#### Possible Causes\r\n* The phone number was rejected by T-Mobile SDG Service Provisioning API\r\n\r\n#### Possible Solutions\r\n* Check the phone number',
    causes: '* The phone number was rejected by T-Mobile SDG Service Provisioning API',
    solutions: '* Check the phone number',
    description:
      'Exception received while creating application address in SDG Service Provisioning API: Invalid short code And enum server status is: FAILURE',
    product: null,
    date_created: '2020-10-13T22:02:21Z',
    last_updated: '2020-10-13T22:02:21Z',
  },
  40135: {
    code: 40135,
    message: 'TaskRouter->Dequeue',
    log_level: 'ERROR',
    secondary_message: 'Dequeue Instruction can only be issued on a currently pending reservation.',
    log_type: null,
    docs: '## Error - 40135\r\n\r\n### The Reservation must currently be Pending - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-08-22T23:02:11Z',
    last_updated: '2020-08-04T10:00:21.265Z',
  },
  30100: {
    code: 30100,
    message: 'Domain SID is invalid',
    log_level: 'ERROR',
    secondary_message:
      'The Domain SID included in your request is not a valid Domain for your Twilio Organization.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 30100\r\n\r\n### Domain SID is invalid\r\n\r\nThe Domain SID included in your request is not a valid Domain for your Twilio Organization. The Domain SID included in your request is not a valid Domain for your Twilio Organization.\r\n\r\n#### Possible Causes\r\nThe Domain SID you're using could belong to another Organization. It could also potentially be an issue of copy and pasting. You may be providing a URL instead of a Domain SID in the Domain SID field.\r\n\r\n#### Possible Solutions\r\nCheck the Domain SID from your Organization through the Admin Center.",
    causes:
      "The Domain SID you're using could belong to another Organization. It could also potentially be an issue of copy and pasting. You may be providing a URL instead of a Domain SID in the Domain SID field.",
    solutions: 'Check the Domain SID from your Organization through the Admin Center.',
    description:
      'The Domain SID included in your request is not a valid Domain for your Twilio Organization.',
    product: 'Programmable SMS',
    date_created: '2020-04-22T20:23:16Z',
    last_updated: '2023-05-22T19:49:50.88115Z',
  },
  90027: {
    code: 90027,
    message: "Broadcast 'FriendlyName' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90027\r\n\r\n### Broadcast 'FriendlyName' is too long\r\n\r\n Broadcast 'FriendlyName' is too long\r\n\r\n#### Possible Causes\r\n'FriendlyName' field has too long length\r\n\r\n#### Possible Solutions\r\nUse shorter string as Broadcast 'FriendlyName'",
    causes: "'FriendlyName' field has too long length",
    solutions: "Use shorter string as Broadcast 'FriendlyName'",
    description: "Broadcast 'FriendlyName' is too long",
    product: null,
    date_created: '2020-12-11T13:13:55Z',
    last_updated: '2020-12-11T13:13:55Z',
  },
  30002: {
    code: 30002,
    message: 'Account suspended',
    log_level: 'ERROR',
    secondary_message:
      'Your account was suspended between the time of message send and delivery. Please contact Twilio.',
    log_type: 'TWILIO',
    docs: '## ERROR - 30002\r\n\r\n### Account suspended\r\n\r\nYour account was suspended between the time of message send and delivery. Please contact Twilio. This message failed because your account was suspended after this message was queued but before it was sent by Twilio.\r\n\r\n\r\n#### Possible Causes\r\n*  Account was suspended for lack of funds after your message was queued but before it was sent by Twilio.\r\n* Account was suspended because Twilio detected a violation of our Acceptable Use Policy. \r\n\r\n\r\n#### Possible Solutions\r\n*  Please [contact Twilio support](https://www.twilio.com/console/support/tickets/create).\r\n',
    causes:
      '*  Account was suspended for lack of funds after your message was queued but before it was sent by Twilio.\r\n* Account was suspended because Twilio detected a violation of our Acceptable Use Policy. \r\n',
    solutions:
      '*  Please [contact Twilio support](https://www.twilio.com/console/support/tickets/create).\r\n',
    description:
      'This message failed because your account was suspended after this message was queued but before it was sent by Twilio.\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:33Z',
    last_updated: '2020-08-04T10:00:24.605Z',
  },
  81027: {
    code: 81027,
    message: 'Error parsing type in Studio widget',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 81027\r\n\r\n### Error parsing type in Studio widget\r\n\r\n An error occurred when Studio attempted to parse a type in a widget\r\n\r\n#### Possible Causes\r\n* Tried to convert a variable to an incompatible type (e.g. "foo" to JSON Object type)\r\n* The provided JSON string is not valid\r\n\r\n#### Possible Solutions\r\n* Verify the runtime data of your flow execution by checking the Flow Data and inspecting any variables you may have referenced\r\n* Ensure that the configured type matches the variable data.',
    causes:
      '* Tried to convert a variable to an incompatible type (e.g. "foo" to JSON Object type)\r\n* The provided JSON string is not valid',
    solutions:
      '* Verify the runtime data of your flow execution by checking the Flow Data and inspecting any variables you may have referenced\r\n* Ensure that the configured type matches the variable data.',
    description: 'An error occurred when Studio attempted to parse a type in a widget',
    product: 'Studio',
    date_created: '2024-05-28T18:58:37Z',
    last_updated: '2024-05-28T18:58:37Z',
  },
  64010: {
    code: 64010,
    message: 'Pay: Payment Gateway rejected token creation.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 64010\r\n\r\n### Pay: Payment Gateway rejected token creation.\r\n\r\nA 64010 Error is an indication that the request to create token was rejected by the Payment Gateway. \r\n\r\n#### Possible Solutions\r\n* Please see the data returned in the with webhook to action url for more details.  \r\n* Reach out to your Payment Gateway support for more assistance.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-02-26T22:04:37Z',
    last_updated: '2020-08-04T10:00:10.208Z',
  },
  63047: {
    code: 63047,
    message: 'Link to a sample media file returned an invalid Content-Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63047\r\n\r\n### Link to a sample media file returned an invalid Content-Type\r\n\r\n The link to the media file does not have a Content-Type header set to an accepted MIME type. As a result, the template was not created.\r\n\r\n#### Possible Causes\r\n- The web server hosting the media file is not sending Content-Type headers\r\n- The web server hosting the media file is sending an invalid Content-Type header\r\n\r\n#### Possible Solutions\r\n- Make sure the web server hosting the sample file returns either `image/jpeg`, `image/png`, `application/pdf`, or `video/mp4` for the `Content-Type` header.',
    causes:
      '- The web server hosting the media file is not sending Content-Type headers\r\n- The web server hosting the media file is sending an invalid Content-Type header',
    solutions:
      '- Make sure the web server hosting the sample file returns either `image/jpeg`, `image/png`, `application/pdf`, or `video/mp4` for the `Content-Type` header.',
    description:
      'The link to the media file does not have a Content-Type header set to an accepted MIME type. As a result, the template was not created.',
    product: 'Programmable Messaging',
    date_created: '2023-04-03T17:12:35Z',
    last_updated: '2023-04-03T17:12:35Z',
  },
  16025: {
    code: 16025,
    message: 'Dial->Conference: Participant label is in use by another participant',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16025\r\n\r\n### Dial->Conference: Participant label is in use by another participant\r\n\r\n The participant label specified as an attribute on the conference noun in twiml is already in use by another active participant in the same conference.\r\n\r\n#### Possible Causes\r\n1. The same static twiml specifying a participant label was served to two difference calls\r\n2. Dynamically generated twiml specified the same participant label for two different calls\r\n3. The participant label specified in the twiml Is the same as one specified for an outbound participant that was already added to the conference using the Twilio API \r\n\r\n#### Possible Solutions\r\nUse a label value which uniquely identifies this participant within the conference',
    causes:
      '1. The same static twiml specifying a participant label was served to two difference calls\r\n2. Dynamically generated twiml specified the same participant label for two different calls\r\n3. The participant label specified in the twiml Is the same as one specified for an outbound participant that was already added to the conference using the Twilio API ',
    solutions: 'Use a label value which uniquely identifies this participant within the conference',
    description:
      'The participant label specified as an attribute on the conference noun in twiml is already in use by another active participant in the same conference.',
    product: 'Programmable Voice',
    date_created: '2020-04-23T21:40:32Z',
    last_updated: '2020-08-04T10:00:03.821Z',
  },
  60375: {
    code: 60375,
    message: 'Invalid id',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60375\r\n\r\n### Invalid id\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe ID in the request is incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the ID in the request body is correct.',
    causes: 'The ID in the request is incorrectly formatted.',
    solutions: 'Check that the ID in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:36:59Z',
    last_updated: '2023-12-27T09:36:59Z',
  },
  30473: {
    code: 30473,
    message: 'Toll Free verification rejection - Cannot validate business website URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30473\r\n\r\n### Toll Free verification rejection - Cannot validate business website URL\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the business website submitted is not accessible or available. The business website URL must pertain to the website the consumer is engaging with. In any of the following cases, the business website won’t be reviewable:\r\n* The business website does not load or is not operational\r\n* The business website is in a private state that requires a login/password\r\n\r\n#### Possible Solutions\r\n* Check the business website URL in the submission is correct and resubmit if it’s incorrect\r\n* Check that the business website URL is a live website. Resubmit once it is live. \r\n* Make sure that the business website URL is not in a private state that requires a login/password.. Resubmit after it is corrected.\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the business website submitted is not accessible or available. The business website URL must pertain to the website the consumer is engaging with. In any of the following cases, the business website won’t be reviewable:\r\n* The business website does not load or is not operational\r\n* The business website is in a private state that requires a login/password',
    solutions:
      '* Check the business website URL in the submission is correct and resubmit if it’s incorrect\r\n* Check that the business website URL is a live website. Resubmit once it is live. \r\n* Make sure that the business website URL is not in a private state that requires a login/password.. Resubmit after it is corrected.\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:43:57Z',
    last_updated: '2024-02-22T21:43:57Z',
  },
  80606: {
    code: 80606,
    message: 'Proxy Identifier Not Owned By Account',
    log_level: 'WARNING',
    secondary_message: 'Proxy identifier not owned by account.',
    log_type: null,
    docs: '## Warning\n\n### Proxy Identifier Not Owned By Account\n\nExample Message: Proxy identifier not owned by account.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.77Z',
  },
  14204: {
    code: 14204,
    message: 'Enqueue: Queue name too short',
    log_level: 'ERROR',
    secondary_message: 'The queue name must be at least one character long.',
    log_type: null,
    docs: '## Error - 14204\n\n### Enqueue: Queue name too short\n\nThe queue name must be at least one character long.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:10Z',
    last_updated: '2020-08-04T10:00:26.293Z',
  },
  53617: {
    code: 53617,
    message: 'Internal failure when bulk deleting compositions from your account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53617\r\n\r\n### Internal failure when bulk deleting compositions from your account\r\n\r\n Despite our best efforts, we have failed to delete some or all of the selected compositions. The operation has been cancelled.\r\n\r\n#### Possible Causes\r\nThere was an internal failure when processing your request. This action will not be retried.\r\n\r\n#### Possible Solutions\r\n* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the compositions.',
    causes:
      'There was an internal failure when processing your request. This action will not be retried.',
    solutions:
      '* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the compositions.',
    description:
      'Despite our best efforts, we have failed to delete some or all of the selected compositions. The operation has been cancelled.',
    product: 'Programmable Video',
    date_created: '2019-07-05T11:13:01Z',
    last_updated: '2020-08-04T10:00:07.808Z',
  },
  50436: {
    code: 50436,
    message: 'Participant limit exceeded for group conversation',
    log_level: 'ERROR',
    secondary_message:
      'The maximum of participants allowed in a group conversation has been exceeded.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50436\r\n\r\n### Participant limit exceeded for group conversation\r\n\r\nThe maximum of participants allowed in a group conversation has been exceeded. There is a limit to how many participants can be active in the same conversation at once. Adding this participant would exceed that limit.\r\n\r\n#### Possible Causes\r\n* You may have failed to remove old participants in a long-running conversation.\r\n* You may have reached an edge-case in your application that creates unusually large conversations, in excess of the limit.\r\n\r\n#### Possible Solutions\r\n* Drop another participant from the conversation before adding new one.',
    causes:
      '* You may have failed to remove old participants in a long-running conversation.\r\n* You may have reached an edge-case in your application that creates unusually large conversations, in excess of the limit.',
    solutions: '* Drop another participant from the conversation before adding new one.',
    description:
      'There is a limit to how many participants can be active in the same conversation at once. Adding this participant would exceed that limit.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T11:57:28Z',
    last_updated: '2021-08-16T11:57:28Z',
  },
  81014: {
    code: 81014,
    message: 'There was an internal error while processing an HTTP request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 81014\r\n\r\n### There was an internal error while processing an HTTP request\r\n\r\n An internal error occurred while Studio was executing an HTTP Request widget. \r\n\r\n#### Possible Causes\r\n* Parameter name uses a reserved word, e.g. "method"\r\n* URL was set to a Liquid variable that did not evaluate to a valid URL at runtime\r\n* A transient internal error occurred\r\n\r\n#### Possible Solutions\r\n* Remove reserved words from the parameter names, e.g. "method"\r\n* Check Flow logs to ensure a valid URL is being used in Liquid variables\r\n* Retry the request\r\n* Check [Twilio Status](https://status.twilio.com/)\r\n* Contact [Twilio Support](https://www.twilio.com/help/contact)',
    causes:
      '* Parameter name uses a reserved word, e.g. "method"\r\n* URL was set to a Liquid variable that did not evaluate to a valid URL at runtime\r\n* A transient internal error occurred',
    solutions:
      '* Remove reserved words from the parameter names, e.g. "method"\r\n* Check Flow logs to ensure a valid URL is being used in Liquid variables\r\n* Retry the request\r\n* Check [Twilio Status](https://status.twilio.com/)\r\n* Contact [Twilio Support](https://www.twilio.com/help/contact)',
    description: 'An internal error occurred while Studio was executing an HTTP Request widget. ',
    product: 'Studio',
    date_created: '2018-06-26T23:17:30Z',
    last_updated: '2022-08-30T17:48:58.365372Z',
  },
  13331: {
    code: 13331,
    message: 'Gather: Invalid language value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13331\r\n\r\n### Gather: Invalid language value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-05-01T22:47:43Z',
    last_updated: '2020-08-04T10:00:19.219Z',
  },
  94304: {
    code: 94304,
    message: 'Transcriptions Configurations: Language is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94304\r\n\r\n### Transcriptions Configurations: Language is invalid\r\n\r\n Invalid language value, either to create a new configuration or update existing one. Language should be a BCP-47 code\r\n\r\n#### Possible Causes\r\n* "Language" value is not a BCP-47 code\r\n\r\n#### Possible Solutions\r\n* Specify a valid "language" as a BCP-47 code',
    causes: '* "Language" value is not a BCP-47 code',
    solutions: '* Specify a valid "language" as a BCP-47 code',
    description:
      'Invalid language value, either to create a new configuration or update existing one. Language should be a BCP-47 code',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-02T11:02:33Z',
  },
  83001: {
    code: 83001,
    message: 'Parameter missing while registering a Super SIM',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 83001\r\n\r\n### Parameter missing while registering a Super SIM\r\n\r\n Raised whenever a required parameter was not passed with the request while registering a Super SIM. The error object’s detail field will indicate which parameter was not provided.\r\n\r\n#### Possible Causes\r\nEither you did not provide the Super SIM's ICCID or Registration Code in the request.\r\n\r\n#### Possible Solutions\r\nEnsure both the ICCID and Registration Code are provided in the request while registering a Super SIM.",
    causes: "Either you did not provide the Super SIM's ICCID or Registration Code in the request.",
    solutions:
      'Ensure both the ICCID and Registration Code are provided in the request while registering a Super SIM.',
    description:
      'Raised whenever a required parameter was not passed with the request while registering a Super SIM. The error object’s detail field will indicate which parameter was not provided.',
    product: 'Super SIM',
    date_created: '2021-03-21T23:59:53Z',
    last_updated: '2021-03-22T00:00:00.325Z',
  },
  92007: {
    code: 92007,
    message: 'The Content Variables Parameter is invalid',
    log_level: 'ERROR',
    secondary_message: 'The Content Variables Parameter is invalid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 92007\r\n\r\n### The Content Variables Parameter is invalid\r\n\r\nThe Content Variables Parameter is invalid \r\n\r\n#### Possible Causes\r\nThe Content Variables Parameter is not a JSON String \r\n\r\n#### Possible Solutions\r\nValidate the Content Variables Parameter, it must be a JSON String ',
    causes: 'The Content Variables Parameter is not a JSON String ',
    solutions: 'Validate the Content Variables Parameter, it must be a JSON String ',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-11-08T20:02:33Z',
    last_updated: '2021-11-08T20:02:33Z',
  },
  21723: {
    code: 21723,
    message: 'Campaign Verify token import already in progress',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21723\r\n\r\n### Campaign Verify token import already in progress\r\n\r\n The attempt to import a Campaign Verify token to your brand failed because there is already a token that is queued for importing.\r\n\r\n#### Possible Causes\r\nAnother Campaign Verify token has a status of `IN_PROGRESS` meaning it is already queued for import. Only one token can be imported at a time. \r\n\r\n#### Possible Solutions\r\nVerify that there are not existing vetting attempts for Campaign Verify that are in progress by checking the `vettingStatus` field of the Fetch Vettings API . There should not be a vetting listed with the `vettingProvider: "CampaignVerify"` that has a `vettingStatus` of `IN_PROGRESS`. Please wait until the vetting status moves to `SUCCESS` or `FAILED` before attempting to import a new Campaign Verify token. \r\n',
    causes:
      'Another Campaign Verify token has a status of `IN_PROGRESS` meaning it is already queued for import. Only one token can be imported at a time. ',
    solutions:
      'Verify that there are not existing vetting attempts for Campaign Verify that are in progress by checking the `vettingStatus` field of the Fetch Vettings API . There should not be a vetting listed with the `vettingProvider: "CampaignVerify"` that has a `vettingStatus` of `IN_PROGRESS`. Please wait until the vetting status moves to `SUCCESS` or `FAILED` before attempting to import a new Campaign Verify token. \r\n',
    description:
      'The attempt to import a Campaign Verify token to your brand failed because there is already a token that is queued for importing.',
    product: 'Programmable SMS',
    date_created: '2021-10-25T16:12:22Z',
    last_updated: '2021-10-25T16:12:22Z',
  },
  13252: {
    code: 13252,
    message: 'Dial: Invalid header name',
    log_level: 'WARNING',
    secondary_message: 'You named your header something invalid.',
    log_type: null,
    docs: '## Warning - 13252\n\n### Dial: Invalid header name\n\nYou named your header something invalid.\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:09Z',
    last_updated: '2020-08-04T10:00:26.404Z',
  },
  40152: {
    code: 40152,
    message: 'Invalid Queue for Known Worker',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 40152\r\n\r\n### Invalid Queue for Known Worker\r\n\r\n Worker isn't part of the queue specified in the Workflow target for re-targeted Task.\r\n\r\n#### Possible Causes\r\nThe Worker targeted by the Known Worker Routing feature is not a member of the TaskQueue referenced in the Workflow Target\r\n\r\n#### Possible Solutions\r\nEnsure the Worker is a member of the TaskQueue referenced in the Workflow Target. Find out more about the Known Worker Routing feature here: https://www.twilio.com/docs/taskrouter/workflow-configuration/known-agent-routing",
    causes:
      'The Worker targeted by the Known Worker Routing feature is not a member of the TaskQueue referenced in the Workflow Target',
    solutions:
      'Ensure the Worker is a member of the TaskQueue referenced in the Workflow Target. Find out more about the Known Worker Routing feature here: https://www.twilio.com/docs/taskrouter/workflow-configuration/known-agent-routing',
    description:
      "Worker isn't part of the queue specified in the Workflow target for re-targeted Task.",
    product: 'TaskRouter',
    date_created: '2021-06-25T16:47:46Z',
    last_updated: '2021-08-05T16:33:10.02458Z',
  },
  50374: {
    code: 50374,
    message: "'State' field can't be empty",
    log_level: 'ERROR',
    secondary_message: "'State' field can't be empty or removed from channel.",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50374\r\n\r\n### 'State' field can't be empty\r\n\r\n'State' field can't be empty or removed from channel. 'State' field can't be removed or set to empty if it was already set before.\r\n\r\n#### Possible Causes\r\n* 'State' field is set to empty string value when channel has some non-empty state.\r\n\r\n#### Possible Solutions\r\n* Remove 'State' field from request parameters.\r\n* Set 'State' field to some valid value('active', 'inactive', 'closed', etc.)",
    causes: "* 'State' field is set to empty string value when channel has some non-empty state.",
    solutions:
      "* Remove 'State' field from request parameters.\r\n* Set 'State' field to some valid value('active', 'inactive', 'closed', etc.)",
    description: "'State' field can't be removed or set to empty if it was already set before.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:18:59Z',
    last_updated: '2020-09-24T12:19:18.82Z',
  },
  54100: {
    code: 54100,
    message: 'Document not found',
    log_level: 'ERROR',
    secondary_message: 'The specified Document does not exist.',
    log_type: null,
    docs: "\n## Error - 54100\n\n### Sync: Document not found\nThe specified Document does not exist.\n\n#### Possible Causes\n* The supplied Sync Document SID or Unique Name is erroneous.\n* This Sync Document has been deleted.\n\n#### Possible Solutions\nConfirm that the document you're requesting exists, and that you are using the precise SID or unique name it is assigned.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.644Z',
  },
  50705: {
    code: 50705,
    message: 'Provided module sid should have prefix XE.',
    log_level: 'ERROR',
    secondary_message: 'Provided module sid should have prefix XE.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50705\r\n\r\n### Provided module sid should have prefix XE.\r\n\r\nProvided module sid should have prefix XE. \r\n\r\n#### Possible Causes\r\nYou are trying to specify a different field value for ChatbotConfiguration.ModuleSid.\r\n\r\n#### Possible Solutions\r\n* Double check and fix value for ChatbotConfiguration.ModuleSid. It should start with XE prefix.',
    causes: 'You are trying to specify a different field value for ChatbotConfiguration.ModuleSid.',
    solutions:
      '* Double check and fix value for ChatbotConfiguration.ModuleSid. It should start with XE prefix.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:02:28Z',
    last_updated: '2023-10-11T18:02:28Z',
  },
  53208: {
    code: 53208,
    message: "Participant's bandwidth profile configuration is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53208\r\n\r\n### Participant's bandwidth profile configuration is invalid\r\n\r\n Participant's bandwidth profile configuration is invalid\r\n\r\n#### Possible Causes\r\nAt least one of the bandwidth profile configuration parameters is invalid. This could mean out of range, missing entirely, etc.\r\n\r\n#### Possible Solutions\r\n* Check the bandwidth profile documentation and confirm that your configuration is valid.",
    causes:
      'At least one of the bandwidth profile configuration parameters is invalid. This could mean out of range, missing entirely, etc.',
    solutions:
      '* Check the bandwidth profile documentation and confirm that your configuration is valid.',
    description: "Participant's bandwidth profile configuration is invalid",
    product: 'Programmable Video',
    date_created: '2020-10-26T15:45:53Z',
    last_updated: '2020-10-26T15:55:44.045Z',
  },
  95115: {
    code: 95115,
    message: 'Media has too many channels',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95115\r\n\r\n### Media has too many channels\r\n\r\n Validation of audio failed because it contains more than two channels.\r\n\r\n#### Possible Causes\r\nMulti channel audio containing more than 2 channels. It could come from a recording of a conference.\r\n\r\n#### Possible Solutions\r\nRemove unnecessary channels. Downmix extra channels into one.',
    causes:
      'Multi channel audio containing more than 2 channels. It could come from a recording of a conference.',
    solutions: 'Remove unnecessary channels. Downmix extra channels into one.',
    description: 'Validation of audio failed because it contains more than two channels.',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:39:53Z',
    last_updated: '2024-04-16T17:39:53Z',
  },
  21207: {
    code: 21207,
    message: 'Invalid IfMachine',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call, but you sent an invalid <span class=\'rest-attribute\'>IfMachine</span> parameter.  Twilio can determine if an answering machine or voicemail has answered the call, and behave differently if it has.  Valid options for <span class=\'rest-attribute\'>IfMachine</span> are "Continue" (continue with the call, progressing after the beep), "Hangup" (immediately hangup the call) or "False" (don\'t determine if a machine has answered).',
    log_type: null,
    docs: '## Error - 21207 \n\n### Invalid IfMachine\n\nYou attempted to initiate an outbound phone call, but you sent an invalid <span class=\'rest-attribute\'>IfMachine</span> parameter.  Twilio can determine if an answering machine or voicemail has answered the call, and behave differently if it has.  Valid options for <span class=\'rest-attribute\'>IfMachine</span> are "Continue" (continue with the call, progressing after the beep), "Hangup" (immediately hangup the call) or "False" (don\'t determine if a machine has answered).\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:55Z',
    last_updated: '2020-08-04T10:00:27.187Z',
  },
  80904: {
    code: 80904,
    message: 'Expired Proxy Session',
    log_level: 'WARNING',
    secondary_message: ' ',
    log_type: 'APPLICATION',
    docs: '## WARNING - 80904\r\n\r\n### Expired Proxy Session\r\n\r\n  Proxy session has expired.\r\n\r\n#### Possible Causes\r\n* Session has expired due to **"Ttl"** or **"DateExpiry"** has been reached. \r\n    * If Session has DateExpiry property set, it overrides the Ttl value and session will expire as soon as DateExpiry is reached.\r\n    * If Both the properties are not set, default Ttl is set to 90 days and session expires when Ttl is reached. \r\n\r\n#### Possible Solutions\r\nCreate a new session or re-open a closed session within the service. Refer: [docs](https://www.twilio.com/docs/proxy/api/session)',
    causes:
      '* Session has expired due to **"Ttl"** or **"DateExpiry"** has been reached. \r\n    * If Session has DateExpiry property set, it overrides the Ttl value and session will expire as soon as DateExpiry is reached.\r\n    * If Both the properties are not set, default Ttl is set to 90 days and session expires when Ttl is reached. ',
    solutions:
      'Create a new session or re-open a closed session within the service. Refer: [docs](https://www.twilio.com/docs/proxy/api/session)',
    description: 'Proxy session has expired.',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2022-12-14T10:03:39.955833Z',
  },
  30446: {
    code: 30446,
    message: 'Toll Free verification rejection - Opt-in not sufficient: express consent required',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30446\r\n\r\n### Toll Free verification rejection - Opt-in not sufficient: express consent required\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe Opt-in workflow provided in the toll-free verification is not sufficient. Express Consent is required. Express Consent is more than collecting a phone number - it is a voluntary, informed end user choice for a specific purpose - it requires upfront disclosure and intentional action. Explicit opt-in leaves no ambiguity for why the customer gave the phone number, and for how they expect the company will communicate with them.  Every end business must have consent from each recipient they send a message to. Consumers may give permission over text, on a form, on a website, or verbally. Consumers may also give written permission. Listing “SMS” in your Terms of Service or Privacy Policy is not Express Consent. \r\n\r\nNote: If there is promotional messaging on this toll-free phone number, it requires express written consent.\r\n\r\nOpt-in refers to the process of getting a consumer’s permission to send them text messages. According to TCPA law, businesses must have "express written consent" from the consumer before texting them. NonConsumer (A2P) Message Senders should: \r\n\r\n* Obtain a Consumer’s consent to receive messages generally; \r\n* Obtain a Consumer’s express written consent to specifically receive marketing messages; \r\n* Ensure that Consumers have the ability to revoke consent\r\n\r\n#### Possible Solutions\r\n* Correct your opt-in process to collect a consumer’s express consent via CTIA guidelines and resubmit the toll free verification\r\n* Note: An opt-in call-to-action (CTA) with a checkbox must be unchecked by default\r\n\r\n[CITIA guidelines](\r\nhttps://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The Opt-in workflow provided in the toll-free verification is not sufficient. Express Consent is required. Express Consent is more than collecting a phone number - it is a voluntary, informed end user choice for a specific purpose - it requires upfront disclosure and intentional action. Explicit opt-in leaves no ambiguity for why the customer gave the phone number, and for how they expect the company will communicate with them.  Every end business must have consent from each recipient they send a message to. Consumers may give permission over text, on a form, on a website, or verbally. Consumers may also give written permission. Listing “SMS” in your Terms of Service or Privacy Policy is not Express Consent. \r\n\r\nNote: If there is promotional messaging on this toll-free phone number, it requires express written consent.\r\n\r\nOpt-in refers to the process of getting a consumer’s permission to send them text messages. According to TCPA law, businesses must have "express written consent" from the consumer before texting them. NonConsumer (A2P) Message Senders should: \r\n\r\n* Obtain a Consumer’s consent to receive messages generally; \r\n* Obtain a Consumer’s express written consent to specifically receive marketing messages; \r\n* Ensure that Consumers have the ability to revoke consent',
    solutions:
      '* Correct your opt-in process to collect a consumer’s express consent via CTIA guidelines and resubmit the toll free verification\r\n* Note: An opt-in call-to-action (CTA) with a checkbox must be unchecked by default\r\n\r\n[CITIA guidelines](\r\nhttps://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:14:40Z',
    last_updated: '2024-04-16T16:19:22.574183Z',
  },
  40005: {
    code: 40005,
    message: 'Assignment Callback response does not contain Instruction',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 40005\r\n\r\n### Assignment Callback response does not contain Instruction\r\n\r\n Assignment Callback response does not contain 'instruction'\r\n\r\n\r\n\r\n#### Possible Causes\r\nAssignment Callback response is a 200 with some json that doesn't contain 'instruction'.\r\n\r\n#### Possible Solutions\r\nDo not respond to the Assignment Callback or issue an empty json response.",
    causes:
      "Assignment Callback response is a 200 with some json that doesn't contain 'instruction'.",
    solutions: 'Do not respond to the Assignment Callback or issue an empty json response.',
    description: "Assignment Callback response does not contain 'instruction'\r\n\r\n",
    product: 'TaskRouter',
    date_created: '2020-03-11T21:23:50Z',
    last_updated: '2020-09-14T21:38:27.896Z',
  },
  21503: {
    code: 21503,
    message: 'Invalid transcription type',
    log_level: 'ERROR',
    secondary_message:
      'The transcription type you provided is not a valid choice.  You may use one of: fast, accurate or all.',
    log_type: null,
    docs: '## Error - 21503 \n\n### Invalid transcription type\n\nThe transcription value you provided is invalid.  You may use one of: "true" or "false".\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:02Z',
    last_updated: '2020-08-04T10:00:26.781Z',
  },
  30009: {
    code: 30009,
    message: 'Missing inbound segment',
    log_level: 'ERROR',
    secondary_message:
      'One or more segments associated with your multi-part inbound message was not received.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30009\r\n\r\n### Missing inbound segment\r\n\r\n One or more segments associated with your multi-part inbound message was not received.\r\n\r\n#### Possible Causes\r\n* The mobile network or carrier did not successfully send the entire message to Twilio\r\n* The mobile handset had a malfunction and did not successfully send all segments\r\n* The mobile user was in poor network coverage, causing an incomplete message to be sent\r\n\r\n#### Possible Solutions\r\n* Ensure the mobile user is in good network coverage and request they try sending the message again\r\n* If the issue is occurring frequently for multiple users, [contact Twilio Support](https://www.twilio.com/console/support/tickets/create) with Message SIDs of affected messages',
    causes:
      '* The mobile network or carrier did not successfully send the entire message to Twilio\r\n* The mobile handset had a malfunction and did not successfully send all segments\r\n* The mobile user was in poor network coverage, causing an incomplete message to be sent',
    solutions:
      '* Ensure the mobile user is in good network coverage and request they try sending the message again\r\n* If the issue is occurring frequently for multiple users, [contact Twilio Support](https://www.twilio.com/console/support/tickets/create) with Message SIDs of affected messages',
    description:
      'One or more segments associated with your multi-part inbound message was not received.',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:35Z',
    last_updated: '2021-01-29T15:40:12.191Z',
  },
  50330: {
    code: 50330,
    message: 'Programmable Chat: Channel webhook filter not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain parameter for webhook filter',
    log_type: null,
    docs: '## Error - 50330\r\n\r\n### Programmable Chat: Channel webhook filter not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook filter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:12:22Z',
    last_updated: '2020-08-04T10:00:11.955Z',
  },
  70004: {
    code: 70004,
    message: 'Unauthorized',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70004\r\n\r\n### Unauthorized\r\nThe Request does not contain any authorization information (most cases: credentials) or the credentials and the resource have no relation.\r\n\r\n#### Possible Causes \r\n* When omitting the Auth header from HTTP request\r\n* Passing an Auth header to access a resource that belongs to some other account.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:39:48Z',
    last_updated: '2020-08-04T10:00:19.887Z',
  },
  81012: {
    code: 81012,
    message: 'Failed to update Sync service',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81012\r\n\r\n### Failed to update Sync service\r\nStudio was unable to update the Sync Service while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Sync API failed.\r\n* Invalid values were passed to the Sync API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:17:01Z',
    last_updated: '2020-08-04T10:00:13.078Z',
  },
  50382: {
    code: 50382,
    message: "Timer can't be set without state",
    log_level: 'ERROR',
    secondary_message:
      "You are trying to set 'TimeToInactive' and/or 'TimeToClosed' without 'State' parameter in request",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50382\r\n\r\n### Timer can't be set without state\r\n\r\nYou are trying to set 'TimeToInactive' and/or 'TimeToClosed' without 'State' parameter in request You are trying to set 'TimeToInactive' and/or 'TimeToClosed' without 'State' parameter in request during conversation creation\r\n\r\n#### Possible Causes\r\n* 'State' parameter is missing while 'TimeToInactive' and/or 'TimeToClosed' are present\r\n\r\n#### Possible Solutions\r\n* Add 'State' parameter in conversation creation request\r\n* Remove 'TimeToInactive' and/or 'TimeToClosed' from conversation creation request",
    causes:
      "* 'State' parameter is missing while 'TimeToInactive' and/or 'TimeToClosed' are present",
    solutions:
      "* Add 'State' parameter in conversation creation request\r\n* Remove 'TimeToInactive' and/or 'TimeToClosed' from conversation creation request",
    description:
      "You are trying to set 'TimeToInactive' and/or 'TimeToClosed' without 'State' parameter in request during conversation creation",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:29:59Z',
    last_updated: '2020-09-24T12:30:08.7Z',
  },
  13212: {
    code: 13212,
    message: 'Dial: Invalid timeout value',
    log_level: 'WARNING',
    secondary_message:
      "timeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/dial#timeout'>Dial Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13212 \n\n### Dial: Invalid timeout value\n\ntimeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/dial#timeout'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:32Z',
    last_updated: '2020-08-04T10:00:28.941Z',
  },
  60500: {
    code: 60500,
    message: 'SNA Phone Number Mismatch',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60500\r\n\r\n### SNA Phone Number Mismatch\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request and processing was successful but the phone number provided in the request does not match the phone number detected via the carrier. This can happen when there is dual SIM usage or the end user is trying to verify a phone number that does not belong to the SIM.\r\n\r\n#### Possible Solutions\r\n- Check that the phone number provided is correct.\n- Retry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request and processing was successful but the phone number provided in the request does not match the phone number detected via the carrier. This can happen when there is dual SIM usage or the end user is trying to verify a phone number that does not belong to the SIM.',
    solutions:
      '- Check that the phone number provided is correct.\n- Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-29T21:51:30Z',
    last_updated: '2022-08-29T21:51:30Z',
  },
  53205: {
    code: 53205,
    message: 'Participant disconnected because of duplicate identity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53205: Participant disconnected because of duplicate identity\r\n\r\nRaised by the server to the existing Participant when a new Participant joins a Room with the same identity as the existing Participant.\r\n\r\n#### Causes\r\n\r\n * Using the same identity for more than one Room Participant.\r\n\r\n#### Solutions\r\n\r\n * Make sure that each Participant joins a Room with a unique identity.\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-05-09T23:59:56Z',
    last_updated: '2020-08-04T10:00:18.647Z',
  },
  63028: {
    code: 63028,
    message: 'Number of parameters provided does not match the expected number of parameters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Number of parameters provided does not match the expected number of parameters\r\n\r\n#### Possible Causes \r\n* Number of parameters provided does not match the expected number of parameters',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-05-16T19:08:26Z',
    last_updated: '2020-08-04T10:00:08.716Z',
  },
  60371: {
    code: 60371,
    message: 'Relying party invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60371\r\n\r\n### Relying party invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe config for relying party in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the config for relying party in the request body is correct.',
    causes: 'The config for relying party in the request is missing or incorrectly formatted.',
    solutions: 'Check that the config for relying party in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-20T09:19:37Z',
    last_updated: '2023-12-20T09:19:37Z',
  },
  21472: {
    code: 21472,
    message: 'Account is not active',
    log_level: 'ERROR',
    secondary_message:
      'The AccountSid you specified is not an active Twilio Account.  To transfer the account, you must supply an Active 34 character AccountSid .',
    log_type: null,
    docs: '## Error - 21472\n\n### Account is not active\n\nThe AccountSid you specified is not an active Twilio Account.  To transfer the account, you must supply an Active 34 character AccountSid .\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:22Z',
    last_updated: '2020-08-04T10:00:25.353Z',
  },
  21203: {
    code: 21203,
    message: 'International calling not enabled',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call to an international phone number, which is not currently supported.',
    log_type: null,
    docs: '## Error - 21203 \n\n### International calling not enabled\n\nYou attempted to initiate an outbound phone call to an international phone number, which is not currently supported.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:54Z',
    last_updated: '2020-08-04T10:00:27.258Z',
  },
  45207: {
    code: 45207,
    message: 'Chat User per Chat Channel limit reached. User is part of too many Chat Channels.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45207\r\n\r\n### Chat User per Chat Channel limit reached. User is part of too many Chat Channels.\r\n\r\n \r\n\r\n#### Possible Causes\r\nFlex Agents as part of standard Flex Orchestration are removed from Chat Channels once they are done working a specific Task related to a Channel. Possible cause to this error is that this orchestration is not working or Flex is unaware that the Custom Task Channel used has chat capabilities. \r\n\r\n#### Possible Solutions\r\nPlease check that Agents are not part of large number of inactive Channels/Tasks, review any custom programmability you may have in Flex UI (please review Flex Documentation). You can control the Chat Channels and Members through Programmable Chat API. You can also change the Channel Limit in Twilio Programmable Chat Console but keep in mind this cannot be extended indefinitely. ',
    causes:
      'Flex Agents as part of standard Flex Orchestration are removed from Chat Channels once they are done working a specific Task related to a Channel. Possible cause to this error is that this orchestration is not working or Flex is unaware that the Custom Task Channel used has chat capabilities. ',
    solutions:
      'Please check that Agents are not part of large number of inactive Channels/Tasks, review any custom programmability you may have in Flex UI (please review Flex Documentation). You can control the Chat Channels and Members through Programmable Chat API. You can also change the Channel Limit in Twilio Programmable Chat Console but keep in mind this cannot be extended indefinitely. ',
    description: null,
    product: 'Flex',
    date_created: '2019-09-26T11:43:01Z',
    last_updated: '2020-08-04T10:00:06.205Z',
  },
  51105: {
    code: 51105,
    message: "Twilsock: Token doesn't contain identity",
    log_level: 'ERROR',
    secondary_message: "The token doesn't have an identity specified.",
    log_type: null,
    docs: "## Error - 51105\r\n\r\n### Token doesn't contain identity\r\n\r\n#### Possible Causes \r\nThe token doesn't have an identity specified.\r\n\r\n#### Possible Solutions\r\nConfirm that there is an identity field in the token. To check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T11:57:48Z',
    last_updated: '2020-08-04T10:00:09.844Z',
  },
  60611: {
    code: 60611,
    message: 'Lookup Package Quota Reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60611\r\n\r\n### Lookup Package Quota Reached\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received but failed due to the Account reaching its request quota for the given Lookup package. Some packages may have a quota set when they are in the Pilot phase.\r\n\r\n#### Possible Solutions\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to remove the quota limitation.',
    causes:
      'The request was received but failed due to the Account reaching its request quota for the given Lookup package. Some packages may have a quota set when they are in the Pilot phase.',
    solutions:
      '- [Contact Twilio Support](https://www.twilio.com/help/contact) to remove the quota limitation.',
    description: 'Lookup quota for requested package has been reached',
    product: 'Lookup',
    date_created: '2021-07-02T16:34:22Z',
    last_updated: '2023-01-06T00:28:41.143586Z',
  },
  90103: {
    code: 90103,
    message: 'Error processing answer during collection',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 90103\r\n\r\n### Error processing answer during collection\r\n\r\n Error processing answer during collection\r\n\r\n#### Possible Causes\r\nAn internal error rendered us unable to process the answer. Apologies!\r\n\r\n#### Possible Solutions\r\nIf the error persists, <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it.\r\nNote the time of the error and what you were trying to do when it occurred. Thank you!',
    causes: 'An internal error rendered us unable to process the answer. Apologies!',
    solutions:
      'If the error persists, <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it.\r\nNote the time of the error and what you were trying to do when it occurred. Thank you!',
    description: 'Error processing answer during collection',
    product: 'Understand',
    date_created: '2020-07-02T23:29:36Z',
    last_updated: '2020-08-04T10:00:02.33Z',
  },
  50418: {
    code: 50418,
    message: 'Non-Chat participants limit exceeded',
    log_level: 'ERROR',
    secondary_message:
      'The total number of SMS, WhatsApp, or other non-Chat participants in this conversation exceeds the allowed limit.',
    log_type: null,
    docs: '\n## Error - 50418\n\n### Conversations: Non-Chat participants limit exceeded\nThe total number of SMS, WhatsApp, or other non-Chat participants in this conversation exceeds the allowed limit.\n\n#### Possible Causes\n* You are trying to add more non-Chat participants than allowed in this conversation. [Maximum number](https://www.twilio.com/docs/conversations/conversations-limits) of conversation participants is 50.\n\n#### Possible Solutions\n* Retrieve a [list of current participants](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) in this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource) the ones that are no longer required.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.389Z',
  },
  81019: {
    code: 81019,
    message: 'Twilio phone number using deprecated API version',
    log_level: 'ERROR',
    secondary_message: 'Studio does not support 2008-08-01 API',
    log_type: 'APPLICATION',
    docs: '## ERROR - 81019\r\n\r\n### Twilio phone number using deprecated API version\r\n\r\nStudio does not support 2008-08-01 API The Twilio phone number connected to your Studio Flow is configured for the deprecated 2008-08-01 API, which is not compatible. Update the phone number API version to 2010-04-01.\r\n\r\n#### Possible Causes\r\nThe Twilio phone number is configured for the 2008-08-01 API\r\n\r\n#### Possible Solutions\r\nUpdate the phone number API version to 2010-04-01',
    causes: 'The Twilio phone number is configured for the 2008-08-01 API',
    solutions: 'Update the phone number API version to 2010-04-01',
    description:
      'The Twilio phone number connected to your Studio Flow is configured for the deprecated 2008-08-01 API, which is not compatible. Update the phone number API version to 2010-04-01.',
    product: 'Studio',
    date_created: '2019-06-17T17:28:02Z',
    last_updated: '2020-08-28T02:40:02.354Z',
  },
  45773: {
    code: 45773,
    message: 'Internal Error. Failed to create token.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45773\r\n\r\n### Internal Error. Failed to create token.\r\n\r\n An unexpected error occurred when processing init token request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when creating token.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when creating token.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing init token request.',
    product: 'Flex',
    date_created: '2023-11-22T15:38:26Z',
    last_updated: '2023-11-22T15:38:26Z',
  },
  21701: {
    code: 21701,
    message: 'The Messaging Service does not exist',
    log_level: 'ERROR',
    secondary_message: 'The Messaging Service resource you are referencing does not exist',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21701\r\n\r\n### The Messaging Service does not exist\r\n\r\n The Messaging Service resource you are referencing does not exist or does not match the `Account SID` in the API Request.\r\n\r\n\r\n#### Possible Causes\r\n* The Messaging Service resource you are referencing does not exist.\r\n* The Messaging Service resource you are referencing does not belong to the Account SID in your API Request.\r\n\r\n\r\n#### Possible Solutions\r\n*  Double check the `Messaging Service SID` and `Account SID` parameters that you are using. You can find the Messaging Service SID in the [Twilio Console](https://console.twilio.com/us1/develop/sms/services) (beginning with MG).',
    causes:
      '* The Messaging Service resource you are referencing does not exist.\r\n* The Messaging Service resource you are referencing does not belong to the Account SID in your API Request.\r\n',
    solutions:
      '*  Double check the `Messaging Service SID` and `Account SID` parameters that you are using. You can find the Messaging Service SID in the [Twilio Console](https://console.twilio.com/us1/develop/sms/services) (beginning with MG).',
    description:
      'The Messaging Service resource you are referencing does not exist or does not match the `Account SID` in the API Request.\r\n',
    product: null,
    date_created: '2016-03-31T17:14:29Z',
    last_updated: '2024-02-05T12:19:44.781495Z',
  },
  21239: {
    code: 21239,
    message: 'Maximum Credential Lists Reached',
    log_level: 'ERROR',
    secondary_message: 'An account cannot have more than 100 IP Access Control Lists.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21239\r\n\r\n### Maximum Credential Lists Reached\r\n\r\nAn account cannot have more than 100 IP Access Control Lists. \r\n\r\n#### Possible Causes\r\n* An account cannot have more than 100 IP Access Control Lists.\r\n\r\n#### Possible Solutions\r\n* Delete an existing IP Access Control List if you must create more.',
    causes: '* An account cannot have more than 100 IP Access Control Lists.',
    solutions: '* Delete an existing IP Access Control List if you must create more.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:22:12Z',
    last_updated: '2020-08-04T10:00:00.48Z',
  },
  50378: {
    code: 50378,
    message: "'State' parameter value is invalid",
    log_level: 'ERROR',
    secondary_message: "'State' parameter value is set to some not supported value",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50378\r\n\r\n### 'State' parameter value is invalid\r\n\r\n'State' parameter value is set to some not supported value 'State' parameter value is set to some not supported value. Supported values are 'active', 'inactive', 'closed'.\r\n\r\n#### Possible Causes\r\n* 'State' parameter value is set to values different from 'active', 'inactive', 'closed'.\r\n\r\n#### Possible Solutions\r\n* Use following values for 'State' parameter: 'active', 'inactive', 'closed'.",
    causes:
      "* 'State' parameter value is set to values different from 'active', 'inactive', 'closed'.",
    solutions: "* Use following values for 'State' parameter: 'active', 'inactive', 'closed'.",
    description:
      "'State' parameter value is set to some not supported value. Supported values are 'active', 'inactive', 'closed'.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:24:40Z',
    last_updated: '2020-09-24T12:24:46.33Z',
  },
  51201: {
    code: 51201,
    message: 'Twilsock : CPS, Init per Account',
    log_level: 'ERROR',
    secondary_message: 'Too many connection requests for this account.',
    log_type: null,
    docs: 'Too many connection requests for this account.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-05-03T11:45:30Z',
    last_updated: '2020-08-04T10:00:09.12Z',
  },
  62017: {
    code: 62017,
    message: 'No IP route specified',
    log_level: 'ERROR',
    secondary_message:
      'The request did not identify an IP route. This may indicate that the IP Route parameter was misspelled.',
    log_type: null,
    docs: '## Error - 62017\r\n\r\n### No IP route specified\r\n\r\nThe request did not identify an IP route. This may indicate that the IP Route parameter was misspelled.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:43:10Z',
    last_updated: '2020-08-04T10:00:20.879Z',
  },
  50438: {
    code: 50438,
    message: 'Group conversation with given participant list already exists',
    log_level: 'ERROR',
    secondary_message:
      'There is an existing (open) group conversation with the same participant list.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50438\r\n\r\n### Group conversation with given participant list already exists\r\n\r\nThere is an existing (open) group conversation with the same participant list. There is an existing group conversation with the same participant list.\r\n\r\n#### Possible Causes\r\n* You previously created a conflicting conversation\r\n* Twilio created a conversation — which now conflicts — in the course of Autocreation.\r\n\r\n#### Possible Solutions\r\n* If the existing conversation is no longer in use, delete or [close the conversation](https://www.twilio.com/docs/conversations/states-timers#closed-conversations).\r\n* Alternatively, locate the other conversation and use that in place of this one.',
    causes:
      '* You previously created a conflicting conversation\r\n* Twilio created a conversation — which now conflicts — in the course of Autocreation.',
    solutions:
      '* If the existing conversation is no longer in use, delete or [close the conversation](https://www.twilio.com/docs/conversations/states-timers#closed-conversations).\r\n* Alternatively, locate the other conversation and use that in place of this one.',
    description: 'There is an existing group conversation with the same participant list.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T11:59:26Z',
    last_updated: '2021-08-16T11:59:26Z',
  },
  52116: {
    code: 52116,
    message: 'Legacy FCM server key credential used to send notifications',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 52116\r\n\r\n### Legacy FCM server key credential used to send notifications\r\n\r\n Google will deprecate the legacy FCM API in June 2024: https://help.twilio.com/articles/20768292997147-Updating-Twilio-Push-for-FCM-HTTP-v1-API\r\n\r\n#### Possible Causes\r\nDetected the use of a legacy FCM server key credential. This credential will stop working after Google deprecates the legacy FCM API in June 2024. Your action is required in order for FCM push notifications to continue to work after the legacy FCM API is deprecated.\r\n\r\n#### Possible Solutions\r\nUse a new FCMv1 credential before June 2024 to keep sending push notifications. See instructions linked in the description above.',
    causes:
      'Detected the use of a legacy FCM server key credential. This credential will stop working after Google deprecates the legacy FCM API in June 2024. Your action is required in order for FCM push notifications to continue to work after the legacy FCM API is deprecated.',
    solutions:
      'Use a new FCMv1 credential before June 2024 to keep sending push notifications. See instructions linked in the description above.',
    description:
      'Google will deprecate the legacy FCM API in June 2024: https://help.twilio.com/articles/20768292997147-Updating-Twilio-Push-for-FCM-HTTP-v1-API',
    product: null,
    date_created: '2024-02-22T09:06:56Z',
    last_updated: '2024-02-22T09:37:41.669066Z',
  },
  60619: {
    code: 60619,
    message: 'Lookup Request Cannot be Completed in Twilio Region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60619\r\n\r\n### Lookup Request Cannot be Completed in Twilio Region\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received but failed due to the Lookup request not being supported by the selected Twilio Region. This can happen when specific Lookup packages or functionality is not available in the Region. Learn more at [Twilio Regions](https://www.twilio.com/docs/global-infrastructure/understanding-twilio-regions) and [Using Lookup with Twilio Regions](https://www.twilio.com/docs/lookup/using-lookup-with-twilio-regions).\r\n\r\n#### Possible Solutions\r\n- Confirm that the request is selecting the expected Region.\r\n- Confirm that the request is using an API key generated for the expected Region.',
    causes:
      'The request was received but failed due to the Lookup request not being supported by the selected Twilio Region. This can happen when specific Lookup packages or functionality is not available in the Region. Learn more at [Twilio Regions](https://www.twilio.com/docs/global-infrastructure/understanding-twilio-regions) and [Using Lookup with Twilio Regions](https://www.twilio.com/docs/lookup/using-lookup-with-twilio-regions).',
    solutions:
      '- Confirm that the request is selecting the expected Region.\r\n- Confirm that the request is using an API key generated for the expected Region.',
    description: 'The Lookup request cannot be completed in the selected Twilio region.',
    product: 'Lookup',
    date_created: '2022-11-01T15:51:59Z',
    last_updated: '2023-01-06T00:42:58.736135Z',
  },
  30116: {
    code: 30116,
    message: 'Certificate or private key or both are missing',
    log_level: 'ERROR',
    secondary_message: 'Please use PEM format for uploaded certificates',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30116\r\n\r\n### Certificate or private key or both are missing\r\n\r\nPlease use PEM format for uploaded certificates Certificates should be uploaded in PEM format. https://en.wikipedia.org/wiki/Privacy-Enhanced_Mail\r\n\r\n#### Possible Causes\r\n- Certificate is using a different format\r\n- Certificate has been corrupted\r\n\r\n#### Possible Solutions\r\n- Generate a new certificate in PEM format and reupload',
    causes: '- Certificate is using a different format\r\n- Certificate has been corrupted',
    solutions: '- Generate a new certificate in PEM format and reupload',
    description:
      'Certificates should be uploaded in PEM format. https://en.wikipedia.org/wiki/Privacy-Enhanced_Mail',
    product: 'Programmable SMS',
    date_created: '2020-09-01T18:08:20Z',
    last_updated: '2022-07-15T00:02:55.012427Z',
  },
  60401: {
    code: 60401,
    message: 'Network Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60401\r\n\r\n### Network Error\r\n\r\n An error occurred while calling the API.\r\n\r\n#### Possible Causes\r\nIt was not possible to communicate properly with the API.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry',
    causes: 'It was not possible to communicate properly with the API.',
    solutions: 'Check parameters and retry',
    description: 'An error occurred while calling the API.',
    product: 'Verify',
    date_created: '2021-03-15T20:43:25Z',
    last_updated: '2021-03-15T20:43:25Z',
  },
  20423: {
    code: 20423,
    message: 'Invalid SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20423\r\n\r\n### Invalid SID\r\n\r\nThe request contained at least one parameter what is incorrect SID but has to be.\r\n\r\n#### Is the request safe to retry?\r\n\r\nA 422 request is never processed and is always safe to retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-30T16:17:11Z',
    last_updated: '2020-08-04T10:00:10.976Z',
  },
  50529: {
    code: 50529,
    message: 'Content variables are too long',
    log_level: 'ERROR',
    secondary_message:
      'Message content variables are exceeding allowed total length of 27,801 characters',
    log_type: 'TWILIO',
    docs: "## ERROR - 50529\r\n\r\n### Content variables are too long\r\n\r\nMessage content variables are exceeding allowed total length of 27,801 characters Allowed total length for message content variables is sum of key, value and JSON-specific characters' lengths.\r\n\r\n#### Possible Causes\r\nEither too many variables are defined (max 100 in total), or too long keys (max 16 characters per variable), or too long values (max 256 characters per variable).\r\n\r\n#### Possible Solutions\r\nFollow the length limitations:\r\n- variables: 100 in total;\r\n- key: 16 characters per variable;\r\n- value: 256 characters per variable.",
    causes:
      'Either too many variables are defined (max 100 in total), or too long keys (max 16 characters per variable), or too long values (max 256 characters per variable).',
    solutions:
      'Follow the length limitations:\r\n- variables: 100 in total;\r\n- key: 16 characters per variable;\r\n- value: 256 characters per variable.',
    description:
      "Allowed total length for message content variables is sum of key, value and JSON-specific characters' lengths.",
    product: 'Conversations',
    date_created: '2023-03-10T14:23:30Z',
    last_updated: '2023-03-10T14:23:30Z',
  },
  14221: {
    code: 14221,
    message: 'Enqueue: Provided Attributes JSON was not valid',
    log_level: 'ERROR',
    secondary_message: 'Provided Attributes is not valid JSON.',
    log_type: null,
    docs: '## Error - 14221\n\n### Enqueue: Provided Attributes JSON was not valid\n\nProvided Attributes is not valid JSON.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:13Z',
    last_updated: '2020-08-04T10:00:26.078Z',
  },
  22153: {
    code: 22153,
    message: 'Port In Error - Invalid end user name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 22153\r\n\r\n### Port In Error - Invalid end user name\r\n\r\n The name of the Authorized Representative submitted in the port in request does not the losing carrier's information. \r\n\r\n#### Possible Causes\r\nThe name of the Authorized Representative submitted in the port in request does not the losing carrier's information. \r\n\r\n#### Possible Solutions\r\nUpdate the port in request to include an authorized representative that is on record with the losing carrier for this phone number.\r\n\r\nNote if this is the only phone number in a port in request that got rejected you may need to start a new port in request with this phone number so that you can correct the authorized representative name as it may be different from the other phone numbers in this request. ",
    causes:
      "The name of the Authorized Representative submitted in the port in request does not the losing carrier's information. ",
    solutions:
      'Update the port in request to include an authorized representative that is on record with the losing carrier for this phone number.\r\n\r\nNote if this is the only phone number in a port in request that got rejected you may need to start a new port in request with this phone number so that you can correct the authorized representative name as it may be different from the other phone numbers in this request. ',
    description:
      "The name of the Authorized Representative submitted in the port in request does not the losing carrier's information. ",
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:03:06Z',
    last_updated: '2024-04-22T23:03:06Z',
  },
  18604: {
    code: 18604,
    message: 'Unable to verify Authorized representative #1',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18604\r\n\r\n### Unable to verify Authorized representative #1\r\n\r\n Unable to verify Authorized representative #1\r\n\r\n#### Possible Causes\r\nUnable to verify Authorized representative #1’s identity or their affiliation with the business.\r\n\r\n#### Possible Solutions\r\nPlease feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    causes:
      'Unable to verify Authorized representative #1’s identity or their affiliation with the business.',
    solutions:
      'Please feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    description: 'Unable to verify Authorized representative #1',
    product: 'Phone Numbers',
    date_created: '2024-02-22T03:32:42Z',
    last_updated: '2024-02-22T03:32:42Z',
  },
  11243: {
    code: 11243,
    message: 'HTTP retry policy is invalid',
    log_level: 'ERROR',
    secondary_message:
      'One or more retry policies specified in the ‘rp’ parameter of your connection settings are invalid.',
    log_type: null,
    docs: "## Error - 11243\r\n\r\n### HTTP retry policy is invalid\r\nOne or more retry policies specified in the ‘rp’ parameter of your connection settings are invalid.\r\n\r\n#### Possible Solutions\r\n*  Correct the 'rp' (retry policy) parameter in the fragment part of the URL, the one after '#'.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-31T00:29:58Z',
    last_updated: '2020-08-04T10:00:10.831Z',
  },
  64019: {
    code: 64019,
    message: 'Pay: Required payment information incomplete',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64019\r\n\r\n### Pay: Required payment information incomplete\r\n\r\n A 64019 Error is an indication that the pieces of payment information indicated as required were not captured.\r\n\r\n#### Possible Causes\r\n* Postal code and Security code were marked as required but not captured during the payment flow\r\n* BankAccountNumber and BankRoutingNumber were not captured\r\n* Credit Card Number and Expiration Date were not captured\r\n* Status parameter value was set to "complete" before all payment information was captured\r\n\r\n#### Possible Solutions\r\n* Set Status parameter to "complete" only after all payment information is received via the Capture parameter',
    causes:
      '* Postal code and Security code were marked as required but not captured during the payment flow\r\n* BankAccountNumber and BankRoutingNumber were not captured\r\n* Credit Card Number and Expiration Date were not captured\r\n* Status parameter value was set to "complete" before all payment information was captured',
    solutions:
      '* Set Status parameter to "complete" only after all payment information is received via the Capture parameter',
    description:
      'A 64019 Error is an indication that the pieces of payment information indicated as required were not captured.',
    product: 'Programmable Voice',
    date_created: '2020-05-05T23:05:11Z',
    last_updated: '2020-08-04T10:00:03.385Z',
  },
  17009: {
    code: 17009,
    message: 'Internal Server Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 17009\r\n\r\n### Internal Server Error\r\n\r\n The requested resource failed to complete the request. \r\n\r\n#### Possible Causes\r\nThe requested resource failed to complete the request. \r\n\r\n#### Possible Solutions\r\nThe request should be retried using exponential backoff strategy until it succeeds.',
    causes: 'The requested resource failed to complete the request. ',
    solutions:
      'The request should be retried using exponential backoff strategy until it succeeds.',
    description: 'The requested resource failed to complete the request. ',
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:35:59Z',
    last_updated: '2020-09-29T19:35:59Z',
  },
  48031: {
    code: 48031,
    message:
      'Outgoing conversation: Conversation with this contact and proxy address already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48031\r\n\r\n### Outgoing conversation: Conversation with this contact and proxy address already exists\r\n\r\n A conversation could not be created because the requested contact address and Twilio proxy number are already in an active conversation in the same channel.\r\n\r\n#### Possible Causes\r\n* Another Frontline user is already engaged in the conversation with the same contact using the same Twilio proxy number.\r\n* A conversation was created with the same contact using the same Twilio proxy number, but a Frontline user was never added to the conversation (i.e. the conversation was never routed to a Frontline user).\r\n\r\n#### Possible Solutions\r\n* If the conversation has a Frontline user assigned to it, ask the user engaged in the conversation to either close the conversation or transfer it to the user who initiated the new conversation creation.\r\n* If the conversation does not have any Frontline users assigned to it, either close the conversation or add the user who initiated the new conversation creation to the existing conversation.\r\n    * If inbound conversations are unintentionally not being routed to a Frontline user, you may want to check your inbound routing configuration for issues. Check out the [docs](https://www.twilio.com/docs/frontline/handle-incoming-conversations) on inbound conversation routing.',
    causes:
      '* Another Frontline user is already engaged in the conversation with the same contact using the same Twilio proxy number.\r\n* A conversation was created with the same contact using the same Twilio proxy number, but a Frontline user was never added to the conversation (i.e. the conversation was never routed to a Frontline user).',
    solutions:
      '* If the conversation has a Frontline user assigned to it, ask the user engaged in the conversation to either close the conversation or transfer it to the user who initiated the new conversation creation.\r\n* If the conversation does not have any Frontline users assigned to it, either close the conversation or add the user who initiated the new conversation creation to the existing conversation.\r\n    * If inbound conversations are unintentionally not being routed to a Frontline user, you may want to check your inbound routing configuration for issues. Check out the [docs](https://www.twilio.com/docs/frontline/handle-incoming-conversations) on inbound conversation routing.',
    description:
      'A conversation could not be created because the requested contact address and Twilio proxy number are already in an active conversation in the same channel.',
    product: 'Frontline',
    date_created: '2022-04-20T15:55:39Z',
    last_updated: '2022-04-20T15:55:39Z',
  },
  31211: {
    code: 31211,
    message: 'Call is not in the expected state.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31211\r\n\r\n### Call is not in the expected state.\r\n\r\n Call is not in the expected state.\r\n\r\n#### Possible Causes\r\nThe Call should be at least in the Ringing state to Subscribe and send Call Message.\r\n\r\n#### Possible Solutions\r\nEnsure the Call is at least in the Ringing state and the Subscription is successful and try again.',
    causes: 'The Call should be at least in the Ringing state to Subscribe and send Call Message.',
    solutions:
      'Ensure the Call is at least in the Ringing state and the Subscription is successful and try again.',
    description: 'Call is not in the expected state.',
    product: 'Programmable Voice',
    date_created: '2024-05-23T20:41:29Z',
    last_updated: '2024-05-23T20:42:37.654065Z',
  },
  45700: {
    code: 45700,
    message: 'Unexpected error occurred. Unable to process WebChat request.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45700\r\n\r\n### Unexpected error occurred. Unable to process WebChat request.\r\n\r\n An unexpected error occurred when processing create WebChat conversation request. \r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error while processing your create WebChat endpoint.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our [status page](https://status.twilio.com/) to see if we are having an outage.\r\n\r\nIf our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error while processing your create WebChat endpoint.',
    solutions:
      'Retry the request.\r\n\r\nCheck our [status page](https://status.twilio.com/) to see if we are having an outage.\r\n\r\nIf our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.',
    description:
      'An unexpected error occurred when processing create WebChat conversation request. ',
    product: 'Flex',
    date_created: '2022-10-03T20:38:45Z',
    last_updated: '2022-10-03T21:04:39.827265Z',
  },
  60410: {
    code: 60410,
    message: 'Verification delivery attempt blocked',
    log_level: 'ERROR',
    secondary_message: 'A verification delivery attempt was blocked. ',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60410\r\n\r\n### Verification delivery attempt blocked\r\n\r\nA verification delivery attempt was blocked.  This is because [Fraud Guard](/docs/verify/preventing-toll-fraud/sms-fraud-guard) has identified potential fraudulent messages being sent to one or more destination. A temporary block on SMS traffic has been placed for the next 12 hours on the prefix you used. This block will be lifted at the end of this 12-hour period. If further fraudulent activity is detected after this block, this pattern will continue with further temporary 12 hour blocks until the issue is no longer observed.\r\n\r\n#### Possible Causes\r\nWe [identified SMS fraud](https://www.twilio.com/docs/verify/preventing-toll-fraud/sms-fraud-guard) occurring within your Verify product.\r\n\r\n#### Possible Solutions\r\nYou do not need to take any specific action. The block is temporary and will resolve in 12 hours if we do not detect additional fraud.',
    causes:
      'We [identified SMS fraud](https://www.twilio.com/docs/verify/preventing-toll-fraud/sms-fraud-guard) occurring within your Verify product.',
    solutions:
      'You do not need to take any specific action. The block is temporary and will resolve in 12 hours if we do not detect additional fraud.',
    description:
      'This is because [Fraud Guard](/docs/verify/preventing-toll-fraud/sms-fraud-guard) has identified potential fraudulent messages being sent to one or more destination. A temporary block on SMS traffic has been placed for the next 12 hours on the prefix you used. This block will be lifted at the end of this 12-hour period. If further fraudulent activity is detected after this block, this pattern will continue with further temporary 12 hour blocks until the issue is no longer observed.',
    product: 'Verify',
    date_created: '2022-03-15T12:01:33Z',
    last_updated: '2023-08-09T13:33:33.231756Z',
  },
  13611: {
    code: 13611,
    message: 'Record: Invalid timeout value',
    log_level: 'WARNING',
    secondary_message:
      "timeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/record#timeout'>Record Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13611 \n\n### Record: Invalid timeout value\n\ntimeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/record#timeout'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:44Z',
    last_updated: '2020-08-04T10:00:27.857Z',
  },
  50708: {
    code: 50708,
    message: 'ChatbotConfiguration.FriendlyName is required parameter.',
    log_level: 'ERROR',
    secondary_message: 'ChatbotConfiguration.FriendlyName is required parameter.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50708\r\n\r\n### ChatbotConfiguration.FriendlyName is required parameter.\r\n\r\nChatbotConfiguration.FriendlyName is required parameter. \r\n\r\n#### Possible Causes\r\nYou are trying to create Virtual Agent participant without ChatbotConfiguration.FriendlyName parameter.\r\n\r\n#### Possible Solutions\r\n* Specify ChatbotConfiguration.FriendlyName parameter.',
    causes:
      'You are trying to create Virtual Agent participant without ChatbotConfiguration.FriendlyName parameter.',
    solutions: '* Specify ChatbotConfiguration.FriendlyName parameter.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:05:50Z',
    last_updated: '2023-10-11T18:05:50Z',
  },
  20012: {
    code: 20012,
    message: 'Invalid TLSv1.2 Cipher Suite',
    log_level: 'ERROR',
    secondary_message: 'Request is not configured with a PCI compliant cipher suite',
    log_type: 'APPLICATION',
    docs: '## ERROR - 20012\r\n\r\n### Invalid TLSv1.2 Cipher Suite\r\n\r\nRequest is not configured with a PCI compliant cipher suite ## Error Code 20012\r\n\r\n### Invalid TLSv1.2 Cipher Suite\r\n\r\nThe request was rejected because it was not correctly configured to use TLSv1.2. All new accounts are [required to use TLSv1.2 with supported ciphers suites](https://support.twilio.com/hc/en-us/articles/360007724794). \r\n\r\n#### Possible Solutions:\r\n* Reconfigure request to use a supported cipher suite for TLSv1.2\r\n* Review these [tips for upgrading your environment to TLSv1.2](https://support.twilio.com/hc/en-us/articles/360006751753)\r\n\r\n#### Supported Cipher Suites:\r\n* TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA (ecdh_x25519) - A\r\n* TLS_RSA_WITH_AES_128_GCM_SHA256 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_128_CBC_SHA256 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_128_CBC_SHA (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_256_GCM_SHA384 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_256_CBC_SHA256 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_256_CBC_SHA (rsa 2048) - A\r\n* TLS_RSA_WITH_3DES_EDE_CBC_SHA (rsa 2048) - C\r\n\r\n#### Possible Causes\r\nSupported Cipher Suites list is not reflecting the reality.\r\n\r\n#### Possible Solutions\r\nChanged with the real list which is checked ',
    causes: 'Supported Cipher Suites list is not reflecting the reality.',
    solutions: 'Changed with the real list which is checked ',
    description:
      '## Error Code 20012\r\n\r\n### Invalid TLSv1.2 Cipher Suite\r\n\r\nThe request was rejected because it was not correctly configured to use TLSv1.2. All new accounts are [required to use TLSv1.2 with supported ciphers suites](https://support.twilio.com/hc/en-us/articles/360007724794). \r\n\r\n#### Possible Solutions:\r\n* Reconfigure request to use a supported cipher suite for TLSv1.2\r\n* Review these [tips for upgrading your environment to TLSv1.2](https://support.twilio.com/hc/en-us/articles/360006751753)\r\n\r\n#### Supported Cipher Suites:\r\n* TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384 (ecdh_x25519) - A\r\n* TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA (ecdh_x25519) - A\r\n* TLS_RSA_WITH_AES_128_GCM_SHA256 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_128_CBC_SHA256 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_128_CBC_SHA (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_256_GCM_SHA384 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_256_CBC_SHA256 (rsa 2048) - A\r\n* TLS_RSA_WITH_AES_256_CBC_SHA (rsa 2048) - A\r\n* TLS_RSA_WITH_3DES_EDE_CBC_SHA (rsa 2048) - C',
    product: null,
    date_created: '2019-01-30T22:43:25Z',
    last_updated: '2022-10-21T10:09:32.330465Z',
  },
  62006: {
    code: 62006,
    message: ' MPLS carrier is not associated with the exchange.',
    log_level: 'ERROR',
    secondary_message:
      'The MPLS carrier SID in the request is not associated with the exchange SID in the request. Choose an MPLS carrier SID that is associated with the exchange SID, or choose an exchange SID that is associated with the MPLS carrier SID.',
    log_type: null,
    docs: '## Error - 62006\r\n\r\n### MPLS carrier is not associated with the exchange\r\n\r\nThe MPLS carrier SID in the request is not associated with the exchange SID\r\nin the request. Choose an MPLS carrier SID that is associated with the\r\nexchange SID, or choose an exchange SID that is associated with the MPLS\r\ncarrier SID.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:36:20Z',
    last_updated: '2020-08-04T10:00:21.091Z',
  },
  34106: {
    code: 34106,
    message: 'No Fax TwiML action specified',
    log_level: 'ERROR',
    secondary_message: 'Missing Receive verb in TwiML',
    log_type: null,
    docs: '## Error - 34106\r\n### Fax: No Fax TwiML action specified\r\n\r\nMissing [Receive](https://www.twilio.com/docs/api/fax/receive#receive) verb in received TwiML.\r\n\r\nSimplest implementation is `<Receive />`',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Fax',
    date_created: '2017-09-08T04:30:59Z',
    last_updated: '2020-08-04T10:00:17.134Z',
  },
  30471: {
    code: 30471,
    message: 'Toll Free verification rejection - High Risk - Non-secured URL in sample message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30471\r\n\r\n### Toll Free verification rejection - High Risk - Non-secured URL in sample message\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nToll-Free phone number cannot be verified because the campaign provided an unsecure URL in the sample message. URLs sent in message content are required to support the https: protocol and the sample message needs to reflect that.\r\n\r\n#### Possible Solutions\r\n* Correct the URL with https:// in your sample message and resubmit the verification\r\n* Ensure that any URL’s sent in messages will be secured with https://\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'Toll-Free phone number cannot be verified because the campaign provided an unsecure URL in the sample message. URLs sent in message content are required to support the https: protocol and the sample message needs to reflect that.',
    solutions:
      '* Correct the URL with https:// in your sample message and resubmit the verification\r\n* Ensure that any URL’s sent in messages will be secured with https://\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:29:18Z',
    last_updated: '2024-02-22T21:29:18Z',
  },
  64006: {
    code: 64006,
    message: 'Pay: Connector does not support token type.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64006\r\n\r\n### Pay: Connector does not support token type.\r\n\r\n ## Error - 64006\r\n\r\n### Pay: Connector does not support token type.\r\n\r\n Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\nA 64006 Error is an indication that the request to tokenize of a particular type is not supported by the &lt;Pay&gt; connector.  For instance, tokenType="one-time" was used but\r\nonly tokenType="reusable" is supported.\r\n\r\n#### Possible Causes\r\n* The paymentConnector attribute points to a Connector that does not support the requested type of tokenization.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports the tokenization type you want.\r\n* Make sure you specify the tokenType that matches what you want to perform.',
    causes:
      '* The paymentConnector attribute points to a Connector that does not support the requested type of tokenization.',
    solutions:
      '* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports the tokenization type you want.\r\n* Make sure you specify the tokenType that matches what you want to perform.',
    description:
      '## Error - 64006\r\n\r\n### Pay: Connector does not support token type.\r\n\r\n Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\nA 64006 Error is an indication that the request to tokenize of a particular type is not supported by the &lt;Pay&gt; connector.  For instance, tokenType="one-time" was used but\r\nonly tokenType="reusable" is supported.',
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:57:11Z',
    last_updated: '2020-08-04T10:00:10.281Z',
  },
  32021: {
    code: 32021,
    message: 'SHAKEN/STIR call verification failed',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## WARNING - 32021\r\n\r\n### SHAKEN/STIR call verification failed\r\n\r\n Twilio cannot verify incoming SHAKEN PASSporT from carrier\r\n\r\n#### Possible Causes\r\nSee the error message for details\r\n\r\n#### Possible Solutions\r\nNo action required. Incoming call to your Twilio number can still be established without verstat.',
    causes: 'See the error message for details',
    solutions:
      'No action required. Incoming call to your Twilio number can still be established without verstat.',
    description: 'Twilio cannot verify incoming SHAKEN PASSporT from carrier',
    product: 'Programmable Voice',
    date_created: '2020-02-03T19:48:01Z',
    last_updated: '2020-08-04T10:00:04.721Z',
  },
  33119: {
    code: 33119,
    message: 'SIM connectivity reset not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33119\r\n\r\n### SIM connectivity reset not allowed\r\n\r\n Raised whenever a SIM connectivity reset is requested but not permitted.\r\n\r\n\r\n#### Possible Causes\r\n * This operation is temporarily unavailable because the downstream carrier is undergoing maintenance and not accepting requests.\r\n * Your SIM either does not support this operation or is not in a status where it can connect to a cellular network.\r\n\r\n\r\n#### Possible Solutions\r\n * Try again later if there is an ongoing maintenance.\r\n * Verify the SIM is not a Narrowband SIM.\r\n * Ensure the SIM is either in status `ready` or `active`.\r\n',
    causes:
      ' * This operation is temporarily unavailable because the downstream carrier is undergoing maintenance and not accepting requests.\r\n * Your SIM either does not support this operation or is not in a status where it can connect to a cellular network.\r\n',
    solutions:
      ' * Try again later if there is an ongoing maintenance.\r\n * Verify the SIM is not a Narrowband SIM.\r\n * Ensure the SIM is either in status `ready` or `active`.\r\n',
    description: 'Raised whenever a SIM connectivity reset is requested but not permitted.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:23:17Z',
    last_updated: '2020-09-15T11:23:17Z',
  },
  31604: {
    code: 31604,
    message: 'Does Not Exist Anywhere',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31604\r\n\r\n### Does Not Exist Anywhere\r\n\r\nThe requested callee does not exist anywhere.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:50:35Z',
    last_updated: '2020-08-04T10:00:08.115Z',
  },
  32500: {
    code: 32500,
    message: 'Voice Conversation: Generic error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32500\r\n\r\n### Voice Conversation: Generic error.\r\n\r\n Request through Voice Conversation Service failed.\r\n\r\n#### Possible Causes\r\n- Some error occurred during communication with Twilio internal services.\r\n\r\n#### Possible Solutions\r\n- See the Debugger in Console for further information. If this is a continuous experience, please contact Twilio Support.',
    causes: '- Some error occurred during communication with Twilio internal services.',
    solutions:
      '- See the Debugger in Console for further information. If this is a continuous experience, please contact Twilio Support.',
    description: 'Request through Voice Conversation Service failed.',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:34:36Z',
    last_updated: '2022-07-29T16:29:20.61573Z',
  },
  32101: {
    code: 32101,
    message: 'SIP: Invalid phone number',
    log_level: 'WARNING',
    secondary_message:
      'The called number is not a valid E.164 number. Make sure that any phone number sent via SIP to Twilio is always E.164-formatted.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 32101\r\n\r\n### SIP: Invalid phone number\r\n\r\nThe called number is not a valid E.164 number. Make sure that any phone number sent via SIP to Twilio is always E.164-formatted. SIP: Invalid phone number\r\n\r\n\r\n#### Possible Causes\r\nThe called number is not a valid [E.164](https://www.twilio.com/docs/glossary/what-e164) number.\r\n\r\n#### Possible Solutions\r\nMake sure that any phone number sent via SIP to Twilio is always E.164-formatted.',
    causes:
      'The called number is not a valid [E.164](https://www.twilio.com/docs/glossary/what-e164) number.',
    solutions: 'Make sure that any phone number sent via SIP to Twilio is always E.164-formatted.',
    description: 'SIP: Invalid phone number\r\n',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:14:36Z',
    last_updated: '2023-01-10T20:17:14.574139Z',
  },
  64014: {
    code: 64014,
    message: 'Pay: ECP/ACH requires AVSName Parameter in the <Pay> verb.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64014\r\n\r\n### Pay: ECP/ACH requires AVSName Parameter in the <Pay> verb.\r\n\r\n A 64014 Error is an indication that the provided paymentMethod attribute "ach-debit" was used, but the AVSName Parameter was not found inside the <Pay> verb.\r\n\r\n#### Possible Causes\r\nElectronic Check Processing requires a name.\r\n\r\n#### Possible Solutions\r\nMake sure a "AVSName" Parameter element exists inside the <Pay> verb.\r\n\r\nExample:\r\n```\r\n<Pay paymentMethod="ach-debit" ...>\r\n  <Parameter name="AVSName" value="john smith" />\r\n</Pay\r\n```\r\n',
    causes: 'Electronic Check Processing requires a name.',
    solutions:
      'Make sure a "AVSName" Parameter element exists inside the <Pay> verb.\r\n\r\nExample:\r\n```\r\n<Pay paymentMethod="ach-debit" ...>\r\n  <Parameter name="AVSName" value="john smith" />\r\n</Pay\r\n```\r\n',
    description:
      'A 64014 Error is an indication that the provided paymentMethod attribute "ach-debit" was used, but the AVSName Parameter was not found inside the <Pay> verb.',
    product: 'Programmable Voice',
    date_created: '2019-08-23T03:55:11Z',
    last_updated: '2020-08-04T10:00:07.173Z',
  },
  19056: {
    code: 19056,
    message: 'Input request content type is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19056\r\n\r\n### Input request content type is invalid\r\n\r\n Input request content type is invalid\r\n\r\n#### Possible Causes\r\nAttempt to use invalid content type in input request\r\n\r\n#### Possible Solutions\r\nProvide correct content type in input request',
    causes: 'Attempt to use invalid content type in input request',
    solutions: 'Provide correct content type in input request',
    description: 'Input request content type is invalid',
    product: 'Contacts',
    date_created: '2020-08-17T18:37:05Z',
    last_updated: '2020-08-24T18:18:51.855Z',
  },
  80504: {
    code: 80504,
    message: 'An internal server error has occurred.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 80504\r\n\r\n### An internal server error has occurred.\r\n\r\n An internal server error has occurred.\r\n\r\n#### Possible Causes\r\nAn internal server error has occurred.\r\n\r\n#### Possible Solutions\r\nNo action required.',
    causes: 'An internal server error has occurred.',
    solutions: 'No action required.',
    description: 'An internal server error has occurred.',
    product: 'Proxy',
    date_created: '2020-03-10T20:53:56Z',
    last_updated: '2020-08-04T10:00:04.463Z',
  },
  22401: {
    code: 22401,
    message: 'Phone Number Instance fields are not supported within region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22401\r\n\r\n### Phone Number Instance fields are not supported within region\r\n\r\n The fields you are attempting to update are not supported within the region specified.\r\n\r\n#### Possible Causes\r\nThe feature is not supported within the region.\r\n\r\n#### Possible Solutions\r\nPlease refer to documentation to understand which fields are supported.',
    causes: 'The feature is not supported within the region.',
    solutions: 'Please refer to documentation to understand which fields are supported.',
    description:
      'The fields you are attempting to update are not supported within the region specified.',
    product: 'Phone Numbers',
    date_created: '2022-04-26T14:09:35Z',
    last_updated: '2022-04-26T14:09:35Z',
  },
  17001: {
    code: 17001,
    message: "Completed summary for this call wasn't found",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 17001\r\n\r\n### Completed summary for this call wasn't found\r\n\r\n This error code is returned by the /Summary API when a completed summary is requested and it doesn't exist.\r\n\r\n#### Possible Causes\r\nThe call SID for the call is valid, but the call summarization process was not complete at the time of the request. Summarization takes 30 minutes to complete.\r\n\r\n#### Possible Solutions\r\nTo see results immediately, use the ProcessingState=partial query parameter, which will return a 200, but the response will contain only a partial or incomplete information until the summarization is completed. ",
    causes:
      'The call SID for the call is valid, but the call summarization process was not complete at the time of the request. Summarization takes 30 minutes to complete.',
    solutions:
      'To see results immediately, use the ProcessingState=partial query parameter, which will return a 200, but the response will contain only a partial or incomplete information until the summarization is completed. ',
    description:
      "This error code is returned by the /Summary API when a completed summary is requested and it doesn't exist.",
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:25:57Z',
    last_updated: '2020-09-29T19:25:57Z',
  },
  90016: {
    code: 90016,
    message:
      "'Template' or 'TemplateSid'/'TemplateLanguage' is required to send a Template Message",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90016\r\n\r\n### 'Template' or 'TemplateSid'/'TemplateLanguage' is required to send a Template Message\r\n\r\n 'Template' or 'TemplateSid'/'TemplateLanguage' is required to send a Template Message\r\n\r\n#### Possible Causes\r\nSome template parameters are provided but Template (or TemplateSid) itself is not provide.\r\n\r\n#### Possible Solutions\r\nProvide Template or TemplateSid&TemplateLanguage in the create message request",
    causes:
      'Some template parameters are provided but Template (or TemplateSid) itself is not provide.',
    solutions: 'Provide Template or TemplateSid&TemplateLanguage in the create message request',
    description:
      "'Template' or 'TemplateSid'/'TemplateLanguage' is required to send a Template Message",
    product: null,
    date_created: '2020-12-11T08:40:29Z',
    last_updated: '2020-12-11T08:40:29Z',
  },
  21731: {
    code: 21731,
    message: 'Cannot perform operation on suspended brand',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21731\r\n\r\n### Cannot perform operation on suspended brand\r\n\r\n When an A2P 10DLC Brand is in a suspended state, the following operations are not allowed:\r\n• Create a new campaign - when you try to create a new campaign using a suspended brand, this error code is returned\r\n• Update brand - when you try to update a suspended brand, this error code is returned\r\n\r\n\r\n#### Possible Causes\r\nYour Brand has been suspended because of one or more violations against the US A2P 10DLC policies.\r\n\r\n#### Possible Solutions\r\nThe Twilio team should be reaching out to you to provide guidance on how to fix the suspended Brand. Please check your email or the Twilio Support Center. If you don’t see anything, please raise a ticket with the Twilio Support team.',
    causes:
      'Your Brand has been suspended because of one or more violations against the US A2P 10DLC policies.',
    solutions:
      'The Twilio team should be reaching out to you to provide guidance on how to fix the suspended Brand. Please check your email or the Twilio Support Center. If you don’t see anything, please raise a ticket with the Twilio Support team.',
    description:
      'When an A2P 10DLC Brand is in a suspended state, the following operations are not allowed:\r\n• Create a new campaign - when you try to create a new campaign using a suspended brand, this error code is returned\r\n• Update brand - when you try to update a suspended brand, this error code is returned\r\n',
    product: 'Programmable Messaging',
    date_created: '2023-08-09T14:01:35Z',
    last_updated: '2023-08-09T14:08:13.888102Z',
  },
  50107: {
    code: 50107,
    message: 'Programmable Chat: User not authorized for command',
    log_level: 'ERROR',
    secondary_message:
      'Specified User is not authorized for this command due to his Role or Permissions set.',
    log_type: null,
    docs: "## Error - 50107\r\n\r\n### Programmable Chat: User not authorized for command\t\r\n\r\n#### Possible Causes \r\n*  Specified User is not authorized for this command due to his Role or Permissions set.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role and Permissions exist for this User to execute request's provided command. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:48Z',
    last_updated: '2020-08-04T10:00:23.359Z',
  },
  53109: {
    code: 53109,
    message: 'Timeout is out of range',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53109: Timeout is out of range\r\n\r\nRaised in the REST API when Timeout is set out of range.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with Timeout out of range.\r\n\r\n#### Solutions\r\n\r\n * Set the Timeout value (in seconds) from 1 second up to a maximum of 1 hour.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:45:09Z',
    last_updated: '2020-08-04T10:00:19.535Z',
  },
  63001: {
    code: 63001,
    message:
      'Channel could not authenticate the request. Please see Channel specific error message for more information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 63001\r\n\r\n### Channel could not authenticate the request. Please see Channel specific error message for more information\r\n\r\n The Channel could not authenticate the request. Please see Channel specific error message for more information.\r\n\r\n#### Possible Causes\r\n*   The Channel could not authenticate the request. Please see Channel specific error message for more information.\r\n*   Facebook identified a potential security issue and rotated the token\r\n*   The Facebook user who connected the FB page to Twilio has changed their password\r\n*   The user de-authorized the Twilio app\r\n\r\n#### Possible Solutions\r\nIf the issue persists, you may need to delete the sender and and re-add it.',
    causes:
      '*   The Channel could not authenticate the request. Please see Channel specific error message for more information.\r\n*   Facebook identified a potential security issue and rotated the token\r\n*   The Facebook user who connected the FB page to Twilio has changed their password\r\n*   The user de-authorized the Twilio app',
    solutions: 'If the issue persists, you may need to delete the sender and and re-add it.',
    description:
      'The Channel could not authenticate the request. Please see Channel specific error message for more information.',
    product: 'Programmable SMS',
    date_created: '2017-05-31T22:21:51Z',
    last_updated: '2023-04-18T20:26:50.71643Z',
  },
  62003: {
    code: 62003,
    message: 'MPLS carrier not found.',
    log_level: 'ERROR',
    secondary_message: 'The MPLS carrier SID in the request could not be found.',
    log_type: null,
    docs: '## Error - 62003\r\n\r\n### MPLS carrier not found\r\n\r\nThe MPLS carrier SID in the request could not be found.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:34:32Z',
    last_updated: '2020-08-04T10:00:21.143Z',
  },
  32009: {
    code: 32009,
    message: 'The user you tried to dial is not registered with the corresponding SIP Domain',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 32009\r\n\r\n### Dialing SIP Endpoint failure - User not registered\r\nThere was a failure attempting to Dial the specified SIP Endpoint.\r\nThe User specified is not registered.\r\n\r\n#### Possible Causes \r\n\r\nYou tried to Dial a SIP Endpoint that is not currently registered with the corresponding SIP Domain. Please check your TwiML or REST API.\r\n\r\n#### Possible Solutions\r\n\r\n* If you are using TwiML\r\nPlease check that there isn\'t a typo in  &lt;Dial&gt;&lt;Sip&gt;<b>username</b>@yoursipdomain.sip.us1.twilio.com&lt;/Sip&gt;&lt;/Dial&gt; and compare against your SIP Endpoint configuration. \r\nMake sure the <b>username</b> matches a username in the Credential List used to authenticate the SIP Endpoint with the SIP Domain. \r\n\r\n* If you are using the REST API\r\nPlease check the <b>To</b> field and verify there isn\'t a typo. Make sure the <b>username</b> matches a username in the Credential List used to authenticate the SIP Endpoint with the SIP Domain.\r\n\r\n#### Troubleshooting\r\n* Prior to dialing, you can verify that your SIP Endpoint has successfully registered in the Console "Registered SIP Endpoints" tab found on the SIP Domains page.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-10-28T19:54:55Z',
    last_updated: '2020-08-04T10:00:20.599Z',
  },
  30460: {
    code: 30460,
    message: 'Toll Free verification rejection - Disallowed: Third Party Debt Collection',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30460\r\n\r\n### Toll Free verification rejection - Disallowed: Third Party Debt Collection\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Debt collection or forgiveness: Third party debt collection). Third party debt collection is not permitted, consent must be obtained directly from end-users. \r\n\r\n"Third-party debt collection" means originating from any party other than the one who is owed the debt. For example, a hospital could send messages regarding bills for its own patients, assuming they provided opt-in to receive that messaging.\r\n\r\nDebt consolidation, debt reduction and credit repair programs are prohibited regardless if there is first-party consent. \r\n\r\nNote: While third party debt collection is not permitted, a debt collection business that has direct consent from a consumer to send related content may do so. \r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Debt collection or forgiveness: Third party debt collection). Third party debt collection is not permitted, consent must be obtained directly from end-users. \r\n\r\n"Third-party debt collection" means originating from any party other than the one who is owed the debt. For example, a hospital could send messages regarding bills for its own patients, assuming they provided opt-in to receive that messaging.\r\n\r\nDebt consolidation, debt reduction and credit repair programs are prohibited regardless if there is first-party consent. \r\n\r\nNote: While third party debt collection is not permitted, a debt collection business that has direct consent from a consumer to send related content may do so. ',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T17:15:33Z',
    last_updated: '2024-02-22T17:15:33Z',
  },
  50201: {
    code: 50201,
    message: 'Programmable Chat: User already exists',
    log_level: 'ERROR',
    secondary_message: 'Specified User already exists for this Service.',
    log_type: null,
    docs: '## Error - 50201\r\n\r\n### Programmable Chat: User already exists\r\n\r\n#### Possible Causes \r\n*  Specified User already exists for this Service.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid non-existing User is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:48Z',
    last_updated: '2020-08-04T10:00:23.322Z',
  },
  90006: {
    code: 90006,
    message: 'Invalid direction',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 90006\r\n\r\n### Invalid direction\r\n\r\n Invalid value for direction. Please contact Customer Support.\r\n\r\n#### Possible Causes\r\nWe're having trouble completing your request\r\n\r\n#### Possible Solutions\r\nContact Customer Support for help",
    causes: "We're having trouble completing your request",
    solutions: 'Contact Customer Support for help',
    description: 'Invalid value for direction. Please contact Customer Support.',
    product: 'Programmable SMS',
    date_created: '2022-01-19T11:52:47Z',
    last_updated: '2022-01-19T11:52:47Z',
  },
  22200: {
    code: 22200,
    message: 'Invalid End-User Type or Number Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22200\r\n\r\n### Invalid End-User Type or Number Type\r\n\r\n An invalid End-User Type or Number Type is included in the request to create a Bundle.\r\n\r\n#### Possible Causes\r\nThe End-User Type or Number Type is malformed or is not an acceptable value.\r\n\r\n#### Possible Solutions\r\nEnsure that the End-User Type value or Number Type value is spelled correctly or is an acceptable value from the End-User Type LIST resource or Number Type LIST resource.',
    causes: 'The End-User Type or Number Type is malformed or is not an acceptable value.',
    solutions:
      'Ensure that the End-User Type value or Number Type value is spelled correctly or is an acceptable value from the End-User Type LIST resource or Number Type LIST resource.',
    description:
      'An invalid End-User Type or Number Type is included in the request to create a Bundle.',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:39:44Z',
    last_updated: '2020-08-04T10:00:05.717Z',
  },
  64004: {
    code: 64004,
    message: 'Pay: Invalid paymentConnector attribute in TwiML.',
    log_level: 'ERROR',
    secondary_message:
      'paymentConnector attribute provided does not reference a connector configuration.',
    log_type: null,
    docs: '## Error - 64004\r\n\r\n### Pay: Invalid paymentConnector attribute in TwiML.\r\n\r\nA 64004 Error is an indication that the value provided with paymentConnector attribute of Pay verb\r\ndoes not match to a Pay Connector configuration. See the <A HREF="/docs/voice/twiml/pay#paymentconnector">Pay Verb</A> API Reference.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a Unique Name in the &lt;Pay&gt; Connector. Go to <A HREF="/console/voice/pay-connectors">this page</A> for a list of your Connectors.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:55:41Z',
    last_updated: '2020-08-04T10:00:10.316Z',
  },
  60604: {
    code: 60604,
    message: 'SendGrid Authenticated user is not authorized to send mail',
    log_level: 'ERROR',
    secondary_message: 'SendGrid Authenticated user is not authorized to send mail',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60604\r\n\r\n### SendGrid Authenticated user is not authorized to send mail\r\n\r\nSendGrid Authenticated user is not authorized to send mail SendGrid Authenticated user is not authorized to send mail\r\n\r\nHTTP status: 401\r\n\r\n#### Possible Causes\r\nSendGrid API key have no send emails privileges\r\n\r\n#### Possible Solutions\r\nUpdate your API key permissions',
    causes: 'SendGrid API key have no send emails privileges',
    solutions: 'Update your API key permissions',
    description:
      'SendGrid Authenticated user is not authorized to send mail\r\n\r\nHTTP status: 401',
    product: 'Verify',
    date_created: '2019-12-30T18:13:28Z',
    last_updated: '2021-05-18T04:58:31.248Z',
  },
  83002: {
    code: 83002,
    message: 'Super SIM cannot be registered',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83002\r\n\r\n### Super SIM cannot be registered\r\n\r\n The ICCID and Registration Code do not belong to a registrable Super SIM.\r\n\r\n#### Possible Causes\r\nYou tried to register a Super SIM that cannot be registered to your Account.\r\n\r\n#### Possible Solutions\r\nEnsure the ICCID and Registration Code you used in the request belong to a registrable Super SIM. If you are unable to register a new Super SIM, please contact Twilio Support.',
    causes: 'You tried to register a Super SIM that cannot be registered to your Account.',
    solutions:
      'Ensure the ICCID and Registration Code you used in the request belong to a registrable Super SIM. If you are unable to register a new Super SIM, please contact Twilio Support.',
    description: 'The ICCID and Registration Code do not belong to a registrable Super SIM.',
    product: 'Super SIM',
    date_created: '2021-03-22T00:01:05Z',
    last_updated: '2021-03-22T00:01:12.025Z',
  },
  18606: {
    code: 18606,
    message: "The Email domain doesn't match the website domain",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 18606\r\n\r\n### The Email domain doesn't match the website domain\r\n\r\n The Email domain doesn't match the website domain\r\n\r\n#### Possible Causes\r\nThe domain of the email address you provided doesn't match the website domain.\r\n\r\n#### Possible Solutions\r\nPlease feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.",
    causes: "The domain of the email address you provided doesn't match the website domain.",
    solutions:
      'Please feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    description: "The Email domain doesn't match the website domain",
    product: 'Phone Numbers',
    date_created: '2024-02-22T03:34:52Z',
    last_updated: '2024-02-22T03:34:52Z',
  },
  25018: {
    code: 25018,
    message: 'The request is not authorized',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25018\r\n\r\n### The request is not authorized\r\n\r\n The request is not authorized.\r\n\r\n#### Possible Causes\r\nIncorrect credentials.\r\n\r\n#### Possible Solutions\r\nVerify credentials.',
    causes: 'Incorrect credentials.',
    solutions: 'Verify credentials.',
    description: 'The request is not authorized.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:42:44Z',
    last_updated: '2023-12-04T14:22:53.613842Z',
  },
  60311: {
    code: 60311,
    message: 'Factor verification failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60311\r\n\r\n### Factor verification failed\r\n\r\n Factor verification failure.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nIt was not possible to verify a Factor.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'It was not possible to verify a Factor.',
    solutions: 'Check parameters and retry.',
    description: 'Factor verification failure.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-06-30T17:03:06Z',
    last_updated: '2021-06-30T03:43:32.824975Z',
  },
  52164: {
    code: 52164,
    message: 'No Credentials found for the supplied Binding Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52131\r\n\r\n### Invalid APNs credentials\r\n\r\n#### Possible Causes \r\n*  The Webhook Credential was configured for the wrong Binding Type\r\n*  Your token endpoint responded with the respective error code by mistake\r\n*  An internal Twilio error occurred\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credential is set up for the correct Binding Type\r\n*  Verify that your token endpoint is set up correctly',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T11:52:27Z',
    last_updated: '2020-08-04T10:00:14.325Z',
  },
  21501: {
    code: 21501,
    message: 'Resource not available',
    log_level: 'ERROR',
    secondary_message: 'The resource you requested is not (yet) available.',
    log_type: null,
    docs: "## Error - 21501 \n\n### Resource not available\n\nThe resource you requested is not (yet) available.\n\n#### Possible Causes \n*  Most likely you're fetching a Recording resource that is temporarily performing some post-processing, and will be available momentarily.\n\n\n#### Possible Solutions\n*  Retry the HTTP request again.  The Retry-After header will tell you when to retry.  Within a couple seconds should be ample.\t\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:01Z',
    last_updated: '2020-08-04T10:00:26.815Z',
  },
  30122: {
    code: 30122,
    message: 'Fallback URL is invalid',
    log_level: 'ERROR',
    secondary_message: 'Fallback URL is invalid, please check the format of the URL parameter',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30122\r\n\r\n### Fallback URL is invalid\r\n\r\nFallback URL is invalid, please check the format of the URL parameter Fallback URL is invalid\r\n\r\n#### Possible Causes\r\nThe fallbackUrl field has incorrectly formatted URL\r\n\r\n#### Possible Solutions\r\nUse a correctly formatted URL in the fallbackUrl field',
    causes: 'The fallbackUrl field has incorrectly formatted URL',
    solutions: 'Use a correctly formatted URL in the fallbackUrl field',
    description: 'Fallback URL is invalid',
    product: 'Programmable SMS',
    date_created: '2022-02-09T19:30:08Z',
    last_updated: '2022-02-09T19:30:08Z',
  },
  33108: {
    code: 33108,
    message: 'Rate Plan not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 33108\r\n\r\n### Rate Plan not found\r\n\r\n Raised whenever the given Rate Plan is not found.\r\n\r\n\r\n#### Possible Causes\r\n * While updating a SIM's Rate Plan, your request was rejected because the Rate Plan was not found.\r\n * While transferring a SIM to another Account, your request was rejected because the given Rate Plan was not found in the target Account.\r\n\r\n\r\n#### Possible Solutions\r\n * While updating a SIM's Rate Plan, ensure the provided `RatePlan` exists on your Account.\r\n * While transferring a SIM to another Account, ensure the provided `RatePlan` is present in the target Account.\r\n",
    causes:
      " * While updating a SIM's Rate Plan, your request was rejected because the Rate Plan was not found.\r\n * While transferring a SIM to another Account, your request was rejected because the given Rate Plan was not found in the target Account.\r\n",
    solutions:
      " * While updating a SIM's Rate Plan, ensure the provided `RatePlan` exists on your Account.\r\n * While transferring a SIM to another Account, ensure the provided `RatePlan` is present in the target Account.\r\n",
    description: 'Raised whenever the given Rate Plan is not found.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:20:54Z',
    last_updated: '2020-09-15T11:20:54Z',
  },
  25021: {
    code: 25021,
    message: 'Rate limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25021\r\n\r\n### Rate limit exceeded\r\n\r\n Rate limit exceeded.\r\n\r\n#### Possible Causes\r\nYour application is requesting Organization API resources at a rate that is higher than allowed.\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.',
    causes:
      'Your application is requesting Organization API resources at a rate that is higher than allowed.',
    solutions:
      'Verify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.',
    description: 'Rate limit exceeded.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:49:07Z',
    last_updated: '2023-12-04T14:23:40.058866Z',
  },
  57018: {
    code: 57018,
    message: "'Event' value type must be Map",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57018\r\n\r\n### 'Event' value type must be Map\r\n\r\n Specified 'Event' value type is invalid, Map required\r\n\r\n#### Possible Causes\r\nSpecified \"Event\" value must be Map\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Event' is being passed in request. ",
    causes: 'Specified "Event" value must be Map',
    solutions: "Confirm a valid 'Event' is being passed in request. ",
    description: "Specified 'Event' value type is invalid, Map required",
    product: 'Programmable SMS',
    date_created: '2021-06-11T19:08:42Z',
    last_updated: '2021-06-11T19:08:42Z',
  },
  50328: {
    code: 50328,
    message: 'Programmable Chat: Channel webhook type not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain parameter for webhook type',
    log_type: null,
    docs: '## Error - 50328\r\n\r\n### Programmable Chat: Channel webhook type not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook type.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:01:49Z',
    last_updated: '2020-08-04T10:00:11.999Z',
  },
  60517: {
    code: 60517,
    message: 'SNA User-Agent Mismatch Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60517\r\n\r\n### SNA User-Agent Mismatch Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received but failed during processing due to a User-Agent mismatch detected during redirects.\r\n\r\n#### Possible Solutions\r\nRetry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received but failed during processing due to a User-Agent mismatch detected during redirects.',
    solutions:
      'Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T16:48:34Z',
    last_updated: '2022-08-30T16:48:34Z',
  },
  57003: {
    code: 57003,
    message: "'Secret id' is invalid for this Partner",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57003\r\n\r\n### 'Secret id' is invalid for this Partner\r\n\r\n 'Secret id' is invalid for this Partner\r\n\r\n#### Possible Causes\r\n'Secret id' is invalid for this Partner\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Secret id' is being passed in request. ",
    causes: "'Secret id' is invalid for this Partner",
    solutions: "Confirm a valid 'Secret id' is being passed in request. ",
    description: "'Secret id' is invalid for this Partner",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:46:13Z',
    last_updated: '2021-05-31T08:59:41.693Z',
  },
  64022: {
    code: 64022,
    message: 'Pay: Invalid Test Card Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64022\r\n\r\n### Pay: Invalid Test Card Number\r\n\r\n A 64022 error is an indication that your Pay Connector is in TEST mode, but you did not provide a valid test card number when testing a payment.\r\n\r\n#### Possible Causes\r\n* Your pay connector is in TEST mode and you provided an invalid test card number when testing a payment. For compliance reasons, we can only allow certain test card numbers in TEST mode.\r\n\r\n#### Possible Solutions\r\n* Check the documentation for the pay connector in the Twilio Console or in our Twilio docs for valid test card numbers that can be used when in TEST mode.',
    causes:
      '* Your pay connector is in TEST mode and you provided an invalid test card number when testing a payment. For compliance reasons, we can only allow certain test card numbers in TEST mode.',
    solutions:
      '* Check the documentation for the pay connector in the Twilio Console or in our Twilio docs for valid test card numbers that can be used when in TEST mode.',
    description:
      'A 64022 error is an indication that your Pay Connector is in TEST mode, but you did not provide a valid test card number when testing a payment.',
    product: 'Programmable Voice',
    date_created: '2023-04-12T16:26:59Z',
    last_updated: '2023-04-12T16:26:59Z',
  },
  54003: {
    code: 54003,
    message: 'Invalid If-Match header',
    log_level: 'ERROR',
    secondary_message: 'The specified If-Match header is invalid.',
    log_type: null,
    docs: '\n## Error - 54003\n\n### Sync: Invalid If-Match header\nThe specified If-Match header cannot be used for concurrency control.\n\n#### Possible Causes\n* The value specified in the If-Match header is not a valid Sync object revision.\n\n#### Possible Solutions\nThe value you provide should be a revision assigned by the Sync service when interacting with an object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.828Z',
  },
  80802: {
    code: 80802,
    message: 'Simultaneous requests to create the same Identifier in one or more Sessions',
    log_level: 'ERROR',
    secondary_message: 'Possible duplicate Participant created in multiple Sessions.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 80802\r\n\r\n### Simultaneous requests to create the same Identifier in one or more Sessions\r\n\r\nPossible duplicate Participant created in multiple Sessions. Multiple requests to the create-participant endpoint with the same identifier were made simultaneously or very close in time.  This can result in the same proxy-identifier being assigned, causing Participants with the same Identifier/ProxyIdentifier pair to be active in multiple Sessions.  This can result in calls and messages from affected Participants being routed to unintended recipients.\r\n\r\n#### Possible Causes\r\nMultiple requests to the create-participant endpoint with the same identifier were made simultaneously or very close in time. \r\n\r\n#### Possible Solutions\r\n1. If you are trying to add the same person to multiple Sessions, make the requests sequentially.\r\n\r\n2. Request that the ProxyAllowParticipantConflict flag be removed from your account.  Proxy will reject requests that could result in having multiple Participants in active sessions with the same Identifier/ProxyIdentifier pair.  In this case, Session create or Participant create, Proxy will return a 409 status code.  You can retry the failed request after the previous (conflicting) request has completed.  However, in order to opt-in to this behavior, the ProxyAllowParticipantConflict flag on your account must be removed*.  See option 3 for details on how to opt-in to this behavior on a per-request basis if you wish to do some testing first.\r\n\r\n3. Include the form parameter FailOnParticipantConflict=True in your requests to Participant create (and/or Session create, if you include participant parameters) to allow Proxy to reject the request if it would result in this condition.  Proxy will return a 409 (error code 80623) in this case.\r\n\r\n*Note that this flag also impacts the behavior of the Session update endpoint, on attempting to re-open closed sessions, when those requests would result in the condition described.  This endpoint would return 400 (error code 80604).',
    causes:
      'Multiple requests to the create-participant endpoint with the same identifier were made simultaneously or very close in time. ',
    solutions:
      '1. If you are trying to add the same person to multiple Sessions, make the requests sequentially.\r\n\r\n2. Request that the ProxyAllowParticipantConflict flag be removed from your account.  Proxy will reject requests that could result in having multiple Participants in active sessions with the same Identifier/ProxyIdentifier pair.  In this case, Session create or Participant create, Proxy will return a 409 status code.  You can retry the failed request after the previous (conflicting) request has completed.  However, in order to opt-in to this behavior, the ProxyAllowParticipantConflict flag on your account must be removed*.  See option 3 for details on how to opt-in to this behavior on a per-request basis if you wish to do some testing first.\r\n\r\n3. Include the form parameter FailOnParticipantConflict=True in your requests to Participant create (and/or Session create, if you include participant parameters) to allow Proxy to reject the request if it would result in this condition.  Proxy will return a 409 (error code 80623) in this case.\r\n\r\n*Note that this flag also impacts the behavior of the Session update endpoint, on attempting to re-open closed sessions, when those requests would result in the condition described.  This endpoint would return 400 (error code 80604).',
    description:
      'Multiple requests to the create-participant endpoint with the same identifier were made simultaneously or very close in time.  This can result in the same proxy-identifier being assigned, causing Participants with the same Identifier/ProxyIdentifier pair to be active in multiple Sessions.  This can result in calls and messages from affected Participants being routed to unintended recipients.',
    product: 'Proxy',
    date_created: '2020-07-29T23:42:46Z',
    last_updated: '2020-09-11T03:33:16.31Z',
  },
  22102: {
    code: 22102,
    message: 'Invalid Phone Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22102\r\n\r\n### Invalid Phone Number\r\n\r\n The phone number provided is not a valid number.\r\n\r\n#### Possible Causes\r\n* The phone number provided is formatted incorrectly.\r\n\r\n* The phone number provided includes a non-existent country code, area code or exchange.\r\n\r\n#### Possible Solutions\r\nPlease specify a valid phone number in [E164 format](http://en.wikipedia.org/wiki/E.164) (i.e. "+1 format").',
    causes:
      '* The phone number provided is formatted incorrectly.\r\n\r\n* The phone number provided includes a non-existent country code, area code or exchange.',
    solutions:
      'Please specify a valid phone number in [E164 format](http://en.wikipedia.org/wiki/E.164) (i.e. "+1 format").',
    description: 'The phone number provided is not a valid number.',
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:49:28Z',
    last_updated: '2023-06-29T13:23:47.682895Z',
  },
  18607: {
    code: 18607,
    message: 'Customer Profile or Trust Product is not eligible to be copied',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18607\r\n\r\n### Customer Profile or Trust Product is not eligible to be copied\r\n\r\n You can not copy the customer profile or trust product\r\n\r\n#### Possible Causes\r\nThe customer profile is not eligible to be copied\r\n\r\n#### Possible Solutions\r\nPlease move forward without copying the customer profile or trust product',
    causes: 'The customer profile is not eligible to be copied',
    solutions: 'Please move forward without copying the customer profile or trust product',
    description: 'You can not copy the customer profile or trust product',
    product: 'Phone Numbers',
    date_created: '2024-02-27T02:28:26Z',
    last_updated: '2024-02-27T02:28:26Z',
  },
  83007: {
    code: 83007,
    message: 'Unable to activate your Super SIM as it does not belong to a Fleet',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83007\r\n\r\n### Unable to activate your Super SIM as it does not belong to a Fleet\r\n\r\n Your Super SIM cannot be activated without being assigned to a Fleet.\r\n\r\n#### Possible Causes\r\n* The Super SIM is not assigned to a Fleet and the activation request did not include a Fleet.\r\n\r\n#### Possible Solutions\r\n* Provide a Fleet in the activation request or first assign your Super SIM to a Fleet and then try activating it again.',
    causes:
      '* The Super SIM is not assigned to a Fleet and the activation request did not include a Fleet.',
    solutions:
      '* Provide a Fleet in the activation request or first assign your Super SIM to a Fleet and then try activating it again.',
    description: 'Your Super SIM cannot be activated without being assigned to a Fleet.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:24:06Z',
    last_updated: '2021-08-23T11:24:06Z',
  },
  60245: {
    code: 60245,
    message: 'You have exceeded your messaging limits',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60245\r\n\r\n### You have exceeded your messaging limits\r\n\r\n You have exceeded your messaging limits\r\n\r\n#### Possible Causes\r\nThis error is returned by SendGrid if you've sent more emails than your account can handle. This error can occur for a number of reasons, including daily or hourly limits, or limits on the number of messages that can be sent at once. SendGrid uses one credit for each email, and credits renew at the beginning of each month.\r\n\r\n#### Possible Solutions\r\nContact SendGrid support to remove that limit or change your SendGrid plan. ",
    causes:
      "This error is returned by SendGrid if you've sent more emails than your account can handle. This error can occur for a number of reasons, including daily or hourly limits, or limits on the number of messages that can be sent at once. SendGrid uses one credit for each email, and credits renew at the beginning of each month.",
    solutions: 'Contact SendGrid support to remove that limit or change your SendGrid plan. ',
    description: 'You have exceeded your messaging limits',
    product: 'Verify',
    date_created: '2024-05-20T16:59:05Z',
    last_updated: '2024-05-20T16:59:05Z',
  },
  19010: {
    code: 19010,
    message: 'Invalid contact search request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19010\r\n\r\n### Invalid contact search request\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe search parameter provided is not valid\r\n\r\n#### Possible Solutions\r\nReview the API documentation for more information',
    causes: 'The search parameter provided is not valid',
    solutions: 'Review the API documentation for more information',
    description: null,
    product: null,
    date_created: '2020-07-21T18:48:55Z',
    last_updated: '2020-08-04T10:00:01.835Z',
  },
  32209: {
    code: 32209,
    message: 'SIP: Secure transport required',
    log_level: 'ERROR',
    secondary_message:
      'When secure calling is enabled, Twilio cannot accept calls made using UDP or TCP. Please use TLS.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 32209\r\n\r\n### SIP: Secure transport required\r\n\r\nWhen secure calling is enabled, Twilio cannot accept calls made using UDP or TCP. Please use TLS. \r\n\r\n#### Possible Causes\r\n* Media security is enabled on your SIP domain or trunk, but Twilio received SIP traffic over an insecure protocol, such as UDP or TCP.\r\n* You are using SIP registration, and are attempting to place a secure call to an endpoint where all of the available bindings were registered with an insecure protocol, such as UDP or TCP.\r\n\r\n#### Possible Solutions\r\n* Please ensure your PBX or end device is configured to send SIP traffic over the TLS transport.\r\n* If you are using SIP registration, your device must be configured to *register* over the TLS protocol. Devices registered over insecure protocols will not be attempted for secure calls.',
    causes:
      '* Media security is enabled on your SIP domain or trunk, but Twilio received SIP traffic over an insecure protocol, such as UDP or TCP.\r\n* You are using SIP registration, and are attempting to place a secure call to an endpoint where all of the available bindings were registered with an insecure protocol, such as UDP or TCP.',
    solutions:
      '* Please ensure your PBX or end device is configured to send SIP traffic over the TLS transport.\r\n* If you are using SIP registration, your device must be configured to *register* over the TLS protocol. Devices registered over insecure protocols will not be attempted for secure calls.',
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:39Z',
    last_updated: '2020-08-04T10:00:24.098Z',
  },
  80614: {
    code: 80614,
    message: ' No Partner Participant Found',
    log_level: 'WARNING',
    secondary_message:
      'Example Message: Incoming message or call found no target participant in session KCac74da33088913e84bfafb5b821ab0b0 for participant KP2ece38f658cdabc372ef3f149ed5977a',
    log_type: null,
    docs: '## Warning\r\n\r\n### No Partner Participant Found\r\n\r\nExample Message: Incoming message or call found no target participant in session <SessionSid> for participant <ParticipantSid>',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-04-18T21:11:05Z',
    last_updated: '2020-08-04T10:00:13.832Z',
  },
  12301: {
    code: 12301,
    message: 'Invalid Upload Content-Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 12301\r\n\r\n### Invalid Upload Content-Type\r\n\r\nTwilio is unable to process the Content-Type of the uploaded file. Please make sure the uploaded file is valid and supported.\r\n\r\n#### Possible Causes\r\n* Unsupported file format\r\n* File is malformed\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-04-11T18:36:06Z',
    last_updated: '2020-08-04T10:00:09.143Z',
  },
  50104: {
    code: 50104,
    message: 'Programmable Chat: Permission not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Permission does not exist.',
    log_type: null,
    docs: '## Error - 50104\r\n\r\n### Programmable Chat: Permission not found\t\r\n\r\n#### Possible Causes \r\n*  Specified Permission does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Permission is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:47Z',
    last_updated: '2020-08-04T10:00:23.417Z',
  },
  31002: {
    code: 31002,
    message: 'Connection declined.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31002\r\n\r\n### Connection declined.\r\n\r\nConnection declined.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:38:09Z',
    last_updated: '2020-08-04T10:00:11.29Z',
  },
  13247: {
    code: 13247,
    message: 'Dial: Invalid From number (caller ID)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13247\r\n\r\n### Dial: Invalid From number (caller ID)\r\n\r\n You attempted to initiate an outbound phone call or message, but the \'From\' parameter you supplied was not a valid phone number or alphanumeric sender ID.\r\n\r\nTwilio accepts phone numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US and Canadian numbers with any combination of non-digit separators, or Alphanumeric Sender IDs (SMS only) with up to 11 alphanumeric characters [a-zA-Z0-9]. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\nThe number must not be on a do-not-originate (DNO) list, and Alpha Sender IDs may not be generic.\r\n\r\n#### Possible Causes\r\n* You have supplied a phone number that was not in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Your `From` phone number is on a do-not-originate (DNO) list\r\n\r\n#### Possible Solutions\r\n* Ensure your number is formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Ensure that your `From` number is assigned and not on a do-not-originate (DNO) list.',
    causes:
      '* You have supplied a phone number that was not in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Your `From` phone number is on a do-not-originate (DNO) list',
    solutions:
      '* Ensure your number is formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Ensure that your `From` number is assigned and not on a do-not-originate (DNO) list.',
    description:
      'You attempted to initiate an outbound phone call or message, but the \'From\' parameter you supplied was not a valid phone number or alphanumeric sender ID.\r\n\r\nTwilio accepts phone numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US and Canadian numbers with any combination of non-digit separators, or Alphanumeric Sender IDs (SMS only) with up to 11 alphanumeric characters [a-zA-Z0-9]. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\nThe number must not be on a do-not-originate (DNO) list, and Alpha Sender IDs may not be generic.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:14:07Z',
    last_updated: '2023-10-23T16:22:42.546905Z',
  },
  48029: {
    code: 48029,
    message: 'Outgoing conversation: Contact address type does not match proxy address type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48029\r\n\r\n### Outgoing conversation: Contact address type does not match proxy address type\r\n\r\n A conversation could not be created because the provided Twilio proxy address does not match the contact’s expected channel type.\r\n\r\n#### Possible Causes\r\n* The outgoing conversation callback returned a Twilio proxy number that does not match the channel type of the contact address.\r\n\r\n#### Possible Solutions\r\n* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback has the same type as the channel over which the conversation is being created (i.e., for a WhatsApp conversation, use a Twilio proxy number with the prefix _whatsapp:_).\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/outgoing-conversations) on how to create outgoing conversations.',
    causes:
      '* The outgoing conversation callback returned a Twilio proxy number that does not match the channel type of the contact address.',
    solutions:
      '* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback has the same type as the channel over which the conversation is being created (i.e., for a WhatsApp conversation, use a Twilio proxy number with the prefix _whatsapp:_).\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/outgoing-conversations) on how to create outgoing conversations.',
    description:
      'A conversation could not be created because the provided Twilio proxy address does not match the contact’s expected channel type.',
    product: 'Frontline',
    date_created: '2022-04-20T15:54:05Z',
    last_updated: '2022-04-20T15:54:05Z',
  },
  36001: {
    code: 36001,
    message: 'Broadcast SID Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36001\r\n\r\n### Broadcast SID Not Found\r\n\r\n The Broadcast SID entered was not found\r\n\r\n#### Possible Causes\r\n* You provided an empty Broadcast SID\r\n* You provided a Broadcast SID that does not exist\r\n\r\n#### Possible Solutions\r\n* Provide a non-empty, existing Broadcast SID',
    causes:
      '* You provided an empty Broadcast SID\r\n* You provided a Broadcast SID that does not exist',
    solutions: '* Provide a non-empty, existing Broadcast SID',
    description: 'The Broadcast SID entered was not found',
    product: 'Programmable Messaging',
    date_created: '2023-12-15T21:47:15Z',
    last_updated: '2023-12-15T21:47:15Z',
  },
  45103: {
    code: 45103,
    message: 'Workspace Not Configured',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45103\r\n\r\n### Workspace Not Configured\r\n\r\n \r\n\r\n#### Possible Causes\r\nWorkspace is not defined in the configuration.\r\n\r\n#### Possible Solutions\r\nUpdate the configuration: set the workspace.',
    causes: 'Workspace is not defined in the configuration.',
    solutions: 'Update the configuration: set the workspace.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:56:00Z',
    last_updated: '2020-08-04T10:00:12.357Z',
  },
  50309: {
    code: 50309,
    message: 'Programmable Chat: Invalid Date Updated parameter',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correctly formatted parameter for Date Updated',
    log_type: 'TWILIO',
    docs: '## ERROR - 50309\r\n\r\n### Programmable Chat: Invalid Date Updated parameter\r\n\r\nRequest does not contain correctly formatted parameter for Date Updated ## Error - 50309\r\n\r\n### Programmable Chat: Invalid Date Updated parameter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for Date Updated.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Date Updated parameter is passed in request. \r\n\r\n#### Possible Causes\r\n*  Request does not contain correctly formatted parameter for Date Updated.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Date Updated parameter is passed in request. ',
    causes: '*  Request does not contain correctly formatted parameter for Date Updated.',
    solutions: '*  Confirm a valid Date Updated parameter is passed in request. ',
    description:
      '## Error - 50309\r\n\r\n### Programmable Chat: Invalid Date Updated parameter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for Date Updated.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Date Updated parameter is passed in request. ',
    product: 'Programmable Chat',
    date_created: '2017-11-06T11:58:29Z',
    last_updated: '2020-08-04T10:00:16.616Z',
  },
  80602: {
    code: 80602,
    message: 'Non Unique Service Name',
    log_level: 'WARNING',
    secondary_message: 'Service UniqueName must be unique.',
    log_type: null,
    docs: '## Warning\n\n### Non Unique Service Name\n\nExample Message: Service UniqueName must be unique.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.847Z',
  },
  20500: {
    code: 20500,
    message: 'Internal Server Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "## Error - 20500 \r\n\r\n### Internal Server Error\r\n\r\nThe Twilio API encountered an error when processing your request. This generally indicates an error in the server handling logic or a timeout in the API. We apologize for the inconvenience.\r\n\r\n#### I'm seeing a lot of these\r\n\r\nIf you are seeing a consistent pattern of 500 server errors coming from the Twilio API, check our [status page](http://status.twilio.com/) for more details. If our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.\r\n\r\n#### Is the request safe to retry?\r\n\r\nGET and DELETE requests are always safe for you to retry as they are idempotent. Some POST requests are idempotent by nature - purchasing a specific phone number, or hanging up a call - and while these may return different HTTP status codes on each attempt, the end state of the system will be the same whether you make the request one time or ten.\r\n\r\nOther POST requests - sending an SMS or triggering an outbound call - are not idempotent. If you get a 500 Server Error on these requests, and you retry the request, it is possible for a customer to receive multiple messages or calls from your application.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-06-22T15:02:09Z',
    last_updated: '2020-08-04T10:00:18.283Z',
  },
  54509: {
    code: 54509,
    message: 'Query expression contains too many operators',
    log_level: 'ERROR',
    secondary_message: 'The query expression must contain less than 30 operators',
    log_type: null,
    docs: '## Error - 54509\r\n\r\n### Sync: Query expression contains too many operators\r\nThe query expression must contain less than 30 operators.\r\n\r\n#### Possible Causes\r\n* The query expression contains 30 or more operators, probably a user-facing edge case or a programming error.\r\n\r\n#### Possible Solutions\r\n* Rewrite the query or the code generating it to use fewer operators or issue separate queries. You can use any combination of the following operators: `and`, `or`, `in`, `eq`, `not_in`, `not_eq `, `contains`, however overall number of operators in any query expression must be less than 30.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2019-03-28T08:31:03Z',
    last_updated: '2020-08-04T10:00:09.287Z',
  },
  45361: {
    code: 45361,
    message: 'Failed to add Participant. Downstream error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45361\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'Conversations API returned an error',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to add Participant to Conversation <conversation sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:38.826257Z',
  },
  90102: {
    code: 90102,
    message: 'Assistant failure to start collection',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 90102\r\n\r\n### Assistant failure to start collection\r\n\r\n Autopilot was unable to start the collection\r\n\r\n#### Possible Causes\r\nAn internal error rendered us unable to start the collection. Apologies!\r\n\r\n#### Possible Solutions\r\nIf the error persists, <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it.\r\nNote the time of the error and what you were trying to do when it occurred. Thank you!',
    causes: 'An internal error rendered us unable to start the collection. Apologies!',
    solutions:
      'If the error persists, <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it.\r\nNote the time of the error and what you were trying to do when it occurred. Thank you!',
    description: 'Autopilot was unable to start the collection',
    product: 'Understand',
    date_created: '2020-07-02T23:29:31Z',
    last_updated: '2020-08-04T10:00:02.371Z',
  },
  90013: {
    code: 90013,
    message: "'Template' or 'TemplateSid'&'TemplateLanguage' or 'MediaUrls' is required",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90013\r\n\r\n### 'Template' or 'TemplateSid'&'TemplateLanguage' or 'MediaUrls' is required\r\n\r\n 'Template' or 'TemplateSid'&'TemplateLanguage' or 'MediaUrls' is required to send Broadcast\r\n\r\n#### Possible Causes\r\nAll next attributes are missing: 'Template', 'TemplateSid', 'TemplateLanguage', 'MediaUrls'\r\n\r\n#### Possible Solutions\r\nUse one of the attributes 'Template', 'TemplateSid', 'TemplateLanguage', 'MediaUrls' to specify Broadcast content",
    causes:
      "All next attributes are missing: 'Template', 'TemplateSid', 'TemplateLanguage', 'MediaUrls'",
    solutions:
      "Use one of the attributes 'Template', 'TemplateSid', 'TemplateLanguage', 'MediaUrls' to specify Broadcast content",
    description:
      "'Template' or 'TemplateSid'&'TemplateLanguage' or 'MediaUrls' is required to send Broadcast",
    product: null,
    date_created: '2020-12-11T09:46:01Z',
    last_updated: '2020-12-11T09:46:01Z',
  },
  95116: {
    code: 95116,
    message: 'PCI Recordings are not supported',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 95116\r\n\r\n### PCI Recordings are not supported\r\n\r\n Voice Intelligence do not support PCI Recordings\r\n\r\n#### Possible Causes\r\nThe account is marked as PCI compliant.\r\n\r\n#### Possible Solutions\r\nUse the MediaUrl parameter instead of the SourceSid when creating a Transcription',
    causes: 'The account is marked as PCI compliant.',
    solutions: 'Use the MediaUrl parameter instead of the SourceSid when creating a Transcription',
    description: 'Voice Intelligence do not support PCI Recordings',
    product: 'Voice Intelligence',
    date_created: '2024-05-30T16:55:20Z',
    last_updated: '2024-05-30T16:55:32.000498Z',
  },
  18005: {
    code: 18005,
    message: 'Redactions in supporting document',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18005\r\n\r\n### Redactions in supporting document\r\n\r\n The supporting document you submitted had redactions or covered information.\r\n\r\n#### Possible Causes\r\nUploading a document with obscured or redacted information.\r\n\r\n#### Possible Solutions\r\nRe-upload the Supporting Document without any redactions or covered portions. For any ID document, make sure to provide a color copy of the ID document without any reductions. Make sure that all the edges of the ID document and MRZ data for passports are visible.',
    causes: 'Uploading a document with obscured or redacted information.',
    solutions:
      'Re-upload the Supporting Document without any redactions or covered portions. For any ID document, make sure to provide a color copy of the ID document without any reductions. Make sure that all the edges of the ID document and MRZ data for passports are visible.',
    description: 'The supporting document you submitted had redactions or covered information.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:48:49Z',
    last_updated: '2024-07-04T09:48:49Z',
  },
  60369: {
    code: 60369,
    message: 'Factor type invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60369\r\n\r\n### Factor type invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Factor type in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Factor type in the request body is correct.',
    causes: 'The Factor type in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Factor type in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-19T11:36:56Z',
    last_updated: '2023-12-19T11:36:56Z',
  },
  83605: {
    code: 83605,
    message: 'StartTime parameter is too far in the past. It must be within the last 18 months.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83605\r\n\r\n### StartTime parameter is too far in the past. It must be within the last 18 months.\r\n\r\n You can query usage data up to 18 months in the past. The oldest allowed StartTime is 18 months prior to the start of the current UTC day. For example, if the current time is 2021-12-13T5:00:00Z, then you can query usage as far back as 2020-06-13T:00:00:00Z.\r\n\r\n#### Possible Causes\r\nThis happens if you request Usage Records with a StartTime parameter more than 18 months in the past.\r\n\r\n#### Possible Solutions\r\nAdjust your StartTime parameter to be at most 18 months in the past.',
    causes:
      'This happens if you request Usage Records with a StartTime parameter more than 18 months in the past.',
    solutions: 'Adjust your StartTime parameter to be at most 18 months in the past.',
    description:
      'You can query usage data up to 18 months in the past. The oldest allowed StartTime is 18 months prior to the start of the current UTC day. For example, if the current time is 2021-12-13T5:00:00Z, then you can query usage as far back as 2020-06-13T:00:00:00Z.',
    product: 'Super SIM',
    date_created: '2022-01-04T00:09:10Z',
    last_updated: '2022-01-04T00:09:10Z',
  },
  53661: {
    code: 53661,
    message: 'StatusCallbackMethod is invalid',
    log_level: 'WARNING',
    secondary_message: 'The recording will be processed, but status notifications will not be sent',
    log_type: null,
    docs: '## Warning - 53661\r\n\r\n### StatusCallbackMethod is invalid\r\n\r\nThe recording will be processed, but status notifications will not be sent.\r\n\r\nRaised when StatusCallbackMethod is set to an invalid value.\r\n\r\n#### Causes\r\n\r\n * Recording created with StatusCallbackMethod set to an invalid value.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallbackMethod to either GET or POST or leave blank for the default (POST).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:41:57Z',
    last_updated: '2020-08-04T10:00:14.688Z',
  },
  95100: {
    code: 95100,
    message: 'Failed to transcribe',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 95100\r\n\r\n### Failed to transcribe\r\n\r\n Twilio failed to transcribe audio due to an internal issue.The resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\nThis is an internal issue.\r\n\r\n#### Possible Solutions\r\nContact support',
    causes: 'This is an internal issue.',
    solutions: 'Contact support',
    description:
      'Twilio failed to transcribe audio due to an internal issue.The resource has been marked as “failed”',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:29:40Z',
    last_updated: '2024-04-19T11:25:18.972233Z',
  },
  21620: {
    code: 21620,
    message: 'Invalid media URL(s)',
    log_level: 'ERROR',
    secondary_message:
      'One or more media URL you provided is invalid. Please use only valid HTTP and HTTPS URLs.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21620\r\n\r\n### Invalid media URL(s)\r\n\r\nOne or more media URL you provided is invalid. Please use only valid HTTP and HTTPS URLs. One or more media URLs that you provided is invalid — they are malformed in some way. \r\n\r\nTypically, this error is issued when a URL lacks a protocol specifier prefix, i.e., `htttp://` or `https://`.\r\n\r\n#### Possible Causes\r\nThe URL(s) lack a protocol specifier: `http://` or `https://`\r\n\r\n#### Possible Solutions\r\nAdd a correct protocol specifier prefix: `http://` or `https://`',
    causes: 'The URL(s) lack a protocol specifier: `http://` or `https://`',
    solutions: 'Add a correct protocol specifier prefix: `http://` or `https://`',
    description:
      'One or more media URLs that you provided is invalid — they are malformed in some way. \r\n\r\nTypically, this error is issued when a URL lacks a protocol specifier prefix, i.e., `htttp://` or `https://`.',
    product: null,
    date_created: '2016-03-31T17:14:28Z',
    last_updated: '2022-09-02T10:05:21.106564Z',
  },
  30754: {
    code: 30754,
    message: 'Brand Registration Failure: Invalid postal address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30754\r\n\r\n### Brand Registration Failure: Invalid postal address\r\n\r\n You have used an invalid postal address for brand registration.\r\n\r\n#### Possible Causes\r\nYou have used an invalid address for brand registration.\r\n\r\n#### Possible Solutions\r\nPlease ensure 'street', 'region', 'state', 'postal_code', and 'iso_country' collectively forms a valid postal address.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]",
    causes: 'You have used an invalid address for brand registration.',
    solutions:
      "Please ensure 'street', 'region', 'state', 'postal_code', and 'iso_country' collectively forms a valid postal address.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]",
    description: 'You have used an invalid postal address for brand registration.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:46:05Z',
    last_updated: '2024-02-13T16:15:30.944147Z',
  },
  48011: {
    code: 48011,
    message: 'Custom Routing Callback failed due to an internal error',
    log_level: 'ERROR',
    secondary_message:
      'An internal error has occurred that prevented Twilio from processing your callback.',
    log_type: 'TWILIO',
    docs: '## ERROR - 48011\r\n\r\n### Custom Routing Callback failed due to an internal error\r\n\r\nAn internal error has occurred that prevented Twilio from processing your callback. \r\n\r\n#### Possible Causes\r\n- We failed to execute callback request.\r\n\r\n#### Possible Solutions\r\n - If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
    causes: '- We failed to execute callback request.',
    solutions:
      ' - If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
    description: null,
    product: 'Frontline',
    date_created: '2021-11-18T11:11:45Z',
    last_updated: '2021-11-18T11:11:45Z',
  },
  14238: {
    code: 14238,
    message: 'Dial->Conference: Unable to accept Reservation',
    log_level: 'ERROR',
    secondary_message: 'Unable to accept the Reservation',
    log_type: null,
    docs: '## Error - 14238\r\n\r\n### Conference: Unable to accept or find the Reservation\r\n\r\nUnable to accept or find the provided Reservation.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:48:23Z',
    last_updated: '2020-08-04T10:00:21.72Z',
  },
  20410: {
    code: 20410,
    message: 'Gone',
    log_level: 'ERROR',
    secondary_message:
      'This API is being discontinued. Please see https://support.twilio.com/hc/en-us/articles/223181028-Switching-from-SMS-Messages-resource-URI-to-Messages-resource-URI- for more information',
    log_type: 'APPLICATION',
    docs: '## ERROR - 20410\r\n\r\n### Gone\r\n\r\n The API is no longer available\r\n\r\n#### Possible Causes\r\n* You are  attempting to send messages via a discontinued API\r\n* You are sending messages via the deprecated “SMS/Messages” endpoint\r\n\r\n\r\n#### Possible Solutions\r\n* Ensure you are using the most up to date Messaging Resources. See the [Programmable Messaging API docs](https://www.twilio.com/docs/messaging/api) for up to date endpoints.\r\n* Migrate from the “SMS/Messages” endpoint to “Messages” endpoint. See [here](https://support.twilio.com/hc/en-us/articles/223181028-Switching-from-SMS-Messages-resource-URI-to-Messages-resource-URI) for more information.',
    causes:
      '* You are  attempting to send messages via a discontinued API\r\n* You are sending messages via the deprecated “SMS/Messages” endpoint\r\n',
    solutions:
      '* Ensure you are using the most up to date Messaging Resources. See the [Programmable Messaging API docs](https://www.twilio.com/docs/messaging/api) for up to date endpoints.\r\n* Migrate from the “SMS/Messages” endpoint to “Messages” endpoint. See [here](https://support.twilio.com/hc/en-us/articles/223181028-Switching-from-SMS-Messages-resource-URI-to-Messages-resource-URI) for more information.',
    description: 'The API is no longer available',
    product: 'Programmable Messaging',
    date_created: '2023-02-24T21:26:52Z',
    last_updated: '2024-02-05T11:00:01.153285Z',
  },
  13257: {
    code: 13257,
    message: 'Invalid transcribeCallback URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13257\r\n\r\n### Invalid transcribeCallback URL\r\n\r\n Transcribe callback URL does not conform to standard URL format.\r\n\r\n#### Possible Causes\r\nTranscribe callback URL is invalid.\r\n\r\n#### Possible Solutions\r\nCorrect transcribe callback URL.',
    causes: 'Transcribe callback URL is invalid.',
    solutions: 'Correct transcribe callback URL.',
    description: 'Transcribe callback URL does not conform to standard URL format.',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:51:48Z',
    last_updated: '2020-08-04T10:00:04.351Z',
  },
  31202: {
    code: 31202,
    message: 'Signature validation failed.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31202\r\n\r\n### Signature validation failed.\r\n\r\n The provided access token failed signature validation.\r\n\r\n#### Possible Causes\r\nThe access token has an invalid Account SID, API Key, or API Key Secret.\r\n\r\n#### Possible Solutions\r\nEnsure the Account SID, API Key, and API Key Secret are valid when generating your access token.',
    causes: 'The access token has an invalid Account SID, API Key, or API Key Secret.',
    solutions:
      'Ensure the Account SID, API Key, and API Key Secret are valid when generating your access token.',
    description: 'The provided access token failed signature validation.',
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:45:37Z',
    last_updated: '2020-08-04T10:00:11.135Z',
  },
  30031: {
    code: 30031,
    message: 'Invalid MaxRate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30031\r\n\r\n### Invalid MaxRate\r\n\r\n MaxRate is not a valid float\r\n\r\n#### Possible Causes\r\nMaxRate value is not a float or is equal to or less than zero\r\n\r\n#### Possible Solutions\r\nUse a positive float value for MaxRate',
    causes: 'MaxRate value is not a float or is equal to or less than zero',
    solutions: 'Use a positive float value for MaxRate',
    description: 'MaxRate is not a valid float',
    product: 'Programmable SMS',
    date_created: '2022-01-26T14:42:35Z',
    last_updated: '2022-01-26T14:42:35Z',
  },
  51003: {
    code: 51003,
    message: 'Client Connection: identity too long',
    log_level: 'ERROR',
    secondary_message: 'error',
    log_type: null,
    docs: '## Error - 51003\n\n### Client Connection: `identity` too long\n\n#### Possible Causes \n\n`identity` field in the Access Token is too long.\n\n#### Possible Solutions\n\nConsult the product documentation for maximum allowed length of `identity` field.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:55Z',
    last_updated: '2020-08-04T10:00:22.837Z',
  },
  82006: {
    code: 82006,
    message: 'Environment Context too large',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 82006\r\n\r\n### Environment Context too large\r\n\r\n Context of the function has exceeded maximum limit. Reduce the context size and try again.\r\n\r\n#### Possible Causes\r\nContext size consists of account metadata, domain name, path and Environment variables stored as a JSON string. If this string exceeds 3KB, invocations may fail.\r\n\r\n#### Possible Solutions\r\nTry reducing number of Environment Variables or size of the Environment Variables stored.',
    causes:
      'Context size consists of account metadata, domain name, path and Environment variables stored as a JSON string. If this string exceeds 3KB, invocations may fail.',
    solutions:
      'Try reducing number of Environment Variables or size of the Environment Variables stored.',
    description:
      'Context of the function has exceeded maximum limit. Reduce the context size and try again.',
    product: 'Functions',
    date_created: '2020-09-11T14:48:34Z',
    last_updated: '2020-09-11T14:48:34Z',
  },
  60723: {
    code: 60723,
    message: 'Brand status does not allow updates',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60723\r\n\r\n### Brand status does not allow updates\r\n\r\n Brands can only be updated when they have certain status values.\r\n\r\n#### Possible Causes\r\nYou sent a POST request to update a brand that is in status "Pending Verification" or "Verified".\r\n\r\n#### Possible Solutions\r\nIf you really need to update the brand information, you can dismiss its current status (this action will update the status to "Draft") and then you can POST the update.',
    causes:
      'You sent a POST request to update a brand that is in status "Pending Verification" or "Verified".',
    solutions:
      'If you really need to update the brand information, you can dismiss its current status (this action will update the status to "Draft") and then you can POST the update.',
    description: 'Brands can only be updated when they have certain status values.',
    product: 'Branded Comms',
    date_created: '2020-01-24T20:37:06Z',
    last_updated: '2020-08-04T10:00:04.798Z',
  },
  31212: {
    code: 31212,
    message: 'Call Message Event Payload size exceeded authorized limit.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31212\r\n\r\n### Call Message Event Payload size exceeded authorized limit.\r\n\r\n Call Message Event Payload size exceeded authorized limit.\r\n\r\n#### Possible Causes\r\nThe payload size of Call Message Event exceeds the authorized limit.\r\n\r\n#### Possible Solutions\r\nReduce payload size of Call Message Event to be within the authorized limit and try again.',
    causes: 'The payload size of Call Message Event exceeds the authorized limit.',
    solutions:
      'Reduce payload size of Call Message Event to be within the authorized limit and try again.',
    description: 'Call Message Event Payload size exceeded authorized limit.',
    product: 'Programmable Voice',
    date_created: '2024-06-20T20:29:31Z',
    last_updated: '2024-06-20T20:29:31Z',
  },
  33201: {
    code: 33201,
    message: 'Unauthorized',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33201\r\n\r\n### Unauthorized\r\n\r\n Raised whenever the requested operation is not permitted.\r\n\r\n\r\n#### Possible Causes\r\n * Your Account has been suspended and an asynchronous request has been canceled.\r\n * While sending Commands to your SIM, your Command was rejected by its Rate Plan.\r\n * While transferring your SIM to another Account, your request was rejected because the SIM must be `new` and the new Account must either be the requesting Account or a Subaccount of the requesting Account.\r\n\r\n\r\n#### Possible Solutions\r\n * While sending a Command, ensure the Rate Plan associated to the given SIM has Commands enabled.\r\n * Contact Twilio Support to help with the SIM transfer.\r\n',
    causes:
      ' * Your Account has been suspended and an asynchronous request has been canceled.\r\n * While sending Commands to your SIM, your Command was rejected by its Rate Plan.\r\n * While transferring your SIM to another Account, your request was rejected because the SIM must be `new` and the new Account must either be the requesting Account or a Subaccount of the requesting Account.\r\n',
    solutions:
      ' * While sending a Command, ensure the Rate Plan associated to the given SIM has Commands enabled.\r\n * Contact Twilio Support to help with the SIM transfer.\r\n',
    description: 'Raised whenever the requested operation is not permitted.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:25:20Z',
    last_updated: '2020-09-15T11:25:20Z',
  },
  32503: {
    code: 32503,
    message: 'Voice Conversation: Callback event response error.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32503\r\n\r\n### Voice Conversation: Callback event response error.\r\n\r\n Request to status callback URL received a response error from the customer-side server.\r\n\r\n#### Possible Causes\r\n- This error indicates that Twilio was able to reach the customer-provided URL, however, received an error from the customer-side callback endpoint.\r\n- The URL provided was likely valid, but Twilio might be receiving an error from the customer-side service.\r\n\r\n#### Possible Solutions\r\n- Make sure you have a web server up and running that serves that URL with the configured method in TwiML, e.g. POST.',
    causes:
      '- This error indicates that Twilio was able to reach the customer-provided URL, however, received an error from the customer-side callback endpoint.\r\n- The URL provided was likely valid, but Twilio might be receiving an error from the customer-side service.',
    solutions:
      '- Make sure you have a web server up and running that serves that URL with the configured method in TwiML, e.g. POST.',
    description:
      'Request to status callback URL received a response error from the customer-side server.',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:38:42Z',
    last_updated: '2022-07-29T16:32:41.875087Z',
  },
  80903: {
    code: 80903,
    message: 'Unknown Participant',
    log_level: 'WARNING',
    secondary_message: 'Unknown Participant',
    log_type: null,
    docs: '## Warning\n\n### Unknown Participant\n\nExample Message: Unknown Participant',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.626Z',
  },
  21648: {
    code: 21648,
    message: 'Regulatory Bundle cannot be deleted due to active number assignment',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21648\r\n\r\n### Regulatory Bundle cannot be deleted due to active number assignment\r\n\r\n The Regulatory Bundle cannot be deleted due to an active number assignment.a\r\n\r\n#### Possible Causes\r\nThe Regulatory Bundle cannot be deleted due to an active number assignment.a\r\n\r\n#### Possible Solutions\r\nRe-assign the current number(s) to another twilio-approved Regulatory Bundle.',
    causes: 'The Regulatory Bundle cannot be deleted due to an active number assignment.a',
    solutions: 'Re-assign the current number(s) to another twilio-approved Regulatory Bundle.',
    description: 'The Regulatory Bundle cannot be deleted due to an active number assignment.a',
    product: 'Phone Numbers',
    date_created: '2020-07-17T19:54:41Z',
    last_updated: '2020-08-04T10:00:01.978Z',
  },
  21608: {
    code: 21608,
    message: "The 'to' phone number provided is not yet verified for this account.",
    log_level: 'ERROR',
    secondary_message:
      'While your account is in Trial Mode, you may only send SMS messages to verified numbers.  Upgrade to a Full Twilio account to send to any phone number.',
    log_type: null,
    docs: "## Error - 21608\r\n\r\n### This number can send messages only to verified numbers\r\n\r\nYou have attempted to send a message to an unverified phone number while using a trial account.\r\n\r\nTo prevent spam, trial accounts can only send messages to phone numbers you've verified with Twilio. You must upgrade your account to remove this restriction.\r\n\r\n### Possible solutions\r\n* Verify the phone number you wish to reach via the [Twilio console](https://www.twilio.com/console/phone-numbers/verified). See step-by-step instructions in our [guide to working with your trial account](https://www.twilio.com/docs/usage/tutorials/how-to-use-your-free-trial-account#verify-your-personal-phone-number). _Note that you will need access to this device to receive the call or text with your verification code._\r\n*  Upgrade your Twilio trial account to a full paid account to remove this restriction by providing your payment information via credit card or Paypal on the [console billing page](https://www.twilio.com/console/billing). \r\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:06Z',
    last_updated: '2020-08-04T10:00:26.608Z',
  },
  57004: {
    code: 57004,
    message: "'Category' is empty",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57004\r\n\r\n### 'Category' is empty\r\n\r\n 'Category' is not specified\r\n\r\n#### Possible Causes\r\n'Category' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Category' is being passed in request.",
    causes: "'Category' is not specified",
    solutions: "Confirm a valid 'Category' is being passed in request.",
    description: "'Category' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:48:06Z',
    last_updated: '2021-05-07T08:48:06Z',
  },
  94500: {
    code: 94500,
    message: 'Transcriptions: sourceSid invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94500\r\n\r\n### Transcriptions: sourceSid invalid\r\n\r\n The action could not be performed because the sourceSid provided is not valid\r\n\r\n#### Possible Causes\r\n* sourceSid value is invalid\r\n* sourceSid is not a call recording sid\r\n\r\n#### Possible Solutions\r\n * Specify a sourceSid of a valid call recording',
    causes: '* sourceSid value is invalid\r\n* sourceSid is not a call recording sid',
    solutions: ' * Specify a sourceSid of a valid call recording',
    description: 'The action could not be performed because the sourceSid provided is not valid',
    product: null,
    date_created: '2022-03-01T14:16:52Z',
    last_updated: '2022-03-01T14:16:52Z',
  },
  60612: {
    code: 60612,
    message: 'Requested phone number not mobile',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60612\r\n\r\n### Requested phone number not mobile\r\n\r\n Requested phone number is not a mobile number\r\n\r\n#### Possible Causes\r\nLookup package requested is only applicable to mobile phone numbers\r\n\r\n#### Possible Solutions\r\nTry again with a mobile phone number',
    causes: 'Lookup package requested is only applicable to mobile phone numbers',
    solutions: 'Try again with a mobile phone number',
    description: 'Requested phone number is not a mobile number',
    product: 'Lookup',
    date_created: '2021-08-03T20:54:45Z',
    last_updated: '2021-10-18T22:26:19.176006Z',
  },
  13329: {
    code: 13329,
    message: 'Gather: Invalid partialResultCallbackMethod value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13329\r\n\r\n### Gather: Invalid partialResultCallbackMethod value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-05-01T22:46:05Z',
    last_updated: '2020-08-04T10:00:19.257Z',
  },
  50704: {
    code: 50704,
    message: 'Provided addon sid should have prefix XB.',
    log_level: 'ERROR',
    secondary_message: 'Provided addon sid should have prefix XB.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50704\r\n\r\n### Provided addon sid should have prefix XB.\r\n\r\nProvided addon sid should have prefix XB. \r\n\r\n#### Possible Causes\r\nYou are trying to specify different field value for ChatbotConfiguration.AddonSid.\r\n\r\n#### Possible Solutions\r\n* Double check and fix value for ChatbotConfiguration.AddonSid. It should start with XB prefix.',
    causes: 'You are trying to specify different field value for ChatbotConfiguration.AddonSid.',
    solutions:
      '* Double check and fix value for ChatbotConfiguration.AddonSid. It should start with XB prefix.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:01:38Z',
    last_updated: '2023-10-11T18:01:38Z',
  },
  50363: {
    code: 50363,
    message: 'Invalid conversation webhook SID',
    log_level: 'ERROR',
    secondary_message: 'An invalid conversation webhook SID was supplied.',
    log_type: null,
    docs: '\n## Error - 50363\n\n### Conversations: Invalid conversation webhook SID\nAn invalid conversation webhook SID was supplied.\n\n#### Possible Causes\n* Webhook SID parameter provided with the request does not match a valid SID pattern (WHxx).\n\n#### Possible Solutions\n* Add a valid Webhook SID parameter to the API request and supply a SID that exists under your account.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.784Z',
  },
  60712: {
    code: 60712,
    message: 'Error communicating with Regulatory Compliance API',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 60712\r\n\r\n### Error communicating with Regulatory Compliance API\r\n\r\n KYC, part of the Branded Comms product, depends on Twilio's regulatory APIs\r\n\r\n#### Possible Causes\r\nCommunication with the Regulatory Compliance API failed\r\n\r\n#### Possible Solutions\r\nWait a bit in case this is a temporal error, or else contact our support team",
    causes: 'Communication with the Regulatory Compliance API failed',
    solutions: 'Wait a bit in case this is a temporal error, or else contact our support team',
    description: "KYC, part of the Branded Comms product, depends on Twilio's regulatory APIs",
    product: 'Branded Comms',
    date_created: '2020-01-24T18:10:54Z',
    last_updated: '2020-08-04T10:00:04.96Z',
  },
  21220: {
    code: 21220,
    message: 'Invalid call state',
    log_level: 'ERROR',
    secondary_message:
      'You attempted a realtime operation on a Call that was not in-progress.  Calls that have completed cannot be recorded or redirected.',
    log_type: null,
    docs: '## Error - 21220 \n\n### Invalid call state\n\nYou attempted a realtime operation on a Call that was not in-progress.  Calls that have completed cannot be recorded or redirected.  \n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:16Z',
    last_updated: '2020-08-04T10:00:25.767Z',
  },
  50396: {
    code: 50396,
    message: 'EndDate parameter should be greater than StartDate parameter',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50396\r\n\r\n### EndDate parameter should be greater than StartDate parameter\r\n\r\n EndDate parameter should be greater than StartDate parameter\r\n\r\n#### Possible Causes\r\nEndDate parameter is before StartDate parameter\r\n\r\n#### Possible Solutions\r\nSet EndDate parameter greater than StartDate parameter',
    causes: 'EndDate parameter is before StartDate parameter',
    solutions: 'Set EndDate parameter greater than StartDate parameter',
    description: 'EndDate parameter should be greater than StartDate parameter',
    product: 'Conversations',
    date_created: '2024-07-02T11:44:39Z',
    last_updated: '2024-07-02T11:44:39Z',
  },
  60621: {
    code: 60621,
    message: 'Lookup Carrier Information Not Available',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 60621\r\n\r\n### Lookup Carrier Information Not Available\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was processed successfully and Last SIM Swap information was returned, but carrier information was not available.\r\n\r\n#### Possible Solutions\r\n- Retry request to rule out transient issues in order to receive carrier information.\r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out other issues.',
    causes:
      'The request was processed successfully and Last SIM Swap information was returned, but carrier information was not available.',
    solutions:
      '- Retry request to rule out transient issues in order to receive carrier information.\r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out other issues.',
    description: 'Lookup SIM Swap Information is Incomplete From Carrier',
    product: 'Lookup',
    date_created: '2022-11-01T17:07:42Z',
    last_updated: '2023-01-06T00:27:35.607591Z',
  },
  36004: {
    code: 36004,
    message: 'Error Retrieving File',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36004\r\n\r\n### Error Retrieving File\r\n\r\n File couldn\'t be retrieved, make sure it has \'file\' key\r\n\r\n#### Possible Causes\r\n* You did not specify a key with the name "file" in the Broadcast Upload request body\r\n\r\n#### Possible Solutions\r\n* Attach a .json.gz file as the value to the "file" key in the Broadcast Upload request body',
    causes: '* You did not specify a key with the name "file" in the Broadcast Upload request body',
    solutions:
      '* Attach a .json.gz file as the value to the "file" key in the Broadcast Upload request body',
    description: "File couldn't be retrieved, make sure it has 'file' key",
    product: 'Programmable Messaging',
    date_created: '2023-12-15T21:51:10Z',
    last_updated: '2023-12-15T21:51:10Z',
  },
  95119: {
    code: 95119,
    message: 'Voice Intelligence does not support encrypted recordings',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 95119\r\n\r\n### Voice Intelligence does not support encrypted recordings\r\n\r\n Voice Intelligence does not support encrypted recordings\r\n\r\n#### Possible Causes\r\nThe account uses Voice Recording Encryption\r\n\r\n#### Possible Solutions\r\nUse decrypted recordings when creating a Transcription',
    causes: 'The account uses Voice Recording Encryption',
    solutions: 'Use decrypted recordings when creating a Transcription',
    description: 'Voice Intelligence does not support encrypted recordings',
    product: 'Voice Intelligence',
    date_created: '2024-05-30T16:58:05Z',
    last_updated: '2024-05-30T16:58:05Z',
  },
  503: {
    code: 503,
    message: 'Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 503\r\n\r\n### Internal Error\r\n\r\n  An internal error has occurred while processing the request.\r\n\r\n\r\n#### Possible Causes\r\n* The server is currently unable to handle the request.\r\n\r\n\r\n#### Possible Solutions\r\n* Retry the request at a later time.',
    causes: '* The server is currently unable to handle the request.\r\n',
    solutions: '* Retry the request at a later time.',
    description: ' An internal error has occurred while processing the request.\r\n',
    product: null,
    date_created: '2020-09-14T21:55:34Z',
    last_updated: '2020-09-14T21:55:34Z',
  },
  32601: {
    code: 32601,
    message: 'Virtual Agent: Provider Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32601\r\n\r\n### Virtual Agent: Provider Error\r\n\r\n A 32601 Error is an indication that the &lt;VirtualAgent&gt; connector configuration was rejected by the VirtualAgent provider.\r\n\r\n#### Possible Causes\r\n* Connector configuration contains invalid properties\r\n\r\n\r\n#### Possible Solutions\r\n* Check your &lt;VirtualAgent&gt; connector configuration\r\n* Check any &lt;Config&gt; elements referenced in TwiML\r\n* Check the VirtualAgentProviderError included in the webhook to the action url or the Debugger message in Console for further information. For additional assistance, please contact Twilio Support.',
    causes: '* Connector configuration contains invalid properties\r\n',
    solutions:
      '* Check your &lt;VirtualAgent&gt; connector configuration\r\n* Check any &lt;Config&gt; elements referenced in TwiML\r\n* Check the VirtualAgentProviderError included in the webhook to the action url or the Debugger message in Console for further information. For additional assistance, please contact Twilio Support.',
    description:
      'A 32601 Error is an indication that the &lt;VirtualAgent&gt; connector configuration was rejected by the VirtualAgent provider.',
    product: 'Programmable Voice',
    date_created: '2022-08-04T01:21:26Z',
    last_updated: '2022-08-04T01:21:26Z',
  },
  30610: {
    code: 30610,
    message: "Message couldn't be delivered",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30610\r\n\r\n### Message couldn't be delivered\r\n\r\n Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n\r\n#### Possible Causes\r\nTBD\r\n\r\n#### Possible Solutions\r\nTBD",
    causes: 'TBD',
    solutions: 'TBD',
    description:
      'Message couldn’t be delivered to the destination number you are trying to reach temporarily.',
    product: 'Programmable Messaging',
    date_created: '2024-04-16T06:06:20Z',
    last_updated: '2024-04-16T06:06:20Z',
  },
  50414: {
    code: 50414,
    message: 'Participant address type does not match proxy address type',
    log_level: 'ERROR',
    secondary_message:
      'The provided participant address mismatches the proxy address channel type.',
    log_type: null,
    docs: '\n## Error - 50414\n\n### Conversations: Participant address type does not match proxy address type\nThe provided participant address mismatches the proxy address channel type.\n\n#### Possible Causes\n* MessagingBinding.Address and MessagingBinding.ProxyAddress passed to the API do not belong to the same communication channel.\n\n#### Possible Solutions\n* Ensure that both MessagingBinding.Address and MessagingBinding.ProxyAddress are both of the same type, e.g. both SMS or both WhatsApp.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.456Z',
  },
  60719: {
    code: 60719,
    message: 'Branded Call not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60719\r\n\r\n### Branded Call not found\r\n\r\n You are requesting a branded call for phone number that is not branded (it is not associated to a verified brand and business)\r\n\r\n#### Possible Causes\r\nThe phone number is not associated to a brand, or it is, but the brand or the business are no verified.\r\n\r\n#### Possible Solutions\r\nThe business and brand associated to the phone number being requested in the branded call must go through a vetting process and get a status of verified',
    causes:
      'The phone number is not associated to a brand, or it is, but the brand or the business are no verified.',
    solutions:
      'The business and brand associated to the phone number being requested in the branded call must go through a vetting process and get a status of verified',
    description:
      'You are requesting a branded call for phone number that is not branded (it is not associated to a verified brand and business)',
    product: 'Branded Comms',
    date_created: '2020-01-24T20:20:58Z',
    last_updated: '2020-08-04T10:00:04.855Z',
  },
  45719: {
    code: 45719,
    message: 'Failed to create webchat participant. Too many requests ',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 45719\r\n\r\n### Failed to create webchat participant. Too many requests \r\n\r\n Failed to create participant for webchat conversation. Too many requests \r\n\r\n#### Possible Causes\r\nYour account is sending too many concurrent Rest API requests to Twilio servers.\r\n\r\n#### Possible Solutions\r\nAn API Request that receives an error 429 response is never processed and is always safe to retry. Please wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API.",
    causes: 'Your account is sending too many concurrent Rest API requests to Twilio servers.',
    solutions:
      "An API Request that receives an error 429 response is never processed and is always safe to retry. Please wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API.",
    description: 'Failed to create participant for webchat conversation. Too many requests ',
    product: 'Flex',
    date_created: '2022-10-03T21:45:31Z',
    last_updated: '2022-10-03T21:45:31Z',
  },
  70052: {
    code: 70052,
    message: 'Public Key Client Validation Required For Account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70052 \r\n\r\n### Public Key Client Validation Required For Account\r\nThe account is only allowed to perform Public Key Client Validation requests at Twilio. All other types of authentication are disabled for the account.\r\n\r\n#### Possible Causes \r\n* The Twilio-Client-Validation is not present in the request.\r\n\r\n#### Possible Solution:\r\n* Ensure the Twilio-Client-Validation header is present in the request and valid.\r\n* Disable forcing Client Validation feature at the Console if not needed.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:19:33Z',
    last_updated: '2020-08-04T10:00:18.861Z',
  },
  21614: {
    code: 21614,
    message: "'To' number is not a valid mobile number",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21614\r\n\r\n### 'To' number is not a valid mobile number\r\n\r\n You have attempted to send a SMS with a 'To' number that is not \r\na valid mobile number. It is likely that the number that you \r\nhave specified is a landline number or is an invalid number. \r\n\r\n#### Possible Causes\r\n* The number you provided may be a landline number.\r\n* The number you provided may be invalid or formatted incorrectly.\r\n* If you are attempting to send SMS to Internet of Things (IoT) or machine-to-machine (M2M) numbers, the numbers may use a non-standard format that Twilio has not added to our number validation system yet.\r\n\r\n#### Possible Solutions\r\n* Confirm that the number you are sending to is not a landline, using the [Lookup API](https://www.twilio.com/docs/lookup/v2-api).\r\n* Please verify you have provided a valid mobile number in proper [E.164 format](https://support.twilio.com/hc/en-us/articles/223183008-Formatting-International-Phone-Numbers).\r\n* If you are attempting to send SMS to an IoT or M2M number, check whether the number format is different from the standard mobile numbers in that country or locality. Often, these numbers have additional digits or unusual formats which do not pass Twilio's number validation. If you believe this is the issue, please [contact Twilio Support](https://www.twilio.com/help/contact) for assistance.",
    causes:
      '* The number you provided may be a landline number.\r\n* The number you provided may be invalid or formatted incorrectly.\r\n* If you are attempting to send SMS to Internet of Things (IoT) or machine-to-machine (M2M) numbers, the numbers may use a non-standard format that Twilio has not added to our number validation system yet.',
    solutions:
      "* Confirm that the number you are sending to is not a landline, using the [Lookup API](https://www.twilio.com/docs/lookup/v2-api).\r\n* Please verify you have provided a valid mobile number in proper [E.164 format](https://support.twilio.com/hc/en-us/articles/223183008-Formatting-International-Phone-Numbers).\r\n* If you are attempting to send SMS to an IoT or M2M number, check whether the number format is different from the standard mobile numbers in that country or locality. Often, these numbers have additional digits or unusual formats which do not pass Twilio's number validation. If you believe this is the issue, please [contact Twilio Support](https://www.twilio.com/help/contact) for assistance.",
    description:
      "You have attempted to send a SMS with a 'To' number that is not \r\na valid mobile number. It is likely that the number that you \r\nhave specified is a landline number or is an invalid number. ",
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:26Z',
    last_updated: '2023-07-31T21:21:51.532803Z',
  },
  13233: {
    code: 13233,
    message: 'Dial->Conference: Invalid waitUrl',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Error - 13233\n\n### Dial->Conference: Invalid waitUrl value\n\nwaitUrl must be either a well formed URL or the empty string ""\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:36Z',
    last_updated: '2020-08-04T10:00:28.441Z',
  },
  25022: {
    code: 25022,
    message: 'Duplicate username or externalId',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25022\r\n\r\n### Duplicate username or externalId\r\n\r\n Duplicate username or externalId\r\n\r\n#### Possible Causes\r\nA user with the specified username or externalId already exists in the system.\r\n\r\n#### Possible Solutions\r\nVerify that the intended user has a unique username and externalId. If necessary, adjust the username or externalId to ensure uniqueness and avoid duplication in the system.',
    causes: 'A user with the specified username or externalId already exists in the system.',
    solutions:
      'Verify that the intended user has a unique username and externalId. If necessary, adjust the username or externalId to ensure uniqueness and avoid duplication in the system.',
    description: 'Duplicate username or externalId',
    product: 'Organizations API',
    date_created: '2023-12-04T10:51:12Z',
    last_updated: '2023-12-04T14:23:49.551337Z',
  },
  91007: {
    code: 91007,
    message: 'Sink still in use',
    log_level: 'ERROR',
    secondary_message: 'There are subscriptions using this sink',
    log_type: 'APPLICATION',
    docs: '## ERROR - 91007\r\n\r\n### Sink still in use\r\n\r\nThere are subscriptions using this sink Sink cannot be deleted because it is sill in use\r\n\r\n#### Possible Causes\r\n* There are subscriptions using this sink\r\n\r\n#### Possible Solutions\r\n* Delete all the subscriptions that use this sink. You can use the Event Streams - Subscriptions API endpoint to list all your subscriptions filtered by SinkSid and then delete them.',
    causes: '* There are subscriptions using this sink',
    solutions:
      '* Delete all the subscriptions that use this sink. You can use the Event Streams - Subscriptions API endpoint to list all your subscriptions filtered by SinkSid and then delete them.',
    description: 'Sink cannot be deleted because it is sill in use',
    product: 'Events',
    date_created: '2021-01-18T15:01:41Z',
    last_updated: '2021-01-18T15:01:41Z',
  },
  21613: {
    code: 21613,
    message: 'PhoneNumber Requires Certification',
    log_level: 'ERROR',
    secondary_message:
      'To purchase this phone number, you must certify that you or your customer has a business or personal address within the local country. To certify that you have an address in this country for this account, please purchase this phone number via the [buy a phone number](/user/account/phone-numbers/search) page in the account portal.  You will only need to certify your address once for each country.  Alternatively, you can provision a phone number that does not require certification.',
    log_type: null,
    docs: '## Error - 21613\n\n### PhoneNumber Requires an Address\n\nLocal regulation requires Twilio to have an address on file for your account to\npurchase this phone number.  You must add an address that specifies the end\nuser’s location using our [API][addresses-api] or [account\nportal][addresses-portal]. Alternatively, you can provision a phone number that\ndoes not require an address by using Basic List Filters on the\n[AvailablePhoneNumbers][phone-numbers] resource. If you received this error\nwhen trying to transfer a phone number to a subaccount or between subaccounts,\nplease ensure that the subaccount has the correct address on file.\n\n[addresses-api]: /docs/api/rest/addresses\n[addresses-portal]: /user/account\n[phone-numbers]: /docs/api/rest/available-phone-numbers\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:26Z',
    last_updated: '2020-08-04T10:00:25.062Z',
  },
  60602: {
    code: 60602,
    message: 'App hash can only be used with SMS channel',
    log_level: 'ERROR',
    secondary_message: 'App hash can only be used with SMS channel',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60602\r\n\r\n### App hash can only be used with SMS channel\r\n\r\nApp hash can only be used with SMS channel App hash can only be used with SMS channel\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nThe customer is using App Hash without SMS channel\r\n\r\n#### Possible Solutions\r\ndo not use app Hash with channel other than SMS',
    causes: 'The customer is using App Hash without SMS channel',
    solutions: 'do not use app Hash with channel other than SMS',
    description: 'App hash can only be used with SMS channel\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-12-24T17:19:35Z',
    last_updated: '2021-05-18T04:57:41.384Z',
  },
  63023: {
    code: 63023,
    message: 'Channel generic error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel generic error\r\n\r\n#### Possible Causes \r\n* Twilio encountered a generic error for your message.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:30:40Z',
    last_updated: '2020-08-04T10:00:10.451Z',
  },
  21502: {
    code: 21502,
    message: 'Invalid callback url',
    log_level: 'ERROR',
    secondary_message: 'The callback url provided is not a valid URL.',
    log_type: null,
    docs: '## Error - 21502 \n\n### Invalid callback url\n\nThe callback url provided is not a valid URL.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:02Z',
    last_updated: '2020-08-04T10:00:26.798Z',
  },
  21231: {
    code: 21231,
    message: 'Domain Validation Error',
    log_level: 'ERROR',
    secondary_message:
      'One of the parameters passed when creating or updating a SIP domain was incorrect.  Please see the response body for more details.',
    log_type: null,
    docs: '# Error - 21231\n\n### Domain Validation Error\n\nOne of the parameters passed when creating or updating a SIP domain was incorrect.  This may be caused by the IP Access Control List SID already being associated with the Domain.  \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:31Z',
    last_updated: '2020-08-04T10:00:24.725Z',
  },
  51130: {
    code: 51130,
    message: 'Twilsock: Token is invalid!',
    log_level: 'ERROR',
    secondary_message: 'Token is invalid!',
    log_type: null,
    docs: '## Error - 51130\r\n\r\n### Token is invalid!',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:31:20Z',
    last_updated: '2020-08-04T10:00:09.358Z',
  },
  60212: {
    code: 60212,
    message: 'Too many concurrent requests for phone number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60212\r\n\r\n### Too many concurrent requests for phone number\r\n\r\n Your application is initiating many verifications in a short period of time for the same phone number.\r\n\r\nHTTP status: 429\r\n\r\n\r\n#### Possible Causes\r\nYour application is initiating many verifications in a short period of time for the same phone number.\r\n\r\n#### Possible Solutions\r\n* Check if your application is being the target of fraudulent traffic.\r\n* Review your implementation.',
    causes:
      'Your application is initiating many verifications in a short period of time for the same phone number.',
    solutions:
      '* Check if your application is being the target of fraudulent traffic.\r\n* Review your implementation.',
    description:
      'Your application is initiating many verifications in a short period of time for the same phone number.\r\n\r\nHTTP status: 429\r\n',
    product: 'Verify',
    date_created: '2019-06-07T17:15:10Z',
    last_updated: '2021-05-18T04:44:38.908Z',
  },
  31920: {
    code: 31920,
    message: 'Stream - WebSocket - Handshake Error',
    log_level: 'ERROR',
    secondary_message: 'The WebSocket protocol handshake was declined by the server',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31920\r\n\r\n### Stream - WebSocket - Handshake Error\r\n\r\nThe WebSocket protocol handshake was declined by the server The server has returned an HTTP code different from 101 to the connection request sent by stream\r\n\r\nSee https://tools.ietf.org/html/rfc6455#section-4 for details.\r\n\r\n#### Possible Causes\r\n* The server does not support WebSocket\r\n* The WebSocket protocol is not enabled for the requested URL\r\n\r\n#### Possible Solutions\r\n* Verify WebSocket protocol is enabled in the server\r\n* Verify the path in TwiML URL is actually the one supporting WebSocket',
    causes:
      '* The server does not support WebSocket\r\n* The WebSocket protocol is not enabled for the requested URL',
    solutions:
      '* Verify WebSocket protocol is enabled in the server\r\n* Verify the path in TwiML URL is actually the one supporting WebSocket',
    description:
      'The server has returned an HTTP code different from 101 to the connection request sent by stream\r\n\r\nSee https://tools.ietf.org/html/rfc6455#section-4 for details.',
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:55:22Z',
    last_updated: '2020-08-04T10:00:07.387Z',
  },
  62025: {
    code: 62025,
    message: 'Interconnect: Invalid connection type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 62025\r\n\r\n#### Possible Causes \r\n* Invalid connection type\r\n\r\n#### Possible Solutions\r\n*  The request specified an invalid connection type. Please add a valid type-cloudconnect, crossconnect, mpls or vpn.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:49:50Z',
    last_updated: '2020-08-04T10:00:20.735Z',
  },
  19044: {
    code: 19044,
    message: 'Field definition name exceeded maximum length',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19044\r\n\r\n### Field definition name exceeded maximum length\r\n\r\n The custom field in the request is more than 100 chars long\r\n\r\n#### Possible Causes\r\nRequest with a custom field name greater than 100 chars\r\n\r\n#### Possible Solutions\r\nUpdate custom field name to be 100 chars or less',
    causes: 'Request with a custom field name greater than 100 chars',
    solutions: 'Update custom field name to be 100 chars or less',
    description: 'The custom field in the request is more than 100 chars long',
    product: 'Contacts',
    date_created: '2020-07-21T20:35:50Z',
    last_updated: '2020-08-31T06:03:30.93Z',
  },
  51116: {
    code: 51116,
    message: 'Twilsock: Invalid access token grants',
    log_level: 'ERROR',
    secondary_message: 'Provided token has invalid grants.',
    log_type: null,
    docs: '## Error - 51116\r\n\r\n### Invalid access token grants\r\n\r\n#### Possible Causes \r\nProvided token has invalid grants.\r\n\r\n#### Possible Solutions\r\nConfirm valid grants are being passed in the token.\r\n\r\nTo check whether the token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:53:17Z',
    last_updated: '2020-08-04T10:00:09.621Z',
  },
  50310: {
    code: 50310,
    message: 'Programmable Chat: Author parameter is too long',
    log_level: 'ERROR',
    secondary_message: 'Author parameter is too long.',
    log_type: null,
    docs: '## Error - 50310\r\n\r\n### Programmable Chat: Author parameter is too long\r\n\r\n#### Possible Causes \r\n*  Author parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Author is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T11:53:50Z',
    last_updated: '2020-08-04T10:00:16.667Z',
  },
  80208: {
    code: 80208,
    message: 'No Available Unused Proxy',
    log_level: 'ERROR',
    secondary_message:
      'This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for {identifier}. All matching proxies for this Participant are already in use in other Sessions.',
    log_type: null,
    docs: '## Warning\r\n\r\n### No Available Unused Proxy\r\n\r\nThis Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for {identifier}. All matching proxies for this Participant are already in use in other Sessions.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-11-22T05:06:25Z',
    last_updated: '2020-08-04T10:00:11.707Z',
  },
  30734: {
    code: 30734,
    message: 'Brand Registration Failure: Sole Proprietor brands are not enabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30734\r\n\r\n### Brand Registration Failure: Sole Proprietor brands are not enabled\r\n\r\n Sole proprietor brand registration is not enabled for your account.\r\n\r\n#### Possible Causes\r\nSole proprietor brand registration is not enabled for your account.\r\n\r\n#### Possible Solutions\r\nPlease contact Twilio Support.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes: 'Sole proprietor brand registration is not enabled for your account.',
    solutions:
      'Please contact Twilio Support.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description: 'Sole proprietor brand registration is not enabled for your account.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:40:05Z',
    last_updated: '2024-02-13T15:40:58.063646Z',
  },
  51006: {
    code: 51006,
    message: 'Client Connection: Connection expired',
    log_level: 'ERROR',
    secondary_message: 'warning',
    log_type: null,
    docs: '## Warning - 51006\n\n### Client Connection: Connection expired\n\n#### Possible Causes \n\nThe connection has expired. The connection expiration is set by the `exp` field of the Access Token.\n\n#### Possible Solutions\n\nMake sure clients refresh Access Tokens before they expire. Please, refer to the Twilio SDK documentation for further details.\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:56Z',
    last_updated: '2020-08-04T10:00:22.787Z',
  },
  45003: {
    code: 45003,
    message: 'Authorization Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45003\r\n\r\n### Authorization Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nAttempt to access resource where access is not allowed for given credentials.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly or apply for permissions.',
    causes: 'Attempt to access resource where access is not allowed for given credentials.',
    solutions: 'Check that accessed resource is set correctly or apply for permissions.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:51:10Z',
    last_updated: '2020-08-04T10:00:12.449Z',
  },
  21101: {
    code: 21101,
    message: 'Subaccounts cannot contain subaccounts',
    log_level: 'ERROR',
    secondary_message:
      'A subaccount cannot contain nested subaccounts.  Only a root account may contain subaccounts.',
    log_type: null,
    docs: null,
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:52Z',
    last_updated: '2020-08-04T10:00:27.333Z',
  },
  30041: {
    code: 30041,
    message: 'Message from an unregistered number sent to a United Kingdom number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30041\r\n\r\n### Message from an unregistered number sent to a United Kingdom number\r\n\r\n Message sent to a United Kingdom number may not be delivered because it is being sent from a number that must be registered.\r\n\r\n#### Possible Causes\r\nAlphanumeric, Shortcode, Twilio Domestic Longcode must complete and return a Letter of Authorization (LOA) to Twilio in order to continue using Protected Sender IDs to send messages to the United Kingdom. [More details on UK SMS Guidelines](https://www.twilio.com/en-us/guidelines/gb/sms).\r\n\r\n#### Possible Solutions\r\nAlphanumeric, Shortcode, Twilio Domestic Longcode must complete and return a Letter of Authorization (LOA) to Twilio in order to continue using Protected Sender IDs to send messages to the United Kingdom. [More details on UK SMS Guidelines](https://www.twilio.com/en-us/guidelines/gb/sms).',
    causes:
      'Alphanumeric, Shortcode, Twilio Domestic Longcode must complete and return a Letter of Authorization (LOA) to Twilio in order to continue using Protected Sender IDs to send messages to the United Kingdom. [More details on UK SMS Guidelines](https://www.twilio.com/en-us/guidelines/gb/sms).',
    solutions:
      'Alphanumeric, Shortcode, Twilio Domestic Longcode must complete and return a Letter of Authorization (LOA) to Twilio in order to continue using Protected Sender IDs to send messages to the United Kingdom. [More details on UK SMS Guidelines](https://www.twilio.com/en-us/guidelines/gb/sms).',
    description:
      'Message sent to a United Kingdom number may not be delivered because it is being sent from a number that must be registered.',
    product: 'Programmable SMS',
    date_created: '2023-07-14T08:24:27Z',
    last_updated: '2024-05-22T10:03:23.792416Z',
  },
  25002: {
    code: 25002,
    message: "The provided user's first name is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25002\r\n\r\n### The provided user's first name is invalid\r\n\r\n The provided user's first name is invalid.\r\n\r\n#### Possible Causes\r\nThe first name is either less than 2 characters or exceeds 255 characters.\r\n\r\n#### Possible Solutions\r\nEnsure the user's first name is between 2 and 255 characters in length.",
    causes: 'The first name is either less than 2 characters or exceeds 255 characters.',
    solutions: "Ensure the user's first name is between 2 and 255 characters in length.",
    description: "The provided user's first name is invalid.",
    product: 'Organizations API',
    date_created: '2023-12-04T09:42:10Z',
    last_updated: '2023-12-04T14:07:47.176388Z',
  },
  30475: {
    code: 30475,
    message:
      'Toll Free verification rejection - Opt-in not sufficient: Cannot combine consent for messaging with requirement for service',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30475\r\n\r\n### Toll Free verification rejection - Opt-in not sufficient: Cannot combine consent for messaging with requirement for service\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nYour opt-in mechanism requires that the consumer opt-in to messaging as a requirement of using your service, which is not allowed.\r\n\r\nConsent cannot be a requirement for your business’s service. A business may not combine collecting a consumer’s phone number with opting-in to receive marketing messaging. An explicit opt-in leaves no ambiguity for why the customer gave the phone number, and for how they expect the company will communicate with them. \r\n\r\nOpt-in refers to the process of getting a consumer’s permission to send them text messages. According to TCPA law, businesses must have "express written consent" from the consumer before texting them. NonConsumer (A2P) Message Senders should: \r\n* Obtain a Consumer’s consent to receive messages generally; \r\n* Obtain a Consumer’s express written consent to specifically receive marketing messages; and \r\n* Ensure that Consumers have the ability to revoke consent.\r\n\r\nNote: If there is promotional messaging on this toll-free phone number, it requires express written consent.\r\n\r\n#### Possible Solutions\r\n* Ensure your opt-in mechanism is a distinct action during a consumer’s sign up for your service. \r\n* An opt-in call-to-action (CTA) with a checkbox must be unchecked by default.\r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n',
    causes:
      'Your opt-in mechanism requires that the consumer opt-in to messaging as a requirement of using your service, which is not allowed.\r\n\r\nConsent cannot be a requirement for your business’s service. A business may not combine collecting a consumer’s phone number with opting-in to receive marketing messaging. An explicit opt-in leaves no ambiguity for why the customer gave the phone number, and for how they expect the company will communicate with them. \r\n\r\nOpt-in refers to the process of getting a consumer’s permission to send them text messages. According to TCPA law, businesses must have "express written consent" from the consumer before texting them. NonConsumer (A2P) Message Senders should: \r\n* Obtain a Consumer’s consent to receive messages generally; \r\n* Obtain a Consumer’s express written consent to specifically receive marketing messages; and \r\n* Ensure that Consumers have the ability to revoke consent.\r\n\r\nNote: If there is promotional messaging on this toll-free phone number, it requires express written consent.',
    solutions:
      '* Ensure your opt-in mechanism is a distinct action during a consumer’s sign up for your service. \r\n* An opt-in call-to-action (CTA) with a checkbox must be unchecked by default.\r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:57:31Z',
    last_updated: '2024-04-16T16:56:01.93199Z',
  },
  60208: {
    code: 60208,
    message: 'Rate limit with that UniqueName already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60208\r\n\r\n### Rate limit with that UniqueName already exists\r\n\r\n You tried to create a rate limit with a `UniqueName` that already exists for the specified service\r\n\r\nHTTP status: 400\r\n\r\n\r\n#### Possible Causes\r\nYou tried to create a rate limit with a `UniqueName` that already exists for the specified service\r\n\r\n#### Possible Solutions\r\n* Use a different `UniqueName`\r\n* Create a new service and create a rate limit with the desired `UniqueName`',
    causes:
      'You tried to create a rate limit with a `UniqueName` that already exists for the specified service',
    solutions:
      '* Use a different `UniqueName`\r\n* Create a new service and create a rate limit with the desired `UniqueName`',
    description:
      'You tried to create a rate limit with a `UniqueName` that already exists for the specified service\r\n\r\nHTTP status: 400\r\n',
    product: 'Verify',
    date_created: '2019-05-08T15:23:07Z',
    last_updated: '2021-05-18T04:40:50.96Z',
  },
  25016: {
    code: 25016,
    message: 'Updating the organization owner is not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25016\r\n\r\n### Updating the organization owner is not allowed\r\n\r\n Updating the organization owner is not allowed.\r\n\r\n#### Possible Causes\r\nUpdate request is trying to modify organization owner.\r\n\r\n#### Possible Solutions\r\nIf changes to the organization owner are necessary, contact support for guidance on handling specific scenarios.',
    causes: 'Update request is trying to modify organization owner.',
    solutions:
      'If changes to the organization owner are necessary, contact support for guidance on handling specific scenarios.',
    description: 'Updating the organization owner is not allowed.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:38:57Z',
    last_updated: '2023-12-04T14:22:12.2597Z',
  },
  62012: {
    code: 62012,
    message: 'Connection not found.',
    log_level: 'ERROR',
    secondary_message: 'The connection SID in the request could not be found.',
    log_type: null,
    docs: '## Error - 62012\r\n\r\n### Connection not found\r\n\r\nThe connection SID in the request could not be found.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:40:17Z',
    last_updated: '2020-08-04T10:00:20.98Z',
  },
  52137: {
    code: 52137,
    message: 'Invalid size of subject in APNs certificate',
    log_level: 'ERROR',
    secondary_message: 'APNs certificate is invalid',
    log_type: null,
    docs: '## Error - 52137\r\n\r\n### Invalid size of subject in APNs certificate\r\n\r\n#### Possible Causes \r\n*  The subject of APNs certificate is of invalid size.\r\n\r\n#### Possible Solutions\r\n*  The subject of the APNs certificate is the bundle ID of your application. Make sure you have a valid bundle ID defined when generating the certificate signing request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:37:14Z',
    last_updated: '2020-08-04T10:00:22.104Z',
  },
  17007: {
    code: 17007,
    message: 'Voice Insights Advanced Features not enabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 17007\r\n\r\n### Voice Insights Advanced Features not enabled\r\n\r\n The requested resource's call_sid is valid, but it ended before the Voice Insights product was last enabled for the requester's account.\r\n\r\n#### Possible Causes\r\nVoice Insights Advanced Features not enabled on the account when the call was made.\r\n\r\n#### Possible Solutions\r\nEnable Voice Insights Advanced Features for API access to future calls.",
    causes: 'Voice Insights Advanced Features not enabled on the account when the call was made.',
    solutions: 'Enable Voice Insights Advanced Features for API access to future calls.',
    description:
      "The requested resource's call_sid is valid, but it ended before the Voice Insights product was last enabled for the requester's account.",
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:32:28Z',
    last_updated: '2020-09-29T19:32:28Z',
  },
  95108: {
    code: 95108,
    message: 'Failed to delete resource',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95108\r\n\r\n### Failed to delete resource\r\n\r\n Twilio failed to delete resource\r\n\r\n#### Possible Causes\r\nResource was already deleted\r\n\r\n#### Possible Solutions\r\nResource was already deleted. Failed to access S3',
    causes: 'Resource was already deleted',
    solutions: 'Resource was already deleted. Failed to access S3',
    description: 'Twilio failed to delete resource',
    product: 'Voice Intelligence',
    date_created: '2024-05-03T18:46:27Z',
    last_updated: '2024-05-03T18:46:27Z',
  },
  91006: {
    code: 91006,
    message: 'The sink sid is in an invalid format',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91006\r\n\r\n### The sink sid is in an invalid format\r\n\r\n The sink sid provided does not match the expected format (dg[0-9a-f]{32})\r\n\r\n#### Possible Causes\r\nThe id for the sink has to start with a DG, followed by a 32 character UUID\r\n\r\n#### Possible Solutions\r\nMake sure the sink sid is in the expected format',
    causes: 'The id for the sink has to start with a DG, followed by a 32 character UUID',
    solutions: 'Make sure the sink sid is in the expected format',
    description: 'The sink sid provided does not match the expected format (dg[0-9a-f]{32})',
    product: 'Events',
    date_created: '2020-09-16T16:06:33Z',
    last_updated: '2021-01-06T16:29:00.38Z',
  },
  70104: {
    code: 70104,
    message: 'Invalid Public Key',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70104\r\n\r\n### Invalid Public Key\r\nThe Request tries to store a Public Key in Twilio. This public key cannot be parsed. Only supported key format is X.509 PEM. The prefix and suffix (-----BEGIN PUBLIC KEY-----) of the key can be present (but not mandatory).\r\n\r\n#### Possible Solution:\r\nMake sure the public key is correct in the request:\r\n* The key is in X.509 PEM format\r\n* There are no copy paste errors\r\n* All the parts of the key are present in the request.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:57:56Z',
    last_updated: '2020-08-04T10:00:19.8Z',
  },
  13333: {
    code: 13333,
    message: 'Gather: Invalid profanityFilter value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13333\r\n\r\n### Gather: Invalid profanityFilter value\r\n\r\n ## Warning - 13333\r\n\r\n### Gather: Invalid profanityFilter value\r\n\r\n#### Possible Causes\r\nProfanity filter is invalid\r\n\r\n#### Possible Solutions\r\nEnter valid profanity filter',
    causes: 'Profanity filter is invalid',
    solutions: 'Enter valid profanity filter',
    description: '## Warning - 13333\r\n\r\n### Gather: Invalid profanityFilter value',
    product: 'Programmable Voice',
    date_created: '2019-07-17T20:19:01Z',
    last_updated: '2020-08-04T10:00:07.661Z',
  },
  50452: {
    code: 50452,
    message: 'Group MMS is not enabled for this Account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50452\r\n\r\n### Group MMS is not enabled for this Account\r\n\r\n Triggered when an Account attempts to use GMMS without the appropriate permissions\r\n\r\n#### Possible Causes\r\nMissing permissions for GMMS\r\n\r\n#### Possible Solutions\r\nVerify if GMMS allowed for this Account',
    causes: 'Missing permissions for GMMS',
    solutions: 'Verify if GMMS allowed for this Account',
    description:
      'Triggered when an Account attempts to use GMMS without the appropriate permissions',
    product: 'Conversations',
    date_created: '2022-03-28T10:04:36Z',
    last_updated: '2022-03-28T10:04:36Z',
  },
  45307: {
    code: 45307,
    message: 'Add Participant Not Allowed',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45307\r\n\r\n### Add Participant Not Allowed\r\n\r\n Adding participant to the meeting is not allowed in the current meeting state\r\n\r\n#### Possible Causes\r\nMeeting is not in the right state for adding the participants\r\n\r\n#### Possible Solutions\r\nRetry operation',
    causes: 'Meeting is not in the right state for adding the participants',
    solutions: 'Retry operation',
    description: 'Adding participant to the meeting is not allowed in the current meeting state',
    product: 'Flex',
    date_created: '2020-05-08T21:27:02Z',
    last_updated: '2020-08-04T10:00:03.256Z',
  },
  33111: {
    code: 33111,
    message: 'Command exceeded max length',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33111\r\n\r\n### Command exceeded max length\r\n\r\n Raised whenever a Command from your SIM exceeds the maximum length of 160 characters. As a result the Command is truncated but still delivered to the target Callback URL.\r\n\r\n\r\n#### Possible Causes\r\n * The Command from your SIM in text mode exceeded the maximum length of 160 characters.\r\n\r\n\r\n#### Possible Solutions\r\n * Ensure that Commands in text mode do not exceed the maximum length.\r\n',
    causes:
      ' * The Command from your SIM in text mode exceeded the maximum length of 160 characters.\r\n',
    solutions: ' * Ensure that Commands in text mode do not exceed the maximum length.\r\n',
    description:
      'Raised whenever a Command from your SIM exceeds the maximum length of 160 characters. As a result the Command is truncated but still delivered to the target Callback URL.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:21:37Z',
    last_updated: '2020-09-15T11:21:37Z',
  },
  25007: {
    code: 25007,
    message: 'The organization has reached its limit for managed users',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25007\r\n\r\n### The organization has reached its limit for managed users\r\n\r\n The organization has reached its limit for managed users.\r\n\r\n#### Possible Causes\r\nThe maximum allowable number of users for the organization has been reached.\r\n\r\n#### Possible Solutions\r\nTo increase the limit of managed users for your organization, please get in touch with Twilio support.',
    causes: 'The maximum allowable number of users for the organization has been reached.',
    solutions:
      'To increase the limit of managed users for your organization, please get in touch with Twilio support.',
    description: 'The organization has reached its limit for managed users.',
    product: 'Organizations API',
    date_created: '2023-12-04T09:53:09Z',
    last_updated: '2023-12-04T14:14:52.303511Z',
  },
  52145: {
    code: 52145,
    message: 'Failed to authenticate with APNs',
    log_level: 'ERROR',
    secondary_message: 'Could not authenticate with APNs using the provided credentials',
    log_type: null,
    docs: '## Error - 52145\r\n\r\n### Failed to authenticate with APNs\r\n\r\n#### Possible Causes \r\n*  Unable to complete the TLS handshake with APNs.\r\n\r\n#### Possible Solutions\r\n* Verify that your certificate and private key are correct and can be used together.\r\n* Verify that your certificate has not been revoked.\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-01-04T11:29:20Z',
    last_updated: '2020-08-04T10:00:15.331Z',
  },
  60721: {
    code: 60721,
    message: 'Phone Number(s) already used in a Branded Channel',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60721\r\n\r\n### Phone Number(s) already used in a Branded Channel\r\n\r\n When you create/update a Branded Channel resource, you send a list of your phone numbers to be associated with it. You cannot have a phone number associated with more than one Branded Channel.\r\n\r\n#### Possible Causes\r\nAt least one of the phone numbers sent in the payload when creating/updating a Branded Channel are already associated with a different Branded Channel.\r\n\r\n#### Possible Solutions\r\nUse a different phone number in the Branded Channel payload, or remove the phone number from the existing Branded Channel if you really want to associate it with the Branded Channel being created/updated.',
    causes:
      'At least one of the phone numbers sent in the payload when creating/updating a Branded Channel are already associated with a different Branded Channel.',
    solutions:
      'Use a different phone number in the Branded Channel payload, or remove the phone number from the existing Branded Channel if you really want to associate it with the Branded Channel being created/updated.',
    description:
      'When you create/update a Branded Channel resource, you send a list of your phone numbers to be associated with it. You cannot have a phone number associated with more than one Branded Channel.',
    product: 'Branded Comms',
    date_created: '2020-01-24T20:26:36Z',
    last_updated: '2020-08-04T10:00:04.835Z',
  },
  53120: {
    code: 53120,
    message: ' Invalid Recording Rule(s)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53120\r\n\r\n###  Invalid Recording Rule(s)\r\n\r\n Raised by the server when a Recording Rule is invalid.\r\n\r\n#### Possible Causes\r\n* An empty set of rules [] is not allowed.\r\n* A rule containing all must have a value of true and must not contain any other expression.\r\n* A rule must contain a type field.\r\n* If kind is used, it must be audio or video.\r\n* A maximum of 20 recording rules are allowed per room.\r\n\r\n\r\n#### Possible Solutions\r\n* Ensure the set of rules has at least one rule.\r\n* If you include all in a rule, the only other allowed field is type.\r\n* Ensure every rule has a type field.\r\n* Ensure kind is one of the valid enum values.\r\n* Limit the number of recording rules to 20 or fewer.',
    causes:
      '* An empty set of rules [] is not allowed.\r\n* A rule containing all must have a value of true and must not contain any other expression.\r\n* A rule must contain a type field.\r\n* If kind is used, it must be audio or video.\r\n* A maximum of 20 recording rules are allowed per room.\r\n',
    solutions:
      '* Ensure the set of rules has at least one rule.\r\n* If you include all in a rule, the only other allowed field is type.\r\n* Ensure every rule has a type field.\r\n* Ensure kind is one of the valid enum values.\r\n* Limit the number of recording rules to 20 or fewer.',
    description: 'Raised by the server when a Recording Rule is invalid.',
    product: 'Programmable Video',
    date_created: '2020-06-19T00:08:24Z',
    last_updated: '2020-08-04T10:00:02.815Z',
  },
  30903: {
    code: 30903,
    message: 'Campaign rejection - Incorrect Sole Prop Brand Registration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30903\r\n\r\n### Campaign rejection - Incorrect Sole Prop Brand Registration\r\n\r\n The campaign for a Sole Proprietorship Brand has been rejected due to incorrect registration and failure to meet the small business Sole Proprietor (EIN) criteria set by TCR and mobile carriers.\r\n\r\n#### Possible Causes\r\nReasons for this failure can be:\r\n\r\n* Failure to meet the specified criteria for Sole Proprietor registration, entities with EINs should be registered as a Standard Brand.\r\n\r\n* Incorrect or incomplete registration information provided during the brand registration process.\r\n\r\n* Inconsistencies or discrepancies in the provided information.\r\n\r\n#### Possible Solutions\r\n* Verify the accuracy and completeness of the registration information for the Sole Proprietorship Brand.\r\n* Ensure that the brand meets the criteria defined by TCR and mobile carriers for Sole Proprietor (EIN) registration.\r\n* If the brand does not qualify as a Sole Proprietorship, consider registering it as a standard brand according to the appropriate guidelines and requirements.\r\n* Register a standard or acceptable campaign use case that aligns with the registered brand's classification.",
    causes:
      'Reasons for this failure can be:\r\n\r\n* Failure to meet the specified criteria for Sole Proprietor registration, entities with EINs should be registered as a Standard Brand.\r\n\r\n* Incorrect or incomplete registration information provided during the brand registration process.\r\n\r\n* Inconsistencies or discrepancies in the provided information.',
    solutions:
      "* Verify the accuracy and completeness of the registration information for the Sole Proprietorship Brand.\r\n* Ensure that the brand meets the criteria defined by TCR and mobile carriers for Sole Proprietor (EIN) registration.\r\n* If the brand does not qualify as a Sole Proprietorship, consider registering it as a standard brand according to the appropriate guidelines and requirements.\r\n* Register a standard or acceptable campaign use case that aligns with the registered brand's classification.",
    description:
      'The campaign for a Sole Proprietorship Brand has been rejected due to incorrect registration and failure to meet the small business Sole Proprietor (EIN) criteria set by TCR and mobile carriers.',
    product: 'Programmable Messaging',
    date_created: '2023-07-21T07:06:27Z',
    last_updated: '2023-07-21T07:06:27Z',
  },
  30701: {
    code: 30701,
    message: 'Brand Registration Failure: Invalid input parameters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30701\r\n\r\n### Brand Registration Failure: Invalid input parameters\r\n\r\n Brand registration request contained one or more invalid inputs. \r\n\r\n#### Possible Causes\r\nThe fields provided in the error message failed validations. Most string parameters are subject to min and/or max length validations. Some parameters are subject to additional country-specific validation rules, including business_registration_number, state, and postal_code. Please refer to the following table for validation details.\r\n\r\n#### Validation Rules\r\n\r\n|Property|Description|Validation|\r\n|--- |--- |--- |\r\n|friendly_name|Brand/Marketing/DBA name of the business|Max length 255|\r\n|business_name|The legal name of the business|Max length 255|\r\n|business_registration_number|Tax ID of the business|Max length 21|\r\n|first_name|First name of business contact|Max length 100|\r\n|last_name|Last name of business contact|Max length 100|\r\n|phone_number|The support contact telephone in e.164 format. E.g. +12023339999|Max length 20|\r\n|mobile_phone_number|Valid wireless telephone in e.164 format. E.g. +12023339999.|Max length 20|\r\n|street|Street name and house number. E.g. 1000 Sunset Hill Road|Max length 100|\r\n|city|City name|Max length 100|\r\n|region|State, region or province. For the United States, please use 2 character codes. E.g. \'CA\' for California.|Max length 20|\r\n|postal_code|Zipcode or postal code. E.g. 21012|Max length 10|\r\n|iso_country|2 letter ISO-2 country code. E.g. US, CA Length 2||\r\n|email|The email address of support contact|Max length 100|\r\n|stock_ticker|The stock symbol of the brand|Max length 10|\r\n|stock_exchange|The stock exchange of the brand|Enumerated values: "NONE", "NASDAQ", "NYSE", "AMEX", "AMX", "ASX", "B3", "BME", "BSE", "FRA", "ICEX", "JPX", "JSE", "KRX", "LON", "NSE", "OMX", "SEHK", "SGX", "SSE", "STO", "SWX", "SZSE", "TSX", "TWSE", "VSE", "OTHER"|\r\n|website_url|The website/online presence of the business|Max length 100|\r\n|business_industry|The segment in which the business operates in|Enumerated values: "AUTOMOTIVE", "AGRICULTURE", "BANKING", "CONSUMER", "EDUCATION", "ENGINEERING", "ENERGY", "OIL_AND_GAS", "FAST_MOVING_CONSUMER_GOODS", "FINANCIAL", "FINTECH", "FOOD_AND_BEVERAGE", "GOVERNMENT", "HEALTHCARE", "HOSPITALITY", "INSURANCE", "LEGAL", "MANUFACTURING", "MEDIA", "ONLINE", "RAW_MATERIALS", "REAL_ESTATE", "RELIGION", "RETAIL", "JEWELRY", "TECHNOLOGY", "TELECOMMUNICATIONS", "TRANSPORTATION", "TRAVEL", "ELECTRONICS", "NOT_FOR_PROFIT"|\r\n\r\n\r\n#### Possible Solutions\r\nPlease check your inputs for the fields in the error message and confirm that they meet the validations listed in possible causes.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    causes:
      'The fields provided in the error message failed validations. Most string parameters are subject to min and/or max length validations. Some parameters are subject to additional country-specific validation rules, including business_registration_number, state, and postal_code. Please refer to the following table for validation details.\r\n\r\n#### Validation Rules\r\n\r\n|Property|Description|Validation|\r\n|--- |--- |--- |\r\n|friendly_name|Brand/Marketing/DBA name of the business|Max length 255|\r\n|business_name|The legal name of the business|Max length 255|\r\n|business_registration_number|Tax ID of the business|Max length 21|\r\n|first_name|First name of business contact|Max length 100|\r\n|last_name|Last name of business contact|Max length 100|\r\n|phone_number|The support contact telephone in e.164 format. E.g. +12023339999|Max length 20|\r\n|mobile_phone_number|Valid wireless telephone in e.164 format. E.g. +12023339999.|Max length 20|\r\n|street|Street name and house number. E.g. 1000 Sunset Hill Road|Max length 100|\r\n|city|City name|Max length 100|\r\n|region|State, region or province. For the United States, please use 2 character codes. E.g. \'CA\' for California.|Max length 20|\r\n|postal_code|Zipcode or postal code. E.g. 21012|Max length 10|\r\n|iso_country|2 letter ISO-2 country code. E.g. US, CA Length 2||\r\n|email|The email address of support contact|Max length 100|\r\n|stock_ticker|The stock symbol of the brand|Max length 10|\r\n|stock_exchange|The stock exchange of the brand|Enumerated values: "NONE", "NASDAQ", "NYSE", "AMEX", "AMX", "ASX", "B3", "BME", "BSE", "FRA", "ICEX", "JPX", "JSE", "KRX", "LON", "NSE", "OMX", "SEHK", "SGX", "SSE", "STO", "SWX", "SZSE", "TSX", "TWSE", "VSE", "OTHER"|\r\n|website_url|The website/online presence of the business|Max length 100|\r\n|business_industry|The segment in which the business operates in|Enumerated values: "AUTOMOTIVE", "AGRICULTURE", "BANKING", "CONSUMER", "EDUCATION", "ENGINEERING", "ENERGY", "OIL_AND_GAS", "FAST_MOVING_CONSUMER_GOODS", "FINANCIAL", "FINTECH", "FOOD_AND_BEVERAGE", "GOVERNMENT", "HEALTHCARE", "HOSPITALITY", "INSURANCE", "LEGAL", "MANUFACTURING", "MEDIA", "ONLINE", "RAW_MATERIALS", "REAL_ESTATE", "RELIGION", "RETAIL", "JEWELRY", "TECHNOLOGY", "TELECOMMUNICATIONS", "TRANSPORTATION", "TRAVEL", "ELECTRONICS", "NOT_FOR_PROFIT"|\r\n',
    solutions:
      'Please check your inputs for the fields in the error message and confirm that they meet the validations listed in possible causes.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    description: 'Brand registration request contained one or more invalid inputs. ',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:17:53Z',
    last_updated: '2024-02-28T17:22:41.211521Z',
  },
  80301: {
    code: 80301,
    message: 'Not Found Phone Number SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 80301\r\n\r\n### Not Found Phone Number SID\r\n\r\n Phone Number SID is not associated with the Account SID.\r\n\r\n#### Possible Causes\r\nThe Account SID doesn't own the Phone Number SID.\r\n\r\n#### Possible Solutions\r\nThe Phone Number SID should be owned by the Account SID.",
    causes: "The Account SID doesn't own the Phone Number SID.",
    solutions: 'The Phone Number SID should be owned by the Account SID.',
    description: 'Phone Number SID is not associated with the Account SID.',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.075Z',
  },
  40155: {
    code: 40155,
    message: 'Invalid Workspace for Known Worker',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40155\r\n\r\n### Invalid Workspace for Known Worker\r\n\r\n Worker is not part of the workspace referenced by the Workflow target\r\n\r\n#### Possible Causes\r\nThe Worker targeted by the Known Worker Routing feature is not a member of the Workspace referenced by the Workflow Target\r\n\r\n#### Possible Solutions\r\nEnsure the Worker is a member of the Workspace referenced by the Workflow that is configured to use Known Agent Routing. \r\nFind out more about the Known Worker Routing feature here: https://www.twilio.com/docs/taskrouter/workflow-configuration/known-agent-routing',
    causes:
      'The Worker targeted by the Known Worker Routing feature is not a member of the Workspace referenced by the Workflow Target',
    solutions:
      'Ensure the Worker is a member of the Workspace referenced by the Workflow that is configured to use Known Agent Routing. \r\nFind out more about the Known Worker Routing feature here: https://www.twilio.com/docs/taskrouter/workflow-configuration/known-agent-routing',
    description: 'Worker is not part of the workspace referenced by the Workflow target',
    product: 'TaskRouter',
    date_created: '2022-12-29T10:57:28Z',
    last_updated: '2022-12-29T10:58:42.742646Z',
  },
  83008: {
    code: 83008,
    message: 'Unable to remove your Super SIM from its Fleet',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83008\r\n\r\n### Unable to remove your Super SIM from its Fleet\r\n\r\n Your Super SIM must be assigned to a Fleet while it is in status ‘ready’ or ‘active’.\r\n\r\n#### Possible Causes\r\n* The Super SIM is in status ready or active, and must belong to a Fleet.\r\n\r\n#### Possible Solutions\r\n* If you want to change your Super SIM’s Fleet while it is in status ready or active, you need to provide an alternative Fleet in the request.\r\n* Update the Super SIM’s status to inactive. This can be done either as a separate update request or in the same request as removing the Fleet.',
    causes: '* The Super SIM is in status ready or active, and must belong to a Fleet.',
    solutions:
      '* If you want to change your Super SIM’s Fleet while it is in status ready or active, you need to provide an alternative Fleet in the request.\r\n* Update the Super SIM’s status to inactive. This can be done either as a separate update request or in the same request as removing the Fleet.',
    description:
      'Your Super SIM must be assigned to a Fleet while it is in status ‘ready’ or ‘active’.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:24:43Z',
    last_updated: '2021-08-23T11:24:54.349612Z',
  },
  13313: {
    code: 13313,
    message: 'Gather: Invalid timeout value',
    log_level: 'WARNING',
    secondary_message:
      "timeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/gather#timeout'>Gather Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13313 \n\n### Gather: Invalid timeout value\n\ntimeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/gather#timeout'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:40Z',
    last_updated: '2020-08-04T10:00:28.123Z',
  },
  83010: {
    code: 83010,
    message: 'Unable to update your Super SIM to the desired status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83010\r\n\r\n### Unable to update your Super SIM to the desired status\r\n\r\n Your Super SIM cannot be updated from its current status to the desired status.\r\n\r\n#### Possible Causes\r\n* The Super SIM’s current status cannot be updated to the desired status.\r\n\r\n#### Possible Solutions\r\n* Check the public documentation for valid operations.',
    causes: '* The Super SIM’s current status cannot be updated to the desired status.',
    solutions: '* Check the public documentation for valid operations.',
    description: 'Your Super SIM cannot be updated from its current status to the desired status.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:26:13Z',
    last_updated: '2021-08-23T11:26:13Z',
  },
  20007: {
    code: 20007,
    message: 'Page size too large',
    log_level: 'ERROR',
    secondary_message:
      'You’ve requested a page size that is too large. The maximum page size is 1000.',
    log_type: null,
    docs: "## Error - 20007\n\n### Page size too large\n\nYou've requested a page size that is too large. The maximum page size is 1000.\n\n#### Possible solutions\n\n* Decrease the page size in your request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:30Z',
    last_updated: '2020-08-04T10:00:24.826Z',
  },
  90017: {
    code: 90017,
    message: "'Template' and 'TemplateSid'/'TemplateLanguage' must not be specified together",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90017\r\n\r\n### 'Template' and 'TemplateSid'/'TemplateLanguage' must not be specified together\r\n\r\n 'Template' and 'TemplateSid'/'TemplateLanguage' must not be specified together for template message\r\n\r\n#### Possible Causes\r\n'Template' and 'TemplateSid'/'TemplateLanguage' are specified together for template message\r\n\r\n#### Possible Solutions\r\nChoose which template message to use Direcy('Template') or Indirect('TemplateSid')",
    causes:
      "'Template' and 'TemplateSid'/'TemplateLanguage' are specified together for template message",
    solutions: "Choose which template message to use Direcy('Template') or Indirect('TemplateSid')",
    description:
      "'Template' and 'TemplateSid'/'TemplateLanguage' must not be specified together for template message",
    product: null,
    date_created: '2020-12-11T08:42:19Z',
    last_updated: '2020-12-11T08:42:19Z',
  },
  62053: {
    code: 62053,
    message: 'Interconnect: The subaccount is not authorized to access this connection.  ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '#### Possible Causes \r\n*  The subaccount is not authorized to access this connection.\r\n \r\n \r\n#### Possible Solutions\r\n*  Please verify your Interconnect Connection permission settings, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2017-06-05T22:47:22Z',
    last_updated: '2020-08-04T10:00:18.325Z',
  },
  50371: {
    code: 50371,
    message: 'Conversation webhook trigger not provided',
    log_level: 'ERROR',
    secondary_message: 'Scoped webhook trigger keywords are required but were not provided.',
    log_type: null,
    docs: '\n## Error - 50371\n\n### Conversations: Conversation webhook trigger not provided\nScoped webhook trigger keywords are required but were not provided.\n\n#### Possible Causes\n* The API expected at least one Configuration.Triggers input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a one or more valid Configuration.Triggers parameters to the API request and confirm that they are not misspelled.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.634Z',
  },
  60385: {
    code: 60385,
    message: 'Public key invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60385\r\n\r\n### Public key invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Public key in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Public key in the request body is correct.',
    causes: 'The Public key in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Public key in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:54:45Z',
    last_updated: '2024-02-06T14:08:01.23705Z',
  },
  21709: {
    code: 21709,
    message: 'Alpha Sender ID is Invalid or Not Authorized for this Messaging Service',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21709\r\n\r\n### Alpha Sender ID is Invalid or Not Authorized for this Messaging Service\r\n\r\n The Alpha Sender ID being added to a Messaging Service is invalid or Alpha Sender IDs have not been enabled for this Messaging Service.\r\n\r\n#### Possible Causes\r\n* The Messaging Service is not enabled to support Alpha Sender IDs. \r\n* The Alpha Sender ID being added to a Messaging Service is invalid. Alphanumeric Sender IDs may be up to 11 characters. They may not be only numbers. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\n#### Possible Solutions\r\n* Follow [these steps](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS#h_01F4SK0WYHA75NK1DNXGTCFMP8) to verify your Messaging Service is enabled to support Alpha Sender IDs. If it is not, please reach out to Support.\r\n* Verify the Alpha Sender ID you are trying to add to the Messaging Service is valid. View formatting requirements [here](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS#h_01F4SK0R6NH8AQW36Y4BR16FVA).',
    causes:
      '* The Messaging Service is not enabled to support Alpha Sender IDs. \r\n* The Alpha Sender ID being added to a Messaging Service is invalid. Alphanumeric Sender IDs may be up to 11 characters. They may not be only numbers. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.',
    solutions:
      '* Follow [these steps](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS#h_01F4SK0WYHA75NK1DNXGTCFMP8) to verify your Messaging Service is enabled to support Alpha Sender IDs. If it is not, please reach out to Support.\r\n* Verify the Alpha Sender ID you are trying to add to the Messaging Service is valid. View formatting requirements [here](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS#h_01F4SK0R6NH8AQW36Y4BR16FVA).',
    description:
      'The Alpha Sender ID being added to a Messaging Service is invalid or Alpha Sender IDs have not been enabled for this Messaging Service.',
    product: 'Programmable SMS',
    date_created: '2021-05-27T17:43:31Z',
    last_updated: '2022-07-18T23:08:16.611224Z',
  },
  11202: {
    code: 11202,
    message: 'TCP connection refused',
    log_level: 'ERROR',
    secondary_message:
      'Twilio cannot establish a TCP connection to your web server. Your web server rejected our two connection attempts.',
    log_type: null,
    docs: '## Error - 11202\r\n### TCP connection refused\r\nTwilio cannot establish a TCP connection to your web server. Your web server rejected our two connection attempts.\r\n\r\n#### Possible Causes\r\n* invalid port number in the HTTP URL\r\n* your web server process is down so no process is listening on the port\r\n* your web server is in a degraded state and is not accepting new connections (e.g., overloaded)\r\n\r\n#### Possible Solutions\r\n* verify the HTTP URL provided has the correct host and port number of your web server\r\n* verify your web server is running and listening on the correct port\r\n* verify your web server is properly provisioned to handle all requests',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-07-26T20:08:56Z',
    last_updated: '2020-08-04T10:00:12.927Z',
  },
  31530: {
    code: 31530,
    message: 'DNS Resolution Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31530\r\n\r\n### DNS Resolution Error\r\n\r\nCould not connect to the server.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:47:58Z',
    last_updated: '2020-08-04T10:00:08.173Z',
  },
  83703: {
    code: 83703,
    message: 'Attachment Rejected Due To Rate Limiting',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83703\r\n\r\n### Attachment Rejected Due To Rate Limiting\r\n\r\n The SIM was not able to attach to the specified Network because your device has repeatedly attempted to connect too frequently and is rate limited. Rate limiting is enforced to protect the network infrastracture and prevent one device from impacting the experience of other users on the Network.\r\n\r\n#### Possible Causes\r\n * Your device may be stuck in a loop and is repeatedly and rapidly attempting to reattach to the network.\r\n\r\n#### Possible Solutions\r\n * Implement backoffs in connection attempts on your device to not overwhelm the network infrastructure.',
    causes:
      ' * Your device may be stuck in a loop and is repeatedly and rapidly attempting to reattach to the network.',
    solutions:
      ' * Implement backoffs in connection attempts on your device to not overwhelm the network infrastructure.',
    description:
      'The SIM was not able to attach to the specified Network because your device has repeatedly attempted to connect too frequently and is rate limited. Rate limiting is enforced to protect the network infrastracture and prevent one device from impacting the experience of other users on the Network.',
    product: 'Super SIM',
    date_created: '2022-07-21T14:25:26Z',
    last_updated: '2022-07-21T14:26:17.560462Z',
  },
  83500: {
    code: 83500,
    message: 'No eSIM Profiles are available',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 83500\r\n\r\n### No eSIM Profiles are available\r\n\r\n Twilio currently does not have eSIM Profiles available for ordering.\r\n\r\n#### Possible Causes\r\n* There are no eSIM Profiles currently available for ordering.\r\n\r\n#### Possible Solutions\r\n* Twilio tries to restock eSIM Profiles as soon as possible. If you would like to be notified when eSIM Profiles are available again, please open a ticket with customer support.',
    causes: '* There are no eSIM Profiles currently available for ordering.',
    solutions:
      '* Twilio tries to restock eSIM Profiles as soon as possible. If you would like to be notified when eSIM Profiles are available again, please open a ticket with customer support.',
    description: 'Twilio currently does not have eSIM Profiles available for ordering.',
    product: 'Super SIM',
    date_created: '2021-11-02T12:45:52Z',
    last_updated: '2021-11-02T12:45:52Z',
  },
  14101: {
    code: 14101,
    message: 'Invalid "To" attribute',
    log_level: 'WARNING',
    secondary_message: 'The To attribute does not appear to be a phone number that you can SMS',
    log_type: null,
    docs: '## Warning - 14101 \n\n### "To" Attribute is Invalid\n\nThe To attribute does not appear to be a phone number that you can SMS\n\n#### Possible Causes \n*  Invalid formatted number\n*  SMSing an un-validated number while using a Trial Account\n\n\n#### Possible Solutions\n*  Check the number and make sure it is a valid 10 digit domestic phone number  \n*  Confirm you have validated this number, if you are still using a Trial account, or upgrade your account\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:47Z',
    last_updated: '2020-08-04T10:00:27.68Z',
  },
  50373: {
    code: 50373,
    message: 'No Messaging Service assigned to Conversation',
    log_level: 'ERROR',
    secondary_message:
      'This Conversation does not have an assigned Messaging Service, therefore cannot accept non-chat participants.',
    log_type: null,
    docs: '\n## Error - 50373\n\n### Conversations: No Messaging Service assigned to Conversation\nThis Conversation does not have an assigned Messaging Service, therefore cannot accept non-chat participants.\n\n#### Possible Causes\n* You may be attempting to add a non-Chat participant (e.g. on SMS) to a channel from Programmable Chat. As Chat precedes the Conversations product, these channels first need to be provided a Messaging Service before they can access SMS, WhatsApp, or other channels.\n\n#### Possible Solutions\n* Update the Conversation with any existing Messaging Service SID on your account. After that, you will be able to add non-Chat participants and continue the conversation with them involved.\n\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.594Z',
  },
  30012: {
    code: 30012,
    message: 'TTL is too small',
    log_level: 'ERROR',
    secondary_message: 'Message Time To Live is too small',
    log_type: null,
    docs: '## Error - 30012\r\n\r\n## Message Time To Live is too small\r\n\r\n### Possible Causes \r\nTTL specified in the request is too small\r\n\r\n### Possible Solutions\r\nSpecify a bigger TTL\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-22T10:39:38Z',
    last_updated: '2020-08-04T10:00:11.52Z',
  },
  25006: {
    code: 25006,
    message: 'The SCIM schema syntax is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25006\r\n\r\n### The SCIM schema syntax is invalid\r\n\r\n The SCIM schema syntax is invalid.\r\n\r\n#### Possible Causes\r\nThe provided SCIM schema is not correctly formatted or does not adhere to the specified syntax.\r\n\r\n#### Possible Solutions\r\nDouble-check the schema for accuracy and ensure it complies with the RFC 7643 guidelines for SCIM. Refer to the RFC 7643 documentation for detailed information on valid syntax.',
    causes:
      'The provided SCIM schema is not correctly formatted or does not adhere to the specified syntax.',
    solutions:
      'Double-check the schema for accuracy and ensure it complies with the RFC 7643 guidelines for SCIM. Refer to the RFC 7643 documentation for detailed information on valid syntax.',
    description: 'The SCIM schema syntax is invalid.',
    product: 'Organizations API',
    date_created: '2023-12-04T09:51:35Z',
    last_updated: '2023-12-04T14:14:32.220565Z',
  },
  21732: {
    code: 21732,
    message: 'Campaign limit reached on the Brand',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21732\r\n\r\n### Campaign limit reached on the Brand\r\n\r\n You can only set up one Sole Proprietor Campaign per Sole Proprietor Brand. Please note that campaigns in all statuses (such as Pending, Registered, Failed) count towards this limit.\r\n\r\n#### Possible Causes\r\nYour request to create a Campaign has failed because there’s already an existing Campaign associated with this Sole Proprietor Brand.\r\n\r\n#### Possible Solutions\r\nPlease delete the existing Campaign first and then retry.',
    causes:
      'Your request to create a Campaign has failed because there’s already an existing Campaign associated with this Sole Proprietor Brand.',
    solutions: 'Please delete the existing Campaign first and then retry.',
    description:
      'You can only set up one Sole Proprietor Campaign per Sole Proprietor Brand. Please note that campaigns in all statuses (such as Pending, Registered, Failed) count towards this limit.',
    product: 'Programmable Messaging',
    date_created: '2023-11-14T08:38:44Z',
    last_updated: '2023-11-14T08:38:44Z',
  },
  53006: {
    code: 53006,
    message: 'Video server is busy',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 53006\r\n\r\n### Video server is busy\r\n\r\n Raised when the server is too busy to accept new clients.\r\n\r\n#### Possible Causes\r\nThe Video server is temporarily overloaded and cannot handle new requests.\r\n\r\n#### Possible Solutions\r\n* Try connecting later.\r\n* If the problem persists, try connecting to another region.',
    causes: 'The Video server is temporarily overloaded and cannot handle new requests.',
    solutions:
      '* Try connecting later.\r\n* If the problem persists, try connecting to another region.',
    description: 'Raised when the server is too busy to accept new clients.',
    product: 'Programmable Video',
    date_created: '2022-05-26T18:04:35Z',
    last_updated: '2022-05-26T18:05:37.237199Z',
  },
  50442: {
    code: 50442,
    message: 'Failed to remove the projected address of a participant.',
    log_level: 'ERROR',
    secondary_message: 'The participant should have a projected address in order to remove it.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50442\r\n\r\n### Failed to remove the projected address of a participant.\r\n\r\nThe participant should have a projected address in order to remove it. The conversation participant being updated does not have a projected address.\r\n\r\n#### Possible Causes\r\n* The participant does not have the projected address you are trying to remove.\r\n\r\n#### Possible Solutions\r\n* Check that the request does not update projected address of this particular participant.',
    causes: '* The participant does not have the projected address you are trying to remove.',
    solutions:
      '* Check that the request does not update projected address of this particular participant.',
    description: 'The conversation participant being updated does not have a projected address.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:02:11Z',
    last_updated: '2021-08-16T12:02:11Z',
  },
  25101: {
    code: 25101,
    message: "The organization's account was not found",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25101\r\n\r\n### The organization's account was not found\r\n\r\n The organization's account was not found.\r\n\r\n#### Possible Causes\r\n- Requested account doesn't exist\r\n- Requested account is not a managed account\r\n\r\n#### Possible Solutions\r\nVerify the Organization Sid and the Account Sid. Ensure that the Organization Sid corresponds to your organization and the Account is a managed account.",
    causes: "- Requested account doesn't exist\r\n- Requested account is not a managed account",
    solutions:
      'Verify the Organization Sid and the Account Sid. Ensure that the Organization Sid corresponds to your organization and the Account is a managed account.',
    description: "The organization's account was not found.",
    product: 'Organizations API',
    date_created: '2023-12-04T11:14:32Z',
    last_updated: '2023-12-04T14:25:18.442364Z',
  },
  80101: {
    code: 80101,
    message: 'Number Already Added to Another Service',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80101\r\n\r\n### Number Already Added to Another Service\r\n\r\n A phone number can be added in one service at a time.\r\n\r\n#### Possible Causes\r\nPhone Number has already been added to another Service.\r\n\r\n#### Possible Solutions\r\nAdd a different phone number or remove the number from the relevant Proxy Service. ',
    causes: 'Phone Number has already been added to another Service.',
    solutions:
      'Add a different phone number or remove the number from the relevant Proxy Service. ',
    description: 'A phone number can be added in one service at a time.',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.301Z',
  },
  19046: {
    code: 19046,
    message: 'Number of custom field definitions exceeded limit',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19046\r\n\r\n### Number of custom field definitions exceeded limit\r\n\r\n Maximum number of custom field definition allowed is 2000\r\n\r\n#### Possible Causes\r\nAttempt to create more custom fields definitions than allowed\r\n\r\n#### Possible Solutions\r\nDelete an existing custom field before adding a new one',
    causes: 'Attempt to create more custom fields definitions than allowed',
    solutions: 'Delete an existing custom field before adding a new one',
    description: 'Maximum number of custom field definition allowed is 2000',
    product: 'Contacts',
    date_created: '2020-07-21T20:37:22Z',
    last_updated: '2020-08-31T06:15:01.409Z',
  },
  91005: {
    code: 91005,
    message: 'Test ID is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91005\r\n\r\n### Test ID is invalid\r\n\r\n Test ID is invalid\r\n\r\n#### Possible Causes\r\n* The provided test id is not the one that was sent to the configured stream\r\n\r\n#### Possible Solutions\r\n* Ensure test id is valid and exists in your stream',
    causes: '* The provided test id is not the one that was sent to the configured stream',
    solutions: '* Ensure test id is valid and exists in your stream',
    description: 'Test ID is invalid',
    product: 'Events',
    date_created: '2020-09-16T15:56:33Z',
    last_updated: '2021-01-06T16:28:00.938Z',
  },
  94200: {
    code: 94200,
    message: 'Transcriptions Settings: Invalid encryptionEnabled value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94200\r\n\r\n### Transcriptions Settings: Invalid encryptionEnabled value\r\n\r\n Invalid "encryptionEnabled" value. It should be either true or false\r\n\r\n#### Possible Causes\r\n* "encryptionEnabled" value is invalid\r\n\r\n#### Possible Solutions\r\n* Set "encryptionEnabled" value to true to enable encryption for transcriptions\r\n* Set "encryptionEnabled" value to false to disable encryption for transcriptions',
    causes: '* "encryptionEnabled" value is invalid',
    solutions:
      '* Set "encryptionEnabled" value to true to enable encryption for transcriptions\r\n* Set "encryptionEnabled" value to false to disable encryption for transcriptions',
    description: 'Invalid "encryptionEnabled" value. It should be either true or false',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-02T11:06:25Z',
  },
  21201: {
    code: 21201,
    message: 'No Called number specified',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to initiate an outbound phone call, but you did not specify what number to call in the <span class='rest-attribute'>Called</span> POST parameter",
    log_type: null,
    docs: "## Error - 21201 \n\n### No 'To' number specified\n\nYou attempted to initiate an outbound phone call, but you did not specify what number to call in the 'To' POST parameter\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:53Z',
    last_updated: '2020-08-04T10:00:27.297Z',
  },
  30445: {
    code: 30445,
    message: 'Toll Free verification rejection - Could not validate business information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30445\r\n\r\n### Toll Free verification rejection - Could not validate business information\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\n#### Possible Causes\r\nThe Toll-Free phone number cannot be verified because of invalid information. The Business Information such as business name or address that was submitted could not be verified or the website URL could be not validated because it is not accessible or available. Or the ISV contact information was provided instead of its customer’s contact information. \r\n\r\n#### Possible Solutions\r\n* Ensure all business information fields are valid and accurately represent the business who manages the opt-in and has the relationship with the consumer:\r\n\r\n  -- BusinessName\r\n\r\n  -- BusinessStreetAddress\r\n\r\n  -- BusinessCity\r\n\r\n  -- BusinessStateProvinceRegion\r\n\r\n  -- BusinessPostalCode\r\n\r\n  -- BusinessCountry\r\n\r\n  -- BusinessContactFirstName\r\n\r\n  -- BusinessContactLastName\r\n\r\n  -- BusinessContactEmail\r\n\r\n  -- BusinessContactPhone\r\n\r\n  -- BusinessWebsite\r\n\r\n- Correct the business information fields on toll-free verification submission by editing it and then resubmit it. \r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The Toll-Free phone number cannot be verified because of invalid information. The Business Information such as business name or address that was submitted could not be verified or the website URL could be not validated because it is not accessible or available. Or the ISV contact information was provided instead of its customer’s contact information. ',
    solutions:
      '* Ensure all business information fields are valid and accurately represent the business who manages the opt-in and has the relationship with the consumer:\r\n\r\n  -- BusinessName\r\n\r\n  -- BusinessStreetAddress\r\n\r\n  -- BusinessCity\r\n\r\n  -- BusinessStateProvinceRegion\r\n\r\n  -- BusinessPostalCode\r\n\r\n  -- BusinessCountry\r\n\r\n  -- BusinessContactFirstName\r\n\r\n  -- BusinessContactLastName\r\n\r\n  -- BusinessContactEmail\r\n\r\n  -- BusinessContactPhone\r\n\r\n  -- BusinessWebsite\r\n\r\n- Correct the business information fields on toll-free verification submission by editing it and then resubmit it. \r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:13:15Z',
    last_updated: '2024-04-16T16:13:31.718472Z',
  },
  13227: {
    code: 13227,
    message: 'Geo Permission configuration is not permitting call',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13227\r\n\r\n### Geo Permission configuration is not permitting call\r\n\r\n You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.\r\n\r\n#### Possible Causes\r\nUser dialed a destination your application is not enabled to support calling to.\r\n\r\n#### Possible Solutions\r\nPlease check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try again.',
    causes: 'User dialed a destination your application is not enabled to support calling to.',
    solutions:
      'Please check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try again.',
    description:
      'You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:35Z',
    last_updated: '2023-09-26T23:13:31.194526Z',
  },
  21658: {
    code: 21658,
    message: 'Parameter exceeded character limit',
    log_level: 'ERROR',
    secondary_message: 'Parameter exceeded character limit',
    log_type: 'APPLICATION',
    docs: "## ERROR - 21658\r\n\r\n### Parameter exceeded character limit\r\n\r\n Parameter exceeded character limit\r\n\r\n#### Possible Causes\r\nEnsure parameter doesn't exceed character limit during content creation\r\n\r\n#### Possible Solutions\r\nValidate parameter in within character limit",
    causes: "Ensure parameter doesn't exceed character limit during content creation",
    solutions: 'Validate parameter in within character limit',
    description: 'Parameter exceeded character limit',
    product: 'Programmable SMS',
    date_created: '2023-05-01T20:55:01Z',
    last_updated: '2023-05-05T22:03:39.075346Z',
  },
  21722: {
    code: 21722,
    message: 'Invalid Campaign Verify token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21722\r\n\r\n### Invalid Campaign Verify token\r\n\r\n The attempt to import a Campaign Verify token to your brand failed because your token is invalid.\r\n\r\n#### Possible Causes\r\n- The token is not formatted correctly\r\n\r\n#### Possible Solutions\r\nVerify that you are using a valid token from Campaign Verify that is not expired and hasn’t been used by another A2P brand. Then, try to import your token again.',
    causes: '- The token is not formatted correctly',
    solutions:
      'Verify that you are using a valid token from Campaign Verify that is not expired and hasn’t been used by another A2P brand. Then, try to import your token again.',
    description:
      'The attempt to import a Campaign Verify token to your brand failed because your token is invalid.',
    product: 'Programmable SMS',
    date_created: '2021-10-25T16:08:50Z',
    last_updated: '2021-10-25T16:10:29.671604Z',
  },
  80617: {
    code: 80617,
    message: 'Flex Configuration Error',
    log_level: 'ERROR',
    secondary_message: 'A Flex component was not configured correctly',
    log_type: null,
    docs: '## Error - 80617 \r\n\r\n### Flex Configuration Error\r\n\r\nA Flex component was not configured correctly.\r\n\r\n#### Possible Causes \r\n* You made changes to one of your Flex phone numbers\r\n* You are trying to use a phone number with Flex but have not created a Flex Flow for that number\r\n* You manually deleted a Chat Channel or Proxy Session\r\n* You removed or changed the Chat Channel Sid setting in your Proxy Service\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2019-02-12T23:50:50Z',
    last_updated: '2020-08-04T10:00:10.634Z',
  },
  50370: {
    code: 50370,
    message: 'Conversation webhook filter not provided',
    log_level: 'ERROR',
    secondary_message: 'Scoped webhook filter parameter is required but was not provided.',
    log_type: null,
    docs: '\n## Error - 50370\n\n### Conversations: Conversation webhook filter not provided\nScoped webhook filter parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected at least one Configuration.Filters input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add one or more valid Configuration.Filters parameters to the API request and confirm that they are not misspelled.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.651Z',
  },
  32007: {
    code: 32007,
    message: 'SIP: Too many endpoints/bindings for the Address-of-record (AOR)',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: 'The AOR refers to: username@yoursipdomain.com\r\n\r\nThere is a limit on the number of SIP Endpoints/bindings per AOR\r\n\r\n<b>Possible Causes</b>\r\n\r\nThere is a limit of 10 bindings (SIP Endpoints) per AOR.\r\n\r\n<b>Possible Solutions</b>\r\nReduce the number of SIP Endpoints',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-11-15T19:54:16Z',
    last_updated: '2020-08-04T10:00:20.489Z',
  },
  13510: {
    code: 13510,
    message: 'Say: Invalid loop value',
    log_level: 'WARNING',
    secondary_message:
      "The value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/say#loop'>Play Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13510 \n\n### Say: Invalid loop value\n\nThe value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/say#loop'>Play Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:42Z',
    last_updated: '2020-08-04T10:00:27.971Z',
  },
  50511: {
    code: 50511,
    message: 'Invalid message media content type',
    log_level: 'ERROR',
    secondary_message: 'An invalid multimedia attachment content type was supplied.',
    log_type: null,
    docs: '\n## Error - 50511\n\n### Conversations: Invalid message media content type\nAn invalid multimedia attachment content type was supplied.\n\n#### Possible Causes\n* The MIME content type of multimedia attachment you are trying to send is not acceptable for this conversation.\n\n#### Possible Solutions\n* Make sure that the content type of multimedia attachments conform to channel constraints. Check for accepted MIME types in [API documentation](https://www.twilio.com/docs/conversations/conversations-limits#media-limits).  \n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.279Z',
  },
  50327: {
    code: 50327,
    message: 'Programmable Chat: Invalid channel webhook flow sid',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correct parameter for webhook flow sid',
    log_type: null,
    docs: '## Error - 50327\r\n\r\n### Programmable Chat: Invalid channel webhook flow sid\r\n\r\n#### Possible Causes \r\n*  Request does not contain correct parameter for channel webhook flow sid.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T15:59:50Z',
    last_updated: '2020-08-04T10:00:12.019Z',
  },
  20154: {
    code: 20154,
    message: 'Invalid Claim Set',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20154 \r\n\r\n### Invalid Claim Set\r\nThe JWT could be parsed, but the claims in the payload section are invalid.\r\n\r\n#### Possible Causes \r\n* One of the required claims is missing.\r\n* For JWTs used as part of Public Key Client Validation, we require two custom claims:\r\n  * “hrh” - HTTP headers that were included when calculating the request hash\r\n  * “rqh” - The hash of the HTTP request\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest Twilio Helper Library\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:08:16Z',
    last_updated: '2020-08-04T10:00:19.07Z',
  },
  50211: {
    code: 50211,
    message: 'Identity parameter not acceptable for this Participant',
    log_level: 'ERROR',
    secondary_message:
      'Participants on SMS, WhatsApp or other non-Chat channels cannot have Identities.',
    log_type: null,
    docs: '\n## Error - 50211\n\n### Conversations: Identity parameter not acceptable for this Participant\nParticipants on SMS, WhatsApp or other non-Chat channels cannot have Identities.\n\n#### Possible Causes\nThis error is fired when the parameter *Identity* is provided together with either:\n* MessagingBinding.Address,\n* MessagingBinding.ProxyAddress, or\n* both of the above.\n\nAs the error indicates, such a combination is not allowed. You can provide either an address binding or an Identity, but not both.\n\n#### Possible Solutions\n* Avoid using both Identity and MessagingBinding.Address parameters when creating a Conversation participant. Instead, distinguish the use-case for your participants upfront and supply either the Identity for users of Programmable Chat Web/iOS/Android SDKs, or MessagingBinding.Address for non-Chat users such as SMS, MMS, WhatsApp, etc.\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2018-10-10T11:43:38Z',
    last_updated: '2020-08-04T10:00:12.178Z',
  },
  90010: {
    code: 90010,
    message: 'Account is not active',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: 'This account is currently not in an active state\r\n\r\n#### Possible causes\r\n\r\n* Account is suspended\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-04-01T20:24:55Z',
    last_updated: '2020-08-04T10:00:22.612Z',
  },
  45355: {
    code: 45355,
    message: 'Failed to create a channel.  No Participants found.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45355\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'No Participants were found in a Conversation that triggered a new Channel to be created. The Participant may have been removed after the Conversation was created.',
    solutions: 'Close this Conversation and start a new one.\r',
    description:
      'Failed to create Channel <channel sid> because no Participants were found in the associated Conversation <conversation sid>.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:30.909711Z',
  },
  50602: {
    code: 50602,
    message: 'Programmable Chat: Cannot decline invite when already channel member.',
    log_level: 'ERROR',
    secondary_message:
      'Specified user is already member of this channel so his invitation is not present.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 50602\r\n\r\n### Programmable Chat: Cannot decline invite when already channel member.\r\n\r\nSpecified user is already member of this channel so his invitation is not present. \r\n\r\n#### Possible Causes\r\nUser was added directly to the channel and his invite was removed so he can't decline it.\r\n\r\n#### Possible Solutions\r\nUser shouldn't decline invite if he was already added to channel.",
    causes:
      "User was added directly to the channel and his invite was removed so he can't decline it.",
    solutions: "User shouldn't decline invite if he was already added to channel.",
    description: null,
    product: 'Programmable Chat',
    date_created: '2019-11-21T11:27:40Z',
    last_updated: '2020-08-04T10:00:05.994Z',
  },
  45371: {
    code: 45371,
    message: 'Failed to close Channel.  Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45371\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'We failed to update the status of a Channel (e.g., to close the Channel) due to an unexpected error condition.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to update Channel <channel sid> due to an internal error.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:09.263426Z',
  },
  60003: {
    code: 60003,
    message: 'End User Data is Not Available',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60003\r\n\r\n### End User Data is Not Available\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received and processed successfully but data is not available for the requested end user.\r\n\r\n#### Possible Solutions\r\nDo not retry request for this end user.',
    causes:
      'The request was received and processed successfully but data is not available for the requested end user.',
    solutions: 'Do not retry request for this end user.',
    description: null,
    product: null,
    date_created: '2022-09-06T13:10:40.987363Z',
    last_updated: '2022-09-06T13:10:40.987372Z',
  },
  60727: {
    code: 60727,
    message: 'Channel not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60727\r\n\r\n### Channel not found\r\n\r\n Returned when looking for a channel with no match in the storage\r\n\r\n#### Possible Causes\r\n- The channel does not exist anymore\r\n- The phone number sent is invalid/incorrect\r\n\r\n#### Possible Solutions\r\n- Check the phone number in your request',
    causes: '- The channel does not exist anymore\r\n- The phone number sent is invalid/incorrect',
    solutions: '- Check the phone number in your request',
    description: 'Returned when looking for a channel with no match in the storage',
    product: 'Branded Comms',
    date_created: '2020-04-14T22:49:13Z',
    last_updated: '2020-08-04T10:00:04.035Z',
  },
  31104: {
    code: 31104,
    message: 'Invalid bridge token.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31104\r\n\r\n### Invalid bridge token.\r\n\r\nInvalid bridge token.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:44:13Z',
    last_updated: '2020-08-04T10:00:11.169Z',
  },
  53002: {
    code: 53002,
    message: 'Signaling connection timed out',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53002: Signaling connection timed out\r\n\r\nRaised whenever the signaling connection times out.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:38:29Z',
    last_updated: '2020-08-04T10:00:19.726Z',
  },
  13614: {
    code: 13614,
    message: 'Record: Invalid transcribe value',
    log_level: 'WARNING',
    secondary_message:
      "The transcribe attribute of Record must be FAST or ACCURATE. See the <a href='/docs/api/twiml/record#transcribe'>Record Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13614 \n\n### Record: Invalid transcribe value\n\nThe transcribe attribute of Record must be TRUE or FALSE. See the <a href='/docs/api/twiml/record#transcribe'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:45Z',
    last_updated: '2020-08-04T10:00:27.802Z',
  },
  19055: {
    code: 19055,
    message:
      'When updating a channel, invalid JSON syntax or invalid field that cannot be updated by this endpoint',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19055\r\n\r\n### When updating a channel, invalid JSON syntax or invalid field that cannot be updated by this endpoint\r\n\r\n Invalid JSON or fields other than type, description and is_primary exist in update channel request\r\n\r\n#### Possible Causes\r\nUser provided an invalid JSON or trying to update fields other than type, description and is_primary of a channel\r\n\r\n#### Possible Solutions\r\nFix JSON input or change update channel request to update only type, description and is_primary',
    causes:
      'User provided an invalid JSON or trying to update fields other than type, description and is_primary of a channel',
    solutions:
      'Fix JSON input or change update channel request to update only type, description and is_primary',
    description:
      'Invalid JSON or fields other than type, description and is_primary exist in update channel request',
    product: 'Contacts',
    date_created: '2020-08-07T22:53:01Z',
    last_updated: '2020-08-24T18:19:06.363Z',
  },
  50437: {
    code: 50437,
    message: 'Group Participant already exists',
    log_level: 'ERROR',
    secondary_message: 'Participant already exists in the group conversation.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50437\r\n\r\n### Group Participant already exists\r\n\r\nParticipant already exists in the group conversation. A participant matching this one already exists in the conversation.\r\n\r\n#### Possible Causes\r\n* An participant with the same ProxyAddress+Address pair already exists in this conversation\r\n* A native GMMS Participant with the same Address exists in this conversation\r\n* A Chat Participant with the same Identity and Project Address exists in this conversation\r\n\r\nThis error may result from a race condition, where a participant was inadvertently added twice.\r\n\r\n#### Possible Solutions\r\n* Add the participant with a different Address or Identity\r\n* Ignore this error — your participant is already present.',
    causes:
      '* An participant with the same ProxyAddress+Address pair already exists in this conversation\r\n* A native GMMS Participant with the same Address exists in this conversation\r\n* A Chat Participant with the same Identity and Project Address exists in this conversation\r\n\r\nThis error may result from a race condition, where a participant was inadvertently added twice.',
    solutions:
      '* Add the participant with a different Address or Identity\r\n* Ignore this error — your participant is already present.',
    description: 'A participant matching this one already exists in the conversation.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T11:58:20Z',
    last_updated: '2021-08-16T11:58:20Z',
  },
  40140: {
    code: 40140,
    message: "Failed to issue Dequeue instruction due to missing 'call_sid' property",
    log_level: 'ERROR',
    secondary_message: ' ',
    log_type: 'APPLICATION',
    docs: "## ERROR - 40140\r\n\r\n### Failed to issue Dequeue instruction due to missing 'call_sid' property\r\n\r\n  \r\n\r\n#### Possible Causes\r\n* The Task was not created via the `<Enqueue>` verb\r\n* The `call_sid` property is missing in the Task's attributes\r\n\r\n#### Possible Solutions\r\n* Only issue Dequeue instruction on Tasks created via the `<Enqueue>` verb\r\n* Ensure that `call_sid` property is present in the Task's attributes",
    causes:
      "* The Task was not created via the `<Enqueue>` verb\r\n* The `call_sid` property is missing in the Task's attributes",
    solutions:
      "* Only issue Dequeue instruction on Tasks created via the `<Enqueue>` verb\r\n* Ensure that `call_sid` property is present in the Task's attributes",
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:38:39Z',
    last_updated: '2020-09-15T22:46:34.759Z',
  },
  50051: {
    code: 50051,
    message: 'Programmable Chat: Service SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Service SID parameter.',
    log_type: null,
    docs: '## Error - 50051\r\n\r\n### Programmable Chat: Service SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Service SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Service SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:44Z',
    last_updated: '2020-08-04T10:00:23.659Z',
  },
  63038: {
    code: 63038,
    message: 'Account exceeded the daily messages limit',
    log_level: 'ERROR',
    secondary_message: 'Account exceeded the maximum amount of messages per 24 hours',
    log_type: 'APPLICATION',
    docs: '## ERROR - 63038\r\n\r\n### Account exceeded the daily messages limit\r\n\r\n Account exceeded the maximum amount of messages per 24 hours.\r\n\r\n#### Possible Causes\r\nAccount has sent too many messages.\r\n\r\n#### Possible Solutions\r\n* Wait for the next day or contact support to raise the limit.\r\n* Check your [support center](https://help.twilio.com/tickets) or email inbox/spam folder for outreach from the Twilio team on how to remove/raise your daily limit.',
    causes: 'Account has sent too many messages.',
    solutions:
      '* Wait for the next day or contact support to raise the limit.\r\n* Check your [support center](https://help.twilio.com/tickets) or email inbox/spam folder for outreach from the Twilio team on how to remove/raise your daily limit.',
    description: 'Account exceeded the maximum amount of messages per 24 hours.',
    product: 'Programmable SMS',
    date_created: '2020-07-24T10:53:29Z',
    last_updated: '2024-02-06T14:03:23.375865Z',
  },
  83705: {
    code: 83705,
    message: 'Attachment Rejected Due To SIM In Inactive State',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83705\r\n\r\n### Attachment Rejected Due To SIM In Inactive State\r\n\r\n The SIM was not able to attach to the specified Network because your SIM is `inactive`. A SIM must be in the `ready` or `active` states to access the Network.\r\n\r\n#### Possible Causes\r\n * Your SIM is in the `inactive` state.\r\n\r\n#### Possible Solutions\r\n * Use the Twilio Console or REST API to activate your SIM by setting its `status` to `active`.',
    causes: ' * Your SIM is in the `inactive` state.',
    solutions:
      ' * Use the Twilio Console or REST API to activate your SIM by setting its `status` to `active`.',
    description:
      'The SIM was not able to attach to the specified Network because your SIM is `inactive`. A SIM must be in the `ready` or `active` states to access the Network.',
    product: 'Super SIM',
    date_created: '2022-07-21T14:31:51Z',
    last_updated: '2022-07-21T14:31:51Z',
  },
  45762: {
    code: 45762,
    message: 'Failed to validate address configuration. Auto create type is empty or invalid. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45762\r\n\r\n### Failed to validate address configuration. Auto create type is empty or invalid. \r\n\r\n Failed to validate address configuration associated with provided address SID. Auto create type is empty or invalid. \r\n\r\n#### Possible Causes\r\nAddress configuration associated with the provided address SID has an invalid or missing auto create type.  \r\n\r\nThe address configuration could be incorrect or out of date. \r\n\r\n#### Possible Solutions\r\nEnsure that the address SID provided is valid and associated with the correct account.\r\n\r\nEnsure the auto create type is present and set in the address configuration and is set to one of the valid types: webhook, studio, or default. More information on creating and updating an address configuration resource can be found [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#addressconfiguration-properties)',
    causes:
      'Address configuration associated with the provided address SID has an invalid or missing auto create type.  \r\n\r\nThe address configuration could be incorrect or out of date. ',
    solutions:
      'Ensure that the address SID provided is valid and associated with the correct account.\r\n\r\nEnsure the auto create type is present and set in the address configuration and is set to one of the valid types: webhook, studio, or default. More information on creating and updating an address configuration resource can be found [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#addressconfiguration-properties)',
    description:
      'Failed to validate address configuration associated with provided address SID. Auto create type is empty or invalid. ',
    product: 'Flex',
    date_created: '2022-10-03T21:14:03Z',
    last_updated: '2022-10-03T21:14:03Z',
  },
  53207: {
    code: 53207,
    message: 'MaxPublishedTracks is out of range',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53207\r\n\r\n### MaxPublishedTracks is out of range\r\n\r\n ### 53207: MaxPublishedTracks is out of range\r\n\r\nRaised in the REST API when MaxPublishedTracks is set out of range.\r\n\r\n#### Possible Causes\r\n * REST API call to Create Room instance with MaxPublishedTracks out of range.\r\n\r\n#### Possible Solutions\r\n* Set the MaxPublishedTracks value from 0 (unlimited) up to the maximum allowed for the Room Type.',
    causes: ' * REST API call to Create Room instance with MaxPublishedTracks out of range.',
    solutions:
      '* Set the MaxPublishedTracks value from 0 (unlimited) up to the maximum allowed for the Room Type.',
    description:
      '### 53207: MaxPublishedTracks is out of range\r\n\r\nRaised in the REST API when MaxPublishedTracks is set out of range.',
    product: 'Programmable Video',
    date_created: '2020-11-11T01:19:53Z',
    last_updated: '2020-11-11T01:19:53Z',
  },
  50408: {
    code: 50408,
    message: 'Invalid participant proxy address',
    log_level: 'ERROR',
    secondary_message: 'An invalid participant proxy address was supplied.',
    log_type: null,
    docs: '\n## Error - 50408\n\n### Conversations: Invalid participant proxy address\nAn invalid participant proxy address was supplied.\n\n#### Possible Causes\n* Participant MessagingBinding.ProxyAddress parameter provided with the request is not a valid conversation proxy address.\n\n#### Possible Solutions\n* Check that the length of MessagingBinding.ProxyAddress parameter does not exceed 256 characters.\n* Ensure that MessagingBinding.ProxyAddress parameter contains an address with valid syntax (e.g. SMS phone numbers must follow [E.164 format](https://www.twilio.com/docs/glossary/what-e164)).\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.553Z',
  },
  54103: {
    code: 54103,
    message: 'Document revision mismatch',
    log_level: 'ERROR',
    secondary_message: 'The actual revision of the Document does not match the expected revision.',
    log_type: null,
    docs: '\n## Error - 54103\n\n### Sync: Document revision mismatch\nThe actual revision of the Document does not match the expected revision.\n\n#### Possible Causes\n* Your update to this Sync Document has conflicted with a request submitted elsewhere.\n* The value specified in the If-Match header is erroneous.\n\n#### Possible Solutions\nIf your update conflicts with a concurrent update elsewhere, the correct solution is to read the latest revision (on the client SDK: wait for an update) and then re-attempt your update until you succeed. Consider that, since the data has changed, you may not want to submit the exact same update a second time. On the JavaScript SDK, we suggest using the [mutate](https://www.twilio.com/docs/api/sync/mutation-and-conflict-resolution#javascript-sdk-conflict-walkthrough) convenience function.\n\nThe value you provide in the If-Match header should be a revision assigned by the Sync service when interacting with an object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.606Z',
  },
  50440: {
    code: 50440,
    message: 'Failed to remove the proxy address of a participant.',
    log_level: 'ERROR',
    secondary_message: 'The participant should have a proxy address in order to remove it.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50440\r\n\r\n### Failed to remove the proxy address of a participant.\r\n\r\nThe participant should have a proxy address in order to remove it. The conversation participant being updated does not have a proxy address.\r\n\r\n#### Possible Causes\r\n* The participant does not have a proxy address you are trying to remove.\r\n* The participant you are updating is not an SMS participant.\r\n\r\n#### Possible Solutions\r\n* Check that the request does not update proxy address of this particular participant.',
    causes:
      '* The participant does not have a proxy address you are trying to remove.\r\n* The participant you are updating is not an SMS participant.',
    solutions:
      '* Check that the request does not update proxy address of this particular participant.',
    description: 'The conversation participant being updated does not have a proxy address.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:07:26Z',
    last_updated: '2021-08-16T12:07:26Z',
  },
  70155: {
    code: 70155,
    message: 'Request Is Missing Required HTTP Headers',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70155\r\n\r\n### Request Is Missing Required HTTP Headers\r\nThe JWT received by Twilio along with the request has defined a set of HTTP headers that must be validated. The actual request is missing at least one of those headers. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest Twilio helper library.\r\n* Make sure the JWT does not declare unnecessary headers.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:40:23Z',
    last_updated: '2020-08-04T10:00:18.667Z',
  },
  50351: {
    code: 50351,
    message: 'Conversation SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Conversation SID parameter is required but was not provided.',
    log_type: null,
    docs: "\n## Error - 50351\n\n### Conversations: Conversation SID not provided\nConversation SID parameter is required but was not provided.\n\n#### Possible Causes\nYour API request did not include a ConversationSid form parameter.\n\n#### Possible Solutions\nAdd a valid ConversationSid parameter to the API request, making sure you haven't spelled the parameter name wrong.\n\n",
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.859Z',
  },
  30456: {
    code: 30456,
    message: 'Toll Free verification rejection - Disallowed: SHAFT - Alcohol',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30456\r\n\r\n### Toll Free verification rejection - Disallowed: SHAFT - Alcohol\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (SHAFT: Alcohol).\r\n\r\nAlcohol traffic is allowed on Toll Free, Short Code, and Long Code in the US, as long as proper age gating procedures are in place. Age gating means that website users must input their date of birth. It cannot be a yes or no question.\r\n\r\nAll age-gated content into Canada must be blocked across Toll Free, Short Code, and Long Code. The only way to send age-gated traffic into Canada (even with proper age-gating) is to receive a special carrier exemption. Allowed age gated content in Canada include: pocket knives, lighters, and non-alcoholic beverages.\r\n\r\n#### Possible Solutions\r\nAdd an Age Gate for your US business website. Resubmit the verification and provide proof in your opt-in workflow documentation that you have measures in place to ensure compliance.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (SHAFT: Alcohol).\r\n\r\nAlcohol traffic is allowed on Toll Free, Short Code, and Long Code in the US, as long as proper age gating procedures are in place. Age gating means that website users must input their date of birth. It cannot be a yes or no question.\r\n\r\nAll age-gated content into Canada must be blocked across Toll Free, Short Code, and Long Code. The only way to send age-gated traffic into Canada (even with proper age-gating) is to receive a special carrier exemption. Allowed age gated content in Canada include: pocket knives, lighters, and non-alcoholic beverages.',
    solutions:
      'Add an Age Gate for your US business website. Resubmit the verification and provide proof in your opt-in workflow documentation that you have measures in place to ensure compliance.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T01:02:12Z',
    last_updated: '2024-02-22T01:04:59.746846Z',
  },
  50213: {
    code: 50213,
    message: 'Conflicting user modification',
    log_level: 'ERROR',
    secondary_message:
      'The requested user is already being added or removed from this channel by a concurrent API request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50213\r\n\r\n### Conflicting user modification\r\n\r\nThe requested user is already being added or removed from this channel by a concurrent API request. The requested user is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.\r\n\r\n#### Possible Causes\r\n* You might be adding a new user to the service instance while the user with the same identity is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a user with the same identity to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same user by SID or identity from the service instance.\r\n\r\n#### Possible Solutions\r\n* Implement an operation retrier and repeat the failed user API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.',
    causes:
      '* You might be adding a new user to the service instance while the user with the same identity is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a user with the same identity to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same user by SID or identity from the service instance.',
    solutions:
      '* Implement an operation retrier and repeat the failed user API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.',
    description:
      'The requested user is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.',
    product: 'Programmable Chat',
    date_created: '2020-05-05T15:22:27Z',
    last_updated: '2020-08-04T10:00:03.577Z',
  },
  90037: {
    code: 90037,
    message: "Broadcast has too many 'CorrelationId' items",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90037\r\n\r\n### Broadcast has too many 'CorrelationId' items\r\n\r\n Broadcast has too many 'CorrelationId' items\r\n\r\n#### Possible Causes\r\nTo many 'CorrelationId' items in the request\r\n\r\n#### Possible Solutions\r\nUse no more than allowed number of 'CorrelationId' fields",
    causes: "To many 'CorrelationId' items in the request",
    solutions: "Use no more than allowed number of 'CorrelationId' fields",
    description: "Broadcast has too many 'CorrelationId' items",
    product: null,
    date_created: '2020-12-11T15:49:06Z',
    last_updated: '2020-12-11T15:49:06Z',
  },
  31208: {
    code: 31208,
    message: 'User denied access to microphone.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31208\r\n\r\n### User denied access to microphone.\r\n\r\nUser denied access to microphone.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:49:47Z',
    last_updated: '2020-08-04T10:00:11.027Z',
  },
  60532: {
    code: 60532,
    message: 'SNA Potential Dual SIM Detected',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60532\r\n\r\n### SNA Potential Dual SIM Detected\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received and failed due to the request potentially coming from a dual SIM device. In this case, the carrier identified via IP address does not match the carrier identified via phone number and Silent Network Auth cannot be completed. This can also happen when multiple people share one device.\r\n\r\n#### Possible Solutions\r\nRetry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received and failed due to the request potentially coming from a dual SIM device. In this case, the carrier identified via IP address does not match the carrier identified via phone number and Silent Network Auth cannot be completed. This can also happen when multiple people share one device.',
    solutions:
      'Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T17:02:55Z',
    last_updated: '2022-08-30T17:02:55Z',
  },
  14230: {
    code: 14230,
    message: 'Dial->Conference: Invalid WorkflowSid',
    log_level: 'ERROR',
    secondary_message: 'Provided workflow sid was not valid.',
    log_type: null,
    docs: '## Error - 14230\r\n\r\n### Conference: Provided WorkflowSid was not valid\r\n\r\nProvided Workflow is invalid.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:44:58Z',
    last_updated: '2020-08-04T10:00:21.862Z',
  },
  63051: {
    code: 63051,
    message: 'WhatsApp Business Account is Locked',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63051\r\n\r\n### WhatsApp Business Account is Locked\r\n\r\n Twilio cannot send the message because WhatsApp has locked the WhatsApp Business Account that contains this Sender due to an integrity policy violation\r\n\r\n#### Possible Causes\r\nViolating the WhatsApp Terms of Service or Commerce Policy\r\n\r\n#### Possible Solutions\r\nIf you believe this is in error, please open a support ticket for us to appeal to WhatsApp on your behalf.',
    causes: 'Violating the WhatsApp Terms of Service or Commerce Policy',
    solutions:
      'If you believe this is in error, please open a support ticket for us to appeal to WhatsApp on your behalf.',
    description:
      'Twilio cannot send the message because WhatsApp has locked the WhatsApp Business Account that contains this Sender due to an integrity policy violation',
    product: 'Programmable Messaging',
    date_created: '2022-11-29T00:57:33Z',
    last_updated: '2022-11-29T00:57:33Z',
  },
  57002: {
    code: 57002,
    message: "'Secret id' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57002\r\n\r\n### 'Secret id' is too long\r\n\r\n Specified 'Secret id' is too long\r\n\r\n#### Possible Causes\r\nSpecified 'Secret id' is too long.\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Secret id' is being passed in request. ",
    causes: "Specified 'Secret id' is too long.",
    solutions: "Confirm a valid 'Secret id' is being passed in request. ",
    description: "Specified 'Secret id' is too long",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:43:37Z',
    last_updated: '2021-05-07T08:44:12.72Z',
  },
  31910: {
    code: 31910,
    message: 'Stream - WebSocket - SSL Protocol Error',
    log_level: 'ERROR',
    secondary_message:
      'The server doesn’t support SSL, can’t provide a secure connection or the SSL handshake has failed',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31910\r\n\r\n### Stream - WebSocket - SSL Protocol Error\r\n\r\nThe server doesn’t support SSL, can’t provide a secure connection or the SSL handshake has failed \r\n\r\n#### Possible Causes\r\n* Server doesn’t support SSL\r\n* Stream is trying to connect the wrong port\r\n* Protocol or SSL handshake has failed\r\n\r\n#### Possible Solutions\r\n* Verify the server has enabled SSL\r\n* Verify the port in TwiML URL is actually the one supporting SSL\r\n* Verify the certificate is correct and accepted by HTTP clients',
    causes:
      '* Server doesn’t support SSL\r\n* Stream is trying to connect the wrong port\r\n* Protocol or SSL handshake has failed',
    solutions:
      '* Verify the server has enabled SSL\r\n* Verify the port in TwiML URL is actually the one supporting SSL\r\n* Verify the certificate is correct and accepted by HTTP clients',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:55:06Z',
    last_updated: '2020-08-04T10:00:07.407Z',
  },
  83005: {
    code: 83005,
    message: 'Super SIM not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83005\r\n\r\n### Super SIM not found\r\n\r\n Your Super SIM could not be found.\r\n\r\n#### Possible Causes\r\n* The Super SIM could not be found. It may have been deleted or transferred to another account.\r\n\r\n#### Possible Solutions\r\n* Ensure that the defined Super SIM SID or Unique Name is present in your Account.',
    causes:
      '* The Super SIM could not be found. It may have been deleted or transferred to another account.',
    solutions: '* Ensure that the defined Super SIM SID or Unique Name is present in your Account.',
    description: 'Your Super SIM could not be found.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:22:34Z',
    last_updated: '2021-08-23T11:22:49.700039Z',
  },
  63020: {
    code: 63020,
    message: 'Twilio encountered a Business Manager account error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Business Manager Account Error\r\n\r\n#### Possible Causes \r\n* Please use Facebook Business Manager to accept an invitation from Twilio to send messages on your behalf. Also verify the WhatsApp billing account associated with your business',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:26:54Z',
    last_updated: '2020-08-04T10:00:10.506Z',
  },
  50100: {
    code: 50100,
    message: 'Programmable Chat: Role not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Role does not exist.',
    log_type: null,
    docs: '## Error - 50100\r\n\r\n### Programmable Chat: Role not found\r\n\r\n#### Possible Causes \r\n*  Specified Role does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:46Z',
    last_updated: '2020-08-04T10:00:23.5Z',
  },
  52001: {
    code: 52001,
    message: 'Invalid destination binding',
    log_level: 'ERROR',
    secondary_message: 'Provided destination binding information is invalid',
    log_type: null,
    docs: '## Error 52001\r\n\r\n### Invalid destination binding\r\n\r\nThe message has been rejected by channel due to an invalid destination information. This specific message has not been sent.\r\n\r\n### Possible causes\r\n- Address or identity or notification protocol version in a Notify Binding (or ToBinding) were invalid\r\n\r\n### Possible solutions\r\n- Make sure that you do not modify the address before creating the Binding or sending ToBinding property of Notification Request. \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-12-27T12:35:48Z',
    last_updated: '2020-08-04T10:00:15.443Z',
  },
  53113: {
    code: 53113,
    message: 'Room creation failed',
    log_level: 'ERROR',
    secondary_message: 'A Room with the same name already exists.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 53113\r\n\r\n### Room creation failed\r\n\r\nA Room with the same name already exists. This error is raised when the Server is unable to create a Room because the name you have used is already associated with an existing Room.\r\n\r\nThe [Video API Room resource page](https://www.twilio.com/docs/video/api/rooms-resource#filter-by-unique-name) will show you how to get a list of existing Rooms’ names, allowing you to choose a new one that has not yet been used.\r\n\r\n#### Possible Causes\r\nYou have already creasted a Room with the name you just used.\r\n\r\n#### Possible Solutions\r\nCreate a new Room with a unique name.',
    causes: 'You have already creasted a Room with the name you just used.',
    solutions: 'Create a new Room with a unique name.',
    description:
      'This error is raised when the Server is unable to create a Room because the name you have used is already associated with an existing Room.\r\n\r\nThe [Video API Room resource page](https://www.twilio.com/docs/video/api/rooms-resource#filter-by-unique-name) will show you how to get a list of existing Rooms’ names, allowing you to choose a new one that has not yet been used.',
    product: 'Programmable Video',
    date_created: '2017-09-11T22:30:36Z',
    last_updated: '2022-09-29T10:40:34.092284Z',
  },
  60706: {
    code: 60706,
    message: 'Invalid Push Token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60706\r\n\r\n### Invalid Push Token\r\n\r\n Registering a new device, the Push Token is empty or invalid\r\n\r\n#### Possible Causes\r\n- The `PushToken` is iOS-incorrect or empty\r\n\r\n#### Possible Solutions\r\n- Check the `PushToken` of the iOS device to register',
    causes: '- The `PushToken` is iOS-incorrect or empty',
    solutions: '- Check the `PushToken` of the iOS device to register',
    description: 'Registering a new device, the Push Token is empty or invalid',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:58:36Z',
    last_updated: '2020-08-04T10:00:05.109Z',
  },
  21226: {
    code: 21226,
    message: 'SIP calling not enabled for this account',
    log_level: 'WARNING',
    secondary_message: 'Your account is not enabled for SIP calling.',
    log_type: null,
    docs: '## Warning - 21226\n\n### SIP calling not enabled for this account\n\nYour account is not enabled for SIP calling.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:18Z',
    last_updated: '2020-08-04T10:00:25.654Z',
  },
  20107: {
    code: 20107,
    message: 'Invalid Access Token signature',
    log_level: 'ERROR',
    secondary_message: 'Invalid Access Token signature',
    log_type: null,
    docs: "# Error - 20107\r\n\r\n## Invalid Access Token signature\r\n\r\nThe signature for the Access Token provided was invalid.\r\n\r\nCheck that your code is correctly generating signatures using the algorithm and format expected by the Twilio API.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nAccess Tokens are used by multiple Twilio SDKs, including Programmable Voice, Programmable Video, and Programmable Chat. For the details of Twilio's specific Access Token implementation, see [the documentation](/docs/api/rest/access-tokens).\r\n\r\n### Possible Causes\r\n\r\n* The supplied Account SID, API Key or API Secret is incorrect.\r\n\r\n### Possible Solutions\r\n\r\n* Ensure you're using the correct Account SID for your [Live API Credentials](/console/account/settings).\r\n* Verify the API Key was generated for the same account as the supplied Account SID. (The API Secret is not the same as the Account Auth Token.)\r\n* Verify the API Secret is correct for the API Key being used and that no extra characters are included.\r\n* Check if the API Secret passes signature validation when used at [jwt.io](https://jwt.io/).\r\n* Generate a new API Key and Secret for the Account SID and try again.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T07:02:07Z',
    last_updated: '2020-08-04T10:00:22.664Z',
  },
  31953: {
    code: 31953,
    message: 'Stream - Media - RTP timeout',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## WARNING - 31953\r\n\r\n### Stream - Media - RTP timeout\r\n\r\n An RTP timeout is detected, meaning that inbound stream stopped flowing.\r\n\r\n#### Possible Causes\r\n* Phone call finished\r\n* Carrier stopped sending audio to Twilio\r\n\r\n#### Possible Solutions\r\n* Contact Twilio support',
    causes: '* Phone call finished\r\n* Carrier stopped sending audio to Twilio',
    solutions: '* Contact Twilio support',
    description: 'An RTP timeout is detected, meaning that inbound stream stopped flowing.',
    product: 'Programmable Voice',
    date_created: '2023-06-28T12:56:21Z',
    last_updated: '2023-06-29T08:45:46.256133Z',
  },
  32202: {
    code: 32202,
    message: 'SIP: Bad user credentials',
    log_level: 'ERROR',
    secondary_message:
      'Bad user credentials. Confirm that your username/password matches one in your [Credentials List](/user/account/sip-trunking/authentication/cls).',
    log_type: null,
    docs: '## Error - 32202\r\n\r\n###  SIP: Bad user credentials\r\n\r\n#### Possible Causes \r\n*  There is a Credentials List on your trunk, and your INVITE’s Authentication Digest is incorrect due to wrong username/password\r\n\r\n#### Possible Solutions\r\n*  Confirm that your username/password matches one in your Credentials List. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:38Z',
    last_updated: '2020-08-04T10:00:24.25Z',
  },
  25023: {
    code: 25023,
    message: 'Invalid page token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25023\r\n\r\n### Invalid page token\r\n\r\n Invalid page token\r\n\r\n#### Possible Causes\r\n- The provided page token is invalid \r\n- The provided page token is expired\r\n\r\n#### Possible Solutions\r\nMake sure that you are using the page token from a recent list response.',
    causes: '- The provided page token is invalid \r\n- The provided page token is expired',
    solutions: 'Make sure that you are using the page token from a recent list response.',
    description: 'Invalid page token',
    product: 'Organizations API',
    date_created: '2023-12-04T10:55:34Z',
    last_updated: '2023-12-04T10:55:34Z',
  },
  50369: {
    code: 50369,
    message: 'Conversation webhook URL not provided',
    log_level: 'ERROR',
    secondary_message: 'Conversation webhook URL parameter is required but was not provided.',
    log_type: null,
    docs: '\n## Error - 50369\n\n### Conversations: Conversation webhook URL not provided\nConversation webhook URL parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected a Configuration.Url input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid Configuration.Url parameter to the API request and confirm that it is not misspelled.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.67Z',
  },
  21255: {
    code: 21255,
    message: 'Maximum IP Access Control Lists reached',
    log_level: 'ERROR',
    secondary_message: 'You cannot have more than 1000 IP Access Control Lists.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21255\r\n\r\n### Maximum IP Access Control Lists reached\r\n\r\nYou cannot have more than 1000 IP Access Control Lists. \r\n\r\n#### Possible Causes\r\n* You cannot have more than 1000 IP Access Control Lists.\r\n\r\n#### Possible Solutions\r\n* Remove current IP Access Control Lists if you must create new ones.',
    causes: '* You cannot have more than 1000 IP Access Control Lists.',
    solutions: '* Remove current IP Access Control Lists if you must create new ones.',
    description: null,
    product: null,
    date_created: '2020-08-04T01:30:00Z',
    last_updated: '2021-01-15T21:30:48.303Z',
  },
  83700: {
    code: 83700,
    message: 'Attachment Failed Due To Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 83700\r\n\r\n### Attachment Failed Due To Internal Error\r\n\r\n An unexpected error occurred while attempting to process your SIM's attachment request to the Network. This is usually a transient error and should resolve itself in time.\r\n\r\n#### Possible Causes\r\n- An unexpected error occurred in processing your SIM's attachment to the Network\r\n\r\n#### Possible Solutions\r\n- Retry connecting to the Network from your device.\r\n- If this issue persists for your SIM, please contact Twilio Support.",
    causes: "- An unexpected error occurred in processing your SIM's attachment to the Network",
    solutions:
      '- Retry connecting to the Network from your device.\r\n- If this issue persists for your SIM, please contact Twilio Support.',
    description:
      "An unexpected error occurred while attempting to process your SIM's attachment request to the Network. This is usually a transient error and should resolve itself in time.",
    product: 'Super SIM',
    date_created: '2022-07-21T14:18:43Z',
    last_updated: '2022-07-21T14:18:43Z',
  },
  16024: {
    code: 16024,
    message:
      "Invalid participant label, must not exceed 128 characters, must not be a CallSid, must not contain '/'",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 16024\r\n\r\n### Invalid participant label, must not exceed 128 characters, must not be a CallSid, must not contain '/'\r\n\r\n The participant label specified in an API call to create a voice conference participant was invalid. It may not exceed 128 characters, it may not be a CallSid, and it may not contain a ‘/’ (even in URL encoded form %2F).\r\n\r\n#### Possible Causes\r\nA POST to conference participants call to the Twilio API specified a participant label which is greater than 128 characters or which resembles a CallSid (“CA” followed by 32 lowercase hexadecimal characters), or contains the ‘/’ character or URL encoded ‘/’ character (%2F).\r\n\r\n#### Possible Solutions\r\nShorten the length of the ParticipantLabel parameter, avoid using a call SID and avoid including ‘/’ characters.",
    causes:
      'A POST to conference participants call to the Twilio API specified a participant label which is greater than 128 characters or which resembles a CallSid (“CA” followed by 32 lowercase hexadecimal characters), or contains the ‘/’ character or URL encoded ‘/’ character (%2F).',
    solutions:
      'Shorten the length of the ParticipantLabel parameter, avoid using a call SID and avoid including ‘/’ characters.',
    description:
      'The participant label specified in an API call to create a voice conference participant was invalid. It may not exceed 128 characters, it may not be a CallSid, and it may not contain a ‘/’ (even in URL encoded form %2F).',
    product: 'Programmable Voice',
    date_created: '2020-04-23T21:38:44Z',
    last_updated: '2020-08-04T10:00:03.858Z',
  },
  80206: {
    code: 80206,
    message: 'No Available Proxy',
    log_level: 'WARNING',
    secondary_message:
      "This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for +1415555XXXX. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.",
    log_type: 'APPLICATION',
    docs: "## WARNING - 80206\r\n\r\n### No Available Proxy\r\n\r\nThis Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for +1415555XXXX. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions. ## Warning\r\n\r\n### No Available Proxy\r\n\r\nExample Message: This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for +1415555XXXX. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.\r\n\r\n#### Possible Causes\r\nThis Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for <phone-number>. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.\r\n\r\n#### Possible Solutions\r\n1. Add one or more numbers to your pool matching this Participant's area code\r\n2. If this Participant is in an active Session, close that Session to make the number available to them.",
    causes:
      "This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for <phone-number>. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.",
    solutions:
      "1. Add one or more numbers to your pool matching this Participant's area code\r\n2. If this Participant is in an active Session, close that Session to make the number available to them.",
    description:
      "## Warning\r\n\r\n### No Available Proxy\r\n\r\nExample Message: This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for +1415555XXXX. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.",
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2022-02-28T19:11:43.048229Z',
  },
  60386: {
    code: 60386,
    message: 'Attestation object invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60386\r\n\r\n### Attestation object invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Attestation object in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Attestation object in the request body is correct.',
    causes: 'The Attestation object in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Attestation object in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:56:15Z',
    last_updated: '2023-12-27T09:56:15Z',
  },
  34002: {
    code: 34002,
    message: 'Callee Busy',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 34002\r\n### Fax: Callee Busy\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Fax',
    date_created: '2017-09-15T19:46:00Z',
    last_updated: '2020-08-04T10:00:17.089Z',
  },
  19011: {
    code: 19011,
    message:
      'When updating a contact, invalid JSON syntax or invalid field that cannot be updated by this endpoint',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19011\r\n\r\n### When updating a contact, invalid JSON syntax or invalid field that cannot be updated by this endpoint\r\n\r\n Invalid JSON or fields other than first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or custom_fields exist in update contact request\r\n\r\n#### Possible Causes\r\nUser provided an invalid JSON or trying to update fields other than first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or custom_fields of a contact\r\n\r\n#### Possible Solutions\r\nFix JSON input or change update contact request to update only first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or custom_fields',
    causes:
      'User provided an invalid JSON or trying to update fields other than first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or custom_fields of a contact',
    solutions:
      'Fix JSON input or change update contact request to update only first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or custom_fields',
    description:
      'Invalid JSON or fields other than first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or custom_fields exist in update contact request',
    product: null,
    date_created: '2020-08-07T22:45:13Z',
    last_updated: '2020-08-07T22:45:13Z',
  },
  19031: {
    code: 19031,
    message: 'Maximum number of locations allowed reached ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19031\r\n\r\n### Maximum number of locations allowed reached \r\n\r\n Maximum number of locations allowed reached\r\n\r\n#### Possible Causes\r\nAttempt to create more than 5 locations\r\n\r\n#### Possible Solutions\r\nRemove an existing location to add a new one',
    causes: 'Attempt to create more than 5 locations',
    solutions: 'Remove an existing location to add a new one',
    description: 'Maximum number of locations allowed reached',
    product: null,
    date_created: '2020-07-21T20:23:58Z',
    last_updated: '2020-08-04T10:00:01.466Z',
  },
  94401: {
    code: 94401,
    message: 'Transcriptions: audio processing error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 94401\r\n\r\n### Transcriptions: audio processing error\r\n\r\n Twilio failed to transcribe audio due to an issue with the transcription provider.  The transcription files have been deleted and the resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\n* The speech-to-text provider failed to transcribe audio\r\n\r\n#### Possible Solutions\r\n ',
    causes: '* The speech-to-text provider failed to transcribe audio',
    solutions: ' ',
    description:
      'Twilio failed to transcribe audio due to an issue with the transcription provider.  The transcription files have been deleted and the resource has been marked as “failed”',
    product: null,
    date_created: '2021-07-21T09:11:04Z',
    last_updated: '2021-07-21T09:11:04Z',
  },
  60709: {
    code: 60709,
    message: 'Business Profile already exists',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 60709\r\n\r\n### Business Profile already exists\r\n\r\n This Account already has a Business Profile\r\n\r\n#### Possible Causes\r\n- Each Account can have only one Business Profile, and you're attempting to create another for the same Account\r\n\r\n#### Possible Solutions\r\n- Make sure you're using the Account intended to create the new Business Profile",
    causes:
      "- Each Account can have only one Business Profile, and you're attempting to create another for the same Account",
    solutions: "- Make sure you're using the Account intended to create the new Business Profile",
    description: 'This Account already has a Business Profile',
    product: 'Branded Comms',
    date_created: '2020-01-20T15:03:19Z',
    last_updated: '2020-08-04T10:00:05.053Z',
  },
  22402: {
    code: 22402,
    message: 'Phone Number Operation not permitted within Region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22402\r\n\r\n### Phone Number Operation not permitted within Region\r\n\r\n Phone Number update operation is not permitted within the Region.\r\n\r\n#### Possible Causes\r\nCertain Phone Number operations are not permitted within this Region such as restore, transfer, emergency services, and release.\r\n\r\n#### Possible Solutions\r\nPlease refer to documentation to understand which operations are permitted within each region.',
    causes:
      'Certain Phone Number operations are not permitted within this Region such as restore, transfer, emergency services, and release.',
    solutions:
      'Please refer to documentation to understand which operations are permitted within each region.',
    description: 'Phone Number update operation is not permitted within the Region.',
    product: 'Phone Numbers',
    date_created: '2022-04-26T14:11:17Z',
    last_updated: '2022-04-26T14:11:17Z',
  },
  60390: {
    code: 60390,
    message: 'Factor not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60390\r\n\r\n### Factor not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe requested Factor is missing\r\n\r\n#### Possible Solutions\r\nCheck that the Factor in the request parameter/body is correct.',
    causes: 'The requested Factor is missing',
    solutions: 'Check that the Factor in the request parameter/body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:59:52Z',
    last_updated: '2023-12-27T09:59:52Z',
  },
  91000: {
    code: 91000,
    message: 'Sink could not be created',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91000\r\n\r\n### Sink could not be created\r\n\r\n Creating sink failed due to bad configuration\r\n\r\n#### Possible Causes\r\n* Sink type is not Kinesis or Webhook\r\n* Sink Configuration is empty\r\n* Sink Configuration role-arn is empty\r\n* Sink Configuration arn is empty\r\n* Sink Configuration external_id is empty\r\n* Sink Configuration destination is empty\r\n* Sink Configuration method is empty\r\n* Sink Configuration batch_events is empty\r\n\r\n#### Possible Solutions\r\n* Description cannot be empty\r\n* Sink configuration values cannot be empty\r\n* Sink type must be Kinesis or Webhook',
    causes:
      '* Sink type is not Kinesis or Webhook\r\n* Sink Configuration is empty\r\n* Sink Configuration role-arn is empty\r\n* Sink Configuration arn is empty\r\n* Sink Configuration external_id is empty\r\n* Sink Configuration destination is empty\r\n* Sink Configuration method is empty\r\n* Sink Configuration batch_events is empty',
    solutions:
      '* Description cannot be empty\r\n* Sink configuration values cannot be empty\r\n* Sink type must be Kinesis or Webhook',
    description: 'Creating sink failed due to bad configuration',
    product: 'Events',
    date_created: '2020-09-16T15:33:10Z',
    last_updated: '2021-01-06T16:14:56.7Z',
  },
  52109: {
    code: 52109,
    message: 'GCM/FCM unauthorized error',
    log_level: 'ERROR',
    secondary_message: 'GCM/FCM could not authorise request',
    log_type: null,
    docs: "## Error - 52109\r\n\r\n### GCM/FCM unauthorized error\r\n\r\n#### Possible Causes \r\n*  ApiKey/Secret is revoked or invalid.\r\n\r\n#### Possible Solutions\r\nProvide a new API Key/Secret and make sure your application is configured to use it.\r\n\r\n* If using IP-Messaging, update your Credential with the new API Key/Secret.\r\n* If using User Notifications, you can either update your Credential or create a new Credential and update your Service's GcmCredentialSid/FcmCredentialSid.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:31:42Z',
    last_updated: '2020-08-04T10:00:22.258Z',
  },
  62020: {
    code: 62020,
    message: 'Connection pending deletion.',
    log_level: 'ERROR',
    secondary_message:
      'The connection SID in the request is pending deletion. No changes can be made to it.',
    log_type: null,
    docs: '## Error - 62020\r\n\r\n### Connection pending deletion.\r\n\r\nThe connection SID in the request is pending deletion. No changes can be made to it. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:46:37Z',
    last_updated: '2020-08-04T10:00:20.826Z',
  },
  70001: {
    code: 70001,
    message: 'Validation Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70001\r\n\r\n### Validation Failed\r\nThe Request body is syntactically correct, the body was successfully parsed, but the data in the body violates the constraints.\r\n\r\n#### Possible Causes \r\n* Performing an update to the “FriendlyName” with a string longer than the allowed 64 characters.\r\n* Updating a field that cannot have a null value to a null.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:28:31Z',
    last_updated: '2020-08-04T10:00:19.945Z',
  },
  63035: {
    code: 63035,
    message:
      'This operation is blocked because the RCS agent has not launched, the recipient has not accepted the invitation to become a tester, or the RCS sender only works in certain regions.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63035\r\n\r\n### This operation is blocked because the RCS agent has not launched, the recipient has not accepted the invitation to become a tester, or the RCS sender only works in certain regions.\r\n\r\n This operation is blocked because the RCS sender has not launched and the recipient has not been invited and accepted the invitation to become a tester. This may also happen if you are attempting to send to a device with a country code from a region that is not supported by that sender.\r\n\r\n#### Possible Causes\r\nDevice is not RCS capable, recipient has not accepted to become a tester, or device is not reachable from the RCS sender.\r\n\r\n#### Possible Solutions\r\nIf device is RCS capable, accept invitation to become a tester. If the device has already accepted the invitation, please confirm that you are not attempting to send from an RCS sender that is regionally restricted.',
    causes:
      'Device is not RCS capable, recipient has not accepted to become a tester, or device is not reachable from the RCS sender.',
    solutions:
      'If device is RCS capable, accept invitation to become a tester. If the device has already accepted the invitation, please confirm that you are not attempting to send from an RCS sender that is regionally restricted.',
    description:
      'This operation is blocked because the RCS sender has not launched and the recipient has not been invited and accepted the invitation to become a tester. This may also happen if you are attempting to send to a device with a country code from a region that is not supported by that sender.',
    product: 'Programmable SMS',
    date_created: '2019-10-10T20:30:35Z',
    last_updated: '2024-05-29T17:12:24.413404Z',
  },
  32650: {
    code: 32650,
    message: 'Real-time Transcriptions: Configuration Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32650\r\n\r\n### Real-time Transcriptions: Configuration Error\r\n\r\n A 32650 Error is an indication there is something wrong with the &lt;Transcription&gt; configuration.\r\n\r\n#### Possible Causes\r\n* Configuration is missing required properties\r\n* Configuration contains invalid properties\r\n\r\n#### Possible Solutions\r\n* Check the TranscriptionError message included in the webhook or the Debugger message in Console for further information and update your &lt;Transcription&gt; configuration',
    causes:
      '* Configuration is missing required properties\r\n* Configuration contains invalid properties',
    solutions:
      '* Check the TranscriptionError message included in the webhook or the Debugger message in Console for further information and update your &lt;Transcription&gt; configuration',
    description:
      'A 32650 Error is an indication there is something wrong with the &lt;Transcription&gt; configuration.',
    product: 'Programmable Voice',
    date_created: '2024-05-10T19:59:34Z',
    last_updated: '2024-05-10T19:59:34Z',
  },
  17008: {
    code: 17008,
    message: 'Internal Server Error - Query Timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 17008\r\n\r\n### Internal Server Error - Query Timeout\r\n\r\n Query Timeout\r\n\r\n#### Possible Causes\r\nThe requested resource exceeded the time limit for the data to be fetched from the underlying data store.\r\n\r\n#### Possible Solutions\r\nThe request should be retried using exponential backoff strategy until it succeeds.',
    causes:
      'The requested resource exceeded the time limit for the data to be fetched from the underlying data store.',
    solutions:
      'The request should be retried using exponential backoff strategy until it succeeds.',
    description: 'Query Timeout',
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:33:39Z',
    last_updated: '2020-09-29T19:36:22.458Z',
  },
  83011: {
    code: 83011,
    message: 'A Super SIM with the specified Unique Name exists already',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83011\r\n\r\n### A Super SIM with the specified Unique Name exists already\r\n\r\n Your Super SIM cannot be updated with the provided Unique Name because another Super SIM on your Account is already using it.\r\n\r\n#### Possible Causes\r\n* A Unique Name must be unique across all Super SIMs that belong to your Account. Two Super SIMs cannot have the same Unique Name.\r\n\r\n#### Possible Solutions\r\n* Specify an alternative Unique Name in your request.\r\n* Change the Unique Name of the Super SIM already using the desired Unique Name to something else and then retry your request.',
    causes:
      '* A Unique Name must be unique across all Super SIMs that belong to your Account. Two Super SIMs cannot have the same Unique Name.',
    solutions:
      '* Specify an alternative Unique Name in your request.\r\n* Change the Unique Name of the Super SIM already using the desired Unique Name to something else and then retry your request.',
    description:
      'Your Super SIM cannot be updated with the provided Unique Name because another Super SIM on your Account is already using it.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:26:55Z',
    last_updated: '2021-08-23T11:27:06.992962Z',
  },
  32106: {
    code: 32106,
    message: 'SIP: Authentication Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: 'Authentication error.\r\n\r\n<b>Possible Causes</b>\r\n\r\nAuthorization name and username do not match.\r\n\r\n<b>Possible Solutions</b>\r\n\r\nConfigure your SIP endpoint so the username and Authorization name match',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-11-09T22:37:37Z',
    last_updated: '2020-08-04T10:00:20.526Z',
  },
  90041: {
    code: 90041,
    message: "Broadcast 'MediaUrl' field is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90041\r\n\r\n### Broadcast 'MediaUrl' field is too long\r\n\r\n Broadcast 'MediaUrl' field is too long\r\n\r\n#### Possible Causes\r\nOne of 'MediaUrl' fields is too long\r\n\r\n#### Possible Solutions\r\nUse shorter 'MediaUrl' value",
    causes: "One of 'MediaUrl' fields is too long",
    solutions: "Use shorter 'MediaUrl' value",
    description: "Broadcast 'MediaUrl' field is too long",
    product: null,
    date_created: '2020-12-11T15:58:37Z',
    last_updated: '2020-12-11T15:58:37Z',
  },
  50516: {
    code: 50516,
    message: 'Programmable Chat: Message index is not a number',
    log_level: 'ERROR',
    secondary_message: 'Programmable Chat: Message index is not a number',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50516\r\n\r\n### Programmable Chat: Message index is not a number\r\n\r\nProgrammable Chat: Message index is not a number Not a number string was provided as message index.\r\n\r\n#### Possible Causes\r\n* Some text or message sid was provided as message index\r\n\r\n#### Possible Solutions\r\n* Proper message index should be provided.',
    causes: '* Some text or message sid was provided as message index',
    solutions: '* Proper message index should be provided.',
    description: 'Not a number string was provided as message index.',
    product: 'Programmable Chat',
    date_created: '2020-11-23T14:44:22Z',
    last_updated: '2020-11-23T14:44:22Z',
  },
  32014: {
    code: 32014,
    message: 'Call is terminated because of no audio received',
    log_level: 'WARNING',
    secondary_message: 'RTP-Timeout',
    log_type: null,
    docs: "## Warning - 32014\r\n\r\n### Call is terminated because of no audio received\r\n\r\n#### Possible Causes\r\n\r\n* One party doesn't send audio for an extended period of time and call is terminated.\r\n\r\n#### Possible Solutions\r\n\r\n* It could be the case when one party is disconnected without hanging up due to network failure. Try to call again later.\r\n* If this keeps happening, please contact Twilio support to enable voice trace. With voice trace enabled, Twilio can know which side stops sending audio to track down the root cause.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-08-24T16:39:49Z',
    last_updated: '2020-08-04T10:00:17.945Z',
  },
  80906: {
    code: 80906,
    message: 'Interaction Not Open',
    log_level: 'WARNING',
    secondary_message:
      'Received interaction completion event for an Interaction that is already complete',
    log_type: null,
    docs: '## Warning\n\n### Interaction Not Open\n\nExample Message: Received interaction completion event for an Interaction that is already complete',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.571Z',
  },
  50204: {
    code: 50204,
    message: 'Programmable Chat: Identity not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required "Identity" parameter.',
    log_type: null,
    docs: '## Error - 50204\r\n\r\n### Programmable Chat: Identity not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required "Identity" parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid "Identity" parameter is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:49Z',
    last_updated: '2020-08-04T10:00:23.263Z',
  },
  51125: {
    code: 51125,
    message: 'Twilsock: Too many updates',
    log_level: 'ERROR',
    secondary_message: 'Number of updates for this account is higher than expected!',
    log_type: null,
    docs: "## Error - 51125\r\n\r\n### Too many updates\r\n\r\n#### Possible Causes \r\nNumber of updates for this account is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:24:48Z',
    last_updated: '2020-08-04T10:00:09.458Z',
  },
  13226: {
    code: 13226,
    message: 'Dial: Invalid country code',
    log_level: 'WARNING',
    secondary_message: 'The country code of the provided phone number is unknown',
    log_type: null,
    docs: '## Warning - 13226 \n\n### Dial: Invalid country code\n\nThe country code of the provided phone number is unknown\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:35Z',
    last_updated: '2020-08-04T10:00:28.585Z',
  },
  70251: {
    code: 70251,
    message: 'Bad SSO Settings',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70251\r\n\r\n### Bad SSO Settings\r\nThe Request tries to authenticate through SSO. The request is well-formed, but the configured settings for the SSO is not valid.\r\n\r\n#### Possible Causes \r\n* Malformed urls\r\n* Missing certificates\r\n\r\n#### Possible Solution\r\n* Reconfigure the SSO settings and retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-07-26T21:18:48Z',
    last_updated: '2020-08-04T10:00:12.889Z',
  },
  63011: {
    code: 63011,
    message: 'Invalid Request: Twilio encountered an error while processing your request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel returned an invalid request error\r\n\r\n#### Possible Causes \r\n*   Twilio could not process your error because the channel provider failed to receive capabilities for your request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-03-28T17:33:55Z',
    last_updated: '2020-08-04T10:00:09.246Z',
  },
  20155: {
    code: 20155,
    message: 'Expiration Time In The Future',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20155 \r\n\r\n### Expiration Time In The Future\r\nThe JWT provided to the Twilio API is not yet valid.\r\n\r\n#### Possible Causes \r\n* The client system that generates the JWT might have issues with system time.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:11:20Z',
    last_updated: '2020-08-04T10:00:19.047Z',
  },
  11100: {
    code: 11100,
    message: 'Invalid URL format',
    log_level: 'ERROR',
    secondary_message: 'The format of the provided URL is invalid.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 11100\r\n\r\n### Invalid URL format\r\n\r\nThe format of the provided URL is invalid. ## Error - 11100 \r\n\r\n### Invalid URL format\r\n\r\nThe format of the provided URL is invalid.\r\n\r\n\r\n#### Possible Causes\r\n*   Bad URL for phone number configuration\r\n*   Bad URL passed to outgoing call REST request\r\n*   Bad URL in Play or Redirect Verb Body\r\n*   Bad URL provided for a verb's action attribute\r\n*   No URL provided in Record verb action attribute when modifying a live call\r\n*   Unsupported characters in auth portion of URL\r\n\r\n#### Possible Solutions\r\nMake sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n*   hostname\r\n*   file path\r\n*   properly url-encoded query parameters\r\n\r\nTwilio must be able to reach this URL over the public Internet.",
    causes:
      "*   Bad URL for phone number configuration\r\n*   Bad URL passed to outgoing call REST request\r\n*   Bad URL in Play or Redirect Verb Body\r\n*   Bad URL provided for a verb's action attribute\r\n*   No URL provided in Record verb action attribute when modifying a live call\r\n*   Unsupported characters in auth portion of URL",
    solutions:
      'Make sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n*   hostname\r\n*   file path\r\n*   properly url-encoded query parameters\r\n\r\nTwilio must be able to reach this URL over the public Internet.',
    description:
      '## Error - 11100 \r\n\r\n### Invalid URL format\r\n\r\nThe format of the provided URL is invalid.\r\n',
    product: null,
    date_created: '2016-03-31T17:13:23Z',
    last_updated: '2021-05-26T00:11:08.56Z',
  },
  21409: {
    code: 21409,
    message: 'VoiceCallerIdLookup cannot be set for this phone number',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to set the VoiceCallerIdLookup for a phone number using the REST API, but the number does not support this feature.',
    log_type: null,
    docs: '## Error - 21409\n\n### VoiceCallerIdLookup cannot be set for this phone number\n\nYou attempted to set the VoiceCallerIdLookup for a phone number using the REST API, but the number does not support this feature.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:59Z',
    last_updated: '2020-08-04T10:00:26.966Z',
  },
  92004: {
    code: 92004,
    message: 'Invalid language code',
    log_level: 'ERROR',
    secondary_message: 'Invalid language code',
    log_type: 'APPLICATION',
    docs: "## ERROR - 92004\r\n\r\n### Invalid language code\r\n\r\nInvalid language code \r\n\r\n#### Possible Causes\r\nYou attempted to create content, but you sent an invalid 'language code'\r\n\r\n#### Possible Solutions\r\nPlease review that the language code is supported",
    causes: "You attempted to create content, but you sent an invalid 'language code'",
    solutions: 'Please review that the language code is supported',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-11-03T07:41:11Z',
    last_updated: '2021-11-03T07:41:11Z',
  },
  30133: {
    code: 30133,
    message: 'The certificate could not be uploaded.',
    log_level: 'ERROR',
    secondary_message: 'The certificate could not be uploaded due to invalid system state.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30133\r\n\r\n### The certificate could not be uploaded.\r\n\r\nThe certificate could not be uploaded due to invalid system state. \r\n\r\n#### Possible Causes\r\nThis might happen if an associated domain resource has been deleted and recreated since the last certificate upload.\r\n\r\n#### Possible Solutions\r\nPlease try uploading again in a few minutes.',
    causes:
      'This might happen if an associated domain resource has been deleted and recreated since the last certificate upload.',
    solutions: 'Please try uploading again in a few minutes.',
    description: null,
    product: 'Programmable SMS',
    date_created: '2022-10-13T00:06:22Z',
    last_updated: '2022-10-13T00:06:22Z',
  },
  52172: {
    code: 52172,
    message: 'Unexpected Binding Type used for Webhook Credentials request',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52172\r\n\r\n### Unexpected Binding Type used for Webhook Credentials request\r\n\r\n#### Possible Causes \r\n* Your token endpoint responded with an error indicating that the Binding Type used was not correct\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-04-04T09:55:20Z',
    last_updated: '2020-08-04T10:00:14.15Z',
  },
  60361: {
    code: 60361,
    message: 'Account SID is invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60361\r\n\r\n### Account SID is invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Account SID in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Account SID in the request parameter/header is correct.',
    causes: 'The Account SID in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Account SID in the request parameter/header is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-13T09:48:07Z',
    last_updated: '2023-12-13T09:48:07Z',
  },
  14217: {
    code: 14217,
    message: 'Dial->Queue: Could not find or accept provided reservationSid',
    log_level: 'ERROR',
    secondary_message:
      'Provided ReservationSid could not be found or has been canceled / rescinded.',
    log_type: null,
    docs: '### Dial->Queue: Could not find or accept provided reservationSid\r\n\r\nProvided ReservationSid could not be found or has been canceled / rescinded.',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2017-11-06T21:16:58Z',
    last_updated: '2020-08-04T10:00:16.347Z',
  },
  21422: {
    code: 21422,
    message: 'PhoneNumber is not available',
    log_level: 'ERROR',
    secondary_message:
      'You tried to purchase a phone number that is not available for purchase.  This error can be triggered in a few ways:  - Twilio does not own the phone number in question. - Twilio owns the number, but it is reserved for another account.',
    log_type: null,
    docs: '## Error - 21422\n\n### PhoneNumber is not available\n\nYou tried to purchase a phone number that is not available for purchase. \n\nThis error can be triggered in a few ways:\n\n- Twilio does not own the phone number in question.\n- Twilio owns the number, but it is reserved for another account.\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:21Z',
    last_updated: '2020-08-04T10:00:25.461Z',
  },
  32651: {
    code: 32651,
    message: 'Real-time Transcriptions: Provider Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32651\r\n\r\n### Real-time Transcriptions: Provider Error\r\n\r\n A 32651 Error is an indication that the &lt;Transcription&gt; provider configuration was rejected by the Speech-to-Text provider.\r\n\r\n\r\n#### Possible Causes\r\n* Provider configuration contains invalid or unsupported properties\r\n\r\n#### Possible Solutions\r\n* Check any provider specific configuration referenced in TwiML\r\n* Check the TranscriptionError message included in the webhook or the Debugger message in Console for further information. For additional assistance, please contact Twilio Support.',
    causes: '* Provider configuration contains invalid or unsupported properties',
    solutions:
      '* Check any provider specific configuration referenced in TwiML\r\n* Check the TranscriptionError message included in the webhook or the Debugger message in Console for further information. For additional assistance, please contact Twilio Support.',
    description:
      'A 32651 Error is an indication that the &lt;Transcription&gt; provider configuration was rejected by the Speech-to-Text provider.\r\n',
    product: 'Programmable Voice',
    date_created: '2024-05-10T20:01:28Z',
    last_updated: '2024-06-04T18:14:38.518907Z',
  },
  51126: {
    code: 51126,
    message: 'Twilsock: DNC limit has been reached',
    log_level: 'ERROR',
    secondary_message: 'DNC limit has been reached',
    log_type: null,
    docs: '## Error - 51126\r\n\r\n### DNC limit has been reached',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:29:14Z',
    last_updated: '2020-08-04T10:00:09.439Z',
  },
  32006: {
    code: 32006,
    message: 'SIP: Too many hops',
    log_level: 'WARNING',
    secondary_message:
      "The request was rejected because its 'Max-Forward' header had reached zero. Ensure your infrastructure will send a minimum value of 20 for 'Max-Forward' to ensure your call is processed successfully.",
    log_type: null,
    docs: '## Error - 32006\n\n### SIP: Too many hops\n\n#### Possible Causes \n*  The request was rejected because its `Max-Forward` header had reached zero.\n\n#### Possible Solutions\n*  Ensure your infrastructure will send a minimum value of 20 for `Max-Forward` to ensure your call is processed successfully.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:36Z',
    last_updated: '2020-08-04T10:00:24.409Z',
  },
  45203: {
    code: 45203,
    message: 'Requested Chat User not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45203\r\n\r\n### Requested Chat User not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nChat User related to a Chat Channel could not be found. \r\n\r\n#### Possible Solutions\r\nChat User is created automatically by Flex for any inbound end customer requests and automatically when an Agent connects to Flex where that Agent already does not have a Chat User. Chat User is synchronized to Identity Provider provided information (via SSO) on role and name. Please try again and ensure that the relevant Chat Users are not removed in your own implementations. ',
    causes: 'Chat User related to a Chat Channel could not be found. ',
    solutions:
      'Chat User is created automatically by Flex for any inbound end customer requests and automatically when an Agent connects to Flex where that Agent already does not have a Chat User. Chat User is synchronized to Identity Provider provided information (via SSO) on role and name. Please try again and ensure that the relevant Chat Users are not removed in your own implementations. ',
    description: null,
    product: 'Flex',
    date_created: '2019-07-08T11:49:22Z',
    last_updated: '2020-08-04T10:00:07.722Z',
  },
  21630: {
    code: 21630,
    message: 'Cannot mutate Address that is linked to a verified Document.',
    log_level: 'ERROR',
    secondary_message: 'Cannot mutate Address that is linked to a verified Document.',
    log_type: null,
    docs: '## Error - 21630\r\n\r\n### Cannot mutate Address that is linked to a verified Document.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2019-04-10T21:32:19Z',
    last_updated: '2020-08-04T10:00:09.162Z',
  },
  50416: {
    code: 50416,
    message: 'Participant and proxy address pair is already in use',
    log_level: 'ERROR',
    secondary_message:
      'The requested participant and proxy address pair is already registered in the system.',
    log_type: null,
    docs: "\n## Error - 50416\n\n### Conversations: Participant and proxy address pair is already in use\nThe requested participant and proxy address pair is already registered in the system.\n\n#### Possible Causes\n* You are attempting to map a non-Chat (e.g. SMS) conversation member with participant address and proxy address that are already assigned to an active conversation. For example, there may be only one unique mapping between your conversation participant's public phone number and internal (proxying) Twilio phone number, in order to route inbound messages correctly.\n\n#### Possible Solutions\n* [Locate](https://www.twilio.com/docs/conversations/api/conversation-resource#read-multiple-conversation-resources) a conflicting active conversation that has an identical participant added to it. Either [delete](https://www.twilio.com/docs/conversations/api/conversation-resource#delete-a-conversation-resource) old conversations completely if you don't need the message history, or just remove the participant that uses these numbers in a previous conversation.\n\n",
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.421Z',
  },
  19027: {
    code: 19027,
    message: 'Invalid Channel Description',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19027\r\n\r\n### Invalid Channel Description\r\n\r\n The channel description provided in the request is invalid\r\n\r\n#### Possible Causes\r\nChannel description is over 100 chars\r\n\r\n#### Possible Solutions\r\nChannel description must be under 100 chars',
    causes: 'Channel description is over 100 chars',
    solutions: 'Channel description must be under 100 chars',
    description: 'The channel description provided in the request is invalid',
    product: null,
    date_created: '2020-07-21T20:20:30Z',
    last_updated: '2020-08-04T10:00:01.59Z',
  },
  60609: {
    code: 60609,
    message: 'Live activity not enabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60609\r\n\r\n### Live activity not enabled\r\n\r\n live_activity is not enabled on your account\r\n\r\n#### Possible Causes\r\nYour account has not been approved and enabled to access the requested package\r\n\r\n#### Possible Solutions\r\nPlease contact Support or Sales to enable the requested package',
    causes: 'Your account has not been approved and enabled to access the requested package',
    solutions: 'Please contact Support or Sales to enable the requested package',
    description: 'live_activity is not enabled on your account',
    product: 'Lookup',
    date_created: '2021-06-30T14:15:13Z',
    last_updated: '2021-06-30T17:39:45.946743Z',
  },
  40158: {
    code: 40158,
    message: "Call Instruction does not have a valid 'status_callback_url' parameter",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40158\r\n\r\n### Call Instruction does not have a valid \'status_callback_url\' parameter\r\n\r\n Invalid \'status_callback_url\' parameter - Call Instruction\r\n\r\n#### Possible Causes\r\nProvided value for the "status_callback_url" parameter is either an empty string or of an incorrect datatype.\r\n\r\n#### Possible Solutions\r\n"status_callback_url" should be a well formed HTTP or HTTPS URL string.',
    causes:
      'Provided value for the "status_callback_url" parameter is either an empty string or of an incorrect datatype.',
    solutions: '"status_callback_url" should be a well formed HTTP or HTTPS URL string.',
    description: "Invalid 'status_callback_url' parameter - Call Instruction",
    product: 'TaskRouter',
    date_created: '2023-02-22T06:56:07Z',
    last_updated: '2023-02-22T06:56:07Z',
  },
  60408: {
    code: 60408,
    message: 'TemplateSid is only supported for the SMS channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60408\r\n\r\n### TemplateSid is only supported for the SMS channel\r\n\r\n TemplateSid is only supported for the SMS channel\r\n\r\n#### Possible Causes\r\nCreating a verification on CALL or EMAIL with TemplateSid parameter.\r\n\r\n#### Possible Solutions\r\nStop sending the TemplateSid param with non SMS verifications',
    causes: 'Creating a verification on CALL or EMAIL with TemplateSid parameter.',
    solutions: 'Stop sending the TemplateSid param with non SMS verifications',
    description: 'TemplateSid is only supported for the SMS channel',
    product: 'Verify',
    date_created: '2021-06-22T04:57:26Z',
    last_updated: '2021-06-22T04:57:26Z',
  },
  45744: {
    code: 45744,
    message: 'Failed to create webchat conversation. A resource provided could not be found. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 45744\r\n\r\n### Failed to create webchat conversation. A resource provided could not be found. \r\n\r\n Failed to create webchat conversation for provided address SID. Resource not found\r\n\r\n#### Possible Causes\r\nA resource provided in create webchat conversation request could not be found by conversations API. \r\n\r\n#### Possible Solutions\r\nEnsure the account credentials and address SID provided in the request are correct and are all associated with the intended account. \r\n\r\nEnsure there's a default messaging service configured.\r\nRead more about setting up a service [here.](https://www.twilio.com/docs/conversations/fundamentals#configuring-default-conversation-services-and-messaging-services)\r\n\r\nRead more about the create conversation request [here.](https://www.twilio.com/docs/conversations/api/conversation-resource#create-a-conversation-resource)\r\n\r\nRead more about messaging service resource [here.](https://www.twilio.com/docs/messaging/services/api)",
    causes:
      'A resource provided in create webchat conversation request could not be found by conversations API. ',
    solutions:
      "Ensure the account credentials and address SID provided in the request are correct and are all associated with the intended account. \r\n\r\nEnsure there's a default messaging service configured.\r\nRead more about setting up a service [here.](https://www.twilio.com/docs/conversations/fundamentals#configuring-default-conversation-services-and-messaging-services)\r\n\r\nRead more about the create conversation request [here.](https://www.twilio.com/docs/conversations/api/conversation-resource#create-a-conversation-resource)\r\n\r\nRead more about messaging service resource [here.](https://www.twilio.com/docs/messaging/services/api)",
    description:
      'Failed to create webchat conversation for provided address SID. Resource not found',
    product: 'Flex',
    date_created: '2022-10-03T21:34:33Z',
    last_updated: '2022-10-03T21:35:41.945105Z',
  },
  21720: {
    code: 21720,
    message: 'A2P Use Case is Invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21720\r\n\r\n### A2P Use Case is Invalid\r\n\r\n The A2P use case you are trying to specify in the request is not a valid use case.\r\n\r\n#### Possible Causes\r\nThe A2P use case specified in the request is not a valid A2P use case.\r\n\r\n#### Possible Solutions\r\nVerify that you are spelling the use case correctly in your request and that it is using all uppercase letters. The following resource can also be used to retrieve all valid A2P use cases for a specific Messaging Service: https://messaging.twilio.com/v1/Services/MGXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX/Compliance/Usa2p/Usecases',
    causes: 'The A2P use case specified in the request is not a valid A2P use case.',
    solutions:
      'Verify that you are spelling the use case correctly in your request and that it is using all uppercase letters. The following resource can also be used to retrieve all valid A2P use cases for a specific Messaging Service: https://messaging.twilio.com/v1/Services/MGXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX/Compliance/Usa2p/Usecases',
    description:
      'The A2P use case you are trying to specify in the request is not a valid use case.',
    product: 'Programmable SMS',
    date_created: '2021-06-29T16:25:31Z',
    last_updated: '2021-06-29T16:25:31Z',
  },
  95114: {
    code: 95114,
    message: 'Media duration is too long.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95114\r\n\r\n### Media duration is too long.\r\n\r\n Validation of audio failed as it is longer than the allowed maximum duration (8h). Some STT providers have this limit in place.\r\n\r\n#### Possible Causes\r\nMedia duration is longer than 8h.\r\n\r\n#### Possible Solutions\r\nSplit audio into smaller pieces.',
    causes: 'Media duration is longer than 8h.',
    solutions: 'Split audio into smaller pieces.',
    description:
      'Validation of audio failed as it is longer than the allowed maximum duration (8h). Some STT providers have this limit in place.',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:38:48Z',
    last_updated: '2024-04-16T17:38:48Z',
  },
  13615: {
    code: 13615,
    message: 'Record: maxLength too high for transcription',
    log_level: 'WARNING',
    secondary_message:
      "If maxLength must be less than or equal to 120 seconds (2 minutes) if transcribe or transcribeCallback attributes are specified, otherwise transcription is disabled.  See the <a href='/docs/api/twiml/record#transcribe'>Record Verb</a> API Reference for more information.",
    log_type: null,
    docs: '## Warning - 13615 \n\n### Record: transcribeCallback URL is invalid\n\nThe transcribeCallback URL provided in the `<Record>` verb is not valid.\n\n\n#### Possible Solutions\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n \t\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:45Z',
    last_updated: '2020-08-04T10:00:27.78Z',
  },
  11242: {
    code: 11242,
    message: 'HTTP connection over Twilio Interconnect is not allowed',
    log_level: 'ERROR',
    secondary_message:
      'Your account has not been enabled for HTTP connections over Twilio Interconnect.',
    log_type: null,
    docs: "## Error - 11242\r\n\r\n### HTTP connection over Twilio Interconnect is not allowed\r\n\r\nYour account has not been enabled for HTTP connections over Twilio Interconnect.\r\n\r\n#### Possible Solutions\r\n* Correct the 'r' (region) parameter in the fragment part of the URL, the one after '#'. Remove those with the '-ix' suffix.\r\n* Contact Twilio <a href=\"/help/contact\">customer support</a> to inquire further.\r\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-02-04T18:37:33Z',
    last_updated: '2020-08-04T10:00:10.762Z',
  },
  19021: {
    code: 19021,
    message: 'Only one channel can be set as primary',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19021\r\n\r\n### Only one channel can be set as primary\r\n\r\n is_primary can be set to true only for one channel\r\n\r\n#### Possible Causes\r\nRequest with is_primary set to True for more than one channel \r\n\r\n#### Possible Solutions\r\nEnsure only each channel has only 1 is_primary set to true',
    causes: 'Request with is_primary set to True for more than one channel ',
    solutions: 'Ensure only each channel has only 1 is_primary set to true',
    description: 'is_primary can be set to true only for one channel',
    product: null,
    date_created: '2020-07-21T20:15:07Z',
    last_updated: '2020-08-04T10:00:01.776Z',
  },
  52104: {
    code: 52104,
    message: 'Mismatched GCM/FCM sender ID',
    log_level: 'ERROR',
    secondary_message:
      'GCM/FCM application used different sender id with provided application credentials (ApiKey/Secret)',
    log_type: null,
    docs: '## Error - 52104\r\n\r\n### Mismatched GCM/FCM sender ID\r\n\r\n#### Possible Causes \r\n*  GCM/FCM API Key provided is not allowed to send notifications to the registration token.\r\n\r\n#### Possible Solutions\r\nMake sure that you are using an API Key/Secret that is allowed to send notifications to your application.\r\n\r\n*\tAdd the Project number of the Google Developers Console/Firebase Console project that the API Key/Secret belongs to to the allowed sender IDs of your application\r\n*\tAlternatively use an API Key/Secret from a project that is already allowed to send notifications to your application',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:26:02Z',
    last_updated: '2020-08-04T10:00:22.345Z',
  },
  13326: {
    code: 13326,
    message: 'Gather: Invalid input value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13326 \r\n\r\n### Gather: Invalid input value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-05-01T22:44:32Z',
    last_updated: '2020-08-04T10:00:19.275Z',
  },
  31426: {
    code: 31426,
    message: 'Upgrade Required',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31426\r\n\r\n### Upgrade Required\r\n\r\nThis error is raised when an HTTP 426 response is received. The reason for this is most likely because of an incompatible TLS version. To mitigate this, you may need to upgrade the OS or download a more recent version of the SDK.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:33:19Z',
    last_updated: '2020-08-04T10:00:08.395Z',
  },
  57011: {
    code: 57011,
    message: 'Unsupported Partner name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57011\r\n\r\n### Unsupported Partner name\r\n\r\n Unsupported Partner name\r\n\r\n#### Possible Causes\r\nSpecified 'PartnerName' is not supported\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'PartnerName' is being passed in request.",
    causes: "Specified 'PartnerName' is not supported",
    solutions: "Confirm a valid 'PartnerName' is being passed in request.",
    description: 'Unsupported Partner name',
    product: 'Programmable SMS',
    date_created: '2021-05-07T09:01:50Z',
    last_updated: '2021-05-31T09:01:25.251Z',
  },
  50053: {
    code: 50053,
    message: 'Programmable Chat: Invalid typing indicator format',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain valid typing indicator timeout.',
    log_type: null,
    docs: '## Error - 50053\r\n\r\n### Programmable Chat: Invalid typing indicator format\r\n\r\n#### Possible Causes \r\n*  Request does not contain valid typing indicator timeout.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid typing indicator timeout is being passed in request. \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:45Z',
    last_updated: '2020-08-04T10:00:23.61Z',
  },
  50513: {
    code: 50513,
    message: ' Message author should be among Group MMS participants.',
    log_level: 'ERROR',
    secondary_message: 'Author identity or address not found among Group MMS participants',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50513\r\n\r\n###  Message author should be among Group MMS participants.\r\n\r\nAuthor identity or address not found among Group MMS participants Author identity or address not found among Group MMS participants.\r\n\r\n#### Possible Causes\r\n* Provided author Address is not among Group MMS participants.\r\n* Provided author Identity is not among Group MMS participants.\r\n\r\n#### Possible Solutions\r\n* Check that the Author is participant of Group MMS conversation.',
    causes:
      '* Provided author Address is not among Group MMS participants.\r\n* Provided author Identity is not among Group MMS participants.',
    solutions: '* Check that the Author is participant of Group MMS conversation.',
    description: 'Author identity or address not found among Group MMS participants.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:05:03Z',
    last_updated: '2021-08-16T12:05:03Z',
  },
  21211: {
    code: 21211,
    message: "Invalid 'To' Phone Number",
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call or send a message, but the `To` phone number you supplied was not a valid phone number or was incorrectly formatted. Twilio accepts phone numbers in [E164 format](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 21211\r\n\r\n### Invalid 'To' Phone Number\r\n\r\nYou attempted to initiate an outbound phone call or send a message, but the `To` phone number you supplied was not a valid phone number or was incorrectly formatted. Twilio accepts phone numbers in [E164 format](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`. You attempted to initiate an outbound phone call or send a message, but the `To` phone number you supplied was not a valid phone number or was incorrectly formatted. Twilio accepts phone numbers in [E164 format](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`.\r\n\r\n#### Possible Causes\r\n* The formatting of the `To` number you supplied was invalid.\r\n* You attempted to send a message or place a call from a Twilio number to itself (i.e. putting the same Twilio number in the `To` and `From` parameters).\r\n* You attempted to send a message to Short Code.\r\n* You attempted to send a message to an Alphanumeric Sender ID.\r\n* You attempted to send a message to a `To` number with an invalid prefix using a Messaging Service.\r\n\r\n#### Possible Solutions\r\n* Ensure you have formatted your phone numbers in [E164\r\nformat](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`.\r\n* Ensure you have used the correct [country calling code](https://en.wikipedia.org/wiki/List_of_country_calling_codes#Alphabetical_listing_by_country_or_region) for the phone number you are calling.\r\n* Ensure you are not attempting to call or message from a Twilio number to itself.\r\n* Ensure you are not attempting to send messages to Short Codes or Alphanumeric Sender IDs. These sender types cannot receive messages from Twilio numbers.\r\n* Review the 'To' number for any typos or incorrect input methods.\r\n* If you are using a third party integration, test your API request in the [Try it out](https://console.twilio.com/us1/develop/sms/try-it-out/send-an-sms) section of the Twilio console. If this is successful, you may need to contact the third party to ensure they are not making unexpected changes to your `To` parameter.\r\n* When sending messages using a Messaging Service, instead of formatting a `To` number with an invalid prefix, remove the prefix and send directly to the `To` number using [E164\r\nformat](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`. If the `To` number is able to accept RCS messages and there is an RCS Agent available in the Messaging Service Sender Pool, it will be selected to send to the given `To` number.\r\n",
    causes:
      '* The formatting of the `To` number you supplied was invalid.\r\n* You attempted to send a message or place a call from a Twilio number to itself (i.e. putting the same Twilio number in the `To` and `From` parameters).\r\n* You attempted to send a message to Short Code.\r\n* You attempted to send a message to an Alphanumeric Sender ID.\r\n* You attempted to send a message to a `To` number with an invalid prefix using a Messaging Service.',
    solutions:
      "* Ensure you have formatted your phone numbers in [E164\r\nformat](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`.\r\n* Ensure you have used the correct [country calling code](https://en.wikipedia.org/wiki/List_of_country_calling_codes#Alphabetical_listing_by_country_or_region) for the phone number you are calling.\r\n* Ensure you are not attempting to call or message from a Twilio number to itself.\r\n* Ensure you are not attempting to send messages to Short Codes or Alphanumeric Sender IDs. These sender types cannot receive messages from Twilio numbers.\r\n* Review the 'To' number for any typos or incorrect input methods.\r\n* If you are using a third party integration, test your API request in the [Try it out](https://console.twilio.com/us1/develop/sms/try-it-out/send-an-sms) section of the Twilio console. If this is successful, you may need to contact the third party to ensure they are not making unexpected changes to your `To` parameter.\r\n* When sending messages using a Messaging Service, instead of formatting a `To` number with an invalid prefix, remove the prefix and send directly to the `To` number using [E164\r\nformat](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`. If the `To` number is able to accept RCS messages and there is an RCS Agent available in the Messaging Service Sender Pool, it will be selected to send to the given `To` number.\r\n",
    description:
      'You attempted to initiate an outbound phone call or send a message, but the `To` phone number you supplied was not a valid phone number or was incorrectly formatted. Twilio accepts phone numbers in [E164 format](http://en.wikipedia.org/wiki/E.164): `[+] [country code] [subscriber number including area code]`.',
    product: null,
    date_created: '2016-03-31T17:13:57Z',
    last_updated: '2024-04-12T08:34:40.814541Z',
  },
  60323: {
    code: 60323,
    message: 'Challenge expired',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60323\r\n\r\n### Challenge expired\r\n\r\n Challenge verification window expired.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nThe Challenge was not responded within the window of time.\r\n\r\n#### Possible Solutions\r\nCreate a new Challenge.',
    causes: 'The Challenge was not responded within the window of time.',
    solutions: 'Create a new Challenge.',
    description: 'Challenge verification window expired.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-06-30T21:42:23Z',
    last_updated: '2021-06-30T03:47:03.950294Z',
  },
  50419: {
    code: 50419,
    message: 'Conflicting member modification',
    log_level: 'ERROR',
    secondary_message:
      'The requested member is already being added or removed from this channel by a concurrent API request.',
    log_type: null,
    docs: '\n## Error - 50419\n\n### Programmable Chat: Conflicting member modification\nThe requested member is already being added or removed from this channel concurrently with another API request. The last request will be rejected to avoid inconsistent state.\n\n#### Possible Causes\n* You might be adding a new member to the channel while the member with the same identity is being removed from another thread.\n* You might be submitting multiple concurrent requests to add a member with the same identity to the channel.\n* You might be submitting multiple concurrent requests to delete the same member by SID or identity from the channel.\n\n#### Possible Solutions\n* Implement an operation retrier and repeat the failed member API requests after an interval of time, using an exponential backoff algorithm.\n* Review your application logic that caused the race condition when adding or removing members. Perhaps the conflicting operations are happening in a loop that could be avoided.\n* Serialize your API requests that add or remove members. Wait until the original request completes and returns an API response, before sending any successive member requests.\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2020-03-03T15:25:00Z',
    last_updated: '2020-08-04T10:00:04.522Z',
  },
  53632: {
    code: 53632,
    message: 'Failed to enqueue a room composition',
    log_level: 'WARNING',
    secondary_message: 'The job will not be executed',
    log_type: null,
    docs: '## Warning -  53632\r\n\r\n### Failed to enqueue a room composition\r\n\r\nThere was a failure enqueuing a composition for processing.\r\n\r\n#### Causes\r\n\r\n * There was an internal error when enqueuing the composition.\r\n\r\n#### Solutions\r\n\r\n* The composition can be launched again using the <a href="/docs/video/api/compositions-resource">REST API</a>.\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-09-28T16:25:58Z',
    last_updated: '2020-08-04T10:00:12.511Z',
  },
  45109: {
    code: 45109,
    message: 'Skills Limit Exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45109\r\n\r\n### Skills Limit Exceeded\r\n\r\n The number of Skills exceeds the limits.\r\n\r\n#### Possible Causes\r\nApplication attempted adding skills beyond Maximum Limit\r\n\r\n#### Possible Solutions\r\nDelete some existing Skills or Contact Customer Support to increase your Skills Limit',
    causes: 'Application attempted adding skills beyond Maximum Limit',
    solutions:
      'Delete some existing Skills or Contact Customer Support to increase your Skills Limit',
    description: 'The number of Skills exceeds the limits.',
    product: 'Flex',
    date_created: '2022-08-29T08:24:09Z',
    last_updated: '2022-08-29T08:24:09Z',
  },
  50413: {
    code: 50413,
    message: 'Account is not authorized to use proxy address',
    log_level: 'ERROR',
    secondary_message: 'Your account is not authorized to use the requested proxy address.',
    log_type: null,
    docs: '\n## Error - 50413\n\n### Conversations: Account is not authorized to use proxy address\nYour account is not authorized to use the requested proxy address.\n\n#### Possible Causes\n* The provided conversation proxy address is not allowed to be used under your account.\n\n#### Possible Solutions\n* Check that MessagingBinding.ProxyAddress parameter passed to API contains a proxy address that belongs to your account. For example, use a Twilio phone number that is purchased under the same project.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.476Z',
  },
  21705: {
    code: 21705,
    message: 'The Messaging Service is invalid',
    log_level: 'ERROR',
    secondary_message: 'The Messaging Service Sid you are using is not valid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21705\r\n\r\n### The Messaging Service is invalid\r\n\r\nThe Messaging Service Sid you are using is not valid \r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\n* The MessagingServiceSid provided with the request does not match a valid Sid \r\n   pattern(MGxxx).\r\n\r\n#### Possible Solutions\r\n* Double check the Messaging Service Sid parameter that you are using.\r\n* Find a specific Messaging Service Sid and manage your Messaging Services in the \r\n  [Twilio Console](https://www.twilio.com/console/sms/services).',
    causes:
      '* The MessagingServiceSid provided with the request does not match a valid Sid \r\n   pattern(MGxxx).',
    solutions:
      '* Double check the Messaging Service Sid parameter that you are using.\r\n* Find a specific Messaging Service Sid and manage your Messaging Services in the \r\n  [Twilio Console](https://www.twilio.com/console/sms/services).',
    description: '\r\n\r\n\r\n\r\n',
    product: null,
    date_created: '2016-03-31T17:14:30Z',
    last_updated: '2021-07-12T12:36:32.062661Z',
  },
  13750: {
    code: 13750,
    message: 'Twiml verb not supported by this API version.',
    log_level: 'ERROR',
    secondary_message:
      'Your version of the API does not support this feature. Please use version 2010-04-01 or later.',
    log_type: null,
    docs: '## ERROR - 13750\r\n\r\n### Twiml verb not supported in this version of the API\r\nYour version of the API does not support this feature. Please use version 2010-04-01 or later.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2018-10-23T23:30:26Z',
    last_updated: '2020-08-04T10:00:11.804Z',
  },
  21711: {
    code: 21711,
    message:
      'Phone Number, Shortcode, or AlphaSender is not associated to the specified Messaging Service.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 21711\r\n\r\n### Phone Number, Shortcode, or AlphaSender is not associated to the specified Messaging Service.\r\n\r\n ## Error - 21711\r\n\r\n### Phone Number, Shortcode, or AlphaSender is not associated to the specified Messaging Service.\r\n\r\n#### Possible Causes\r\n* The sender was never associated with a given Messaging Service. \r\n\r\n#### Possible Solutions\r\nPlease add this number to a specified Messaging Service. [See here](https://www.twilio.com/docs/messaging/services/api/phonenumber-resource#create-a-phonenumber-resource-add-a-phone-number-to-a-messaging-service) for a code sample. ',
    causes: '* The sender was never associated with a given Messaging Service. ',
    solutions:
      'Please add this number to a specified Messaging Service. [See here](https://www.twilio.com/docs/messaging/services/api/phonenumber-resource#create-a-phonenumber-resource-add-a-phone-number-to-a-messaging-service) for a code sample. ',
    description:
      '## Error - 21711\r\n\r\n### Phone Number, Shortcode, or AlphaSender is not associated to the specified Messaging Service.',
    product: 'Programmable SMS',
    date_created: '2022-12-27T21:07:17Z',
    last_updated: '2022-12-27T21:07:28.936678Z',
  },
  45010: {
    code: 45010,
    message: 'Rate Limit Exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45010\r\n\r\n### Rate Limit Exceeded\r\n\r\n The rate of access to this resource exceeds the prescribed limits.\r\n\r\n#### Possible Causes\r\nYour application is requesting Flex API resources at a rate that is higher than expected.\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.',
    causes:
      'Your application is requesting Flex API resources at a rate that is higher than expected.',
    solutions:
      'Verify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.',
    description: 'The rate of access to this resource exceeds the prescribed limits.',
    product: 'Flex',
    date_created: '2019-03-20T15:52:46Z',
    last_updated: '2020-08-04T10:00:09.945Z',
  },
  13240: {
    code: 13240,
    message: 'Dial->Conference: Invalid Whisper SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 13240\r\n\r\n### Dial->Conference: Invalid Whisper SID\r\n\r\nThe call SID specified by the whisper parameter is invalid. This may because the specified call is no longer connected to the conference. Validate that this call is connecting to the correct conference and the call SID specified is also in the conference.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-02-14T23:38:57Z',
    last_updated: '2020-08-04T10:00:20.268Z',
  },
  52004: {
    code: 52004,
    message: 'Credential SID not specified',
    log_level: 'ERROR',
    secondary_message: 'Credential SID not specified in binding, token or service',
    log_type: 'APPLICATION',
    docs: "## ERROR - 52004\r\n\r\n### Credential SID not specified\r\n\r\nCredential SID not specified in binding, token or service Credential SIDs are used to determine which Credential resource to use to send a given push notification (APNS, FCM or GCM). For each delivery attempt the system tries to select a Credential SID depending on the API request and configuration. This error indicates that the system did not find any available Credential SID to use and hence failed to send the delivery attempt.\r\n\r\n#### Possible Causes\r\nConfiguration is slightly different depending on which Twilio API and product you are using.\r\n\r\n*  Notify: Credential SID can be specified in the Notify Service or in the Binding. This error indicates neither of those were specified.\r\n\r\n*  Verify Push: Credential SID can be specified in the Verify Service in the `push` configuration. This error indicates the service doesn't have this configuration.\r\n\r\n*  Chat, Voice, Verify, Lookup: Credential SID can be specified in the Twilio Access Token used to register for push notifications. This error indicates that the token missed that information.\r\n\r\n\r\n#### Possible Solutions\r\n*  Notify: Set the Credential SID either in the Notify Service or in the Create Binding request\r\n*  Verify Push: Set the FCM/APN Credential SID in the Verify Service\r\n*  Chat, Voice, Verify, Lookup: Set the Credential SID in the Access Token",
    causes:
      "Configuration is slightly different depending on which Twilio API and product you are using.\r\n\r\n*  Notify: Credential SID can be specified in the Notify Service or in the Binding. This error indicates neither of those were specified.\r\n\r\n*  Verify Push: Credential SID can be specified in the Verify Service in the `push` configuration. This error indicates the service doesn't have this configuration.\r\n\r\n*  Chat, Voice, Verify, Lookup: Credential SID can be specified in the Twilio Access Token used to register for push notifications. This error indicates that the token missed that information.\r\n",
    solutions:
      '*  Notify: Set the Credential SID either in the Notify Service or in the Create Binding request\r\n*  Verify Push: Set the FCM/APN Credential SID in the Verify Service\r\n*  Chat, Voice, Verify, Lookup: Set the Credential SID in the Access Token',
    description:
      'Credential SIDs are used to determine which Credential resource to use to send a given push notification (APNS, FCM or GCM). For each delivery attempt the system tries to select a Credential SID depending on the API request and configuration. This error indicates that the system did not find any available Credential SID to use and hence failed to send the delivery attempt.',
    product: null,
    date_created: '2017-10-30T10:27:05Z',
    last_updated: '2023-12-05T18:03:18.212397Z',
  },
  16110: {
    code: 16110,
    message: 'Internal failure when bulk deleting recordings from your account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16110\r\n\r\n### Internal failure when bulk deleting recordings from your account\r\n\r\n Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.\r\n\r\n#### Possible Causes\r\nThere was an internal failure when processing your request. This action will not be retried.\r\n\r\n#### Possible Solutions\r\n* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
    causes:
      'There was an internal failure when processing your request. This action will not be retried.',
    solutions:
      '* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
    description:
      'Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.',
    product: 'Programmable Voice',
    date_created: '2019-09-16T09:03:27Z',
    last_updated: '2023-07-31T21:27:01.992018Z',
  },
  63046: {
    code: 63046,
    message: 'Template approved',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 63046\r\n\r\n### Template approved\r\n\r\n WhatsApp template approval status has changed to approved.\r\n\r\n#### Possible Causes\r\nWhatsApp has reported the template is now approved.\r\n\r\n#### Possible Solutions\r\nNo further action needed.',
    causes: 'WhatsApp has reported the template is now approved.',
    solutions: 'No further action needed.',
    description: 'WhatsApp template approval status has changed to approved.',
    product: 'Programmable Messaging',
    date_created: '2023-03-24T16:36:49Z',
    last_updated: '2023-03-24T16:36:49Z',
  },
  53103: {
    code: 53103,
    message: ' Unable to create Room',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53103\r\n\r\n###  Unable to create Room\r\n\r\n Raised when the Server is unable to create a Room.\r\n\r\n#### Possible Causes\r\n* A user attempted to connect to a Room which does not yet exist, and Ad-hoc Rooms are not enabled.\r\n* You may have chosen to enable Room features that are unsupported or not available to your account.\r\n* A server-side error has occurred.\r\n\r\n#### Possible Solutions\r\n* Make sure Ad-hoc Rooms are enabled in the Video settings for your account in Twilio Console, or create the Room explicitly using the REST API before attempting to connect to it.\r\n* Choose a Room configuration supported by your account.\r\n* If the problem persists, try connecting to another region.',
    causes:
      '* A user attempted to connect to a Room which does not yet exist, and Ad-hoc Rooms are not enabled.\r\n* You may have chosen to enable Room features that are unsupported or not available to your account.\r\n* A server-side error has occurred.',
    solutions:
      '* Make sure Ad-hoc Rooms are enabled in the Video settings for your account in Twilio Console, or create the Room explicitly using the REST API before attempting to connect to it.\r\n* Choose a Room configuration supported by your account.\r\n* If the problem persists, try connecting to another region.',
    description: 'Raised when the Server is unable to create a Room.',
    product: 'Programmable Video',
    date_created: '2017-04-24T15:42:05Z',
    last_updated: '2022-05-16T21:48:06.546832Z',
  },
  13610: {
    code: 13610,
    message: 'Record: Invalid method value',
    log_level: 'WARNING',
    secondary_message:
      "The method attribute of Record must be GET or POST. See the <a href='/docs/api/twiml/record#method'>Record Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13610 \n\n### Record: Invalid method value\n\nThe method attribute of Record must be GET or POST. See the <a href='/docs/api/twiml/record#method'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:44Z',
    last_updated: '2020-08-04T10:00:27.878Z',
  },
  32205: {
    code: 32205,
    message: 'SIP Trunking: Geo Permission configuration is not permitting call',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32205\r\n\r\n### SIP Trunking: Geo Permission configuration is not permitting call\r\n\r\n You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.\r\n\r\n#### Possible Causes\r\nUser dialed a destination your application is not enabled to support calling to.\r\n\r\n#### Possible Solutions\r\nPlease check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try again.',
    causes: 'User dialed a destination your application is not enabled to support calling to.',
    solutions:
      'Please check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try again.',
    description:
      'You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.',
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:38Z',
    last_updated: '2023-09-26T23:15:27.142057Z',
  },
  81025: {
    code: 81025,
    message: 'Studio Flow exceeds maximum allowed widgets',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 81025\r\n\r\n### Studio Flow exceeds maximum allowed widgets\r\n\r\n The cumulative number of widgets in your Studio Flow and all its linked Subflows exceeds the maximum allowed widget count of 2,000. You must reduce the number of widgets to 2,000 or fewer to prevent future Executions from failing.\r\n\r\n#### Possible Causes\r\n* Too many widgets in your Subflows\r\n* Subflows reused too many times in a parent Flow\r\n\r\n#### Possible Solutions\r\n* Reduce the number of widgets in your Subflows',
    causes:
      '* Too many widgets in your Subflows\r\n* Subflows reused too many times in a parent Flow',
    solutions: '* Reduce the number of widgets in your Subflows',
    description:
      'The cumulative number of widgets in your Studio Flow and all its linked Subflows exceeds the maximum allowed widget count of 2,000. You must reduce the number of widgets to 2,000 or fewer to prevent future Executions from failing.',
    product: 'Studio',
    date_created: '2021-08-19T22:20:18Z',
    last_updated: '2021-08-19T22:22:36.093637Z',
  },
  45206: {
    code: 45206,
    message: 'Chat User is already a member of the Chat Channel',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45206\r\n\r\n### Chat User is already a member of the Chat Channel\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request could not be completed due to a conflict as the Chat User is already part of the desired Chat Channel. This is possibly related to duplicate requests to Twilio Flex.\r\n\r\n#### Possible Solutions\r\nNo further action is necessary however please verify your business logic to avoid duplicate requests.',
    causes:
      'The request could not be completed due to a conflict as the Chat User is already part of the desired Chat Channel. This is possibly related to duplicate requests to Twilio Flex.',
    solutions:
      'No further action is necessary however please verify your business logic to avoid duplicate requests.',
    description: null,
    product: 'Flex',
    date_created: '2019-09-26T11:42:45Z',
    last_updated: '2020-08-04T10:00:06.223Z',
  },
  30908: {
    code: 30908,
    message: 'Campaign vetting rejection - Compliant Privacy Policy Required',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30908\r\n\r\n### Campaign vetting rejection - Compliant Privacy Policy Required\r\n\r\n The campaign submission has been reviewed and rejected because a compliant privacy policy can not be verified.\r\n\r\n#### Possible Causes\r\n* *Missing Privacy Policy*: A compliant privacy policy was not located on the website provided or Message Flow during the review process.\r\n* *Policy Inconsistencies*: Discrepancies in the provided privacy policy such as multiple privacy policies.\r\n* *Mobile Information Sharing*: Privacy policy indicates end-user mobile information is shared with third parties/affiliates.\r\n\r\n\r\n#### Possible Solutions\r\n1. Verify privacy policy is accessible to end-users and meets the compliance standards for the collection and use of mobile phone numbers for messaging. \r\n2. Include a direct link to the privacy policy within the Message Flow.\r\nOnce you have made a change to address the privacy policy error, please resubmit the campaign for review.\r\n3. Ensure that Privacy Policy states that no mobile information will be shared with third parties/affiliates for marketing/promotional purposes. \r\n\r\nAdditional help resources\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n\r\n',
    causes:
      '* *Missing Privacy Policy*: A compliant privacy policy was not located on the website provided or Message Flow during the review process.\r\n* *Policy Inconsistencies*: Discrepancies in the provided privacy policy such as multiple privacy policies.\r\n* *Mobile Information Sharing*: Privacy policy indicates end-user mobile information is shared with third parties/affiliates.\r\n',
    solutions:
      '1. Verify privacy policy is accessible to end-users and meets the compliance standards for the collection and use of mobile phone numbers for messaging. \r\n2. Include a direct link to the privacy policy within the Message Flow.\r\nOnce you have made a change to address the privacy policy error, please resubmit the campaign for review.\r\n3. Ensure that Privacy Policy states that no mobile information will be shared with third parties/affiliates for marketing/promotional purposes. \r\n\r\nAdditional help resources\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n\r\n',
    description:
      'The campaign submission has been reviewed and rejected because a compliant privacy policy can not be verified.',
    product: 'Programmable Messaging',
    date_created: '2023-11-09T16:26:34Z',
    last_updated: '2024-02-07T18:46:02.946675Z',
  },
  21703: {
    code: 21703,
    message: 'The Messaging Service does not have a phone number available to send a message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21703\r\n\r\n### The Messaging Service does not have a phone number available to send a message\r\n\r\n You have phone numbers or short codes in your Messaging Service, but none of them are capable of sending the requested message or media to this recipient.\r\nPossible causes vary depending on the type of message and the country of the destination number. Below are several common causes of this error.\r\n\r\n#### Possible Causes\r\n• You attempted to send a message to a United States or Canada mobile number, but you do not have any US/Canada numbers or short codes in your Messaging Service. US/Canada mobile numbers are not reachable from Twilio numbers from outside the US/Canada, due to limitations imposed by carriers.**\r\n\r\n• You only have a short code number in your Messaging Service, and the recipient is not reachable from your short code (for example, the To number is from a different country than your short code, or is on a [carrier that does not support short code messaging](https://support.twilio.com/hc/en-us/articles/223182088-What-carriers-are-supported-on-Twilio-short-codes-)).\r\n\r\n• You attempted to send an MMS message, but you do not have any US/Canada long code numbers or an [MMS-enabled short code](https://support.twilio.com/hc/en-us/articles/223134667-Sending-receiving-MMS-messages-with-short-codes) in your Messaging Service.**\r\n\r\n• You only have an [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Getting-started-with-Alphanumeric-Sender-ID) in your Messaging Service, and the To number is in a [country where Alphanumeric Sender ID is unsupported](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n\r\n• You attempted to send a message to a United States mobile number, but you do not have any 10DLC numbers that are registered with a verified A2P Campaign in the Messaging Service. Only numbers registered with a verified A2P Campaign can be allowed to send to US based numbers. \r\n\r\n** If you have recently added the number to a Messaging Service and while the number has a “Pending Registration” status, you may be experiencing a known issue which disables the ability to benefit from a temporary exception Twilio has made available to sending messages from “Pending Registration” numbers.  You can reattempt to send from the impacted number by including the number in the "From" parameter of your API request instead of using the Messaging Service SID. However, this exception will sunset in the coming weeks.  For more information about the 21703 error in relation to numbers “Pending Registration”, and processing times to complete the Number Registration going forward, please review updated [A2P 10DLC Number Registration Best Practices](https://support.twilio.com/hc/en-us/articles/19622397178139-A2P-10DLC-Number-Registration-Best-Practices). To check the status of your numbers at any given time, you can use the Number Registration CSV report as described in [How do I check that I have completed US A2P 10DLC registration](https://support.twilio.com/hc/en-us/articles/4418081745179-How-do-I-check-that-I-have-completed-US-A2P-10DLC-registration-).\r\n\r\n#### Possible Solutions\r\nAdd a sender to your Messaging Service with the required capabilities, using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/messaging/services/api/phonenumber-resource#create-a-phonenumber-resource-add-a-phone-number-to-a-messaging-service).',
    causes:
      '• You attempted to send a message to a United States or Canada mobile number, but you do not have any US/Canada numbers or short codes in your Messaging Service. US/Canada mobile numbers are not reachable from Twilio numbers from outside the US/Canada, due to limitations imposed by carriers.**\r\n\r\n• You only have a short code number in your Messaging Service, and the recipient is not reachable from your short code (for example, the To number is from a different country than your short code, or is on a [carrier that does not support short code messaging](https://support.twilio.com/hc/en-us/articles/223182088-What-carriers-are-supported-on-Twilio-short-codes-)).\r\n\r\n• You attempted to send an MMS message, but you do not have any US/Canada long code numbers or an [MMS-enabled short code](https://support.twilio.com/hc/en-us/articles/223134667-Sending-receiving-MMS-messages-with-short-codes) in your Messaging Service.**\r\n\r\n• You only have an [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Getting-started-with-Alphanumeric-Sender-ID) in your Messaging Service, and the To number is in a [country where Alphanumeric Sender ID is unsupported](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n\r\n• You attempted to send a message to a United States mobile number, but you do not have any 10DLC numbers that are registered with a verified A2P Campaign in the Messaging Service. Only numbers registered with a verified A2P Campaign can be allowed to send to US based numbers. \r\n\r\n** If you have recently added the number to a Messaging Service and while the number has a “Pending Registration” status, you may be experiencing a known issue which disables the ability to benefit from a temporary exception Twilio has made available to sending messages from “Pending Registration” numbers.  You can reattempt to send from the impacted number by including the number in the "From" parameter of your API request instead of using the Messaging Service SID. However, this exception will sunset in the coming weeks.  For more information about the 21703 error in relation to numbers “Pending Registration”, and processing times to complete the Number Registration going forward, please review updated [A2P 10DLC Number Registration Best Practices](https://support.twilio.com/hc/en-us/articles/19622397178139-A2P-10DLC-Number-Registration-Best-Practices). To check the status of your numbers at any given time, you can use the Number Registration CSV report as described in [How do I check that I have completed US A2P 10DLC registration](https://support.twilio.com/hc/en-us/articles/4418081745179-How-do-I-check-that-I-have-completed-US-A2P-10DLC-registration-).',
    solutions:
      'Add a sender to your Messaging Service with the required capabilities, using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/messaging/services/api/phonenumber-resource#create-a-phonenumber-resource-add-a-phone-number-to-a-messaging-service).',
    description:
      'You have phone numbers or short codes in your Messaging Service, but none of them are capable of sending the requested message or media to this recipient.\r\nPossible causes vary depending on the type of message and the country of the destination number. Below are several common causes of this error.',
    product: 'Programmable Messaging',
    date_created: '2016-03-31T17:14:29Z',
    last_updated: '2023-10-20T21:03:36.010396Z',
  },
  40157: {
    code: 40157,
    message: "Dequeue Instruction does not have a valid 'status_callback_url' parameter",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 40157\r\n\r\n### Dequeue Instruction does not have a valid 'status_callback_url' parameter\r\n\r\n Invalid 'status_callback_url' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes\r\nYou have provided either an empty string or a value with incorrect datatype for the “status_callback_url” parameter.\r\n\r\n#### Possible Solutions\r\n\"status_callback_url\" should be a well formed HTTP or HTTPS URL string.",
    causes:
      'You have provided either an empty string or a value with incorrect datatype for the “status_callback_url” parameter.',
    solutions: '"status_callback_url" should be a well formed HTTP or HTTPS URL string.',
    description: "Invalid 'status_callback_url' parameter - Dequeue Instruction",
    product: 'TaskRouter',
    date_created: '2022-10-19T17:51:01Z',
    last_updated: '2023-02-22T06:59:28.910165Z',
  },
  50362: {
    code: 50362,
    message: 'Too many conversation webhook triggers',
    log_level: 'ERROR',
    secondary_message:
      'The number of keywords used to trigger the webhook configured for this conversation exceeds the limit.',
    log_type: null,
    docs: '\n## Error - 50362\n\n### Conversations: Too many conversation webhook triggers\nThe number of keywords used to trigger the webhook configured for this conversation would have exceeded the limit.\n\n#### Possible Causes\nYou are attempting to add more than 5 keywords as triggers for this webhook.\n\n#### Possible Solutions\n* Retrieve a list of the [existing keywords](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#fetch-a-conversationscopedwebhook-resource) used as triggers and remove the ones that are redundant or obsolete.\n* Consider creating a new scoped webhook with an alternative set of trigger keywords.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.802Z',
  },
  21236: {
    code: 21236,
    message: 'IP Access Control List Dependencies Violation',
    log_level: 'ERROR',
    secondary_message:
      'You cannot delete an IP Access Control List that is still mapped to a SIP Domain.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21236\r\n\r\n### IP Access Control List Dependencies Violation\r\n\r\nYou cannot delete an IP Access Control List that is still mapped to a SIP Domain. \r\n\r\n#### Possible Causes\r\n* Your IP Access Control List is still mapped to a SIP Domain.\r\n\r\n#### Possible Solutions\r\n* Remove the IP Access Control list from your SIP Domain before trying to delete it.',
    causes: '* Your IP Access Control List is still mapped to a SIP Domain.',
    solutions:
      '* Remove the IP Access Control list from your SIP Domain before trying to delete it.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:08:32Z',
    last_updated: '2020-08-04T10:00:00.584Z',
  },
  13220: {
    code: 13220,
    message: 'Dial: Invalid ringTone value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13220\r\n\r\n### Dial: Invalid ringTone value\r\n\r\n \r\n\r\n#### Possible Causes\r\nDial: Invalid ringTone value\r\n\r\n#### Possible Solutions\r\nProvide valid ringTone value',
    causes: 'Dial: Invalid ringTone value',
    solutions: 'Provide valid ringTone value',
    description: null,
    product: 'Programmable Voice',
    date_created: '2020-05-16T02:49:41Z',
    last_updated: '2020-08-04T10:00:03.048Z',
  },
  21449: {
    code: 21449,
    message: 'Number already can be used for outgoing calls and messages',
    log_level: 'ERROR',
    secondary_message:
      'The number you attempted to add as an Outgoing Caller ID to your account already can be used for outgoing calls and messages.',
    log_type: null,
    docs: '## Error - 21449\r\n\r\n### Number already can be used for outgoing calls and messages\r\n\r\nThe number you attempted to add as an Outgoing Caller ID to your account already can be used for outgoing calls and messages.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-16T12:08:00Z',
    last_updated: '2020-08-04T10:00:15.293Z',
  },
  45701: {
    code: 45701,
    message: 'Unexpected error occurred. Service unavailable. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45701\r\n\r\n### Unexpected error occurred. Service unavailable. \r\n\r\n An unexpected error occurred when processing create WebChat request. Our service is currently unavailable.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error while processing your request. Our service is currently unavailable. \r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our [status page](https://status.twilio.com/) to see if we are having an outage.\r\n\r\nIf our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.',
    causes:
      'We encountered an unexpected error while processing your request. Our service is currently unavailable. ',
    solutions:
      'Retry the request.\r\n\r\nCheck our [status page](https://status.twilio.com/) to see if we are having an outage.\r\n\r\nIf our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.',
    description:
      'An unexpected error occurred when processing create WebChat request. Our service is currently unavailable.',
    product: 'Flex',
    date_created: '2022-10-03T20:52:38Z',
    last_updated: '2022-10-03T21:05:36.942698Z',
  },
  21604: {
    code: 21604,
    message: "The destination 'To' phone number is required to send an SMS",
    log_level: 'ERROR',
    secondary_message: 'Make sure to specify a valid phone number as the recipient of the SMS.',
    log_type: null,
    docs: "## Error - 21604\n\n### 'To' phone number is required to send a Message\n\nMake sure to specify a valid phone number as the recipient of the message.\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:03Z',
    last_updated: '2020-08-04T10:00:26.71Z',
  },
  50320: {
    code: 50320,
    message: 'Programmable Chat: Channel webhook not found',
    log_level: 'ERROR',
    secondary_message: 'Specified channel webhook does not exist',
    log_type: null,
    docs: '## Error - 50320\r\n\r\n### Programmable Chat: Channel webhook not found\r\n\r\n#### Possible Causes \r\n*  Specified channel webhook does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid channel webhook SID is provided in request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T12:07:09Z',
    last_updated: '2020-08-04T10:00:12.161Z',
  },
  54101: {
    code: 54101,
    message: 'Invalid Document data',
    log_level: 'ERROR',
    secondary_message: "The 'Data' parameter cannot be null.",
    log_type: null,
    docs: "\n## Error - 54101\n\n### Sync: Invalid Document data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\nYour request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.625Z',
  },
  60411: {
    code: 60411,
    message: 'Phone Number already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60411\r\n\r\n### Phone Number already exists\r\n\r\n The phone number already exists in the SafeList.\r\n\r\n#### Possible Causes\r\n* Multiple requests were made to add the phone number to the SafeList.\r\n* The phone number was already added at an earlier time.\r\n\r\n#### Possible Solutions\r\nIf you know this phone number is present in the SafeList, do nothing.',
    causes:
      '* Multiple requests were made to add the phone number to the SafeList.\r\n* The phone number was already added at an earlier time.',
    solutions: 'If you know this phone number is present in the SafeList, do nothing.',
    description: 'The phone number already exists in the SafeList.',
    product: 'Verify',
    date_created: '2022-09-02T19:45:38Z',
    last_updated: '2022-09-02T19:45:38Z',
  },
  19030: {
    code: 19030,
    message: 'Invalid location type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19030\r\n\r\n### Invalid location type\r\n\r\n Request with an invalid location type\r\n\r\n#### Possible Causes\r\nLocation type other than: work, home, other\r\n\r\n#### Possible Solutions\r\nOnly use work, home, other as location type',
    causes: 'Location type other than: work, home, other',
    solutions: 'Only use work, home, other as location type',
    description: 'Request with an invalid location type',
    product: null,
    date_created: '2020-07-21T20:23:21Z',
    last_updated: '2020-08-04T10:00:01.497Z',
  },
  94002: {
    code: 94002,
    message: 'Transcriptions: configuration not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 94002\r\n\r\n### Transcriptions: configuration not found\r\n\r\n Twilio failed to process the request to transcribe audio because configuration was not found. No transcription resource has been created\r\n\r\n#### Possible Causes\r\n* Transcription Configuration was not specified\r\n* Transcription Configuration was specified but not found in account\r\n\r\n#### Possible Solutions\r\n* Specify unique name or Sid of an existent Transcription Configuration associated to your account',
    causes:
      '* Transcription Configuration was not specified\r\n* Transcription Configuration was specified but not found in account',
    solutions:
      '* Specify unique name or Sid of an existent Transcription Configuration associated to your account',
    description:
      'Twilio failed to process the request to transcribe audio because configuration was not found. No transcription resource has been created',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-13T14:06:13Z',
  },
  21252: {
    code: 21252,
    message: 'Invalid Region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21252\r\n\r\n### Invalid Region\r\n\r\n \r\n\r\n#### Possible Causes\r\n*   The Region requested is not valid.\r\n\r\n#### Possible Solutions\r\n*  Please see [Localized Termination URIs](/docs/sip-trunking#localized-termination-uris) for more information on the valid Elastic SIP Trunking Regions.',
    causes: '*   The Region requested is not valid.',
    solutions:
      '*  Please see [Localized Termination URIs](/docs/sip-trunking#localized-termination-uris) for more information on the valid Elastic SIP Trunking Regions.',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:13:06Z',
    last_updated: '2023-07-28T17:08:42.739204Z',
  },
  30400: {
    code: 30400,
    message: 'Parameters are not valid ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30400\r\n\r\n### Parameters are not valid \r\n\r\n There is an issue with the request body.\r\n\r\n#### Possible Causes\r\n- POST body is missing parameters Body or Status.\r\n- Attempted to cancel the message and redact the message body at the same time.\r\n- Value for Status is invalid.\r\n- Message body redaction request does not have empty Body parameter.\r\n\r\n#### Possible Solutions\r\n- To cancel the message, include Status: canceled.\r\n- To redact the message body, ensure Body is empty. More details [here](https://support.twilio.com/hc/en-us/articles/223133687-Deleting-messages-message-media-or-message-bodies).\r\n- If you want to cancel and redact the message body: First, request the message to be canceled. Then, request for message body redaction. More details [here](https://support.twilio.com/hc/en-us/articles/223133687-Deleting-messages-message-media-or-message-bodies).',
    causes:
      '- POST body is missing parameters Body or Status.\r\n- Attempted to cancel the message and redact the message body at the same time.\r\n- Value for Status is invalid.\r\n- Message body redaction request does not have empty Body parameter.',
    solutions:
      '- To cancel the message, include Status: canceled.\r\n- To redact the message body, ensure Body is empty. More details [here](https://support.twilio.com/hc/en-us/articles/223133687-Deleting-messages-message-media-or-message-bodies).\r\n- If you want to cancel and redact the message body: First, request the message to be canceled. Then, request for message body redaction. More details [here](https://support.twilio.com/hc/en-us/articles/223133687-Deleting-messages-message-media-or-message-bodies).',
    description: 'There is an issue with the request body.',
    product: 'Programmable SMS',
    date_created: '2021-08-06T22:33:36Z',
    last_updated: '2021-08-06T22:33:36Z',
  },
  32216: {
    code: 32216,
    message: 'SIP: SIP Address is on a deny list',
    log_level: 'ERROR',
    secondary_message: 'This address is on a deny list.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 32216\r\n\r\n### SIP: SIP Address is on a deny list\r\n\r\nThis address is on a deny list. This address is on a deny list.\r\n\r\n#### Possible Causes\r\nThe SIP Address exists on a deny list.\r\n\r\n#### Possible Solutions\r\nUse a SIP Address that is not on a deny list.',
    causes: 'The SIP Address exists on a deny list.',
    solutions: 'Use a SIP Address that is not on a deny list.',
    description: 'This address is on a deny list.',
    product: null,
    date_created: '2018-06-11T21:19:09Z',
    last_updated: '2023-11-01T19:26:35.10948Z',
  },
  19032: {
    code: 19032,
    message: 'Invalid location input',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19032\r\n\r\n### Invalid location input\r\n\r\n Request body is not valid\r\n\r\n#### Possible Causes\r\nA Required field is missing or field is invalid or duplicated \r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'A Required field is missing or field is invalid or duplicated ',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'Request body is not valid',
    product: null,
    date_created: '2020-07-21T20:24:37Z',
    last_updated: '2020-08-04T10:00:01.442Z',
  },
  60209: {
    code: 60209,
    message: 'UniqueName format is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60209\r\n\r\n### UniqueName format is invalid\r\n\r\n `UniqueName` only supports alphanumeric characters and `-`, `_` or `.` \r\n\r\nHTTP status: 400\r\n\r\n\r\n#### Possible Causes\r\n`UniqueName` only supports alphanumeric characters and `-`, `_` or `.` \r\n\r\n\r\n#### Possible Solutions\r\n* Remove unsupported characters from `UniqueName`',
    causes: '`UniqueName` only supports alphanumeric characters and `-`, `_` or `.` \r\n',
    solutions: '* Remove unsupported characters from `UniqueName`',
    description:
      '`UniqueName` only supports alphanumeric characters and `-`, `_` or `.` \r\n\r\nHTTP status: 400\r\n',
    product: 'Verify',
    date_created: '2019-05-07T18:18:07Z',
    last_updated: '2021-05-18T04:41:49.031Z',
  },
  80105: {
    code: 80105,
    message: 'Short Code Already In Service',
    log_level: 'WARNING',
    secondary_message: 'ShortCode has already been added to Service',
    log_type: null,
    docs: '## Warning\n\n### Short Code Already In Service\n\nExample Message: ShortCode has already been added to Service',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.188Z',
  },
  22215: {
    code: 22215,
    message: 'Missing End-User field',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22215\r\n\r\n### Missing End-User field\r\n\r\n An End-User field is missing from the Regulatory Bundle\r\n\r\n#### Possible Causes\r\nThe Regulation requires an End-User field which is missing from your Regulatory Bundle.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Regulations API to ensure that all required fields are present in the End-User.',
    causes:
      'The Regulation requires an End-User field which is missing from your Regulatory Bundle.',
    solutions:
      'Please refer to the Regulations API to ensure that all required fields are present in the End-User.',
    description: 'An End-User field is missing from the Regulatory Bundle',
    product: 'Phone Numbers',
    date_created: '2020-04-23T22:06:33Z',
    last_updated: '2020-08-04T10:00:03.758Z',
  },
  68002: {
    code: 68002,
    message: 'Mapper Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 68002\r\n\r\n### Mapper Error\r\n\r\n An error occurred while mapping an entity.\r\n\r\n#### Possible Causes\r\nUnexpected entity format.\r\n\r\n#### Possible Solutions\r\nCreate a new factor.',
    causes: 'Unexpected entity format.',
    solutions: 'Create a new factor.',
    description: 'An error occurred while mapping an entity.',
    product: 'Verify',
    date_created: '2020-09-15T18:12:09Z',
    last_updated: '2020-09-15T18:12:09Z',
  },
  45367: {
    code: 45367,
    message: 'Failed to add Participant.  Invalid request parameters.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45367\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'sInvalid or missing parameters supplied in the create participant request.',
    solutions:
      'Ensure that request parameters are in accordance with the public documentation.\r\n',
    description:
      'Failed to add participant <participant sid> to Channel <channel sid> due to invalid request parameters.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:03.961285Z',
  },
  32016: {
    code: 32016,
    message: 'PSTN PDD timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 32016\r\n\r\n### PSTN PDD timeout\r\n\r\n ## PSTN Post-Dial Delay timeout\r\n\r\n#### Possible Causes\r\nPSTN Post-Dial Delay timer (60s) expired due to lack of response from multiple Carriers in route.\r\n\r\n#### Possible Solutions\r\n* Check the dialed Number to ensure it is currently reachable.\r\n* If you believe the Number is currently reachable, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) and be sure to mention this Error code.',
    causes:
      'PSTN Post-Dial Delay timer (60s) expired due to lack of response from multiple Carriers in route.',
    solutions:
      '* Check the dialed Number to ensure it is currently reachable.\r\n* If you believe the Number is currently reachable, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) and be sure to mention this Error code.',
    description: '## PSTN Post-Dial Delay timeout',
    product: null,
    date_created: '2018-02-02T22:23:50Z',
    last_updated: '2023-11-01T04:42:38.394127Z',
  },
  21301: {
    code: 21301,
    message: 'Cannot create application: application limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21301\r\n\r\n### Cannot create application: application limit exceeded\r\n\r\n Cannot create application: application limit exceeded \r\n\r\n#### Possible Causes\r\nYou have attempted to create a new application that exceeds the limit of 1000 applications.\r\n\r\n#### Possible Solutions\r\nDelete or update application in order to create new application.',
    causes:
      'You have attempted to create a new application that exceeds the limit of 1000 applications.',
    solutions: 'Delete or update application in order to create new application.',
    description: 'Cannot create application: application limit exceeded ',
    product: 'Programmable Voice',
    date_created: '2020-03-30T19:08:19Z',
    last_updated: '2020-08-04T10:00:04.168Z',
  },
  60325: {
    code: 60325,
    message: 'Translation for locale not found, using default',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60325\r\n\r\n### Translation for locale not found, using default\r\n\r\n The template you are using does not have the translation with the locale you specified.\r\n\r\n#### Possible Causes\r\nThe translation might not exist.\r\n\r\n#### Possible Solutions\r\nIf you want to add more translations, please contact support.',
    causes: 'The translation might not exist.',
    solutions: 'If you want to add more translations, please contact support.',
    description:
      'The template you are using does not have the translation with the locale you specified.',
    product: 'Verify',
    date_created: '2021-10-16T15:11:12Z',
    last_updated: '2021-10-16T15:11:12Z',
  },
  13910: {
    code: 13910,
    message: 'Pause: Invalid length value',
    log_level: 'WARNING',
    secondary_message:
      "The length attribute must be a positive integer, in seconds. See the <a href='/docs/api/twiml/pause#length'>Pause Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13910 \n\n### Pause: Invalid length value\n\nThe length attribute must be a positive integer, in seconds. See the <a href='/docs/api/twiml/pause#length'>Pause Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:47Z',
    last_updated: '2020-08-04T10:00:27.699Z',
  },
  60221: {
    code: 60221,
    message: 'No target verification specified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60221\r\n\r\n### No target verification specified\r\n\r\n Ensure that either a `To` or `VerificationSid` is provided\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nNo `To` nor `VerificationSid` is provided in the request\r\n\r\n#### Possible Solutions\r\nEnsure that either a `To` or `VerificationSid` is provided',
    causes: 'No `To` nor `VerificationSid` is provided in the request',
    solutions: 'Ensure that either a `To` or `VerificationSid` is provided',
    description:
      'Ensure that either a `To` or `VerificationSid` is provided\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-07-03T00:53:12Z',
    last_updated: '2021-05-18T04:51:41.837Z',
  },
  31504: {
    code: 31504,
    message: 'Gateway Timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31504\r\n\r\n### Gateway Timeout \r\n\r\nThe server, while acting as a gateway or proxy, did not receive a timely response from an upstream server.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:47:14Z',
    last_updated: '2020-08-04T10:00:08.195Z',
  },
  21605: {
    code: 21605,
    message: 'Maximum body length is 160 characters (old API endpoint)',
    log_level: 'ERROR',
    secondary_message:
      'You are using the deprecated /SMS/Messages API endpoint, which supports up to 160 characters per message. To send up to 1600 characters per message, switch to our upgraded /Messages endpoint.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21605\r\n\r\n### Maximum body length is 160 characters (old API endpoint)\r\n\r\nYou are using the deprecated /SMS/Messages API endpoint, which supports up to 160 characters per message. To send up to 1600 characters per message, switch to our upgraded /Messages endpoint. ## Error - 21605\r\n\r\n### Maximum body length is 160 characters\r\n\r\nThis error is specific to the deprecated /SMS/Messages API endpoint. When using this endpoint, your message body must be 160 characters or less. \r\n\r\nYou can send messages up to 1600 characters long by using the [/Messages](https://www.twilio.com/docs/sms/api/message#create-a-message-resource) API endpoint.\r\n\r\nFor more info, please refer to [our FAQ on message size constraints](https://support.twilio.com/hc/en-us/articles/223133347-Size-limitations-of-combining-text-and-images).\r\n\r\n#### Possible Causes\r\nThe SMS body contains too many characters.\r\n\r\n#### Possible Solutions\r\nReduce the number of characters in your message body and review our FAQ on message size constraints.',
    causes: 'The SMS body contains too many characters.',
    solutions:
      'Reduce the number of characters in your message body and review our FAQ on message size constraints.',
    description:
      '## Error - 21605\r\n\r\n### Maximum body length is 160 characters\r\n\r\nThis error is specific to the deprecated /SMS/Messages API endpoint. When using this endpoint, your message body must be 160 characters or less. \r\n\r\nYou can send messages up to 1600 characters long by using the [/Messages](https://www.twilio.com/docs/sms/api/message#create-a-message-resource) API endpoint.\r\n\r\nFor more info, please refer to [our FAQ on message size constraints](https://support.twilio.com/hc/en-us/articles/223133347-Size-limitations-of-combining-text-and-images).',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:03Z',
    last_updated: '2023-10-31T17:11:47.527178Z',
  },
  52071: {
    code: 52071,
    message: 'Internal error when sending notification via mqtt client connection',
    log_level: 'ERROR',
    secondary_message:
      'An unexpected error has happened in notification flow via mqtt client connection',
    log_type: null,
    docs: '## Error - 52071\r\n\r\n### RtdNotification: Internal error when sending notification via mqtt client connection\r\n\r\n#### Possible Causes \r\n*  Temporary outage of client connection mqtt gateway.\r\n\r\n#### Possible Solutions\r\n*  Ask customer support for investigation. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:03:56Z',
    last_updated: '2020-08-04T10:00:22.435Z',
  },
  52105: {
    code: 52105,
    message: 'Invalid GCM/FCM package name',
    log_level: 'ERROR',
    secondary_message: 'Mismatch package name in request and from GCM/FCM registration id',
    log_type: null,
    docs: '## Error - 52105\r\n\r\n### RtdNotification: Invalid GCM/FCM package name\r\n\r\n#### Possible Causes \r\n*  Application configuration problem.\r\n\r\n#### Possible Solutions\r\n*  Make sure the message was addressed to a registration token whose package name matches the value passed in the request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:28:59Z',
    last_updated: '2020-08-04T10:00:22.328Z',
  },
  53668: {
    code: 53668,
    message: 'Public key credentials for media tracks encryption could not be loaded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53668\r\n\r\n### Public key credentials for media tracks encryption could not be loaded\r\n\r\n The public key credentials configured in your account's composition settings could not be loaded.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.\r\n\r\n#### Possible Causes\r\n * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Possible Solutions\r\n * In the composition settings section of your account's console, create and assign a new valid public key or disable the encryption (media will be uploaded in raw).",
    causes:
      ' * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the credentials resource has been removed from Twilio.',
    solutions:
      " * In the composition settings section of your account's console, create and assign a new valid public key or disable the encryption (media will be uploaded in raw).",
    description:
      "The public key credentials configured in your account's composition settings could not be loaded.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.",
    product: 'Programmable Video',
    date_created: '2021-04-13T07:36:09Z',
    last_updated: '2021-04-13T07:36:09Z',
  },
  53001: {
    code: 53001,
    message: 'Signaling connection disconnected',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53001: Signaling connection disconnected\r\n\r\nRaised whenever the signaling connection is unexpectedly disconnected.\r\n\r\n#### Causes\r\n\r\n * The device running your application lost its internet connection.\r\n\r\n#### Solutions\r\n\r\n * Ensure the device running your application has access to a stable internet connection.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:37:59Z',
    last_updated: '2020-08-04T10:00:19.747Z',
  },
  80407: {
    code: 80407,
    message: 'Phone Number Sid Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Phone Number Sid',
    log_type: null,
    docs: '## Warning\n\n### Phone Number Sid Invalid\n\nExample Message: Invalid Phone Number Sid',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.929Z',
  },
  60363: {
    code: 60363,
    message: 'Service SID invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60363\r\n\r\n### Service SID invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Service SID in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Service SID in the request parameter/header is correct.',
    causes: 'The Service SID in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Service SID in the request parameter/header is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-13T09:52:58Z',
    last_updated: '2023-12-13T09:52:58Z',
  },
  31930: {
    code: 31930,
    message: 'Stream - Media - Buffer Overflow',
    log_level: 'WARNING',
    secondary_message:
      'Audio is discarded due to a congestion control condition (restricted bandwidth) in the WebSocket upstream',
    log_type: 'APPLICATION',
    docs: '## WARNING - 31930\r\n\r\n### Stream - Media - Buffer Overflow\r\n\r\nAudio is discarded due to a congestion control condition (restricted bandwidth) in the WebSocket upstream \r\n\r\n#### Possible Causes\r\n* The server has an upstream bandwidth restriction\r\n\r\n#### Possible Solutions\r\n* Verify network load',
    causes: '* The server has an upstream bandwidth restriction',
    solutions: '* Verify network load',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:56:23Z',
    last_updated: '2020-08-04T10:00:07.307Z',
  },
  60383: {
    code: 60383,
    message: 'Illegal factor status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60383\r\n\r\n### Illegal factor status\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe requested operation cannot be performed on this Factor because the Factor is in an inconsistent state or has expired.\r\n\r\n#### Possible Solutions\r\nComplete the Factor or re-register the identity.',
    causes:
      'The requested operation cannot be performed on this Factor because the Factor is in an inconsistent state or has expired.',
    solutions: 'Complete the Factor or re-register the identity.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:51:28Z',
    last_updated: '2023-12-27T09:51:28Z',
  },
  13246: {
    code: 13246,
    message: 'Dial: SIP dialing not enabled for this account',
    log_level: 'WARNING',
    secondary_message: 'Your account is not enabled for SIP dialing.',
    log_type: null,
    docs: '## Warning - 13246\n\n### Dial: SIP dialing not enabled for this account.\n\nYour account is not enabled for SIP dialing.\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:07Z',
    last_updated: '2020-08-04T10:00:26.52Z',
  },
  18603: {
    code: 18603,
    message: 'The address could not be verified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18603\r\n\r\n### The address could not be verified\r\n\r\n The address you provided could not be verified.\r\n\r\n#### Possible Causes\r\nThe address is not found in an authoritative address database.\r\n\r\n#### Possible Solutions\r\nPlease feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at trusthub-verify@twilio.com for any additional clarifications.',
    causes: 'The address is not found in an authoritative address database.',
    solutions:
      'Please feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at trusthub-verify@twilio.com for any additional clarifications.',
    description: 'The address you provided could not be verified.',
    product: 'Phone Numbers',
    date_created: '2024-02-22T03:31:40Z',
    last_updated: '2024-04-25T20:40:00.206043Z',
  },
  21612: {
    code: 21612,
    message: 'Message cannot be sent with the current combination of "To" and/or "From" parameters',
    log_level: 'ERROR',
    secondary_message: ' ',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21612\r\n\r\n### Message cannot be sent with the current combination of "To" and/or "From" parameters\r\n\r\n   Message cannot be sent with the current combination of "To" and/or "From" parameters.\r\n\r\n#### Possible Causes\r\n **Sender ID restrictions in the destination country:** Many countries limit which numbers, short-codes, and/or alphanumeric senders can be used in that region. Consult the [SMS guidelines for the destination region](https://www.twilio.com/en-us/guidelines/sms).\r\n\r\n**Sender ID restrictions on the destination network:** Some networks do not support receiving messages from shortcodes, others might allow SMS from shortcodes but cannot receive MMS messages from shortcodes. Similar restrictions may apply to the use of longcodes from countries that do not match the destination country. Consult the [SMS guidelines for the destination region](https://www.twilio.com/en-us/guidelines/sms).\r\n\r\n**Alphanumeric senderIDs:** If you are using an alphanumeric sender ID, the \'To\' number must be in a country where alphanumeric sender IDs are supported. Certain countries require pre-registration of alphanumeric sender IDs. A list of countries where alphanumeric sender ID is supported and whether or not pre-registration is required can be found [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n\r\n**Number formatting:** The format you used for the “To” or “From” number may not be formatted using the [E.164 format](https://www.twilio.com/docs/glossary/what-e164). Twilio standardizes numbers using the E.164 format. If the “To” or “From” number of this message were altered by Twilio in a way that you didn’t expect, try re-submitting the message with E.164 formatted addresses.\r\n\r\n**Destinations where Twilio does not have connectivity:**  It is possible that Twilio does not yet have service with the carrier you are trying to reach. You can lookup the destination network via [the lookup api](https://www.twilio.com/docs/lookup/v2-api).\r\n\r\n#### Possible Solutions\r\nConsult the linked documentation for each cause. You can also try sending again with a different "To" and "From" combination.',
    causes:
      " **Sender ID restrictions in the destination country:** Many countries limit which numbers, short-codes, and/or alphanumeric senders can be used in that region. Consult the [SMS guidelines for the destination region](https://www.twilio.com/en-us/guidelines/sms).\r\n\r\n**Sender ID restrictions on the destination network:** Some networks do not support receiving messages from shortcodes, others might allow SMS from shortcodes but cannot receive MMS messages from shortcodes. Similar restrictions may apply to the use of longcodes from countries that do not match the destination country. Consult the [SMS guidelines for the destination region](https://www.twilio.com/en-us/guidelines/sms).\r\n\r\n**Alphanumeric senderIDs:** If you are using an alphanumeric sender ID, the 'To' number must be in a country where alphanumeric sender IDs are supported. Certain countries require pre-registration of alphanumeric sender IDs. A list of countries where alphanumeric sender ID is supported and whether or not pre-registration is required can be found [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n\r\n**Number formatting:** The format you used for the “To” or “From” number may not be formatted using the [E.164 format](https://www.twilio.com/docs/glossary/what-e164). Twilio standardizes numbers using the E.164 format. If the “To” or “From” number of this message were altered by Twilio in a way that you didn’t expect, try re-submitting the message with E.164 formatted addresses.\r\n\r\n**Destinations where Twilio does not have connectivity:**  It is possible that Twilio does not yet have service with the carrier you are trying to reach. You can lookup the destination network via [the lookup api](https://www.twilio.com/docs/lookup/v2-api).",
    solutions:
      'Consult the linked documentation for each cause. You can also try sending again with a different "To" and "From" combination.',
    description:
      ' Message cannot be sent with the current combination of "To" and/or "From" parameters.',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:26Z',
    last_updated: '2024-05-09T10:47:48.783986Z',
  },
  25009: {
    code: 25009,
    message: "The user's is in an unupdatable status.",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25009\r\n\r\n### The user's is in an unupdatable status.\r\n\r\n The user's is in an unupdatable status.\r\n\r\n#### Possible Causes\r\nThe user cannot be updated because they are currently in an unupdatable status.\r\n\r\n#### Possible Solutions\r\n Verify the current status of the user. If the user is in an unupdatable status, updates may be restricted.",
    causes: 'The user cannot be updated because they are currently in an unupdatable status.',
    solutions:
      ' Verify the current status of the user. If the user is in an unupdatable status, updates may be restricted.',
    description: "The user's is in an unupdatable status.",
    product: 'Organizations API',
    date_created: '2023-12-04T09:56:52Z',
    last_updated: '2023-12-04T14:15:48.590911Z',
  },
  53206: {
    code: 53206,
    message: 'The Participant concurrency quota was exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53206\r\n\r\n### The Participant concurrency quota was exceeded\r\n\r\n ### 53206: The concurrent Participants quota was exceeded\r\n\r\n#### Possible Causes\r\nConnecting another Participant to a Room would exceed the account's concurrent Participants quota\r\n\r\n#### Possible Solutions\r\n * Complete in-progress Rooms to disconnect Participants.\r\n * Disconnect connected Participants.\r\n * Contact support/sales to increase the concurrent Participants quota for your account.",
    causes:
      "Connecting another Participant to a Room would exceed the account's concurrent Participants quota",
    solutions:
      ' * Complete in-progress Rooms to disconnect Participants.\r\n * Disconnect connected Participants.\r\n * Contact support/sales to increase the concurrent Participants quota for your account.',
    description: '### 53206: The concurrent Participants quota was exceeded',
    product: 'Programmable Video',
    date_created: '2020-05-13T23:04:58Z',
    last_updated: '2021-06-08T18:28:13.042Z',
  },
  32207: {
    code: 32207,
    message: 'SIP: Secure media not accepted',
    log_level: 'ERROR',
    secondary_message:
      'Please use RTP. For SIP Trunking if you wish to use SRTP kindly enable [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).',
    log_type: null,
    docs: '## Error - 32207\r\n\r\n###  SIP: Secure media not accepted\r\n\r\n#### Possible Causes\r\n*    A SIP Call is made to a Twilio SIP Domain using SRTP, which it is not supported\r\n*    A termination Call is made to a Twilio SIP Trunk and the Twilio SIP Trunk is not configured to accept secure media (SRTP). \r\n\r\n#### Possible Solutions\r\n*  Please use RTP.\r\n*  For Twilio Elastic SIP Trunking, if you wish to use SRTP kindly enable [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:39Z',
    last_updated: '2020-08-04T10:00:24.14Z',
  },
  60315: {
    code: 60315,
    message: 'Reached max limit of 20 push Factors associated per Entity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60315\r\n\r\n### Reached max limit of 20 push Factors associated per Entity\r\n\r\n * Reached max limit of 20 Factors of `FactorType` = `push` per Entity.\r\n* Reached max limit of 100 Factors of `FactorType` = `totp` per Entity.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\n* You already have 20 `push` Factors created for the Entity.\r\n* You already have 100 `totp` Factors created for the Entity.\r\n\r\n#### Possible Solutions\r\nDelete one of the existing Factors of the same `FactorType` to create a new one.',
    causes:
      '* You already have 20 `push` Factors created for the Entity.\r\n* You already have 100 `totp` Factors created for the Entity.',
    solutions: 'Delete one of the existing Factors of the same `FactorType` to create a new one.',
    description:
      '* Reached max limit of 20 Factors of `FactorType` = `push` per Entity.\r\n* Reached max limit of 100 Factors of `FactorType` = `totp` per Entity.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-06-30T17:09:54Z',
    last_updated: '2021-08-30T20:53:26.887532Z',
  },
  32103: {
    code: 32103,
    message: 'SIP: Empty body',
    log_level: 'WARNING',
    secondary_message: 'The body of the request was empty, which is not allowed in this context.',
    log_type: null,
    docs: '## Error - 32103\n\n###  SIP: Empty body\n\n#### Possible Causes \n*  The body of the request was empty, which is not allowed in this context.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:37Z',
    last_updated: '2020-08-04T10:00:24.353Z',
  },
  70102: {
    code: 70102,
    message: 'Unsupported Public Key Length',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70102\r\n\r\n### Unsupported Public Key Length\r\nThe Request tries to store a Public Key in Twilio. This public key can be parsed, has a correct encryption algorithm, but the request fails because the key has an invalid length.\r\n\r\n#### Possible Causes \r\n* Public key lenght different than 2048.\r\n\r\n#### Possible Solution\r\n* Regenerate a new keypair with length 2048 and retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:50:40Z',
    last_updated: '2020-08-04T10:00:19.85Z',
  },
  57017: {
    code: 57017,
    message: "'Topic' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57017\r\n\r\n### 'Topic' is too long\r\n\r\n Specified 'Topic' is too long\r\n\r\n#### Possible Causes\r\nSpecified 'Topic' is too long\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Topic' is being passed in request. ",
    causes: "Specified 'Topic' is too long",
    solutions: "Confirm a valid 'Topic' is being passed in request. ",
    description: "Specified 'Topic' is too long",
    product: 'Programmable SMS',
    date_created: '2021-06-11T19:06:10Z',
    last_updated: '2021-06-11T19:06:10Z',
  },
  40137: {
    code: 40137,
    message: "Missing 'to' parameter when issuing Conference instruction",
    log_level: 'ERROR',
    secondary_message: ' ',
    log_type: 'APPLICATION',
    docs: '## ERROR - 40137\r\n\r\n### Missing \'to\' parameter when issuing Conference instruction\r\n\r\n  A valid \'to\' parameter must be provided when using the Conference Instruction\r\n\r\n\r\n\r\n#### Possible Causes\r\n- A \'to\' parameter was not passed when issuing the Conference instruction\r\n- The \'to\' parameter supplied to the Conference instruction was invalid\r\n\r\n#### Possible Solutions\r\n* Supply a valid \'to\' parameter when issuing the Conference instruction\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "+18001234567"\r\n}\r\n```',
    causes:
      "- A 'to' parameter was not passed when issuing the Conference instruction\r\n- The 'to' parameter supplied to the Conference instruction was invalid",
    solutions:
      '* Supply a valid \'to\' parameter when issuing the Conference instruction\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "+18001234567"\r\n}\r\n```',
    description:
      "A valid 'to' parameter must be provided when using the Conference Instruction\r\n\r\n",
    product: 'TaskRouter',
    date_created: '2020-08-19T23:07:18Z',
    last_updated: '2020-08-21T00:01:57.962Z',
  },
  30463: {
    code: 30463,
    message: 'Toll Free verification rejection - Disallowed: Stock Alerts/Platforms',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30463\r\n\r\n### Toll Free verification rejection - Disallowed: Stock Alerts/Platforms\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (High-risk financial services: Stock alerts/stock platforms). \r\n\r\nNo businesses that solely operate in stocks, investing, or cryptocurrency are allowed to send SMS traffic. If there is a mixed use case where that is a partial aspect of the business it may be approved based on the other use case content.\r\n\r\nNote, however, that stock platforms are allowed a two-factor authentication (2FA) messaging use case. \r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (High-risk financial services: Stock alerts/stock platforms). \r\n\r\nNo businesses that solely operate in stocks, investing, or cryptocurrency are allowed to send SMS traffic. If there is a mixed use case where that is a partial aspect of the business it may be approved based on the other use case content.\r\n\r\nNote, however, that stock platforms are allowed a two-factor authentication (2FA) messaging use case. ',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:08:59Z',
    last_updated: '2024-02-22T21:08:59Z',
  },
  81017: {
    code: 81017,
    message: 'Error in Twilio Function Response',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81017\r\n\r\n### Error on Twilio Function response\r\nThere was an error in the response back from a Twilio Function attached to the Studio flow.\r\n\r\n#### Possible Causes\r\n* Your Function timed out before responding\r\n* Your Function returned an error response\r\n\r\n#### Possible Solutions\r\n* Your Function must contain a callback.\r\n* Make sure you place the Function callback `callback(err, response)` is placed correctly in your Function code.\r\n * If you are using a JavaScript promise, make sure the callback is called in both success and catch blocks.\r\n* Your Function responded with an error.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-09-19T18:48:09Z',
    last_updated: '2020-08-04T10:00:12.629Z',
  },
  30895: {
    code: 30895,
    message: 'Campaign vetting rejection - Direct Lending - Campaign and Content Attribute Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30895\r\n\r\n### Campaign vetting rejection - Direct Lending - Campaign and Content Attribute Error\r\n\r\n The campaign cannot be approved because it appears to be associated with direct lending or loan arrangement, and the necessary content attribute was not indicated\r\n\r\n#### Possible Causes\r\nThe campaign may involve direct lending or loan arrangements, and this was not accurately reflected in the content attribute during registration.\r\n\r\n#### Possible Solutions\r\n1. Verify Direct Lending Indicated in Campaign Description: If the campaign involves direct lending or loan arrangement or is associated with a financial services organization, ensure "DIRECT LENDING" is mentioned in campaign description. Please mention this even if the specified campaign use case does not directly relate to loan offering (e.g. 2FA).\r\n2. Update Campaign Description if Needed: If the campaign is not related to direct lending or loan arrangement, update the campaign description to reflect the actual content and purpose. If the campaign is related to a financial services organization, update the campaign descripton to contain "DIRECT LENDING".\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign may involve direct lending or loan arrangements, and this was not accurately reflected in the content attribute during registration.',
    solutions:
      '1. Verify Direct Lending Indicated in Campaign Description: If the campaign involves direct lending or loan arrangement or is associated with a financial services organization, ensure "DIRECT LENDING" is mentioned in campaign description. Please mention this even if the specified campaign use case does not directly relate to loan offering (e.g. 2FA).\r\n2. Update Campaign Description if Needed: If the campaign is not related to direct lending or loan arrangement, update the campaign description to reflect the actual content and purpose. If the campaign is related to a financial services organization, update the campaign descripton to contain "DIRECT LENDING".\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign cannot be approved because it appears to be associated with direct lending or loan arrangement, and the necessary content attribute was not indicated',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:42:31Z',
    last_updated: '2023-08-21T13:38:28.86111Z',
  },
  53123: {
    code: 53123,
    message: 'MaxParticipantDuration is out of range',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53123\r\n\r\n### MaxParticipantDuration is out of range\r\n\r\n MaxParticipantDuration is set to a value outside of the acceptable range of 600 seconds (10 minutes) and 86400 seconds (24 hours)\r\n\r\n#### Possible Causes\r\nMaxParticipantDuration is set to a value outside of the acceptable range\r\n\r\n#### Possible Solutions\r\nSet MaxParticipantDuration to a value inside the acceptable range of 600 seconds (10 minutes) and 86400 seconds (24 hours)',
    causes: 'MaxParticipantDuration is set to a value outside of the acceptable range',
    solutions:
      'Set MaxParticipantDuration to a value inside the acceptable range of 600 seconds (10 minutes) and 86400 seconds (24 hours)',
    description:
      'MaxParticipantDuration is set to a value outside of the acceptable range of 600 seconds (10 minutes) and 86400 seconds (24 hours)',
    product: 'Programmable Video',
    date_created: '2022-06-23T02:26:25Z',
    last_updated: '2022-06-23T02:30:23.690564Z',
  },
  90032: {
    code: 90032,
    message: "Broadcast recipient's 'to' is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90032\r\n\r\n### Broadcast recipient's 'to' is invalid\r\n\r\n Broadcast recipient's 'to' is invalid\r\n\r\n#### Possible Causes\r\nBroadcast recipient's 'to' has invalid format. For instance, colon is missing.\r\n\r\n#### Possible Solutions\r\nUse correct 'to' (\"channel:address\") for recipient object",
    causes: "Broadcast recipient's 'to' has invalid format. For instance, colon is missing.",
    solutions: 'Use correct \'to\' ("channel:address") for recipient object',
    description: "Broadcast recipient's 'to' is invalid",
    product: null,
    date_created: '2020-12-11T13:26:17Z',
    last_updated: '2020-12-11T13:29:16.367Z',
  },
  81006: {
    code: 81006,
    message: 'Failed to create Chat Channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81006\r\n\r\n### Failed to create Chat Channel\r\nStudio was unable to create the Chat Channel while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Chat API failed.\r\n* Invalid values were passed to the Chat API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:15:14Z',
    last_updated: '2020-08-04T10:00:13.194Z',
  },
  50202: {
    code: 50202,
    message: 'Programmable Chat: User SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required User SID parameter.',
    log_type: null,
    docs: '## Error - 50202\r\n\r\n### Programmable Chat: User SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required User SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:48Z',
    last_updated: '2020-08-04T10:00:23.303Z',
  },
  11236: {
    code: 11236,
    message: 'Certificate Invalid - Certificate Expired',
    log_level: 'ERROR',
    secondary_message:
      'Twilio tried to validate your SSL certificate but your certificate has expired.',
    log_type: null,
    docs: '## Error - 11236\n\n### Certificate Invalid - Certificate Expired\n\nTwilio tried to validate your SSL certificate but your certificate has expired.\n\n#### Possible Causes\n*  Your SSL certificate has expired.\n\n#### Possible Solutions\n*  Renew your SSL certificate.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:25Z',
    last_updated: '2020-08-04T10:00:29.41Z',
  },
  52213: {
    code: 52213,
    message: 'Invalid Alexa user ID',
    log_level: 'ERROR',
    secondary_message: 'The message has been rejected by Alexa channel due to an invalid User ID',
    log_type: null,
    docs: '## Error 52213\r\n\r\n### Invalid Alexa user ID\r\n\r\nThe message has been rejected by Alexa channel due to an invalid User ID. This specific message has not been sent.\r\n\r\n### Possible causes\r\n- The user ID (Address) in a Notify Binding was invalid\r\n\r\n### Possible solutions\r\n- Make sure that you do not modify the user ID before creating the Binding. \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-06-22T15:23:19Z',
    last_updated: '2020-08-04T10:00:18.219Z',
  },
  80913: {
    code: 80913,
    message: 'Out-Of-Session Callback Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80913\r\n\r\n### Out-Of-Session Callback Error\r\n\r\n Callback to Out-of-Session handler returned a non-success status code.\r\n\r\n#### Possible Causes\r\n* Your Out-of-Session callback URL is invalid.\r\n\r\n#### Possible Solutions\r\n* Verify that your Out-of-Session callback URL is valid and that your server is correctly processing Out-of-Session callbacks from Proxy.\r\n* Please read over the [Out-Of-Session Callback guide] (https://www.twilio.com/docs/proxy/out-session-callback-response-guide) for more detailed information.',
    causes: '* Your Out-of-Session callback URL is invalid.',
    solutions:
      '* Verify that your Out-of-Session callback URL is valid and that your server is correctly processing Out-of-Session callbacks from Proxy.\r\n* Please read over the [Out-Of-Session Callback guide] (https://www.twilio.com/docs/proxy/out-session-callback-response-guide) for more detailed information.',
    description: 'Callback to Out-of-Session handler returned a non-success status code.',
    product: 'Proxy',
    date_created: '2019-06-17T17:49:15Z',
    last_updated: '2020-08-04T10:00:07.872Z',
  },
  30729: {
    code: 30729,
    message: 'Brand Registration Failure: Country code not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30729\r\n\r\n### Brand Registration Failure: Country code not allowed\r\n\r\n Provided country code has been blacklisted and is not allowed for US A2P Brand registrations.\r\n\r\n#### Possible Causes\r\nProvided country code has been blacklisted and is not allowed for US A2P Brand registrations. Supported list of country codes are : PR,PS,PT,PW,PY,QA,AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,RE,AU,AW,AX,AZ,RO,BA,BB,RS,BD,RU,BE,BF,BG,RW,BH,BI,BJ,BL,BM,BN,BO,SA,SB,BQ,SC,BR,BS,SD,SE,BT,SG,BV,SH,BW,SI,SJ,BY,BZ,SK,SL,SM,SN,SO,CA,SR,CC,SS,ST,CD,CF,SV,CG,SX,CH,CI,SZ,CK,CL,CM,CN,CO,CR,TC,TD,TF,TG,CV,CW,TH,CX,TJ,CY,TK,CZ,TL,TM,TN,TO,TR,TT,DE,TV,TW,DJ,TZ,DK,DM,DO,UA,UG,DZ,UM,EC,US,EE,EG,EH,UY,UZ,VA,ER,VC,ES,VE,ET,VG,VI,VN,VU,FI,FJ,FK,FM,FO,FR,WF,GA,GB,WS,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,XE,GU,GW,GY,XK,HK,HM,HN,HR,YE,HT,HU,YT,ID,IE,IL,IM,IN,IO,ZA,IQ,IS,IT,ZM,JE,ZW,JM,JO,JP,KE,KG,KH,KI,KM,KN,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN\r\n\r\n#### Possible Solutions\r\nPlease use a supported country for brand registrations.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    causes:
      'Provided country code has been blacklisted and is not allowed for US A2P Brand registrations. Supported list of country codes are : PR,PS,PT,PW,PY,QA,AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,RE,AU,AW,AX,AZ,RO,BA,BB,RS,BD,RU,BE,BF,BG,RW,BH,BI,BJ,BL,BM,BN,BO,SA,SB,BQ,SC,BR,BS,SD,SE,BT,SG,BV,SH,BW,SI,SJ,BY,BZ,SK,SL,SM,SN,SO,CA,SR,CC,SS,ST,CD,CF,SV,CG,SX,CH,CI,SZ,CK,CL,CM,CN,CO,CR,TC,TD,TF,TG,CV,CW,TH,CX,TJ,CY,TK,CZ,TL,TM,TN,TO,TR,TT,DE,TV,TW,DJ,TZ,DK,DM,DO,UA,UG,DZ,UM,EC,US,EE,EG,EH,UY,UZ,VA,ER,VC,ES,VE,ET,VG,VI,VN,VU,FI,FJ,FK,FM,FO,FR,WF,GA,GB,WS,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,XE,GU,GW,GY,XK,HK,HM,HN,HR,YE,HT,HU,YT,ID,IE,IL,IM,IN,IO,ZA,IQ,IS,IT,ZM,JE,ZW,JM,JO,JP,KE,KG,KH,KI,KM,KN,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN',
    solutions:
      'Please use a supported country for brand registrations.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    description:
      'Provided country code has been blacklisted and is not allowed for US A2P Brand registrations.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:39:26Z',
    last_updated: '2024-02-13T16:16:14.738614Z',
  },
  81005: {
    code: 81005,
    message: 'Failed to transition because no match was found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 81005\r\n\r\n### Failed to transition because no match was found\r\nStudio was unable to transition to the next widget because no matching transition was found in the Split widget.\r\n\r\n#### Possible Causes\r\n* Missing values in the match field.\r\n* Match field is in the wrong format.\r\n* Regular expression is too restrictive.\r\n\r\n#### Possible Solutions\r\n* Check the values that you’re matching against in the Split widget.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:14:59Z',
    last_updated: '2020-08-04T10:00:13.212Z',
  },
  52167: {
    code: 52167,
    message: 'Invalid Webhook Credentials response',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52167\r\n\r\n### Invalid Webhook Credentials response\r\n\r\n#### Possible Causes \r\n*  Your Webhook Credentials response did not adhere to the required schema\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credentials response is correct',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T12:01:11Z',
    last_updated: '2020-08-04T10:00:14.269Z',
  },
  14202: {
    code: 14202,
    message: 'Enqueue: Invalid waitUrl',
    log_level: 'ERROR',
    secondary_message:
      'The waitUrl for the Enqueue verb is invalid.  #### Possible Solutions  Make sure you submit a fully qualified URL including:  *   protocol (http:// or https://) *   hostname *   file path *   properly url-encoded query parameters  Twilio must be able to reach this URL over the public Internet.',
    log_type: null,
    docs: '## Error - 14202\n\n### Enqueue: Invalid waitUrl\n\nThe waitUrl for the Enqueue verb is invalid.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:10Z',
    last_updated: '2020-08-04T10:00:26.329Z',
  },
  32603: {
    code: 32603,
    message: 'Virtual Agent: Unsupported <Config> attribute(s) in TwiML',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32603\r\n\r\n### Virtual Agent: Unsupported <Config> attribute(s) in TwiML\r\n\r\n A 32603 Error is an indication that &lt;VirtualAgent&gt; TwiML contains invalid or unsupported &lt;Config&gt; attributes\r\n\r\n#### Possible Causes\r\n* Some of the &lt;Config&gt; attribute(s) referenced in the &lt;VirtualAgent&gt; TwiML are not supported by the VirtualAgent provider. \r\n\r\n#### Possible Solutions\r\n* Ensure the correct &lt;VirtualAgent&gt; connector is being referenced\r\n* Review the Debugger message in console and update or remove the offending attributes',
    causes:
      '* Some of the &lt;Config&gt; attribute(s) referenced in the &lt;VirtualAgent&gt; TwiML are not supported by the VirtualAgent provider. ',
    solutions:
      '* Ensure the correct &lt;VirtualAgent&gt; connector is being referenced\r\n* Review the Debugger message in console and update or remove the offending attributes',
    description:
      'A 32603 Error is an indication that &lt;VirtualAgent&gt; TwiML contains invalid or unsupported &lt;Config&gt; attributes',
    product: 'Programmable Voice',
    date_created: '2022-08-04T01:23:38Z',
    last_updated: '2022-08-04T01:23:38Z',
  },
  62021: {
    code: 62021,
    message: 'IP Gateway Invalid',
    log_level: 'ERROR',
    secondary_message:
      'The request provided an invalid gateway IP address. Request must provide a valid IP address not in the RFC 1918 range.',
    log_type: null,
    docs: '## Error - 62021\r\n\r\n### IP Gateway Invalid\r\n\r\nThe request provided an invalid gateway IP address. Request must provide a valid IP address not in the RFC 1918 range.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:47:11Z',
    last_updated: '2020-08-04T10:00:20.808Z',
  },
  21619: {
    code: 21619,
    message: 'A Message Body, Media URL or Content SID is required',
    log_level: 'ERROR',
    secondary_message: 'A Message Body, Media URL or Content SID is required',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21619\r\n\r\n### A Message Body, Media URL or Content SID is required\r\n\r\nA Message Body, Media URL or Content SID is required A Message Body, Media URL or Content SID is required\r\n\r\n#### Possible Causes\r\nYou are sending a message using a Messaging Service without specifying a `Body`,`Media URL` or `Content SID`.\r\n\r\n#### Possible Solutions\r\n* Ensure you are specifying the correct API Parameters when sending your message.\r\n* If you are using Content Templates, you need to specify a [Content SID](https://www.twilio.com/docs/content/send-templates-created-with-the-content-template-builder), otherwise you will need to send a [“Body” and/or “Media URL”](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource).\r\n',
    causes:
      'You are sending a message using a Messaging Service without specifying a `Body`,`Media URL` or `Content SID`.',
    solutions:
      '* Ensure you are specifying the correct API Parameters when sending your message.\r\n* If you are using Content Templates, you need to specify a [Content SID](https://www.twilio.com/docs/content/send-templates-created-with-the-content-template-builder), otherwise you will need to send a [“Body” and/or “Media URL”](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource).\r\n',
    description: 'A Message Body, Media URL or Content SID is required',
    product: 'Programmable SMS',
    date_created: '2018-07-05T18:04:49Z',
    last_updated: '2024-05-29T14:19:54.78989Z',
  },
  50514: {
    code: 50514,
    message: 'Conflicting message modification',
    log_level: 'ERROR',
    secondary_message:
      'The requested message is already being modified by a concurrent API request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50514\r\n\r\n### Conflicting message modification\r\n\r\nThe requested message is already being modified by a concurrent API request. The requested message is already being modified in this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.\r\n\r\n#### Possible Causes\r\n* You might be submitting multiple concurrent requests to modify a message or its attributes with the same SID in the service instance.\r\n\r\n#### Possible Solutions\r\n* Implement an operation retrier and repeat the failed API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when modifying a message. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that modify conversation messages. Wait until the original request completes and returns an API response, before sending any successive conversation requests.',
    causes:
      '* You might be submitting multiple concurrent requests to modify a message or its attributes with the same SID in the service instance.',
    solutions:
      '* Implement an operation retrier and repeat the failed API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when modifying a message. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that modify conversation messages. Wait until the original request completes and returns an API response, before sending any successive conversation requests.',
    description:
      'The requested message is already being modified in this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.',
    product: 'Conversations',
    date_created: '2024-01-10T22:42:18Z',
    last_updated: '2024-01-17T15:41:23.648258Z',
  },
  11216: {
    code: 11216,
    message: 'HTTP invalid redirect',
    log_level: 'ERROR',
    secondary_message: 'The response from your server contained an invalid redirect.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 11216\r\n\r\n### HTTP invalid redirect\r\n\r\nThe response from your server contained an invalid redirect. Twilio sent a webhook to your server and your server responded with a 3xx status code that was not a valid redirect.\r\n\r\n#### Possible Causes\r\n* Your server responded with an non-redirect HTTP status code in the 3xx series. Twilio will only follow redirects for status codes 301, 302, 303, and 307.\r\n* Your server did not include a location header in the redirect response\r\n\r\n#### Possible Solutions\r\n* Update your webhook configuration specifying the final URL you would like to be called, removing the need for redirects.\r\n* Ensure you are using a standard redirect HTTP status code (301, 302, 303, or 307)\r\n* Ensure that you are including a valid url in the location header of your response.',
    causes:
      '* Your server responded with an non-redirect HTTP status code in the 3xx series. Twilio will only follow redirects for status codes 301, 302, 303, and 307.\r\n* Your server did not include a location header in the redirect response',
    solutions:
      '* Update your webhook configuration specifying the final URL you would like to be called, removing the need for redirects.\r\n* Ensure you are using a standard redirect HTTP status code (301, 302, 303, or 307)\r\n* Ensure that you are including a valid url in the location header of your response.',
    description:
      'Twilio sent a webhook to your server and your server responded with a 3xx status code that was not a valid redirect.',
    product: null,
    date_created: '2023-10-04T07:53:56Z',
    last_updated: '2023-10-04T12:43:07.463366Z',
  },
  20153: {
    code: 20153,
    message: 'Invalid Issuer Or Subject',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20153 \r\n\r\n### Invalid Issuer Or Subject\r\nThe issuer or subject of the JWT provided to the Twilio API was invalid.\r\n\r\n#### Possible Causes \r\n* The issuer is missing from JWT\r\n* The issuer entity is suspended in Twilio.\r\n* The subject is missing from JWT\r\n* The subject entity is suspended in Twilio.\r\n* The issuer and subject are not related.\r\n\r\n#### Possible Solution:\r\n* In case of Public Key Client Validation, make sure the account and the API key are valid and not suspended.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:05:37Z',
    last_updated: '2020-08-04T10:00:19.095Z',
  },
  53626: {
    code: 53626,
    message: 'Internal failure while processing media composition',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 53626\r\n\r\n### Internal failure while processing media composition\r\n\r\nRaised when an internal error prevents us from processing the media composition.\r\n\r\n#### Causes\r\n\r\n * We screwed up. Sorry!\r\n\r\n#### Solutions\r\n\r\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n*   Note the time of the error and what you were trying to do when it occurred!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-25T10:20:16Z',
    last_updated: '2020-08-04T10:00:13.38Z',
  },
  60404: {
    code: 60404,
    message: 'Input Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60404\r\n\r\n### Input Error\r\n\r\n An error occurred while loading input.\r\n\r\n#### Possible Causes\r\nSome inputs are invalid.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'Some inputs are invalid.',
    solutions: 'Check parameters and retry.',
    description: 'An error occurred while loading input.',
    product: 'Verify',
    date_created: '2021-03-15T20:45:25Z',
    last_updated: '2021-03-15T20:45:25Z',
  },
  53664: {
    code: 53664,
    message: 'Invalid URL for external S3 bucket in composition settings',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53664\r\n\r\n### Invalid URL for external S3 bucket in composition settings\r\n\r\n The S3 bucket URL configured in your account's composition settings is not valid.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.\r\n\r\n#### Possible Causes\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Possible Solutions\r\n * In the composition settings section of your account's console, set a valid S3 URL for uploading media or disable the external storage (media will be uploaded to the default bucket).",
    causes:
      ' * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.',
    solutions:
      " * In the composition settings section of your account's console, set a valid S3 URL for uploading media or disable the external storage (media will be uploaded to the default bucket).",
    description:
      "The S3 bucket URL configured in your account's composition settings is not valid.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.",
    product: 'Programmable Video',
    date_created: '2021-04-13T07:25:48Z',
    last_updated: '2021-04-13T07:25:48Z',
  },
  50105: {
    code: 50105,
    message: 'Programmable Chat: Invalid role type',
    log_level: 'ERROR',
    secondary_message: 'Specified Role Type does not exist.',
    log_type: null,
    docs: '## Error - 50105\r\n\r\n### Programmable Chat: Invalid role type\t\r\n\r\n#### Possible Causes \r\n*  Specified Role Type does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role Type is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:47Z',
    last_updated: '2020-08-04T10:00:23.398Z',
  },
  50528: {
    code: 50528,
    message: 'Content SID is missing',
    log_level: 'ERROR',
    secondary_message: 'Message content variables are defined without a proper content sid',
    log_type: 'TWILIO',
    docs: '## ERROR - 50528\r\n\r\n### Content SID is missing\r\n\r\nMessage content variables are defined without a proper content sid Message content variables are defined without a proper content sid\r\n\r\n#### Possible Causes\r\nContent variables are present but there is no content sid defined\r\n\r\n#### Possible Solutions\r\nMessage content sid should be present along with content variables',
    causes: 'Content variables are present but there is no content sid defined',
    solutions: 'Message content sid should be present along with content variables',
    description: 'Message content variables are defined without a proper content sid',
    product: 'Conversations',
    date_created: '2022-11-23T13:35:50Z',
    last_updated: '2022-11-23T13:35:50Z',
  },
  30007: {
    code: 30007,
    message: 'Message filtered',
    log_level: 'ERROR',
    secondary_message: 'Your message content was flagged as going against carrier guidelines.',
    log_type: 'CARRIER',
    docs: "## ERROR - 30007\r\n\r\n### Message filtered\r\n\r\nYour message content was flagged as going against carrier guidelines. Your message was filtered (blocked) by Twilio or by the carrier. This may be done by Twilio for violating Twilio’s [Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy) or [Acceptable Use Policy](https://www.twilio.com/en-us/legal/aup), or by a wireless carrier for violating carrier rules or regulations.\r\n\r\nExamples of messaging that would be blocked by Twilio are spam, phishing, and fraud. Twilio’s filtering system is in place to protect mobile subscribers from spam or other forms of malicious or unwanted messages.\r\n\r\nWireless carriers have filtering systems in place as well. These carrier filters are used to block abusive traffic, as well as to enforce rules or regulations about what types of messaging are allowed to that country or mobile network.\r\n\r\nLearn more about how message filtering works and how to avoid it: [How Does Message Filtering Work?](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-)\r\n\r\nFor a detailed explanation of carrier filtering in the United States and Canada, please see [SMS Carrier Filtering in the United States and Canada](https://support.twilio.com/hc/en-us/articles/360022449893-SMS-Carrier-Filtering-in-the-United-States-and-Canada).\r\n\r\n#### Possible Causes\r\n* Your message was identified as spam or unwanted messaging by Twilio's message filtering system\r\n* Your message was flagged as objectionable and blocked by a wireless carrier\r\n\r\n#### Possible Solutions\r\n* Ensure your messaging use case complies with Twilio's [Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy) and [Acceptable Use Policy](https://www.twilio.com/en-us/legal/aup)\r\n* Review the information in [How Does Message Filtering Work?](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-) to understand what causes filtering.\r\n* See [How do I prevent my Twilio messages from being filtered (blocked)?](https://support.twilio.com/hc/en-us/articles/1260803966670-How-do-I-prevent-my-Twilio-messages-from-being-filtered-blocked-) for specific tips on avoiding message filtering.\r\n* If you believe your messages are compliant with Twilio and carrier policies, please collect 3 or more examples of Message SIDs that have the “undelivered” status with error 30007, and then [contact our Support team](https://www.twilio.com/console/support/tickets/create). We can help review your messaging and determine if an error was made, and put you in touch with our Compliance team if needed.",
    causes:
      "* Your message was identified as spam or unwanted messaging by Twilio's message filtering system\r\n* Your message was flagged as objectionable and blocked by a wireless carrier",
    solutions:
      "* Ensure your messaging use case complies with Twilio's [Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy) and [Acceptable Use Policy](https://www.twilio.com/en-us/legal/aup)\r\n* Review the information in [How Does Message Filtering Work?](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-) to understand what causes filtering.\r\n* See [How do I prevent my Twilio messages from being filtered (blocked)?](https://support.twilio.com/hc/en-us/articles/1260803966670-How-do-I-prevent-my-Twilio-messages-from-being-filtered-blocked-) for specific tips on avoiding message filtering.\r\n* If you believe your messages are compliant with Twilio and carrier policies, please collect 3 or more examples of Message SIDs that have the “undelivered” status with error 30007, and then [contact our Support team](https://www.twilio.com/console/support/tickets/create). We can help review your messaging and determine if an error was made, and put you in touch with our Compliance team if needed.",
    description:
      'Your message was filtered (blocked) by Twilio or by the carrier. This may be done by Twilio for violating Twilio’s [Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy) or [Acceptable Use Policy](https://www.twilio.com/en-us/legal/aup), or by a wireless carrier for violating carrier rules or regulations.\r\n\r\nExamples of messaging that would be blocked by Twilio are spam, phishing, and fraud. Twilio’s filtering system is in place to protect mobile subscribers from spam or other forms of malicious or unwanted messages.\r\n\r\nWireless carriers have filtering systems in place as well. These carrier filters are used to block abusive traffic, as well as to enforce rules or regulations about what types of messaging are allowed to that country or mobile network.\r\n\r\nLearn more about how message filtering works and how to avoid it: [How Does Message Filtering Work?](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-)\r\n\r\nFor a detailed explanation of carrier filtering in the United States and Canada, please see [SMS Carrier Filtering in the United States and Canada](https://support.twilio.com/hc/en-us/articles/360022449893-SMS-Carrier-Filtering-in-the-United-States-and-Canada).',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:35Z',
    last_updated: '2023-07-31T21:44:35.506325Z',
  },
  18012: {
    code: 18012,
    message: 'Invalid business registration number.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18012\r\n\r\n### Invalid business registration number.\r\n\r\n Business registration number does not match with the local \r\ncompany register or the excerpt from the commercial register that you may have submitted. \r\n\r\n#### Possible Causes\r\nThe submitted business registration number does not align with the domestic company register or excerpt from the commercial register\r\n\r\n#### Possible Solutions\r\nPlease resubmit with the accurate business registration number to ensure it matches the local company register or commercial register.',
    causes:
      'The submitted business registration number does not align with the domestic company register or excerpt from the commercial register',
    solutions:
      'Please resubmit with the accurate business registration number to ensure it matches the local company register or commercial register.',
    description:
      'Business registration number does not match with the local \r\ncompany register or the excerpt from the commercial register that you may have submitted. ',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:04:04Z',
    last_updated: '2024-07-04T10:04:04Z',
  },
  22403: {
    code: 22403,
    message: 'Phone Number Operation not permitted within Region',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 22403\r\n\r\n### Phone Number Operation not permitted within Region\r\n\r\n Phone Number update operation is not permitted within the Region.\r\n\r\n#### Possible Causes\r\nCertain Phone Number operations are not permitted within this Region emergency services\r\n\r\n#### Possible Solutions\r\nPlease refer to documentation to understand which operations are permitted within each region.',
    causes:
      'Certain Phone Number operations are not permitted within this Region emergency services',
    solutions:
      'Please refer to documentation to understand which operations are permitted within each region.',
    description: 'Phone Number update operation is not permitted within the Region.',
    product: 'Phone Numbers',
    date_created: '2022-04-26T14:13:12Z',
    last_updated: '2022-04-26T14:13:12Z',
  },
  45381: {
    code: 45381,
    message: 'Failed to activate Channel. Downstream error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45381\r\n\r\n### Failed to activate Channel. Downstream error.\r\n\r\n Failed to activate a Channel <channel sid> due to an error from Twilio Conversations API.\r\n\r\n#### Possible Causes\r\nConversations API returned an error\r\n\r\n#### Possible Solutions\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'Conversations API returned an error',
    solutions:
      'Check our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to activate a Channel <channel sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2023-08-28T21:56:43Z',
    last_updated: '2023-08-28T21:56:43Z',
  },
  22400: {
    code: 22400,
    message: 'Phone Number linked to Active Route Configuration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 22400\r\n\r\n### Phone Number linked to Active Route Configuration\r\n\r\n Phone Number linked to Active Route Configuration.\r\n\r\n#### Possible Causes\r\nPhone Number linked to Active Route Configuration.\r\n\r\n#### Possible Solutions\r\nPlease contact Twilio Support either via the [Console](https://console.twilio.com) or the [Help Center](https://support.twilio.com) to request assistance with deleting the Active Route Configuration for an inactive phone number reference.',
    causes: 'Phone Number linked to Active Route Configuration.',
    solutions:
      'Please contact Twilio Support either via the [Console](https://console.twilio.com) or the [Help Center](https://support.twilio.com) to request assistance with deleting the Active Route Configuration for an inactive phone number reference.',
    description: 'Phone Number linked to Active Route Configuration.',
    product: 'Phone Numbers',
    date_created: '2022-04-26T14:07:18Z',
    last_updated: '2023-11-04T00:45:20.272233Z',
  },
  50058: {
    code: 50058,
    message: 'Programmable Chat: Notification template too long',
    log_level: 'ERROR',
    secondary_message: 'Specified notification template parameter is too long',
    log_type: null,
    docs: '## Error - 50058\r\n\r\n### Programmable Chat: Notification template too long\r\n\r\n#### Possible Causes \r\n*  Specified notification template parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length notification template is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-10-30T13:04:16Z',
    last_updated: '2020-08-04T10:00:16.807Z',
  },
  14111: {
    code: 14111,
    message: 'Invalid To phone number for Trial mode',
    log_level: 'WARNING',
    secondary_message: 'To field must be a validated caller ID while in Trial mode',
    log_type: null,
    docs: "## Warning - 14111\n\n### Invalid To phone number for Trial mode\n\n'To' field must be a validated caller ID while in Trial mode\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:50Z',
    last_updated: '2020-08-04T10:00:27.483Z',
  },
  30896: {
    code: 30896,
    message: 'Campaign vetting rejection - Opt-in Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30896\r\n\r\n### Campaign vetting rejection - Opt-in Error\r\n\r\n The campaign submission has been reviewed and it was rejected because of provided Opt-in information.\r\n\r\n#### Possible Causes\r\n* Opt-in message workflow does not meet the requirements for the specific campaign type.\r\n* Consent is required but not adequately provided or maintained.\r\n* Opt-in information is shared with third-party entities.\r\n\r\n#### Possible Solutions\r\n1. Ensure compliance with Twilio Messaging Policy relating to opt-in\r\n2. Detail All Opt-in Methods: Include all methods of opt-in, whether electronic, paper form, in-person verbal opt-in, or other means.\r\n3. Provide Necessary Links and Documentation: If opt-in is collected through a paper form or behind a login, supply a hosted link to an image of the opt-in. If the opt-in occurs on a website, provide the relevant link.\r\n4. Include Privacy Policy and Terms of Service: The website where opt-in occurs must contain a privacy policy and terms of service.\r\n5. Avoid Third-Party Sharing: Make sure that opt-in information is not shared with unauthorized third parties.\r\n6. Ensure Opt-in is Verifable: Each campaign is manually reviewed and needs to be verifable by a human.\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\n \r\nAdditional help resources\r\n\r\n* [CTIA Guidelines]( https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      '* Opt-in message workflow does not meet the requirements for the specific campaign type.\r\n* Consent is required but not adequately provided or maintained.\r\n* Opt-in information is shared with third-party entities.',
    solutions:
      '1. Ensure compliance with Twilio Messaging Policy relating to opt-in\r\n2. Detail All Opt-in Methods: Include all methods of opt-in, whether electronic, paper form, in-person verbal opt-in, or other means.\r\n3. Provide Necessary Links and Documentation: If opt-in is collected through a paper form or behind a login, supply a hosted link to an image of the opt-in. If the opt-in occurs on a website, provide the relevant link.\r\n4. Include Privacy Policy and Terms of Service: The website where opt-in occurs must contain a privacy policy and terms of service.\r\n5. Avoid Third-Party Sharing: Make sure that opt-in information is not shared with unauthorized third parties.\r\n6. Ensure Opt-in is Verifable: Each campaign is manually reviewed and needs to be verifable by a human.\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\n \r\nAdditional help resources\r\n\r\n* [CTIA Guidelines]( https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because of provided Opt-in information.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:43:14Z',
    last_updated: '2023-08-21T19:38:30.24003Z',
  },
  63006: {
    code: 63006,
    message:
      'Could not format given content for the channel. Please see Channel specific error message for more information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Could not format given content for the Channel\r\n\r\n#### Possible Causes \r\n*   Incorrect format.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:20:54Z',
    last_updated: '2020-08-04T10:00:14.488Z',
  },
  80502: {
    code: 80502,
    message: 'Internal Server Error from Downstream',
    log_level: 'ERROR',
    secondary_message: 'A downstream server failed or refused to process a request.',
    log_type: null,
    docs: '## Error\r\n\r\n### Internal Server Error from Downstream\r\n\r\nA downstream server failed or refused to process a request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-10-05T03:12:52Z',
    last_updated: '2020-08-04T10:00:12.292Z',
  },
  63029: {
    code: 63029,
    message: 'The receiver failed to download the template',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 63029\r\n\r\n### The receiver failed to download the template\r\n\r\n The receiver failed to download the template\r\n\r\n\r\n#### Possible Causes\r\nThe receiver failed to download the template\r\n\r\n#### Possible Solutions\r\nPlease check your destination number/handset and retry the number',
    causes: 'The receiver failed to download the template',
    solutions: 'Please check your destination number/handset and retry the number',
    description: 'The receiver failed to download the template\r\n',
    product: 'Programmable SMS',
    date_created: '2019-05-16T19:09:54Z',
    last_updated: '2020-08-04T10:00:08.639Z',
  },
  52311: {
    code: 52311,
    message: 'Delivery callback invocation failed',
    log_level: 'ERROR',
    secondary_message: 'Notify is unable to invoke the given callback',
    log_type: 'TWILIO',
    docs: '## ERROR - 52311\r\n\r\n### Delivery callback invocation failed\r\n\r\nNotify is unable to invoke the given callback \r\n\r\n#### Possible Causes\r\nInvalid callback URL or Internal Server Error\r\n\r\n#### Possible Solutions\r\nCheck the callback URL',
    causes: 'Invalid callback URL or Internal Server Error',
    solutions: 'Check the callback URL',
    description: null,
    product: 'Notify',
    date_created: '2019-11-21T14:30:38Z',
    last_updated: '2020-08-04T10:00:05.976Z',
  },
  30906: {
    code: 30906,
    message: 'Campaign Rejected by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30906\r\n\r\n### Campaign Rejected by Twilio\r\n\r\n Messaging Service could not be attached to the Campaign because Twilio's DCA declined the Campaign due to compliance violations.\r\n\r\n#### Possible Causes\r\n* Twilio identified compliance violations during the review process. The specific reason for rejection is provided in the CAMPAIGN_SHARE_DELETE webhook from TCR.\r\n\r\n#### Possible Solutions\r\n* Revise the Campaign details to address the compliance issues and re-share the Campaign with Twilio's DCA for another review.\r\n* For further clarification and resolution, contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n* [Changes to Externally Registered Campaign Submission](https://support.twilio.com/hc/en-us/articles/13097615242395-Changes-to-Externally-Registered-Campaign-Submission)",
    causes:
      '* Twilio identified compliance violations during the review process. The specific reason for rejection is provided in the CAMPAIGN_SHARE_DELETE webhook from TCR.',
    solutions:
      "* Revise the Campaign details to address the compliance issues and re-share the Campaign with Twilio's DCA for another review.\r\n* For further clarification and resolution, contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n* [Changes to Externally Registered Campaign Submission](https://support.twilio.com/hc/en-us/articles/13097615242395-Changes-to-Externally-Registered-Campaign-Submission)",
    description:
      "Messaging Service could not be attached to the Campaign because Twilio's DCA declined the Campaign due to compliance violations.",
    product: 'Programmable Messaging',
    date_created: '2023-10-23T14:05:05Z',
    last_updated: '2023-10-23T14:05:05Z',
  },
  93101: {
    code: 93101,
    message: 'Unable to deliver events to sink',
    log_level: 'ERROR',
    secondary_message:
      'The sink you are using for your Event Streams subscription is having issues',
    log_type: 'APPLICATION',
    docs: '## ERROR - 93101\r\n\r\n### Unable to deliver events to sink\r\n\r\nThe sink you are using for your Event Streams subscription is having issues There is an issue with sending event to your sink\r\n\r\n#### Possible Causes\r\nSee the error message for more details\r\n\r\n#### Possible Solutions\r\nVerify that your sink destination is up and has not changed',
    causes: 'See the error message for more details',
    solutions: 'Verify that your sink destination is up and has not changed',
    description: 'There is an issue with sending event to your sink',
    product: 'Events',
    date_created: '2021-01-13T18:25:56Z',
    last_updated: '2021-02-04T17:11:13.707Z',
  },
  20156: {
    code: 20156,
    message: 'Expired or Invalid Expiration in Token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20156\r\n\r\n### Expired or Invalid Expiration in Token\r\nThe JWT provided to the Twilio API has expired, or the expiration time specified in the JWT was invalid.\r\n\r\n\r\n#### Possible Causes \r\n* The client system that generates the JWT might have issues with system time.\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:12:14Z',
    last_updated: '2020-08-04T10:00:19.023Z',
  },
  45794: {
    code: 45794,
    message: 'Max deployment keys limit reached for this account.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45794\r\n\r\n### Max deployment keys limit reached for this account.\r\n\r\n Max deployment keys limit reached for this account.\r\n\r\n#### Possible Causes\r\nAccount already has maximum allowed number of deployment keys.\r\n\r\n#### Possible Solutions\r\nDelete any of the existing deployment key to create more.',
    causes: 'Account already has maximum allowed number of deployment keys.',
    solutions: 'Delete any of the existing deployment key to create more.',
    description: 'Max deployment keys limit reached for this account.',
    product: 'Flex',
    date_created: '2023-11-23T04:23:48Z',
    last_updated: '2023-11-23T04:23:48Z',
  },
  30040: {
    code: 30040,
    message: 'Destination carrier requires Sender ID pre-registration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30040\r\n\r\n### Destination carrier requires Sender ID pre-registration\r\n\r\n You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Alphanumeric Sender ID pre-registration, and the Sender ID you used is not registered to your account.\r\n\r\n#### Possible Causes\r\n* The recipient you are sending a message to is on a network that requires Alphanumeric Sender ID pre-registration, and our records indicate that your Sender ID is not registered.\r\n* You may have previously received a WARNING 30018 “Destination carrier requires Sender ID pre-registration” code. This is the corresponding ERROR version of that code when a block is indeed happening.\r\n\r\n#### Possible Solutions\r\n* Learn more about Alpha Sender ID registration requirements [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Use [this form](https://twiliodoer.secure.force.com/SenderId) to register a Sender ID for the destination country.',
    causes:
      '* The recipient you are sending a message to is on a network that requires Alphanumeric Sender ID pre-registration, and our records indicate that your Sender ID is not registered.\r\n* You may have previously received a WARNING 30018 “Destination carrier requires Sender ID pre-registration” code. This is the corresponding ERROR version of that code when a block is indeed happening.',
    solutions:
      '* Learn more about Alpha Sender ID registration requirements [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Use [this form](https://twiliodoer.secure.force.com/SenderId) to register a Sender ID for the destination country.',
    description:
      'You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Alphanumeric Sender ID pre-registration, and the Sender ID you used is not registered to your account.',
    product: 'Programmable SMS',
    date_created: '2023-05-25T14:50:33Z',
    last_updated: '2023-05-25T14:50:40.197096Z',
  },
  45208: {
    code: 45208,
    message: 'Chat Channel with this unique name already exists',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 45208\r\n\r\n### Chat Channel with this unique name already exists\r\n\r\n \r\n\r\n#### Possible Causes\r\nAn Active Chat Channel already exists with this unique name - new Channel not created. \r\n\r\n#### Possible Solutions\r\nPlease use the existing active Chat Channel, mark the Channel as inactive by setting Channel Attributes status to 'inactive', remove the Chat Channel or use a different unique name. ",
    causes:
      'An Active Chat Channel already exists with this unique name - new Channel not created. ',
    solutions:
      "Please use the existing active Chat Channel, mark the Channel as inactive by setting Channel Attributes status to 'inactive', remove the Chat Channel or use a different unique name. ",
    description: null,
    product: 'Flex',
    date_created: '2019-09-26T11:43:18Z',
    last_updated: '2020-08-04T10:00:06.187Z',
  },
  70051: {
    code: 70051,
    message: 'Authorization Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 70051\r\n\r\n### Authorization Failed\r\n\r\n Twilio could not authorize the given request.\r\n\r\n#### Possible Causes\r\n* The Account is not found or is suspended\r\n* The API key is not found or is suspended\r\n* The Credentials used for authorization do not belong to the given account\r\n* If using a Restricted API Key - the key may be missing a permission to access the resource\r\n* If using a Restricted API Key - permission to access the resource may not be supported\r\n\r\n#### Possible Solutions\r\n* Make sure the account or the API key are valid and active\r\n* If using a Restricted API Key - add the missing permission to the key\r\n* If using a Restricted API Key - use a Main/Standard type API key',
    causes:
      '* The Account is not found or is suspended\r\n* The API key is not found or is suspended\r\n* The Credentials used for authorization do not belong to the given account\r\n* If using a Restricted API Key - the key may be missing a permission to access the resource\r\n* If using a Restricted API Key - permission to access the resource may not be supported',
    solutions:
      '* Make sure the account or the API key are valid and active\r\n* If using a Restricted API Key - add the missing permission to the key\r\n* If using a Restricted API Key - use a Main/Standard type API key',
    description: 'Twilio could not authorize the given request.',
    product: null,
    date_created: '2017-05-05T16:17:31Z',
    last_updated: '2023-09-09T23:06:36.967098Z',
  },
  57021: {
    code: 57021,
    message: 'Token invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 57021\r\n\r\n### Token invalid\r\n\r\n Invalid Token\r\n\r\n#### Possible Causes\r\nInvalid Token.\r\n\r\n#### Possible Solutions\r\nPass the correct token.',
    causes: 'Invalid Token.',
    solutions: 'Pass the correct token.',
    description: 'Invalid Token',
    product: 'Programmable SMS',
    date_created: '2024-06-11T09:53:17Z',
    last_updated: '2024-06-11T09:53:17Z',
  },
  54507: {
    code: 54507,
    message: 'Invalid query',
    log_level: 'ERROR',
    secondary_message: 'Valid query expression is expected',
    log_type: null,
    docs: "## Error - 54507\r\n\r\n### Sync: Invalid query\r\nValid query expression is expected.\r\n\r\n#### Possible Causes\r\n* You made a typo.\r\n* You've made a programming error that produces a corrupt expression (where usually the expression is valid).\r\n\r\n#### Possible Solutions\r\n* Check that you're adhering to the right format. Query expressions must be specified in infix notation in the form `field operator \"value\"`.\r\n* Check that you're using supported operators. Please review https://www.twilio.com/docs/sync/live-query for a list of supported operators and query examples examples.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2019-04-09T06:47:13Z',
    last_updated: '2020-08-04T10:00:09.207Z',
  },
  60534: {
    code: 60534,
    message: 'SNA Downstream Carrier Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60534\r\n\r\n### SNA Downstream Carrier Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received but failed during processing due to a downstream carrier error.\r\n\r\n#### Possible Solutions\r\nRetry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received but failed during processing due to a downstream carrier error.',
    solutions:
      'Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T17:10:56Z',
    last_updated: '2022-08-30T17:10:56Z',
  },
  62009: {
    code: 62009,
    message: 'Account SID was not found.',
    log_level: 'ERROR',
    secondary_message:
      'The account SID in the request could not be found in the Twilio Interconnect directory. This does not mean that the account is not valid, only that it is not associated with any Twilio Interconnect entries.',
    log_type: null,
    docs: '## Error - 62009\r\n\r\n### Account SID was not found\r\n\r\nThe account SID in the request could not be found in the Twilio Interconnect\r\ndirectory. This does not mean that the account is not valid, only that it\r\nis not associated with any Twilio Interconnect entries.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:38:28Z',
    last_updated: '2020-08-04T10:00:21.036Z',
  },
  19048: {
    code: 19048,
    message: 'Input request body is not properly json formatted',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19048\r\n\r\n### Input request body is not properly json formatted\r\n\r\n Input request body is not properly json formatted\r\n\r\n#### Possible Causes\r\nUnique in the request is missing or request contains invalid form data\r\n\r\n#### Possible Solutions\r\nProvide correct request with unique and form data',
    causes: 'Unique in the request is missing or request contains invalid form data',
    solutions: 'Provide correct request with unique and form data',
    description: 'Input request body is not properly json formatted',
    product: 'Contacts',
    date_created: '2020-08-17T18:30:02Z',
    last_updated: '2020-08-29T00:32:58.857Z',
  },
  40147: {
    code: 40147,
    message:
      "Failed to issue Supervise instruction due to missing or invalid 'contact_uri' property",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 40147\r\n\r\n### Failed to issue Supervise instruction due to missing or invalid 'contact_uri' property\r\n\r\n  \r\n\r\n#### Possible Causes\r\n* The `contact_uri` is missing in the Supervisor's Worker attributes.\r\n* The `contact_uri` in the Supervisor's Worker attributes is invalid.\r\n\r\n#### Possible Solutions\r\n* Add a valid `contact_uri` to the Supervisor’s Worker attributes.",
    causes:
      "* The `contact_uri` is missing in the Supervisor's Worker attributes.\r\n* The `contact_uri` in the Supervisor's Worker attributes is invalid.",
    solutions: '* Add a valid `contact_uri` to the Supervisor’s Worker attributes.',
    description: ' ',
    product: 'TaskRouter',
    date_created: '2020-09-14T21:45:11Z',
    last_updated: '2020-09-15T22:58:33.486Z',
  },
  17002: {
    code: 17002,
    message: 'This call ended more than 30 days ago',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 17002\r\n\r\n### This call ended more than 30 days ago\r\n\r\n The requested resource's call_sid is valid, but the call ended more than 30 days before the request was made.\r\n\r\n#### Possible Causes\r\nVoice Insights only stores 30 days worth of call data.\r\n\r\n#### Possible Solutions\r\nDo not request Voice Insights resources for calls that ended more than 30 days ago.",
    causes: 'Voice Insights only stores 30 days worth of call data.',
    solutions:
      'Do not request Voice Insights resources for calls that ended more than 30 days ago.',
    description:
      "The requested resource's call_sid is valid, but the call ended more than 30 days before the request was made.",
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:30:58Z',
    last_updated: '2020-09-29T19:30:58Z',
  },
  62024: {
    code: 62024,
    message: 'Missing connection type',
    log_level: 'ERROR',
    secondary_message:
      'The request did not specify a connection type. Valid connection types are vpn, crossconnect, mpls.',
    log_type: null,
    docs: '## Error - 62024\r\n\r\n### Missing connection type\r\n\r\nThe request did not specify a connection type. Valid connection types are vpn, crossconnect, mpls.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:49:15Z',
    last_updated: '2020-08-04T10:00:20.752Z',
  },
  53202: {
    code: 53202,
    message: 'Participant identity contains invalid characters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53202: Participant identity contains invalid characters\r\n\r\nRaised whenever a Participant identity contains invalid characters.\r\n\r\n#### Causes\r\n\r\n * The Participant identity contains an invalid UTF-8 byte sequence.\r\n\r\n#### Solutions\r\n\r\n * Choose a Participant identity that is a valid UTF-8 string.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:47:52Z',
    last_updated: '2020-08-04T10:00:19.443Z',
  },
  21210: {
    code: 21210,
    message: "'From' phone number not verified",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21210\r\n\r\n### 'From' phone number not verified\r\n\r\n You attempted to initiate an outbound phone call, but the\r\n'From' number you specified is not a verified\r\nnumber for your account. In order to use a phone number as the Caller ID on\r\noutgoing calls, you must first verify your ownership of that phone number.\r\n\r\nYou can verify phone numbers in the Console [here](https://www.twilio.com/console/phone-numbers/verified).\r\n\r\n### Test Credentials\r\n\r\nIf you received this error while trying to authenticate with your Test\r\nCredentials, you probably tried to make a test call with a `From` number from\r\nyour live account. The only number that can be used to queue `successful`\r\ncalls with your Test Credentials is `+15005550006`. For more information,\r\nread our documentation on [the `From` number for making calls with your test\r\ncredentials][from-test-credentials].\r\n\r\n[from-test-credentials]: /docs/iam/test-credentials#test-sms-messages-parameters-From\r\n\r\n\r\n#### Possible Causes\r\nThe From number used to make outbound call not a Twilio number or not a verified caller ID\r\n\r\n#### Possible Solutions\r\n [phone number verification on Console](https://www.twilio.com/console/phone-numbers/verified)",
    causes:
      'The From number used to make outbound call not a Twilio number or not a verified caller ID',
    solutions:
      ' [phone number verification on Console](https://www.twilio.com/console/phone-numbers/verified)',
    description:
      "You attempted to initiate an outbound phone call, but the\r\n'From' number you specified is not a verified\r\nnumber for your account. In order to use a phone number as the Caller ID on\r\noutgoing calls, you must first verify your ownership of that phone number.\r\n\r\nYou can verify phone numbers in the Console [here](https://www.twilio.com/console/phone-numbers/verified).\r\n\r\n### Test Credentials\r\n\r\nIf you received this error while trying to authenticate with your Test\r\nCredentials, you probably tried to make a test call with a `From` number from\r\nyour live account. The only number that can be used to queue `successful`\r\ncalls with your Test Credentials is `+15005550006`. For more information,\r\nread our documentation on [the `From` number for making calls with your test\r\ncredentials][from-test-credentials].\r\n\r\n[from-test-credentials]: /docs/iam/test-credentials#test-sms-messages-parameters-From\r\n",
    product: null,
    date_created: '2016-03-31T17:13:56Z',
    last_updated: '2023-07-28T17:03:59.388598Z',
  },
  35126: {
    code: 35126,
    message: 'The ScheduleType value provided is not supported for this channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35126\r\n\r\n### The ScheduleType value provided is not supported for this channel\r\n\r\n The ScheduleType value provided is not supported for the channel you want to send the message on. \r\n\r\n#### Possible Causes\r\nYou provided a value other than ‘fixed’ in the ScheduleType parameter\r\n\r\n#### Possible Solutions\r\nChange the ScheduleType value to ‘fixed’',
    causes: 'You provided a value other than ‘fixed’ in the ScheduleType parameter',
    solutions: 'Change the ScheduleType value to ‘fixed’',
    description:
      'The ScheduleType value provided is not supported for the channel you want to send the message on. ',
    product: 'Programmable SMS',
    date_created: '2021-12-08T23:30:53Z',
    last_updated: '2022-07-13T17:44:52.402145Z',
  },
  45370: {
    code: 45370,
    message: 'Failed to create outbound Channel.  Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45370\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'We failed to create an inbound Channel due to an unexpected error condition.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to create inbound Channel due to an internal error.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:07.800196Z',
  },
  80303: {
    code: 80303,
    message: 'Not Found Short Code Sid',
    log_level: 'WARNING',
    secondary_message: 'Short Code Sid is not associated with your Account.',
    log_type: null,
    docs: '## Warning\n\n### Not Found Short Code Sid\n\nExample Message: Short Code Sid is not associated with your Account.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.055Z',
  },
  30038: {
    code: 30038,
    message: 'OTP Message Body Filtered',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30038\r\n\r\n### OTP Message Body Filtered\r\n\r\n Twilio has determined that the body of this message contains a One-Time Passcode (OTP). In order to prevent the abuse of Twilio numbers, Twilio does not generally allow receiving OTP messages. The passcode content has been redacted and the message failed.\r\n\r\n#### Possible Causes\r\nYou are receiving inbound OTP messages.\r\n\r\n#### Possible Solutions\r\nIn order to prevent account creation and abuse with Twilio hosted numbers, Twilio does not generally allow the reception of OTP messages. Contact our [Support team](https://www.twilio.com/console/support/tickets/create) if additional information is required.',
    causes: 'You are receiving inbound OTP messages.',
    solutions:
      'In order to prevent account creation and abuse with Twilio hosted numbers, Twilio does not generally allow the reception of OTP messages. Contact our [Support team](https://www.twilio.com/console/support/tickets/create) if additional information is required.',
    description:
      'Twilio has determined that the body of this message contains a One-Time Passcode (OTP). In order to prevent the abuse of Twilio numbers, Twilio does not generally allow receiving OTP messages. The passcode content has been redacted and the message failed.',
    product: 'Programmable SMS',
    date_created: '2023-09-05T07:39:45Z',
    last_updated: '2023-09-05T07:39:52.66048Z',
  },
  52214: {
    code: 52214,
    message: 'Alexa skill is not connected to Twilio',
    log_level: 'ERROR',
    secondary_message:
      'The Alexa skill configured for the Notify Service is not connected to Twilio',
    log_type: null,
    docs: '## Error - 52214\r\n\r\n### Alexa skill not connected to Twilio\r\n\r\n#### Possible Causes \r\n* Alexa skill ID configured for Notify Service is not connected to Twilio\r\n* After the Notify Service had been configured, the Alexa skill was disconnected from Twilio\r\n\r\n#### Possible Solutions\r\n* [Configure a new Alexa skill](https://www.twilio.com/console/notify/services) for your Notify Service\r\n* [Connect the Alexa skill](https://www.twilio.com/console/channels) to your Twilio Account',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-07-06T13:14:05Z',
    last_updated: '2020-08-04T10:00:18.144Z',
  },
  80905: {
    code: 80905,
    message: 'Unknown Scenario',
    log_level: 'WARNING',
    secondary_message: 'No valid proxy scenario for handling inbound call or message',
    log_type: null,
    docs: '## Warning\n\n### Unknown Scenario\n\nExample Message: No valid proxy scenario for handling inbound call or message',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.589Z',
  },
  60716: {
    code: 60716,
    message: 'Selected logo is not a valid PNG file',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60716\r\n\r\n### Selected logo is not a valid PNG file\r\n\r\n The file sent for the brand logo image is not the expected, PNG\r\n\r\n#### Possible Causes\r\nBrand logo file format was not interpreted as PNG\r\n\r\n#### Possible Solutions\r\nMake sure file format is PNG indeed',
    causes: 'Brand logo file format was not interpreted as PNG',
    solutions: 'Make sure file format is PNG indeed',
    description: 'The file sent for the brand logo image is not the expected, PNG',
    product: 'Branded Comms',
    date_created: '2020-01-24T18:28:02Z',
    last_updated: '2020-08-04T10:00:04.896Z',
  },
  61004: {
    code: 61004,
    message: 'Add-ons: No results',
    log_level: 'WARNING',
    secondary_message:
      ' The Add-on Provider returned a successful response but the Response Validation Schema indicated there was no usable data.',
    log_type: null,
    docs: '## Error - 61004\r\n\r\n### Add-ons: No results\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider returned a successful response but the Response Validation Schema indicated there was no usable data.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:37:17Z',
    last_updated: '2020-08-04T10:00:21.516Z',
  },
  52304: {
    code: 52304,
    message: 'User already exists',
    log_level: 'WARNING',
    secondary_message: 'User with this identity already exists',
    log_type: null,
    docs: '## Warning - 52304\r\n\r\n### User already exists.\r\n\r\n#### Possible Causes \r\n*  User with this identity has already been created, possibly during create binding operation.\r\n\r\n#### Possible Solutions\r\n*  As user already exists, no extra actions are required. However one might want to make sure that the existing user has all the necessary attributes, e.g. segments.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-05-24T08:42:20Z',
    last_updated: '2020-08-04T10:00:18.476Z',
  },
  45358: {
    code: 45358,
    message: 'Failed to close Channel.  Missing status parameter.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45358\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: "Update Channel request was made without valid 'status' parameter.",
    solutions:
      'The only supported operation on a Channel is to update the status to "closed".  A status parameter must be provided.\r',
    description:
      'Failed to close Channel <channel sid>.  No Channel status parameter was provided.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:34.779589Z',
  },
  50422: {
    code: 50422,
    message: 'Non-chat conversation participants limit exceeded',
    log_level: 'ERROR',
    secondary_message:
      'The total number of non-chat participants in this conversation exceeds the allowed limit.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50422\r\n\r\n### Non-chat conversation participants limit exceeded\r\n\r\nThe total number of non-chat participants in this conversation exceeds the allowed limit. \r\n\r\n#### Possible Causes\r\nYou are trying to add more non-chat participants than allowed in this conversation. Maximum number of conversation participants is 50.\r\n* You are trying to add more non-Chat participants than allowed in this conversation. [Maximum number](https://www.twilio.com/docs/conversations/conversations-limits) of conversation participants is 50.\r\n\r\n#### Possible Solutions\r\n* Retrieve a [list of current participants](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) in this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource) the ones that are no longer required.',
    causes:
      'You are trying to add more non-chat participants than allowed in this conversation. Maximum number of conversation participants is 50.\r\n* You are trying to add more non-Chat participants than allowed in this conversation. [Maximum number](https://www.twilio.com/docs/conversations/conversations-limits) of conversation participants is 50.',
    solutions:
      '* Retrieve a [list of current participants](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) in this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource) the ones that are no longer required.',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-10-13T12:36:33Z',
    last_updated: '2021-10-13T12:36:33Z',
  },
  45005: {
    code: 45005,
    message: 'Service Unavailable',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45005\r\n\r\n### Service Unavailable\r\n\r\n \r\n\r\n#### Possible Causes\r\nService or one of it dependent services does not respond, timeout, etc.\r\n\r\n#### Possible Solutions\r\nTry the request again.',
    causes: 'Service or one of it dependent services does not respond, timeout, etc.',
    solutions: 'Try the request again.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:53:15Z',
    last_updated: '2020-08-04T10:00:12.411Z',
  },
  35111: {
    code: 35111,
    message: 'SendAt timestamp is missing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 35111\r\n\r\n### SendAt timestamp is missing\r\n\r\n You must indicate SendAt timestamp if ScheduleType is 'fixed'.\r\n\r\n#### Possible Causes\r\nYou did not indicate SendAt timestamp.\r\n\r\n#### Possible Solutions\r\nCheck if there is a valid timestamp entered for SendAt when ScheduleType is 'fixed'.",
    causes: 'You did not indicate SendAt timestamp.',
    solutions:
      "Check if there is a valid timestamp entered for SendAt when ScheduleType is 'fixed'.",
    description: "You must indicate SendAt timestamp if ScheduleType is 'fixed'.",
    product: 'Programmable SMS',
    date_created: '2020-10-09T04:53:21Z',
    last_updated: '2020-10-09T04:53:56.828Z',
  },
  13217: {
    code: 13217,
    message: 'Dial: Invalid record value',
    log_level: 'WARNING',
    secondary_message: 'record must be "true" or "false".',
    log_type: null,
    docs: '## Warning - 13217 \n\n### Dial: Invalid record value\n\nrecord must be "true" or "false".\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:33Z',
    last_updated: '2020-08-04T10:00:28.757Z',
  },
  80503: {
    code: 80503,
    message: 'No Records Updated',
    log_level: 'WARNING',
    secondary_message: 'Record to be updated was not found. It may have been deleted.',
    log_type: null,
    docs: '## Error\r\n\r\n### No Records Updated\r\n\r\nExample Message: Record to be updated was not found. It may have been deleted.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-06T16:10:48Z',
    last_updated: '2020-08-04T10:00:15.497Z',
  },
  50003: {
    code: 50003,
    message: 'Programmable Chat: Friendly name too long',
    log_level: 'ERROR',
    secondary_message: 'Specified friendly name is too long',
    log_type: null,
    docs: '## Error - 50003\r\n\r\n### Programmable Chat: Friendly name too long\r\n\r\n#### Possible Causes \r\n*  Specified friendly name is too long\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid FriendlyName is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2019-02-06T13:20:59Z',
    last_updated: '2020-08-04T10:00:10.725Z',
  },
  60702: {
    code: 60702,
    message: 'Business Profile not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60702\r\n\r\n### Business Profile not found\r\n\r\n The Business was not found\r\n\r\n#### Possible Causes\r\n- The business does not exist anymore\r\n- The `BusinessSid` parameter is invalid/incorrect\r\n\r\n#### Possible Solutions\r\n- Check the `BusinessSid` parameter in your request, from Console',
    causes:
      '- The business does not exist anymore\r\n- The `BusinessSid` parameter is invalid/incorrect',
    solutions: '- Check the `BusinessSid` parameter in your request, from Console',
    description: 'The Business was not found',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:25:30Z',
    last_updated: '2020-08-04T10:00:05.163Z',
  },
  83402: {
    code: 83402,
    message: 'Received error response to IP Command callback request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83402\r\n\r\n### Received error response to IP Command callback request\r\n\r\n Twilio received an error response when attempting to send an IP Command event to the provided callback URL.\r\n\r\n#### Possible Causes\r\nTwilio did not receive a 2xx response from the callback URL when attempting to send an IP Command event.\r\n\r\n#### Possible Solutions\r\nEnsure that your callback server can handle the callback and responds with a 2xx HTTP status code. See the [Debugger](https://www.twilio.com/console/debugger) in Console for further information on the callback response.',
    causes:
      'Twilio did not receive a 2xx response from the callback URL when attempting to send an IP Command event.',
    solutions:
      'Ensure that your callback server can handle the callback and responds with a 2xx HTTP status code. See the [Debugger](https://www.twilio.com/console/debugger) in Console for further information on the callback response.',
    description:
      'Twilio received an error response when attempting to send an IP Command event to the provided callback URL.',
    product: 'Super SIM',
    date_created: '2021-04-29T14:18:12Z',
    last_updated: '2021-04-29T14:18:12Z',
  },
  18602: {
    code: 18602,
    message: 'The Business ID you provided could not be verified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18602\r\n\r\n### The Business ID you provided could not be verified\r\n\r\n The Business ID you provided could not be verified.\r\n\r\n#### Possible Causes\r\nYou may have provided an inaccurate business ID or the Business ID is invalid / expired.\r\n\r\n#### Possible Solutions\r\nPlease feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.\r\n\r\nPlease be sure to use the legal company name and EIN number found in your Tax records.',
    causes:
      'You may have provided an inaccurate business ID or the Business ID is invalid / expired.',
    solutions:
      'Please feel free to edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.\r\n\r\nPlease be sure to use the legal company name and EIN number found in your Tax records.',
    description: 'The Business ID you provided could not be verified.',
    product: 'Phone Numbers',
    date_created: '2024-02-22T03:25:35Z',
    last_updated: '2024-02-22T03:25:35Z',
  },
  60223: {
    code: 60223,
    message: 'Delivery channel disabled',
    log_level: 'ERROR',
    secondary_message: 'Create verification failed because delivery channel is currently disabled',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60223\r\n\r\n### Delivery channel disabled\r\n\r\nCreate verification failed because delivery channel is currently disabled \r\n\r\n#### Possible Causes\r\nThe delivery channel specified is currently disabled in the Verify Service settings\r\n\r\n#### Possible Solutions\r\n * Enable delivery channel in Verify Service settings\r\n * Change the delivery channel specified in the create verification request',
    causes: 'The delivery channel specified is currently disabled in the Verify Service settings',
    solutions:
      ' * Enable delivery channel in Verify Service settings\r\n * Change the delivery channel specified in the create verification request',
    description:
      'Create verification failed because delivery channel is currently disabled\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-09-16T16:26:13Z',
    last_updated: '2022-04-25T20:47:44.014213Z',
  },
  60368: {
    code: 60368,
    message: 'Challenge details invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60368\r\n\r\n### Challenge details invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Challenge details section in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Challenge details in the request body is correct.',
    causes: 'The Challenge details section in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Challenge details in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-19T11:34:41Z',
    last_updated: '2023-12-19T11:34:41Z',
  },
  30103: {
    code: 30103,
    message: 'Links not shortened due to application failure.',
    log_level: 'ERROR',
    secondary_message:
      'Twilio was unable to shorten the links included in your message due to an application error in the Twilio Link Shortening service.',
    log_type: 'TWILIO',
    docs: '## ERROR - 30103\r\n\r\n### Links not shortened due to application failure.\r\n\r\nTwilio was unable to shorten the links included in your message due to an application error in the Twilio Link Shortening service. Links not shortened due to shortener application failure\r\n\r\n#### Possible Causes\r\nUnknown service interruption or outage. \r\n\r\n#### Possible Solutions\r\nFile a support ticket and include the Message SID.',
    causes: 'Unknown service interruption or outage. ',
    solutions: 'File a support ticket and include the Message SID.',
    description: 'Links not shortened due to shortener application failure',
    product: 'Programmable SMS',
    date_created: '2020-04-23T21:13:38Z',
    last_updated: '2023-05-22T20:24:01.832344Z',
  },
  11320: {
    code: 11320,
    message: 'Invalid template unclosed brackets',
    log_level: 'ERROR',
    secondary_message:
      'The provided URL template has an invalid format. Please check to see if you have unclosed brackets.',
    log_type: null,
    docs: '## Error - 11320 \n\n### Invalid template unclosed brackets\n\nThe provided URL template has an invalid format. Please check to see if you have unclosed brackets.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:27Z',
    last_updated: '2020-08-04T10:00:29.221Z',
  },
  21249: {
    code: 21249,
    message: 'Maximum Origination URIs reached  ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21249\r\n\r\n### Maximum Origination URIs reached  \r\n\r\n \r\n\r\n#### Possible Causes\r\n*   You've configured the maximum number of Origination URIs allowed for your Trunk.\r\n\r\n#### Possible Solutions\r\n* Please see [Multiple Origination URIs](/docs/sip-trunking#multiple-orig-uris) for more information.",
    causes: "*   You've configured the maximum number of Origination URIs allowed for your Trunk.",
    solutions:
      '* Please see [Multiple Origination URIs](/docs/sip-trunking#multiple-orig-uris) for more information.',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:09:20Z',
    last_updated: '2023-07-28T17:07:55.944962Z',
  },
  13242: {
    code: 13242,
    message: 'Dial->SIP: Invalid sendDigits value',
    log_level: 'WARNING',
    secondary_message:
      'sendDigits attribute may only contain the following characters "0123456789*#w"',
    log_type: null,
    docs: '## Warning - 13242 \n\n### Dial->SIP: Invalid sendDigits value\n\nsendDigits attribute may only contain the following characters "0123456789*#w"\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:38Z',
    last_updated: '2020-08-04T10:00:28.268Z',
  },
  13245: {
    code: 13245,
    message: 'Dial: Not allowed in this API version',
    log_level: 'WARNING',
    secondary_message: 'Your version of the API does not support this feature.',
    log_type: null,
    docs: '## Warning - 13245 \n\n### Dial: Not allowed in this API version.\n\nYour version of the API does not support this feature.\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:07Z',
    last_updated: '2020-08-04T10:00:26.539Z',
  },
  53304: {
    code: 53304,
    message: 'Track name is duplicated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53304: Track name is duplicated\r\n\r\nRaised whenever a Participant is currently publishing a Track with the same name.\r\n\r\n#### Causes\r\n\r\n * A Track with the same name already exists.\r\n\r\n#### Solutions\r\n\r\n * Choose a Track name that is unique per Participant.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-10-12T20:01:19Z',
    last_updated: '2020-08-04T10:00:16.869Z',
  },
  52140: {
    code: 52140,
    message: 'Unknown APNs error',
    log_level: 'ERROR',
    secondary_message: 'Unexpected error has happened in Apn binding adaptor',
    log_type: null,
    docs: '## Error - 52140\r\n\r\n### Unknown APNs error\r\n\r\n#### Possible Causes \r\n*  Unknown APNs error.\r\n\r\n#### Possible Solutions\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:39:17Z',
    last_updated: '2020-08-04T10:00:22.052Z',
  },
  22224: {
    code: 22224,
    message: 'Regulatory Bundle cannot transfer Item Assignments',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22224\r\n\r\n### Regulatory Bundle cannot transfer Item Assignments\r\n\r\n The Regulatory Bundle cannot transfer the Item Assignments from the destination Bundle.\r\n\r\n#### Possible Causes\r\nThe status is either not eligible as all Bundles need to be in a twilio-approved state or the destination Bundle is not a Copy of the source Bundle.\r\n\r\n#### Possible Solutions\r\nEnsure both Bundles are in the correct twilio-approved status and that the destination Bundle is a Copy of the source Bundle.',
    causes:
      'The status is either not eligible as all Bundles need to be in a twilio-approved state or the destination Bundle is not a Copy of the source Bundle.',
    solutions:
      'Ensure both Bundles are in the correct twilio-approved status and that the destination Bundle is a Copy of the source Bundle.',
    description:
      'The Regulatory Bundle cannot transfer the Item Assignments from the destination Bundle.',
    product: 'Phone Numbers',
    date_created: '2022-03-10T23:30:48Z',
    last_updated: '2022-03-10T23:30:48Z',
  },
  30105: {
    code: 30105,
    message: 'Shortened link not found and no fallback URL found',
    log_level: 'WARNING',
    secondary_message:
      'We returned a 404 to this user action as we could not find a valid url or fallback url to redirect them to.',
    log_type: 'TWILIO',
    docs: "## WARNING - 30105\r\n\r\n### Shortened link not found and no fallback URL found\r\n\r\nWe returned a 404 to this user action as we could not find a valid url or fallback url to redirect them to. We received a request to a domain you've registered with Click Tracking but we don't have a record of the shortened url or a fallback url set on the domain.\r\n\r\n#### Possible Causes\r\n- The url has expired\r\n- A request was sent to a url that wasn't generated by Twilio\r\n- The fallback url isn't set\r\n\r\n#### Possible Solutions\r\n- Contact your account manager or support about extending the retention period of links.\r\n- Set a fallback url to mitigate this error",
    causes:
      "- The url has expired\r\n- A request was sent to a url that wasn't generated by Twilio\r\n- The fallback url isn't set",
    solutions:
      '- Contact your account manager or support about extending the retention period of links.\r\n- Set a fallback url to mitigate this error',
    description:
      "We received a request to a domain you've registered with Click Tracking but we don't have a record of the shortened url or a fallback url set on the domain.",
    product: 'Programmable SMS',
    date_created: '2020-04-28T15:18:14Z',
    last_updated: '2020-08-04T10:00:03.636Z',
  },
  30907: {
    code: 30907,
    message: 'Campaign vetting rejection - Website URL Validation Issue',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30907\r\n\r\n### Campaign vetting rejection - Website URL Validation Issue\r\n\r\n The campaign submission has been reviewed and rejected because the provided website URL does not match the Brand and Campaign registered.\r\n\r\n#### Possible Causes\r\n* *Mismatched Website Information*: The website URL submitted does not correspond to the Brand information or the campaign's intended use as registered.\r\n* *Brand-Campaign Discrepancy*: There is a discrepancy between the Brand details and the campaign details on provided website.\r\n\r\n\r\n#### Possible Solutions\r\n1. Confirm website content aligns with the registered Brand and Campaign details.\r\n2. Update Website URL submission on Brand details.\r\nOnce you have made a change to address the website validation error, please resubmit the campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n",
    causes:
      "* *Mismatched Website Information*: The website URL submitted does not correspond to the Brand information or the campaign's intended use as registered.\r\n* *Brand-Campaign Discrepancy*: There is a discrepancy between the Brand details and the campaign details on provided website.\r\n",
    solutions:
      '1. Confirm website content aligns with the registered Brand and Campaign details.\r\n2. Update Website URL submission on Brand details.\r\nOnce you have made a change to address the website validation error, please resubmit the campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n',
    description:
      'The campaign submission has been reviewed and rejected because the provided website URL does not match the Brand and Campaign registered.',
    product: 'Programmable Messaging',
    date_created: '2023-11-09T16:25:32Z',
    last_updated: '2023-11-09T17:24:31.544841Z',
  },
  51104: {
    code: 51104,
    message: "Twilsock: Token doesn't contain service instance",
    log_level: 'ERROR',
    secondary_message: "The token doesn't have a service instance.",
    log_type: null,
    docs: "## Error - 51104\r\n\r\n### Token doesn't contain service instance\r\n\r\n#### Possible Causes \r\nThe token doesn't have a service instance.\r\n\r\n#### Possible Solutions\r\nConfirm a service instance is being passed in the token. \r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T11:54:21Z',
    last_updated: '2020-08-04T10:00:09.864Z',
  },
  45360: {
    code: 45360,
    message: 'Failed to close or delete Conversation.  Downstream error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45360\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'Conversations API returned an error',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to update Conversation <conversation sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:37.369822Z',
  },
  52215: {
    code: 52215,
    message: 'Missing Title parameter for Alexa',
    log_level: 'ERROR',
    secondary_message: 'Message has been rejected by Alexa channel due to missing Title parameter',
    log_type: null,
    docs: '## Error 52215\r\n\r\n### Missing Title parameter for Alexa\r\n\r\nMessage has been rejected by Alexa channel due to missing Title parameter. Title is a required parameter for Alexa channel. This specific message has not been sent. \r\n\r\n### Possible causes\r\n- Have not provided the Title parameter neither in the generic payload nor in the Alexa specific parameter. \r\n\r\n### Possible solutions\r\n- Make sure that you provide the Title parameter for the Alexa channel either in the [generic payload](https://www.twilio.com/docs/api/notify/rest/notifications#generic-payload-parameters) or the [Alexa specific parameter](https://www.twilio.com/docs/api/notify/rest/notifications#sending-channel-specific-notifications).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-06-22T15:30:09Z',
    last_updated: '2020-08-04T10:00:18.202Z',
  },
  22207: {
    code: 22207,
    message: 'Unable to parse attributes JSON',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22207\r\n\r\n### Unable to parse attributes JSON\r\n\r\n The attributes JSON string provided was not valid or parsing otherwise failed.\r\n\r\n#### Possible Causes\r\nThe JSON was invalid.\r\n\r\n#### Possible Solutions\r\nCheck to see if the JSON is valid and resend the request.',
    causes: 'The JSON was invalid.',
    solutions: 'Check to see if the JSON is valid and resend the request.',
    description: 'The attributes JSON string provided was not valid or parsing otherwise failed.',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:46:11Z',
    last_updated: '2020-08-04T10:00:05.582Z',
  },
  21256: {
    code: 21256,
    message: 'Invalid ruleset',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21256\r\n\r\n### Invalid ruleset\r\n\r\n The ruleset is invalid\r\n\r\n#### Possible Causes\r\nThe json format of the ruleset does not match the spec or duplicate rule name.\r\n\r\n#### Possible Solutions\r\nFollow the json format for the ruleset found in the spec and use a valid ruleset.',
    causes: 'The json format of the ruleset does not match the spec or duplicate rule name.',
    solutions: 'Follow the json format for the ruleset found in the spec and use a valid ruleset.',
    description: 'The ruleset is invalid',
    product: 'Elastic SIP Trunking',
    date_created: '2021-09-16T19:30:42Z',
    last_updated: '2021-10-28T21:05:01.067508Z',
  },
  32008: {
    code: 32008,
    message: 'SIP: Registration per second limit reached',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: 'Registration per second limit reached\r\n\r\n<b>Cause</b>\r\n\r\nYou are allowed:\r\n5 REGISTER requests / second / AOR\r\n\r\n<b>Solution</b>\r\n\r\nReduce the frequency (Increase interval) of REGISTRATIONS by your SIP Endpoints.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-11-09T23:00:49Z',
    last_updated: '2020-08-04T10:00:20.506Z',
  },
  60510: {
    code: 60510,
    message: 'SNA Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60510\r\n\r\n### SNA Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received but failed during processing due to an error during the Silent Network Auth process.\r\n\r\n#### Possible Solutions\r\n- Check that the mobile client is using a mobile data connection to invoke the SNA URL, not WiFi.\r\n- Retry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received but failed during processing due to an error during the Silent Network Auth process.',
    solutions:
      '- Check that the mobile client is using a mobile data connection to invoke the SNA URL, not WiFi.\r\n- Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T16:43:11Z',
    last_updated: '2022-10-25T14:24:47.212435Z',
  },
  51122: {
    code: 51122,
    message: 'Twilsock: Authentication failed',
    log_level: 'ERROR',
    secondary_message: 'Authentication failed.',
    log_type: null,
    docs: '## Error - 51122\r\n\r\n### Authentication failed\r\n\r\n#### Possible Causes \r\nMissing or wrong information provided as credentials.\r\n\r\n#### Possible Solutions\r\nConfirm your credentials are correct and being passed correctly.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:22:30Z',
    last_updated: '2020-08-04T10:00:09.514Z',
  },
  30902: {
    code: 30902,
    message: 'Campaign rejection - A DCA2 rejected this campaign registration request.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30902\r\n\r\n### Campaign rejection - A DCA2 rejected this campaign registration request.\r\n\r\n The campaign registration request failed due to a DCA2 rejecting this campaign.\r\n\r\n#### Possible Causes\r\nReasons for this failure can be:\r\n\r\n* Third parties involved in campaign registration rejected the campaign registration request.\r\n\r\n#### Possible Solutions\r\nPlease reach out to customer support with campaign and account details for resolution. ',
    causes:
      'Reasons for this failure can be:\r\n\r\n* Third parties involved in campaign registration rejected the campaign registration request.',
    solutions:
      'Please reach out to customer support with campaign and account details for resolution. ',
    description: 'The campaign registration request failed due to a DCA2 rejecting this campaign.',
    product: 'Programmable Messaging',
    date_created: '2023-07-12T20:28:38Z',
    last_updated: '2023-07-12T20:28:38Z',
  },
  20104: {
    code: 20104,
    message: 'Access Token expired or expiration date invalid',
    log_level: 'WARNING',
    secondary_message: 'Access Token has expired or expiration date is invalid',
    log_type: null,
    docs: "# Warning - 20104\r\n\r\n## Access Token has expired or expiration date is invalid\r\n\r\nThe Access Token provided to the Twilio API has expired, the expiration time\r\nspecified in the token was invalid, or the expiration time specified was too\r\nfar in the future.\r\n\r\nAccess Token expiration times can be set up to 24 hours in the future.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nAccess Tokens are used by multiple Twilio SDKs, including Programmable Voice, Programmable Video, and Programmable Chat. For the details of Twilio's specific Access Token implementation, see [the documentation](/docs/api/rest/access-tokens).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T06:53:53Z',
    last_updated: '2020-08-04T10:00:22.72Z',
  },
  20020: {
    code: 20020,
    message: 'No update/state change is observed for the data entered',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 20020\r\n\r\n### No update/state change is observed for the data entered\r\n\r\n No update/state change is observed for the data entered\r\n\r\n#### Possible Causes\r\n* The data already exist in T-Mobile SDG Service Provisioning API\r\n\r\n#### Possible Solutions\r\n* If data is needed to be updated in T-Mobile SDG Service Provisioning API the request must have updated fields',
    causes: '* The data already exist in T-Mobile SDG Service Provisioning API',
    solutions:
      '* If data is needed to be updated in T-Mobile SDG Service Provisioning API the request must have updated fields',
    description: 'No update/state change is observed for the data entered',
    product: null,
    date_created: '2020-10-13T21:53:42Z',
    last_updated: '2020-10-13T22:01:41.796Z',
  },
  52182: {
    code: 52182,
    message: 'Messaging Service not specified',
    log_level: 'ERROR',
    secondary_message: 'MessagingServiceSid in Notify Service is not specified',
    log_type: null,
    docs: '## Error - 52182\r\n\r\n### Messaging Service not specified\r\n\r\nIn order to send SMS messages with Notify you need to configure a [Messaging Service](https://www.twilio.com/docs/api/rest/messaging-services-and-copilot-overview) and connect it with your Notify Service. Messaging Services make it easy to build SMS application by automatically selecting an optimal From phone number from pool you can define. \r\n\r\n#### Possible causes\r\n- MessagingServiceSid in Notify Service is not specified\r\n\r\n#### Possible solutions\r\n- Configure a Messaging Service in the [console](/console/notify/services) or via the [REST API](https://www.twilio.com/docs/api/notify/rest/services#update-a-service). You can create a new Messaging Service in the [console](https://www.twilio.com/console/sms/services) or via the [REST API](https://www.twilio.com/docs/api/rest/messaging-services).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-07-14T09:29:35Z',
    last_updated: '2020-08-04T10:00:18.029Z',
  },
  21710: {
    code: 21710,
    message: 'Phone Number Already Exists in Messaging Service',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 21710\r\n\r\n### Phone Number Already Exists in Messaging Service\r\n\r\n The phone number, short code or alpha sender ID already exists in the Messaging Service.\r\n\r\n#### Possible Causes\r\n* Multiple requests were made to add the phone number, short code or alpha sender ID to the Messaging Service’s Sender Pool. \r\n* The phone number, short code or alpha sender ID was already added at an earlier time.\r\n\r\n#### Possible Solutions\r\n* If you know this phone number is properly associated with the Messaging Service, do nothing. \r\n* Remove the existing phone number, short code or alpha sender ID from the Messaging Service and add it back to the Messaging Service’s Sender Pool.',
    causes:
      '* Multiple requests were made to add the phone number, short code or alpha sender ID to the Messaging Service’s Sender Pool. \r\n* The phone number, short code or alpha sender ID was already added at an earlier time.',
    solutions:
      '* If you know this phone number is properly associated with the Messaging Service, do nothing. \r\n* Remove the existing phone number, short code or alpha sender ID from the Messaging Service and add it back to the Messaging Service’s Sender Pool.',
    description:
      'The phone number, short code or alpha sender ID already exists in the Messaging Service.',
    product: 'Programmable SMS',
    date_created: '2021-05-27T17:51:26Z',
    last_updated: '2021-05-27T17:51:26Z',
  },
  30404: {
    code: 30404,
    message: 'Not Found',
    log_level: 'ERROR',
    secondary_message: 'The resource was not found.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30404\r\n\r\n### Not Found\r\n\r\nThe resource was not found. ## Not Found\r\n\r\nThe resource was not found. Here are some examples of cases that may trigger a 404 error.\r\n\r\n#### Possible Causes\r\n Using a base URL that is not `https://api.twilio.com`. For example, making requests to `https://twilio.com` or `https://www.twilio.com` will not work.\r\n\r\n#### Possible Solutions\r\nConfirm that the AccountSid and MessagingServiceSid is correct',
    causes:
      ' Using a base URL that is not `https://api.twilio.com`. For example, making requests to `https://twilio.com` or `https://www.twilio.com` will not work.',
    solutions: 'Confirm that the AccountSid and MessagingServiceSid is correct',
    description:
      '## Not Found\r\n\r\nThe resource was not found. Here are some examples of cases that may trigger a 404 error.',
    product: 'Programmable SMS',
    date_created: '2022-10-27T18:45:37Z',
    last_updated: '2022-10-27T18:45:37Z',
  },
  53622: {
    code: 53622,
    message: 'Invalid public key for media tracks encryption in composition settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53622\r\n\r\n### Invalid public key for media tracks encryption in composition settings\r\n\r\nThe public key configured in your account's composition settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the key value is not correct.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-11T14:37:32Z',
    last_updated: '2020-08-04T10:00:13.475Z',
  },
  54053: {
    code: 54053,
    message: 'Invalid friendly name',
    log_level: 'ERROR',
    secondary_message: "The specified 'FriendlyName' parameter is not valid.",
    log_type: null,
    docs: "\n## Error - 54053\n\n### Sync: Invalid friendly name\nThe specified 'FriendlyName' parameter is not valid.\n\n#### Possible Causes\n* The value supplied by the FriendlyName parameter is an empty string.\n* The value supplied by the FriendlyName parameter exceeds 255 characters.\n\n#### Possible Solutions\nConfirm the FriendlyName string parameter is either unspecified (`null`) or a nonempty string of up to 1-255 Unicode characters.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.683Z',
  },
  57005: {
    code: 57005,
    message: "'Category' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57005\r\n\r\n### 'Category' is too long\r\n\r\n Specified 'Category' is too long\r\n\r\n#### Possible Causes\r\nSpecified 'Category' is too long\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Category' is being passed in request.",
    causes: "Specified 'Category' is too long",
    solutions: "Confirm a valid 'Category' is being passed in request.",
    description: "Specified 'Category' is too long",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:49:49Z',
    last_updated: '2021-05-07T08:49:49Z',
  },
  19042: {
    code: 19042,
    message: 'Custom Field validation error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19042\r\n\r\n### Custom Field validation error\r\n\r\n The request body has invalid inputs\r\n\r\n#### Possible Causes\r\nInvalid length for custom field, data type mismatch and/or date in invalid format\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'Invalid length for custom field, data type mismatch and/or date in invalid format',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'The request body has invalid inputs',
    product: null,
    date_created: '2020-07-21T20:34:04Z',
    last_updated: '2020-08-04T10:00:01.211Z',
  },
  54452: {
    code: 54452,
    message: "Invalid 'Bounds' query parameter",
    log_level: 'ERROR',
    secondary_message: "The 'Bounds' query parameter must be one of {'inclusive', 'exclusive'}.",
    log_type: null,
    docs: "\n## Error - 54452\n\n### Sync: Invalid 'Bounds' query parameter\nThe 'Bounds' query parameter must be one of {'inclusive', 'exclusive'}.\n\n#### Possible Causes\n* The value supplied by the Bounds query string parameter does not match _inclusive_ or _exclusive_ designators.\n\n#### Possible Solutions\nConfirm a valid Bounds query parameter is being passed in request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.212Z',
  },
  12101: {
    code: 12101,
    message: 'Invalid Twilio Markup XML version',
    log_level: 'ERROR',
    secondary_message: 'The version attribute of the Response root element is not valid.',
    log_type: null,
    docs: '## Error - 12101 \n\n### Invalid Twilio Markup XML version\n\nThe version attribute of the Response root element is not valid.\n\n#### Possible Causes \n*  an invalid value was provided for the "version" attribute of the <a href=\'/docs/api/twiml/response\'>Response</a> root element.\n\n\n#### Possible Solutions\n*  refer to the <a href="/docs/api/twiml/response">versions</a> documentation for information on valid version values.\t\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:28Z',
    last_updated: '2020-08-04T10:00:29.187Z',
  },
  14211: {
    code: 14211,
    message: 'Dial->Queue: Invalid whisper url',
    log_level: 'ERROR',
    secondary_message:
      'The whisper url is invalid.  #### Possible Solutions  Make sure you submit a fully qualified URL including:  *   protocol (http:// or https://) *   hostname *   file path *   properly url-encoded query parameters  Twilio must be able to reach this URL over the public Internet.',
    log_type: null,
    docs: '## Error - 14211\n\n### Dial->Queue: Invalid whisper url\n\nThe whisper url is invalid.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:11Z',
    last_updated: '2020-08-04T10:00:26.203Z',
  },
  30129: {
    code: 30129,
    message: 'Certificate is self signed',
    log_level: 'ERROR',
    secondary_message: 'Please use a certificate with valid signature',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30129\r\n\r\n### Certificate is self signed\r\n\r\nPlease use a certificate with valid signature Certificate is self signed\r\n\r\n#### Possible Causes\r\nUsing self signed certificates\r\n\r\n#### Possible Solutions\r\nPlease use a certificate with valid signature',
    causes: 'Using self signed certificates',
    solutions: 'Please use a certificate with valid signature',
    description: 'Certificate is self signed',
    product: 'Programmable SMS',
    date_created: '2022-07-15T00:15:20Z',
    last_updated: '2022-07-15T00:16:31.815589Z',
  },
  45733: {
    code: 45733,
    message: 'Pre-engagement data is not in valid JSON format.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45733\r\n\r\n### Pre-engagement data is not in valid JSON format.\r\n\r\n Failed to create webchat conversation. Pre-engagement data not in valid JSON format. \r\n\r\n#### Possible Causes\r\nPre-engagement data is not in valid JSON format.\r\n\r\n#### Possible Solutions\r\nEnsure pre-engagement data is in valid JSON format.\r\n\r\nRead more about creating valid attributes [here.](https://www.twilio.com/docs/conversations/attributes)',
    causes: 'Pre-engagement data is not in valid JSON format.',
    solutions:
      'Ensure pre-engagement data is in valid JSON format.\r\n\r\nRead more about creating valid attributes [here.](https://www.twilio.com/docs/conversations/attributes)',
    description:
      'Failed to create webchat conversation. Pre-engagement data not in valid JSON format. ',
    product: 'Flex',
    date_created: '2022-10-03T21:23:17Z',
    last_updated: '2022-10-03T21:23:17Z',
  },
  32711: {
    code: 32711,
    message: 'Voice User-Defined Message: Request to subscription callback URL encountered error ',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32711\r\n\r\n### Voice User-Defined Message: Request to subscription callback URL encountered error \r\n\r\n Twilio received an error response when attempting to send a User-Defined Message event to the UserDefinedMessageSubscription callback URL.\r\n\r\n#### Possible Causes\r\n* The UserDefinedMessageSubscription callback URL is incorrect.\r\n* Your endpoint at the UserDefinedMessageSubscription callback URL was not responding or responded with a 400- or 500-level HTTP status code.\r\n\r\n#### Possible Solutions\r\n* Make sure that the UserDefinedMessageSubscription callback URL is correct.\r\n* Make sure that your endpoint at the UserDefinedMessageSubscription callback URL can successfully receive and respond to requests with 200-level HTTP status codes.',
    causes:
      '* The UserDefinedMessageSubscription callback URL is incorrect.\r\n* Your endpoint at the UserDefinedMessageSubscription callback URL was not responding or responded with a 400- or 500-level HTTP status code.',
    solutions:
      '* Make sure that the UserDefinedMessageSubscription callback URL is correct.\r\n* Make sure that your endpoint at the UserDefinedMessageSubscription callback URL can successfully receive and respond to requests with 200-level HTTP status codes.',
    description:
      'Twilio received an error response when attempting to send a User-Defined Message event to the UserDefinedMessageSubscription callback URL.',
    product: 'Programmable Voice',
    date_created: '2022-08-18T21:55:10Z',
    last_updated: '2022-08-18T22:25:21.765151Z',
  },
  21730: {
    code: 21730,
    message: 'System under maintenance. Please try again later.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 21730\r\n\r\n### System under maintenance. Please try again later.\r\n\r\n This error is returned by Twilio Systems when the system is going through a scheduled maintenance. During this maintenance window some of the operations are not allowed and this error is returned.\r\n\r\n#### Possible Causes\r\nCurrently the system is going through some maintenance.\r\n\r\n#### Possible Solutions\r\nTry again later because once maintenance activity is completed all requests are processed successfully.',
    causes: 'Currently the system is going through some maintenance.',
    solutions:
      'Try again later because once maintenance activity is completed all requests are processed successfully.',
    description:
      'This error is returned by Twilio Systems when the system is going through a scheduled maintenance. During this maintenance window some of the operations are not allowed and this error is returned.',
    product: 'Programmable SMS',
    date_created: '2023-03-22T01:00:55Z',
    last_updated: '2023-03-22T01:00:55Z',
  },
  21452: {
    code: 21452,
    message: 'No phone numbers found in area code',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to get a phone number for your account, but Twilio couldn't find any numbers in the area you specified.  You may try again with a different <span class='rest-attribute'>AreaCode</span> or contact us to request a number in a certain area.  We can usually accommodate such requests within a few days.",
    log_type: null,
    docs: "## Error - 21452 \n\n### No phone numbers found in area code\n\nYou attempted to get a phone number for your account, but Twilio couldn't find any numbers in the area you specified.  You may try again with a different <span class='rest-attribute'>AreaCode</span> or contact us to request a number in a certain area.  We can usually accommodate such requests within a few days.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:00Z',
    last_updated: '2020-08-04T10:00:26.909Z',
  },
  16010: {
    code: 16010,
    message: 'Conference Event: Internal Twilio Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16010\r\n\r\n### Conference Event: Internal Twilio Error\r\n\r\nTwilio experienced an unexpected internal error in attempting to deliver a conference event to the provided call back URL.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:11:00Z',
    last_updated: '2020-08-04T10:00:10.101Z',
  },
  33107: {
    code: 33107,
    message: 'SIM not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33107\r\n\r\n### SIM not found\r\n\r\n Raised whenever the given SIM is not found.\r\n\r\n#### Possible Causes\r\n * While sending a Command, your request was rejected because the SIM you provided was not found.\r\n\r\n\r\n#### Possible Solutions\r\n * While sending a Command, ensure the SIM exists.\r\n',
    causes:
      ' * While sending a Command, your request was rejected because the SIM you provided was not found.\r\n',
    solutions: ' * While sending a Command, ensure the SIM exists.\r\n',
    description: 'Raised whenever the given SIM is not found.',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:20:09Z',
    last_updated: '2020-09-15T11:20:09Z',
  },
  50324: {
    code: 50324,
    message: 'Invalid channel webhook type',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for channel webhook type',
    log_type: null,
    docs: '## Error - 50324\r\n\r\n### Programmable Chat: Invalid channel webhook type\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for channel webhook type.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T15:20:55Z',
    last_updated: '2020-08-04T10:00:12.076Z',
  },
  50421: {
    code: 50421,
    message: 'Invalid last read message index format',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for last read message index',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50421\r\n\r\n### Invalid last read message index format\r\n\r\nRequest does not contain correctly formatted parameter for last read message index \r\n\r\n#### Possible Causes\r\nRequest does not contain correctly formatted parameter for last read message index\r\n\r\n#### Possible Solutions\r\nConfirm a valid parameter is passed in request.',
    causes: 'Request does not contain correctly formatted parameter for last read message index',
    solutions: 'Confirm a valid parameter is passed in request.',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-10-13T12:29:40Z',
    last_updated: '2021-10-13T12:29:40Z',
  },
  61000: {
    code: 61000,
    message: 'Add-ons: Internal server error',
    log_level: 'ERROR',
    secondary_message:
      'This is generic catch all error for Add-on related conditions that were not caught by a more specific error.',
    log_type: null,
    docs: '## Error - 61000\r\n\r\n### Add-ons Internal server error\r\n\r\n#### Possible Causes \r\n*  This is generic catch all error for Add-on related conditions that were not caught by a more specific error.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:35:33Z',
    last_updated: '2020-08-04T10:00:21.618Z',
  },
  21421: {
    code: 21421,
    message: 'Phone Number is invalid',
    log_level: 'ERROR',
    secondary_message:
      'You tried to purchase a phone number for your account that was an invalid number. Please specify a valid phone number in E.164 format.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21421\r\n\r\n### Phone Number is invalid\r\n\r\nYou tried to purchase a phone number for your account that was an invalid number. Please specify a valid phone number in E.164 format. You tried to purchase or lookup a phone number that is invalid or add a phone number to a Messaging Service with an invalid Phone Number SID.\r\n\r\n#### Possible Causes\r\n* You tried to purchase or lookup a phone number that is invalid.\r\n* You tried to add an invalid Phone Number SID or Short Code SID to a Messaging Service.\r\n\r\n#### Possible Solutions\r\n* For phone number lookup or purchase, please specify a valid phone number in E.164 format.\r\n* For adding a Phone Number to a Messaging Service, verify that the Phone Number SID or Short Code SID is correct and formatted properly, then retry the request. ',
    causes:
      '* You tried to purchase or lookup a phone number that is invalid.\r\n* You tried to add an invalid Phone Number SID or Short Code SID to a Messaging Service.',
    solutions:
      '* For phone number lookup or purchase, please specify a valid phone number in E.164 format.\r\n* For adding a Phone Number to a Messaging Service, verify that the Phone Number SID or Short Code SID is correct and formatted properly, then retry the request. ',
    description:
      'You tried to purchase or lookup a phone number that is invalid or add a phone number to a Messaging Service with an invalid Phone Number SID.',
    product: null,
    date_created: '2016-03-31T17:14:21Z',
    last_updated: '2021-05-28T19:14:26.612Z',
  },
  30127: {
    code: 30127,
    message: 'MessagingServiceSID is invalid.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30127\r\n\r\n### MessagingServiceSID is invalid.\r\n\r\n MessagingServiceSID is invalid.\r\n\r\n#### Possible Causes\r\nUser included an invalid MessagingServiceSID.\r\n\r\n#### Possible Solutions\r\nPlease follow doc for valid messaging service sid.',
    causes: 'User included an invalid MessagingServiceSID.',
    solutions: 'Please follow doc for valid messaging service sid.',
    description: 'MessagingServiceSID is invalid.',
    product: 'Programmable SMS',
    date_created: '2022-07-11T18:41:16Z',
    last_updated: '2022-07-11T18:41:16Z',
  },
  21259: {
    code: 21259,
    message: 'Maximum number of SIP Manipulation Polies per account reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21259\r\n\r\n### Maximum number of SIP Manipulation Polies per account reached\r\n\r\n Your account already has the maximum number of Sip Manipulation Policies allowed.\r\n\r\n#### Possible Causes\r\nThe number of Sip Manipulation Policies per account cannot exceed the limit. See https://www.twilio.com/docs/sip-trunking/sip-header-manipulation \r\n\r\n#### Possible Solutions\r\nRemove unused Sip Manipulation Policies.',
    causes:
      'The number of Sip Manipulation Policies per account cannot exceed the limit. See https://www.twilio.com/docs/sip-trunking/sip-header-manipulation ',
    solutions: 'Remove unused Sip Manipulation Policies.',
    description:
      'Your account already has the maximum number of Sip Manipulation Policies allowed.',
    product: 'Elastic SIP Trunking',
    date_created: '2021-09-16T19:34:08Z',
    last_updated: '2021-09-27T18:49:16.621862Z',
  },
  33000: {
    code: 33000,
    message: 'Generic Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 33000\r\n\r\n### Generic Error\r\n\r\n Your request has caused an error that is not further specified.\r\n\r\n#### Possible Causes\r\nAn unspecified error occurred while carrying out the request.\r\n\r\n#### Possible Solutions\r\nSee the [Debugger](https://www.twilio.com/console/debugger) in Console for further information. If this is a continuous experience, please contact Twilio Support.',
    causes: 'An unspecified error occurred while carrying out the request.',
    solutions:
      'See the [Debugger](https://www.twilio.com/console/debugger) in Console for further information. If this is a continuous experience, please contact Twilio Support.',
    description: 'Your request has caused an error that is not further specified.',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:10:50Z',
    last_updated: '2020-09-15T20:55:18.281Z',
  },
  53669: {
    code: 53669,
    message: 'Access denied to external S3 bucket configured in composition settings',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53669\r\n\r\n### Access denied to external S3 bucket configured in composition settings\r\n\r\n Failed to upload media to the external S3 bucket configured in your account's composition settings.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.\r\n\r\n#### Possible Causes\r\n* If you have specified your own bucket and access credentials, this is most likely due to the fact that the configuration is out of date.\r\n\r\n#### Possible Solutions\r\n * In the composition settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes:
      '* If you have specified your own bucket and access credentials, this is most likely due to the fact that the configuration is out of date.',
    solutions:
      " * In the composition settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    description:
      "Failed to upload media to the external S3 bucket configured in your account's composition settings.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.",
    product: 'Programmable Video',
    date_created: '2021-04-13T07:37:07Z',
    last_updated: '2021-04-13T07:37:07Z',
  },
  95200: {
    code: 95200,
    message: 'Status callback response error',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 95200\r\n\r\n### Status callback response error\r\n\r\n Twilio attempted to send a transcript event to the callback URL specified and your application returned a 4xx or 5xx or other HTTP response error\r\n\r\n#### Possible Causes\r\nThe callback URL specified is incorrect. Your application has an issue while handling callback requests or suffering and outage\r\n\r\n#### Possible Solutions\r\nEnsure that the callback URL specified is correct. Ensure that your callback server can handle the request and responds with a 2xx HTTP status code.',
    causes:
      'The callback URL specified is incorrect. Your application has an issue while handling callback requests or suffering and outage',
    solutions:
      'Ensure that the callback URL specified is correct. Ensure that your callback server can handle the request and responds with a 2xx HTTP status code.',
    description:
      'Twilio attempted to send a transcript event to the callback URL specified and your application returned a 4xx or 5xx or other HTTP response error',
    product: 'Voice Intelligence',
    date_created: '2024-04-18T16:38:39Z',
    last_updated: '2024-04-18T16:38:39Z',
  },
  83000: {
    code: 83000,
    message: 'Super SIM registration failed due to Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 83000\r\n\r\n### Super SIM registration failed due to Internal Error\r\n\r\n Your Super SIM registration request has caused an internal error that is not further specified.\r\n\r\n#### Possible Causes\r\nAn unspecified error occurred while registering your Super SIM.\r\n\r\n#### Possible Solutions\r\n* Retry to register your Super SIM.\r\n* If this is a continuous experience, please contact Twilio Support.',
    causes: 'An unspecified error occurred while registering your Super SIM.',
    solutions:
      '* Retry to register your Super SIM.\r\n* If this is a continuous experience, please contact Twilio Support.',
    description:
      'Your Super SIM registration request has caused an internal error that is not further specified.',
    product: 'Super SIM',
    date_created: '2021-03-21T23:58:07Z',
    last_updated: '2021-03-21T23:58:41.511Z',
  },
  16108: {
    code: 16108,
    message: 'Voice Recording: Request failed due to concurrent recordings',
    log_level: 'ERROR',
    secondary_message:
      'The request failed because there is more than one active recording for the provided CallSID',
    log_type: null,
    docs: '## Error - 16108\r\n\r\n### Voice Recording: Request failed due to concurrent recordings\r\n\r\nThe request failed because there is more than one active recording for the provided Call SID',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2018-03-28T22:05:11Z',
    last_updated: '2020-08-04T10:00:14.178Z',
  },
  50361: {
    code: 50361,
    message: 'Too many conversation webhooks',
    log_level: 'ERROR',
    secondary_message: 'The number of webhooks configured for this conversation exceeds the limit.',
    log_type: null,
    docs: '\n## Error - 50361\n\n### Conversations: Too many conversation webhooks\nThe limit for conversation-scoped webhooks is five; this request would have created a sixth, and is thus rejected.\n\n#### Possible Causes\nYou may have forgotten to remove other webhooks before adding this one. Alternatively, your use-case may include scenarios requiring more than five.\n\n#### Possible Solutions\n* Retrieve a list of the [existing webhooks](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#read-multiple-conversationscopedwebhook-resources) for this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#delete-a-conversationscopedwebhook-resource) the ones that are redundant or obsolete.\n* Consider combining some of the [existing webhooks](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#read-multiple-conversationscopedwebhook-resources) and forward events to a single destination.\n* Consider using [global webhooks](https://www.twilio.com/docs/conversations/api/conversation-webhook-resource) instead of conversation-scoped hooks.\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.821Z',
  },
  95118: {
    code: 95118,
    message: 'Twilio Recordings with external storage are not supported',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 95118\r\n\r\n### Twilio Recordings with external storage are not supported\r\n\r\n Voice Intelligence does not support Twilio Recordings with external storage\r\n\r\n#### Possible Causes\r\nTwilio Recordings use external storage\r\n\r\n#### Possible Solutions\r\nUse the MediaUrl parameter instead of the SourceSid when creating a Transcription',
    causes: 'Twilio Recordings use external storage',
    solutions: 'Use the MediaUrl parameter instead of the SourceSid when creating a Transcription',
    description: 'Voice Intelligence does not support Twilio Recordings with external storage',
    product: 'Voice Intelligence',
    date_created: '2024-05-30T16:57:02Z',
    last_updated: '2024-05-30T16:57:02Z',
  },
  21902: {
    code: 21902,
    message: 'InvoiceTag length must be between 0 and 32',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21902\r\n\r\n### InvoiceTag length must be between 0 and 32\r\n\r\n InvoiceTag length must be between 0 and 32\r\n\r\n#### Possible Causes\r\nInvoiceTag is too long\r\n\r\n#### Possible Solutions\r\nDecrease InvoiceTag length',
    causes: 'InvoiceTag is too long',
    solutions: 'Decrease InvoiceTag length',
    description: 'InvoiceTag length must be between 0 and 32',
    product: 'Programmable SMS',
    date_created: '2021-03-19T18:43:52Z',
    last_updated: '2021-03-19T18:43:52Z',
  },
  13312: {
    code: 13312,
    message: 'Gather: Invalid method value',
    log_level: 'WARNING',
    secondary_message:
      "The method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/gather#method'>Gather Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13312 \n\n### Gather: Invalid method value\n\nThe method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/gather#method'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:40Z',
    last_updated: '2020-08-04T10:00:28.143Z',
  },
  22204: {
    code: 22204,
    message: 'Bundle status and properties cannot be updated in the same request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22204\r\n\r\n### Bundle status and properties cannot be updated in the same request\r\n\r\n Bundle status and properties cannot be updated in the same request\r\n\r\n#### Possible Causes\r\nStatus update and a property update are in the same request\r\n\r\n#### Possible Solutions\r\nRemove the status update parameter or remove the property update(s) in the request.',
    causes: 'Status update and a property update are in the same request',
    solutions:
      'Remove the status update parameter or remove the property update(s) in the request.',
    description: 'Bundle status and properties cannot be updated in the same request',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:43:46Z',
    last_updated: '2020-08-04T10:00:05.638Z',
  },
  20429: {
    code: 20429,
    message: 'Too Many Requests',
    log_level: 'ERROR',
    secondary_message:
      'Your account is sending too many concurrent Rest API requests to Twilio servers.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 20429\r\n\r\n### Too Many Requests\r\n\r\nYour account is sending too many concurrent Rest API requests to Twilio servers. \r\n\r\n#### Possible Causes\r\nYour account is sending too many concurrent Rest API requests to Twilio servers.\r\n\r\n#### Possible Solutions\r\nAn API Request that receives an error 429 response is never processed and is always safe to retry.  Please wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API.\r\n\r\nFor more information, please review the 429 Error Response knowledge base article at [https://support.twilio.com/hc/en-us/articles/360044308153-Twilio-API-response-Error-429-Too-Many-Requests-](https://support.twilio.com/hc/en-us/articles/360044308153-Twilio-API-response-Error-429-Too-Many-Requests-)",
    causes: 'Your account is sending too many concurrent Rest API requests to Twilio servers.',
    solutions:
      "An API Request that receives an error 429 response is never processed and is always safe to retry.  Please wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API.\r\n\r\nFor more information, please review the 429 Error Response knowledge base article at [https://support.twilio.com/hc/en-us/articles/360044308153-Twilio-API-response-Error-429-Too-Many-Requests-](https://support.twilio.com/hc/en-us/articles/360044308153-Twilio-API-response-Error-429-Too-Many-Requests-)",
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:52Z',
    last_updated: '2020-08-04T10:00:27.373Z',
  },
  22113: {
    code: 22113,
    message: 'Phone Verification Incorrect',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22113\r\n\r\n#### Phone Verification Incorrect\r\n\r\nYou attempted to complete caller verification but the code you provided was incorrect. \r\n\r\n#### Possible Causes\r\n\r\n* You entered the code incorrectly in the request\r\n\r\n* The code you entered has expired\r\n\r\n#### Possible Solutions\r\n\r\n* Make another request to update Hosted Number Order instance to Status pending-verification to receive another verification code.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:59:12Z',
    last_updated: '2020-08-04T10:00:15.043Z',
  },
  30441: {
    code: 30441,
    message: 'Toll-Free phone number verification rejection - Disallowed: SHAFT - Sex',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30441\r\n\r\n### Toll-Free phone number verification rejection - Disallowed: SHAFT - Sex\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category - (SHAFT: Sex). \r\n\r\nTwilio does not allow Hate speech, harassment, exploitative, abusive, or any communications that originate from a hate group.\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category - (SHAFT: Sex). \r\n\r\nTwilio does not allow Hate speech, harassment, exploitative, abusive, or any communications that originate from a hate group.',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:07:20Z',
    last_updated: '2024-04-16T15:32:03.667057Z',
  },
  22203: {
    code: 22203,
    message: 'Unable to parse bundle status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 22203\r\n\r\n### Unable to parse bundle status\r\n\r\n Bundle Status provided by user didn't parse into the accepted enum valuesf\r\n\r\n#### Possible Causes\r\nBundle status is not a valid option from the enum values\r\n\r\n#### Possible Solutions\r\nRefer to the Bundle REST API status section for which statuses you are able to choose from.",
    causes: 'Bundle status is not a valid option from the enum values',
    solutions:
      'Refer to the Bundle REST API status section for which statuses you are able to choose from.',
    description: "Bundle Status provided by user didn't parse into the accepted enum valuesf",
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:42:45Z',
    last_updated: '2020-08-04T10:00:05.654Z',
  },
  50364: {
    code: 50364,
    message: 'Invalid conversation webhook type',
    log_level: 'ERROR',
    secondary_message: 'An invalid conversation webhook target was supplied.',
    log_type: null,
    docs: '\n## Error - 50364\n\n### Conversations: Invalid conversation webhook type\nAn invalid conversation webhook target was supplied.\n\n#### Possible Causes\n* Webhook Target parameter provided with the request does not match any of valid targets: webhook, studio, trigger.\n\n#### Possible Solutions\n* Add a valid Target parameter to the webhook API request and supply one of the supported targets.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.766Z',
  },
  30128: {
    code: 30128,
    message: 'MessagingServiceSidsAction is invalid',
    log_level: 'ERROR',
    secondary_message: 'MessagingServiceSidsAction is invalid, please check for valid action types',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30128\r\n\r\n### MessagingServiceSidsAction is invalid\r\n\r\nMessagingServiceSidsAction is invalid, please check for valid action types MessagingServiceSidAction is invalid\r\n\r\n#### Possible Causes\r\nOnly ADD, DELETE or REPLACE action types are allowed\r\n\r\n#### Possible Solutions\r\nTry to use any of the action types - ADD, DELETE, REPLACE',
    causes: 'Only ADD, DELETE or REPLACE action types are allowed',
    solutions: 'Try to use any of the action types - ADD, DELETE, REPLACE',
    description: 'MessagingServiceSidAction is invalid',
    product: 'Programmable SMS',
    date_created: '2022-07-08T12:03:04Z',
    last_updated: '2022-07-15T00:12:52.92634Z',
  },
  13521: {
    code: 13521,
    message: '`<Say>` element character limits exceeded',
    log_level: 'WARNING',
    secondary_message:
      'The maximum text length inside a `<Say>` verb is 4096 characters for basic TTS and 3000 characters for Polly voices.',
    log_type: 'APPLICATION',
    docs: "## WARNING - 13521\r\n\r\n### `<Say>` element character limits exceeded\r\n\r\n The maximum text length inside a <Say> verb is limited and varies depending on the option used. Basic, Polly and Google TTS have different limits and character count.  \r\nSee the <a href='/docs/voice/twiml/say#voice'>Say Verb</a> API Reference for more information.\r\n\r\n#### Possible Causes\r\nThe maximum text length inside the `<Say>` verb has been exceeded.\r\n\r\n#### Possible Solutions\r\nMake sure that the character limit is under the limit for the TTS type being used: \r\n\r\n* Basic TTS Voices are limited to 4096 UTF-8 single byte characters\r\n* Polly TTS Voices are limited to 3000 UTF-8 single byte characters; note that SSML tags do not contribute to the character count\r\n* Google TTS Voices are limited to 5000 UTF-8 single byte characters; note that SSML tags, newlines and spaces contribute to the character count\r\n* The URL-encoded string cannot exceed 4500 characters\r\n\r\n",
    causes: 'The maximum text length inside the `<Say>` verb has been exceeded.',
    solutions:
      'Make sure that the character limit is under the limit for the TTS type being used: \r\n\r\n* Basic TTS Voices are limited to 4096 UTF-8 single byte characters\r\n* Polly TTS Voices are limited to 3000 UTF-8 single byte characters; note that SSML tags do not contribute to the character count\r\n* Google TTS Voices are limited to 5000 UTF-8 single byte characters; note that SSML tags, newlines and spaces contribute to the character count\r\n* The URL-encoded string cannot exceed 4500 characters\r\n\r\n',
    description:
      "The maximum text length inside a <Say> verb is limited and varies depending on the option used. Basic, Polly and Google TTS have different limits and character count.  \r\nSee the <a href='/docs/voice/twiml/say#voice'>Say Verb</a> API Reference for more information.",
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:43Z',
    last_updated: '2023-06-23T10:54:45.042824Z',
  },
  50068: {
    code: 50068,
    message: 'Programmable Chat: Service instance unique name invalid',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correctly formatted service instance unique name',
    log_type: null,
    docs: '## Error - 50068\r\n\r\n### Programmable Chat: Service instance unique name invalid\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted service instance unique name\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid service instance unique name is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-10-10T11:03:15Z',
    last_updated: '2020-08-04T10:00:12.235Z',
  },
  60228: {
    code: 60228,
    message: 'Template was not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60228\r\n\r\n### Template was not found\r\n\r\n ## Error - 60228\r\n\r\n### Invalid Parameter\r\n\r\nThe selected template was not found\r\n\r\n#### Possible Causes\r\nThe user has provide a TemplateSid that was not found\r\n\r\n#### Possible Solutions\r\nProvide a TemplateSid that exists',
    causes: 'The user has provide a TemplateSid that was not found',
    solutions: 'Provide a TemplateSid that exists',
    description:
      '## Error - 60228\r\n\r\n### Invalid Parameter\r\n\r\nThe selected template was not found',
    product: 'Verify',
    date_created: '2022-08-30T18:44:09Z',
    last_updated: '2022-08-30T18:44:09Z',
  },
  51202: {
    code: 51202,
    message: 'Twilsock : CPS, Too many requests',
    log_level: 'ERROR',
    secondary_message: 'Too many requests',
    log_type: null,
    docs: 'Too many requests',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-05-03T11:46:20Z',
    last_updated: '2020-08-04T10:00:09.098Z',
  },
  25005: {
    code: 25005,
    message: "The provided user's username is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25005\r\n\r\n### The provided user's username is invalid\r\n\r\n The provided user's username is invalid.\r\n\r\n#### Possible Causes\r\nThe username is either less than 2 characters or exceeds 255 characters.\r\n\r\n#### Possible Solutions\r\nEnsure the user's username is between 2 and 255 characters in length.",
    causes: 'The username is either less than 2 characters or exceeds 255 characters.',
    solutions: "Ensure the user's username is between 2 and 255 characters in length.",
    description: "The provided user's username is invalid.",
    product: 'Organizations API',
    date_created: '2023-12-04T09:50:06Z',
    last_updated: '2023-12-04T14:14:07.648991Z',
  },
  16113: {
    code: 16113,
    message: 'Voice Recording: Cannot download a dual-channel presentation of a mono recording',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 16113\r\n\r\n### Voice Recording: Cannot download a dual-channel presentation of a mono recording\r\n\r\n A recording created as a mono recording cannot be downloaded as a dual-channel audio file.\r\n\r\n#### Possible Causes\r\n* The recording was requested as a mono recording upon creation\r\n\r\n#### Possible Solutions\r\n* Retry download without specifying a channel count',
    causes: '* The recording was requested as a mono recording upon creation',
    solutions: '* Retry download without specifying a channel count',
    description:
      'A recording created as a mono recording cannot be downloaded as a dual-channel audio file.',
    product: 'Programmable Voice',
    date_created: '2022-02-16T20:58:58Z',
    last_updated: '2022-02-16T20:58:58Z',
  },
  15009: {
    code: 15009,
    message: 'Internal Server Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 15009\r\n\r\n### Internal Server Error\r\n\r\n The requested resource failed to complete the request.\r\n\r\n#### Possible Causes\r\nThe requested resource failed to complete the request.\r\n\r\n#### Possible Solutions\r\nThe request should be retried using exponential backoff strategy until it succeeds.',
    causes: 'The requested resource failed to complete the request.',
    solutions:
      'The request should be retried using exponential backoff strategy until it succeeds.',
    description: 'The requested resource failed to complete the request.',
    product: 'Programmable Voice',
    date_created: '2020-09-29T19:34:40Z',
    last_updated: '2020-09-29T19:34:40Z',
  },
  60232: {
    code: 60232,
    message: 'Sender id does not exist',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60232\r\n\r\n### Sender id does not exist\r\n\r\n Sender id does not exist\r\n\r\n#### Possible Causes\r\nThe sender id used in the request does not exist\r\n\r\n#### Possible Solutions\r\nUse a sender id that exists for the given account',
    causes: 'The sender id used in the request does not exist',
    solutions: 'Use a sender id that exists for the given account',
    description: 'Sender id does not exist',
    product: 'Verify',
    date_created: '2023-05-24T16:51:18Z',
    last_updated: '2023-05-24T16:51:18Z',
  },
  53217: {
    code: 53217,
    message: 'maxAudioTracks or maxVideoTracks configuration is out of range',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53217\r\n\r\n### maxAudioTracks or maxVideoTracks configuration is out of range\r\n\r\n The configuration value provided for maxVideoTracks or maxAudioTracks in the bandwidthProfile options is out of range\r\n\r\n#### Possible Causes\r\nThe provided configuration for maxAudioTracks or maxVideoTracks is out of range\r\n\r\n#### Possible Solutions\r\nUse a valid value for maxVideoTracks and maxAudioTracks',
    causes: 'The provided configuration for maxAudioTracks or maxVideoTracks is out of range',
    solutions: 'Use a valid value for maxVideoTracks and maxAudioTracks',
    description:
      'The configuration value provided for maxVideoTracks or maxAudioTracks in the bandwidthProfile options is out of range',
    product: 'Programmable Video',
    date_created: '2022-08-03T07:25:07Z',
    last_updated: '2022-08-09T15:29:27.600572Z',
  },
  18022: {
    code: 18022,
    message: 'Please provide latest document for address proof document.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18022\r\n\r\n### Please provide latest document for address proof document.\r\n\r\n The address document you shared is outdated.\r\n\r\n#### Possible Causes\r\nThe address document you shared is older than three months.\r\n\r\n#### Possible Solutions\r\n- If you are an individual, please share the document issued in the last three months.\r\n- If you are a business, please share the document issued within the last year. ',
    causes: 'The address document you shared is older than three months.',
    solutions:
      '- If you are an individual, please share the document issued in the last three months.\r\n- If you are a business, please share the document issued within the last year. ',
    description: 'The address document you shared is outdated.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:16:29Z',
    last_updated: '2024-07-04T10:16:29Z',
  },
  10005: {
    code: 10005,
    message: 'Voice calling has been disabled for this account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 10005\r\n\r\n### Voice calling has been disabled for this account\r\n\r\n Voice calling has been disabled for this account. \r\n\r\n#### Possible Causes\r\nYour account may have been flagged for review.\r\n\r\n#### Possible Solutions\r\nPlease reach out to Support for assistance. ',
    causes: 'Your account may have been flagged for review.',
    solutions: 'Please reach out to Support for assistance. ',
    description: 'Voice calling has been disabled for this account. ',
    product: 'Programmable Voice',
    date_created: '2023-09-05T16:31:53Z',
    last_updated: '2023-09-05T16:40:45.727161Z',
  },
  83702: {
    code: 83702,
    message: 'Attachment Rejected Due To Network Not Allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 83702\r\n\r\n### Attachment Rejected Due To Network Not Allowed\r\n\r\n The SIM could not to attach to the specified Network, either because its Fleet's Network Access Profile did not allow the Network or because Twilio has blocked the IMSI currently being used from attaching to the Network.\r\n\r\n#### Possible Causes\r\n * The Network Access Profile associated with this SIM's Fleet has blocked access to this Network.\r\n * Twilio has disabled this Network for all SIMs.\r\n\r\n#### Possible Solutions\r\n * Check the Network Access Profile associated with the SIM and enable the Network if you would like to use it.",
    causes:
      " * The Network Access Profile associated with this SIM's Fleet has blocked access to this Network.\r\n * Twilio has disabled this Network for all SIMs.",
    solutions:
      ' * Check the Network Access Profile associated with the SIM and enable the Network if you would like to use it.',
    description:
      "The SIM could not to attach to the specified Network, either because its Fleet's Network Access Profile did not allow the Network or because Twilio has blocked the IMSI currently being used from attaching to the Network.",
    product: 'Super SIM',
    date_created: '2022-07-21T14:23:23Z',
    last_updated: '2022-07-21T14:27:21.133622Z',
  },
  60326: {
    code: 60326,
    message: 'Too many requests to create factors for the entity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60326\r\n\r\n### Too many requests to create factors for the entity\r\n\r\n * Too many requests to create factors for the entity\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\n* This entity tried to create more than 100 factors per day\r\n\r\n#### Possible Solutions\r\nTry again 24h later',
    causes: '* This entity tried to create more than 100 factors per day',
    solutions: 'Try again 24h later',
    description: '* Too many requests to create factors for the entity\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2022-02-16T18:37:04Z',
    last_updated: '2022-02-18T16:02:09.401313Z',
  },
  25017: {
    code: 25017,
    message: 'The email domain is unverified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25017\r\n\r\n### The email domain is unverified\r\n\r\n The email domain is unverified.\r\n\r\n#### Possible Causes\r\nUser creation is attempted with an email domain that is not verified by the organization.\r\n\r\n#### Possible Solutions\r\n- Verify the domain associated with the user in twilio.com.\r\n- User creation is only allowed with domains that have been verified.',
    causes:
      'User creation is attempted with an email domain that is not verified by the organization.',
    solutions:
      '- Verify the domain associated with the user in twilio.com.\r\n- User creation is only allowed with domains that have been verified.',
    description: 'The email domain is unverified.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:40:47Z',
    last_updated: '2023-12-04T14:22:40.519127Z',
  },
  30037: {
    code: 30037,
    message: 'Outbound Messaging Disabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30037\r\n\r\n### Outbound Messaging Disabled\r\n\r\n Sending messages from this account has been disabled.\r\n\r\n#### Possible Causes\r\nThis account is configured to not send outbound messages.\r\n\r\n#### Possible Solutions\r\nIf you believe this configuration is in error you can [contact support](https://support.twilio.com/hc/en-us/articles/360048500694-Contacting-Twilio-Support) to adjust the account configuration.',
    causes: 'This account is configured to not send outbound messages.',
    solutions:
      'If you believe this configuration is in error you can [contact support](https://support.twilio.com/hc/en-us/articles/360048500694-Contacting-Twilio-Support) to adjust the account configuration.',
    description: 'Sending messages from this account has been disabled.',
    product: 'Programmable SMS',
    date_created: '2023-06-02T15:29:31Z',
    last_updated: '2023-10-31T10:21:22.907176Z',
  },
  45002: {
    code: 45002,
    message: 'Authentication Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45002\r\n\r\n### Authentication Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nAttempt to access resource with invalid credentials or without credentials.\r\n\r\n#### Possible Solutions\r\nCheck the credentials and try again.',
    causes: 'Attempt to access resource with invalid credentials or without credentials.',
    solutions: 'Check the credentials and try again.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:49:49Z',
    last_updated: '2020-08-04T10:00:12.468Z',
  },
  52149: {
    code: 52149,
    message: 'Invalid APNs provider token used',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52149\r\n\r\n### Invalid APNs provider token used\r\n\r\n#### Possible Causes \r\n* The APNs provider token is malformed or otherwise incorrect\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-04-04T10:02:19Z',
    last_updated: '2020-08-04T10:00:13.976Z',
  },
  22214: {
    code: 22214,
    message: 'Missing End User',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22214\r\n\r\n### Missing End User\r\n\r\n An End User is missing from the regulatory bundle\r\n\r\n#### Possible Causes\r\nThe Regulation requires an end-user which is missing from the regulatory bundle you are attempting to evaluate.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Regulations API to ensure that the End User satisfying the requirement is in the regulatory bundle.',
    causes:
      'The Regulation requires an end-user which is missing from the regulatory bundle you are attempting to evaluate.',
    solutions:
      'Please refer to the Regulations API to ensure that the End User satisfying the requirement is in the regulatory bundle.',
    description: 'An End User is missing from the regulatory bundle',
    product: 'Phone Numbers',
    date_created: '2020-04-23T21:53:57Z',
    last_updated: '2020-08-04T10:00:03.779Z',
  },
  30465: {
    code: 30465,
    message:
      'Toll Free verification rejection - Disallowed: Risk Investment/Get Rich Quick Schemes',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30465\r\n\r\n### Toll Free verification rejection - Disallowed: Risk Investment/Get Rich Quick Schemes\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Get Rich Quick Schemes: Risk Investment). \r\n\r\n\r\nUse cases in this category pertain to minimal effort for maximum and/or guaranteed financial gains. These categories in the telecoms industry produce high consumer complaints and are not permissible on carrier routes.\r\n\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Get Rich Quick Schemes: Risk Investment). \r\n\r\n\r\nUse cases in this category pertain to minimal effort for maximum and/or guaranteed financial gains. These categories in the telecoms industry produce high consumer complaints and are not permissible on carrier routes.\r\n',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:12:10Z',
    last_updated: '2024-02-22T21:12:10Z',
  },
  22209: {
    code: 22209,
    message: 'Invalid status enum in Supporting Document update request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22209\r\n\r\n### Invalid status enum in Supporting Document update request\r\n\r\n An invalid status enum was sent in an update Supporting Document reques\r\n\r\n#### Possible Causes\r\nThe status enum may be malformed or incorrect.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Supporting Documents REST Public API documentation for the update instance resource to pick from an allowed status enum list.',
    causes: 'The status enum may be malformed or incorrect.',
    solutions:
      'Please refer to the Supporting Documents REST Public API documentation for the update instance resource to pick from an allowed status enum list.',
    description: 'An invalid status enum was sent in an update Supporting Document reques',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:47:32Z',
    last_updated: '2020-08-04T10:00:05.544Z',
  },
  35127: {
    code: 35127,
    message: "'Messages' Body and ContentVariables cannot be provided together",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 35127\r\n\r\n### 'Messages' Body and ContentVariables cannot be provided together\r\n\r\n You provided a 'Messages' Body and 'ContentVariables' parameters in your request, which would lead to a conflict. Please provide only one of these. \r\n\r\n#### Possible Causes\r\nYou provided both a 'Messages' Body and 'ContentVariables' parameters in your request\r\n\r\n#### Possible Solutions\r\nSpecify only one of the both parameters in your request",
    causes: "You provided both a 'Messages' Body and 'ContentVariables' parameters in your request",
    solutions: 'Specify only one of the both parameters in your request',
    description:
      "You provided a 'Messages' Body and 'ContentVariables' parameters in your request, which would lead to a conflict. Please provide only one of these. ",
    product: 'Programmable Messaging',
    date_created: '2023-05-30T22:18:35Z',
    last_updated: '2023-06-05T15:24:19.524809Z',
  },
  50701: {
    code: 50701,
    message: 'Only one Virtual Agent participant is allowed per conversation.',
    log_level: 'ERROR',
    secondary_message: 'Only one Virtual Agent participant is allowed per conversation.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50701\r\n\r\n### Only one Virtual Agent participant is allowed per conversation.\r\n\r\nOnly one Virtual Agent participant is allowed per conversation. \r\n\r\n#### Possible Causes\r\nThere is already a Virtual Agent participant in the conversation.\r\n\r\n#### Possible Solutions\r\n* Remove existing Virtual Agent participant from the conversation before adding new one.',
    causes: 'There is already a Virtual Agent participant in the conversation.',
    solutions:
      '* Remove existing Virtual Agent participant from the conversation before adding new one.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T17:58:23Z',
    last_updated: '2023-10-11T17:58:27.78669Z',
  },
  50415: {
    code: 50415,
    message: 'Proxy address is not WhatsApp enabled sender',
    log_level: 'ERROR',
    secondary_message:
      'The requested participant proxy address is not a correctly configured WhatsApp number.',
    log_type: null,
    docs: '\n## Error - 50415\n\n### Conversations: Proxy address is not WhatsApp enabled sender\nThe requested participant proxy address is not a correctly configured WhatsApp number.\n\n#### Possible Causes\n* Provided MessagingBinding.ProxyAddress parameter contains a participant number that is not recognized as a valid WhatsApp number.\n\n#### Possible Solutions\n* Ensure that MessagingBinding.ProxyAddress is an [on-boarded WhatsApp number](https://www.twilio.com/docs/sms/whatsapp/api) assigned to your number pool.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.438Z',
  },
  63045: {
    code: 63045,
    message: 'Link to a sample media file returned an unexpected error status',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63045\r\n\r\n### Link to a sample media file returned an unexpected error status\r\n\r\n The link returned an unexpected status code, making it impossible to retrieve the file.\r\n\r\n#### Possible Causes\r\n- The server that hosts the sample media file is not able to return the data\r\n\r\n#### Possible Solutions\r\n- Confirm that the link is correct\r\n- See if the link can be accessed in your browser',
    causes: '- The server that hosts the sample media file is not able to return the data',
    solutions:
      '- Confirm that the link is correct\r\n- See if the link can be accessed in your browser',
    description:
      'The link returned an unexpected status code, making it impossible to retrieve the file.',
    product: 'Programmable Messaging',
    date_created: '2023-03-24T16:35:10Z',
    last_updated: '2023-03-24T16:35:10Z',
  },
  30032: {
    code: 30032,
    message: 'Toll-Free Number Has Not Been Verified',
    log_level: 'ERROR',
    secondary_message: 'Toll-Free Verification Required. ',
    log_type: 'CARRIER',
    docs: '## ERROR - 30032\r\n\r\n### Toll-Free Number Has Not Been Verified\r\n\r\nToll-Free Verification Required.  You sent a message (message SID: SMXXXXX) from a Toll-Free number to a mobile subscriber in USA or Canada. Twilio requires all Toll-Free numbers to go through a verification process. The Toll-Free number you sent from has not been verified through the required verification process.\r\n\r\n#### Possible Causes\r\n*Your toll-free number has not been Verified to allow sending of traffic in USA and Canada.  \r\n\r\n*Your toll-free verification submission was rejected. \r\n\r\n\r\n#### Possible Solutions\r\nPlease refer to this [Support Article](https://support.twilio.com/hc/en-us/articles/5377174717595-Toll-Free-Message-Verification-for-US-Canada) for the process to get your Toll Free number verified. \r\n\r\nEffective Nov 8th, 2023, messages on restricted toll-free phone numbers are blocked.\r\nEffective Jan 31st, 2024, messages on pending toll-free phone numbers are blocked.\r\n\r\nToll-Free best practices can be found [here](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    causes:
      '*Your toll-free number has not been Verified to allow sending of traffic in USA and Canada.  \r\n\r\n*Your toll-free verification submission was rejected. \r\n',
    solutions:
      'Please refer to this [Support Article](https://support.twilio.com/hc/en-us/articles/5377174717595-Toll-Free-Message-Verification-for-US-Canada) for the process to get your Toll Free number verified. \r\n\r\nEffective Nov 8th, 2023, messages on restricted toll-free phone numbers are blocked.\r\nEffective Jan 31st, 2024, messages on pending toll-free phone numbers are blocked.\r\n\r\nToll-Free best practices can be found [here](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    description:
      'You sent a message (message SID: SMXXXXX) from a Toll-Free number to a mobile subscriber in USA or Canada. Twilio requires all Toll-Free numbers to go through a verification process. The Toll-Free number you sent from has not been verified through the required verification process.',
    product: 'Programmable SMS',
    date_created: '2022-05-09T19:02:25Z',
    last_updated: '2023-11-09T04:34:46.999129Z',
  },
  32220: {
    code: 32220,
    message: 'Specifying an edge is not allowed when dialing SIP registered endpoints',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR -  32220\r\n\r\n### Specifying an edge is not allowed when dialing SIP registered endpoints\r\n\r\n Twilio SIP domains allow endpoints to register through any supported SIP edge location. When dialing a registered endpoint, Twilio will fork the call to _all_ SIP devices registered under the same username/domain. Dialing one of your SIP domain's localized URIs (such as yourdomain.sip.ashburn.twilio.com) is not supported.\r\n\r\n#### Possible Causes\r\n* Attempting to place a call to username@yourdomain.sip.*ashburn*.twilio.com, or any other edge variant (e.g. ashburn-ix, umatilla, sydney, etc.)\r\n* Note that existing registration customers dialing yourdomain.sip.us1.twilio.com or yourdomain.sip.us1-ix.twilio.com _are_ allowed (although this behavior is deprecated).\r\n\r\n#### Possible Solutions\r\n* Dial the global URI for your SIP domain, e.g. username@yourdomain.sip.twilio.com.",
    causes:
      '* Attempting to place a call to username@yourdomain.sip.*ashburn*.twilio.com, or any other edge variant (e.g. ashburn-ix, umatilla, sydney, etc.)\r\n* Note that existing registration customers dialing yourdomain.sip.us1.twilio.com or yourdomain.sip.us1-ix.twilio.com _are_ allowed (although this behavior is deprecated).',
    solutions:
      '* Dial the global URI for your SIP domain, e.g. username@yourdomain.sip.twilio.com.',
    description:
      "Twilio SIP domains allow endpoints to register through any supported SIP edge location. When dialing a registered endpoint, Twilio will fork the call to _all_ SIP devices registered under the same username/domain. Dialing one of your SIP domain's localized URIs (such as yourdomain.sip.ashburn.twilio.com) is not supported.",
    product: 'Programmable Voice',
    date_created: '2020-11-11T00:18:36Z',
    last_updated: '2020-11-11T00:18:36Z',
  },
  50212: {
    code: 50212,
    message: 'Programmable Chat: User already invited',
    log_level: 'ERROR',
    secondary_message: 'User with specified Identity already invited to this Channel',
    log_type: 'TWILIO',
    docs: '## ERROR - 50212\r\n\r\n### Programmable Chat: User already invited\r\n\r\nUser with specified Identity already invited to this Channel \r\n\r\n#### Possible Causes\r\nUser with specified Identity already invited to this Channel.\r\n\r\n#### Possible Solutions\r\nConfirm that the Identity passed in the request is not already invited to the intended channel.',
    causes: 'User with specified Identity already invited to this Channel.',
    solutions:
      'Confirm that the Identity passed in the request is not already invited to the intended channel.',
    description: null,
    product: 'Programmable Chat',
    date_created: '2019-11-20T09:34:19Z',
    last_updated: '2020-08-04T10:00:06.013Z',
  },
  40151: {
    code: 40151,
    message: 'TaskRouter->Invalid instruction',
    log_level: 'ERROR',
    secondary_message:
      'Invalid instruction issued on a task being transferred. Valid instructions are: ACCEPT, REJECT, CONFERENCE, SUPERVISE',
    log_type: null,
    docs: '## Error - 40151\r\n\r\n### Call API Error - Invalid instruction issued on a task being transferred\r\n\r\n#### Possible Causes \r\n*  Instruction is not acceptable for transferred tasks \r\n*  Internal Twilio API error. \r\n\r\n#### Possible Solutions\r\n*  Make certain that instruction is accept, reject, conference, or supervise\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2018-12-04T05:30:07Z',
    last_updated: '2020-08-04T10:00:11.627Z',
  },
  13340: {
    code: 13340,
    message: 'Gather: Degraded Speech ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 13340\r\n\r\n### Gather: Degraded Speech \r\n\r\n We are sorry for the inconvenience. You may be experiencing degraded <Gather> speech i.e. gather with input="speech dtmf" or input="speech".\r\n\r\n#### Possible Causes\r\nInternal Causes\r\n\r\n#### Possible Solutions\r\nPlease check Twilio\'s status page to see if engineers are currently working on resolving the issue. ',
    causes: 'Internal Causes',
    solutions:
      "Please check Twilio's status page to see if engineers are currently working on resolving the issue. ",
    description:
      'We are sorry for the inconvenience. You may be experiencing degraded <Gather> speech i.e. gather with input="speech dtmf" or input="speech".',
    product: 'Programmable Voice',
    date_created: '2022-03-25T15:37:16Z',
    last_updated: '2022-03-25T15:37:16Z',
  },
  30797: {
    code: 30797,
    message:
      'Brand Registration Feedback: Non government entity registered as a government entity. Must be a U.S. government entity.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30797\r\n\r\n### Brand Registration Feedback: Non government entity registered as a government entity. Must be a U.S. government entity.\r\n\r\n Your Brand has received feedback from The Campaign Registry upon registration. This Brand Registration can not be used for campaign creation until the provided feedback has been addressed. In this particular case, a non-government entity has been registered as a government entity. The entity registering the brand must be a U.S. government entity.\r\n\r\n#### Possible Causes\r\n* The submitted company is not a US entity. Only US entities qualify for the Government Entity Type. \r\n* The company’s submission as a Government Entity type could not be confirmed from independent sources. \r\n\r\n\r\n#### Possible Solutions\r\nPlease change the entity_type field value to something other than Government. If you are a US Entity, please update the customer profile address to indicate the same.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n',
    causes:
      '* The submitted company is not a US entity. Only US entities qualify for the Government Entity Type. \r\n* The company’s submission as a Government Entity type could not be confirmed from independent sources. \r\n',
    solutions:
      'Please change the entity_type field value to something other than Government. If you are a US Entity, please update the customer profile address to indicate the same.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n',
    description:
      'Your Brand has received feedback from The Campaign Registry upon registration. This Brand Registration can not be used for campaign creation until the provided feedback has been addressed. In this particular case, a non-government entity has been registered as a government entity. The entity registering the brand must be a U.S. government entity.',
    product: 'Programmable Messaging',
    date_created: '2024-02-28T16:31:38Z',
    last_updated: '2024-06-04T15:39:37.795325Z',
  },
  53501: {
    code: 53501,
    message: 'Unable to acquire TURN credentials',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53501: Unable to acquire TURN credentials\r\n\r\nRaised whenever the Server is unable to return TURN credentials to the Client\r\n\r\n#### Causes\r\n\r\n* A server-side error has occurred.\r\n\r\n#### Solutions\r\n\r\n * If the problem persists, try connecting to another region.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-06-05T17:36:49Z',
    last_updated: '2020-08-04T10:00:18.372Z',
  },
  22404: {
    code: 22404,
    message: 'Starter profile creation and updates are temporarily disabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22404\r\n\r\n### Starter profile creation and updates are temporarily disabled\r\n\r\n Starter profiles cannot be created or updated at this time. Contact support for help.\r\n\r\n#### Possible Causes\r\nThe profile you are trying to create/update is a Starter profile. See [New Requirements for A2P 10DLC Registrations](https://www.twilio.com/blog/new-requirements-for-a2p-10dlc-registrations) for more info.\r\n\r\n#### Possible Solutions\r\nContact Twilio support.',
    causes:
      'The profile you are trying to create/update is a Starter profile. See [New Requirements for A2P 10DLC Registrations](https://www.twilio.com/blog/new-requirements-for-a2p-10dlc-registrations) for more info.',
    solutions: 'Contact Twilio support.',
    description:
      'Starter profiles cannot be created or updated at this time. Contact support for help.',
    product: 'Phone Numbers',
    date_created: '2022-09-22T09:44:31Z',
    last_updated: '2022-09-30T09:59:43.868302Z',
  },
  53603: {
    code: 53603,
    message: 'Internal failure while processing a recording',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 53603\r\n\r\n### Internal failure while processing a recording\r\n\r\nRaised when an internal error prevents us from processing the recording.\r\n\r\n#### Causes\r\n\r\n * We screwed up. Sorry!\r\n\r\n#### Solutions\r\n\r\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n*   Note the time of the error and what you were trying to do when it occurred!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:37:53Z',
    last_updated: '2020-08-04T10:00:14.741Z',
  },
  50600: {
    code: 50600,
    message: 'Programmable Chat: Invite SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Invite SID parameter.',
    log_type: null,
    docs: '## Error - 50600\r\n\r\n### Programmable Chat: Invite SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Invite SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Invite SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:54Z',
    last_updated: '2020-08-04T10:00:22.916Z',
  },
  30885: {
    code: 30885,
    message: 'Campaign vetting rejection - High Risk',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30885\r\n\r\n### Campaign vetting rejection - High Risk\r\n\r\n The campaign submission has been reviewed and it was rejected because it is considered High Risk.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because it is considered Fraud or Deceptive Marketing.\r\n\r\n#### Possible Solutions\r\nThe rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada ) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because it is considered Fraud or Deceptive Marketing.',
    solutions:
      'The rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada ) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because it is considered High Risk.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:35:06Z',
    last_updated: '2023-04-18T11:35:06Z',
  },
  93103: {
    code: 93103,
    message: 'There was an error with your Kinesis stream',
    log_level: 'ERROR',
    secondary_message: 'The Kinesis Stream associated with this Sink is having issues.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 93103\r\n\r\n### There was an error with your Kinesis stream\r\n\r\nThe Kinesis Stream associated with this Sink is having issues. Event Streams is unable to write to the Kinesis Stream\r\n\r\n#### Possible Causes\r\nSee Error Message for more details\r\n\r\n#### Possible Solutions\r\nCheck your Kinesis Stream and ensure it is configured correctly for the load of events you are subscribed too,  Check to see if there is an AWS outage with Kinesis streams.',
    causes: 'See Error Message for more details',
    solutions:
      'Check your Kinesis Stream and ensure it is configured correctly for the load of events you are subscribed too,  Check to see if there is an AWS outage with Kinesis streams.',
    description: 'Event Streams is unable to write to the Kinesis Stream',
    product: 'Events',
    date_created: '2021-01-13T18:27:03Z',
    last_updated: '2021-02-04T17:35:21.006Z',
  },
  54301: {
    code: 54301,
    message: 'Unique name already exists',
    log_level: 'ERROR',
    secondary_message: 'An object with the specified unique name already exists.',
    log_type: null,
    docs: '\n## Error - 54301\n\n### Sync: Unique name already exists\nAn object with the specified unique name already exists.\n\n#### Possible Causes\n* Another object with the matching Unique Name already exists in this Sync Service Instance, causing a conflict.\n* The provided UniqueName parameter is not set correctly.\n* Your original Sync object creation request has been sent more than once due to a retrier error.\n\n#### Possible Solutions\n* Confirm a valid UniqueName parameter is being passed in request, matching your expectation.\n* Delete a previous object with the matching Unique Name if you no longer need it.\n* Pick a different Unique Name, or create an anonymous object addressed by a SID instead.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.325Z',
  },
  30894: {
    code: 30894,
    message: 'Campaign vetting rejection - Invalid Brand Information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30894\r\n\r\n### Campaign vetting rejection - Invalid Brand Information\r\n\r\n The campaign submission has been reviewed and it was rejected because invalid brand information.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because registration needs to be associated with the brand behind the campaign. If you are an ISV registering a direct offering, campaign description needs to indicate a direct offering.\r\n\r\n#### Possible Solutions\r\nPlease verify that the brand information is valid. Resubmit campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because registration needs to be associated with the brand behind the campaign. If you are an ISV registering a direct offering, campaign description needs to indicate a direct offering.',
    solutions:
      'Please verify that the brand information is valid. Resubmit campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because invalid brand information.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:41:54Z',
    last_updated: '2023-04-18T11:41:54Z',
  },
  22119: {
    code: 22119,
    message: 'Invalid Capabilities',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "## Error - 22119\r\n\r\n#### Invalid Capabilities\r\n\r\nThe SMS Capability you specified for your Hosted Number Order was not valid.\r\n\r\n#### Possible Solutions\r\n\r\nPlease explicitly specify SMS as the capability to host on Twilio's platform by setting SMS Capability to true.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-07T21:41:49Z',
    last_updated: '2020-08-04T10:00:14.924Z',
  },
  21471: {
    code: 21471,
    message: 'Account does not exist',
    log_level: 'ERROR',
    secondary_message:
      'The AccountSid you specified does not exist. AccountSids are 34 character strings that represent the Twilio Account.  For example, AC44CE4123947237834573457345347567.',
    log_type: null,
    docs: '## Error - 21471\r\n\r\n### Account does not exist\r\n\r\nThe AccountSid you specified does not exist.  AccountSids are 34 character strings that represent the Twilio Account.  For example, AC44CE4123947237834573457345347567.\r\n\r\n\r\n\r\n\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:22Z',
    last_updated: '2020-08-04T10:00:25.371Z',
  },
  70253: {
    code: 70253,
    message: 'Invalid User Grants',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70253\r\n\r\n### Invalid User Grants\r\nThe Request tries to authenticate through SSO. The request is well-formed, but the user grants stored is not a valid grants form.\r\n\r\n#### Possible Causes \r\n* Invalid User Grants.\r\n\r\n#### Possible Solution\r\n* Reconfigure the user grants and retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-07-26T21:31:58Z',
    last_updated: '2020-08-04T10:00:12.841Z',
  },
  18038: {
    code: 18038,
    message: 'Missing name of the Authorized Representative.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18038\r\n\r\n### Missing name of the Authorized Representative.\r\n\r\n The name of the Authorized Representative is missing.\r\n\r\n#### Possible Causes\r\nThe first and/or the last name of the company’s Authorized Representative has not been provided.\r\n\r\n#### Possible Solutions\r\nPlease provide the first and last name of the company’s Authorized Representative.',
    causes:
      'The first and/or the last name of the company’s Authorized Representative has not been provided.',
    solutions: 'Please provide the first and last name of the company’s Authorized Representative.',
    description: 'The name of the Authorized Representative is missing.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:55:54Z',
    last_updated: '2024-07-04T09:55:54Z',
  },
  90012: {
    code: 90012,
    message: "'Recipients' list has too many items [deprecated] ",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90012\r\n\r\n### 'Recipients' list has too many items [deprecated] \r\n\r\n 'Recipients' list has too many items\r\n\r\n#### Possible Causes\r\nToo many recipients are provided for a single Broadcast\r\n\r\n#### Possible Solutions\r\nSplit the broadcast to several parts where each part has smaller number of recipients than allowed",
    causes: 'Too many recipients are provided for a single Broadcast',
    solutions:
      'Split the broadcast to several parts where each part has smaller number of recipients than allowed',
    description: "'Recipients' list has too many items",
    product: null,
    date_created: '2020-12-11T09:40:31Z',
    last_updated: '2023-05-30T20:57:23.816396Z',
  },
  17400: {
    code: 17400,
    message: 'Invalid query parameter',
    log_level: 'ERROR',
    secondary_message: 'Invalid query parameter',
    log_type: 'APPLICATION',
    docs: '## ERROR - 17400\r\n\r\n### Invalid query parameter\r\n\r\nInvalid query parameter Invalid query parameter has been passed in the request.\r\n\r\n#### Possible Causes\r\nInvalid format for country code, SIP URI, Client address, or phone number. Wildcard searches.\r\n\r\n#### Possible Solutions\r\nUtilize only two-character country code; e.g. US\r\nDo not attempt wildcard searches; e.g. from=+1206*\r\nUse E.164 address format for telephone numbers; e.g. +14258675309\r\nUse SIP URI format; e.g. sip:user@domain.com\r\nUse Client address format; e.g. client:username',
    causes:
      'Invalid format for country code, SIP URI, Client address, or phone number. Wildcard searches.',
    solutions:
      'Utilize only two-character country code; e.g. US\r\nDo not attempt wildcard searches; e.g. from=+1206*\r\nUse E.164 address format for telephone numbers; e.g. +14258675309\r\nUse SIP URI format; e.g. sip:user@domain.com\r\nUse Client address format; e.g. client:username',
    description: 'Invalid query parameter has been passed in the request.',
    product: 'Programmable Voice',
    date_created: '2021-08-19T13:17:28Z',
    last_updated: '2021-08-19T13:33:07.986737Z',
  },
  25107: {
    code: 25107,
    message: 'The Request does not contain any authorization information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25107\r\n\r\n### The Request does not contain any authorization information\r\n\r\n The Request does not contain any authorization information (most cases: credentials) or the credentials and the resource have no relation.\r\n\r\n#### Possible Causes\r\n- When omitting the Auth header from HTTP request\r\n- Passing an Auth header to access a resource that belongs to some other organization.\r\n\r\n\r\n#### Possible Solutions\r\nVerify correctness of Auth header.',
    causes:
      '- When omitting the Auth header from HTTP request\r\n- Passing an Auth header to access a resource that belongs to some other organization.\r\n',
    solutions: 'Verify correctness of Auth header.',
    description:
      'The Request does not contain any authorization information (most cases: credentials) or the credentials and the resource have no relation.',
    product: 'Organizations API',
    date_created: '2023-12-04T11:41:43Z',
    last_updated: '2023-12-04T14:27:50.909061Z',
  },
  81016: {
    code: 81016,
    message: 'Outbound HTTP Request Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81016\r\n\r\n### Outgoing HTTP request failed\r\nThe outgoing HTTP request from a Studio widget failed.\r\n\r\n#### Possible Causes\r\n* The URL you are requesting is incorrect\r\n* The response is badly formed\r\n* The URL returned a 4xx or 5xx error code\r\n\r\n#### Possible Solutions\r\n* Make sure the request results in a response code 2xx or 3xx\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-09-19T18:47:42Z',
    last_updated: '2020-08-04T10:00:12.647Z',
  },
  21601: {
    code: 21601,
    message: 'Phone number is not a valid SMS-capable inbound phone number',
    log_level: 'ERROR',
    secondary_message:
      'The phone number you provided as the FROM field to initiate an outbound SMS is not an incoming phone number assigned to your account.  Only phone numbers that you buy from Twilio can be used for outgoing SMSes.  In particular, 3rd party phone numbers such as validated CallerIDs cannot be used to send SMSs.',
    log_type: null,
    docs: '## Error - 21601\n\n### Phone number is not a valid SMS-capable/MMS-capable inbound phone number \n\nThe phone number you provided as the FROM field to initiate an outbound message is not an incoming phone number assigned to your account. Only phone numbers that you buy from Twilio can be used for outgoing messages. In particular, 3rd party phone numbers such as validated CallerIDs cannot be used to send messages.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:25Z',
    last_updated: '2020-08-04T10:00:25.138Z',
  },
  32218: {
    code: 32218,
    message: 'SIP: Transfer not allowed',
    log_level: 'ERROR',
    secondary_message: 'Transfer is disabled or transferring to disallowed destination (SIP/PSTN)',
    log_type: null,
    docs: '## Error - 32218\r\n\r\n### SIP: Transfer not allowed\r\n\r\n#### Possible Causes \r\n*    Transfer enable mode is in DISABLE_ALL\r\n*    Transferring to PSTN when transfer enable mode is in `SIP_ONLY`\r\n*    Transferring to SIP when transfer enable mode is in `PSTN_ONLY`\r\n\r\n#### Possible Solutions\r\n*   There is a configurable transfer enable mode on your trunk. Change this mode to suit your needs',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2018-05-31T17:42:51Z',
    last_updated: '2020-08-04T10:00:13.536Z',
  },
  48027: {
    code: 48027,
    message: 'Outgoing conversation: Proxy address equals contact address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48027\r\n\r\n### Outgoing conversation: Proxy address equals contact address\r\n\r\n A conversation could not be created because the provided Twilio proxy address was the same as contact address.\r\n\r\n#### Possible Causes\r\n* The outgoing conversation callback returned a Twilio proxy number that was the same as the contact address.\r\n\r\n#### Possible Solutions\r\n* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback is different from the contact address.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#sign-up-for-a-twilio-account-and-get-a-phone-number) on how to configure Twilio proxy numbers.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#configure-the-twilio-frontline-integration-service) on how to use your Twilio proxy number within the integration service.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/outgoing-conversations) on how to create outgoing conversations.',
    causes:
      '* The outgoing conversation callback returned a Twilio proxy number that was the same as the contact address.',
    solutions:
      '* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback is different from the contact address.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#sign-up-for-a-twilio-account-and-get-a-phone-number) on how to configure Twilio proxy numbers.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#configure-the-twilio-frontline-integration-service) on how to use your Twilio proxy number within the integration service.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/outgoing-conversations) on how to create outgoing conversations.',
    description:
      'A conversation could not be created because the provided Twilio proxy address was the same as contact address.',
    product: 'Frontline',
    date_created: '2022-04-20T15:52:38Z',
    last_updated: '2022-04-20T15:52:38Z',
  },
  13221: {
    code: 13221,
    message: 'Dial->Number: Invalid method value',
    log_level: 'WARNING',
    secondary_message:
      "The method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13221 \n\n### Dial->Number: Invalid method value\n\nThe method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:33Z',
    last_updated: '2020-08-04T10:00:28.728Z',
  },
  32215: {
    code: 32215,
    message: 'Dial failure calling a SIP Domain without specifying a region',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 32215\r\n\r\n### Dial failure - Must specify a region in the SIP Domain\r\n\r\n#### Possible Causes\r\n\r\n* If you do a &lt;Dial&gt;&lt;Sip&gt; without specifying a region\r\n\r\n#### Possible Solutions\r\n\r\n* Dial the regional SIP domain.\r\nFor instance:\r\n&lt;Dial&gt;&lt;Sip&gt;username@yoursipdomain.sip.`us1`.twilio.com&lt;/Dial&gt;&lt;/Sip&gt;.\r\n\r\nNote the `us1` above that is specifying that you are calling a SIP endpoint registered to the US1 (North Virginia) data center.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-10-28T21:02:03Z',
    last_updated: '2020-08-04T10:00:20.582Z',
  },
  14212: {
    code: 14212,
    message: 'Dial->Queue: queue name too short',
    log_level: 'ERROR',
    secondary_message: 'The name of the queue must be at least 1 character long.',
    log_type: null,
    docs: '## Error - 14212\n\n### Dial->Queue: queue name too short\n\nThe name of the queue must be at least 1 character long.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:12Z',
    last_updated: '2020-08-04T10:00:26.172Z',
  },
  60308: {
    code: 60308,
    message: 'Challenge verification attempts limit reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60308\r\n\r\n### Challenge verification attempts limit reached\r\n\r\n The maximum number of verification attempts for a Challenge has been reached.\r\n\r\nMax. number of attempts for TOTP: 5.\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\nToo many incorrect TOTP codes have been provided in the AuthPayload\r\n\r\n#### Possible Solutions\r\n- Create a new Challenge and verify that one.\r\n- For TOTP, ask the user to provide the correct TOTP code or re-register them with a new Factor if they are unable to generate correct codes for the existing Factor.',
    causes: 'Too many incorrect TOTP codes have been provided in the AuthPayload',
    solutions:
      '- Create a new Challenge and verify that one.\r\n- For TOTP, ask the user to provide the correct TOTP code or re-register them with a new Factor if they are unable to generate correct codes for the existing Factor.',
    description:
      'The maximum number of verification attempts for a Challenge has been reached.\r\n\r\nMax. number of attempts for TOTP: 5.\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2021-04-23T22:03:03Z',
    last_updated: '2021-06-30T03:41:59.82327Z',
  },
  45760: {
    code: 45760,
    message: 'Unable to validate address configuration. Auto create data missing.  ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45760\r\n\r\n### Unable to validate address configuration. Auto create data missing.  \r\n\r\n Unable to validate address configuration for provided address SID. Auto create data missing.  \r\n\r\n#### Possible Causes\r\nAddress configuration data associated with the provided address SID is missing auto create data. \r\n\r\n#### Possible Solutions\r\nEnsure that the address SID provided is valid and associated with the correct account. \r\n\r\nEnsure that the auto create data associated with the address is present and in the correct format. More information on creating and updating an address configuration resource can be found [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#addressconfiguration-properties)',
    causes:
      'Address configuration data associated with the provided address SID is missing auto create data. ',
    solutions:
      'Ensure that the address SID provided is valid and associated with the correct account. \r\n\r\nEnsure that the auto create data associated with the address is present and in the correct format. More information on creating and updating an address configuration resource can be found [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#addressconfiguration-properties)',
    description:
      'Unable to validate address configuration for provided address SID. Auto create data missing.  ',
    product: 'Flex',
    date_created: '2022-10-03T20:56:58Z',
    last_updated: '2022-10-03T20:58:48.929105Z',
  },
  21910: {
    code: 21910,
    message: "Invalid 'From' and 'To' pair. 'From' and 'To' should be of the same channel",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21910\r\n\r\n### Invalid 'From' and 'To' pair. 'From' and 'To' should be of the same channel\r\n\r\n `From` and `To` parameters in the API Request should be of the same channel.\r\n\r\n#### Possible Causes\r\nYou are trying to send a message between different channels, eg. from an SMS capable number to a WhatsApp number.\r\n\r\n#### Possible Solutions\r\nEnsure `From` and `To` parameters are the same channel, eg. both are SMS or both are WhatsApp.",
    causes:
      'You are trying to send a message between different channels, eg. from an SMS capable number to a WhatsApp number.',
    solutions:
      'Ensure `From` and `To` parameters are the same channel, eg. both are SMS or both are WhatsApp.',
    description: '`From` and `To` parameters in the API Request should be of the same channel.',
    product: 'Programmable SMS',
    date_created: '2021-02-17T12:46:50Z',
    last_updated: '2024-02-05T12:26:04.517748Z',
  },
  60714: {
    code: 60714,
    message: 'Brand not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60714\r\n\r\n### Brand not found\r\n\r\n You are asking for a brand that does not exist for the business\r\n\r\n#### Possible Causes\r\nThe brand, or its associated business, may have been removed\r\n\r\n#### Possible Solutions\r\nDouble check that the business SID and the brand SID are correct',
    causes: 'The brand, or its associated business, may have been removed',
    solutions: 'Double check that the business SID and the brand SID are correct',
    description: 'You are asking for a brand that does not exist for the business',
    product: 'Branded Comms',
    date_created: '2020-01-24T18:15:25Z',
    last_updated: '2020-08-04T10:00:04.936Z',
  },
  22105: {
    code: 22105,
    message: 'Invalid URL format',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22105\r\n\r\n#### Invalid URL Format\r\n\r\nYou attempted to configure your hosted number, but the URL you specified was not valid.\r\n\r\n#### Possible Causes\r\n\r\n* Invalid URL provided for phone number configuration (SmsUrl, SmsFallbackUrl, VoiceUrl, VoiceFallbackUrl). \r\n\r\n* Invalid URL provided for status callback configuration (StatusCallbackUrl).\r\n\r\n#### Possible Solutions\r\n\r\nMake sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n\r\n*   hostname\r\n\r\n*   file path\r\n\r\n*   properly url-encoded query parameters\r\n\r\nTwilio must be able to reach this URL over the public Internet.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:52:45Z',
    last_updated: '2020-08-04T10:00:15.189Z',
  },
  80624: {
    code: 80624,
    message: 'Approaching Maximium Number Pool Size',
    log_level: 'WARNING',
    secondary_message: 'Your Proxy number pool has reached 85% of the maximum limit.  ',
    log_type: 'TWILIO',
    docs: '## WARNING - 80624\r\n\r\n### Approaching Maximium Number Pool Size\r\n\r\nYour Proxy number pool has reached 85% of the maximum limit.   Proxy number pools can include a maximum of 5000 Reserved numbers and 500 un-reserved numbers.  We have detected that are getting close to one of those limits.  Once you reach the limit, you will not be able to add more numbers to your pool.\r\n\r\n#### Possible Causes\r\nYou are nearing one of the limits in your Proxy number pool.\r\n\r\n#### Possible Solutions\r\nWe strongly suggest that you shard numbers across multiple Proxy services.  If you need more numbers than are specified by these limits, consider creating another Proxy Service for the additional numbers.',
    causes: 'You are nearing one of the limits in your Proxy number pool.',
    solutions:
      'We strongly suggest that you shard numbers across multiple Proxy services.  If you need more numbers than are specified by these limits, consider creating another Proxy Service for the additional numbers.',
    description:
      'Proxy number pools can include a maximum of 5000 Reserved numbers and 500 un-reserved numbers.  We have detected that are getting close to one of those limits.  Once you reach the limit, you will not be able to add more numbers to your pool.',
    product: 'Proxy',
    date_created: '2021-09-20T22:01:15Z',
    last_updated: '2021-09-20T22:01:59.358946Z',
  },
  13251: {
    code: 13251,
    message: 'Dial: Too many headers passed',
    log_level: 'WARNING',
    secondary_message: 'You sent too many header elements.',
    log_type: null,
    docs: '## Warning - 13251 \n\n### Dial: Too many headers passed\n\nYou sent too many header elements.\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:08Z',
    last_updated: '2020-08-04T10:00:26.423Z',
  },
  53110: {
    code: 53110,
    message: 'StatusCallbackMethod is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53110: StatusCallbackMethod is invalid\r\n\r\nRaised in the REST API when StatusCallbackMethod is set to an invalid value.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with StatusCallbackMethod set to an invalid value.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallbackMethod to either GET or POST or leave blank for the default.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:45:33Z',
    last_updated: '2020-08-04T10:00:19.517Z',
  },
  54009: {
    code: 54009,
    message: 'Rate limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'The rate of access to this resource exceeds the prescribed limits.',
    log_type: null,
    docs: '\n## Error - 54009\n\n### Sync: Rate limit exceeded\nThe rate of access to this resource exceeds the prescribed limits.\n\n#### Possible Causes\n* Your application is opening, reading or querying a single Sync object or its sub-items too often.\n* Your application is updating a single Sync object or its sub-items too often.\n* Your application is creating new Sync objects or their sub-items too often.\n\n#### Possible Solutions\n* Analyze your application to ensure that the _sustained_ rate of reads and writes against a single Sync object, and the sustained rate of of new object creations, is below 20 per second during normal application activity. Note that this limit only applies to explicit reads or writes; delivered state updates are not limited.\n* Analyze your application to ensure that bursts of activity are uncommon; Sync provides a ten-second burst window during which you can exceed the sustained request-rate limits.\n* Make sure your application (client or backend) uses a good exponential back-off algorithm like [the one advocated by Amazon](https://www.awsarchitectureblog.com/2015/03/backoff.html) to retry on HTTP 429 (rate limiting) responses.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.736Z',
  },
  13430: {
    code: 13430,
    message: 'Play: Invalid DTMF String',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13430\r\n\r\n### Play: Invalid DTMF String\r\n\r\n Play cannot use the DTMF characters in the configuration.  Must be an alphanumeric, asterisk, or pound sign.\r\n\r\n#### Possible Causes\r\nInvalid value in DTMF String\r\n\r\n#### Possible Solutions\r\nCorrect the DTMF string to use alpha-numeric, pound, or hash symbol.',
    causes: 'Invalid value in DTMF String',
    solutions: 'Correct the DTMF string to use alpha-numeric, pound, or hash symbol.',
    description:
      'Play cannot use the DTMF characters in the configuration.  Must be an alphanumeric, asterisk, or pound sign.',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:46:29Z',
    last_updated: '2020-08-04T10:00:04.392Z',
  },
  25011: {
    code: 25011,
    message: 'The value for the primary email address is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25011\r\n\r\n### The value for the primary email address is invalid\r\n\r\n The value for the primary email address is invalid.\r\n\r\n#### Possible Causes\r\nThe provided value for the email address is not valid.\r\n\r\n#### Possible Solutions\r\nDouble-check the email address value to ensure it adheres to the required format and standards.',
    causes: 'The provided value for the email address is not valid.',
    solutions:
      'Double-check the email address value to ensure it adheres to the required format and standards.',
    description: 'The value for the primary email address is invalid.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:01:50Z',
    last_updated: '2023-12-04T14:16:45.994828Z',
  },
  50532: {
    code: 50532,
    message: 'Failed to create Channel Metadata',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50532\r\n\r\n### Failed to create Channel Metadata\r\n\r\n Unable to create Channel Metadata for the Message\r\n\r\n#### Possible Causes\r\n* Channel Metadata was in an invalid format\r\n* Channel Metadata required keys were missing\r\n* A persistence error occured\r\n\r\n#### Possible Solutions\r\n* Validate Channel Metadata was in the correct format\r\n* Retry Channel Metadata creation',
    causes:
      '* Channel Metadata was in an invalid format\r\n* Channel Metadata required keys were missing\r\n* A persistence error occured',
    solutions:
      '* Validate Channel Metadata was in the correct format\r\n* Retry Channel Metadata creation',
    description: 'Unable to create Channel Metadata for the Message',
    product: 'Conversations',
    date_created: '2024-02-27T16:21:49Z',
    last_updated: '2024-02-27T16:21:55.260133Z',
  },
  52305: {
    code: 52305,
    message: 'User already belongs to the segment',
    log_level: 'WARNING',
    secondary_message: 'User is already a member of this segment',
    log_type: null,
    docs: '## Warning - 52305\r\n\r\n### User is already a member of this segment.\r\n\r\n#### Possible Causes \r\n*  User has already been added to this segment.\r\n\r\n#### Possible Solutions\r\n*  As user is already a member of the required segment, no actions are needed.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-05-24T08:45:48Z',
    last_updated: '2020-08-04T10:00:18.459Z',
  },
  54051: {
    code: 54051,
    message: 'Invalid webhook URL',
    log_level: 'ERROR',
    secondary_message:
      "The specified 'WebhookUrl' parameter is not a valid URL or exceeds the allowed length.",
    log_type: 'TWILIO',
    docs: "## ERROR - 54051\r\n\r\n### Invalid webhook URL\r\n\r\nThe specified 'WebhookUrl' parameter is not a valid URL or exceeds the allowed length.  \r\n\r\n\r\n#### Possible Causes\r\n* You did not pass a correctly-formatted URL.\r\n* You are crafting HTTP requests yourself and passed a URL, but did not percent-encoded it.\r\n* You passed a webhook URL that is longer than 512 characters.\r\n\r\n#### Possible Solutions\r\nConfirm that you are providing a fully-qualified, percent-encoded HTTP URL no longer than 512 characters.",
    causes:
      '* You did not pass a correctly-formatted URL.\r\n* You are crafting HTTP requests yourself and passed a URL, but did not percent-encoded it.\r\n* You passed a webhook URL that is longer than 512 characters.',
    solutions:
      'Confirm that you are providing a fully-qualified, percent-encoded HTTP URL no longer than 512 characters.',
    description: ' \r\n',
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-12-15T10:50:15.093Z',
  },
  30620: {
    code: 30620,
    message: "Message couldn't be delivered",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30620\r\n\r\n### Message couldn't be delivered\r\n\r\n Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n\r\n\r\n#### Possible Causes\r\nTBD\r\n\r\n#### Possible Solutions\r\nTBD",
    causes: 'TBD',
    solutions: 'TBD',
    description:
      'Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-04-16T06:24:53Z',
    last_updated: '2024-04-16T06:24:53Z',
  },
  50203: {
    code: 50203,
    message: 'Programmable Chat: Identity reserved',
    log_level: 'ERROR',
    secondary_message: 'Specified identity is reserved for internal use.',
    log_type: null,
    docs: '## Error - 50203\r\n\r\n### Programmable Chat: Identity reserved\t \r\n\r\n#### Possible Causes \r\n*  Specified identity is reserved for internal use.\r\n\r\n#### Possible Solutions\r\n*  Choose different valid identity and provide it in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:49Z',
    last_updated: '2020-08-04T10:00:23.281Z',
  },
  22005: {
    code: 22005,
    message: 'Call Queue Full',
    log_level: 'ERROR',
    secondary_message: 'There are more than 24 hours of calls in your call queue',
    log_type: 'APPLICATION',
    docs: '## ERROR - 22005\r\n\r\n### Call Queue Full\r\n\r\nThere are more than 24 hours of calls in your call queue ## Error - 22005\r\n\r\n### Call Queue Full \r\n\r\nThere are more than 24 hours of calls in your call queue.\r\n\r\nWhen you create calls via the REST API they are added to a call queue. Calls are removed from that call queue and placed at a default rate of 1 per second. This calls per second rate can be increased. Twilio will reject requests to place calls that will not be placed within 24 hours. At 1 call per second Twilio will reject calls once there are 86400 calls in your queue. More calls will not be accepted until your queue length decreases, calls in your queue will continue to be placed. If your application requires timely placement of calls, your application performance may be degraded.\r\n\r\n#### Possible Causes\r\n* Large spikes in call volume\r\n* Runaway or looping application\r\n\r\n#### Possible Solutions\r\n* Validate application logic\r\n* Contact your account manager or Twilio support to purchase additional capacity.',
    causes: '* Large spikes in call volume\r\n* Runaway or looping application',
    solutions:
      '* Validate application logic\r\n* Contact your account manager or Twilio support to purchase additional capacity.',
    description:
      '## Error - 22005\r\n\r\n### Call Queue Full \r\n\r\nThere are more than 24 hours of calls in your call queue.\r\n\r\nWhen you create calls via the REST API they are added to a call queue. Calls are removed from that call queue and placed at a default rate of 1 per second. This calls per second rate can be increased. Twilio will reject requests to place calls that will not be placed within 24 hours. At 1 call per second Twilio will reject calls once there are 86400 calls in your queue. More calls will not be accepted until your queue length decreases, calls in your queue will continue to be placed. If your application requires timely placement of calls, your application performance may be degraded.',
    product: 'Programmable Voice',
    date_created: '2020-02-11T23:32:02Z',
    last_updated: '2020-08-04T10:00:04.701Z',
  },
  52181: {
    code: 52181,
    message: 'Too many SMS notification requests',
    log_level: 'ERROR',
    secondary_message: 'Global SMS notification per second limit exceeded',
    log_type: null,
    docs: '## Error - 52181\r\n\r\n### RtdNotification: Global SMS notification per second limit exceeded\r\n\r\n#### Possible Causes \r\n* Somebody is using SMS broadcast\r\n* General high load\r\n\r\n#### Possible Solutions\r\n* At the moment there is a global SMS rate limit. This should be increased or eliminated entirely in the near future, but that requires some development. Please notify RTD Notifications team if this error starts occurring.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-06-07T15:56:12Z',
    last_updated: '2020-08-04T10:00:21.385Z',
  },
  80622: {
    code: 80622,
    message: 'Maximum Pool Size Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 80622\r\n\r\n### Maximum Pool Size Error\r\n\r\n You attempted to add a number to a Proxy Number Pool that has reached its maximum allowed size.  A Proxy Service pool can have up to 500 unreserved numbers and 5000 reserved numbers.\r\n\r\n#### Possible Causes\r\nYou attempted to add a number to a Proxy Number Pool that has reached its maximum allowed size.  A Proxy Service pool can have up to 500 unreserved numbers and 5000 reserved numbers.\r\n\r\n#### Possible Solutions\r\nRemove unused numbers, or create a new Proxy Service with additional numbers.',
    causes:
      'You attempted to add a number to a Proxy Number Pool that has reached its maximum allowed size.  A Proxy Service pool can have up to 500 unreserved numbers and 5000 reserved numbers.',
    solutions: 'Remove unused numbers, or create a new Proxy Service with additional numbers.',
    description:
      'You attempted to add a number to a Proxy Number Pool that has reached its maximum allowed size.  A Proxy Service pool can have up to 500 unreserved numbers and 5000 reserved numbers.',
    product: 'Proxy',
    date_created: '2020-05-27T21:01:08Z',
    last_updated: '2020-12-01T16:51:35.711Z',
  },
  51127: {
    code: 51127,
    message: 'Twilsock: PNC limit has been',
    log_level: 'ERROR',
    secondary_message: 'N/A',
    log_type: null,
    docs: '## Error - 51127\r\n\r\n### Twilsock: PNC limit hit',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:29:43Z',
    last_updated: '2020-08-04T10:00:09.423Z',
  },
  80501: {
    code: 80501,
    message: 'Storage Operation Failed',
    log_level: 'ERROR',
    secondary_message: 'An internal server error has occurred during a storage operation',
    log_type: null,
    docs: '## Error\r\n\r\n### Storage Operation Failed\r\n\r\nAn internal server error has occurred during a storage operation',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-10-03T23:24:30Z',
    last_updated: '2020-08-04T10:00:12.316Z',
  },
  90003: {
    code: 90003,
    message: 'Unable to fetch plugins from the Custom Plugins URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90003\r\n\r\n### Unable to fetch plugins from the Custom Plugins URL\r\n\r\n Twilio could not fetch your Flex plugins from your provided plugins URL\r\n\r\n#### Possible Causes\r\n* An invalid content type or no content being returned when Twilio tries to retrieve your plugins using the custom plugins URL.\r\n\r\n#### Possible Solutions\r\n* Check if the custom plugins URL has been set correctly \r\n* The custom plugin URL must return a valid JSON object\r\n\r\nSee the [Deploying Flex Plugins](/docs/flex/developer/plugins/cli#deploying-to-your-own-cdn) docs for more information.',
    causes:
      '* An invalid content type or no content being returned when Twilio tries to retrieve your plugins using the custom plugins URL.',
    solutions:
      '* Check if the custom plugins URL has been set correctly \r\n* The custom plugin URL must return a valid JSON object\r\n\r\nSee the [Deploying Flex Plugins](/docs/flex/developer/plugins/cli#deploying-to-your-own-cdn) docs for more information.',
    description: 'Twilio could not fetch your Flex plugins from your provided plugins URL',
    product: 'Flex',
    date_created: '2019-09-09T23:18:54Z',
    last_updated: '2023-08-09T13:43:45.653775Z',
  },
  82005: {
    code: 82005,
    message: 'Function execution resulted in an error log',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 82005\r\n\r\n### Function execution resulted in an error log\r\n\r\n Your Function execution resulted in logging an error message\r\n\r\n#### Possible Causes\r\nFunction execution code path lead to console.error(...)\r\n\r\n#### Possible Solutions\r\nCheck the highlighted message above for further debugging',
    causes: 'Function execution code path lead to console.error(...)',
    solutions: 'Check the highlighted message above for further debugging',
    description: 'Your Function execution resulted in logging an error message',
    product: 'Functions',
    date_created: '2020-02-12T02:50:37Z',
    last_updated: '2020-08-04T10:00:04.657Z',
  },
  48025: {
    code: 48025,
    message: 'Outgoing conversation: Invalid contact address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48025\r\n\r\n### Outgoing conversation: Invalid contact address\r\n\r\n A conversation could not be created because the provided contact address was invalid.\r\n\r\n#### Possible Causes\r\n* The contact phone number used to initiate a new conversation was invalid.\r\n\r\n#### Possible Solutions\r\n* Make sure that the contact address returned from the CRM callback is correct and properly formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164), including any channel prefixes if relevant.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/my-customers) on CRM callbacks for additional information.',
    causes: '* The contact phone number used to initiate a new conversation was invalid.',
    solutions:
      '* Make sure that the contact address returned from the CRM callback is correct and properly formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164), including any channel prefixes if relevant.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/my-customers) on CRM callbacks for additional information.',
    description:
      'A conversation could not be created because the provided contact address was invalid.',
    product: 'Frontline',
    date_created: '2022-04-20T15:50:49Z',
    last_updated: '2022-04-20T15:50:49Z',
  },
  13299: {
    code: 13299,
    message: '2010 Conference API feature requested using 2008 API',
    log_level: 'ERROR',
    secondary_message:
      'A feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 13299\r\n\r\n### 2010 Conference API feature requested using 2008 API\r\n\r\nA feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API. A feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API.\r\n\r\n#### Possible Causes\r\n- \r\n\r\n#### Possible Solutions\r\n- ',
    causes: '- ',
    solutions: '- ',
    description:
      'A feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API.',
    product: null,
    date_created: '2016-03-31T17:13:39Z',
    last_updated: '2020-08-04T10:00:28.209Z',
  },
  22117: {
    code: 22117,
    message: 'Invalid Extension',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22117\r\n\r\n#### Invalid Extension\r\n\r\nThe extension provided for the verification call contains characters that aren\'t allowed. \r\n\r\n#### Possible Solutions\r\n\r\n* Confirm that your Extension is a non-empty string. Extension may contain numbers, the # and * characters, as well as the "w" character to "wait" for half a second. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-07T05:11:10Z',
    last_updated: '2020-08-04T10:00:14.958Z',
  },
  22108: {
    code: 22108,
    message: 'Invalid Application SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22108\r\n\r\n#### Invalid Application SID\r\n\r\nYou attempted to configure a phone number with an invalid Application SID. \r\n\r\n#### Possible Causes\r\n\r\n* The SID is not a 34-character string that is prefixed with "AP".\r\n\r\n* Invalid SMS Application SID provided in request\r\n\r\n* Invalid Voice Application SID provided in request\r\n\r\n* The Application resource identified by the SID does not exist anymore or does not belong to your account.\r\n\r\n#### Possible Solutions\r\n\r\nPlease specify an Application SID you’ve created in your [Account Dashboard](https://www.twilio.com/user/account/apps).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:54:09Z',
    last_updated: '2020-08-04T10:00:15.155Z',
  },
  50056: {
    code: 50056,
    message: 'Programmable Chat: Webhook disabled processing of command',
    log_level: 'ERROR',
    secondary_message:
      'Defined webhook returned other than "200 OK" HTTP code and Programmable Chat Service disabled processing of command.',
    log_type: null,
    docs: '## Error - 50056\r\n\r\n### Programmable Chat: Webhook disabled processing of command\r\n\r\n#### Possible Causes \r\n*  Defined webhook returned other than "200 OK" HTTP code and Programmable Chat Service disabled processing of command.\r\n\r\n#### Possible Solutions\r\n*  Confirm that defined webhooks are processing Programmable Chat Service\'s webhook calls correctly. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:46Z',
    last_updated: '2020-08-04T10:00:23.516Z',
  },
  50403: {
    code: 50403,
    message: 'Programmable Chat: Channel member limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'Channel has too many members',
    log_type: null,
    docs: '## Error - 50403\r\n\r\n### Programmable Chat: Channel member limit exceeded\r\n\r\n#### Possible Causes \r\n* Channel has too many members\r\n\r\n#### Possible Solutions\r\n*  Increase channel member limit for service instance\r\n*  Remove members from channel',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-03-30T11:33:50Z',
    last_updated: '2020-08-04T10:00:20Z',
  },
  36008: {
    code: 36008,
    message: 'Invalid Page Token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36008\r\n\r\n### Invalid Page Token\r\n\r\n Provided page token query parameter is invalid.\r\n\r\nThe provided page token query parameter must be a valid Broadcast SID, consisting of 34 alphanumeric characters, prefixed with "BC".\r\n\r\n#### Possible Causes\r\n* The provided page token has more or less than 34 characters\r\n* The provided page token has non-alphanumeric characters.\r\n* The prefix of the provided page token is something other than "BC"\r\n\r\n#### Possible Solutions\r\n* Make sure the page token has exactly 34 alphanumeric characters\r\n* Make sure the page token is prefixed with "BC"',
    causes:
      '* The provided page token has more or less than 34 characters\r\n* The provided page token has non-alphanumeric characters.\r\n* The prefix of the provided page token is something other than "BC"',
    solutions:
      '* Make sure the page token has exactly 34 alphanumeric characters\r\n* Make sure the page token is prefixed with "BC"',
    description:
      'Provided page token query parameter is invalid.\r\n\r\nThe provided page token query parameter must be a valid Broadcast SID, consisting of 34 alphanumeric characters, prefixed with "BC".',
    product: 'Programmable Messaging',
    date_created: '2024-03-04T21:37:42Z',
    last_updated: '2024-03-04T21:37:42Z',
  },
  52144: {
    code: 52144,
    message: 'APNs experienced an internal error',
    log_level: 'ERROR',
    secondary_message: 'APNs was unable to handle your request',
    log_type: null,
    docs: '## Error - 52144\r\n\r\n### APNs experienced an internal error\r\n\r\n#### Possible Causes \r\n* APNs had an unexpected error\r\n* APNS is unavailable\r\n* Request to APNs timed out\r\n\r\n#### Possible Solutions\r\n* Retry the request at a later time\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-01-04T11:23:15Z',
    last_updated: '2020-08-04T10:00:15.348Z',
  },
  403: {
    code: 403,
    message: 'Forbidden',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 403\r\n\r\n### Forbidden\r\n\r\n The request is not authorized\r\n\r\n#### Possible Causes\r\nIncorrect credentials\r\n\r\n#### Possible Solutions\r\nVerify credentials',
    causes: 'Incorrect credentials',
    solutions: 'Verify credentials',
    description: 'The request is not authorized',
    product: null,
    date_created: '2023-05-02T17:53:30Z',
    last_updated: '2023-05-02T18:03:44.513592Z',
  },
  31486: {
    code: 31486,
    message: 'Busy Here',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31486\r\n\r\n### Busy Here\r\n\r\nThe callee is busy.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:40:25Z',
    last_updated: '2020-08-04T10:00:08.311Z',
  },
  92009: {
    code: 92009,
    message: 'The template associated with this SID has already been submitted for approval.',
    log_level: 'ERROR',
    secondary_message:
      'The template associated with this SID has already been submitted for approval.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 92009\r\n\r\n### The template associated with this SID has already been submitted for approval.\r\n\r\nThe template associated with this SID has already been submitted for approval. The template associated with this SID has already been submitted for approval.\r\n\r\n#### Possible Causes\r\nThis template sid has already been submitted for approval.\r\n\r\n#### Possible Solutions\r\nPlease recreate a new template to make any changes.',
    causes: 'This template sid has already been submitted for approval.',
    solutions: 'Please recreate a new template to make any changes.',
    description: 'The template associated with this SID has already been submitted for approval.',
    product: 'Programmable SMS',
    date_created: '2023-07-07T21:40:15Z',
    last_updated: '2023-07-07T21:40:15Z',
  },
  40134: {
    code: 40134,
    message: "Dequeue Instruction does not have a valid 'status_callback_events' parameter",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 40134\r\n\r\n### Invalid \'status_callback_events\' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You provided an invalid format in your "status_callback_events" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "status_callback_events" contains a valid comma separated string of events to subscribe to if responding to an assignment callback\r\n*  Make certain each "DequeueStatusCallbackEvent" contains an acceptable event to subscribe to if making a POST /v1/Workspaces/{WorkspaceSid}/Tasks/{TaskSid}/Reservations/{ReservationSid}\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef",\r\n    "status_callback_events": "initiated,ringing,answered,completed"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-07-28T22:11:03Z',
    last_updated: '2020-08-04T10:00:21.33Z',
  },
  10002: {
    code: 10002,
    message: 'Trial accounts do not support the feature you tried to use',
    log_level: 'ERROR',
    secondary_message:
      'Your account is currently in trial mode and therefore does not have access to the premium feature you attempted to use.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 10002\r\n\r\n### Trial accounts do not support the feature you tried to use\r\n\r\nYour account is currently in trial mode and therefore does not have access to the premium feature you attempted to use. Premium features are limited to full accounts, so you must upgrade your account if you wish to use them.\r\n\r\nFor guidance on updating your account, please see [How to Work with your Free Twilio Trial Account](/docs/usage/tutorials/how-to-use-your-free-trial-account#how-to-upgrade-your-account). \r\n\r\n\r\n#### Possible Causes\r\nYou attempted to use a premium feature with a trial account.\r\n\r\n#### Possible Solutions\r\nUpgrade to a full account and try the feature again.',
    causes: 'You attempted to use a premium feature with a trial account.',
    solutions: 'Upgrade to a full account and try the feature again.',
    description:
      'Premium features are limited to full accounts, so you must upgrade your account if you wish to use them.\r\n\r\nFor guidance on updating your account, please see [How to Work with your Free Twilio Trial Account](/docs/usage/tutorials/how-to-use-your-free-trial-account#how-to-upgrade-your-account). \r\n',
    product: 'Phone Numbers',
    date_created: '2016-03-31T17:13:22Z',
    last_updated: '2024-03-11T18:04:37.073973Z',
  },
  54354: {
    code: 54354,
    message: 'Permission not found',
    log_level: 'ERROR',
    secondary_message: 'The specified Permission does not exist.',
    log_type: null,
    docs: '## Error - 54354\r\n\r\n### Sync: Permission not found\r\nThe specified Permission does not exist.\r\n\r\n#### Possible Causes\r\n* Requested permission does not exist because the provided Identity parameter is incorrect.\r\n* Permission for the specified Identity has been deleted.\r\n\r\n#### Possible Solutions\r\nConfirm that the Identity parameter being passed in your request answers to the correct identity in your app, and that it has permissions to access the given object.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.269Z',
  },
  45302: {
    code: 45302,
    message: 'Participant was disconnected before setting up Meeting',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45302\r\n\r\n### Participant was disconnected before setting up Meeting\r\n\r\n User was disconnected from media before setting up Meeting\r\n\r\n#### Possible Causes\r\nBad connectivity, User error\r\n\r\n#### Possible Solutions\r\nPlease verify user connectivity and retry',
    causes: 'Bad connectivity, User error',
    solutions: 'Please verify user connectivity and retry',
    description: 'User was disconnected from media before setting up Meeting',
    product: 'Flex',
    date_created: '2020-01-14T21:11:50Z',
    last_updated: '2020-08-04T10:00:05.354Z',
  },
  50706: {
    code: 50706,
    message: 'Updating Virtual Agent participant information is not allowed.',
    log_level: 'ERROR',
    secondary_message: 'Updating Virtual Agent participant information is not allowed.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50706\r\n\r\n### Updating Virtual Agent participant information is not allowed.\r\n\r\nUpdating Virtual Agent participant information is not allowed. \r\n\r\n#### Possible Causes\r\nYou are trying to edit Virtual Agent participant information.\r\n\r\n#### Possible Solutions\r\n* If you want to change any fields of Virtual Agent participant you should delete it and create new one.',
    causes: 'You are trying to edit Virtual Agent participant information.',
    solutions:
      '* If you want to change any fields of Virtual Agent participant you should delete it and create new one.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:03:48Z',
    last_updated: '2023-10-11T18:18:54.669676Z',
  },
  82002: {
    code: 82002,
    message: 'Error on Twilio Function response',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 82002\r\n\r\n### Error on Twilio Function response\r\n\r\n Your Function invocation resulted in StatusCode 5xx.\r\n\r\n#### Possible Causes\r\n* Your Function timed out before responding.\r\n* Your Function returned an error response.\r\n\r\n#### Possible Solutions\r\n* Your Function must contain a callback.\r\n* Make sure you place the Function callback `callback(err, response)` is placed correctly in your Function code.\r\n * If you are using a JavaScript promise, make sure the callback is called in both success and catch blocks.\r\n* Your Function responded with an error.',
    causes:
      '* Your Function timed out before responding.\r\n* Your Function returned an error response.',
    solutions:
      '* Your Function must contain a callback.\r\n* Make sure you place the Function callback `callback(err, response)` is placed correctly in your Function code.\r\n * If you are using a JavaScript promise, make sure the callback is called in both success and catch blocks.\r\n* Your Function responded with an error.',
    description: 'Your Function invocation resulted in StatusCode 5xx.',
    product: 'Functions',
    date_created: '2018-09-12T03:00:29Z',
    last_updated: '2023-11-02T21:28:02.990954Z',
  },
  33105: {
    code: 33105,
    message: 'Transition invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 33105\r\n\r\n### Transition invalid\r\n\r\n Raised whenever the SIM cannot be transitioned to the requested status.\r\n\r\n\r\n#### Possible Causes\r\n* While activating a SIM, your request was rejected because the SIM you are trying to activate is not compatible with the Rate Plan.\r\n* While changing a SIM's status, your request was rejected because the requested Status change is invalid.\r\n\r\n\r\n#### Possible Solutions\r\n* While activating a SIM, ensure that the SIM is compatible with the Rate Plan, e.g. the Rate Plan specifies international roaming for data but the SIM does not support it.\r\n* While changing a SIM's status, ensure that the Status transition is valid. Read more about [Status Values](https://www.twilio.com/docs/iot/wireless/api/sim-resource#status-values).\r\n",
    causes:
      "* While activating a SIM, your request was rejected because the SIM you are trying to activate is not compatible with the Rate Plan.\r\n* While changing a SIM's status, your request was rejected because the requested Status change is invalid.\r\n",
    solutions:
      "* While activating a SIM, ensure that the SIM is compatible with the Rate Plan, e.g. the Rate Plan specifies international roaming for data but the SIM does not support it.\r\n* While changing a SIM's status, ensure that the Status transition is valid. Read more about [Status Values](https://www.twilio.com/docs/iot/wireless/api/sim-resource#status-values).\r\n",
    description: 'Raised whenever the SIM cannot be transitioned to the requested status.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:19:24Z',
    last_updated: '2020-09-15T20:59:36.811Z',
  },
  57019: {
    code: 57019,
    message: "'Authorization' header is missing or is invalid",
    log_level: 'ERROR',
    secondary_message: "'Authorization' header is missing or is invalid",
    log_type: 'APPLICATION',
    docs: "## ERROR - 57019\r\n\r\n### 'Authorization' header is missing or is invalid\r\n\r\n'Authorization' header is missing or is invalid 'Authorization' header is missing or is invalid\r\n\r\n#### Possible Causes\r\n'Authorization' header is missing or is invalid\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Authorisation' header is being passed in the request",
    causes: "'Authorization' header is missing or is invalid",
    solutions: "Confirm a valid 'Authorisation' header is being passed in the request",
    description: "'Authorization' header is missing or is invalid",
    product: 'Programmable SMS',
    date_created: '2021-06-28T14:17:49Z',
    last_updated: '2021-06-28T14:17:49Z',
  },
  30125: {
    code: 30125,
    message: 'Your phone number could not be registered with US A2P 10DLC',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 30125\r\n\r\n### Your phone number could not be registered with US A2P 10DLC\r\n\r\n We noticed that you have tried to add a number to a messaging service associated with a US A2P 10DLC Sole Proprietor campaign. Please note that all Sole Proprietor campaigns have a max limit of 1 phone number per campaign. Since you have reached this limit previously, your phone number could not be successfully registered for US A2P 10DLC. If you try to send SMS or MMS messages to the US using this phone number, those messages will be considered as unregistered traffic, where higher fees apply.\r\n\r\n\r\n#### Possible Causes\r\nYou already have 1 phone number registered with your Sole Proprietor campaign.\r\n\r\n#### Possible Solutions\r\nYou may continue to send messages to other non-US destinations using this phone number. However, if you want to use this phone number to send to recipients in the US, please consider removing all senders from this campaign from the Messaging Services page and then add back the number you wish to use, or register for a standard A2P brand and campaign instead.',
    causes: 'You already have 1 phone number registered with your Sole Proprietor campaign.',
    solutions:
      'You may continue to send messages to other non-US destinations using this phone number. However, if you want to use this phone number to send to recipients in the US, please consider removing all senders from this campaign from the Messaging Services page and then add back the number you wish to use, or register for a standard A2P brand and campaign instead.',
    description:
      'We noticed that you have tried to add a number to a messaging service associated with a US A2P 10DLC Sole Proprietor campaign. Please note that all Sole Proprietor campaigns have a max limit of 1 phone number per campaign. Since you have reached this limit previously, your phone number could not be successfully registered for US A2P 10DLC. If you try to send SMS or MMS messages to the US using this phone number, those messages will be considered as unregistered traffic, where higher fees apply.\r\n',
    product: 'Programmable SMS',
    date_created: '2022-04-12T16:43:11Z',
    last_updated: '2023-07-10T20:00:42.065272Z',
  },
  60317: {
    code: 60317,
    message: 'Factor already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60317\r\n\r\n### Factor already exists\r\n\r\n You are creating a Factor that already exists.\r\n\r\nHTTP status: 409\r\n\r\n#### Possible Causes\r\nYou are trying to create a Factor with the same binding parameters as an existing one.\r\n\r\n#### Possible Solutions\r\nCheck that the binding parameters are not the same as those in an existing Factor.',
    causes:
      'You are trying to create a Factor with the same binding parameters as an existing one.',
    solutions: 'Check that the binding parameters are not the same as those in an existing Factor.',
    description: 'You are creating a Factor that already exists.\r\n\r\nHTTP status: 409',
    product: 'Verify',
    date_created: '2020-06-30T17:14:44Z',
    last_updated: '2021-06-30T03:45:39.579565Z',
  },
  53500: {
    code: 53500,
    message: 'Unable to acquire configuration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53500: Unable to acquire configuration\r\n\r\nRaised whenever the Client is unable to acquire configuration information from the Server.\r\n\r\n#### Causes\r\n\r\n * The device running your application lost its Internet connection.\r\n * A server-side error has occurred.\r\n\r\n#### Solutions\r\n\r\n * Ensure the device running your application has access to a stable internet connection. If the problem persists, try connecting to another region.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-06-05T17:34:15Z',
    last_updated: '2020-08-04T10:00:18.396Z',
  },
  80618: {
    code: 80618,
    message: 'Chat Integration Error',
    log_level: 'ERROR',
    secondary_message: 'A Chat element was not configured correctly for Proxy',
    log_type: null,
    docs: '## Error - 80618\r\n\r\n### Chat Integration Error\r\n\r\nA Chat component was not configured correctly for integration with Proxy Service\r\n\r\n#### Possible Causes \r\n* You manually deleted a Chat Channel or Proxy Session\r\n* You removed or changed the Chat Channel Sid setting in your Proxy Service\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2019-02-12T23:53:23Z',
    last_updated: '2020-08-04T10:00:10.617Z',
  },
  53663: {
    code: 53663,
    message: 'Internal failure when bulk deleting recordings from your account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53663\r\n\r\n### Internal failure when bulk deleting recordings from your account\r\n\r\n Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.\r\n\r\n#### Possible Causes\r\nThere was an internal failure when processing your request. This action will not be retried.\r\n\r\n#### Possible Solutions\r\n* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
    causes:
      'There was an internal failure when processing your request. This action will not be retried.',
    solutions:
      '* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
    description:
      'Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.',
    product: 'Programmable Video',
    date_created: '2019-07-29T08:29:08Z',
    last_updated: '2020-08-04T10:00:07.52Z',
  },
  60242: {
    code: 60242,
    message: 'WhatsApp template not found',
    log_level: 'ERROR',
    secondary_message:
      'An approved WhatsApp template was not found for the given account sid and language',
    log_type: 'TWILIO',
    docs: '## ERROR - 60242\r\n\r\n### WhatsApp template not found\r\n\r\nAn approved WhatsApp template was not found for the given account sid and language An approved WhatsApp template was not found for the given account sid and language\r\n\r\n#### Possible Causes\r\nSelected account does not have whatsApp template created or approved\r\n\r\n#### Possible Solutions\r\nCreate and request approval for a whatsApp template in the needed language',
    causes: 'Selected account does not have whatsApp template created or approved',
    solutions: 'Create and request approval for a whatsApp template in the needed language',
    description:
      'An approved WhatsApp template was not found for the given account sid and language',
    product: 'Verify',
    date_created: '2023-12-22T15:31:59Z',
    last_updated: '2023-12-22T15:31:59Z',
  },
  14226: {
    code: 14226,
    message: 'TaskRouter Enqueue not supported in this realm',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 14226\r\n\r\n### TaskRouter Enqueue not supported in this realm\r\n\r\n TaskRouter Enqueue not supported in this realm\r\n\r\n#### Possible Causes\r\nTaskRouter Enqueue not supported in this realm\r\n\r\n#### Possible Solutions\r\nUse TaskRouter Enqueue in supported realm',
    causes: 'TaskRouter Enqueue not supported in this realm',
    solutions: 'Use TaskRouter Enqueue in supported realm',
    description: 'TaskRouter Enqueue not supported in this realm',
    product: 'Programmable Voice',
    date_created: '2020-08-13T16:27:25Z',
    last_updated: '2020-08-13T16:27:25Z',
  },
  14239: {
    code: 14239,
    message: 'Dial->Conference: Unable to update Worker',
    log_level: 'ERROR',
    secondary_message: 'Unable to update Worker to provided PostWorkActivitySid',
    log_type: null,
    docs: "## Error - 14239\r\n\r\n### Conference: Unable to update Worker's activity\r\n\r\nUnable to update the Worker to the provided ActivitySid. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:48:45Z',
    last_updated: '2020-08-04T10:00:21.699Z',
  },
  18004: {
    code: 18004,
    message: 'Expired or invalid document submission',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18004\r\n\r\n### Expired or invalid document submission\r\n\r\n The supporting document you submitted has either expired or is invalid.\r\n\r\n#### Possible Causes\r\nThe Supporting Document you uploaded has expired or it does not show an expiration date. \r\n\r\n#### Possible Solutions\r\nPlease resubmit with a valid supporting document.',
    causes:
      'The Supporting Document you uploaded has expired or it does not show an expiration date. ',
    solutions: 'Please resubmit with a valid supporting document.',
    description: 'The supporting document you submitted has either expired or is invalid.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:47:49Z',
    last_updated: '2024-07-04T09:47:49Z',
  },
  32654: {
    code: 32654,
    message: 'Real-time Transcriptions: PCI Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32654\r\n\r\n### Real-time Transcriptions: PCI Error\r\n\r\n A 32654 Error is an indication that the &lt;Transcription&gt; TwiML contains an invalid or insecure URL in the statusCallback attribute when PCI mode is enabled on your account\r\n\r\n#### Possible Causes\r\n* &lt;Transcription&gt; statusCallback attribute contains an invalid URL\r\n* &lt;Transcription&gt; statusCallback attribute does not specify scheme https\r\n\r\n#### Possible Solutions\r\n* Ensure that the &lt;Transcription&gt; TwiML statusCallback attribute contains a valid URL format with scheme https',
    causes:
      '* &lt;Transcription&gt; statusCallback attribute contains an invalid URL\r\n* &lt;Transcription&gt; statusCallback attribute does not specify scheme https',
    solutions:
      '* Ensure that the &lt;Transcription&gt; TwiML statusCallback attribute contains a valid URL format with scheme https',
    description:
      'A 32654 Error is an indication that the &lt;Transcription&gt; TwiML contains an invalid or insecure URL in the statusCallback attribute when PCI mode is enabled on your account',
    product: 'Programmable Voice',
    date_created: '2024-05-10T20:08:00Z',
    last_updated: '2024-06-07T21:56:29.864321Z',
  },
  63025: {
    code: 63025,
    message: 'Media already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Media already exists\r\n\r\n#### Possible Causes \r\n* The media content already exists. Conflict in uploading the media.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:33:21Z',
    last_updated: '2020-08-04T10:00:10.413Z',
  },
  18014: {
    code: 18014,
    message: 'Business name Mismatch',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18014\r\n\r\n### Business name Mismatch\r\n\r\n Business name provided does not match with the domestic \r\ncompany register or excerpt from the commercial register  that you may have submitted.\r\n\r\n#### Possible Causes\r\nThe business name and registration information do not align with the domestic company register or excerpt from the commercial register.\r\n\r\n#### Possible Solutions\r\nPlease resubmit with the accurate business name and the corresponding business registration number.',
    causes:
      'The business name and registration information do not align with the domestic company register or excerpt from the commercial register.',
    solutions:
      'Please resubmit with the accurate business name and the corresponding business registration number.',
    description:
      'Business name provided does not match with the domestic \r\ncompany register or excerpt from the commercial register  that you may have submitted.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:04:47Z',
    last_updated: '2024-07-04T10:04:47Z',
  },
  95111: {
    code: 95111,
    message: 'Failed to download media file: unauthorized',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95111\r\n\r\n### Failed to download media file: unauthorized\r\n\r\n The media file is not accessible. The URL returned “Unauthorized” when trying to download.\r\n\r\n#### Possible Causes\r\nProtected resource.\r\nExpired pre-signed URL.\r\n\r\n#### Possible Solutions\r\nVerify that the media url is not an expired pre-signed URL or ensure open access to the media.',
    causes: 'Protected resource.\r\nExpired pre-signed URL.',
    solutions:
      'Verify that the media url is not an expired pre-signed URL or ensure open access to the media.',
    description:
      'The media file is not accessible. The URL returned “Unauthorized” when trying to download.',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:36:14Z',
    last_updated: '2024-05-27T08:43:13.387476Z',
  },
  30883: {
    code: 30883,
    message: 'Campaign vetting rejection - Content Violation',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30883\r\n\r\n### Campaign vetting rejection - Content Violation\r\n\r\n The campaign submission has been reviewed and it was rejected due to Content Violation.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because the submission indicated that the business was part of a prohibited SHAFT category or the content was potentially sending SHAFT material. SHAFT (Sex, Hate, Alcohol, Firearms, Tobacco/Vape) and Marijuana/CBD are prohibited categories.\r\n\r\n#### Possible Solutions\r\nThe rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada ) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because the submission indicated that the business was part of a prohibited SHAFT category or the content was potentially sending SHAFT material. SHAFT (Sex, Hate, Alcohol, Firearms, Tobacco/Vape) and Marijuana/CBD are prohibited categories.',
    solutions:
      'The rejected campaign is ineligible for resubmission. If you feel that this was in error, please contact Twilio Customer Support.\r\n \r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada ) \r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected due to Content Violation.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:33:31Z',
    last_updated: '2023-04-18T11:33:31Z',
  },
  52166: {
    code: 52166,
    message: 'Webhook Credentials endpoint responded with Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52166\r\n\r\n### Webhook Credentials endpoint responded with Internal Error\r\n\r\n#### Possible Causes \r\n*  Your Webhook Credentials endpoint is misconfigured\r\n\r\n#### Possible Solutions\r\n*  Verify that your token endpoint is configured correctly',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T11:57:55Z',
    last_updated: '2020-08-04T10:00:14.286Z',
  },
  31008: {
    code: 31008,
    message: 'Call cancelled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31008\r\n\r\n### Call cancelled\r\n\r\n ## Error - 31008\r\n\r\n### Call cancelled\r\n\r\nUnable to answer because the call has ended\r\n\r\n#### Possible Causes\r\nThis error indicates that the incoming call was cancelled because it was not answered in time or it was accepted/rejected by another application instance registered with the same identity.\r\n\r\n#### Possible Solutions\r\nN/A',
    causes:
      'This error indicates that the incoming call was cancelled because it was not answered in time or it was accepted/rejected by another application instance registered with the same identity.',
    solutions: 'N/A',
    description:
      '## Error - 31008\r\n\r\n### Call cancelled\r\n\r\nUnable to answer because the call has ended',
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:30:23Z',
    last_updated: '2020-08-04T10:00:11.399Z',
  },
  60202: {
    code: 60202,
    message: 'Max check attempts reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60202\r\n\r\n### Max check attempts reached\r\n\r\n Max (5) verification check attempts reached.\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\nYou have attempted to check a verification more than 5 times and have reached the limit.\r\n\r\n#### Possible Solutions\r\nYou have 5 attempts to check a verification code, after that you will need to wait until the current verification expires (10 minutes) to create a new verification. Find more recommendations for avoiding rate limits while testing Verify in [this blog post](https://www.twilio.com/blog/test-verify-no-rate-limits).',
    causes:
      'You have attempted to check a verification more than 5 times and have reached the limit.',
    solutions:
      'You have 5 attempts to check a verification code, after that you will need to wait until the current verification expires (10 minutes) to create a new verification. Find more recommendations for avoiding rate limits while testing Verify in [this blog post](https://www.twilio.com/blog/test-verify-no-rate-limits).',
    description: 'Max (5) verification check attempts reached.\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2018-11-20T19:38:55Z',
    last_updated: '2021-05-18T04:29:01.199Z',
  },
  30442: {
    code: 30442,
    message: 'Toll-Free phone number verification rejection - Disallowed: Spam',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30442\r\n\r\n### Toll-Free phone number verification rejection - Disallowed: Spam\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the business or message content was found to be associated with a known spam or fraudulent campaign. \r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the business or message content was found to be associated with a known spam or fraudulent campaign. ',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:09:07Z',
    last_updated: '2024-04-16T15:46:47.424606Z',
  },
  30021: {
    code: 30021,
    message: 'Internal Failure with messaging service orchestrator',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 30021\r\n\r\n### Internal Failure with messaging service orchestrator\r\n\r\n An internal error has occurred with the messaging service orchestrator that prevented Twilio from processing your response.\r\n\r\n#### Possible Causes\r\n* We screwed up. Sorry!\r\n\r\n#### Possible Solutions\r\n* If the error persists, please contact us to figure out what has happened and how to fix it.',
    causes: '* We screwed up. Sorry!',
    solutions:
      '* If the error persists, please contact us to figure out what has happened and how to fix it.',
    description:
      'An internal error has occurred with the messaging service orchestrator that prevented Twilio from processing your response.',
    product: 'Programmable SMS',
    date_created: '2020-09-18T19:09:19Z',
    last_updated: '2020-09-18T19:09:19Z',
  },
  32001: {
    code: 32001,
    message: 'SIP: Trunk CPS limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'Calls Per Second placed against a SIP trunk exceeded its set limit.',
    log_type: null,
    docs: "## Error - 32001\r\n\r\n### SIP: Trunk CPS limit exceeded\r\n\r\n#### Possible Causes \r\n*  Calls Per Second placed against a SIP trunk exceeded its set limit. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on this SIP Trunk. Visit [Elastic SIP Trunks](/user/account/sip-trunking/trunks) and within a specific Trunk, under the `Termination` tab you may see your CPS limits.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:36Z',
    last_updated: '2020-08-04T10:00:24.429Z',
  },
  81024: {
    code: 81024,
    message: 'Subflow Error',
    log_level: 'ERROR',
    secondary_message: 'Subflow could not be executed',
    log_type: 'APPLICATION',
    docs: '## ERROR - 81024\r\n\r\n### Subflow Error\r\n\r\nSubflow could not be executed \r\n\r\n#### Possible Causes\r\n* Subflow definition does not exist\r\n* Subflow is trying to invoke another Subflow\r\n\r\n#### Possible Solutions\r\n* Ensure Subflow exists\r\n* Remove Subflow widget from Subflow definition',
    causes: '* Subflow definition does not exist\r\n* Subflow is trying to invoke another Subflow',
    solutions: '* Ensure Subflow exists\r\n* Remove Subflow widget from Subflow definition',
    description: null,
    product: 'Studio',
    date_created: '2020-05-21T18:54:28Z',
    last_updated: '2020-08-04T10:00:03.001Z',
  },
  50420: {
    code: 50420,
    message:
      'Participant Messaging Binding type does not support all of the provided Messaging Binding parameters',
    log_level: 'ERROR',
    secondary_message:
      'Sms Participant should not have MessagingBinding.Name or MessagingBinding.Level',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50420\r\n\r\n### Participant Messaging Binding type does not support all of the provided Messaging Binding parameters\r\n\r\nSms Participant should not have MessagingBinding.Name or MessagingBinding.Level \r\n\r\n#### Possible Causes\r\nParticipant is being created with not supported MessagingBinding parameters. Sms Participant should not have MessagingBinding.Name or MessagingBinding.Level.\r\n\r\n#### Possible Solutions\r\nRemove MessagingBinding.Name and MessagingBinding.Level from the request.',
    causes:
      'Participant is being created with not supported MessagingBinding parameters. Sms Participant should not have MessagingBinding.Name or MessagingBinding.Level.',
    solutions: 'Remove MessagingBinding.Name and MessagingBinding.Level from the request.',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-10-14T13:40:10Z',
    last_updated: '2021-10-14T13:40:10Z',
  },
  54502: {
    code: 54502,
    message: 'Invalid index name',
    log_level: 'ERROR',
    secondary_message: 'The specified index does not exist',
    log_type: null,
    docs: "## Error - 54502\r\n\r\n### Sync: Invalid index name\r\nThe specified index doesn't exist, therefore cannot be queried.\r\n\r\n#### Possible Causes\r\n* You may have made a typo.\r\n* You may have made a programming error that yields the empty string in place of a valid index name.\r\n\r\n#### Possible Solutions\r\n* Please review https://www.twilio.com/docs/sync/live-query for the currently supported list of indices, and make sure your code consumes one of those. There is no facility to create your own index today.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2019-04-09T06:40:33Z',
    last_updated: '2020-08-04T10:00:09.226Z',
  },
  50321: {
    code: 50321,
    message: 'Programmable Chat: Too many channel webhooks',
    log_level: 'ERROR',
    secondary_message: 'Webhooks limit exceeded for given channel',
    log_type: null,
    docs: '## Error - 50321\r\n\r\n### Programmable Chat: Too many channel webhooks\r\n\r\n#### Possible Causes \r\n*  Webhooks limit exceeded for given channel.\r\n\r\n#### Possible Solutions\r\n*  Reduce number of webhooks for channel before creating new one.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T12:31:33Z',
    last_updated: '2020-08-04T10:00:12.143Z',
  },
  13231: {
    code: 13231,
    message: 'Dial->Conference: Invalid endConferenceOnExit value',
    log_level: 'ERROR',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Error - 13231\r\n\r\n### Dial->Conference: Invalid endConferenceOnExit value\r\n\r\nendConferenceOnExit must be either "true" or false".\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:36Z',
    last_updated: '2020-08-04T10:00:28.483Z',
  },
  32005: {
    code: 32005,
    message: 'Voice calling has been disabled for this account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32005\r\n\r\n### Voice calling has been disabled for this account\r\n\r\n Voice calling has been disabled for this account. \r\n\r\n#### Possible Causes\r\nYour account may have been flagged for review.\r\n\r\n#### Possible Solutions\r\nPlease reach out to Support for assistance. ',
    causes: 'Your account may have been flagged for review.',
    solutions: 'Please reach out to Support for assistance. ',
    description: 'Voice calling has been disabled for this account. ',
    product: 'Elastic SIP Trunking',
    date_created: '2023-09-05T16:44:00Z',
    last_updated: '2023-09-05T16:44:00Z',
  },
  40000: {
    code: 40000,
    message: "Content-Type of 'application/json' not set",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "### Content-Type of 'application/json' not set\r\n\r\n#### Possible Causes \r\n*  You responded with a 200 HTTP response but did not provide a Content-Type header of 'application/json'\r\n\r\n#### Possible Solutions\r\n*  Add Content-Type header of 'application/json'\r\n\r\n#### Example\r\n\r\n~~~.json\r\n{\r\n\t\"instruction\": \"accept\"\r\n}\r\n~~~\r\n\r\nwith no Content-Type header provided.\r\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-05-19T19:42:01Z',
    last_updated: '2020-08-04T10:00:21.656Z',
  },
  62027: {
    code: 62027,
    message: 'Interconnect: Extra MPLS parameter',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 62027\r\n\r\n#### Possible Causes \r\n* Extra MPLS parameter\r\n\r\n#### Possible Solutions\r\n*  An MPLS carrier does not relate to a connection of the specified type, please update the parameter and try again.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:50:56Z',
    last_updated: '2020-08-04T10:00:20.699Z',
  },
  53662: {
    code: 53662,
    message: 'StatusCallback is invalid',
    log_level: 'WARNING',
    secondary_message: 'The recording will be processed, but status notifications will not be sent',
    log_type: null,
    docs: '## Warning - 53662\r\n\r\n### StatusCallback is invalid\r\n\r\nThe recording will be processed, but status notifications will not be sent.\r\n\r\nRaised when StatusCallback is not a valid URL.\r\n\r\n#### Causes\r\n\r\n * Recording created with StatusCallback set to an invalid URL.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallback to a valid URL or leave blank (status notifications will not be sent).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:43:12Z',
    last_updated: '2020-08-04T10:00:14.66Z',
  },
  30485: {
    code: 30485,
    message: "Message couldn't be delivered",
    log_level: 'ERROR',
    secondary_message: "Message couldn't be delivered",
    log_type: 'APPLICATION',
    docs: "## ERROR - 30485\r\n\r\n### Message couldn't be delivered\r\n\r\nMessage couldn't be delivered Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n\r\n#### Possible Causes\r\n* This is because Twilio has identified potential fraudulent messages being sent to the destination you are trying to reach.\r\n* Hence SMS traffic can not be delivered to the destination phone number used for the next couple of hours. The traffic should return to normalcy post that. However, the SMS traffic could be undelivered for an even longer period if fraudulent activity doesn't subside & continues to go on.\r\n\r\n#### Possible Solutions\r\nYou do not need to take any specific action. The disruption in traffic is usually temporary and will resolve in a couple of hours if we do not detect additional fraudulent activity.\r\n\r\n#### Continued issues with error 30485\r\nTwilio's support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30485, and [open a support request.](https://www.twilio.com/console/support/tickets/create)",
    causes:
      "* This is because Twilio has identified potential fraudulent messages being sent to the destination you are trying to reach.\r\n* Hence SMS traffic can not be delivered to the destination phone number used for the next couple of hours. The traffic should return to normalcy post that. However, the SMS traffic could be undelivered for an even longer period if fraudulent activity doesn't subside & continues to go on.",
    solutions:
      "You do not need to take any specific action. The disruption in traffic is usually temporary and will resolve in a couple of hours if we do not detect additional fraudulent activity.\r\n\r\n#### Continued issues with error 30485\r\nTwilio's support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30485, and [open a support request.](https://www.twilio.com/console/support/tickets/create)",
    description:
      'Message couldn’t be delivered to the destination number you are trying to reach temporarily.',
    product: 'Programmable SMS',
    date_created: '2024-05-09T11:33:48Z',
    last_updated: '2024-05-09T11:33:48Z',
  },
  52310: {
    code: 52310,
    message: 'Notification TTL has expired',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 52310\r\n\r\n### Notification TTL has expired\r\n\r\n Notification expired during processing\r\n\r\n#### Possible Causes\r\nNotification took too much time or there are too many notifications\r\n\r\n#### Possible Solutions\r\nIncrease TTL for notification or try again later',
    causes: 'Notification took too much time or there are too many notifications',
    solutions: 'Increase TTL for notification or try again later',
    description: 'Notification expired during processing',
    product: 'Notify',
    date_created: '2019-07-29T12:33:56Z',
    last_updated: '2020-08-04T10:00:07.502Z',
  },
  50502: {
    code: 50502,
    message: 'Programmable Chat: Message index not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Message Index parameter.',
    log_type: null,
    docs: '## Error - 50502\r\n\r\n### Programmable Chat: Message index not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Message Index parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message Index is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:53Z',
    last_updated: '2020-08-04T10:00:22.955Z',
  },
  13120: {
    code: 13120,
    message: 'Annotate->BillingReferenceTag cannot be over 128 characters',
    log_level: 'ERROR',
    secondary_message: 'BillingReferenceTag cannot be over 128 characters',
    log_type: null,
    docs: '## Error - 13120 \n\n### Annotate->BillingReferenceTag cannot be over 128 characters\n\nBillingReferenceTag cannot be over 128 characters\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:31Z',
    last_updated: '2020-08-04T10:00:29.019Z',
  },
  52309: {
    code: 52309,
    message: 'Channel provider replied with an error',
    log_level: 'ERROR',
    secondary_message: 'Channel provider (Amazon Alexa, Facebook, etc) replied with an error',
    log_type: null,
    docs: '## Error - 52309\r\n\r\n### RtdNotification: Channel provider replied with an error\r\n\r\n#### Possible Causes \r\n*  Some errors in channel configuration: destination address, credentials, permissions, etc.\r\n\r\n#### Possible Solutions\r\n*  Check channel configuration or re-install the channel and destination binding. Check response message from the provider in a debugger alert.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-12-21T12:07:11Z',
    last_updated: '2020-08-04T10:00:15.461Z',
  },
  21653: {
    code: 21653,
    message: 'There are more recipient addresses than allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21653\r\n\r\n### There are more recipient addresses than allowed\r\n\r\n There are more recipient addresses than allowed for a channel. For instance for SMS we allow only one recipient but for Group MMS we allow multiple recipients\r\n\r\n#### Possible Causes\r\nToo many recipients were provided in the request or channel selection is incorrect\r\n\r\n#### Possible Solutions\r\nFix the list of recipients according a channel restrictions',
    causes: 'Too many recipients were provided in the request or channel selection is incorrect',
    solutions: 'Fix the list of recipients according a channel restrictions',
    description:
      'There are more recipient addresses than allowed for a channel. For instance for SMS we allow only one recipient but for Group MMS we allow multiple recipients',
    product: null,
    date_created: '2020-12-11T08:15:08Z',
    last_updated: '2020-12-11T08:15:08Z',
  },
  62008: {
    code: 62008,
    message: 'Bandwidth reserve is not associated with the exchange.',
    log_level: 'ERROR',
    secondary_message:
      'The bandwidth reserve SID in the request is not associated with the exchange SID in the request. Choose a bandwidth reserve that is associated with the exchange SID, or choose an exchange SID that is associated with the bandwidth reserve SID.',
    log_type: null,
    docs: '## Error - 62008\r\n\r\n### Bandwidth reserve is not associated with the exchange\r\n\r\nThe bandwidth reserve SID in the request is not associated with the\r\nexchange SID in the request. Choose a bandwidth reserve that is associated\r\nwith the exchange SID, or choose an exchange SID that is associated with\r\nthe bandwidth reserve SID.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:37:48Z',
    last_updated: '2020-08-04T10:00:21.055Z',
  },
  45375: {
    code: 45375,
    message: 'Failed to delete Channel.  Invalid Account sid.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45375\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'We failed to delete a Channel since the provided AccountSid did not match witth our records.',
    solutions:
      'Ensure the AccountSid being used is the same as the one used to create the resource\r',
    description: 'Failed to delete Channel <channel sid> due to invalid AccountSid.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:14.384956Z',
  },
  60380: {
    code: 60380,
    message: 'Client data invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60380\r\n\r\n### Client data invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Client data JSON in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Client data JSON in the request body is correct.',
    causes: 'The Client data JSON in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Client data JSON in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:46:25Z',
    last_updated: '2023-12-27T09:46:25Z',
  },
  82004: {
    code: 82004,
    message: 'Function execution resulted in a warning log',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 82004\r\n\r\n### Function execution resulted in a warning log\r\n\r\n Your Function execution resulted in logging a warning message\r\n\r\n#### Possible Causes\r\nFunction execution code path lead to console.warn(...)\r\n\r\n#### Possible Solutions\r\nCheck the highlighted message above for further debugging',
    causes: 'Function execution code path lead to console.warn(...)',
    solutions: 'Check the highlighted message above for further debugging',
    description: 'Your Function execution resulted in logging a warning message',
    product: 'Functions',
    date_created: '2020-02-12T02:43:54Z',
    last_updated: '2020-08-04T10:00:04.679Z',
  },
  12300: {
    code: 12300,
    message: 'Invalid Content-Type',
    log_level: 'ERROR',
    secondary_message:
      'Twilio is unable to process the Content-Type of the provided URL. Please see Twilio\'s <a href="https://www.twilio.com/docs/sms/accepted-mime-types"> documentation on accepted content types </a> for more information on valid Content-Types.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 12300\r\n\r\n### Invalid Content-Type\r\n\r\n Twilio is unable to process the Content-Type of the provided URL. Please see Twilio\'s <a href="https://www.twilio.com/docs/voice/twiml#twilio-understands-mime-types"> documentation on accepted content types </a> for more information on valid Content-Types.\r\n\r\nYou must return a Content-Type for all requests. Requests without a\r\nContent-Type will appear in the [Debugger](/console/runtime/debugger) as a\r\n502 Bad Gateway error.\r\n\r\n\r\n\r\n#### Possible Causes\r\n* Having a phone number, outgoing call request or action attribute refer to a non-XML or audio resource.\r\n* Having a Play verb attempt to play non-audio content, such as XML or text.\r\n\r\n#### Possible Solutions\r\n* Verify that that your web server is returning a Content-Type and it is the expected value\r\n* Make sure the URL noted refers to a valid resource\r\n* Make sure messages to or from your Twilio phone number are using a supported content-type. See the [full list of supported content types](https://www.twilio.com/docs/sms/accepted-mime-types).\r\n* Use one of the [supported request types](https://www.twilio.com/docs/runtime/functions/request-flow#supported-requests) to call a Twilio function.',
    causes:
      '* Having a phone number, outgoing call request or action attribute refer to a non-XML or audio resource.\r\n* Having a Play verb attempt to play non-audio content, such as XML or text.',
    solutions:
      '* Verify that that your web server is returning a Content-Type and it is the expected value\r\n* Make sure the URL noted refers to a valid resource\r\n* Make sure messages to or from your Twilio phone number are using a supported content-type. See the [full list of supported content types](https://www.twilio.com/docs/sms/accepted-mime-types).\r\n* Use one of the [supported request types](https://www.twilio.com/docs/runtime/functions/request-flow#supported-requests) to call a Twilio function.',
    description:
      'Twilio is unable to process the Content-Type of the provided URL. Please see Twilio\'s <a href="https://www.twilio.com/docs/voice/twiml#twilio-understands-mime-types"> documentation on accepted content types </a> for more information on valid Content-Types.\r\n\r\nYou must return a Content-Type for all requests. Requests without a\r\nContent-Type will appear in the [Debugger](/console/runtime/debugger) as a\r\n502 Bad Gateway error.\r\n\r\n',
    product: null,
    date_created: '2016-03-31T17:13:29Z',
    last_updated: '2020-08-05T18:18:30.961Z',
  },
  51215: {
    code: 51215,
    message: 'Twilsock: Unauthorized',
    log_level: 'ERROR',
    secondary_message: 'Auth failure',
    log_type: null,
    docs: 'Auth failure',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-05-03T11:47:56Z',
    last_updated: '2020-08-04T10:00:09.07Z',
  },
  80604: {
    code: 80604,
    message: 'Proxy Identifier In Use',
    log_level: 'WARNING',
    secondary_message: 'Proxy identifier already in use with requested identifier.',
    log_type: null,
    docs: '## Warning\n\n### Proxy Identifier In Use\n\nExample Message: Proxy identifier already in use with requested identifier.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.808Z',
  },
  32113: {
    code: 32113,
    message: 'SIP: Header name is not allowed',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32113\r\n\r\n### SIP: Header name is not allowed\r\n\r\n The SIP header you asked Twilio to stamp was omitted because it is not supported on the Twilio platform.\r\n\r\nTwilio supports extension headers beginning with an X- prefix. Your extension header name cannot begin with the prefix `X-Twilio`.\r\n\r\n#### Possible Causes\r\n* SIP header name not supported on the Twilio platform.\r\n\r\n#### Possible Solutions\r\n* If your application can use a different header name, use an X- prefixed header name, e.g. if you want to use the name `Customer-Info`, see if your application can be configured to use `X-Customer-Info` instead.',
    causes: '* SIP header name not supported on the Twilio platform.',
    solutions:
      '* If your application can use a different header name, use an X- prefixed header name, e.g. if you want to use the name `Customer-Info`, see if your application can be configured to use `X-Customer-Info` instead.',
    description:
      'The SIP header you asked Twilio to stamp was omitted because it is not supported on the Twilio platform.\r\n\r\nTwilio supports extension headers beginning with an X- prefix. Your extension header name cannot begin with the prefix `X-Twilio`.',
    product: null,
    date_created: '2019-06-13T20:42:47Z',
    last_updated: '2020-08-04T10:00:07.909Z',
  },
  30123: {
    code: 30123,
    message: 'Callback URL is missing',
    log_level: 'ERROR',
    secondary_message: 'Callback URL is missing, please add an URL.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30123\r\n\r\n### Callback URL is missing\r\n\r\nCallback URL is missing, please add an URL. Callback URL is missing\r\n\r\n#### Possible Causes\r\nUser did not include callbackUrl field\r\n\r\n#### Possible Solutions\r\nPlease follow doc for setting up callback URL.',
    causes: 'User did not include callbackUrl field',
    solutions: 'Please follow doc for setting up callback URL.',
    description: 'Callback URL is missing',
    product: 'Programmable SMS',
    date_created: '2022-02-23T21:44:00Z',
    last_updated: '2022-02-23T21:44:00Z',
  },
  21453: {
    code: 21453,
    message: 'Phone number already validated on another account',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to validate your phone number to activate your Twilio Free Trial Account, but that phone number is already associated with another Free Trial Account.  You can only open one Free Trial Account per phone number.',
    log_type: null,
    docs: '## Error - 21453 \n\n### Phone number already verified for another account\n\nYou attempted to verify your phone number to activate your Twilio Free Trial Account, but that phone number is already associated with another Free Trial Account.  You can only open one Free Trial Account per phone number.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:00Z',
    last_updated: '2020-08-04T10:00:26.891Z',
  },
  60200: {
    code: 60200,
    message: 'Invalid parameter',
    log_level: 'ERROR',
    secondary_message: 'Parameter value is incorrectly formatted or is not an accepted option.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60200\r\n\r\n### Invalid parameter\r\n\r\nParameter value is incorrectly formatted or is not an accepted option. The response `message` contains the name of the invalid parameter. \r\n\r\nHTTP status: 400\r\n\r\nExample where `To` is the invalid parameter:\r\n```\r\n{\r\n    "code": 60200,\r\n    "message": "Invalid parameter: To",\r\n    "more_info": "https://www.twilio.com/docs/errors/60200",\r\n    "status": 400\r\n}\r\n```\r\n\r\n#### Possible Causes\r\nWhen [starting a verification](https://www.twilio.com/docs/verify/api/verification#start-new-verification):\r\n\r\n* `To` parameter is incorrectly formatted or missing the leading `+`.\r\n* `Channel` parameter is not one of the [accepted options](https://www.twilio.com/docs/verify/api/verification#start-new-verification), or you might not have access to the requested channel.\r\n\r\nWhen [checking a verification](https://www.twilio.com/docs/verify/api/verification-check#check-a-verification):\r\n\r\n* `Code` parameter is not between 4-10 numbers long.\r\n\r\nWhen [creating a service](https://www.twilio.com/docs/verify/api/service#create-a-verification-service):\r\n\r\n* `FriendlyName` is too long (max 30 characters).\r\n\r\nWhen [fetching a service](https://www.twilio.com/docs/verify/api/service#fetch-a-service):\r\n\r\n* Neither `ServiceSid` nor `UniqueName` is present.\r\n\r\n#### Possible Solutions\r\n* Use strict [E.164 formatting](https://www.twilio.com/docs/glossary/what-e164), including the `+` sign, for phone numbers in the `To` parameter. Example: `+15017122661`.\r\n* If using the `sna` channel, ensure you have requested and been granted access. See [SNA Overview](https://www.twilio.com/docs/verify/sna) for details.',
    causes:
      'When [starting a verification](https://www.twilio.com/docs/verify/api/verification#start-new-verification):\r\n\r\n* `To` parameter is incorrectly formatted or missing the leading `+`.\r\n* `Channel` parameter is not one of the [accepted options](https://www.twilio.com/docs/verify/api/verification#start-new-verification), or you might not have access to the requested channel.\r\n\r\nWhen [checking a verification](https://www.twilio.com/docs/verify/api/verification-check#check-a-verification):\r\n\r\n* `Code` parameter is not between 4-10 numbers long.\r\n\r\nWhen [creating a service](https://www.twilio.com/docs/verify/api/service#create-a-verification-service):\r\n\r\n* `FriendlyName` is too long (max 30 characters).\r\n\r\nWhen [fetching a service](https://www.twilio.com/docs/verify/api/service#fetch-a-service):\r\n\r\n* Neither `ServiceSid` nor `UniqueName` is present.',
    solutions:
      '* Use strict [E.164 formatting](https://www.twilio.com/docs/glossary/what-e164), including the `+` sign, for phone numbers in the `To` parameter. Example: `+15017122661`.\r\n* If using the `sna` channel, ensure you have requested and been granted access. See [SNA Overview](https://www.twilio.com/docs/verify/sna) for details.',
    description:
      'The response `message` contains the name of the invalid parameter. \r\n\r\nHTTP status: 400\r\n\r\nExample where `To` is the invalid parameter:\r\n```\r\n{\r\n    "code": 60200,\r\n    "message": "Invalid parameter: To",\r\n    "more_info": "https://www.twilio.com/docs/errors/60200",\r\n    "status": 400\r\n}\r\n```',
    product: 'Verify',
    date_created: '2017-10-04T22:00:46Z',
    last_updated: '2024-06-11T14:15:21.593745Z',
  },
  19024: {
    code: 19024,
    message: 'Invalid channel input',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19024\r\n\r\n### Invalid channel input\r\n\r\n Request body is not valid\r\n\r\n#### Possible Causes\r\nRequired field is missing or field provided is invalid or duplicated\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'Required field is missing or field provided is invalid or duplicated',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'Request body is not valid',
    product: null,
    date_created: '2020-07-21T20:17:21Z',
    last_updated: '2020-08-07T22:49:40.178Z',
  },
  81004: {
    code: 81004,
    message: 'Failed to add member to Chat Channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81004\r\n\r\n### Failed to add member to Chat Channel\r\nStudio was unable to add a member to the Chat Channel while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Chat API failed.\r\n* Invalid values were passed to the Chat API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:14:37Z',
    last_updated: '2020-08-04T10:00:13.232Z',
  },
  60713: {
    code: 60713,
    message: 'Error communicating with Regulatory Identification API',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 60713\r\n\r\n### Error communicating with Regulatory Identification API\r\n\r\n KYC, part of the Branded Comms product, depends on Twilio's regulatory APIs\r\n\r\n#### Possible Causes\r\nCommunication with the Regulatory Identification API failed\r\n\r\n#### Possible Solutions\r\nWait a bit in case this is a temporal error, or else contact our support team",
    causes: 'Communication with the Regulatory Identification API failed',
    solutions: 'Wait a bit in case this is a temporal error, or else contact our support team',
    description: "KYC, part of the Branded Comms product, depends on Twilio's regulatory APIs",
    product: 'Branded Comms',
    date_created: '2020-01-24T18:10:52Z',
    last_updated: '2020-08-04T10:00:04.993Z',
  },
  45301: {
    code: 45301,
    message: 'Error occurred when connecting to a Meeting Participant',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45301\r\n\r\n### Error occurred when connecting to a Meeting Participant\r\n\r\n Error occurred when connecting to a user\r\n\r\n#### Possible Causes\r\nFlex encountered a service error when connecting to a user\r\n\r\n#### Possible Solutions\r\nNo further information available.',
    causes: 'Flex encountered a service error when connecting to a user',
    solutions: 'No further information available.',
    description: 'Error occurred when connecting to a user',
    product: 'Flex',
    date_created: '2020-01-14T21:10:52Z',
    last_updated: '2020-08-04T10:00:05.375Z',
  },
  19038: {
    code: 19038,
    message: 'Page token must be bigger than or equal to 0',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19038\r\n\r\n### Page token must be bigger than or equal to 0\r\n\r\n \r\n\r\n#### Possible Causes\r\nGet chat messages PageToken is smaller than 0\r\n\r\n#### Possible Solutions\r\nMake sure PageToken query parameter is not smaller than 0',
    causes: 'Get chat messages PageToken is smaller than 0',
    solutions: 'Make sure PageToken query parameter is not smaller than 0',
    description: null,
    product: 'Programmable Chat',
    date_created: '2022-02-15T10:27:54Z',
    last_updated: '2022-02-15T10:27:54Z',
  },
  62100: {
    code: 62100,
    message: 'IP address(es) already linked to another connection',
    log_level: 'ERROR',
    secondary_message: 'An IP address can be associated to one Interconnect connection only.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 62100\r\n\r\n### IP address(es) already linked to another connection\r\n\r\nAn IP address can be associated to one Interconnect connection only. The IP address is already associated with another Interconnect connection.\r\n\r\n#### Possible Causes\r\nIP conflict\r\n\r\n#### Possible Solutions\r\nNew valid IP address',
    causes: 'IP conflict',
    solutions: 'New valid IP address',
    description: 'The IP address is already associated with another Interconnect connection.',
    product: 'Interconnect',
    date_created: '2020-04-13T22:12:52Z',
    last_updated: '2020-08-04T10:00:04.098Z',
  },
  48032: {
    code: 48032,
    message: 'Outgoing conversation: Missing Messaging service',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48032\r\n\r\n### Outgoing conversation: Missing Messaging service\r\n\r\n A conversation could not be created because the Messaging service required for Frontline is missing.\r\n\r\n#### Possible Causes\r\n* You may have deleted the Messaging service that auto-creates conversations in the Frontline Conversations service.\r\n\r\n#### Possible Solutions\r\n* Configure a new "Default Messaging Service" from the console, under the [Conversations defaults](https://console.twilio.com/us1/develop/conversations/manage/defaults?frameUrl=%2Fconsole%2Fconversations%2Fconfiguration%2Fdefaults%3Fx-target-region%3Dus1).\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#configure-twilio-conversations) on how to configure Conversations to work with Frontline.\r\n* Reach out to [customer support](http://twilio.com/console/support/tickets/create) for any additional help.',
    causes:
      '* You may have deleted the Messaging service that auto-creates conversations in the Frontline Conversations service.',
    solutions:
      '* Configure a new "Default Messaging Service" from the console, under the [Conversations defaults](https://console.twilio.com/us1/develop/conversations/manage/defaults?frameUrl=%2Fconsole%2Fconversations%2Fconfiguration%2Fdefaults%3Fx-target-region%3Dus1).\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/nodejs-demo-quickstart#configure-twilio-conversations) on how to configure Conversations to work with Frontline.\r\n* Reach out to [customer support](http://twilio.com/console/support/tickets/create) for any additional help.',
    description:
      'A conversation could not be created because the Messaging service required for Frontline is missing.',
    product: 'Frontline',
    date_created: '2022-04-20T15:56:27Z',
    last_updated: '2022-05-20T10:08:07.879547Z',
  },
  30892: {
    code: 30892,
    message: 'Campaign vetting rejection - Invalid Sample Message - Public URL Shorteners',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30892\r\n\r\n### Campaign vetting rejection - Invalid Sample Message - Public URL Shorteners\r\n\r\n The campaign submission has been reviewed and it was rejected because of URL shortener in the sample message.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because public URL shorteners are not accepted. The website URL included in the sample messages was either from a public URL shortener or is unsecured.\r\n\r\n#### Possible Solutions\r\nVerify URL in sample messages does not contain public URL shorteners. Resubmit campaign.',
    causes:
      'The campaign cannot be approved because public URL shorteners are not accepted. The website URL included in the sample messages was either from a public URL shortener or is unsecured.',
    solutions:
      'Verify URL in sample messages does not contain public URL shorteners. Resubmit campaign.',
    description:
      'The campaign submission has been reviewed and it was rejected because of URL shortener in the sample message.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:40:27Z',
    last_updated: '2023-05-25T23:15:25.702888Z',
  },
  22222: {
    code: 22222,
    message: 'Emergency Status cannot be updated',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 22222\r\n\r\n### Emergency Status cannot be updated\r\n\r\n Emergency Status cannot be updated\r\n\r\n#### Possible Causes\r\nYou sent a *POST* request to update the Emergency Status\r\n\r\n#### Possible Solutions\r\nRemove Emergency Status from the request',
    causes: 'You sent a *POST* request to update the Emergency Status',
    solutions: 'Remove Emergency Status from the request',
    description: 'Emergency Status cannot be updated',
    product: 'Phone Numbers',
    date_created: '2022-02-04T22:11:01Z',
    last_updated: '2022-02-04T22:17:04.672075Z',
  },
  63022: {
    code: 63022,
    message: 'Invalid vname certificate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Invalid vname certificate\r\n\r\n#### Possible Causes \r\n* The vname cert for your business account was invalid. Please reach out to support to verify the cert.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:29:14Z',
    last_updated: '2020-08-04T10:00:10.469Z',
  },
  11235: {
    code: 11235,
    message: 'Certificate Invalid - Domain Mismatch',
    log_level: 'ERROR',
    secondary_message:
      'Twilio tried to validate your SSL certificate but your certificate has a domain name that does not match the domain we requested.',
    log_type: null,
    docs: '## Error - 11235\n\n### Certificate Invalid - Domain Mismatch\n\nTwilio tried to validate your SSL certificate but your certificate has a domain name that does not match the domain we requested.\n\n#### Possible Causes\n*  Your Certificate Name or Certificate Alternate Name on your SSL certificate does not match the domain Twilio requested.\n\n\n#### Possible Solutions\n*  Obtain a SSL certificate with a Certificate Name or Certificate Alternate Name that matches this domain.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:25Z',
    last_updated: '2020-08-04T10:00:29.428Z',
  },
  90025: {
    code: 90025,
    message: 'Template body has unsupported tag type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90025\r\n\r\n### Template body has unsupported tag type\r\n\r\n Template body has unsupported Mustache tag type\r\n\r\n#### Possible Causes\r\nCurrently, Twilio supports only data tags ("{{<tag name>}}"). All other Mustache tags/commands are disabled.\r\n\r\n#### Possible Solutions\r\nCheck your template body has only data tags (placeholders)',
    causes:
      'Currently, Twilio supports only data tags ("{{<tag name>}}"). All other Mustache tags/commands are disabled.',
    solutions: 'Check your template body has only data tags (placeholders)',
    description: 'Template body has unsupported Mustache tag type',
    product: null,
    date_created: '2020-12-11T08:53:44Z',
    last_updated: '2020-12-11T08:54:04.38Z',
  },
  50401: {
    code: 50401,
    message: 'Programmable Chat: Member SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Member SID parameter.',
    log_type: null,
    docs: '## Error - 50401\r\n\r\n### Programmable Chat: Member SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Member SID parameter. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Member SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:52Z',
    last_updated: '2020-08-04T10:00:23.048Z',
  },
  20102: {
    code: 20102,
    message: 'Invalid Access Token header',
    log_level: 'ERROR',
    secondary_message: 'Invalid Access Token header',
    log_type: null,
    docs: "# Error - 20102\r\n\r\n## Invalid Access Token header\r\n\r\nThe header of the Access Token provided to the Twilio API was\r\ninvalid.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation and the header\r\nrequirements, see [the documentation](/docs/api/rest/access-tokens).\r\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T06:49:49Z',
    last_updated: '2020-08-04T10:00:22.754Z',
  },
  40123: {
    code: 40123,
    message: 'TaskRouter->Redirect',
    log_level: 'ERROR',
    secondary_message:
      'Redirect Instruction can only be issued on a currently pending reservation.',
    log_type: null,
    docs: '## Error - 40123\r\n\r\n### The Reservation must currently be Pending - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-08-22T23:00:20Z',
    last_updated: '2020-08-04T10:00:21.289Z',
  },
  80304: {
    code: 80304,
    message: 'Not Found Unmanaged Identifier',
    log_level: 'WARNING',
    secondary_message:
      'Unmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). Possibly you tried to add a participant with a proxy identifier for a channel that is not managed by Twilio or by your Proxy Service.',
    log_type: null,
    docs: '## Warning\r\n\r\n### Not Found Unmanaged Identifier\r\n\r\nUnmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). Possibly you tried to add a participant with a proxy identifier for a channel that is not managed by Twilio or by your Proxy Service.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-09-18T19:55:29Z',
    last_updated: '2020-08-04T10:00:12.686Z',
  },
  25109: {
    code: 25109,
    message: 'Request is rate limited',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25109\r\n\r\n### Request is rate limited\r\n\r\n Request is rate limited.\r\n\r\n#### Possible Causes\r\nYour application is requesting resources at a rate that is higher than expected.\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.',
    causes: 'Your application is requesting resources at a rate that is higher than expected.',
    solutions:
      'Verify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.',
    description: 'Request is rate limited.',
    product: 'Organizations API',
    date_created: '2023-12-04T11:46:48Z',
    last_updated: '2023-12-04T14:28:02.587374Z',
  },
  52401: {
    code: 52401,
    message: 'Too many notification log events ',
    log_level: 'WARNING',
    secondary_message: 'Too many notification log events, some may be discarded.',
    log_type: null,
    docs: '## Warning - 52401\r\n\r\n### Too many notification log events \r\n\r\n#### Possible Causes \r\n*  Notification requests resulted in too many delivery attempts. As a result, some of the notification events were rate limited and might not be visible in the notification log in console. The message delivery itself is not affected.\r\n\r\n#### Possible Solutions\r\n* When sending large broadcasts, slow down the rate of Send Notification requests, e.g. to 1 / s',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-10-14T07:36:47Z',
    last_updated: '2020-08-04T10:00:16.849Z',
  },
  70106: {
    code: 70106,
    message: 'Invalid AWS credentials',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70106\r\n\r\n### Invalid AWS credentials specified in the request\r\nWhen uploading AWS credentials to Twilio make sure:\r\n* AWS key matches the regex: (?<![A-Z0-9])[A-Z0-9]{20}(?![A-Z0-9])\r\n* AWS secret matches the regex: (?<![A-Za-z0-9/+=])[A-Za-z0-9/+=]{40}(?![A-Za-z0-9/+=])\r\n\r\n#### Possible Solution:\r\n* Validate the credentials and upload them again.\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-08-03T11:53:37Z',
    last_updated: '2020-08-04T10:00:17.979Z',
  },
  60707: {
    code: 60707,
    message: 'Branded Channel not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60707\r\n\r\n### Branded Channel not found\r\n\r\n Branded Channel not found\r\n\r\n#### Possible Causes\r\n- The branded channel does not exist anymore\r\n- The `BrandedChannelSid`, `BrandSid` or `BusinessSid` parameter is invalid/incorrect\r\n\r\n#### Possible Solutions\r\n- Check the Sids in your request',
    causes:
      '- The branded channel does not exist anymore\r\n- The `BrandedChannelSid`, `BrandSid` or `BusinessSid` parameter is invalid/incorrect',
    solutions: '- Check the Sids in your request',
    description: 'Branded Channel not found',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:59:50Z',
    last_updated: '2020-08-04T10:00:05.091Z',
  },
  30751: {
    code: 30751,
    message: 'Brand Registration Failure: Unsupported mobile phone number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30751\r\n\r\n### Brand Registration Failure: Unsupported mobile phone number\r\n\r\n You have provided an unsupported mobile phone number for brand registration.\r\n\r\n#### Possible Causes\r\nYou have provided an unsupported mobile phone number for brand registration.\r\n\r\n#### Possible Solutions\r\nPlease use a valid US Wireless mobile phone number which is capable of receiving verification SMS.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes: 'You have provided an unsupported mobile phone number for brand registration.',
    solutions:
      'Please use a valid US Wireless mobile phone number which is capable of receiving verification SMS.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description: 'You have provided an unsupported mobile phone number for brand registration.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:43:43Z',
    last_updated: '2024-02-13T16:13:26.448107Z',
  },
  52203: {
    code: 52203,
    message: 'Missing body for Facebook Messenger delivery attempt',
    log_level: 'ERROR',
    secondary_message:
      'Either Body or FacebookMessenger parameter of Notification should be used to specify the message body',
    log_type: null,
    docs: '## Error - 52203\r\n\r\n### Missing body for Facebook Messenger delivery attempt\r\n\r\nMessenger messages need to have some content. You can specify this either via the [generic Body parameter](https://www.twilio.com/docs/api/notify/rest/notifications#generic-payload-parameters) of the Notification request or the [FacebookMessenger channel specific parameter](https://www.twilio.com/docs/api/notify/rest/notifications#channel-specific-parameters).\r\n\r\n#### Possible causes\r\n- Notification has neither Body not FacebookMessenger parameter set\r\n\r\n#### Possible solutions\r\n- Specify either Body or FacebookMessenger parameter when sending a Notification',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-07-17T07:40:44Z',
    last_updated: '2020-08-04T10:00:18.014Z',
  },
  45369: {
    code: 45369,
    message: 'Failed to create inbound Channel.  Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45369\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'We failed to create an outbound Channel due to an unexpected error condition.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to create outbound Channel due to an internal error.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:06.516345Z',
  },
  31000: {
    code: 31000,
    message: 'Generic error',
    log_level: 'ERROR',
    secondary_message:
      'No further information available. Check the debugger for more information on the actual cause.',
    log_type: null,
    docs: '## Error - 31000\r\n\r\n### Generic error\r\n\r\n#### Possible Solutions\r\n\r\n- No further information available. Check the debugger for more information on the actual cause. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-10-05T22:56:56Z',
    last_updated: '2020-08-04T10:00:16.973Z',
  },
  30891: {
    code: 30891,
    message: 'Campaign vetting rejection - Invalid Website URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30891\r\n\r\n### Campaign vetting rejection - Invalid Website URL\r\n\r\n The campaign submission has been reviewed and it was rejected because of unverifiable website.\r\n\r\n#### Possible Causes\r\n* An invalid URL was provided during the registration process.\r\n* The website associated with the campaign is not functioning or inaccessible.\r\n* Opt-in flow is not found on website provided.\r\n* Lack of proper indication in the campaign description if the registration pertains to a pre-launch website.\r\n\r\n#### Possible Solutions\r\n* Verify that the provided website(s) are functioning correctly, and accessible. If the website(s) are geographic specific, please indicate this in the campaign description and provide a link to a screenshot.\r\n* If the registration is for a pre-launch website, instead include a publically accessible URL to view a screenshot of the SMS opt-in flow that will appear.\r\n* If opt-in occurs on website, provide the direct link in the Message Flow field.\r\n* If opt-in is collected through a paper form or behind a login, supply a hosted link to an image of the opt-in. If the opt-in occurs on a website, provide the relevant link.\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      '* An invalid URL was provided during the registration process.\r\n* The website associated with the campaign is not functioning or inaccessible.\r\n* Opt-in flow is not found on website provided.\r\n* Lack of proper indication in the campaign description if the registration pertains to a pre-launch website.',
    solutions:
      '* Verify that the provided website(s) are functioning correctly, and accessible. If the website(s) are geographic specific, please indicate this in the campaign description and provide a link to a screenshot.\r\n* If the registration is for a pre-launch website, instead include a publically accessible URL to view a screenshot of the SMS opt-in flow that will appear.\r\n* If opt-in occurs on website, provide the direct link in the Message Flow field.\r\n* If opt-in is collected through a paper form or behind a login, supply a hosted link to an image of the opt-in. If the opt-in occurs on a website, provide the relevant link.\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because of unverifiable website.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:39:48Z',
    last_updated: '2023-09-13T19:29:10.659958Z',
  },
  60333: {
    code: 60333,
    message: 'The SMS message was sent using a brandless template.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60333\r\n\r\n### The SMS message was sent using a brandless template.\r\n\r\n The SMS message was sent using a brandless template, instead of the template that you configured, which contains a friendly name (brand).\r\n\r\n#### Possible Causes\r\nDue to mobile carrier regulations, Verify needs to remove the friendly name from the message body. \r\nThis is due to compliance, and our best-effort to ensure delivery of your OTP to certain restricted destinations.\r\n\r\n#### Possible Solutions\r\nConfigure a dedicated Sender ID or phone number to send messages, instead of using a shared one.\r\n\r\nTo learn more, see <a href="https://support.twilio.com/hc/en-us/articles/12387480513307-Why-was-my-friendly-name-not-included-in-the-Verify-SMS-">Why was my friendly name not included in the Verify SMS?</a>',
    causes:
      'Due to mobile carrier regulations, Verify needs to remove the friendly name from the message body. \r\nThis is due to compliance, and our best-effort to ensure delivery of your OTP to certain restricted destinations.',
    solutions:
      'Configure a dedicated Sender ID or phone number to send messages, instead of using a shared one.\r\n\r\nTo learn more, see <a href="https://support.twilio.com/hc/en-us/articles/12387480513307-Why-was-my-friendly-name-not-included-in-the-Verify-SMS-">Why was my friendly name not included in the Verify SMS?</a>',
    description:
      'The SMS message was sent using a brandless template, instead of the template that you configured, which contains a friendly name (brand).',
    product: 'Verify',
    date_created: '2023-01-27T16:26:17Z',
    last_updated: '2023-02-23T04:58:02.05733Z',
  },
  45366: {
    code: 45366,
    message: 'Failed to create Channel.  Invalid request parameters.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45366\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'Invalid or missing parameters supplied in the create Channel request.',
    solutions: 'Ensure that request parameters are in accordance with the public documentation.\r',
    description: 'Failed to create Channel <channel sid> due to invalid request parameters.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:01.331929Z',
  },
  10001: {
    code: 10001,
    message: 'Account is not active',
    log_level: 'ERROR',
    secondary_message: 'This account has been disabled and may not be used until it is reactived.',
    log_type: 'TWILIO',
    docs: '## ERROR - 10001\r\n\r\n### Account is not active\r\n\r\nThis account has been disabled and may not be used until it is reactived. This account has been disabled and may not be used until it is reactivated.\r\n\r\n#### Possible Causes\r\n*  Lack of funds\r\n*   Violation of the Terms of Service or Acceptable Use Policy\r\n\r\n#### Possible Solutions\r\n*  Check your account balance.  Refill funds if necessary.\t\r\n*  Please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes: '*  Lack of funds\r\n*   Violation of the Terms of Service or Acceptable Use Policy',
    solutions:
      '*  Check your account balance.  Refill funds if necessary.\t\r\n*  Please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description: 'This account has been disabled and may not be used until it is reactivated.',
    product: null,
    date_created: '2016-03-31T17:13:21Z',
    last_updated: '2023-11-01T04:47:50.904317Z',
  },
  50507: {
    code: 50507,
    message: 'Programmable Chat: Media not found',
    log_level: 'ERROR',
    secondary_message: 'Media with specified SID does not exist. ',
    log_type: null,
    docs: '## Error - 50507\r\n\r\n### Programmable Chat: Media not found\t\r\n\r\n#### Possible Causes \r\n*  Media with specified SID does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Media SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:37:07Z',
    last_updated: '2020-08-04T10:00:16.439Z',
  },
  31923: {
    code: 31923,
    message: 'Stream - WebSocket - Malformed URL',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31923\r\n\r\n### Stream - WebSocket - Malformed URL\r\n\r\n \r\n\r\n#### Possible Causes\r\n* URL schema is malformed\r\n\r\n#### Possible Solutions\r\n* Verify the URL in TwiML is correct ',
    causes: '* URL schema is malformed',
    solutions: '* Verify the URL in TwiML is correct ',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:56:03Z',
    last_updated: '2020-08-04T10:00:07.326Z',
  },
  80605: {
    code: 80605,
    message: 'Proxy Identifier Not In Service',
    log_level: 'WARNING',
    secondary_message: 'Proxy identifier not associated with service.',
    log_type: null,
    docs: '## Warning\n\n### Proxy Identifier Not In Service\n\nExample Message: Proxy identifier not associated with service.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.788Z',
  },
  30024: {
    code: 30024,
    message: 'Numeric Sender ID Not Provisioned on Carrier',
    log_level: 'ERROR',
    secondary_message: 'Provisioning Issue with Carrier',
    log_type: 'CARRIER',
    docs: "## ERROR - 30024\r\n\r\n### Numeric Sender ID Not Provisioned on Carrier\r\n\r\nProvisioning Issue with Carrier You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Numeric Sender ID pre-registration and provisioning. The Numeric Sender ID is not currently provisioned with the carrier.\r\n\r\n#### Possible Causes\r\n* The Numeric Sender ID has not been provisioned by the carrier yet. Typically in this situation you would see >90% failures towards the carrier.\r\n* If this is for US A2P 10DLC and you just registered this number, it could take a brief period of time for all carriers to provision the number to your campaign. Typically you would see all messages towards a single carrier fail, if the code isn't provisioned.\r\n* Your shortcode has not been fully provisioned for production traffic, or the carrier has disabled your shortcode due to cancellation or compliance violations. Typically in this situation you would see >90% failures towards the carrier.\r\n* The destination number has recently ported to a new carrier and the port hasn't completed 100%.\r\n* Your toll-free number has not been fully provisioned for production traffic. \r\n*The destination number is not provisioned to receive SMS messages.\r\n\r\n\r\n\r\n#### Possible Solutions\r\n* If you believe your Numeric Sender ID should be registered, please collect 3 or more examples of Message SIDs that have the “undelivered” status with error 30024, and then contact our Support team. We can help review the registration status to resolve these errors. ",
    causes:
      "* The Numeric Sender ID has not been provisioned by the carrier yet. Typically in this situation you would see >90% failures towards the carrier.\r\n* If this is for US A2P 10DLC and you just registered this number, it could take a brief period of time for all carriers to provision the number to your campaign. Typically you would see all messages towards a single carrier fail, if the code isn't provisioned.\r\n* Your shortcode has not been fully provisioned for production traffic, or the carrier has disabled your shortcode due to cancellation or compliance violations. Typically in this situation you would see >90% failures towards the carrier.\r\n* The destination number has recently ported to a new carrier and the port hasn't completed 100%.\r\n* Your toll-free number has not been fully provisioned for production traffic. \r\n*The destination number is not provisioned to receive SMS messages.\r\n\r\n",
    solutions:
      '* If you believe your Numeric Sender ID should be registered, please collect 3 or more examples of Message SIDs that have the “undelivered” status with error 30024, and then contact our Support team. We can help review the registration status to resolve these errors. ',
    description:
      'You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Numeric Sender ID pre-registration and provisioning. The Numeric Sender ID is not currently provisioned with the carrier.',
    product: 'Programmable SMS',
    date_created: '2021-08-02T17:24:37Z',
    last_updated: '2022-10-10T21:09:03.943013Z',
  },
  14222: {
    code: 14222,
    message: 'Enqueue: Could not create Task',
    log_level: 'ERROR',
    secondary_message: 'The Task attributes could not be matched a Workflow.',
    log_type: null,
    docs: '## Error - 14222\r\n\r\n### Enqueue: Could not create Task\r\n\r\nCould not match the task to a target given the defined attributes.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2017-12-15T21:31:29Z',
    last_updated: '2020-08-04T10:00:15.479Z',
  },
  60313: {
    code: 60313,
    message: 'Unauthorized factor creation',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60313\r\n\r\n### Unauthorized factor creation\r\n\r\n You are not authorized to create a Factor.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nYou do not have the permissions required to create a Factor.\r\n\r\n#### Possible Solutions\r\nRequest permissions.',
    causes: 'You do not have the permissions required to create a Factor.',
    solutions: 'Request permissions.',
    description: 'You are not authorized to create a Factor.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-06-30T17:04:43Z',
    last_updated: '2021-06-30T03:44:13.103591Z',
  },
  30029: {
    code: 30029,
    message: 'Invalid ContentRetention',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30029\r\n\r\n### Invalid ContentRetention\r\n\r\n ContentRetention value used in the request is invalid\r\n\r\n#### Possible Causes\r\nContentRetention is not either 'retain', 'discard' or 'debug' or Message Privacy features are not enabled for this account\r\n\r\n#### Possible Solutions\r\nEnable the correct Message Privacy features and use a valid value for ContentRetention",
    causes:
      "ContentRetention is not either 'retain', 'discard' or 'debug' or Message Privacy features are not enabled for this account",
    solutions:
      'Enable the correct Message Privacy features and use a valid value for ContentRetention',
    description: 'ContentRetention value used in the request is invalid',
    product: 'Programmable SMS',
    date_created: '2022-01-26T11:54:26Z',
    last_updated: '2022-01-26T12:36:14.630915Z',
  },
  48030: {
    code: 48030,
    message: 'Outgoing conversation: Proxy address is not WhatsApp-enabled sender',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48030\r\n\r\n### Outgoing conversation: Proxy address is not WhatsApp-enabled sender\r\n\r\n A WhatsApp conversation could not be created because the provided Twilio proxy number is not a WhatsApp-enabled sender.\r\n\r\n#### Possible Causes\r\n* The Outgoing Conversation callback returned a Twilio proxy number that was properly formatted, but not configured as a WhatsApp-enabled sender.\r\n\r\n#### Possible Solutions\r\n* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback is a WhatsApp-enabled sender.\r\n    * Check out the [docs](https://www.twilio.com/docs/whatsapp/api#using-twilio-phone-numbers-with-whatsapp) for how to configure WhatsApp-enabled senders as a Twilio proxy number.\r\n    * Manage your WhatsApp-enabled senders from the [console](https://twilio.com/console/sms/whatsapp/senders).',
    causes:
      '* The Outgoing Conversation callback returned a Twilio proxy number that was properly formatted, but not configured as a WhatsApp-enabled sender.',
    solutions:
      '* Make sure that the `proxy_address` value that is returned from the Outgoing Conversation callback is a WhatsApp-enabled sender.\r\n    * Check out the [docs](https://www.twilio.com/docs/whatsapp/api#using-twilio-phone-numbers-with-whatsapp) for how to configure WhatsApp-enabled senders as a Twilio proxy number.\r\n    * Manage your WhatsApp-enabled senders from the [console](https://twilio.com/console/sms/whatsapp/senders).',
    description:
      'A WhatsApp conversation could not be created because the provided Twilio proxy number is not a WhatsApp-enabled sender.',
    product: 'Frontline',
    date_created: '2022-04-20T15:54:50Z',
    last_updated: '2022-05-20T10:05:19.071962Z',
  },
  50206: {
    code: 50206,
    message: 'Programmable Chat: Identity should not match user SID pattern',
    log_level: 'ERROR',
    secondary_message: 'Specified User\'s Identity matches User SID Pattern "US[0-9a-f]{32}"',
    log_type: null,
    docs: '## Error - 50206\r\n\r\n### Programmable Chat: Identity should not match user SID pattern\r\n\r\n#### Possible Causes \r\n*  Specified User\'s Identity matches User SID Pattern "US[0-9a-f]{32}".\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User\'s Identity is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-04-15T11:22:50Z',
    last_updated: '2020-08-04T10:00:22.557Z',
  },
  13112: {
    code: 13112,
    message: 'Annotate: Invalid nested element',
    log_level: 'WARNING',
    secondary_message: 'You may only nest BillingReferenceTag elements in Annotate',
    log_type: null,
    docs: '## Warning - 13112 \n\n### Annotate: Invalid nested element\n\nYou may only nest BillingReferenceTag elements in Annotate\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:30Z',
    last_updated: '2020-08-04T10:00:29.043Z',
  },
  45771: {
    code: 45771,
    message: 'Failed to create InboundConversation. Internal Error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45771\r\n\r\n### Failed to create InboundConversation. Internal Error.\r\n\r\n An unexpected error occurred while creating Inbound Conversation. \r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error processing the request.\r\n\r\n#### Possible Solutions\r\n"Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate."',
    causes: 'We encountered an unexpected error processing the request.',
    solutions:
      '"Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate."',
    description: 'An unexpected error occurred while creating Inbound Conversation. ',
    product: 'Flex',
    date_created: '2023-03-24T16:09:49Z',
    last_updated: '2023-03-24T16:09:49Z',
  },
  25003: {
    code: 25003,
    message: "The provided user's last name is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25003\r\n\r\n### The provided user's last name is invalid\r\n\r\n The provided user's last name is invalid.\r\n\r\n#### Possible Causes\r\nThe last name is either less than 2 characters or exceeds 255 characters.\r\n\r\n#### Possible Solutions\r\nEnsure the user's last name is between 2 and 255 characters in length.",
    causes: 'The last name is either less than 2 characters or exceeds 255 characters.',
    solutions: "Ensure the user's last name is between 2 and 255 characters in length.",
    description: "The provided user's last name is invalid.",
    product: 'Organizations API',
    date_created: '2023-12-04T09:44:01Z',
    last_updated: '2023-12-04T14:09:15.055266Z',
  },
  62007: {
    code: 62007,
    message: 'Direct connect is not associated with the exchange.',
    log_level: 'ERROR',
    secondary_message:
      'The direct connect SID in the request is not associated with the exchange SID in the request. Choose a direct connect SID that is associated with the exchange SID, or choose an exchange SID associated with the direct connect SID.',
    log_type: null,
    docs: '## Error - 62007\r\n\r\n### Direct connect is not associated with the exchange\r\n\r\nThe direct connect SID in the request is not associated with the exchange\r\nSID in the request. Choose a direct connect SID that is associated with the\r\nexchange SID, or choose an exchange SID associated with the direct connect\r\nSID.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:37:08Z',
    last_updated: '2020-08-04T10:00:21.074Z',
  },
  50435: {
    code: 50435,
    message: 'Group MMS activation failed.',
    log_level: 'ERROR',
    secondary_message: 'Group MMS activation with the new list of participants has failed.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 50435\r\n\r\n### Group MMS activation failed.\r\n\r\nGroup MMS activation with the new list of participants has failed. The conversation's Group MMS could not be activated.\r\n\r\n#### Possible Causes\r\n* The conversation does not have at least three participants with messaging binding.\r\n* The conversation has got a participant with identity but without projected address.\r\n* The conversation's participants do not make a valid address list for group messaging.\r\n\r\n#### Possible Solutions\r\n* Check that all the participants have messaging bindings.\r\n* Check that there is at least one participant with user address only.\r\n* Check that there is at least one participant with a proxy address or a projected address.",
    causes:
      "* The conversation does not have at least three participants with messaging binding.\r\n* The conversation has got a participant with identity but without projected address.\r\n* The conversation's participants do not make a valid address list for group messaging.",
    solutions:
      '* Check that all the participants have messaging bindings.\r\n* Check that there is at least one participant with user address only.\r\n* Check that there is at least one participant with a proxy address or a projected address.',
    description: "The conversation's Group MMS could not be activated.",
    product: 'Programmable Chat',
    date_created: '2021-08-16T11:56:33Z',
    last_updated: '2021-08-16T11:56:33Z',
  },
  91102: {
    code: 91102,
    message: 'Subscription could not be found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91102\r\n\r\n### Subscription could not be found\r\n\r\n Subscription could not be found\r\n\r\n#### Possible Causes\r\n* Subscription does not exist\r\n* Invalid sid\r\n\r\n#### Possible Solutions\r\n* Make sure subscription exists\r\n* Pass an valid sid for the subscription',
    causes: '* Subscription does not exist\r\n* Invalid sid',
    solutions: '* Make sure subscription exists\r\n* Pass an valid sid for the subscription',
    description: 'Subscription could not be found',
    product: 'Events',
    date_created: '2020-09-16T14:42:34Z',
    last_updated: '2021-01-06T16:33:08.191Z',
  },
  94100: {
    code: 94100,
    message: 'Transcriptions: status callback response error',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 94100\r\n\r\n### Transcriptions: status callback response error\r\n\r\n Twilio attempted to send a transcription event to the callback URL specified and your application returned a 4xx or 5xx or other HTTP response error\r\n\r\n#### Possible Causes\r\n* The callback URL specified is incorrect\r\n* Your application has an issue while handling callback requests or suffering and outage\r\n\r\n#### Possible Solutions\r\n* Ensure that the callback URL specified is correct\r\n* Ensure that your callback server can handle the request and responds with a 2xx HTTP status code',
    causes:
      '* The callback URL specified is incorrect\r\n* Your application has an issue while handling callback requests or suffering and outage',
    solutions:
      '* Ensure that the callback URL specified is correct\r\n* Ensure that your callback server can handle the request and responds with a 2xx HTTP status code',
    description:
      'Twilio attempted to send a transcription event to the callback URL specified and your application returned a 4xx or 5xx or other HTTP response error',
    product: null,
    date_created: '2021-08-31T11:16:33Z',
    last_updated: '2021-08-31T11:16:33Z',
  },
  25200: {
    code: 25200,
    message: 'The scope for role assignments must be a managed account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25200\r\n\r\n### The scope for role assignments must be a managed account\r\n\r\n The scope for role assignments must be a managed account.\r\n\r\n#### Possible Causes\r\nThe role assignments scope was set to "organization" or an independent account.\r\n\r\n#### Possible Solutions\r\nVerify the role assignments scope is a managed account.',
    causes: 'The role assignments scope was set to "organization" or an independent account.',
    solutions: 'Verify the role assignments scope is a managed account.',
    description: 'The scope for role assignments must be a managed account.',
    product: 'Organizations API',
    date_created: '2023-12-04T11:49:12Z',
    last_updated: '2023-12-04T14:28:08.062704Z',
  },
  22218: {
    code: 22218,
    message: 'The Supporting Document field does not match the field in the End-User',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22218\r\n\r\n### The Supporting Document field does not match the field in the End-User\r\n\r\n The Supporting Document field does not match the field in the End-User.\r\n\r\n#### Possible Causes\r\nThe Regulation requires the fields on the Supporting Document and End-User to match.\r\n\r\n#### Possible Solutions\r\nPlease ensure that the field in the Supporting Document matches the field in the End-User.',
    causes: 'The Regulation requires the fields on the Supporting Document and End-User to match.',
    solutions:
      'Please ensure that the field in the Supporting Document matches the field in the End-User.',
    description: 'The Supporting Document field does not match the field in the End-User.',
    product: 'Phone Numbers',
    date_created: '2020-04-23T22:15:43Z',
    last_updated: '2020-08-04T10:00:03.717Z',
  },
  63100: {
    code: 63100,
    message: 'Validation Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63100\r\n\r\n### Validation Error\r\n\r\n The request body is either empty, not valid JSON, or failed other validation rules. Please refer to the response's message parameter for additional guidance. \r\n\r\n#### Possible Causes\r\n* Request body was empty\r\n* Request body was not valid JSON\r\n* Request body failed other validation rules\r\n\r\n#### Possible Solutions\r\n* Review the response's message parameter for additional details\r\n* Verify the request body contains valid JSON according to the documentation",
    causes:
      '* Request body was empty\r\n* Request body was not valid JSON\r\n* Request body failed other validation rules',
    solutions:
      "* Review the response's message parameter for additional details\r\n* Verify the request body contains valid JSON according to the documentation",
    description:
      "The request body is either empty, not valid JSON, or failed other validation rules. Please refer to the response's message parameter for additional guidance. ",
    product: 'Channels',
    date_created: '2024-02-09T22:22:49Z',
    last_updated: '2024-02-09T22:22:49Z',
  },
  63009: {
    code: 63009,
    message:
      'Channel provider returned an internal service error (HTTP 5xx). Please see Channel specific error message for more information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel returned an error when executing the request\r\n\r\n#### Possible Causes \r\n*  Please see Channel specific error message for more information.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:23:54Z',
    last_updated: '2020-08-04T10:00:14.454Z',
  },
  90039: {
    code: 90039,
    message: "Broadcast 'MessageStatusCallbackUrl' is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90039\r\n\r\n### Broadcast 'MessageStatusCallbackUrl' is invalid\r\n\r\n Broadcast 'MessageStatusCallbackUrl' is invalid\r\n\r\n#### Possible Causes\r\n'MessageStatusCallbackUrl' has invalid URL format or schema. Messaging allows only HTTP or HTTPS schemas\r\n\r\n#### Possible Solutions\r\nUse correct http or https URL",
    causes:
      "'MessageStatusCallbackUrl' has invalid URL format or schema. Messaging allows only HTTP or HTTPS schemas",
    solutions: 'Use correct http or https URL',
    description: "Broadcast 'MessageStatusCallbackUrl' is invalid",
    product: null,
    date_created: '2020-12-11T15:53:24Z',
    last_updated: '2020-12-11T15:53:24Z',
  },
  20151: {
    code: 20151,
    message: 'Authentication Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20151\r\n\r\n### Authentication Failed\r\nThe Authentication with the provided JWT failed.\r\n\r\n\r\n#### Possible Causes \r\n* The system could not perform the authorization for the given request.\r\n\r\n#### Possible Solution:\r\n* Retry, if this keeps happening, please contact the Twilio Support\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T15:59:36Z',
    last_updated: '2020-08-04T10:00:19.141Z',
  },
  54453: {
    code: 54453,
    message: "Invalid 'PageToken' query parameter",
    log_level: 'ERROR',
    secondary_message: 'Your query specifies an invalid paging token.',
    log_type: null,
    docs: "## Error - 54453\r\n\r\n### Sync: Invalid 'PageToken' query parameter\r\nThe specified 'PageToken' query parameter is invalid.\r\n\r\n#### Possible Causes\r\n* The value supplied by the PageToken query string parameter is invalid or malformed.\r\n\r\n#### Possible Solutions\r\nEnsure that a valid PageToken parameter is supplied, as originally included in the previous/next page links under the _meta_ block of pagination response.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.19Z',
  },
  13327: {
    code: 13327,
    message: 'Gather: Invalid speechTimeout value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 13327 \r\n\r\n### Gather: Invalid speechTimeout value',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-06-13T21:24:51Z',
    last_updated: '2020-08-04T10:00:18.304Z',
  },
  30114: {
    code: 30114,
    message: 'Specified date is not available yet',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30114\r\n\r\n### Specified date is not available yet\r\n\r\n Deactivation list data is not yet available for the date that you specified.\r\n\r\n#### Possible Causes\r\n- You have specified a date in the future\r\n- You have specified today and Twilio has yet to process data for today yet\r\n\r\n#### Possible Solutions\r\nPlease either specify an earlier date or wait for Twilio to process today's data.",
    causes:
      '- You have specified a date in the future\r\n- You have specified today and Twilio has yet to process data for today yet',
    solutions: "Please either specify an earlier date or wait for Twilio to process today's data.",
    description: 'Deactivation list data is not yet available for the date that you specified.',
    product: 'Programmable SMS',
    date_created: '2020-08-27T19:49:17Z',
    last_updated: '2020-08-27T19:49:17Z',
  },
  30003: {
    code: 30003,
    message: 'Unreachable destination handset',
    log_level: 'ERROR',
    secondary_message:
      'The destination handset you are trying to reach is switched off or otherwise unavailable.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30003\r\n\r\n### Unreachable destination handset\r\n\r\nThe destination handset you are trying to reach is switched off or otherwise unavailable. ### Unreachable destination handset\r\n\r\nThe destination handset you are trying to reach is switched off or otherwise unavailable. \r\n\r\n#### Possible Causes\r\n*  The destination handset you are trying to reach is switched off or otherwise unavailable.\r\n*  The device you are trying to reach does not have sufficient signal\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline)\r\n*  There is an issue with the mobile carrier\r\n\r\n#### Possible Solutions\r\nIn some cases, a delivery error may occur once due to a transient issue downstream of Twilio. To test whether the issue occurs again, please attempt to send another message to the user via a [REST API](https://help.twilio.com/articles/223133907-Simple-example-for-sending-SMS-or-MMS-messages) request.\r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not power the device off, wait 30 seconds, and then power it back up.\r\n*  Is the device connected to the home carrier\'s network? We cannot guarantee message delivery on devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (non-Alphanumeric Sender ID), or with a shorter one-segment (non-concatenated) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\nIf you can rule out all of the above issues, continue troubleshooting below.\r\n\r\n#### Messages sent from short codes\r\nRepeated Error 30003 results on undelivered messages sent from [short codes](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code) could occur if the destination user has a wireless plan that does not support short code or "Premium" messages.\r\n\r\n**Sprint** customers may be able to allow messages sent from your short code by texting the phrase `Allow XXXXX` to **9999**, replacing `XXXXX` with your short code. However, customers from other wireless carriers will likely need to reach out to their carrier\'s support group to enable "Premium" or short code messaging.\r\n\r\n#### Messages sent from long codes\r\nRepeated Error 30003 results on undelivered messages sent from long codes (regular phone numbers) and Toll-Free numbers could be due to carrier filtering. \r\n\r\nThe rules for carrier filtering vary throughout the industry, making it difficult at times to pin down exactly why a message is being filtered out. For more details including potential workarounds, please see this Help Center article ["How Does Carrier Filtering Work?"](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work)\r\n\r\n#### Continued Error 30003 issues\r\nTwilio\'s Support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30003, and [open a support request](https://www.twilio.com/console/support/tickets/create).',
    causes:
      '*  The destination handset you are trying to reach is switched off or otherwise unavailable.\r\n*  The device you are trying to reach does not have sufficient signal\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline)\r\n*  There is an issue with the mobile carrier',
    solutions:
      'In some cases, a delivery error may occur once due to a transient issue downstream of Twilio. To test whether the issue occurs again, please attempt to send another message to the user via a [REST API](https://help.twilio.com/articles/223133907-Simple-example-for-sending-SMS-or-MMS-messages) request.\r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not power the device off, wait 30 seconds, and then power it back up.\r\n*  Is the device connected to the home carrier\'s network? We cannot guarantee message delivery on devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (non-Alphanumeric Sender ID), or with a shorter one-segment (non-concatenated) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\nIf you can rule out all of the above issues, continue troubleshooting below.\r\n\r\n#### Messages sent from short codes\r\nRepeated Error 30003 results on undelivered messages sent from [short codes](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code) could occur if the destination user has a wireless plan that does not support short code or "Premium" messages.\r\n\r\n**Sprint** customers may be able to allow messages sent from your short code by texting the phrase `Allow XXXXX` to **9999**, replacing `XXXXX` with your short code. However, customers from other wireless carriers will likely need to reach out to their carrier\'s support group to enable "Premium" or short code messaging.\r\n\r\n#### Messages sent from long codes\r\nRepeated Error 30003 results on undelivered messages sent from long codes (regular phone numbers) and Toll-Free numbers could be due to carrier filtering. \r\n\r\nThe rules for carrier filtering vary throughout the industry, making it difficult at times to pin down exactly why a message is being filtered out. For more details including potential workarounds, please see this Help Center article ["How Does Carrier Filtering Work?"](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work)\r\n\r\n#### Continued Error 30003 issues\r\nTwilio\'s Support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30003, and [open a support request](https://www.twilio.com/console/support/tickets/create).',
    description:
      '### Unreachable destination handset\r\n\r\nThe destination handset you are trying to reach is switched off or otherwise unavailable. ',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:34Z',
    last_updated: '2024-05-21T08:05:30.491285Z',
  },
  30455: {
    code: 30455,
    message: 'Toll-Free phone number verification rejection - Disallowed: SHAFT - Hate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30455\r\n\r\n### Toll-Free phone number verification rejection - Disallowed: SHAFT - Hate\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category - (SHAFT: Hate). \r\n\r\nTwilio does not allow Hate speech, harassment, exploitative, abusive, or any communications that originate from a hate group.\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category - (SHAFT: Hate). \r\n\r\nTwilio does not allow Hate speech, harassment, exploitative, abusive, or any communications that originate from a hate group.',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-21T19:45:22Z',
    last_updated: '2024-02-21T19:45:22Z',
  },
  50303: {
    code: 50303,
    message: 'Programmable Chat: Attributes too long',
    log_level: 'ERROR',
    secondary_message: "Specified Channel's Attributes parameter is too long.",
    log_type: null,
    docs: "## Error - 50303\r\n\r\n### Programmable Chat: Attributes too long\r\n\r\n#### Possible Causes \r\n*  Specified Channel's Attributes parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Channel's Attributes is being passed in request. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:50Z',
    last_updated: '2020-08-04T10:00:23.168Z',
  },
  22208: {
    code: 22208,
    message: 'Supporting Document status and attributes cannot be updated in the same request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22208\r\n\r\n### Supporting Document status and attributes cannot be updated in the same request\r\n\r\n Both the Supporting Documents status and the attributes were present in the update request.\r\n\r\n#### Possible Causes\r\nThe Supporting Documents status cannot have both the status and the attributes in the same update request.\r\n\r\n#### Possible Solutions\r\nSend the attributes in the update request followed with a status update in another request.',
    causes:
      'The Supporting Documents status cannot have both the status and the attributes in the same update request.',
    solutions:
      'Send the attributes in the update request followed with a status update in another request.',
    description:
      'Both the Supporting Documents status and the attributes were present in the update request.',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:46:52Z',
    last_updated: '2020-08-04T10:00:05.564Z',
  },
  16105: {
    code: 16105,
    message: 'Voice Recording: Unavailable due to no valid public keys',
    log_level: 'ERROR',
    secondary_message:
      'Recording was not stored due to no valid public keys on the account  (only applicable if call recording encryption feature enabled)',
    log_type: null,
    docs: '## Error - 16105\r\n\r\n### Voice Recording: Unavailable due to no valid public keys\r\n\r\nRecording was not stored because there were no valid public keys on the account  (only applicable if call recording encryption feature enabled)',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-08-25T22:27:42Z',
    last_updated: '2020-08-04T10:00:17.888Z',
  },
  21209: {
    code: 21209,
    message: 'Invalid Method',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to initiate an outbound phone call, but you sent a <span class='rest-attribute'>Method</span> paramter that was invalid.  <span class='rest-attribute'>Method</span> specifies what HTTP method Twilio should use in contacting your web server.  Possible values are GET and POST.",
    log_type: null,
    docs: "## Error - 21209 \n\n### Invalid Method\n\nYou attempted to initiate an outbound phone call, but you sent a <span class='rest-attribute'>Method</span> parameter that was invalid.  <span class='rest-attribute'>Method</span> specifies what HTTP method Twilio should use in contacting your web server.  Possible values are GET and POST.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:56Z',
    last_updated: '2020-08-04T10:00:27.151Z',
  },
  45763: {
    code: 45763,
    message: 'Unable to validate address configuration. Auto create studio flow SID missing. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45763\r\n\r\n### Unable to validate address configuration. Auto create studio flow SID missing. \r\n\r\n Unable to validate address configuration for provided address SID. Auto create studio flow SID missing. \r\n\r\n#### Possible Causes\r\nAddress configuration associated with the provided address SID has auto create type set to STUDIO but no corresponding studio flow SID. \r\n\r\n#### Possible Solutions\r\nEnsure that the address SID provided is valid and associated with the correct account. \r\n\r\nEnsure that the auto create type in address configuration is correct. If your auto create type is set to STUDIO, ensure the studio flow SID is present and correct in address configuration. \r\n\r\nRead more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#create-an-addressconfiguration-resource)\r\n\r\nRead more about creating a studio flow [here.](https://www.twilio.com/docs/usage/webhooks/webhooks-overview)',
    causes:
      'Address configuration associated with the provided address SID has auto create type set to STUDIO but no corresponding studio flow SID. ',
    solutions:
      'Ensure that the address SID provided is valid and associated with the correct account. \r\n\r\nEnsure that the auto create type in address configuration is correct. If your auto create type is set to STUDIO, ensure the studio flow SID is present and correct in address configuration. \r\n\r\nRead more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#create-an-addressconfiguration-resource)\r\n\r\nRead more about creating a studio flow [here.](https://www.twilio.com/docs/usage/webhooks/webhooks-overview)',
    description:
      'Unable to validate address configuration for provided address SID. Auto create studio flow SID missing. ',
    product: 'Flex',
    date_created: '2022-10-03T21:16:41Z',
    last_updated: '2022-10-03T21:16:41Z',
  },
  11203: {
    code: 11203,
    message: 'HTTP communication total time out triggered',
    log_level: 'ERROR',
    secondary_message: 'All attempts to communicate with your web server were timed out.',
    log_type: null,
    docs: "## Error - 11203\r\n\r\n### HTTP communication total time out triggered\r\nAll attempts to communicate with your web server were timed out. You set the total timeout using the tt parameter in the URL fragment identifier.\r\n\r\n#### Possible Solutions\r\n*  Adjust the 'tt' (total timeout) parameter in the fragment part of the URL, the one after '#'.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-31T00:28:56Z',
    last_updated: '2020-08-04T10:00:10.848Z',
  },
  63003: {
    code: 63003,
    message: 'Channel could not find To address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63003\r\n\r\n### Channel could not find To address\r\n\r\n You have tried to send a message to a To address that is inactive or invalid.\r\n\r\n#### Possible Causes\r\n* The To address is no invalid or longer belongs to a mobile user\r\n* The To address was entered or formatted incorrectly\r\n\r\n#### Possible Solutions\r\n* Ensure you have provided the correct To address for the user you are trying to reach\r\n* Ensure that the To address is still active',
    causes:
      '* The To address is no invalid or longer belongs to a mobile user\r\n* The To address was entered or formatted incorrectly',
    solutions:
      '* Ensure you have provided the correct To address for the user you are trying to reach\r\n* Ensure that the To address is still active',
    description: 'You have tried to send a message to a To address that is inactive or invalid.',
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:17:17Z',
    last_updated: '2020-08-04T10:00:14.531Z',
  },
  63043: {
    code: 63043,
    message: 'Link to a sample media file returns 403 Forbidden',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63043\r\n\r\n### Link to a sample media file returns 403 Forbidden\r\n\r\n The link returned a status code of 403 Forbidden, making it impossible to retrieve the file.\r\n\r\n#### Possible Causes\r\n- Server requires authorization\r\n\r\n#### Possible Solutions\r\n- Use a publicly accessible URL\r\n- Use a URL that includes an access token',
    causes: '- Server requires authorization',
    solutions: '- Use a publicly accessible URL\r\n- Use a URL that includes an access token',
    description:
      'The link returned a status code of 403 Forbidden, making it impossible to retrieve the file.',
    product: 'Programmable Messaging',
    date_created: '2023-03-24T15:47:37Z',
    last_updated: '2023-03-24T16:32:42.873105Z',
  },
  12100: {
    code: 12100,
    message: 'Document parse failure',
    log_level: 'ERROR',
    secondary_message: 'Twilio was unable to parse the provided XML Document.',
    log_type: null,
    docs: '## Error - 12100\n\n### Document parse failure\n\nTwilio was unable to parse the provided XML Document.\n\nYour TwiML document must be a valid XML Document, or Twilio will not\nbe able to read your document. You can debug XML parsing errors by\ngetting the response body in the [debugger](/user/account/debugger),\nand then using an online validation tool like the\n[W3C Validation Service](http://validator.w3.org/#validate_by_input).\n\n#### Possible Causes\n*   There is a leading space, or an empty line, before the XML type header (i.e. ` <?xml version="1.0" encoding="UTF-8"?>`)\n*   The root `<Response>` element is missing\n*   There is an unclosed element\n*   There is an unquoted attribute\n*   There is an improperly nested element\n\n#### Possible Solutions\n*   Make sure there is no extra space or line at the beginning of the file before the type header\n*   Make sure your root element is &lt;Response&gt;\n*   XML is case sensitive, make sure your start and end elements match case. (Twilio elements begin with a capital letter)\n*   Make sure characters such as &lt; &gt; and &amp; are escaped properly, as `&lt; &gt; and &amp;`.\n\n[redirect]:/docs/api/twiml/redirect\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:27Z',
    last_updated: '2020-08-04T10:00:29.204Z',
  },
  60224: {
    code: 60224,
    message: 'Missing substitutions for selected template',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60224\r\n\r\n### Missing substitutions for selected template\r\n\r\n The selected template has some substitutions that were not provided in the request.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nThe template requires extra fields for building the message that are not included in the request. \r\n\r\nLike when a template is in the form "Your {{app}} code is {{code}}" but the substitutions map doesn\'t include the "app" value.\r\n\r\n\r\n#### Possible Solutions\r\n* Make sure that you include all the substitutions for filling the place holders in the template.',
    causes:
      'The template requires extra fields for building the message that are not included in the request. \r\n\r\nLike when a template is in the form "Your {{app}} code is {{code}}" but the substitutions map doesn\'t include the "app" value.\r\n',
    solutions:
      '* Make sure that you include all the substitutions for filling the place holders in the template.',
    description:
      'The selected template has some substitutions that were not provided in the request.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2021-06-16T15:51:44Z',
    last_updated: '2021-06-30T03:36:53.358067Z',
  },
  60366: {
    code: 60366,
    message: 'Entity invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60366\r\n\r\n### Entity invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Entity in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Entity in the request body is correct.',
    causes: 'The Entity in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Entity in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-13T10:23:51Z',
    last_updated: '2023-12-13T10:23:59.154406Z',
  },
  52165: {
    code: 52165,
    message: 'No Credentials found for the supplied Identifier',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52165\r\n\r\n### No Credentials found for the supplied Identifier\r\n\r\n#### Possible Causes \r\n*  Your Webhook Credential has a misconfigured Identifier value\r\n*  Your token endpoint responded with the respective error code by mistake\r\n*  An internal Twilio error occurred\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credential is configured correctly\r\n*  Verify that your token endpoint is set up correctly',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T11:54:53Z',
    last_updated: '2020-08-04T10:00:14.307Z',
  },
  36003: {
    code: 36003,
    message: 'Broadcast Upload File Size Exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36003\r\n\r\n### Broadcast Upload File Size Exceeded\r\n\r\n The file size is greater than the allowed 25 MB\r\n\r\n#### Possible Causes\r\n* You attempted to upload a file that is greater than 25 MB\r\n\r\n#### Possible Solutions\r\n* Upload a file that is less than 25 MB',
    causes: '* You attempted to upload a file that is greater than 25 MB',
    solutions: '* Upload a file that is less than 25 MB',
    description: 'The file size is greater than the allowed 25 MB',
    product: 'Programmable Messaging',
    date_created: '2023-12-15T21:50:01Z',
    last_updated: '2023-12-15T21:50:01Z',
  },
  22120: {
    code: 22120,
    message: 'Invalid Verification Type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22120\r\n\r\n#### Invalid Verification Type\r\n\r\nVerification Type must be either "phone-call" or "phone-bill".',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-07T21:57:33Z',
    last_updated: '2020-08-04T10:00:14.906Z',
  },
  52135: {
    code: 52135,
    message: 'Missing subject in APNs certificate',
    log_level: 'ERROR',
    secondary_message: 'APNs certificate is invalid',
    log_type: null,
    docs: '## Error - 52135\r\n\r\n### Missing subject in APNs certificate\r\n\r\n#### Possible Causes \r\n*  The subject of APNs certificate is missing.\r\n\r\n#### Possible Solutions\r\n*  The subject of the APNs certificate is the bundle ID of your application. Make sure you have a bundle ID defined when generating the certificate signing request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:36:04Z',
    last_updated: '2020-08-04T10:00:22.138Z',
  },
  61008: {
    code: 61008,
    message: 'Add-ons:  HTTP too many redirects',
    log_level: 'ERROR',
    secondary_message:
      'Add-on Provider returned too many HTTP redirects. To prevent getting stuck in a redirect loop only 5 redirects will be followed. After that the request will be terminated and this error code will be returned.',
    log_type: null,
    docs: '## Error - 61008\r\n\r\n### Add-ons:  HTTP too many redirects\r\n\r\n#### Possible Causes \r\n*  Add-on Provider returned too many HTTP redirects. To prevent getting stuck in a redirect loop only 5 redirects will be followed. After that the request will be terminated and this error code will be returned.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:38:44Z',
    last_updated: '2020-08-04T10:00:21.429Z',
  },
  50078: {
    code: 50078,
    message: 'Invalid post-webhook url',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain a valid url for post-webhook.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 50078\r\n\r\n### Invalid post-webhook url\r\n\r\nRequest does not contain a valid url for post-webhook. \r\n\r\n#### Possible Causes\r\n*  Provided url has the wrong format.\r\n\r\n#### Possible Solutions\r\n*  Make sure that url is complete and properly encoded.\r\n*  Make sure that url contains valid protocol and hostname and doesn't contain invalid characters.",
    causes: '*  Provided url has the wrong format.',
    solutions:
      "*  Make sure that url is complete and properly encoded.\r\n*  Make sure that url contains valid protocol and hostname and doesn't contain invalid characters.",
    description: null,
    product: 'Programmable Chat',
    date_created: '2024-01-29T21:49:14Z',
    last_updated: '2024-01-29T21:49:14Z',
  },
  20103: {
    code: 20103,
    message: 'Invalid Access Token issuer/subject',
    log_level: 'ERROR',
    secondary_message: 'Invalid Access Token issuer or subject',
    log_type: null,
    docs: "# Error - 20103\r\n\r\n## Invalid Access Token issuer or subject\r\n\r\nThe issuer or subject of the Access Token provided to the Twilio API was\r\ninvalid.\r\n\r\n**Issuer:** The [API Key](/docs/api/rest/keys) used to sign the the token.\r\n\r\n**Subject:** The Twilio Account SID from your [Live Credentials](/console/account/settings).\r\n\r\n### Possible Causes\r\n* Account is inactive or suspended.\r\n* Account SID is incorrect.\r\n* API Key is incorrect or has been deleted.\r\n\r\n### Possible Solutions\r\n\r\n* Ensure the account is active and there are enough funds available.\r\n* Ensure the Account SID is correct and is from your Live Credentials.\r\n* Make sure that the API Key used to sign the request is correct and associated with the supplied Account SID.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nAccess Tokens are used by multiple Twilio SDKs, including Programmable Voice, Programmable Video, and Programmable Chat. For the details of Twilio's specific Access Token implementation and the requirements of the issuer and subject fields, see [the documentation](/docs/api/rest/access-tokens).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T06:51:44Z',
    last_updated: '2020-08-04T10:00:22.737Z',
  },
  61005: {
    code: 61005,
    message: 'Add-ons: Bad request',
    log_level: 'ERROR',
    secondary_message:
      ' The Vendor provided an HTTP Status Code in the 400 range. This indicates that the Add-on Provider received the request but was unable to processes it due to validation or authorization issue.',
    log_type: null,
    docs: '## Error - 61005\r\n\r\n### Add-ons: Bad request\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider provided an HTTP Status Code in the 400 range. This indicates that they received the request but were unable to processes it due to validation or authorization issue.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:37:37Z',
    last_updated: '2020-08-04T10:00:21.496Z',
  },
  60607: {
    code: 60607,
    message: 'Lookup Unsupported Country',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60607\r\n\r\n### Lookup Unsupported Country\r\n\r\n No provider found to satisfy the Lookup request\r\n\r\n#### Possible Causes\r\nThe request was received but failed due to the phone number being associated with a country that is not supported by the requested Lookup package.\r\n\r\n#### Possible Solutions\r\n- Check that the phone number provided is correct. \r\n- Confirm that the phone number's country is supported by the requested Lookup package. Check country coverage in https://www.twilio.com/docs/lookup/v2-api.",
    causes:
      'The request was received but failed due to the phone number being associated with a country that is not supported by the requested Lookup package.',
    solutions:
      "- Check that the phone number provided is correct. \r\n- Confirm that the phone number's country is supported by the requested Lookup package. Check country coverage in https://www.twilio.com/docs/lookup/v2-api.",
    description: 'No provider found to satisfy the Lookup request',
    product: 'Lookup',
    date_created: '2021-02-09T15:05:57Z',
    last_updated: '2023-08-28T22:15:03.62462Z',
  },
  53605: {
    code: 53605,
    message: "Internal failure when retrieving your account's recording settings",
    log_level: 'WARNING',
    secondary_message: 'A new attempt will be made after a delay',
    log_type: null,
    docs: "## Warning - 53605\r\n\r\n### Internal failure when retrieving your account's recording settings\r\n\r\nRaised when an error prevented us from retrieving your account's recording settings.\r\n\r\nThe recording will not be uploaded until we manage to read your recording settings.\r\n\r\n#### Causes\r\n\r\n* An internal error stopped us from uploading the recording. We'll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* If the error persists, please <a href=\"/help/contact\">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:40:02Z',
    last_updated: '2020-08-04T10:00:14.706Z',
  },
  14106: {
    code: 14106,
    message: 'Document retrieval limit reached',
    log_level: 'WARNING',
    secondary_message: 'Your SMS Reply session has requested too many documents. The limit is 50',
    log_type: null,
    docs: '## Warning - 14106 \n\n### Message Reply TwiML document retrieval limit reached\n\nYour Message Reply session has requested too many documents. The limit is 50\n\n#### Possible Causes \n*  infinite loop caused by self referencing Message verb action URL\n*  infinite loop caused by self referencing Redirect verb URL\n\n#### Possible Solutions\n*  make certain any action or Redirect URLs do not loop back to the same TwiML document.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:49Z',
    last_updated: '2020-08-04T10:00:27.575Z',
  },
  16028: {
    code: 16028,
    message: 'Participant to be whispered is not present in the conference',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16028\r\n\r\n### Participant to be whispered is not present in the conference\r\n\r\n The participant to be whispered is not present in the conference, so the coach to the participant cannot be added to the conference.\r\n\r\n#### Possible Causes\r\nThis may because the specified participant is not yet connected to the conference or no longer connected to the conference.\r\n\r\n#### Possible Solutions\r\nValidate that this call is connecting to the correct conference and the call SID specified is also in the conference.',
    causes:
      'This may because the specified participant is not yet connected to the conference or no longer connected to the conference.',
    solutions:
      'Validate that this call is connecting to the correct conference and the call SID specified is also in the conference.',
    description:
      'The participant to be whispered is not present in the conference, so the coach to the participant cannot be added to the conference.',
    product: 'Programmable Voice',
    date_created: '2020-12-03T23:57:39Z',
    last_updated: '2020-12-04T00:18:47.161Z',
  },
  45209: {
    code: 45209,
    message:
      'Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45209\r\n\r\n### Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.\r\n\r\n Adding user to Chat Channel has failed because of a timeout\r\n\r\n#### Possible Causes\r\nAdding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.\r\n\r\n#### Possible Solutions\r\nPlease refresh your browser and retry your Webchat experience.',
    causes:
      'Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.',
    solutions: 'Please refresh your browser and retry your Webchat experience.',
    description: 'Adding user to Chat Channel has failed because of a timeout',
    product: 'Flex',
    date_created: '2019-09-26T11:48:14Z',
    last_updated: '2020-08-04T10:00:06.167Z',
  },
  11217: {
    code: 11217,
    message: 'HTTP error response code',
    log_level: 'ERROR',
    secondary_message:
      'Your server responded to the webhook request with an error response (4xx or 5xx)',
    log_type: 'APPLICATION',
    docs: "## ERROR - 11217\r\n\r\n### HTTP error response code\r\n\r\nYour server responded to the webhook request with an error response (4xx or 5xx) Twilio sent a webhook to your server and your server responded with a 4xx or 5xx status code.\r\n\r\n#### Possible Causes\r\n* There was an error in your server (500).\r\n* There was a problem between your proxy and your server (502, 503, 504).\r\n* The URL specified in your webhook configuration is incorrect (404, 410).\r\n* Your server is attempting to rate limit Twilio's webhook requests (429). Twilio's webhooks do not support rate limiting.\r\n* Your webhook configuration does not have appropriate permissions to call the configured URL (403).\r\n\r\n#### Possible Solutions\r\n* Review the configured webhook URL to ensure that it is correct.\r\n* Look for and fix errors in your server logs.\r\n* Ensure that you can get 2xx status codes by calling your webhook URL.\r\n* Review your proxy and authentication configurations.\r\n* For rate limiting issues, consider shifting to Event Streams HTTP Sink which [support rate limiting](https://www.twilio.com/docs/events/faq/problems-on-delivery#what-does-throttle-sink-means-for-eventstreams).",
    causes:
      "* There was an error in your server (500).\r\n* There was a problem between your proxy and your server (502, 503, 504).\r\n* The URL specified in your webhook configuration is incorrect (404, 410).\r\n* Your server is attempting to rate limit Twilio's webhook requests (429). Twilio's webhooks do not support rate limiting.\r\n* Your webhook configuration does not have appropriate permissions to call the configured URL (403).",
    solutions:
      '* Review the configured webhook URL to ensure that it is correct.\r\n* Look for and fix errors in your server logs.\r\n* Ensure that you can get 2xx status codes by calling your webhook URL.\r\n* Review your proxy and authentication configurations.\r\n* For rate limiting issues, consider shifting to Event Streams HTTP Sink which [support rate limiting](https://www.twilio.com/docs/events/faq/problems-on-delivery#what-does-throttle-sink-means-for-eventstreams).',
    description:
      'Twilio sent a webhook to your server and your server responded with a 4xx or 5xx status code.',
    product: null,
    date_created: '2023-10-04T07:56:09Z',
    last_updated: '2023-10-04T12:43:28.992151Z',
  },
  19054: {
    code: 19054,
    message: 'Expected Unique form key in input request is missing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19054\r\n\r\n### Expected Unique form key in input request is missing\r\n\r\n Expected Unique form key in input request is missing\r\n\r\n#### Possible Causes\r\nAttempt to create custom field definition without Unique form key\r\n\r\n#### Possible Solutions\r\nProvide Unique form key in input request',
    causes: 'Attempt to create custom field definition without Unique form key',
    solutions: 'Provide Unique form key in input request',
    description: 'Expected Unique form key in input request is missing',
    product: 'Contacts',
    date_created: '2020-08-17T18:35:40Z',
    last_updated: '2020-08-24T18:18:47.115Z',
  },
  50379: {
    code: 50379,
    message: 'TimeToInactive format is invalid',
    log_level: 'ERROR',
    secondary_message: "'TimeToInactive' parameter format should be ISO8601 duration",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50379\r\n\r\n### TimeToInactive format is invalid\r\n\r\n'TimeToInactive' parameter format should be ISO8601 duration 'TimeToInactive' parameter supports values which are ISO8601 durations.\r\n\r\n#### Possible Causes\r\n* 'TimeToInactive' parameter value is not ISO8601 duration.\r\n\r\n#### Possible Solutions\r\n* Use ISO8601 duration format value for 'TimeToInactive' parameter. For example PT0S, PT10M, P1D etc..",
    causes: "* 'TimeToInactive' parameter value is not ISO8601 duration.",
    solutions:
      "* Use ISO8601 duration format value for 'TimeToInactive' parameter. For example PT0S, PT10M, P1D etc..",
    description: "'TimeToInactive' parameter supports values which are ISO8601 durations.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:26:15Z',
    last_updated: '2021-02-22T12:55:47.975Z',
  },
  13248: {
    code: 13248,
    message: 'Dial: Invalid callerID, too long',
    log_level: 'WARNING',
    secondary_message: 'Your callerID contains too many characters.',
    log_type: null,
    docs: '## Warning - 13248 \n\n### Dial: Invalid callerID, too long\n\nYour callerID contains too many characters.\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:07Z',
    last_updated: '2020-08-04T10:00:26.48Z',
  },
  50350: {
    code: 50350,
    message: 'Conversation not found',
    log_level: 'ERROR',
    secondary_message: 'The requested conversation SID was not found.',
    log_type: null,
    docs: '\n## Error - 50350\n\n### Conversations: Conversation not found\nThe requested conversation SID was not found.\n\n#### Possible Causes\nThe conversation SID you are requesting does not exist under your account.\n\n#### Possible Solutions\n* Check that you have provided a Conversation SID and not some other SID (should have the prefix CH).\n* Check that the requested conversation SID belongs to the account that your REST request has targeted.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.877Z',
  },
  60550: {
    code: 60550,
    message:
      'Auto Channel Failed: None of the available channels could be selected due to validation errors. Check your debugger messages in console.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60550\r\n\r\n### Auto Channel Failed: None of the available channels could be selected due to validation errors. Check your debugger messages in console.\r\n\r\n Due to validation errors, none of the available specific channels could be selected. Check your debugger messages in the console for more details.\r\n\r\n#### Possible Causes\r\n- Specific delivery channel(s) are disabled\r\n- Your service does not have access to an specific feature.\r\n\r\n#### Possible Solutions\r\nCheck your debugger messages in the console to get the specific validation errors',
    causes:
      '- Specific delivery channel(s) are disabled\r\n- Your service does not have access to an specific feature.',
    solutions: 'Check your debugger messages in the console to get the specific validation errors',
    description:
      'Due to validation errors, none of the available specific channels could be selected. Check your debugger messages in the console for more details.',
    product: 'Verify',
    date_created: '2023-02-02T13:40:09Z',
    last_updated: '2023-02-02T13:40:09Z',
  },
  14240: {
    code: 14240,
    message: 'Max concurrent Workers exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 14240\r\n\r\n### Max concurrent Workers exceeded\r\n\r\n Max concurrent Workers exceeded\r\n\r\n#### Possible Causes\r\nMax concurrent worker limit met/exceeded\r\n\r\n#### Possible Solutions\r\nReduce TaskRouter Workers currently in "Active" status',
    causes: 'Max concurrent worker limit met/exceeded',
    solutions: 'Reduce TaskRouter Workers currently in "Active" status',
    description: 'Max concurrent Workers exceeded',
    product: 'TaskRouter',
    date_created: '2020-04-29T17:04:39Z',
    last_updated: '2020-08-04T10:00:03.617Z',
  },
  94600: {
    code: 94600,
    message: 'Filter limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94600\r\n\r\n### Filter limit exceeded\r\n\r\n The action could not be performed because the filter limit was exceeded.\r\n\r\n#### Possible Causes\r\n * There were too many filters applied.\r\n\r\n#### Possible Solutions\r\n * Use date filtering freely plus at most one other filter.',
    causes: ' * There were too many filters applied.',
    solutions: ' * Use date filtering freely plus at most one other filter.',
    description: 'The action could not be performed because the filter limit was exceeded.',
    product: null,
    date_created: '2022-05-09T16:05:09Z',
    last_updated: '2022-05-09T16:05:09Z',
  },
  22206: {
    code: 22206,
    message: 'Attempting to add invalid object type to bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22206\r\n\r\n### Attempting to add invalid object type to bundle\r\n\r\n The object_sid provided was not a Supporting Document Sid or an End-User Sid\r\n\r\n#### Possible Causes\r\nThe SID belongs to a different object group that is not allowed to be assigned as an item to a Bundle.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.',
    causes:
      'The SID belongs to a different object group that is not allowed to be assigned as an item to a Bundle.',
    solutions:
      'Please refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.',
    description: 'The object_sid provided was not a Supporting Document Sid or an End-User Sid',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:45:30Z',
    last_updated: '2020-08-04T10:00:05.599Z',
  },
  54300: {
    code: 54300,
    message: 'Unique name not found',
    log_level: 'ERROR',
    secondary_message: 'No object with the specified unique name exists.',
    log_type: null,
    docs: '\n## Error - 54300\n\n### Sync: Unique name not found\nNo object with the specified unique name exists.\n\n#### Possible Causes\n* The provided UniqueName parameter is incorrect.\n* The requested Sync object with given unique name has been deleted.\n\n#### Possible Solutions\nConfirm that a valid UniqueName parameter is being passed in your request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.344Z',
  },
  13244: {
    code: 13244,
    message: 'Dial: No SIP Authorization',
    log_level: 'WARNING',
    secondary_message: 'Your account is not authorized to make SIP calls',
    log_type: null,
    docs: '## Warning - 13244 \n\n### Dial: No SIP Authorization\n\nYour account is not authorized to make SIP calls\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:39Z',
    last_updated: '2020-08-04T10:00:28.227Z',
  },
  30131: {
    code: 30131,
    message: "Domain's certificate will expire soon",
    log_level: 'WARNING',
    secondary_message: 'A TLS certificate associated with one of your domains will expire soon.',
    log_type: 'APPLICATION',
    docs: "## WARNING - 30131\r\n\r\n### Domain's certificate will expire soon\r\n\r\nA TLS certificate associated with one of your domains will expire soon. A TLS certificate associated with one of your domains will expire soon.\r\n\r\n#### Possible Causes\r\nA TLS certificate associated with one of your domains has not been renewed in our system, and the existing certificate will expire soon.\r\n\r\n#### Possible Solutions\r\nPlease generate and upload a new certificate.",
    causes:
      'A TLS certificate associated with one of your domains has not been renewed in our system, and the existing certificate will expire soon.',
    solutions: 'Please generate and upload a new certificate.',
    description: 'A TLS certificate associated with one of your domains will expire soon.',
    product: 'Programmable SMS',
    date_created: '2022-08-02T23:00:17Z',
    last_updated: '2022-08-02T23:00:17Z',
  },
  22135: {
    code: 22135,
    message: 'Error - Internal Server Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 22135\r\n\r\n### Error - Internal Server Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nInternal error determining the portability of this number, please try again\r\n\r\n#### Possible Solutions\r\nRun the Portability Check again',
    causes: 'Internal error determining the portability of this number, please try again',
    solutions: 'Run the Portability Check again',
    description: null,
    product: 'Phone Numbers',
    date_created: '2023-06-22T18:45:40Z',
    last_updated: '2023-06-22T18:45:40Z',
  },
  14235: {
    code: 14235,
    message: 'Dial->Conference: Unable to cleanup task',
    log_level: 'ERROR',
    secondary_message:
      'Unable to cancel the task created by Conference upon a TwiML error or task hangup.',
    log_type: null,
    docs: '## Error - 14235\r\n\r\n### Conference: Unable to cleanup Task\r\n\r\nUnable to cancel the Task created by Conference upon a TwiML error or task hangup.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:47:14Z',
    last_updated: '2020-08-04T10:00:21.775Z',
  },
  62019: {
    code: 62019,
    message: 'IP route exceeds permitted IP range',
    log_level: 'ERROR',
    secondary_message:
      'The request provided an IP route that would exceed permitted IP range. IP addresses are limited to the 256 address range.',
    log_type: null,
    docs: '## Error - 62019\r\n\r\n### IP route exceeds permitted IP range\r\n\r\nThe request provided an IP route that would exceed permitted IP range. IP addresses are limited to the 256 address range.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:44:37Z',
    last_updated: '2020-08-04T10:00:20.845Z',
  },
  48050: {
    code: 48050,
    message: 'Internal service error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 48050\r\n\r\n### Internal service error\r\n\r\n \r\n\r\n#### Possible Causes\r\n* Frontline encountered an internal error.\r\n\r\n#### Possible Solutions\r\n* Please reach out to [customer support](http://twilio.com/console/support/tickets/create).',
    causes: '* Frontline encountered an internal error.',
    solutions:
      '* Please reach out to [customer support](http://twilio.com/console/support/tickets/create).',
    description: null,
    product: 'Frontline',
    date_created: '2022-04-20T15:58:06Z',
    last_updated: '2022-05-20T10:08:28.798746Z',
  },
  50060: {
    code: 50060,
    message: 'Programmable Chat: Invalid user channels limit format',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for user channels limit',
    log_type: null,
    docs: '## Error - 50060\r\n\r\n### Programmable Chat: Invalid user channels limit format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for user channels limit.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid user channels limit parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T07:56:20Z',
    last_updated: '2020-08-04T10:00:16.766Z',
  },
  22500: {
    code: 22500,
    message: 'Twilio phone number using deprecated API version',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22500\r\n\r\n### Twilio phone number using deprecated API version\r\n\r\n Phone Numbers no longer supports 2008-08-01 API.  The Twilio phone number is configured for the deprecated 2008-08-01 API, which is not compatible. Update the phone number API version to 2010-04-01\r\n\r\n#### Possible Causes\r\nThe Twilio phone number is configured for the 2008-08-01 API\r\n\r\n#### Possible Solutions\r\nUpdate the phone number API version to 2010-04-01 or later version',
    causes: 'The Twilio phone number is configured for the 2008-08-01 API',
    solutions: 'Update the phone number API version to 2010-04-01 or later version',
    description:
      'Phone Numbers no longer supports 2008-08-01 API.  The Twilio phone number is configured for the deprecated 2008-08-01 API, which is not compatible. Update the phone number API version to 2010-04-01',
    product: 'Phone Numbers',
    date_created: '2023-04-18T20:58:09Z',
    last_updated: '2023-04-18T20:58:09Z',
  },
  35117: {
    code: 35117,
    message: 'Scheduling does not support this timestamp',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35117\r\n\r\n### Scheduling does not support this timestamp\r\n\r\n SendAt time must be between 900 seconds and 35 days (3024000 seconds) in the future, inclusive.\r\n\r\n#### Possible Causes\r\nScheduler currently doesn\'t support scheduling a message at a fixed time less that 15 minutes from now, or more than 35 days in the future.\r\n\r\n#### Possible Solutions\r\nVerify that the SendAt parameter is using "[YYYY]-[MM]-[DD]T[HH]:[MM]:[SS]Z" format (in UTC).',
    causes:
      "Scheduler currently doesn't support scheduling a message at a fixed time less that 15 minutes from now, or more than 35 days in the future.",
    solutions:
      'Verify that the SendAt parameter is using "[YYYY]-[MM]-[DD]T[HH]:[MM]:[SS]Z" format (in UTC).',
    description:
      'SendAt time must be between 900 seconds and 35 days (3024000 seconds) in the future, inclusive.',
    product: 'Programmable SMS',
    date_created: '2023-07-27T15:15:56Z',
    last_updated: '2023-07-27T15:15:56Z',
  },
  60362: {
    code: 60362,
    message: 'Factor SID invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60362\r\n\r\n### Factor SID invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Factor SID in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Factor SID in the request parameter is correct.',
    causes: 'The Factor SID in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Factor SID in the request parameter is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-13T09:50:20Z',
    last_updated: '2023-12-13T09:50:20Z',
  },
  35134: {
    code: 35134,
    message: '`Messages` array contains duplicate `To` numbers.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35134\r\n\r\n### `Messages` array contains duplicate `To` numbers.\r\n\r\n `Messages` array contains duplicate `To` numbers. Please check the list for duplicates\r\n\r\n#### Possible Causes\r\nThe provided `Messages` array has one or more duplicate `To` numbers\r\n\r\n#### Possible Solutions\r\nCheck the `Messages` array and remove `To` number duplicates if any',
    causes: 'The provided `Messages` array has one or more duplicate `To` numbers',
    solutions: 'Check the `Messages` array and remove `To` number duplicates if any',
    description:
      '`Messages` array contains duplicate `To` numbers. Please check the list for duplicates',
    product: 'Programmable Messaging',
    date_created: '2023-07-17T00:58:05Z',
    last_updated: '2023-07-31T17:25:38.391276Z',
  },
  52107: {
    code: 52107,
    message: 'Invalid custom key for GCM/FCM',
    log_level: 'ERROR',
    secondary_message: 'Using one of custom keys is rejected by GCM/FCM service',
    log_type: null,
    docs: '## Error - 52107\r\n\r\n### Invalid custom key for GCM/FCM\r\n\r\n#### Possible Causes \r\n*  You have specified an invalid key in the custom key-value pair section of the payload.\r\n\r\n#### Possible Solutions\r\n*  GCM/FCM rejects some keys including from, gcm and anything prefixed by google. Make sure you are not using any of these keys.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:30:22Z',
    last_updated: '2020-08-04T10:00:22.291Z',
  },
  91104: {
    code: 91104,
    message: 'Event type not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91104\r\n\r\n### Event type not found\r\n\r\n Event type not found\r\n\r\n#### Possible Causes\r\n* Event type is not supported by our system\r\n\r\n#### Possible Solutions\r\n* Use a supported Event',
    causes: '* Event type is not supported by our system',
    solutions: '* Use a supported Event',
    description: 'Event type not found',
    product: 'Events',
    date_created: '2020-09-16T14:49:30Z',
    last_updated: '2021-01-06T16:40:16.419Z',
  },
  52072: {
    code: 52072,
    message: 'Client mqtt connection not created or closed',
    log_level: 'WARNING',
    secondary_message: 'Mqtt gateway could not find connection to user for sending notification',
    log_type: null,
    docs: "## Warning - 52072\r\n\r\n### RtdNotification: Mqtt client connection not created or closed\r\n\r\n#### Possible Causes \r\n*  Most probably mqtt client had disconnected but registration didn't removed yet.\r\n\r\n#### Possible Solutions\r\n*  Check this warning happens only once for certain registration id. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:04:40Z',
    last_updated: '2020-08-04T10:00:22.418Z',
  },
  18007: {
    code: 18007,
    message: 'Incomplete document submission',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18007\r\n\r\n### Incomplete document submission\r\n\r\n The Proof of Identity needs to show the front and back of the ID. Your uploaded proof of Identity does not have both sides.\r\n\r\n#### Possible Causes\r\nYour uploaded proof of Identity does not have both sides. \r\n\r\n#### Possible Solutions\r\nPlease upload a copy of both sides and make sure to upload them in one document.',
    causes: 'Your uploaded proof of Identity does not have both sides. ',
    solutions: 'Please upload a copy of both sides and make sure to upload them in one document.',
    description:
      'The Proof of Identity needs to show the front and back of the ID. Your uploaded proof of Identity does not have both sides.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:59:49Z',
    last_updated: '2024-07-04T09:59:49Z',
  },
  13223: {
    code: 13223,
    message: 'Dial: Invalid phone number format',
    log_level: 'WARNING',
    secondary_message:
      'Phone Numbers must be in E.164 format. E.164 numbers are formatted [+] [country code] [subscriber number including area code] and can have a maximum of fifteen digits.',
    log_type: 'APPLICATION',
    docs: "## WARNING - 13223\r\n\r\n### Dial: Invalid phone number format\r\n\r\nPhone Numbers must be in E.164 format. E.164 numbers are formatted [+] [country code] [subscriber number including area code] and can have a maximum of fifteen digits. Phone Numbers must be in E.164 format. E.164 numbers are formatted [+] [country code] [subscriber number including area code] and can have a maximum of 15 digits.\r\n\r\n#### Possible Causes\r\n- The phone number you are attempting to dial is not in E.164 format\r\n- The `<Number>` noun inside your `<Dial>` TwiML instructions is not present\r\n- You are attempting to dial something that is not a phone number\r\n\r\n#### Possible Solutions\r\nCheck the format of the phone number inside your `<Dial><Number>` TwiML. \r\n\r\nVerify that the number is in [E.164 format](https://www.twilio.com/docs/glossary/what-e164): \r\n- Includes the country code \r\n- Includes the area code\r\n- Does not exceed 15 digits\r\n- Does not include any invalid characters, like hyphens or parentheses\r\n\r\nIn your TwiML instructions, the phone number must be between the opening and closing `<Number>` tags, which are nested within `<Dial>`'s opening and closing tags:\r\n\r\n```\r\n<Dial><Number>+15555555555</Number></Dial>\r\n```\r\n\r\nIf you are attempting to `<Dial>` an SDK end-user, ensure you're using the `<Client>` noun inside your `<Dial>` tags.\r\n\r\nIf you are attempting to `<Dial>` a SIP endpoint, ensure you're using the `<Sip>` noun inside your `<Dial>` tags.\r\n\r\nFor more information, read the [`<Dial>` docs](https://www.twilio.com/docs/voice/twiml/dial).\r\n\r\n",
    causes:
      '- The phone number you are attempting to dial is not in E.164 format\r\n- The `<Number>` noun inside your `<Dial>` TwiML instructions is not present\r\n- You are attempting to dial something that is not a phone number',
    solutions:
      "Check the format of the phone number inside your `<Dial><Number>` TwiML. \r\n\r\nVerify that the number is in [E.164 format](https://www.twilio.com/docs/glossary/what-e164): \r\n- Includes the country code \r\n- Includes the area code\r\n- Does not exceed 15 digits\r\n- Does not include any invalid characters, like hyphens or parentheses\r\n\r\nIn your TwiML instructions, the phone number must be between the opening and closing `<Number>` tags, which are nested within `<Dial>`'s opening and closing tags:\r\n\r\n```\r\n<Dial><Number>+15555555555</Number></Dial>\r\n```\r\n\r\nIf you are attempting to `<Dial>` an SDK end-user, ensure you're using the `<Client>` noun inside your `<Dial>` tags.\r\n\r\nIf you are attempting to `<Dial>` a SIP endpoint, ensure you're using the `<Sip>` noun inside your `<Dial>` tags.\r\n\r\nFor more information, read the [`<Dial>` docs](https://www.twilio.com/docs/voice/twiml/dial).\r\n\r\n",
    description:
      'Phone Numbers must be in E.164 format. E.164 numbers are formatted [+] [country code] [subscriber number including area code] and can have a maximum of 15 digits.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:34Z',
    last_updated: '2022-08-29T14:11:33.904925Z',
  },
  22121: {
    code: 22121,
    message: 'Unable to Transfer Hosted Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22121\r\n\r\n#### Unable to Transfer Hosted Number \r\n\r\n\r\n#### Possible Causes\r\n\r\n\r\n* The Hosted Number you are trying to transfer is not in status "in-use."\r\n\r\n#### Possible Solutions\r\n\r\nSee [Exchanging Numbers Between Subaccounts](https://www.twilio.com/docs/api/rest/subaccounts#exchanging-numbers) for more details about transferring numbers.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-16T00:41:27Z',
    last_updated: '2020-08-04T10:00:14.833Z',
  },
  60220: {
    code: 60220,
    message: 'Messages to China require use case vetting',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60220\r\n\r\n### Messages to China require use case vetting\r\n\r\n Messages to China require use case vetting, please refer to this support article https://support.twilio.com/hc/en-us/articles/17024185400859-Use-Case-Vetting-for-Verify-Messages-to-China to understand this in detail.\r\n\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nYour account is not allowed to create verifications towards China\r\n\r\n#### Possible Solutions\r\nPlease read this support article https://support.twilio.com/hc/en-us/articles/17024185400859-Use-Case-Vetting-for-Verify-Messages-to-China to get your more details on how to get your use case vetted for China.',
    causes: 'Your account is not allowed to create verifications towards China',
    solutions:
      'Please read this support article https://support.twilio.com/hc/en-us/articles/17024185400859-Use-Case-Vetting-for-Verify-Messages-to-China to get your more details on how to get your use case vetted for China.',
    description:
      'Messages to China require use case vetting, please refer to this support article https://support.twilio.com/hc/en-us/articles/17024185400859-Use-Case-Vetting-for-Verify-Messages-to-China to understand this in detail.\r\n\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-12-06T20:21:57Z',
    last_updated: '2023-07-24T13:07:49.919807Z',
  },
  51131: {
    code: 51131,
    message: 'Twilsock: Authentication failed',
    log_level: 'ERROR',
    secondary_message: 'N/A',
    log_type: null,
    docs: '## Error - 51131\r\n\r\n### Authentication failed',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:31:56Z',
    last_updated: '2020-08-04T10:00:09.34Z',
  },
  21655: {
    code: 21655,
    message: 'The ContentSid is Invalid',
    log_level: 'ERROR',
    secondary_message: 'The ContentSid you are using is not valid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21655\r\n\r\n### The ContentSid is Invalid\r\n\r\nThe ContentSid you are using is not valid \r\n\r\n#### Possible Causes\r\nThe ContentSid you are using is not valid\r\n\r\n#### Possible Solutions\r\nDouble check the ContentSid parameter that you are using. Make sure it has the proper formatting and starts with an HX prefix.',
    causes: 'The ContentSid you are using is not valid',
    solutions:
      'Double check the ContentSid parameter that you are using. Make sure it has the proper formatting and starts with an HX prefix.',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-09-29T15:24:20Z',
    last_updated: '2021-09-29T15:24:20Z',
  },
  50331: {
    code: 50331,
    message: 'Programmable Chat: Channel webhook trigger not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain parameter for webhook trigger',
    log_type: null,
    docs: '## Error - 50331\r\n\r\n### Programmable Chat: Channel webhook trigger not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook trigger.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:15:40Z',
    last_updated: '2020-08-04T10:00:11.936Z',
  },
  50329: {
    code: 50329,
    message: 'Programmable Chat: Channel webhook url not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain parameter for webhook url',
    log_type: null,
    docs: '## Error - 50329\r\n\r\n### Programmable Chat: Channel webhook url not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook url.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:09:45Z',
    last_updated: '2020-08-04T10:00:11.974Z',
  },
  53200: {
    code: 53200,
    message: 'Participant identity is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53200: Participant identity is invalid\r\n\r\nRaised whenever a Participant identity is invalid, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\nThe Participant identity does not adhere to the Participant identity requirements. \r\n\r\nPossible causes:\r\n\r\n* The identity is null or an empty string.\r\n* Another Participant with the same identity already exists in the Room.\r\n* The identity has more than 128 characters (NOTE: Double-byte characters are counted as 2 characters).\r\n\r\n\r\n#### Solutions\r\n\r\n * Choose a Participant identity adheres to the Participant identity requirements.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:47:04Z',
    last_updated: '2020-08-04T10:00:19.482Z',
  },
  52111: {
    code: 52111,
    message: 'GCM/FCM unknown error',
    log_level: 'ERROR',
    secondary_message: 'Unexpected error has happened in GCM/FCM binding adaptor',
    log_type: null,
    docs: '## Error - 52111\r\n\r\n### GCM/FCM unknown error\r\n\r\n#### Possible Causes \r\n*  Unknown GCM/FCM error.\r\n\r\n#### Possible Solutions\r\n*  If the problem persists, contact [customer support](https://www.twilio.com/help/contact) and provide the time of the error and details about the requests that are failing.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:33:19Z',
    last_updated: '2020-08-04T10:00:22.219Z',
  },
  21481: {
    code: 21481,
    message: 'Invalid PageToken',
    log_level: 'ERROR',
    secondary_message: 'The PageToken in the requested URL was not valid.',
    log_type: null,
    docs: '### Invalid PageToken\r\n\r\nThe `PageToken` in the requested URL was not valid. If you are paging through\r\na result set, be sure you are requesting the provided paging urls in the\r\nTwilio API response.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-03T21:24:06Z',
    last_updated: '2020-08-04T10:00:19.161Z',
  },
  30034: {
    code: 30034,
    message: 'US A2P 10DLC - Message from an Unregistered Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30034\r\n\r\n### US A2P 10DLC - Message from an Unregistered Number\r\n\r\n Messages sent to US numbers will not be delivered if they are sent from numbers that are not associated with an approved A2P 10DLC Campaign. This <a href= "https://support.twilio.com/hc/en-us/articles/4418081745179-How-do-I-check-that-I-have-completed-US-A2P-10DLC-registration-">guide </a>will help you determine if you have completed registration for A2P 10DLC. To initiate or continue an A2P 10DLC registration,<a href= "https://console.twilio.com/us1/develop/sms/regulatory-compliance/a2p-onboarding"> visit your console here</a>. Find out how to register using <a href =" https://support.twilio.com/hc/en-us/articles/1260801864489-How-do-I-register-to-use-A2P-10DLC-messaging-">this guide</a>.\r\n\r\nFor a step-by-step walkthrough, check out <a href =" https://twil.io/resolve30034">this video on resolving Error 30034</a>.\r\n\r\n#### Possible Causes\r\nYou are sending messages to the US using a US 10DLC number that is not associated with an approved A2P 10DLC Campaign.\r\n\r\n#### Possible Solutions\r\nAssociate your US 10DLC number with a registered A2P Campaign by adding it to the corresponding Messaging Service via the Twilio Console or API. Find out how to register using <a href =" https://support.twilio.com/hc/en-us/articles/1260801864489-How-do-I-register-to-use-A2P-10DLC-messaging-">this guide</a>. \r\n<p></p>\r\nAlternatively, you can also use a different number that is already associated with an approved A2P Campaign to send messages in the US.\r\n',
    causes:
      'You are sending messages to the US using a US 10DLC number that is not associated with an approved A2P 10DLC Campaign.',
    solutions:
      'Associate your US 10DLC number with a registered A2P Campaign by adding it to the corresponding Messaging Service via the Twilio Console or API. Find out how to register using <a href =" https://support.twilio.com/hc/en-us/articles/1260801864489-How-do-I-register-to-use-A2P-10DLC-messaging-">this guide</a>. \r\n<p></p>\r\nAlternatively, you can also use a different number that is already associated with an approved A2P Campaign to send messages in the US.\r\n',
    description:
      'Messages sent to US numbers will not be delivered if they are sent from numbers that are not associated with an approved A2P 10DLC Campaign. This <a href= "https://support.twilio.com/hc/en-us/articles/4418081745179-How-do-I-check-that-I-have-completed-US-A2P-10DLC-registration-">guide </a>will help you determine if you have completed registration for A2P 10DLC. To initiate or continue an A2P 10DLC registration,<a href= "https://console.twilio.com/us1/develop/sms/regulatory-compliance/a2p-onboarding"> visit your console here</a>. Find out how to register using <a href =" https://support.twilio.com/hc/en-us/articles/1260801864489-How-do-I-register-to-use-A2P-10DLC-messaging-">this guide</a>.\r\n\r\nFor a step-by-step walkthrough, check out <a href =" https://twil.io/resolve30034">this video on resolving Error 30034</a>.',
    product: 'Programmable SMS',
    date_created: '2023-04-28T05:33:55Z',
    last_updated: '2023-08-31T20:20:10.893788Z',
  },
  80902: {
    code: 80902,
    message: 'No Active Session',
    log_level: 'ERROR',
    secondary_message:
      'You received a call to your Proxy Number from a caller who is not a participant in an active session. ',
    log_type: null,
    docs: '## Warning\r\n\r\n### No Active Session\r\n\r\nYou received a call to your Proxy Number from a caller who is not a participant in an active session. ',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.643Z',
  },
  50441: {
    code: 50441,
    message: 'Failed to add a proxy address to a participant.',
    log_level: 'ERROR',
    secondary_message: 'The participant should have an address in order to add a proxy address.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50441\r\n\r\n### Failed to add a proxy address to a participant.\r\n\r\nThe participant should have an address in order to add a proxy address. You cannot add a proxy address to the participant.\r\n\r\n#### Possible Causes\r\n* The participant to which you are trying to add a proxy address, does not have a user address.\r\n\r\n#### Possible Solutions\r\n* Check that the request does not update proxy address of this particular participant.',
    causes:
      '* The participant to which you are trying to add a proxy address, does not have a user address.',
    solutions:
      '* Check that the request does not update proxy address of this particular participant.',
    description: 'You cannot add a proxy address to the participant.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:01:27Z',
    last_updated: '2021-08-16T12:01:27Z',
  },
  33122: {
    code: 33122,
    message: 'Rate Plan Is Not Allowed',
    log_level: 'ERROR',
    secondary_message: 'Cannot activate a SIM on a Rate Plan with deprecated Data Metering.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 33122\r\n\r\n### Rate Plan Is Not Allowed\r\n\r\nCannot activate a SIM on a Rate Plan with deprecated Data Metering. \r\n\r\n#### Possible Causes\r\nSIM update request was rejected because the SIM cannot be activated on a Rate Plan with deprecated Data Metering.\r\n\r\n#### Possible Solutions\r\nConsider using a Rate Plan with `payg` Data Metering.',
    causes:
      'SIM update request was rejected because the SIM cannot be activated on a Rate Plan with deprecated Data Metering.',
    solutions: 'Consider using a Rate Plan with `payg` Data Metering.',
    description: null,
    product: 'Programmable Wireless',
    date_created: '2022-09-30T11:01:55Z',
    last_updated: '2022-09-30T11:01:55Z',
  },
  45780: {
    code: 45780,
    message:
      'Failed to perform this operation. Account is sending too many concurrent API  requests.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 45780\r\n\r\n### Failed to perform this operation. Account is sending too many concurrent API  requests.\r\n\r\n Failed to perform this operation. Account is sending too many concurrent API  requests.\r\n\r\n#### Possible Causes\r\nYour account is sending too many concurrent requests.\r\n\r\n#### Possible Solutions\r\nPlease wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API.",
    causes: 'Your account is sending too many concurrent requests.',
    solutions:
      "Please wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API.",
    description:
      'Failed to perform this operation. Account is sending too many concurrent API  requests.',
    product: 'Flex',
    date_created: '2023-11-22T15:47:49Z',
    last_updated: '2023-11-22T15:47:49Z',
  },
  21420: {
    code: 21420,
    message: 'ApplicationSid is not accessible',
    log_level: 'ERROR',
    secondary_message:
      "You specified a VoiceApplicationSid or SmsApplicationSid for a new phone number that is not controlled by your account, or is invalid. Please specify an ApplicationSid that you've created in your [Account Dashboard](/user/account/apps).",
    log_type: null,
    docs: "## Error - 21420\n\n### ApplicationSid is not accessible\n\nYou specified a VoiceApplicationSid or SmsApplicationSid for a new phone number\nthat is not controlled by your account, or is invalid. Please specify an\nApplicationSid that you've created in your [Account\nDashboard](/user/account/apps).\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:20Z',
    last_updated: '2020-08-04T10:00:25.499Z',
  },
  22211: {
    code: 22211,
    message: 'Cannot create a Supporting Document with no FriendlyName',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22211\r\n\r\n### Cannot create a Supporting Document with no FriendlyName\r\n\r\n The request to create a new Supporting Document instance did not contain a FriendlyName\r\n\r\n#### Possible Causes\r\nThe FriendlyName is missing from the POST LIST request to create a new Supporting Document.\r\n\r\n#### Possible Solutions\r\nResend the request including the FriendlyName',
    causes:
      'The FriendlyName is missing from the POST LIST request to create a new Supporting Document.',
    solutions: 'Resend the request including the FriendlyName',
    description:
      'The request to create a new Supporting Document instance did not contain a FriendlyName',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:49:40Z',
    last_updated: '2020-08-04T10:00:05.511Z',
  },
  52307: {
    code: 52307,
    message: 'No users with provided segments',
    log_level: 'WARNING',
    secondary_message: 'No users were found belonging to the specified segment(s)',
    log_type: null,
    docs: '## Error - 52307\r\n\r\n### No users with provided segments\r\n\r\nNo users were found belonging to the specified segment(s)\r\n\r\n#### Possible Causes \r\n* A notification was sent to one or more user segments, but no users belong to these segments\r\n\r\n#### Possible Solutions\r\n* Check if correct segments were specified\r\n* Check if users are assigned to correct segments',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-07-06T13:36:46Z',
    last_updated: '2020-08-04T10:00:18.117Z',
  },
  11237: {
    code: 11237,
    message: 'Certificate Invalid - Could not find path to certificate',
    log_level: 'ERROR',
    secondary_message:
      'Twilio tried to validate your SSL certificate but was unable to find it in our certificate store.',
    log_type: null,
    docs: '## Error - 11237\r\n\r\n### Certificate Invalid - Could not find path to certificate\r\n\r\nTwilio tried to validate your SSL certificate but was unable to find it in our certificate store.\r\n\r\n#### Possible Causes\r\n*  You are using a self signed certificate.\r\n*  The certificate authority you are using is not on our list of approved certificate authorities.\r\n* Your certificate chain is incomplete and requires an additional download.\r\n\r\n#### Possible Solutions\r\n*  Do not use a self signed certificate.\r\n* Concatenate your certificate chain so that no additional download is required.\r\n*  Twilio uses CAs that are approved by Mozilla, you can find the full list [here](https://ccadb-public.secure.force.com/mozilla/IncludedCACertificateReport).\r\n* For testing purposes you can [disable SSL Certificate Validation in Console](https://www.twilio.com/console/project/settings).\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:26Z',
    last_updated: '2020-08-04T10:00:29.391Z',
  },
  21247: {
    code: 21247,
    message: 'Trunk Dependencies',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21247\r\n\r\n### Trunk Dependencies\r\n\r\n \r\n\r\n#### Possible Causes\r\n*  Cannot create subdomain because parent domain does not exist/account does not own it\r\n* Cannot delete trunk while it has subdomains\r\n* Cannot rename subdomain because parent domain does not exist/account doesn\'t own it\r\n* Cannot rename domain while it has subdomains\r\n\r\n#### Possible Solutions\r\n*  One of these constraints in the "Possible Causes" has been be violated, please review your Termination URI (Domain name).',
    causes:
      "*  Cannot create subdomain because parent domain does not exist/account does not own it\r\n* Cannot delete trunk while it has subdomains\r\n* Cannot rename subdomain because parent domain does not exist/account doesn't own it\r\n* Cannot rename domain while it has subdomains",
    solutions:
      '*  One of these constraints in the "Possible Causes" has been be violated, please review your Termination URI (Domain name).',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:07:34Z',
    last_updated: '2020-08-04T10:00:20.124Z',
  },
  61003: {
    code: 61003,
    message: 'Add-ons: Requirements to invoke AddOns have not been met',
    log_level: 'ERROR',
    secondary_message:
      ' A parameter required to complete the request was missing or is not supported. As a result the Add-on Request can not be completed.',
    log_type: null,
    docs: '## Error - 61003\r\n\r\n### Add-ons: Requirements to invoke AddOns have not been met\r\n\r\n#### Possible Causes \r\n*  A parameter required to complete the request was not provided at run time. As a result the Add-on Request can not be completed.\r\n*  The Add-on does not support the data that was provided. For example the Add-on may not support looking up phone numbers in specific countries. \r\n\r\n#### Possible Solutions\r\n*  Refer to Add-on documentation in Console to determine if the Add-on supports the country or format of the data you are providing\r\n* Check Add-on documentation to see if you may be missing some data for Lookup Add-ons',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:36:55Z',
    last_updated: '2020-08-04T10:00:21.56Z',
  },
  90022: {
    code: 90022,
    message: "One of 'TemplateArgs' dictionary value is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90022\r\n\r\n### One of 'TemplateArgs' dictionary value is too long\r\n\r\n One of 'TemplateArgs' dictionary value is too long\r\n\r\n#### Possible Causes\r\nOne of 'TemplateArgs' dictionary value is too long\r\n\r\n#### Possible Solutions\r\nUse shorter 'TemplateArgs' dictionary values",
    causes: "One of 'TemplateArgs' dictionary value is too long",
    solutions: "Use shorter 'TemplateArgs' dictionary values",
    description: "One of 'TemplateArgs' dictionary value is too long",
    product: null,
    date_created: '2020-12-11T08:48:09Z',
    last_updated: '2020-12-11T08:48:09Z',
  },
  54206: {
    code: 54206,
    message: 'Invalid Map Item data',
    log_level: 'ERROR',
    secondary_message: "The 'Data' parameter cannot be null.",
    log_type: null,
    docs: "\n## Error - 54206\n\n### Sync: Invalid Map Item data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\n* Your request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.439Z',
  },
  31207: {
    code: 31207,
    message: 'JWT token expiration too long.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31207\r\n\r\n### JWT token expiration too long.\r\n\r\nJWT token expiration too long.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:48:52Z',
    last_updated: '2020-08-04T10:00:11.044Z',
  },
  14108: {
    code: 14108,
    message: 'From phone number not SMS capable',
    log_level: 'WARNING',
    secondary_message:
      'The From phone number does not appear to be a phone number that you can SMS from',
    log_type: null,
    docs: '## Warning - 14108 \n\n### Message "From" Phone Number not message capable\n\nThe From phone number does not appear to be a phone number that you can Message from\n\n#### Possible Causes \n*  Sending from a number that is not SMS or MMS capable\n\n\n#### Possible Solutions\n*  Check to make sure the number is correct\n*  Check to make sure the number is an SMS or MMS capable Twilio Incoming number assigned to your account\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:49Z',
    last_updated: '2020-08-04T10:00:27.539Z',
  },
  60372: {
    code: 60372,
    message: 'Relying party id invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60372\r\n\r\n### Relying party id invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Relying party ID in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Relying party ID in the request body is correct.',
    causes: 'The Relying party ID in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Relying party ID in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-20T09:21:40Z',
    last_updated: '2023-12-20T09:21:40Z',
  },
  60511: {
    code: 60511,
    message: 'SNA Downstream Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60511\r\n\r\n### SNA Downstream Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received but failed during processing due to a downstream error during the Silent Network Auth process. This can happen when the carrier was expecting a missing header, the phone number was invalid, the SNA URL was invoked on a carrier that does not support HTTPS, or there is an invalid redirect.\r\n\r\n#### Possible Solutions\r\nRetry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received but failed during processing due to a downstream error during the Silent Network Auth process. This can happen when the carrier was expecting a missing header, the phone number was invalid, the SNA URL was invoked on a carrier that does not support HTTPS, or there is an invalid redirect.',
    solutions:
      'Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T16:46:26Z',
    last_updated: '2022-08-30T16:46:26Z',
  },
  50391: {
    code: 50391,
    message: 'Conflicting conversation modification',
    log_level: 'ERROR',
    secondary_message:
      'The requested conversation is already being added or removed by a concurrent API request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50391\r\n\r\n### Conflicting conversation modification\r\n\r\nThe requested conversation is already being added or removed by a concurrent API request. The requested conversation is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.\r\n\r\n#### Possible Causes\r\n* You might be adding a new conversation to the service instance while the conversation with the same unique name is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a conversation with the same unique name to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same conversation by SID or unique name from the service instance.\r\n\r\n#### Possible Solutions\r\n* Implement an operation retrier and repeat the failed conversation API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that add or remove conversations. Wait until the original request completes and returns an API response, before sending any successive conversation requests.',
    causes:
      '* You might be adding a new conversation to the service instance while the conversation with the same unique name is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a conversation with the same unique name to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same conversation by SID or unique name from the service instance.',
    solutions:
      '* Implement an operation retrier and repeat the failed conversation API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that add or remove conversations. Wait until the original request completes and returns an API response, before sending any successive conversation requests.',
    description:
      'The requested conversation is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.',
    product: 'Programmable Chat',
    date_created: '2021-10-13T12:27:33Z',
    last_updated: '2021-10-13T12:28:05.183407Z',
  },
  50106: {
    code: 50106,
    message: 'Programmable Chat: Channel creator role not found',
    log_level: 'ERROR',
    secondary_message: 'Valid Channel Creator Role does not exist in this service deployment.',
    log_type: null,
    docs: '## Error - 50106\r\n\r\n### Programmable Chat: Channel creator role not found\r\n\r\n#### Possible Causes \r\n*  Valid Channel Creator Role does not exist in this service deployment.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel Creator Role exists in this service deployment. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:47Z',
    last_updated: '2020-08-04T10:00:23.378Z',
  },
  32304: {
    code: 32304,
    message: 'Interconnect: Connection (TNX) SID is not Active',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '#### Possible Causes \r\n*  The Interconnect Connection (TNX) SID is not Active.\r\n\r\n\r\n#### Possible Solutions\r\n*  Please verify the status of your Interconnect Connection SID, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-11-16T21:55:38Z',
    last_updated: '2020-08-04T10:00:20.36Z',
  },
  60201: {
    code: 60201,
    message: 'Selected template translation is not approved',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60201\r\n\r\n### Selected template translation is not approved\r\n\r\n ## Error - 60201\r\n\r\n### Invalid Parameter\r\n\r\nSelected template translation is not approved\r\n\r\n#### Possible Causes\r\nThe user want to use a template with a translation that is not approved\r\n\r\n#### Possible Solutions\r\n- Use a translation of the template approved. \r\n- Contact Twilio Support',
    causes: 'The user want to use a template with a translation that is not approved',
    solutions: '- Use a translation of the template approved. \r\n- Contact Twilio Support',
    description:
      '## Error - 60201\r\n\r\n### Invalid Parameter\r\n\r\nSelected template translation is not approved',
    product: 'Verify',
    date_created: '2022-08-30T20:31:40Z',
    last_updated: '2022-08-30T20:31:40Z',
  },
  20002: {
    code: 20002,
    message: 'Invalid FriendlyName',
    log_level: 'ERROR',
    secondary_message:
      'Many Twilio resources take descriptive names to help you remember what they are.  However, such "FriendlyNames" must be between 1 and 64 characters long.',
    log_type: null,
    docs: '## Error - 20002 \n\n### Invalid FriendlyName\n\nMany Twilio resources take descriptive names to help you remember what they are.  However, such "FriendlyNames" must be between 1 and 64 characters long.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:51Z',
    last_updated: '2020-08-04T10:00:27.445Z',
  },
  60618: {
    code: 60618,
    message: 'Lookup Malformed Request Parameter',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60618\r\n\r\n### Lookup Malformed Request Parameter\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received but failed due to one or more request parameters being malformed. This can happen when a parameter has exceeded its maximum length constraint. \r\n\r\n#### Possible Solutions\r\n- Review request parameters and retry request.',
    causes:
      'The request was received but failed due to one or more request parameters being malformed. This can happen when a parameter has exceeded its maximum length constraint. ',
    solutions: '- Review request parameters and retry request.',
    description: 'An invalid value was passed for query parameters',
    product: 'Lookup',
    date_created: '2022-10-05T16:33:37Z',
    last_updated: '2023-01-06T00:30:40.542277Z',
  },
  82007: {
    code: 82007,
    message: 'Unsupported Runtime',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 82007\r\n\r\n### Unsupported Runtime\r\n\r\n The runtime used in the Serverless Build request is not supported on the platform. A runtime defines the environment your Functions will be executed in (e.g. which Node.js version to use for your Functions).\r\n\r\n#### Possible Causes\r\n* A Serverless Build request was made without providing the runtime and the runtime used for the last successful build in the service (e.g. a Node.js version that is no longer supported on the platform).\r\n* A Serverless Build request was made with a specified runtime (e.g. node10) that is currently not supported on the platform.\r\n\r\n#### Possible Solutions\r\n* Determine what [runtime versions are currently available](https://www.twilio.com/docs/serverless/functions-assets/faq#which-runtimes-are-available-for-twilio-functions).\r\n* Migrate to a new valid Node.js version by following our migration guide:  [https://www.twilio.com/docs/serverless/functions-assets/node-upgrade](https://www.twilio.com/docs/serverless/functions-assets/node-upgrade)\r\n* When using the Serverless API pass a dedicated valid runtime version when creating a new Build: [https://www.twilio.com/docs/serverless/api/resource/build](https://www.twilio.com/docs/serverless/api/resource/build)',
    causes:
      '* A Serverless Build request was made without providing the runtime and the runtime used for the last successful build in the service (e.g. a Node.js version that is no longer supported on the platform).\r\n* A Serverless Build request was made with a specified runtime (e.g. node10) that is currently not supported on the platform.',
    solutions:
      '* Determine what [runtime versions are currently available](https://www.twilio.com/docs/serverless/functions-assets/faq#which-runtimes-are-available-for-twilio-functions).\r\n* Migrate to a new valid Node.js version by following our migration guide:  [https://www.twilio.com/docs/serverless/functions-assets/node-upgrade](https://www.twilio.com/docs/serverless/functions-assets/node-upgrade)\r\n* When using the Serverless API pass a dedicated valid runtime version when creating a new Build: [https://www.twilio.com/docs/serverless/api/resource/build](https://www.twilio.com/docs/serverless/api/resource/build)',
    description:
      'The runtime used in the Serverless Build request is not supported on the platform. A runtime defines the environment your Functions will be executed in (e.g. which Node.js version to use for your Functions).',
    product: 'Functions',
    date_created: '2021-05-06T23:15:01Z',
    last_updated: '2023-08-09T13:41:19.178167Z',
  },
  53630: {
    code: 53630,
    message: 'Empty track list for composition',
    log_level: 'ERROR',
    secondary_message: 'The composition job did not start',
    log_type: null,
    docs: '## Error -  53630\r\n\r\n### Empty track list for composition\r\n\r\nThe combination of sources and exclusions passed to the composition resulted in an empty track list. The composition job did not start.\r\n\r\n#### Causes\r\n\r\n * You specified an incorrect list of sources and exclusions, audio and video, which have resulted in an empty track list.\r\n\r\n#### Solutions\r\n\r\n * Recreate the composition using an updated list of sources and exclusions.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-09-28T16:09:33Z',
    last_updated: '2020-08-04T10:00:12.55Z',
  },
  80406: {
    code: 80406,
    message: 'Phone Number Did Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Phone Number Did',
    log_type: null,
    docs: '## Warning\n\n### Phone Number Did Invalid\n\nExample Message: Invalid Phone Number Did',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:15.946Z',
  },
  13218: {
    code: 13218,
    message: 'Dial: Invalid sequential value',
    log_level: 'WARNING',
    secondary_message: 'sequential must be "true" or "false".',
    log_type: 'APPLICATION',
    docs: '## WARNING - 13218\r\n\r\n### Dial: Invalid sequential value\r\n\r\nsequential must be "true" or "false". \r\n\r\n#### Possible Causes\r\nsequential value is not "true" or "false".\r\n\r\n#### Possible Solutions\r\nsequential must be "true" or "false".',
    causes: 'sequential value is not "true" or "false".',
    solutions: 'sequential must be "true" or "false".',
    description: null,
    product: 'Programmable Voice',
    date_created: '2020-05-14T18:00:55Z',
    last_updated: '2020-08-04T10:00:03.088Z',
  },
  50368: {
    code: 50368,
    message: 'Conversation webhook type not provided',
    log_level: 'ERROR',
    secondary_message: 'Conversation webhook target parameter is required but was not provided.',
    log_type: null,
    docs: '\n## Error - 50368\n\n### Conversations: Conversation webhook type not provided\nConversation webhook target parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected a Target input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid Target parameter to the API request and confirm that it is not misspelled.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.694Z',
  },
  63007: {
    code: 63007,
    message: "Twilio could not find a Channel with the specified 'From' address",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63007\r\n\r\n### Twilio could not find a Channel with the specified 'From' address\r\n\r\n \r\n   \r\n\r\n#### Possible Causes\r\n* Sending a message using a `From` address that is not associated with any Channel or WhatsApp installation.\r\n* Sending a message using a `From` address for a Channel that is pending approval.\r\n* Using incorrect Account Credentials for the account that owns the Sender\r\n\r\n\r\n#### Possible Solutions\r\n* See [here](https://www.twilio.com/docs/api/channels#channel-addresses) for supported formats of Channel endpoint addresses.\r\n* To send messages using WhatsApp, the `From `address should be `whatsapp:<sandbox phone number>` or` whatsapp:<your twilio number>` . This can be found on the [WhatsApp sandbox page](https://www.twilio.com/console/messaging/whatsapp/sandbox) or [WhatsApp numbers page](https://www.twilio.com/console/messaging/whatsapp/numbers).\r\n* If you are using the WhatsApp sandbox, ensure that you have activated the Twilio Sandbox for WhatsApp. This can be found on the [WhatsApp sandbox page](https://www.twilio.com/console/messaging/whatsapp/sandbox).\r\n* Check your account SID and auth token are correct and correspond to the account that owns the Sender. You can find your account credentials in the Console [here](https://console.twilio.com/).\r\n",
    causes:
      '* Sending a message using a `From` address that is not associated with any Channel or WhatsApp installation.\r\n* Sending a message using a `From` address for a Channel that is pending approval.\r\n* Using incorrect Account Credentials for the account that owns the Sender\r\n',
    solutions:
      '* See [here](https://www.twilio.com/docs/api/channels#channel-addresses) for supported formats of Channel endpoint addresses.\r\n* To send messages using WhatsApp, the `From `address should be `whatsapp:<sandbox phone number>` or` whatsapp:<your twilio number>` . This can be found on the [WhatsApp sandbox page](https://www.twilio.com/console/messaging/whatsapp/sandbox) or [WhatsApp numbers page](https://www.twilio.com/console/messaging/whatsapp/numbers).\r\n* If you are using the WhatsApp sandbox, ensure that you have activated the Twilio Sandbox for WhatsApp. This can be found on the [WhatsApp sandbox page](https://www.twilio.com/console/messaging/whatsapp/sandbox).\r\n* Check your account SID and auth token are correct and correspond to the account that owns the Sender. You can find your account credentials in the Console [here](https://console.twilio.com/).\r\n',
    description: '\r\n   ',
    product: 'Programmable SMS',
    date_created: '2018-03-17T01:22:43Z',
    last_updated: '2024-02-12T11:56:42.541018Z',
  },
  53107: {
    code: 53107,
    message: 'MaxParticipants is out of range',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53107: MaxParticipants is out of range\r\n\r\nRaised in the REST API when MaxParticipants is set out of range.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with MaxParticipants out of range.\r\n\r\n#### Solutions\r\n\r\n * Set the MaximumParticipants value from 1 up to the maximum allowed for the Room Type.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:43:56Z',
    last_updated: '2020-08-04T10:00:19.568Z',
  },
  36007: {
    code: 36007,
    message: 'Broadcast Upload Status Check Failure',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36007\r\n\r\n### Broadcast Upload Status Check Failure\r\n\r\n The Broadcast cannot have a file uploaded to it because it is in a state other than PENDING_UPLOAD.\r\n\r\n#### Possible Causes\r\n* The Broadcast SID that you provided is for a Broadcast that is in a state other than PENDING_UPLOAD. Those other states include: UPLOADED, QUEUED, EXECUTING, EXECUTION_FAILURE, EXECUTION_COMPLETED, CANCELATION_REQUESTED, CANCELED\r\n\r\n#### Possible Solutions\r\n* Upload the file to a Broadcast SID that is in a PENDING_UPLOAD state',
    causes:
      '* The Broadcast SID that you provided is for a Broadcast that is in a state other than PENDING_UPLOAD. Those other states include: UPLOADED, QUEUED, EXECUTING, EXECUTION_FAILURE, EXECUTION_COMPLETED, CANCELATION_REQUESTED, CANCELED',
    solutions: '* Upload the file to a Broadcast SID that is in a PENDING_UPLOAD state',
    description:
      'The Broadcast cannot have a file uploaded to it because it is in a state other than PENDING_UPLOAD.',
    product: 'Programmable Messaging',
    date_created: '2024-01-04T23:14:38Z',
    last_updated: '2024-01-10T18:58:54.755399Z',
  },
  60307: {
    code: 60307,
    message: "Cannot resend push notifications to 'none' notification platform",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60307\r\n\r\n### Cannot resend push notifications to \'none\' notification platform\r\n\r\n This error is returned when the resend push notification endpoint was called for a factor using "none" as notification platform in its configuration.\r\n\r\n#### Possible Causes\r\nYou called the resend push notification endpoint for a factor with the "none" notification platform configured.\r\n\r\n#### Possible Solutions\r\nFor factor configured with "none" as notification platform, it is not necessary to call the resend push notification endpoint.',
    causes:
      'You called the resend push notification endpoint for a factor with the "none" notification platform configured.',
    solutions:
      'For factor configured with "none" as notification platform, it is not necessary to call the resend push notification endpoint.',
    description:
      'This error is returned when the resend push notification endpoint was called for a factor using "none" as notification platform in its configuration.',
    product: 'Verify',
    date_created: '2021-10-29T18:08:00Z',
    last_updated: '2021-10-29T18:08:00Z',
  },
  64008: {
    code: 64008,
    message: 'Pay: Payment Gateway rejected charge creation.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 64008\r\n\r\n### Pay: Payment Gateway rejected charge creation.\r\n\r\nA 64008 Error is an indication that the request attempted to perform a charge of a credit card\r\nbut the attempt failed because the connector returned an error.\r\n\r\n#### Possible Causes\r\n* The &lt;Pay&gt; Connector returned an error.\r\n\r\n#### Possible Solutions\r\n* Please see the data returned in the with webhook to action url for more details.  \r\n* Reach out to your Payment Gateway support for more assistance.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-02-26T22:02:35Z',
    last_updated: '2020-08-04T10:00:10.242Z',
  },
  21618: {
    code: 21618,
    message: 'The message body cannot be sent',
    log_level: 'ERROR',
    secondary_message:
      'You have attempted to send a message with content that is being filtered by all of our carriers.  We have logged the carrier you are attempting to reach and will monitor these failures when adding new carriers. If we add a new carrier in the future that does not filter the content you are trying to send, Twilio will automatically route your message through the new carrier.',
    log_type: null,
    docs: '## Error - 21618\n\n### The message body cannot be sent\n\nYou have attempted to send a message with content that is being filtered by all\nof our carriers.\n\nWe have logged the carrier you are attempting to reach and will monitor these\nfailures when adding new carriers. If we add a new carrier in the future that\ndoes not filter the content you are trying to send, Twilio will automatically\nroute your message through the new carrier.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:27Z',
    last_updated: '2020-08-04T10:00:24.989Z',
  },
  50214: {
    code: 50214,
    message: 'User conversation limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50214\r\n\r\n### User conversation limit exceeded\r\n\r\n \r\n\r\n#### Possible Causes\r\nUser has joined too many conversations\r\n\r\n#### Possible Solutions\r\n*  Increase user conversation limit for service instance\r\n*  Remove user from conversations',
    causes: 'User has joined too many conversations',
    solutions:
      '*  Increase user conversation limit for service instance\r\n*  Remove user from conversations',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-10-13T12:24:20Z',
    last_updated: '2021-10-13T12:24:20Z',
  },
  13238: {
    code: 13238,
    message: 'Dial->Conference: Invalid Verb used in waitUrl, holdUrl, or announceUrl TwiML',
    log_level: 'ERROR',
    secondary_message: 'placeholder',
    log_type: 'APPLICATION',
    docs: '## ERROR - 13238\r\n\r\n### Dial->Conference: Invalid Verb used in waitUrl, holdUrl, or announceUrl TwiML\r\n\r\n The TwiML that executes via the waitUrl, holdUrl, or announceUrl can only contain Say, Play, Pause, and Redirect verbs. Dial, Gather, Hangup and Record are not allowed.\r\n\r\n#### Possible Causes\r\nDial, Gather, Hangup or Record verbs are used in the TwiML.\r\n\r\n#### Possible Solutions\r\nRemove Dial, Gather, Hangup and Record verbs from the TwiML.',
    causes: 'Dial, Gather, Hangup or Record verbs are used in the TwiML.',
    solutions: 'Remove Dial, Gather, Hangup and Record verbs from the TwiML.',
    description:
      'The TwiML that executes via the waitUrl, holdUrl, or announceUrl can only contain Say, Play, Pause, and Redirect verbs. Dial, Gather, Hangup and Record are not allowed.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:38Z',
    last_updated: '2022-10-10T19:42:08.139168Z',
  },
  53633: {
    code: 53633,
    message: 'Composition is too large',
    log_level: 'ERROR',
    secondary_message: 'The composition job did not start.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 53633\r\n\r\n### Composition is too large\r\n\r\nThe composition job did not start. The composition job did not start because the combined size of the media sources passed to the composition is too large to process.\r\n\r\n#### Possible Causes\r\nDue to fixed hardware constraints, Twilio is not able to compose all the media tracks specified in the composition create request. Check the maximum size on <a href="https://www.twilio.com/docs/video/api/compositions-resource#known-issues">Known limitations</a>\r\n\r\n#### Possible Solutions\r\nPlease reduce the scope of the composition by excluding some of the sources to verity that they are below our maximum size.\r\nIf not possible, please <a href="/help/contact">contact us</a> and provide a description of the media files you are attempting to compose.',
    causes:
      'Due to fixed hardware constraints, Twilio is not able to compose all the media tracks specified in the composition create request. Check the maximum size on <a href="https://www.twilio.com/docs/video/api/compositions-resource#known-issues">Known limitations</a>',
    solutions:
      'Please reduce the scope of the composition by excluding some of the sources to verity that they are below our maximum size.\r\nIf not possible, please <a href="/help/contact">contact us</a> and provide a description of the media files you are attempting to compose.',
    description:
      'The composition job did not start because the combined size of the media sources passed to the composition is too large to process.',
    product: 'Programmable Video',
    date_created: '2019-08-13T12:08:41Z',
    last_updated: '2021-12-15T07:54:59.590778Z',
  },
  30796: {
    code: 30796,
    message:
      'Brand Registration Feedback: Non public entity registered as a public for profit entity or the stock information mismatch.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30796\r\n\r\n### Brand Registration Feedback: Non public entity registered as a public for profit entity or the stock information mismatch.\r\n\r\n Your Brand has received feedback from The Campaign Registry upon registration. This Brand Registration can not be used for campaign creation until the provided feedback has been addressed. In this particular case, either a non-public entity has been registered as a public for profit entity or the stock information provided during the registration process doesn’t match the public company records.\r\n\r\n\r\n#### Possible Causes\r\n* The submitted stock symbol and stock exchange could not be verified for the submitted legal company name. \r\n* The submitted stock exchange is not recognized.  \r\n\r\n\r\n#### Possible Solutions\r\nPlease edit your A2P profile and update the stock_symbol and/or stock_exchange with correct information.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    causes:
      '* The submitted stock symbol and stock exchange could not be verified for the submitted legal company name. \r\n* The submitted stock exchange is not recognized.  \r\n',
    solutions:
      'Please edit your A2P profile and update the stock_symbol and/or stock_exchange with correct information.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    description:
      'Your Brand has received feedback from The Campaign Registry upon registration. This Brand Registration can not be used for campaign creation until the provided feedback has been addressed. In this particular case, either a non-public entity has been registered as a public for profit entity or the stock information provided during the registration process doesn’t match the public company records.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-28T16:29:44Z',
    last_updated: '2024-06-04T15:36:44.585075Z',
  },
  61007: {
    code: 61007,
    message: 'Add-ons: Response body too large',
    log_level: 'ERROR',
    secondary_message:
      ' The Add-on Provider returned a response payload that exceeded 64 kilobytes. As a result the payload was removed and this error was returned instead.',
    log_type: null,
    docs: '## Error - 61007\r\n\r\n### Add-ons: Response body too large\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider returned a response payload that exceeded 64 kilobytes. As a result the payload was removed and this error was returned instead.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:38:26Z',
    last_updated: '2020-08-04T10:00:21.45Z',
  },
  30104: {
    code: 30104,
    message: 'Shortened link not found. Click redirected to fallback Url',
    log_level: 'WARNING',
    secondary_message:
      'Twilio was unable to find a record of the shortened link that this request was sent to.',
    log_type: 'TWILIO',
    docs: "## WARNING - 30104\r\n\r\n### Shortened link not found. Click redirected to fallback Url\r\n\r\nTwilio was unable to find a record of the shortened link that this request was sent to. We received a request to a domain you've registered with Click Tracking but we don't have a record of the shortened url.\r\n\r\n#### Possible Causes\r\n- The url has expired\r\n- A request was sent to a url that wasn't generated by Twilio\r\n\r\n#### Possible Solutions\r\n- Contact your account manager or support about extending the retention period of links.",
    causes:
      "- The url has expired\r\n- A request was sent to a url that wasn't generated by Twilio",
    solutions:
      '- Contact your account manager or support about extending the retention period of links.',
    description:
      "We received a request to a domain you've registered with Click Tracking but we don't have a record of the shortened url.",
    product: 'Programmable SMS',
    date_created: '2020-04-23T21:16:26Z',
    last_updated: '2020-08-04T10:00:03.9Z',
  },
  83401: {
    code: 83401,
    message: 'The device was not attached to a cellular network',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83401\r\n\r\n### The device was not attached to a cellular network\r\n\r\n The device was not attached to a cellular network when Twilio attempted to send the IP Command. The IP Command was not sent to the device.\r\n\r\n#### Possible Causes\r\nYour device was not attached to a cellular network when Twilio attempted to send the IP Command.\r\n\r\n#### Possible Solutions\r\nEnsure your device is attached to a cellular network and try to send the IP Command again.',
    causes:
      'Your device was not attached to a cellular network when Twilio attempted to send the IP Command.',
    solutions:
      'Ensure your device is attached to a cellular network and try to send the IP Command again.',
    description:
      'The device was not attached to a cellular network when Twilio attempted to send the IP Command. The IP Command was not sent to the device.',
    product: 'Super SIM',
    date_created: '2021-04-15T21:10:15Z',
    last_updated: '2021-04-15T21:10:15Z',
  },
  22202: {
    code: 22202,
    message: 'No regulation sid or phone number country and type was provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22202\r\n\r\n### No regulation sid or phone number country and type was provided\r\n\r\n No regulation sid or phone number country and type was provided\r\n\r\n#### Possible Causes\r\nThe regulation sid or phone number country and type are missing from the request.\r\n\r\n#### Possible Solutions\r\n* Please ensure you are passing a regulation sid or phone number country and type\r\n* If you need to know which regulation sid or phone number country and type to use, please refer to the Regulations REST API.',
    causes: 'The regulation sid or phone number country and type are missing from the request.',
    solutions:
      '* Please ensure you are passing a regulation sid or phone number country and type\r\n* If you need to know which regulation sid or phone number country and type to use, please refer to the Regulations REST API.',
    description: 'No regulation sid or phone number country and type was provided',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:41:59Z',
    last_updated: '2020-08-04T10:00:05.68Z',
  },
  53122: {
    code: 53122,
    message: 'The recording operation requested is not supported for the Room type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 53122\r\n\r\n### The recording operation requested is not supported for the Room type\r\n\r\n The recording operation requested is not supported for the Room type\r\n\r\n#### Possible Causes\r\nREST API call requesting to record a Track in a peer-to-peer Room.\r\n\r\n#### Possible Solutions\r\nMake sure that the recording operation requested is supported for the Room type.',
    causes: 'REST API call requesting to record a Track in a peer-to-peer Room.',
    solutions: 'Make sure that the recording operation requested is supported for the Room type.',
    description: 'The recording operation requested is not supported for the Room type',
    product: 'Programmable Video',
    date_created: '2020-07-21T23:31:57Z',
    last_updated: '2020-08-04T10:00:00.981Z',
  },
  30470: {
    code: 30470,
    message: 'Toll Free verification rejection - High Risk: Deceptive Marketing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30470\r\n\r\n### Toll Free verification rejection - High Risk: Deceptive Marketing\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category  (High-risk: Deceptive Marketing). \r\n\r\nMarketing messages must be truthful, not misleading, and, when appropriate, backed by scientific evidence in order to meet the standard held by the Federal Trade Commission’s (FTC) Truth In Advertising rules. The FTC prohibits unfair or deceptive advertising in any medium, including text messages.\r\n\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category  (High-risk: Deceptive Marketing). \r\n\r\nMarketing messages must be truthful, not misleading, and, when appropriate, backed by scientific evidence in order to meet the standard held by the Federal Trade Commission’s (FTC) Truth In Advertising rules. The FTC prohibits unfair or deceptive advertising in any medium, including text messages.\r\n',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:24:05Z',
    last_updated: '2024-02-22T21:24:05Z',
  },
  30476: {
    code: 30476,
    message: 'Toll Free verification rejection - Opt-in not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30476\r\n\r\n### Toll Free verification rejection - Opt-in not provided\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nProof of opt-in for consumer to provide consent was not provided. Every end business must have consent from each recipient they send a message to. It’s insufficient to select an opt-in method without description or providing evidence.\r\n\r\nYou may have submitted a URL for the opt-in workflow, but it did not demonstrate how the consumer opts-in to messaging. The URL can contain a link to the web form where the consumer opts-in, a hosted image file with a screenshot of how the consumer opts-in, or a link to a document that tells the story of the opt-in (such as a verbal opt-in script). \r\n\r\nAny URL submitted must be reachable, resolvable and of access to the public. \r\n\r\nOpt-in refers to the process of getting a consumer’s permission to send them text messages. A2P message Senders should: \r\n* Obtain a Consumer’s consent to receive messages generally; \r\n* Obtain a Consumer’s express written consent to specifically receive marketing messages; and \r\n* Ensure that Consumers have the ability to revoke consent.\r\n\r\nNote: Any business with a terms of service or privacy policy that mentions sharing or selling consumer data/opt-in information is considered noncompliant. \r\n\r\n\r\n#### Possible Solutions\r\nResubmit the toll-free verification with a link that tells the story of your opt-in workflow. \r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    causes:
      'Proof of opt-in for consumer to provide consent was not provided. Every end business must have consent from each recipient they send a message to. It’s insufficient to select an opt-in method without description or providing evidence.\r\n\r\nYou may have submitted a URL for the opt-in workflow, but it did not demonstrate how the consumer opts-in to messaging. The URL can contain a link to the web form where the consumer opts-in, a hosted image file with a screenshot of how the consumer opts-in, or a link to a document that tells the story of the opt-in (such as a verbal opt-in script). \r\n\r\nAny URL submitted must be reachable, resolvable and of access to the public. \r\n\r\nOpt-in refers to the process of getting a consumer’s permission to send them text messages. A2P message Senders should: \r\n* Obtain a Consumer’s consent to receive messages generally; \r\n* Obtain a Consumer’s express written consent to specifically receive marketing messages; and \r\n* Ensure that Consumers have the ability to revoke consent.\r\n\r\nNote: Any business with a terms of service or privacy policy that mentions sharing or selling consumer data/opt-in information is considered noncompliant. \r\n',
    solutions:
      'Resubmit the toll-free verification with a link that tells the story of your opt-in workflow. \r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T22:03:58Z',
    last_updated: '2024-02-22T22:03:58Z',
  },
  19034: {
    code: 19034,
    message: 'Invalid country code',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19034\r\n\r\n### Invalid country code\r\n\r\n Country code provided in the request is not valid\r\n\r\n#### Possible Causes\r\nCountry code is not in the ISO 3166-1 alpha-2 country code of the address format\r\n\r\n#### Possible Solutions\r\nUpdate the country code to match  ISO 3166-1 alpha-2 country code of the address format',
    causes: 'Country code is not in the ISO 3166-1 alpha-2 country code of the address format',
    solutions:
      'Update the country code to match  ISO 3166-1 alpha-2 country code of the address format',
    description: 'Country code provided in the request is not valid',
    product: null,
    date_created: '2020-07-21T20:26:00Z',
    last_updated: '2020-08-04T10:00:01.365Z',
  },
  64007: {
    code: 64007,
    message: 'Pay: Connector does not support creating charge.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64007\r\n\r\n### Pay: Connector does not support creating charge.\r\n\r\n ## Error - 64007\r\n\r\n### Pay: Connector does not support creating charge.\r\n\r\n Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\nA 64007 Error is an indication that the request to create a charge on the credit card failed because the connector does not support making charges.\r\n\r\n\r\n#### Possible Causes\r\n* The paymentConnector attribute points to a Connector that does not support charging.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports charging.\r\n* If tokenization was intended, please change the chargeAmount attribute. Please see <A HREF="/docs/voice/twiml/pay#chargeamount">this API documentation</A> for more details.',
    causes:
      '* The paymentConnector attribute points to a Connector that does not support charging.',
    solutions:
      '* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports charging.\r\n* If tokenization was intended, please change the chargeAmount attribute. Please see <A HREF="/docs/voice/twiml/pay#chargeamount">this API documentation</A> for more details.',
    description:
      '## Error - 64007\r\n\r\n### Pay: Connector does not support creating charge.\r\n\r\n Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\nA 64007 Error is an indication that the request to create a charge on the credit card failed because the connector does not support making charges.\r\n',
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:59:00Z',
    last_updated: '2020-08-04T10:00:10.263Z',
  },
  60601: {
    code: 60601,
    message: 'Authorization required for Canada lookups',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60601\r\n\r\n### Authorization required for Canada lookups\r\n\r\n Authorization must be granted to your company by the CLNPC to return data on Canada phone numbers.\r\n\r\n#### Possible Causes\r\nYour account is not authorized for lookups on Canada phone numbers\r\n\r\n#### Possible Solutions\r\nTo apply for access to query Canada phone number information, see https://help.twilio.com/articles/360004563433-Twilio-Lookup-API-is-Not-Returning-Carrier-Data-for-Canadian-Phone-Numbers',
    causes: 'Your account is not authorized for lookups on Canada phone numbers',
    solutions:
      'To apply for access to query Canada phone number information, see https://help.twilio.com/articles/360004563433-Twilio-Lookup-API-is-Not-Returning-Carrier-Data-for-Canadian-Phone-Numbers',
    description:
      'Authorization must be granted to your company by the CLNPC to return data on Canada phone numbers.',
    product: 'Lookup',
    date_created: '2018-05-28T21:31:27Z',
    last_updated: '2024-04-15T19:49:32.386966Z',
  },
  30990: {
    code: 30990,
    message: 'Campaign Suspension',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30990\r\n\r\n### Campaign Suspension\r\n\r\n The campaign has been suspended. Messaging has been halted and number registration/deregistration is not available until suspension has been lifted\r\n\r\n#### Possible Causes\r\n*Active Suspension*: The campaign has been suspended due to a violation of messaging policies or other related issues.\r\n\r\n*Suspension Reason Category : Suspension Reason Description*\r\n* Campaign-to-traffic mismatch: In-market traffic does not match with the registered campaign.\r\n* Spam: Including but not limited to any kind of unwanted or unsolicited messaging.\r\n* Controlled substance: Including but not limited to messaging pertaining to controlled substances.\r\n* Phishing Messages: Including but not limited to messaging designed to gain access.\r\n* Excessive Complaints: Including but not limited to unacceptable volumes of consumer complaints.\r\n* Illicit Content: Including but not limited to messages relating to illegal activity.\r\n* Fraudulent Messages: Including but not limited to counterfeit/fraudulent goods or activities.\r\n* Affiliate Marketing: Including but not limited to sharing of opt-ins to affiliate companies.\r\n* Promotional Gambling: Including but not limited to the act of gambling or promoting gambling.\r\n* Lack of Age Gate: No age gate mechanism for messaging campaigns that require it.\r\n* Illegal Sweepstakes: Including but not limited to sweepstakes that do not follow required laws.\r\n* Other: As applicable.\r\n\r\n#### Possible Solutions\r\n1. Review the specific reasons for the campaign suspension and resolve any outstanding compliance or policy issues. \r\n2. Contact Twilio Support team to receive more details around why your campaign has been suspended, and how to resolve the issue.',
    causes:
      '*Active Suspension*: The campaign has been suspended due to a violation of messaging policies or other related issues.\r\n\r\n*Suspension Reason Category : Suspension Reason Description*\r\n* Campaign-to-traffic mismatch: In-market traffic does not match with the registered campaign.\r\n* Spam: Including but not limited to any kind of unwanted or unsolicited messaging.\r\n* Controlled substance: Including but not limited to messaging pertaining to controlled substances.\r\n* Phishing Messages: Including but not limited to messaging designed to gain access.\r\n* Excessive Complaints: Including but not limited to unacceptable volumes of consumer complaints.\r\n* Illicit Content: Including but not limited to messages relating to illegal activity.\r\n* Fraudulent Messages: Including but not limited to counterfeit/fraudulent goods or activities.\r\n* Affiliate Marketing: Including but not limited to sharing of opt-ins to affiliate companies.\r\n* Promotional Gambling: Including but not limited to the act of gambling or promoting gambling.\r\n* Lack of Age Gate: No age gate mechanism for messaging campaigns that require it.\r\n* Illegal Sweepstakes: Including but not limited to sweepstakes that do not follow required laws.\r\n* Other: As applicable.',
    solutions:
      '1. Review the specific reasons for the campaign suspension and resolve any outstanding compliance or policy issues. \r\n2. Contact Twilio Support team to receive more details around why your campaign has been suspended, and how to resolve the issue.',
    description:
      'The campaign has been suspended. Messaging has been halted and number registration/deregistration is not available until suspension has been lifted',
    product: 'Programmable Messaging',
    date_created: '2023-12-06T20:44:20Z',
    last_updated: '2023-12-06T20:48:59.150865Z',
  },
  45359: {
    code: 45359,
    message: 'Failed to close Channel.  Invalid status parameter.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45359\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: "Update Channel request was made with invalid 'status'.",
    solutions: 'The only supported status change to a Channel is "closed".\r',
    description: 'Failed to close Channel <channel sid>.  The channel status provided was invalid.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:36.019112Z',
  },
  45009: {
    code: 45009,
    message: 'Configuration Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45009\r\n\r\n### Configuration Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nA Flex component was not configured correctly.\r\n\r\n#### Possible Solutions\r\nRevise and verify the configuration. If everything is as expected then contact Customer Support to review your use case.',
    causes: 'A Flex component was not configured correctly.',
    solutions:
      'Revise and verify the configuration. If everything is as expected then contact Customer Support to review your use case.',
    description: null,
    product: 'Flex',
    date_created: '2019-07-08T11:33:15Z',
    last_updated: '2020-08-04T10:00:07.741Z',
  },
  13239: {
    code: 13239,
    message: 'Dial->Conference: Invalid Trim Value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 13239\r\n\r\n### Dial->Conference: Invalid Trim Value\r\n\r\nThe trim parameter you entered is invalid. Acceptable values are trim-silence, do-not-trim, true and false.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-02-14T23:37:04Z',
    last_updated: '2020-08-04T10:00:20.286Z',
  },
  80901: {
    code: 80901,
    message: 'Message Matched Stop Word',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## WARNING - 80901\r\n\r\n### Message Matched Stop Word\r\n\r\n Message matched a stop word.\r\n\r\n#### Possible Causes\r\nMessage matched a STOP or START word, not proxying. See our [help](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) pages for more information. \r\n\r\n#### Possible Solutions\r\nSend a message with START, to resubscribe and continue the interactions. ',
    causes:
      'Message matched a STOP or START word, not proxying. See our [help](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) pages for more information. ',
    solutions: 'Send a message with START, to resubscribe and continue the interactions. ',
    description: 'Message matched a stop word.',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-10-27T21:40:34.183Z',
  },
  11770: {
    code: 11770,
    message: 'Empty response body',
    log_level: 'ERROR',
    secondary_message:
      'Twilio received a HTTP response with Transfer-encoding: chunked but an empty body.  #### Possible Causes  *   Server misconfiguration *   Network disruptions   #### Possible Solutions  *   Verify that the server is serving a non-empty HTTP response *   Verify that the network connection is stable',
    log_type: null,
    docs: '## Error - 11770\n\n### Empty response body\n\nTwilio received a HTTP response with Transfer-encoding: chunked but an empty body.\n\n#### Possible Causes \n\n*   Server misconfiguration\n*   Network disruptions\n\n\n#### Possible Solutions\n\n*   Verify that the server is serving a non-empty HTTP response\n*   Verify that the network connection is stable\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:06Z',
    last_updated: '2020-08-04T10:00:26.626Z',
  },
  30436: {
    code: 30436,
    message: 'Invalid Phone Number SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30436\r\n\r\n### Invalid Phone Number SID\r\n\r\n The phone number SID is malformed or belongs to another account.\r\n\r\n#### Possible Causes\r\n* The phone number SID does not exist or does not belong to your account.\r\n* The phone number SID is not a 34 character string prefixed with “PN”\r\n\r\n\r\n#### Possible Solutions\r\n* Please specify a phone number SID for a toll free number you own.',
    causes:
      '* The phone number SID does not exist or does not belong to your account.\r\n* The phone number SID is not a 34 character string prefixed with “PN”\r\n',
    solutions: '* Please specify a phone number SID for a toll free number you own.',
    description: 'The phone number SID is malformed or belongs to another account.',
    product: 'Programmable Messaging',
    date_created: '2023-05-08T22:36:15Z',
    last_updated: '2023-05-11T23:25:11.214899Z',
  },
  60610: {
    code: 60610,
    message: 'Phone number outside of coverage',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60610\r\n\r\n### Phone number outside of coverage\r\n\r\n The requested phone number is outside of our range of coverage\r\n\r\n#### Possible Causes\r\nYou have provided a phone number that appears as either not provisioned with any carrier or belonging to a carrier outside the scope of our data coverage.\r\n\r\n#### Possible Solutions\r\nTry a supported phone number',
    causes:
      'You have provided a phone number that appears as either not provisioned with any carrier or belonging to a carrier outside the scope of our data coverage.',
    solutions: 'Try a supported phone number',
    description: 'The requested phone number is outside of our range of coverage',
    product: 'Lookup',
    date_created: '2021-06-30T14:26:50Z',
    last_updated: '2021-06-30T18:21:34.789431Z',
  },
  30452: {
    code: 30452,
    message: 'Toll-Free phone number verification unable to process - email invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30452\r\n\r\n### Toll-Free phone number verification unable to process - email invalid\r\n\r\n Twilio is unable to process your Toll Free Verification request because it could not be validated by Twilio and could not be submitted for verification review. \r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the email address is invalid. It could be due to:\r\n\r\n* Incorrectly formatted email address\r\n* Unknown email domain\r\n* Email is a suspected disposable address\r\n* Email is invalid\r\n\r\n\r\n#### Possible Solutions\r\nCorrect the email address and resubmit the verification in Console via the Messaging Compliance API. It is not recommended to delete the verification to resolve email validation issue. \r\n\r\n\r\nForbidden message categories\r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada \r\n\r\nToll-Free best practices can be found at \r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada\r\n',
    causes:
      'The toll-free phone number cannot be verified because the email address is invalid. It could be due to:\r\n\r\n* Incorrectly formatted email address\r\n* Unknown email domain\r\n* Email is a suspected disposable address\r\n* Email is invalid\r\n',
    solutions:
      'Correct the email address and resubmit the verification in Console via the Messaging Compliance API. It is not recommended to delete the verification to resolve email validation issue. \r\n\r\n\r\nForbidden message categories\r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada \r\n\r\nToll-Free best practices can be found at \r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada\r\n',
    description:
      'Twilio is unable to process your Toll Free Verification request because it could not be validated by Twilio and could not be submitted for verification review. \r\n',
    product: 'Programmable Messaging',
    date_created: '2023-08-14T19:31:17Z',
    last_updated: '2024-05-28T16:20:13.137982Z',
  },
  31600: {
    code: 31600,
    message: 'Busy Everywhere',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31600\r\n\r\n### Busy Everywhere \r\n\r\nAll possible destinations are busy.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:48:42Z',
    last_updated: '2020-08-04T10:00:08.153Z',
  },
  81008: {
    code: 81008,
    message: 'Failed to connect to outgoing Call',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81008\r\n\r\n### Failed to connect to outgoing Call\r\nStudio was unable to connect a call while processing the Outgoing Call widget.\r\n\r\n#### Possible Causes\r\n* The request to the Voice API failed.\r\n* Invalid values were passed to the Voice API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:15:49Z',
    last_updated: '2020-08-04T10:00:13.16Z',
  },
  48001: {
    code: 48001,
    message: 'Callback URL is not set',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 48001\r\n\r\n### Callback URL is not set\r\n\r\n \r\n\r\n#### Possible Causes\r\nCallback URL is not set in Twilio Frontline Console.\r\n\r\n#### Possible Solutions\r\nSet a Callback URL in Twilio Frontline Console to use this functionality.',
    causes: 'Callback URL is not set in Twilio Frontline Console.',
    solutions: 'Set a Callback URL in Twilio Frontline Console to use this functionality.',
    description: null,
    product: 'Frontline',
    date_created: '2021-09-24T08:05:44Z',
    last_updated: '2021-09-24T08:05:44Z',
  },
  33103: {
    code: 33103,
    message: 'Paging information invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33103\r\n\r\n### Paging information invalid\r\n\r\n Raised whenever an invalid value for pagination while listing resources is provided.\r\n\r\n#### Possible Causes\r\n* You provided Invalid values for pagination requests.\r\n\r\n#### Possible Solutions\r\n * Ensure that `Page` is a positive integer.\r\n * Ensure that `PageSize` is a positive integer and not greater than 1000.\r\n * Ensure that `PageToken` is valid as provided by a previous request.',
    causes: '* You provided Invalid values for pagination requests.',
    solutions:
      ' * Ensure that `Page` is a positive integer.\r\n * Ensure that `PageSize` is a positive integer and not greater than 1000.\r\n * Ensure that `PageToken` is valid as provided by a previous request.',
    description:
      'Raised whenever an invalid value for pagination while listing resources is provided.',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:17:27Z',
    last_updated: '2020-09-15T11:17:27Z',
  },
  11300: {
    code: 11300,
    message: 'Invalid template URL',
    log_level: 'ERROR',
    secondary_message:
      'The provided URL template has an invalid format. Please check to see if you have unclosed brackets.',
    log_type: null,
    docs: '## Error - 11300 \n\n### Invalid template URL\n\nThe provided URL template has an invalid format. Please check to see if you have unclosed brackets.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:26Z',
    last_updated: '2020-08-04T10:00:29.26Z',
  },
  80307: {
    code: 80307,
    message: 'Record to be updated was not found in database.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 80307\r\n\r\n### Record to be updated was not found in database.\r\n\r\n Record to be updated was not found in database.\r\n\r\n#### Possible Causes\r\nRecord to be updated is already deleted.\r\n\r\n#### Possible Solutions\r\nNo action required.',
    causes: 'Record to be updated is already deleted.',
    solutions: 'No action required.',
    description: 'Record to be updated was not found in database.',
    product: null,
    date_created: '2020-03-31T18:20:23Z',
    last_updated: '2020-08-04T10:00:04.138Z',
  },
  21241: {
    code: 21241,
    message: 'Credential List Dependencies Violation',
    log_level: 'ERROR',
    secondary_message: 'You cannot delete a Credential List that is still mapped to a SIP Domain.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21241\r\n\r\n### Credential List Dependencies Violation\r\n\r\nYou cannot delete a Credential List that is still mapped to a SIP Domain. \r\n\r\n#### Possible Causes\r\n* You cannot delete a Credential List that is still mapped to a SIP Domain.\r\n\r\n#### Possible Solutions\r\n* Remove the Credential List from any mapped SIP Domains before deleting.',
    causes: '* You cannot delete a Credential List that is still mapped to a SIP Domain.',
    solutions: '* Remove the Credential List from any mapped SIP Domains before deleting.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:34:01Z',
    last_updated: '2020-08-04T10:00:00.385Z',
  },
  52000: {
    code: 52000,
    message: 'Internal notification error',
    log_level: 'ERROR',
    secondary_message: 'Internal error is inside of notification services',
    log_type: null,
    docs: '## Error - 52000\r\n\r\n### Internal error\r\n\r\n#### Possible Causes \r\n*  An internal error has occurred that prevented Twilio from processing of your request.\r\n\r\n#### Possible Solutions\r\n* Check our [status page](http://status.twilio.com) to see if we are having an outage. \r\n* If our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T14:59:35Z',
    last_updated: '2020-08-04T10:00:22.522Z',
  },
  20403: {
    code: 20403,
    message: '403 Forbidden',
    log_level: 'ERROR',
    secondary_message: 'Forbidden',
    log_type: 'TWILIO',
    docs: '## ERROR - 20403\r\n\r\n### 403 Forbidden\r\n\r\nForbidden # Error - 20403\r\n\r\n## Forbidden\r\n\r\nThe account lacks permission to access the Twilio API. Typically this means\r\nthe account has been suspended or closed. For assistance, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).\r\n\r\n#### Possible Causes\r\nThe account has been suspended or closed.\r\n\r\n#### Possible Solutions\r\nReach out to Twilio Support.',
    causes: 'The account has been suspended or closed.',
    solutions: 'Reach out to Twilio Support.',
    description:
      '# Error - 20403\r\n\r\n## Forbidden\r\n\r\nThe account lacks permission to access the Twilio API. Typically this means\r\nthe account has been suspended or closed. For assistance, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    product: 'Platform',
    date_created: '2016-04-01T14:31:42Z',
    last_updated: '2023-11-01T04:37:52.239604Z',
  },
  14219: {
    code: 14219,
    message: 'TaskRouter Dial Queue not supported in this realm',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 14219\r\n\r\n### TaskRouter Dial Queue not supported in this realm\r\n\r\n TaskRouter Dial Queue not supported in this realm\r\n\r\n#### Possible Causes\r\nTaskRouter Dial Queue not supported in this realm\r\n\r\n#### Possible Solutions\r\nUse TaskRouter Dial Queue in supported realm',
    causes: 'TaskRouter Dial Queue not supported in this realm',
    solutions: 'Use TaskRouter Dial Queue in supported realm',
    description: 'TaskRouter Dial Queue not supported in this realm',
    product: 'Programmable Voice',
    date_created: '2020-08-13T16:28:41Z',
    last_updated: '2020-08-13T16:28:41Z',
  },
  54200: {
    code: 54200,
    message: 'Map not found',
    log_level: 'ERROR',
    secondary_message: 'The specified Map does not exist.',
    log_type: null,
    docs: "\n## Error - 54200\n\n### Sync: Map not found\nThe specified Map does not exist.\n\n#### Possible Causes\n* The supplied Sync Map SID is erroneous.\n* The requested Sync Map has been deleted.\n\n#### Possible Solutions\nConfirm that the map you're requesting exists, and that you are using the precise SID or unique name it is assigned.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.498Z',
  },
  19050: {
    code: 19050,
    message: 'Internal Server Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 19050\r\n\r\n### Internal Server Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nWe're having trouble completing your request \r\n\r\n#### Possible Solutions\r\nReach Customer Support or Try again later",
    causes: "We're having trouble completing your request ",
    solutions: 'Reach Customer Support or Try again later',
    description: null,
    product: null,
    date_created: '2020-07-21T20:38:09Z',
    last_updated: '2020-08-04T10:00:01.043Z',
  },
  14105: {
    code: 14105,
    message: 'Invalid statusCallback attribute',
    log_level: 'WARNING',
    secondary_message: "The Sms Verb's statusCallback attribute must be a valid URL",
    log_type: null,
    docs: "## Warning - 14105 \n\n### Message statusCallback attribute Invalid\n\nThe Message Verb's statusCallback attribute must be a valid URL\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:48Z',
    last_updated: '2020-08-04T10:00:27.604Z',
  },
  50512: {
    code: 50512,
    message: 'Message media size is too large',
    log_level: 'ERROR',
    secondary_message: 'The requested multimedia attachment size exceeds the allowed limit.',
    log_type: null,
    docs: '\n## Error - 50512\n\n### Conversations: Message media size is too large\nThe requested multimedia attachment size exceeds the allowed limit.\n\n#### Possible Causes\n* The size of multimedia attachment you are trying to send is not acceptable for this conversation.\n\n#### Possible Solutions\n* Make sure that the size of multimedia attachments co form to channel limitations. Check for media size constraints in [API documentation](https://www.twilio.com/docs/conversations/conversations-limits#media-limits).\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.262Z',
  },
  31480: {
    code: 31480,
    message: 'Temporarily Unavailable',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31480\r\n\r\n### Temporarily Unavailable\r\n\r\nThe callee is currently unavailable.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:37:50Z',
    last_updated: '2020-08-04T10:00:08.355Z',
  },
  30020: {
    code: 30020,
    message: 'Internal Failure with Message Scheduling',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 30020\r\n\r\n### Internal Failure with Message Scheduling\r\n\r\n An internal error has occurred with Message Scheduling that prevented Twilio from processing your request.\r\n\r\n#### Possible Causes\r\n* We screwed up. Sorry!\r\n\r\n#### Possible Solutions\r\n* If the error persists, please contact us to figure out what has happened and how to fix it.\r\n* Note the time of the error and what you were trying to do when it occurred.',
    causes: '* We screwed up. Sorry!',
    solutions:
      '* If the error persists, please contact us to figure out what has happened and how to fix it.\r\n* Note the time of the error and what you were trying to do when it occurred.',
    description:
      'An internal error has occurred with Message Scheduling that prevented Twilio from processing your request.',
    product: 'Programmable SMS',
    date_created: '2020-07-21T22:11:07Z',
    last_updated: '2022-06-29T19:31:30.394445Z',
  },
  80409: {
    code: 80409,
    message: 'Session Sid Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Session Sid',
    log_type: null,
    docs: '## Warning\n\n### Session Sid Invalid\n\nExample Message: Invalid Session Sid',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.883Z',
  },
  19025: {
    code: 19025,
    message: 'Channel validation error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19025\r\n\r\n### Channel validation error\r\n\r\n The request body has invalid inputs\r\n\r\n#### Possible Causes\r\nInvalid length, email or phone in invalid format\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'Invalid length, email or phone in invalid format',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'The request body has invalid inputs',
    product: null,
    date_created: '2020-07-21T20:18:05Z',
    last_updated: '2020-08-04T10:00:01.651Z',
  },
  404: {
    code: 404,
    message: 'Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 404\r\n\r\n### Not Found\r\n\r\n Failed to find a match for the request\r\n\r\n#### Possible Causes\r\n* The specified resource is no longer available.\r\n\r\n\r\n#### Possible Solutions\r\n* Check that the specified resource still exists.\r\n',
    causes: '* The specified resource is no longer available.\r\n',
    solutions: '* Check that the specified resource still exists.\r\n',
    description: 'Failed to find a match for the request',
    product: null,
    date_created: '2020-09-14T21:50:07Z',
    last_updated: '2020-09-14T21:50:07Z',
  },
  62014: {
    code: 62014,
    message: 'Connection not ready',
    log_level: 'ERROR',
    secondary_message:
      'The connection SID in the request is not fully configured. Please provide additional configuration info.  For a VPN connection, please provide IP Gateway and at least one IP route. ',
    log_type: null,
    docs: '## Error - 62014\r\n\r\n### Connection not ready\r\n\r\nThe connection SID in the request is not fully configured.  Please provide additional configuration info.  For a VPN connection, please provide IP Gateway and at least one IP route. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:41:28Z',
    last_updated: '2020-08-04T10:00:20.946Z',
  },
  90101: {
    code: 90101,
    message: 'Unique Name Already Exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90101\r\n\r\n### Unique Name Already Exists\r\n\r\n Unique name user created already exists\r\n\r\n#### Possible Causes\r\nA same unique name has been created before\r\n\r\n#### Possible Solutions\r\nChange to a new unique name',
    causes: 'A same unique name has been created before',
    solutions: 'Change to a new unique name',
    description: 'Unique name user created already exists',
    product: 'Understand',
    date_created: '2020-05-29T00:14:46Z',
    last_updated: '2020-08-04T10:00:02.935Z',
  },
  13110: {
    code: 13110,
    message: 'Annotate: Annotate must contain one valid nested element',
    log_level: 'ERROR',
    secondary_message: 'Annotate must contain one valid nested element',
    log_type: null,
    docs: '## Error - 13110 \n\n### Annotate: Annotate must contain one valid nested element\n\nAnnotate must contain one valid nested element\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:30Z',
    last_updated: '2020-08-04T10:00:29.078Z',
  },
  80505: {
    code: 80505,
    message: 'Flex Configuration Error',
    log_level: 'ERROR',
    secondary_message: 'A Flex component was not configured correctly',
    log_type: null,
    docs: '## Error\r\n\r\n### Flex Configuration Error\r\n\r\nA Flex component was not configured correctly.  Please reach out to Flex support.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2019-01-25T23:48:54Z',
    last_updated: '2020-08-04T10:00:11.011Z',
  },
  11200: {
    code: 11200,
    message: 'HTTP retrieval failure',
    log_level: 'ERROR',
    secondary_message:
      'Twilio’s servers were unable to fetch a non-error response from the designated URL.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 11200\r\n\r\n### HTTP retrieval failure\r\n\r\nTwilio’s servers were unable to fetch a non-error response from the designated URL. We try to provide specific webhook errors whenever possible, however in this instance we are unable to identify the exact cause of the webhook delivery/response issue. To prevent 11200 errors, ensure that your webhook receiving infrastructure can quickly respond to inbound Twilio requests with a 2xx status code.\r\n\r\n#### Possible Causes\r\n* Web server returned a 4xx or 5xx HTTP response to Twilio\r\n* Network disruptions between Twilio and your web server; these can be within your or Twilio’s infrastructure or wider disruptions to the internet at large.\r\n* Firewalls (network or application level) between Twilio and your infrastructure\r\n* Misconfigured Web Server\r\n* No Content-Type header attached to response\r\n* Content-Type doesn't match actual content, e.g. an MP3 file that is being served with Content-Type: audio/x-wav, instead of Content-Type: audio/mpeg\r\n\r\n\r\n#### Possible Solutions\r\n* Double check that your TwiML URL does not return a 4xx or 5xx error\r\n* Make certain that the URL does not perform a 302 redirect to an invalid URL\r\n* Confirm the URL requested is not protected by HTTP Auth\r\n* Make sure your web server allows HTTP POST requests to static resources (if the URL refers to .xml or .html files)\r\n* Verify your web server is up and responsive\r\n* Check to see that the URL host is not a private or local IP address\r\n* Verify the ping times and packet loss between your web server and api.twilio.com\r\n* Review firewall rules; modern web application firewalls can trigger on only a small subset of inbound connections leading to inconsistent behavior.\r\n* Check logs at the very edge of your infrastructure to verify if TCP connection attempts are arriving at your edge. If you have confirmed these requests are not reaching your infrastructure, please reach out to [support](https://www.twilio.com/console/support/tickets/create).\r\n* Use more robust options for webhook receipt. For inbound messages and calls be sure to provide a fallback URL (ideally on separate infrastructure). Transition integrations to [Event Streams](https://www.twilio.com/docs/events) which has various event sink types including webhooks with built in retries.\r\n* Review your use of any [webhook connection overrides](https://www.twilio.com/docs/usage/webhooks/webhooks-connection-overrides). In general the defaults provide the best results, start by reconfiguring your webhook URL without any fragment overrides and see if the problem persists.\r\n* If synchronously processing a webhook requires significant time, we recommend that you simply acknowledge the event by quickly responding with an empty 202 (Accepted) and then processing the message on your own timeline. Replies to inbound message events can be done at any time by making a call to the REST API.\r\n",
    causes:
      "* Web server returned a 4xx or 5xx HTTP response to Twilio\r\n* Network disruptions between Twilio and your web server; these can be within your or Twilio’s infrastructure or wider disruptions to the internet at large.\r\n* Firewalls (network or application level) between Twilio and your infrastructure\r\n* Misconfigured Web Server\r\n* No Content-Type header attached to response\r\n* Content-Type doesn't match actual content, e.g. an MP3 file that is being served with Content-Type: audio/x-wav, instead of Content-Type: audio/mpeg\r\n",
    solutions:
      '* Double check that your TwiML URL does not return a 4xx or 5xx error\r\n* Make certain that the URL does not perform a 302 redirect to an invalid URL\r\n* Confirm the URL requested is not protected by HTTP Auth\r\n* Make sure your web server allows HTTP POST requests to static resources (if the URL refers to .xml or .html files)\r\n* Verify your web server is up and responsive\r\n* Check to see that the URL host is not a private or local IP address\r\n* Verify the ping times and packet loss between your web server and api.twilio.com\r\n* Review firewall rules; modern web application firewalls can trigger on only a small subset of inbound connections leading to inconsistent behavior.\r\n* Check logs at the very edge of your infrastructure to verify if TCP connection attempts are arriving at your edge. If you have confirmed these requests are not reaching your infrastructure, please reach out to [support](https://www.twilio.com/console/support/tickets/create).\r\n* Use more robust options for webhook receipt. For inbound messages and calls be sure to provide a fallback URL (ideally on separate infrastructure). Transition integrations to [Event Streams](https://www.twilio.com/docs/events) which has various event sink types including webhooks with built in retries.\r\n* Review your use of any [webhook connection overrides](https://www.twilio.com/docs/usage/webhooks/webhooks-connection-overrides). In general the defaults provide the best results, start by reconfiguring your webhook URL without any fragment overrides and see if the problem persists.\r\n* If synchronously processing a webhook requires significant time, we recommend that you simply acknowledge the event by quickly responding with an empty 202 (Accepted) and then processing the message on your own timeline. Replies to inbound message events can be done at any time by making a call to the REST API.\r\n',
    description:
      'We try to provide specific webhook errors whenever possible, however in this instance we are unable to identify the exact cause of the webhook delivery/response issue. To prevent 11200 errors, ensure that your webhook receiving infrastructure can quickly respond to inbound Twilio requests with a 2xx status code.',
    product: null,
    date_created: '2016-03-31T17:13:23Z',
    last_updated: '2023-08-23T07:59:41.134484Z',
  },
  51111: {
    code: 51111,
    message: 'Twilsock: Service instance limit reached',
    log_level: 'ERROR',
    secondary_message: 'Service instance limit has been reached for the specified account.',
    log_type: null,
    docs: "## Error - 51111\r\n\r\n### Service instance limit has been reached\r\n\r\n#### Possible Causes \r\nService instance limit has been reached for the specified account.\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's service Instance limits.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:46:23Z',
    last_updated: '2020-08-04T10:00:09.736Z',
  },
  21224: {
    code: 21224,
    message: 'Invalid SipAuthPassword. Illegal chars',
    log_level: 'WARNING',
    secondary_message: 'The SipAuthUsername you specified contained characters not allowed in SIP.',
    log_type: null,
    docs: '## Warning - 21224\n\n### Invalid SipAuthPassword. Illegal chars\n\nThe SipAuthUsername you specified contained characters not allowed in SIP.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:18Z',
    last_updated: '2020-08-04T10:00:25.694Z',
  },
  52306: {
    code: 52306,
    message: 'Cannot delete User resource with Bindings',
    log_level: 'ERROR',
    secondary_message: 'User cannot be deleted if it has at least one Binding',
    log_type: null,
    docs: '## Error - 52306\r\n\r\n### Cannot delete User resource with Bindings\r\n\r\n#### Possible Causes \r\n*  User has at least one Binding.\r\n\r\n#### Possible Solutions\r\n*  Make sure you delete all Bindings of a User before you try to delete the User.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-05-24T08:49:50Z',
    last_updated: '2020-08-04T10:00:18.439Z',
  },
  32203: {
    code: 32203,
    message: 'SIP: Call blocked by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32203\r\n\r\n### SIP: Call blocked by Twilio\r\n\r\n The destination number is blocked by Twilio.\r\n\r\n#### Possible Causes\r\nThe destination has a high-risk of fraud or due to regulatory reasons cannot be reached.\r\n\r\n#### Possible Solutions\r\nIf you have a legitimate need to call this number, please reach out to our [support team](https://support.twilio.com/hc/en-us). ',
    causes:
      'The destination has a high-risk of fraud or due to regulatory reasons cannot be reached.',
    solutions:
      'If you have a legitimate need to call this number, please reach out to our [support team](https://support.twilio.com/hc/en-us). ',
    description: 'The destination number is blocked by Twilio.',
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:38Z',
    last_updated: '2023-09-26T23:08:55.906721Z',
  },
  60330: {
    code: 60330,
    message: 'Failed to invoke the webhook',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60330\r\n\r\n### Failed to invoke the webhook\r\n\r\n HTTP status: 400\r\n\r\n#### Possible Causes\r\n- Unable to access the `webhook` **URL**\r\n- The `webhook` is allowing **HTTP** requests other than **POST**\r\n- The `webhook` is responding with a status code other than **200** (OK)\r\n\r\n#### Possible Solutions\r\n- Make sure the `webhook` **URL** is reachable\r\n- Remember the `webhook` must allow **HTTP POST** requests\r\n- Make sure the  `webhook` is responding with status code **200** when everything is going well',
    causes:
      '- Unable to access the `webhook` **URL**\r\n- The `webhook` is allowing **HTTP** requests other than **POST**\r\n- The `webhook` is responding with a status code other than **200** (OK)',
    solutions:
      '- Make sure the `webhook` **URL** is reachable\r\n- Remember the `webhook` must allow **HTTP POST** requests\r\n- Make sure the  `webhook` is responding with status code **200** when everything is going well',
    description: 'HTTP status: 400',
    product: 'Verify',
    date_created: '2020-07-27T15:07:28Z',
    last_updated: '2021-06-30T03:47:35.359473Z',
  },
  13810: {
    code: 13810,
    message: 'Reject: Invalid cause',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13810\r\n\r\n### Reject: Invalid cause\r\n\r\n A call is rejected for any reason other than Busy or Hangup\r\n\r\n#### Possible Causes\r\nCould be timeout, cancelled, or no-answer.\r\n\r\n#### Possible Solutions\r\nCheck application call timeout duration.',
    causes: 'Could be timeout, cancelled, or no-answer.',
    solutions: 'Check application call timeout duration.',
    description: 'A call is rejected for any reason other than Busy or Hangup',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:42:12Z',
    last_updated: '2020-08-04T10:00:04.427Z',
  },
  52136: {
    code: 52136,
    message: 'Missing payload for APNs delivery',
    log_level: 'ERROR',
    secondary_message: 'Payload must be provided to send notification over APNs',
    log_type: null,
    docs: '## Error - 52136\r\n\r\n### Missing payload for APNs delivery\r\n\r\n#### Possible Causes \r\n*  APNs delivery had no payload.\r\n\r\n#### Possible Solutions\r\n*  Make sure to provide a payload using at least one of Body, Sound, Action, Data or Aps parameters.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:36:38Z',
    last_updated: '2020-08-04T10:00:22.122Z',
  },
  50326: {
    code: 50326,
    message: 'Programmable Chat: Invalid channel webhook trigger',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correct parameter for webhook trigger',
    log_type: null,
    docs: '## Error - 50326\r\n\r\n### Programmable Chat: Invalid channel webhook trigger\r\n\r\n#### Possible Causes \r\n*  Request does not contain correct parameter for channel webhook trigger.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T15:53:29Z',
    last_updated: '2020-08-04T10:00:12.038Z',
  },
  50405: {
    code: 50405,
    message: 'Programmable Chat: Invalid last consumption timestamp format',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for last consumption timestamp',
    log_type: null,
    docs: '## Error - 50405\r\n\r\n### Programmable Chat: Invalid last consumption timestamp format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for last consumption timestamp\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:17:03Z',
    last_updated: '2020-08-04T10:00:16.595Z',
  },
  14203: {
    code: 14203,
    message: 'Enqueue: Invalid Enqueue action url',
    log_level: 'ERROR',
    secondary_message:
      'The action URL for the Enqueue verb is invalid.  #### Possible Solutions  Make sure you submit a fully qualified URL including:  *   protocol (http:// or https://) *   hostname *   file path *   properly url-encoded query parameters  Twilio must be able to reach this URL over the public Internet.',
    log_type: null,
    docs: '## Error - 14203\n\n### Enqueue: Invalid Enqueue action url\n\nThe action URL for the Enqueue verb is invalid.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:10Z',
    last_updated: '2020-08-04T10:00:26.312Z',
  },
  53625: {
    code: 53625,
    message: 'Access denied to external S3 bucket configured in composition settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53625\r\n\r\n### Access denied to external S3 bucket configured in composition settings\r\n\r\nFailed to upload media to the external S3 bucket configured in your account's composition settings.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the configuration is out of date.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-11T14:40:15Z',
    last_updated: '2020-08-04T10:00:13.417Z',
  },
  31487: {
    code: 31487,
    message: 'Request Terminated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31487\r\n\r\n### Request Terminated\r\n\r\nThe request has terminated as a result of a bye or cancel.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:41:43Z',
    last_updated: '2020-08-04T10:00:08.29Z',
  },
  60006: {
    code: 60006,
    message: 'Invalid Phone Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60006\r\n\r\n### Invalid Phone Number\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received and failed during processing because a downstream provider indicated that the phone number is invalid, although the phone number formatting was valid. This can happen when the end user provides an invalid phone number in error, the phone number is deactivated, suspended, or in the grace period before reassignment, or a fraudulent user purposefully uses an invalid phone number.\r\n\r\n#### Possible Solutions\r\n- Check that the phone number provided is correct.\r\n- If using Silent Network Auth, retry Verification using a channel not based on phone number such as email.',
    causes:
      'The request was received and failed during processing because a downstream provider indicated that the phone number is invalid, although the phone number formatting was valid. This can happen when the end user provides an invalid phone number in error, the phone number is deactivated, suspended, or in the grace period before reassignment, or a fraudulent user purposefully uses an invalid phone number.',
    solutions:
      '- Check that the phone number provided is correct.\r\n- If using Silent Network Auth, retry Verification using a channel not based on phone number such as email.',
    description: null,
    product: null,
    date_created: '2022-09-06T13:16:11.053933Z',
    last_updated: '2022-09-06T13:16:11.053946Z',
  },
  22115: {
    code: 22115,
    message: 'Invalid Unique Name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22115\r\n\r\n#### Invalid Unique Name\r\n\r\nThe unique name must be a string that does not exceed a length of 128 characters.\r\n\r\n#### Possible Solutions\r\n\r\n* Confirm that your unique name is a string that does not exceed 128 characters.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-07T05:09:08Z',
    last_updated: '2020-08-04T10:00:14.991Z',
  },
  30450: {
    code: 30450,
    message: 'Message delivery blocked',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30450\r\n\r\n### Message delivery blocked\r\n\r\n The destination number you are trying to reach is temporarily blocked from receiving this message.\r\n\r\n#### Possible Causes\r\nThis is because the SMS Pumping Protection feature has identified potential fraudulent messages being sent to the destination you are trying to reach.\r\n\r\nA temporary block on SMS traffic has been placed for the next 15-30 mins on the phone number you used. This block will be lifted at the end of this 15-30 minutes period. If further fraudulent activity is detected after this block, this pattern will continue with temporary 15-30 minutes blocks until the issue is no longer observed.\r\n\r\n#### Possible Solutions\r\nYou do not need to take any specific action. The disruption in traffic is usually temporary and will resolve in a couple of hours if we do not detect additional fraudulent activity.\r\n\r\n#### Continued issues with error 30450\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30453, and [open a support request.](https://www.twilio.com/console/support/tickets/create)\r\n\r\nAlternatively, you can use the optional <code style="color : name_color">RiskCheck</code> parameter when [creating a Message](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource) with the [Programmable Messaging API](https://www.twilio.com/docs/messaging/api). To prevent a known/legitimate message from getting blocked in future by SMS Pumping Protection, include the <code style="color : name_color">RiskCheck</code> parameter with value <code style="color : name_color">disable</code> when creating the new Message resource.\r\n\r\nYou can also mark known/legitimate phone numbers using the Global Safe List feature so that they don’t face any disruption . This provides an additional safety net against false positives, so that the traffic to this number never faces the above scenario. Add known phone numbers to the Safe List by using the [Global Safe List API.](https://www.twilio.com/docs/usage/global-safe-list)',
    causes:
      'This is because the SMS Pumping Protection feature has identified potential fraudulent messages being sent to the destination you are trying to reach.\r\n\r\nA temporary block on SMS traffic has been placed for the next 15-30 mins on the phone number you used. This block will be lifted at the end of this 15-30 minutes period. If further fraudulent activity is detected after this block, this pattern will continue with temporary 15-30 minutes blocks until the issue is no longer observed.',
    solutions:
      'You do not need to take any specific action. The disruption in traffic is usually temporary and will resolve in a couple of hours if we do not detect additional fraudulent activity.\r\n\r\n#### Continued issues with error 30450\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30453, and [open a support request.](https://www.twilio.com/console/support/tickets/create)\r\n\r\nAlternatively, you can use the optional <code style="color : name_color">RiskCheck</code> parameter when [creating a Message](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource) with the [Programmable Messaging API](https://www.twilio.com/docs/messaging/api). To prevent a known/legitimate message from getting blocked in future by SMS Pumping Protection, include the <code style="color : name_color">RiskCheck</code> parameter with value <code style="color : name_color">disable</code> when creating the new Message resource.\r\n\r\nYou can also mark known/legitimate phone numbers using the Global Safe List feature so that they don’t face any disruption . This provides an additional safety net against false positives, so that the traffic to this number never faces the above scenario. Add known phone numbers to the Safe List by using the [Global Safe List API.](https://www.twilio.com/docs/usage/global-safe-list)',
    description:
      'The destination number you are trying to reach is temporarily blocked from receiving this message.',
    product: 'Programmable SMS',
    date_created: '2023-04-05T02:54:53Z',
    last_updated: '2024-01-16T13:29:42.844793Z',
  },
  21479: {
    code: 21479,
    message: 'Unable to update Status for subaccount, subaccount has been closed.',
    log_level: 'ERROR',
    secondary_message:
      'Unable to update Status for subaccount, subaccount is closed and can not be re-opened.',
    log_type: null,
    docs: '## Error - 21479\n\n### Unable to update Status for subaccount, subaccount has been closed.\n\nUnable to update Status for subaccount, subaccount is closed and can not be re-opened.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:24Z',
    last_updated: '2020-08-04T10:00:25.173Z',
  },
  32015: {
    code: 32015,
    message: 'Call is terminated due to exceeding maximum call duration',
    log_level: 'WARNING',
    secondary_message: 'Session-Timeout',
    log_type: 'APPLICATION',
    docs: '## WARNING - 32015\r\n\r\n### Call is terminated due to exceeding maximum call duration\r\n\r\nSession-Timeout ## Warning - 32015\r\n\r\nCall is terminated due to exceeding maximum call duration\r\n\r\n\r\n#### Possible Causes\r\nMaximum call duration as been exceeded.\r\n\r\n#### Possible Solutions\r\nPlease reduce call duration or adjust account configurable timeLimits.',
    causes: 'Maximum call duration as been exceeded.',
    solutions: 'Please reduce call duration or adjust account configurable timeLimits.',
    description:
      '## Warning - 32015\r\n\r\nCall is terminated due to exceeding maximum call duration\r\n',
    product: 'Programmable Voice',
    date_created: '2017-08-24T16:40:34Z',
    last_updated: '2021-03-11T17:57:16.707Z',
  },
  30010: {
    code: 30010,
    message: 'Message price exceeds max price',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30010\r\n\r\n### Message price exceeds max price\r\n\r\n ## Error - 30010\r\n\r\n### Message price exceeds Max Price\r\n\r\nYou provided the [MaxPrice parameter](https://support.twilio.com/hc/en-us/articles/360014170533-Using-MaxPrice-with-Twilio-SMS) in your API request. MaxPrice will prevent a message from sending if it exceeds the price you specified.\r\n\r\nPlease note that SMS pricing is per-segment. SMS messages longer than 160 characters (or longer than 70 characters, if emojis or special characters are used) will require multiple segments. For a detailed explanation of message segmentation and encoding, see [What the Heck is a Segment?](https://www.twilio.com/blog/what-the-heck-is-a-segment.html).\r\n\r\n#### Possible Causes\r\n* The message price exceeded the MaxPrice you specified in your API request.\r\n\r\n#### Possible Solutions\r\n* Increase the MaxPrice parameter value in your API requests.\r\n* Remove the MaxPrice parameter from your API requests.\r\n* Check your message body for any Unicode-only characters such as emojis, glyphs, or curly apostrophes or quotation marks which could cause the message to require additional segments.\r\n* Consider using the [Smart Encoding](https://www.twilio.com/docs/messaging/services#smart-encoding) feature of [Messaging Services](https://www.twilio.com/docs/messaging/services) to automatically replace [certain Unicode-only characters](https://www.twilio.com/docs/messaging/services/smart-encoding-char-list) with standard GSM equivalents.',
    causes: '* The message price exceeded the MaxPrice you specified in your API request.',
    solutions:
      '* Increase the MaxPrice parameter value in your API requests.\r\n* Remove the MaxPrice parameter from your API requests.\r\n* Check your message body for any Unicode-only characters such as emojis, glyphs, or curly apostrophes or quotation marks which could cause the message to require additional segments.\r\n* Consider using the [Smart Encoding](https://www.twilio.com/docs/messaging/services#smart-encoding) feature of [Messaging Services](https://www.twilio.com/docs/messaging/services) to automatically replace [certain Unicode-only characters](https://www.twilio.com/docs/messaging/services/smart-encoding-char-list) with standard GSM equivalents.',
    description:
      '## Error - 30010\r\n\r\n### Message price exceeds Max Price\r\n\r\nYou provided the [MaxPrice parameter](https://support.twilio.com/hc/en-us/articles/360014170533-Using-MaxPrice-with-Twilio-SMS) in your API request. MaxPrice will prevent a message from sending if it exceeds the price you specified.\r\n\r\nPlease note that SMS pricing is per-segment. SMS messages longer than 160 characters (or longer than 70 characters, if emojis or special characters are used) will require multiple segments. For a detailed explanation of message segmentation and encoding, see [What the Heck is a Segment?](https://www.twilio.com/blog/what-the-heck-is-a-segment.html).',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:36Z',
    last_updated: '2023-07-31T21:48:48.731942Z',
  },
  21610: {
    code: 21610,
    message: 'Unsubscribed recipient',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21610\r\n\r\n### Attempt to send to unsubscribed recipient\r\n\r\n The person you are trying to message has opted out of receiving messages from your Twilio phone number, Channels sender, or Messaging Service.\r\n\r\nYou have attempted to message a \'To\' number that has replied with "STOP" to one of your previous messages. You will not be able to send to the phone number specified in the \'To\' parameter until the subscriber identified by the phone number has responded with "START". \r\n\r\nPlease see [this FAQ](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) for more information about how Twilio handles opt-out and opt-in.\r\n\r\n#### Possible Causes\r\n* The end user handset has responded with "STOP" or [another opt-out keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-).\r\n\r\n\r\n#### Possible Solutions\r\n* Consider removing this phone number from your list of recipients.\r\n* Request the recipient to resubscribe to your messages by texting in "START" or [another opt-in keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) to your Twilio sender.\r\n* Before sending messages to a recipient, ensure they have consented to receive messages from you. Please read these guidelines to understand [messaging opt-in requirements and best practices](https://www.twilio.com/blog/ctia-messaging-principles-and-best-practices).',
    causes:
      '* The end user handset has responded with "STOP" or [another opt-out keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-).\r\n',
    solutions:
      '* Consider removing this phone number from your list of recipients.\r\n* Request the recipient to resubscribe to your messages by texting in "START" or [another opt-in keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) to your Twilio sender.\r\n* Before sending messages to a recipient, ensure they have consented to receive messages from you. Please read these guidelines to understand [messaging opt-in requirements and best practices](https://www.twilio.com/blog/ctia-messaging-principles-and-best-practices).',
    description:
      'The person you are trying to message has opted out of receiving messages from your Twilio phone number, Channels sender, or Messaging Service.\r\n\r\nYou have attempted to message a \'To\' number that has replied with "STOP" to one of your previous messages. You will not be able to send to the phone number specified in the \'To\' parameter until the subscriber identified by the phone number has responded with "START". \r\n\r\nPlease see [this FAQ](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) for more information about how Twilio handles opt-out and opt-in.',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:25Z',
    last_updated: '2020-08-04T10:00:25.116Z',
  },
  22170: {
    code: 22170,
    message: 'Port In Error - Invalid Bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22170\r\n\r\n### Port In Error - Invalid Bundle\r\n\r\n Given Bundle SID does not exist for your account or is not approved.\r\n\r\n#### Possible Causes\r\nThe Bundle SID does not exist or is not approved yet.\r\n\r\n#### Possible Solutions\r\nUpdate the Bundle SID to one that exists or is approved.',
    causes: 'The Bundle SID does not exist or is not approved yet.',
    solutions: 'Update the Bundle SID to one that exists or is approved.',
    description: 'Given Bundle SID does not exist for your account or is not approved.',
    product: 'Phone Numbers',
    date_created: '2024-05-03T16:58:30Z',
    last_updated: '2024-05-03T16:58:30Z',
  },
  21451: {
    code: 21451,
    message: 'Invalid area code',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to get a phone number for your account, but the <span class='rest-attribute'>AreaCode</span> parameter you specified was not a valid North American area code.  <span class='rest-attribute'>AreaCode</span> is optional, and for Local phone numbers, may be any US or Canadian area code, or for TollFree numbers, may be one of 800,888,877 or 866.",
    log_type: null,
    docs: "## Error - 21451 \n\n### Invalid area code\n\nYou attempted to get a phone number for your account, but the <span class='rest-attribute'>AreaCode</span> parameter you specified was not a valid North American area code.  <span class='rest-attribute'>AreaCode</span> is optional, and for Local phone numbers, may be any US or Canadian area code, or for TollFree numbers, may be one of 800,888,877 or 866.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:00Z',
    last_updated: '2020-08-04T10:00:26.927Z',
  },
  53614: {
    code: 53614,
    message: 'Public key credentials for media tracks encryption could not be loaded',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53614\r\n\r\n### Public key credentials for media tracks encryption could not be loaded\r\n\r\nThe public key credentials configured in your account's recording settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect raw media tracks, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, create and assign a new valid public key or disable the encryption (media will be uploaded in raw).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-05-24T13:36:47Z',
    last_updated: '2020-08-04T10:00:13.606Z',
  },
  60376: {
    code: 60376,
    message: 'Invalid rawId',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60376\r\n\r\n### Invalid rawId\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe RawID in the request is incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the RawID in the request body is correct.',
    causes: 'The RawID in the request is incorrectly formatted.',
    solutions: 'Check that the RawID in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:39:06Z',
    last_updated: '2023-12-27T09:39:06Z',
  },
  50006: {
    code: 50006,
    message: 'Programmable Chat: Invalid Account SID',
    log_level: 'ERROR',
    secondary_message: 'Specified Account SID does not match pattern "AC[0-9a-f]{32}"',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50006\r\n\r\n### Programmable Chat: Invalid Account SID\r\n\r\nSpecified Account SID does not match pattern "AC[0-9a-f]{32}" \r\n\r\n#### Possible Causes\r\nAccount SID in request does not match pattern "AC[0-9a-f]{32}".\r\n\r\n#### Possible Solutions\r\nConfirm a valid Account SID is being passed in request and matches pattern "AC[0-9a-f]{32}". ',
    causes: 'Account SID in request does not match pattern "AC[0-9a-f]{32}".',
    solutions:
      'Confirm a valid Account SID is being passed in request and matches pattern "AC[0-9a-f]{32}". ',
    description: 'Invalid Account SID',
    product: 'Programmable Chat',
    date_created: '2022-02-10T13:31:32Z',
    last_updated: '2022-02-10T13:44:07.309266Z',
  },
  18020: {
    code: 18020,
    message: 'Address mismatch',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18020\r\n\r\n### Address mismatch\r\n\r\n The address you have provided does not match exactly with the supporting document.\r\n\r\n#### Possible Causes\r\nThere may be a typo when submitting the address information.\r\n\r\n#### Possible Solutions\r\nPlease amend the data entered in the Address fields to match exactly the address in the documents you have provided.',
    causes: 'There may be a typo when submitting the address information.',
    solutions:
      'Please amend the data entered in the Address fields to match exactly the address in the documents you have provided.',
    description:
      'The address you have provided does not match exactly with the supporting document.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:12:44Z',
    last_updated: '2024-07-04T10:12:44Z',
  },
  50209: {
    code: 50209,
    message: 'Programmable Chat: Invalid binding type',
    log_level: 'ERROR',
    secondary_message: 'Specified binding type does not exist.',
    log_type: null,
    docs: '## Error - 50209\r\n\r\n### Programmable Chat: Invalid binding type\r\n\r\n#### Possible Causes \r\n*  Specified binding type does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid binding type is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T11:43:58Z',
    last_updated: '2020-08-04T10:00:16.688Z',
  },
  90001: {
    code: 90001,
    message: 'Message SID is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90001\r\n\r\n### Message SID is invalid\r\n\r\n An invalid message SID has been sent in the request\r\n\r\n#### Possible Causes\r\nMessage SID sent in the request has either wrong prefix or incorrect format\r\n\r\n#### Possible Solutions\r\nProvide correct message SID in the request',
    causes: 'Message SID sent in the request has either wrong prefix or incorrect format',
    solutions: 'Provide correct message SID in the request',
    description: 'An invalid message SID has been sent in the request',
    product: 'Programmable SMS',
    date_created: '2021-03-05T11:30:15Z',
    last_updated: '2021-03-05T11:30:15Z',
  },
  90011: {
    code: 90011,
    message: 'MessageSid is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90011\r\n\r\n### MessageSid is invalid\r\n\r\n MessageSid is invalid\r\n\r\n#### Possible Causes\r\nMessageSid has incorrect sid format or prefix (SM and MM allowed)\r\n\r\n#### Possible Solutions\r\nUse correct MessageSid. Example `SMec8e12b0a5eb4fc68e173f1c5db95b2a`',
    causes: 'MessageSid has incorrect sid format or prefix (SM and MM allowed)',
    solutions: 'Use correct MessageSid. Example `SMec8e12b0a5eb4fc68e173f1c5db95b2a`',
    description: 'MessageSid is invalid',
    product: null,
    date_created: '2020-12-11T08:31:49Z',
    last_updated: '2020-12-11T08:31:49Z',
  },
  62010: {
    code: 62010,
    message: 'No authentication was provided.',
    log_level: 'ERROR',
    secondary_message:
      'An attempt was made to access a restricted resource without proper authorization. Provide authentication details and try again.',
    log_type: null,
    docs: '## Error - 62010\r\n\r\n### No authentication was provided.\r\n\r\nAn attempt was made to access a restricted resource without proper\r\nauthorization. Provide authentication details and try again.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:39:06Z',
    last_updated: '2020-08-04T10:00:21.017Z',
  },
  62002: {
    code: 62002,
    message: 'Exchange not found',
    log_level: 'ERROR',
    secondary_message: 'The exchange SID in the request could not be found.',
    log_type: null,
    docs: '## Error - 62002\r\n\r\n### Exchange not found\r\n\r\nThe exchange SID in the request could not be found.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:33:35Z',
    last_updated: '2020-08-04T10:00:21.183Z',
  },
  32212: {
    code: 32212,
    message: 'SIP: Registration Authentication problem',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: "## Error - 32212\r\n\r\n### Registration Authentication problem\r\n\r\n#### Possible Causes \r\n\r\nA SIP Endpoint tried to register with this SIP Domain and there isn't a Credential List mapped.\r\n#### Possible Solutions\r\n\r\nPlease map a Credential List to the Registration Authentication part of the SIP Domain",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-11-15T21:50:24Z',
    last_updated: '2020-08-04T10:00:20.449Z',
  },
  52051: {
    code: 52051,
    message: 'Internal error when sending notification via client connection',
    log_level: 'ERROR',
    secondary_message:
      'An unexpected error has happened in notification flow via realtime client connection',
    log_type: null,
    docs: '## Error - 52051\r\n\r\n### Internal error when sending notification via client connection\r\n\r\n#### Possible Causes \r\n*  Our client connection gateway is potentially unavailable. We apologize.\r\n\r\n#### Possible Solutions\r\n* Check our [status page](http://status.twilio.com) to see if we are having an outage. \r\n* If our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:02:09Z',
    last_updated: '2020-08-04T10:00:22.469Z',
  },
  45102: {
    code: 45102,
    message: 'Collision On Configuration Change',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45102\r\n\r\n### Collision On Configuration Change\r\n\r\n \r\n\r\n#### Possible Causes\r\nConfiguration for the same account was changed by other request mostly at the same time.\r\n\r\n#### Possible Solutions\r\nTry to update the configuration again.',
    causes:
      'Configuration for the same account was changed by other request mostly at the same time.',
    solutions: 'Try to update the configuration again.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:55:12Z',
    last_updated: '2020-08-04T10:00:12.375Z',
  },
  52174: {
    code: 52174,
    message: 'Unexpected error response received for Webhook Credentials request',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52174\r\n\r\n### Unexpected error response received for Webhook Credentials request\r\n\r\n#### Possible Causes \r\n* Your token endpoint responded with an unexpected error\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-04-04T09:57:36Z',
    last_updated: '2020-08-04T10:00:14.094Z',
  },
  21480: {
    code: 21480,
    message: 'Reached maximum number of subaccounts',
    log_level: 'ERROR',
    secondary_message:
      'Reached maximum number of subaccounts, please contact [Twilio](/help) if you want to create more subaccounts.',
    log_type: null,
    docs: '## Error - 21480\n\n### Reached maximum number of subaccounts\n\nReached maximum number of subaccounts, please contact [Twilio](/help) if you want to create more subaccounts.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:25Z',
    last_updated: '2020-08-04T10:00:25.155Z',
  },
  60520: {
    code: 60520,
    message: 'SNA URL Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60520\r\n\r\n### SNA URL Failed\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received and failed due to an error related to invoking the SNA URL.\r\n\r\n#### Possible Solutions\r\n- Retry Verification using a channel other than Silent Network Auth for this end user.\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    causes:
      'The Verification request was received and failed due to an error related to invoking the SNA URL.',
    solutions:
      '- Retry Verification using a channel other than Silent Network Auth for this end user.\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T16:52:54Z',
    last_updated: '2022-08-30T16:52:54Z',
  },
  81013: {
    code: 81013,
    message: 'Failed to invoke Understand API',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81013\r\n\r\n### Failed to invoke Understand API\r\nStudio was unable to invoke the Understand API while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Understand API failed.\r\n* Invalid values were passed to the Understand API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:17:15Z',
    last_updated: '2020-08-04T10:00:13.06Z',
  },
  31903: {
    code: 31903,
    message: 'Stream - WebSocket - Connection Broken Pipe',
    log_level: 'ERROR',
    secondary_message: 'The WebSocket connection has been abruptly closed by the server',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31903\r\n\r\n### Stream - WebSocket - Connection Broken Pipe\r\n\r\nThe WebSocket connection has been abruptly closed by the server \r\n\r\n#### Possible Causes\r\n* WebSocket server is down\r\n* WebSocket server has experienced a problem causing the connection to close\r\n* Connection has been lost\r\n* End of stream is found. This happens when the socket has been closed by the Server leaving the websocket in an inconsistent state. The error is fired when the Streamer tries to read or write in a closed TCP socket.\r\n\r\n#### Possible Solutions\r\n* Verify server process is up and running\r\n* Verify if there is any related connection error in the server logs\r\n* Verify the server is connected and intermediate elements are routing traffic',
    causes:
      '* WebSocket server is down\r\n* WebSocket server has experienced a problem causing the connection to close\r\n* Connection has been lost\r\n* End of stream is found. This happens when the socket has been closed by the Server leaving the websocket in an inconsistent state. The error is fired when the Streamer tries to read or write in a closed TCP socket.',
    solutions:
      '* Verify server process is up and running\r\n* Verify if there is any related connection error in the server logs\r\n* Verify the server is connected and intermediate elements are routing traffic',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:43:10Z',
    last_updated: '2021-02-01T15:49:13.191Z',
  },
  13322: {
    code: 13322,
    message: 'Gather->Say: Invalid loop value',
    log_level: 'WARNING',
    secondary_message:
      "The value of the loop attribute must be an integer greater or equal to zero.  See the <a href='/docs/api/twiml/say#loop'>Say Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13322 \n\n### Gather->Say: Invalid loop value\n\nThe value of the loop attribute must be an integer greater or equal to zero.  See the <a href='/docs/api/twiml/say#loop'>Say Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:41Z',
    last_updated: '2020-08-04T10:00:28.046Z',
  },
  19047: {
    code: 19047,
    message: 'Field definition name cannot be empty',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19047\r\n\r\n### Field definition name cannot be empty\r\n\r\n Input field name cannot be empty\r\n\r\n#### Possible Causes\r\nAttempt to create custom field definition with empty value\r\n\r\n#### Possible Solutions\r\nUpdate the input request field with valid name',
    causes: 'Attempt to create custom field definition with empty value',
    solutions: 'Update the input request field with valid name',
    description: 'Input field name cannot be empty',
    product: 'Contacts',
    date_created: '2020-08-17T18:23:43Z',
    last_updated: '2020-08-31T06:05:52.398Z',
  },
  45600: {
    code: 45600,
    message: 'Flex UI error',
    log_level: 'ERROR',
    secondary_message: 'Error thrown by Flex UI.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 45600\r\n\r\n### Flex UI error\r\n\r\nError thrown by Flex UI. Flex UI instance experienced a thrown Flex UI Error\r\nA JavaScript error has occurred within Flex UI.\r\n\r\n#### Possible Causes\r\n* There may have been an issue initializing Flex UI (no network, wrong config)\r\n* There may be an error happening in Flex UI code\r\n* There may be an error happening in user's custom code/plugin\r\n\r\n#### Possible Solutions\r\n* Fix custom code\r\n* Fix configuration",
    causes:
      "* There may have been an issue initializing Flex UI (no network, wrong config)\r\n* There may be an error happening in Flex UI code\r\n* There may be an error happening in user's custom code/plugin",
    solutions: '* Fix custom code\r\n* Fix configuration',
    description:
      'Flex UI instance experienced a thrown Flex UI Error\r\nA JavaScript error has occurred within Flex UI.',
    product: 'Flex',
    date_created: '2020-11-26T14:31:02Z',
    last_updated: '2021-04-29T18:10:47.715Z',
  },
  32505: {
    code: 32505,
    message: 'Voice Conversation: Invalid data inside existing conversation.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32505\r\n\r\n### Voice Conversation: Invalid data inside existing conversation.\r\n\r\n Invalid data inside existing conversation.\r\n\r\n#### Possible Causes\r\n- Certain data was wrong when the Conversation was created or when the participants were added.\r\n\r\n#### Possible Solutions\r\n- Delete this Conversation using the Conversation API.',
    causes:
      '- Certain data was wrong when the Conversation was created or when the participants were added.',
    solutions: '- Delete this Conversation using the Conversation API.',
    description: 'Invalid data inside existing conversation.',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:40:54Z',
    last_updated: '2022-07-29T16:35:04.832523Z',
  },
  13254: {
    code: 13254,
    message: 'Dial->Sip: SIP URI DNS does not resolve or resolves to an non-public IP address',
    log_level: 'WARNING',
    secondary_message:
      'Please check your DNS record to ensure it is properly configured. Alternatively, you can use a specific public IP address in your URI rather than specifying a domain.',
    log_type: null,
    docs: '## Warning - 13254\n\n### Dial->Sip: SIP URI DNS does not resolve or resolves to an non-public IP address\n\nPlease check your DNS record to ensure it is properly configured. Alternatively, you can use a specific public IP address in your URI rather than specifying a domain.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:31Z',
    last_updated: '2020-08-04T10:00:24.761Z',
  },
  21717: {
    code: 21717,
    message: 'Brand Registration SID for US A2P Campaign Use Case is Not Registered or Not Valid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21717\r\n\r\n### Brand Registration SID for US A2P Campaign Use Case is Not Registered or Not Valid\r\n\r\n The Brand Registration SID you are trying to use to register a new US A2P campaign use case is not registered or the Brand Registration SID is not valid for the given use case.\r\n\r\n#### Possible Causes\r\n* The Brand Registration SID passed in the request is not registered.\r\n* The Brand Registration SID passed in the request is not valid for the given use case. Only brands with a STARTER brand_type can create STARTER campaign use cases.\r\n\r\n#### Possible Solutions\r\n* Verify if the Brand Registration SID has been registered by checking the `status` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). If the brand has been registered, it will have a status of APPROVED. If this is the case, verify that the Brand Registration SID passed into the request matches the Brand Registration SID that has been registered and retry the request.\r\n* If Brand Registration has an IN_PROGRESS status, registration is in progress. Please wait for it to be in an APPROVED status before moving forward with US A2P campaign use case creation. \r\n* If Brand Registration has a REGISTRATION_FAILED status, you may need to correct your brand request and re-trigger Brand registration.\r\n* Verify the brand_type of the Brand by checking the `brand_type` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). If the brand_type is STARTER, the brand can only be used to create STARTER campaign use cases. If it is a STANDARD brand_type, the brand can be used to create any other type of campaign use case.',
    causes:
      '* The Brand Registration SID passed in the request is not registered.\r\n* The Brand Registration SID passed in the request is not valid for the given use case. Only brands with a STARTER brand_type can create STARTER campaign use cases.',
    solutions:
      '* Verify if the Brand Registration SID has been registered by checking the `status` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). If the brand has been registered, it will have a status of APPROVED. If this is the case, verify that the Brand Registration SID passed into the request matches the Brand Registration SID that has been registered and retry the request.\r\n* If Brand Registration has an IN_PROGRESS status, registration is in progress. Please wait for it to be in an APPROVED status before moving forward with US A2P campaign use case creation. \r\n* If Brand Registration has a REGISTRATION_FAILED status, you may need to correct your brand request and re-trigger Brand registration.\r\n* Verify the brand_type of the Brand by checking the `brand_type` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). If the brand_type is STARTER, the brand can only be used to create STARTER campaign use cases. If it is a STANDARD brand_type, the brand can be used to create any other type of campaign use case.',
    description:
      'The Brand Registration SID you are trying to use to register a new US A2P campaign use case is not registered or the Brand Registration SID is not valid for the given use case.',
    product: 'Programmable SMS',
    date_created: '2021-05-27T17:59:10Z',
    last_updated: '2021-09-10T16:26:43.348866Z',
  },
  30793: {
    code: 30793,
    message: 'Brand Registration Failure: Validation problems with connected bundles',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30793\r\n\r\n### Brand Registration Failure: Validation problems with connected bundles\r\n\r\n There was an error while processing the provided customer and a2p information.\r\n\r\n#### Possible Causes\r\nFollowing cases can cause this error :\r\n\r\n* We were not able to find A2P bundle with the bundle SID provided as A2PProfileBundleSid\r\n\r\n* We were not able to find Customer Profile bundle with the bundle SID provided as CustomerProfileBundleSid\r\n\r\n* Invalid/unsupported stock exchange information was provided as part of A2P bundle (applicable only for public entities registering Low Volume Standard or Standard Brands)\r\n\r\n#### Possible Solutions\r\nPlease check that bundle SIDs provide as A2PProfileBundleSid/CustomerProfileBundleSid exist and contain valid information.\r\n\r\n\r\nPlease check that you have provided one the following support Stock Exchanges (applicable only for public entities registering Low Volume Standard or Standard Brands)\r\nNONE, NASDAQ, NYSE, AMEX, AMX, ASX, B3, BME, BSE, FRA, ICEX, JPX, JSE, KRX, LON, NSE, OMX, SEHK, SGX, SSE, STO, SWX, SZSE, TSX, TWSE, VSE, OTHER',
    causes:
      'Following cases can cause this error :\r\n\r\n* We were not able to find A2P bundle with the bundle SID provided as A2PProfileBundleSid\r\n\r\n* We were not able to find Customer Profile bundle with the bundle SID provided as CustomerProfileBundleSid\r\n\r\n* Invalid/unsupported stock exchange information was provided as part of A2P bundle (applicable only for public entities registering Low Volume Standard or Standard Brands)',
    solutions:
      'Please check that bundle SIDs provide as A2PProfileBundleSid/CustomerProfileBundleSid exist and contain valid information.\r\n\r\n\r\nPlease check that you have provided one the following support Stock Exchanges (applicable only for public entities registering Low Volume Standard or Standard Brands)\r\nNONE, NASDAQ, NYSE, AMEX, AMX, ASX, B3, BME, BSE, FRA, ICEX, JPX, JSE, KRX, LON, NSE, OMX, SEHK, SGX, SSE, STO, SWX, SZSE, TSX, TWSE, VSE, OTHER',
    description: 'There was an error while processing the provided customer and a2p information.',
    product: 'Programmable Messaging',
    date_created: '2024-02-13T08:46:41Z',
    last_updated: '2024-02-13T08:46:41Z',
  },
  30468: {
    code: 30468,
    message: 'Toll Free verification rejection - Disallowed: Third-party Lead Generation',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30468\r\n\r\n### Toll Free verification rejection - Disallowed: Third-party Lead Generation\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Third-party lead generation services and marketing). \r\n\r\nAny third-party use cases are strictly forbidden. Consent must be obtained by the end business directly from consumers. Consent cannot be given to one business and then transferred to another. Any business with a terms of service or privacy policy that mentions sharing or selling consumer data/opt-in information is considered noncompliant.\r\n\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Third-party lead generation services and marketing). \r\n\r\nAny third-party use cases are strictly forbidden. Consent must be obtained by the end business directly from consumers. Consent cannot be given to one business and then transferred to another. Any business with a terms of service or privacy policy that mentions sharing or selling consumer data/opt-in information is considered noncompliant.\r\n',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:19:55Z',
    last_updated: '2024-02-22T21:19:55Z',
  },
  11251: {
    code: 11251,
    message: 'Fatal protocol violation',
    log_level: 'ERROR',
    secondary_message: 'There was an HTTP protocol violation speaking to the target URL.',
    log_type: null,
    docs: null,
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:26Z',
    last_updated: '2020-08-04T10:00:29.373Z',
  },
  54302: {
    code: 54302,
    message: 'Invalid unique name',
    log_level: 'ERROR',
    secondary_message:
      'The unique name must be a string with length 1-256 and not match the SID pattern [A-Z]{2}[a-f0-9]{32}.',
    log_type: null,
    docs: '\n## Error - 54302\n\n### Sync: Invalid unique name\nThe unique name must be a string with length 1-256 and not match the SID pattern [A-Z]{2}[a-f0-9]{32}.\n\n#### Possible Causes\n* The value supplied by the UniqueName parameter is an empty string.\n* The value supplied by the UniqueName parameter exceeds 256 characters.\n\n#### Possible Solutions\nConfirm that your UniqueName is a string of 1-256 characters not matching the SID pattern.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.304Z',
  },
  70103: {
    code: 70103,
    message: 'Unsupported Public Key Exponent',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70103\r\n\r\n### Unsupported Public Key Exponent\r\nThe Request tries to store a Public Key in Twilio. This public key can be parsed, has a correct encryption algorithm, but the request fails because the key exponent has an invalid length.\r\n\r\n#### Possible Causes \r\n* Public key key exponent different than 65537.\r\n\r\n#### Possible Solution\r\n* Regenerate a new keypair with exponent 65537 and retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:53:22Z',
    last_updated: '2020-08-04T10:00:19.819Z',
  },
  90034: {
    code: 90034,
    message: "'BroadcastStatusCallbackUrl' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90034\r\n\r\n### 'BroadcastStatusCallbackUrl' is too long\r\n\r\n 'BroadcastStatusCallbackUrl' is too long\r\n\r\n#### Possible Causes\r\n'BroadcastStatusCallbackUrl' is too long\r\n\r\n#### Possible Solutions\r\nUse shorter url in 'BroadcastStatusCallbackUrl' field",
    causes: "'BroadcastStatusCallbackUrl' is too long",
    solutions: "Use shorter url in 'BroadcastStatusCallbackUrl' field",
    description: "'BroadcastStatusCallbackUrl' is too long",
    product: null,
    date_created: '2020-12-11T15:42:17Z',
    last_updated: '2020-12-11T15:42:17Z',
  },
  50306: {
    code: 50306,
    message: 'Programmable Chat: Unique name should not match channel SID pattern',
    log_level: 'ERROR',
    secondary_message:
      'Specified Channel\'s Unique Name matches Channel SID Pattern "CH[0-9a-f]{32}".',
    log_type: null,
    docs: '## Error - 50306\r\n\r\n### Programmable Chat: Unique name should not match channel SID pattern\r\n\r\n#### Possible Causes \r\n*  Specified Channel\'s Unique Name matches Channel SID Pattern "CH[0-9a-f]{32}".\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel\'s Unique Name is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:51Z',
    last_updated: '2020-08-04T10:00:23.11Z',
  },
  53611: {
    code: 53611,
    message: 'Invalid AWS credentials to access external S3 bucket in recording settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53611\r\n\r\n### Invalid AWS credentials to access external S3 bucket in recording settings\r\n\r\nThe AWS credentials configured in your account's recording settings are not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the AWS Access Key ID and Secret Access Key are not correct.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, set some valid credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-05-24T13:15:25Z',
    last_updated: '2020-08-04T10:00:13.703Z',
  },
  22136: {
    code: 22136,
    message: 'Not Portable - Already in one of your Twilio Accounts',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 22136\r\n\r\n### Not Portable - Already in one of your Twilio Accounts\r\n\r\n \r\n\r\n#### Possible Causes\r\nPhone number already exists in one of your accounts or is currently being ported into one of your Twilio accounts.\r\n\r\n#### Possible Solutions\r\nIf needed, see this [support page](https://support.twilio.com/hc/en-us/articles/223135327-Moving-Twilio-Phone-Numbers-to-another-Twilio-Account) for more information on how to move the line to a different subaccount.',
    causes:
      'Phone number already exists in one of your accounts or is currently being ported into one of your Twilio accounts.',
    solutions:
      'If needed, see this [support page](https://support.twilio.com/hc/en-us/articles/223135327-Moving-Twilio-Phone-Numbers-to-another-Twilio-Account) for more information on how to move the line to a different subaccount.',
    description: null,
    product: 'Phone Numbers',
    date_created: '2023-08-02T23:41:06Z',
    last_updated: '2024-06-20T15:23:15.880903Z',
  },
  14234: {
    code: 14234,
    message: 'Dial->Conference: Unable to create task',
    log_level: 'ERROR',
    secondary_message: 'Unable to create the task created by Conference',
    log_type: null,
    docs: '## Error - 14234\r\n\r\n### Conference: Unable to create Task\r\n\r\nUnable to create the Task specified under Conference upon a TwiML error.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:46:44Z',
    last_updated: '2020-08-04T10:00:21.792Z',
  },
  91103: {
    code: 91103,
    message: 'Event type list is empty',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91103\r\n\r\n### Event type list is empty\r\n\r\n Event type list is empty\r\n\r\n#### Possible Causes\r\n* Event types cannot be empty\r\n\r\n#### Possible Solutions\r\n* Ensure event types are not empty',
    causes: '* Event types cannot be empty',
    solutions: '* Ensure event types are not empty',
    description: 'Event type list is empty',
    product: 'Events',
    date_created: '2020-09-16T14:43:41Z',
    last_updated: '2021-01-06T16:38:32.821Z',
  },
  31500: {
    code: 31500,
    message: 'Internal Server Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31500\r\n\r\n### Internal Server Error\r\n\r\nThe server could not fulfill the request due to some unexpected condition.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:44:23Z',
    last_updated: '2020-08-04T10:00:08.273Z',
  },
  22104: {
    code: 22104,
    message: 'Invalid Email Format',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22104\r\n\r\n#### Invalid Email Format\r\n\r\nThe format of a provided email was invalid.\r\n\r\n#### Possible Causes\r\n\r\n* Invalid email provided in request for email or cc emails.\r\n\r\n#### Possible Solutions\r\n\r\nMake sure you submit emails in the format local-part@domain',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:51:10Z',
    last_updated: '2020-08-04T10:00:15.206Z',
  },
  45352: {
    code: 45352,
    message: 'Failed to create an outbound Channel.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45352\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'Conversations API returned an error',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to create a Conversation due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:26.969506Z',
  },
  50508: {
    code: 50508,
    message: 'Programmable Chat: Media already sent with another message',
    log_level: 'ERROR',
    secondary_message: 'Media with specified SID is already sent with another Chat message',
    log_type: null,
    docs: '## Error - 50508\r\n\r\n### Programmable Chat: Media already sent with another message\r\n\r\n#### Possible Causes \r\n*  Media with specified SID is already sent with another Chat message. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Media SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:39:09Z',
    last_updated: '2020-08-04T10:00:16.41Z',
  },
  30748: {
    code: 30748,
    message: 'Brand Registration Failure: Phone number duplicate threshold reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30748\r\n\r\n### Brand Registration Failure: Phone number duplicate threshold reached\r\n\r\n Brand can not be registered with provided phone number since duplicate threshold limit has been reached for it.\r\n\r\n#### Possible Causes\r\nA phone number can not be used multiple times for Sole Proprietor Brand registrations. It is possible that the Starter customer profile bundle used for Sole Proprietor brand registration contains phone number that has been used to register multiple Sole Proprietor brands already. \r\n\r\n#### Possible Solutions\r\nPlease edit the starter customer profile and use a different phone number. Once submitted for review, you can resubmit the brand registration request. \r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes:
      'A phone number can not be used multiple times for Sole Proprietor Brand registrations. It is possible that the Starter customer profile bundle used for Sole Proprietor brand registration contains phone number that has been used to register multiple Sole Proprietor brands already. ',
    solutions:
      'Please edit the starter customer profile and use a different phone number. Once submitted for review, you can resubmit the brand registration request. \r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description:
      'Brand can not be registered with provided phone number since duplicate threshold limit has been reached for it.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:41:26Z',
    last_updated: '2024-02-13T15:49:42.143918Z',
  },
  22106: {
    code: 22106,
    message: 'Invalid Method',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22106\r\n\r\n#### Invalid Method\r\n\r\nThe method you provided for configuring your hosted number was invalid.\r\n\r\nValid values are GET and POST..\r\n\r\n#### Possible Causes\r\n\r\n* Invalid method passed for number configuration (SmsMethod, SmsFallbackMethod, VoiceMethod, VoiceFallbackMethod).\r\n\r\n* Invalid method passed for status callback configuration (StatusCallbackMethod).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:53:18Z',
    last_updated: '2020-08-04T10:00:15.172Z',
  },
  21212: {
    code: 21212,
    message: "Invalid 'From' Number",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21212\r\n\r\n### Invalid \'From\' Number\r\n\r\n You attempted to initiate an outbound phone call or message, but the `From` parameter you supplied was not a valid phone number, Alphanumeric Sender ID or approved WhatsApp Sender.\r\n\r\nTwilio accepts phone numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US and Canadian numbers with any combination of non-digit separators, or Alphanumeric Sender IDs (SMS only) with up to 11 alphanumeric characters [a-zA-Z0-9]. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\nThe number must not be on a do-not-originate (DNO) list, and Alphanumeric Sender IDs may not be generic.\r\n\r\n\r\n#### Possible Causes\r\n* You have supplied a phone number that was not in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).\r\n* Your `From` phone number is on a do-not-originate (DNO) list.\r\nYour [Alphanumeric Sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id) is blocked or too generic.\r\n* You are trying to use an Alphanumeric Sender ID on Trial Account. Trial accounts [cannot send from Alphanumeric Sender IDs](https://www.twilio.com/docs/messaging/guides/how-to-use-your-free-trial-account#sending-sms-and-mms-messages).\r\n* Your WhatsApp Sender is not approved.\r\n* You attempted to send a message with a `From` number that has an invalid prefix, using a Messaging Service.\r\n\r\n\r\n#### Possible Solutions\r\n* Ensure your number is formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).\r\n* Ensure that your `From` number is assigned and not on a do-not-originate (DNO) list.\r\n* Ensure you are not using an [alphanumeric sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id) that is too generic (for example, "SMS" or "INFO").\r\n* If you are getting this error when using a non-generic alphanumeric sender ID, please [submit a support ticket](https://www.twilio.com/console/support/tickets/create) for further assistance.\r\n* If you are using an Alphanumeric Sender ID on a Trial Account, upgrade your account.\r\n* If you are using a WhatsApp Sender, check that your [sender is approved](https://console.twilio.com/us1/develop/sms/senders/whatsapp-senders) and that you have followed the [onboarding instructions](https://www.twilio.com/docs/whatsapp/tutorial/requesting-access-to-whatsapp).\r\n* If you are sending messages using a Messaging Service, and you wish to utilize an RCS Agent in your Sender Pool that falls back to SMS, [send the message from a MessagingServiceSid](https://www.twilio.com/docs/messaging/services#send-a-message-with-a-messaging-service-1). ',
    causes:
      '* You have supplied a phone number that was not in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).\r\n* Your `From` phone number is on a do-not-originate (DNO) list.\r\nYour [Alphanumeric Sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id) is blocked or too generic.\r\n* You are trying to use an Alphanumeric Sender ID on Trial Account. Trial accounts [cannot send from Alphanumeric Sender IDs](https://www.twilio.com/docs/messaging/guides/how-to-use-your-free-trial-account#sending-sms-and-mms-messages).\r\n* Your WhatsApp Sender is not approved.\r\n* You attempted to send a message with a `From` number that has an invalid prefix, using a Messaging Service.\r\n',
    solutions:
      '* Ensure your number is formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).\r\n* Ensure that your `From` number is assigned and not on a do-not-originate (DNO) list.\r\n* Ensure you are not using an [alphanumeric sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id) that is too generic (for example, "SMS" or "INFO").\r\n* If you are getting this error when using a non-generic alphanumeric sender ID, please [submit a support ticket](https://www.twilio.com/console/support/tickets/create) for further assistance.\r\n* If you are using an Alphanumeric Sender ID on a Trial Account, upgrade your account.\r\n* If you are using a WhatsApp Sender, check that your [sender is approved](https://console.twilio.com/us1/develop/sms/senders/whatsapp-senders) and that you have followed the [onboarding instructions](https://www.twilio.com/docs/whatsapp/tutorial/requesting-access-to-whatsapp).\r\n* If you are sending messages using a Messaging Service, and you wish to utilize an RCS Agent in your Sender Pool that falls back to SMS, [send the message from a MessagingServiceSid](https://www.twilio.com/docs/messaging/services#send-a-message-with-a-messaging-service-1). ',
    description:
      'You attempted to initiate an outbound phone call or message, but the `From` parameter you supplied was not a valid phone number, Alphanumeric Sender ID or approved WhatsApp Sender.\r\n\r\nTwilio accepts phone numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US and Canadian numbers with any combination of non-digit separators, or Alphanumeric Sender IDs (SMS only) with up to 11 alphanumeric characters [a-zA-Z0-9]. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\nThe number must not be on a do-not-originate (DNO) list, and Alphanumeric Sender IDs may not be generic.\r\n',
    product: null,
    date_created: '2016-03-31T17:13:57Z',
    last_updated: '2024-03-20T23:15:42.708216Z',
  },
  83400: {
    code: 83400,
    message: 'IP Commands error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 83400\r\n\r\n### IP Commands error\r\n\r\n Raised whenever delivering an IP Command fails with an error that is not covered by a more specific error code.\r\n\r\n#### Possible Causes\r\nAn unspecified error occurred while delivering your IP Command.\r\n\r\n#### Possible Solutions\r\n* Try to send the IP Command again.\r\n* If this is a continuous experience, please contact Twilio Support.',
    causes: 'An unspecified error occurred while delivering your IP Command.',
    solutions:
      '* Try to send the IP Command again.\r\n* If this is a continuous experience, please contact Twilio Support.',
    description:
      'Raised whenever delivering an IP Command fails with an error that is not covered by a more specific error code.',
    product: 'Super SIM',
    date_created: '2021-04-15T21:08:47Z',
    last_updated: '2021-04-15T21:08:47Z',
  },
  30451: {
    code: 30451,
    message: 'Toll-Free phone number verification unable to process - address invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30451\r\n\r\n### Toll-Free phone number verification unable to process - address invalid\r\n\r\n Twilio is unable to process your Toll Free Verification request because it could not be validated by Twilio and could not be submitted for verification review. \r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the address is invalid. It could be due to:\r\n\r\n* The provided address is not a valid US or Canada address\r\n* Invalid State or Region\r\n* Invalid Country\r\n* Invalid House Number (or Unit/Apartment/Suite Number)\r\n* Invalid City\r\n* Invalid Postal Code\r\n* Invalid Street\r\n* Invalid Address - multiple issues\r\n\r\n\r\n#### Possible Solutions\r\nCorrect the address and resubmit the verification in Console or via the Messaging Compliance API. It is not recommended to delete the verification to resolve address validation issue. \r\n\r\nForbidden message categories\r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada \r\n\r\nToll-Free best practices can be found at \r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada\r\n',
    causes:
      'The toll-free phone number cannot be verified because the address is invalid. It could be due to:\r\n\r\n* The provided address is not a valid US or Canada address\r\n* Invalid State or Region\r\n* Invalid Country\r\n* Invalid House Number (or Unit/Apartment/Suite Number)\r\n* Invalid City\r\n* Invalid Postal Code\r\n* Invalid Street\r\n* Invalid Address - multiple issues\r\n',
    solutions:
      'Correct the address and resubmit the verification in Console or via the Messaging Compliance API. It is not recommended to delete the verification to resolve address validation issue. \r\n\r\nForbidden message categories\r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada \r\n\r\nToll-Free best practices can be found at \r\n\r\nhttps://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada\r\n',
    description:
      'Twilio is unable to process your Toll Free Verification request because it could not be validated by Twilio and could not be submitted for verification review. \r\n',
    product: 'Programmable Messaging',
    date_created: '2023-08-14T19:27:51Z',
    last_updated: '2024-06-04T15:32:46.793434Z',
  },
  57001: {
    code: 57001,
    message: "'Secret id' is empty",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57001\r\n\r\n### 'Secret id' is empty\r\n\r\n 'Secret id' is not specified\r\n\r\n#### Possible Causes\r\n'Secret id' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Secret id' is being passed in request. ",
    causes: "'Secret id' is not specified",
    solutions: "Confirm a valid 'Secret id' is being passed in request. ",
    description: "'Secret id' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:41:35Z',
    last_updated: '2021-05-07T08:41:35Z',
  },
  20161: {
    code: 20161,
    message: 'Programmable Chat: Parameters are not specified for update request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 20161\r\n\r\n### Programmable Chat: Parameters are not specified for update request\r\n\r\n Update request doesn't contain any parameters\r\n\r\n#### Possible Causes\r\n* You may have passed parameters, but named them incorrectly.\r\n* You may have forgotten to pass form-encoded parameters with your request\r\n\r\n#### Possible Solutions\r\nCompare your request with the documentation for this resource. Be sure you are submitting form-encoded parameters.",
    causes:
      '* You may have passed parameters, but named them incorrectly.\r\n* You may have forgotten to pass form-encoded parameters with your request',
    solutions:
      'Compare your request with the documentation for this resource. Be sure you are submitting form-encoded parameters.',
    description: "Update request doesn't contain any parameters",
    product: 'Programmable Chat',
    date_created: '2020-02-27T11:22:48Z',
    last_updated: '2020-08-04T10:00:04.544Z',
  },
  81018: {
    code: 81018,
    message: 'Template evaluation error in Studio widget',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 81018\r\n\r\n### Template evaluation error in Studio widget\r\n\r\n An error occurred when Studio tried to evaluate your template syntax.\r\n\r\n#### Possible Causes\r\n* The syntax used in your widget caused an error\r\n* An array index referenced in your widget didn't exist at execution time\r\n* Your Liquid curly braces are mismatched\r\n* You used a `+` character in your template\r\n* You have improperly assigned a variable\r\n* You used a non-ASCII character in a variable name\r\n* A tag or filter used in your template does not exist\r\n\r\n#### Possible Solutions\r\n* Check the syntax used in your widget (See Liquid docs [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language))\r\n* Verify the runtime data of your flow execution by checking the Flow Data and inspecting any variables you may have referenced\r\n* Verify that your Liquid curly braces are matched\r\n* Verify that all tags and filters used in your template are correct (The list of available filters is [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language#standard-filters))\r\n* Use only ASCII characters in variable names",
    causes:
      "* The syntax used in your widget caused an error\r\n* An array index referenced in your widget didn't exist at execution time\r\n* Your Liquid curly braces are mismatched\r\n* You used a `+` character in your template\r\n* You have improperly assigned a variable\r\n* You used a non-ASCII character in a variable name\r\n* A tag or filter used in your template does not exist",
    solutions:
      '* Check the syntax used in your widget (See Liquid docs [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language))\r\n* Verify the runtime data of your flow execution by checking the Flow Data and inspecting any variables you may have referenced\r\n* Verify that your Liquid curly braces are matched\r\n* Verify that all tags and filters used in your template are correct (The list of available filters is [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language#standard-filters))\r\n* Use only ASCII characters in variable names',
    description: 'An error occurred when Studio tried to evaluate your template syntax.',
    product: 'Studio',
    date_created: '2018-10-03T17:41:08Z',
    last_updated: '2020-11-24T18:58:18.762Z',
  },
  13210: {
    code: 13210,
    message: 'Dial: Invalid method value',
    log_level: 'WARNING',
    secondary_message:
      'You have provided an invalid value for the "method" attribute.  Valid values are GET or POST.  See the <a href=\'/docs/api/twiml/dial#method\'>Dial Verb</a> API Reference for more information.',
    log_type: null,
    docs: '## Warning - 13210 \n\n### Dial: Invalid method value\n\nYou have provided an invalid value for the "method" attribute.  Valid values are GET or POST.  See the <a href=\'/docs/api/twiml/dial#method\'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:31Z',
    last_updated: '2020-08-04T10:00:28.984Z',
  },
  50400: {
    code: 50400,
    message: 'Programmable Chat: User not member of channel',
    log_level: 'ERROR',
    secondary_message: 'Specified User is not member of this Channel.',
    log_type: null,
    docs: '## Error - 50400\r\n\r\n### Programmable Chat: User not member of channel\r\n\r\n#### Possible Causes \r\n*  Specified User is not member of this Channel.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User who is Member of this Channel is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:52Z',
    last_updated: '2020-08-04T10:00:23.068Z',
  },
  30454: {
    code: 30454,
    message: 'Account exceeded the messages limit',
    log_level: 'ERROR',
    secondary_message: 'Account exceeded the messages limit',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30454\r\n\r\n### Account exceeded the messages limit\r\n\r\nAccount exceeded the messages limit Account sent too many messages which exceeded the messages limit.\r\n\r\n#### Possible Causes\r\nAccount exceeded the trial account messages limit.\r\n\r\n#### Possible Solutions\r\n* Consider upgrading your account to remove the restrictions. It takes 3-4 hours to reflect the changes in all systems. Please retry after that.',
    causes: 'Account exceeded the trial account messages limit.',
    solutions:
      '* Consider upgrading your account to remove the restrictions. It takes 3-4 hours to reflect the changes in all systems. Please retry after that.',
    description: 'Account sent too many messages which exceeded the messages limit.',
    product: 'Programmable SMS',
    date_created: '2023-10-17T09:52:21Z',
    last_updated: '2024-06-06T14:35:01.839586Z',
  },
  60710: {
    code: 60710,
    message: 'Phone number CPS not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60710\r\n\r\n### Phone number CPS not found\r\n\r\n This phone number was not found on the Call Placement Service (CPS) Directory\r\n\r\n#### Possible Causes\r\n- The number queried is not branded by Twilio or any other CPS\r\n- The service to discover CPS is having issues querying phone numbers\r\n\r\n#### Possible Solutions\r\n- Check that the phone number is the same that you branded in Twilio or your CPS provider',
    causes:
      '- The number queried is not branded by Twilio or any other CPS\r\n- The service to discover CPS is having issues querying phone numbers',
    solutions:
      '- Check that the phone number is the same that you branded in Twilio or your CPS provider',
    description: 'This phone number was not found on the Call Placement Service (CPS) Directory',
    product: 'Branded Comms',
    date_created: '2020-01-20T15:05:31Z',
    last_updated: '2020-08-04T10:00:05.033Z',
  },
  18002: {
    code: 18002,
    message: 'Inadequate document submission',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18002\r\n\r\n### Inadequate document submission\r\n\r\n The document you have uploaded does not match our Regulatory Requirements criteria.\r\n\r\n#### Possible Causes\r\nThe document you have uploaded does not match our acceptable documentation for the Regulatory Requirements.\r\n\r\n#### Possible Solutions\r\nPlease re-submit after uploading a Supporting Document according to our Guidelines. \r\n\r\nhttps://www.twilio.com/en-us/guidelines/regulatory',
    causes:
      'The document you have uploaded does not match our acceptable documentation for the Regulatory Requirements.',
    solutions:
      'Please re-submit after uploading a Supporting Document according to our Guidelines. \r\n\r\nhttps://www.twilio.com/en-us/guidelines/regulatory',
    description:
      'The document you have uploaded does not match our Regulatory Requirements criteria.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:44:09Z',
    last_updated: '2024-07-04T09:44:09Z',
  },
  11201: {
    code: 11201,
    message: 'TCP connection timed out',
    log_level: 'ERROR',
    secondary_message:
      'Twilio cannot establish a TCP connection to your web server. The two attempts to connect to your web server were timed out. Each connection attempt has a 5 second timeout.',
    log_type: null,
    docs: '## Error - 11201\r\n### TCP connection timed out\r\nTwilio cannot establish a TCP connection to your web server. The two attempts to connect to your web server were timed out. Each connection attempt has a 5 second timeout.\r\n\r\n#### Possible Causes\r\n* firewall in your network blocking incoming TCP traffic\r\n* network outage between Twilio and your web server\r\n* invalid host part in the HTTP URL pointing to non-existing host or private IP address\r\n\r\n#### Possible Solutions\r\n* verify firewall configuration in your network or on the web server\r\n* verify network connectivity to your web server\r\n* verify the HTTP URL provided is accessible to the public Internet',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-07-26T20:08:21Z',
    last_updated: '2020-08-04T10:00:12.946Z',
  },
  80207: {
    code: 80207,
    message: ' No unreserved numbers in proxy pool.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80207\r\n\r\n###  No unreserved numbers in proxy pool.\r\n\r\n Failed to find a proxy number.\r\n\r\n#### Possible Causes\r\nThe only matching candidate number(s) in your pool are marked as Reserved.\r\n\r\n#### Possible Solutions\r\nVerify there is at least one unreserved number in your proxy pool.',
    causes: 'The only matching candidate number(s) in your pool are marked as Reserved.',
    solutions: 'Verify there is at least one unreserved number in your proxy pool.',
    description: 'Failed to find a proxy number.',
    product: 'Proxy',
    date_created: '2020-03-10T20:49:33Z',
    last_updated: '2020-08-04T10:00:04.503Z',
  },
  20413: {
    code: 20413,
    message: 'Request Entity Too Large',
    log_level: 'ERROR',
    secondary_message: 'Request entity is larger than limits defined',
    log_type: null,
    docs: '## Request Entity Too Large\r\n\r\n### Request entity is larger than limits defined\r\n\r\nRequest entity is larger than limits defined by the server. ',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-10-10T09:44:56Z',
    last_updated: '2020-08-04T10:00:12.257Z',
  },
  92002: {
    code: 92002,
    message: "The 'variables' parameter exceeds the allowed limit",
    log_level: 'ERROR',
    secondary_message: 'Invalid variables. The max amount of variables allowed is 100',
    log_type: 'APPLICATION',
    docs: "## ERROR - 92002\r\n\r\n### The 'variables' parameter exceeds the allowed limit\r\n\r\nInvalid variables. The max amount of variables allowed is 100 \r\n\r\n#### Possible Causes\r\nYou attempted to create content, but you send more than '100' variables\r\n\r\n#### Possible Solutions\r\nPlease review the amount of variables defined in the 'variables' property",
    causes: "You attempted to create content, but you send more than '100' variables",
    solutions: "Please review the amount of variables defined in the 'variables' property",
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-11-03T07:54:38Z',
    last_updated: '2021-11-03T07:54:38Z',
  },
  81021: {
    code: 81021,
    message: 'Flow revision must be an integer or enum(LatestPublished, LatestRevision)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 81021\r\n\r\n### Flow revision must be an integer or enum(LatestPublished, LatestRevision)\r\n\r\n The Revision was invalid. Revision must be an integer or enum(LatestPublished, LatestRevision).\r\n\r\n#### Possible Causes\r\n* Revision did not match a valid option\r\n\r\n#### Possible Solutions\r\n* Check the value and ensure it is either an integer or one of the magic identifiers: LatestPublished or LatestRevision',
    causes: '* Revision did not match a valid option',
    solutions:
      '* Check the value and ensure it is either an integer or one of the magic identifiers: LatestPublished or LatestRevision',
    description:
      'The Revision was invalid. Revision must be an integer or enum(LatestPublished, LatestRevision).',
    product: 'Studio',
    date_created: '2020-02-21T17:50:10Z',
    last_updated: '2020-08-04T10:00:04.583Z',
  },
  90004: {
    code: 90004,
    message: 'Message Truncated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90004\r\n\r\n### Message Truncated\r\n\r\n A debug-event was too large to be published to Twilio Debugger.\r\n\r\n#### Possible Causes\r\n* You have logged a message field that exceeds a total of 5000 allowed bytes\r\n\r\n#### Possible Solutions\r\n* Try to separate out your logs into individual messages',
    causes: '* You have logged a message field that exceeds a total of 5000 allowed bytes',
    solutions: '* Try to separate out your logs into individual messages',
    description: 'A debug-event was too large to be published to Twilio Debugger.',
    product: 'Flex',
    date_created: '2019-10-08T18:54:28Z',
    last_updated: '2021-03-10T21:56:21.349Z',
  },
  13511: {
    code: 13511,
    message: 'Say: Invalid voice value',
    log_level: 'WARNING',
    secondary_message:
      'The value of the voice attribute must be "man" or "woman". See the <a href=\'/docs/api/twiml/say#voice\'>Say Verb</a> API Reference for more information.',
    log_type: 'APPLICATION',
    docs: "## WARNING - 13511\r\n\r\n### Say: Invalid voice value\r\n\r\n The value of the voice attribute must be valid one.   \r\nSee the <a href='/docs/voice/twiml/say#voice'>Say Verb</a> API Reference for more information.\r\n\r\n\r\n#### Possible Causes\r\n* You have entered an invalid attribute for voice parameter\r\n\r\n\r\n#### Possible Solutions\r\n* Enter a valid voice as parameter",
    causes: '* You have entered an invalid attribute for voice parameter\r\n',
    solutions: '* Enter a valid voice as parameter',
    description:
      "The value of the voice attribute must be valid one.   \r\nSee the <a href='/docs/voice/twiml/say#voice'>Say Verb</a> API Reference for more information.\r\n",
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:43Z',
    last_updated: '2023-06-16T14:28:52.088138Z',
  },
  14237: {
    code: 14237,
    message: 'Dial->Conference: Invalid PostWorkActivitySid',
    log_level: 'ERROR',
    secondary_message: 'Provided PostWorkActivitySid on Conference is invalid',
    log_type: null,
    docs: '## Error - 14237\r\n\r\n### Conference: Invalid PostWorkActivitySid\r\n\r\nThe provided PostWorkActivitySid on the Conference TwiML was an invalid ActivitySid.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:48:00Z',
    last_updated: '2020-08-04T10:00:21.742Z',
  },
  54208: {
    code: 54208,
    message: 'Map Item already exists',
    log_level: 'ERROR',
    secondary_message: 'A Map Item with given key already exists in the Map.',
    log_type: null,
    docs: '\n## Error - 54208\n\n### Sync: Map Item already exists\nA Map Item with given key already exists in the Map.\n\n#### Possible Causes\n* Another Item with the matching Key already exists in this Sync Map, causing a conflict.\n* The provided Key parameter is not set correctly.\n* Your original Map Item creation request has been sent more than once due to a retrier error.\n\n#### Possible Solutions\n* Confirm a valid Key parameter is being passed in request, matching your expectation.\n* Delete a previous Map Item with the matching Key if you no longer need it.\n* Pick a different Key. If your items should be unique, consider using a UUID.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.42Z',
  },
  50341: {
    code: 50341,
    message: 'Invalid messaging service SID',
    log_level: 'ERROR',
    secondary_message: 'An invalid messaging service SID was supplied.',
    log_type: null,
    docs: '\n## Error - 50341\n\n### Conversations: Invalid messaging service SID\nAn invalid messaging service SID was supplied.\n\n#### Possible Causes\nThe MessagingServiceSid provided with the request does not match a valid SID pattern (MGxx).\n\n#### Possible Solutions\nVerify that the SID provided is prefixed with MG and is not missing digits. Your messaging services can be enumerated at https://twilio.com/console/sms/services.\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2018-10-10T16:26:34Z',
    last_updated: '2020-08-04T10:00:11.879Z',
  },
  32105: {
    code: 32105,
    message: 'SIP: Invalid contact header',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: 'Possible loop in Contact header\r\n\r\n<b>Possible Causes</b>\r\n\r\nYou’re sending `127.0.0.1` or `localhost` in the Contact header which will create a loop at Twilio.\r\n\r\n<b>Possible Solutions</b>\r\n\r\n Configure your SIP stack so it populates the Contact header properly.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-11-09T00:55:10Z',
    last_updated: '2020-08-04T10:00:20.545Z',
  },
  91001: {
    code: 91001,
    message: 'Sink could not be found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 91001\r\n\r\n### Sink could not be found\r\n\r\n Sink could not be found\r\n\r\n#### Possible Causes\r\n* Sink doesn't exist\r\n* Invalid Sid\r\n\r\n#### Possible Solutions\r\n* Ensure Sink exists\r\n* Valid Sink ID",
    causes: "* Sink doesn't exist\r\n* Invalid Sid",
    solutions: '* Ensure Sink exists\r\n* Valid Sink ID',
    description: 'Sink could not be found',
    product: 'Events',
    date_created: '2020-09-16T15:37:38Z',
    last_updated: '2021-01-06T16:24:35.294Z',
  },
  50407: {
    code: 50407,
    message: 'Invalid messaging binding address',
    log_level: 'ERROR',
    secondary_message: 'An invalid participant public address was supplied.',
    log_type: null,
    docs: '\n## Error - 50407\n\n### Conversations: Invalid messaging binding address\nAn invalid participant public address was supplied.\n\n#### Possible Causes\n* Participant MessagingBinding.Address parameter provided with the request is not a valid participant address.\n\n#### Possible Solutions\n* Check that the length of MessagingBinding.Address parameter does not exceed 256 characters.\n* Ensure that MessagingBinding.Address parameter contains an address with valid syntax (e.g. SMS phone numbers must follow [E.164 format](https://www.twilio.com/docs/glossary/what-e164)).\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.573Z',
  },
  45778: {
    code: 45778,
    message: 'Configuration not found for provided Deployment Key.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45778\r\n\r\n### Configuration not found for provided Deployment Key.\r\n\r\n Deployment configuration not found for provided deployment key.\r\n\r\n#### Possible Causes\r\nNo deployment configuration associated with the given deployment key.\r\n\r\n#### Possible Solutions\r\nEnsure the deployment key is correct and there exists a valid deployment configuration associated with it.',
    causes: 'No deployment configuration associated with the given deployment key.',
    solutions:
      'Ensure the deployment key is correct and there exists a valid deployment configuration associated with it.',
    description: 'Deployment configuration not found for provided deployment key.',
    product: 'Flex',
    date_created: '2023-11-22T16:01:14Z',
    last_updated: '2023-11-22T16:01:14Z',
  },
  50433: {
    code: 50433,
    message: 'Participant already exists',
    log_level: 'ERROR',
    secondary_message: 'The requested Chat participant is already mapped to a conversation.',
    log_type: null,
    docs: "\n## Error - 50433\n\n### Conversations: Participant already exists\nThe requested Chat participant is already mapped to a conversation.\n\n#### Possible Causes\n* You are attempting to add a Programmable Chat participant to a conversation that already has another participant with the same identity.\n\n#### Possible Solutions\n* [Retrieve a list](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) of existing participants in this conversation and remove the one with the same identity using [REST API](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource).\n* Perhaps it's not an issue, and we can continue as-is. Instead of adding a new participant, reuse the existing one, potentially [update its attributes](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#update-a-conversationparticipant-resource) if necessary.\n",
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.316Z',
  },
  53402: {
    code: 53402,
    message: 'Client is unable to apply a remote media description',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53402: Client is unable to apply a remote media description\r\n\r\nRaised whenever the Client receives a remote media description but is unable to apply it.\r\n\r\n#### Causes\r\n\r\n * The Client may not be using a supported WebRTC implementation.\r\n * The Client may be connecting peer-to-peer with another Participant that is not using a supported WebRTC implementation.\r\n * The Client may not have the necessary resources to apply a new media description.\r\n\r\n#### Solutions\r\n\r\n * If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T22:00:26Z',
    last_updated: '2020-08-04T10:00:19.296Z',
  },
  12102: {
    code: 12102,
    message: 'The root element must be Response',
    log_level: 'ERROR',
    secondary_message:
      'The root element of a Twilio Markup XML document *must* be <a href="/docs/api/twiml/response">Response</a>',
    log_type: null,
    docs: '## Error - 12102 \n\n### The root element must be Response\n\nThe root element of a Twilio Markup XML document *must* be <a href="/docs/api/twiml/response">Response</a>\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:28Z',
    last_updated: '2020-08-04T10:00:29.17Z',
  },
  31400: {
    code: 31400,
    message: 'Bad Request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31400\r\n\r\n### Bad Request \r\n\r\nThe request could not be understood due to malformed syntax.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:11:40Z',
    last_updated: '2020-08-04T10:00:08.562Z',
  },
  51001: {
    code: 51001,
    message: 'Client Connection: Connections resource limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'error',
    log_type: null,
    docs: "## Error - 51001\r\n\r\n### Client Connection: Connections resource limit exceeded\r\n\r\n#### Possible Causes \r\n\r\nThe rate of client connection requests or the number of concurrent connections exceeded the limit.\r\n\r\n#### Possible Solutions\r\n\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your Account's limits.\r\n\r\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:54Z',
    last_updated: '2020-08-04T10:00:22.876Z',
  },
  45745: {
    code: 45745,
    message: 'Invalid or missing parameters in the create conversation request.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45745\r\n\r\n### Invalid or missing parameters in the create conversation request.\r\n\r\n Failed to create webchat conversation for provided address SID due to invalid request parameters.\r\n\r\n#### Possible Causes\r\nInvalid or missing parameters in the create conversation request.\r\n\r\n#### Possible Solutions\r\nEnsure that request parameters are in accordance with the public documentation.',
    causes: 'Invalid or missing parameters in the create conversation request.',
    solutions: 'Ensure that request parameters are in accordance with the public documentation.',
    description:
      'Failed to create webchat conversation for provided address SID due to invalid request parameters.',
    product: 'Flex',
    date_created: '2022-10-03T21:27:00Z',
    last_updated: '2022-10-03T21:27:00Z',
  },
  25103: {
    code: 25103,
    message: "The organization's account owner is not a managed user",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25103\r\n\r\n### The organization's account owner is not a managed user\r\n\r\n The organization's account owner is not a managed user.\r\n\r\n#### Possible Causes\r\n- An independent user has been set as the organization's account owner\r\n- A non-managed user has been set as the organization's account owner\r\n- User doesn't exist\r\n\r\n#### Possible Solutions\r\nOnly managed users can be designated as an organization's account owner.",
    causes:
      "- An independent user has been set as the organization's account owner\r\n- A non-managed user has been set as the organization's account owner\r\n- User doesn't exist",
    solutions: "Only managed users can be designated as an organization's account owner.",
    description: "The organization's account owner is not a managed user.",
    product: 'Organizations API',
    date_created: '2023-12-04T11:21:26Z',
    last_updated: '2023-12-04T14:25:35.979708Z',
  },
  60300: {
    code: 60300,
    message: 'Invalid Param',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60300\r\n\r\n### Invalid Param\r\n\r\n The request contained malformed or semantically incorrect parameters.\r\n\r\n#### Is the request safe to retry?\r\n\r\nA 60300 error request is never processed and is always safe to retry.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\n* Missing parameter.\r\n* Invalid parameter type, value, or length.\r\n\r\n#### Possible Solutions\r\n* Send the required parameter.\r\n* Review the parameter type or value.\r\n* Review the parameter length.',
    causes: '* Missing parameter.\r\n* Invalid parameter type, value, or length.',
    solutions:
      '* Send the required parameter.\r\n* Review the parameter type or value.\r\n* Review the parameter length.',
    description:
      'The request contained malformed or semantically incorrect parameters.\r\n\r\n#### Is the request safe to retry?\r\n\r\nA 60300 error request is never processed and is always safe to retry.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-06-30T16:44:20Z',
    last_updated: '2021-05-18T04:54:27.328Z',
  },
  53216: {
    code: 53216,
    message: 'Participant session length exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53216\r\n\r\n### Participant session length exceeded\r\n\r\n Raised by the server when a Participant\\'s session length exceeds the MaxParticipantDuration value.\r\n\r\n#### Possible Causes\r\n- The Participant\\'s session length exceeds the MaxParticipantDuration value.\r\n- MaxParticipantDuration can be set to a value (in seconds) between 10 minutes (600 seconds) and 24 hours (86400 seconds).\r\n\r\n#### Possible Solutions\r\n- Increase the MaxParticipantDuration configuration for Rooms (up to 24 hours) via REST API upon room creation or via the Video Settings page in Twilio Console to change the default value.",
    causes:
      "- The Participant\\'s session length exceeds the MaxParticipantDuration value.\r\n- MaxParticipantDuration can be set to a value (in seconds) between 10 minutes (600 seconds) and 24 hours (86400 seconds).",
    solutions:
      '- Increase the MaxParticipantDuration configuration for Rooms (up to 24 hours) via REST API upon room creation or via the Video Settings page in Twilio Console to change the default value.',
    description:
      "Raised by the server when a Participant\\'s session length exceeds the MaxParticipantDuration value.",
    product: 'Programmable Video',
    date_created: '2021-10-20T19:50:43Z',
    last_updated: '2021-10-20T19:54:16.857536Z',
  },
  52302: {
    code: 52302,
    message: 'Too many recipients',
    log_level: 'ERROR',
    secondary_message:
      'Request has exceed the maximum recipients limit. No deliveries were attempted.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 52302\r\n\r\n### Too many recipients\r\n\r\nRequest has exceed the maximum recipients limit. No deliveries were attempted. ## Error - 52302\r\n\r\n### Request has exceeded the maximum recipients limit. No deliveries were attempted.\r\n\r\n#### Possible Causes\r\nAn attempt was made to send a broadcast notification that targeted too many recipients.\r\n\r\n#### Possible Solutions\r\n*  Send several notifications that target fewer recipients (e.g. by partitioning your audience using more Segments and Tags).\r\n*  If there is no good way to partition your audience, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes:
      'An attempt was made to send a broadcast notification that targeted too many recipients.',
    solutions:
      '*  Send several notifications that target fewer recipients (e.g. by partitioning your audience using more Segments and Tags).\r\n*  If there is no good way to partition your audience, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description:
      '## Error - 52302\r\n\r\n### Request has exceeded the maximum recipients limit. No deliveries were attempted.',
    product: 'Notifications',
    date_created: '2017-05-24T08:28:51Z',
    last_updated: '2023-11-01T04:39:44.829408Z',
  },
  84001: {
    code: 84001,
    message: 'Workflow execution timed out.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 84001\r\n\r\n### Workflow execution timed out.\r\n\r\n Execution timed out before completing the execution of all the blocks.\r\n\r\n#### Possible Causes\r\n- Long await on any async await events.\r\n\r\n#### Possible Solutions\r\n- Define a timeout for async await events. ',
    causes: '- Long await on any async await events.',
    solutions: '- Define a timeout for async await events. ',
    description: 'Execution timed out before completing the execution of all the blocks.',
    product: null,
    date_created: '2024-01-10T18:08:36Z',
    last_updated: '2024-01-10T18:08:43.379187Z',
  },
  18018: {
    code: 18018,
    message: 'Invalid or incomplete address provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18018\r\n\r\n### Invalid or incomplete address provided\r\n\r\n The address you have provided is not valid.\r\n\r\n#### Possible Causes\r\nThe submitted address does not meet our requirements.\r\n\r\n#### Possible Solutions\r\nPlease resubmit the bundle with the correct address\r\nPlease note that we cannot accept PO boxes/Virtual addresses.',
    causes: 'The submitted address does not meet our requirements.',
    solutions:
      'Please resubmit the bundle with the correct address\r\nPlease note that we cannot accept PO boxes/Virtual addresses.',
    description: 'The address you have provided is not valid.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:11:11Z',
    last_updated: '2024-07-04T10:11:11Z',
  },
  45006: {
    code: 45006,
    message: 'Resource Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45006\r\n\r\n### Resource Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequested resource could not be found.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly.',
    causes: 'Requested resource could not be found.',
    solutions: 'Check that accessed resource is set correctly.',
    description: null,
    product: 'Flex',
    date_created: '2019-07-08T11:27:47Z',
    last_updated: '2020-08-04T10:00:07.789Z',
  },
  90100: {
    code: 90100,
    message: 'Invalid Autopilot Actions JSON',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90100\r\n\r\n### Invalid Autopilot Actions JSON\r\n\r\n Autopilot Actions Configured on the Task are Invalid\r\n\r\n#### Possible Causes\r\nActions JSON does not comply with the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)\r\n\r\n#### Possible Solutions\r\nTest your JSON response against the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)',
    causes:
      'Actions JSON does not comply with the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)',
    solutions:
      'Test your JSON response against the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)',
    description: 'Autopilot Actions Configured on the Task are Invalid',
    product: 'Understand',
    date_created: '2019-08-07T00:57:57Z',
    last_updated: '2020-08-04T10:00:07.286Z',
  },
  22221: {
    code: 22221,
    message: 'Emergency address is not registered',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 22221\r\n\r\n### Emergency address is not registered\r\n\r\n The emergency address is missing when an emergency call is made. The emergency call might have an additional cost.\r\n\r\n#### Possible Causes\r\nFrom number does not have a registered emergency address when an emergency call is made.\r\n\r\n#### Possible Solutions\r\nPlease register an emergency address with the from number.',
    causes:
      'From number does not have a registered emergency address when an emergency call is made.',
    solutions: 'Please register an emergency address with the from number.',
    description:
      'The emergency address is missing when an emergency call is made. The emergency call might have an additional cost.',
    product: 'Phone Numbers',
    date_created: '2021-03-24T09:14:19Z',
    last_updated: '2021-07-08T10:11:10.089462Z',
  },
  90029: {
    code: 90029,
    message: "Broadcast 'CorrelationId' is empty",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90029\r\n\r\n### Broadcast 'CorrelationId' is empty\r\n\r\n Broadcast 'CorrelationId' is empty\r\n\r\n#### Possible Causes\r\nEmpty string value is used in 'CorrelationId' field\r\n\r\n#### Possible Solutions\r\nUse not empty string as 'CorrelationId' field",
    causes: "Empty string value is used in 'CorrelationId' field",
    solutions: "Use not empty string as 'CorrelationId' field",
    description: "Broadcast 'CorrelationId' is empty",
    product: null,
    date_created: '2020-12-11T13:19:12Z',
    last_updated: '2020-12-11T13:19:12Z',
  },
  60406: {
    code: 60406,
    message: 'Initialization Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60406\r\n\r\n### Initialization Error\r\n\r\n An error occurred while initializing a class.\r\n\r\n#### Possible Causes\r\nMissing arguments to initialize a class.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'Missing arguments to initialize a class.',
    solutions: 'Check parameters and retry.',
    description: 'An error occurred while initializing a class.',
    product: 'Verify',
    date_created: '2021-03-15T20:47:11Z',
    last_updated: '2021-03-15T20:47:11Z',
  },
  53101: {
    code: 53101,
    message: 'Room name is too long',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53101: Room name is too long\r\n\r\nRaised whenever a Room name is too long.\r\n\r\n#### Causes\r\n\r\n * The Room name is too long.\r\n\r\n#### Solutions\r\n\r\n * Choose a shorter Room name.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:40:26Z',
    last_updated: '2020-08-04T10:00:19.639Z',
  },
  30457: {
    code: 30457,
    message: 'Toll Free verification rejection - Disallowed: SHAFT - Firearms',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30457\r\n\r\n### Toll Free verification rejection - Disallowed: SHAFT - Firearms\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (SHAFT: Firearms and accessories). \r\n\r\nFirearms and accessories, Tobacco, Vape, and E-cigarettes are not allowed on Toll Free, Short Code, or Long Code regardless of age gating.\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (SHAFT: Firearms and accessories). \r\n\r\nFirearms and accessories, Tobacco, Vape, and E-cigarettes are not allowed on Toll Free, Short Code, or Long Code regardless of age gating.',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T01:08:53Z',
    last_updated: '2024-02-22T01:09:03.653952Z',
  },
  90031: {
    code: 90031,
    message: 'Broadcast Recipients list is empty [deprecated] ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90031\r\n\r\n### Broadcast Recipients list is empty [deprecated] \r\n\r\n Broadcast 'Recipients' list is empty\r\n\r\n#### Possible Causes\r\nBroadcast 'Recipients' list is empty\r\n\r\n#### Possible Solutions\r\nSpecify at least one recipient for Broadcast request",
    causes: "Broadcast 'Recipients' list is empty",
    solutions: 'Specify at least one recipient for Broadcast request',
    description: "Broadcast 'Recipients' list is empty",
    product: 'Programmable SMS',
    date_created: '2020-12-11T13:22:29Z',
    last_updated: '2023-05-30T20:57:38.149716Z',
  },
  31404: {
    code: 31404,
    message: 'Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31404\r\n\r\n### Not Found \r\n\r\nThe server has not found anything matching the request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:12:50Z',
    last_updated: '2020-08-04T10:00:08.451Z',
  },
  19040: {
    code: 19040,
    message: 'Custom Field provided is not defined',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19040\r\n\r\n### Custom Field provided is not defined\r\n\r\n The custom field provided in the request does not exist\r\n\r\n#### Possible Causes\r\nRequest with a custom_field that is not defined\r\n\r\n#### Possible Solutions\r\nUse custom field definition API to define the custom field first',
    causes: 'Request with a custom_field that is not defined',
    solutions: 'Use custom field definition API to define the custom field first',
    description: 'The custom field provided in the request does not exist',
    product: null,
    date_created: '2020-07-21T20:32:36Z',
    last_updated: '2020-08-04T10:00:01.267Z',
  },
  30467: {
    code: 30467,
    message: 'Toll Free verification rejection - Disallowed: Credit Repair',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30467\r\n\r\n### Toll Free verification rejection - Disallowed: Credit Repair\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Debt collection or forgiveness: Credit/debt repair). \r\n\r\nDebt consolidation, debt reduction and credit repair programs are prohibited regardless if there is first-party consent.\r\n\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide additional information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Debt collection or forgiveness: Credit/debt repair). \r\n\r\nDebt consolidation, debt reduction and credit repair programs are prohibited regardless if there is first-party consent.\r\n',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide additional information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:15:57Z',
    last_updated: '2024-02-22T21:15:57Z',
  },
  45764: {
    code: 45764,
    message: 'Unable to validate address configuration. Auto create webhook URL missing. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45764\r\n\r\n### Unable to validate address configuration. Auto create webhook URL missing. \r\n\r\n Unable to validate address configuration for provided address SID. Auto create webhook URL missing. \r\n\r\n#### Possible Causes\r\nAddress configuration associated with the provided address SID has auto create type set to WEBHOOK but no webhook URL was provided.\r\n\r\n#### Possible Solutions\r\nEnsure that the address SID provided is valid and associated with the correct account.\r\n\r\nEnsure that the auto create type provided is correct. If your auto create type is WEBHOOK, ensure the webhook url is present and valid in the address configuration. \r\n\r\nRead more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#create-an-addressconfiguration-resource)\r\n\r\nRead more about webhooks and their applications [here.](https://www.twilio.com/docs/usage/webhooks/webhooks-overview)',
    causes:
      'Address configuration associated with the provided address SID has auto create type set to WEBHOOK but no webhook URL was provided.',
    solutions:
      'Ensure that the address SID provided is valid and associated with the correct account.\r\n\r\nEnsure that the auto create type provided is correct. If your auto create type is WEBHOOK, ensure the webhook url is present and valid in the address configuration. \r\n\r\nRead more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#create-an-addressconfiguration-resource)\r\n\r\nRead more about webhooks and their applications [here.](https://www.twilio.com/docs/usage/webhooks/webhooks-overview)',
    description:
      'Unable to validate address configuration for provided address SID. Auto create webhook URL missing. ',
    product: 'Flex',
    date_created: '2022-10-03T21:18:58Z',
    last_updated: '2022-10-03T21:18:58Z',
  },
  62004: {
    code: 62004,
    message: 'Direct connect not found.',
    log_level: 'ERROR',
    secondary_message: 'The direct connect SID in the request could not be found.',
    log_type: null,
    docs: '## Error - 62004\r\n\r\n### Direct connect not found\r\n\r\nThe direct connect SID in the request could not be found.\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:35:06Z',
    last_updated: '2020-08-04T10:00:21.126Z',
  },
  45201: {
    code: 45201,
    message: 'Resource Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45201\r\n\r\n### Resource Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequested resource could not be found.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly.',
    causes: 'Requested resource could not be found.',
    solutions: 'Check that accessed resource is set correctly.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-16T06:00:03Z',
    last_updated: '2020-08-04T10:00:11.859Z',
  },
  63019: {
    code: 63019,
    message: 'Media failed to download',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63019\r\n\r\n### Media failed to download\r\n\r\n \r\n\r\n#### Possible Causes\r\n* Twilio failed to download the media from the sender. \r\n* Attempt to retrieve the media returned 0 bytes. \r\n\r\n#### Possible Solutions\r\nPlease check the media content before retrying',
    causes:
      '* Twilio failed to download the media from the sender. \r\n* Attempt to retrieve the media returned 0 bytes. ',
    solutions: 'Please check the media content before retrying',
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:24:34Z',
    last_updated: '2020-08-04T10:00:10.525Z',
  },
  60608: {
    code: 60608,
    message: 'Lookup Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 60608\r\n\r\n### Lookup Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Lookup request was received but failed during processing due to an error encountered with downstream providers.\r\n\r\n#### Possible Solutions\r\n- Retry request to rule out transient issues. \r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    causes:
      'The Lookup request was received but failed during processing due to an error encountered with downstream providers.',
    solutions:
      '- Retry request to rule out transient issues. \r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    description: 'Lookup provider replied with an error',
    product: 'Lookup',
    date_created: '2021-02-09T15:07:14Z',
    last_updated: '2023-01-06T00:08:06.829364Z',
  },
  30798: {
    code: 30798,
    message: 'Brand Registration Feedback: No IRS 501c tax-exempt status found.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30798\r\n\r\n### Brand Registration Feedback: No IRS 501c tax-exempt status found.\r\n\r\n Your Brand has received feedback from The Campaign Registration upon registration. This brand registration can not be used for campaign creation till the provided feedback has been addressed. In this particular case,  no IRS 501c tax-exempt status was found for the entity being registered.\r\n\r\n#### Possible Causes\r\n* The submitted company is not a US entity. Only US entities qualify for the Non-Profit Entity Type. \r\n* The submitted company is not verified as a US IRS recognised non-profit organisation. \r\n* The submitted company is verified as a US IRS recognised non-profit organisation but the charitable subsection code was not reported.\r\n\r\n\r\n#### Possible Solutions\r\nPlease change the entity_type field value to something other than Non-Profit. If you are a Non-Profit Entity, please update the customer profile to indicate the same.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n',
    causes:
      '* The submitted company is not a US entity. Only US entities qualify for the Non-Profit Entity Type. \r\n* The submitted company is not verified as a US IRS recognised non-profit organisation. \r\n* The submitted company is verified as a US IRS recognised non-profit organisation but the charitable subsection code was not reported.\r\n',
    solutions:
      'Please change the entity_type field value to something other than Non-Profit. If you are a Non-Profit Entity, please update the customer profile to indicate the same.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n',
    description:
      'Your Brand has received feedback from The Campaign Registration upon registration. This brand registration can not be used for campaign creation till the provided feedback has been addressed. In this particular case,  no IRS 501c tax-exempt status was found for the entity being registered.',
    product: 'Programmable Messaging',
    date_created: '2024-02-28T16:33:53Z',
    last_updated: '2024-02-28T16:33:53Z',
  },
  50700: {
    code: 50700,
    message: 'Virtual Agent provider is invalid.',
    log_level: 'ERROR',
    secondary_message:
      "Provided Virtual Agent provider doesn't match the list of available providers for conversations.",
    log_type: 'TWILIO',
    docs: "## ERROR - 50700\r\n\r\n### Virtual Agent provider is invalid.\r\n\r\nProvided Virtual Agent provider doesn't match the list of available providers for conversations. \r\n\r\n#### Possible Causes\r\nProvided Virtual Agent provider doesn't match the list of available providers for conversations or has different case\r\n\r\n#### Possible Solutions\r\n* Check list of available Virtual Agent providers in Conversations documentation. Please note that values are case sensitive.",
    causes:
      "Provided Virtual Agent provider doesn't match the list of available providers for conversations or has different case",
    solutions:
      '* Check list of available Virtual Agent providers in Conversations documentation. Please note that values are case sensitive.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T17:57:35Z',
    last_updated: '2023-10-11T17:57:35Z',
  },
  64015: {
    code: 64015,
    message: 'Pay: `<Pay>` verb is missing a needed Parameter',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64015\r\n\r\n### Pay: `<Pay>` verb is missing a needed Parameter\r\n\r\n A 64015 Error is an indication that the configured connector for the payment method is missing one of the Parameter needed in the `<Pay>` verb.\r\n\r\n#### Possible Causes\r\nThe connector needs a specific Parameter in the `<Pay>` verb\r\n\r\n#### Possible Solutions\r\nThe required parameters for the connector are listed in the "Description" section of the connector.\r\nThe parameters should be passed inside the `<Pay>` verb.\r\n\r\nExample:\r\n```\r\n<Pay>\r\n  <Parameter name="Parameter Name" value="Parameter Value" />\r\n</Pay\r\n```\r\n\r\n### Connector Specific Reasons for Error\r\n#### Braintree\r\n- `MerchantAccountId` is required to be passed via a `<Parameter>` noun for all Braintree `<Pay>` executions. This value can be found in the Braintree console by navigating to Settings (gear icon) -> Business.\r\n- If passing a `description` as a parameter in `<Pay>`, you must also pass the following fields via separate `<Parameter>` nouns: `name`, `kind`, `quantity`, `totalAmount`, `unitAmount`. If you received this error you either left one of these fields out, or passed an invalid value for one of them. See [Braintree Documentation](https://developer.paypal.com/braintree/docs/reference/request/transaction/sale#line_items.description) for more information.',
    causes: 'The connector needs a specific Parameter in the `<Pay>` verb',
    solutions:
      'The required parameters for the connector are listed in the "Description" section of the connector.\r\nThe parameters should be passed inside the `<Pay>` verb.\r\n\r\nExample:\r\n```\r\n<Pay>\r\n  <Parameter name="Parameter Name" value="Parameter Value" />\r\n</Pay\r\n```\r\n\r\n### Connector Specific Reasons for Error\r\n#### Braintree\r\n- `MerchantAccountId` is required to be passed via a `<Parameter>` noun for all Braintree `<Pay>` executions. This value can be found in the Braintree console by navigating to Settings (gear icon) -> Business.\r\n- If passing a `description` as a parameter in `<Pay>`, you must also pass the following fields via separate `<Parameter>` nouns: `name`, `kind`, `quantity`, `totalAmount`, `unitAmount`. If you received this error you either left one of these fields out, or passed an invalid value for one of them. See [Braintree Documentation](https://developer.paypal.com/braintree/docs/reference/request/transaction/sale#line_items.description) for more information.',
    description:
      'A 64015 Error is an indication that the configured connector for the payment method is missing one of the Parameter needed in the `<Pay>` verb.',
    product: 'Programmable Voice',
    date_created: '2020-01-07T20:48:23Z',
    last_updated: '2022-08-05T18:10:17.837675Z',
  },
  60392: {
    code: 60392,
    message: 'Entity not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60392\r\n\r\n### Entity not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe requested Entity is missing\r\n\r\n#### Possible Solutions\r\nCheck that the Entity in the request parameter/body is correct.',
    causes: 'The requested Entity is missing',
    solutions: 'Check that the Entity in the request parameter/body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T10:03:19Z',
    last_updated: '2023-12-27T10:03:19Z',
  },
  54510: {
    code: 54510,
    message: 'Query expression contains an array with too many items',
    log_level: 'ERROR',
    secondary_message: 'Any array within query expression must contain less than 30 items',
    log_type: null,
    docs: '## Error - 54510\r\n\r\n### Sync: Query expression contains an array with too many items\r\nAny array within query expression must contain less than 30 items.\r\n\r\n#### Possible Causes\r\n* The query expression contains an array with 30 or more elements.\r\n\r\n#### Possible Solutions\r\n* Rewrite your queries (or the code generating them) such that arrays never contain more than 30 items.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2019-03-28T08:29:58Z',
    last_updated: '2020-08-04T10:00:09.304Z',
  },
  40111: {
    code: 40111,
    message: 'TaskRouter->Call',
    log_level: 'ERROR',
    secondary_message: "Call Instruction does not have a valid 'from' parameter provided.",
    log_type: null,
    docs: '## Error - 40111\r\n\r\n### Missing or Invalid \'from\' parameter - Call Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "from" parameter on your \'call\' instruction.\r\n*  You provided an invalid format in your "from" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "from" contains a validated caller ID if you\'re dialing the PSTN. \r\n*  Make certain "from" contains an acceptable caller field when connecting to client or SIP.  \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:40Z',
    last_updated: '2020-08-04T10:00:24.012Z',
  },
  32111: {
    code: 32111,
    message: 'SIP: Invalid header name',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32111\r\n\r\n### SIP: Invalid header name\r\n\r\n The header you asked Twilio to stamp was omitted because it contains illegal characters in its _name_. Including this header would have resulted in Twilio generating a message that runs contrary to the SIP specification.\r\n\r\nThe set of legal characters for a header name is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).\r\n\r\n#### Possible Causes\r\n* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.\r\n\r\n#### Possible Solutions\r\n* Ensure that your SIP URI is formed correctly. Header names should generally only consist of alphanumeric characters and hyphens.',
    causes:
      '* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.',
    solutions:
      '* Ensure that your SIP URI is formed correctly. Header names should generally only consist of alphanumeric characters and hyphens.',
    description:
      'The header you asked Twilio to stamp was omitted because it contains illegal characters in its _name_. Including this header would have resulted in Twilio generating a message that runs contrary to the SIP specification.\r\n\r\nThe set of legal characters for a header name is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).',
    product: null,
    date_created: '2019-06-13T20:34:41Z',
    last_updated: '2021-03-06T00:40:47.355Z',
  },
  30461: {
    code: 30461,
    message: 'Toll Free verification rejection - Disallowed: Gambling',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30461\r\n\r\n### Toll Free verification rejection - Disallowed: Gambling\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Gambling). \r\n\r\nGambling traffic is prohibited in the US and Canada on all number types (Toll Free, Short Code, Long Code). The gambling category includes, but is not limited to:\r\n \r\n* Casino apps\r\n* Websites that offer gambling\r\n* Sweepstakes\r\n* 50/50 Raffles\r\n* Contests\r\n* Betting/Sports picks\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Gambling). \r\n\r\nGambling traffic is prohibited in the US and Canada on all number types (Toll Free, Short Code, Long Code). The gambling category includes, but is not limited to:\r\n \r\n* Casino apps\r\n* Websites that offer gambling\r\n* Sweepstakes\r\n* 50/50 Raffles\r\n* Contests\r\n* Betting/Sports picks',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T18:20:41Z',
    last_updated: '2024-02-22T18:20:41Z',
  },
  30893: {
    code: 30893,
    message: 'Campaign vetting rejection - Inconsistency between Sample Message and Use-case',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30893\r\n\r\n### Campaign vetting rejection - Inconsistency between Sample Message and Use-case\r\n\r\n The campaign submission has been reviewed and rejected due to inconsistencies between the sample message and the intended use-case of the campaign.\r\n\r\n#### Possible Causes\r\n* Sample messages are missing, unclear, or their content does not match the campaign's use-case.\r\n* Invalid content within the sample messages.\r\n\r\n#### Possible Solutions\r\n* Verify that the sample messages are accurate, detailed, and reflective of the actual messages to be sent under the campaign.\r\n* Indicate templated fields within sample messages using brackets.\r\n* At least one of the sample messages should include your business name and opt-out message.\r\n* Ensure at least two sample messages are provided.\r\n* Ensure that the use-case and campaign description align with each other.\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices]( https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)",
    causes:
      "* Sample messages are missing, unclear, or their content does not match the campaign's use-case.\r\n* Invalid content within the sample messages.",
    solutions:
      '* Verify that the sample messages are accurate, detailed, and reflective of the actual messages to be sent under the campaign.\r\n* Indicate templated fields within sample messages using brackets.\r\n* At least one of the sample messages should include your business name and opt-out message.\r\n* Ensure at least two sample messages are provided.\r\n* Ensure that the use-case and campaign description align with each other.\r\n\r\nOnce you have made a change to address the issue, please resubmit the campaign for review.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices]( https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and rejected due to inconsistencies between the sample message and the intended use-case of the campaign.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:41:18Z',
    last_updated: '2023-08-21T19:40:57.9982Z',
  },
  31902: {
    code: 31902,
    message: 'Stream - WebSocket - Connection Refused',
    log_level: 'ERROR',
    secondary_message:
      'The WebSocket connection request sent by the stream is refused by the server host',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31902\r\n\r\n### Stream - WebSocket - Connection Refused\r\n\r\nThe WebSocket connection request sent by the stream is refused by the server host \r\n\r\n#### Possible Causes\r\n* The stream is trying to connect the wrong port\r\n* The WebSocket server is down\r\n\r\n#### Possible Solutions\r\n* Verify the TwiML URL is correct\r\n* Verify server process is up and running',
    causes: '* The stream is trying to connect the wrong port\r\n* The WebSocket server is down',
    solutions: '* Verify the TwiML URL is correct\r\n* Verify server process is up and running',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:54:15Z',
    last_updated: '2020-08-04T10:00:07.425Z',
  },
  53108: {
    code: 53108,
    message: 'RoomType is not valid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53108: RoomType is not valid\r\n\r\nRaised in the REST API when the user attempts to create a Room with an invalid RoomType\r\n\r\n#### Causes\r\n\r\n * REST API call to Create Room instance with an invalid RoomType.\r\n\r\n#### Solutions\r\n\r\n * Set the RoomType value to a valid type or leave this field blank for the default.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:44:21Z',
    last_updated: '2020-08-04T10:00:19.551Z',
  },
  32602: {
    code: 32602,
    message: 'Virtual Agent: Invalid Connector',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32602\r\n\r\n### Virtual Agent: Invalid Connector\r\n\r\n A 32602 Error is an indication that the referenced connector is not a valid &lt;VirtualAgent&gt; connector.\r\n\r\n#### Possible Causes\r\n* The connector referenced by the supplied connectorName does not exist\r\n* The connector referenced by the supplied connectorName is not a VirtualAgent connector\r\n* The supplied TwiML is missing the connectorName attribute\r\n\r\n#### Possible Solutions\r\n* Check the connectorName attribute in your TwiML and ensure that it matches the unique name of a VirtualAgent connector',
    causes:
      '* The connector referenced by the supplied connectorName does not exist\r\n* The connector referenced by the supplied connectorName is not a VirtualAgent connector\r\n* The supplied TwiML is missing the connectorName attribute',
    solutions:
      '* Check the connectorName attribute in your TwiML and ensure that it matches the unique name of a VirtualAgent connector',
    description:
      'A 32602 Error is an indication that the referenced connector is not a valid &lt;VirtualAgent&gt; connector.',
    product: 'Programmable Voice',
    date_created: '2022-08-04T01:22:31Z',
    last_updated: '2022-08-04T01:22:31Z',
  },
  30026: {
    code: 30026,
    message: 'US A2P 10DLC - 70% T-Mobile Daily Message Limit Consumed',
    log_level: 'WARNING',
    secondary_message:
      'As part of the US A2P 10DLC initiative, T-Mobile has instituted a daily message limit. We’re sending you this warning to let you know that you have consumed 70% of your T-Mobile daily limit.',
    log_type: 'CARRIER',
    docs: '## WARNING - 30026\r\n\r\n### US A2P 10DLC - 70% T-Mobile Daily Message Limit Consumed\r\n\r\nAs part of the US A2P 10DLC initiative, T-Mobile has instituted a daily message limit. We’re sending you this warning to let you know that you have consumed 70% of your T-Mobile daily limit. Please note that this daily limit is based on the sum of SMS segments and MMS messages you send to T-Mobile subscribers on a 24-hour basis, and is reset daily at midnight PT. When you hit 100% of your daily message limit, you will start to receive error code 30023 for each subsequent message you send to T-Mobile. Those messages will not be delivered, and you must wait until midnight PT to resume message sending.\r\n\r\nFor more information on T-Mobile daily limit, please refer to [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more information on US A2P 10DLC, please refer to [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\nPlease disregard this warning if you have been approved for the unlimited tier via the [T-Mobile Special Business Review process](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC).\r\n\r\nPlease note that if you have multiple providers sending registered SMS or MMS to T-Mobile on your behalf, this warning might not be accurate.\r\n\r\n#### Possible Causes\r\n* You have consumed 70% of your T-Mobile daily message limit for the day.\r\n\r\n#### Possible Solutions\r\n* No action is required from you. \r\n* To view the warning and errors in the debugger, please visit [here](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n* To view your daily T-Mobile message limit, please visit [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1), select your US A2P brand, and view the  details of your TCR trust score (registered customers only).\r\n* To view your daily T-Mobile usage, please use the Messaging Insights tool.',
    causes: '* You have consumed 70% of your T-Mobile daily message limit for the day.',
    solutions:
      '* No action is required from you. \r\n* To view the warning and errors in the debugger, please visit [here](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n* To view your daily T-Mobile message limit, please visit [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1), select your US A2P brand, and view the  details of your TCR trust score (registered customers only).\r\n* To view your daily T-Mobile usage, please use the Messaging Insights tool.',
    description:
      'Please note that this daily limit is based on the sum of SMS segments and MMS messages you send to T-Mobile subscribers on a 24-hour basis, and is reset daily at midnight PT. When you hit 100% of your daily message limit, you will start to receive error code 30023 for each subsequent message you send to T-Mobile. Those messages will not be delivered, and you must wait until midnight PT to resume message sending.\r\n\r\nFor more information on T-Mobile daily limit, please refer to [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more information on US A2P 10DLC, please refer to [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\nPlease disregard this warning if you have been approved for the unlimited tier via the [T-Mobile Special Business Review process](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC).\r\n\r\nPlease note that if you have multiple providers sending registered SMS or MMS to T-Mobile on your behalf, this warning might not be accurate.',
    product: 'Programmable SMS',
    date_created: '2021-10-18T19:26:58Z',
    last_updated: '2021-12-08T19:22:45.333132Z',
  },
  30115: {
    code: 30115,
    message: 'Date format is incorrect',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30115\r\n\r\n### Date format is incorrect\r\n\r\n The date format you have used is incorrect.\r\n\r\n#### Possible Causes\r\n- You may have included a timestamp in your date\r\n- You may have abbreviated YYYY to YY\r\n\r\n#### Possible Solutions\r\nPlease use YYYY-MM-DD format for the Date field.',
    causes:
      '- You may have included a timestamp in your date\r\n- You may have abbreviated YYYY to YY',
    solutions: 'Please use YYYY-MM-DD format for the Date field.',
    description: 'The date format you have used is incorrect.',
    product: 'Programmable SMS',
    date_created: '2020-08-27T19:49:18Z',
    last_updated: '2020-08-27T19:49:18Z',
  },
  35118: {
    code: 35118,
    message: 'MessagingServiceSid is required to schedule a message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35118\r\n\r\n### MessagingServiceSid is required to schedule a message\r\n\r\n Message Scheduling is only accessible on Messaging Services. You need to pass a MessageServiceSid instead or along with a From Phone Number in order to schedule a message.\r\n\r\n#### Possible Causes\r\nA MessagingServiceSid was not provided as part of the MessagingServiceSid or From parameter.\r\n\r\n#### Possible Solutions\r\nPass the MessagingServiceSid in either the MessagingServiceSid parameter or the From parameter.',
    causes:
      'A MessagingServiceSid was not provided as part of the MessagingServiceSid or From parameter.',
    solutions:
      'Pass the MessagingServiceSid in either the MessagingServiceSid parameter or the From parameter.',
    description:
      'Message Scheduling is only accessible on Messaging Services. You need to pass a MessageServiceSid instead or along with a From Phone Number in order to schedule a message.',
    product: 'Programmable SMS',
    date_created: '2022-06-18T01:07:28Z',
    last_updated: '2022-06-18T01:07:28Z',
  },
  14241: {
    code: 14241,
    message: 'start_date passed to TaskRouter statistics is older than 30 days.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 14241\r\n\r\n### start_date passed to TaskRouter statistics is older than 30 days.\r\n\r\n Starting Nov. 30, 2021 we will no longer return data older than 30 days, and instead return a 400-response for requests with <start_date> older than 30 days.\r\n\r\n#### Possible Causes\r\n<start_date> is older than 30 days.\r\n\r\n#### Possible Solutions\r\nPass a <start_date> that is within 30 days.',
    causes: '<start_date> is older than 30 days.',
    solutions: 'Pass a <start_date> that is within 30 days.',
    description:
      'Starting Nov. 30, 2021 we will no longer return data older than 30 days, and instead return a 400-response for requests with <start_date> older than 30 days.',
    product: 'TaskRouter',
    date_created: '2021-08-26T16:59:09Z',
    last_updated: '2021-08-27T16:21:30.86363Z',
  },
  90018: {
    code: 90018,
    message: "'Template' field is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90018\r\n\r\n### 'Template' field is too long\r\n\r\n 'Template' field is too long\r\n\r\n#### Possible Causes\r\n'Template' field is too long\r\n\r\n#### Possible Solutions\r\nUse shorter 'Template'",
    causes: "'Template' field is too long",
    solutions: "Use shorter 'Template'",
    description: "'Template' field is too long",
    product: null,
    date_created: '2020-12-11T08:43:54Z',
    last_updated: '2020-12-11T08:43:54Z',
  },
  30039: {
    code: 30039,
    message: 'Filtered to Prevent Message Loops',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 30039\r\n\r\n### Filtered to Prevent Message Loops\r\n\r\n This inbound message appears to be machine generated. Responding to this message programmatically could lead to endless messaging loops. For that reason, Twilio has failed the message with this error code and did not POST to the number’s configured TwiML URLs.\r\n\r\n#### Possible Causes\r\nYou are receiving a message that appears to be machine generated.\r\n\r\n#### Possible Solutions\r\nIf you want to respond to these messages programmatically, you can listen for failed status callbacks with this error code and respond using the Twilio REST API.',
    causes: 'You are receiving a message that appears to be machine generated.',
    solutions:
      'If you want to respond to these messages programmatically, you can listen for failed status callbacks with this error code and respond using the Twilio REST API.',
    description:
      'This inbound message appears to be machine generated. Responding to this message programmatically could lead to endless messaging loops. For that reason, Twilio has failed the message with this error code and did not POST to the number’s configured TwiML URLs.',
    product: 'Programmable SMS',
    date_created: '2023-09-05T07:37:47Z',
    last_updated: '2023-09-05T07:37:55.536572Z',
  },
  62026: {
    code: 62026,
    message: 'Interconnect: Missing MPLS carrier SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 62026\r\n\r\n#### Possible Causes \r\n* Missing MPLS carrier SID\r\n\r\n#### Possible Solutions\r\n*  Please add a valid MPLS carrier SID.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:50:17Z',
    last_updated: '2020-08-04T10:00:20.718Z',
  },
  21631: {
    code: 21631,
    message: 'Phone Number Requires an Address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21631\r\n\r\n### Phone Number Requires an Address\r\n\r\n To purchase this number you must supply the Address of the user of this phone number.  Previously the IncomingPhoneNumbers API would look at your account for an appropriate address, however, you are now required to pass in an AddressSid that satisfies the requirement for the phone number.  This is because Twilio needs to know which address will be operating the phone number to meet regulatory requirements for that country and type of phone number.\r\n\r\n#### Possible Causes\r\n- No address was provided \r\n- No address was that satisfies the locality requirement for this phone number type.\r\n- Depending on the country and number type, this may be an address in the same country or same geographic area as the number being purchased.\r\n\r\n#### Possible Solutions\r\n- Add an address that satisfies the locality requirement.\r\n- Contact Twilio Support.',
    causes:
      '- No address was provided \r\n- No address was that satisfies the locality requirement for this phone number type.\r\n- Depending on the country and number type, this may be an address in the same country or same geographic area as the number being purchased.',
    solutions:
      '- Add an address that satisfies the locality requirement.\r\n- Contact Twilio Support.',
    description:
      'To purchase this number you must supply the Address of the user of this phone number.  Previously the IncomingPhoneNumbers API would look at your account for an appropriate address, however, you are now required to pass in an AddressSid that satisfies the requirement for the phone number.  This is because Twilio needs to know which address will be operating the phone number to meet regulatory requirements for that country and type of phone number.',
    product: 'Phone Numbers',
    date_created: '2019-06-12T00:30:52Z',
    last_updated: '2020-08-04T10:00:08.001Z',
  },
  94001: {
    code: 94001,
    message: 'Transcriptions: Invalid transcribe value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94001\r\n\r\n### Transcriptions: Invalid transcribe value\r\n\r\n Invalid “transcribe” value. It should be either true or false. No transcription resource has been created\r\n\r\n#### Possible Causes\r\n \r\n\r\n#### Possible Solutions\r\n* Ensure that the transcribe value is set to “true” to request a transcription via REST API or TwiML',
    causes: ' ',
    solutions:
      '* Ensure that the transcribe value is set to “true” to request a transcription via REST API or TwiML',
    description:
      'Invalid “transcribe” value. It should be either true or false. No transcription resource has been created',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-13T14:05:05Z',
  },
  21615: {
    code: 21615,
    message: 'Phone Number Requires a Local Address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21615\r\n\r\n### Phone Number Requires a Local Address\r\n\r\n To purchase this number you must have an Address on your account which satisfies the local address requirements. \r\n\r\n#### Possible Causes\r\n- No address on your account or subaccount that satisfies the locality requirement. Depending on the country, this can be either same country or same geographic area as the number being purchased.\r\n\r\n#### Possible Solutions\r\n- Add an address that satisfies the locality requirement\r\n- Contact Twilio Support',
    causes:
      '- No address on your account or subaccount that satisfies the locality requirement. Depending on the country, this can be either same country or same geographic area as the number being purchased.',
    solutions:
      '- Add an address that satisfies the locality requirement\r\n- Contact Twilio Support',
    description:
      'To purchase this number you must have an Address on your account which satisfies the local address requirements. ',
    product: 'Phone Numbers',
    date_created: '2017-05-17T11:33:25Z',
    last_updated: '2020-08-04T10:00:18.589Z',
  },
  13321: {
    code: 13321,
    message: 'Gather -> Say: Invalid voice value',
    log_level: 'WARNING',
    secondary_message:
      'The value of the voice attribute must be "man" or "woman". See the <a href=\'/docs/api/twiml/say#voice\'>Say Verb</a> API Reference for more information.',
    log_type: 'APPLICATION',
    docs: "## WARNING - 13321\r\n\r\n### Gather -> Say: Invalid voice value\r\n\r\n The value of the voice attribute must be valid one.   \r\nSee the <a href='/docs/voice/twiml/say#voice'>Say Verb</a> API Reference for more information.\r\n\r\n\r\n#### Possible Causes\r\n* You have entered an invalid attribute for voice parameter\r\n\r\n#### Possible Solutions\r\n* Enter a valid voice as parameter",
    causes: '* You have entered an invalid attribute for voice parameter',
    solutions: '* Enter a valid voice as parameter',
    description:
      "The value of the voice attribute must be valid one.   \r\nSee the <a href='/docs/voice/twiml/say#voice'>Say Verb</a> API Reference for more information.\r\n",
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:41Z',
    last_updated: '2023-06-16T14:26:35.145739Z',
  },
  21652: {
    code: 21652,
    message: 'Maximum subject length is 40 characters',
    log_level: 'ERROR',
    secondary_message: 'Keep the subject text of your message to 40 characters or less.',
    log_type: null,
    docs: '## Error - 21652\r\n\r\n### Maximum subject text length is 40 characters\r\n\r\nThe subject text of your message should be 40 characters or less.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-08-30T17:32:59Z',
    last_updated: '2020-08-04T10:00:12.742Z',
  },
  40144: {
    code: 40144,
    message: 'TaskRouter->Conference',
    log_level: 'ERROR',
    secondary_message: 'Conference Instruction does not have a pending Reservation for the Task',
    log_type: null,
    docs: '## Error - 40144\r\n\r\n### Reservation is no longer Pending - Conference Instruction\r\n\r\n#### Possible Causes \r\n* The original caller has hungup\r\n* The Task has been moved into a \'canceled\' state\r\n\r\n#### Possible Solutions\r\n*  Make sure the Task created has not been canceled prior to issuing \'conference\' instruction\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:43:10Z',
    last_updated: '2020-08-04T10:00:21.896Z',
  },
  30469: {
    code: 30469,
    message: 'Toll Free verification rejection - Disallowed: Illegal substances/articles',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30469\r\n\r\n### Toll Free verification rejection - Disallowed: Illegal substances/articles\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Illegal substances/articles).\r\n\r\nCannabis, CBD, Kratom, or drug paraphernalia product businesses are prohibited from utilizing SMS/MMS messaging on Twilio in the US and Canada, regardless of content. These restrictions apply regardless of the federal or state legality. All use cases for these are disallowed from sending SMS whether it contains cannabis content or not, even for 2FA purposes it is not permissible for such entities. Illegal substances/articles include, but are not limited to: \r\n\r\n* Cannabis\r\n* CBD\r\n* Kratom\r\n* Paraphernalia products\r\n* Vape/E-cigs\r\n* Fireworks\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Illegal substances/articles).\r\n\r\nCannabis, CBD, Kratom, or drug paraphernalia product businesses are prohibited from utilizing SMS/MMS messaging on Twilio in the US and Canada, regardless of content. These restrictions apply regardless of the federal or state legality. All use cases for these are disallowed from sending SMS whether it contains cannabis content or not, even for 2FA purposes it is not permissible for such entities. Illegal substances/articles include, but are not limited to: \r\n\r\n* Cannabis\r\n* CBD\r\n* Kratom\r\n* Paraphernalia products\r\n* Vape/E-cigs\r\n* Fireworks',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:22:34Z',
    last_updated: '2024-02-22T21:22:34Z',
  },
  45772: {
    code: 45772,
    message: 'Failed to perform operation. Required header is either missing or incorrect.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45772\r\n\r\n### Failed to perform operation. Required header is either missing or incorrect.\r\n\r\n Failed to perform operation. Required header is either missing or incorrect.\r\n\r\n#### Possible Causes\r\nMandatory headers might be missing in the request.\r\n\r\n#### Possible Solutions\r\nProvide all the mandatory headers.',
    causes: 'Mandatory headers might be missing in the request.',
    solutions: 'Provide all the mandatory headers.',
    description: 'Failed to perform operation. Required header is either missing or incorrect.',
    product: 'Flex',
    date_created: '2023-11-22T12:25:30Z',
    last_updated: '2023-11-22T12:25:30Z',
  },
  94201: {
    code: 94201,
    message: 'Transcriptions Settings: encryptionKeySid invalid or not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94201\r\n\r\n### Transcriptions Settings: encryptionKeySid invalid or not found\r\n\r\n Request to enable encryption for transcriptions failed because encryptionKeySid is invalid or not defined\r\n\r\n#### Possible Causes\r\n* "encryptionKeySid" value is invalid\r\n* "encryptionKeySid" not found in Transcription Settings\r\n* "encryptionKeySid" not found in Credentials Storage\r\n* "encryptionKeySid" is not a credential resource of type Public Key\r\n\r\n#### Possible Solutions\r\n* Specify a encryptionKeySid of a valid credential resource of type Public Key that can be used to encrypt transcription results or disable encryption',
    causes:
      '* "encryptionKeySid" value is invalid\r\n* "encryptionKeySid" not found in Transcription Settings\r\n* "encryptionKeySid" not found in Credentials Storage\r\n* "encryptionKeySid" is not a credential resource of type Public Key',
    solutions:
      '* Specify a encryptionKeySid of a valid credential resource of type Public Key that can be used to encrypt transcription results or disable encryption',
    description:
      'Request to enable encryption for transcriptions failed because encryptionKeySid is invalid or not defined',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-02T11:08:56Z',
  },
  80203: {
    code: 80203,
    message: 'No Available Proxy For Country',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 80203\r\n\r\n### No Available Proxy For Country\r\n\r\n This Service has no compatible Proxy numbers for this Participant. \r\n\r\nThis Service has no available Proxy numbers for the participant's number country code <country>.\r\n\r\n#### Possible Causes\r\nThere are no numbers in the Service that can be assigned to this participant's identifier.\r\n\r\n#### Possible Solutions\r\nAdd a Twilio number from your account to the Service that matches the participant's country code. Alternatively, pass the proxyIdentifier's optional property when creating the participant. Please note that international tolls may apply.",
    causes:
      "There are no numbers in the Service that can be assigned to this participant's identifier.",
    solutions:
      "Add a Twilio number from your account to the Service that matches the participant's country code. Alternatively, pass the proxyIdentifier's optional property when creating the participant. Please note that international tolls may apply.",
    description:
      "This Service has no compatible Proxy numbers for this Participant. \r\n\r\nThis Service has no available Proxy numbers for the participant's number country code <country>.",
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.131Z',
  },
  60329: {
    code: 60329,
    message: 'Verify SNA does not work with `psd2_enabled`',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60329\r\n\r\n### Verify SNA does not work with `psd2_enabled`\r\n\r\n The Silent Network Auth channel does not work when `psd2_nabled` is set to `true` for a Verify `Service`.\r\n\r\n#### Possible Causes\r\n- Attempting to create a `Verification` with `channel` set to `sna` under a Verify `Service` with `psd2_enabled` set to `true`.\r\n\r\n#### Possible Solutions\r\n- Do not use `sna` channel for a Verify `Service` with `psd2_enabled` set to `true`.',
    causes:
      '- Attempting to create a `Verification` with `channel` set to `sna` under a Verify `Service` with `psd2_enabled` set to `true`.',
    solutions:
      '- Do not use `sna` channel for a Verify `Service` with `psd2_enabled` set to `true`.',
    description:
      'The Silent Network Auth channel does not work when `psd2_nabled` is set to `true` for a Verify `Service`.',
    product: 'Verify',
    date_created: '2022-07-11T19:05:18Z',
    last_updated: '2022-07-11T19:05:18Z',
  },
  54050: {
    code: 54050,
    message: 'Service Instance not found',
    log_level: 'ERROR',
    secondary_message: 'The specified Service Instance does not exist.',
    log_type: null,
    docs: '\n## Error - 54050\n\n### Sync: Instance not found\nThe specified Service Instance does not exist.\n\n#### Possible Causes\n* The supplied Sync Service Instance SID is erroneous.\n* The requested Sync Service Instance has been deleted.\n\n#### Possible Solutions\n* Use the [Twilio Console](https://twilio.com/console) or the [REST API](https://www.twilio.com/docs/api/sync/rest/services) to confirm your Sync service exists.\n* Make sure the Sync Service Instance SID passed in your request matches the SID of that service exactly.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.718Z',
  },
  30753: {
    code: 30753,
    message: 'Brand Registration Failure: Unsupported email address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30753\r\n\r\n### Brand Registration Failure: Unsupported email address\r\n\r\n You have used an unsupported email address for brand registration\r\n\r\n#### Possible Causes\r\nYou have used an unsupported email address for brand registration\r\n\r\n#### Possible Solutions\r\nPlease use a valid and supported email address.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes: 'You have used an unsupported email address for brand registration',
    solutions:
      'Please use a valid and supported email address.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description: 'You have used an unsupported email address for brand registration',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:45:28Z',
    last_updated: '2024-02-13T16:14:50.47981Z',
  },
  40100: {
    code: 40100,
    message: 'TaskRouter->Reject',
    log_level: 'ERROR',
    secondary_message: 'Your Reject instruction does not include a valid `activity_sid` parameter.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 40100\r\n\r\n### TaskRouter->Reject\r\n\r\nYour Reject instruction does not include a valid `activity_sid` parameter. &nbsp;\r\n\r\n#### Possible Causes\r\n* You did not include an `activity_sid` parameter in your `reject` instruction.\r\n* You did include an `activity_sid` but it was invalid or no longer exists. \r\n\r\n#### Possible Solutions\r\n* Confirm a valid `ActivitySid` value is is being passed by your code into the request payload JSON’s `activity_sid` parameter: `{ "instruction": "reject", "activity_sid": "WA0123456789abcdef0123456789abcdef" }`',
    causes:
      '* You did not include an `activity_sid` parameter in your `reject` instruction.\r\n* You did include an `activity_sid` but it was invalid or no longer exists. ',
    solutions:
      '* Confirm a valid `ActivitySid` value is is being passed by your code into the request payload JSON’s `activity_sid` parameter: `{ "instruction": "reject", "activity_sid": "WA0123456789abcdef0123456789abcdef" }`',
    description: '&nbsp;',
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:39Z',
    last_updated: '2022-09-28T09:43:18.039483Z',
  },
  52138: {
    code: 52138,
    message: 'APNs payload too large',
    log_level: 'ERROR',
    secondary_message: 'Provided payload is too large for APNs',
    log_type: null,
    docs: '## Error - 52138\r\n\r\n### APNs payload too large\r\n\r\n#### Possible Causes \r\n*  Generated APNs payload exceeded limit.\r\n\r\n#### Possible Solutions\r\n*  The maximum payload size allowed for iOS 8+ devices is 2KB for earlier devices it is 256 B. Revise your payload so that it does not exceed this limit.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:38:00Z',
    last_updated: '2020-08-04T10:00:22.087Z',
  },
  50200: {
    code: 50200,
    message: 'Programmable Chat: User not found',
    log_level: 'ERROR',
    secondary_message: 'Specified User does not exist.',
    log_type: null,
    docs: '## Error - 50200\r\n\r\n### Programmable Chat: User not found\r\n\r\n#### Possible Causes \r\n*  Specified User does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:48Z',
    last_updated: '2020-08-04T10:00:23.34Z',
  },
  25202: {
    code: 25202,
    message: 'The role assignment has an invalid role',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25202\r\n\r\n### The role assignment has an invalid role\r\n\r\n The role assignment has an invalid role.\r\n\r\n#### Possible Causes\r\nThe role assignment creation specifies an invalid role.\r\n\r\n#### Possible Solutions\r\nValidate that the role provided is valid. Acceptable roles are:\r\n\r\n- Admin: IX00000000000000000000000000000102\r\n- Developer: IX00000000000000000000000000000103\r\n- Billing: IX00000000000000000000000000000104\r\n- Support: IX00000000000000000000000000000105',
    causes: 'The role assignment creation specifies an invalid role.',
    solutions:
      'Validate that the role provided is valid. Acceptable roles are:\r\n\r\n- Admin: IX00000000000000000000000000000102\r\n- Developer: IX00000000000000000000000000000103\r\n- Billing: IX00000000000000000000000000000104\r\n- Support: IX00000000000000000000000000000105',
    description: 'The role assignment has an invalid role.',
    product: 'Organizations API',
    date_created: '2023-12-04T12:00:38Z',
    last_updated: '2023-12-04T14:28:20.104971Z',
  },
  32100: {
    code: 32100,
    message: 'SIP: Trial accounts can only call verified caller IDs',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: 'You must verify your caller ID on the Console or via the REST API. You must use a verified callerID for both the from and to number while in Trial status. Once you upgrade you can use any caller ID for the from and to number.\r\nYou can verify you caller ID in the Console (https://www.twilio.com/console/phone-numbers/verified)',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2018-03-08T23:50:04Z',
    last_updated: '2020-08-04T10:00:14.623Z',
  },
  30008: {
    code: 30008,
    message: 'Unknown error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 30008\r\n\r\n### Unknown error\r\n\r\n ## Error - 30008\r\n\r\n### Message Delivery - Unknown error\r\n\r\n\r\n#### Possible Causes\r\nIf a message you sent is not delivered to the end device and returns a 30008 error code, this means that delivery of your message failed for unknown reasons.\r\n\r\nWhen Twilio receives a very generic error from our carrier partner that we have no further details about, we associate the message with the error code 30008, letting you know that Twilio truly doesn’t know what caused this error from the provider.\r\n\r\n#### Possible Solutions\r\n* Check that the phone you were sending to is turned on and can receive non-Twilio SMS\r\n* Ensure that the phone is not roaming off network. We cannot guarantee message delivery on roaming phones.\r\n* Try sending to other phones who have the same mobile carrier (you can use our Lookups API to determine the carrier if you’re unsure). If messages to other phones go through, the issue is likely device related. Try rebooting the device or contact the mobile carrier for help.\r\n* If you are sending SMS from an alphanumeric sender ID, see if using a Twilio phone number works better. We’ve observed that certain networks may block alpha sender IDs.\r\n* If the recipient number is another Twilio number, ensure that number has an action configured for its Messaging capabilities. Choose any available option like "Webhook" or "TwiML Bin."\r\n* Try sending a shorter message to the phone, with simple content that does not include any special characters. This would give our support team an idea as to whether the failure is related to concatenation or character encoding.\r\n* Twilio support can help investigate what went wrong with our carriers. Please open a support request and include a minimum of 3 or more message SIDs where a 30008 error was thrown. Per our carriers\' requirements, these SIDs can be no older than 48 hours at most.',
    causes:
      'If a message you sent is not delivered to the end device and returns a 30008 error code, this means that delivery of your message failed for unknown reasons.\r\n\r\nWhen Twilio receives a very generic error from our carrier partner that we have no further details about, we associate the message with the error code 30008, letting you know that Twilio truly doesn’t know what caused this error from the provider.',
    solutions:
      '* Check that the phone you were sending to is turned on and can receive non-Twilio SMS\r\n* Ensure that the phone is not roaming off network. We cannot guarantee message delivery on roaming phones.\r\n* Try sending to other phones who have the same mobile carrier (you can use our Lookups API to determine the carrier if you’re unsure). If messages to other phones go through, the issue is likely device related. Try rebooting the device or contact the mobile carrier for help.\r\n* If you are sending SMS from an alphanumeric sender ID, see if using a Twilio phone number works better. We’ve observed that certain networks may block alpha sender IDs.\r\n* If the recipient number is another Twilio number, ensure that number has an action configured for its Messaging capabilities. Choose any available option like "Webhook" or "TwiML Bin."\r\n* Try sending a shorter message to the phone, with simple content that does not include any special characters. This would give our support team an idea as to whether the failure is related to concatenation or character encoding.\r\n* Twilio support can help investigate what went wrong with our carriers. Please open a support request and include a minimum of 3 or more message SIDs where a 30008 error was thrown. Per our carriers\' requirements, these SIDs can be no older than 48 hours at most.',
    description: '## Error - 30008\r\n\r\n### Message Delivery - Unknown error\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:35Z',
    last_updated: '2023-09-14T23:51:54.44493Z',
  },
  13253: {
    code: 13253,
    message: 'Dial: Header is too long',
    log_level: 'WARNING',
    secondary_message: 'You sent a header that is too long.',
    log_type: null,
    docs: '## Warning - 13253\n\n### Dial: Header is too long\n\nYou sent a header that is too long.\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:09Z',
    last_updated: '2020-08-04T10:00:26.384Z',
  },
  18003: {
    code: 18003,
    message: 'Illegible document submission: submit a clear copy ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18003\r\n\r\n### Illegible document submission: submit a clear copy \r\n\r\n The document you have uploaded is not legible. \r\n\r\n#### Possible Causes\r\nBlur or bad quality image uploaded.\r\n\r\n#### Possible Solutions\r\nPlease re-submit after uploading a clear copy of the supporting document.',
    causes: 'Blur or bad quality image uploaded.',
    solutions: 'Please re-submit after uploading a clear copy of the supporting document.',
    description: 'The document you have uploaded is not legible. ',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:45:47Z',
    last_updated: '2024-07-04T09:46:51.345137Z',
  },
  31102: {
    code: 31102,
    message: 'Authorization token missing in request.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31102\r\n\r\n### Authorization token missing in request.\r\n\r\nAuthorization token missing in request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:42:24Z',
    last_updated: '2020-08-04T10:00:11.207Z',
  },
  19004: {
    code: 19004,
    message: 'Invalid or missing Contact input',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19004\r\n\r\n### Invalid or missing Contact input\r\n\r\n The request body provided has some errors\r\n\r\n#### Possible Causes\r\nA required field is missing, duplicate field or invalid field name.\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'A required field is missing, duplicate field or invalid field name.',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'The request body provided has some errors',
    product: null,
    date_created: '2020-07-21T18:39:38Z',
    last_updated: '2020-08-04T10:00:01.905Z',
  },
  19005: {
    code: 19005,
    message: 'Contact validation error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19005\r\n\r\n### Contact validation error\r\n\r\n The data provided in the request body is invalid\r\n\r\n#### Possible Causes\r\nInvalid string length, invalid data type\r\n\r\n#### Possible Solutions\r\nReview the request body and the API documentation for more information',
    causes: 'Invalid string length, invalid data type',
    solutions: 'Review the request body and the API documentation for more information',
    description: 'The data provided in the request body is invalid',
    product: null,
    date_created: '2020-07-21T18:48:13Z',
    last_updated: '2020-08-04T10:00:01.881Z',
  },
  80201: {
    code: 80201,
    message: 'No Available Voice Proxy',
    log_level: 'WARNING',
    secondary_message:
      'This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having voice capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 80201\r\n\r\n### No Available Voice Proxy\r\n\r\nThis Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having voice capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities. ## Warning\r\n\r\n### No Available Voice Proxy\r\n\r\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having voice capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities.\r\n\r\n#### Possible Causes\r\nYou tried to add a Participant to a Session with a mode that includes voice, but your proxy pool does not include any voice-capable numbers.\r\n\r\n#### Possible Solutions\r\nAdd one or more numbers to your pool that have voice capability.',
    causes:
      'You tried to add a Participant to a Session with a mode that includes voice, but your proxy pool does not include any voice-capable numbers.',
    solutions: 'Add one or more numbers to your pool that have voice capability.',
    description:
      '## Warning\r\n\r\n### No Available Voice Proxy\r\n\r\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having voice capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities.',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2022-02-28T19:09:01.198893Z',
  },
  95006: {
    code: 95006,
    message: 'Media url is empty',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95006\r\n\r\n### Media url is empty\r\n\r\n Twilio failed to create a new transcript due to an empty media url\r\n\r\n#### Possible Causes\r\nCreate transcript requests cannot have an empty media url if no recording is specified.\r\n\r\n#### Possible Solutions\r\nProvide a valid media url.',
    causes:
      'Create transcript requests cannot have an empty media url if no recording is specified.',
    solutions: 'Provide a valid media url.',
    description: 'Twilio failed to create a new transcript due to an empty media url',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:28:33Z',
    last_updated: '2024-04-16T17:28:33Z',
  },
  90019: {
    code: 90019,
    message: "'TemplateArgs' dictionary size is too large",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90019\r\n\r\n### 'TemplateArgs' dictionary size is too large\r\n\r\n 'TemplateArgs' dictionary size is too large\r\n\r\n#### Possible Causes\r\nToo many items in 'TemplateArgs' dictionary\r\n\r\n#### Possible Solutions\r\nUse shorter 'TemplateArgs' dictionary",
    causes: "Too many items in 'TemplateArgs' dictionary",
    solutions: "Use shorter 'TemplateArgs' dictionary",
    description: "'TemplateArgs' dictionary size is too large",
    product: null,
    date_created: '2020-12-11T08:45:09Z',
    last_updated: '2020-12-11T08:45:09Z',
  },
  60370: {
    code: 60370,
    message: 'Factor config invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60370\r\n\r\n### Factor config invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Factor config section in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Factor config in the request body is correct.',
    causes: 'The Factor config section in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Factor config in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-19T11:39:12Z',
    last_updated: '2023-12-19T11:39:12Z',
  },
  25019: {
    code: 25019,
    message: 'Failed to complete request due to a business rule violations',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25019\r\n\r\n### Failed to complete request due to a business rule violations\r\n\r\n Failed to complete request due to a business rule violations.\r\n\r\n#### Possible Causes\r\nThe resource to be modified has moved into a state that is no longer valid.\r\nInput on the request did not pass validation.\r\n\r\n#### Possible Solutions\r\nVerify if the resource to be modified exists and is in a valid state.',
    causes:
      'The resource to be modified has moved into a state that is no longer valid.\r\nInput on the request did not pass validation.',
    solutions: 'Verify if the resource to be modified exists and is in a valid state.',
    description: 'Failed to complete request due to a business rule violations.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:44:18Z',
    last_updated: '2023-12-04T14:23:07.70166Z',
  },
  60533: {
    code: 60533,
    message: 'SNA Carrier Header Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60533\r\n\r\n### SNA Carrier Header Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received but failed during processing due to a missing header from the carrier.\r\n\r\n#### Possible Solutions\r\nRetry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received but failed during processing due to a missing header from the carrier.',
    solutions:
      'Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T17:07:51Z',
    last_updated: '2022-08-30T17:07:51Z',
  },
  45378: {
    code: 45378,
    message: 'Failed to inactivate Channel. Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45378\r\n\r\n### Failed to inactivate Channel. Internal error.\r\n\r\n Failed to inactivate a Channel <channel sid> due to an internal error.\r\n\r\n#### Possible Causes\r\nWe failed to inactive a Channel due to an unexpected error condition.\r\n\r\n#### Possible Solutions\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We failed to inactive a Channel due to an unexpected error condition.',
    solutions:
      'Check our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'Failed to inactivate a Channel <channel sid> due to an internal error.',
    product: 'Flex',
    date_created: '2023-08-28T21:54:17Z',
    last_updated: '2023-08-28T21:57:11.210376Z',
  },
  60238: {
    code: 60238,
    message: 'Verification Creation Attempt blocked by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60238\r\n\r\n### Verification Creation Attempt blocked by Twilio\r\n\r\n The destination number is blocked by Twilio.\r\n\r\n#### Possible Causes\r\nThe destination has a high-risk of fraud or due to regulatory reasons cannot be reached.\r\n\r\n#### Possible Solutions\r\nIf you are facing this error for more than 24 hours, please reach out to our support team.',
    causes:
      'The destination has a high-risk of fraud or due to regulatory reasons cannot be reached.',
    solutions:
      'If you are facing this error for more than 24 hours, please reach out to our support team.',
    description: 'The destination number is blocked by Twilio.',
    product: 'Verify',
    date_created: '2023-10-05T03:20:04Z',
    last_updated: '2023-10-05T17:38:48.212093Z',
  },
  45795: {
    code: 45795,
    message: 'Friendly name must be between 1 and  64 characters long.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45795\r\n\r\n### Friendly name must be between 1 and  64 characters long.\r\n\r\n Friendly name must be between 1 and  64 characters long.\r\n\r\n#### Possible Causes\r\nThe friendly name must consists of at least 1 character and up to a maximum of 64 characters.\r\n\r\n#### Possible Solutions\r\nProvide a friendly name that is between 1 and 64 characters in length.',
    causes:
      'The friendly name must consists of at least 1 character and up to a maximum of 64 characters.',
    solutions: 'Provide a friendly name that is between 1 and 64 characters in length.',
    description: 'Friendly name must be between 1 and  64 characters long.',
    product: 'Flex',
    date_created: '2023-11-23T04:39:05Z',
    last_updated: '2023-11-23T04:39:05Z',
  },
  400: {
    code: 400,
    message: 'Bad Request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 400\r\n\r\n### Bad Request\r\n\r\n Failed to complete request due to a bad request\r\n\r\n#### Possible Causes\r\n* The resource to be modified has moved into a state that is no longer valid.\r\n* Input on the request did not pass validation.\r\n\r\n#### Possible Solutions\r\n* Retry the request after confirming the request is valid.\r\n* Verify if the resource to be modified exists and is in a valid state.',
    causes:
      '* The resource to be modified has moved into a state that is no longer valid.\r\n* Input on the request did not pass validation.',
    solutions:
      '* Retry the request after confirming the request is valid.\r\n* Verify if the resource to be modified exists and is in a valid state.',
    description: 'Failed to complete request due to a bad request',
    product: null,
    date_created: '2020-09-14T21:49:18Z',
    last_updated: '2024-03-11T19:55:06.554471Z',
  },
  30448: {
    code: 30448,
    message: 'Toll-Free phone number verification rejection - Age Gate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30448\r\n\r\n### Toll-Free phone number verification rejection - Age Gate\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe Toll-Free phone number cannot be verified because an Age Gate is not present or is not acceptable on your website and/or opt-in policy.\r\n\r\n#### Possible Solutions\r\n* Add a robust age gate to your website or opt-in policy. Resubmit the toll free verification with the updated age gate information. \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The Toll-Free phone number cannot be verified because an Age Gate is not present or is not acceptable on your website and/or opt-in policy.',
    solutions:
      '* Add a robust age gate to your website or opt-in policy. Resubmit the toll free verification with the updated age gate information. \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:17:08Z',
    last_updated: '2024-04-16T16:28:54.447648Z',
  },
  13520: {
    code: 13520,
    message: 'Say: Invalid text',
    log_level: 'WARNING',
    secondary_message:
      "The text of the Say verb was empty or un-parsable. See the <a href='/docs/api/twiml/say'>Say Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13520 \n\n### Say: Invalid text\n\nThe text of the Say verb was empty or un-parsable. See the <a href='/docs/api/twiml/say'>Say Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:43Z',
    last_updated: '2020-08-04T10:00:27.913Z',
  },
  48024: {
    code: 48024,
    message: 'Contact conversation limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48024\r\n\r\n### Contact conversation limit exceeded\r\n\r\n A Chat conversation could not be created because the Conversations user associated to the given contact is a participant in too many conversations.\r\n\r\n#### Possible Causes\r\n* The Conversations user associated to the given contact attempted to create a conversation over Chat channel and exceeded the Conversations service’s maximum user conversations limit.\r\n\r\n#### Possible Solutions\r\n* If you frequently exceed the user conversations limit for the Frontline Conversations service, you may want to consider raising your user conversations limit.\r\n    * Read more about Conversations API user conversations limits in our [docs](https://www.twilio.com/docs/conversations/conversations-limits#maximum-channelsconversations-per-identity).\r\n    * In order to request a limit increase, please contact [customer support](http://twilio.com/console/support/tickets/create).\r\n* Close or delete conversations the user is a participant in.',
    causes:
      '* The Conversations user associated to the given contact attempted to create a conversation over Chat channel and exceeded the Conversations service’s maximum user conversations limit.',
    solutions:
      '* If you frequently exceed the user conversations limit for the Frontline Conversations service, you may want to consider raising your user conversations limit.\r\n    * Read more about Conversations API user conversations limits in our [docs](https://www.twilio.com/docs/conversations/conversations-limits#maximum-channelsconversations-per-identity).\r\n    * In order to request a limit increase, please contact [customer support](http://twilio.com/console/support/tickets/create).\r\n* Close or delete conversations the user is a participant in.',
    description:
      'A Chat conversation could not be created because the Conversations user associated to the given contact is a participant in too many conversations.',
    product: 'Frontline',
    date_created: '2022-04-20T15:49:36Z',
    last_updated: '2022-05-20T10:01:18.644099Z',
  },
  45210: {
    code: 45210,
    message: 'Flex Flow creation failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45210\r\n\r\n### Flex Flow creation failed\r\n\r\n Flex Flow creation failed.\r\n\r\n#### Possible Causes\r\nRequired Flow attributes were missing from the request or collided with existing Flows.\r\n\r\n#### Possible Solutions\r\nCheck the returned error details for additional info and adjust the request as necessary.',
    causes:
      'Required Flow attributes were missing from the request or collided with existing Flows.',
    solutions:
      'Check the returned error details for additional info and adjust the request as necessary.',
    description: 'Flex Flow creation failed.',
    product: 'Flex',
    date_created: '2022-02-15T13:43:50Z',
    last_updated: '2022-02-15T13:43:50Z',
  },
  60403: {
    code: 60403,
    message: 'Storage Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60403\r\n\r\n### Storage Error\r\n\r\n An error occurred while storing/loading an entity.\r\n\r\n#### Possible Causes\r\n* Storage may be corrupted.\r\n* Factor not found.\r\n\r\n#### Possible Solutions\r\nCreate a new factor.',
    causes: '* Storage may be corrupted.\r\n* Factor not found.',
    solutions: 'Create a new factor.',
    description: 'An error occurred while storing/loading an entity.',
    product: 'Verify',
    date_created: '2021-03-15T20:44:48Z',
    last_updated: '2021-03-15T20:44:48Z',
  },
  45402: {
    code: 45402,
    message: 'RTA feed callback response time exceeded the threshold',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45402\r\n\r\n### RTA feed callback response time exceeded the threshold\r\n\r\n The RTA Feed callback is taking longer than a defined threshold to respond\r\n\r\n#### Possible Causes\r\nIssues on WFM vendor side\r\n\r\n#### Possible Solutions\r\nPlease contact the WFM Vendor for troubleshooting',
    causes: 'Issues on WFM vendor side',
    solutions: 'Please contact the WFM Vendor for troubleshooting',
    description: 'The RTA Feed callback is taking longer than a defined threshold to respond',
    product: 'Flex',
    date_created: '2021-06-17T12:12:55Z',
    last_updated: '2021-06-17T12:12:55Z',
  },
  31941: {
    code: 31941,
    message: 'Stream - Invalid Track configuration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31941\r\n\r\n### Stream - Invalid Track configuration\r\n\r\n Unsupported value of track attribute in TwiML\r\n\r\n#### Possible Causes\r\n* Value different of "inbound_track" is used with verb Connect\r\n* Value different of "inbound_track", "outbound_track" or "both_tracks" is used with verb Start\r\n\r\n#### Possible Solutions\r\n* Make sure track value is among supported ones',
    causes:
      '* Value different of "inbound_track" is used with verb Connect\r\n* Value different of "inbound_track", "outbound_track" or "both_tracks" is used with verb Start',
    solutions: '* Make sure track value is among supported ones',
    description: 'Unsupported value of track attribute in TwiML',
    product: 'Programmable Voice',
    date_created: '2020-07-08T15:08:40Z',
    last_updated: '2020-09-22T06:33:24.959Z',
  },
  22132: {
    code: 22132,
    message: 'Not Portable - Already in Twilio different owner',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22132\r\n\r\n### Not Portable - Already in Twilio different owner\r\n\r\n \r\n\r\n#### Possible Causes\r\nPhone number already exists on another Twilio account. \r\n\r\n#### Possible Solutions\r\nSee this [support page](https://support.twilio.com/hc/en-us/articles/223135327-Moving-Twilio-Phone-Numbers-to-another-Twilio-Account) for more information on how to move the line to your account.',
    causes: 'Phone number already exists on another Twilio account. ',
    solutions:
      'See this [support page](https://support.twilio.com/hc/en-us/articles/223135327-Moving-Twilio-Phone-Numbers-to-another-Twilio-Account) for more information on how to move the line to your account.',
    description: null,
    product: 'Phone Numbers',
    date_created: '2023-06-22T18:43:44Z',
    last_updated: '2023-06-28T15:30:21.56685Z',
  },
  54151: {
    code: 54151,
    message: 'List Item not found',
    log_level: 'ERROR',
    secondary_message: 'The specified List Item does not exist.',
    log_type: null,
    docs: '\n## Error - 54151\n\n### Sync: List Item not found\nThe specified List Item does not exist.\n\n#### Possible Causes\n* The specified Sync List item index is incorrect.\n* The requested item of a Sync List has been deleted.\n\n#### Possible Solutions\nConfirm a valid Sync List index is being passed in your request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.567Z',
  },
  21609: {
    code: 21609,
    message: "Invalid 'StatusCallback'",
    log_level: 'ERROR',
    secondary_message:
      'StatusCallback must be a valid HTTP(s) URL.  The maximum length of the StatusCallback is 4000 characters.',
    log_type: null,
    docs: '## Error - 21609\n\n### Invalid StatusCallback URL\n\nThe `StatusCallback` URL provided is not a valid URL. \n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:06Z',
    last_updated: '2020-08-04T10:00:26.59Z',
  },
  30042: {
    code: 30042,
    message: 'The Sender ID is blocked as generic or it contains special characters',
    log_level: 'ERROR',
    secondary_message: 'Compliance issue in destination',
    log_type: 'CARRIER',
    docs: '## ERROR - 30042\r\n\r\n### The Sender ID is blocked as generic or it contains special characters\r\n\r\nCompliance issue in destination The Sender ID has been blocked for being generic by Twilio’s service provider, containing non compliant special characters or relating to fraudulent activities.\r\n\r\n#### Possible Causes\r\nYou are using a Sender ID that is not compliant with SMS guidelines\r\n\r\n#### Possible Solutions\r\nPlease review the SMS guidelines and use a Sender ID that is compliant with SMS guidelines',
    causes: 'You are using a Sender ID that is not compliant with SMS guidelines',
    solutions:
      'Please review the SMS guidelines and use a Sender ID that is compliant with SMS guidelines',
    description:
      'The Sender ID has been blocked for being generic by Twilio’s service provider, containing non compliant special characters or relating to fraudulent activities.',
    product: 'Programmable SMS',
    date_created: '2023-09-14T15:58:03Z',
    last_updated: '2023-09-21T21:25:27.869192Z',
  },
  45785: {
    code: 45785,
    message: 'Internal Error. Failed to delete deployment keys.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45785\r\n\r\n### Internal Error. Failed to delete deployment keys.\r\n\r\n An unexpected error occurred when processing delete all deployment keys request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when deleting deployment keys.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when deleting deployment keys.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing delete all deployment keys request.',
    product: 'Flex',
    date_created: '2023-11-23T04:15:09Z',
    last_updated: '2023-11-23T04:15:09Z',
  },
  13338: {
    code: 13338,
    message: 'Gather: Invalid actionOnEmptyResult value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13338\r\n\r\n### Gather: Invalid actionOnEmptyResult value\r\n\r\n Defined action on Gather verb is invalid or empty\r\n\r\n#### Possible Causes\r\nDefined action on Gather verb is invalid or empty\r\n\r\n#### Possible Solutions\r\nCorrect action on Gather verb',
    causes: 'Defined action on Gather verb is invalid or empty',
    solutions: 'Correct action on Gather verb',
    description: 'Defined action on Gather verb is invalid or empty',
    product: 'Programmable Voice',
    date_created: '2020-03-11T00:00:34Z',
    last_updated: '2020-08-04T10:00:04.288Z',
  },
  52170: {
    code: 52170,
    message: 'Too many Webhook Credential requests',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52170\r\n\r\n### Too many Webhook Credential requests\r\n\r\n#### Possible Causes \r\n*  You are sending Notifications too quickly\r\n*  Your Webhook Credentials are not being cached correctly\r\n\r\n#### Possible Solutions\r\n*  Rate limit your requests accordingly\r\n*  Verify the contents of your token endpoint response',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T12:04:59Z',
    last_updated: '2020-08-04T10:00:14.217Z',
  },
  64001: {
    code: 64001,
    message: 'Pay: Configuration Error',
    log_level: 'ERROR',
    secondary_message: 'Failed to retrieve connector configuration.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 64001\r\n\r\n### Pay: Configuration Error\r\n\r\nFailed to retrieve connector configuration. ## Error - 64001\r\n\r\n### Pay: Configuration Error\r\n\r\nA 64001 Error is an indication there is something wrong with the &lt;Pay&gt; connector configuration.\r\n\r\n#### Possible Causes\r\n* Credentials were removed from configuration.\r\n* Credentials were modified and are not matching the Connector Type.\r\n* Configuration is missing Credentials.\r\n* Configuration contains invalid attributes.\r\n\r\n#### Possible Solutions\r\n* Recreate your &lt;Pay&gt; connector configuration.',
    causes:
      '* Credentials were removed from configuration.\r\n* Credentials were modified and are not matching the Connector Type.\r\n* Configuration is missing Credentials.\r\n* Configuration contains invalid attributes.',
    solutions: '* Recreate your &lt;Pay&gt; connector configuration.',
    description:
      '## Error - 64001\r\n\r\n### Pay: Configuration Error\r\n\r\nA 64001 Error is an indication there is something wrong with the &lt;Pay&gt; connector configuration.',
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:51:39Z',
    last_updated: '2020-08-04T10:00:10.373Z',
  },
  22101: {
    code: 22101,
    message: 'Invalid Hosted Number Order SIDs',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22101\r\n\r\n### Invalid Hosted Number Order SIDs\r\n\r\nYou attempted to create or update an Authorization Document with one or more invalid Hosted Number Order SIDs. \r\n\r\n#### Possible Causes\r\n\r\n* No Hosted Number Order SIDs were provided when creating the Authorization Document.\r\n\r\n* One or more of the SIDs provided is not a 34-character string that is prefixed with "HR".\r\n\r\n\r\n\r\n#### Possible Solutions\r\nPlease specify Hosted Number Order SIDs you\'ve created in your [Account Dashboard](https://www.twilio.com/console/phone-numbers/hosted).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-16T00:38:03Z',
    last_updated: '2020-08-04T10:00:14.87Z',
  },
  51121: {
    code: 51121,
    message: 'Twilsock: Token expiration time exceeds maximum',
    log_level: 'ERROR',
    secondary_message: 'Token expiration time exceeds max allowed amount.',
    log_type: null,
    docs: '## Error - 51121\r\n\r\n### Token expiration time exceeds maximum\r\n\r\n#### Possible Causes \r\nToken expiration time exceeds max allowed amount.\r\n\r\n#### Possible Solutions\r\nUse a proper expiration time to fit into the allowed range.\r\n\r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:21:21Z',
    last_updated: '2020-08-04T10:00:09.532Z',
  },
  32401: {
    code: 32401,
    message: 'BYOC Trunk routing failure - failover to Twilio default routing.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32401\r\n\r\n### BYOC Trunk routing failure - failover to Twilio default routing.\r\n\r\n Call delivery attempt(s) over the specified BYOC Trunk did not succeed. Failover to Twilio default routing took place.\r\n\r\n#### Possible Causes\r\nTwilio encountered errors communicating with your SIP communications infrastructure.\r\n\r\n#### Possible Solutions\r\nLook for errors with error code [32011](/docs/api/errors/32011), Error communicating with your SIP communications infrastructure, and follow instructions.',
    causes: 'Twilio encountered errors communicating with your SIP communications infrastructure.',
    solutions:
      'Look for errors with error code [32011](/docs/api/errors/32011), Error communicating with your SIP communications infrastructure, and follow instructions.',
    description:
      'Call delivery attempt(s) over the specified BYOC Trunk did not succeed. Failover to Twilio default routing took place.',
    product: 'Programmable Voice',
    date_created: '2020-03-16T21:30:57Z',
    last_updated: '2020-08-04T10:00:04.207Z',
  },
  50703: {
    code: 50703,
    message: 'DialogflowCX provider must contain module sid and addon sid.',
    log_level: 'ERROR',
    secondary_message: 'DialogflowCX provider must contain module sid and addon sid.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50703\r\n\r\n### DialogflowCX provider must contain module sid and addon sid.\r\n\r\nDialogflowCX provider must contain module sid and addon sid. \r\n\r\n#### Possible Causes\r\nEither ChatbotConfiguration.ModuleSid or ChatbotConfiguration.ModuleSid are not specified for DialogflowCX Virtual Agent participant.\r\n\r\n#### Possible Solutions\r\n* If you try to create DialogflowCX provider, you must specify ChatbotConfiguration.ModuleSid and ChatbotConfiguration.ModuleSid.',
    causes:
      'Either ChatbotConfiguration.ModuleSid or ChatbotConfiguration.ModuleSid are not specified for DialogflowCX Virtual Agent participant.',
    solutions:
      '* If you try to create DialogflowCX provider, you must specify ChatbotConfiguration.ModuleSid and ChatbotConfiguration.ModuleSid.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:00:18Z',
    last_updated: '2023-10-11T18:00:18Z',
  },
  84002: {
    code: 84002,
    message: 'Workflow execution failed. ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 84002\r\n\r\n### Workflow execution failed. \r\n\r\n Workflow execution failed.\r\n\r\n#### Possible Causes\r\n- Possible downstream exceptions.\r\n\r\n#### Possible Solutions\r\n- Check error payload for the error message.',
    causes: '- Possible downstream exceptions.',
    solutions: '- Check error payload for the error message.',
    description: 'Workflow execution failed.',
    product: null,
    date_created: '2024-01-10T18:10:07Z',
    last_updated: '2024-01-10T18:10:07Z',
  },
  63021: {
    code: 63021,
    message: 'Channel invalid content error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63021\r\n\r\n### Channel invalid content error\r\n\r\n Message contains content that is rejected or unsupported by the messaging channel.\r\n\r\n#### Possible Causes\r\n* Unable to upload the media used in the message because it is not supported by the messaging channel.\r\n* Length of the parameters and the template text exceeds the allowed length of 1024 for WhatsApp.\r\n\r\n#### Possible Solutions\r\n* Inspect the media files being sent and confirm their MIME type is in fact supported by the messaging channel. \r\n* Confirm WhatsApp template sends do not exceed 1024 characters, which can occur when placeholder text substitutions or translations are too long.',
    causes:
      '* Unable to upload the media used in the message because it is not supported by the messaging channel.\r\n* Length of the parameters and the template text exceeds the allowed length of 1024 for WhatsApp.',
    solutions:
      '* Inspect the media files being sent and confirm their MIME type is in fact supported by the messaging channel. \r\n* Confirm WhatsApp template sends do not exceed 1024 characters, which can occur when placeholder text substitutions or translations are too long.',
    description:
      'Message contains content that is rejected or unsupported by the messaging channel.',
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:28:04Z',
    last_updated: '2024-02-29T05:52:50.999529Z',
  },
  21624: {
    code: 21624,
    message: 'Invalid validity period value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 21624\r\n\r\n### Invalid validity period value\r\n\r\nValidity period can only be set to integers between 1 and 14,400 seconds (4 hours max).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2017-05-18T21:39:00Z',
    last_updated: '2020-08-04T10:00:18.572Z',
  },
  30449: {
    code: 30449,
    message: 'Toll Free verification rejection - URL issues in sample message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30449\r\n\r\n### Toll Free verification rejection - URL issues in sample message\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the website URL in the sample message that you submitted was either from a public URL shortener or is non-secure.\r\n\r\nLinks to websites embedded within a message cannot conceal or obscure the Message Sender’s identity and are not intended to cause harm or deceive Consumers. A website URL used in messaging must be a dedicated custom domain that belongs to your business, not a free shared public link shortener.The domain must align with the message sender identified in the text message itself. Web addresses contained in messages as well as any websites to which they redirect should unambiguously identify the website owner (i.e., a person or legally registered business entity) and include contact information, such as a postal mailing address.\r\n\r\n#### Possible Solutions\r\n* Replace call to action (CTA) in sample message with a branded URL. Resubmit the toll free verification with an updated sample message.  \r\n* Ensure that any URL's sent in messages are not sent from a public URL shortener.\r\n* Consider utilizing Twilio’s Link Shortening to programmatically shorten long links with your own company branded domain. \r\n\r\n[Link Shortening](https://help.twilio.com/articles/1260804572090-How-can-I-send-shortened-URLs-links-in-my-messages)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)",
    causes:
      'The toll-free phone number cannot be verified because the website URL in the sample message that you submitted was either from a public URL shortener or is non-secure.\r\n\r\nLinks to websites embedded within a message cannot conceal or obscure the Message Sender’s identity and are not intended to cause harm or deceive Consumers. A website URL used in messaging must be a dedicated custom domain that belongs to your business, not a free shared public link shortener.The domain must align with the message sender identified in the text message itself. Web addresses contained in messages as well as any websites to which they redirect should unambiguously identify the website owner (i.e., a person or legally registered business entity) and include contact information, such as a postal mailing address.',
    solutions:
      "* Replace call to action (CTA) in sample message with a branded URL. Resubmit the toll free verification with an updated sample message.  \r\n* Ensure that any URL's sent in messages are not sent from a public URL shortener.\r\n* Consider utilizing Twilio’s Link Shortening to programmatically shorten long links with your own company branded domain. \r\n\r\n[Link Shortening](https://help.twilio.com/articles/1260804572090-How-can-I-send-shortened-URLs-links-in-my-messages)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)",
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:18:36Z',
    last_updated: '2024-04-16T16:35:47.055729Z',
  },
  53613: {
    code: 53613,
    message: 'AWS credentials to access external S3 bucket could not be loaded',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53613\r\n\r\n### AWS credentials to access external S3 bucket could not be loaded\r\n\r\nThe AWS credentials configured in your account's recording settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\nThis is most likely due to the fact that the AWS Credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, create and assign a new credentials entry for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-05-24T13:33:22Z',
    last_updated: '2020-08-04T10:00:13.648Z',
  },
  11310: {
    code: 11310,
    message: 'Invalid template token',
    log_level: 'ERROR',
    secondary_message: 'The provided URL template references a nonexistent token.',
    log_type: null,
    docs: '## Error - 11310 \n\n### Invalid template token\n\nThe provided URL template references a nonexistent token.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:27Z',
    last_updated: '2020-08-04T10:00:29.24Z',
  },
  40149: {
    code: 40149,
    message: 'Failed to issue Conference instruction due to missing ‘conference_sid’',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40149\r\n\r\n### Failed to issue Conference instruction due to missing ‘conference_sid’\r\n\r\n The conference instruction issued as a result of the transfer can only be issued on a task which has a `conference_sid` in its attributes.\r\n\r\n#### Possible Causes\r\n* The Conference instruction was issued on the wrong Task.\r\n* The Task attributes were modified and no longer contain the `conference_sid` property.\r\n\r\n#### Possible Solutions\r\n* Confirm the Conference instruction is issued on the correct voice Task.\r\n* Ensure that the `conference_sid` is present in the Task’s attributes.',
    causes:
      '* The Conference instruction was issued on the wrong Task.\r\n* The Task attributes were modified and no longer contain the `conference_sid` property.',
    solutions:
      '* Confirm the Conference instruction is issued on the correct voice Task.\r\n* Ensure that the `conference_sid` is present in the Task’s attributes.',
    description:
      'The conference instruction issued as a result of the transfer can only be issued on a task which has a `conference_sid` in its attributes.',
    product: 'TaskRouter',
    date_created: '2020-09-14T21:48:16Z',
    last_updated: '2020-09-14T21:48:16Z',
  },
  83004: {
    code: 83004,
    message: 'Super SIM update operation failed due to Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 83004\r\n\r\n### Super SIM update operation failed due to Internal Error\r\n\r\n Your Super SIM update request has caused an internal error that is not further specified.\r\n\r\n#### Possible Causes\r\n* An unspecified error occurred while updating your Super SIM.\r\n\r\n#### Possible Solutions\r\n* Retry updating your Super SIM.\r\n* If you continue to experience this issue, please contact Twilio Support.',
    causes: '* An unspecified error occurred while updating your Super SIM.',
    solutions:
      '* Retry updating your Super SIM.\r\n* If you continue to experience this issue, please contact Twilio Support.',
    description:
      'Your Super SIM update request has caused an internal error that is not further specified.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:21:33Z',
    last_updated: '2021-08-23T11:21:33Z',
  },
  45004: {
    code: 45004,
    message: 'Validation Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45004\r\n\r\n### Validation Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequest body validation fails.\r\n\r\n#### Possible Solutions\r\nReview the input and fix (if possible) the problem mentioned in the error message.',
    causes: 'Request body validation fails.',
    solutions: 'Review the input and fix (if possible) the problem mentioned in the error message.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:52:05Z',
    last_updated: '2020-08-04T10:00:12.429Z',
  },
  54150: {
    code: 54150,
    message: 'List not found',
    log_level: 'ERROR',
    secondary_message: 'The specified List does not exist.',
    log_type: null,
    docs: "\n## Error - 54150\n\n### Sync: List not found\nThe specified List does not exist.\n\n#### Possible Causes\n* The supplied Sync List SID is erroneous.\n* The requested Sync List has been deleted.\n\n#### Possible Solutions\nConfirm that the list you're requesting exists, and that you are using the precise SID or unique name it is assigned.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.587Z',
  },
  22201: {
    code: 22201,
    message: 'No regulation sid found for the given number group',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22201\r\n\r\n### No regulation sid found for the given number group\r\n\r\n No regulation sid found for the given number group\r\n\r\n#### Possible Causes\r\nThe regulation sid may be misspelled or belong to another account.\r\n\r\n#### Possible Solutions\r\nUse the Regulations LIST resource with filters to find the correct Number Group.',
    causes: 'The regulation sid may be misspelled or belong to another account.',
    solutions: 'Use the Regulations LIST resource with filters to find the correct Number Group.',
    description: 'No regulation sid found for the given number group',
    product: 'Phone Numbers',
    date_created: '2019-12-24T18:40:58Z',
    last_updated: '2020-08-04T10:00:05.699Z',
  },
  60387: {
    code: 60387,
    message: 'Attested credential data invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60387\r\n\r\n### Attested credential data invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Attested credential data in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Attested credential data in the request body is correct.',
    causes: 'The Attested credential data in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Attested credential data in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:57:51Z',
    last_updated: '2023-12-27T09:57:51Z',
  },
  22100: {
    code: 22100,
    message: 'Reached Maximum Verification Attempts',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22100\r\n\r\n### Reached Maximum Verification Attempts\r\n\r\nYou have reached maximum verification attempts on this Hosted Number Order. Please reach out to hostedsms@twilio.com to reset the verification attempts.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-13T01:37:23Z',
    last_updated: '2020-08-04T10:00:14.887Z',
  },
  60531: {
    code: 60531,
    message: 'SNA Carrier Not Detected',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60531\r\n\r\n### SNA Carrier Not Detected\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received and failed due to being unable to identify the carrier from the detected IP address. This can happen if the end user is connected to WiFi during the Verification process.\r\n\r\n#### Possible Solutions\r\n- Check that the mobile client is using a mobile data connection to invoke the SNA URL, not WiFi.\n- Retry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The Verification request was received and failed due to being unable to identify the carrier from the detected IP address. This can happen if the end user is connected to WiFi during the Verification process.',
    solutions:
      '- Check that the mobile client is using a mobile data connection to invoke the SNA URL, not WiFi.\n- Retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T17:00:49Z',
    last_updated: '2022-08-30T17:00:49Z',
  },
  60008: {
    code: 60008,
    message: 'Unsupported Carrier',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60008\r\n\r\n### Unsupported Carrier\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request was received and failed due to the phone number’s carrier not supporting this endpoint.\r\n\r\n#### Possible Solutions\r\n- Complete the [Account Security Registration](https://interactive.twilio.com/account-security-registration-form?_ga=2.40477419.894088021.1660748067-1879743973.1650468405) form to use this carrier.\r\n- If you have completed the Account Security Registration form, [contact Twilio Support](https://www.twilio.com/help/contact) to confirm that you are approved.\r\n- If you have completed the Account Security Registration form and it has been approved, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.\r\n- If using Silent Network Auth, retry Verification using a channel other than Silent Network Auth for this end user.',
    causes:
      'The request was received and failed due to the phone number’s carrier not supporting this endpoint.',
    solutions:
      '- Complete the [Account Security Registration](https://interactive.twilio.com/account-security-registration-form?_ga=2.40477419.894088021.1660748067-1879743973.1650468405) form to use this carrier.\r\n- If you have completed the Account Security Registration form, [contact Twilio Support](https://www.twilio.com/help/contact) to confirm that you are approved.\r\n- If you have completed the Account Security Registration form and it has been approved, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.\r\n- If using Silent Network Auth, retry Verification using a channel other than Silent Network Auth for this end user.',
    description: null,
    product: null,
    date_created: '2022-09-06T13:17:31.60648Z',
    last_updated: '2023-01-05T16:47:04.326814Z',
  },
  50402: {
    code: 50402,
    message: 'Programmable Chat: Member not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Member does not exist.',
    log_type: null,
    docs: '## Error - 500402\r\n\r\n### Programmable Chat: Member not found\r\n\r\n#### Possible Causes \r\n*  Specified Member does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Member is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:52Z',
    last_updated: '2020-08-04T10:00:23.014Z',
  },
  30790: {
    code: 30790,
    message: 'Brand Registration Failure: Internal system error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30790\r\n\r\n### Brand Registration Failure: Internal system error\r\n\r\n There was an internal system error when processing brand registration request.\r\n\r\n#### Possible Causes\r\nThere was an internal system error when processing brand registration request.\r\n\r\n#### Possible Solutions\r\nPlease contact Twilio Support.',
    causes: 'There was an internal system error when processing brand registration request.',
    solutions: 'Please contact Twilio Support.',
    description: 'There was an internal system error when processing brand registration request.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:48:10Z',
    last_updated: '2024-02-12T08:48:10Z',
  },
  31205: {
    code: 31205,
    message: 'JWT token expired.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31205\r\n\r\n### JWT token expired.\r\n\r\nJWT token expired.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:47:32Z',
    last_updated: '2020-08-04T10:00:11.078Z',
  },
  45372: {
    code: 45372,
    message: 'Failed to add Participant.  Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45372\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'We failed to add a Participant to a Channel due to an unexpected error condition.',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'Failed to add a Participant to Channel <channel sid> due to an internal error.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:10.566489Z',
  },
  30459: {
    code: 30459,
    message: 'Toll Free verification rejection - Disallowed: Cannabis/CBD',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30459\r\n\r\n### Toll Free verification rejection - Disallowed: Cannabis/CBD\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Illegal Substances/articles: Cannabis/CBD).\r\n\r\nMessages related to cannabis are not allowed in the United States as federal laws prohibit its sale, even though some states have legalized it. Similarly, messages related to CBD are not permissible in the United States, as certain states prohibit its sale. Twilio defines a cannabis message as any message which relates to the marketing or sale of a cannabis product, regardless of whether or not those messages explicitly contain cannabis terms, images, or links to cannabis websites.\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Illegal Substances/articles: Cannabis/CBD).\r\n\r\nMessages related to cannabis are not allowed in the United States as federal laws prohibit its sale, even though some states have legalized it. Similarly, messages related to CBD are not permissible in the United States, as certain states prohibit its sale. Twilio defines a cannabis message as any message which relates to the marketing or sale of a cannabis product, regardless of whether or not those messages explicitly contain cannabis terms, images, or links to cannabis websites.',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T01:16:05Z',
    last_updated: '2024-02-22T01:16:05Z',
  },
  50432: {
    code: 50432,
    message: 'Participant not found',
    log_level: 'ERROR',
    secondary_message: 'The requested conversation participant SID was not found.',
    log_type: null,
    docs: '\n## Error - 50432\n\n### Conversations: Participant not found\nThe requested conversation participant SID was not found.\n\n#### Possible Causes\n* The participant SID you are requesting does not exist in this conversation.\n\n#### Possible Solutions\n* Check that the requested participant SID is not misspelled.\n* Check that the requested participant SID was added to this conversation. Use REST API to [fetch a list](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) of existing conversation participants.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.334Z',
  },
  80613: {
    code: 80613,
    message: 'Downstream Request Rejected',
    log_level: 'ERROR',
    secondary_message: 'A downstream service rejected a request from Proxy on your behalf.',
    log_type: 'TWILIO',
    docs: '## ERROR - 80613\r\n\r\n### Downstream Request Rejected\r\n\r\nA downstream service rejected a request from Proxy on your behalf. A downstream service rejected a request from Proxy while processing a request for your service.\r\n\r\n#### Possible Causes\r\nUnknown.  You may be able to find more information if the downstream emitted any debugger notifications for the request.\r\n\r\n#### Possible Solutions\r\nUnknown.  You may be able to find more information if the downstream emitted any debugger notifications for the request.',
    causes:
      'Unknown.  You may be able to find more information if the downstream emitted any debugger notifications for the request.',
    solutions:
      'Unknown.  You may be able to find more information if the downstream emitted any debugger notifications for the request.',
    description:
      'A downstream service rejected a request from Proxy while processing a request for your service.',
    product: 'Proxy',
    date_created: '2018-04-10T03:31:04Z',
    last_updated: '2020-08-04T10:00:13.932Z',
  },
  62023: {
    code: 62023,
    message: 'Missing exchange',
    log_level: 'ERROR',
    secondary_message: 'The request did not specify an exchange SID.',
    log_type: null,
    docs: '## Error - 62023\r\n\r\n### Missing exchange\r\n\r\nThe request did not specify an exchange SID. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:48:43Z',
    last_updated: '2020-08-04T10:00:20.771Z',
  },
  53400: {
    code: 53400,
    message: 'Client is unable to create or apply a local media description',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53400: Client is unable to create or apply a local media description\r\n\r\nRaised whenever a Client is unable to create or apply a local media description.\r\n\r\n#### Causes\r\n\r\n * The Client may not be using a supported WebRTC implementation.\r\n * The Client may not have the necessary resources to create or apply a new media description.\r\n\r\n#### Solutions\r\n\r\n * If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T21:58:38Z',
    last_updated: '2020-08-04T10:00:19.328Z',
  },
  30795: {
    code: 30795,
    message:
      'Brand Registration Feedback: Data mismatch related to tax id and its associated properties.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30795\r\n\r\n### Brand Registration Feedback: Data mismatch related to tax id and its associated properties.\r\n\r\n Your Brand has received feedback from The Campaign Registry upon registration. This Brand Registration can not be used for campaign creation until the provided feedback has been addressed. In this particular case, there is a data mismatch related to the Tax ID that was provided during the registration and its associated properties such as business legal name.\r\n\r\n#### Possible Causes\r\n* The submitted US EIN is invalid. \r\n* The submitted Canadian government ID cannot be verified.\r\n* The submitted foreign government ID cannot be verified.\r\n* The submitted legal company name does not match with US EIN. \r\n* The submitted legal company name does not match with the Canadian government ID. \r\n* The submitted legal company name does not match with foreign government ID. \r\n* The submitted US EIN appears to be a US SSN.\r\n\r\n\r\n#### Possible Solutions\r\nPlease edit your customer profile and update the business registration identifier with correct information that matches your tax returns. Please also make sure that your legal company name also matches the tax documents.\r\n\r\nAdditional help resources:\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    causes:
      '* The submitted US EIN is invalid. \r\n* The submitted Canadian government ID cannot be verified.\r\n* The submitted foreign government ID cannot be verified.\r\n* The submitted legal company name does not match with US EIN. \r\n* The submitted legal company name does not match with the Canadian government ID. \r\n* The submitted legal company name does not match with foreign government ID. \r\n* The submitted US EIN appears to be a US SSN.\r\n',
    solutions:
      'Please edit your customer profile and update the business registration identifier with correct information that matches your tax returns. Please also make sure that your legal company name also matches the tax documents.\r\n\r\nAdditional help resources:\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    description:
      'Your Brand has received feedback from The Campaign Registry upon registration. This Brand Registration can not be used for campaign creation until the provided feedback has been addressed. In this particular case, there is a data mismatch related to the Tax ID that was provided during the registration and its associated properties such as business legal name.',
    product: 'Programmable Messaging',
    date_created: '2024-02-28T16:27:09Z',
    last_updated: '2024-06-04T15:33:35.297504Z',
  },
  45211: {
    code: 45211,
    message: 'Provided identity is reserved by system',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45211\r\n\r\n### Provided identity is reserved by system\r\n\r\n Provided identity is reserved by system.\r\n\r\n#### Possible Causes\r\nWill pop up when users try to create a new channel with a reserved identity.\r\n\r\n#### Possible Solutions\r\nChange the identity field in the request and try again',
    causes: 'Will pop up when users try to create a new channel with a reserved identity.',
    solutions: 'Change the identity field in the request and try again',
    description: 'Provided identity is reserved by system.',
    product: 'Flex',
    date_created: '2020-08-10T12:49:03Z',
    last_updated: '2020-08-10T12:49:03Z',
  },
  40131: {
    code: 40131,
    message: 'TaskRouter->Dequeue',
    log_level: 'ERROR',
    secondary_message: "Dequeue Instruction does not have a valid 'to' parameter provided.",
    log_type: null,
    docs: '## Error - 40131\r\n\r\n### Missing or Invalid \'to\' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "to" parameter on your \'dequeue\' instruction.\r\n*  You provided an invalid format in your "to" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a valid phone number, client URI, or SIP URI. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:42Z',
    last_updated: '2020-08-04T10:00:23.878Z',
  },
  60722: {
    code: 60722,
    message: 'Business status does not allow dismissal',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60722\r\n\r\n### Business status does not allow dismissal\r\n\r\n Businesses (AKA Business Profiles) can only be dismissed when they have certain status values. Dismissing a business will set its status to "Draft".\r\n\r\n#### Possible Causes\r\nYou sent a dismiss request for a business that is in status "Draft" or "Rejected".\r\n\r\n\r\n#### Possible Solutions\r\nYou\'re only interested in dismissing a business to update its information before being vetted by Twilio\'s vetting team, or if you want to remove its verified status.\r\nTo dismiss the business its status must be one of "Pending Verification" or "Verified".',
    causes:
      'You sent a dismiss request for a business that is in status "Draft" or "Rejected".\r\n',
    solutions:
      'You\'re only interested in dismissing a business to update its information before being vetted by Twilio\'s vetting team, or if you want to remove its verified status.\r\nTo dismiss the business its status must be one of "Pending Verification" or "Verified".',
    description:
      'Businesses (AKA Business Profiles) can only be dismissed when they have certain status values. Dismissing a business will set its status to "Draft".',
    product: 'Branded Comms',
    date_created: '2020-01-24T20:34:04Z',
    last_updated: '2020-08-04T10:00:04.816Z',
  },
  83604: {
    code: 83604,
    message:
      'The requested query period exceeds the maximum allowed period for the requested Granularity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83604\r\n\r\n### The requested query period exceeds the maximum allowed period for the requested Granularity\r\n\r\n Requests for Usage Records with granularity "all" may only query up to 18 months of data, granularity "day" may query up to 3 months of data, and granularity "hour" may query up to 31 days of data.\r\n\r\n#### Possible Causes\r\n  * This happens if you request Usage Records with StartTime or EndTime parameters defining a time range exceeding the maximum allowed threshold for a given Granularity.\r\n\r\n#### Possible Solutions\r\n * Adjust your StartTime or EndTime parameters so that the time range is less than or equal to the threshold allowed for the desired Granularity.',
    causes:
      '  * This happens if you request Usage Records with StartTime or EndTime parameters defining a time range exceeding the maximum allowed threshold for a given Granularity.',
    solutions:
      ' * Adjust your StartTime or EndTime parameters so that the time range is less than or equal to the threshold allowed for the desired Granularity.',
    description:
      'Requests for Usage Records with granularity "all" may only query up to 18 months of data, granularity "day" may query up to 3 months of data, and granularity "hour" may query up to 31 days of data.',
    product: 'Super SIM',
    date_created: '2021-08-19T13:16:11Z',
    last_updated: '2021-08-19T13:42:39.164624Z',
  },
  94300: {
    code: 94300,
    message: 'Transcriptions Configurations: Invalid callback configuration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94300\r\n\r\n### Transcriptions Configurations: Invalid callback configuration\r\n\r\n Invalid callback configuration, either to create a new configuration or update existing one. A valid Url and Method must be specified to enable callbacks via HTTP request (webhook) and receive transcriptions status updates.\r\n\r\n#### Possible Causes\r\n* Invalid Callback "Url" value\r\n* Invalid Callback "Method" value\r\n\r\n#### Possible Solutions\r\n* Callback "Url" value should be valid Http(s) url format \r\n* Callback "Method" value should be either POST or GET \r\n* Disable callback by setting “Url” to ‘’ value (empty string)',
    causes: '* Invalid Callback "Url" value\r\n* Invalid Callback "Method" value',
    solutions:
      '* Callback "Url" value should be valid Http(s) url format \r\n* Callback "Method" value should be either POST or GET \r\n* Disable callback by setting “Url” to ‘’ value (empty string)',
    description:
      'Invalid callback configuration, either to create a new configuration or update existing one. A valid Url and Method must be specified to enable callbacks via HTTP request (webhook) and receive transcriptions status updates.',
    product: null,
    date_created: '2021-09-02T10:44:42Z',
    last_updated: '2021-11-26T10:48:12.175208Z',
  },
  48010: {
    code: 48010,
    message: 'Custom Routing Callback failed to execute successfully',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48010\r\n\r\n### Custom Routing Callback failed to execute successfully\r\n\r\n \r\n\r\n#### Possible Causes\r\n- The callback endpoint returned an error code.\r\n- The callback processing is exceeding 10 seconds.\r\n\r\n#### Possible Solutions\r\n- Check your callback execution logic to ensure it is processing the callback calls correctly and passing back 200 OK.\r\n- Make sure that callback processing time is less than 10 seconds.',
    causes:
      '- The callback endpoint returned an error code.\r\n- The callback processing is exceeding 10 seconds.',
    solutions:
      '- Check your callback execution logic to ensure it is processing the callback calls correctly and passing back 200 OK.\r\n- Make sure that callback processing time is less than 10 seconds.',
    description: null,
    product: 'Frontline',
    date_created: '2021-11-18T11:10:26Z',
    last_updated: '2021-11-18T11:10:26Z',
  },
  51112: {
    code: 51112,
    message: 'Twilsock: Product usage disabled',
    log_level: 'ERROR',
    secondary_message: 'Product usage has been disabled for this instance.',
    log_type: null,
    docs: '## Error - 51112\r\n\r\n### Product usage disabled\r\n\r\n#### Possible Causes \r\nProduct usage has been disabled for this instance.\r\n\r\n#### Possible Solutions\r\nIf you are sure the service instance and product are correct, please contact with Customer Support.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:46:58Z',
    last_updated: '2020-08-04T10:00:09.718Z',
  },
  45353: {
    code: 45353,
    message: 'A duplicate create Channel request was dropped.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45353\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'Multiple concurrent inbound messages to a non-existent conversation triggered multiple create Channel requests for the same Conversation. The duplicate request was dropped.',
    solutions: 'No Action.\r',
    description:
      'The Conversation sid <conversation sid> already has a mapped Channel sid <channel sid>.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:28.290319Z',
  },
  50367: {
    code: 50367,
    message: 'Invalid conversation webhook flow SID',
    log_level: 'ERROR',
    secondary_message: 'An invalid conversation webhook flow SID was supplied.',
    log_type: null,
    docs: '\n## Error - 50367\n\n### Conversations: Invalid conversation webhook flow SID\nAn invalid conversation webhook flow SID was supplied.\n\n#### Possible Causes\n* Webhook Configuration.FlowSid parameter provided with the request does not match a valid Studio flow SID pattern (FWxx).\n\n#### Possible Solutions\n* Add a valid Configuration.FlowSid parameter to the API request and supply a Studio flow SID that exists under your account.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.712Z',
  },
  50527: {
    code: 50527,
    message: 'Invalid content variables format',
    log_level: 'ERROR',
    secondary_message: 'Specified content variables value is invalid JSON object',
    log_type: 'TWILIO',
    docs: '## ERROR - 50527\r\n\r\n### Invalid content variables format\r\n\r\nSpecified content variables value is invalid JSON object An invalid value was specified for the message content variables\r\n\r\n#### Possible Causes\r\nContent variables value is invalid JSON object\r\n\r\n#### Possible Solutions\r\nMessage content variables value should be a valid JSON object.',
    causes: 'Content variables value is invalid JSON object',
    solutions: 'Message content variables value should be a valid JSON object.',
    description: 'An invalid value was specified for the message content variables',
    product: 'Conversations',
    date_created: '2022-11-23T13:35:06Z',
    last_updated: '2022-11-23T13:35:06Z',
  },
  80910: {
    code: 80910,
    message: 'Message To Voice Only Session Rejected',
    log_level: 'WARNING',
    secondary_message: 'Example Message: Inbound message to voice-only session rejected.',
    log_type: null,
    docs: '## Warning\r\n\r\n### Message To Voice Only Session Rejected\r\n\r\nExample Message: Inbound message to voice-only session rejected.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-03-12T15:28:21Z',
    last_updated: '2020-08-04T10:00:14.588Z',
  },
  94301: {
    code: 94301,
    message: 'Transcriptions Configurations: UniqueName is required',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94301\r\n\r\n### Transcriptions Configurations: UniqueName is required\r\n\r\n A UniqueName is required to create a new configuration\r\n\r\n#### Possible Causes\r\n* "UniqueName" is blank\r\n* "UniqueName" is null\r\n\r\n#### Possible Solutions\r\n* Specify a valid "UniqueName" for transcription configuration',
    causes: '* "UniqueName" is blank\r\n* "UniqueName" is null',
    solutions: '* Specify a valid "UniqueName" for transcription configuration',
    description: 'A UniqueName is required to create a new configuration',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-02T10:48:51Z',
  },
  31003: {
    code: 31003,
    message: 'Connection timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31003\r\n\r\n### Connection timeout\r\n\r\nThe server could not produce a response within a suitable amount of time',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:26:00Z',
    last_updated: '2020-08-04T10:00:11.468Z',
  },
  21234: {
    code: 21234,
    message: 'Invalid Machine Detection configuration value',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound call, but you provided a Machine Detection configuration value that is not allowed',
    log_type: null,
    docs: '## Error - 21234\r\n\r\n### Invalid Machine Detection configuration value\r\n\r\nYou attempted to initiate an outbound call, but you provided a Machine Detection configuration value that is not allowed',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-02-04T23:25:55Z',
    last_updated: '2020-08-04T10:00:10.743Z',
  },
  30437: {
    code: 30437,
    message: 'Toll Free verification rejection - Edit time expired',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30437\r\n\r\n### Toll Free verification rejection - Edit time expired\r\n\r\n The rejected toll-free verification time window has reached the 7 day expiration. An edit is accepted, but the toll-free number remains unverified and the submission is no longer prioritized, so time to process is similar to a new submission. Effective Nov 8, 2023, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\n#### Possible Causes\r\nThere were no edits to the verification within 7 days of its rejection.\r\n\r\n#### Possible Solutions\r\nEdit and re-submit the toll-free verification. The resubmission will still be received, but it is handled as a new submission, so the review will take slightly longer.\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes: 'There were no edits to the verification within 7 days of its rejection.',
    solutions:
      'Edit and re-submit the toll-free verification. The resubmission will still be received, but it is handled as a new submission, so the review will take slightly longer.\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The rejected toll-free verification time window has reached the 7 day expiration. An edit is accepted, but the toll-free number remains unverified and the submission is no longer prioritized, so time to process is similar to a new submission. Effective Nov 8, 2023, messaging traffic on this Toll-Free number is blocked until it’s verified.',
    product: 'Programmable Messaging',
    date_created: '2023-05-18T18:16:32Z',
    last_updated: '2024-04-16T16:41:31.814855Z',
  },
  62018: {
    code: 62018,
    message: 'Invalid IP route',
    log_level: 'ERROR',
    secondary_message:
      'The request provided an invalid IP route. The IP route must be a valid formed CIDR address that does not exist within the RFC 1918 address space.',
    log_type: null,
    docs: '## Error - 62018\r\n\r\n### Invalid IP route\r\n\r\nThe request provided an invalid IP route. The IP route must be a valid formed CIDR address that does not exist within the RFC 1918 address space.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:43:42Z',
    last_updated: '2020-08-04T10:00:20.863Z',
  },
  54007: {
    code: 54007,
    message: 'Access forbidden for identity',
    log_level: 'ERROR',
    secondary_message:
      'The identity specified in the Access Token does not have permissions to perform this operation.',
    log_type: null,
    docs: "\n## Error - 54007\n\n### Sync: Access forbidden for identity\nThe identity specified in the Access Token does not have permissions to perform this operation.\n\n#### Possible Causes\n* Sync's ACL control has been unintentionally enabled on your Sync service instance.\n* An SDK endpoint trying to read or write a Sync object does not have the correct permission configured.\n* The identity you specified in your SDK's token does not match the permissions that you intended for them.\n\n#### Possible Solutions\n* Disable the ACL feature on this Sync service. This will allow access from any SDK with a valid token.\nDo this by either unchecking the AclEnabled feature in the [Twilio Console](https://www.twilio.com/console/sync/services), or setting the `acl_enabled` flag to `false` via the [Sync REST API](https://www.twilio.com/docs/api/sync/rest/services).\n* Confirm a valid permission is configured via the [Sync Permissions REST API](https://www.twilio.com/docs/api/sync/rest/sync-rest-api-permissions), and that the configured identity matches the identity you provide in your FPA Access Tokens.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.789Z',
  },
  20005: {
    code: 20005,
    message: 'Account not active',
    log_level: 'ERROR',
    secondary_message:
      'Your Twilio account is not active, potentially because you ran out of funds, or you have not yet activated your free trial.',
    log_type: null,
    docs: '## Error - 20005 \n\n### Account not active\n\nYour Twilio account is not active, potentially because you ran out of funds, or you have not yet activated your free trial.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:52Z',
    last_updated: '2020-08-04T10:00:27.391Z',
  },
  53125: {
    code: 53125,
    message: 'The track kind is not supported by the Room',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53125\r\n\r\n### The track kind is not supported by the Room\r\n\r\n Raised whenever a participant tries to publish a track or connects with a track that is not supported by the Group Room.\r\n\r\n#### Possible Causes\r\nA participant tried to publish a video track in an Audio Only Group Room.\r\nA participant tried to connect with a video track in an Audio Only Group Room.\r\n\r\n#### Possible Solutions\r\nMake sure that only audio and/or data tracks are published in an Audio Only Group Room.',
    causes:
      'A participant tried to publish a video track in an Audio Only Group Room.\r\nA participant tried to connect with a video track in an Audio Only Group Room.',
    solutions:
      'Make sure that only audio and/or data tracks are published in an Audio Only Group Room.',
    description:
      'Raised whenever a participant tries to publish a track or connects with a track that is not supported by the Group Room.',
    product: 'Programmable Video',
    date_created: '2021-10-13T16:36:10Z',
    last_updated: '2021-10-13T16:36:30.63987Z',
  },
  50055: {
    code: 50055,
    message: 'Programmable Chat: Invalid webhook method',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain valid HTTP method for webhook.',
    log_type: null,
    docs: '## Error - 50055\r\n\r\n### Programmable Chat: Invalid webhook method\r\n\r\n#### Possible Causes \r\n*  Request does not contain valid HTTP method for webhook.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid HTTP method for webhook is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:45Z',
    last_updated: '2020-08-04T10:00:23.535Z',
  },
  48004: {
    code: 48004,
    message: 'Callback returned an error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48004\r\n\r\n### Callback returned an error\r\n\r\n \r\n\r\n#### Possible Causes\r\nYour callback returned an error response, the Callback URL provided might be wrong or callback endpoint might be failing to process request.\r\n\r\n#### Possible Solutions\r\nMake sure that Callback URL and endpoint is correct and you have a running web server at that URL.',
    causes:
      'Your callback returned an error response, the Callback URL provided might be wrong or callback endpoint might be failing to process request.',
    solutions:
      'Make sure that Callback URL and endpoint is correct and you have a running web server at that URL.',
    description: null,
    product: 'Frontline',
    date_created: '2021-09-24T08:07:57Z',
    last_updated: '2021-09-24T08:07:57Z',
  },
  32110: {
    code: 32110,
    message: 'SIP: URI is formatted incorrectly',
    log_level: 'WARNING',
    secondary_message: 'Your SIP URI cannot be parsed unambiguously.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 32110\r\n\r\n### SIP: URI is formatted incorrectly\r\n\r\nYour SIP URI cannot be parsed unambiguously. Twilio cannot understand parts of your SIP URI. This may be due to invalid characters appearing in the user, params, or headers portion. While Twilio may still attempt to complete your call, the parts of the URI that are invalid will be ignored.\r\n\r\nThe format for a valid SIP URI is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).\r\n\r\n#### Possible Causes\r\n* The user-portion of the URI contains invalid characters. The user-info portion allows alphanumeric characters, hyphens, underscores, and a small number of additional punctuation characters.\r\n* A URI header or parameter value contains punctuation or whitespace that is not escaped.\r\n\r\n#### Possible Solutions\r\n* If you specify SIP headers in your URI, ensure any non-alphanumeric characters in the header values are escaped. For example, to add a User-to-User header with value `0A1B2C3D;encoding=hex`, you must encode this into the URI as `User-to-User=0A1B2C3D%3Bencoding%3Dhex`.',
    causes:
      '* The user-portion of the URI contains invalid characters. The user-info portion allows alphanumeric characters, hyphens, underscores, and a small number of additional punctuation characters.\r\n* A URI header or parameter value contains punctuation or whitespace that is not escaped.',
    solutions:
      '* If you specify SIP headers in your URI, ensure any non-alphanumeric characters in the header values are escaped. For example, to add a User-to-User header with value `0A1B2C3D;encoding=hex`, you must encode this into the URI as `User-to-User=0A1B2C3D%3Bencoding%3Dhex`.',
    description:
      'Twilio cannot understand parts of your SIP URI. This may be due to invalid characters appearing in the user, params, or headers portion. While Twilio may still attempt to complete your call, the parts of the URI that are invalid will be ignored.\r\n\r\nThe format for a valid SIP URI is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).',
    product: null,
    date_created: '2019-06-13T20:30:14Z',
    last_updated: '2020-08-04T10:00:07.965Z',
  },
  45305: {
    code: 45305,
    message: ' No answer from Participant',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45305\r\n\r\n###  No answer from Participant\r\n\r\n No media response from user\r\n\r\n#### Possible Causes\r\nInactive user\r\n\r\n#### Possible Solutions\r\nRetry operation.',
    causes: 'Inactive user',
    solutions: 'Retry operation.',
    description: 'No media response from user',
    product: 'Flex',
    date_created: '2020-01-14T21:14:37Z',
    last_updated: '2020-08-04T10:00:05.293Z',
  },
  83006: {
    code: 83006,
    message: 'Super SIM’s Target Fleet not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83006\r\n\r\n### Super SIM’s Target Fleet not found\r\n\r\n Your Super SIM cannot be assigned to the target Fleet because the Fleet could not be found.\r\n\r\n#### Possible Causes\r\n* The defined Fleet’s SID or Unique Name does not exist.\r\n\r\n#### Possible Solutions\r\n* Ensure that the defined Fleet SID or Unique Name is present in your Account.',
    causes: '* The defined Fleet’s SID or Unique Name does not exist.',
    solutions: '* Ensure that the defined Fleet SID or Unique Name is present in your Account.',
    description:
      'Your Super SIM cannot be assigned to the target Fleet because the Fleet could not be found.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:23:24Z',
    last_updated: '2021-08-23T11:23:32.753371Z',
  },
  52403: {
    code: 52403,
    message: 'Provided text template in the notification request cannot be parsed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 52403\r\n\r\n### Provided text template in the notification request cannot be parsed\r\n\r\n An error may arise if the provided text template in the notification request cannot be parsed, potentially due to syntax errors in the input.\r\n\r\n#### Possible Causes\r\nThe error might be attributed to syntax errors within the provided text template.\r\n\r\n#### Possible Solutions\r\nTo identify the precise issue, customers are advised to examine the debugger logs in the console for detailed error messages.',
    causes: 'The error might be attributed to syntax errors within the provided text template.',
    solutions:
      'To identify the precise issue, customers are advised to examine the debugger logs in the console for detailed error messages.',
    description:
      'An error may arise if the provided text template in the notification request cannot be parsed, potentially due to syntax errors in the input.',
    product: 'Notify',
    date_created: '2024-03-19T15:57:13Z',
    last_updated: '2024-03-19T15:57:13Z',
  },
  40141: {
    code: 40141,
    message: 'TaskRouter->Conference',
    log_level: 'ERROR',
    secondary_message: "Conference Instruction does not have a valid 'from' parameter provided.",
    log_type: null,
    docs: '## Error - 40141\r\n\r\n### Missing or Invalid \'from\' parameter - Conference Instruction\r\n\r\n#### Possible Causes\r\n*  You did not provide a \'from\' parameter on your \'conference\' instruction.\r\n*  You provided an invalid format in your "from" field.\r\n\r\n#### Possible Solutions\r\n*  Make certain \'from\' contains a validated caller ID if you\'re dialing the PSTN.\r\n*  Make certain \'from\' contains an acceptable caller field.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:40:13Z',
    last_updated: '2020-08-04T10:00:21.951Z',
  },
  22150: {
    code: 22150,
    message: 'Port In Error - Contact support required',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 22150\r\n\r\n### Port In Error - Contact support required\r\n\r\n There was an error during the port in process. \r\n\r\n#### Possible Causes\r\nThere was an error during the port in process.\r\n\r\n#### Possible Solutions\r\nPlease contact Twilio's Porting Operations team at porting@twilio.com for support.",
    causes: 'There was an error during the port in process.',
    solutions: "Please contact Twilio's Porting Operations team at porting@twilio.com for support.",
    description: 'There was an error during the port in process. ',
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:00:57Z',
    last_updated: '2024-04-22T23:00:57Z',
  },
  53111: {
    code: 53111,
    message: 'StatusCallback is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53111: StatusCallback is invalid\r\n\r\nRaised in the REST API when StatusCallback is not a valid URL or the url is too long.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with StatusCallback set to an invalid URL.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallback to a valid URL less than 1024 characters or leave blank to disable callbacks.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:46:02Z',
    last_updated: '2020-08-04T10:00:19.5Z',
  },
  31105: {
    code: 31105,
    message: 'Invalid client name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31105\r\n\r\n### Invalid client name\r\n\r\n Client name should not contain control, space, delims, or unwise characters and should not be longer than 256 characters.\r\n\r\n#### Possible Causes\r\nClient name contains invalid characters or is longer than 256 characters.\r\n\r\n#### Possible Solutions\r\nMake sure that client name does not contain any of the invalid characters and length is at most 256 characters.',
    causes: 'Client name contains invalid characters or is longer than 256 characters.',
    solutions:
      'Make sure that client name does not contain any of the invalid characters and length is at most 256 characters.',
    description:
      'Client name should not contain control, space, delims, or unwise characters and should not be longer than 256 characters.',
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:44:47Z',
    last_updated: '2024-03-21T17:55:41.165195Z',
  },
  50061: {
    code: 50061,
    message: 'Programmable Chat: Invalid channel members limit format',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for channel members limit',
    log_type: null,
    docs: '## Error - 50061\r\n\r\n### Programmable Chat: Invalid channel members limit format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for channel members limit.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid channel members limit parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T07:57:43Z',
    last_updated: '2020-08-04T10:00:16.744Z',
  },
  32504: {
    code: 32504,
    message: 'Voice Conversation: Incomplete Conversation.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32504\r\n\r\n### Voice Conversation: Incomplete Conversation.\r\n\r\n Existing Conversation did not have a Frontline worker participant. \r\n\r\n#### Possible Causes\r\n- Issue with Frontline routing configuration that caused no worker assigned.\r\n- Conversation might not have been created by the Frontline service. This error indicates that the code is directly using Conversation API to the create the conversation, and Frontline cannot determine the format of the call.\r\n- Something went wrong when the Conversation was created by the Frontline worker or admin. \r\n\r\n#### Possible Solutions\r\n- Check that your routing is set up properly in your Frontline Console page and delete this Conversation using the Conversation API.',
    causes:
      '- Issue with Frontline routing configuration that caused no worker assigned.\r\n- Conversation might not have been created by the Frontline service. This error indicates that the code is directly using Conversation API to the create the conversation, and Frontline cannot determine the format of the call.\r\n- Something went wrong when the Conversation was created by the Frontline worker or admin. ',
    solutions:
      '- Check that your routing is set up properly in your Frontline Console page and delete this Conversation using the Conversation API.',
    description: 'Existing Conversation did not have a Frontline worker participant. ',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:39:56Z',
    last_updated: '2022-07-29T16:33:57.696303Z',
  },
  51120: {
    code: 51120,
    message: 'Twilsock: Token is not valid yet',
    log_level: 'ERROR',
    secondary_message: 'Token is not valid yet',
    log_type: null,
    docs: '## Error - 51120\r\n\r\n### Token is not valid yet',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:11:57Z',
    last_updated: '2020-08-04T10:00:09.549Z',
  },
  80305: {
    code: 80305,
    message: 'Not Found Unmanaged Identifier Sid',
    log_level: 'ERROR',
    secondary_message:
      'Unmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). If you want to include channels such as Facebook Messenger, WhatsApp, etc. as Proxy participants, you must configure the channel integration callback url to point to your proxy service: https://webhooks.twilio.com/v1/Accounts/<AccountSid>/Proxy/<ServiceSid>/Webhooks/Message',
    log_type: null,
    docs: '## Error\r\n\r\n### Not Found Unmanaged Identifier Sid\r\n\r\nExample Message: Unmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). If you want to include channels such as Facebook Messenger, WhatsApp, etc. as Proxy participants, you must configure the channel integration callback url to point to your proxy service: https://webhooks.twilio.com/v1/Accounts/{AccountSid}/Proxy/{ServiceSid}/Webhooks/Message',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-09-18T20:08:16Z',
    last_updated: '2020-08-04T10:00:12.665Z',
  },
  50004: {
    code: 50004,
    message: 'Programmable Chat: Unique Name too long',
    log_level: 'ERROR',
    secondary_message: 'Specified unique name is too long',
    log_type: null,
    docs: '## Error - 50004\r\n\r\n### Programmable Chat: Unique Name too long\r\n\r\n#### Possible Causes \r\n*  Specified unique name is too long\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid UniqueName is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2019-02-06T13:22:43Z',
    last_updated: '2020-08-04T10:00:10.709Z',
  },
  50610: {
    code: 50610,
    message: 'Address configuration deleted',
    log_level: 'WARNING',
    secondary_message: 'Address configuration was deleted which affects auto-create functionality',
    log_type: 'APPLICATION',
    docs: '## WARNING - 50610\r\n\r\n### Address configuration deleted\r\n\r\nAddress configuration was deleted which affects auto-create functionality \r\n\r\n#### Possible Causes\r\nThe Twilio phone number associated with the address configuration was either released or ported out\r\n\r\n#### Possible Solutions\r\n ',
    causes:
      'The Twilio phone number associated with the address configuration was either released or ported out',
    solutions: ' ',
    description: null,
    product: 'Programmable Chat',
    date_created: '2022-02-22T14:49:23Z',
    last_updated: '2022-02-22T14:49:23Z',
  },
  14231: {
    code: 14231,
    message: 'Dial->Conference: Provided Attributes was not valid JSON ',
    log_level: 'ERROR',
    secondary_message: 'Provided attributes is not valid JSON',
    log_type: null,
    docs: '## Error - 14231\r\n\r\n### Conference: Provided Attributes JSON was not valid\r\n\r\nProvided Attributes is not valid JSON.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:45:43Z',
    last_updated: '2020-08-04T10:00:21.844Z',
  },
  60239: {
    code: 60239,
    message: 'BYOT feature is not enabled',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## WARNING - 60239\r\n\r\n### BYOT feature is not enabled\r\n\r\n Your account doesn't have access to use Bring your Own templates (BYOT). The verification was sent using default templates.\r\n\r\n#### Possible Causes\r\nThe BYOT feature is not enabled on your account.\r\n\r\n#### Possible Solutions\r\nIf you need access to the BYOT feature please contact Twilio Support.",
    causes: 'The BYOT feature is not enabled on your account.',
    solutions: 'If you need access to the BYOT feature please contact Twilio Support.',
    description:
      "Your account doesn't have access to use Bring your Own templates (BYOT). The verification was sent using default templates.",
    product: 'Verify',
    date_created: '2023-10-24T17:30:01Z',
    last_updated: '2023-10-25T12:45:36.892359Z',
  },
  55555: {
    code: 55555,
    message: 'Invalid Instruction passed to TaskRouter',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 55555\r\n\r\n### Invalid Instruction passed to TaskRouter\r\n\r\n An invalid instruction was passed to TaskRouter when responding to a pending Reservation.\r\n\r\n#### Possible Causes\r\n* An invalid instruction was passed to TaskRouter.\r\n\r\n\r\n#### Possible Solutions\r\n* Ensure only valid instructions are being used. A list of valid instructions can be found at https://www.twilio.com/docs/taskrouter/api/reservations#action-update',
    causes: '* An invalid instruction was passed to TaskRouter.\r\n',
    solutions:
      '* Ensure only valid instructions are being used. A list of valid instructions can be found at https://www.twilio.com/docs/taskrouter/api/reservations#action-update',
    description:
      'An invalid instruction was passed to TaskRouter when responding to a pending Reservation.',
    product: 'TaskRouter',
    date_created: '2020-09-14T21:57:37Z',
    last_updated: '2020-09-14T21:57:37Z',
  },
  33120: {
    code: 33120,
    message: 'SIM connectivity reset in progress',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 33120\r\n\r\n### SIM connectivity reset in progress\r\n\r\n Raised whenever a SIM connectivity reset is in progress while another SIM connectivity reset is requested.\r\n\r\n\r\n#### Possible Causes\r\n * The SIM you requested has already a connectivity reset in progress which must complete before resetting again.\r\n\r\n\r\n#### Possible Solutions\r\n * Try again later and ensure the SIM's `ResetStatus` is not `resetting`.\r\n",
    causes:
      ' * The SIM you requested has already a connectivity reset in progress which must complete before resetting again.\r\n',
    solutions: " * Try again later and ensure the SIM's `ResetStatus` is not `resetting`.\r\n",
    description:
      'Raised whenever a SIM connectivity reset is in progress while another SIM connectivity reset is requested.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:23:57Z',
    last_updated: '2020-09-15T11:23:57Z',
  },
  50305: {
    code: 50305,
    message: 'Programmable Chat: Channel SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Channel SID parameter.',
    log_type: null,
    docs: '## Error - 50305\r\n\r\n### Programmable Chat: Channel SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Channel SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:51Z',
    last_updated: '2020-08-04T10:00:23.131Z',
  },
  21230: {
    code: 21230,
    message: 'Maximum Domains Reached',
    log_level: 'ERROR',
    secondary_message: 'An account cannot have more than 100 domains.',
    log_type: null,
    docs: '# Error - 21230\n\n### Maximum Domains Reached\n\nAn account cannot have more than 100 domains.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:31Z',
    last_updated: '2020-08-04T10:00:24.744Z',
  },
  21262: {
    code: 21262,
    message: 'No AMD status callback URL provided',
    log_level: 'WARNING',
    secondary_message:
      'No Answering Machine Detection status callback URL was provided for this call.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 21262\r\n\r\n### No AMD status callback URL provided\r\n\r\nNo Answering Machine Detection status callback URL was provided for this call. Answering Machine Detection was enabled on this call, but no AMD status callback URL was provided, so Twilio has no where to send the results when they are returned. AMD results will still be available in the /Calls resource once the call is complete.\r\n\r\n#### Possible Causes\r\nNo AMD status callback URL was provided\r\n\r\n#### Possible Solutions\r\nProvide an AMD status callback URL when enabling Answering Machine Detection',
    causes: 'No AMD status callback URL was provided',
    solutions: 'Provide an AMD status callback URL when enabling Answering Machine Detection',
    description:
      'Answering Machine Detection was enabled on this call, but no AMD status callback URL was provided, so Twilio has no where to send the results when they are returned. AMD results will still be available in the /Calls resource once the call is complete.',
    product: 'Programmable Voice',
    date_created: '2022-08-25T01:37:10Z',
    last_updated: '2022-08-25T01:37:23.376615Z',
  },
  45777: {
    code: 45777,
    message: 'Address Configuration not found for deployment key.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45777\r\n\r\n### Address Configuration not found for deployment key.\r\n\r\n Address Configuration not found for deployment key.\r\n\r\n#### Possible Causes\r\nNo address configuration is linked with the given deployment key.\r\n\r\n#### Possible Solutions\r\nEnsure the deployment key is correct and there exists a valid address configuration Sid associated with it.',
    causes: 'No address configuration is linked with the given deployment key.',
    solutions:
      'Ensure the deployment key is correct and there exists a valid address configuration Sid associated with it.',
    description: 'Address Configuration not found for deployment key.',
    product: 'Flex',
    date_created: '2023-11-22T15:55:48Z',
    last_updated: '2023-11-22T15:55:48Z',
  },
  22173: {
    code: 22173,
    message: 'Port In Error - Invalid Address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22173\r\n\r\n### Port In Error - Invalid Address\r\n\r\n Given Address SID does not exist for your account or is invalid.\r\n\r\n#### Possible Causes\r\nGiven Address SID does not exist for your account or is invalid.\r\n\r\n#### Possible Solutions\r\nUpdate the Address SID to one that exists or check the account you are using.',
    causes: 'Given Address SID does not exist for your account or is invalid.',
    solutions: 'Update the Address SID to one that exists or check the account you are using.',
    description: 'Given Address SID does not exist for your account or is invalid.',
    product: 'Phone Numbers',
    date_created: '2024-05-03T17:00:43Z',
    last_updated: '2024-05-03T17:00:43Z',
  },
  62000: {
    code: 62000,
    message: 'Failed to write to the database.',
    log_level: 'ERROR',
    secondary_message:
      'An internal error occurred, and the service was unable to write data relevant to your request.',
    log_type: null,
    docs: '## Error - 62000\r\n\r\n### Failed to write to the database.\r\n\r\nAn internal error occurred, and the service was unable to write data relevant\r\nto your request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T20:25:16Z',
    last_updated: '2020-08-04T10:00:21.244Z',
  },
  90038: {
    code: 90038,
    message: "'BroadcastStatusCallbackUrl' is invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90038\r\n\r\n### 'BroadcastStatusCallbackUrl' is invalid\r\n\r\n 'BroadcastStatusCallbackUrl' is invalid\r\n\r\n#### Possible Causes\r\n'BroadcastStatusCallbackUrl' has no Url format or schema is incorrect. Broadcast allows only http and https schemas\r\n\r\n#### Possible Solutions\r\nUse valid http or https url",
    causes:
      "'BroadcastStatusCallbackUrl' has no Url format or schema is incorrect. Broadcast allows only http and https schemas",
    solutions: 'Use valid http or https url',
    description: "'BroadcastStatusCallbackUrl' is invalid",
    product: null,
    date_created: '2020-12-11T15:51:11Z',
    last_updated: '2020-12-11T15:51:11Z',
  },
  21214: {
    code: 21214,
    message: "'To' phone number cannot be reached",
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call to a phone number that cannot be reached. Please check the number and try again.',
    log_type: null,
    docs: "## Error - 21214 \n\n### 'To' phone number cannot be reached\n\nYou attempted to initiate an outbound phone call to a phone number that cannot\nbe reached. Please check the number and try again.  \n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:15Z',
    last_updated: '2020-08-04T10:00:25.879Z',
  },
  52141: {
    code: 52141,
    message: 'The provided APNs device token has been unregistered',
    log_level: 'ERROR',
    secondary_message: 'The device token specified is inactive for the specified topic.',
    log_type: null,
    docs: '## Error - 52141\r\n\r\n### The provided APNs device token has been unregistered\r\n\r\n#### Possible Causes \r\n*  APNs notification delivery rejected because the app has either been uninstalled or notifications have been disabled.\r\n#### Possible Solutions\r\n* If the offending Binding still exists, remove it manually or avoid sending Notifications to it.\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-01-04T11:14:58Z',
    last_updated: '2020-08-04T10:00:15.405Z',
  },
  53607: {
    code: 53607,
    message: 'Internal failure when updating the recording resource',
    log_level: 'WARNING',
    secondary_message: 'A new attempt will be made after a delay',
    log_type: null,
    docs: '## Warning - 53607\r\n\r\n### Internal failure when updating the recording resource\r\n\r\nRaised when an error prevented us from updating an internal resource tracking the media recording.\r\n\r\nThe recording\'s media will not be accessible directly from Twilio until we remediate the situation but the media file has probably been stored safely to S3.\r\n\r\n#### Causes\r\n\r\n* An internal error prevented us from updating a resource. We\'ll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-29T13:07:16Z',
    last_updated: '2020-08-04T10:00:13.002Z',
  },
  53003: {
    code: 53003,
    message: 'Client received an invalid signaling message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53003: Client received an invalid signaling message\r\n\r\nRaised whenever the Client receives a message from the Server that the Client cannot handle.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:38:53Z',
    last_updated: '2020-08-04T10:00:19.704Z',
  },
  63034: {
    code: 63034,
    message: 'Media exceeds size limit',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63034\r\n\r\n### Media exceeds size limit\r\n\r\n The specified message media exceeds the maximum size limit. You may re-attempt with media of size 5 MB or less.\r\n\r\n#### Possible Causes\r\nThe specified message media exceeds the maximum size limit.\r\n\r\n#### Possible Solutions\r\nRe-attempt with media of size 5 MB or less.',
    causes: 'The specified message media exceeds the maximum size limit.',
    solutions: 'Re-attempt with media of size 5 MB or less.',
    description:
      'The specified message media exceeds the maximum size limit. You may re-attempt with media of size 5 MB or less.',
    product: 'Programmable SMS',
    date_created: '2019-08-19T22:20:28Z',
    last_updated: '2020-08-04T10:00:07.211Z',
  },
  32700: {
    code: 32700,
    message: 'Voice User-Defined Message: Internal Twilio Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 32700\r\n\r\n### Voice User-Defined Message: Internal Twilio Error\r\n\r\n Twilio experienced an unexpected internal error in attempting to deliver an User-Defined Message event to the Voice SDK client.\r\n\r\n#### Possible Causes\r\n* An error occurred during communication with Twilio internal services.\r\n\r\n#### Possible Solutions\r\n* See the Debugger in the Twilio Console for more information. If you repeatedly receive this error, please contact Twilio Support.',
    causes: '* An error occurred during communication with Twilio internal services.',
    solutions:
      '* See the Debugger in the Twilio Console for more information. If you repeatedly receive this error, please contact Twilio Support.',
    description:
      'Twilio experienced an unexpected internal error in attempting to deliver an User-Defined Message event to the Voice SDK client.',
    product: 'Programmable Voice',
    date_created: '2022-08-18T21:39:35Z',
    last_updated: '2022-08-18T23:57:16.687711Z',
  },
  81022: {
    code: 81022,
    message: 'Flow definition validation failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 81022\r\n\r\n### Flow definition validation failed\r\n\r\n The Flow Definition is invalid. Check the error response details for an array of validation failures.\r\n\r\n#### Possible Causes\r\n* Definition contains properties that do not match the schema\r\n* Widget names are not unique\r\n* Transition references a widget that doesn't exist\r\n\r\n#### Possible Solutions\r\n* Verify the definition adheres to the JSON schema\r\n* Ensure widget names are all unique\r\n* Remove transitions that reference widgets that don't exist",
    causes:
      "* Definition contains properties that do not match the schema\r\n* Widget names are not unique\r\n* Transition references a widget that doesn't exist",
    solutions:
      "* Verify the definition adheres to the JSON schema\r\n* Ensure widget names are all unique\r\n* Remove transitions that reference widgets that don't exist",
    description:
      'The Flow Definition is invalid. Check the error response details for an array of validation failures.',
    product: 'Studio',
    date_created: '2020-02-21T17:44:17Z',
    last_updated: '2020-08-04T10:00:04.6Z',
  },
  51007: {
    code: 51007,
    message: 'Client Connection: Token authentication is rejected',
    log_level: 'ERROR',
    secondary_message: 'error',
    log_type: 'APPLICATION',
    docs: "## ERROR - 51007\r\n\r\n### Client Connection: Token authentication is rejected\r\n\r\nerror ## Error - 51007\r\n\r\n### Client Connection: Token authentication is rejected by authentication service\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\nAuthentication service has rejected provided Access Token.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation including the grant format, see [the documentation](/docs/api/rest/access-tokens).\r\n\r\n#### Possible Solutions\r\nFor further assistance, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).",
    causes:
      "Authentication service has rejected provided Access Token.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation including the grant format, see [the documentation](/docs/api/rest/access-tokens).",
    solutions:
      'For further assistance, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description:
      '## Error - 51007\r\n\r\n### Client Connection: Token authentication is rejected by authentication service\r\n\r\n\r\n\r\n',
    product: null,
    date_created: '2016-04-28T12:08:18Z',
    last_updated: '2023-11-01T04:41:27.041817Z',
  },
  80603: {
    code: 80603,
    message: 'Non Unique Session Name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80603\r\n\r\n### Non Unique Session Name\r\n\r\n Session UniqueName must be unique.\r\n\r\n#### Possible Causes\r\nA Session exists with the proposed UniqueName.\r\n\r\n#### Possible Solutions\r\nRetry with a UniqueName that is not currently in use by any other Sessions for this Service.',
    causes: 'A Session exists with the proposed UniqueName.',
    solutions:
      'Retry with a UniqueName that is not currently in use by any other Sessions for this Service.',
    description: 'Session UniqueName must be unique.',
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.826Z',
  },
  30126: {
    code: 30126,
    message: 'Your 10DLC number failed to be registered ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 30126\r\n\r\n### Your 10DLC number failed to be registered \r\n\r\n Your phone number failed registration/deregistration due to Unknown reasons\r\n\r\n#### Possible Causes\r\nUnknown\r\n\r\n#### Possible Solutions\r\n* Contact [Twilio Customer Support](https://www.twilio.com/console/support/tickets/create)\r\n',
    causes: 'Unknown',
    solutions:
      '* Contact [Twilio Customer Support](https://www.twilio.com/console/support/tickets/create)\r\n',
    description: 'Your phone number failed registration/deregistration due to Unknown reasons',
    product: 'Programmable SMS',
    date_created: '2024-02-16T19:09:26Z',
    last_updated: '2024-02-16T19:09:32.538948Z',
  },
  57014: {
    code: 57014,
    message: "'Event' data in payload is absent",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57014\r\n\r\n### 'Event' data in payload is absent\r\n\r\n 'Event' is not specified\r\n\r\n#### Possible Causes\r\n'Event' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'Event' is being passed in request. ",
    causes: "'Event' is not specified",
    solutions: "Confirm a valid 'Event' is being passed in request. ",
    description: "'Event' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-06-11T19:03:17Z',
    last_updated: '2021-06-11T19:03:17Z',
  },
  30887: {
    code: 30887,
    message: 'Campaign vetting rejection - Opt-out Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30887\r\n\r\n### Campaign vetting rejection - Opt-out Error\r\n\r\n The campaign submission has been reviewed and it was rejected because of provided Opt-out information.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because it was indicated that you are collecting and processing consumer Opt-Outs, but the workflow is unclear, missing opt-out keywords or opt-message.\r\n\r\n#### Possible Solutions\r\nPlease verify that opt-out workflow is accurate and update Call-to-Action/ Message Flow description with opt-out process.\r\n\r\nIf opt-out is managed, add opt-out keywords and update opt-out message to to include acknowledgement of opt-out request, confirmation that no further messages will be sent, and brand name.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because it was indicated that you are collecting and processing consumer Opt-Outs, but the workflow is unclear, missing opt-out keywords or opt-message.',
    solutions:
      'Please verify that opt-out workflow is accurate and update Call-to-Action/ Message Flow description with opt-out process.\r\n\r\nIf opt-out is managed, add opt-out keywords and update opt-out message to to include acknowledgement of opt-out request, confirmation that no further messages will be sent, and brand name.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because of provided Opt-out information.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:36:45Z',
    last_updated: '2023-04-18T11:36:45Z',
  },
  90026: {
    code: 90026,
    message: 'Template body could not be parsed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 90026\r\n\r\n### Template body could not be parsed\r\n\r\n Template body could not be parsed by Mustache compiler\r\n\r\n#### Possible Causes\r\nTemplate body uses incorrect grammar (we support Mustache grammar). For instance empty Mustache placeholder ("{{}}") is not allowed by the grammar.\r\n\r\n#### Possible Solutions\r\nCheck your template body is correct Mustache grammar.',
    causes:
      'Template body uses incorrect grammar (we support Mustache grammar). For instance empty Mustache placeholder ("{{}}") is not allowed by the grammar.',
    solutions: 'Check your template body is correct Mustache grammar.',
    description: 'Template body could not be parsed by Mustache compiler',
    product: null,
    date_created: '2020-12-11T08:56:59Z',
    last_updated: '2020-12-11T08:56:59Z',
  },
  21657: {
    code: 21657,
    message: 'The Sender ID is invalid ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21657\r\n\r\n### The Sender ID is invalid \r\n\r\n The Sender ID is Invalid\r\n\r\n#### Possible Causes\r\nYou are using a Sender ID that is not supported in the specific destination\r\n\r\n#### Possible Solutions\r\nPlease review the SMS guidelines and use a Sender ID that is supported in the specific destination ',
    causes: 'You are using a Sender ID that is not supported in the specific destination',
    solutions:
      'Please review the SMS guidelines and use a Sender ID that is supported in the specific destination ',
    description: 'The Sender ID is Invalid',
    product: 'Programmable SMS',
    date_created: '2023-04-26T13:54:13Z',
    last_updated: '2023-04-27T09:36:12.15342Z',
  },
  60402: {
    code: 60402,
    message: 'Mapper Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60402\r\n\r\n### Mapper Error\r\n\r\n An error occurred while mapping an entity.\r\n\r\n#### Possible Causes\r\nUnexpected entity format.\r\n\r\n#### Possible Solutions\r\nCreate a new factor.',
    causes: 'Unexpected entity format.',
    solutions: 'Create a new factor.',
    description: 'An error occurred while mapping an entity.',
    product: 'Verify',
    date_created: '2021-03-15T20:44:09Z',
    last_updated: '2021-03-15T20:44:09Z',
  },
  30880: {
    code: 30880,
    message: 'Campaign vetting rejection - Unknown Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30880\r\n\r\n### Campaign vetting rejection - Unknown Error\r\n\r\n The campaign submission has been reviewed and it was rejected because of an unknown reason.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because of an unknown error and may stem from an issue raised by other vetting parties in the ecosystem.\r\n\r\n#### Possible Solutions\r\nOur Support team has the means to obtain more detailed information about this specific error. Please contact [Twilio Customer Support]( https://www.twilio.com/help/contact) for assistance in understanding the underlying problem and finding a resolution. ',
    causes:
      'The campaign cannot be approved because of an unknown error and may stem from an issue raised by other vetting parties in the ecosystem.',
    solutions:
      'Our Support team has the means to obtain more detailed information about this specific error. Please contact [Twilio Customer Support]( https://www.twilio.com/help/contact) for assistance in understanding the underlying problem and finding a resolution. ',
    description:
      'The campaign submission has been reviewed and it was rejected because of an unknown reason.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:30:38Z',
    last_updated: '2023-10-17T13:15:58.879638Z',
  },
  63018: {
    code: 63018,
    message: 'Rate limit exceeded for Channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63018\r\n\r\n### Rate limit exceeded for Channel\r\n\r\n \r\n\r\n#### Possible Causes\r\n* Your account is sending messages at a higher combined rate than configured for your account.\r\n* Your WhatsApp Sender has exceeded the messaging limit imposed by WhatsApp. For more information, see [WhatsApp Sender Messaging Limits & Quality Rating](https://support.twilio.com/hc/en-us/articles/360024008153-WhatsApp-Sender-Message-Limits-and-Quality-Rating)\r\n\r\n#### Possible Solutions\r\n* Wait until 24 hours have passed since starting a business-initiated conversation with one or more users',
    causes:
      '* Your account is sending messages at a higher combined rate than configured for your account.\r\n* Your WhatsApp Sender has exceeded the messaging limit imposed by WhatsApp. For more information, see [WhatsApp Sender Messaging Limits & Quality Rating](https://support.twilio.com/hc/en-us/articles/360024008153-WhatsApp-Sender-Message-Limits-and-Quality-Rating)',
    solutions:
      '* Wait until 24 hours have passed since starting a business-initiated conversation with one or more users',
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-20T07:24:45Z',
    last_updated: '2023-10-02T23:12:49.196471Z',
  },
  32002: {
    code: 32002,
    message: 'SIP: Dial failure - Twilio SIP Domain not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 32002\r\n\r\n### Dial failure - Twilio SIP Domain not found\r\n\r\n#### Possible Causes\r\n\r\n* There is a typo in the name of the SIP Domain.\r\n* When a SIP Domain is created you must press SAVE on Console. \r\n\r\n#### Possible Solutions\r\n\r\n* Verify the existence and name of the SIP Domain that you created.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-10-28T21:16:58Z',
    last_updated: '2020-08-04T10:00:20.562Z',
  },
  13224: {
    code: 13224,
    message: 'Dial: Twilio does not support calling this number or the number is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13224\r\n\r\n### Dial: Twilio does not support calling this number or the number is invalid\r\n\r\n Twilio does not support calling this number or the number is invalid\r\n\r\n#### Possible Causes\r\nThis error occurs when the provided number is not in E.164 format; for example using local dialing pattern 01234567890 instead of the full E.164 address +441234567890. This can also occur when calls are attempted to non-existent country codes, area codes, or exchanges. For example, there is no +693 country code, no +1238 US area code, and no 555 US exchange.\r\n\r\nThis can also occur with properly-formatted, valid destinations if none of Twilio’s carrier partners are able to deliver the call; for example due to a telecom network outage in the phone number’s local area.\r\n\r\n#### Possible Solutions\r\nUse E.164 formatting and ensure the destination is a valid, in-service destination.',
    causes:
      'This error occurs when the provided number is not in E.164 format; for example using local dialing pattern 01234567890 instead of the full E.164 address +441234567890. This can also occur when calls are attempted to non-existent country codes, area codes, or exchanges. For example, there is no +693 country code, no +1238 US area code, and no 555 US exchange.\r\n\r\nThis can also occur with properly-formatted, valid destinations if none of Twilio’s carrier partners are able to deliver the call; for example due to a telecom network outage in the phone number’s local area.',
    solutions:
      'Use E.164 formatting and ensure the destination is a valid, in-service destination.',
    description: 'Twilio does not support calling this number or the number is invalid',
    product: null,
    date_created: '2016-03-31T17:13:34Z',
    last_updated: '2023-09-26T23:20:53.652269Z',
  },
  68007: {
    code: 68007,
    message: 'Authentication Token Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 68007\r\n\r\n### Authentication Token Error\r\n\r\n An error occurred while generating a token.\r\n\r\n#### Possible Causes\r\nUnsupported factor type.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'Unsupported factor type.',
    solutions: 'Check parameters and retry.',
    description: 'An error occurred while generating a token.',
    product: 'Verify',
    date_created: '2020-09-15T18:16:22Z',
    last_updated: '2020-09-15T18:16:22Z',
  },
  22103: {
    code: 22103,
    message: 'Unsupported Iso Country',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22103\r\n\r\n### Unsupported Iso Country\r\n\r\nYou attempted to host a number, but Twilio does not currently support hosting numbers in the Iso Country provided.\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:50:24Z',
    last_updated: '2020-08-04T10:00:15.224Z',
  },
  45775: {
    code: 45775,
    message: 'Failed to refresh token. Invalid token provided.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45775\r\n\r\n### Failed to refresh token. Invalid token provided.\r\n\r\n Failed to refresh token. Invalid token provided.\r\n\r\n#### Possible Causes\r\nToken provided in the request is invalid.\r\n\r\n#### Possible Solutions\r\nProvide the correct token.',
    causes: 'Token provided in the request is invalid.',
    solutions: 'Provide the correct token.',
    description: 'Failed to refresh token. Invalid token provided.',
    product: 'Flex',
    date_created: '2023-11-22T15:44:53Z',
    last_updated: '2023-11-22T15:44:53Z',
  },
  14206: {
    code: 14206,
    message: 'Enqueue: Invalid waitUrlMethod value',
    log_level: 'ERROR',
    secondary_message:
      "The waitUrlMethod value is invalid. You must specify one of 'GET' or 'POST'.",
    log_type: null,
    docs: "## Error - 14206\n\n### Enqueue: Invalid waitUrlMethod value\n\nThe waitUrlMethod value is invalid. You must specify one of 'GET' or 'POST'.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:11Z',
    last_updated: '2020-08-04T10:00:26.249Z',
  },
  30899: {
    code: 30899,
    message:
      'Campaign rejection - The campaign registration failed because of carrier rejection(s).',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30899\r\n\r\n### Campaign rejection - The campaign registration failed because of carrier rejection(s).\r\n\r\n The campaign registration failed because of carrier rejection(s).\r\n\r\n#### Possible Causes\r\nOne or more carriers rejected this campaign upon submission.\r\n\r\n#### Possible Solutions\r\nPlease reach out to customer support with campaign and account details for resolution. ',
    causes: 'One or more carriers rejected this campaign upon submission.',
    solutions:
      'Please reach out to customer support with campaign and account details for resolution. ',
    description: 'The campaign registration failed because of carrier rejection(s).',
    product: 'Programmable Messaging',
    date_created: '2023-05-25T08:17:52Z',
    last_updated: '2023-05-25T08:17:52Z',
  },
  40153: {
    code: 40153,
    message: 'Absolute Paging used when iterating TaskRouter resources',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 40153\r\n\r\n### Absolute Paging used when iterating TaskRouter resources\r\n\r\n The absolute paging query type that is being used has been deprecated. Starting Dec. 1, 2021 we will no longer return data for this query, and instead return a 400-response for requests of query type /Workers?Page=<x>&PageSize=<y>.\r\n\r\nPlease update your application to instead utilize relative paging: /Workers?PageToken=PA<task_sid>, where <task_sid> is the last item of the current page.\r\n\r\n#### Possible Causes\r\nNot using the latest Twilio helper libraries. Constructing requests directly which use Page & PageSize query parameters directly.\r\n\r\n#### Possible Solutions\r\nUtilize the latest Twilio helper libraries. Rely upon the PageToken instead of the Page Number for paging.',
    causes:
      'Not using the latest Twilio helper libraries. Constructing requests directly which use Page & PageSize query parameters directly.',
    solutions:
      'Utilize the latest Twilio helper libraries. Rely upon the PageToken instead of the Page Number for paging.',
    description:
      'The absolute paging query type that is being used has been deprecated. Starting Dec. 1, 2021 we will no longer return data for this query, and instead return a 400-response for requests of query type /Workers?Page=<x>&PageSize=<y>.\r\n\r\nPlease update your application to instead utilize relative paging: /Workers?PageToken=PA<task_sid>, where <task_sid> is the last item of the current page.',
    product: 'TaskRouter',
    date_created: '2021-09-01T17:45:23Z',
    last_updated: '2021-09-01T17:45:23Z',
  },
  94604: {
    code: 94604,
    message: 'Account Sid on Legal Hold.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94604\r\n\r\n### Account Sid on Legal Hold.\r\n\r\n The Account is on Legal Hold, the operation could not be performed.\r\n\r\n#### Possible Causes\r\n * The account has a Legal Hold\r\n\r\n#### Possible Solutions\r\n ',
    causes: ' * The account has a Legal Hold',
    solutions: ' ',
    description: 'The Account is on Legal Hold, the operation could not be performed.',
    product: null,
    date_created: '2022-05-09T15:40:38Z',
    last_updated: '2022-05-09T15:40:38Z',
  },
  91201: {
    code: 91201,
    message: 'Bad Request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91201\r\n\r\n### Bad Request\r\n\r\n Incorrect information provided in the request \r\n\r\n#### Possible Causes\r\n* The transform template is not a valid template\r\n* The JSON Schema is incorrect\r\n* The value of one of the entry params is not correct\r\n\r\n#### Possible Solutions\r\n* Recheck the input information and validate against examples',
    causes:
      '* The transform template is not a valid template\r\n* The JSON Schema is incorrect\r\n* The value of one of the entry params is not correct',
    solutions: '* Recheck the input information and validate against examples',
    description: 'Incorrect information provided in the request ',
    product: 'Events',
    date_created: '2020-09-21T21:13:01Z',
    last_updated: '2021-02-11T09:08:38.703Z',
  },
  21300: {
    code: 21300,
    message: 'Invalid BYOC trunk SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21300\r\n\r\n### Invalid BYOC trunk SID\r\n\r\n You have specified a BYOC trunk SID that is malformed or non-existent.\r\n\r\n#### Possible Causes\r\n* The SID in question is not formatted correctly. A valid BYOC trunk SID starts with prefix "BY" and is 34 characters in length.\r\n* The BYOC trunk identified by the SID does not exist. If it existed in the past, it has since been removed.\r\n* The BYOC trunk exists but ownership is with a different account.\r\n\r\n\r\n#### Possible Solutions\r\nMake sure you submit the SID of a BYOC trunk that you can locate within your account.',
    causes:
      '* The SID in question is not formatted correctly. A valid BYOC trunk SID starts with prefix "BY" and is 34 characters in length.\r\n* The BYOC trunk identified by the SID does not exist. If it existed in the past, it has since been removed.\r\n* The BYOC trunk exists but ownership is with a different account.\r\n',
    solutions:
      'Make sure you submit the SID of a BYOC trunk that you can locate within your account.',
    description: 'You have specified a BYOC trunk SID that is malformed or non-existent.',
    product: 'Programmable Voice',
    date_created: '2020-01-17T19:31:54Z',
    last_updated: '2020-08-04T10:00:05.219Z',
  },
  60364: {
    code: 60364,
    message: 'Challenge SID invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60364\r\n\r\n### Challenge SID invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Challenge SID in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Challenge SID in the request parameter/body is correct.',
    causes: 'The Challenge SID in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Challenge SID in the request parameter/body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-13T09:54:54Z',
    last_updated: '2023-12-13T09:54:54Z',
  },
  92001: {
    code: 92001,
    message: "'Types' Parameter Required",
    log_level: 'ERROR',
    secondary_message:
      "You attempted to create content, but you forgot to include at least one type within the 'types' property the 'types' parameter requires at least one type in order to create content. ",
    log_type: 'APPLICATION',
    docs: "## ERROR - 92001\r\n\r\n### 'Types' Parameter Required\r\n\r\nYou attempted to create content, but you forgot to include at least one type within the 'types' property the 'types' parameter requires at least one type in order to create content.  ## Error - 92001 \r\n\r\n### 'types' Parameter Required\r\n\r\nYou attempted to create content, but you forgot to include at least one type within the 'types' property the 'types' parameter requires at least one type in order to create content. \r\n\r\n\r\n#### Possible Causes\r\nYou attempted to create content, but you forgot to include at least one type within the 'types' property, the 'types' parameter requires at least one type in order to create content. \r\n\r\n#### Possible Solutions\r\nPlease include at least one type within the 'types' property",
    causes:
      "You attempted to create content, but you forgot to include at least one type within the 'types' property, the 'types' parameter requires at least one type in order to create content. ",
    solutions: "Please include at least one type within the 'types' property",
    description:
      "## Error - 92001 \r\n\r\n### 'types' Parameter Required\r\n\r\nYou attempted to create content, but you forgot to include at least one type within the 'types' property the 'types' parameter requires at least one type in order to create content. \r\n",
    product: 'Programmable SMS',
    date_created: '2021-11-03T07:51:51Z',
    last_updated: '2021-11-03T07:51:51Z',
  },
  30001: {
    code: 30001,
    message: 'Queue overflow',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30001\r\n\r\n### Queue overflow\r\n\r\n Twilio queues messages based on the sending rate of a sender or an account. For example a US long code number can send one message [segment](https://www.twilio.com/blog/what-the-heck-is-a-segment.html) per second, and a short code may send over 100 message segments per second. \r\n\r\nMessages can only be queued for 4 hours and then they automatically fail. This queue length limit can be reduced by setting a lower [Validity Period](https://www.twilio.com/blog/take-more-control-of-outbound-messages-using-validity-period.html) within your Messaging Service settings or in your API requests to send messages.\r\n\r\nYou can monitor the length on your queue via the [Queue Insights dashboard](https://www.twilio.com/console/sms/insights/queue).\r\n\r\nFor more information please view this [FAQ](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues). \r\n\r\n\r\n#### Possible Causes\r\n* You tried to send too many messages too quickly and your message queue overflowed.\r\n* You tried sending all your messages from a single Sender with an insufficient send rate limit (Message Segments per Second) for that volume, and you need additional throughput to handle the volume.\r\n* There are Messages Per Second (MPS) limits applied for your Senders, Messaging Services, and Accounts that you may be encountering.\r\n\r\n#### Possible Solutions\r\n* **Recommended** Try using a [Messaging Service](https://www.twilio.com/docs/messaging/services) with multiple senders and it will load balance for you.\r\n* Try adding more senders into your [Messaging Service](https://www.twilio.com/docs/messaging/services).\r\n* If you are messaging in the US or Canada, talk to Twilio Sales about getting a [Toll Free](https://www.twilio.com/en-us/messaging/channels/sms) or [Short Code](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code-) number that allows you to send more messages per second.\r\n* Try sending your message again after waiting for some time.\r\n* If you have set a lower Validity Period than the default and maximum value of 14400 seconds (4 hours), try setting a higher Validity Period for your messages.',
    causes:
      '* You tried to send too many messages too quickly and your message queue overflowed.\r\n* You tried sending all your messages from a single Sender with an insufficient send rate limit (Message Segments per Second) for that volume, and you need additional throughput to handle the volume.\r\n* There are Messages Per Second (MPS) limits applied for your Senders, Messaging Services, and Accounts that you may be encountering.',
    solutions:
      '* **Recommended** Try using a [Messaging Service](https://www.twilio.com/docs/messaging/services) with multiple senders and it will load balance for you.\r\n* Try adding more senders into your [Messaging Service](https://www.twilio.com/docs/messaging/services).\r\n* If you are messaging in the US or Canada, talk to Twilio Sales about getting a [Toll Free](https://www.twilio.com/en-us/messaging/channels/sms) or [Short Code](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code-) number that allows you to send more messages per second.\r\n* Try sending your message again after waiting for some time.\r\n* If you have set a lower Validity Period than the default and maximum value of 14400 seconds (4 hours), try setting a higher Validity Period for your messages.',
    description:
      'Twilio queues messages based on the sending rate of a sender or an account. For example a US long code number can send one message [segment](https://www.twilio.com/blog/what-the-heck-is-a-segment.html) per second, and a short code may send over 100 message segments per second. \r\n\r\nMessages can only be queued for 4 hours and then they automatically fail. This queue length limit can be reduced by setting a lower [Validity Period](https://www.twilio.com/blog/take-more-control-of-outbound-messages-using-validity-period.html) within your Messaging Service settings or in your API requests to send messages.\r\n\r\nYou can monitor the length on your queue via the [Queue Insights dashboard](https://www.twilio.com/console/sms/insights/queue).\r\n\r\nFor more information please view this [FAQ](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues). \r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:33Z',
    last_updated: '2023-07-31T21:40:22.917287Z',
  },
  60244: {
    code: 60244,
    message: 'Custom messages are not supported',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 60244\r\n\r\n### Custom messages are not supported\r\n\r\n Your verification messages are upgraded to default templates.\r\n\r\n#### Possible Causes\r\nVerifications created using custom messages are no longer supported and upgraded to default templates.\r\n\r\n#### Possible Solutions\r\nIf you would like to continue using custom message text migrate to [BYOT templates](https://www.twilio.com/docs/verify/api/templates).',
    causes:
      'Verifications created using custom messages are no longer supported and upgraded to default templates.',
    solutions:
      'If you would like to continue using custom message text migrate to [BYOT templates](https://www.twilio.com/docs/verify/api/templates).',
    description: 'Your verification messages are upgraded to default templates.',
    product: 'Verify',
    date_created: '2024-02-06T14:35:30Z',
    last_updated: '2024-02-06T14:35:30Z',
  },
  30120: {
    code: 30120,
    message: ' Domain certificate and private key are not uploaded',
    log_level: 'ERROR',
    secondary_message: 'Given Domain is not onboarded, please upload cert for domain first',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30120\r\n\r\n###  Domain certificate and private key are not uploaded\r\n\r\nGiven Domain is not onboarded, please upload cert for domain first Given Domain is not onboarded\r\n\r\n#### Possible Causes\r\nUser has not uploaded cert for domain\r\n\r\n#### Possible Solutions\r\nPlease follow doc to upload cert for domain',
    causes: 'User has not uploaded cert for domain',
    solutions: 'Please follow doc to upload cert for domain',
    description: 'Given Domain is not onboarded',
    product: 'Programmable SMS',
    date_created: '2022-02-09T19:25:00Z',
    last_updated: '2022-07-15T00:10:49.882537Z',
  },
  31203: {
    code: 31203,
    message: 'No valid account.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31203\r\n\r\n### No valid account.\r\n\r\nNo valid account.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:46:12Z',
    last_updated: '2020-08-04T10:00:11.115Z',
  },
  11241: {
    code: 11241,
    message: 'HTTP connection edge location is not supported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 11241\r\n\r\n### HTTP connection edge location is not supported\r\n\r\n There was an error connecting to the URL due to an unsupported edge location parameter.\r\n\r\n#### Possible Causes\r\n* The edge location(s) specified in the 'e' parameter of your connection settings are not currently supported by Twilio.\r\n\r\n#### Possible Solutions\r\n* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
    causes:
      "* The edge location(s) specified in the 'e' parameter of your connection settings are not currently supported by Twilio.",
    solutions: "* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
    description:
      'There was an error connecting to the URL due to an unsupported edge location parameter.',
    product: null,
    date_created: '2019-02-04T18:35:12Z',
    last_updated: '2020-08-04T10:00:10.779Z',
  },
  50322: {
    code: 50322,
    message: 'Programmable Chat: Too many channel webhook triggers',
    log_level: 'ERROR',
    secondary_message: 'Triggers limit exceeded for given channel webhook',
    log_type: null,
    docs: '## Error - 50322\r\n\r\n### Programmable Chat: Too many channel webhook triggers\r\n\r\n#### Possible Causes \r\n*  Triggers limit exceeded for given channel webhook.\r\n\r\n#### Possible Solutions\r\n*  Reduce number of triggers for given channel webhook before creating new one.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T12:33:59Z',
    last_updated: '2020-08-04T10:00:12.124Z',
  },
  50334: {
    code: 50334,
    message: 'Channel deletion operation is in progress',
    log_level: 'ERROR',
    secondary_message:
      'Channel deletion operation is in progress, all the channel modifications are discarded.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50334\r\n\r\n### Channel deletion operation is in progress\r\n\r\nChannel deletion operation is in progress, all the channel modifications are discarded. \r\n\r\n#### Possible Causes\r\n* Your API request tried to update the channel while the channel deletion operation was in progress.\r\n\r\n#### Possible Solutions\r\n* Do not try to update the channel while the deletion operation is in progress.',
    causes:
      '* Your API request tried to update the channel while the channel deletion operation was in progress.',
    solutions: '* Do not try to update the channel while the deletion operation is in progress.',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-09-27T14:01:07Z',
    last_updated: '2021-09-27T14:01:07Z',
  },
  18009: {
    code: 18009,
    message: 'Nationality mismatch on identity document.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18009\r\n\r\n### Nationality mismatch on identity document.\r\n\r\n The nationality of the government office that issued the document does not match the information on the Proof of Identity.\r\n\r\n#### Possible Causes\r\nYou may have uploaded a wrong document.\r\n\r\n#### Possible Solutions\r\nPlease resubmit with the appropriate identity document. Please ensure the document uploaded and the information you provided match.',
    causes: 'You may have uploaded a wrong document.',
    solutions:
      'Please resubmit with the appropriate identity document. Please ensure the document uploaded and the information you provided match.',
    description:
      'The nationality of the government office that issued the document does not match the information on the Proof of Identity.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:02:40Z',
    last_updated: '2024-07-04T10:02:40Z',
  },
  30113: {
    code: 30113,
    message: 'Specified date is too old',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30113\r\n\r\n### Specified date is too old\r\n\r\n Historical data for Deactivation lists is only available from August 27th, 2020 onwards.\r\n\r\n#### Possible Causes\r\nYou have specified a date that is too far in the past for Twilio to have data available.\r\n\r\n#### Possible Solutions\r\nPlease specify a newer date to retrieve data.',
    causes:
      'You have specified a date that is too far in the past for Twilio to have data available.',
    solutions: 'Please specify a newer date to retrieve data.',
    description:
      'Historical data for Deactivation lists is only available from August 27th, 2020 onwards.',
    product: 'Programmable SMS',
    date_created: '2020-08-27T19:49:16Z',
    last_updated: '2020-08-27T19:49:16Z',
  },
  22131: {
    code: 22131,
    message: 'Not Portable - Already in your Twilio Account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22131\r\n\r\n### Not Portable - Already in your Twilio Account\r\n\r\n \r\n\r\n#### Possible Causes\r\nPhone number already exists on your Twilio account or is currently being ported into your Twilio account\r\n\r\n#### Possible Solutions\r\nIf needed, see this [support page](https://support.twilio.com/hc/en-us/articles/223135327-Moving-Twilio-Phone-Numbers-to-another-Twilio-Account) for more information on how to move the line to a different subaccount.',
    causes:
      'Phone number already exists on your Twilio account or is currently being ported into your Twilio account',
    solutions:
      'If needed, see this [support page](https://support.twilio.com/hc/en-us/articles/223135327-Moving-Twilio-Phone-Numbers-to-another-Twilio-Account) for more information on how to move the line to a different subaccount.',
    description:
      'Phone number already exists on your Twilio account or is currently being ported into your Twilio account',
    product: 'Phone Numbers',
    date_created: '2023-06-22T17:57:47Z',
    last_updated: '2024-06-20T15:23:44.771188Z',
  },
  14232: {
    code: 14232,
    message: 'Dial->Conference: Invalid Priority',
    log_level: 'ERROR',
    secondary_message: 'Provided priority is not a valid integer',
    log_type: null,
    docs: '## Error - 14232\r\n\r\n### Conference: Provided Priority was not a valid integer\r\n\r\nProvided Priority is invalid.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:46:04Z',
    last_updated: '2020-08-04T10:00:21.827Z',
  },
  13237: {
    code: 13237,
    message: 'Dial->Conference: Invalid Conference Name',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Error - 13237\n\n### Dial->Conference: Invalid conference name \n\nThe conference name you attempted to Dial is invalid.  Conference names must be between 1 and 128 characters. \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:38Z',
    last_updated: '2020-08-04T10:00:28.336Z',
  },
  60225: {
    code: 60225,
    message: 'Translation already exists for the provided template',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60225\r\n\r\n### Translation already exists for the provided template\r\n\r\n Translation already exists for the provided template.\r\n\r\nHTTP status: 409\r\n\r\n#### Possible Causes\r\nThe user has provided an existent translation for the template.\r\n\r\n#### Possible Solutions\r\nTry to create another translation with a different locale.',
    causes: 'The user has provided an existent translation for the template.',
    solutions: 'Try to create another translation with a different locale.',
    description: 'Translation already exists for the provided template.\r\n\r\nHTTP status: 409',
    product: 'Verify',
    date_created: '2021-06-16T15:54:51Z',
    last_updated: '2022-09-01T21:43:20.247703Z',
  },
  31950: {
    code: 31950,
    message: 'Stream - Protocol - Malformed Message',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 31950\r\n\r\n### Stream - Protocol - Malformed Message\r\n\r\n The Streamer has received a message that cannot be decoded\r\n(This error is sent once per stream)\r\n\r\n#### Possible Causes\r\n* WebSocket binary format is used\r\n\r\n#### Possible Solutions\r\n* Do not use binary format',
    causes: '* WebSocket binary format is used',
    solutions: '* Do not use binary format',
    description:
      'The Streamer has received a message that cannot be decoded\r\n(This error is sent once per stream)',
    product: 'Programmable Voice',
    date_created: '2020-05-08T11:47:24Z',
    last_updated: '2020-08-04T10:00:03.297Z',
  },
  21215: {
    code: 21215,
    message: 'Geo Permission configuration is not permitting call',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21215\r\n\r\n### Geo Permission configuration is not permitting call\r\n\r\n You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.\r\n\r\n#### Possible Causes\r\nUser dialed a destination your application is not enabled to support calling to.\r\n\r\n#### Possible Solutions\r\nPlease check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try again.',
    causes: 'User dialed a destination your application is not enabled to support calling to.',
    solutions:
      'Please check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try again.',
    description:
      'You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:14:15Z',
    last_updated: '2023-09-26T23:13:37.804061Z',
  },
  13621: {
    code: 13621,
    message: "Invalid 'recordingStatusCallbackEvent'",
    log_level: 'ERROR',
    secondary_message: 'One or more of the recordingStatusCallbackEvents provided were invalid.',
    log_type: null,
    docs: "## Warning - 13621\r\n\r\n### Invalid 'recordingStatusCallbackEvent'\r\n\r\nOne or more of the recordingStatusCallbackEvents provided were invalid.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-07-26T21:02:28Z',
    last_updated: '2020-08-04T10:00:17.997Z',
  },
  80405: {
    code: 80405,
    message: 'Participant Sid Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Participant Sid',
    log_type: null,
    docs: '## Warning\n\n### Participant Sid Invalid\n\nExample Message: Invalid Participant Sid',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:15.963Z',
  },
  21474: {
    code: 21474,
    message: 'API User must be the parent account to transfer phone numbers.',
    log_level: 'ERROR',
    secondary_message:
      'The API user can not be a subaccount, must be a parent account to transfer phone numbers between parent and child accounts.',
    log_type: null,
    docs: '## Error - 21474\n\n### API User must be the parent account to transfer phone numbers.\n\nThe API user can not be a subaccount, must be a parent account to transfer phone numbers between parent and child accounts.\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:23Z',
    last_updated: '2020-08-04T10:00:25.311Z',
  },
  13250: {
    code: 13250,
    message: 'Dial: Too many URIs passed',
    log_level: 'WARNING',
    secondary_message: 'You specified too many URI elements.',
    log_type: null,
    docs: '## Warning - 13250 \n\n### Dial: Too many URIs passed\n\nYou specified too many URI elements.\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:08Z',
    last_updated: '2020-08-04T10:00:26.442Z',
  },
  13314: {
    code: 13314,
    message: 'Gather: Invalid numDigits value',
    log_level: 'WARNING',
    secondary_message:
      "The numDigits attribute must be a positive integer. See the <a href='/docs/api/twiml/gather#numDigits'>Gather Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13314 \n\n### Gather: Invalid numDigits value\n\nThe numDigits attribute must be a positive integer. See the <a href='/docs/api/twiml/gather#numDigits'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:41Z',
    last_updated: '2020-08-04T10:00:28.103Z',
  },
  52161: {
    code: 52161,
    message: 'Empty Credentials',
    log_level: 'ERROR',
    secondary_message: 'Credentials are misconfigured or not exist yet',
    log_type: null,
    docs: '## Error - 52161\r\n\r\n### Empty Credentials\r\n\r\n#### Possible Causes \r\n*  Credentials are invalid or do not exist for provided credential sid.\r\n\r\n#### Possible Solutions\r\n*  Make sure you have credential is valid.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:39:55Z',
    last_updated: '2020-08-04T10:00:22.023Z',
  },
  80909: {
    code: 80909,
    message: 'Inbound Contact Rejected',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 80909\r\n\r\n### Inbound Contact Rejected\r\n\r\n Interaction not completed due to InterceptCallbackUrl.\r\n\r\n#### Possible Causes\r\nA request to InterceptCallbackUrl received 403 and the interaction was aborted/blocked.\r\n\r\n#### Possible Solutions\r\nIf this was unintended, the logic in the InterceptCallbackUrl could be revised. See behavior in the webhooks [documentation](https://www.twilio.com/docs/proxy/api/webhooks).',
    causes:
      'A request to InterceptCallbackUrl received 403 and the interaction was aborted/blocked.',
    solutions:
      'If this was unintended, the logic in the InterceptCallbackUrl could be revised. See behavior in the webhooks [documentation](https://www.twilio.com/docs/proxy/api/webhooks).',
    description: 'Interaction not completed due to InterceptCallbackUrl.',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.515Z',
  },
  83600: {
    code: 83600,
    message: ' An invalid parameter value was passed to the API',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83600\r\n\r\n###  An invalid parameter value was passed to the API\r\n\r\n A parameter was passed to the Usage Records API which failed validation. This usually means the value format was invalid, or multiple parameters in the request conflict with each other.\r\n\r\n#### Possible Causes\r\n  * Check the response message for details on which parameter was invalid and the specific reason.\r\n\r\n#### Possible Solutions\r\n  * Refer to the API documentation and adjust your parameter value to a supported value.',
    causes:
      '  * Check the response message for details on which parameter was invalid and the specific reason.',
    solutions:
      '  * Refer to the API documentation and adjust your parameter value to a supported value.',
    description:
      'A parameter was passed to the Usage Records API which failed validation. This usually means the value format was invalid, or multiple parameters in the request conflict with each other.',
    product: 'Super SIM',
    date_created: '2021-08-19T13:12:45Z',
    last_updated: '2021-08-19T13:42:11.714124Z',
  },
  95005: {
    code: 95005,
    message: 'Invalid media url',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95005\r\n\r\n### Invalid media url\r\n\r\n Twilio failed to create a new transcript due to an invalid media url\r\n\r\n#### Possible Causes\r\nProvided media url is not valid\r\n\r\n#### Possible Solutions\r\nChange the request to use a valid URL format',
    causes: 'Provided media url is not valid',
    solutions: 'Change the request to use a valid URL format',
    description: 'Twilio failed to create a new transcript due to an invalid media url',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:27:12Z',
    last_updated: '2024-04-16T17:27:12Z',
  },
  32506: {
    code: 32506,
    message: 'Voice Conversation: Failed to get worker assigned to a newly created Conversation.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32506\r\n\r\n### Voice Conversation: Failed to get worker assigned to a newly created Conversation.\r\n\r\n Your Frontline instance failed to assign a worker after Conversation auto-creation.\r\n\r\n#### Possible Causes\r\n- Issue with Frontline routing configuration that caused no worker assigned.\r\n- Conversation might not have been created by the Frontline service. This error indicates that the code is directly using Conversation API to the create the conversation, and Frontline cannot determine the format of the call.\r\n- Something went wrong when the Conversation was created by the Frontline worker or admin. \r\n\r\n#### Possible Solutions\r\n- Check the Frontline routing configurations.\r\n- If a custom Routing was used, make sure the webhook is going to the right URL.',
    causes:
      '- Issue with Frontline routing configuration that caused no worker assigned.\r\n- Conversation might not have been created by the Frontline service. This error indicates that the code is directly using Conversation API to the create the conversation, and Frontline cannot determine the format of the call.\r\n- Something went wrong when the Conversation was created by the Frontline worker or admin. ',
    solutions:
      '- Check the Frontline routing configurations.\r\n- If a custom Routing was used, make sure the webhook is going to the right URL.',
    description:
      'Your Frontline instance failed to assign a worker after Conversation auto-creation.',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:42:00Z',
    last_updated: '2022-07-29T16:36:27.074591Z',
  },
  30023: {
    code: 30023,
    message: 'US A2P 10DLC - Daily Message Cap Reached',
    log_level: 'ERROR',
    secondary_message:
      'Your messages to this particular carrier has exceeded the maximum allowable messages for the day.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30023\r\n\r\n### US A2P 10DLC - Daily Message Cap Reached\r\n\r\n You have sent the maximum allowable daily messages for your Brand to the carrier. \r\n\r\nDaily limits are based on your Brand Trust Score. You can check both your Trust Score and your daily Limit in the console [here](https://console.twilio.com/us1/develop/sms/regulatory-compliance/brands).\r\n\r\nNote: That the daily limit applies to the Brand (per EIN) and is based on the total number of outbound SMS segments and MMS messages sent to T-Mobile (including Sprint and MetroPCS) across any messaging platform you have registered your Brand with.\r\n\r\nPlease refer to our documentation on [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more info about A2P 10DLC, refer to our [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\n\r\n#### Possible Causes\r\n* You have sent the maximum amount of message [segments](https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding#:~:text=Additionally%2C%20for%20long,characters%20per%20segment) for the day on a given Brand.\r\n* You have sent the maximum amount of message [segments](https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding#:~:text=Additionally%2C%20for%20long,characters%20per%20segment) for the day across multiple Brands associated with your EIN, which could include Brands associated with other Twilio accounts or providers. \r\n\r\n\r\n#### Possible Solutions\r\n* You must wait till the next calendar day to resume message sending. The day resets at 00:00 Pacific Time (US). Pacific time is affected by Daylight Savings Time and Standard Time switches.\r\n* To avoid exceeding your daily limit, monitor your daily T-Mobile usage using the Messaging Insights tool.\r\n* You can also use the [30025](https://www.twilio.com/docs/api/errors/30025) and [30026](https://www.twilio.com/docs/api/errors/30026) ‘Daily Traffic Used’ and [30027](https://www.twilio.com/docs/api/errors/30027) ‘Daily Traffic Exceeded’ error warnings to understand what percentage of your daily traffic you have used. These warnings are available in the [console Error Logs](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n* For A2P registered customers, view your daily T-Mobile message limit by visiting [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1), selecting your US A2P brand and viewing the details of your TCR trust score.\r\n',
    causes:
      '* You have sent the maximum amount of message [segments](https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding#:~:text=Additionally%2C%20for%20long,characters%20per%20segment) for the day on a given Brand.\r\n* You have sent the maximum amount of message [segments](https://www.twilio.com/docs/glossary/what-is-gsm-7-character-encoding#:~:text=Additionally%2C%20for%20long,characters%20per%20segment) for the day across multiple Brands associated with your EIN, which could include Brands associated with other Twilio accounts or providers. \r\n',
    solutions:
      '* You must wait till the next calendar day to resume message sending. The day resets at 00:00 Pacific Time (US). Pacific time is affected by Daylight Savings Time and Standard Time switches.\r\n* To avoid exceeding your daily limit, monitor your daily T-Mobile usage using the Messaging Insights tool.\r\n* You can also use the [30025](https://www.twilio.com/docs/api/errors/30025) and [30026](https://www.twilio.com/docs/api/errors/30026) ‘Daily Traffic Used’ and [30027](https://www.twilio.com/docs/api/errors/30027) ‘Daily Traffic Exceeded’ error warnings to understand what percentage of your daily traffic you have used. These warnings are available in the [console Error Logs](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n* For A2P registered customers, view your daily T-Mobile message limit by visiting [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1), selecting your US A2P brand and viewing the details of your TCR trust score.\r\n',
    description:
      'You have sent the maximum allowable daily messages for your Brand to the carrier. \r\n\r\nDaily limits are based on your Brand Trust Score. You can check both your Trust Score and your daily Limit in the console [here](https://console.twilio.com/us1/develop/sms/regulatory-compliance/brands).\r\n\r\nNote: That the daily limit applies to the Brand (per EIN) and is based on the total number of outbound SMS segments and MMS messages sent to T-Mobile (including Sprint and MetroPCS) across any messaging platform you have registered your Brand with.\r\n\r\nPlease refer to our documentation on [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more info about A2P 10DLC, refer to our [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n',
    product: 'Programmable SMS',
    date_created: '2021-03-08T21:11:55Z',
    last_updated: '2024-02-15T10:04:43.70613Z',
  },
  50406: {
    code: 50406,
    message: 'Programmable Chat: Invalid last consumed message index format',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for last consumed message index',
    log_type: null,
    docs: '## Error - 50406\r\n\r\n### Programmable Chat: Invalid last consumed message index format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for last consumed message index\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:18:46Z',
    last_updated: '2020-08-04T10:00:16.56Z',
  },
  40145: {
    code: 40145,
    message: 'TaskRouter->Conference',
    log_level: 'ERROR',
    secondary_message:
      'Conference Instruction encountered an error when requesting an outgoing call be made from the API.',
    log_type: null,
    docs: '## Error - 40145\r\n\r\n### Call API Error - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  Un-routable address provided for \'to\' field. \r\n*  Invalid caller-id passed to \'from\' field. \r\n*  Missing \'room_name\' field.\r\n*  Internal Twilio API error. \r\n\r\n#### Possible Solutions\r\n*  Make certain \'to\' contains a routable phone number, client URI or SIP URI. \r\n*  Make certain \'to\' is to a country you have permissions set to call.\r\n*  Make certain \'from\' contains an acceptable caller ID for the chosen \'to\' address.\r\n*  Make certain \'room_name\' is a valid Conference Room Name.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-04-27T19:43:34Z',
    last_updated: '2020-08-04T10:00:21.88Z',
  },
  50069: {
    code: 50069,
    message: 'Programmable Chat: Service instance with provided unique name already exists',
    log_level: 'ERROR',
    secondary_message: 'Request contains already existing service instance unique name',
    log_type: null,
    docs: '## Error - 50069\r\n\r\n### Programmable Chat: Service instance with provided unique name already exists\r\n\r\n#### Possible Causes \r\n*  Request contains already existing service instance unique name\r\n\r\n#### Possible Solutions\r\n*  Provide non-existent service instance unique name in the request',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2018-10-10T11:21:17Z',
    last_updated: '2020-08-04T10:00:12.218Z',
  },
  62013: {
    code: 62013,
    message: 'Unable to identify account owner of connection.',
    log_level: 'ERROR',
    secondary_message:
      'The connection SID in the request is orphaned, and the owner cannot be identified.',
    log_type: null,
    docs: '## Error - 62013\r\n\r\n### Unable to identify account owner of connection\r\n\r\nThe connection SID in the request is orphaned, and the owner cannot be\r\nidentified.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:40:59Z',
    last_updated: '2020-08-04T10:00:20.963Z',
  },
  51119: {
    code: 51119,
    message: 'Twilsock: Token expired',
    log_level: 'ERROR',
    secondary_message: 'The token has been expired.',
    log_type: null,
    docs: '## Error - 51119\r\n\r\n### Token expired\r\n\r\n#### Possible Causes \r\nThe token has been expired.\r\n\r\n#### Possible Solutions\r\nPlease use a valid token.\r\n\r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:10:01Z',
    last_updated: '2020-08-04T10:00:09.567Z',
  },
  60540: {
    code: 60540,
    message: 'SNA Carrier Identified Invalid Phone Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60540\r\n\r\n### SNA Carrier Identified Invalid Phone Number\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Verification request was received and failed during processing because the carrier indicated that the phone number is invalid, although the phone number formatting was valid. This can happen when the end user provides an invalid phone number in error, the phone number is deactivated, suspended, in the grace period before reassignment, or a fraudulent user purposefully uses an invalid phone number.\r\n\r\n#### Possible Solutions\r\n- Check that the phone number provided is correct. \n- Retry Verification using a channel not based on phone number such as email. \n\nIf fraud is suspected:\n- Do not retry Verification using a channel other than Silent Network Auth for this end user.\n- [Report potential fraud attempt](https://www.twilio.com/docs/verify/preventing-toll-fraud#what-to-do-if-you-suspect-fraud-on-your-twilio-account).',
    causes:
      'The Verification request was received and failed during processing because the carrier indicated that the phone number is invalid, although the phone number formatting was valid. This can happen when the end user provides an invalid phone number in error, the phone number is deactivated, suspended, in the grace period before reassignment, or a fraudulent user purposefully uses an invalid phone number.',
    solutions:
      '- Check that the phone number provided is correct. \n- Retry Verification using a channel not based on phone number such as email. \n\nIf fraud is suspected:\n- Do not retry Verification using a channel other than Silent Network Auth for this end user.\n- [Report potential fraud attempt](https://www.twilio.com/docs/verify/preventing-toll-fraud#what-to-do-if-you-suspect-fraud-on-your-twilio-account).',
    description: null,
    product: 'Verify',
    date_created: '2022-08-30T17:23:44Z',
    last_updated: '2022-08-30T17:23:44Z',
  },
  63012: {
    code: 63012,
    message: 'Channel provider returned an internal service error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel returned an internal service error\r\n\r\n#### Possible Causes \r\n*   Channel provider returned an internal service error (HTTP 5xx). ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:26:57Z',
    last_updated: '2020-08-04T10:00:14.438Z',
  },
  53406: {
    code: 53406,
    message: 'The data channel used by the Data Track had a problem',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 53406\r\n\r\n### The data channel used by the Data Track had a problem\r\n\r\n There was a problem while negotiating with the remote media connection and it was not able to complete the channel creation. This can mean that the subscriber does not support data channels or they can not create it at this moment. This can also happen if the data channel suffers connectivity problems once it was connected.\r\n\r\n#### Possible Causes\r\n* The subscriber does not support data channels.\r\n* The subscriber can not open a data channel at this moment.\r\n* The subscriber rejected the data channel.\r\n* ICE connection between the server and the client became disconnected.\r\n\r\n#### Possible Solutions\r\n* Verify ICE connection.\r\n* Verify that the subscriber supports data channels.\r\n* Verify if the subscriber has reached the maximum number of data channels.',
    causes:
      '* The subscriber does not support data channels.\r\n* The subscriber can not open a data channel at this moment.\r\n* The subscriber rejected the data channel.\r\n* ICE connection between the server and the client became disconnected.',
    solutions:
      '* Verify ICE connection.\r\n* Verify that the subscriber supports data channels.\r\n* Verify if the subscriber has reached the maximum number of data channels.',
    description:
      'There was a problem while negotiating with the remote media connection and it was not able to complete the channel creation. This can mean that the subscriber does not support data channels or they can not create it at this moment. This can also happen if the data channel suffers connectivity problems once it was connected.',
    product: 'Programmable Video',
    date_created: '2021-03-09T08:09:35Z',
    last_updated: '2021-03-09T08:09:35Z',
  },
  57022: {
    code: 57022,
    message: 'Required header is missing or invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 57022\r\n\r\n### Required header is missing or invalid\r\n\r\n Required header is missing or invalid\r\n\r\n#### Possible Causes\r\nMandatory headers might be missing in the request.\r\n\r\n#### Possible Solutions\r\nProvide all the mandatory headers.',
    causes: 'Mandatory headers might be missing in the request.',
    solutions: 'Provide all the mandatory headers.',
    description: 'Required header is missing or invalid',
    product: 'Programmable SMS',
    date_created: '2024-06-11T10:28:29Z',
    last_updated: '2024-06-11T10:28:29Z',
  },
  93105: {
    code: 93105,
    message: 'Consent has already been provided for this account and vendor',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 93105\r\n\r\n### Consent has already been provided for this account and vendor\r\n\r\n Error surfaces when consent data has been provided\r\n\r\n#### Possible Causes\r\nThe consent submission happens more than once\r\n\r\n#### Possible Solutions\r\nDo not submit consent data more than once',
    causes: 'The consent submission happens more than once',
    solutions: 'Do not submit consent data more than once',
    description: 'Error surfaces when consent data has been provided',
    product: 'Flex',
    date_created: '2021-04-20T09:12:57Z',
    last_updated: '2021-04-20T09:12:57Z',
  },
  80610: {
    code: 80610,
    message: 'Unauthorized Operation',
    log_level: 'WARNING',
    secondary_message: 'Unauthorized. You may be trying to use an invalid combination of sids.',
    log_type: null,
    docs: '## Warning\n\n### Unauthorized Operation\n\nExample Message: Unauthorized. You may be trying to use an invalid combination of sids.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.698Z',
  },
  31603: {
    code: 31603,
    message: 'Decline',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31603\r\n\r\n### Decline\r\n\r\nThe callee does not wish to participate in the call.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:49:29Z',
    last_updated: '2020-08-04T10:00:08.134Z',
  },
  30905: {
    code: 30905,
    message: 'Campaign Review Pending by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30905\r\n\r\n### Campaign Review Pending by Twilio\r\n\r\n Unable to attach the Messaging Service to the Campaign as the Campaign is still under review and has not been accepted by Twilio's DCA.\r\n\r\n#### Possible Causes\r\n* Messaging Service was attempted to be associated before receiving the CAMPAIGN_SHARE_ACCEPT webhook from TCR.\r\n\r\n#### Possible Solutions\r\n* Await the CAMPAIGN_SHARE_ACCEPT webhook from TCR before assigning the Messaging Service to the CampaignID.\r\n* Note: Campaign will remain in a 'FAILED' state until the Messaging Service is successfully re-attached.\r\n\r\n \r\nAdditional help resources\r\n\r\n* [Changes to Externally Registered Campaign Submission](https://support.twilio.com/hc/en-us/articles/13097615242395-Changes-to-Externally-Registered-Campaign-Submission)",
    causes:
      '* Messaging Service was attempted to be associated before receiving the CAMPAIGN_SHARE_ACCEPT webhook from TCR.',
    solutions:
      "* Await the CAMPAIGN_SHARE_ACCEPT webhook from TCR before assigning the Messaging Service to the CampaignID.\r\n* Note: Campaign will remain in a 'FAILED' state until the Messaging Service is successfully re-attached.\r\n\r\n \r\nAdditional help resources\r\n\r\n* [Changes to Externally Registered Campaign Submission](https://support.twilio.com/hc/en-us/articles/13097615242395-Changes-to-Externally-Registered-Campaign-Submission)",
    description:
      "Unable to attach the Messaging Service to the Campaign as the Campaign is still under review and has not been accepted by Twilio's DCA.",
    product: 'Programmable Messaging',
    date_created: '2023-10-23T14:04:06Z',
    last_updated: '2023-10-23T14:04:21.488845Z',
  },
  36006: {
    code: 36006,
    message: 'Broadcast Cannot Be Canceled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36006\r\n\r\n### Broadcast Cannot Be Canceled\r\n\r\n The Broadcast is in a non-cancelable state. The broadcast cannot be canceled when in any of the following statuses: EXECUTION_COMPLETED, EXECUTION_FAILURE, CANCELED.\r\n\r\n#### Possible Causes\r\n* The Broadcast already completed execution, either successfully or with a failure\r\n* The Broadcast was already canceled\r\n\r\n#### Possible Solutions\r\n* Ensure that you provide a Broadcast SID for a Broadcast that is still in progress',
    causes:
      '* The Broadcast already completed execution, either successfully or with a failure\r\n* The Broadcast was already canceled',
    solutions:
      '* Ensure that you provide a Broadcast SID for a Broadcast that is still in progress',
    description:
      'The Broadcast is in a non-cancelable state. The broadcast cannot be canceled when in any of the following statuses: EXECUTION_COMPLETED, EXECUTION_FAILURE, CANCELED.',
    product: 'Programmable Messaging',
    date_created: '2023-12-15T21:54:14Z',
    last_updated: '2024-01-04T23:06:29.286985Z',
  },
  30479: {
    code: 30479,
    message:
      'Toll Free verification rejection - justification needed for more than five toll free phone numbers per businesses',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30479\r\n\r\n### Toll Free verification rejection - justification needed for more than five toll free phone numbers per businesses\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nVerification supports up to 5 toll-free phone numbers for a single entity in a verification submission with no additional information required for traffic intended for US subscribers. For businesses requesting 6 or more toll-free phone numbers approved for verification, please include a detailed explanation in the “Additional Information” field as to the reason for additional toll-free phone numbers. \r\n\r\nFor ISVs or aggregators who provide messaging service to businesses, it’s expected that the information provided represents the entity (your customer) that is engaging with the opted-in consumer. Therefore, a toll-free verification should not be associated with the ISV.  Exceptions may apply when the use case clearly showcases that the ISV manages opt-in mechanisms and is the sole message content creator.\r\n\r\nSending to Canadian handsets qualify for 1 toll-free number per business, as outlined in the Canadian Code of Conduct guide.\r\n\r\n#### Possible Solutions\r\nResubmit and explain the reason for additional toll-free phone numbers within the Additional information field.\r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    causes:
      'Verification supports up to 5 toll-free phone numbers for a single entity in a verification submission with no additional information required for traffic intended for US subscribers. For businesses requesting 6 or more toll-free phone numbers approved for verification, please include a detailed explanation in the “Additional Information” field as to the reason for additional toll-free phone numbers. \r\n\r\nFor ISVs or aggregators who provide messaging service to businesses, it’s expected that the information provided represents the entity (your customer) that is engaging with the opted-in consumer. Therefore, a toll-free verification should not be associated with the ISV.  Exceptions may apply when the use case clearly showcases that the ISV manages opt-in mechanisms and is the sole message content creator.\r\n\r\nSending to Canadian handsets qualify for 1 toll-free number per business, as outlined in the Canadian Code of Conduct guide.',
    solutions:
      'Resubmit and explain the reason for additional toll-free phone numbers within the Additional information field.\r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T22:16:10Z',
    last_updated: '2024-04-16T16:53:46.709304Z',
  },
  32012: {
    code: 32012,
    message: 'SIP: Parent account pooled Trunking CPS limit exceeded',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 32012\r\n\r\n### SIP: Parent account pooled Trunking CPS limit exceeded\r\n\r\n #### Possible Causes \r\n*  Calls Per Second placed on a SIP trunk exceeded the Parent Account pool limit. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Parent Account. \r\n\r\n#### Possible Causes\r\n*  Calls Per Second placed on a SIP trunk exceeded the Parent Account pool limit. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Parent Account. ",
    causes: '*  Calls Per Second placed on a SIP trunk exceeded the Parent Account pool limit. ',
    solutions:
      "*  You've exceeded the number of calls per second you are authorized to make on your Parent Account. ",
    description:
      "#### Possible Causes \r\n*  Calls Per Second placed on a SIP trunk exceeded the Parent Account pool limit. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Parent Account. ",
    product: 'Elastic SIP Trunking',
    date_created: '2017-05-23T20:53:16Z',
    last_updated: '2024-04-17T18:34:53.521627Z',
  },
  21216: {
    code: 21216,
    message: 'API: Call blocked by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21216\r\n\r\n### API: Call blocked by Twilio\r\n\r\n The destination number is blocked by Twilio.\r\n\r\n#### Possible Causes\r\nThe destination has a high-risk of fraud or due to regulatory reasons cannot be reached.\r\n\r\n#### Possible Solutions\r\nIf you have a legitimate need to call this number, please reach out to our [support team](https://support.twilio.com/hc/en-us). ',
    causes:
      'The destination has a high-risk of fraud or due to regulatory reasons cannot be reached.',
    solutions:
      'If you have a legitimate need to call this number, please reach out to our [support team](https://support.twilio.com/hc/en-us). ',
    description: 'The destination number is blocked by Twilio.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:14:15Z',
    last_updated: '2023-09-26T23:07:25.149274Z',
  },
  60703: {
    code: 60703,
    message: 'Invalid phone numbers format',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60703\r\n\r\n### Invalid phone numbers format\r\n\r\n The origination or destination numbers are not valid numbers in E.164 format\r\n\r\n#### Possible Causes\r\n- The origination or destination number is missing the `+` sign, or has separators like spaces or dashes\r\n\r\n#### Possible Solutions\r\n- Check the `From` and `To` numbers in your request',
    causes:
      '- The origination or destination number is missing the `+` sign, or has separators like spaces or dashes',
    solutions: '- Check the `From` and `To` numbers in your request',
    description: 'The origination or destination numbers are not valid numbers in E.164 format',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:34:25Z',
    last_updated: '2020-08-04T10:00:05.145Z',
  },
  30886: {
    code: 30886,
    message: 'Campaign vetting rejection - Invalid Campaign Description',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30886\r\n\r\n### Campaign vetting rejection - Invalid Campaign Description\r\n\r\n The campaign submission has been reviewed and it was rejected because of invalid campaign description.\r\n\r\n#### Possible Causes\r\nThe campaign does not thoroughly describe explain the purpose or description does not match the use case.\r\n\r\n#### Possible Solutions\r\nVerify that campaign description is accurate and detailed. If you are an ISV registering a direct offering to your customers, please indicate that in the campaign description. Resubmit campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign does not thoroughly describe explain the purpose or description does not match the use case.',
    solutions:
      'Verify that campaign description is accurate and detailed. If you are an ISV registering a direct offering to your customers, please indicate that in the campaign description. Resubmit campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because of invalid campaign description.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:35:53Z',
    last_updated: '2023-04-18T11:35:53Z',
  },
  52301: {
    code: 52301,
    message: 'Resulted destination list for requested parameters is empty',
    log_level: 'WARNING',
    secondary_message: 'Search of target destinations by provided parameters returned empty list',
    log_type: null,
    docs: '## Warning - 52301\r\n\r\n### Destination list for requested parameters is empty\r\n\r\n#### Possible Causes \r\n*  No bindings were selected by the provided combination of parameters.\r\n\r\n#### Possible Solutions\r\n*  This may have been your intention, in that case no action is needed.\r\n*  In case you expected to notify some of your bindings then review your parameters and bindings/registrations.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:41:17Z',
    last_updated: '2020-08-04T10:00:21.989Z',
  },
  21213: {
    code: 21213,
    message: 'Caller phone number is required',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to initiate an outbound phone call, but you forgot to send a <span class='rest-attribute'>Caller</span> parameter.  <span class='rest-attribute'>Caller</span> is required, and tells Twilio what Caller ID to use for the phone call.",
    log_type: null,
    docs: "## Error - 21213 \n\n### 'From' phone number is required\n\nYou attempted to initiate an outbound phone call, but you forgot to include a\n'From' parameter. The 'From' parameter is required, and tells Twilio what Caller\nID to use for the phone call.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:58Z',
    last_updated: '2020-08-04T10:00:27.082Z',
  },
  90036: {
    code: 90036,
    message: "Broadcast recipient's 'body' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90036\r\n\r\n### Broadcast recipient's 'body' is too long\r\n\r\n Broadcast Recipient's 'body' is too long\r\n\r\n#### Possible Causes\r\nRecipient's 'body' is too long\r\n\r\n#### Possible Solutions\r\nUse shorter 'body' value for recipient object",
    causes: "Recipient's 'body' is too long",
    solutions: "Use shorter 'body' value for recipient object",
    description: "Broadcast Recipient's 'body' is too long",
    product: null,
    date_created: '2020-12-11T15:46:28Z',
    last_updated: '2020-12-11T15:46:28Z',
  },
  60623: {
    code: 60623,
    message: 'Verification Not Found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 60623\r\n\r\n### Verification Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Lookup request was received but failed during the verification existence check because it was not found a success verification or it had failed or expired.\r\n\r\n#### Possible Solutions\r\n- Retry request to rule out transient issues. \r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    causes:
      'The Lookup request was received but failed during the verification existence check because it was not found a success verification or it had failed or expired.',
    solutions:
      '- Retry request to rule out transient issues. \r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out integration issues.',
    description: null,
    product: 'Lookup',
    date_created: '2024-02-29T20:11:45Z',
    last_updated: '2024-02-29T20:13:26.032353Z',
  },
  50050: {
    code: 50050,
    message: 'Programmable Chat: Service Instance not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Service Instance does not exist.',
    log_type: null,
    docs: '## Error - 50050\r\n\r\n### Programmable Chat: Service Instance not found\r\n\r\n#### Possible Causes \r\n*  Specified Service Instance does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Service Instance is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:44Z',
    last_updated: '2020-08-04T10:00:23.683Z',
  },
  50541: {
    code: 50541,
    message: 'Content variable value is too long',
    log_level: 'ERROR',
    secondary_message:
      'Value in key-value pair of message content variables is exceeding allowed maximum length of 256 characters',
    log_type: 'TWILIO',
    docs: '## ERROR - 50541\r\n\r\n### Content variable value is too long\r\n\r\nValue in key-value pair of message content variables is exceeding allowed maximum length of 256 characters Length of value in message content variables is restricted to 256 characters.\r\n\r\n#### Possible Causes\r\nOne or many values in key-value pairs of message content variables are hitting limit of allowed 256 characters.\r\n\r\n#### Possible Solutions\r\nReduce the length of value characters to maximum 256 in message content variables.',
    causes:
      'One or many values in key-value pairs of message content variables are hitting limit of allowed 256 characters.',
    solutions: 'Reduce the length of value characters to maximum 256 in message content variables.',
    description: 'Length of value in message content variables is restricted to 256 characters.',
    product: 'Conversations',
    date_created: '2023-03-10T14:39:26Z',
    last_updated: '2023-03-10T14:39:26Z',
  },
  57008: {
    code: 57008,
    message: "'EventType' format must be String",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57008\r\n\r\n### 'EventType' format must be String\r\n\r\n Specified 'EventType' format must be String\r\n\r\n#### Possible Causes\r\nSpecified 'EventType' format is invalid, String required\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'EventType' is being passed in request.",
    causes: "Specified 'EventType' format is invalid, String required",
    solutions: "Confirm a valid 'EventType' is being passed in request.",
    description: "Specified 'EventType' format must be String",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:55:47Z',
    last_updated: '2021-05-07T08:55:47Z',
  },
  13211: {
    code: 13211,
    message: 'Dial: Invalid ifMachine value',
    log_level: 'WARNING',
    secondary_message: 'ifMachine must be either "hangup","continue", or "false".',
    log_type: null,
    docs: '## Warning - 13211 \n\n### Dial: Invalid ifMachine value\n\nifMachine must be either "hangup","continue", or "false".\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:31Z',
    last_updated: '2020-08-04T10:00:28.966Z',
  },
  31302: {
    code: 31302,
    message: 'Unsupported Cancel Message Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31302\r\n\r\n### Unsupported Cancel Message Error\r\n\r\n This version of the SDK no longer supports processing cancel push notification messages. You must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS with this version of the SDK to stop receiving cancel push notification messages. Cancellations are now handled internally and reported to you on behalf of the SDK.\r\n\r\n#### Possible Causes\r\nThe identity associated with the Twilio Voice SDK is still registered to receive cancel push notification messages.\r\n\r\n#### Possible Solutions\r\nThe application must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS to stop receiving cancel push notification messages.',
    causes:
      'The identity associated with the Twilio Voice SDK is still registered to receive cancel push notification messages.',
    solutions:
      'The application must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS to stop receiving cancel push notification messages.',
    description:
      'This version of the SDK no longer supports processing cancel push notification messages. You must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS with this version of the SDK to stop receiving cancel push notification messages. Cancellations are now handled internally and reported to you on behalf of the SDK.',
    product: 'Programmable Voice',
    date_created: '2019-09-13T17:39:18Z',
    last_updated: '2020-08-04T10:00:06.996Z',
  },
  51005: {
    code: 51005,
    message: 'Client Connection: Command or keepalive acknowledgement not received',
    log_level: 'ERROR',
    secondary_message: 'warning',
    log_type: null,
    docs: '## Warning - 51005\n\n### Client Connection: Command or keepalive acknowledgement not received\n\n#### Possible Causes \n\nThe client did not acknowledge a message or a keep-alive request, which is required by the connection protocol therefore the connection has been dropped. This is most often caused by network connectivity issues.\n\n#### Possible Solutions\n\nTwilio SDKs automatically recover and reestablish the connection if possible. \nFor best user experience, ensure reliable network connectivity.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:55Z',
    last_updated: '2020-08-04T10:00:22.803Z',
  },
  30882: {
    code: 30882,
    message: 'Campaign vetting rejection - Terms & Conditions',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30882\r\n\r\n### Campaign vetting rejection - Terms & Conditions\r\n\r\n The campaign submission has been reviewed and it was rejected due to Terms and Conditions issues.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because affiliated marketing is not a supported use case. Terms and conditions do not support this use case.\r\n\r\n#### Possible Solutions\r\nIneligible for resubmission. If you feel that this was in error, contact Twilio Customer Support.\r\n\r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because affiliated marketing is not a supported use case. Terms and conditions do not support this use case.',
    solutions:
      'Ineligible for resubmission. If you feel that this was in error, contact Twilio Customer Support.\r\n\r\nAdditional help resources\r\n\r\n* [Forbidden message categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected due to Terms and Conditions issues.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:32:41Z',
    last_updated: '2023-04-18T11:32:41Z',
  },
  64021: {
    code: 64021,
    message: 'Pay: Invalid Operation',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64021\r\n\r\n### Pay: Invalid Operation\r\n\r\n A 64021 Error is an indication invalid operation was provided.\r\n\r\n#### Possible Causes\r\n* Start operation on already started Pay session\r\n\r\n#### Possible Solutions\r\n* Make sure to use a valid operation',
    causes: '* Start operation on already started Pay session',
    solutions: '* Make sure to use a valid operation',
    description: 'A 64021 Error is an indication invalid operation was provided.',
    product: 'Programmable Voice',
    date_created: '2020-07-02T16:04:08Z',
    last_updated: '2020-08-04T10:00:02.393Z',
  },
  60700: {
    code: 60700,
    message: 'Something went wrong. Try again later',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60700\r\n\r\n### Something went wrong. Try again later\r\n\r\n Server error, generic 500 error\r\n\r\n#### Possible Causes\r\n- Details included in the response body\r\n\r\n#### Possible Solutions\r\n- Details included in the response body',
    causes: '- Details included in the response body',
    solutions: '- Details included in the response body',
    description: 'Server error, generic 500 error',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:21:31Z',
    last_updated: '2020-08-04T10:00:05.199Z',
  },
  50349: {
    code: 50349,
    message: 'Conflicting channel modification',
    log_level: 'ERROR',
    secondary_message:
      'The requested channel is already being added or removed by a concurrent API request.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50349\r\n\r\n### Conflicting channel modification\r\n\r\nThe requested channel is already being added or removed by a concurrent API request. The requested channel is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.\r\n\r\n#### Possible Causes\r\n* You might be adding a new channel to the service instance while the channel with the same unique name is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a channel with the same unique name to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same channel by SID or unique name from the service instance.\r\n\r\n#### Possible Solutions\r\n* Implement an operation retrier and repeat the failed channel API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that add or remove channels. Wait until the original request completes and returns an API response, before sending any successive channel requests.',
    causes:
      '* You might be adding a new channel to the service instance while the channel with the same unique name is being removed from another thread.\r\n* You might be submitting multiple concurrent requests to add a channel with the same unique name to the service instance.\r\n* You might be submitting multiple concurrent requests to delete the same channel by SID or unique name from the service instance.',
    solutions:
      '* Implement an operation retrier and repeat the failed channel API requests after an interval of time, using an exponential backoff algorithm.\r\n* Review your application logic that caused the race condition when adding or removing users. Perhaps the conflicting operations are happening in a loop that could be avoided.\r\n* Serialize your API requests that add or remove channels. Wait until the original request completes and returns an API response, before sending any successive channel requests.',
    description:
      'The requested channel is already being added or removed from this service instance concurrently with another API request. The last request will be rejected to avoid inconsistent state.',
    product: 'Programmable Chat',
    date_created: '2020-06-02T07:39:44Z',
    last_updated: '2020-08-04T10:00:02.916Z',
  },
  53667: {
    code: 53667,
    message: 'AWS credentials to access external S3 bucket could not be loaded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53667\r\n\r\n### AWS credentials to access external S3 bucket could not be loaded\r\n\r\n The AWS credentials configured in your account's composition settings could not be loaded.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.\r\n\r\n#### Possible Causes\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Possible Solutions\r\n * In the composition settings section of your account's console, create and assign a new credentials entry for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes:
      ' * If you have specified your own bucket and access credentials, this is most likely due to the fact that the credentials resource has been removed from Twilio.',
    solutions:
      " * In the composition settings section of your account's console, create and assign a new credentials entry for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    description:
      "The AWS credentials configured in your account's composition settings could not be loaded.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.",
    product: 'Programmable Video',
    date_created: '2021-04-13T07:34:49Z',
    last_updated: '2021-04-13T07:34:49Z',
  },
  13803: {
    code: 13803,
    message: 'SMS verb not supported in this realm',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13803\r\n\r\n### SMS verb not supported in this realm\r\n\r\n SMS verb not supported in this realm\r\n\r\n#### Possible Causes\r\nSMS verb not supported in this realm\r\n\r\n#### Possible Solutions\r\nUse SMS verb in another realm',
    causes: 'SMS verb not supported in this realm',
    solutions: 'Use SMS verb in another realm',
    description: 'SMS verb not supported in this realm',
    product: 'Programmable Voice',
    date_created: '2020-08-24T16:37:32Z',
    last_updated: '2020-08-24T16:37:32Z',
  },
  21729: {
    code: 21729,
    message: 'Cannot perform operation on suspended campaign',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21729\r\n\r\n### Cannot perform operation on suspended campaign\r\n\r\n The operation you're trying to perform on this campaign is not allowed because the campaign is in a suspended state.\r\n\r\n#### Possible Causes\r\nCampaign is suspended.\r\n\r\n#### Possible Solutions\r\nContact Twilio support.",
    causes: 'Campaign is suspended.',
    solutions: 'Contact Twilio support.',
    description:
      "The operation you're trying to perform on this campaign is not allowed because the campaign is in a suspended state.",
    product: 'Programmable SMS',
    date_created: '2022-12-09T00:26:46Z',
    last_updated: '2022-12-09T00:26:46Z',
  },
  21719: {
    code: 21719,
    message: 'Incompatible Messaging Service/A2P Use Cases',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21719\r\n\r\n### Incompatible Messaging Service/A2P Use Cases\r\n\r\n Request was unsuccessful due to incompatibility between the Messaging Service use case and the A2P use case for the messaging service.\r\n\r\n#### Possible Causes\r\n* Updating a Messaging Service use case to one that is not compatible with the current A2P use case for this messaging service.\r\n* Creating a new A2P campaign with an A2P use case that is not compatible with the current Messaging Service use case.\r\n\r\n#### Possible Solutions\r\nUpdate the request to pass a compatible A2P/Messaging Service use case. The following resource can be used to retrieve all compatible A2P use cases for a specific Messaging Service: https://messaging.twilio.com/v1/Services/MGXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX/Compliance/Usa2p/Usecases',
    causes:
      '* Updating a Messaging Service use case to one that is not compatible with the current A2P use case for this messaging service.\r\n* Creating a new A2P campaign with an A2P use case that is not compatible with the current Messaging Service use case.',
    solutions:
      'Update the request to pass a compatible A2P/Messaging Service use case. The following resource can be used to retrieve all compatible A2P use cases for a specific Messaging Service: https://messaging.twilio.com/v1/Services/MGXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX/Compliance/Usa2p/Usecases',
    description:
      'Request was unsuccessful due to incompatibility between the Messaging Service use case and the A2P use case for the messaging service.',
    product: 'Programmable SMS',
    date_created: '2021-06-29T16:24:24Z',
    last_updated: '2021-06-29T16:24:24Z',
  },
  22109: {
    code: 22109,
    message: 'Invalid Address SID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22109\r\n\r\n#### Invalid Address SID\r\n\r\nYou attempted to host a phone number with an invalid Address SID. \r\n\r\n#### Possible Causes\r\n\r\n* The SID is not a 34-character string that is prefixed with "AD". \r\n\r\n* The Address resource identified by the SID does not exist anymore or does not belong to your account.\r\n\r\n#### Possible Solutions\r\n\r\n* Please specify an Address SID you’ve created in your [Account Dashboard](https://www.twilio.com/console/phone-numbers/addresses).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:54:35Z',
    last_updated: '2020-08-04T10:00:15.138Z',
  },
  21724: {
    code: 21724,
    message: 'Brand update count exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21724\r\n\r\n### Brand update count exceeded\r\n\r\n Maximum number of brand update requests reached on this brand. Contact support for help.\r\n\r\n#### Possible Causes\r\nToo many requests were made to update a Brand\r\n\r\n#### Possible Solutions\r\nContact Twilio support',
    causes: 'Too many requests were made to update a Brand',
    solutions: 'Contact Twilio support',
    description:
      'Maximum number of brand update requests reached on this brand. Contact support for help.',
    product: 'Programmable SMS',
    date_created: '2021-11-18T18:19:00Z',
    last_updated: '2021-11-18T18:19:00Z',
  },
  63027: {
    code: 63027,
    message: 'Template does not exist for a language and locale',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 63027\r\n\r\n### Template does not exist for a language and locale\r\n\r\n ### Template does not exist for a language and locale\r\n\r\n#### Possible Causes\r\n* Template does not exist for a language and locale\r\n* Template is being sent using the wrong parameters. Content API templates must be sent with a Content Template sid starting with HX and include a Messaging Service. Templates created using the Legacy System through Templates API or the WA Templates Console UI must be sent with a body string.\r\n* Their requested body does not match an approved template.\r\n\r\n#### Possible Solutions\r\n* Double check your body string parameter to make sure it matches exactly with the approved template. New lines or blank characters may cause an issue.\r\n* If the template was created with Content API or Content Editor. Validate that you are sending templates with the right parameters.',
    causes:
      '* Template does not exist for a language and locale\r\n* Template is being sent using the wrong parameters. Content API templates must be sent with a Content Template sid starting with HX and include a Messaging Service. Templates created using the Legacy System through Templates API or the WA Templates Console UI must be sent with a body string.\r\n* Their requested body does not match an approved template.',
    solutions:
      '* Double check your body string parameter to make sure it matches exactly with the approved template. New lines or blank characters may cause an issue.\r\n* If the template was created with Content API or Content Editor. Validate that you are sending templates with the right parameters.',
    description: '### Template does not exist for a language and locale',
    product: 'Programmable SMS',
    date_created: '2019-05-16T19:07:17Z',
    last_updated: '2023-05-18T21:03:46.030005Z',
  },
  30132: {
    code: 30132,
    message: 'Certificate cannot be validated. ',
    log_level: 'ERROR',
    secondary_message: 'We were not able to validate your certificate for your domain.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30132\r\n\r\n### Certificate cannot be validated. \r\n\r\nWe were not able to validate your certificate for your domain. Please upload a new valid certificate.\r\n\r\n#### Possible Causes\r\nInvalid certificate format has been uploaded.\r\n\r\n#### Possible Solutions\r\nUpload a new valid certificate as outlined in Twilio docs for Link Shortening.',
    causes: 'Invalid certificate format has been uploaded.',
    solutions: 'Upload a new valid certificate as outlined in Twilio docs for Link Shortening.',
    description: 'Please upload a new valid certificate.',
    product: 'Programmable SMS',
    date_created: '2022-08-25T17:18:02Z',
    last_updated: '2022-08-25T20:28:26.713945Z',
  },
  21733: {
    code: 21733,
    message: 'Default Messaging Service Not Found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 21733\r\n\r\n### Default Messaging Service Not Found\r\n\r\n Default messaging service not found\r\n\r\n#### Possible Causes\r\nA default messaging service was not created for the account. \r\n\r\n#### Possible Solutions\r\nContact Twilio messaging support with the account sid and error code to make the error code disappear, the outbound message itself should still be successful.',
    causes: 'A default messaging service was not created for the account. ',
    solutions:
      'Contact Twilio messaging support with the account sid and error code to make the error code disappear, the outbound message itself should still be successful.',
    description: 'Default messaging service not found',
    product: 'Programmable Messaging',
    date_created: '2024-01-03T18:54:57Z',
    last_updated: '2024-01-03T18:54:57Z',
  },
  30464: {
    code: 30464,
    message: 'Toll Free verification rejection - Disallowed: Cryptocurrency',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30464\r\n\r\n### Toll Free verification rejection - Disallowed: Cryptocurrency\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (High-risk financial services: Cryptocurrency). \r\n\r\nNo businesses that solely operate in stocks, investing, or cryptocurrency are allowed to send SMS traffic. If there is a mixed use case where that is a partial aspect of the business it may be approved based on the other use case content.\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (High-risk financial services: Cryptocurrency). \r\n\r\nNo businesses that solely operate in stocks, investing, or cryptocurrency are allowed to send SMS traffic. If there is a mixed use case where that is a partial aspect of the business it may be approved based on the other use case content.',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:10:33Z',
    last_updated: '2024-02-22T21:10:33Z',
  },
  25012: {
    code: 25012,
    message: 'Updating the email address is unsupported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25012\r\n\r\n### Updating the email address is unsupported\r\n\r\n Updating the email address is unsupported.\r\n\r\n#### Possible Causes\r\nThe system does not allow updates to the user's email address.\r\n\r\n#### Possible Solutions\r\nEmail address updates are not permitted. If changes to the email address are necessary, contact support for assistance with specific cases.",
    causes: "The system does not allow updates to the user's email address.",
    solutions:
      'Email address updates are not permitted. If changes to the email address are necessary, contact support for assistance with specific cases.',
    description: 'Updating the email address is unsupported.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:03:30Z',
    last_updated: '2023-12-04T14:17:10.999295Z',
  },
  12400: {
    code: 12400,
    message: 'Internal Failure',
    log_level: 'ERROR',
    secondary_message:
      'An internal error has occurred that prevented Twilio from processing your response.',
    log_type: null,
    docs: '## Error - 12400 \r\n\r\n### Internal Failure\r\n\r\nAn internal error has occurred that prevented Twilio from processing your response.\r\n\r\n#### Possible Causes \r\n*  We screwed up. Sorry!\r\n\r\n\r\n#### Possible Solutions\r\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it.\r\n*   Note the time of the error and what you were trying to do when it occurred.\r\n\r\n\r\n\r\n\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:29Z',
    last_updated: '2020-08-04T10:00:29.112Z',
  },
  33104: {
    code: 33104,
    message: 'Configuration incomplete',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33104\r\n\r\n### Configuration incomplete\r\n\r\n Raised whenever the configuration for a given resource is incomplete.\r\n\r\n\r\n#### Possible Causes\r\n * While activating a SIM, your request was rejected because the SIM is not associated with a Rate Plan.\r\n * While sending a Command, your request was rejected because SIM is not properly configured (e.g. the SIM is not in status `active`).\r\n\r\n#### Possible Solutions\r\n * While activating a SIM, ensure the SIM is associated with a proper Rate Plan.\r\n * While sending a Command, ensure the given `sim` is in status `ready` or `active`, and paired with a SIM.\r\n',
    causes:
      ' * While activating a SIM, your request was rejected because the SIM is not associated with a Rate Plan.\r\n * While sending a Command, your request was rejected because SIM is not properly configured (e.g. the SIM is not in status `active`).',
    solutions:
      ' * While activating a SIM, ensure the SIM is associated with a proper Rate Plan.\r\n * While sending a Command, ensure the given `sim` is in status `ready` or `active`, and paired with a SIM.\r\n',
    description: 'Raised whenever the configuration for a given resource is incomplete.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:18:45Z',
    last_updated: '2020-09-15T11:18:45Z',
  },
  53004: {
    code: 53004,
    message: 'Client sent an invalid signaling message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53004: Client sent an invalid signaling message\r\n\r\nRaised whenever the Client sends a message to the Server that the Server cannot handle.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:39:17Z',
    last_updated: '2020-08-04T10:00:19.682Z',
  },
  95102: {
    code: 95102,
    message: 'Transcript media processing error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95102\r\n\r\n### Transcript media processing error\r\n\r\n Twilio failed to transcribe audio due to an issue with the transcript recording. The transcript files have been deleted and the resource has been marked as “failed”\r\n\r\n\r\n#### Possible Causes\r\nThe recording was deleted.\r\nThe recording is not authorized to the given account.\r\n\r\n\r\n\r\n#### Possible Solutions\r\nEnsure the recording status is completed before starting to transcribe.\r\nEnsure the recording was not deleted.\r\nEnsure the recording is part of the given account.',
    causes:
      'The recording was deleted.\r\nThe recording is not authorized to the given account.\r\n\r\n',
    solutions:
      'Ensure the recording status is completed before starting to transcribe.\r\nEnsure the recording was not deleted.\r\nEnsure the recording is part of the given account.',
    description:
      'Twilio failed to transcribe audio due to an issue with the transcript recording. The transcript files have been deleted and the resource has been marked as “failed”\r\n',
    product: 'Voice Intelligence',
    date_created: '2024-06-12T17:37:47Z',
    last_updated: '2024-06-12T17:43:20.74558Z',
  },
  32114: {
    code: 32114,
    message: 'SIP: Unsupported parameter value',
    log_level: 'WARNING',
    secondary_message: 'A URI parameter contains an unsupported value and will be ignored',
    log_type: 'APPLICATION',
    docs: '## WARNING - 32114\r\n\r\n### SIP: Unsupported parameter value\r\n\r\nA URI parameter contains an unsupported value and will be ignored Twilio parses certain standard URI parameters, such as the "transport" parameter, as well as Twilio-specific parameters such as "secure".\r\n\r\n#### Possible Causes\r\n* If using the "secure" parameter, allowed values are "true" and "false". Any other value will be treated as "false" and trigger this warning.\r\n\r\n#### Possible Solutions\r\n* Check the other details of the debugger alert. The alert may indicate which parameter contains the unsupported value.\r\n* Update your application/configuration to ensure a URI with appropriate parameters is sent.',
    causes:
      '* If using the "secure" parameter, allowed values are "true" and "false". Any other value will be treated as "false" and trigger this warning.',
    solutions:
      '* Check the other details of the debugger alert. The alert may indicate which parameter contains the unsupported value.\r\n* Update your application/configuration to ensure a URI with appropriate parameters is sent.',
    description:
      'Twilio parses certain standard URI parameters, such as the "transport" parameter, as well as Twilio-specific parameters such as "secure".',
    product: null,
    date_created: '2020-01-15T18:56:07Z',
    last_updated: '2020-08-04T10:00:05.238Z',
  },
  21450: {
    code: 21450,
    message: 'Phone number already validated on your account',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to add an Outgoing Caller ID to your account, but that number is already verified as an Outgoing Caller ID on your account.',
    log_type: null,
    docs: '## Error - 21450\n\n### Phone number already verified for your account\n\nYou attempted to verify a phone number for your account, but that number is\nalready verified for your account.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:59Z',
    last_updated: '2020-08-04T10:00:26.945Z',
  },
  50710: {
    code: 50710,
    message: 'ChatbotConfiguration.InitialContext is invalid.',
    log_level: 'ERROR',
    secondary_message: 'ChatbotConfiguration.InitialContext is invalid.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50710\r\n\r\n### ChatbotConfiguration.InitialContext is invalid.\r\n\r\nChatbotConfiguration.InitialContext is invalid. \r\n\r\n#### Possible Causes\r\nYou are trying to create Virtual Agent participant with ChatbotConfiguration.InitialContext which is longer than 32768 characters.\r\n\r\n#### Possible Solutions\r\n* Update ChatbotConfiguration.InitialContext parameter according to provided validation rules.',
    causes:
      'You are trying to create Virtual Agent participant with ChatbotConfiguration.InitialContext which is longer than 32768 characters.',
    solutions:
      '* Update ChatbotConfiguration.InitialContext parameter according to provided validation rules.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:07:20Z',
    last_updated: '2023-10-11T18:07:20Z',
  },
  30410: {
    code: 30410,
    message: 'Provider Timeout Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 30410\r\n\r\n### Provider Timeout Error\r\n\r\n The provider used may be experiencing disruptions resulting in errors or request timeouts. Messages are failed and not retried to avoid duplicate message delivery.\r\n\r\n#### Possible Causes\r\nProvider side disruptions.\r\n\r\n#### Possible Solutions\r\n Please attempt to send messages at a later time.',
    causes: 'Provider side disruptions.',
    solutions: ' Please attempt to send messages at a later time.',
    description:
      'The provider used may be experiencing disruptions resulting in errors or request timeouts. Messages are failed and not retried to avoid duplicate message delivery.',
    product: 'Programmable SMS',
    date_created: '2022-04-28T22:33:09Z',
    last_updated: '2022-04-28T22:33:09Z',
  },
  21454: {
    code: 21454,
    message: 'Invalid CallDelay',
    log_level: 'ERROR',
    secondary_message:
      'Call delay specified must be an integer between 0 and 60, specifying the number of seconds to delay before initiating the validation call.',
    log_type: null,
    docs: '## Error - 21454 \n\n### Invalid CallDelay\n\nCall delay specified must be an integer between 0 and 60, specifying the number of seconds to delay before initiating the validation call.\n\n#### Possible Causes \n*  Make sure to enter an integer between 0 and 60.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:00Z',
    last_updated: '2020-08-04T10:00:26.87Z',
  },
  50503: {
    code: 50503,
    message: 'Programmable Chat: Message body not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Message Body parameter.',
    log_type: null,
    docs: '## Error - 50503\r\n\r\n### Programmable Chat: Message body not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Message Body parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message Body is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:53Z',
    last_updated: '2020-08-04T10:00:22.935Z',
  },
  40136: {
    code: 40136,
    message: 'TaskRouter->Conference',
    log_level: 'ERROR',
    secondary_message:
      'Conference Instruction can only be issued on a currently pending reservation.',
    log_type: null,
    docs: '## Error - 40136\r\n\r\n### The Reservation must currently be Pending - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "+18001234567"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2018-12-03T19:12:13Z',
    last_updated: '2020-08-04T10:00:11.648Z',
  },
  21626: {
    code: 21626,
    message: "Invalid 'StatusCallbackEvent'",
    log_level: 'ERROR',
    secondary_message: 'One or more of the StatusCallbackEvents provided were invalid.',
    log_type: null,
    docs: "## Error - 21626\n\n### Invalid 'StatusCallbackEvent'\n\nOne or more of the StatusCallbackEvents provided were invalid.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:06Z',
    last_updated: '2020-08-04T10:00:26.572Z',
  },
  32710: {
    code: 32710,
    message: 'Voice User-Defined Message: Subscription Callback Internal Error',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32710\r\n\r\n### Voice User-Defined Message: Subscription Callback Internal Error\r\n\r\n Twilio experienced an unexpected internal error in attempting to deliver an User-Defined Message event to the callback URL provided in the Voice User-Defined Message Subscription request.\r\n\r\n#### Possible Causes\r\n* An error occurred during communication with Twilio internal services.\r\n\r\n#### Possible Solutions\r\n* See the Debugger in the Twilio Console for further information. If you repeatedly receive this error, please contact Twilio Support.',
    causes: '* An error occurred during communication with Twilio internal services.',
    solutions:
      '* See the Debugger in the Twilio Console for further information. If you repeatedly receive this error, please contact Twilio Support.',
    description:
      'Twilio experienced an unexpected internal error in attempting to deliver an User-Defined Message event to the callback URL provided in the Voice User-Defined Message Subscription request.',
    product: 'Programmable Voice',
    date_created: '2022-08-18T21:52:18Z',
    last_updated: '2022-08-18T23:55:42.484067Z',
  },
  63005: {
    code: 63005,
    message:
      'Channel did not accept given content. Please see Channel specific error message for more information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 63005\r\n\r\n### Channel did not accept given content. Please see Channel specific error message for more information\r\n\r\n ### Channel did not accept given content\r\n\r\n#### Possible Causes\r\n*   The content you are trying to send was rejected by the Channel. Please see Channel specific error message for more information. \r\n*   When sending messages to an end user on WhatsApp, this error may occur when the end user is not a valid WhatsApp user.\r\n*   When sending messages with media to an end user on WhatsApp, this error may occur when WhatsApp detects an issue with the media file sent.\r\n\r\n#### Possible Solutions\r\n*   Make sure the end user you are messaging has a valid WhatsApp account.\r\n*   Make sure the media file sent is valid. Try to download the media file being sent. Export the file to a different valid format and re-upload it to your storage solution. If sending over WhatsApp, resubmit a new template for approval with the new media file.\r\n*   Confirm that you are sending rich content within the sending session guidelines. If fields that are only supported as part of a template or fields that are only available in session are sent incorrectly, this error may occur. ',
    causes:
      '*   The content you are trying to send was rejected by the Channel. Please see Channel specific error message for more information. \r\n*   When sending messages to an end user on WhatsApp, this error may occur when the end user is not a valid WhatsApp user.\r\n*   When sending messages with media to an end user on WhatsApp, this error may occur when WhatsApp detects an issue with the media file sent.',
    solutions:
      '*   Make sure the end user you are messaging has a valid WhatsApp account.\r\n*   Make sure the media file sent is valid. Try to download the media file being sent. Export the file to a different valid format and re-upload it to your storage solution. If sending over WhatsApp, resubmit a new template for approval with the new media file.\r\n*   Confirm that you are sending rich content within the sending session guidelines. If fields that are only supported as part of a template or fields that are only available in session are sent incorrectly, this error may occur. ',
    description: '### Channel did not accept given content',
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:19:12Z',
    last_updated: '2024-04-30T20:53:10.206223Z',
  },
  30752: {
    code: 30752,
    message: 'Brand Registration Failure: Invalid or expired OTP',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30752\r\n\r\n### Brand Registration Failure: Invalid or expired OTP\r\n\r\n You have used either an invalid or an expired OTP for brand verification.\r\n\r\n#### Possible Causes\r\nYou have used either an invalid or an expired OTP for brand verification.\r\n\r\n#### Possible Solutions\r\nPlease use a valid OTP for verifying your Sole Proprietor brand. You can use our public api or console to request a latest OTP and use that for verification.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes: 'You have used either an invalid or an expired OTP for brand verification.',
    solutions:
      'Please use a valid OTP for verifying your Sole Proprietor brand. You can use our public api or console to request a latest OTP and use that for verification.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description: 'You have used either an invalid or an expired OTP for brand verification.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:44:24Z',
    last_updated: '2024-02-13T16:14:20.008375Z',
  },
  22156: {
    code: 22156,
    message: 'Port In Error - Invalid Account Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 22156\r\n\r\n### Port In Error - Invalid Account Number\r\n\r\n The Account Number submitted in the port in request for this phone number does not match the losing carrier's information. \r\n\r\n#### Possible Causes\r\nThe Account Number submitted for the port in request does not match the losing carrier's information. \r\n\r\n#### Possible Solutions\r\nUpdate Account Number in the port in request to one that matches the losing carrier's information. \r\n\r\nNote if this is the only phone number in a port in request that got rejected you may need to start a new port in request with this phone number so that you can correct the account number as it may be different from the other phone numbers in this request.",
    causes:
      "The Account Number submitted for the port in request does not match the losing carrier's information. ",
    solutions:
      "Update Account Number in the port in request to one that matches the losing carrier's information. \r\n\r\nNote if this is the only phone number in a port in request that got rejected you may need to start a new port in request with this phone number so that you can correct the account number as it may be different from the other phone numbers in this request.",
    description:
      "The Account Number submitted in the port in request for this phone number does not match the losing carrier's information. ",
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:05:47Z',
    last_updated: '2024-04-22T23:05:47Z',
  },
  35132: {
    code: 35132,
    message: 'Bulk : Provided Attributes JSON is not valid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35132\r\n\r\n### Bulk : Provided Attributes JSON is not valid\r\n\r\n Provided Attributes are not in the expected JSON format\r\n\r\n#### Possible Causes\r\nProvided attributes is not a valid JSON\r\n\r\n#### Possible Solutions\r\nCheck if all the attributes are in expected format',
    causes: 'Provided attributes is not a valid JSON',
    solutions: 'Check if all the attributes are in expected format',
    description: 'Provided Attributes are not in the expected JSON format',
    product: 'Programmable Messaging',
    date_created: '2023-05-30T21:25:11Z',
    last_updated: '2023-06-05T15:24:26.116734Z',
  },
  63013: {
    code: 63013,
    message: 'Channel policy violation',
    log_level: 'ERROR',
    secondary_message: "This message send failed because it violates Channel provider's policy.",
    log_type: 'TWILIO',
    docs: "## ERROR - 63013\r\n\r\n### Channel policy violation\r\n\r\nThis message send failed because it violates Channel provider's policy. \r\n\r\n\r\n\r\n#### Possible Causes\r\nThis message send failed because it violates Channel provider's policy. Please see Channel specific error message for more information. \r\n*  This error may also be seen if more than 4 consecutive whitespaces replace a placeholder in a WhatsApp message body.\r\n\r\n#### Possible Solutions\r\nCheck content is in compliance with Channel providers policy.",
    causes:
      "This message send failed because it violates Channel provider's policy. Please see Channel specific error message for more information. \r\n*  This error may also be seen if more than 4 consecutive whitespaces replace a placeholder in a WhatsApp message body.",
    solutions: 'Check content is in compliance with Channel providers policy.',
    description: '\r\n\r\n',
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:28:00Z',
    last_updated: '2021-06-25T11:43:14.789182Z',
  },
  32011: {
    code: 32011,
    message: 'Error communicating with your SIP communications infrastructure',
    log_level: 'WARNING',
    secondary_message:
      'Twilio received a SIP error while communicating with your communications infrastructure specified in either your Trunking Origination URI(s), or Dial SIP URI.',
    log_type: 'APPLICATION',
    docs: "## WARNING - 32011\r\n\r\n### Error communicating with your SIP communications infrastructure\r\n\r\nTwilio received a SIP error while communicating with your communications infrastructure specified in either your Trunking Origination URI(s), or Dial SIP URI. There was a problem communicating with a specific endpoint of your SIP communications infrastructure. This means there was either a lack of timely response, an error response or an invalid response from your SIP endpoint. This may result in increased call setup times or even failed call depending on the failover configuration for your Elastic SIP Trunk or SIP application. Twilio will make multiple attempts to deliver calls to your endpoint and each failed attempt will have its own notification.\r\nThe notification will have details about the specific error response and the SIP URI that causes the failure.\r\n\r\n#### Possible Causes\r\n* Your SIP endpoint is not reachable due to network connectivity issue between Twilio and your system\r\n* Your SIP endpoint is not responding (service down or maintenance) \r\n* There is a firewall in your network that is blocking SIP traffic from Twilio\r\n* Your SIP endpoint is sending an error response, such as SIP 500 response.\r\n* The SIP URI specified in your Trunking Origination URI, <Dial> <SIP> TwiML or REST API call is invalid\r\n* Your SIP endpoint does not support TLSv1.2\r\n\r\n#### Possible Solutions\r\n* Ensure the SIP URI used in the request is correctly configured.\r\n * For details on how to configure your Origination URIs for SIP trunking, please see [Origination settings](/docs/sip-trunking#origination).\r\n * For SIP interfaces verify that your SIP URI in your <Dial> <SIP> TwiML or REST API call, see [Receiving SIP from Twilio](/docs/voice/api/receiving-sip).\r\n* Ensure you've allowed Twilio's IP address ranges and ports on your firewall for SIP signalling and RTP media traffic, see [IP addresses - Trunking](/docs/sip-trunking#ip-addresses) or [IP addresses - SIP Interface](/docs/voice/api/sip-interface#ip-addresses)\r\n* Ensure that your SIP servers are running properly and is properly processing calls from Twilio.\r\n* Ensure that your SIP servers support TLSv1.2, or configure your account to allow TLSv1.0+",
    causes:
      '* Your SIP endpoint is not reachable due to network connectivity issue between Twilio and your system\r\n* Your SIP endpoint is not responding (service down or maintenance) \r\n* There is a firewall in your network that is blocking SIP traffic from Twilio\r\n* Your SIP endpoint is sending an error response, such as SIP 500 response.\r\n* The SIP URI specified in your Trunking Origination URI, <Dial> <SIP> TwiML or REST API call is invalid\r\n* Your SIP endpoint does not support TLSv1.2',
    solutions:
      "* Ensure the SIP URI used in the request is correctly configured.\r\n * For details on how to configure your Origination URIs for SIP trunking, please see [Origination settings](/docs/sip-trunking#origination).\r\n * For SIP interfaces verify that your SIP URI in your <Dial> <SIP> TwiML or REST API call, see [Receiving SIP from Twilio](/docs/voice/api/receiving-sip).\r\n* Ensure you've allowed Twilio's IP address ranges and ports on your firewall for SIP signalling and RTP media traffic, see [IP addresses - Trunking](/docs/sip-trunking#ip-addresses) or [IP addresses - SIP Interface](/docs/voice/api/sip-interface#ip-addresses)\r\n* Ensure that your SIP servers are running properly and is properly processing calls from Twilio.\r\n* Ensure that your SIP servers support TLSv1.2, or configure your account to allow TLSv1.0+",
    description:
      'There was a problem communicating with a specific endpoint of your SIP communications infrastructure. This means there was either a lack of timely response, an error response or an invalid response from your SIP endpoint. This may result in increased call setup times or even failed call depending on the failover configuration for your Elastic SIP Trunk or SIP application. Twilio will make multiple attempts to deliver calls to your endpoint and each failed attempt will have its own notification.\r\nThe notification will have details about the specific error response and the SIP URI that causes the failure.',
    product: 'Elastic SIP Trunking',
    date_created: '2017-05-11T18:55:36Z',
    last_updated: '2023-08-01T13:17:30.0446Z',
  },
  13410: {
    code: 13410,
    message: 'Play: Invalid loop value',
    log_level: 'WARNING',
    secondary_message:
      "The value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/play#loop'>Play Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13410 \n\n### Play: Invalid loop value\n\nThe value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/play#loop'>Play Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:42Z',
    last_updated: '2020-08-04T10:00:28.008Z',
  },
  21401: {
    code: 21401,
    message: 'Invalid Phone Number',
    log_level: 'ERROR',
    secondary_message:
      'The phone number you specified was not a valid North American (US or Canadian) number.  Twilio accepts only 10 digit US domestic and Canadian phone numbers, with or without a leading "1" or "+1", with any combination of character separators.  For example, these are all valid: 415-867-5309, 4158675309, +1 (415) 867 5309.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21401\r\n\r\n### Invalid Phone Number\r\n\r\nThe phone number you specified was not a valid North American (US or Canadian) number.  Twilio accepts only 10 digit US domestic and Canadian phone numbers, with or without a leading "1" or "+1", with any combination of character separators.  For example, these are all valid: 415-867-5309, 4158675309, +1 (415) 867 5309. ## Error - 21401\r\n\r\n### Invalid Phone Number\r\n\r\nThe phone number you specified was not a valid SMS-enabled phone number or alphanumeric sender ID.\r\n\r\nIf a phone number was used, this number must be one you have purchased from or ported to Twilio in [E.164 format][e164].\r\n\r\nAlphanumeric sender IDs can only be used with [accepted characters][alpha-sender-id] when messaging [countries where this feature is supported][alphanumeric-countries].\r\n\r\n[e164]: http://en.wikipedia.org/wiki/E.164\r\n[alphanumeric-countries]: https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID\r\n[alpha-sender-id]: /docs/api/rest/sending-messages#alpha-sender-id\r\n\r\n#### Possible Causes\r\nThe phone number is not supported in North America.\r\n\r\n#### Possible Solutions\r\nTry using a different phone number: https://www.twilio.com/phone-numbers',
    causes: 'The phone number is not supported in North America.',
    solutions: 'Try using a different phone number: https://www.twilio.com/phone-numbers',
    description:
      '## Error - 21401\r\n\r\n### Invalid Phone Number\r\n\r\nThe phone number you specified was not a valid SMS-enabled phone number or alphanumeric sender ID.\r\n\r\nIf a phone number was used, this number must be one you have purchased from or ported to Twilio in [E.164 format][e164].\r\n\r\nAlphanumeric sender IDs can only be used with [accepted characters][alpha-sender-id] when messaging [countries where this feature is supported][alphanumeric-countries].\r\n\r\n[e164]: http://en.wikipedia.org/wiki/E.164\r\n[alphanumeric-countries]: https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID\r\n[alpha-sender-id]: /docs/api/rest/sending-messages#alpha-sender-id',
    product: null,
    date_created: '2016-03-31T17:13:58Z',
    last_updated: '2023-10-31T17:09:48.2171Z',
  },
  70153: {
    code: 70153,
    message: 'Public Key Specified Does Not Exist',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70153 \r\n\r\n### Public Key Specified Does Not Exist\r\nThe Public Key with the SID provided in the JWT header does exist. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Update the kid value provided in the JWT header.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:33:26Z',
    last_updated: '2020-08-04T10:00:18.742Z',
  },
  33203: {
    code: 33203,
    message: 'Messaging not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33203\r\n\r\n### Messaging not allowed\r\n\r\n Raised whenever a Command from your SIM is received but not permitted.\r\n\r\n\r\n#### Possible Causes\r\n * The SIM that sent the Command, is not in status `ready` or `active`.\r\n * The associated Rate Plan of the SIM does not have commands enabled.\r\n * Breakout Commands from your SIMs are only permitted for Narrowband SIMs.\r\n\r\n\r\n#### Possible Solutions\r\n * While sending Commands from your SIM, verify that the SIM is either in status `ready` or `active`.\r\n * While sending Commands from your SIM, ensure that the associated Rate Plan of the SIM has commands enabled.\r\n',
    causes:
      ' * The SIM that sent the Command, is not in status `ready` or `active`.\r\n * The associated Rate Plan of the SIM does not have commands enabled.\r\n * Breakout Commands from your SIMs are only permitted for Narrowband SIMs.\r\n',
    solutions:
      ' * While sending Commands from your SIM, verify that the SIM is either in status `ready` or `active`.\r\n * While sending Commands from your SIM, ensure that the associated Rate Plan of the SIM has commands enabled.\r\n',
    description: 'Raised whenever a Command from your SIM is received but not permitted.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:26:30Z',
    last_updated: '2020-09-15T11:26:30Z',
  },
  30472: {
    code: 30472,
    message: 'Toll Free verification rejection - Could not verify Business',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30472\r\n\r\n### Toll Free verification rejection - Could not verify Business\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified. The business could not be verified, this may not be a valid business. \r\n\r\n#### Possible Solutions\r\n- Verify that the business is a valid business\r\n- Ensure all business information fields are valid and accurately represent the business who manages the opt-in and has the relationship with the consumer:\r\n\r\n  **BusinessName**, **BusinessStreetAddress**, **BusinessCity**, **BusinessStateProvinceRegion**, **BusinessPostalCode**, **BusinessCountry**, **BusinessContactFirstName**, **BusinessContactLastName**, **BusinessContactEmail**, **BusinessContactPhone**, **BusinessWebsite**\r\n- Correct the business information fields on toll-free verification submission by editing it and then resubmit it.\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    causes:
      'The toll-free phone number cannot be verified. The business could not be verified, this may not be a valid business. ',
    solutions:
      '- Verify that the business is a valid business\r\n- Ensure all business information fields are valid and accurately represent the business who manages the opt-in and has the relationship with the consumer:\r\n\r\n  **BusinessName**, **BusinessStreetAddress**, **BusinessCity**, **BusinessStateProvinceRegion**, **BusinessPostalCode**, **BusinessCountry**, **BusinessContactFirstName**, **BusinessContactLastName**, **BusinessContactEmail**, **BusinessContactPhone**, **BusinessWebsite**\r\n- Correct the business information fields on toll-free verification submission by editing it and then resubmit it.\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:41:31Z',
    last_updated: '2024-02-28T07:24:14.0486Z',
  },
  20160: {
    code: 20160,
    message: 'Invalid Token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20160 \r\n\r\n### Invalid Token\r\nThe JWT provided to the Twilio API is not a valid JWT.\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest version of Twilio Helper libraries\r\n* To check whether the JWT is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:14:48Z',
    last_updated: '2020-08-04T10:00:18.938Z',
  },
  60226: {
    code: 60226,
    message: 'Messages sent to china require friendly_name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60226\r\n\r\n### Messages sent to china require friendly_name\r\n\r\n Messages sent to china require friendly_name\r\n\r\n#### Possible Causes\r\nYou are trying to send a verification to a chinese phone number but didn't specify the friendly name\r\n\r\n#### Possible Solutions\r\nSend the friendly name if the verification is done to a chinese phone number",
    causes:
      "You are trying to send a verification to a chinese phone number but didn't specify the friendly name",
    solutions: 'Send the friendly name if the verification is done to a chinese phone number',
    description: 'Messages sent to china require friendly_name',
    product: 'Verify',
    date_created: '2021-09-07T20:04:16Z',
    last_updated: '2021-09-07T20:04:16Z',
  },
  21645: {
    code: 21645,
    message: 'Supporting Document cannot be deleted due to active Regulatory Bundle assignment',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21645\r\n\r\n### Supporting Document cannot be deleted due to active Regulatory Bundle assignment\r\n\r\n The Supporting Document cannot be deleted as it is an active item assignment in one or more Regulatory Bundles.\r\n\r\n#### Possible Causes\r\nThe Supporting Document cannot be deleted as it is an active item assignment in one or more Regulatory Bundles.\r\n\r\n#### Possible Solutions\r\nUnassign the Supporting Document from the Regulatory Bundle(s)',
    causes:
      'The Supporting Document cannot be deleted as it is an active item assignment in one or more Regulatory Bundles.',
    solutions: 'Unassign the Supporting Document from the Regulatory Bundle(s)',
    description:
      'The Supporting Document cannot be deleted as it is an active item assignment in one or more Regulatory Bundles.',
    product: 'Phone Numbers',
    date_created: '2020-07-17T19:35:06Z',
    last_updated: '2020-08-04T10:00:02.075Z',
  },
  53623: {
    code: 53623,
    message: 'AWS credentials to access external S3 bucket could not be loaded',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53623\r\n\r\n### AWS credentials to access external S3 bucket could not be loaded\r\n\r\nThe AWS credentials configured in your account's composition settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, create and assign a new credentials entry for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-11T14:38:26Z',
    last_updated: '2020-08-04T10:00:13.456Z',
  },
  91002: {
    code: 91002,
    message: 'Incorrect values for pagination',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91002\r\n\r\n### Incorrect values for pagination\r\n\r\n Pagination failed due to bad paging values\r\n\r\n#### Possible Causes\r\nPage and PageSize are invalid values\r\n\r\n#### Possible Solutions\r\nPage and PageSize must be integers greater than or equal than zero',
    causes: 'Page and PageSize are invalid values',
    solutions: 'Page and PageSize must be integers greater than or equal than zero',
    description: 'Pagination failed due to bad paging values',
    product: 'Events',
    date_created: '2020-09-16T15:45:21Z',
    last_updated: '2021-01-06T16:24:19.34Z',
  },
  50109: {
    code: 50109,
    message: 'Conversation role not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Conversation Role does not exist.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50109\r\n\r\n### Conversation role not found\r\n\r\nSpecified Conversation Role does not exist. \r\n\r\n#### Possible Causes\r\nSpecified Conversation Role does not exist.\r\n\r\n#### Possible Solutions\r\nConfirm a valid Conversation Role is being passed in request.',
    causes: 'Specified Conversation Role does not exist.',
    solutions: 'Confirm a valid Conversation Role is being passed in request.',
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-10-13T12:22:00Z',
    last_updated: '2021-10-13T12:22:00Z',
  },
  70152: {
    code: 70152,
    message: 'Request Contains Invalid Flags',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70152\r\n\r\n### Request Contains Invalid Flags\r\nOne or more of the provided flags in the API key request are invalid in the given context.\r\n\r\n#### Possible Causes \r\n* An API key is attempting to create a new key with greater permissions than what it is assigned.\r\n\r\n#### Possible Solution:\r\n* Remove the invalid flag(s) that would expand permissions.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:31:59Z',
    last_updated: '2020-08-04T10:00:18.764Z',
  },
  60222: {
    code: 60222,
    message: 'SendGrid The from address does not match a verified Sender Identity',
    log_level: 'ERROR',
    secondary_message:
      'The from address does not match a verified Sender Identity. Mail cannot be sent until this error is resolved.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60222\r\n\r\n### SendGrid The from address does not match a verified Sender Identity\r\n\r\nThe from address does not match a verified Sender Identity. Mail cannot be sent until this error is resolved. Now SendGrid needs that the account has been verified before it can send messages.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nThe SendGrid account from address the message has not been verified.\r\n\r\n#### Possible Solutions\r\nVisit https://sendgrid.com/docs/for-developers/sending-email/sender-identity/ to see the Sender Identity requirements',
    causes: 'The SendGrid account from address the message has not been verified.',
    solutions:
      'Visit https://sendgrid.com/docs/for-developers/sending-email/sender-identity/ to see the Sender Identity requirements',
    description:
      'Now SendGrid needs that the account has been verified before it can send messages.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-07-16T23:53:55Z',
    last_updated: '2021-05-18T04:52:14.933Z',
  },
  30135: {
    code: 30135,
    message: 'Unable to issue certificate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 30135\r\n\r\n### Unable to issue certificate\r\n\r\n \r\n\r\n#### Possible Causes\r\nDomain DNS setup is not completed.\r\nThere is an issue with the certificate authority\r\n\r\n#### Possible Solutions\r\nPlease verify your Domain DNS setup. If you continue seeing this error, please contact the Support team',
    causes:
      'Domain DNS setup is not completed.\r\nThere is an issue with the certificate authority',
    solutions:
      'Please verify your Domain DNS setup. If you continue seeing this error, please contact the Support team',
    description: null,
    product: 'Programmable Messaging',
    date_created: '2024-06-27T15:37:13Z',
    last_updated: '2024-06-27T15:37:13Z',
  },
  80202: {
    code: 80202,
    message: 'No Available Message Proxy',
    log_level: 'WARNING',
    secondary_message:
      'This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having sms capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities, or if your only available proxy numbers do not have messaging capabilities.',
    log_type: null,
    docs: '## Warning\n\n### No Available Message Proxy\n\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having sms capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities, or if your only available proxy numbers do not have messaging capabilities.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.151Z',
  },
  30898: {
    code: 30898,
    message: 'Campaign vetting rejection - Excessive EIN  ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30898\r\n\r\n### Campaign vetting rejection - Excessive EIN  \r\n\r\n The campaign submission has been reviewed and it was rejected because of repeated use of same for multiple brands.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because it the same EIN is used for multiple brands. \r\n\r\n#### Possible Solutions\r\nOnly register minimum number of brands per EIN and do not resubmit until brand registration is updated.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes: 'The campaign cannot be approved because it the same EIN is used for multiple brands. ',
    solutions:
      'Only register minimum number of brands per EIN and do not resubmit until brand registration is updated.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because of repeated use of same for multiple brands.',
    product: 'Programmable Messaging',
    date_created: '2023-05-10T07:42:25Z',
    last_updated: '2023-05-10T07:42:25Z',
  },
  45741: {
    code: 45741,
    message: 'Failed to create webchat conversation. Account not authorized ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45741\r\n\r\n### Failed to create webchat conversation. Account not authorized \r\n\r\n Failed to create webchat conversation for provided address SID. Account not authorized \r\n\r\n#### Possible Causes\r\nRequest attempted to access resource where access is not allowed for given credentials.\r\n\r\n#### Possible Solutions\r\nCheck that credentials are correct.\r\n\r\nCheck that accessed resource is set correctly or apply for permissions.',
    causes:
      'Request attempted to access resource where access is not allowed for given credentials.',
    solutions:
      'Check that credentials are correct.\r\n\r\nCheck that accessed resource is set correctly or apply for permissions.',
    description:
      'Failed to create webchat conversation for provided address SID. Account not authorized ',
    product: 'Flex',
    date_created: '2022-10-03T21:31:47Z',
    last_updated: '2022-10-03T21:31:47Z',
  },
  30017: {
    code: 30017,
    message: 'Carrier network congestion',
    log_level: 'ERROR',
    secondary_message: 'Message request was rejected because the carrier has high traffic.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30017\r\n\r\n### Carrier network congestion\r\n\r\nMessage request was rejected because the carrier has high traffic. A 30017 error is an indicator that the downstream carrier is experiencing performance issues due to high traffic. During times of carrier network congestion, we re-try the request, and return this error if the request is not accepted.\r\n\r\n#### Possible Causes\r\n* Carrier is experiencing congestion in MMS traffic\r\n\r\n#### Possible Solutions\r\n* Send your message over a longer period of time, rather than sending in bursts',
    causes: '* Carrier is experiencing congestion in MMS traffic',
    solutions: '* Send your message over a longer period of time, rather than sending in bursts',
    description:
      'A 30017 error is an indicator that the downstream carrier is experiencing performance issues due to high traffic. During times of carrier network congestion, we re-try the request, and return this error if the request is not accepted.',
    product: 'Programmable SMS',
    date_created: '2019-09-04T18:03:23Z',
    last_updated: '2020-08-04T10:00:07.077Z',
  },
  21651: {
    code: 21651,
    message: 'Document does not satisfy regulatory requirement',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 21651\r\n\r\n### Document does not satisfy regulatory requirement\r\n\r\nThe document being mapped to the number does not satisfy the regulatory requirements. \r\n\r\n#### Possible Causes\r\n- The document is the incorrect type for the number you are trying to purchase or update.\r\n- The document does not have the correct metadata fields required for the number you are trying to purchase or update.\r\n- The document sid is not valid. \r\n\r\n#### Possible Solutions\r\n- Ensure that the document you are using satisfies the regulatory requirement.\r\n- Ensure the document sid refers to a document on your account or subaccount. \r\n- Contact support for assistance.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-03-12T12:26:26Z',
    last_updated: '2020-08-04T10:00:14.605Z',
  },
  60217: {
    code: 60217,
    message: 'Invalid Service configuration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60217\r\n\r\n### Invalid Service configuration\r\n\r\n Add an email integration before using the Email channel.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nNo email integration has been set up with the Verify Service.\r\n\r\n#### Possible Solutions\r\nCreate a SendGrid email integration for the Service before using the email channel. [Detailed instructions available here.](https://www.twilio.com/docs/verify/email)',
    causes: 'No email integration has been set up with the Verify Service.',
    solutions:
      'Create a SendGrid email integration for the Service before using the email channel. [Detailed instructions available here.](https://www.twilio.com/docs/verify/email)',
    description: 'Add an email integration before using the Email channel.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-11-21T15:59:24Z',
    last_updated: '2021-05-18T04:48:49.932Z',
  },
  64013: {
    code: 64013,
    message: 'Pay: Connector does not support supplied paymentMethod attribute.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64013\r\n\r\n### Pay: Connector does not support supplied paymentMethod attribute.\r\n\r\n A 64013 Error is an indication that the provided paymentMethod attribute was not supported by the Connector.\r\n\r\n#### Possible Causes\r\nThe targeted Payment Connector did not support the paymentMethod. For instance, a credit card might have been supplied but the Connector did not support Credit Cards.\r\n\r\n#### Possible Solutions\r\nMake sure the Connector supports the defined paymentMethod attribute.',
    causes:
      'The targeted Payment Connector did not support the paymentMethod. For instance, a credit card might have been supplied but the Connector did not support Credit Cards.',
    solutions: 'Make sure the Connector supports the defined paymentMethod attribute.',
    description:
      'A 64013 Error is an indication that the provided paymentMethod attribute was not supported by the Connector.',
    product: 'Programmable Voice',
    date_created: '2019-07-26T17:32:32Z',
    last_updated: '2020-08-04T10:00:07.54Z',
  },
  20503: {
    code: 20503,
    message: 'Service unavailable',
    log_level: 'ERROR',
    secondary_message: 'Service is unavailable',
    log_type: null,
    docs: '## Error 20503\r\n\r\n### Service unavailable\r\n\r\nThe requested Twilio Service is temporarily unavailable.\r\n\r\n### Possible Solutions\r\n- Try again a few times with exponential back-off\r\n- If the problem persists, please [contact support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-07-06T13:43:21Z',
    last_updated: '2020-08-04T10:00:18.047Z',
  },
  30028: {
    code: 30028,
    message: 'Invalid API version',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30028\r\n\r\n### Invalid API version\r\n\r\n API version used in the request is invalid\r\n\r\n#### Possible Causes\r\nAPI version is not specified or is not either 2008-08-01 or 2010-04-01\r\n\r\n#### Possible Solutions\r\nUse API version 2008-08-01 or 2010-04-01',
    causes: 'API version is not specified or is not either 2008-08-01 or 2010-04-01',
    solutions: 'Use API version 2008-08-01 or 2010-04-01',
    description: 'API version used in the request is invalid',
    product: 'Programmable SMS',
    date_created: '2022-01-26T11:34:03Z',
    last_updated: '2022-01-26T11:34:03Z',
  },
  40132: {
    code: 40132,
    message: 'TaskRouter->Dequeue',
    log_level: 'ERROR',
    secondary_message: "Dequeue Instruction does not have a valid 'from' parameter provided.",
    log_type: null,
    docs: '## Error - 40132\r\n\r\n### Missing or Invalid \'from\' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "from" parameter on your \'dequeue\' instruction.\r\n*  You provided an invalid format in your "from" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "from" contains a validated caller ID if you\'re dialing the PSTN. \r\n*  Make certain "from" contains an acceptable caller field when connecting to client or SIP.  \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:43Z',
    last_updated: '2020-08-04T10:00:23.766Z',
  },
  21713: {
    code: 21713,
    message: 'Messaging Service Use Case is Invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21713\r\n\r\n### Messaging Service Use Case is Invalid\r\n\r\n The Messaging Service use case you are trying to specify in the request is not a valid use case. \r\n\r\n#### Possible Causes\r\n* The Messaging Service use case specified in the request is not a valid Messaging Service use case. Valid Messaging Service use cases include: discussion, marketing, notifications, poll, undeclared and verification.\r\n\r\n#### Possible Solutions\r\n* Verify that you are spelling the use case correctly in your request and that it is using all lowercase letters.',
    causes:
      '* The Messaging Service use case specified in the request is not a valid Messaging Service use case. Valid Messaging Service use cases include: discussion, marketing, notifications, poll, undeclared and verification.',
    solutions:
      '* Verify that you are spelling the use case correctly in your request and that it is using all lowercase letters.',
    description:
      'The Messaging Service use case you are trying to specify in the request is not a valid use case. ',
    product: 'Programmable SMS',
    date_created: '2021-05-27T17:53:40Z',
    last_updated: '2021-05-27T17:53:40Z',
  },
  62035: {
    code: 62035,
    message: 'Interconnect: No bandwidth was specified in the request',
    log_level: 'ERROR',
    secondary_message:
      'The request did not specify bandwidth. Approved quantities are 10.0, 100.0, and 1000.0Mb.',
    log_type: null,
    docs: '## Error - 62035\r\n\r\n#### Possible Causes \r\n*  No bandwidth was specified in the request\r\n\r\n#### Possible Solutions\r\n* The request did not specify bandwidth. Please include an approved bandwidth option--those are 10.0Mb, 100.0mb, and 1000.0Mb',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:53:23Z',
    last_updated: '2020-08-04T10:00:20.636Z',
  },
  94000: {
    code: 94000,
    message: 'Transcriptions: request to transcribe audio error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 94000\r\n\r\n### Transcriptions: request to transcribe audio error\r\n\r\n Twilio failed to process the request to transcribe audio due to an internal issue. No transcription resource has been created\r\n\r\n#### Possible Causes\r\n \r\n\r\n#### Possible Solutions\r\n ',
    causes: ' ',
    solutions: ' ',
    description:
      'Twilio failed to process the request to transcribe audio due to an internal issue. No transcription resource has been created',
    product: null,
    date_created: '2021-09-13T14:03:16Z',
    last_updated: '2021-09-13T14:03:24.114433Z',
  },
  68005: {
    code: 68005,
    message: 'Key Storage Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 68005\r\n\r\n### Key Storage Error\r\n\r\n An error occurred while storing/loading keypairs.\r\n\r\n#### Possible Causes\r\n* Keypair not set.\r\n* Keypair could not be created.\r\n* Signature failed.\r\n\r\n#### Possible Solutions\r\nCreate a new factor.',
    causes: '* Keypair not set.\r\n* Keypair could not be created.\r\n* Signature failed.',
    solutions: 'Create a new factor.',
    description: 'An error occurred while storing/loading keypairs.',
    product: 'Verify',
    date_created: '2020-09-15T18:14:45Z',
    last_updated: '2020-09-15T18:14:45Z',
  },
  13232: {
    code: 13232,
    message: 'Dial->Conference: Invalid startConferenceOnEnter value',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Warning - 13232\n\n### Dial->Conference: Invalid startConferenceOnEnter value\n\nstartConferenceOnEnter must be either "true" or false".\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:36Z',
    last_updated: '2020-08-04T10:00:28.463Z',
  },
  21901: {
    code: 21901,
    message: 'DltTemplateId is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21901\r\n\r\n### DltTemplateId is invalid\r\n\r\n DltTemplateId is invalid\r\n\r\n#### Possible Causes\r\nToo long DltTemplateId or its format is invalid\r\n\r\n#### Possible Solutions\r\nUse correct DltTemplateId',
    causes: 'Too long DltTemplateId or its format is invalid',
    solutions: 'Use correct DltTemplateId',
    description: 'DltTemplateId is invalid',
    product: null,
    date_created: '2020-12-11T08:20:37Z',
    last_updated: '2020-12-11T08:20:37Z',
  },
  53302: {
    code: 53302,
    message: 'Track name is too long',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53302: Track name is too long\r\n\r\nRaised whenever a Track name is too long.\r\n\r\n#### Causes\r\n\r\n * The Track name is too long.\r\n\r\n#### Solutions\r\n\r\n * Choose a shorter Track name.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-10-12T19:59:42Z',
    last_updated: '2020-08-04T10:00:16.91Z',
  },
  21708: {
    code: 21708,
    message: 'Alpha Sender ID Missing from the request',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 21708\r\n\r\n### Alpha Sender ID Missing from the request\r\n\r\n ## Error - 21708\r\n\r\n### Alpha Sender ID Missing from the request \r\n\r\n#### Possible Causes\r\n\r\n* Ensure that a request contains an alphasender in it\r\n\r\n#### Possible Solutions\r\nPlease include an alphasender in the request',
    causes: '\r\n* Ensure that a request contains an alphasender in it',
    solutions: 'Please include an alphasender in the request',
    description: '## Error - 21708\r\n\r\n### Alpha Sender ID Missing from the request ',
    product: 'Programmable SMS',
    date_created: '2022-12-28T02:01:45Z',
    last_updated: '2022-12-28T02:01:45Z',
  },
  30030: {
    code: 30030,
    message: 'Invalid AddressRetention',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30030\r\n\r\n### Invalid AddressRetention\r\n\r\n AddressRetention value used in the request is invalid\r\n\r\n#### Possible Causes\r\nAddressRetention is not either 'obfuscate' or 'retain' or Message Privacy features are not enabled for this account\r\n\r\n#### Possible Solutions\r\nEnable the correct Message Privacy features and use a valid value for AddressRetention",
    causes:
      "AddressRetention is not either 'obfuscate' or 'retain' or Message Privacy features are not enabled for this account",
    solutions:
      'Enable the correct Message Privacy features and use a valid value for AddressRetention',
    description: 'AddressRetention value used in the request is invalid',
    product: 'Programmable SMS',
    date_created: '2022-01-26T11:59:11Z',
    last_updated: '2022-01-26T12:36:29.290513Z',
  },
  50065: {
    code: 50065,
    message: 'Programmable Chat: Invalid webhook retry count',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for webhook retry count.',
    log_type: null,
    docs: '## Error - 50065\r\n\r\n### Programmable Chat: Invalid webhook retry count\r\n\r\n#### Possible Causes \r\n* Request does not contain correctly formatted parameter for webhook retry count.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid webhook parameters are being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T09:41:53Z',
    last_updated: '2020-08-04T10:00:16.714Z',
  },
  30500: {
    code: 30500,
    message: 'Twilio Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 30500\r\n\r\n### Twilio Internal Error\r\n\r\n Twilio's platform encountered an internal error while processing this message.\r\n\r\n#### Possible Causes\r\n* If this message was being processed during an incident, it is possible that this message was affected. See [Twilio's status page](https://status.twilio.com/) for ongoing and historical incidents.\r\n* There was an unrecoverable anomaly that occurred while processing this particular message.\r\n\r\n#### Possible Solutions\r\n* Try sending the message again.\r\n* If the subsequent attempt also fails with this error, [contact support](https://support.twilio.com/hc/en-us/articles/360048500694-Contacting-Twilio-Support) referencing the affected Message Sids for further troubleshooting.",
    causes:
      "* If this message was being processed during an incident, it is possible that this message was affected. See [Twilio's status page](https://status.twilio.com/) for ongoing and historical incidents.\r\n* There was an unrecoverable anomaly that occurred while processing this particular message.",
    solutions:
      '* Try sending the message again.\r\n* If the subsequent attempt also fails with this error, [contact support](https://support.twilio.com/hc/en-us/articles/360048500694-Contacting-Twilio-Support) referencing the affected Message Sids for further troubleshooting.',
    description: "Twilio's platform encountered an internal error while processing this message.",
    product: 'Programmable SMS',
    date_created: '2023-12-08T10:20:51Z',
    last_updated: '2023-12-08T10:20:51Z',
  },
  50443: {
    code: 50443,
    message: 'Failed to add a projected address to a participant.',
    log_level: 'ERROR',
    secondary_message:
      'The participant should not have a messaging binding in order to add a projected address.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50443\r\n\r\n### Failed to add a projected address to a participant.\r\n\r\nThe participant should not have a messaging binding in order to add a projected address. The conversation participant being updated can not have a projected address.\r\n\r\n#### Possible Causes\r\n* You are trying to add a projected address to a participant with messaging binding assigned.\r\n\r\n#### Possible Solutions\r\n* Check that the request does not update projected address of this particular participant.',
    causes:
      '* You are trying to add a projected address to a participant with messaging binding assigned.',
    solutions:
      '* Check that the request does not update projected address of this particular participant.',
    description: 'The conversation participant being updated can not have a projected address.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:03:09Z',
    last_updated: '2021-08-16T12:03:09Z',
  },
  21603: {
    code: 21603,
    message: "A 'From' or 'MessagingServiceSid' parameter is required to send a message",
    log_level: 'ERROR',
    secondary_message:
      'Make sure to specify a valid Twilio Phone Number, Alpha Sender ID, or Messaging Service SID in your API requests',
    log_type: 'APPLICATION',
    docs: "## ERROR - 21603\r\n\r\n### A 'From' or 'MessagingServiceSid' parameter is required to send a message\r\n\r\nMake sure to specify a valid Twilio Phone Number, Alpha Sender ID, or Messaging Service SID in your API requests The 'From' parameter in your API request to send an outbound message did not include a valid [Twilio Number](/user/account/phone-numbers/), [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS), or [Messaging Service SID](https://www.twilio.com/docs/messaging/services).\r\n\t\r\nYou can provide any of the above sender types in your From parameter. You may also provide a Messaging Service SID using the dedicated 'MessagingServiceSid' parameter, either instead of or in addition to a specific 'From' parameter.\r\n\r\n#### Possible Causes\r\n* You did not specify a 'From' parameter in your API request\r\n\r\n#### Possible Solutions\r\n* Specify a valid [Twilio Number](/user/account/phone-numbers/), [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS), or [Messaging Service SID](https://www.twilio.com/docs/messaging/services) as the 'From' parameter in your API request\r\n* Specify a valid Messaging Service SID as the 'MessagingServiceSid' parameter in your API request",
    causes: "* You did not specify a 'From' parameter in your API request",
    solutions:
      "* Specify a valid [Twilio Number](/user/account/phone-numbers/), [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS), or [Messaging Service SID](https://www.twilio.com/docs/messaging/services) as the 'From' parameter in your API request\r\n* Specify a valid Messaging Service SID as the 'MessagingServiceSid' parameter in your API request",
    description:
      "The 'From' parameter in your API request to send an outbound message did not include a valid [Twilio Number](/user/account/phone-numbers/), [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Alphanumeric-Sender-ID-for-Twilio-Programmable-SMS), or [Messaging Service SID](https://www.twilio.com/docs/messaging/services).\r\n\t\r\nYou can provide any of the above sender types in your From parameter. You may also provide a Messaging Service SID using the dedicated 'MessagingServiceSid' parameter, either instead of or in addition to a specific 'From' parameter.",
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:03Z',
    last_updated: '2023-07-31T21:14:45.210252Z',
  },
  57010: {
    code: 57010,
    message: "'PartnerName' is absent",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 57010\r\n\r\n### 'PartnerName' is absent\r\n\r\n 'PartnerName' is not specified\r\n\r\n#### Possible Causes\r\n'PartnerName' is not specified\r\n\r\n#### Possible Solutions\r\nConfirm a valid 'PartnerName' is being passed in request.",
    causes: "'PartnerName' is not specified",
    solutions: "Confirm a valid 'PartnerName' is being passed in request.",
    description: "'PartnerName' is not specified",
    product: 'Programmable SMS',
    date_created: '2021-05-07T08:58:55Z',
    last_updated: '2021-05-31T09:00:22.284Z',
  },
  13619: {
    code: 13619,
    message: 'Record: Transcription feature not available for this type of recording.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: 'Warning - 13619 Record: Transcription feature not available for this type of recording. Possible Causes The transcription attribute was specified for a type of recording that does not currently support transcription. Possible Solutions: Check in the TwiML or API docs whether the recording type you specified allows transcription.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-05-20T03:22:25Z',
    last_updated: '2020-08-04T10:00:21.638Z',
  },
  19013: {
    code: 19013,
    message:
      'At least one of the following fields is required for a contact: first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19013\r\n\r\n### At least one of the following fields is required for a contact: first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or channel\r\n\r\n Contact should contain at least one required field\r\n\r\n#### Possible Causes\r\nContact does not possess even one required field\r\n\r\n#### Possible Solutions\r\nContact should contain at least one of the following fields - first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or channel',
    causes: 'Contact does not possess even one required field',
    solutions:
      'Contact should contain at least one of the following fields - first_name, middle_name, last_name, legal_name, preferred_name, unique_customer_provided_id or channel',
    description: 'Contact should contain at least one required field',
    product: null,
    date_created: '2020-08-07T22:47:45Z',
    last_updated: '2020-08-07T22:47:45Z',
  },
  32201: {
    code: 32201,
    message: 'SIP: Source IP address not in ACL',
    log_level: 'ERROR',
    secondary_message:
      'Authorization failure - source IP Address not in ACL. Either fix local routing so that you are sending us SIP from an address already in your ACL or add this other address to your [ACL](/user/account/sip-trunking/authentication/ip-acls).',
    log_type: null,
    docs: '## Error - 32201\r\n\r\n###  SIP: Source IP address not in ACL\r\n\r\n#### Possible Causes \r\n*  Authorization failure - source IP Address not in ACL (Access Control List).\r\n\r\n#### Possible Solutions\r\n*  There is an ACL on your trunk and you are sending us INVITE requests from an IP address not on that ACL. Either fix local routing so that you are sending us SIP from an address already in your ACL or add this other address to your ACL. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:37Z',
    last_updated: '2020-08-04T10:00:24.275Z',
  },
  63030: {
    code: 63030,
    message: 'Unsupported parameter for type of channels message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 63030\r\n\r\n### Unsupported parameter for type of channels message\r\n\r\n ### Media messages are not supported with template (structured) messages. Please check your message and try sending a template message without the media\r\n### URL preview messages sent with incorrect URL format\r\n\r\n#### Possible Causes\r\n* Media message not supported with template messages\r\n* No URL to support preview\r\n\r\n#### Possible Solutions\r\n* Send template message without the media component\r\n* Check url for correctness for url previews',
    causes: '* Media message not supported with template messages\r\n* No URL to support preview',
    solutions:
      '* Send template message without the media component\r\n* Check url for correctness for url previews',
    description:
      '### Media messages are not supported with template (structured) messages. Please check your message and try sending a template message without the media\r\n### URL preview messages sent with incorrect URL format',
    product: 'Programmable SMS',
    date_created: '2019-06-27T18:49:50Z',
    last_updated: '2020-08-04T10:00:07.852Z',
  },
  53118: {
    code: 53118,
    message: 'Room Completed Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53118\r\n\r\n### Room Completed Error\r\n\r\n Raised whenever a Room is completed via the REST API.\r\n\r\n#### Possible Causes\r\n* The operation you requested cannot be performed on a completed Room.\r\n\r\n#### Possible Solutions\r\n* Some operations can only be performed on in-progress Rooms. Check the status of your Room before attempting the operation.',
    causes: '* The operation you requested cannot be performed on a completed Room.',
    solutions:
      '* Some operations can only be performed on in-progress Rooms. Check the status of your Room before attempting the operation.',
    description: 'Raised whenever a Room is completed via the REST API.',
    product: 'Programmable Video',
    date_created: '2020-06-16T03:59:35Z',
    last_updated: '2020-08-04T10:00:02.846Z',
  },
  95106: {
    code: 95106,
    message: 'Speech-to-Text engine error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95106\r\n\r\n### Speech-to-Text engine error\r\n\r\n Twilio failed to transcribe audio due to a third party speech-to-text engine failure. The transcription resource has been marked as “failed”.\r\n\r\n#### Possible Causes\r\nTranscript language is not the one specified in the service.\r\n\r\n#### Possible Solutions\r\nEnsure the transcript language matches the specified language of the service.',
    causes: 'Transcript language is not the one specified in the service.',
    solutions: 'Ensure the transcript language matches the specified language of the service.',
    description:
      'Twilio failed to transcribe audio due to a third party speech-to-text engine failure. The transcription resource has been marked as “failed”.',
    product: 'Voice Intelligence',
    date_created: '2024-05-27T08:34:05Z',
    last_updated: '2024-05-27T08:34:05Z',
  },
  10004: {
    code: 10004,
    message: 'Call concurrency limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 10004\r\n\r\n### Call concurrency limit exceeded\r\n\r\n ## Error - 10004\r\n\r\n### Call concurrency limit exceeded\r\n\r\nThe call was rejected because you reached the maximum limit of concurrent calls available for your account.\r\n\r\n#### Possible Causes\r\nTrial accounts and newly upgraded accounts without an approved Primary Customer Profile have limited concurrent calls.\r\n\r\n#### Possible Solutions\r\n[Upgrade your account](https://www.twilio.com/docs/usage/tutorials/how-to-use-your-free-trial-account-namer#how-to-upgrade-your-account) and [create a Primary Business Profile](https://www.twilio.com/docs/trust-hub/trusthub-rest-api/console-create-a-primary-customer-profile) to remove concurrent call limitations.',
    causes:
      'Trial accounts and newly upgraded accounts without an approved Primary Customer Profile have limited concurrent calls.',
    solutions:
      '[Upgrade your account](https://www.twilio.com/docs/usage/tutorials/how-to-use-your-free-trial-account-namer#how-to-upgrade-your-account) and [create a Primary Business Profile](https://www.twilio.com/docs/trust-hub/trusthub-rest-api/console-create-a-primary-customer-profile) to remove concurrent call limitations.',
    description:
      '## Error - 10004\r\n\r\n### Call concurrency limit exceeded\r\n\r\nThe call was rejected because you reached the maximum limit of concurrent calls available for your account.',
    product: null,
    date_created: '2018-10-05T04:05:45Z',
    last_updated: '2024-03-27T20:52:20.445749Z',
  },
  54008: {
    code: 54008,
    message: 'Invalid JSON',
    log_level: 'ERROR',
    secondary_message: "The specified 'Data' parameter is not valid JSON.",
    log_type: null,
    docs: "\n## Error - 54008\n\n### Sync: Invalid JSON\nThe specified 'Data' parameter is not valid JSON.\n\n#### Possible Causes\n* The data you submitted is not JSON, or\n* A missing or poorly-encoded character makes your JSON fail to parse.\n* You crafted the HTTP request yourself, and did not percent-encode the submitted JSON data in the form parameters.\n\n#### Possible Solutions\n* Use a tool like [JSONLint](https://jsonlint.com/) to check the data you're sending for syntax errors.\n* If you're crafting HTTP requests yourself, make sure all form data is percent-encoded.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.757Z',
  },
  31005: {
    code: 31005,
    message: 'Connection error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31005\r\n\r\n### Connection error\r\n\r\nA connection error occurred during the call',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:28:32Z',
    last_updated: '2020-08-04T10:00:11.445Z',
  },
  40112: {
    code: 40112,
    message: 'TaskRouter->Call',
    log_level: 'ERROR',
    secondary_message: "Call Instruction does not have a valid 'url' parameter provided.",
    log_type: null,
    docs: '## Error - 40112\r\n\r\n### Missing or Invalid \'url\' parameter - Call Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "url" parameter on your \'call\' instruction.\r\n*  You provided an invalid format in your "url" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "url" is provided and contains a well formed HTTP or HTTPS URL. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:40Z',
    last_updated: '2020-08-04T10:00:23.992Z',
  },
  30904: {
    code: 30904,
    message: 'Campaign Not Shared with Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30904\r\n\r\n### Campaign Not Shared with Twilio\r\n\r\n Messaging Service could not be associated with the Campaign because the specific Campaign was not found in Twilio's DCA records.\r\n\r\n#### Possible Causes\r\n* Campaign has not been shared with Twilio's DCA.\r\n* Provided campaignID is incorrect.\r\n\r\n#### Possible Solutions\r\n* Ensure that the Campaign has been successfully shared with Twilio as the DCA and has received approval.\r\n* Confirm that the entered CampaignID is accurate.\r\n* If needed, re-share the Campaign through TCR, await the CAMPAIGN_SHARE_ACCEPT webhook, and then proceed to assign the Messaging Service.\r\n\r\nAdditional help resources\r\n* [Changes to Externally Registered Campaign Submission](https://support.twilio.com/hc/en-us/articles/13097615242395-Changes-to-Externally-Registered-Campaign-Submission)\r\n",
    causes:
      "* Campaign has not been shared with Twilio's DCA.\r\n* Provided campaignID is incorrect.",
    solutions:
      '* Ensure that the Campaign has been successfully shared with Twilio as the DCA and has received approval.\r\n* Confirm that the entered CampaignID is accurate.\r\n* If needed, re-share the Campaign through TCR, await the CAMPAIGN_SHARE_ACCEPT webhook, and then proceed to assign the Messaging Service.\r\n\r\nAdditional help resources\r\n* [Changes to Externally Registered Campaign Submission](https://support.twilio.com/hc/en-us/articles/13097615242395-Changes-to-Externally-Registered-Campaign-Submission)\r\n',
    description:
      "Messaging Service could not be associated with the Campaign because the specific Campaign was not found in Twilio's DCA records.",
    product: 'Programmable Messaging',
    date_created: '2023-10-23T14:02:30Z',
    last_updated: '2023-10-23T14:03:12.576379Z',
  },
  32604: {
    code: 32604,
    message: 'Virtual Agent: Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 32604\r\n\r\n### Virtual Agent: Internal Error\r\n\r\n A 32604 Error is an indication that there is an internal server error and some internal services failed.\r\n\r\n#### Possible Causes\r\n* Some error occurred during communication with Twilio internal services.\r\n\r\n#### Possible Solutions\r\n* If this is a continuous experience, please contact Twilio Support.',
    causes: '* Some error occurred during communication with Twilio internal services.',
    solutions: '* If this is a continuous experience, please contact Twilio Support.',
    description:
      'A 32604 Error is an indication that there is an internal server error and some internal services failed.',
    product: 'Programmable Voice',
    date_created: '2022-08-04T01:24:28Z',
    last_updated: '2022-08-04T01:24:28Z',
  },
  60334: {
    code: 60334,
    message: 'The SMS message was sent using a brandful template.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60334\r\n\r\n### The SMS message was sent using a brandful template.\r\n\r\n The SMS message was sent using a brandful template instead of the configured template, which does not contain a friendly name (brand).\r\n\r\n#### Possible Causes\r\nDue to mobile carrier regulations, Verify needs to add the friendly name from the message body.\r\n\r\n#### Possible Solutions\r\nConfigure or use a dedicated template that includes the friendly name.',
    causes:
      'Due to mobile carrier regulations, Verify needs to add the friendly name from the message body.',
    solutions: 'Configure or use a dedicated template that includes the friendly name.',
    description:
      'The SMS message was sent using a brandful template instead of the configured template, which does not contain a friendly name (brand).',
    product: 'Verify',
    date_created: '2024-05-09T22:41:18Z',
    last_updated: '2024-05-10T19:15:54.635655Z',
  },
  50709: {
    code: 50709,
    message: 'ChatbotConfiguration.FriendlyName is invalid.',
    log_level: 'ERROR',
    secondary_message: 'ChatbotConfiguration.FriendlyName is invalid.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50709\r\n\r\n### ChatbotConfiguration.FriendlyName is invalid.\r\n\r\nChatbotConfiguration.FriendlyName is invalid. \r\n\r\n#### Possible Causes\r\nYou are trying to create Virtual Agent participant with ChatbotConfiguration.FriendlyName which is longer than 256 characters.\r\n\r\n#### Possible Solutions\r\n* Update ChatbotConfiguration.FriendlyName parameter according to provided validation rules.',
    causes:
      'You are trying to create Virtual Agent participant with ChatbotConfiguration.FriendlyName which is longer than 256 characters.',
    solutions:
      '* Update ChatbotConfiguration.FriendlyName parameter according to provided validation rules.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:06:37Z',
    last_updated: '2023-10-11T18:06:37Z',
  },
  32013: {
    code: 32013,
    message: 'SIP: Parent account SIP Interface CPS limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 32013\r\n\r\n### SIP: Parent account SIP Interface CPS limit exceeded\r\n\r\n #### Possible Causes \r\n*  Calls Per Second placed on a SIP domain exceeded the Parent Account limits. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Parent Account for SIP Interface. \r\n\r\n#### Possible Causes\r\nCalls Per Second placed on a SIP domain exceeded the Parent Account limits. \r\n\r\n#### Possible Solutions\r\nIncrease the CPS on the Parent Account.",
    causes: 'Calls Per Second placed on a SIP domain exceeded the Parent Account limits. ',
    solutions: 'Increase the CPS on the Parent Account.',
    description:
      "#### Possible Causes \r\n*  Calls Per Second placed on a SIP domain exceeded the Parent Account limits. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Parent Account for SIP Interface. ",
    product: 'Programmable Voice',
    date_created: '2017-05-23T20:56:57Z',
    last_updated: '2024-04-17T18:36:39.041626Z',
  },
  60207: {
    code: 60207,
    message: 'Max rate limits per service reached ',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60207\r\n\r\n### Max rate limits per service reached \r\n\r\n Your service has reached the max number of rate limits\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nYour service has reached the max number of rate limits\r\n\r\n\r\n#### Possible Solutions\r\n* Delete/update rate limits that you are not using at the moment\r\n* Create a new service and add the desired rate limit to the new service',
    causes: 'Your service has reached the max number of rate limits\r\n',
    solutions:
      '* Delete/update rate limits that you are not using at the moment\r\n* Create a new service and add the desired rate limit to the new service',
    description: 'Your service has reached the max number of rate limits\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-05-08T15:21:08Z',
    last_updated: '2021-05-18T04:39:18.939Z',
  },
  50342: {
    code: 50342,
    message: 'Messaging service does not belong to account',
    log_level: 'ERROR',
    secondary_message: 'The requested messaging service SID does not belong to your account.',
    log_type: null,
    docs: '\n## Error - 50342\n\n### Conversations: Messaging service does not belong to account\nThe requested messaging service SID does not belong to your account.\n\n#### Possible Causes\nYou may have copied/pasted incorrectly, or your API request targeted a different account (e.g. if you have several Projects or several Twilio accounts).\n\n#### Possible Solutions\nDouble-check the Messaging Service SID, confirming that it belongs to your account. Check whether you are authenticating against Twilio with the same account. With these matching, the request will succeed.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.917Z',
  },
  14107: {
    code: 14107,
    message: 'SMS send rate limit exceeded',
    log_level: 'ERROR',
    secondary_message:
      'Too many messages have been sent between two numbers within a short time period, possibly indicating a runaway job or infinite loop. There is a limit of 30 outbound replies between two phone numbers in a short period.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 14107\r\n\r\n### SMS send rate limit exceeded\r\n\r\nToo many messages have been sent between two numbers within a short time period, possibly indicating a runaway job or infinite loop. There is a limit of 30 outbound replies between two phone numbers in a short period. Too many messages have been sent between two numbers within a short time period, possibly indicating a runaway job or infinite loop. There is a limit of 30 outbound replies between two phone numbers in a 30-second period.\r\n\r\nA counter is set for each outbound reply in a conversation (between two numbers). When the first reply occurs, the counter starts at 1. If the next reply is sent less than 30 seconds after the prior reply, then the counter goes to 2. This will continue if each reply is less than 30 seconds, until the counter surpasses 30; at this time, Twilio will set any further messages in the loop to "failed" status for 30 seconds, with this error code. Messages with the "failed" status are not charged against your account balance.\r\n\r\n\r\n#### Possible Causes\r\n*  repeated rapid responses by the end user (30 replies in less than 30 seconds)\r\n*  infinite loop caused by self referencing Sms or Message verb action URL\r\n*  infinite loop caused by self referencing Redirect verb URL\r\n*  runaway process making repeated outgoing REST API requests\r\n\r\n#### Possible Solutions\r\n*  make certain any action or Redirect URL\'s do not loop back to the same TwiML document.\r\n*  make sure you are not inadvertently sending a large quantity of messages to the same phone number, e.g. a script caught in a loop\r\n* if you need this protection disabled for your Twilio Account, [contact Twilio Support](https://www.twilio.com/console/support/tickets/create). Please note, if you choose to have this feature disabled, you must have protection in place in your application to prevent costly auto-reply loops.',
    causes:
      '*  repeated rapid responses by the end user (30 replies in less than 30 seconds)\r\n*  infinite loop caused by self referencing Sms or Message verb action URL\r\n*  infinite loop caused by self referencing Redirect verb URL\r\n*  runaway process making repeated outgoing REST API requests',
    solutions:
      "*  make certain any action or Redirect URL's do not loop back to the same TwiML document.\r\n*  make sure you are not inadvertently sending a large quantity of messages to the same phone number, e.g. a script caught in a loop\r\n* if you need this protection disabled for your Twilio Account, [contact Twilio Support](https://www.twilio.com/console/support/tickets/create). Please note, if you choose to have this feature disabled, you must have protection in place in your application to prevent costly auto-reply loops.",
    description:
      'Too many messages have been sent between two numbers within a short time period, possibly indicating a runaway job or infinite loop. There is a limit of 30 outbound replies between two phone numbers in a 30-second period.\r\n\r\nA counter is set for each outbound reply in a conversation (between two numbers). When the first reply occurs, the counter starts at 1. If the next reply is sent less than 30 seconds after the prior reply, then the counter goes to 2. This will continue if each reply is less than 30 seconds, until the counter surpasses 30; at this time, Twilio will set any further messages in the loop to "failed" status for 30 seconds, with this error code. Messages with the "failed" status are not charged against your account balance.\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:13:49Z',
    last_updated: '2023-06-29T15:01:07.684084Z',
  },
  53660: {
    code: 53660,
    message: 'Status Callback response timed out',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 53660\r\n\r\n### Status callback response timed out\r\n\r\nRaised by a Twilio Service when the StatusCallback request takes too long or does not respond to callbacks sent \r\n\r\n### Causes\r\n\r\n * The server receiving status callbacks sent by Twilio takes too long too respond.\r\n\r\n### Solutions\r\n\r\n * Make sure service receiving callbacks does not block incoming requests.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-12-28T11:43:25Z',
    last_updated: '2020-08-04T10:00:15.424Z',
  },
  60725: {
    code: 60725,
    message: 'Brand status does not allow to have branded channels',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60725\r\n\r\n### Brand status does not allow to have branded channels\r\n\r\n You are creating a branded channel for a brand in a status does not allow it to have branded channels\r\n\r\n#### Possible Causes\r\nA brand must be verified in order to have any branded channels\r\n\r\n#### Possible Solutions\r\nMake sure your brand already has a verified status before attempting to create branded channels.',
    causes: 'A brand must be verified in order to have any branded channels',
    solutions:
      'Make sure your brand already has a verified status before attempting to create branded channels.',
    description:
      'You are creating a branded channel for a brand in a status does not allow it to have branded channels',
    product: 'Branded Comms',
    date_created: '2020-01-24T21:25:03Z',
    last_updated: '2020-08-04T10:00:04.76Z',
  },
  63002: {
    code: 63002,
    message: 'Channel could not find the From address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel could not find the From address\r\n\r\n#### Possible Causes \r\n*   Incorrect From address or trying to use a From address that is not supported by this Channel when trying to send a message. See [here](https://www.twilio.com/docs/api/channels#channel-addresses) for supported formats of Channel endpoint addresses. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:16:07Z',
    last_updated: '2020-08-04T10:00:14.55Z',
  },
  60605: {
    code: 60605,
    message: 'Verification delivery attempt blocked',
    log_level: 'ERROR',
    secondary_message: 'Verification delivery attempt blocked',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60605\r\n\r\n### Verification delivery attempt blocked\r\n\r\nVerification delivery attempt blocked The destination phone number has been blocked by Verify Geo-Permissions\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nThe destination has been disabled due to suspected fraudulent activity or for possible security reasons.\r\n\r\n#### Possible Solutions\r\nInvestigate your application for potential abuse. If you have a legitimate need to call this number, please check the following: https://support.twilio.com/hc/en-us/articles/5054044369179-Error-60605-Verification-delivery-attempt-blocked-',
    causes:
      'The destination has been disabled due to suspected fraudulent activity or for possible security reasons.',
    solutions:
      'Investigate your application for potential abuse. If you have a legitimate need to call this number, please check the following: https://support.twilio.com/hc/en-us/articles/5054044369179-Error-60605-Verification-delivery-attempt-blocked-',
    description:
      'The destination phone number has been blocked by Verify Geo-Permissions\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-10-14T15:41:59Z',
    last_updated: '2022-04-25T14:06:41.449675Z',
  },
  19037: {
    code: 19037,
    message: 'When updating a location at least one field should be updated',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19037\r\n\r\n### When updating a location at least one field should be updated\r\n\r\n No location updates provided in the request\r\n\r\n#### Possible Causes\r\nUser has not provided location updates\r\n\r\n#### Possible Solutions\r\nWhen updating a location at least one field should be updated',
    causes: 'User has not provided location updates',
    solutions: 'When updating a location at least one field should be updated',
    description: 'No location updates provided in the request',
    product: null,
    date_created: '2020-08-07T22:52:03Z',
    last_updated: '2020-08-07T22:52:03Z',
  },
  25014: {
    code: 25014,
    message: 'The primary email address does not match the username',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25014\r\n\r\n### The primary email address does not match the username\r\n\r\n The primary email address does not match the username.\r\n\r\n#### Possible Causes\r\nThe user's primary email address does not match with the specified username.\r\n\r\n#### Possible Solutions\r\nEnsure that the primary email address matches the user's username.",
    causes: "The user's primary email address does not match with the specified username.",
    solutions: "Ensure that the primary email address matches the user's username.",
    description: 'The primary email address does not match the username.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:17:51Z',
    last_updated: '2023-12-04T14:17:57.460566Z',
  },
  45202: {
    code: 45202,
    message: 'Resource Already Exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45202\r\n\r\n### Resource Already Exists\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request could not be completed due to a conflict with the current state of the resource.\r\n\r\n#### Possible Solutions\r\nCheck that resource to be updated is set correctly.',
    causes:
      'The request could not be completed due to a conflict with the current state of the resource.',
    solutions: 'Check that resource to be updated is set correctly.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-16T06:00:40Z',
    last_updated: '2020-08-04T10:00:11.84Z',
  },
  30791: {
    code: 30791,
    message: 'Brand Registration Failure: Temporary system error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30791\r\n\r\n### Brand Registration Failure: Temporary system error\r\n\r\n There was a temporary system error when processing brand registration request.\r\n\r\n\r\n\r\n#### Possible Causes\r\nThere was a temporary system error when processing brand registration request.\r\n\r\n\r\n\r\n#### Possible Solutions\r\nPlease try again after 30 seconds.\r\n\r\n',
    causes:
      'There was a temporary system error when processing brand registration request.\r\n\r\n',
    solutions: 'Please try again after 30 seconds.\r\n\r\n',
    description:
      'There was a temporary system error when processing brand registration request.\r\n\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:48:52Z',
    last_updated: '2024-02-12T08:48:52Z',
  },
  31951: {
    code: 31951,
    message: 'Stream - Protocol - Invalid Message',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 31951\r\n\r\n### Stream - Protocol - Invalid Message\r\n\r\n The Streamer has received a message non compliant with the protocol\r\n(This error is sent once per stream)\r\n\r\n#### Possible Causes\r\n* Message does not have JSON format\r\n* Unknown message type\r\n* Missing or extra field in message\r\n* Wrong Stream SID used in message\r\n\r\n#### Possible Solutions\r\n* Validate message is compliant with Stream protocols\r\n* Validate message is a valid JSON',
    causes:
      '* Message does not have JSON format\r\n* Unknown message type\r\n* Missing or extra field in message\r\n* Wrong Stream SID used in message',
    solutions:
      '* Validate message is compliant with Stream protocols\r\n* Validate message is a valid JSON',
    description:
      'The Streamer has received a message non compliant with the protocol\r\n(This error is sent once per stream)',
    product: 'Programmable Voice',
    date_created: '2020-05-08T11:48:02Z',
    last_updated: '2020-08-04T10:00:03.277Z',
  },
  62022: {
    code: 62022,
    message: 'Missing account SID',
    log_level: 'ERROR',
    secondary_message: 'The request did not specify an account SID. ',
    log_type: null,
    docs: '## Error - 62022\r\n\r\n### Missing account SID\r\n\r\nThe request did not specify an account SID.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:48:09Z',
    last_updated: '2020-08-04T10:00:20.789Z',
  },
  32605: {
    code: 32605,
    message: 'Virtual Agent: PCI Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32605\r\n\r\n### Virtual Agent: PCI Error\r\n\r\n A 32605 Error is an indication that the &lt;VirtualAgent&gt; TwiML contains an invalid or insecure URL in the statusCallback attribute when PCI mode is enabled on your account\r\n\r\n#### Possible Causes\r\n* &lt;VirtualAgent&gt; statusCallback attribute contains an invalid URL\r\n* &lt;VirtualAgent&gt; statusCallback attribute does not specify scheme https\r\n\r\n\r\n#### Possible Solutions\r\n* Ensure that the &lt;VirtualAgent&gt; TwiML statusCallback attribute contains a valid URL format with scheme https',
    causes:
      '* &lt;VirtualAgent&gt; statusCallback attribute contains an invalid URL\r\n* &lt;VirtualAgent&gt; statusCallback attribute does not specify scheme https\r\n',
    solutions:
      '* Ensure that the &lt;VirtualAgent&gt; TwiML statusCallback attribute contains a valid URL format with scheme https',
    description:
      'A 32605 Error is an indication that the &lt;VirtualAgent&gt; TwiML contains an invalid or insecure URL in the statusCallback attribute when PCI mode is enabled on your account',
    product: 'Programmable Voice',
    date_created: '2023-01-26T19:10:10Z',
    last_updated: '2023-01-26T20:54:29.010891Z',
  },
  30794: {
    code: 30794,
    message: 'US A2P Registration: General error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30794\r\n\r\n### US A2P Registration: General error\r\n\r\n There was a general system error when processing your registration request.\r\n\r\n#### Possible Causes\r\nYour US A2P Brand or Campaign registration request was not processed successfully. While our systems were not able to identify the exact cause of failure, the error description provided as part of registration response should indicate the possible issue. \r\n\r\n#### Possible Solutions\r\nPlease fix the cause of error message and retry the registration request. If issue persists, please contact Twilio support.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n\r\n* [Troubleshooting and rectifying US A2P Campaigns](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands/troubleshooting-and-rectifying-a2p-campaigns-1)\r\n\r\n',
    causes:
      'Your US A2P Brand or Campaign registration request was not processed successfully. While our systems were not able to identify the exact cause of failure, the error description provided as part of registration response should indicate the possible issue. ',
    solutions:
      'Please fix the cause of error message and retry the registration request. If issue persists, please contact Twilio support.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n\r\n* [Troubleshooting and rectifying US A2P Campaigns](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands/troubleshooting-and-rectifying-a2p-campaigns-1)\r\n\r\n',
    description: 'There was a general system error when processing your registration request.',
    product: 'Programmable Messaging',
    date_created: '2024-02-13T08:44:38Z',
    last_updated: '2024-03-04T12:22:41.629696Z',
  },
  13213: {
    code: 13213,
    message: 'Dial: Invalid hangupOnStar value',
    log_level: 'WARNING',
    secondary_message:
      'hangupOnStar must be "true" or "false". See the <a href=\'/docs/api/twiml/dial#hangupOnStar\'>Dial Verb</a> API Reference for more information.',
    log_type: null,
    docs: '## Warning - 13213 \n\n### Dial: Invalid hangupOnStar value\n\nhangupOnStar must be "true" or "false". See the <a href=\'/docs/api/twiml/dial#hangupOnStar\'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:32Z',
    last_updated: '2020-08-04T10:00:28.922Z',
  },
  30889: {
    code: 30889,
    message: 'Campaign vetting rejection - Embedded Phone Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30889\r\n\r\n### Campaign vetting rejection - Embedded Phone Number\r\n\r\n The campaign submission has been reviewed and it was rejected because Embedded Phone Number selection.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because embedded phone number use is selected, but is not reflective in the sample message.\r\n\r\n#### Possible Solutions\r\nPlease verify that embedded phone number selection is accurate. Update the Sample Messages with Embedded Phone Number or update Embedded Phone Number selection. Resubmit campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because embedded phone number use is selected, but is not reflective in the sample message.',
    solutions:
      'Please verify that embedded phone number selection is accurate. Update the Sample Messages with Embedded Phone Number or update Embedded Phone Number selection. Resubmit campaign for review.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because Embedded Phone Number selection.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:38:15Z',
    last_updated: '2023-04-18T11:38:15Z',
  },
  25104: {
    code: 25104,
    message: "The organization's account owner was not set during creation",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25104\r\n\r\n### The organization's account owner was not set during creation\r\n\r\n The organization's account owner was not set during creation.\r\n\r\n#### Possible Causes\r\nThe organization's account creation request does not specify an owner, and the organization does not currently have an owner assigned.\r\n\r\n#### Possible Solutions\r\n- Set the account's owner in the request\r\n- To set an organization's owner, please contact Twilio support",
    causes:
      "The organization's account creation request does not specify an owner, and the organization does not currently have an owner assigned.",
    solutions:
      "- Set the account's owner in the request\r\n- To set an organization's owner, please contact Twilio support",
    description: "The organization's account owner was not set during creation.",
    product: 'Organizations API',
    date_created: '2023-12-04T11:23:31Z',
    last_updated: '2023-12-04T14:25:43.875286Z',
  },
  11205: {
    code: 11205,
    message: 'HTTP connection failure',
    log_level: 'ERROR',
    secondary_message: 'There was a network failure attempting to connect to this URL',
    log_type: 'APPLICATION',
    docs: '## ERROR - 11205\r\n\r\n### HTTP connection failure\r\n\r\nThere was a network failure attempting to connect to this URL ### HTTP connection failure\r\n\r\nThere was a network failure attempting to connect to this URL. Twilio will try for 10 seconds to establish a TCP connection to your URL (two 5-second attempts). Twilio will wait for a total of 15 seconds to receive an HTTP response. This includes the TCP connection time, so if it took six seconds to establish a TCP connection, your server would have 9 seconds to deliver an HTTP response. If either of those timers expire, we fail the request, fire a notification, and try your fallback URL, if one is specified.\r\n\r\n#### Possible Causes\r\n*  Network outages between Twilio and your web server.\r\n*  URLs that reference private IP addresses or localhost.\r\n*  Twilio’s TCP timeout is 10 seconds. If you see an error in Request Inspector after more than 10000 milliseconds, Twilio could locate your server, but could not establish a TCP connection with it. \r\n*  Twilio’s HTTP timeout is 15 seconds. If you see an error in Request Inspector returned after more than 15000 milliseconds, Twilio was able to establish a TCP connection with your server, but the HTTP response from the server failed.\r\n\r\n#### Possible Solutions\r\n*  Verify the URL provided is accessible to the public internet.\t\r\n*  Verify network connectivity to your web server.\r\n*  Check your TCP logs to verify inbound connection attempts are successful.\r\n*  Check HTTP server logs to verify a response was generated and returned within the timeout.\r\n*  Check your edge element logs to verify responses are making it out of your infrastructure.',
    causes:
      '*  Network outages between Twilio and your web server.\r\n*  URLs that reference private IP addresses or localhost.\r\n*  Twilio’s TCP timeout is 10 seconds. If you see an error in Request Inspector after more than 10000 milliseconds, Twilio could locate your server, but could not establish a TCP connection with it. \r\n*  Twilio’s HTTP timeout is 15 seconds. If you see an error in Request Inspector returned after more than 15000 milliseconds, Twilio was able to establish a TCP connection with your server, but the HTTP response from the server failed.',
    solutions:
      '*  Verify the URL provided is accessible to the public internet.\t\r\n*  Verify network connectivity to your web server.\r\n*  Check your TCP logs to verify inbound connection attempts are successful.\r\n*  Check HTTP server logs to verify a response was generated and returned within the timeout.\r\n*  Check your edge element logs to verify responses are making it out of your infrastructure.',
    description:
      '### HTTP connection failure\r\n\r\nThere was a network failure attempting to connect to this URL. Twilio will try for 10 seconds to establish a TCP connection to your URL (two 5-second attempts). Twilio will wait for a total of 15 seconds to receive an HTTP response. This includes the TCP connection time, so if it took six seconds to establish a TCP connection, your server would have 9 seconds to deliver an HTTP response. If either of those timers expire, we fail the request, fire a notification, and try your fallback URL, if one is specified.',
    product: null,
    date_created: '2016-03-31T17:13:23Z',
    last_updated: '2021-03-19T13:44:11.373Z',
  },
  30109: {
    code: 30109,
    message: 'Callback URL is invalid',
    log_level: 'ERROR',
    secondary_message: 'The URL specified in your API request for callback is invalid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30109\r\n\r\n### Callback URL is invalid\r\n\r\nThe URL specified in your API request for callback is invalid The URL specific in your API request for Click Tracking is invalid\r\n\r\n#### Possible Causes\r\n- Protocol could be missing\r\n- Hostname could be invalid\r\n- Incorrect encoding\r\n\r\n#### Possible Solutions\r\nMake sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n*   hostname\r\n*   file path\r\n*   properly url-encoded query parameters',
    causes: '- Protocol could be missing\r\n- Hostname could be invalid\r\n- Incorrect encoding',
    solutions:
      'Make sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n*   hostname\r\n*   file path\r\n*   properly url-encoded query parameters',
    description: 'The URL specific in your API request for Click Tracking is invalid',
    product: 'Programmable SMS',
    date_created: '2020-05-05T19:14:31Z',
    last_updated: '2022-07-15T00:00:51.450287Z',
  },
  51102: {
    code: 51102,
    message: 'Twilsock: Service instance SID not specified',
    log_level: 'ERROR',
    secondary_message: "Service instance SID is not specified and couln't be generated.",
    log_type: null,
    docs: "## Error - 51102\r\n\r\n### Service instance SID not specified\r\n\r\n#### Possible Causes \r\nNo service instance SID specified and couldn't be generated.\r\n\r\n#### Possible Solutions\r\nConfirm a service instance SID is being passed in the request. ",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T11:39:20Z',
    last_updated: '2020-08-04T10:00:09.903Z',
  },
  62016: {
    code: 62016,
    message: 'Connection not active',
    log_level: 'ERROR',
    secondary_message:
      'The connection SID in the request is not currently active. To transition a connection from active to inactive, the connection must be in an active state.',
    log_type: null,
    docs: '## Error - 62016\r\n\r\n### Connection not active\r\n\r\nThe connection SID in the request is not currently active. To transition a connection from active to inactive, the connection must be in an active state.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:42:34Z',
    last_updated: '2020-08-04T10:00:20.897Z',
  },
  16104: {
    code: 16104,
    message: 'Voice Recording: Unavailable due to encryption failure',
    log_level: 'ERROR',
    secondary_message:
      'Recording was not stored due to a public key encryption failure.  (only applicable if call recording encryption feature enabled)',
    log_type: null,
    docs: '## Error - 16104\r\n\r\n### Voice Recording: Unavailable due to encryption failure\r\n\r\nRecording was not stored due to a public key encryption failure.  (only applicable if call recording encryption feature enabled)',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-08-25T22:23:16Z',
    last_updated: '2020-08-04T10:00:17.907Z',
  },
  21656: {
    code: 21656,
    message: 'The ContentVariables Parameter is invalid',
    log_level: 'ERROR',
    secondary_message: 'The ContentVariables you are using are not valid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21656\r\n\r\n### The ContentVariables Parameter is invalid\r\n\r\n \r\n\r\n#### Possible Causes\r\n* The ContentVariables Parameter is not a JSON String. \r\n* A ContentVariables variable placeholder is improperly formed e.g. {{example}. \r\n* A ContentVariables variable placeholder is an "empty mustache" e.g. {{}}. \r\n* The ContentVariables field is defined with improper formatting at time of send. \r\n* The ContentVariables field contains a variable that was set to null at time of send.\r\n\r\n\r\n#### Possible Solutions\r\n* Review the [documentation](https://www.twilio.com/docs/content/using-variables-with-content-api) on how to use Content Variables with Content Templates.\r\n* Validate the ContentVariables Parameter, it must be a JSON String and be properly formatted. \r\n* Make sure all ContentVariables are defined and have a valid definition at time of send.\r\n',
    causes:
      '* The ContentVariables Parameter is not a JSON String. \r\n* A ContentVariables variable placeholder is improperly formed e.g. {{example}. \r\n* A ContentVariables variable placeholder is an "empty mustache" e.g. {{}}. \r\n* The ContentVariables field is defined with improper formatting at time of send. \r\n* The ContentVariables field contains a variable that was set to null at time of send.\r\n',
    solutions:
      '* Review the [documentation](https://www.twilio.com/docs/content/using-variables-with-content-api) on how to use Content Variables with Content Templates.\r\n* Validate the ContentVariables Parameter, it must be a JSON String and be properly formatted. \r\n* Make sure all ContentVariables are defined and have a valid definition at time of send.\r\n',
    description: 'The ContentVariables Parameter is invalid.',
    product: 'Programmable SMS',
    date_created: '2021-09-29T15:26:47Z',
    last_updated: '2024-02-12T12:00:38.57393Z',
  },
  50076: {
    code: 50076,
    message: 'Webhook failed to execute successfully due to timeout',
    log_level: 'ERROR',
    secondary_message: "Webhook's response isn't received in 5 seconds",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50076\r\n\r\n### Webhook failed to execute successfully due to timeout\r\n\r\nWebhook's response isn't received in 5 seconds Programmable Chat: Webhook failed to execute successfully due to timeout\r\n\r\n#### Possible Causes\r\n*  Application side processing is exceeding 5 seconds.\r\n*  Some network blips might cause delay in returning the response to chat\r\n\r\n#### Possible Solutions\r\n*  Make sure that webhook processing time is less than 5 seconds\r\n*  Make webhook processing asynchronous on the app side and return response immediately ",
    causes:
      '*  Application side processing is exceeding 5 seconds.\r\n*  Some network blips might cause delay in returning the response to chat',
    solutions:
      '*  Make sure that webhook processing time is less than 5 seconds\r\n*  Make webhook processing asynchronous on the app side and return response immediately ',
    description: 'Programmable Chat: Webhook failed to execute successfully due to timeout',
    product: 'Programmable Chat',
    date_created: '2021-02-16T11:22:51Z',
    last_updated: '2021-02-16T11:22:51Z',
  },
  45312: {
    code: 45312,
    message: 'Remove Participant Request Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45312\r\n\r\n### Remove Participant Request Failed\r\n\r\n Error occurred when trying to remove a participant\r\n\r\n#### Possible Causes\r\nVoice API returned an error while trying to remove the participant\r\n\r\n#### Possible Solutions\r\nRetry operation',
    causes: 'Voice API returned an error while trying to remove the participant',
    solutions: 'Retry operation',
    description: 'Error occurred when trying to remove a participant',
    product: 'Flex',
    date_created: '2020-05-08T21:31:24Z',
    last_updated: '2020-08-04T10:00:03.195Z',
  },
  57012: {
    code: 57012,
    message: 'Signature invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 57012\r\n\r\n### Signature invalid\r\n\r\n Signature invalid\r\n\r\n#### Possible Causes\r\nRequest signature passed in X-Registry-Signature header is invalid\r\n\r\n#### Possible Solutions\r\nConfirm signature consists of WebhookURL + canonicalized JSON payload and signed with HMAC-SHA1.',
    causes: 'Request signature passed in X-Registry-Signature header is invalid',
    solutions:
      'Confirm signature consists of WebhookURL + canonicalized JSON payload and signed with HMAC-SHA1.',
    description: 'Signature invalid',
    product: 'Programmable SMS',
    date_created: '2021-05-07T09:03:25Z',
    last_updated: '2021-05-07T09:03:37.207Z',
  },
  31204: {
    code: 31204,
    message: 'Invalid JWT token.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31204\r\n\r\n### Invalid JWT token.\r\n\r\nInvalid JWT token.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:46:52Z',
    last_updated: '2020-08-04T10:00:11.096Z',
  },
  52142: {
    code: 52142,
    message: 'The provided APNs device token is not correct',
    log_level: 'ERROR',
    secondary_message: 'APNs Device Token is missing or malformed',
    log_type: null,
    docs: "## Error - 52142\r\n\r\n### The provided APNs device token is not correct\r\n\r\n#### Possible Causes \r\n*  The APNs device token is either malformed or missing.\r\n\r\n#### Possible Solutions\r\n*  Please verify that you're capturing the device token correctly.\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-01-04T11:17:03Z',
    last_updated: '2020-08-04T10:00:15.386Z',
  },
  32022: {
    code: 32022,
    message: 'ACK not received from your SIP endpoint',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32022\r\n\r\n### ACK not received from your SIP endpoint\r\n\r\n No ACK was received from your SIP endpoint 32 seconds after sending a 200 OK response, which resulted in the termination of the Inbound call. As per RFC 3261, the calling device’s SIP endpoint must send an ACK to acknowledge the receipt of a 200 OK response, to establish a successful call. \r\n\r\n#### Possible Causes\r\n* Your NAT configuration may be incorrect.\r\n* Your Firewall may be blocking traffic.\r\n* SIP signaling not adhering to RFC 3261. For example ACK sent to the wrong IP address or using incorrect Route headers or Request URI.\r\n* A network disruption or packet loss within or between your network and the Twilio network may have caused the ACK messages to get lost.\r\n\r\n#### Possible Solutions\r\n* Review configurations of your  SIP endpoint. Consult your documentation for details.\r\n* Review logs on your SIP endpoint if possible. Consult your documentation for details on how to enable and access the logs.\r\n* SIP devices generally re-transmit messages multiple times, in the event a single message is lost. Ensure your device is configured with the maximum retransmissions.\r\n* Review proper SIP signaling by downloading PCAP via call log in Twilio console. And if possible, capture PCAP at your SIP endpoint to narrow down the cause of the signaling issue.',
    causes:
      '* Your NAT configuration may be incorrect.\r\n* Your Firewall may be blocking traffic.\r\n* SIP signaling not adhering to RFC 3261. For example ACK sent to the wrong IP address or using incorrect Route headers or Request URI.\r\n* A network disruption or packet loss within or between your network and the Twilio network may have caused the ACK messages to get lost.',
    solutions:
      '* Review configurations of your  SIP endpoint. Consult your documentation for details.\r\n* Review logs on your SIP endpoint if possible. Consult your documentation for details on how to enable and access the logs.\r\n* SIP devices generally re-transmit messages multiple times, in the event a single message is lost. Ensure your device is configured with the maximum retransmissions.\r\n* Review proper SIP signaling by downloading PCAP via call log in Twilio console. And if possible, capture PCAP at your SIP endpoint to narrow down the cause of the signaling issue.',
    description:
      'No ACK was received from your SIP endpoint 32 seconds after sending a 200 OK response, which resulted in the termination of the Inbound call. As per RFC 3261, the calling device’s SIP endpoint must send an ACK to acknowledge the receipt of a 200 OK response, to establish a successful call. ',
    product: 'Programmable Voice',
    date_created: '2022-04-20T16:40:11Z',
    last_updated: '2022-04-20T16:40:19.980129Z',
  },
  50390: {
    code: 50390,
    message: 'Unique name should not match conversation sid pattern',
    log_level: 'ERROR',
    secondary_message:
      'Specified Conversation\'s Unique Name matches Conversation SID Pattern "CH[0-9a-f]{32}".',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50390\r\n\r\n### Unique name should not match conversation sid pattern\r\n\r\nSpecified Conversation\'s Unique Name matches Conversation SID Pattern "CH[0-9a-f]{32}". \r\n\r\n#### Possible Causes\r\nSpecified Conversation\'s Unique Name matches Conversation SID Pattern "CH[0-9a-f]{32}".\r\n\r\n#### Possible Solutions\r\nConfirm a valid Conversation\'s Unique Name is being passed in request.',
    causes:
      'Specified Conversation\'s Unique Name matches Conversation SID Pattern "CH[0-9a-f]{32}".',
    solutions: "Confirm a valid Conversation's Unique Name is being passed in request.",
    description: null,
    product: 'Programmable Chat',
    date_created: '2021-10-13T12:31:22Z',
    last_updated: '2021-10-13T12:31:22Z',
  },
  50376: {
    code: 50376,
    message: 'TimeToClosed should be greater or equal to 10 minutes',
    log_level: 'ERROR',
    secondary_message:
      "Duration to transfer channel to closed state can't be shorter than 10 minutes.",
    log_type: 'APPLICATION',
    docs: "## ERROR - 50376\r\n\r\n### TimeToClosed should be greater or equal to 10 minutes\r\n\r\nDuration to transfer channel to closed state can't be shorter than 10 minutes. 'TimeToClosed' duration should be greater or equal to 10 minutes.\r\n\r\n#### Possible Causes\r\n* 'TimeToClosed' field is set to duration which is less than 10 minutes.\r\n\r\n#### Possible Solutions\r\n* Set 'TimeToClosed' field to duration which is longer than 10 minutes.",
    causes: "* 'TimeToClosed' field is set to duration which is less than 10 minutes.",
    solutions: "* Set 'TimeToClosed' field to duration which is longer than 10 minutes.",
    description: "'TimeToClosed' duration should be greater or equal to 10 minutes.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:21:45Z',
    last_updated: '2020-09-24T12:21:59.17Z',
  },
  45007: {
    code: 45007,
    message: 'Resource Conflict Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45007\r\n\r\n### Resource Conflict Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request could not be completed due to a conflict with the current state of the target resource.\r\n\r\n#### Possible Solutions\r\nPlease verify the current status of the resource to see if desired updates are already present in the system and that the request does not contain information that conflicts with the current state.\r\nMore context of the specific resource can be seen under the console message body.',
    causes:
      'The request could not be completed due to a conflict with the current state of the target resource.',
    solutions:
      'Please verify the current status of the resource to see if desired updates are already present in the system and that the request does not contain information that conflicts with the current state.\r\nMore context of the specific resource can be seen under the console message body.',
    description: null,
    product: 'Flex',
    date_created: '2019-07-02T08:43:53Z',
    last_updated: '2020-09-01T07:05:02.697Z',
  },
  53666: {
    code: 53666,
    message: 'Invalid public key for media tracks encryption in composition settings',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53666\r\n\r\n### Invalid public key for media tracks encryption in composition settings\r\n\r\n The public key configured in your account's composition settings is not valid.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.\r\n\r\n#### Possible Causes\r\n * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the key value is not correct.\r\n\r\n#### Possible Solutions\r\n * In the composition settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
    causes:
      ' * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the key value is not correct.',
    solutions:
      " * In the composition settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
    description:
      "The public key configured in your account's composition settings is not valid.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.",
    product: 'Programmable Video',
    date_created: '2021-04-13T07:33:35Z',
    last_updated: '2021-04-13T07:34:03.046Z',
  },
  30478: {
    code: 30478,
    message: 'Toll Free verification rejection - single phone number used for multiple businesses',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30478\r\n\r\n### Toll Free verification rejection - single phone number used for multiple businesses\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nA toll-free verification has been received for a toll-free phone number that is assigned to multiple businesses. The toll-free phone number must be 1:1 with a single business, it cannot be used for multiple businesses. \r\n\r\n#### Possible Solutions\r\n* Use the toll-free phone number for only one business.  \r\n* Resubmit the verification and provide Additional Information that explains how you rectified this. \r\n\r\nResources: \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'A toll-free verification has been received for a toll-free phone number that is assigned to multiple businesses. The toll-free phone number must be 1:1 with a single business, it cannot be used for multiple businesses. ',
    solutions:
      '* Use the toll-free phone number for only one business.  \r\n* Resubmit the verification and provide Additional Information that explains how you rectified this. \r\n\r\nResources: \r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T22:11:34Z',
    last_updated: '2024-02-22T22:11:34Z',
  },
  22199: {
    code: 22199,
    message: 'Configuration Retrieval Error',
    log_level: 'ERROR',
    secondary_message: 'The Phone Numbers Configuration is Missing',
    log_type: 'APPLICATION',
    docs: '## ERROR - 22199\r\n\r\n### Configuration Retrieval Error\r\n\r\nThe Phone Numbers Configuration is Missing The Phone Numbers Configuration is Missing.  Phone Numbers have a configuration for each region.  This Error shows if you are attempting to perform an action that requires region specific configuration.  Please create or add a configuration to this Phone Number for the Region in question.\r\n\r\n#### Possible Causes\r\nPerforming an Action that Requires a Configuration in Region in Question\r\n\r\n#### Possible Solutions\r\nDouble Check that the phone number has a configuration for each region you are working with.\r\n',
    causes: 'Performing an Action that Requires a Configuration in Region in Question',
    solutions:
      'Double Check that the phone number has a configuration for each region you are working with.\r\n',
    description:
      'The Phone Numbers Configuration is Missing.  Phone Numbers have a configuration for each region.  This Error shows if you are attempting to perform an action that requires region specific configuration.  Please create or add a configuration to this Phone Number for the Region in question.',
    product: 'Phone Numbers',
    date_created: '2022-04-26T14:15:12Z',
    last_updated: '2022-04-26T14:15:12Z',
  },
  30102: {
    code: 30102,
    message: 'TLS certificate for your Domain has expired.',
    log_level: 'ERROR',
    secondary_message: 'TLS certificate associated with the Domain is expired.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30102\r\n\r\n### TLS certificate for your Domain has expired.\r\n\r\nTLS certificate associated with the Domain is expired. TLS certificate for the Domain you are using with Twilio Link Shortening has been expired. \r\n\r\n#### Possible Causes\r\nTLS certificate associated with the Domain is expired.\r\n\r\n#### Possible Solutions\r\nGenerate and upload a new TLS certificate for the Domain through Twilio Link Shortening console or via Domain Certificate API.',
    causes: 'TLS certificate associated with the Domain is expired.',
    solutions:
      'Generate and upload a new TLS certificate for the Domain through Twilio Link Shortening console or via Domain Certificate API.',
    description:
      'TLS certificate for the Domain you are using with Twilio Link Shortening has been expired. ',
    product: 'Programmable SMS',
    date_created: '2020-04-22T20:23:25Z',
    last_updated: '2023-05-22T20:00:13.120833Z',
  },
  53201: {
    code: 53201,
    message: 'Participant identity is too long',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53201: Participant identity is too long\r\n\r\nRaised whenever a Participant identity is too long.\r\n\r\n#### Causes\r\n\r\n * The Participant identity is too long.\r\n\r\n#### Solutions\r\n\r\n * Choose a shorter Participant identity.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:47:27Z',
    last_updated: '2020-08-04T10:00:19.463Z',
  },
  63015: {
    code: 63015,
    message: 'Channel Sandbox can only send messages to phone numbers that have joined the Sandbox',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63015\r\n\r\n### Channel Sandbox can only send messages to phone numbers that have joined the Sandbox\r\n\r\n Channel Sandbox can only send messages to phone numbers that have joined the Sandbox\r\n\r\n#### Possible Causes\r\nThis message failed to be delivered to the user because it was sent from a Sandbox to a phone number that has not joined your Sandbox\r\n\r\n#### Possible Solutions\r\nInstruct the recipient to join your Sandbox by sending the join phrase or keyword shown on the Sandbox page in your Twilio Console.',
    causes:
      'This message failed to be delivered to the user because it was sent from a Sandbox to a phone number that has not joined your Sandbox',
    solutions:
      'Instruct the recipient to join your Sandbox by sending the join phrase or keyword shown on the Sandbox page in your Twilio Console.',
    description:
      'Channel Sandbox can only send messages to phone numbers that have joined the Sandbox',
    product: 'Programmable SMS',
    date_created: '2018-06-25T18:44:31Z',
    last_updated: '2020-08-04T10:00:13.343Z',
  },
  21649: {
    code: 21649,
    message: 'Phone Number Requires a Bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21649\r\n\r\n### Phone Number Requires a Bundle\r\n\r\n To provision this number you must supply the Bundle with End-User information and Supporting Documents to comply with local telecom regulations. \r\n\r\nPreviously the IncomingPhoneNumbers API would let you provision the phone number without providing a Bundle, however, you are now required to pass in a BundleSid that satisfies the requirement for the phone number. This is because Twilio needs to know which Bundle containing End-User information and Supporting Documents will be assigned to the phone number to meet regulatory requirements for that country and type of phone number.\r\n\r\n#### Possible Causes\r\n- No Bundle was provided\r\n- No Bundle was that satisfies the locality requirement for this phone number type\r\n- Depending on the country, number type, and end-user type, the regulations will be different compared to other phone numbers\r\n\r\n#### Possible Solutions\r\n- Build a new Bundle that satisfies the regulations of the phone number.\r\n- Contact Twilio Support.',
    causes:
      '- No Bundle was provided\r\n- No Bundle was that satisfies the locality requirement for this phone number type\r\n- Depending on the country, number type, and end-user type, the regulations will be different compared to other phone numbers',
    solutions:
      '- Build a new Bundle that satisfies the regulations of the phone number.\r\n- Contact Twilio Support.',
    description:
      'To provision this number you must supply the Bundle with End-User information and Supporting Documents to comply with local telecom regulations. \r\n\r\nPreviously the IncomingPhoneNumbers API would let you provision the phone number without providing a Bundle, however, you are now required to pass in a BundleSid that satisfies the requirement for the phone number. This is because Twilio needs to know which Bundle containing End-User information and Supporting Documents will be assigned to the phone number to meet regulatory requirements for that country and type of phone number.',
    product: 'Phone Numbers',
    date_created: '2019-11-15T00:21:58Z',
    last_updated: '2020-08-04T10:00:06.035Z',
  },
  92006: {
    code: 92006,
    message: 'The Content Sid is Invalid',
    log_level: 'ERROR',
    secondary_message: 'The Content Sid you are using is not valid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 92006\r\n\r\n### The Content Sid is Invalid\r\n\r\nThe Content Sid you are using is not valid \r\n\r\n#### Possible Causes\r\nThe Content Sid you are using is not valid\r\n\r\n#### Possible Solutions\r\nDouble check the Content Sid parameter that you are using. Make sure it has the proper formatting and starts with an HX prefix.',
    causes: 'The Content Sid you are using is not valid',
    solutions:
      'Double check the Content Sid parameter that you are using. Make sure it has the proper formatting and starts with an HX prefix.',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-11-08T20:01:08Z',
    last_updated: '2021-11-08T20:01:08Z',
  },
  63040: {
    code: 63040,
    message: 'Template Rejected',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63040\r\n\r\n### Template Rejected\r\n\r\n This message matches a template that was rejected by WhatsApp or failed to be submitted. For the most updated guidelines, please view WhatsApp’s documentation: https://developers.facebook.com/docs/whatsapp/message-templates/guidelines.\r\n\r\n#### Possible Causes\r\n* Template purpose is not clear, concise, or well-written. For example, "Hi, {{1 2 Thank you.}}" is vague and not clear how it would be used or what the placeholder values represent.\r\n* Template placeholders are not sequential in order. For example, "{{1 and 2 and 4 }}" are included but the placeholder {{3}} does not exist in the template.\r\n* Template placeholders cannot be right next to each other like "{}{{1 2{}}}".\r\n* Template content is identical to the content of another existing template.\r\n* Template body cannot start or end with a placeholder.\r\n* Template body cannot have the \\n newline character.\r\n* Template footer cannot have emojis or the \\n newline character.\r\n* Templates with Text headers cannot have emojis, asterisks, formatting markup, or the \\n newline character.\r\n* Templates with Media headers (video, image, document) must include a sample with their submission.\r\n* Template is abusive or threatening in nature, such as containing content threatening to take legal action against a user.\r\n\r\nFor the most updated guidelines, please view WhatsApp’s documentation: https://developers.facebook.com/docs/whatsapp/message-templates/guidelines.\r\n\r\nThis error may also occur if you have an approved template that has similar body to a rejected template.\r\n\r\n#### Possible Solutions\r\nSubmit a new template that doesn’t violate the above causes. We also recommend the follow best practices when creating templates:\r\n  * Templates should be as short as possible to get the necessary information across.\r\n  * Templates must not have any grammatical or spelling mistakes. \r\n  * Templates that include major spelling or grammatical mistakes are likely to be rejected. Templates with minor punctuation errors or grammatical inconsistencies may be approved, but should be avoided.\r\n  * When submitting your Template in Console, ensure you select the appropriate message type and language.\r\n  * Get feedback from your teammates or coworkers to ensure the template you’ve written is clear and free of errors.\r\n  * Think about a template message as a conversation starter, with the goal to convert this into a 2-way message by having the user reply. The two-way use case will keep your spend lower, as WhatsApp does not charge the Template message fee for two-way messages.\r\n  * Make sure your customers understand why they received your message – you can remind them of the reason why they originally gave you permission to send them messages.\r\n  * Avoid sending surveys or using the word “survey”. Instead, you may ask the customer for their feedback.\r\n\r\nIf you believe you have an approved template that matches the message you are attempting to send, then we recommend deleting any rejected templates that are similar to the approved template. You may also use the Twilio Content API, which lets you send templates by referencing a template Sid. To learn more, please see: https://www.twilio.com/docs/content-api',
    causes:
      '* Template purpose is not clear, concise, or well-written. For example, "Hi, {{1 2 Thank you.}}" is vague and not clear how it would be used or what the placeholder values represent.\r\n* Template placeholders are not sequential in order. For example, "{{1 and 2 and 4 }}" are included but the placeholder {{3}} does not exist in the template.\r\n* Template placeholders cannot be right next to each other like "{}{{1 2{}}}".\r\n* Template content is identical to the content of another existing template.\r\n* Template body cannot start or end with a placeholder.\r\n* Template body cannot have the \\n newline character.\r\n* Template footer cannot have emojis or the \\n newline character.\r\n* Templates with Text headers cannot have emojis, asterisks, formatting markup, or the \\n newline character.\r\n* Templates with Media headers (video, image, document) must include a sample with their submission.\r\n* Template is abusive or threatening in nature, such as containing content threatening to take legal action against a user.\r\n\r\nFor the most updated guidelines, please view WhatsApp’s documentation: https://developers.facebook.com/docs/whatsapp/message-templates/guidelines.\r\n\r\nThis error may also occur if you have an approved template that has similar body to a rejected template.',
    solutions:
      'Submit a new template that doesn’t violate the above causes. We also recommend the follow best practices when creating templates:\r\n  * Templates should be as short as possible to get the necessary information across.\r\n  * Templates must not have any grammatical or spelling mistakes. \r\n  * Templates that include major spelling or grammatical mistakes are likely to be rejected. Templates with minor punctuation errors or grammatical inconsistencies may be approved, but should be avoided.\r\n  * When submitting your Template in Console, ensure you select the appropriate message type and language.\r\n  * Get feedback from your teammates or coworkers to ensure the template you’ve written is clear and free of errors.\r\n  * Think about a template message as a conversation starter, with the goal to convert this into a 2-way message by having the user reply. The two-way use case will keep your spend lower, as WhatsApp does not charge the Template message fee for two-way messages.\r\n  * Make sure your customers understand why they received your message – you can remind them of the reason why they originally gave you permission to send them messages.\r\n  * Avoid sending surveys or using the word “survey”. Instead, you may ask the customer for their feedback.\r\n\r\nIf you believe you have an approved template that matches the message you are attempting to send, then we recommend deleting any rejected templates that are similar to the approved template. You may also use the Twilio Content API, which lets you send templates by referencing a template Sid. To learn more, please see: https://www.twilio.com/docs/content-api',
    description:
      'This message matches a template that was rejected by WhatsApp or failed to be submitted. For the most updated guidelines, please view WhatsApp’s documentation: https://developers.facebook.com/docs/whatsapp/message-templates/guidelines.',
    product: 'Programmable Messaging',
    date_created: '2022-10-05T19:19:15Z',
    last_updated: '2023-01-24T01:25:18.623506Z',
  },
  54209: {
    code: 54209,
    message: 'Invalid Map Item key',
    log_level: 'ERROR',
    secondary_message: 'The Map Item key must be a string with length 1-256.',
    log_type: null,
    docs: '\n## Error - 54209\n\n### Sync: Invalid Map Item key\nThe Map Item key must be a string with length 1-256.\n\n#### Possible Causes\n* The value supplied by the Map Key parameter contains an empty string.\n* The string supplied by the Map Key parameter exceeds 256 characters.\n\n#### Possible Solutions\n* Confirm a valid Map Key parameter is being passed in your request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.401Z',
  },
  50531: {
    code: 50531,
    message: 'Not Authorized to make this request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 50531\r\n\r\n### Not Authorized to make this request\r\n\r\n User is not authorized to access the requested resource\r\n\r\n#### Possible Causes\r\nUser making the request does not have the appropriate permission:  readChannelMetadata\r\n\r\n#### Possible Solutions\r\nAdd readChannelMetadata permissions to the requesting user's role",
    causes:
      'User making the request does not have the appropriate permission:  readChannelMetadata',
    solutions: "Add readChannelMetadata permissions to the requesting user's role",
    description: 'User is not authorized to access the requested resource',
    product: 'Conversations',
    date_created: '2024-02-27T16:20:20Z',
    last_updated: '2024-02-27T16:20:20Z',
  },
  64012: {
    code: 64012,
    message: 'Pay: Payment Gateway rejected the card.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64012\r\n\r\n### Pay: Payment Gateway rejected the card.\r\n\r\n ## Error - 64012\r\n\r\n### Pay: Payment Gateway rejected the card.\r\n\r\nA 64012 Error is an indication that the provided card was rejected by the Payment Gateway.\r\n\r\n#### Possible Causes\r\n* The card used was rejected by the Payment Gateway.\r\n\r\n#### Possible Solutions\r\n* Check the PaymentError in the response for more detailed information from the Payment Gateway.\r\n* Prompt the user about the card information again.',
    causes: '* The card used was rejected by the Payment Gateway.',
    solutions:
      '* Check the PaymentError in the response for more detailed information from the Payment Gateway.\r\n* Prompt the user about the card information again.',
    description:
      '## Error - 64012\r\n\r\n### Pay: Payment Gateway rejected the card.\r\n\r\nA 64012 Error is an indication that the provided card was rejected by the Payment Gateway.',
    product: 'Programmable Voice',
    date_created: '2019-02-26T22:07:25Z',
    last_updated: '2020-08-04T10:00:10.173Z',
  },
  54458: {
    code: 54458,
    message: 'Invalid List Item index',
    log_level: 'ERROR',
    secondary_message: 'The List Item index must be a non-negative integer.',
    log_type: null,
    docs: '\n## Error - 54458\n\n### Sync: Invalid List Item Index\nThe List Item index must be a non-negative integer.\n\n#### Possible Causes\n* The value supplied by the List Index parameter contains a non-integer or a negative integer.\n\n#### Possible Solutions\nConfirm that a valid List Index parameter is being passed in your request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.153Z',
  },
  31301: {
    code: 31301,
    message: 'Registration error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31301\r\n\r\n### Registration error\r\n\r\nAn error occurred during registration',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:32:46Z',
    last_updated: '2020-08-04T10:00:11.374Z',
  },
  60204: {
    code: 60204,
    message: 'Service does not support this feature',
    log_level: 'ERROR',
    secondary_message: 'Your service does not have access to this feature.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60204\r\n\r\n### Service does not support this feature\r\n\r\n Your service does not have access to this feature.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nYou attempted to use a premium feature but this feature is not enabled in your Service. Further authorization required. \r\n\r\n#### Possible Solutions\r\nContact Twilio Sales (https://www.twilio.com/help/sales) to have this feature enabled. ',
    causes:
      'You attempted to use a premium feature but this feature is not enabled in your Service. Further authorization required. ',
    solutions:
      'Contact Twilio Sales (https://www.twilio.com/help/sales) to have this feature enabled. ',
    description: 'Your service does not have access to this feature.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2018-11-20T19:40:20Z',
    last_updated: '2021-05-18T04:33:57.378Z',
  },
  60715: {
    code: 60715,
    message: 'Error reading logo file',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60715\r\n\r\n### Error reading logo file\r\n\r\n The file sent for the brand logo image could not be read\r\n\r\n#### Possible Causes\r\nThe file may be corrupted, or the file format is not expected (PNG is expected, max size 128kb)\r\n\r\n#### Possible Solutions\r\nMake sure file format and size meet the criteria',
    causes:
      'The file may be corrupted, or the file format is not expected (PNG is expected, max size 128kb)',
    solutions: 'Make sure file format and size meet the criteria',
    description: 'The file sent for the brand logo image could not be read',
    product: 'Branded Comms',
    date_created: '2020-01-24T18:23:35Z',
    last_updated: '2020-08-04T10:00:04.916Z',
  },
  45788: {
    code: 45788,
    message: 'Internal Error. Failed to update deployment key.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45788\r\n\r\n### Internal Error. Failed to update deployment key.\r\n\r\n An unexpected error occurred when processing update deployment key request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when updating deployment key.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when updating deployment key.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing update deployment key request.',
    product: 'Flex',
    date_created: '2023-11-23T04:18:55Z',
    last_updated: '2023-11-23T04:18:55Z',
  },
  60231: {
    code: 60231,
    message: 'Sender id already exists for account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60231\r\n\r\n### Sender id already exists for account\r\n\r\n Sender id already exists for account\r\n\r\n#### Possible Causes\r\nThe created sender id already exists in the given account sid\r\n\r\n#### Possible Solutions\r\nUse a different sender id',
    causes: 'The created sender id already exists in the given account sid',
    solutions: 'Use a different sender id',
    description: 'Sender id already exists for account',
    product: 'Verify',
    date_created: '2023-05-24T16:48:21Z',
    last_updated: '2023-05-24T16:48:21Z',
  },
  51129: {
    code: 51129,
    message: 'Twilsock: Too many messages per account',
    log_level: 'ERROR',
    secondary_message: 'Number of messages for this account is higher than expected!',
    log_type: null,
    docs: "## Error - 51129\r\n\r\n### Too many messages per account\r\n\r\n#### Possible Causes \r\nNumber of messages for this account is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:30:51Z',
    last_updated: '2020-08-04T10:00:09.38Z',
  },
  14223: {
    code: 14223,
    message: 'Enqueue: Unable to cleanup task',
    log_level: 'ERROR',
    secondary_message:
      'Unable to cancel the task created by Enqueue upon a TwimL error or task hangup.',
    log_type: null,
    docs: '## Error - 14223\n\n### Enqueue: Unable to cleanup task\n\nUnable to cancel the task created by Enqueue upon a TwimL error or task hangup.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:13Z',
    last_updated: '2020-08-04T10:00:26.057Z',
  },
  54205: {
    code: 54205,
    message: 'Map Item revision mismatch',
    log_level: 'ERROR',
    secondary_message: 'The actual revision of the Map Item does not match the expected revision.',
    log_type: null,
    docs: '\n## Error - 54205\n\n### Sync: Map Item revision mismatch\nThe actual revision of the Map Item does not match the expected revision.\n\n#### Possible Causes\n* Your update to this Sync Map Item has conflicted with a request submitted elsewhere.\n* The value specified in the If-Match header is erroneous.\n\n#### Possible Solutions\nIf your update conflicts with a concurrent update elsewhere, the correct solution is to read the latest data (on the client SDK: wait for an update) and then re-attempt your update until you succeed. Consider that, since the data has changed, you may not want to submit the exact same update a second time. On the JavaScript SDK, we suggest using the [mutate](https://www.twilio.com/docs/api/sync/mutation-and-conflict-resolution#javascript-sdk-conflict-walkthrough) convenience function.\n\nThe value you provide in the If-Match header should be a revision assigned by the Sync service when interacting with the object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.46Z',
  },
  80103: {
    code: 80103,
    message: 'Participant Already In Session',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80103\r\n\r\n### Participant Already In Session\r\n\r\n The identifier is already a participant in the Session\r\n\r\n#### Possible Causes\r\nParticipant has already been added to the Session\r\n\r\n#### Possible Solutions\r\nCreate a new Session to add this participant, or add a new participant in the Session.',
    causes: 'Participant has already been added to the Session',
    solutions:
      'Create a new Session to add this participant, or add a new participant in the Session.',
    description: 'The identifier is already a participant in the Session',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.241Z',
  },
  410: {
    code: 410,
    message: 'Unknown Error Code',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 410\r\n\r\n### Unknown Error Code\r\n\r\n Access to this resource is no longer available and should not be retried.\r\n\r\n\r\n#### Possible Causes\r\n* The resource has reached a terminal state and is no longer available.\r\n\r\n\r\n#### Possible Solutions\r\n* Do not retry the request since the condition is likely permanent.\r\n',
    causes: '* The resource has reached a terminal state and is no longer available.\r\n',
    solutions: '* Do not retry the request since the condition is likely permanent.\r\n',
    description: 'Access to this resource is no longer available and should not be retried.\r\n',
    product: null,
    date_created: '2020-09-14T21:50:57Z',
    last_updated: '2020-09-14T21:51:24Z',
  },
  94602: {
    code: 94602,
    message: 'Invalid FromDate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94602\r\n\r\n### Invalid FromDate\r\n\r\n The action could not be performed because the FromDate is invalid.\r\n\r\n#### Possible Causes\r\n* FromDate is a future date.\r\n\r\n#### Possible Solutions\r\n * FromDate should be earlier than the present date.',
    causes: '* FromDate is a future date.',
    solutions: ' * FromDate should be earlier than the present date.',
    description: 'The action could not be performed because the FromDate is invalid.',
    product: null,
    date_created: '2022-05-09T16:06:59Z',
    last_updated: '2022-05-09T16:06:59Z',
  },
  50366: {
    code: 50366,
    message: 'Invalid conversation webhook trigger',
    log_level: 'ERROR',
    secondary_message: 'An invalid conversation webhook trigger keyword was supplied.',
    log_type: null,
    docs: '\n## Error - 50366\n\n### Conversations: Invalid conversation webhook trigger\nAn invalid conversation webhook trigger keyword was supplied.\n\n#### Possible Causes\n* One of Configuration.Triggers keywords provided with the request is an empty string.\n* One of Configuration.Triggers keywords provided with the request exceeds the maximum length limit of 248 characters.\n\n#### Possible Solutions\n* Ensure that a list of valid Configuration.Triggers keywords are passed to the API request.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.73Z',
  },
  32210: {
    code: 32210,
    message: 'SIP: Register not supported',
    log_level: 'ERROR',
    secondary_message: 'Registration is not enabled for the SIP domain',
    log_type: null,
    docs: '## Error - 32210\r\n\r\n###  SIP: Registration not supported\r\n\r\n#### Possible Causes \r\n*    Registration is not enabled for the SIP domain\r\n\r\n#### Possible Solutions\r\n*   Enable registration for the SIP domain.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-04-11T20:56:00Z',
    last_updated: '2020-08-04T10:00:22.593Z',
  },
  19052: {
    code: 19052,
    message: 'Invalid page size for custom field definition',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19052\r\n\r\n### Invalid page size for custom field definition\r\n\r\n Invalid page size for custom field definition\r\n\r\n#### Possible Causes\r\nInvalid value for page size in the request URL (not an integer; not within a valid range)\r\n\r\n#### Possible Solutions\r\nChange the value to a parsable integer or to be within the valid range of 1 to 2000',
    causes:
      'Invalid value for page size in the request URL (not an integer; not within a valid range)',
    solutions:
      'Change the value to a parsable integer or to be within the valid range of 1 to 2000',
    description: 'Invalid page size for custom field definition',
    product: 'Contacts',
    date_created: '2020-08-18T01:04:02Z',
    last_updated: '2020-08-24T18:18:06.695Z',
  },
  31960: {
    code: 31960,
    message: 'Stream - Quota exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31960\r\n\r\n### Stream - Quota exceeded\r\n\r\n  Exceeded quota for Dialogflow API\r\n\r\n#### Possible Causes\r\n*The Dialogflow API quotas has been exceeded\r\n\r\n#### Possible Solutions\r\n*Increase the Dialogflow API quotas for the project used with Twilio Virtual Agent',
    causes: '*The Dialogflow API quotas has been exceeded',
    solutions: '*Increase the Dialogflow API quotas for the project used with Twilio Virtual Agent',
    description: ' Exceeded quota for Dialogflow API',
    product: 'Programmable Voice',
    date_created: '2020-09-08T08:14:00Z',
    last_updated: '2021-03-16T07:56:39.371Z',
  },
  53401: {
    code: 53401,
    message: 'Server is unable to create or apply a local media description',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 53401\r\n\r\n### Server is unable to create or apply a local media description\r\n\r\nRaised whenever the Server is unable to create or apply a local media description.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:52:32Z',
    last_updated: '2020-08-04T10:00:08.096Z',
  },
  63032: {
    code: 63032,
    message: 'We cannot send this message to this user because of a WhatsApp limitation. ',
    log_level: 'ERROR',
    secondary_message: "User's number is part of an experiment.",
    log_type: 'CARRIER',
    docs: "## ERROR - 63032\r\n\r\n### We cannot send this message to this user because of a WhatsApp limitation. \r\n\r\n User's number is part of an experiment.\r\n\r\n#### Possible Causes\r\nFailed to send message because this user's phone number is part of an experiment.\r\n\r\n#### Possible Solutions\r\nSkip sending messages to this user.",
    causes: "Failed to send message because this user's phone number is part of an experiment.",
    solutions: 'Skip sending messages to this user.',
    description: "User's number is part of an experiment.",
    product: 'Programmable SMS',
    date_created: '2019-07-25T22:52:16Z',
    last_updated: '2023-07-24T15:35:25.175927Z',
  },
  20003: {
    code: 20003,
    message: 'Permission Denied',
    log_level: 'ERROR',
    secondary_message: 'You lack permission to the resource and method you requested.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 20003\r\n\r\n### Permission Denied\r\n\r\nYou lack permission to the resource and method you requested. #### Authenticating requests to the Twilio API\r\n\r\nAll requests to sensitive areas of the Twilio API must use [HTTP Basic\r\nAuthentication][auth]. Authenticate using your Account SID as the username,\r\nand your Auth Token as the password. Both can be found in the [Twilio\r\nConsole](/console/account/settings).\r\n\r\nYou can also generate revocable [API Keys](/docs/iam/keys/api-key) to authenticate.\r\n\r\nYou may want to consider using a [Twilio helper library](/docs/libraries)\r\n(available in PHP, .NET, Java, Ruby, Python and Node.js) as they will take care of\r\nauthentication for you.\r\n\r\n[auth]: http://en.wikipedia.org/wiki/Basic_access_authentication\r\n\r\n#### Possible Causes\r\n* Using the wrong combination of Account SID and Auth Token \r\n* Using Test Credentials to access your Live Account\r\n* Using subaccount credentials to access master account\r\n* Previous Auth Token has been deleted\r\n* Attempted API Key has been deleted\r\n* Account is suspended or closed\r\n* Extra characters or spaces in the supplied credentials\r\n* Web proxy is stripping out credentials before forwarding to Twilio\r\n* Using JWT with Auth Token rather than API Key\r\n* Attempted API Key is for the incorrect Twilio Region\r\n\r\n#### Possible Solutions\r\n* Verify the Account SID and Auth Token are correct\r\n* Verify the correct Account is being accessed\r\n* Ensure the Account is active, not suspended or closed\r\n* Ensure no extra characters or spaces are being included\r\n* Ensure JWT is only used with API Key\r\n* Ensure the API Key's Twilio Region matches the request's specified Twilio Region",
    causes:
      '* Using the wrong combination of Account SID and Auth Token \r\n* Using Test Credentials to access your Live Account\r\n* Using subaccount credentials to access master account\r\n* Previous Auth Token has been deleted\r\n* Attempted API Key has been deleted\r\n* Account is suspended or closed\r\n* Extra characters or spaces in the supplied credentials\r\n* Web proxy is stripping out credentials before forwarding to Twilio\r\n* Using JWT with Auth Token rather than API Key\r\n* Attempted API Key is for the incorrect Twilio Region',
    solutions:
      "* Verify the Account SID and Auth Token are correct\r\n* Verify the correct Account is being accessed\r\n* Ensure the Account is active, not suspended or closed\r\n* Ensure no extra characters or spaces are being included\r\n* Ensure JWT is only used with API Key\r\n* Ensure the API Key's Twilio Region matches the request's specified Twilio Region",
    description:
      '#### Authenticating requests to the Twilio API\r\n\r\nAll requests to sensitive areas of the Twilio API must use [HTTP Basic\r\nAuthentication][auth]. Authenticate using your Account SID as the username,\r\nand your Auth Token as the password. Both can be found in the [Twilio\r\nConsole](/console/account/settings).\r\n\r\nYou can also generate revocable [API Keys](/docs/iam/keys/api-key) to authenticate.\r\n\r\nYou may want to consider using a [Twilio helper library](/docs/libraries)\r\n(available in PHP, .NET, Java, Ruby, Python and Node.js) as they will take care of\r\nauthentication for you.\r\n\r\n[auth]: http://en.wikipedia.org/wiki/Basic_access_authentication',
    product: null,
    date_created: '2016-03-31T17:13:51Z',
    last_updated: '2023-07-28T16:56:47.701165Z',
  },
  82008: {
    code: 82008,
    message: 'Headers or cookies too large',
    log_level: 'ERROR',
    secondary_message: 'Request or response headers/cookies size is greater than the limits',
    log_type: 'APPLICATION',
    docs: '## ERROR - 82008\r\n\r\n### Headers or cookies too large\r\n\r\nRequest or response headers/cookies size is greater than the limits This error is thrown when request or response headers are greater than the enforced limits.\r\n\r\n#### Possible Causes\r\n1. The user has passed request/response headers larger than 4kb. \r\n2. Request/response has more than 75 headers+cookies.\r\n\r\n#### Possible Solutions\r\n1. Pass cookies and headers less than 4kb. Set cookies less than 4kb in the response.\r\n2. Send less than 75 headers. Set less than 75 headers/cookies in the response.',
    causes:
      '1. The user has passed request/response headers larger than 4kb. \r\n2. Request/response has more than 75 headers+cookies.',
    solutions:
      '1. Pass cookies and headers less than 4kb. Set cookies less than 4kb in the response.\r\n2. Send less than 75 headers. Set less than 75 headers/cookies in the response.',
    description:
      'This error is thrown when request or response headers are greater than the enforced limits.',
    product: 'Functions',
    date_created: '2021-08-11T17:44:58Z',
    last_updated: '2021-08-13T19:26:05.041951Z',
  },
  48000: {
    code: 48000,
    message: 'Invalid request payload',
    log_level: 'ERROR',
    secondary_message: 'The callback request payload provided is invalid',
    log_type: 'APPLICATION',
    docs: '## ERROR - 48000\r\n\r\n### Invalid request payload\r\n\r\nThe callback request payload provided is invalid \r\n\r\n#### Possible Causes\r\n- You might be using an old version of Frontline application.\r\n\r\n#### Possible Solutions\r\n- Update your Frontline application.',
    causes: '- You might be using an old version of Frontline application.',
    solutions: '- Update your Frontline application.',
    description: null,
    product: 'Frontline',
    date_created: '2021-09-24T08:04:55Z',
    last_updated: '2021-09-24T08:04:55Z',
  },
  64024: {
    code: 64024,
    message: 'Pay: Connector Instance Not Approved',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64024\r\n\r\n### Pay: Connector Instance Not Approved\r\n\r\n This connector instance has not been approved by Twilio. Please contact Twilio support to gain approval for LIVE transactions.\r\n\r\n#### Possible Causes\r\nThis is caused by your connector instance not having been approved by Twilio for LIVE transactions. You must go through a PCI review in order to gain approval for LIVE transactions.\r\n\r\n#### Possible Solutions\r\nContact Twilio Support in order to gain approval for LIVE transactions for the specific connector instance.',
    causes:
      'This is caused by your connector instance not having been approved by Twilio for LIVE transactions. You must go through a PCI review in order to gain approval for LIVE transactions.',
    solutions:
      'Contact Twilio Support in order to gain approval for LIVE transactions for the specific connector instance.',
    description:
      'This connector instance has not been approved by Twilio. Please contact Twilio support to gain approval for LIVE transactions.',
    product: 'Programmable Voice',
    date_created: '2023-04-12T16:28:32Z',
    last_updated: '2023-04-12T16:28:32Z',
  },
  80701: {
    code: 80701,
    message: 'Parameter Validation Failed',
    log_level: 'WARNING',
    secondary_message: "'<parameter name>' is invalid. <parameter is invalid>",
    log_type: null,
    docs: "## Warning\n\n### Parameter Validation Failed\n\nExample Message: '<parameter name>' is invalid. <parameter is invalid>",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.678Z',
  },
  31106: {
    code: 31106,
    message: 'Invalid data',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31106\r\n\r\n### Invalid data\r\n\r\nThe provided data was not valid.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:53:51Z',
    last_updated: '2020-08-04T10:00:11.354Z',
  },
  45313: {
    code: 45313,
    message: 'Transfer Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45313\r\n\r\n### Transfer Failed\r\n\r\n Transfer failed to complete \r\n\r\n#### Possible Causes\r\nTransfer process took too long to complete or the voice API returned error\r\n\r\n#### Possible Solutions\r\nRetry operation',
    causes: 'Transfer process took too long to complete or the voice API returned error',
    solutions: 'Retry operation',
    description: 'Transfer failed to complete ',
    product: 'Flex',
    date_created: '2020-05-08T21:32:13Z',
    last_updated: '2020-08-04T10:00:03.176Z',
  },
  21217: {
    code: 21217,
    message: 'Phone number does not appear to be valid',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call to an invalid phone number. Please check the phone number and try again.',
    log_type: null,
    docs: '## Error - 21217\n\n### Phone number does not appear to be valid \n\nYou attempted to initiate an outbound phone call to an invalid phone number.  \nPlease check the phone number and try again.  \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:15Z',
    last_updated: '2020-08-04T10:00:25.822Z',
  },
  54056: {
    code: 54056,
    message: 'Account cannot access requested Service Instance',
    log_level: 'ERROR',
    secondary_message: 'Account cannot access requested Service Instance.',
    log_type: null,
    docs: "\n## Error - 54056\n\n### Sync: Account cannot access requested Service Instance\nAccount cannot access requested Service Instance.\n\n#### Possible Causes\n* The requested Sync Service does not belong to this account.\n* You have multiple accounts, and this Sync Service does not belong to the account whose credentials you used.\n\n#### Possible Solutions\nConfirm that you're using the correct credentials for this instance's account. This could mean:\n\n* Make sure the Access Token specifies the correct Account SID\n* Make sure that the Account SID + AuthToken pair you're using (for REST access) matches the correct account\n* Make sure the API Key + API secret you're using (for REST access) belongs to the correct account.\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.661Z',
  },
  45781: {
    code: 45781,
    message: 'Internal Error. Failed to create deployment key.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45781\r\n\r\n### Internal Error. Failed to create deployment key.\r\n\r\n An unexpected error occurred when processing create deployment key request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when creating deployment key.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when creating deployment key.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing create deployment key request.',
    product: 'Flex',
    date_created: '2023-11-21T07:55:35Z',
    last_updated: '2023-11-21T07:55:35Z',
  },
  53124: {
    code: 53124,
    message: 'The AudioOnly flag is not supported for the Room type',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53124\r\n\r\n### The AudioOnly flag is not supported for the Room type\r\n\r\n Raised whenever a participant tries to set the AudioOnly flag for a Room type other than Group Rooms.\r\n\r\n#### Possible Causes\r\nThe AudioOnly flag is set for a room that is not a Group Room.\r\n\r\n#### Possible Solutions\r\nMake sure that the flag is supported by the Room type.',
    causes: 'The AudioOnly flag is set for a room that is not a Group Room.',
    solutions: 'Make sure that the flag is supported by the Room type.',
    description:
      'Raised whenever a participant tries to set the AudioOnly flag for a Room type other than Group Rooms.',
    product: 'Programmable Video',
    date_created: '2021-10-13T16:33:44Z',
    last_updated: '2021-10-13T16:33:44Z',
  },
  60227: {
    code: 60227,
    message: 'The selected channel for template is not supported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60227\r\n\r\n### The selected channel for template is not supported\r\n\r\n ## Error - 60227\r\n\r\n### Invalid Parameter\r\n\r\nThe selected template for translation is not supported\r\n\r\n#### Possible Causes\r\nThe user have provided a channel to be used that is not supported for a template.\r\n\r\n#### Possible Solutions\r\nProvide a supported channel for the template.',
    causes: 'The user have provided a channel to be used that is not supported for a template.',
    solutions: 'Provide a supported channel for the template.',
    description:
      '## Error - 60227\r\n\r\n### Invalid Parameter\r\n\r\nThe selected template for translation is not supported',
    product: 'Verify',
    date_created: '2022-08-23T16:05:06Z',
    last_updated: '2022-08-30T22:19:28.44231Z',
  },
  21621: {
    code: 21621,
    message: "The 'From' number has not been enabled for MMS",
    log_level: 'ERROR',
    secondary_message:
      "The 'From' phone number does not appear to be a phone number that you can send MMS messages from.",
    log_type: 'APPLICATION',
    docs: "## ERROR - 21621\r\n\r\n### The 'From' number has not been enabled for MMS\r\n\r\n The `From` number is not enabled for MMS messaging.\r\n\r\n\r\n#### Possible Causes\r\nThe `From` phone number is not capable of sending MMS.\r\n\r\n#### Possible Solutions\r\n* Buy an MMS Capable phone number from the [Twilio Console](https://console.twilio.com/us1/develop/phone-numbers/manage/search?isoCountry=US&types[]=Local&types[]=Tollfree&capabilities[]=Sms&capabilities[]=Mms&capabilities[]=Voice&capabilities[]=Fax&searchTerm=&searchFilter=left&searchType=number) by filtering for “MMS” under “Capabilities”.\r\n* Check if you already have MMS capable numbers in the [Twilio Console](https://console.twilio.com/us1/develop/phone-numbers/manage/incoming) and use that number in your `From` parameter or Messaging Service.",
    causes: 'The `From` phone number is not capable of sending MMS.',
    solutions:
      '* Buy an MMS Capable phone number from the [Twilio Console](https://console.twilio.com/us1/develop/phone-numbers/manage/search?isoCountry=US&types[]=Local&types[]=Tollfree&capabilities[]=Sms&capabilities[]=Mms&capabilities[]=Voice&capabilities[]=Fax&searchTerm=&searchFilter=left&searchType=number) by filtering for “MMS” under “Capabilities”.\r\n* Check if you already have MMS capable numbers in the [Twilio Console](https://console.twilio.com/us1/develop/phone-numbers/manage/incoming) and use that number in your `From` parameter or Messaging Service.',
    description: 'The `From` number is not enabled for MMS messaging.\r\n',
    product: null,
    date_created: '2016-03-31T17:14:28Z',
    last_updated: '2024-02-06T09:59:25.089781Z',
  },
  14300: {
    code: 14300,
    message: 'Start: Invalid nested noun value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 14300\r\n\r\n### Start: Invalid nested noun value\r\n\r\n Start or Stop has an invalid noun defined.\r\n\r\n#### Possible Causes\r\nStart or Stop has an invalid noun defined.\r\n\r\n#### Possible Solutions\r\nCorrect the noun used in Twiml',
    causes: 'Start or Stop has an invalid noun defined.',
    solutions: 'Correct the noun used in Twiml',
    description: 'Start or Stop has an invalid noun defined.',
    product: 'Programmable Voice',
    date_created: '2020-03-11T00:02:52Z',
    last_updated: '2020-08-04T10:00:04.267Z',
  },
  21245: {
    code: 21245,
    message: 'Trunk Validation Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 21245\r\n\r\n### Trunk Validation Error\r\n\r\n \r\n\r\n#### Possible Causes\r\n* Cannot use another account's SID as the Termination URI for this Trunk\r\n* Cannot create more than one Trunk with the same Termination URI\r\n* Credential List or IP-ACL already associated with Trunk\r\n\r\n#### Possible Solutions\r\n*  Please update your Trunk settings to avoid the conditions stated above. Learn more: [Configure Trunks](/docs/sip-trunking#configure-trunks).",
    causes:
      "* Cannot use another account's SID as the Termination URI for this Trunk\r\n* Cannot create more than one Trunk with the same Termination URI\r\n* Credential List or IP-ACL already associated with Trunk",
    solutions:
      '*  Please update your Trunk settings to avoid the conditions stated above. Learn more: [Configure Trunks](/docs/sip-trunking#configure-trunks).',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:06:22Z',
    last_updated: '2023-07-28T17:06:58.70108Z',
  },
  40122: {
    code: 40122,
    message: 'TaskRouter->Direct',
    log_level: 'ERROR',
    secondary_message:
      'Direct Instruction encountered an error when redirecting a call via the API.',
    log_type: null,
    docs: '## Error - 40122\r\n\r\n### Call Redirection API Error - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  The call being redirected is no longer in progress.\r\n*  The call_sid passed doesn\'t reference an actual call\r\n\r\n#### Possible Solutions\r\n*  Make certain "call_sid" is provided an is a 34 char string starting with CA that represents a live call. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:42Z',
    last_updated: '2020-08-04T10:00:23.917Z',
  },
  64020: {
    code: 64020,
    message: 'Pay: Invalid Parameter Value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64020\r\n\r\n### Pay: Invalid Parameter Value\r\n\r\n A 64020 Error is an indication that one or more of the values provided for an attribute or parameter are invalid.\r\n\r\n#### Possible Causes\r\n* Misspelled parameter values\r\n* Incorrect format for parameter values\r\n* Unexpcted value for one or more parameters\r\n\r\n#### Possible Solutions\r\n* Ensure that values match what is expected by refering to the API and TwiML docs',
    causes:
      '* Misspelled parameter values\r\n* Incorrect format for parameter values\r\n* Unexpcted value for one or more parameters',
    solutions: '* Ensure that values match what is expected by refering to the API and TwiML docs',
    description:
      'A 64020 Error is an indication that one or more of the values provided for an attribute or parameter are invalid.',
    product: 'Programmable Voice',
    date_created: '2020-05-05T23:06:41Z',
    last_updated: '2020-08-04T10:00:03.363Z',
  },
  50392: {
    code: 50392,
    message: 'PreWebhookTimeout should be greater than 0ms',
    log_level: 'ERROR',
    secondary_message: 'Duration of waiting for pre-webhook response cannot be 0ms or less.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 50392\r\n\r\n### PreWebhookTimeout should be greater than 0ms\r\n\r\nDuration of waiting for pre-webhook response cannot be 0ms or less. 'PreWebhookTimeout' should be greater than 0ms.\r\n\r\n#### Possible Causes\r\n* 'PreWebhookTimeout' field is set with a value less than or equal to 0.\r\n\r\n#### Possible Solutions\r\n* set 'PreWebhookTimeout' field with a value greater than 0.",
    causes: "* 'PreWebhookTimeout' field is set with a value less than or equal to 0.",
    solutions: "* set 'PreWebhookTimeout' field with a value greater than 0.",
    description: "'PreWebhookTimeout' should be greater than 0ms.",
    product: 'Programmable Chat',
    date_created: '2021-12-03T13:00:45Z',
    last_updated: '2021-12-03T13:00:45Z',
  },
  50500: {
    code: 50500,
    message: 'Programmable Chat: Message not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Message does not exist.',
    log_type: null,
    docs: '## Error - 50500\r\n\r\n### Programmable Chat: Message not found\t\r\n\r\n#### Possible Causes \r\n*  Specified Message does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:52Z',
    last_updated: '2020-08-04T10:00:22.995Z',
  },
  25102: {
    code: 25102,
    message: "The organization's account limit has been reached",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25102\r\n\r\n### The organization's account limit has been reached\r\n\r\n The organization's account limit has been reached.\r\n\r\n#### Possible Causes\r\nYour organization has reached the maximum limit for managed accounts.\r\n\r\n#### Possible Solutions\r\nTo increase the account limit for your organization, please contact Twilio support.",
    causes: 'Your organization has reached the maximum limit for managed accounts.',
    solutions:
      'To increase the account limit for your organization, please contact Twilio support.',
    description: "The organization's account limit has been reached.",
    product: 'Organizations API',
    date_created: '2023-12-04T11:16:34Z',
    last_updated: '2023-12-04T14:25:25.400726Z',
  },
  32703: {
    code: 32703,
    message: 'Voice User-Defined Message: Content body exceeded max length',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32703\r\n\r\n### Voice User-Defined Message: Content body exceeded max length\r\n\r\n The content body in the Voice User-Defined Message request exceeds the maximum allowed length of 10000 characters.\r\n\r\n#### Possible Causes\r\n* The content body in the Voice POST request to the UserDefinedMessage.Resource exceeds the maximum allowed length of 10000 characters.\r\n\r\n#### Possible Solutions\r\n* Make sure that the content body in the request does not exceed the maximum.length.',
    causes:
      '* The content body in the Voice POST request to the UserDefinedMessage.Resource exceeds the maximum allowed length of 10000 characters.',
    solutions:
      '* Make sure that the content body in the request does not exceed the maximum.length.',
    description:
      'The content body in the Voice User-Defined Message request exceeds the maximum allowed length of 10000 characters.',
    product: 'Programmable Voice',
    date_created: '2022-08-18T21:50:48Z',
    last_updated: '2022-08-18T22:01:03.669863Z',
  },
  30909: {
    code: 30909,
    message: 'Campaign vetting rejection - CTA Verification Issue',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30909\r\n\r\n### Campaign vetting rejection - CTA Verification Issue\r\n\r\n The campaign submission has been reviewed and rejected due to issues verifying the Call to Action (CTA) provided for the campaign.\r\n\r\n#### Possible Causes\r\n* *Unverifiable CTA*: The Call to Action associated with the campaign could not be verified during the review process.  If opt-in occurs outside of the website,then provided information was incomplete or not fully detailed.\r\n\r\n\r\n#### Possible Solutions\r\n1. Provide complete CTA information and all possible methods of receiving consent. If opt-in is not conducted through the website, please detail and provide documentation how the CTA is presented to and actioned by end-users.\r\n Once you have made a change to address CTA verification issues, please resubmit the campaign for review.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n',
    causes:
      '* *Unverifiable CTA*: The Call to Action associated with the campaign could not be verified during the review process.  If opt-in occurs outside of the website,then provided information was incomplete or not fully detailed.\r\n',
    solutions:
      '1. Provide complete CTA information and all possible methods of receiving consent. If opt-in is not conducted through the website, please detail and provide documentation how the CTA is presented to and actioned by end-users.\r\n Once you have made a change to address CTA verification issues, please resubmit the campaign for review.\r\n\r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)\r\n',
    description:
      'The campaign submission has been reviewed and rejected due to issues verifying the Call to Action (CTA) provided for the campaign.',
    product: 'Programmable Messaging',
    date_created: '2023-11-09T16:27:25Z',
    last_updated: '2023-11-09T16:27:25Z',
  },
  30443: {
    code: 30443,
    message: 'Toll-Free verification rejection - Disallowed: Loan Marketing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30443\r\n\r\n### Toll-Free verification rejection - Disallowed: Loan Marketing\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (High-risk financial services: New loan soliciting). \r\n\r\nNew loan soliciting, Payday loans, Short term high-interest loans, Third-party loans and Student loans are disallowed content. \r\n\r\n"Third-party" means originating from any party other than the one which will service the loan. Examples of third-party loans could include: auto, mortgage, personal, etc. First party loan content is acceptable if it is not promotional messaging.\r\n\r\nNote: Any business with a terms of service or privacy policy that mentions sharing or selling consumer data/opt-in information is considered noncompliant.\r\n\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (High-risk financial services: New loan soliciting). \r\n\r\nNew loan soliciting, Payday loans, Short term high-interest loans, Third-party loans and Student loans are disallowed content. \r\n\r\n"Third-party" means originating from any party other than the one which will service the loan. Examples of third-party loans could include: auto, mortgage, personal, etc. First party loan content is acceptable if it is not promotional messaging.\r\n\r\nNote: Any business with a terms of service or privacy policy that mentions sharing or selling consumer data/opt-in information is considered noncompliant.\r\n',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2022-09-30T17:10:59Z',
    last_updated: '2024-04-16T15:53:58.329931Z',
  },
  60603: {
    code: 60603,
    message: 'SendGrid maximum credits exceeded',
    log_level: 'ERROR',
    secondary_message: 'SendGrid maximum credits exceeded',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60603\r\n\r\n### SendGrid maximum credits exceeded\r\n\r\nSendGrid maximum credits exceeded SendGrid maximum credits exceeded\r\n\r\nHTTP status: 401\r\n\r\n#### Possible Causes\r\nSent too many emails verifications\r\n\r\n#### Possible Solutions\r\nUpgrade your Sendgrid subscription ',
    causes: 'Sent too many emails verifications',
    solutions: 'Upgrade your Sendgrid subscription ',
    description: 'SendGrid maximum credits exceeded\r\n\r\nHTTP status: 401',
    product: 'Verify',
    date_created: '2019-12-30T18:04:42Z',
    last_updated: '2021-05-18T04:58:04.948Z',
  },
  13249: {
    code: 13249,
    message: 'Dial: Invalid username or password attribute',
    log_level: 'WARNING',
    secondary_message: 'Your username or password are invalid.',
    log_type: null,
    docs: '## Warning - 13249 \n\n### Dial: Invalid username or password attribute\n\nYour username or password are invalid.\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:08Z',
    last_updated: '2020-08-04T10:00:26.462Z',
  },
  82003: {
    code: 82003,
    message: 'Deployment Installation Failure',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 82003\r\n\r\n### Deployment Installation Failure\r\n\r\n Your latest Functions and Private Assets failed to be deployed.\r\n\r\n#### Possible Causes\r\n* NPM registry is degraded.\r\n* Your Service instance is trying to install a package that requires a gcc compiler. \r\n* Your Service instance resulted in out of space error due to large packages.\r\n\r\n#### Possible Solutions\r\n* Retry deployment after sometime.',
    causes:
      '* NPM registry is degraded.\r\n* Your Service instance is trying to install a package that requires a gcc compiler. \r\n* Your Service instance resulted in out of space error due to large packages.',
    solutions: '* Retry deployment after sometime.',
    description: 'Your latest Functions and Private Assets failed to be deployed.',
    product: 'Functions',
    date_created: '2018-09-21T17:11:37Z',
    last_updated: '2023-11-02T21:29:55.173682Z',
  },
  13215: {
    code: 13215,
    message: 'Dial: Invalid nested element',
    log_level: 'WARNING',
    secondary_message:
      "The only valid nested element for Dial is Number. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13215 \n\n### Dial: Invalid nested element\n\nThe only valid nested element for Dial is Number. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:33Z',
    last_updated: '2020-08-04T10:00:28.876Z',
  },
  52303: {
    code: 52303,
    message: 'Concurrent User update',
    log_level: 'WARNING',
    secondary_message: 'Concurrent User update may have caused User data inconsistency',
    log_type: null,
    docs: '## Error - 52303\r\n\r\n### Concurrent User update\r\n\r\nUpdating the same User resource in multiple concurrent requests may cause data inconsistency. This may result in that searches using multiple Segments will not find your User resource even if it should belong to all the specified Segments.\r\n\r\n#### Possible Causes \r\n* Updating the same User resource (e.g. adding or removing it to/from Segments) in multiple requests concurrently.\r\n\r\n#### Possible Solutions\r\n* Change implementation so that if you need to add a User to multiple Segments at once you wait for each request to complete before trying the next one.\r\n* For past errors, just read the affected User resource by using the [Read User API](https://www.twilio.com/docs/notify/api/users#retrieve-a-user) this will fix the data inconsistency.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-05-24T08:37:50Z',
    last_updated: '2020-08-04T10:00:18.496Z',
  },
  21202: {
    code: 21202,
    message: 'Called number is a premium number',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outboud phone call to a "premium" phone number, such as a toll 976 line.',
    log_type: null,
    docs: '## Error - 21202 \n\n### \'To\' number is a premium number\n\nYou attempted to initiate an outbound phone call to a "premium" phone number, such as a toll 976 line.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:53Z',
    last_updated: '2020-08-04T10:00:27.276Z',
  },
  456001: {
    code: 456001,
    message: 'Approaching Flex Plugin creation limit',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 456001\r\n\r\n### Approaching Flex Plugin creation limit\r\n\r\n You are approaching the limit of how many Flex Plugins you can have on your account. Once you reach the limit, you may need to archive old Plugins to create any new one.\r\n\r\n#### Possible Causes\r\nYou are approaching 25 Flex Plugins on your account.\r\n\r\n#### Possible Solutions\r\nArchive older Plugins if they are no longer used.',
    causes: 'You are approaching 25 Flex Plugins on your account.',
    solutions: 'Archive older Plugins if they are no longer used.',
    description:
      'You are approaching the limit of how many Flex Plugins you can have on your account. Once you reach the limit, you may need to archive old Plugins to create any new one.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-07-15T21:05:58Z',
  },
  22116: {
    code: 22116,
    message: 'Invalid Friendly Name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22116\r\n\r\n#### Invalid Friendly Name\r\n\r\nFriendly name is a descriptive name to help you remember your resource. The friendly name cannot exceed a length of 128 characters. \r\n\r\n#### Possible Solutions\r\n\r\n* Confirm that your friendly name is a string that does not exceed 128 characters.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-07T05:10:02Z',
    last_updated: '2020-08-04T10:00:14.974Z',
  },
  53407: {
    code: 53407,
    message: 'Media connection failed due to DTLS handshake failure',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 53407\r\n\r\n### Media connection failed due to DTLS handshake failure\r\n\r\n There was a problem while negotiating with the remote DTLS peer. Therefore the Participant will not be able to publish or subscribe to Tracks.\r\n\r\n#### Possible Causes\r\n* One or both of the DTLS peers have an invalid certificate.\r\n* One or both of the DTLS peers have an outdated version of DTLS.\r\n* One or both of the DTLS peers lost internet connectivity while performing a DTLS handshake.\r\n\r\n#### Possible Solutions\r\n* Ensure that your certificate is valid.\r\n* Ensure that you have a stable internet connection.\r\n* Ensure that the browser or the Mobile SDK supports newer versions of DTLS.',
    causes:
      '* One or both of the DTLS peers have an invalid certificate.\r\n* One or both of the DTLS peers have an outdated version of DTLS.\r\n* One or both of the DTLS peers lost internet connectivity while performing a DTLS handshake.',
    solutions:
      '* Ensure that your certificate is valid.\r\n* Ensure that you have a stable internet connection.\r\n* Ensure that the browser or the Mobile SDK supports newer versions of DTLS.',
    description:
      'There was a problem while negotiating with the remote DTLS peer. Therefore the Participant will not be able to publish or subscribe to Tracks.',
    product: 'Programmable Video',
    date_created: '2021-03-09T08:12:52Z',
    last_updated: '2021-03-09T08:12:52Z',
  },
  32214: {
    code: 32214,
    message: 'SIP: Invalid <Dial><Sip> ',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning 32214\r\n\r\n###  Invalid &lt;Dial&gt;&lt;Sip&gt;\r\n\r\n#### Possible Causes\r\nYour TwiML can only &lt;Dial&gt;&lt;Sip&gt;username@yoursipdomain.sip.us1.twilio.com&lt;/Dial&gt;&lt;/Sip&gt;\r\n  to Twilio SIP Domains either in the same subaccount or within the master account.\r\n\r\n<b>Possible Solutions</b>\r\n\r\nRegister the SIP endpoint to a SIP Domain on the same subaccount.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2016-11-15T20:22:33Z',
    last_updated: '2020-08-04T10:00:20.47Z',
  },
  456002: {
    code: 456002,
    message: 'Approaching Flex Plugin Version creation limit',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 456002\r\n\r\n### Approaching Flex Plugin Version creation limit\r\n\r\n You are approaching the limit of how many Flex Plugin Versions you can have. Once you reach the limit, you may need to archive old Versions to create any new one.\r\n\r\n#### Possible Causes\r\nYou are approaching 500 Flex Plugin Versions on your account.\r\n\r\n#### Possible Solutions\r\nArchive older Plugin Versions if they are no longer used.',
    causes: 'You are approaching 500 Flex Plugin Versions on your account.',
    solutions: 'Archive older Plugin Versions if they are no longer used.',
    description:
      'You are approaching the limit of how many Flex Plugin Versions you can have. Once you reach the limit, you may need to archive old Versions to create any new one.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-07-15T21:06:35Z',
  },
  45401: {
    code: 45401,
    message: 'RTA feed callback returned not successful response code',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 45401\r\n\r\n### RTA feed callback returned not successful response code\r\n\r\n Call to defined rta_callback_url returned with not successful response code\r\n\r\n#### Possible Causes\r\nRTA callback is misconfigured or down\r\n\r\n#### Possible Solutions\r\nChange account configuration and set correct value for rta_callback_url',
    causes: 'RTA callback is misconfigured or down',
    solutions: 'Change account configuration and set correct value for rta_callback_url',
    description: 'Call to defined rta_callback_url returned with not successful response code',
    product: 'Flex',
    date_created: '2020-06-08T06:19:53Z',
    last_updated: '2020-09-21T21:19:32.827Z',
  },
  32221: {
    code: 32221,
    message: 'Dialing SIP Endpoint failure - No devices registered in specified edge',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32221\r\n\r\n### Dialing SIP Endpoint failure - No devices registered in specified edge\r\n\r\n Twilio was unable to dial the specified SIP Endpoint. While the user did have at least one device registered, no devices were registered through the edge location specified in the URI.\r\n\r\n#### Possible Causes\r\n* You are trying to migrate from us1-only or us1-ix-only SIP registration and have configured some devices to register through other edges, but you are still using edge-specific URIs (e.g. username@yourdomain.sip.us1.twilio.com) when placing calls in your application.\r\n* If you only intend to use the us1 or us1-ix edges, you may have SIP devices unexpectedly registering through another edge. Check the domain name and outbound proxy settings on your client devices.\r\n\r\n#### Possible Solutions\r\n* If you want to take advantage of new global SIP registration features, including the ability to dial any registered endpoint regardless of the edge through which it registered, update your TwiML or REST API app to use your SIP domain’s global URI, e.g username@yourdomain.sip.twilio.com.\r\n* If SIP devices are registering through an edge you did not intend, either re-configure these devices to register through the desired edge, or turn off the SIP Registration functionality in your device settings if the registration behavior is not needed.\r\n* To troubleshoot, you can verify if a SIP Endpoint has registered by using the Console "Registered SIP Endpoints" tab found on the SIP Domains page.',
    causes:
      '* You are trying to migrate from us1-only or us1-ix-only SIP registration and have configured some devices to register through other edges, but you are still using edge-specific URIs (e.g. username@yourdomain.sip.us1.twilio.com) when placing calls in your application.\r\n* If you only intend to use the us1 or us1-ix edges, you may have SIP devices unexpectedly registering through another edge. Check the domain name and outbound proxy settings on your client devices.',
    solutions:
      '* If you want to take advantage of new global SIP registration features, including the ability to dial any registered endpoint regardless of the edge through which it registered, update your TwiML or REST API app to use your SIP domain’s global URI, e.g username@yourdomain.sip.twilio.com.\r\n* If SIP devices are registering through an edge you did not intend, either re-configure these devices to register through the desired edge, or turn off the SIP Registration functionality in your device settings if the registration behavior is not needed.\r\n* To troubleshoot, you can verify if a SIP Endpoint has registered by using the Console "Registered SIP Endpoints" tab found on the SIP Domains page.',
    description:
      'Twilio was unable to dial the specified SIP Endpoint. While the user did have at least one device registered, no devices were registered through the edge location specified in the URI.',
    product: 'Programmable Voice',
    date_created: '2020-11-11T00:20:50Z',
    last_updated: '2020-12-10T06:36:26.716Z',
  },
  45761: {
    code: 45761,
    message: 'Failed to validate address configuration. Auto create not enabled.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45761\r\n\r\n### Failed to validate address configuration. Auto create not enabled.\r\n\r\n Unable to validate address configuration for provided address SID. Auto create not enabled.\r\n\r\n#### Possible Causes\r\nAddress configuration data associated with the provided address SID does not have auto create enabled in address configuration. When disabled, conversations will not be auto-created on incoming messages.  \r\n\r\n#### Possible Solutions\r\n"Ensure the address SID provided is valid and associated with the correct account.\r\n\r\nEnsure the address configuration associated with the address is correct. Read more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#fetch-an-addressconfiguration-resource)"',
    causes:
      'Address configuration data associated with the provided address SID does not have auto create enabled in address configuration. When disabled, conversations will not be auto-created on incoming messages.  ',
    solutions:
      '"Ensure the address SID provided is valid and associated with the correct account.\r\n\r\nEnsure the address configuration associated with the address is correct. Read more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#fetch-an-addressconfiguration-resource)"',
    description:
      'Unable to validate address configuration for provided address SID. Auto create not enabled.',
    product: 'Flex',
    date_created: '2022-10-03T21:10:04Z',
    last_updated: '2022-10-03T21:10:04Z',
  },
  16109: {
    code: 16109,
    message: 'Voice Recording: Cannot fetch .mp3 encrypted recording',
    log_level: 'ERROR',
    secondary_message:
      'Recording cannot be retrieved in .mp3 format when call recording encryption feature is enabled on the account.  Please request with .wav format.',
    log_type: null,
    docs: '## Error - 16109\r\n\r\n### Voice Recording: Cannot fetch .mp3 encrypted recording\r\n\r\nRecording cannot be retrieved in .mp3 format when call recording encryption feature is enabled on the account.  Please re-request with .wav format.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-02-07T20:04:51Z',
    last_updated: '2020-08-04T10:00:10.654Z',
  },
  50002: {
    code: 50002,
    message: 'Programmable Chat: Resource is being deleted',
    log_level: 'ERROR',
    secondary_message: 'The resource your request relates to is currently being deleted.',
    log_type: null,
    docs: '## Error - 50002\r\n\r\n### Programmable Chat: Resource is being deleted\r\n\r\n#### Possible Causes \r\n*  The resource your request relates to is currently being deleted.\r\n\r\n#### Possible Solutions\r\n*  Try the same request again later.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:43Z',
    last_updated: '2020-08-04T10:00:23.704Z',
  },
  21225: {
    code: 21225,
    message: 'SipAuthPassword is required when providing SipAuthUsername',
    log_level: 'WARNING',
    secondary_message: 'You must specify a SipAuthPassword if you are also using SipAuthUsername.',
    log_type: null,
    docs: '## Warning - 21225\n\n### SipAuthPassword is required when providing SipAuthUsername\n\nYou must specify a SipAuthPassword if you are also using SipAuthUsername.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:18Z',
    last_updated: '2020-08-04T10:00:25.675Z',
  },
  21455: {
    code: 21455,
    message: 'Invalid PlayUrl',
    log_level: 'ERROR',
    secondary_message: 'PlayUrl must be a valid URL using the HTTP or HTTPS protocol.',
    log_type: null,
    docs: "## Error - 21455 \n\n### Invalid PlayUrl\n\nThe URL given to play during validation isn't a valid URL.\n\n#### Possible Causes \n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:01Z',
    last_updated: '2020-08-04T10:00:26.852Z',
  },
  30005: {
    code: 30005,
    message: 'Unknown destination handset',
    log_level: 'ERROR',
    secondary_message:
      'The destination number you are trying to reach is unknown and may no longer exist.',
    log_type: 'CARRIER',
    docs: "## ERROR - 30005\r\n\r\n### Unknown destination handset\r\n\r\nThe destination number you are trying to reach is unknown and may no longer exist. ## Error - 30005\r\n\r\n## Message Delivery - Unknown destination handset\r\n\r\n\r\n\r\n#### Possible Causes\r\n*  The destination number you are trying to reach is unknown and may no longer exist.\r\n*  The device you are trying to reach is not on or does not have sufficient signal.\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline)\r\n*  There is an issue with the mobile carrier\r\n\r\n#### Possible Solutions\r\nThe first step to troubleshooting this issue is to attempt to replicate the problems. Attempt to send another test message to this user via a REST API request, or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nPay close attention to your request and double check to verify you are attempting to send messages to the correct phone number in the correct [E.164](https://www.twilio.com/docs/glossary/what-e164) format: `[+] [country code] [subscriber number including area code]` \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not power the device off, wait 30 seconds, and then power it back up.\r\n*  Is the device connected to the home carrier's network? We cannot guarantee message delivery on devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (non-Alphanumeric Sender ID), or with a shorter one-segment (non-concatenated) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\n#### Continued issues with Error 30005\r\nTwilio's Support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with `Error 30005`, and [open a support request](https://www.twilio.com/console/support/tickets/create).",
    causes:
      '*  The destination number you are trying to reach is unknown and may no longer exist.\r\n*  The device you are trying to reach is not on or does not have sufficient signal.\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline)\r\n*  There is an issue with the mobile carrier',
    solutions:
      "The first step to troubleshooting this issue is to attempt to replicate the problems. Attempt to send another test message to this user via a REST API request, or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nPay close attention to your request and double check to verify you are attempting to send messages to the correct phone number in the correct [E.164](https://www.twilio.com/docs/glossary/what-e164) format: `[+] [country code] [subscriber number including area code]` \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not power the device off, wait 30 seconds, and then power it back up.\r\n*  Is the device connected to the home carrier's network? We cannot guarantee message delivery on devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (non-Alphanumeric Sender ID), or with a shorter one-segment (non-concatenated) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\n#### Continued issues with Error 30005\r\nTwilio's Support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with `Error 30005`, and [open a support request](https://www.twilio.com/console/support/tickets/create).",
    description:
      '## Error - 30005\r\n\r\n## Message Delivery - Unknown destination handset\r\n\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:34Z',
    last_updated: '2023-09-14T23:50:08.371489Z',
  },
  94101: {
    code: 94101,
    message: 'Transcriptions: status callback response timed out',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 94101\r\n\r\n### Transcriptions: status callback response timed out\r\n\r\n Twilio attempted to send a transcription event to the callback URL specified and your application didn’t respond before time out\r\n\r\n#### Possible Causes\r\n* The server receiving status callbacks sent by Twilio takes too long to respond\r\n\r\n#### Possible Solutions\r\n* Ensure that your callback server can handle the request and responds within a reasonable time',
    causes: '* The server receiving status callbacks sent by Twilio takes too long to respond',
    solutions:
      '* Ensure that your callback server can handle the request and responds within a reasonable time',
    description:
      'Twilio attempted to send a transcription event to the callback URL specified and your application didn’t respond before time out',
    product: null,
    date_created: '2021-08-31T11:17:33Z',
    last_updated: '2021-08-31T11:17:33Z',
  },
  50308: {
    code: 50308,
    message: 'Programmable Chat: Invalid Date Created parameter',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correctly formatted parameter for Date Created',
    log_type: null,
    docs: '## Error - 50308\r\n\r\n### Programmable Chat: Invalid Date Created parameter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for Date Created.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Date Created parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T11:57:14Z',
    last_updated: '2020-08-04T10:00:16.643Z',
  },
  31900: {
    code: 31900,
    message: 'Stream - Unknown Error',
    log_level: 'ERROR',
    secondary_message: 'This stream has failed due to an unknown cause',
    log_type: 'TWILIO',
    docs: '## ERROR - 31900\r\n\r\n### Stream - Unknown Error\r\n\r\nThis stream has failed due to an unknown cause \r\n\r\n#### Possible Causes\r\nUnknown\r\n\r\n#### Possible Solutions\r\nUnknown',
    causes: 'Unknown',
    solutions: 'Unknown',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:52:27Z',
    last_updated: '2020-08-04T10:00:07.464Z',
  },
  13235: {
    code: 13235,
    message: 'Dial->Conference: Invalid beep value',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Warning - 13235\n\n### Dial->Conference: Invalid beep value\n\nbeep must be either "true" or false".\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:37Z',
    last_updated: '2020-08-04T10:00:28.396Z',
  },
  51128: {
    code: 51128,
    message: 'Twilsock: Too many messages per connection',
    log_level: 'ERROR',
    secondary_message: 'Number of messages for one connection is higher than expected!',
    log_type: null,
    docs: "## Error - 51128\r\n\r\n### Too many messages per connection\r\n\r\n#### Possible Causes \r\nNumber of messages for one connection is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:30:16Z',
    last_updated: '2020-08-04T10:00:09.4Z',
  },
  32400: {
    code: 32400,
    message: 'BYOC Trunk routing failure - failover routing disabled.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32400\r\n\r\n### BYOC Trunk routing failure - failover routing disabled.\r\n\r\n Call delivery attempt(s) over the specified BYOC Trunk did not succeed. Failover routing was disabled.\r\n\r\n#### Possible Causes\r\nTwilio encountered errors communicating with your SIP communications infrastructure.\r\n\r\n#### Possible Solutions\r\nLook for errors with error code [32011](/docs/api/errors/32011), Error communicating with your SIP communications infrastructure, and follow instructions.',
    causes: 'Twilio encountered errors communicating with your SIP communications infrastructure.',
    solutions:
      'Look for errors with error code [32011](/docs/api/errors/32011), Error communicating with your SIP communications infrastructure, and follow instructions.',
    description:
      'Call delivery attempt(s) over the specified BYOC Trunk did not succeed. Failover routing was disabled.',
    product: 'Programmable Voice',
    date_created: '2020-03-16T21:29:32Z',
    last_updated: '2020-08-04T10:00:04.227Z',
  },
  13236: {
    code: 13236,
    message: 'Dial->Conference: Invalid Conference Sid',
    log_level: 'WARNING',
    secondary_message: 'placeholder',
    log_type: null,
    docs: '## Error - 13236\n\n### Dial->Conference: Invalid Conference Sid value\n\nYou attempted to dial a Conference Sid that does not exist or has already been completed. \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:37Z',
    last_updated: '2020-08-04T10:00:28.373Z',
  },
  16107: {
    code: 16107,
    message: 'Voice Recording: Encrypted with alternate public key',
    log_level: 'ERROR',
    secondary_message:
      'Recording was encrypted with alternate public key because the one configured on the account is invalid or deleted. (only applicable if call recording encryption feature enabled)',
    log_type: null,
    docs: '## Error - 16107\r\n\r\n### Voice Recording: Encrypted with alternate public key\r\n\r\nRecording was encrypted with alternate public key because the one configured on the account is invalid or deleted. (only applicable if call recording encryption feature enabled)',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-08-25T22:30:45Z',
    last_updated: '2020-08-04T10:00:17.85Z',
  },
  53631: {
    code: 53631,
    message: 'Failed to enqueue a room composition from a configured composition hook',
    log_level: 'WARNING',
    secondary_message: 'The group room will not be composed',
    log_type: null,
    docs: '## Warning -  53631\r\n\r\n### Failed to enqueue a room composition from a configured composition hook\r\n\r\nThere was a failure creating or enqueuing a composition for a completed Group Room, using the configuration from a composition hook.\r\n\r\n#### Causes\r\n\r\n * We failed to create the composition or the configuration was not suitable for a specific Group Room.\r\n\r\n#### Solutions\r\n\r\n* Verify the composition hook configured in your account\'s console.\r\n\r\n* The composition can also be launched manually using the <a href="/docs/video/api/compositions-resource">REST API</a>.\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-09-28T16:22:30Z',
    last_updated: '2020-08-04T10:00:12.531Z',
  },
  21405: {
    code: 21405,
    message: 'Cannot set VoiceFallbackUrl without setting Url',
    log_level: 'ERROR',
    secondary_message: 'You cannot set a fallback URL without specifying a primary URL',
    log_type: null,
    docs: '## Error - 21405 \n\n### Cannot set VoiceFallbackUrl without setting Url\n\nYou cannot set a fallback URL without specifying a primary URL\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:19Z',
    last_updated: '2020-08-04T10:00:25.579Z',
  },
  30462: {
    code: 30462,
    message: 'Toll Free verification rejection - Disallowed: Sweepstakes',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30462\r\n\r\n### Toll Free verification rejection - Disallowed: Sweepstakes\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Gambling - Sweepstakes). \r\n\r\nGambling traffic is prohibited in the US and Canada on all number types (Toll Free, Short Code, Long Code). The gambling category includes, but is not limited to:\r\n \r\n* Casino apps\r\n* Websites that offer gambling\r\n* Sweepstakes\r\n* 50/50 Raffles\r\n* Contests\r\n* Betting/Sports picks\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (Gambling - Sweepstakes). \r\n\r\nGambling traffic is prohibited in the US and Canada on all number types (Toll Free, Short Code, Long Code). The gambling category includes, but is not limited to:\r\n \r\n* Casino apps\r\n* Websites that offer gambling\r\n* Sweepstakes\r\n* 50/50 Raffles\r\n* Contests\r\n* Betting/Sports picks',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:05:50Z',
    last_updated: '2024-02-22T21:05:50Z',
  },
  32010: {
    code: 32010,
    message: 'SIP: No valid Origination URIs configured',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 32010\r\n\r\n### SIP: No valid Origination URIs configured\r\n\r\n Your call can't be completed because no valid/active origination URLs could be found for your Elastic SIP Trunk or BYOC Trunk.\r\n\r\n#### Possible Causes\r\nYour Elastic SIP Trunk or BYOC Trunk does not have any valid active origination URLs\r\n\r\n#### Possible Solutions\r\nPlease verify your Origination settings of your [Elastic SIP Trunk](/docs/sip-trunking#origination) or [BYOC Trunk](/docs/voice/bring-your-own-carrier-byoc#origination-connection-policy-settings).",
    causes: 'Your Elastic SIP Trunk or BYOC Trunk does not have any valid active origination URLs',
    solutions:
      'Please verify your Origination settings of your [Elastic SIP Trunk](/docs/sip-trunking#origination) or [BYOC Trunk](/docs/voice/bring-your-own-carrier-byoc#origination-connection-policy-settings).',
    description:
      "Your call can't be completed because no valid/active origination URLs could be found for your Elastic SIP Trunk or BYOC Trunk.",
    product: 'Elastic SIP Trunking',
    date_created: '2016-11-16T21:56:25Z',
    last_updated: '2023-08-01T13:14:40.313232Z',
  },
  95109: {
    code: 95109,
    message: 'Media content is empty',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95109\r\n\r\n### Media content is empty\r\n\r\n Failed to download, media content is empty.\r\n\r\n#### Possible Causes\r\nMedia content is empty. Media duration is less than 2 seconds.\r\n\r\n#### Possible Solutions\r\nVerify the media is not empty',
    causes: 'Media content is empty. Media duration is less than 2 seconds.',
    solutions: 'Verify the media is not empty',
    description: 'Failed to download, media content is empty.',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:34:27Z',
    last_updated: '2024-04-16T17:34:27Z',
  },
  95250: {
    code: 95250,
    message: 'AI/ML Features Addendum has not been accepted',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 95250\r\n\r\n### AI/ML Features Addendum has not been accepted\r\n\r\n [The Predictive and Generative AI/ML Features Addendum](https://www.twilio.com/en-us/legal/ai-terms/predictive-generative-ai-features) has to be accepted.\r\n\r\n#### Possible Causes\r\nThe Predictive and Generative AI/ML Features Addendum has not been accepted yet.\r\n\r\n#### Possible Solutions\r\nAccept the Predictive and Generative AI/ML Features Addendum on the [Voice Settings](https://console.twilio.com/us1/develop/voice/settings/general?frameUrl=%2Fconsole%2Fvoice%2Fsettings%3Fx-target-region%3Dus1) on Twilio Console.',
    causes: 'The Predictive and Generative AI/ML Features Addendum has not been accepted yet.',
    solutions:
      'Accept the Predictive and Generative AI/ML Features Addendum on the [Voice Settings](https://console.twilio.com/us1/develop/voice/settings/general?frameUrl=%2Fconsole%2Fvoice%2Fsettings%3Fx-target-region%3Dus1) on Twilio Console.',
    description:
      '[The Predictive and Generative AI/ML Features Addendum](https://www.twilio.com/en-us/legal/ai-terms/predictive-generative-ai-features) has to be accepted.',
    product: 'Voice Intelligence',
    date_created: '2024-06-17T08:08:00Z',
    last_updated: '2024-06-17T08:08:00Z',
  },
  30110: {
    code: 30110,
    message: 'Domain is blocked',
    log_level: 'ERROR',
    secondary_message: 'The provided URL to resolve this link to is on a blocked domain.',
    log_type: 'TWILIO',
    docs: '## ERROR - 30110\r\n\r\n### Domain is blocked\r\n\r\nThe provided URL to resolve this link to is on a blocked domain. The provided URL to resolve the link is on a blocked domain.\r\n\r\n#### Possible Causes\r\n- Fraudulent activity has been detected on this domain\r\n- Domain owner has requested Twilio not link to their site\r\n\r\n#### Possible Solutions\r\nPlease reach out to Twilio support',
    causes:
      '- Fraudulent activity has been detected on this domain\r\n- Domain owner has requested Twilio not link to their site',
    solutions: 'Please reach out to Twilio support',
    description: 'The provided URL to resolve the link is on a blocked domain.',
    product: 'Programmable SMS',
    date_created: '2020-05-05T19:14:34Z',
    last_updated: '2020-08-04T10:00:03.494Z',
  },
  31403: {
    code: 31403,
    message: 'Forbidden',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31403\r\n\r\n### Forbidden\r\n\r\nThe server understood the request, but is refusing to fulfill it.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:12:20Z',
    last_updated: '2020-08-04T10:00:08.5Z',
  },
  22110: {
    code: 22110,
    message: 'Phone Number Not Hostable',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22110\r\n\r\n#### Phone Number Not Hostable\r\n\r\nYou attempted to host a number that is not hostable on Twilio.\r\n\r\n#### Possible Causes\r\n\r\n* The number is already hosted. \r\n\r\n* The number is owned by Twilio.\r\n\r\n* The number cannot be enabled by carrier for requested capabilities.\r\n\r\n* The number is type mobile or voip.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-01-30T03:55:10Z',
    last_updated: '2020-08-04T10:00:15.118Z',
  },
  32206: {
    code: 32206,
    message: 'SIP: Invalid From number (caller ID)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32206\r\n\r\n### SIP: Invalid From number (caller ID)\r\n\r\n You attempted to initiate an outbound phone call or message, but the \'From\' parameter you supplied was not a valid phone number or alphanumeric sender ID.\r\n\r\nTwilio accepts phone numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US and Canadian numbers with any combination of non-digit separators, or Alphanumeric Sender IDs (SMS only) with up to 11 alphanumeric characters [a-zA-Z0-9]. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\nThe number must not be on a do-not-originate (DNO) list, and Alpha Sender IDs may not be generic.\r\n\r\n#### Possible Causes\r\n* You have supplied a phone number that was not in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Your `From` phone number is on a do-not-originate (DNO) list\r\n\r\n#### Possible Solutions\r\n* Ensure your number is formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Ensure that your `From` number is assigned and not on a do-not-originate (DNO) list.',
    causes:
      '* You have supplied a phone number that was not in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Your `From` phone number is on a do-not-originate (DNO) list',
    solutions:
      '* Ensure your number is formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164)\r\n* Ensure that your `From` number is assigned and not on a do-not-originate (DNO) list.',
    description:
      'You attempted to initiate an outbound phone call or message, but the \'From\' parameter you supplied was not a valid phone number or alphanumeric sender ID.\r\n\r\nTwilio accepts phone numbers in [E.164 format](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US and Canadian numbers with any combination of non-digit separators, or Alphanumeric Sender IDs (SMS only) with up to 11 alphanumeric characters [a-zA-Z0-9]. Refer to [this page](https://support.twilio.com/hc/en-us/articles/223133867-Using-Alphanumeric-Sender-ID-with-Messaging-Services) for acceptable characters.\r\n\r\nThe number must not be on a do-not-originate (DNO) list, and Alpha Sender IDs may not be generic.',
    product: 'Elastic SIP Trunking',
    date_created: '2019-09-05T21:45:40Z',
    last_updated: '2023-10-23T16:22:29.158124Z',
  },
  14109: {
    code: 14109,
    message: 'TwiML Reply message limit exceeded',
    log_level: 'WARNING',
    secondary_message:
      'Too many messages have been sent in reply to an incoming message. The current is 10',
    log_type: 'APPLICATION',
    docs: '## WARNING - 14109\r\n\r\n### TwiML Reply message limit exceeded\r\n\r\nToo many messages have been sent in reply to an incoming message. The current is 10 ## Warning - 14109 \r\n\r\n### TwiML Reply message limit exceeded\r\n\r\nToo many TwiML reply messages have been sent in response to a single incoming message. You can send a maximum of 10 TwiML replies per incoming message.\r\n\r\n#### Possible Causes\r\n* A runaway loop or other error in your application generated more than 10 TwiML replies to a single incoming message\r\n* You have attempted to send >10 TwiML replies to a single incoming message\r\n\r\n#### Possible Solutions\r\n* If you need to generate >10 outbound messages for one incoming message, please use new API requests to create these messages.',
    causes:
      '* A runaway loop or other error in your application generated more than 10 TwiML replies to a single incoming message\r\n* You have attempted to send >10 TwiML replies to a single incoming message',
    solutions:
      '* If you need to generate >10 outbound messages for one incoming message, please use new API requests to create these messages.',
    description:
      '## Warning - 14109 \r\n\r\n### TwiML Reply message limit exceeded\r\n\r\nToo many TwiML reply messages have been sent in response to a single incoming message. You can send a maximum of 10 TwiML replies per incoming message.',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:13:50Z',
    last_updated: '2021-02-16T22:55:46.9Z',
  },
  70002: {
    code: 70002,
    message: 'Bad request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70002\r\n\r\n### Bad request\r\nThe data in the request is unparsable.\r\n\r\n#### Possible Causes \r\n* When sending a string field “abc” when an intValue is expected\r\n* When sending invalid JSON in the request body',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:35:35Z',
    last_updated: '2020-08-04T10:00:19.925Z',
  },
  48002: {
    code: 48002,
    message: 'Callback URL is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 48002\r\n\r\n### Callback URL is invalid\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Callback URL provided is invalid.\r\n\r\n#### Possible Solutions\r\nMake sure that you provided a valid Callback URL.',
    causes: 'The Callback URL provided is invalid.',
    solutions: 'Make sure that you provided a valid Callback URL.',
    description: null,
    product: 'Frontline',
    date_created: '2021-09-24T08:06:20Z',
    last_updated: '2021-09-24T08:06:20Z',
  },
  45765: {
    code: 45765,
    message: 'Address configuration data not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45765\r\n\r\n### Address configuration data not found\r\n\r\n No address configuration data found for provided address SID. \r\n\r\n#### Possible Causes\r\nNo address configuration has been created for the provided address SID.\r\n\r\nThe address SID provided is incorrect.\r\n\r\n#### Possible Solutions\r\n"Ensure the provided address SID is correct and that the asscoiated address configuration has been created. \r\n\r\nRead more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#create-an-addressconfiguration-resource)"',
    causes:
      'No address configuration has been created for the provided address SID.\r\n\r\nThe address SID provided is incorrect.',
    solutions:
      '"Ensure the provided address SID is correct and that the asscoiated address configuration has been created. \r\n\r\nRead more about creating and updating an address configuration resource [here.](https://www.twilio.com/docs/conversations/api/address-configuration-resource#create-an-addressconfiguration-resource)"',
    description: 'No address configuration data found for provided address SID. ',
    product: 'Flex',
    date_created: '2022-10-04T16:07:38Z',
    last_updated: '2022-10-04T16:07:38Z',
  },
  80616: {
    code: 80616,
    message: 'Unsupported Identifier Type For Session Mode',
    log_level: 'ERROR',
    secondary_message:
      'Cannot add <Identifier> to session <SessionSid>. The identifier is not compatible with the session mode.',
    log_type: null,
    docs: '## Error\r\n\r\n### Unsupported Identifier Type For Session Mode\r\n\r\nCannot add <Identifier> to session <SessionSid>. The identifier is not compatible with the session mode.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-08-28T02:35:15Z',
    last_updated: '2020-08-04T10:00:12.784Z',
  },
  81001: {
    code: 81001,
    message: 'The Widget has exceeded max steps in a loop',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Warning - 81001\r\n\r\n### Widget has exceeded max steps in a loop\r\nThis limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.\r\n\r\n#### Possible Causes\r\n* You have a single widget looping back on itself too many times.\r\n\r\n#### Possible Solutions\r\n* Remove the single widget loop.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:14:02Z',
    last_updated: '2020-08-04T10:00:13.306Z',
  },
  45789: {
    code: 45789,
    message: 'Deployment key is already linked to other address  configuration sid.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45789\r\n\r\n### Deployment key is already linked to other address  configuration sid.\r\n\r\n Deployment key is already linked to another address  configuration Sid.\r\n\r\n#### Possible Causes\r\nYou cannot link deployment key to multiple address configuration Sids.\r\n\r\n#### Possible Solutions\r\nFirst unlink the deployment key from current address configuration Sid.',
    causes: 'You cannot link deployment key to multiple address configuration Sids.',
    solutions: 'First unlink the deployment key from current address configuration Sid.',
    description: 'Deployment key is already linked to another address  configuration Sid.',
    product: 'Flex',
    date_created: '2023-11-23T04:22:19Z',
    last_updated: '2023-11-23T04:22:19Z',
  },
  21260: {
    code: 21260,
    message: 'Maximum number of actions per rule reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21260\r\n\r\n### Maximum number of actions per rule reached\r\n\r\n This rule already has the maximum number of actions allowed.\r\n\r\n#### Possible Causes\r\nThe number of actions in a given rule cannot exceed the limit. See https://www.twilio.com/docs/sip-trunking/sip-header-manipulation \r\n\r\n#### Possible Solutions\r\nOptimize your rule by removing unused actions.',
    causes:
      'The number of actions in a given rule cannot exceed the limit. See https://www.twilio.com/docs/sip-trunking/sip-header-manipulation ',
    solutions: 'Optimize your rule by removing unused actions.',
    description: 'This rule already has the maximum number of actions allowed.',
    product: 'Elastic SIP Trunking',
    date_created: '2021-09-16T19:35:05Z',
    last_updated: '2021-10-12T19:02:45.437022Z',
  },
  68004: {
    code: 68004,
    message: 'Input Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 68004\r\n\r\n### Input Error\r\n\r\n An error occurred while loading input.\r\n\r\n#### Possible Causes\r\nSome inputs are invalid.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry.',
    causes: 'Some inputs are invalid.',
    solutions: 'Check parameters and retry.',
    description: 'An error occurred while loading input.',
    product: 'Verify',
    date_created: '2020-09-15T18:13:46Z',
    last_updated: '2020-09-15T18:13:46Z',
  },
  32223: {
    code: 32223,
    message: 'There is no username in the SIP URI when calling a SIP registered endpoint',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32223\r\n\r\n### There is no username in the SIP URI when calling a SIP registered endpoint\r\n\r\n Calling Twilio SIP domains such as "yourdomain.sip.twilio.com" is not allowed. You can only call a registered SIP endpoint such as "username@yourdomain.sip.twilio.com".\r\n\r\n#### Possible Causes\r\n* Attempting to place a call from Twilio back to your own Twilio SIP domain. Twilio does not allow SIP calls between Twilio domains either in the same account or different accounts.\r\n* Attempting to call a registered SIP AOR without specifying the username you wanted to call\r\n\r\n#### Possible Solutions\r\n* Add the correct username in the SIP URI you call, e.g., username@yourdomain.sip.twilio.com',
    causes:
      '* Attempting to place a call from Twilio back to your own Twilio SIP domain. Twilio does not allow SIP calls between Twilio domains either in the same account or different accounts.\r\n* Attempting to call a registered SIP AOR without specifying the username you wanted to call',
    solutions:
      '* Add the correct username in the SIP URI you call, e.g., username@yourdomain.sip.twilio.com',
    description:
      'Calling Twilio SIP domains such as "yourdomain.sip.twilio.com" is not allowed. You can only call a registered SIP endpoint such as "username@yourdomain.sip.twilio.com".',
    product: 'Programmable Voice',
    date_created: '2022-05-16T23:51:31Z',
    last_updated: '2022-05-17T04:42:26.966177Z',
  },
  13513: {
    code: 13513,
    message: 'Say: Invalid rate value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13513\r\n\r\n### Say: Invalid rate value\r\n\r\n Say rate value is invalid.  The function will use a default rate value of 150.\r\n\r\n#### Possible Causes\r\nSay rate value is invalid.\r\n\r\n#### Possible Solutions\r\nChange Say rate value.',
    causes: 'Say rate value is invalid.',
    solutions: 'Change Say rate value.',
    description: 'Say rate value is invalid.  The function will use a default rate value of 150.',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:49:26Z',
    last_updated: '2020-08-04T10:00:04.371Z',
  },
  32600: {
    code: 32600,
    message: 'Virtual Agent: Configuration Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32600\r\n\r\n### Virtual Agent: Configuration Error\r\n\r\n A 32600 Error is an indication there is something wrong with the &lt;VirtualAgent&gt; connector configuration.\r\n\r\n#### Possible Causes\r\n* Connector configuration is missing required properties\r\n* Connector configuration contains invalid properties\r\n\r\n#### Possible Solutions\r\n* Update your &lt;VirtualAgent&gt; connector configuration',
    causes:
      '* Connector configuration is missing required properties\r\n* Connector configuration contains invalid properties',
    solutions: '* Update your &lt;VirtualAgent&gt; connector configuration',
    description:
      'A 32600 Error is an indication there is something wrong with the &lt;VirtualAgent&gt; connector configuration.',
    product: 'Programmable Voice',
    date_created: '2022-08-04T01:20:39Z',
    last_updated: '2022-08-04T01:20:39Z',
  },
  33121: {
    code: 33121,
    message: 'Invalid Parameter Combination',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 33121\r\n\r\n### Invalid Parameter Combination\r\n\r\n Raised whenever a request contains conflicting parameters.\r\n\r\n\r\n#### Possible Causes\r\n * While updating your SIM, the request was rejected because you cannot update `Status` and `ResetStatus` simultaneously.\r\n * Updating a SIM's status to `suspended` and removing its Rate Plan is not permitted.\r\n\r\n\r\n#### Possible Solutions\r\n * While updating a SIM, ensure not to update `Status` and `ResetStatus` within the same request.\r\n * While updating a SIM, you cannot simultaneously update its `Status` to `suspended` and remove its Rate Plan.\r\n",
    causes:
      " * While updating your SIM, the request was rejected because you cannot update `Status` and `ResetStatus` simultaneously.\r\n * Updating a SIM's status to `suspended` and removing its Rate Plan is not permitted.\r\n",
    solutions:
      ' * While updating a SIM, ensure not to update `Status` and `ResetStatus` within the same request.\r\n * While updating a SIM, you cannot simultaneously update its `Status` to `suspended` and remove its Rate Plan.\r\n',
    description: 'Raised whenever a request contains conflicting parameters.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:24:41Z',
    last_updated: '2020-09-15T11:24:41Z',
  },
  48026: {
    code: 48026,
    message: 'Outgoing conversation: Invalid proxy address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48026\r\n\r\n### Outgoing conversation: Invalid proxy address\r\n\r\n A conversation could not be created because the provided Twilio proxy address for the Frontline user was invalid.\r\n\r\n#### Possible Causes\r\n* The outgoing conversation callback returned an invalid Twilio proxy number or no number at all.\r\n\r\n#### Possible Solutions\r\n* Make sure that the `proxy_address` value returned from the Outgoing Conversation callback is present and properly formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164), including any channel prefixes if relevant.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/outgoing-conversations) on how to create outgoing conversations.',
    causes:
      '* The outgoing conversation callback returned an invalid Twilio proxy number or no number at all.',
    solutions:
      '* Make sure that the `proxy_address` value returned from the Outgoing Conversation callback is present and properly formatted in [E.164 format](https://www.twilio.com/docs/glossary/what-e164), including any channel prefixes if relevant.\r\n    * Check out the [docs](https://www.twilio.com/docs/frontline/outgoing-conversations) on how to create outgoing conversations.',
    description:
      'A conversation could not be created because the provided Twilio proxy address for the Frontline user was invalid.',
    product: 'Frontline',
    date_created: '2022-04-20T15:51:50Z',
    last_updated: '2022-04-20T15:51:50Z',
  },
  50103: {
    code: 50103,
    message: 'Programmable Chat: Role SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Role SID parameter.',
    log_type: null,
    docs: '## Error - 50103\r\n\r\n### Programmable Chat: Role SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Role SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:47Z',
    last_updated: '2020-08-04T10:00:23.437Z',
  },
  31931: {
    code: 31931,
    message: 'Stream - Media - Media Discarded',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 31931\r\n\r\n### Stream - Media - Media Discarded\r\n\r\n Audio discarded due to buffer overflow in the Websocket downstream .\r\nNOTE: This error is sent once per stream\r\n\r\n#### Possible Causes\r\n* More than 10 minutes of audio is buffered by the Streamer. No more data is accepted.\r\n\r\n#### Possible Solutions\r\n* Wait until previous media has been processed before to send more media.',
    causes:
      '* More than 10 minutes of audio is buffered by the Streamer. No more data is accepted.',
    solutions: '* Wait until previous media has been processed before to send more media.',
    description:
      'Audio discarded due to buffer overflow in the Websocket downstream .\r\nNOTE: This error is sent once per stream',
    product: 'Programmable Voice',
    date_created: '2020-07-09T08:10:55Z',
    last_updated: '2020-08-04T10:00:02.219Z',
  },
  21223: {
    code: 21223,
    message: 'Invalid SipAuthPassword. Must be fewer than 256 chars',
    log_level: 'WARNING',
    secondary_message: 'The SipAuthPassword you specified contained too many characters.',
    log_type: null,
    docs: '## Warning - 21223\n\n### Invalid SipAuthPassword. Must be fewer than 256 chars\n\nThe SipAuthPassword you specified contained too many characters.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:17Z',
    last_updated: '2020-08-04T10:00:25.713Z',
  },
  35114: {
    code: 35114,
    message: 'Scheduling does not support this timestamp',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35114\r\n\r\n### Scheduling does not support this timestamp\r\n\r\n SendAt time must be between 900 seconds and 35 days (3024000 seconds) in the future, inclusive.\r\n\r\n#### Possible Causes\r\nScheduler currently doesn\'t support scheduling a message at a fixed time less that 15 minutes from now, or more than 35 days in the future. *Scheduling up to 35 days before is available in Pilot with limited access.\r\n\r\n#### Possible Solutions\r\nVerify that the SendAt parameter is using "[YYYY]-[MM]-[DD]T[HH]:[MM]:[SS]Z" format (in UTC). \r\n\r\nCheck the SendAt parameter to ensure it is is greater than 15 minutes (900 seconds) from request time and 35 days (3024000 seconds) in the future.',
    causes:
      "Scheduler currently doesn't support scheduling a message at a fixed time less that 15 minutes from now, or more than 35 days in the future. *Scheduling up to 35 days before is available in Pilot with limited access.",
    solutions:
      'Verify that the SendAt parameter is using "[YYYY]-[MM]-[DD]T[HH]:[MM]:[SS]Z" format (in UTC). \r\n\r\nCheck the SendAt parameter to ensure it is is greater than 15 minutes (900 seconds) from request time and 35 days (3024000 seconds) in the future.',
    description:
      'SendAt time must be between 900 seconds and 35 days (3024000 seconds) in the future, inclusive.',
    product: 'Programmable SMS',
    date_created: '2020-10-07T18:38:38Z',
    last_updated: '2023-12-05T22:57:33.319526Z',
  },
  45303: {
    code: 45303,
    message: 'Participant was busy',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45303\r\n\r\n### Participant was busy\r\n\r\n User was busy and could not connect to media\r\n\r\n#### Possible Causes\r\nUser was already engaged on the media channel\r\n\r\n#### Possible Solutions\r\nDisconnect media and retry.',
    causes: 'User was already engaged on the media channel',
    solutions: 'Disconnect media and retry.',
    description: 'User was busy and could not connect to media',
    product: 'Flex',
    date_created: '2020-01-14T21:12:48Z',
    last_updated: '2020-08-04T10:00:05.333Z',
  },
  60391: {
    code: 60391,
    message: 'Challenge not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60391\r\n\r\n### Challenge not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe requested Challenge is missing\r\n\r\n#### Possible Solutions\r\nCheck that the Challenge in the request parameter/body is correct.',
    causes: 'The requested Challenge is missing',
    solutions: 'Check that the Challenge in the request parameter/body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T10:01:33Z',
    last_updated: '2023-12-27T10:01:33Z',
  },
  60717: {
    code: 60717,
    message: 'Error uploading logo to the storage',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60717\r\n\r\n### Error uploading logo to the storage\r\n\r\n The file sent for the brand logo image could not be stored in the storage bucket\r\n\r\n#### Possible Causes\r\nIt may be caused by a temporal communication issue with the storage bucket.\r\n\r\n#### Possible Solutions\r\nTry again later',
    causes: 'It may be caused by a temporal communication issue with the storage bucket.',
    solutions: 'Try again later',
    description: 'The file sent for the brand logo image could not be stored in the storage bucket',
    product: 'Branded Comms',
    date_created: '2020-01-24T18:55:34Z',
    last_updated: '2020-08-04T10:00:04.875Z',
  },
  68003: {
    code: 68003,
    message: 'Storage Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 68003\r\n\r\n### Storage Error\r\n\r\n An error occurred while storing/loading an entity.\r\n\r\n#### Possible Causes\r\n* Storage may be corrupted.\r\n* Factor not found.\r\n\r\n#### Possible Solutions\r\nCreate a new factor.',
    causes: '* Storage may be corrupted.\r\n* Factor not found.',
    solutions: 'Create a new factor.',
    description: 'An error occurred while storing/loading an entity.',
    product: 'Verify',
    date_created: '2020-09-15T18:12:57Z',
    last_updated: '2020-09-15T18:12:57Z',
  },
  50504: {
    code: 50504,
    message: 'Programmable Chat: Message body parameter is too long',
    log_level: 'ERROR',
    secondary_message: 'Message body parameter is too long',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50504\r\n\r\n### Programmable Chat: Message body parameter is too long\r\n\r\nMessage body parameter is too long ## Error - 50504\r\n\r\n### Programmable Chat: Message body parameter is too long\r\n\r\n#### Possible Causes\r\nMessage body parameter is too long. Visit the [Chat Limits](https://www.twilio.com/docs/chat/chat-limits) documentation to learn more about the maximum message length. \r\n\r\n#### Possible Solutions\r\nConfirm a valid length Message body is being passed in the request. Additionally, consider intercepting messages with [Event Webhooks](https://www.twilio.com/docs/chat/webhook-events#webhook-bodies-pre-event) to validate or reject messages.',
    causes:
      'Message body parameter is too long. Visit the [Chat Limits](https://www.twilio.com/docs/chat/chat-limits) documentation to learn more about the maximum message length. ',
    solutions:
      'Confirm a valid length Message body is being passed in the request. Additionally, consider intercepting messages with [Event Webhooks](https://www.twilio.com/docs/chat/webhook-events#webhook-bodies-pre-event) to validate or reject messages.',
    description:
      '## Error - 50504\r\n\r\n### Programmable Chat: Message body parameter is too long',
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:23:50Z',
    last_updated: '2021-07-07T08:13:38.089769Z',
  },
  21900: {
    code: 21900,
    message: 'DltPEId is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21900\r\n\r\n### DltPEId is invalid\r\n\r\n DltPEId is invalid\r\n\r\n#### Possible Causes\r\nThe format or size of DltPEId is invalid\r\n\r\n#### Possible Solutions\r\nUse correct DltPEId',
    causes: 'The format or size of DltPEId is invalid',
    solutions: 'Use correct DltPEId',
    description: 'DltPEId is invalid',
    product: null,
    date_created: '2020-12-11T08:18:46Z',
    last_updated: '2020-12-11T08:18:46Z',
  },
  45304: {
    code: 45304,
    message: 'Internal timeout error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45304\r\n\r\n### Internal timeout error\r\n\r\n Internal timeout error\r\n\r\n#### Possible Causes\r\nFlex encountered a timeout error\r\n\r\n#### Possible Solutions\r\nRetry operation.',
    causes: 'Flex encountered a timeout error',
    solutions: 'Retry operation.',
    description: 'Internal timeout error',
    product: 'Flex',
    date_created: '2020-01-14T21:13:41Z',
    last_updated: '2020-08-04T10:00:05.314Z',
  },
  63024: {
    code: 63024,
    message: 'Invalid message recipient',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63024\r\n\r\n### Invalid message recipient\r\n\r\n For WhatsApp, the message is undeliverable due to the recipient being an invalid user on WhatsApp or other Meta restrictions for WhatsApp.\r\n\r\n#### Possible Causes\r\nFor WhatsApp, reasons can include:\r\n\r\n* Recipient phone number is not a WhatsApp phone number.\r\n* Recipient has not accepted WhatsApp's new Terms of Service and Privacy Policy.\r\n* Recipient is using an old, unsupported version of the WhatsApp client for their phone.\r\n* Meta blocked the delivery of Authentication template messages to the recipient. Meta does not support the Authentication use case for WhatsApp users registered with India (+91) phone numbers.\r\n* Meta blocked the delivery of Marketing template messages to the recipient. Meta imposes an unspecified limit to how many marketing messages WhatsApp users registered with India (+91) phone numbers can receive at a given time. This limit is based on the number of marketing conversations opened with a user from any business, and is not related to the interactions between the user and your business.\r\n\r\n#### Possible Solutions\r\n* Confirm with the recipient that they have accepted Meta's latest Terms of Service for WhatsApp. If they have not, then send them this link https://wa.me/tos/20210210 to accept the latest WhatsApp Terms of Service.\r\n* Confirm with the recipient that they have an active WhatsApp phone number on the latest client version for their phone.",
    causes:
      "For WhatsApp, reasons can include:\r\n\r\n* Recipient phone number is not a WhatsApp phone number.\r\n* Recipient has not accepted WhatsApp's new Terms of Service and Privacy Policy.\r\n* Recipient is using an old, unsupported version of the WhatsApp client for their phone.\r\n* Meta blocked the delivery of Authentication template messages to the recipient. Meta does not support the Authentication use case for WhatsApp users registered with India (+91) phone numbers.\r\n* Meta blocked the delivery of Marketing template messages to the recipient. Meta imposes an unspecified limit to how many marketing messages WhatsApp users registered with India (+91) phone numbers can receive at a given time. This limit is based on the number of marketing conversations opened with a user from any business, and is not related to the interactions between the user and your business.",
    solutions:
      "* Confirm with the recipient that they have accepted Meta's latest Terms of Service for WhatsApp. If they have not, then send them this link https://wa.me/tos/20210210 to accept the latest WhatsApp Terms of Service.\r\n* Confirm with the recipient that they have an active WhatsApp phone number on the latest client version for their phone.",
    description:
      'For WhatsApp, the message is undeliverable due to the recipient being an invalid user on WhatsApp or other Meta restrictions for WhatsApp.',
    product: 'Programmable Messaging',
    date_created: '2019-02-25T19:31:58Z',
    last_updated: '2024-04-05T00:58:51.363381Z',
  },
  15003: {
    code: 15003,
    message: 'Call Progress: Warning Response to Callback URL',
    log_level: 'WARNING',
    secondary_message: 'Got an HTTP warning in response to the callback URL.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 15003\r\n\r\n### Call Progress: Warning Response to Callback URL\r\n\r\nGot an HTTP warning in response to the callback URL. \r\n\r\n#### Possible Causes\r\n*  Your application returned a 4xx or 5xx HTTP response to Twilio.\r\n\r\n#### Possible Solutions\r\nEnsure your application responds to callbacks with: \r\n\r\n*  200 OK  \r\n*  Content-Type: text/xml \r\n*  Valid TwiML\r\n\r\nOr respond with 204 No Content and an empty response body.',
    causes: '*  Your application returned a 4xx or 5xx HTTP response to Twilio.',
    solutions:
      'Ensure your application responds to callbacks with: \r\n\r\n*  200 OK  \r\n*  Content-Type: text/xml \r\n*  Valid TwiML\r\n\r\nOr respond with 204 No Content and an empty response body.',
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:14Z',
    last_updated: '2020-08-04T10:00:25.987Z',
  },
  40113: {
    code: 40113,
    message: 'TaskRouter->Call',
    log_level: 'ERROR',
    secondary_message:
      'Call Instruction encountered an error when requesting an outgoing call be made from the API.',
    log_type: null,
    docs: '## Error - 40113\r\n\r\n### Error Making Outgoing Call - Call Instruction\r\n\r\n#### Possible Causes \r\n*  Un-routable address provided for "to" field. \r\n*  Invalid caller-id passed to "from" field. \r\n*  Poorly formed URL passed to "url" field. \r\n*  Internal Twilio API error.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a routable phone number, client URI or SIP URI. \r\n*  Make certain "to" is to a country you have permissions set to call.\r\n*  Make certain "from" contains an acceptable caller ID for the chosen "to" address.\r\n*  Make certain "url" is a valid HTTP/HTTPS URL. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:41Z',
    last_updated: '2020-08-04T10:00:23.969Z',
  },
  19003: {
    code: 19003,
    message: 'Contact with the unique_customer_provided_id provided already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19003\r\n\r\n### Contact with the unique_customer_provided_id provided already exists\r\n\r\n unique_customer_provided_id already exists\r\n\r\n#### Possible Causes\r\nAn existing contact has the same unique_customer_provided_id value provided in the request\r\n\r\n#### Possible Solutions\r\nProvide different unique_customer_provided_id or remove the existing one',
    causes:
      'An existing contact has the same unique_customer_provided_id value provided in the request',
    solutions: 'Provide different unique_customer_provided_id or remove the existing one',
    description: 'unique_customer_provided_id already exists',
    product: null,
    date_created: '2020-07-21T18:31:31Z',
    last_updated: '2020-08-04T10:00:01.933Z',
  },
  15000: {
    code: 15000,
    message: 'Call Progress: Internal Twilio Error',
    log_level: 'ERROR',
    secondary_message:
      'An internal error has occurred that prevented Twilio from processing your Call Progress Event.',
    log_type: null,
    docs: '## Error - 15000\n\n### Call Progress: Internal Twilio Error\n\nAn internal error has occurred that prevented Twilio from processing your Call Progress Event.\n\n#### Possible Solutions\n\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\n*   Note the time of the error and what you were trying to do when it occurred!',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:13Z',
    last_updated: '2020-08-04T10:00:26.035Z',
  },
  60708: {
    code: 60708,
    message: 'Phone record number not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 60708\r\n\r\n### Phone record number not found\r\n\r\n DNS Record for that phone number not found\r\n\r\n#### Possible Causes\r\n- Our provider (Route 53) did not find the DNS record you're trying to update or delete\r\n\r\n#### Possible Solutions\r\n- Make sure the DNS record for that phone number exists in order to update or delete it",
    causes:
      "- Our provider (Route 53) did not find the DNS record you're trying to update or delete",
    solutions:
      '- Make sure the DNS record for that phone number exists in order to update or delete it',
    description: 'DNS Record for that phone number not found',
    product: 'Branded Comms',
    date_created: '2020-01-20T15:01:54Z',
    last_updated: '2020-08-04T10:00:05.07Z',
  },
  45205: {
    code: 45205,
    message: 'Requested Flex Flow is not found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45205\r\n\r\n### Requested Flex Flow is not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Flex Flow referenced in this request or related Messaging request cannot be found.\r\n\r\n#### Possible Solutions\r\nPlease ensure you have correctly configured a Flex Flow related to your Messaging Channel (e.g. sms) and Integration Type (e.g. studio). You can use the Flex API or Flex Console to do this.',
    causes:
      'The Flex Flow referenced in this request or related Messaging request cannot be found.',
    solutions:
      'Please ensure you have correctly configured a Flex Flow related to your Messaging Channel (e.g. sms) and Integration Type (e.g. studio). You can use the Flex API or Flex Console to do this.',
    description: null,
    product: 'Flex',
    date_created: '2019-09-26T11:41:41Z',
    last_updated: '2020-08-04T10:00:06.24Z',
  },
  52404: {
    code: 52404,
    message: 'Undefined variable within the notification payload template',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 52404\r\n\r\n### Undefined variable within the notification payload template\r\n\r\n The error indicates that there are one or more undefined variables in the provided template of the notification payload.\r\n\r\n#### Possible Causes\r\n1. Missing variables might have been overlooked during template creation.\r\n2. Variables could have been mistyped or not properly declared.\r\n\r\n#### Possible Solutions\r\n1. Check the debugger logs in the console to identify the exact missing variables.\r\n2. Ensure that all necessary variables are included in either or both of the per-recipient object and the default variables of the notification request.\r\n3. Double-check the spelling and syntax of variables in the template.',
    causes:
      '1. Missing variables might have been overlooked during template creation.\r\n2. Variables could have been mistyped or not properly declared.',
    solutions:
      '1. Check the debugger logs in the console to identify the exact missing variables.\r\n2. Ensure that all necessary variables are included in either or both of the per-recipient object and the default variables of the notification request.\r\n3. Double-check the spelling and syntax of variables in the template.',
    description:
      'The error indicates that there are one or more undefined variables in the provided template of the notification payload.',
    product: 'Notify',
    date_created: '2024-03-19T15:58:40Z',
    last_updated: '2024-03-19T15:58:40Z',
  },
  45363: {
    code: 45363,
    message: 'Failed to remove Participant.  Downstream error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45363\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'Conversations API returned an error',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to remove Participant <participant sid> from Conversation <conversation sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:41.59639Z',
  },
  40133: {
    code: 40133,
    message: 'TaskRouter->Dequeue',
    log_level: 'ERROR',
    secondary_message:
      'Dequeue Instruction encountered an error when requesting an outgoing call be made from the API.',
    log_type: null,
    docs: '## Error - 40133\r\n\r\n### Call API Error - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  Un-routable address provided for "to" field. \r\n*  Invalid caller-id passed to "from" field. \r\n*  Internal Twilio API error. \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a routable phone number, client URI or SIP URI. \r\n*  Make certain "to" is to a country you have permissions set to call.\r\n*  Make certain "from" contains an acceptable caller ID for the chosen "to" address.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:43Z',
    last_updated: '2020-08-04T10:00:23.745Z',
  },
  83601: {
    code: 83601,
    message: 'Request StartTime and/or EndTime must be aligned to UTC day boundaries',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83601\r\n\r\n### Request StartTime and/or EndTime must be aligned to UTC day boundaries\r\n\r\n Certain requests for Usage Records can only be made with StartTime and EndTime parameters that align to midnight UTC (e.g. "2021-07-15T00:00:00Z").\r\n\r\n#### Possible Causes\r\n  * This happens if you request Usage Records with StartTime or EndTime parameters that do not fall on a day cutoff (i.e. midnight UTC) for certain UsageRecord requests.\r\n\r\n#### Possible Solutions\r\n  * Adjust your StartTime or EndTime parameters so that they are at midnight UTC (e.g. "2021-07-15T00:00:00Z").',
    causes:
      '  * This happens if you request Usage Records with StartTime or EndTime parameters that do not fall on a day cutoff (i.e. midnight UTC) for certain UsageRecord requests.',
    solutions:
      '  * Adjust your StartTime or EndTime parameters so that they are at midnight UTC (e.g. "2021-07-15T00:00:00Z").',
    description:
      'Certain requests for Usage Records can only be made with StartTime and EndTime parameters that align to midnight UTC (e.g. "2021-07-15T00:00:00Z").',
    product: 'Super SIM',
    date_created: '2021-08-19T13:13:35Z',
    last_updated: '2021-08-19T13:42:19.617134Z',
  },
  52148: {
    code: 52148,
    message: 'Expired APNs provider token used',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52148\r\n\r\n### Expired APNs provider token used\r\n\r\n#### Possible Causes \r\n* The APNs provider token has been in the cache for too long\r\n* The APNs provider token is generated incorrectly\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-04-04T10:01:11Z',
    last_updated: '2020-08-04T10:00:14.016Z',
  },
  21240: {
    code: 21240,
    message: 'Credential List Validation Error',
    log_level: 'ERROR',
    secondary_message:
      'One of the parameters passed when creating or updating a Credential List was incorrect.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21240\r\n\r\n### Credential List Validation Error\r\n\r\nOne of the parameters passed when creating or updating a Credential List was incorrect. \r\n\r\n#### Possible Causes\r\n* A Credential List with the same FriendlyName may already exist\r\n* A Username was not provided. A Username must be provided and it must have 32 characters or less\r\n* The password was not provided. A password is required that meets the following criteria:\r\n    * Minimum 12 characters\r\n    * At least one mixed case\r\n    * At least one digit\r\n\r\n#### Possible Solutions\r\n* Ensure that your Credential List meets the validation requirements.',
    causes:
      '* A Credential List with the same FriendlyName may already exist\r\n* A Username was not provided. A Username must be provided and it must have 32 characters or less\r\n* The password was not provided. A password is required that meets the following criteria:\r\n    * Minimum 12 characters\r\n    * At least one mixed case\r\n    * At least one digit',
    solutions: '* Ensure that your Credential List meets the validation requirements.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:28:44Z',
    last_updated: '2020-08-04T10:00:00.429Z',
  },
  50530: {
    code: 50530,
    message: 'Channel Metadata not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 50530\r\n\r\n### Channel Metadata not found\r\n\r\n Channel Metadata was not found for the Message\r\n\r\n#### Possible Causes\r\n* Channel Metadata was not found for this message\r\n* Channel Metadata is only relevant for select channel types \r\n\r\n#### Possible Solutions\r\n* Confirm the channel type provides Channel Metadata.',
    causes:
      '* Channel Metadata was not found for this message\r\n* Channel Metadata is only relevant for select channel types ',
    solutions: '* Confirm the channel type provides Channel Metadata.',
    description: 'Channel Metadata was not found for the Message',
    product: 'Conversations',
    date_created: '2024-02-27T16:19:36Z',
    last_updated: '2024-02-27T16:19:36Z',
  },
  31924: {
    code: 31924,
    message: 'Stream - Websocket - Protocol Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31924\r\n\r\n### Stream - Websocket - Protocol Error\r\n\r\n Malformed message or message not conformant with WebSocket protocol\r\n\r\n#### Possible Causes\r\n* The WebSocket control frame was fragmented\r\n\r\n#### Possible Solutions\r\n* Verify the messages sent by the server',
    causes: '* The WebSocket control frame was fragmented',
    solutions: '* Verify the messages sent by the server',
    description: 'Malformed message or message not conformant with WebSocket protocol',
    product: 'Programmable Voice',
    date_created: '2021-02-18T14:33:15Z',
    last_updated: '2021-02-18T14:33:15Z',
  },
  16021: {
    code: 16021,
    message: 'Failed to join conference due to account concurrency limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16021\r\n\r\n### Failed to join conference due to account concurrency limit exceeded\r\n\r\nA conference participant could not be created, as the account is currently at or above its concurrency limit.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:19:28Z',
    last_updated: '2020-08-04T10:00:10.037Z',
  },
  31100: {
    code: 31100,
    message: 'Malformed request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31100\r\n\r\n### Malformed request\r\n\r\nThe request could not be understood due to malformed syntax.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:56:33Z',
    last_updated: '2020-08-04T10:00:11.332Z',
  },
  18037: {
    code: 18037,
    message: 'Missing information in the form',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18037\r\n\r\n### Missing information in the form\r\n\r\n One of more of the information in the forms are missing.\r\n\r\n#### Possible Causes\r\nYou may have missed sharing the required information.\r\n\r\n#### Possible Solutions\r\nPlease fill out the required form fields and resubmit the bundle.',
    causes: 'You may have missed sharing the required information.',
    solutions: 'Please fill out the required form fields and resubmit the bundle.',
    description: 'One of more of the information in the forms are missing.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:51:10Z',
    last_updated: '2024-07-04T09:51:10Z',
  },
  22172: {
    code: 22172,
    message: 'Port In Error - Contains numbers for multiple countries',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22172\r\n\r\n### Port In Error - Contains numbers for multiple countries\r\n\r\n Port in request contains numbers for multiple countries. Please resubmit with only numbers from one country.\r\n\r\n#### Possible Causes\r\nThere are phone numbers that are not part of the same country.\r\n\r\n#### Possible Solutions\r\nPlease review the list of phone numbers and resubmit with only numbers from one country.',
    causes: 'There are phone numbers that are not part of the same country.',
    solutions:
      'Please review the list of phone numbers and resubmit with only numbers from one country.',
    description:
      'Port in request contains numbers for multiple countries. Please resubmit with only numbers from one country.',
    product: 'Phone Numbers',
    date_created: '2024-05-03T17:00:10Z',
    last_updated: '2024-05-03T17:00:10Z',
  },
  21206: {
    code: 21206,
    message: 'Invalid SendDigits',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to initiate an outbound phone call, and you included a <span class='rest-attribute'>SendDigits</span> parameter that wasn't valid. <span class='rest-attribute'>SendDigits</span> is optional, and specifies that Twilio should simulate sending keypad digits when the party answers.  It is useful for navigating a phone tree, reaching an extension or entering a password in a voicemail system.  <span class='rest-attribute'>SendDigits</span> may contain numbers, the # and * characters, as well as the \"w\" character to \"wait\" for half a second.",
    log_type: null,
    docs: "## Error - 21206 \n\n### Invalid SendDigits\n\nYou attempted to initiate an outbound phone call, and you included a <span class='rest-attribute'>SendDigits</span> parameter that wasn't valid. <span class='rest-attribute'>SendDigits</span> is optional, and specifies that Twilio should simulate sending keypad digits when the party answers.  It is useful for navigating a phone tree, reaching an extension or entering a password in a voicemail system.  <span class='rest-attribute'>SendDigits</span> may contain numbers, the # and * characters, as well as the \"w\" character to \"wait\" for half a second.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:54Z',
    last_updated: '2020-08-04T10:00:27.204Z',
  },
  21261: {
    code: 21261,
    message: 'Maximum number of conditions per rule reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21261\r\n\r\n### Maximum number of conditions per rule reached\r\n\r\n This rule already has the maximum number of conditions allowed.\r\n\r\n#### Possible Causes\r\nThe number of conditions in a given rule cannot exceed the limit. See https://www.twilio.com/docs/sip-trunking/sip-header-manipulation \r\n\r\n#### Possible Solutions\r\nOptimize your rule by removing unused conditions.',
    causes:
      'The number of conditions in a given rule cannot exceed the limit. See https://www.twilio.com/docs/sip-trunking/sip-header-manipulation ',
    solutions: 'Optimize your rule by removing unused conditions.',
    description: 'This rule already has the maximum number of conditions allowed.',
    product: 'Elastic SIP Trunking',
    date_created: '2021-09-16T19:36:00Z',
    last_updated: '2021-10-12T19:02:59.771663Z',
  },
  70053: {
    code: 70053,
    message: 'Public Key Client Validation Not Enabled For Account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '\r\n## Error - 70053\r\n\r\n### Public Key Client Validation Not Enabled For Account\r\nThe request attempted to use the Public Key Client Validation but the functionality is not enabled for this account.\r\n\r\n#### Possible Solution:\r\n* Ensure your Account is enabled for this feature.\r\n* Remove the Twilio-Client-Validation header from your request',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:20:36Z',
    last_updated: '2020-08-04T10:00:18.837Z',
  },
  80205: {
    code: 80205,
    message: 'No Proxies For Service',
    log_level: 'WARNING',
    secondary_message:
      'This Service has no compatible Proxy numbers for this Participant. This Service has no Proxy numbers configured.',
    log_type: null,
    docs: '## Warning\n\n### No Proxies For Service\n\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no Proxy numbers configured.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.11Z',
  },
  80620: {
    code: 80620,
    message: 'Chat Configured Proxy Identifier Not Found',
    log_level: 'ERROR',
    secondary_message:
      'Received a chat message for a proxy identifier that does not exist in your Proxy pool',
    log_type: null,
    docs: '## Error - 80620\r\n\r\n### Chat Configured Proxy Identifier Not Found\r\n\r\nReceived a chat message for a proxy identifier that does not exist in your Proxy pool\r\n\r\n#### Possible Causes\r\n* You removed a Flex number from your Proxy pool ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2019-02-12T23:59:52Z',
    last_updated: '2020-08-04T10:00:10.578Z',
  },
  52212: {
    code: 52212,
    message: 'Missing Alexa skill ID',
    log_level: 'ERROR',
    secondary_message: 'You have not specified the Alexa Skill ID in the Notify Service',
    log_type: null,
    docs: '## Error 52212\r\n\r\n### Missing Alexa skill ID\r\n\r\nYour Alexa message was rejected because the Alexa Skill ID was missing. This specific message was not sent.\r\n\r\n### Possible causes\r\n- You have not specified the Alexa Skill ID in your Notify Service.\r\n\r\n### Possible solutions\r\n- Connect your Alexa Skill via the [Channels console](https://www.twilio.com/console/channels) then connect your skill to your [Notify Service](https://www.twilio.com/console/notify/services).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2017-06-22T15:15:53Z',
    last_updated: '2020-08-04T10:00:18.238Z',
  },
  21704: {
    code: 21704,
    message: 'The Messaging Service contains no phone numbers',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21704\r\n\r\n### The Messaging Service contains no phone numbers\r\n\r\n ## Error - 21704\r\n\r\n### The Messaging Service contains no senders.\r\n\r\nA Messaging Service requires at least one phone number, Alphanumeric Sender ID or short code to send messages.\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\n* Your Messaging Service does not contain any senders\r\n\r\n#### Possible Solutions\r\n* Add at least one phone number or short code to your Messaging Service, or enable Alphanumeric Sender ID.',
    causes: '* Your Messaging Service does not contain any senders',
    solutions:
      '* Add at least one phone number or short code to your Messaging Service, or enable Alphanumeric Sender ID.',
    description:
      '## Error - 21704\r\n\r\n### The Messaging Service contains no senders.\r\n\r\nA Messaging Service requires at least one phone number, Alphanumeric Sender ID or short code to send messages.\r\n\r\n\r\n\r\n\r\n\r\n',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:30Z',
    last_updated: '2020-08-04T10:00:24.798Z',
  },
  50307: {
    code: 50307,
    message: 'Programmable Chat: Channel with provided unique name already exists',
    log_level: 'ERROR',
    secondary_message: "Specified Channel's Unique Name already exists in this Service deployment.",
    log_type: null,
    docs: "## Error - 50307\r\n\r\n### Programmable Chat: Channel with provided unique name already exists\t\r\n\r\n#### Possible Causes \r\n*  Specified Channel's Unique Name already exists in this Service deployment.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid non-existing Channel's Unique Name is being passed in request. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:51Z',
    last_updated: '2020-08-04T10:00:23.088Z',
  },
  21646: {
    code: 21646,
    message: 'Supporting Document is not eligible for deletion',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 21646\r\n\r\n### Supporting Document is not eligible for deletion\r\n\r\n The Supporting Document is in a non-deletable status and is not eligible to be deleted until the Supporting Document transitions to a deletable status.\r\n\r\n#### Possible Causes\r\nThe Supporting Document is in a non-deletable status (PENDING_REVIEW).\r\n\r\n#### Possible Solutions\r\nWait for the Supporting Document to transition to a deletable status (DRAFT, TWILIO_REJECTED, TWILIO_APPROVED). If your Supporting Document is idle for more than 3 business days, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes: 'The Supporting Document is in a non-deletable status (PENDING_REVIEW).',
    solutions:
      'Wait for the Supporting Document to transition to a deletable status (DRAFT, TWILIO_REJECTED, TWILIO_APPROVED). If your Supporting Document is idle for more than 3 business days, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description:
      'The Supporting Document is in a non-deletable status and is not eligible to be deleted until the Supporting Document transitions to a deletable status.',
    product: 'Phone Numbers',
    date_created: '2020-07-17T19:47:56Z',
    last_updated: '2023-10-13T17:59:35.656418Z',
  },
  81000: {
    code: 81000,
    message: 'The Execution has exceeded max steps allowed for a flow',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 81000\r\n\r\n### The Execution has exceeded max steps allowed for a flow\r\n\r\n This limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.\r\n\r\n#### Possible Causes\r\n* You have too many steps in your flow.\r\n\r\n#### Possible Solutions\r\n* Reduce the number of steps in your flow.',
    causes: '* You have too many steps in your flow.',
    solutions: '* Reduce the number of steps in your flow.',
    description:
      'This limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.',
    product: 'Studio',
    date_created: '2018-06-26T23:13:46Z',
    last_updated: '2020-08-04T10:00:13.323Z',
  },
  18021: {
    code: 18021,
    message: 'Proof of identity does not show address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18021\r\n\r\n### Proof of identity does not show address\r\n\r\n The Proof of Identity does not show a visible address.\r\n\r\n#### Possible Causes\r\nThe identity document that you submitted for address document does not have the address.\r\n\r\n#### Possible Solutions\r\nPlease upload a Supporting Document that shows an address.',
    causes:
      'The identity document that you submitted for address document does not have the address.',
    solutions: 'Please upload a Supporting Document that shows an address.',
    description: 'The Proof of Identity does not show a visible address.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:15:32Z',
    last_updated: '2024-07-04T10:15:32Z',
  },
  53403: {
    code: 53403,
    message: 'Server is unable to apply a remote media description',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53403\r\n\r\n### Server is unable to apply a remote media description\r\n\r\n \r\n\r\n#### Possible Causes\r\nRaised whenever the Video Media Server receives a remote media description but is unable to apply it.\r\n\r\n#### Possible Solutions\r\n* Update to the latest Twilio Video SDK\r\n* Use the latest browser version (if applicable)',
    causes:
      'Raised whenever the Video Media Server receives a remote media description but is unable to apply it.',
    solutions:
      '* Update to the latest Twilio Video SDK\r\n* Use the latest browser version (if applicable)',
    description: null,
    product: 'Programmable Video',
    date_created: '2019-05-22T22:53:08Z',
    last_updated: '2022-07-06T17:13:11.957567Z',
  },
  30136: {
    code: 30136,
    message: 'Unable to renew certificate',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 30136\r\n\r\n### Unable to renew certificate\r\n\r\n \r\n\r\n#### Possible Causes\r\nDomain DNS setup is not completed.\r\nThere is an issue with the certificate authority\r\n\r\n#### Possible Solutions\r\nPlease verify your Domain DNS setup. If you continue seeing this error, please contact the Support team',
    causes:
      'Domain DNS setup is not completed.\r\nThere is an issue with the certificate authority',
    solutions:
      'Please verify your Domain DNS setup. If you continue seeing this error, please contact the Support team',
    description: null,
    product: 'Programmable Messaging',
    date_created: '2024-06-27T15:37:11Z',
    last_updated: '2024-06-27T15:37:26.087968Z',
  },
  25020: {
    code: 25020,
    message: 'Version conflict in SCIM header',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25020\r\n\r\n### Version conflict in SCIM header\r\n\r\n Version conflict in SCIM header.\r\n\r\n#### Possible Causes\r\nThe SCIM version specified in the header does not match the version of the entity.\r\n\r\n#### Possible Solutions\r\nTo resolve this conflict, either fetch the latest user entity to obtain the correct version or avoid setting the version in the header.',
    causes: 'The SCIM version specified in the header does not match the version of the entity.',
    solutions:
      'To resolve this conflict, either fetch the latest user entity to obtain the correct version or avoid setting the version in the header.',
    description: 'Version conflict in SCIM header.',
    product: 'Organizations API',
    date_created: '2023-12-04T10:45:40Z',
    last_updated: '2023-12-04T14:23:23.870788Z',
  },
  50300: {
    code: 50300,
    message: 'Programmable Chat: Channel not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Channel does not exist.',
    log_type: null,
    docs: '## Error - 50300\r\n\r\n### Programmable Chat: Channel not found\r\n\r\n#### Possible Causes \r\n*  Specified Channel does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:49Z',
    last_updated: '2020-08-04T10:00:23.226Z',
  },
  21721: {
    code: 21721,
    message: 'Cannot import Campaign Verify token due to incompatible A2P brand',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21721\r\n\r\n### Cannot import Campaign Verify token due to incompatible A2P brand\r\n\r\n The attempt to import a Campaign Verify token to your brand failed because your A2P brand is in an incompatible state.\r\n\r\n#### Possible Causes\r\n- Your A2P brand has a status of `FAILED` meaning the brand was not successfully registered\r\n- Your A2P brand is of type `STARTER` meaning it is a starter brand, not a standard brand\r\n\r\n#### Possible Solutions\r\n- Verify if the Brand Registration SID has been registered successfully by checking the `status` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). If the brand has been registered successfully, it will have a status of `APPROVED`. If this is the case, try to import the token again.\r\n- Verify that the Brand Registration SID is of the correct type by checking the `brand_type` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). The brand should have a type of “STANDARD.” If the `brand_type` is `STARTER`, the brand does not support importing a Campaign Verify token. Once you’ve verified that you are using a standard brand, try to import the token again\r\n',
    causes:
      '- Your A2P brand has a status of `FAILED` meaning the brand was not successfully registered\r\n- Your A2P brand is of type `STARTER` meaning it is a starter brand, not a standard brand',
    solutions:
      '- Verify if the Brand Registration SID has been registered successfully by checking the `status` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). If the brand has been registered successfully, it will have a status of `APPROVED`. If this is the case, try to import the token again.\r\n- Verify that the Brand Registration SID is of the correct type by checking the `brand_type` field using the [Brand API](https://www.twilio.com/docs/sms/a2p-10dlc/onboarding-isv-api#using-get-to-check-brand-registration-status). The brand should have a type of “STANDARD.” If the `brand_type` is `STARTER`, the brand does not support importing a Campaign Verify token. Once you’ve verified that you are using a standard brand, try to import the token again\r\n',
    description:
      'The attempt to import a Campaign Verify token to your brand failed because your A2P brand is in an incompatible state.',
    product: 'Programmable SMS',
    date_created: '2021-10-25T16:04:32Z',
    last_updated: '2021-10-25T16:07:34.283316Z',
  },
  60617: {
    code: 60617,
    message: 'Lookup Not Enough Request Parameters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60617\r\n\r\n### Lookup Not Enough Request Parameters\r\n\r\n Missing at least one valid additional argument to execute the Lookup you requested\r\n\r\n#### Possible Causes\r\nThe request was received but failed due to the Lookup package you requested requiring at least one optional request parameter to match against the phone number. If there is a single request parameter, its value may not be left blank.\r\n\r\n#### Possible Solutions\r\n- Review request parameters to ensure at least one optional field, such as FirstName, is included.',
    causes:
      'The request was received but failed due to the Lookup package you requested requiring at least one optional request parameter to match against the phone number. If there is a single request parameter, its value may not be left blank.',
    solutions:
      '- Review request parameters to ensure at least one optional field, such as FirstName, is included.',
    description:
      'Missing at least one valid additional argument to execute the Lookup you requested',
    product: 'Lookup',
    date_created: '2022-10-05T16:33:01Z',
    last_updated: '2023-07-25T17:24:51.525992Z',
  },
  34005: {
    code: 34005,
    message: 'Programmable Fax is no longer available',
    log_level: 'ERROR',
    secondary_message:
      'Twilio ended support for Programmable Fax for all accounts on December 17, 2021',
    log_type: 'APPLICATION',
    docs: '## ERROR - 34005\r\n\r\n### Programmable Fax is no longer available\r\n\r\nTwilio ended support for Programmable Fax for all accounts on December 17, 2021 The Programmable Fax API by Twilio is no longer supported\r\n\r\n#### Possible Causes\r\nYou are trying to use the Programmable Fax API which is no longer available\r\n\r\n#### Possible Solutions\r\nPlease consult the migration guide on: https://support.twilio.com/hc/en-us/articles/223136667-Fax-Support-on-Twilio',
    causes: 'You are trying to use the Programmable Fax API which is no longer available',
    solutions:
      'Please consult the migration guide on: https://support.twilio.com/hc/en-us/articles/223136667-Fax-Support-on-Twilio',
    description: 'The Programmable Fax API by Twilio is no longer supported',
    product: 'Programmable Fax',
    date_created: '2021-12-10T22:28:37Z',
    last_updated: '2021-12-10T22:28:51.44287Z',
  },
  30703: {
    code: 30703,
    message: 'Brand Registration Failure: Duplicate record detected',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30703\r\n\r\n### Brand Registration Failure: Duplicate record detected\r\n\r\n Brand registration failed due to duplicate record detection. Following attributes are expected to be unique for each brand and can fail with this duplication check.\r\n\r\n* Mobile phone number\r\n* Business registration identifier\r\n* Business legal name\r\n* Authorised representative's phone number\r\n* Email address\r\n* Website\r\n* Stock symbol (applicable only for public entities)\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\n* The mobile phone number provided in the brand registration request has already been used to register a US A2P Brand with TCR. \r\n\r\n* An existing brand is using the provided business identification type and number.\r\n\r\n* An existing brand is using the provided business legal name.\r\n\r\n* Authorised representative's phone number provided for brand registration has already been registered. Please retry with a different phone number.\r\n\r\n* Email address provided for brand registration has already been registered with another brand. Please try again with a different email address.\r\n\r\n* Website provided for brand registration has already been registered. Please try again with a different website url.\r\n\r\n* Business name provided for brand registration has already been registered. Business names are expected to be unique across all brands.\r\n\r\n* Stock symbol provided for brand registration has already been registered\r\n\r\n#### Possible Solutions\r\nDepending on the fields you may have received in the error message, please refer to the following solutions:\r\n\r\n* Use a unique US mobile phone number for the registration. \r\n\r\n* Use a unique business registration identifier for successful registration.\r\n\r\n* Use a unique business name.\r\n\r\n* Use a unique authorized representative.\r\n\r\n* Use a unique email address.\r\n\r\n* Use a unique website address.\r\n\r\n* Use a unique business name.\r\n\r\n* Use a unique stock symbol.\r\n\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)",
    causes:
      "* The mobile phone number provided in the brand registration request has already been used to register a US A2P Brand with TCR. \r\n\r\n* An existing brand is using the provided business identification type and number.\r\n\r\n* An existing brand is using the provided business legal name.\r\n\r\n* Authorised representative's phone number provided for brand registration has already been registered. Please retry with a different phone number.\r\n\r\n* Email address provided for brand registration has already been registered with another brand. Please try again with a different email address.\r\n\r\n* Website provided for brand registration has already been registered. Please try again with a different website url.\r\n\r\n* Business name provided for brand registration has already been registered. Business names are expected to be unique across all brands.\r\n\r\n* Stock symbol provided for brand registration has already been registered",
    solutions:
      'Depending on the fields you may have received in the error message, please refer to the following solutions:\r\n\r\n* Use a unique US mobile phone number for the registration. \r\n\r\n* Use a unique business registration identifier for successful registration.\r\n\r\n* Use a unique business name.\r\n\r\n* Use a unique authorized representative.\r\n\r\n* Use a unique email address.\r\n\r\n* Use a unique website address.\r\n\r\n* Use a unique business name.\r\n\r\n* Use a unique stock symbol.\r\n\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    description:
      "Brand registration failed due to duplicate record detection. Following attributes are expected to be unique for each brand and can fail with this duplication check.\r\n\r\n* Mobile phone number\r\n* Business registration identifier\r\n* Business legal name\r\n* Authorised representative's phone number\r\n* Email address\r\n* Website\r\n* Stock symbol (applicable only for public entities)\r\n\r\n\r\n\r\n",
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:37:29Z',
    last_updated: '2024-02-13T15:32:34.556326Z',
  },
  45354: {
    code: 45354,
    message: 'Cannot create a Channel for a closed Conversation.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45354\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes:
      'An inbound message triggered a Channel to start, but the associated Conversation was closed or deleted before the request was processed.',
    solutions: 'No Action.\r',
    description:
      'Failed to create Channel <channel sid> because the Conversation <conversation sid> is in a closed state.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:29.639696Z',
  },
  50533: {
    code: 50533,
    message: 'Failed to parse ChannelMetadata Json',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50533\r\n\r\n### Failed to parse ChannelMetadata Json\r\n\r\n The Channel Metadata Content was not in the correct format.\r\n\r\n#### Possible Causes\r\n* Channel Metadata Json was expected.\r\n* Channel Metadata required keys were missing\r\n\r\n#### Possible Solutions\r\n* Fix Channel Metadata payload and retry',
    causes:
      '* Channel Metadata Json was expected.\r\n* Channel Metadata required keys were missing',
    solutions: '* Fix Channel Metadata payload and retry',
    description: 'The Channel Metadata Content was not in the correct format.',
    product: 'Conversations',
    date_created: '2024-02-27T16:24:05Z',
    last_updated: '2024-02-27T16:24:12.480307Z',
  },
  60206: {
    code: 60206,
    message: "'Amount' & 'Payee' params are required",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60206\r\n\r\n### 'Amount' & 'Payee' params are required\r\n\r\n Your service has the `Psd2Enabled ` flag which requires you to send the 'Amount' & 'Payee' params when creating a verification\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nYour service has the `Psd2Enabled ` flag which requires you to send the 'Amount' & 'Payee' params when creating a verification\r\n\r\n#### Possible Solutions\r\n* Make sure that you send the 'Amount' & 'Payee' params\r\n* Set the `Psd2Enabled ` flag on your Verification Service to `false`.",
    causes:
      "Your service has the `Psd2Enabled ` flag which requires you to send the 'Amount' & 'Payee' params when creating a verification",
    solutions:
      "* Make sure that you send the 'Amount' & 'Payee' params\r\n* Set the `Psd2Enabled ` flag on your Verification Service to `false`.",
    description:
      "Your service has the `Psd2Enabled ` flag which requires you to send the 'Amount' & 'Payee' params when creating a verification\r\n\r\nHTTP status: 400",
    product: 'Verify',
    date_created: '2019-03-27T23:19:38Z',
    last_updated: '2021-05-18T04:38:05.615Z',
  },
  30799: {
    code: 30799,
    message:
      'Brand Registration Feedback: We were unable to verify the details of the registration data.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30799\r\n\r\n### Brand Registration Feedback: We were unable to verify the details of the registration data.\r\n\r\n Your Brand has received feedback from The Campaign Registration upon registration. This brand registration can not be used for campaign creation till the provided feedback has been addressed. In this case, it wasn’t possible to determine the exact cause of the failure. Please check the possible causes section to identify if the provided details for brand registration don’t fall into any of the mentioned categories.\r\n\r\n#### Possible Causes\r\n#### If your company is publicly listed and has an EIN, then it is possible that:\r\n\r\n* The submitted US EIN is invalid. \r\n\r\n* The submitted Canadian government ID cannot be verified.\r\n\r\n* The submitted foreign government ID cannot be verified.\r\n\r\n* The submitted legal company name does not match with US EIN. \r\n\r\n* The submitted legal company name does not match with the Canadian government ID. \r\n\r\n* The submitted legal company name does not match with foreign government ID. \r\n\r\n* The submitted US EIN appears to be a US SSN. \r\n\r\n#### If you provided a stock exchange and stock ticker symbol, then it is possible that:\r\n\r\n* The submitted stock symbol and stock exchange could not be verified for the submitted legal company name. \r\n\r\n* The submitted stock exchange is not recognized.  \r\n\r\n#### If your company is a registered government entity, then it is possible that\r\n\r\n*  The submitted company is not a US entity. Only US entities qualify for the Government Entity Type. \r\n\r\n*  The company’s submission as a Government Entity type could not be confirmed from independent sources. \r\n\r\n#### If your company is a non-profit entity, then it is possible that\r\n\r\n* The submitted company is not a US entity. Only US entities qualify for the Non-Profit Entity Type. \r\n\r\n* The submitted company is not verified as a US IRS recognized non-profit organization. \r\n\r\n* The submitted company is verified as a US IRS recognized non-profit organization but the charitable subsection code was not reported.\r\n\r\n\r\n#### Possible Solutions\r\n#### For public entities:\r\n\r\nPlease edit your customer profile and update the business registration identifier with correct information that matches your tax returns. Please also make sure that your legal company name also matches the tax documents.\r\n\r\n#### For entities that are listed on a stock exchange:\r\n\r\nPlease edit your A2P profile and update the stock_symbol and/or stock_exchange with correct information. \r\n\r\n#### For government entities:\r\n\r\nPlease change the entity_type field value to something other than Government. If you are a US Entity, please update the customer profile address to indicate the same.\r\n\r\n#### For non-profit organisations:\r\n\r\nPlease change the entity_type field value to something other than Non-Profit. If you are a Non-Profit Entity, please update the customer profile to indicate the same.\r\n\r\nIn case none of the above meet your case, please contact twilio support for further resolution.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n',
    causes:
      '#### If your company is publicly listed and has an EIN, then it is possible that:\r\n\r\n* The submitted US EIN is invalid. \r\n\r\n* The submitted Canadian government ID cannot be verified.\r\n\r\n* The submitted foreign government ID cannot be verified.\r\n\r\n* The submitted legal company name does not match with US EIN. \r\n\r\n* The submitted legal company name does not match with the Canadian government ID. \r\n\r\n* The submitted legal company name does not match with foreign government ID. \r\n\r\n* The submitted US EIN appears to be a US SSN. \r\n\r\n#### If you provided a stock exchange and stock ticker symbol, then it is possible that:\r\n\r\n* The submitted stock symbol and stock exchange could not be verified for the submitted legal company name. \r\n\r\n* The submitted stock exchange is not recognized.  \r\n\r\n#### If your company is a registered government entity, then it is possible that\r\n\r\n*  The submitted company is not a US entity. Only US entities qualify for the Government Entity Type. \r\n\r\n*  The company’s submission as a Government Entity type could not be confirmed from independent sources. \r\n\r\n#### If your company is a non-profit entity, then it is possible that\r\n\r\n* The submitted company is not a US entity. Only US entities qualify for the Non-Profit Entity Type. \r\n\r\n* The submitted company is not verified as a US IRS recognized non-profit organization. \r\n\r\n* The submitted company is verified as a US IRS recognized non-profit organization but the charitable subsection code was not reported.\r\n',
    solutions:
      '#### For public entities:\r\n\r\nPlease edit your customer profile and update the business registration identifier with correct information that matches your tax returns. Please also make sure that your legal company name also matches the tax documents.\r\n\r\n#### For entities that are listed on a stock exchange:\r\n\r\nPlease edit your A2P profile and update the stock_symbol and/or stock_exchange with correct information. \r\n\r\n#### For government entities:\r\n\r\nPlease change the entity_type field value to something other than Government. If you are a US Entity, please update the customer profile address to indicate the same.\r\n\r\n#### For non-profit organisations:\r\n\r\nPlease change the entity_type field value to something other than Non-Profit. If you are a Non-Profit Entity, please update the customer profile to indicate the same.\r\n\r\nIn case none of the above meet your case, please contact twilio support for further resolution.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)\r\n',
    description:
      'Your Brand has received feedback from The Campaign Registration upon registration. This brand registration can not be used for campaign creation till the provided feedback has been addressed. In this case, it wasn’t possible to determine the exact cause of the failure. Please check the possible causes section to identify if the provided details for brand registration don’t fall into any of the mentioned categories.',
    product: 'Programmable Messaging',
    date_created: '2024-02-28T16:42:57Z',
    last_updated: '2024-02-28T16:42:57Z',
  },
  60219: {
    code: 60219,
    message: 'SendGrid Template does not contain required placeholders',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60219\r\n\r\n### SendGrid Template does not contain required placeholders\r\n\r\n SendGrid Template does not contain required placeholders\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nMissing placeholders {{twilio_code}} or {{twilio_message}}\r\n\r\n#### Possible Solutions\r\nAdd the required placeholders',
    causes: 'Missing placeholders {{twilio_code}} or {{twilio_message}}',
    solutions: 'Add the required placeholders',
    description: 'SendGrid Template does not contain required placeholders\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-11-27T22:14:31Z',
    last_updated: '2021-05-18T04:50:41.122Z',
  },
  50409: {
    code: 50409,
    message: 'Participant address equals proxy address',
    log_level: 'ERROR',
    secondary_message: 'The supplied participant address must not equal its proxy address.',
    log_type: null,
    docs: "\n## Error - 50409\n\n### Conversations: Participant address equals proxy address\nThe supplied participant address must not equal its proxy address.\n\n#### Possible Causes\n* When requesting a participant to be added to a conversation, you specified the identical participant address and its proxy address parameters.\n\n#### Possible Solutions\n* Provide a participant's public address (e.g. user's SMS/MMS number) different from a conversation proxy number (e.g. Twilio SMS/MMS number) when adding a participant to the conference.\n\n",
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.534Z',
  },
  52003: {
    code: 52003,
    message: 'Invalid Credential Type',
    log_level: 'ERROR',
    secondary_message: 'Credential type and binding type does not match',
    log_type: null,
    docs: '## Error - 52003\r\n\r\n### Invalid Credential Type\r\n\r\n#### Possible Causes \r\n*  Type of credential provided in access token does not match that of the registration. For example you included the SID of a APS type Credential in the access token for an Android application using GCM.\r\n\r\n#### Possible Solutions\r\n*  Make sure you provide the right Credential SID in the access token.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:01:14Z',
    last_updated: '2020-08-04T10:00:22.488Z',
  },
  30033: {
    code: 30033,
    message: 'US A2P 10DLC - Campaign Suspended',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30033\r\n\r\n### US A2P 10DLC - Campaign Suspended\r\n\r\n Your message could not be sent because you are sending this message from a suspended US A2P 10DLC Campaign.\r\n\r\n#### Possible Causes\r\nCampaign Suspension\r\n\r\n#### Possible Solutions\r\nPlease reach out to the Twilio Support team to receive more details around why your campaign has been suspended, and how to resolve the issue.',
    causes: 'Campaign Suspension',
    solutions:
      'Please reach out to the Twilio Support team to receive more details around why your campaign has been suspended, and how to resolve the issue.',
    description:
      'Your message could not be sent because you are sending this message from a suspended US A2P 10DLC Campaign.',
    product: 'Programmable SMS',
    date_created: '2023-01-30T19:30:01Z',
    last_updated: '2023-05-11T20:11:27.844835Z',
  },
  21228: {
    code: 21228,
    message: 'Invalid SIP Header. Illegal chars in header name',
    log_level: 'WARNING',
    secondary_message: 'The header you passed has characters not allowed in SIP.',
    log_type: null,
    docs: '## Warning - 21228\n\n### Invalid SIP Header. Illegal chars in header name\n\nThe header you passed has characters not allowed in SIP.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:19Z',
    last_updated: '2020-08-04T10:00:25.616Z',
  },
  50325: {
    code: 50325,
    message: 'Programmable Chat: Invalid channel webhook filter',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain correctly formatted parameter for webhook filter',
    log_type: null,
    docs: '## Error - 50325\r\n\r\n### Programmable Chat: Invalid channel webhook filter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correct parameter for channel webhook filter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T15:31:42Z',
    last_updated: '2020-08-04T10:00:12.056Z',
  },
  81009: {
    code: 81009,
    message: 'Timed out enqueueing Call',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81009\r\n\r\n### Timed out enqueueing Call\r\nStudio timed out while executing the Enqueue Call widget in the Flow.\r\n\r\n#### Possible Causes\r\n* The request to the Taskrouter API failed.\r\n* Invalid values were passed to the Taskrouter API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:16:03Z',
    last_updated: '2020-08-04T10:00:13.139Z',
  },
  31201: {
    code: 31201,
    message: 'Twilio Client: Error occurred while accessing microphone',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31201\r\n\r\n### Twilio Client: Error occurred while accessing microphone\r\n\r\n#### Possible Solutions\r\n\r\n- Check for conflicting applications that might be accessing or attempting to access the microphone\r\n- Try unplugging and reconnecting the microphone, if applicable, to reacquire the microphone',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2018-04-10T03:35:58Z',
    last_updated: '2020-08-04T10:00:13.863Z',
  },
  21232: {
    code: 21232,
    message: 'Invalid Domain',
    log_level: 'ERROR',
    secondary_message:
      'The domain name requested is invalid, already in use or a subdomain of a domain you do not control.  Please see the response body for more details.',
    log_type: null,
    docs: '# Error - 21232\n\n### Invalid Domain\n\nThe domain name requested is invalid, already in use or a subdomain of a domain you do not control.  This is likely because the parent domain does not exist or because neither the account sid or its parent account controls the parent domain.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:32Z',
    last_updated: '2020-08-04T10:00:24.684Z',
  },
  11206: {
    code: 11206,
    message: 'HTTP protocol violation',
    log_level: 'ERROR',
    secondary_message: 'There was an error speaking HTTP to the target URL.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 11206\r\n\r\n### HTTP protocol violation\r\n\r\n There was an error speaking HTTP to the target URL.\r\n\r\n\r\n#### Possible Causes\r\n*  Server misconfiguration\r\n*   Network disruption\r\n*   Making HTTP connections to an HTTPS port\r\n\r\n#### Possible Solutions\r\n*  verify your web server is serving valid HTTP for the URL\t\r\n*   verify the network connection to your server is stable\t\r\n*   verify the URL is not directing you to an SSL port',
    causes:
      '*  Server misconfiguration\r\n*   Network disruption\r\n*   Making HTTP connections to an HTTPS port',
    solutions:
      '*  verify your web server is serving valid HTTP for the URL\t\r\n*   verify the network connection to your server is stable\t\r\n*   verify the URL is not directing you to an SSL port',
    description: 'There was an error speaking HTTP to the target URL.\r\n',
    product: null,
    date_created: '2016-03-31T17:13:24Z',
    last_updated: '2020-08-04T10:00:29.5Z',
  },
  16000: {
    code: 16000,
    message: 'Whisper Not Available on Twilio Conference',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16000\r\n\r\n### Whisper Not Available on Twilio Conference\r\n\r\nWhisper is only available on Agent Conference, to create an Agent Conference configure your account to use Agent Conference in the [conference settings page](https://www.twilio.com/console/voice/settings/conferences)',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2017-02-24T00:20:34Z',
    last_updated: '2020-08-04T10:00:20.247Z',
  },
  91202: {
    code: 91202,
    message: 'Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91202\r\n\r\n### Not Found\r\n\r\n Resource is not found\r\n\r\n#### Possible Causes\r\n* Schema not found\r\n* Event Type Not found\r\n\r\n#### Possible Solutions\r\n* Recheck to see if the correct information is provided else\r\n* Recheck to verify is the resource actually exists',
    causes: '* Schema not found\r\n* Event Type Not found',
    solutions:
      '* Recheck to see if the correct information is provided else\r\n* Recheck to verify is the resource actually exists',
    description: 'Resource is not found',
    product: null,
    date_created: '2020-09-21T21:16:31Z',
    last_updated: '2020-09-21T21:16:31Z',
  },
  51103: {
    code: 51103,
    message: "Twilsock: Token doesn't contain required grants section",
    log_level: 'ERROR',
    secondary_message:
      'No grants section is specified in the token and grants section is required.',
    log_type: null,
    docs: "## Error - 51103\r\n\r\n### Token doesn't contain required grants section\r\n\r\n#### Possible Causes \r\nNo grants section is specified in the token and grants section is required.\r\n\r\n#### Possible Solutions\r\nConfirm grants section exists and valid in the token. \r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T11:50:31Z',
    last_updated: '2020-08-04T10:00:09.885Z',
  },
  80908: {
    code: 80908,
    message: 'Callback Error',
    log_level: 'WARNING',
    secondary_message: 'Error on Callback for http://www.yourdomain.com/callback',
    log_type: null,
    docs: '## Warning\n\n### Callback Error\n\nExample Message: Error on Callback for http://www.yourdomain.com/callback',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.531Z',
  },
  13219: {
    code: 13219,
    message: 'Dial: Invalid answerOnBridge value',
    log_level: 'WARNING',
    secondary_message: 'answerOnBridge must be "true" or "false".',
    log_type: 'APPLICATION',
    docs: '## WARNING - 13219\r\n\r\n### Dial: Invalid answerOnBridge value\r\n\r\nanswerOnBridge must be "true" or "false". \r\n\r\n#### Possible Causes\r\nanswerOnBridge value is not "true" or "false".\r\n\r\n#### Possible Solutions\r\nanswerOnBridge must be "true" or "false".',
    causes: 'answerOnBridge value is not "true" or "false".',
    solutions: 'answerOnBridge must be "true" or "false".',
    description: null,
    product: 'Programmable Voice',
    date_created: '2020-05-16T02:48:19Z',
    last_updated: '2020-08-04T10:00:03.069Z',
  },
  81010: {
    code: 81010,
    message: 'There was an internal error while processing a Function',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "## Error - 81010\r\n\r\n### There was an internal error while processing a Function\r\nStudio could not invoke the Function service.\r\n\r\n#### Possible Causes\r\n* The Function returned a 4xx or 5xx status code\r\n* The Function timed out or did not include `callback()`\r\n* There may be an issue with Twilio Function Service\r\n\r\n#### Possible Solutions\r\n* Verify your Function calls `callback()` to avoid timeouts\r\n* Check your Function logs for runtime errors\r\n* Ensure you're returning the correct status code",
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:16:30Z',
    last_updated: '2020-08-04T10:00:13.117Z',
  },
  80601: {
    code: 80601,
    message: 'Phone Number Not Available',
    log_level: 'WARNING',
    secondary_message: 'PhoneNumber is not available.  It may be bound to a number pool.',
    log_type: null,
    docs: '## Warning\n\n### Phone Number Not Available\n\nExample Message: PhoneNumber is not available.  It may be bound to a number pool.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.866Z',
  },
  54010: {
    code: 54010,
    message: 'No parameters specified',
    log_level: 'ERROR',
    secondary_message: 'Expected at least 1 optional parameter, but none were provided.',
    log_type: null,
    docs: '## Error - 54010\r\n\r\n### Sync: No parameters specified\r\nExpected at least 1 optional parameter, but none were provided.\r\n\r\n#### Possible Causes\r\n* The request expected at least 1 optional parameter, but none was provided.\r\n\r\n#### Possible Solutions\r\n* Add a parameter or confirm that the existing parameters are not misspelled.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2018-11-21T09:25:29Z',
    last_updated: '2020-08-04T10:00:11.725Z',
  },
  19043: {
    code: 19043,
    message: 'Field definition name already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19043\r\n\r\n### Field definition name already exists\r\n\r\n Input field name already exists\r\n\r\n#### Possible Causes\r\nCustom field definition name in the request already exists\r\n\r\n#### Possible Solutions\r\nProvide the unique custom field definition name in the request ',
    causes: 'Custom field definition name in the request already exists',
    solutions: 'Provide the unique custom field definition name in the request ',
    description: 'Input field name already exists',
    product: 'Contacts',
    date_created: '2020-07-21T20:35:12Z',
    last_updated: '2020-08-31T06:01:57.525Z',
  },
  60233: {
    code: 60233,
    message: "Default sender id can't be deleted",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 60233\r\n\r\n### Default sender id can't be deleted\r\n\r\n Default sender id can't be deleted\r\n\r\n#### Possible Causes\r\nThe sender id that was requested to be deleted is default\r\n\r\n#### Possible Solutions\r\nSet another sender id as default and try again",
    causes: 'The sender id that was requested to be deleted is default',
    solutions: 'Set another sender id as default and try again',
    description: "Default sender id can't be deleted",
    product: 'Verify',
    date_created: '2023-08-15T21:41:25Z',
    last_updated: '2023-08-15T21:41:25Z',
  },
  50540: {
    code: 50540,
    message: 'Content variable key is too long',
    log_level: 'ERROR',
    secondary_message:
      'Key in key-value pair of message content variables is exceeding allowed maximum length of 16 characters',
    log_type: 'TWILIO',
    docs: '## ERROR - 50540\r\n\r\n### Content variable key is too long\r\n\r\nKey in key-value pair of message content variables is exceeding allowed maximum length of 16 characters Length of key in message content variables is restricted to 16 characters.\r\n\r\n#### Possible Causes\r\nOne or many keys in key-value pairs of message content variables are hitting limit of allowed 16 characters.\r\n\r\n#### Possible Solutions\r\nReduce the length of key characters to maximum 16 in message content variables.',
    causes:
      'One or many keys in key-value pairs of message content variables are hitting limit of allowed 16 characters.',
    solutions: 'Reduce the length of key characters to maximum 16 in message content variables.',
    description: 'Length of key in message content variables is restricted to 16 characters.',
    product: 'Conversations',
    date_created: '2023-03-10T14:35:10Z',
    last_updated: '2023-03-10T14:38:15.138533Z',
  },
  32115: {
    code: 32115,
    message: 'X-Branded-CallReason header contains an invalid value.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32115\r\n\r\n### X-Branded-CallReason header contains an invalid value.\r\n\r\n X-Branded-CallReason header contains an invalid value.\r\n\r\n#### Possible Causes\r\nX-Branded-CallReason header contains an invalid value exceeding 50 character limit. \r\n\r\n#### Possible Solutions\r\nVerify that the call reason supplied does not exceed more than 50 characters',
    causes: 'X-Branded-CallReason header contains an invalid value exceeding 50 character limit. ',
    solutions: 'Verify that the call reason supplied does not exceed more than 50 characters',
    description: 'X-Branded-CallReason header contains an invalid value.',
    product: 'Elastic SIP Trunking',
    date_created: '2020-03-17T18:58:30Z',
    last_updated: '2020-08-04T10:00:04.189Z',
  },
  14207: {
    code: 14207,
    message: ' Enqueue: The targeted queue reached max queue size',
    log_level: 'WARNING',
    secondary_message: ' The default max queue size is 1000 and can be set to a maximum of 5000.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 14207\r\n\r\n###  Enqueue: The targeted queue reached max queue size\r\n\r\n The default max queue size is 1000 and can be set to a maximum of 5000. The targeted queue has reached its maxSize limit. Once the queue reaches the limit, new requests to queue calls using <Enqueue> will be rejected.\r\n\r\n#### Possible Causes\r\nA full queue can indicate higher <Enqueue> volume, longer queue times, or an incorrectly configured queue’s maxSize.\r\n\r\n#### Possible Solutions\r\nA queue’s maxSize can be adjusted to a maximum of 5000. Use the [Queue API](https://www.twilio.com/docs/voice/api/queue-resource) to identify the current maxSize and adjust accordingly.\r\n\r\nIf a waitUrl is provided for <Enqueue>, the parameters MaxQueueSize and CurrentQueueSize are included in the Webhook request to the waitUrl. Your application can use this information to determine queue capacity and adjust max queue size via the [API](https://www.twilio.com/docs/voice/api/queue-resource).\r\n\r\nIf the queue is already configured for the maximum allowed queue size (5000), one possible workaround is to create multiple queues and distribute the <Enqueue> requests between them.',
    causes:
      'A full queue can indicate higher <Enqueue> volume, longer queue times, or an incorrectly configured queue’s maxSize.',
    solutions:
      'A queue’s maxSize can be adjusted to a maximum of 5000. Use the [Queue API](https://www.twilio.com/docs/voice/api/queue-resource) to identify the current maxSize and adjust accordingly.\r\n\r\nIf a waitUrl is provided for <Enqueue>, the parameters MaxQueueSize and CurrentQueueSize are included in the Webhook request to the waitUrl. Your application can use this information to determine queue capacity and adjust max queue size via the [API](https://www.twilio.com/docs/voice/api/queue-resource).\r\n\r\nIf the queue is already configured for the maximum allowed queue size (5000), one possible workaround is to create multiple queues and distribute the <Enqueue> requests between them.',
    description:
      'The targeted queue has reached its maxSize limit. Once the queue reaches the limit, new requests to queue calls using <Enqueue> will be rejected.',
    product: 'Programmable Voice',
    date_created: '2020-07-24T20:57:35Z',
    last_updated: '2023-07-11T23:46:59.305789Z',
  },
  40148: {
    code: 40148,
    message: 'Failed to issue Supervise instruction due to missing ‘from’ property',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40148\r\n\r\n### Failed to issue Supervise instruction due to missing ‘from’ property\r\n\r\n A valid `from` parameter was not passed to the ‘supervise’ instruction\r\n\r\n#### Possible Causes\r\n* The `from` property is missing in the Task’s attributes.\r\n* The `from` property in the Task’s attributes is invalid.\r\n\r\n#### Possible Solutions\r\n*  Ensure that a valid `from` property is provided in the Task’s attributes.',
    causes:
      '* The `from` property is missing in the Task’s attributes.\r\n* The `from` property in the Task’s attributes is invalid.',
    solutions: '*  Ensure that a valid `from` property is provided in the Task’s attributes.',
    description: 'A valid `from` parameter was not passed to the ‘supervise’ instruction',
    product: 'TaskRouter',
    date_created: '2019-08-15T21:57:00Z',
    last_updated: '2020-09-14T21:46:57.398Z',
  },
  21258: {
    code: 21258,
    message: 'Invalid SIP Manipulation Policy',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21258\r\n\r\n### Invalid SIP Manipulation Policy\r\n\r\n There was a validation error for the Sip Manipulation Policy in question.\r\n\r\n#### Possible Causes\r\nReference the docs for configuration information - https://www.twilio.com/docs/sip-trunking/sip-header-manipulation \r\n\r\n#### Possible Solutions\r\nReference the docs for a possible configuation solition - https://www.twilio.com/docs/sip-trunking/sip-header-manipulation',
    causes:
      'Reference the docs for configuration information - https://www.twilio.com/docs/sip-trunking/sip-header-manipulation ',
    solutions:
      'Reference the docs for a possible configuation solition - https://www.twilio.com/docs/sip-trunking/sip-header-manipulation',
    description: 'There was a validation error for the Sip Manipulation Policy in question.',
    product: 'Elastic SIP Trunking',
    date_created: '2021-09-16T19:32:54Z',
    last_updated: '2021-09-27T18:48:12.202019Z',
  },
  13710: {
    code: 13710,
    message: 'Redirect: Invalid method value',
    log_level: 'WARNING',
    secondary_message:
      "The method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/redirect#method'>Redirect Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13710 \n\n### Redirect: Invalid method value\n\nThe method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/redirect#method'>Redirect Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:47Z',
    last_updated: '2020-08-04T10:00:27.717Z',
  },
  23001: {
    code: 23001,
    message: 'Message Redaction Incompatible Configuration: Long code STOP filtering',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 23001\r\n\r\n### Message Redaction Incompatible Configuration: Long code STOP filtering\r\n\r\n Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* Twilio is currently set to handle opt-out keywords for long code numbers on your account. Twilio\'s opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blocklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blocklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) to disable Twilio\'s built-in opt-out keyword handling for your account.',
    causes:
      "* Twilio is currently set to handle opt-out keywords for long code numbers on your account. Twilio's opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.",
    solutions:
      '* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blocklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blocklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) to disable Twilio\'s built-in opt-out keyword handling for your account.',
    description:
      'Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.',
    product: 'Programmable SMS',
    date_created: '2019-09-20T04:53:05Z',
    last_updated: '2023-11-01T19:17:10.751919Z',
  },
  14104: {
    code: 14104,
    message: 'Invalid Method attribute',
    log_level: 'WARNING',
    secondary_message: 'method attribute may only be "GET" or "POST"',
    log_type: null,
    docs: '## Warning - 14104 \n\n### Message method attribute invalid\n\nMethod attribute may only be "GET" or "POST"\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:48Z',
    last_updated: '2020-08-04T10:00:27.622Z',
  },
  21634: {
    code: 21634,
    message: 'SIP Trunk is in use for emergency calling',
    log_level: 'ERROR',
    secondary_message:
      'One or more numbers associated with this SIP trunk are provisioned for emergency calling.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21634\r\n\r\n### SIP Trunk is in use for emergency calling\r\n\r\nOne or more numbers associated with this SIP trunk are provisioned for emergency calling. Please disable emergency calling on these numbers before\r\nproceeding.\r\n\r\n#### Possible Causes\r\n* One or more numbers associated with this SIP Trunk are provisioned for emergency calling.\r\n\r\n#### Possible Solutions\r\n* Refer to the docs on <a href="/docs/sip-trunking/emergency-calling">\r\nEmergency Calling</a> over SIP trunking for more details.',
    causes:
      '* One or more numbers associated with this SIP Trunk are provisioned for emergency calling.',
    solutions:
      '* Refer to the docs on <a href="/docs/sip-trunking/emergency-calling">\r\nEmergency Calling</a> over SIP trunking for more details.',
    description: 'Please disable emergency calling on these numbers before\r\nproceeding.',
    product: 'Elastic SIP Trunking',
    date_created: '2020-08-04T02:54:12Z',
    last_updated: '2023-07-31T21:29:22.62931Z',
  },
  48003: {
    code: 48003,
    message: 'Callback returned an invalid response',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48003\r\n\r\n### Callback returned an invalid response\r\n\r\n \r\n\r\n#### Possible Causes\r\n* Your Frontline integration service returned a response which is invalid.\r\n* Your service returned a response that was too large. Responses are capped at 64k.\r\n\r\n#### Possible Solutions\r\n* Make sure that callback returns a valid JSON which has the required fields that are defined in Frontline Docs.\r\n* Make sure that your response size is less than 64k.',
    causes:
      '* Your Frontline integration service returned a response which is invalid.\r\n* Your service returned a response that was too large. Responses are capped at 64k.',
    solutions:
      '* Make sure that callback returns a valid JSON which has the required fields that are defined in Frontline Docs.\r\n* Make sure that your response size is less than 64k.',
    description: null,
    product: 'Frontline',
    date_created: '2021-09-24T08:06:56Z',
    last_updated: '2022-08-05T23:58:58.249384Z',
  },
  50404: {
    code: 50404,
    message: 'Programmable Chat: Member already exists',
    log_level: 'ERROR',
    secondary_message: 'Member with specified Identity already exists in this Channel',
    log_type: null,
    docs: '### Programmable Chat: Member already exists\r\n\r\n#### Possible Causes \r\n\r\n*  Member with specified Identity already exists in this Channel.\r\n\r\n#### Possible Solutions\r\n\r\n*  Confirm that the Member Identity passed in the request is not already a member of the intended channel.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-04-05T13:02:02Z',
    last_updated: '2020-08-04T10:00:19.964Z',
  },
  80402: {
    code: 80402,
    message: 'Identifier Proxy Pair Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Identifier and Proxy Identifier pair',
    log_type: null,
    docs: '## Warning\n\n### Identifier Proxy Pair Invalid\n\nExample Message: Invalid Identifier and Proxy Identifier pair',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.016Z',
  },
  90000: {
    code: 90000,
    message: 'Uncaught Flex JavaScript Exception',
    log_level: 'ERROR',
    secondary_message: 'A client-side JavaScript exception occurred within the Flex UI',
    log_type: null,
    docs: '## Error - 90000\r\n\r\n### Uncaught Flex JavaScript Exception\r\nA JavaScript error has occurred within Flex UI.\r\n\r\n#### Possible Causes\r\n* There may have been an issue initializing Flex\r\n* There may be an uncaught exception within a Flex plugin',
    causes: null,
    solutions: null,
    description: null,
    product: 'Flex',
    date_created: '2019-04-09T17:32:00Z',
    last_updated: '2020-08-04T10:00:09.187Z',
  },
  90020: {
    code: 90020,
    message: "One of 'TemplateArgs' dictionary key is blank",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90020\r\n\r\n### One of 'TemplateArgs' dictionary key is blank\r\n\r\n One of 'TemplateArgs' dictionary key is blank\r\n\r\n#### Possible Causes\r\nOne of 'TemplateArgs' dictionary key is blank\r\n\r\n#### Possible Solutions\r\nDo not use empty or blank keys in 'TemplateArgs' dictionary",
    causes: "One of 'TemplateArgs' dictionary key is blank",
    solutions: "Do not use empty or blank keys in 'TemplateArgs' dictionary",
    description: "One of 'TemplateArgs' dictionary key is blank",
    product: null,
    date_created: '2020-12-11T08:46:19Z',
    last_updated: '2020-12-11T08:46:19Z',
  },
  52168: {
    code: 52168,
    message: 'Webhook Credentials request timed out',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52168\r\n\r\n### Webhook Credentials request timed out\r\n\r\n#### Possible Causes \r\n*  The request attempt to the URL specified in your Webhook Credential timed out\r\n\r\n#### Possible Solutions\r\n*  Poor network conditions between Twilio and your endpoint\r\n*  Large delay during request processing by your endpoint',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-03-28T12:02:40Z',
    last_updated: '2020-08-04T10:00:14.234Z',
  },
  21221: {
    code: 21221,
    message: 'Invalid SipAuthUsername. Must be fewer than 256 chars',
    log_level: 'WARNING',
    secondary_message: 'The SipAuthUsername you specified was longer than 255 characters.',
    log_type: null,
    docs: '## Warning - 21221\n\n### Invalid SipAuthUsername. Must be fewer than 256 chars\n\nThe SipAuthUsername you specified was longer than 255 characters.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:17Z',
    last_updated: '2020-08-04T10:00:25.75Z',
  },
  31101: {
    code: 31101,
    message: 'Missing parameter array in request.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31101\r\n\r\n### Missing parameter array in request.\r\n\r\nMissing parameter array in request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:41:46Z',
    last_updated: '2020-08-04T10:00:11.264Z',
  },
  20001: {
    code: 20001,
    message: 'Unknown parameters',
    log_level: 'WARNING',
    secondary_message:
      "One or more parameters you sent the REST API were not recognized and were ignored.  No harm done, but make sure that you didn't mis-type the parameter you really wanted to send.",
    log_type: null,
    docs: "## Warning - 20001 \n\n### Unknown parameters\n\nOne or more parameters you sent the REST API were not recognized and were ignored.  No harm done, but make sure that you didn't mis-type the parameter you really wanted to send.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:50Z',
    last_updated: '2020-08-04T10:00:27.463Z',
  },
  80801: {
    code: 80801,
    message: 'Invalid attempt to Re-Open a Session',
    log_level: 'ERROR',
    secondary_message: 'Participant is active in another Session',
    log_type: 'APPLICATION',
    docs: '## ERROR - 80801\r\n\r\n### Invalid attempt to Re-Open a Session\r\n\r\nParticipant is active in another Session A request was made to re-open a Session that would result in one or both of the Participants being active in multiple Sessions.  This could result in calls or messages from the affected Participant being routed to an unintended recipient.\r\n\r\n#### Possible Causes\r\nMultiple Sessions in your service have a Participant with the same identifier/proxy-identifier pair, and one of those was active at the time a request was made to re-open one of the closed sessions.\r\n\r\n#### Possible Solutions\r\n1. Avoid re-opening sessions unless you can be certain that the Participants have not been assigned the same ProxyIdentifier in other sessions.\r\n\r\n2. Ask that the ProxyAllowParticipantConflict flag be removed from your account.  By default, Proxy now rejects requests such as this one that would result in having two participants in active sessions with the same proxy identifier.  However, this new behavior requires removing the ProxyAllowParticipantConflict flag from your account.  When you are prepared to handle 400 on Session update requests (as well as 409 from Session create and Participant create endpoints), you can request to have this flag removed.\r\n\r\n3. Include the experimental form parameter FailOnParticipantConflict=true in your Session create/update and Participant create requests to allow Proxy to reject the individual request if it would result in this condition.  This will allow you to test your code before choosing to remove the ProxyAllowParticipantConflict flag described above.',
    causes:
      'Multiple Sessions in your service have a Participant with the same identifier/proxy-identifier pair, and one of those was active at the time a request was made to re-open one of the closed sessions.',
    solutions:
      '1. Avoid re-opening sessions unless you can be certain that the Participants have not been assigned the same ProxyIdentifier in other sessions.\r\n\r\n2. Ask that the ProxyAllowParticipantConflict flag be removed from your account.  By default, Proxy now rejects requests such as this one that would result in having two participants in active sessions with the same proxy identifier.  However, this new behavior requires removing the ProxyAllowParticipantConflict flag from your account.  When you are prepared to handle 400 on Session update requests (as well as 409 from Session create and Participant create endpoints), you can request to have this flag removed.\r\n\r\n3. Include the experimental form parameter FailOnParticipantConflict=true in your Session create/update and Participant create requests to allow Proxy to reject the individual request if it would result in this condition.  This will allow you to test your code before choosing to remove the ProxyAllowParticipantConflict flag described above.',
    description:
      'A request was made to re-open a Session that would result in one or both of the Participants being active in multiple Sessions.  This could result in calls or messages from the affected Participant being routed to an unintended recipient.',
    product: 'Proxy',
    date_created: '2020-07-29T23:24:50Z',
    last_updated: '2020-09-11T03:21:14.752Z',
  },
  60728: {
    code: 60728,
    message: 'Account exceeded the hourly messages limit',
    log_level: 'ERROR',
    secondary_message: 'Account exceeded the maximum amount of messages per hour',
    log_type: 'APPLICATION',
    docs: '## ERROR - 60728\r\n\r\n### Account exceeded the hourly messages limit\r\n\r\nAccount exceeded the maximum amount of messages per hour \r\n\r\n#### Possible Causes\r\nAccount has sent too many messages.\r\n\r\n#### Possible Solutions\r\n* Wait for sometime and try again.\r\n* Check your [support center](https://help.twilio.com/tickets) or email inbox/spam folder for outreach from the Twilio team on how to remove/raise your hourly limit.',
    causes: 'Account has sent too many messages.',
    solutions:
      '* Wait for sometime and try again.\r\n* Check your [support center](https://help.twilio.com/tickets) or email inbox/spam folder for outreach from the Twilio team on how to remove/raise your hourly limit.',
    description: null,
    product: 'Verify',
    date_created: '2024-04-15T05:28:57Z',
    last_updated: '2024-04-16T12:28:37.768268Z',
  },
  90028: {
    code: 90028,
    message: "Broadcast 'IdempotencyToken' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90028\r\n\r\n### Broadcast 'IdempotencyToken' is too long\r\n\r\n Broadcast 'IdempotencyToken' is too long\r\n\r\n#### Possible Causes\r\n'IdempotencyToken' field value has too long length\r\n\r\n#### Possible Solutions\r\nUse shorter string lenght for 'IdempotencyToken' field",
    causes: "'IdempotencyToken' field value has too long length",
    solutions: "Use shorter string lenght for 'IdempotencyToken' field",
    description: "Broadcast 'IdempotencyToken' is too long",
    product: null,
    date_created: '2020-12-11T13:17:16Z',
    last_updated: '2020-12-11T13:17:16Z',
  },
  13512: {
    code: 13512,
    message: 'Gather element has an invalid "language" attribute value',
    log_level: 'WARNING',
    secondary_message: 'A Gather element cannot have a "lang" attribute. Use "language" instead.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 13512\r\n\r\n### Gather element has an invalid "language" attribute value\r\n\r\n A Gather element has an invalid value for its "language" attribute. See [the accepted language values list](https://www.twilio.com/docs/voice/twiml/gather#languagetags) and update your Gather TwiML.\r\n\r\n#### Possible Causes\r\nYour Gather TwiML has an invalid language attribute value. (Example: `en` is an invalid value, but `en-US` is a valid value.) \r\n\r\n#### Possible Solutions\r\nFind your preferred language in [this list of accepted values](https://www.twilio.com/docs/voice/twiml/gather#languagetags) and update your Gather TwiML accordingly.',
    causes:
      'Your Gather TwiML has an invalid language attribute value. (Example: `en` is an invalid value, but `en-US` is a valid value.) ',
    solutions:
      'Find your preferred language in [this list of accepted values](https://www.twilio.com/docs/voice/twiml/gather#languagetags) and update your Gather TwiML accordingly.',
    description:
      'A Gather element has an invalid value for its "language" attribute. See [the accepted language values list](https://www.twilio.com/docs/voice/twiml/gather#languagetags) and update your Gather TwiML.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:43Z',
    last_updated: '2022-06-27T20:22:53.149354Z',
  },
  30014: {
    code: 30014,
    message: "'To' attributes are Invalid",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 30014 \r\n\r\n### "To" attributes are Invalid\r\n\r\nThe To attribute list is invalid or empty\r\n\r\n#### Possible Causes \r\n*  empty list\r\n*  to long list\r\n\r\n#### Possible Solutions\r\n*  Check the number of To attributes \r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-30T16:36:24Z',
    last_updated: '2020-08-04T10:00:10.957Z',
  },
  21100: {
    code: 21100,
    message: 'Accounts Resource',
    log_level: 'ERROR',
    secondary_message: 'Errors related to the Accounts resource',
    log_type: null,
    docs: '## Error - 21100 \n\n### Accounts Resource\n\nErrors related to the Accounts resource\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:52Z',
    last_updated: '2020-08-04T10:00:27.351Z',
  },
  60409: {
    code: 60409,
    message: 'Custom message did not match any template',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60409\r\n\r\n### Custom message did not match any template\r\n\r\n The custom message did not match any of our approved templates for your account.  Usage of approved message templates are strongly recommended as they increase the deliverability and conversion rate.\r\n\r\n#### Possible Causes\r\nYou have changed your custom message and it does not match any of our approved templates.\r\n\r\n#### Possible Solutions\r\nIn case you have changed the custom message, please return to the old one and contact support before changing it again. In case you have not changed the custom message, please contact support to provide the correct template for you.\r\nNote: Consider using templates instead of custom messages, if none of the available  templates work for you, please contact support and we can create it for you.',
    causes:
      'You have changed your custom message and it does not match any of our approved templates.',
    solutions:
      'In case you have changed the custom message, please return to the old one and contact support before changing it again. In case you have not changed the custom message, please contact support to provide the correct template for you.\r\nNote: Consider using templates instead of custom messages, if none of the available  templates work for you, please contact support and we can create it for you.',
    description:
      'The custom message did not match any of our approved templates for your account.  Usage of approved message templates are strongly recommended as they increase the deliverability and conversion rate.',
    product: 'Verify',
    date_created: '2021-08-09T01:54:51Z',
    last_updated: '2021-08-19T19:35:09.125984Z',
  },
  50323: {
    code: 50323,
    message: 'Programmable Chat: Invalid channel webhook sid',
    log_level: 'ERROR',
    secondary_message:
      'Request does not contain correctly formatted parameter for channel webhook sid',
    log_type: null,
    docs: '## Error - 50323\r\n\r\n### Programmable Chat: Invalid channel webhook sid\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for channel webhook sid\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T15:05:29Z',
    last_updated: '2020-08-04T10:00:12.098Z',
  },
  21476: {
    code: 21476,
    message: 'Unable to update Status for subaccount, parent account is suspended.',
    log_level: 'ERROR',
    secondary_message:
      'Unable to update Status for subaccount, parent account is suspended.  The account needs to be in good standing to continue using the subaccount feature.',
    log_type: null,
    docs: '## Error - 21476\n\n### Unable to update Status for subaccount, parent account is suspended.\n\nUnable to update Status for subaccount, parent account is suspended.  The account needs to be in good standing to continue using the subaccount feature.\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:24Z',
    last_updated: '2020-08-04T10:00:25.253Z',
  },
  50063: {
    code: 50063,
    message: 'Programmable Chat: Actions per second limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'Service instance actions per second limit exceeded',
    log_type: null,
    docs: '## Error - 50063\r\n\r\n### Programmable Chat: Actions per second limit exceeded\r\n\r\n#### Possible Causes \r\n*  Your application is generating too many actions per second (APS) for Chat service instance\r\n*  Note that the APS limit is enforced for commands such as sending a Message or creating a Channel - not Read actions\r\n\r\n#### Possible Solutions\r\n*  Make sure your application (client or backend) uses a good exponential back-off algorithm like the [one advocated by Amazon](https://www.awsarchitectureblog.com/2015/03/backoff.html) to retry on HTTP 429 (rate limiting) responses\r\n*  Reduce the rate of requests and introduce basic rate control, e.g. for user or channel provisioning use-cases\r\n*  Reduce number of concurrent requests\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-03-30T11:05:13Z',
    last_updated: '2020-08-04T10:00:20.035Z',
  },
  20426: {
    code: 20426,
    message: 'Upgrade Required',
    log_level: 'ERROR',
    secondary_message:
      'The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.',
    log_type: null,
    docs: "# Error - 20426\r\n\r\n## Upgrade Required\r\nThe server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.\r\n\r\n### TLS and cipher suite upgrade requirements\r\nIn moving towards a more secure posture with regards to [TLS](https://en.wikipedia.org/wiki/Transport_Layer_Security), we require that all new accounts must use TLS v1.2 or later. All customers must use TLS > 1.2 starting June 26, 2019.\r\n\r\nCustomers running older operating systems or legacy network software may need to upgrade their systems to be compatible with these changes. If you've received Error 20426, you likely need to upgrade your system.\r\n\r\nTo learn more about these changes, see our support site's FAQ on [Twilio REST API’s TLS and Cipher Suite Security Changes](https://support.twilio.com/hc/en-us/articles/360007820133-FAQ-Twilio-REST-API-s-TLS-and-Cipher-Suite-Security-Changes-for-June-2019)\r\n\r\n### Tips for upgrading your environment\r\nTo learn more about Twilio's TLS and cipher requirements, please reference [this support article](https://support.twilio.com/hc/en-us/articles/360006751753-Tips-for-Upgrading-Your-Environment-to-Support-Twilio-REST-API-s-TLS-and-Strong-Cipher-Suite-Changes) where you can learn more about understanding failure signatures, which components to upgrade, and verifying your upgrade.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-30T22:49:37Z',
    last_updated: '2020-08-04T10:00:10.866Z',
  },
  53105: {
    code: 53105,
    message: 'Room contains too many Participants',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53105: Room contains too many Participants\r\n\r\nRaised whenever a Client is unable to connect to a Room because the Room contains too many Participants.\r\n\r\n#### Causes\r\n\r\n * A Client attempted to connect to a Room that already contained the maximum number of Participants.\r\n\r\n#### Solutions\r\n\r\n * Have one or more Participants disconnect from the Room in order to make room for the Client to connect.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:43:03Z',
    last_updated: '2020-08-04T10:00:19.603Z',
  },
  90033: {
    code: 90033,
    message: "Broadcast recipient's 'to' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90033\r\n\r\n### Broadcast recipient's 'to' is too long\r\n\r\n Broadcast recipient's 'to' is too long\r\n\r\n#### Possible Causes\r\nToo long address and channel are used in Recipient's 'to'\r\n\r\n#### Possible Solutions\r\nUse correct channel type (sms|mms|etc) and appropriate address",
    causes: "Too long address and channel are used in Recipient's 'to'",
    solutions: 'Use correct channel type (sms|mms|etc) and appropriate address',
    description: "Broadcast recipient's 'to' is too long",
    product: null,
    date_created: '2020-12-11T13:28:46Z',
    last_updated: '2020-12-11T13:28:46Z',
  },
  22216: {
    code: 22216,
    message: 'Missing Supporting Document',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22216\r\n\r\n### Missing Supporting Document\r\n\r\n A Supporting Document satisfying the requirement is missing from the regulatory bundle.\r\n\r\n#### Possible Causes\r\nThe Regulation requires a Supporting Document which is missing from your Regulatory Bundle.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Regulations API resource to ensure that a Supporting Document satisfying the requirement is in the regulatory bundle.',
    causes:
      'The Regulation requires a Supporting Document which is missing from your Regulatory Bundle.',
    solutions:
      'Please refer to the Regulations API resource to ensure that a Supporting Document satisfying the requirement is in the regulatory bundle.',
    description:
      'A Supporting Document satisfying the requirement is missing from the regulatory bundle.',
    product: 'Phone Numbers',
    date_created: '2020-04-23T22:26:28Z',
    last_updated: '2020-08-04T10:00:03.676Z',
  },
  31007: {
    code: 31007,
    message: 'Twilio Client: Client version not supported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31007\r\n\r\n### Twilio Client: This JS client version has been deprecated\r\n\r\n#### Possible Solutions\r\n\r\n- Migrate to newer version of Twilio JS client by following the direction provided here: https://www.twilio.com/docs/voice/client/javascript/sdk-11-12-migration-guide',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2018-08-27T20:31:01Z',
    last_updated: '2020-08-04T10:00:12.804Z',
  },
  45008: {
    code: 45008,
    message: 'Unprocessable Request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45008\r\n\r\n### Unprocessable Request\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe server is not able to process the request due to something that is perceived to be a client error (e.g. malformed request syntax or invalid request message).\r\n\r\n#### Possible Solutions\r\nPlease verify the request details and ensure Flex setup and preconditions for this request have been met before trying again. ',
    causes:
      'The server is not able to process the request due to something that is perceived to be a client error (e.g. malformed request syntax or invalid request message).',
    solutions:
      'Please verify the request details and ensure Flex setup and preconditions for this request have been met before trying again. ',
    description: null,
    product: 'Flex',
    date_created: '2019-07-08T11:30:06Z',
    last_updated: '2020-08-04T10:00:07.767Z',
  },
  50702: {
    code: 50702,
    message:
      'Verify Agent participant should not have identity, user address, proxy address, projected address.',
    log_level: 'ERROR',
    secondary_message:
      'Verify Agent participant should not have identity, user address, proxy address, projected address.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50702\r\n\r\n### Verify Agent participant should not have identity, user address, proxy address, projected address.\r\n\r\nVerify Agent participant should not have identity, user address, proxy address, projected address. \r\n\r\n#### Possible Causes\r\nVirtual Agent participant should have only ChatbotConfiguration prefixed fields. Other fields are not available for Virtual Agent participants.\r\n\r\n#### Possible Solutions\r\n* Check your request and remove identity, user address, proxy address, projected address from it.',
    causes:
      'Virtual Agent participant should have only ChatbotConfiguration prefixed fields. Other fields are not available for Virtual Agent participants.',
    solutions:
      '* Check your request and remove identity, user address, proxy address, projected address from it.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T17:59:15Z',
    last_updated: '2023-10-11T17:59:15Z',
  },
  48023: {
    code: 48023,
    message: 'Frontline user conversation limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 48023\r\n\r\n### Frontline user conversation limit exceeded\r\n\r\n A conversation could not be created because the Conversations user associated to the given Frontline user is a participant in too many conversations.\r\n\r\n#### Possible Causes\r\n* The Conversations user associated to the given Frontline user attempted to create a conversation and exceeded the Conversations service’s maximum user conversations limit.\r\n\r\n#### Possible Solutions\r\n* If you frequently exceed the user conversations limit for the Frontline Conversations service, you may want to consider raising your user conversations limit.\r\n    * Read more about Conversations API user conversations limits in our [docs](https://www.twilio.com/docs/conversations/conversations-limits#maximum-channelsconversations-per-identity).\r\n    * In order to request a limit increase, please contact [customer support](http://twilio.com/console/support/tickets/create).\r\n* Ask the Frontline user to close or transfer some of their active conversations.\r\n* Delete conversations the user is a participant in.',
    causes:
      '* The Conversations user associated to the given Frontline user attempted to create a conversation and exceeded the Conversations service’s maximum user conversations limit.',
    solutions:
      '* If you frequently exceed the user conversations limit for the Frontline Conversations service, you may want to consider raising your user conversations limit.\r\n    * Read more about Conversations API user conversations limits in our [docs](https://www.twilio.com/docs/conversations/conversations-limits#maximum-channelsconversations-per-identity).\r\n    * In order to request a limit increase, please contact [customer support](http://twilio.com/console/support/tickets/create).\r\n* Ask the Frontline user to close or transfer some of their active conversations.\r\n* Delete conversations the user is a participant in.',
    description:
      'A conversation could not be created because the Conversations user associated to the given Frontline user is a participant in too many conversations.',
    product: 'Frontline',
    date_created: '2022-04-20T15:48:11Z',
    last_updated: '2022-05-20T10:01:02.362681Z',
  },
  20009: {
    code: 20009,
    message: 'Cannot delete this resource before it is complete',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## ERROR - 20009\r\n\r\n### Cannot delete this resource before it is complete\r\n\r\n You attempted to delete a call or message resource before it was completed. If you are attempting to delete a call, wait until the call is completed and try your request again. If you are attempting to delete a message, wait several minutes and try again.\r\n\r\nIf you're seeing a message in the logs that you have already deleted, please allow up to 14 days for our systems to completely remove this record before reaching out to support.\r\n\r\n#### Possible Causes\r\n* You requested the call or message be deleted before all of Twilio's systems finished processing it.\r\n* In rare cases, a message or call record may take up to 14 days to be finalized and able to be deleted.\r\n\r\n#### Possible Solutions\r\n* If you are attempting to delete a call, verify that the call is not still in-progress.\r\n* If you are attempting to delete a call or message shortly after sending or receiving it, please wait at least 1 minute to make your DELETE request. If you receive this error after waiting 1 minute, wait several minutes and retry deletion again.\r\n* If you encounter this issue frequently even when waiting several minutes before deleting a message or a completed call, please [contact Twilio support](https://www.twilio.com/console/support/tickets/create) with examples of affected Call or Message SIDs.\r\n* For the highest level of privacy for Twilio SMS messages, apply for [message redaction](https://ahoy.twilio.com/message-redaction) which can automatically redact message bodies or phone numbers immediately after a message is sent or received.",
    causes:
      "* You requested the call or message be deleted before all of Twilio's systems finished processing it.\r\n* In rare cases, a message or call record may take up to 14 days to be finalized and able to be deleted.",
    solutions:
      '* If you are attempting to delete a call, verify that the call is not still in-progress.\r\n* If you are attempting to delete a call or message shortly after sending or receiving it, please wait at least 1 minute to make your DELETE request. If you receive this error after waiting 1 minute, wait several minutes and retry deletion again.\r\n* If you encounter this issue frequently even when waiting several minutes before deleting a message or a completed call, please [contact Twilio support](https://www.twilio.com/console/support/tickets/create) with examples of affected Call or Message SIDs.\r\n* For the highest level of privacy for Twilio SMS messages, apply for [message redaction](https://ahoy.twilio.com/message-redaction) which can automatically redact message bodies or phone numbers immediately after a message is sent or received.',
    description:
      "You attempted to delete a call or message resource before it was completed. If you are attempting to delete a call, wait until the call is completed and try your request again. If you are attempting to delete a message, wait several minutes and try again.\r\n\r\nIf you're seeing a message in the logs that you have already deleted, please allow up to 14 days for our systems to completely remove this record before reaching out to support.",
    product: null,
    date_created: '2017-03-03T21:14:43Z',
    last_updated: '2020-08-04T10:00:20.224Z',
  },
  60331: {
    code: 60331,
    message: 'Locale requested is not supported by Verify Text-To-Speech conversion',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60331\r\n\r\n### Locale requested is not supported by Verify Text-To-Speech conversion\r\n\r\n ## Error - 60331\r\n\r\n### Invalid Parameter\r\n\r\nLocale requested is not supported by Verify Text-To-Speech conversion.\r\n\r\n#### Possible Causes\r\nThe user have provided a Locale to be used that is not supported for Text-to-Speech.\r\n\r\n#### Possible Solutions\r\nProvide a supported Text-To-Speech using this documentation. https://support.twilio.com/hc/en-us/articles/223132827-What-Languages-can-the-Say-TwiML-Verb-Speak-',
    causes: 'The user have provided a Locale to be used that is not supported for Text-to-Speech.',
    solutions:
      'Provide a supported Text-To-Speech using this documentation. https://support.twilio.com/hc/en-us/articles/223132827-What-Languages-can-the-Say-TwiML-Verb-Speak-',
    description:
      '## Error - 60331\r\n\r\n### Invalid Parameter\r\n\r\nLocale requested is not supported by Verify Text-To-Speech conversion.',
    product: 'Verify',
    date_created: '2022-08-17T20:42:49Z',
    last_updated: '2022-08-17T20:42:49Z',
  },
  22123: {
    code: 22123,
    message: 'Unable to Initiate Verification Call',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22123\r\n\r\n#### Unable to Initiate Verification Call\r\n\r\n#### Possible Causes\r\n\r\n* The number you are trying to verify cannot be reached.\r\n\r\n* Your account is not allowed to call the number you are trying to verify.\r\n\r\n* The number you are attempting to verify has been blocked.\r\n\r\n* You are attempting to verify a number that is not a valid phone number.\r\n\r\n#### Possible Solutions\r\n\r\nPlease reach out to HostedSMS@twilio.com.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-27T21:58:54Z',
    last_updated: '2020-08-04T10:00:14.641Z',
  },
  94302: {
    code: 94302,
    message: 'Transcriptions Configurations: UniqueName is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 94302\r\n\r\n### Transcriptions Configurations: UniqueName is invalid\r\n\r\n Invalid UniqueName value, either to create a new configuration or update existing one\r\n\r\n#### Possible Causes\r\n* "UniqueName" already associated to another configuration\r\n* "UniqueName" is blank or null\r\n* Invalid "UniqueName" value: Length should be between 1 and 50 characters, can’t contain blank spaces or special characters and can’t be a Transcription Configuration Sid\r\n\r\n#### Possible Solutions\r\n* Specify a valid "UniqueName" for transcription configuration',
    causes:
      '* "UniqueName" already associated to another configuration\r\n* "UniqueName" is blank or null\r\n* Invalid "UniqueName" value: Length should be between 1 and 50 characters, can’t contain blank spaces or special characters and can’t be a Transcription Configuration Sid',
    solutions: '* Specify a valid "UniqueName" for transcription configuration',
    description:
      'Invalid UniqueName value, either to create a new configuration or update existing one',
    product: null,
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2021-09-08T10:33:56.048362Z',
  },
  52400: {
    code: 52400,
    message: 'Exceeded maximum iterations in template rendering',
    log_level: 'ERROR',
    secondary_message:
      'The maximum number of defined iterations in templated fields of the notification payload has been reached.',
    log_type: 'TWILIO',
    docs: '## ERROR - 52400\r\n\r\n### Exceeded maximum iterations in template rendering\r\n\r\nThe maximum number of defined iterations in templated fields of the notification payload has been reached. Your template contains an iterative operation that has reached the maximum allowed limit of 1000 iterations in its definition.\r\n\r\n#### Possible Causes\r\nSome syntax-specific iteration operators in the template, such as for-loops, cycles, table-rows, and others, may have reached the maximum limit.\r\n\r\n#### Possible Solutions\r\n1. Consider reducing the number of iterations required in your template.\r\n2. Review the template structure to optimize the use of iteration operations.\r\n3. Break down complex iterations into smaller, more manageable chunks if possible.',
    causes:
      'Some syntax-specific iteration operators in the template, such as for-loops, cycles, table-rows, and others, may have reached the maximum limit.',
    solutions:
      '1. Consider reducing the number of iterations required in your template.\r\n2. Review the template structure to optimize the use of iteration operations.\r\n3. Break down complex iterations into smaller, more manageable chunks if possible.',
    description:
      'Your template contains an iterative operation that has reached the maximum allowed limit of 1000 iterations in its definition.',
    product: 'Notify',
    date_created: '2024-03-19T15:53:39Z',
    last_updated: '2024-03-19T15:53:39Z',
  },
  13613: {
    code: 13613,
    message: 'Record: Invalid finishOnKey value',
    log_level: 'WARNING',
    secondary_message:
      'The value of the finishOnKey attribute must be one of the following characters "0123456789#*".  See the <a href=\'/docs/api/twiml/record#maxLength\'>Record Verb</a> API Reference for more information.',
    log_type: null,
    docs: '## Warning - 13613 \n\n### Record: Invalid finishOnKey value\n\nThe value of the finishOnKey attribute must be one of the following characters "0123456789#*".  See the <a href=\'/docs/api/twiml/record#maxLength\'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:45Z',
    last_updated: '2020-08-04T10:00:27.82Z',
  },
  11210: {
    code: 11210,
    message: 'HTTP bad host name',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 11210\r\n\r\n### HTTP bad host name\r\n\r\n The DNS entry for the URL’s host cannot be resolved.\r\n\r\n\r\n#### Possible Causes\r\n* URL references a locally defined hostname (check your `/etc/hosts`)\r\n* URL references an undefined hostname\r\n\r\n#### Possible Solutions\r\n* Verify the hostname of the URL has a valid DNS record the can be resolved by the public',
    causes:
      '* URL references a locally defined hostname (check your `/etc/hosts`)\r\n* URL references an undefined hostname',
    solutions:
      '* Verify the hostname of the URL has a valid DNS record the can be resolved by the public',
    description: 'The DNS entry for the URL’s host cannot be resolved.\r\n',
    product: null,
    date_created: '2016-03-31T17:13:24Z',
    last_updated: '2021-03-15T09:50:26.671Z',
  },
  21219: {
    code: 21219,
    message: "'To' phone number not verified",
    log_level: 'ERROR',
    secondary_message:
      "You attempted to initiate an outbound phone call from a trial account, but the 'To' number you specified is not a verified number for your account. In order to make calls during a free trial, you must first verify your ownership of the phone number being called.  You can verify phone numbers from the [phone numbers section](/user/account/phone-numbers) of your account portal.",
    log_type: null,
    docs: "## Error - 21219\n\n### 'To' phone number not verified\n\nYou attempted to initiate an outbound phone call from a trial account, but the\n'To' number you specified is not a verified number for your account. In order\nto make calls during a free trial, you must first verify your ownership of the\nphone number being called.\n\nYou can verify phone numbers from the [phone numbers\nsection](/user/account/phone-numbers) of your account portal.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:16Z',
    last_updated: '2020-08-04T10:00:25.786Z',
  },
  21404: {
    code: 21404,
    message: 'Inbound Phone number not available to trial account',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to get a phone number using the REST API, but your Twilio Free Trial Account does not support having your own phone number.  Please upgrade to a Full Twilio Account in order to enable this feature.',
    log_type: null,
    docs: '## Error - 21404\n\n### Inbound phone numbers not available to trial accounts\n\nPurchasing phone numbers is a feature that is only available for upgraded\naccounts. Please upgrade to a Full Twilio Account in order to purchase numbers.\n\nYou can upgrade from the [billing section](/user/billing) of your account\nportal. \n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:59Z',
    last_updated: '2020-08-04T10:00:27.009Z',
  },
  40154: {
    code: 40154,
    message: 'Invalid Known Worker information',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 40154\r\n\r\n### Invalid Known Worker information\r\n\r\n Worker information is missing or not valid.\r\n\r\n#### Possible Causes\r\nThe Task does not have a field that holds the Known Worker information, the Worker information specified is invalid, or the specified Worker does not exist in TaskRouter.\r\n\r\n#### Possible Solutions\r\nEnsure the Task field referenced in the Workflow definition is provided in the Task's attributes. If Worker information is provided, make sure that the Worker does exist in TaskRouter. Find out more about the Known Worker Routing feature here: https://www.twilio.com/docs/taskrouter/workflow-configuration/known-agent-routing",
    causes:
      'The Task does not have a field that holds the Known Worker information, the Worker information specified is invalid, or the specified Worker does not exist in TaskRouter.',
    solutions:
      "Ensure the Task field referenced in the Workflow definition is provided in the Task's attributes. If Worker information is provided, make sure that the Worker does exist in TaskRouter. Find out more about the Known Worker Routing feature here: https://www.twilio.com/docs/taskrouter/workflow-configuration/known-agent-routing",
    description: 'Worker information is missing or not valid.',
    product: 'TaskRouter',
    date_created: '2021-09-21T20:28:43Z',
    last_updated: '2021-09-21T20:28:43Z',
  },
  21622: {
    code: 21622,
    message: 'MMS has not been enabled for your account',
    log_level: 'ERROR',
    secondary_message:
      'Your account has not been enabled for picture messaging. Please contact support to send picture messages.',
    log_type: null,
    docs: '## Error - 21622\n\n### MMS has not been enabled for your account\n\nYour account has not been enabled for picture messaging.  Please [contact support](/help/contact) to send picture messages\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:28Z',
    last_updated: '2020-08-04T10:00:24.934Z',
  },
  45380: {
    code: 45380,
    message: 'Failed to activate Channel. Internal error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45380\r\n\r\n### Failed to activate Channel. Internal error.\r\n\r\n Failed to activate a Channel <channel sid> due to an internal error.\r\n\r\n#### Possible Causes\r\nWe failed to active a Channel due to an unexpected error condition.\r\n\r\n#### Possible Solutions\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We failed to active a Channel due to an unexpected error condition.',
    solutions:
      'Check our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'Failed to activate a Channel <channel sid> due to an internal error.',
    product: 'Flex',
    date_created: '2023-08-28T21:55:58Z',
    last_updated: '2023-08-28T21:55:58Z',
  },
  50711: {
    code: 50711,
    message: 'ChatbotConfiguration.FriendlyName is reserved.',
    log_level: 'ERROR',
    secondary_message: 'ChatbotConfiguration.FriendlyName is reserved.',
    log_type: 'TWILIO',
    docs: '## ERROR - 50711\r\n\r\n### ChatbotConfiguration.FriendlyName is reserved.\r\n\r\nChatbotConfiguration.FriendlyName is reserved. \r\n\r\n#### Possible Causes\r\nYou are trying to create Virtual Agent participant with ChatbotConfiguration.FriendlyName as "system".\r\n\r\n#### Possible Solutions\r\n* "system" is a reserved name for Virtual Agent participant. Please use another name.',
    causes:
      'You are trying to create Virtual Agent participant with ChatbotConfiguration.FriendlyName as "system".',
    solutions:
      '* "system" is a reserved name for Virtual Agent participant. Please use another name.',
    description: null,
    product: 'Conversations',
    date_created: '2023-10-11T18:08:02Z',
    last_updated: '2023-10-11T18:08:02Z',
  },
  61002: {
    code: 61002,
    message: 'Add-ons: Provider could not complete request',
    log_level: 'ERROR',
    secondary_message:
      'The Add-on Provider  provided a HTTP Status Code in the 500 range. This indicates an error processing the Add-on Request on the Vendors side.',
    log_type: null,
    docs: '## Error - 61002\r\n\r\n### Add-ons: Provider could not complete request\r\n\r\n#### Possible Causes \r\n*  The Add-on Provider  provided a HTTP Status Code in the 500 range. This indicates an error processing the Add-on Request on the Vendors side. ',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:36:32Z',
    last_updated: '2020-08-04T10:00:21.579Z',
  },
  80506: {
    code: 80506,
    message: 'Service Creation is restricted for new customers',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 80506\r\n\r\n### Service Creation is restricted for new customers\r\n\r\n Blocking Proxy Service Creation API for new accounts/sub-accounts/projects as Proxy is in EOS.\r\n\r\n#### Possible Causes\r\nProxy is in EOS and hence, we are blocking the service creation request for new accounts/sub-accounts/projects.\r\n\r\n#### Possible Solutions\r\nIf required, ask for an exempt for your account',
    causes:
      'Proxy is in EOS and hence, we are blocking the service creation request for new accounts/sub-accounts/projects.',
    solutions: 'If required, ask for an exempt for your account',
    description:
      'Blocking Proxy Service Creation API for new accounts/sub-accounts/projects as Proxy is in EOS.',
    product: 'Proxy',
    date_created: '2022-11-15T15:54:15Z',
    last_updated: '2024-04-15T11:00:26.058039Z',
  },
  95113: {
    code: 95113,
    message: 'Corrupted media provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95113\r\n\r\n### Corrupted media provided\r\n\r\n The media file is corrupted and could not be opened.\r\n\r\n#### Possible Causes\r\nCorruption of data.\r\nError recording media.\r\n\r\n#### Possible Solutions\r\nVerify the media is not corrupted or use another media.',
    causes: 'Corruption of data.\r\nError recording media.',
    solutions: 'Verify the media is not corrupted or use another media.',
    description: 'The media file is corrupted and could not be opened.',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:38:04Z',
    last_updated: '2024-04-16T17:38:04Z',
  },
  52147: {
    code: 52147,
    message: 'Too many APNs provider token updates',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52147\r\n\r\n### Too many APNs provider token updates"\r\n\r\n#### Possible Causes \r\n* A new APNs provider token is being generated too often\r\n* The APNs provider token is not cached by Twilio\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-04-04T09:59:45Z',
    last_updated: '2020-08-04T10:00:14.062Z',
  },
  20008: {
    code: 20008,
    message: 'Test Credentials',
    log_level: 'ERROR',
    secondary_message:
      'Currently only a handful of API resources can be tested with your test credentials. Trying to authenticate with your test credentials to other resources will return a Forbidden error message. For a full list of supported resources, please see our [Test Credentials](/docs/api/rest/test-credentials) page.',
    log_type: null,
    docs: '## Error - 20008\n\n#### Cannot access this resource with Test Credentials\n\nCurrently only a handful of API resources can be tested with your test\ncredentials. Trying to authenticate with your test credentials to other\nresources will return a Forbidden error message. For a full list of supported\nresources, please see our [Test Credentials](/docs/api/rest/test-credentials)\npage.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:14Z',
    last_updated: '2020-08-04T10:00:25.906Z',
  },
  51115: {
    code: 51115,
    message: 'Twilsock: Invalid access token subject',
    log_level: 'ERROR',
    secondary_message: 'Subject provided in the token is invalid.',
    log_type: null,
    docs: '## Error - 51115\r\n\r\n### Invalid access token subject\r\n\r\n#### Possible Causes \r\nSubject provided in the token is invalid.\r\n\r\n#### Possible Solutions\r\nConfirm a valid token is being passed with a valid subject. \r\n\r\nTo check whether the token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:49:52Z',
    last_updated: '2020-08-04T10:00:09.659Z',
  },
  32222: {
    code: 32222,
    message: 'TLS version not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 32222\r\n\r\n### TLS version not allowed\r\n\r\n The TLS version used by your SIP endpoints is lower than the one configured for your account. It's highly recommended to upgrade your SIP endpoints to use TLSv1.2. Otherwise, you can opt in to use deprecated TLS versions in the console. By default, only TLSv1.2 is allowed.\r\n\r\n#### Possible Causes\r\nSIP/TLS version is lower than the allowed\r\n\r\n#### Possible Solutions\r\nUpgrade TLS version or configure your account to allow all TLSv1+ in console (Voice → Settings → General → Allow Deprecated SIP/TLS versions)",
    causes: 'SIP/TLS version is lower than the allowed',
    solutions:
      'Upgrade TLS version or configure your account to allow all TLSv1+ in console (Voice → Settings → General → Allow Deprecated SIP/TLS versions)',
    description:
      "The TLS version used by your SIP endpoints is lower than the one configured for your account. It's highly recommended to upgrade your SIP endpoints to use TLSv1.2. Otherwise, you can opt in to use deprecated TLS versions in the console. By default, only TLSv1.2 is allowed.",
    product: 'Elastic SIP Trunking',
    date_created: '2022-01-31T18:20:25Z',
    last_updated: '2022-03-29T17:20:46.327836Z',
  },
  53303: {
    code: 53303,
    message: 'Track name contains invalid characters',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53303: Track name contains invalid characters\r\n\r\nRaised whenever a Track name contains invalid characters.\r\n\r\n#### Causes\r\n\r\n * The Track name contains an invalid UTF-8 byte sequence.\r\n\r\n#### Solutions\r\n\r\n * Choose a Track name that is a valid UTF-8 string.\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-10-12T20:00:45Z',
    last_updated: '2020-08-04T10:00:16.889Z',
  },
  31503: {
    code: 31503,
    message: 'Service Unavailable',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31503\r\n\r\n### Service Unavailable\r\n\r\n ## Error - 31503\r\n\r\n### Service Unavailable\r\n\r\nThe server is currently unable to handle the request due to a temporary overloading or maintenance of the server. This error can also be caused by the Application SID provided in the access token pointing to an inaccessible URL.\r\n\r\n#### Possible Causes\r\n* The server is under maintenance.\r\n* The Application SID provided in the access token points to an inaccessible URL.\r\n\r\n#### Possible Solutions\r\nPlease check the Application SID URL. For further assistance, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes:
      '* The server is under maintenance.\r\n* The Application SID provided in the access token points to an inaccessible URL.',
    solutions:
      'Please check the Application SID URL. For further assistance, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description:
      '## Error - 31503\r\n\r\n### Service Unavailable\r\n\r\nThe server is currently unable to handle the request due to a temporary overloading or maintenance of the server. This error can also be caused by the Application SID provided in the access token pointing to an inaccessible URL.',
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:46:25Z',
    last_updated: '2023-11-01T04:46:16.499246Z',
  },
  80404: {
    code: 80404,
    message: 'Participant Identifier Invalid',
    log_level: 'ERROR',
    secondary_message:
      'Participant identifier provided does not appear to be a valid, reachable phone number.',
    log_type: 'APPLICATION',
    docs: "## ERROR - 80404\r\n\r\n### Participant Identifier Invalid\r\n\r\nParticipant identifier provided does not appear to be a valid, reachable phone number. \r\n\r\n#### Possible Causes\r\nThe participant's number passed in the participant creation is incorrect.\r\n\r\n#### Possible Solutions\r\nPass a valid participant's number in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).",
    causes: "The participant's number passed in the participant creation is incorrect.",
    solutions:
      "Pass a valid participant's number in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).",
    description: null,
    product: 'Proxy',
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:15.979Z',
  },
  50360: {
    code: 50360,
    message: 'Conversation webhook not found',
    log_level: 'ERROR',
    secondary_message: 'The requested webhook SID was not found.',
    log_type: null,
    docs: '\n## Error - 50360\n\n### Conversations: Conversation webhook not found\nThe requested webhook SID was not found.\n\n#### Possible Causes\n* The conversation webhook SID you are requesting does not exist in that conversation.\n\n#### Possible Solutions\n* Check that the requested webhook SID is actually a Webhook SID, and is not misspelled (prefix should be WH).\n* Check that the requested webhook SID belongs to the targeted conversation.\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.839Z',
  },
  50444: {
    code: 50444,
    message: 'Failed to add an identity to a participant.',
    log_level: 'ERROR',
    secondary_message: 'The participant should not have an identity in order to add an identity.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50444\r\n\r\n### Failed to add an identity to a participant.\r\n\r\nThe participant should not have an identity in order to add an identity. The conversation participant being updated can not have an identity.\r\n\r\n#### Possible Causes\r\n* You are trying to add an identity to a participant with identity already assigned.\r\n* You are trying to add an identity to a participant without projected address.\r\n\r\n#### Possible Solutions\r\n* Check that the request does not update identity of this particular participant.',
    causes:
      '* You are trying to add an identity to a participant with identity already assigned.\r\n* You are trying to add an identity to a participant without projected address.',
    solutions: '* Check that the request does not update identity of this particular participant.',
    description: 'The conversation participant being updated can not have an identity.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:04:02Z',
    last_updated: '2021-08-16T12:04:02Z',
  },
  61006: {
    code: 61006,
    message: 'Add-ons: Add-ons unavailable for GET callbacks',
    log_level: 'WARNING',
    secondary_message:
      'Due to the size limitations of GET callbacks we do not include Add-on results in GET callbacks',
    log_type: null,
    docs: '## Error - 61006\r\n\r\n### Add-ons: Add-ons unavailable for GET callbacks\r\n\r\n#### Possible Causes \r\n*  Due to the size limitations of GET callbacks we do not include Add-on results in GET callbacks',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:38:04Z',
    last_updated: '2020-08-04T10:00:21.47Z',
  },
  13620: {
    code: 13620,
    message: 'Record: Transcription not available for this recording',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13620\r\n\r\n### Record: Transcription not available for this recording\r\n\r\n Record: Transcription feature not available for this recording.\r\n\r\n#### Possible Causes\r\nTranscription feature not supported for recordings when your account has one or more of the following features enabled: Recording Encryption, PCI recordings.\r\n\r\n#### Possible Solutions\r\nContact support to disable the corresponding feature(s) on your account.',
    causes:
      'Transcription feature not supported for recordings when your account has one or more of the following features enabled: Recording Encryption, PCI recordings.',
    solutions: 'Contact support to disable the corresponding feature(s) on your account.',
    description: 'Record: Transcription feature not available for this recording.',
    product: 'Programmable Voice',
    date_created: '2016-10-11T17:58:00Z',
    last_updated: '2020-08-04T10:00:20.618Z',
  },
  20010: {
    code: 20010,
    message: 'Action disabled for account',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20010\r\n\r\n#### Action disabled for account\r\n\r\n The action you attempted to perform has been disabled for your account. Please contact Customer Support for assistance.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-03-03T21:15:29Z',
    last_updated: '2020-08-04T10:00:20.199Z',
  },
  84003: {
    code: 84003,
    message: 'Unable to render block.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 84003\r\n\r\n### Unable to render block.\r\n\r\n A block could not be rendered. \r\n\r\n#### Possible Causes\r\n- Liquid values used in the block might not be correct.\r\n\r\n#### Possible Solutions\r\n- Check the liquid expressions in the block evaluate to a proper value.',
    causes: '- Liquid values used in the block might not be correct.',
    solutions: '- Check the liquid expressions in the block evaluate to a proper value.',
    description: 'A block could not be rendered. ',
    product: null,
    date_created: '2024-01-10T18:10:41Z',
    last_updated: '2024-01-10T18:10:41Z',
  },
  45212: {
    code: 45212,
    message: 'Flex Flow creation failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45212\r\n\r\n### Flex Flow creation failed\r\n\r\n Flex Flow creation failed\r\n\r\n#### Possible Causes\r\nSome request attributes were either missing, invalid, or collided with existing Flex Flows.\r\n\r\n#### Possible Solutions\r\nCheck the returned error details for additional info and adjust the request as necessary.',
    causes:
      'Some request attributes were either missing, invalid, or collided with existing Flex Flows.',
    solutions:
      'Check the returned error details for additional info and adjust the request as necessary.',
    description: 'Flex Flow creation failed',
    product: 'Flex',
    date_created: '2022-02-16T07:55:23Z',
    last_updated: '2022-05-03T07:44:05.146128Z',
  },
  63033: {
    code: 63033,
    message: 'Recipient opted out to receive message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63033\r\n\r\n### Recipient opted out to receive message\r\n\r\n The WhatsApp message you are attempting to send uses a "Marketing" category template and the user you are trying to reach has opted out from receiving your marketing messages.\r\n\r\n#### Possible Causes\r\nRecipient has opted out of WhatsApp marketing messages from your business.\r\n\r\n#### Possible Solutions\r\nThe user needs to opt back into WhatsApp marketing messages from your business. You may still send templated WhatsApp messages of other categories, such as Authentication and Utility, to this user.',
    causes: 'Recipient has opted out of WhatsApp marketing messages from your business.',
    solutions:
      'The user needs to opt back into WhatsApp marketing messages from your business. You may still send templated WhatsApp messages of other categories, such as Authentication and Utility, to this user.',
    description:
      'The WhatsApp message you are attempting to send uses a "Marketing" category template and the user you are trying to reach has opted out from receiving your marketing messages.',
    product: 'Programmable SMS',
    date_created: '2019-07-25T22:53:29Z',
    last_updated: '2023-10-13T22:01:58.444821Z',
  },
  22154: {
    code: 22154,
    message: 'Port In Error - Invalid Address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 22154\r\n\r\n### Port In Error - Invalid Address\r\n\r\n The address submitted in the port in request does not match the losing carrier's information for this phone number. \r\n\r\n#### Possible Causes\r\nThe address submitted in the port in request does not match the losing carrier's information for this phone number. \r\n\r\n#### Possible Solutions\r\nCheck the address submitted in the port in request for typos or change it to an address that matches the losing carrier's information for this phone number. \r\n\r\nNote if this is the only phone number in a port in request that got rejected you may need to start a new port in request with this phone number so that you can correct the address as it may be different from the other phone numbers in this request. ",
    causes:
      "The address submitted in the port in request does not match the losing carrier's information for this phone number. ",
    solutions:
      "Check the address submitted in the port in request for typos or change it to an address that matches the losing carrier's information for this phone number. \r\n\r\nNote if this is the only phone number in a port in request that got rejected you may need to start a new port in request with this phone number so that you can correct the address as it may be different from the other phone numbers in this request. ",
    description:
      "The address submitted in the port in request does not match the losing carrier's information for this phone number. ",
    product: 'Phone Numbers',
    date_created: '2024-04-22T23:04:26Z',
    last_updated: '2024-04-22T23:04:26Z',
  },
  63042: {
    code: 63042,
    message: 'Template disabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63042\r\n\r\n### Template disabled\r\n\r\n WhatsApp has reported that the template has been **permanently disabled** due to recurring negative feedback from customers. Message templates with this status cannot be sent to customers. For the most updated guidelines, please view WhatsApp’s documentation: https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/#template-pausing.\r\n\r\n\r\n#### Possible Causes\r\nNegative customer feedback (i.e. multiple customers reporting messages or blocking number)\r\n\r\n#### Possible Solutions\r\n- Use a different template\r\n- Create a new template',
    causes:
      'Negative customer feedback (i.e. multiple customers reporting messages or blocking number)',
    solutions: '- Use a different template\r\n- Create a new template',
    description:
      'WhatsApp has reported that the template has been **permanently disabled** due to recurring negative feedback from customers. Message templates with this status cannot be sent to customers. For the most updated guidelines, please view WhatsApp’s documentation: https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/#template-pausing.\r\n',
    product: 'Programmable Messaging',
    date_created: '2022-11-22T15:11:24Z',
    last_updated: '2022-11-22T15:12:19.762185Z',
  },
  60405: {
    code: 60405,
    message: 'Key Storage Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60405\r\n\r\n### Key Storage Error\r\n\r\n An error occurred while storing/loading keypairs.\r\n\r\n#### Possible Causes\r\n* Keypair not set.\r\n* Keypair could not be created.\r\n* Signature failed.\r\n\r\n#### Possible Solutions\r\nCreate a new factor.',
    causes: '* Keypair not set.\r\n* Keypair could not be created.\r\n* Signature failed.',
    solutions: 'Create a new factor.',
    description: 'An error occurred while storing/loading keypairs.',
    product: 'Verify',
    date_created: '2021-03-15T20:46:04Z',
    last_updated: '2021-03-15T20:46:04Z',
  },
  52002: {
    code: 52002,
    message: 'Invalid Credential Sid',
    log_level: 'ERROR',
    secondary_message: 'Provided credential sid is invalid or empty',
    log_type: null,
    docs: '## Error - 52002\r\n\r\n### Invalid Credential Sid\r\nIn order to send push notifications to iOS and Android devices you need to configure a Credential that allows Twilio to send notifications to your app. \r\n\r\nYou can configure these at different places depending on which Twilio product you use:\r\n\r\n* Chat: Configure in access token\r\n* Notify: Configure default Credential in Notify Service or Binding specific one in Binding\r\n* Voice SDK: Configure in access token\r\n\r\n#### Possible Causes \r\n*   Credential SID is not configured correctly\r\n\r\n#### Possible Solutions\r\n* If using Chat include Credential SID in access token. Check out this [guide](https://www.twilio.com/docs/api/ip-messaging/guides/push-notifications-ios)\r\n*  If using Notify, either configure default Credential SID in your [Service](https://www.twilio.com/console/notify/services) or provide the Credential SID in the [Create Binding](https://www.twilio.com/docs/api/notify/rest/bindings#create-a-binding) request\r\n* If using Voice SDK, include Credential SID in access token. Check out our [documentation](https://www.twilio.com/docs/api/voice-sdk) for details',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:00:27Z',
    last_updated: '2020-08-04T10:00:22.505Z',
  },
  30712: {
    code: 30712,
    message: 'Brand Registration Failure: Max registration limit reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30712\r\n\r\n### Brand Registration Failure: Max registration limit reached\r\n\r\n Your account has reached maximum number allowed brand registrations.\r\n\r\n#### Possible Causes\r\nYour account has reached maximum number allowed brand registrations.\r\n\r\n#### Possible Solutions\r\nPlease contact Twilio Support with relevant error details.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    causes: 'Your account has reached maximum number allowed brand registrations.',
    solutions:
      'Please contact Twilio Support with relevant error details.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures](https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/troubleshooting-a2p-brands)',
    description: 'Your account has reached maximum number allowed brand registrations.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:38:24Z',
    last_updated: '2024-02-13T15:34:01.4565Z',
  },
  21208: {
    code: 21208,
    message: 'Invalid Timeout',
    log_level: 'ERROR',
    secondary_message:
      "You attempted to initiate an outbound phone call, but you sent an invalid <span class='rest-attribute'>Timeout</span> parameter.  The timeoutspecifes how long Twilio should let the phone ring before giving up, and is useful if you want to have Twilio hangup before an answering machine picks up.  You may specify any positive, whole integer for the <span class='rest-attribute'>Timeout</span> parameter.",
    log_type: null,
    docs: "## Error - 21208 \n\n### Invalid Timeout\n\nYou attempted to initiate an outbound phone call, but you sent an invalid <span class='rest-attribute'>Timeout</span> parameter. The timeout specifes how long Twilio should let the phone ring before giving up, and is useful if you want to have Twilio hangup before an answering machine picks up. You may specify any positive, whole integer for the <span class='rest-attribute'>Timeout</span> parameter.\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:55Z',
    last_updated: '2020-08-04T10:00:27.169Z',
  },
  22228: {
    code: 22228,
    message:
      'From Bundle does not have latest Regulation requirements that matches destination Bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 22228\r\n\r\n### From Bundle does not have latest Regulation requirements that matches destination Bundle\r\n\r\n The from Bundle does not have the latest Regulation requirements which match the destination Bundle\r\n\r\n#### Possible Causes\r\nIncompatible Regulation requirements.\r\n\r\n#### Possible Solutions\r\nPlease reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) by referencing this API error code with the BundleSid requesting assistance with fixing the Bundle.',
    causes: 'Incompatible Regulation requirements.',
    solutions:
      'Please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) by referencing this API error code with the BundleSid requesting assistance with fixing the Bundle.',
    description:
      'The from Bundle does not have the latest Regulation requirements which match the destination Bundle',
    product: 'Phone Numbers',
    date_created: '2022-03-10T23:40:53Z',
    last_updated: '2023-11-01T04:45:19.599288Z',
  },
  31001: {
    code: 31001,
    message: 'Application not found.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31001\r\n\r\n### Application not found.\r\n\r\nApplication not found.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T20:36:49Z',
    last_updated: '2020-08-04T10:00:11.31Z',
  },
  54454: {
    code: 54454,
    message: "Sync: Invalid 'PageSize' query parameter",
    log_level: 'ERROR',
    secondary_message: 'The requested page size must be in the range [1-1000].',
    log_type: 'APPLICATION',
    docs: "## ERROR - 54454\r\n\r\n### Sync: Invalid 'PageSize' query parameter\r\n\r\nThe requested page size must be in the range [1-1000]. \r\n\r\n\r\n#### Possible Causes\r\nThe value supplied by the PageSize query string parameter is not an integer in the required range.\r\n\r\n#### Possible Solutions\r\nConfirm that a valid PageSize query parameter is being passed in request.",
    causes:
      'The value supplied by the PageSize query string parameter is not an integer in the required range.',
    solutions: 'Confirm that a valid PageSize query parameter is being passed in request.',
    description: '\r\n',
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2021-01-07T14:35:08.589Z',
  },
  60322: {
    code: 60322,
    message: 'Challenge already responded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60322\r\n\r\n### Challenge already responded\r\n\r\n The Challenge was already responded before.\r\n\r\nHTTP status: 403\r\n\r\n#### Possible Causes\r\nThis Challenge already have a previous response.\r\n\r\n#### Possible Solutions\r\nCreate a new Challenge.',
    causes: 'This Challenge already have a previous response.',
    solutions: 'Create a new Challenge.',
    description: 'The Challenge was already responded before.\r\n\r\nHTTP status: 403',
    product: 'Verify',
    date_created: '2020-06-30T21:34:38Z',
    last_updated: '2021-06-30T03:46:56.337653Z',
  },
  21200: {
    code: 21200,
    message: 'Calls Resource',
    log_level: 'ERROR',
    secondary_message: 'Errors related to the Calls resource',
    log_type: null,
    docs: '## Error - 21200 \n\n### Calls Resource\n\nErrors related to the Calls resource\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:53Z',
    last_updated: '2020-08-04T10:00:27.314Z',
  },
  60379: {
    code: 60379,
    message: 'Authenticator data invalid or not provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60379\r\n\r\n### Authenticator data invalid or not provided\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Authenticator data in the request is missing or incorrectly formatted.\r\n\r\n#### Possible Solutions\r\nCheck that the Authenticator data in the request body is correct.',
    causes: 'The Authenticator data in the request is missing or incorrectly formatted.',
    solutions: 'Check that the Authenticator data in the request body is correct.',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:44:22Z',
    last_updated: '2023-12-27T09:44:22Z',
  },
  60328: {
    code: 60328,
    message: 'Entities rate limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60328\r\n\r\n### Entities rate limit exceeded\r\n\r\n Exceeded the rate limit of entities created per account per second\r\n\r\n#### Possible Causes\r\n* More than 40 entities were created within the last second\r\n\r\n#### Possible Solutions\r\n* Lower the rate at which entities are being created\r\n* Keep in mind that this could also happen while using the create factor endpoint\r\n* Verify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits',
    causes: '* More than 40 entities were created within the last second',
    solutions:
      '* Lower the rate at which entities are being created\r\n* Keep in mind that this could also happen while using the create factor endpoint\r\n* Verify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits',
    description: 'Exceeded the rate limit of entities created per account per second',
    product: 'Verify',
    date_created: '2024-05-30T18:21:59Z',
    last_updated: '2024-05-30T18:21:59Z',
  },
  60314: {
    code: 60314,
    message: 'Factors binding format is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60314\r\n\r\n### Factors binding format is invalid\r\n\r\n The format of the Factor binding is not valid.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nThe `Public Key` might be invalid.\r\n\r\n#### Possible Solutions\r\nMake sure that the `Public Key` and `Algorithm` are correct.',
    causes: 'The `Public Key` might be invalid.',
    solutions: 'Make sure that the `Public Key` and `Algorithm` are correct.',
    description: 'The format of the Factor binding is not valid.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-06-30T17:08:13Z',
    last_updated: '2021-06-30T03:44:37.846775Z',
  },
  30134: {
    code: 30134,
    message: 'Invalid Dns Setup for Link shortening',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30134\r\n\r\n### Invalid Dns Setup for Link shortening\r\n\r\n \r\n\r\n#### Possible Causes\r\nDomain Dns setup is not completed \r\n\r\n#### Possible Solutions\r\nIf you're using a root domain, point the A record of the domain to the following 3 IP addresses only. If other IPs are included, Link Shortening does not work.\r\n\r\n- 3.233.187.46\r\n- 3.233.108.250\r\n- 54.157.2.211\r\n\r\nIf you're using a subdomain, point the CNAME record of the subdomain to the following:\r\n\r\n- lsct.ashburn.us1.twilio.com",
    causes: 'Domain Dns setup is not completed ',
    solutions:
      "If you're using a root domain, point the A record of the domain to the following 3 IP addresses only. If other IPs are included, Link Shortening does not work.\r\n\r\n- 3.233.187.46\r\n- 3.233.108.250\r\n- 54.157.2.211\r\n\r\nIf you're using a subdomain, point the CNAME record of the subdomain to the following:\r\n\r\n- lsct.ashburn.us1.twilio.com",
    description: null,
    product: 'Programmable SMS',
    date_created: '2024-06-11T22:28:33Z',
    last_updated: '2024-06-11T22:31:43.814177Z',
  },
  90023: {
    code: 90023,
    message: "One of 'TemplateArgs' dictionary value is null",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90023\r\n\r\n### One of 'TemplateArgs' dictionary value is null\r\n\r\n One of 'TemplateArgs' dictionary value is null\r\n\r\n#### Possible Causes\r\nOne of 'TemplateArgs' dictionary value is null\r\n\r\n#### Possible Solutions\r\nDo not use null 'TemplateArgs' dictionary values",
    causes: "One of 'TemplateArgs' dictionary value is null",
    solutions: "Do not use null 'TemplateArgs' dictionary values",
    description: "One of 'TemplateArgs' dictionary value is null",
    product: null,
    date_created: '2020-12-11T08:48:59Z',
    last_updated: '2020-12-11T08:48:59Z',
  },
  52139: {
    code: 52139,
    message: 'APN service shutdown',
    log_level: 'ERROR',
    secondary_message: 'APNs is shutdown',
    log_type: null,
    docs: '## Error - 52139\r\n\r\n### APNs service shutdown\r\n\r\n#### Possible Causes \r\n*  APNs delivery rejected because APNs service is shutting down (e.g. for maintenance).\r\n\r\n#### Possible Solutions\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:38:39Z',
    last_updated: '2020-08-04T10:00:22.07Z',
  },
  21629: {
    code: 21629,
    message: 'Address Validation Error - Check Suggested Address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 21629\r\n\r\n### Address Validation Error - Check Suggested Address\r\n\r\nThe address you have provided cannot be validated. A similar address has been found to be valid. The suggested address is included in the error message body. \r\n\r\n#### Possible Causes\r\n- Address misspelling\r\n- Alternate format or spelling in third-party data source\r\n\r\n#### Possible Solutions\r\n- Ensure the address is spelled correctly\r\n- If a correct suggestion, submit the suggested address for validation\r\n- Contact Twilio Support',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2017-05-15T17:44:46Z',
    last_updated: '2020-08-04T10:00:18.606Z',
  },
  90035: {
    code: 90035,
    message: "Broadcast 'MessageStatusCallbackUrl' is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90035\r\n\r\n### Broadcast 'MessageStatusCallbackUrl' is too long\r\n\r\n Broadcast 'MessageStatusCallbackUrl' is too long\r\n\r\n#### Possible Causes\r\n'MessageStatusCallbackUrl' is too long\r\n\r\n#### Possible Solutions\r\nUse shorter url in 'MessageStatusCallbackUrl' field",
    causes: "'MessageStatusCallbackUrl' is too long",
    solutions: "Use shorter url in 'MessageStatusCallbackUrl' field",
    description: "Broadcast 'MessageStatusCallbackUrl' is too long",
    product: null,
    date_created: '2020-12-11T15:43:20Z',
    last_updated: '2020-12-11T15:43:20Z',
  },
  18016: {
    code: 18016,
    message: 'Require domestic address.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18016\r\n\r\n### Require domestic address.\r\n\r\n The phone number type you selected requires a valid domestic address.\r\n\r\n#### Possible Causes\r\n- You may have submitted an international address.\r\n- Your address is not a valid address.\r\n\r\n\r\n#### Possible Solutions\r\nPlease resubmit with a valid address or create a new bundle selecting the appropriate phone number type.',
    causes:
      '- You may have submitted an international address.\r\n- Your address is not a valid address.\r\n',
    solutions:
      'Please resubmit with a valid address or create a new bundle selecting the appropriate phone number type.',
    description: 'The phone number type you selected requires a valid domestic address.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:06:21Z',
    last_updated: '2024-07-04T10:06:21Z',
  },
  80609: {
    code: 80609,
    message: 'Too Many Added Participants',
    log_level: 'WARNING',
    secondary_message: 'A Session may have at most 2 participants',
    log_type: null,
    docs: '## Warning\n\n### Too Many Added Participants\n\nExample Message: A Session may have at most 2 participants',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.715Z',
  },
  13337: {
    code: 13337,
    message: 'Gather: callback must be over HTTPS when using gather with PCI compliance',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13337\r\n\r\n### Gather: callback must be over HTTPS when using gather with PCI compliance\r\n\r\n Gather: callback must be over HTTPS when using gather with PCI compliance\r\n\r\n#### Possible Causes\r\nGather URL must use HTTPS. \r\n\r\n#### Possible Solutions\r\nGather URL must use HTTPS and valid URL format.',
    causes: 'Gather URL must use HTTPS. ',
    solutions: 'Gather URL must use HTTPS and valid URL format.',
    description: 'Gather: callback must be over HTTPS when using gather with PCI compliance',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:53:12Z',
    last_updated: '2020-08-04T10:00:04.329Z',
  },
  30466: {
    code: 30466,
    message: 'Toll Free verification rejection - Disallowed - Debt Reduction',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30466\r\n\r\n### Toll Free verification rejection - Disallowed - Debt Reduction\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category  (Debt collection or forgiveness: Debt reduction). \r\n\r\nDebt consolidation, debt reduction and credit repair programs are prohibited regardless if there is first-party consent. \r\n\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category  (Debt collection or forgiveness: Debt reduction). \r\n\r\nDebt consolidation, debt reduction and credit repair programs are prohibited regardless if there is first-party consent. \r\n',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T21:13:37Z',
    last_updated: '2024-02-22T21:14:05.082857Z',
  },
  23003: {
    code: 23003,
    message: 'Message Redaction Incompatible Configuration: Sticky Sender',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 23003\r\n\r\n### Message Redaction Incompatible Configuration: Sticky Sender\r\n\r\n Phone Number Redaction is enabled for your account. Sticky Sender is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* You have Sticky Sender enabled on your Messaging Service. Sticky Sender requires Twilio to save the non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* Disable Sticky Sender on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/messaging/services/api).\r\n* If Sticky Sender functionality is needed, implement this functionality in your own application.',
    causes:
      '* You have Sticky Sender enabled on your Messaging Service. Sticky Sender requires Twilio to save the non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.',
    solutions:
      '* Disable Sticky Sender on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/messaging/services/api).\r\n* If Sticky Sender functionality is needed, implement this functionality in your own application.',
    description:
      'Phone Number Redaction is enabled for your account. Sticky Sender is not compatible with Phone Number Redaction and should be disabled.',
    product: 'Programmable SMS',
    date_created: '2019-11-21T19:20:34Z',
    last_updated: '2023-07-31T21:38:13.792579Z',
  },
  53610: {
    code: 53610,
    message: 'Invalid URL for external S3 bucket in recording settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53610\r\n\r\n### Invalid URL for external S3 bucket in recording settings\r\n\r\nThe S3 bucket URL configured in your account's recording settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, set a valid S3 URL for uploading media or disable the external storage (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-05-24T12:45:45Z',
    last_updated: '2020-08-04T10:00:13.749Z',
  },
  51124: {
    code: 51124,
    message: 'Twilsock: Too many connections',
    log_level: 'ERROR',
    secondary_message: 'Number of connections for this account is higher than expected!',
    log_type: null,
    docs: "## Error - 51124\r\n\r\n### Too many connections\r\n\r\n#### Possible Causes \r\nNumber of connections for this account is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:24:10Z',
    last_updated: '2020-08-04T10:00:09.477Z',
  },
  50302: {
    code: 50302,
    message: 'Programmable Chat: Unknown channel command',
    log_level: 'ERROR',
    secondary_message: 'Specified Channel Command does not exist.',
    log_type: null,
    docs: '## Error - 50302\r\n\r\n### Programmable Chat: Unknown channel command\r\n\r\n#### Possible Causes \r\n*  Specified Channel Command does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel Command is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:50Z',
    last_updated: '2020-08-04T10:00:23.187Z',
  },
  13258: {
    code: 13258,
    message: 'Dial->Sim not supported in this realm',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13258\r\n\r\n### Dial->Sim not supported in this realm\r\n\r\n Dial->Sim not supported in this realm\r\n\r\n#### Possible Causes\r\nDial->Sim not supported in this realm\r\n\r\n#### Possible Solutions\r\nUse Dial->Sim in another realm',
    causes: 'Dial->Sim not supported in this realm',
    solutions: 'Use Dial->Sim in another realm',
    description: 'Dial->Sim not supported in this realm',
    product: 'Programmable Voice',
    date_created: '2020-08-24T16:35:34Z',
    last_updated: '2020-08-24T16:35:34Z',
  },
  60302: {
    code: 60302,
    message: 'FactorType already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60302\r\n\r\n### FactorType already exists\r\n\r\n The Entity has already a `FactorType` of the same type.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nEach Entity can have multiples Factor types, but each `FactorType` has to be unique for the given Entity.\r\n\r\n#### Possible Solutions\r\nMake sure you are assigning the new `FactorType` to the right Entity.',
    causes:
      'Each Entity can have multiples Factor types, but each `FactorType` has to be unique for the given Entity.',
    solutions: 'Make sure you are assigning the new `FactorType` to the right Entity.',
    description: 'The Entity has already a `FactorType` of the same type.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-06-30T16:47:35Z',
    last_updated: '2021-06-30T03:39:41.452707Z',
  },
  62052: {
    code: 62052,
    message:
      "Interconnect: This account is not a subaccount of the Interconnect Connection owner's account.",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "#### Possible Causes \r\n*  This account is not a subaccount of the Interconnect Connection owner's account.\r\n \r\n \r\n#### Possible Solutions\r\n*  Please verify your Connection SID. Visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n \r\n",
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2017-06-05T22:46:23Z',
    last_updated: '2020-08-04T10:00:18.35Z',
  },
  70005: {
    code: 70005,
    message: 'Failure Threshold Exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70005 \r\n\r\n### Failure Threshold Exceeded\r\nToo many unsuccessful requests against Twilio API.\r\n\r\n#### Possible Causes \r\n* The requests try to repeatedly access a deleted resource\r\n* The requests try to repeatedly access an invalid resource\r\n\r\n#### Possible Solution:\r\n* Slow down the requests\r\n* Validate whether the given resource exists',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:16:52Z',
    last_updated: '2020-08-04T10:00:18.912Z',
  },
  60701: {
    code: 60701,
    message: 'Invalid request',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60701\r\n\r\n### Invalid request\r\n\r\n Bad Request, generic 400 error\r\n\r\n#### Possible Causes\r\n- Details included in the response body\r\n\r\n#### Possible Solutions\r\n- Details included in the response body',
    causes: '- Details included in the response body',
    solutions: '- Details included in the response body',
    description: 'Bad Request, generic 400 error',
    product: 'Branded Comms',
    date_created: '2020-01-20T14:23:55Z',
    last_updated: '2020-08-04T10:00:05.181Z',
  },
  53602: {
    code: 53602,
    message: 'AWS encryption key for recording upload is invalid',
    log_level: 'ERROR',
    secondary_message: 'The recording will not be processed',
    log_type: null,
    docs: "## Error - 53602\r\n\r\n### AWS encryption key for recording upload is invalid\r\n\r\nThe recording will not be processed.\r\n\r\nRaised when the AWS encryption key provided in the recording's metadata for uploading the media to S3 is not valid.\r\n\r\n#### Causes\r\n\r\n * Providing an invalid AWS encryption key for uploading to S3.\r\n\r\n#### Solutions\r\n\r\n * Set AWS encryption key to a correct value.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:36:59Z',
    last_updated: '2020-08-04T10:00:14.76Z',
  },
  45368: {
    code: 45368,
    message: 'Failed to delete Channel.  Not found.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '##  - 45368\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'The Channel was not created or has already been deleted.',
    solutions: 'No Action.\r',
    description: 'Failed to delete Channel <channel sid>. Not found.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:20:05.249827Z',
  },
  32501: {
    code: 32501,
    message: 'Voice Conversation: TwiML attributes validation error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32501\r\n\r\n### Voice Conversation: TwiML attributes validation error.\r\n\r\n Invalid attributes found in <Conversation> noun.\r\n\r\n#### Possible Causes\r\n- Invalid attributes within the <Conversation> noun.\r\n- Can be caused by any invalid syntax within the <Conversation> noun.\r\n\r\n#### Possible Solutions\r\n- Check attribute names or the values following the <Conversation> noun.\r\n- Refer to the <Conversation> twiml docs page “/docs/voice/twiml/connect/conversation” for more information.',
    causes:
      '- Invalid attributes within the <Conversation> noun.\r\n- Can be caused by any invalid syntax within the <Conversation> noun.',
    solutions:
      '- Check attribute names or the values following the <Conversation> noun.\r\n- Refer to the <Conversation> twiml docs page “/docs/voice/twiml/connect/conversation” for more information.',
    description: 'Invalid attributes found in <Conversation> noun.',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:36:04Z',
    last_updated: '2022-07-29T16:30:24.08623Z',
  },
  60301: {
    code: 60301,
    message: 'Entity already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60301\r\n\r\n### Entity already exists\r\n\r\n HTTP status: 409\r\n\r\n#### Possible Causes\r\nYou are trying to create an Entity with an existing `Identity` in the same Service.\r\n\r\n#### Possible Solutions\r\nMake sure that there is not any other Entity with the same `Identity` associated to the same Service. ',
    causes: 'You are trying to create an Entity with an existing `Identity` in the same Service.',
    solutions:
      'Make sure that there is not any other Entity with the same `Identity` associated to the same Service. ',
    description: 'HTTP status: 409',
    product: 'Verify',
    date_created: '2020-06-30T16:46:05Z',
    last_updated: '2021-06-30T03:39:04.339637Z',
  },
  14205: {
    code: 14205,
    message: 'Enqueue: Queue name too long',
    log_level: 'ERROR',
    secondary_message: 'The queue name must be less than 64 characters in length.',
    log_type: null,
    docs: '## Error - 14205\n\n### Enqueue: Queue name too long\n\nThe queue name must be less than 64 characters in length.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:11Z',
    last_updated: '2020-08-04T10:00:26.273Z',
  },
  50102: {
    code: 50102,
    message: 'Programmable Chat: Deployment role not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Deployment Role does not exist.',
    log_type: null,
    docs: '## Error - 50102\r\n\r\n### Programmable Chat: Deployment role not found\t\r\n\r\n#### Possible Causes \r\n*  Specified Deployment Role does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Deployment Role is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:46Z',
    last_updated: '2020-08-04T10:00:23.462Z',
  },
  45310: {
    code: 45310,
    message: 'Participant Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45310\r\n\r\n### Participant Not Found\r\n\r\n Participant is not found in the meeting\r\n\r\n#### Possible Causes\r\nParticipant is not in the meeting anymore\r\n\r\n#### Possible Solutions\r\nNo action required',
    causes: 'Participant is not in the meeting anymore',
    solutions: 'No action required',
    description: 'Participant is not found in the meeting',
    product: 'Flex',
    date_created: '2020-05-08T21:30:25Z',
    last_updated: '2020-08-04T10:00:03.219Z',
  },
  60305: {
    code: 60305,
    message: 'Access Token parameters are invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60305\r\n\r\n### Access Token parameters are invalid\r\n\r\n Access Token parameters are invalid.\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nAny of the required parameters are missing in the request params:\r\n- **Identity:** External unique identifier for the Entity.\r\n- **FactorType:** The factor type that the Access Token will be used to create.\r\n\r\n#### Possible Solutions\r\nCheck Access Token parameters.',
    causes:
      'Any of the required parameters are missing in the request params:\r\n- **Identity:** External unique identifier for the Entity.\r\n- **FactorType:** The factor type that the Access Token will be used to create.',
    solutions: 'Check Access Token parameters.',
    description: 'Access Token parameters are invalid.\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2020-06-30T16:49:31Z',
    last_updated: '2021-06-30T03:40:32.074132Z',
  },
  63010: {
    code: 63010,
    message: "Twilio's platform encountered an internal error processing this message",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: "### Twilio Channels Internal error\r\n\r\n#### Possible Causes \r\n*   Twilio's platform encountered an internal error processing this message",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-19T23:27:15Z',
    last_updated: '2020-08-04T10:00:14.363Z',
  },
  60613: {
    code: 60613,
    message: 'Lookup Provider Degradation',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## ERROR - 60613\r\n\r\n### Lookup Provider Degradation\r\n\r\n \r\n\r\n#### Possible Causes\r\nError encountered when calling Lookup data providers. Fallback data returned.\r\n\r\n#### Possible Solutions\r\n- Retry request to rule out transient issues in order to receive complete information.\r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out other issues.',
    causes: 'Error encountered when calling Lookup data providers. Fallback data returned.',
    solutions:
      '- Retry request to rule out transient issues in order to receive complete information.\r\n- If error persists, [contact Twilio Support](https://www.twilio.com/help/contact) to rule out other issues.',
    description:
      'Temporary service degradation with provider encountered; fallback data returned if available.',
    product: 'Lookup',
    date_created: '2021-10-20T14:30:31Z',
    last_updated: '2023-01-06T00:26:27.700467Z',
  },
  50411: {
    code: 50411,
    message: 'Participant address is empty',
    log_level: 'ERROR',
    secondary_message: 'The provided participant public address parameter must not be empty.',
    log_type: null,
    docs: '\n## Error - 50411\n\n### Conversations: Participant address is empty\nThe provided participant public address parameter must not be empty.\n\n#### Possible Causes\n* MessagingBinding.Address parameter provided with the request contains an empty string.\n\n#### Possible Solutions\n* Add a non-empty MessagingBinding.Address parameter to the API request and supply a valid participant address matching your desired channel, e.g. SMS, MMS or WhatsApp.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.513Z',
  },
  13256: {
    code: 13256,
    message: 'Invalid recordingStatusCallback URL',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13256\r\n\r\n### Invalid recordingStatusCallback URL\r\n\r\n A recording was initiated using an invalid URL for the recordingStatusCallback parameter.\r\nThe recording will be processed, but status notifications will not be sent.\r\n\r\n#### Possible Causes\r\nThe recording status callback URL you provided is not valid.\r\n\r\n#### Possible Solutions\r\nSet recordingStatusCallback to a valid URL or leave blank to disable callbacks.',
    causes: 'The recording status callback URL you provided is not valid.',
    solutions: 'Set recordingStatusCallback to a valid URL or leave blank to disable callbacks.',
    description:
      'A recording was initiated using an invalid URL for the recordingStatusCallback parameter.\r\nThe recording will be processed, but status notifications will not be sent.',
    product: 'Programmable Voice',
    date_created: '2019-09-30T15:35:54Z',
    last_updated: '2024-03-11T18:03:47.469872Z',
  },
  13214: {
    code: 13214,
    message: 'Dial: Invalid callerId value',
    log_level: 'WARNING',
    secondary_message:
      "callerId must be the calling number, called number, or a validated outgoing number. See the <a href='/docs/api/twiml/dial#callerId'>Dial Verb</a> API Reference for more information.",
    log_type: 'APPLICATION',
    docs: "## WARNING - 13214\r\n\r\n### Dial: Invalid callerId value\r\n\r\ncallerId must be the calling number, called number, or a validated outgoing number. See the <a href='/docs/api/twiml/dial#callerId'>Dial Verb</a> API Reference for more information. ## Warning - 13214 \r\n\r\n### Dial: Invalid callerId value\r\n\r\ncallerId must be the calling number, called number, or a validated outgoing number.  Additionally,\r\nif the calling leg is a client leg, the caller ID is required and must be a validated outgoing number. \r\nSee the <a href='/docs/api/twiml/dial#callerId'>Dial Verb</a> API Reference for more information.\r\n\r\n#### Possible Causes\r\nCarriers may send invalid Caller IDs on Incoming calls to Twilio. If a specific Caller ID is not explicitly defined on the <Dial> verb, the invalid Caller ID will be passed to the destination. This may cause some destination providers to reject the call, and Twilio will mark it as failed.\r\n\r\n#### Possible Solutions\r\nTo work around this, your application should recognize invalid caller IDs, and substitute them with a valid Caller ID to construct the subsequent <Dial>. ",
    causes:
      'Carriers may send invalid Caller IDs on Incoming calls to Twilio. If a specific Caller ID is not explicitly defined on the <Dial> verb, the invalid Caller ID will be passed to the destination. This may cause some destination providers to reject the call, and Twilio will mark it as failed.',
    solutions:
      'To work around this, your application should recognize invalid caller IDs, and substitute them with a valid Caller ID to construct the subsequent <Dial>. ',
    description:
      "## Warning - 13214 \r\n\r\n### Dial: Invalid callerId value\r\n\r\ncallerId must be the calling number, called number, or a validated outgoing number.  Additionally,\r\nif the calling leg is a client leg, the caller ID is required and must be a validated outgoing number. \r\nSee the <a href='/docs/api/twiml/dial#callerId'>Dial Verb</a> API Reference for more information.",
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:32Z',
    last_updated: '2021-09-08T06:00:23.615577Z',
  },
  80408: {
    code: 80408,
    message: 'Service Sid Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Service Sid',
    log_type: null,
    docs: '## Warning\n\n### Service Sid Invalid\n\nExample Message: Invalid Service Sid',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.909Z',
  },
  50372: {
    code: 50372,
    message: 'Conversation webhook URL is too long',
    log_level: 'ERROR',
    secondary_message: 'The length of provided conversation webhook URL exceeds the limit.',
    log_type: null,
    docs: '\n## Error - 50372\n\n### Conversations: Conversation webhook URL is too long\nThe length of provided conversation webhook URL exceeds the limit.\n\n#### Possible Causes\n* Your API request contains a parameter containing the URL that is longer than 512 characters.\n\n#### Possible Solutions\n* Provide a shorter webhook URL with your API request.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.613Z',
  },
  21254: {
    code: 21254,
    message: 'Max Connection Policy Entries Reached',
    log_level: 'ERROR',
    secondary_message: 'A Connection Policy cannot have more than 10 entries.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21254\r\n\r\n### Max Connection Policy Entries Reached\r\n\r\nA Connection Policy cannot have more than 10 entries. \r\n\r\n#### Possible Causes\r\n* A Connection Policy cannot have more than 10 entries.\r\n\r\n#### Possible Solutions\r\n* Delete an existing entry from the Connection Policy if you must create more.',
    causes: '* A Connection Policy cannot have more than 10 entries.',
    solutions: '* Delete an existing entry from the Connection Policy if you must create more.',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2020-08-21T20:45:47Z',
    last_updated: '2020-08-21T20:45:47Z',
  },
  13243: {
    code: 13243,
    message: 'Dial->SIP: Invalid SIP URI',
    log_level: 'WARNING',
    secondary_message: 'The provided SIP URI is not formatted properly.',
    log_type: null,
    docs: '## Warning - 13243 \n\n### Dial->SIP: Invalid SIP URI\n\nThe provided SIP URI is not formatted properly.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:39Z',
    last_updated: '2020-08-04T10:00:28.248Z',
  },
  21238: {
    code: 21238,
    message: 'Address Validation Error',
    log_level: 'ERROR',
    secondary_message:
      'One of the parameters passed when creating or updating an Address was incorrect.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21238\r\n\r\n### Address Validation Error\r\n\r\nOne of the parameters passed when creating or updating an Address was incorrect. \r\n\r\n#### Possible Causes\r\n* One of the parameters passed when creating or updating an Address was incorrect.\r\n\r\n#### Possible Solutions\r\n* Ensure that you are creating a valid Address.',
    causes: '* One of the parameters passed when creating or updating an Address was incorrect.',
    solutions: '* Ensure that you are creating a valid Address.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:20:07Z',
    last_updated: '2020-08-04T10:00:00.514Z',
  },
  53119: {
    code: 53119,
    message: 'The concurrent Rooms quota was exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53119\r\n\r\n### The concurrent Rooms quota was exceeded\r\n\r\n #### 53119: The concurrent Rooms quota was exceeded\r\n\r\n#### Possible Causes\r\n * Connecting the first Participant in an Ad-hoc Room would exceed the account's concurrent Rooms quota.\r\n * Creating a Room via the REST API would exceed the account's concurrent Rooms quota.\r\n\r\n#### Possible Solutions\r\n* Complete existing Rooms.\r\n* Contact support/sales to increase the concurrent Rooms quota for your account.",
    causes:
      " * Connecting the first Participant in an Ad-hoc Room would exceed the account's concurrent Rooms quota.\r\n * Creating a Room via the REST API would exceed the account's concurrent Rooms quota.",
    solutions:
      '* Complete existing Rooms.\r\n* Contact support/sales to increase the concurrent Rooms quota for your account.',
    description: '#### 53119: The concurrent Rooms quota was exceeded',
    product: 'Programmable Video',
    date_created: '2020-05-13T23:08:52Z',
    last_updated: '2021-06-08T18:25:27.001Z',
  },
  21728: {
    code: 21728,
    message: 'Campaign registration failed due to length validation failures',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21728\r\n\r\n### Campaign registration failed due to length validation failures\r\n\r\n We could not register your US A2P Campaign because one or more field(s) do not satisfy length requirements.\r\n\r\n#### Possible Causes\r\nOne or more field(s) do not satisfy length requirements.\r\n\r\n#### Possible Solutions\r\nPlease fix the error and retry Campaign registration. Please check out our [support article](https://support.twilio.com/hc/en-us/articles/8959909733403-Changes-to-the-A2P-10DLC-Campaign-Creation-Process) to read about the length requirements on these fields.',
    causes: 'One or more field(s) do not satisfy length requirements.',
    solutions:
      'Please fix the error and retry Campaign registration. Please check out our [support article](https://support.twilio.com/hc/en-us/articles/8959909733403-Changes-to-the-A2P-10DLC-Campaign-Creation-Process) to read about the length requirements on these fields.',
    description:
      'We could not register your US A2P Campaign because one or more field(s) do not satisfy length requirements.',
    product: 'Programmable SMS',
    date_created: '2022-10-06T18:28:14Z',
    last_updated: '2022-10-06T18:53:01.91311Z',
  },
  16111: {
    code: 16111,
    message:
      'Voice Recording: Upload file to external AWS S3 bucket failed (Invalid Configuration)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16111\r\n\r\n### Voice Recording: Upload file to external AWS S3 bucket failed (Invalid Configuration)\r\n\r\n Twilio failed to upload the recording file to the external AWS S3 bucket specified in Voice Settings due to an invalid configuration. The recording file has been deleted, and if the resource exists, the resource has been marked as “failed”.\r\n\r\n#### Possible Causes\r\n* Invalid S3 bucket URL\r\n* Invalid AWS S3 bucket credentials\r\n* AWS S3 bucket credentials not found in Credential Storage\r\n\r\n#### Possible Solutions\r\n* Ensure AWS S3 bucket credentials are valid and available in Credential Storage\r\n* Set a valid S3 bucket URL\r\n* Disable external storage\r\n* Ensure External Storage settings are provided for each home region you want to use',
    causes:
      '* Invalid S3 bucket URL\r\n* Invalid AWS S3 bucket credentials\r\n* AWS S3 bucket credentials not found in Credential Storage',
    solutions:
      '* Ensure AWS S3 bucket credentials are valid and available in Credential Storage\r\n* Set a valid S3 bucket URL\r\n* Disable external storage\r\n* Ensure External Storage settings are provided for each home region you want to use',
    description:
      'Twilio failed to upload the recording file to the external AWS S3 bucket specified in Voice Settings due to an invalid configuration. The recording file has been deleted, and if the resource exists, the resource has been marked as “failed”.',
    product: 'Programmable Voice',
    date_created: '2021-11-17T18:52:58Z',
    last_updated: '2022-03-28T17:38:29.08584Z',
  },
  50430: {
    code: 50430,
    message: 'Participant is not a member of conversation',
    log_level: 'ERROR',
    secondary_message: 'The requested participant is not a member of this conversation.',
    log_type: null,
    docs: '\n## Error - 50430\n\n### Conversations: Participant is not a member of conversation\nThe requested participant is not a member of this conversation.\n\n#### Possible Causes\n* The requested participant was removed from this conversation, or was never added to it.\n* The requested participant SID is misspelled.\n* The requested participant is a member of a different conversation.\n\n#### Possible Solutions\n* Ensure that the participant is added to the conversation. Use API to [create a new participant](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#add-a-conversation-participant-sms).\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.37Z',
  },
  53604: {
    code: 53604,
    message: 'Failed to upload the recording to S3',
    log_level: 'WARNING',
    secondary_message: 'A new attempt will be made after a delay',
    log_type: null,
    docs: "## Warning - 53604\r\n\r\n### Failed to upload the recording to S3\r\n\r\nRaised when an error prevented us from uploading the media to S3.\r\n\r\n#### Causes\r\n\r\n* Despite our best efforts to upload your media to S3, we couldn't do it this time. We'll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* Please verify that any S3 configuration you've provided us is correct, such as AWS access credentials or AWS encryption key.\r\n* If the error persists, please <a href=\"/help/contact\">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:38:50Z',
    last_updated: '2020-08-04T10:00:14.723Z',
  },
  30756: {
    code: 30756,
    message: 'Brand Registration Failure: Obfuscation check failure',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30756\r\n\r\n### Brand Registration Failure: Obfuscation check failure\r\n\r\n  Obfuscation check failed for brand registration inputs.\r\n\r\n#### Possible Causes\r\n Obfuscation check failed for brand registration inputs.\r\n\r\n#### Possible Solutions\r\nPlease use natural text inputs for business name, first and last name.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes: ' Obfuscation check failed for brand registration inputs.',
    solutions:
      'Please use natural text inputs for business name, first and last name.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description: ' Obfuscation check failed for brand registration inputs.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:47:34Z',
    last_updated: '2024-02-13T16:17:19.624493Z',
  },
  80608: {
    code: 80608,
    message: 'Session Status Invalid',
    log_level: 'ERROR',
    secondary_message: 'Session status change not supported',
    log_type: 'APPLICATION',
    docs: '## ERROR - 80608\r\n\r\n### Session Status Invalid\r\n\r\nSession status change not supported Session Status Invalid\r\n\r\n\r\n\r\n#### Possible Causes\r\nSession status change not supported. \r\n\r\n#### Possible Solutions\r\nTo re-open a session the valid status update is from `closed` to `in-progress`. To close a session, update from `open` to `closed` or from `in-progress` to `closed`. \r\n',
    causes: 'Session status change not supported. ',
    solutions:
      'To re-open a session the valid status update is from `closed` to `in-progress`. To close a session, update from `open` to `closed` or from `in-progress` to `closed`. \r\n',
    description: 'Session Status Invalid\r\n\r\n',
    product: 'Proxy',
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.733Z',
  },
  45001: {
    code: 45001,
    message: 'General Service Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45001\r\n\r\n### General Service Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nFlex encountered a general service error.\r\n\r\n#### Possible Solutions\r\nNo further information available.',
    causes: 'Flex encountered a general service error.',
    solutions: 'No further information available.',
    description: null,
    product: 'Flex',
    date_created: '2018-10-01T08:48:39Z',
    last_updated: '2020-08-04T10:00:12.49Z',
  },
  13320: {
    code: 13320,
    message: 'Gather: Invalid nested verb',
    log_level: 'WARNING',
    secondary_message:
      "The only valid nested elements of the Gather Verb are Say and Play. See the <a href='/docs/api/twiml/gather'>Gather Verb</a> API Reference for more information.",
    log_type: null,
    docs: "## Warning - 13320 \n\n### Gather: Invalid nested verb\n\nThe only valid nested elements of the Gather Verb are Say and Play. See the <a href='/docs/api/twiml/gather'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:41Z',
    last_updated: '2020-08-04T10:00:28.084Z',
  },
  32655: {
    code: 32655,
    message: 'Real-time Transcriptions: AI Terms Not Accepted',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 32655\r\n\r\n### Real-time Transcriptions: AI Terms Not Accepted\r\n\r\n A 32655 Warning indicates that the AI Terms for &lt;Transcription&gt; have not been accepted on your account.\r\n\r\n#### Possible Causes\r\nTo use &lt;Transcription&gt; AI Terms should be accepted on your account.\r\n\r\n#### Possible Solutions\r\n* Ensure [AI terms](https://console.twilio.com/develop/voice/settings/general?frameUrl=/console/voice/settings) are accepted on your account to use &lt;Transcription&gt;',
    causes: 'To use &lt;Transcription&gt; AI Terms should be accepted on your account.',
    solutions:
      '* Ensure [AI terms](https://console.twilio.com/develop/voice/settings/general?frameUrl=/console/voice/settings) are accepted on your account to use &lt;Transcription&gt;',
    description:
      'A 32655 Warning indicates that the AI Terms for &lt;Transcription&gt; have not been accepted on your account.',
    product: 'Programmable Voice',
    date_created: '2024-06-06T23:23:51Z',
    last_updated: '2024-06-06T23:24:23.554197Z',
  },
  30015: {
    code: 30015,
    message: 'Non-supported channel type is used',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 30015\r\n\r\n### Non-supported channel type is used\r\n\r\nThe To or From attributes have an unsupported prefix for channel\r\n\r\n#### Possible Causes \r\n*  empty channel prefix for an attribute that requires a prefix\r\n*  non-existing prefix for an attribute that requires a prefix\r\n\r\n#### Possible Solutions\r\n*  Check the To/From attributes channel prefix\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-30T16:40:47Z',
    last_updated: '2020-08-04T10:00:10.939Z',
  },
  45050: {
    code: 45050,
    message: 'Authentication error - Missing User Attributes',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 45050\r\n\r\n### Authentication error - Missing User Attributes\r\n\r\n Authentication error - Missing User Attributes\r\n\r\n#### Possible Causes\r\nMissing or invalid required attributes, such as full_name, email or roles\r\n\r\n#### Possible Solutions\r\nEnsure that the user authentication response sent to Flex includes required user attributes.',
    causes: 'Missing or invalid required attributes, such as full_name, email or roles',
    solutions:
      'Ensure that the user authentication response sent to Flex includes required user attributes.',
    description: 'Authentication error - Missing User Attributes',
    product: 'Flex',
    date_created: '2024-03-19T18:09:22Z',
    last_updated: '2024-03-19T18:09:22Z',
  },
  60203: {
    code: 60203,
    message: 'Max send attempts reached.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60203\r\n\r\n### Max send attempts reached.\r\n\r\n This rate limit is triggered when the verification lifecycle (sending and checking) is not completed.\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\n* You have attempted to send the verification code more than 5 times and have reached the limit.\r\n* You have not [checked the verification](https://www.twilio.com/docs/verify/api/verification-check).\r\n\r\n#### Possible Solutions\r\n* Complete a verification lifecycle by calling the [Verification Check endpoint](https://www.twilio.com/docs/verify/api/verification-check).\r\n* Wait for the verification to [expire](https://www.twilio.com/docs/verify/api/rate-limits-and-timeouts) (10 minutes).\r\n* For use with [custom codes](https://www.twilio.com/docs/verify/api/customization-options) you can manually approve or cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n* **For testing** you can manually cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n\r\nIf you identify a delivery issue, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes:
      '* You have attempted to send the verification code more than 5 times and have reached the limit.\r\n* You have not [checked the verification](https://www.twilio.com/docs/verify/api/verification-check).',
    solutions:
      '* Complete a verification lifecycle by calling the [Verification Check endpoint](https://www.twilio.com/docs/verify/api/verification-check).\r\n* Wait for the verification to [expire](https://www.twilio.com/docs/verify/api/rate-limits-and-timeouts) (10 minutes).\r\n* For use with [custom codes](https://www.twilio.com/docs/verify/api/customization-options) you can manually approve or cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n* **For testing** you can manually cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n\r\nIf you identify a delivery issue, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description:
      'This rate limit is triggered when the verification lifecycle (sending and checking) is not completed.\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2018-11-20T19:39:41Z',
    last_updated: '2023-11-01T04:53:26.970701Z',
  },
  33118: {
    code: 33118,
    message: 'Number of Commands exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 33118\r\n\r\n### Number of Commands exceeded\r\n\r\n Raised whenever there are too many Commands queued for an individual SIM.\r\n\r\n\r\n#### Possible Causes\r\n * While sending a Command, your Command was rejected because there are already more than 100 commands queued for your individual Narrowband SIM.\r\n\r\n\r\n#### Possible Solutions\r\n * While sending a Command, ensure there are less than 100 commands queued for an individual Narrowband SIM.\r\n',
    causes:
      ' * While sending a Command, your Command was rejected because there are already more than 100 commands queued for your individual Narrowband SIM.\r\n',
    solutions:
      ' * While sending a Command, ensure there are less than 100 commands queued for an individual Narrowband SIM.\r\n',
    description: 'Raised whenever there are too many Commands queued for an individual SIM.\r\n',
    product: 'Programmable Wireless',
    date_created: '2020-09-15T11:22:28Z',
    last_updated: '2020-09-15T11:22:28Z',
  },
  50353: {
    code: 50353,
    message: 'Conversation with provided unique name already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50353\r\n\r\n### Conversation with provided unique name already exists\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequest contains already existing Conversation unique name.\r\n\r\n#### Possible Solutions\r\nProvide non-existing Conversation unique name in the request.',
    causes: 'Request contains already existing Conversation unique name.',
    solutions: 'Provide non-existing Conversation unique name in the request.',
    description: null,
    product: null,
    date_created: '2021-08-30T10:16:12Z',
    last_updated: '2021-08-30T10:49:58.481676Z',
  },
  21251: {
    code: 21251,
    message: 'Trunking CPS change not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21251\r\n\r\n### Trunking CPS change not allowed\r\n\r\n \r\n\r\n#### Possible Causes\r\n*   This CPS change is not allowed.\r\n\r\n#### Possible Solutions\r\n*  This CPS change is not allowed, kindly contact Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes: '*   This CPS change is not allowed.',
    solutions:
      '*  This CPS change is not allowed, kindly contact Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2017-03-11T21:11:59Z',
    last_updated: '2023-11-01T04:29:39.698236Z',
  },
  50000: {
    code: 50000,
    message: 'Programmable Chat: FriendlyName not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required "FriendlyName" parameter.',
    log_type: null,
    docs: '## Error - 50000\r\n\r\n### Programmable Chat: FriendlyName not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required "FriendlyName" parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid FriendlyName is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-04-15T11:19:12Z',
    last_updated: '2020-08-04T10:00:22.573Z',
  },
  16001: {
    code: 16001,
    message: 'Conference is not bridged',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 16001\r\n\r\n### Conference is not bridged\r\n\r\nThe conference you have tried to access is not currently active.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-03-01T21:01:20Z',
    last_updated: '2020-08-04T10:00:10.155Z',
  },
  21458: {
    code: 21458,
    message: 'PhoneNumber Provisioning Type Mismatch',
    log_level: 'ERROR',
    secondary_message:
      'The type of a PhoneNumber (toll-free or not) did not match the type of the IncomingPhoneNumbers sub-resource (Local or TollFree).  #### Possible Causes *  Make sure to provision toll-free numbers from the IncomingPhoneNumbers/TollFree resource or directly from the IncomingPhoneNumbers/ resource. *  Make sure to provision non-toll-free numbers from the IncomingPhoneNumbers/Local resource or directly from the IncomingPhoneNumbers/ resource.',
    log_type: null,
    docs: '## Error - 21458\n\n### PhoneNumber Provisioning Type Mismatch\n\nThe type of a PhoneNumber (toll-free or not) did not match the type of the IncomingPhoneNumbers sub-resource (Local or TollFree).\n\n#### Possible Causes \n*  Make sure to provision toll-free numbers from the IncomingPhoneNumbers/TollFree resource or directly from the IncomingPhoneNumbers/ resource.\n*  Make sure to provision non-toll-free numbers from the IncomingPhoneNumbers/Local resource or directly from the IncomingPhoneNumbers/ resource.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:21Z',
    last_updated: '2020-08-04T10:00:25.424Z',
  },
  14201: {
    code: 14201,
    message: 'Enqueue: Invalid method value',
    log_level: 'ERROR',
    secondary_message: "The method is invalid. You must specify one of 'GET' or 'POST'.",
    log_type: null,
    docs: "## Error - 14201\n\n### Enqueue: Invalid method value\n\nThe method is invalid. You must specify one of 'GET' or 'POST'.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:09Z',
    last_updated: '2020-08-04T10:00:26.347Z',
  },
  20152: {
    code: 20152,
    message: 'Invalid Header',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 20152\r\n\r\n### Invalid Header\r\nThe header of the JWT provided to the Twilio API was invalid.\r\n\r\n#### Possible Causes \r\n* The structure of the header was invalid.\r\n* Required header values not provided\r\n* Provided header values invalid.\r\n\r\n#### Possible Solution:\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2017-05-05T16:04:34Z',
    last_updated: '2020-08-04T10:00:19.118Z',
  },
  22107: {
    code: 22107,
    message: 'Unable to Update Authorization Document',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 22107\r\n\r\n#### Unable to Update Authorization Document\r\n\r\nYou attempted to make a change that cannot be applied to the Authorization Document resource.\r\n\r\n#### Possible Causes\r\n\r\n* Trying to update or delete an Authorization Document resource that is in status "signed."\r\n\r\n\r\n* Trying to update an Authorization Document that is in status "signing."\r\n\r\n#### Possible Solutions\r\n\r\n\r\nUpdate the Authorization Document to status "opened" if it is not already in a terminal state.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Phone Numbers',
    date_created: '2018-02-16T00:40:19Z',
    last_updated: '2020-08-04T10:00:14.851Z',
  },
  18601: {
    code: 18601,
    message: 'The association between business name and website cannot be verified',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18601\r\n\r\n### The association between business name and website cannot be verified\r\n\r\n The association between business name and website cannot be verified\r\n\r\n#### Possible Causes\r\nThe business name does not match the website SSL certificate, or the website URL\r\n\r\n#### Possible Solutions\r\nPlease edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    causes: 'The business name does not match the website SSL certificate, or the website URL',
    solutions:
      'Please edit the Business Profile & update the missing information. You can also reach out to our support team at verifymyaccount@twilio.com for any additional clarifications.',
    description: 'The association between business name and website cannot be verified',
    product: 'Phone Numbers',
    date_created: '2024-02-22T03:23:21Z',
    last_updated: '2024-02-22T03:24:13.635666Z',
  },
  63017: {
    code: 63017,
    message: 'Rate limit exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Rate limit exceeded\r\n\r\n#### Possible Causes \r\n* Your account or subaccounts are sending messages at a higher combined rate than 2000 messages-per-second.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-13T23:08:34Z',
    last_updated: '2020-08-04T10:00:10.56Z',
  },
  13622: {
    code: 13622,
    message: 'Record: invalid recordingTrack value',
    log_level: 'WARNING',
    secondary_message: 'The recordingTrack can be "inbound", "outbound", or "both"',
    log_type: 'APPLICATION',
    docs: '## WARNING - 13622\r\n\r\n### Record: invalid recordingTrack value\r\n\r\nThe recordingTrack can be "inbound", "outbound", or "both" \r\n\r\n#### Possible Causes\r\nInvalid combinations of recordingTrack with requested channels\r\n\r\n#### Possible Solutions\r\nCheck valid combinations of recordingTrack with requested channels',
    causes: 'Invalid combinations of recordingTrack with requested channels',
    solutions: 'Check valid combinations of recordingTrack with requested channels',
    description:
      '## Warning - 13622 \r\n\r\n### Record: invalid recordingTrack value\r\n\r\nThe recordingTrack can be "inbound", "outbound", or "both"',
    product: 'Programmable Voice',
    date_created: '2023-11-29T18:13:54Z',
    last_updated: '2023-11-29T18:16:29.897446Z',
  },
  20106: {
    code: 20106,
    message: 'Invalid Access Token grants',
    log_level: 'ERROR',
    secondary_message: 'Invalid Access Token grants',
    log_type: null,
    docs: "# Error - 20106\r\n\r\n## Invalid Access Token grants\r\n\r\nThe Access Token signature and issuer were valid, but the grants specified\r\nin the token were invalid, unparseable, or did not authorize the action\r\nbeing requested.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation including the\r\ngrant format, see\r\n[the documentation](/docs/api/rest/access-tokens).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Platform',
    date_created: '2016-04-01T07:00:25Z',
    last_updated: '2020-08-04T10:00:22.682Z',
  },
  70101: {
    code: 70101,
    message: 'Unsupported Public Key Algorithm',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70101\r\n\r\n### Unsupported Public Key Algorithm\r\nThe Request tries to store a Public Key in Twilio. This public key can be parsed, but the request fails, because the key uses an unsupported algorithm.\r\n\r\n#### Possible Causes \r\n* Wrong public key algorithm. Only supported algorithm is RSA.\r\n\r\n#### Possible Solution\r\n* Regenerate a new keypair with RSA encryption and retry.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:43:57Z',
    last_updated: '2020-08-04T10:00:19.869Z',
  },
  30747: {
    code: 30747,
    message: 'Brand Registration Failure: Address duplicate threshold reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30747\r\n\r\n### Brand Registration Failure: Address duplicate threshold reached\r\n\r\n Brand can not be registered with provided address since duplicate threshold limit has been reached for it.\r\n\r\n#### Possible Causes\r\nReusing addresses for Sole Proprietor Brands is not allowed. Each Sole Proprietor Brand should have a unique address linked to it. It is possible that the Starter customer profile bundle associated with the brand you tried to register has a duplicate address linked to it. \r\n\r\n#### Possible Solutions\r\nPlease edit the connected starter customer profile and link a different (unique) address to it. Once updated and submitted for review, please resubmit the Sole Proprietor Brand registration request.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes:
      'Reusing addresses for Sole Proprietor Brands is not allowed. Each Sole Proprietor Brand should have a unique address linked to it. It is possible that the Starter customer profile bundle associated with the brand you tried to register has a duplicate address linked to it. ',
    solutions:
      'Please edit the connected starter customer profile and link a different (unique) address to it. Once updated and submitted for review, please resubmit the Sole Proprietor Brand registration request.\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description:
      'Brand can not be registered with provided address since duplicate threshold limit has been reached for it.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:40:42Z',
    last_updated: '2024-02-13T15:45:39.88602Z',
  },
  50601: {
    code: 50601,
    message: 'Programmable Chat: Invite not found',
    log_level: 'ERROR',
    secondary_message: 'Specified Invite does not exist.',
    log_type: null,
    docs: '## Error - 50601\r\n\r\n### Programmable Chat: Invite not found\r\n\r\n#### Possible Causes \r\n*  Specified Invite does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Invite is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:54Z',
    last_updated: '2020-08-04T10:00:22.895Z',
  },
  22300: {
    code: 22300,
    message: 'This account is restricted from provisioning new long code phone numbers',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22300\r\n\r\n### This account is restricted from provisioning new long code phone numbers\r\n\r\n The account is temporarily restricted from provisioning new long code phone numbers.\r\n\r\n#### Possible Causes\r\nTwilio Compliance has temporarily restricted the account from provisioning new long code phone numbers.\r\n\r\n#### Possible Solutions\r\nPlease reach out to verifymyaccount@twilio.com to have this restriction lifted from your account. Be sure to include your Twilio Account SID, the name of your business or project, and a brief explanation of your use case.',
    causes:
      'Twilio Compliance has temporarily restricted the account from provisioning new long code phone numbers.',
    solutions:
      'Please reach out to verifymyaccount@twilio.com to have this restriction lifted from your account. Be sure to include your Twilio Account SID, the name of your business or project, and a brief explanation of your use case.',
    description:
      'The account is temporarily restricted from provisioning new long code phone numbers.',
    product: 'Phone Numbers',
    date_created: '2021-06-01T21:29:17Z',
    last_updated: '2023-03-13T21:36:30.738329Z',
  },
  21243: {
    code: 21243,
    message: 'Credential Validation Error',
    log_level: 'ERROR',
    secondary_message:
      'One of the parameters passed when creating or updating a Credential was incorrect.  Please see the response body for more details.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21243\r\n\r\n### Credential Validation Error\r\n\r\nOne of the parameters passed when creating or updating a Credential was incorrect.  Please see the response body for more details. \r\n\r\n#### Possible Causes\r\n* One of the parameters passed when creating or updating a Credential was incorrect.\r\n\r\n#### Possible Solutions\r\n* Please see the response body for more details.',
    causes: '* One of the parameters passed when creating or updating a Credential was incorrect.',
    solutions: '* Please see the response body for more details.',
    description: null,
    product: null,
    date_created: '2020-08-04T02:37:49Z',
    last_updated: '2020-08-04T10:00:00.298Z',
  },
  51123: {
    code: 51123,
    message: 'Twilsock: Upstream not resolved',
    log_level: 'ERROR',
    secondary_message: "Specified upstream couldn't be resolved.",
    log_type: null,
    docs: "## Error - 51123\r\n\r\n### Upstream not resolved\r\n\r\n#### Possible Causes \r\nSpecified upstream couldn't be resolved.\r\n\r\n#### Possible Solutions\r\nVerify that upstream is valid and passed correctly. ",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T13:23:13Z',
    last_updated: '2020-08-04T10:00:09.495Z',
  },
  30035: {
    code: 30035,
    message: 'US A2P 10DLC - Message from a number still being configured',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30035\r\n\r\n### US A2P 10DLC - Message from a number still being configured\r\n\r\n We could not send your message because this number you're sending from is still being configured. Twilio has received your request to register or deregister this number under a US A2P campaign, but has not completed the necessary configurations with ecosystem partners (“Number Registration”). You will not be able to send messages on the A2P routes until your number status is changed to “Registered”.\r\n\r\n#### Possible Causes\r\nTwilio is still processing your Number Registration requests with ecosystem partners for US A2P 10DLC\r\n\r\n#### Possible Solutions\r\nWhile Number Registration often completes within minutes, under certain circumstances, registration time can widely fluctuate depending on the volume of registration requests. Twilio has received your Number Registration request and is working on configuring your number with ecosystem partners. Please [check the status of your number in the Twilio console](https://console.twilio.com/us1/develop/phone-numbers/manage/incoming/a2p-compliance/status?_gl=1*1ttowh2*_ga*MTY4MDY0MDY3NC4xNjkyODkzNTk4*_ga_RRP8K4M4F3*MTY5NzgzNDU4NC42OC4xLjE2OTc4MzQ2MTcuMC4wLjA.&_ga=2.240863811.1963643099.1697477953-1680640674.1692893598). You will only be able to send messages on numbers that are in the “Registered” status. To get your number registered, please check out [A2P 10DLC Number Registration Best Practices](https://support.twilio.com/hc/en-us/articles/19622397178139-A2P-10DLC-Number-Registration-Best-Practices).\r\n\r\nNOTE:  Users of multiple phone numbers should note that antiquated phone number practices to improve deliverability, such as using multiple numbers to increase throughput or rotating them between their customers or use cases, undermine the deliverability benefits of A2P 10DLC and can lead to processing delays related to 30035 errors. We recommend reviewing [A2P 10DLC Number Registration Best Practices](https://support.twilio.com/hc/en-us/articles/19622397178139-A2P-10DLC-Number-Registration-Best-Practices).",
    causes:
      'Twilio is still processing your Number Registration requests with ecosystem partners for US A2P 10DLC',
    solutions:
      'While Number Registration often completes within minutes, under certain circumstances, registration time can widely fluctuate depending on the volume of registration requests. Twilio has received your Number Registration request and is working on configuring your number with ecosystem partners. Please [check the status of your number in the Twilio console](https://console.twilio.com/us1/develop/phone-numbers/manage/incoming/a2p-compliance/status?_gl=1*1ttowh2*_ga*MTY4MDY0MDY3NC4xNjkyODkzNTk4*_ga_RRP8K4M4F3*MTY5NzgzNDU4NC42OC4xLjE2OTc4MzQ2MTcuMC4wLjA.&_ga=2.240863811.1963643099.1697477953-1680640674.1692893598). You will only be able to send messages on numbers that are in the “Registered” status. To get your number registered, please check out [A2P 10DLC Number Registration Best Practices](https://support.twilio.com/hc/en-us/articles/19622397178139-A2P-10DLC-Number-Registration-Best-Practices).\r\n\r\nNOTE:  Users of multiple phone numbers should note that antiquated phone number practices to improve deliverability, such as using multiple numbers to increase throughput or rotating them between their customers or use cases, undermine the deliverability benefits of A2P 10DLC and can lead to processing delays related to 30035 errors. We recommend reviewing [A2P 10DLC Number Registration Best Practices](https://support.twilio.com/hc/en-us/articles/19622397178139-A2P-10DLC-Number-Registration-Best-Practices).',
    description:
      "We could not send your message because this number you're sending from is still being configured. Twilio has received your request to register or deregister this number under a US A2P campaign, but has not completed the necessary configurations with ecosystem partners (“Number Registration”). You will not be able to send messages on the A2P routes until your number status is changed to “Registered”.",
    product: 'Programmable SMS',
    date_created: '2023-05-01T05:25:09Z',
    last_updated: '2023-10-20T20:53:12.502962Z',
  },
  20023: {
    code: 20023,
    message: 'Phone number is not correct: it cannot be null or have non-decimal symbols',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 20023\r\n\r\n### Phone number is not correct: it cannot be null or have non-decimal symbols\r\n\r\n Phone number is not correct: it cannot be null and have non-decimal symbols\r\n\r\n#### Possible Causes\r\n* The phone number entered is not correct: either it is null or it has non-decimal symbols.\r\n\r\n#### Possible Solutions\r\n* Check the phone number',
    causes:
      '* The phone number entered is not correct: either it is null or it has non-decimal symbols.',
    solutions: '* Check the phone number',
    description: 'Phone number is not correct: it cannot be null and have non-decimal symbols',
    product: null,
    date_created: '2020-10-12T22:15:42Z',
    last_updated: '2020-10-13T22:02:16.163Z',
  },
  13334: {
    code: 13334,
    message: 'Gather: Invalid model value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13334\r\n\r\n### Gather: Invalid model value\r\n\r\n ## Warning - 13334\r\n\r\n### Gather: Invalid model value\r\n\r\n#### Possible Causes\r\nInvalid model\r\n\r\n#### Possible Solutions\r\nEnter a valid model',
    causes: 'Invalid model',
    solutions: 'Enter a valid model',
    description: '## Warning - 13334\r\n\r\n### Gather: Invalid model value',
    product: 'Programmable Voice',
    date_created: '2019-07-17T20:20:38Z',
    last_updated: '2020-08-04T10:00:07.64Z',
  },
  70151: {
    code: 70151,
    message: 'Maximum Number Of API Keys Exceeded',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70151\r\n\r\n### Maximum Number Of API Keys Exceeded\r\nThe account reached the maximum limit of API Keys allowed. \r\n\r\n#### Possible Solution:\r\n* Delete unused API Keys before creating additional ones.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:25:00Z',
    last_updated: '2020-08-04T10:00:18.809Z',
  },
  92003: {
    code: 92003,
    message: "'language' Parameter Required",
    log_level: 'ERROR',
    secondary_message: 'Invalid language. Language is required',
    log_type: 'APPLICATION',
    docs: "## ERROR - 92003\r\n\r\n### 'language' Parameter Required\r\n\r\nInvalid language. Language is required \r\n\r\n#### Possible Causes\r\nYou attempted to create content, but you forgot to include the 'language', the language property is required. \r\n\r\n#### Possible Solutions\r\nPlease include a supported language",
    causes:
      "You attempted to create content, but you forgot to include the 'language', the language property is required. ",
    solutions: 'Please include a supported language',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-11-08T19:49:50Z',
    last_updated: '2021-11-08T19:49:50Z',
  },
  30881: {
    code: 30881,
    message: 'Campaign vetting rejection - Invalid Brand Support Email',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30881\r\n\r\n### Campaign vetting rejection - Invalid Brand Support Email\r\n\r\n The campaign submission has been reviewed and it was rejected because invalid brand support email.\r\n\r\n#### Possible Causes\r\nThe campaign cannot be approved because support email needs is not associated with the brand. The brand support email was either invalid or associated with a public domain email.\r\n\r\n#### Possible Solutions\r\nPlease verify that brand support email is valid and not associated with a public domain email.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    causes:
      'The campaign cannot be approved because support email needs is not associated with the brand. The brand support email was either invalid or associated with a public domain email.',
    solutions:
      'Please verify that brand support email is valid and not associated with a public domain email.\r\n \r\nAdditional help resources\r\n\r\n* [A2P 10DLC campaign approval best practices](https://support.twilio.com/hc/en-us/articles/11847054539547-A2P-10DLC-Campaign-Approval-Best-Practices)',
    description:
      'The campaign submission has been reviewed and it was rejected because invalid brand support email.',
    product: 'Programmable Messaging',
    date_created: '2023-04-18T11:31:42Z',
    last_updated: '2023-04-18T11:31:42Z',
  },
  51002: {
    code: 51002,
    message: 'Client Connection: Request rate limit exceeded',
    log_level: 'ERROR',
    secondary_message: 'error',
    log_type: null,
    docs: "## Error - 51002\n\n### Client Connection: Request rate limit exceeded\n\n#### Possible Causes \n\nThe rate of client requests exceeded the limit.\n\n#### Possible Solutions\n\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your Account's client request limit.\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:54Z',
    last_updated: '2020-08-04T10:00:22.855Z',
  },
  40159: {
    code: 40159,
    message: "Conference Instruction does not have a valid 'status_callback_url' parameter",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40159\r\n\r\n### Conference Instruction does not have a valid \'status_callback_url\' parameter\r\n\r\n Invalid \'status_callback_url\' parameter - Conference Instruction\r\n\r\n#### Possible Causes\r\nProvided value for the "status_callback_url" parameter is either an empty string or of an incorrect datatype.\r\n\r\n#### Possible Solutions\r\n"status_callback_url" should be a well formed HTTP or HTTPS URL string.',
    causes:
      'Provided value for the "status_callback_url" parameter is either an empty string or of an incorrect datatype.',
    solutions: '"status_callback_url" should be a well formed HTTP or HTTPS URL string.',
    description: "Invalid 'status_callback_url' parameter - Conference Instruction",
    product: 'TaskRouter',
    date_created: '2023-02-22T06:58:39Z',
    last_updated: '2023-02-22T06:58:39Z',
  },
  30615: {
    code: 30615,
    message: "Message couldn't be delivered",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30615\r\n\r\n### Message couldn't be delivered\r\n\r\n Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n\r\n#### Possible Causes\r\nTBD\r\n\r\n#### Possible Solutions\r\nTBD",
    causes: 'TBD',
    solutions: 'TBD',
    description:
      'Message couldn’t be delivered to the destination number you are trying to reach temporarily.',
    product: 'Programmable Messaging',
    date_created: '2024-04-16T06:06:55Z',
    last_updated: '2024-04-16T06:06:55Z',
  },
  22229: {
    code: 22229,
    message: 'Supporting Document Bundle Assignment cannot be removed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22229\r\n\r\n### Supporting Document Bundle Assignment cannot be removed\r\n\r\n The destination Bundle must have the same address as the Bundle Copy due to lack of feature support for Phone Number address assignment.\r\n\r\n#### Possible Causes\r\nThe Address in the Bundle Copy must be the same as in the destination Bundle and cannot be removed.\r\n\r\n#### Possible Solutions\r\nMetadata of the Supporting Document can be updated but the Address is immutable. Either a new Supporting Document that validates the same information can be supplied or a new Regulatory Bundle can be created.',
    causes:
      'The Address in the Bundle Copy must be the same as in the destination Bundle and cannot be removed.',
    solutions:
      'Metadata of the Supporting Document can be updated but the Address is immutable. Either a new Supporting Document that validates the same information can be supplied or a new Regulatory Bundle can be created.',
    description:
      'The destination Bundle must have the same address as the Bundle Copy due to lack of feature support for Phone Number address assignment.',
    product: 'Phone Numbers',
    date_created: '2022-03-10T23:50:41Z',
    last_updated: '2022-03-10T23:50:41Z',
  },
  13225: {
    code: 13225,
    message: 'Dial: Call blocked by Twilio',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 13225\r\n\r\n### Dial: Call blocked by Twilio\r\n\r\n The destination number is blocked by Twilio.\r\n\r\n#### Possible Causes\r\nThe destination has a high-risk of fraud or due to regulatory reasons cannot be reached.\r\n\r\n#### Possible Solutions\r\nIf you have a legitimate need to call this number, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com). ',
    causes:
      'The destination has a high-risk of fraud or due to regulatory reasons cannot be reached.',
    solutions:
      'If you have a legitimate need to call this number, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com). ',
    description: 'The destination number is blocked by Twilio.',
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:34Z',
    last_updated: '2023-11-01T04:51:52.579502Z',
  },
  22001: {
    code: 22001,
    message: 'Call timed out',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 22001\r\n\r\n### Call timed out\r\n\r\n The call timed out before system could complete the call\r\n\r\n#### Possible Causes\r\nThe call timed out before system could complete the call\r\n\r\n#### Possible Solutions\r\nCPS limits may be too low',
    causes: 'The call timed out before system could complete the call',
    solutions: 'CPS limits may be too low',
    description: 'The call timed out before system could complete the call',
    product: 'Programmable Voice',
    date_created: '2019-12-11T23:12:34Z',
    last_updated: '2020-08-04T10:00:05.757Z',
  },
  80102: {
    code: 80102,
    message: 'Participant Already In Interaction',
    log_level: 'WARNING',
    secondary_message: 'Participant has already been added to Interaction',
    log_type: null,
    docs: '## Warning\n\n### Participant Already In Interaction\n\nExample Message: Participant has already been added to Interaction',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.271Z',
  },
  83009: {
    code: 83009,
    message: 'Unable to update your Super SIM’s Fleet while it is in status scheduled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83009\r\n\r\n### Unable to update your Super SIM’s Fleet while it is in status scheduled\r\n\r\n Your Fleet update request cannot be performed on your Super SIM as it is in status scheduled.\r\n\r\n#### Possible Causes\r\n* Another operation on your Super SIM is in progress.\r\n\r\n#### Possible Solutions\r\n* Wait for the current Super SIM operation to be complete and try again.',
    causes: '* Another operation on your Super SIM is in progress.',
    solutions: '* Wait for the current Super SIM operation to be complete and try again.',
    description:
      'Your Fleet update request cannot be performed on your Super SIM as it is in status scheduled.',
    product: 'Super SIM',
    date_created: '2021-08-23T11:25:40Z',
    last_updated: '2021-08-23T11:25:40Z',
  },
  31942: {
    code: 31942,
    message: 'Stream - Invalid connector configuration',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31942\r\n\r\n### Stream - Invalid connector configuration\r\n\r\n Connector invalid configuration\r\n\r\n#### Possible Causes\r\n* When using Virtual Agent make sure the Project ID, Conversation Profile ID and language configurations are correct.\r\n\r\n#### Possible Solutions\r\n* Review configuration',
    causes:
      '* When using Virtual Agent make sure the Project ID, Conversation Profile ID and language configurations are correct.',
    solutions: '* Review configuration',
    description: 'Connector invalid configuration',
    product: 'Programmable Voice',
    date_created: '2020-09-08T08:07:27Z',
    last_updated: '2020-09-08T08:07:27Z',
  },
  70003: {
    code: 70003,
    message: 'Outdated Entity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70003\r\n\r\n### Outdated Entity\r\nThe request tries to update a resource that has been already updated (by someone else). Only applies if the resource uses a version field.\r\n\r\n#### Possible Causes \r\n* When sending an update request that contains field: “version: 1” and the server recognizes that the actual version of the resource is already 2.\r\n\r\n#### Possible Solution:\r\n* Reload the resource with a GET request to get the latest version.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-04-14T20:37:58Z',
    last_updated: '2020-08-04T10:00:19.907Z',
  },
  32204: {
    code: 32204,
    message: "SIP: 'From' phone number not verified",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 32204\r\n\r\n### SIP: 'From' phone number not verified\r\n\r\n You attempted to initiate an outbound phone call, but the <span class='rest-attribute'>From</span> number you specified is not a verified Outgoing Caller ID for your account.  In order to use a phone number as the Caller ID on outgoing calls, you must first validate your ownership of that phone number.\r\n\r\n#### Possible Causes\r\nThe `From` number used to make outbound call not a Twilio number or not a verified caller ID\r\n\r\n#### Possible Solutions\r\nChange the callerID used in the From field of the SIP INVITE to a Twilio number on your account or verify your number by visiting the Console [Verified Caller IDs](/user/account/phone-numbers/verified) or REST API.",
    causes:
      'The `From` number used to make outbound call not a Twilio number or not a verified caller ID',
    solutions:
      'Change the callerID used in the From field of the SIP INVITE to a Twilio number on your account or verify your number by visiting the Console [Verified Caller IDs](/user/account/phone-numbers/verified) or REST API.',
    description:
      "You attempted to initiate an outbound phone call, but the <span class='rest-attribute'>From</span> number you specified is not a verified Outgoing Caller ID for your account.  In order to use a phone number as the Caller ID on outgoing calls, you must first validate your ownership of that phone number.",
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:38Z',
    last_updated: '2020-08-04T10:00:24.186Z',
  },
  31481: {
    code: 31481,
    message: 'Call/Transaction Does Not Exist',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31481\r\n\r\n### Call/Transaction Does Not Exist \r\n\r\nThe call no longer exists.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-05-22T22:38:19Z',
    last_updated: '2020-08-04T10:00:08.334Z',
  },
  32502: {
    code: 32502,
    message: 'Voice Conversation: Callback event internal error.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 32502\r\n\r\n### Voice Conversation: Callback event internal error.\r\n\r\n Internal error occurred when executing a request to one of the status callback URLs specified in the Conversation noun. This error will occur when Voice Conversation service fails to reach out to Callback service.\r\n\r\n#### Possible Causes\r\n- Twilio failed to execute callback request when Voice Conversation service attempted to reach out to status Callback service. \r\n\r\n#### Possible Solutions\r\n- If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
    causes:
      '- Twilio failed to execute callback request when Voice Conversation service attempted to reach out to status Callback service. ',
    solutions:
      '- If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
    description:
      'Internal error occurred when executing a request to one of the status callback URLs specified in the Conversation noun. This error will occur when Voice Conversation service fails to reach out to Callback service.',
    product: 'Programmable Voice',
    date_created: '2022-06-07T17:37:06Z',
    last_updated: '2022-07-29T16:31:35.621565Z',
  },
  90024: {
    code: 90024,
    message: "Template body has tag which is not provided in 'TemplateArgs'",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90024\r\n\r\n### Template body has tag which is not provided in 'TemplateArgs'\r\n\r\n Template body has tag which is not provided in 'TemplateArgs'\r\n\r\n#### Possible Causes\r\nTemplate body has wider tag's set than specified in 'TemplateArgs' dictionary\r\n\r\n#### Possible Solutions\r\nCheck all tags from template body are specified in 'TemplateArgs' dictionary as keys",
    causes: "Template body has wider tag's set than specified in 'TemplateArgs' dictionary",
    solutions:
      "Check all tags from template body are specified in 'TemplateArgs' dictionary as keys",
    description: "Template body has tag which is not provided in 'TemplateArgs'",
    product: null,
    date_created: '2020-12-11T08:51:17Z',
    last_updated: '2020-12-11T08:51:17Z',
  },
  63102: {
    code: 63102,
    message: 'Account already linked to another WABA ID',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63102\r\n\r\n### Account already linked to another WABA ID\r\n\r\n The Twilio Account contains other WhatsApp Senders and is already linked to an existing WhatsApp Business Account (WABA). Twilio Accounts must be linked to only one WABA ID at a time.\r\n\r\n#### Possible Causes\r\n* Attempting to use a different WABA ID than the one linked to the Twilio Account\r\n\r\n#### Possible Solutions\r\n* Use the same WABA ID that is linked to the account\r\n* Delete other WhatsApp Senders to link the Account to another WABA',
    causes: '* Attempting to use a different WABA ID than the one linked to the Twilio Account',
    solutions:
      '* Use the same WABA ID that is linked to the account\r\n* Delete other WhatsApp Senders to link the Account to another WABA',
    description:
      'The Twilio Account contains other WhatsApp Senders and is already linked to an existing WhatsApp Business Account (WABA). Twilio Accounts must be linked to only one WABA ID at a time.',
    product: 'Channels',
    date_created: '2024-02-09T22:25:29Z',
    last_updated: '2024-02-09T22:25:29Z',
  },
  60384: {
    code: 60384,
    message: 'Invalid challenge timeout',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60384\r\n\r\n### Invalid challenge timeout\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Challenge timeout in the request is negative.\r\n\r\n#### Possible Solutions\r\nCheck that the Challenge timeout in the request has positive value',
    causes: 'The Challenge timeout in the request is negative.',
    solutions: 'Check that the Challenge timeout in the request has positive value',
    description: null,
    product: 'Verify',
    date_created: '2023-12-27T09:53:08Z',
    last_updated: '2023-12-27T09:53:08Z',
  },
  13255: {
    code: 13255,
    message: 'Dialing .sip.twilio.com addresses is not currently allowed',
    log_level: 'WARNING',
    secondary_message:
      'At this time internal routing of SIP calls within Twilio is not supported i.e. dialing .sip.twilio.com addresses from a Twilio number.',
    log_type: null,
    docs: '# Warning - 13255\n\n### Dial->Sip: Dialing .sip.twilio.com addresses is not currently allowed\n\nAt this time internal routing of SIP calls within Twilio is not supported i.e. dialing .sip.twilio.com addresses from a Twilio number.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:32Z',
    last_updated: '2020-08-04T10:00:24.705Z',
  },
  53100: {
    code: 53100,
    message: 'Room name is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### 53100: Room name is invalid\r\n\r\nRaised whenever a Room name is invalid, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\n * The Room name does not adhere to the Room name requirements.\r\n\r\n#### Solutions\r\n\r\n * Choose a Room name adheres to the Room name requirements.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2017-04-24T15:39:38Z',
    last_updated: '2020-08-04T10:00:19.658Z',
  },
  40139: {
    code: 40139,
    message: 'Failed to issue Conference Instruction due to invalid ActivitySid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40139\r\n\r\n### Failed to issue Conference Instruction due to invalid ActivitySid\r\n\r\n Conference Instruction requires a valid `post_work_activity_sid`\r\n\r\n#### Possible Causes\r\n*  The provided  `post_work_activity_sid` is invalid or no longer exists in the operating Workspace.  \r\n\r\n#### Possible Solutions\r\n* Ensure that a valid ActivitySid is provided in the `post_work_activity_sid` property in the Worker’s attributes or request parameters.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```\r\n',
    causes:
      '*  The provided  `post_work_activity_sid` is invalid or no longer exists in the operating Workspace.  ',
    solutions:
      '* Ensure that a valid ActivitySid is provided in the `post_work_activity_sid` property in the Worker’s attributes or request parameters.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```\r\n',
    description: 'Conference Instruction requires a valid `post_work_activity_sid`',
    product: 'TaskRouter',
    date_created: '2020-09-14T21:40:10Z',
    last_updated: '2020-09-14T21:40:10Z',
  },
  31006: {
    code: 31006,
    message: 'Audio device error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 31006\r\n\r\n### Audio device error\r\n\r\nUnable to start the audio device',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-01-24T19:29:27Z',
    last_updated: '2020-08-04T10:00:11.424Z',
  },
  21727: {
    code: 21727,
    message: 'Campaign registration failed due to missing parameter(s)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21727\r\n\r\n### Campaign registration failed due to missing parameter(s)\r\n\r\n We could not register your US A2P Campaign because one or more required parameter(s) are missing\r\n\r\n#### Possible Causes\r\nOne or more required parameters are missing for Campaign registration\r\n\r\n#### Possible Solutions\r\nPlease include all required parameters and retry Campaign registration. Please check out our [support article](https://support.twilio.com/hc/en-us/articles/8959909733403-Changes-to-the-A2P-10DLC-Campaign-Creation-Process) to understand which fields are required for campaign registration. ',
    causes: 'One or more required parameters are missing for Campaign registration',
    solutions:
      'Please include all required parameters and retry Campaign registration. Please check out our [support article](https://support.twilio.com/hc/en-us/articles/8959909733403-Changes-to-the-A2P-10DLC-Campaign-Creation-Process) to understand which fields are required for campaign registration. ',
    description:
      'We could not register your US A2P Campaign because one or more required parameter(s) are missing',
    product: 'Programmable SMS',
    date_created: '2022-10-06T18:25:40Z',
    last_updated: '2022-10-06T18:34:56.167978Z',
  },
  62011: {
    code: 62011,
    message: 'Unauthorized',
    log_level: 'ERROR',
    secondary_message:
      'The access credentials provided are not authorized to access this resource.',
    log_type: null,
    docs: '## Error - 62011\r\n\r\n### Unauthorized\r\n\r\nThe access credentials provided are not authorized to access this resource.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-10-05T23:39:45Z',
    last_updated: '2020-08-04T10:00:20.999Z',
  },
  45715: {
    code: 45715,
    message: 'Failed to create webchat participant. Invalid request parameters. ',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45715\r\n\r\n### Failed to create webchat participant. Invalid request parameters. \r\n\r\n Failed to create participant due to invalid request parameters. \r\n\r\n#### Possible Causes\r\nThe address configuration associated with the address SID provided could have invalid parameters. This could be because the account credentials provided are not associated with the address SID provided. \r\n\r\n#### Possible Solutions\r\nEnsure the account credentials and address SID provided are correct and are all associated with the intended account. \r\n\r\nEnsure that the request parameters are in accordance with the public documentation.',
    causes:
      'The address configuration associated with the address SID provided could have invalid parameters. This could be because the account credentials provided are not associated with the address SID provided. ',
    solutions:
      'Ensure the account credentials and address SID provided are correct and are all associated with the intended account. \r\n\r\nEnsure that the request parameters are in accordance with the public documentation.',
    description: 'Failed to create participant due to invalid request parameters. ',
    product: 'Flex',
    date_created: '2022-10-03T21:38:31Z',
    last_updated: '2022-10-03T21:43:03.939086Z',
  },
  52101: {
    code: 52101,
    message: 'Invalid GCM Api Key or FCM Secret',
    log_level: 'ERROR',
    secondary_message: 'GCM/FCM credential contains invalid or empty ApiKey/Secret',
    log_type: null,
    docs: '## Error - 52101\r\n\r\n### Invalid GCM Api Key or FCM Secret\r\n\r\n#### Possible Causes \r\n*  The GCM API Key or FCM Secret provided is invalid.\r\n\r\n#### Possible Solutions\r\n* Provide a valid GCM API Key or FCM Secret',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:05:29Z',
    last_updated: '2020-08-04T10:00:22.401Z',
  },
  14215: {
    code: 14215,
    message: 'Dial->Queue: Invalid ReservationSid. Unable to dequeue',
    log_level: 'ERROR',
    secondary_message: 'Provided ReservationSid is invalid.',
    log_type: null,
    docs: '## Error - 14215\n\n### Dial->Queue: Invalid ReservationSid. Unable to dequeue\n\nProvided ReservationSid is invalid.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:12Z',
    last_updated: '2020-08-04T10:00:26.124Z',
  },
  63026: {
    code: 63026,
    message: 'Channel sender content flagged as spam',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel sender content flagged as spam\r\n\r\n#### Possible Causes \r\n* Sender content was flagged as spam. Please check the content of the message.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2019-02-25T19:34:31Z',
    last_updated: '2020-08-04T10:00:10.395Z',
  },
  14102: {
    code: 14102,
    message: 'Invalid "From" attribute',
    log_level: 'WARNING',
    secondary_message:
      'The From phone number does not appear to be a phone number that you can SMS from',
    log_type: null,
    docs: '## Warning - 14102 \n\n### Message "From" Attribute is Invalid\n\nThe From phone number does not appear to be a phone number that you can message from\n\n#### Possible Causes \n*  Using a ‘From’ number that is not assigned to your account\n*  Using a ‘From’ number that is not SMS/MMS enabled\n\n\n#### Possible Solutions\n*  Check to make sure the number is correct\n*  Check to make sure the number is an SMS/MMS enabled Twilio Incoming number assigned to your account\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:48Z',
    last_updated: '2020-08-04T10:00:27.66Z',
  },
  53612: {
    code: 53612,
    message: 'Invalid public key for media tracks encryption in recording settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53612\r\n\r\n### Invalid public key for media tracks encryption in recording settings\r\n\r\nThe public key configured in your account's recording settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect raw media tracks, this is most likely due to the fact that the key value is not correct.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-05-24T13:22:15Z',
    last_updated: '2020-08-04T10:00:13.674Z',
  },
  48033: {
    code: 48033,
    message: 'Outgoing conversation: Invalid contact identity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 48033\r\n\r\n### Outgoing conversation: Invalid contact identity\r\n\r\n A conversation could not be created because the provided contact chat identity was invalid.\r\n\r\n#### Possible Causes\r\n* The contact chat identity was not formatted properly.\r\n* A reserved identity was used for contact chat identity.\r\n\r\n#### Possible Solutions\r\n* Make sure that the contact chat identity returned from the CRM callback is formatted properly and does not violate the following rules.\r\n    * Should not match a User SID pattern `US[0-9a-f]{32}`.\r\n    * Should not be a reserved identity (`system`, `private`, `unique`).\r\n    * Should not be longer than 256 characters.\r\n* We recommend following the standard URI specification and avoid the following reserved characters `! * ' ( ) ; : @ & = + $ , / ? % # [ ]` for identity.",
    causes:
      '* The contact chat identity was not formatted properly.\r\n* A reserved identity was used for contact chat identity.',
    solutions:
      "* Make sure that the contact chat identity returned from the CRM callback is formatted properly and does not violate the following rules.\r\n    * Should not match a User SID pattern `US[0-9a-f]{32}`.\r\n    * Should not be a reserved identity (`system`, `private`, `unique`).\r\n    * Should not be longer than 256 characters.\r\n* We recommend following the standard URI specification and avoid the following reserved characters `! * ' ( ) ; : @ & = + $ , / ? % # [ ]` for identity.",
    description:
      'A conversation could not be created because the provided contact chat identity was invalid.',
    product: 'Frontline',
    date_created: '2022-04-20T15:57:23Z',
    last_updated: '2022-04-20T15:57:23Z',
  },
  50453: {
    code: 50453,
    message: 'Proxy Address of participant is not supported for this channel',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 50453\r\n\r\n### Proxy Address of participant is not supported for this channel\r\n\r\n Triggered when account is trying to add or update the participant with a proxy address that is not supported in given channel, e.g. email, etc.\r\n\r\n#### Possible Causes\r\nProxy Address for participant is not supported in given channel\r\n\r\n#### Possible Solutions\r\nRemove proxy address field of the participant',
    causes: 'Proxy Address for participant is not supported in given channel',
    solutions: 'Remove proxy address field of the participant',
    description:
      'Triggered when account is trying to add or update the participant with a proxy address that is not supported in given channel, e.g. email, etc.',
    product: 'Conversations',
    date_created: '2022-08-23T15:27:58Z',
    last_updated: '2022-08-23T15:27:58Z',
  },
  45306: {
    code: 45306,
    message: 'Meeting was canceled',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45306\r\n\r\n### Meeting was canceled\r\n\r\n Operation was canceled\r\n\r\n#### Possible Causes\r\nOperation was canceled\r\n\r\n#### Possible Solutions\r\nNo action required.',
    causes: 'Operation was canceled',
    solutions: 'No action required.',
    description: 'Operation was canceled',
    product: 'Flex',
    date_created: '2020-01-14T21:15:31Z',
    last_updated: '2020-08-04T10:00:05.256Z',
  },
  91100: {
    code: 91100,
    message: 'Subscription could not be created',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 91100\r\n\r\n### Subscription could not be created\r\n\r\n Creating subscription for sink failed\r\n\r\n#### Possible Causes\r\n* Sink is not in an active state\r\n\r\n#### Possible Solutions\r\n* Ensure sink is in an active state before creating subscription',
    causes: '* Sink is not in an active state',
    solutions: '* Ensure sink is in an active state before creating subscription',
    description: 'Creating subscription for sink failed',
    product: 'Events',
    date_created: '2020-09-16T14:20:49Z',
    last_updated: '2021-01-06T16:31:54.985Z',
  },
  30458: {
    code: 30458,
    message: 'Toll Free verification rejection - Disallowed: SHAFT - Tobacco / Vape',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30458\r\n\r\n### Toll Free verification rejection - Disallowed: SHAFT - Tobacco / Vape\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n#### Possible Causes\r\nThe toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (SHAFT: Tobacco/Vape). \r\n\r\nFirearms, Tobacco, Vape, and E-cigarettes are not allowed on Toll Free, Short Code, or Long Code regardless of age gating.\r\n\r\n#### Possible Solutions\r\nIf you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    causes:
      'The toll-free phone number cannot be verified because the submission indicated that the business is associated with or the toll-free verification submission indicated a forbidden messaging category (SHAFT: Tobacco/Vape). \r\n\r\nFirearms, Tobacco, Vape, and E-cigarettes are not allowed on Toll Free, Short Code, or Long Code regardless of age gating.',
    solutions:
      'If you are confident that your business and messaging use case does not fit into forbidden message categories, contact Twilio Support to provide Additional Information that explains your use case.\r\n\r\n[Forbidden Message Categories](https://support.twilio.com/hc/en-us/articles/360045004974-Forbidden-message-categories-for-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)\r\n\r\n[Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected. Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T01:12:40Z',
    last_updated: '2024-02-22T01:12:40Z',
  },
  13699: {
    code: 13699,
    message: 'Record: Invalid trim value',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 13699\r\n\r\n### Record: Invalid trim value\r\n\r\n If a recording has an invalid trim value in configuration.  Defaults to no trim.\r\n\r\n#### Possible Causes\r\nInvalid recording trim value.\r\n\r\n#### Possible Solutions\r\nCorrect the recording trim value.',
    causes: 'Invalid recording trim value.',
    solutions: 'Correct the recording trim value.',
    description: 'If a recording has an invalid trim value in configuration.  Defaults to no trim.',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:44:05Z',
    last_updated: '2020-08-04T10:00:04.41Z',
  },
  80615: {
    code: 80615,
    message: 'Account Sid on Legal Hold',
    log_level: 'ERROR',
    secondary_message: 'Account <AccountSid> is on legal hold.  Cannot delete record <Sid>.',
    log_type: null,
    docs: '## Error\r\n\r\n### Account Sid on Legal Hold\r\n\r\nAccount <AccountSid> is on legal hold.  Cannot delete record <Sid>.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Proxy',
    date_created: '2018-08-28T02:36:57Z',
    last_updated: '2020-08-04T10:00:12.763Z',
  },
  60622: {
    code: 60622,
    message: 'Invalid Magic Number',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60622\r\n\r\n### Invalid Magic Number\r\n\r\n The request was received but failed due to the phone number not being a valid Magic Number.\r\n\r\n#### Possible Causes\r\nThe phone number sent is not a valid Magic Number.\r\n\r\n#### Possible Solutions\r\nCheck that the phone number provided is correct and one of the pre-configured phone numbers from Magic Numbers.',
    causes: 'The phone number sent is not a valid Magic Number.',
    solutions:
      'Check that the phone number provided is correct and one of the pre-configured phone numbers from Magic Numbers.',
    description:
      'The request was received but failed due to the phone number not being a valid Magic Number.',
    product: 'Lookup',
    date_created: '2023-08-18T16:05:52Z',
    last_updated: '2023-08-21T15:20:40.515257Z',
  },
  50439: {
    code: 50439,
    message: 'Account is not authorized to use the projected address',
    log_level: 'ERROR',
    secondary_message: 'Address used as Projected Address does not belong to the account.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 50439\r\n\r\n### Account is not authorized to use the projected address\r\n\r\nAddress used as Projected Address does not belong to the account. Address used as Projected Address does not belong to the account.\r\n\r\n#### Possible Causes\r\n* The account does not own the Address (eg. phone number) used as a Projected Address.\r\n\r\n#### Possible Solutions\r\n* Use a different address owned by the account.',
    causes:
      '* The account does not own the Address (eg. phone number) used as a Projected Address.',
    solutions: '* Use a different address owned by the account.',
    description: 'Address used as Projected Address does not belong to the account.',
    product: 'Programmable Chat',
    date_created: '2021-08-16T12:00:23Z',
    last_updated: '2021-08-16T12:00:23Z',
  },
  53600: {
    code: 53600,
    message: 'S3 URL for recording upload is invalid',
    log_level: 'ERROR',
    secondary_message: 'The recording will not be processed',
    log_type: null,
    docs: "## Error - 53600\r\n\r\n### S3 URL for recording upload is invalid\r\n\r\nThe recording will not be processed.\r\n\r\nRaised when the S3 URL specified in the recording's metadata is not valid.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Solutions\r\n\r\n * Set a valid S3 URL for uploading media or leave blank (media will be uploaded to the default bucket).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-02-19T10:33:23Z',
    last_updated: '2020-08-04T10:00:14.797Z',
  },
  12200: {
    code: 12200,
    message: 'Schema validation warning',
    log_level: 'WARNING',
    secondary_message:
      'The provided XML does not conform to the Twilio Markup XML schema.  Please refer to the specific error and correct the problem.',
    log_type: 'APPLICATION',
    docs: '## WARNING - 12200\r\n\r\n### Schema validation warning\r\n\r\nThe provided XML does not conform to the Twilio Markup XML schema.  Please refer to the specific error and correct the problem. ## Warning - 12200 \r\n\r\n### Schema validation warning\r\n\r\nThe provided XML does not conform to the Twilio Markup XML schema.  Please refer to the specific error and correct the problem.\r\n\r\n#### Possible Causes\r\n* Misspelled verbs\r\n* Incorrect case for verbs; TwiML is case-sensitive, so &lt;Say&gt; works, but &lt;say&gt; will not\r\n* Misspelled or unknown attributes\r\n* Unknown or unexpected nested elements.\r\n\r\n#### Possible Solutions\r\n* Check the line and column reported by the warning to see what part of your XML response caused the complaint\r\n* Verify that your application server is accepting and properly responding to any [custom parameters](https://support.twilio.com/hc/en-us/articles/115011213347) you may be passing',
    causes:
      '* Misspelled verbs\r\n* Incorrect case for verbs; TwiML is case-sensitive, so &lt;Say&gt; works, but &lt;say&gt; will not\r\n* Misspelled or unknown attributes\r\n* Unknown or unexpected nested elements.',
    solutions:
      '* Check the line and column reported by the warning to see what part of your XML response caused the complaint\r\n* Verify that your application server is accepting and properly responding to any [custom parameters](https://support.twilio.com/hc/en-us/articles/115011213347) you may be passing',
    description:
      '## Warning - 12200 \r\n\r\n### Schema validation warning\r\n\r\nThe provided XML does not conform to the Twilio Markup XML schema.  Please refer to the specific error and correct the problem.',
    product: null,
    date_created: '2016-03-31T17:13:29Z',
    last_updated: '2021-08-04T21:01:12.333273Z',
  },
  31921: {
    code: 31921,
    message: 'Stream - WebSocket - Close Error',
    log_level: 'ERROR',
    secondary_message: 'The remote server has closed the WebSocket connection',
    log_type: 'APPLICATION',
    docs: '## ERROR - 31921\r\n\r\n### Stream - WebSocket - Close Error\r\n\r\nThe remote server has closed the WebSocket connection \r\n\r\n#### Possible Causes\r\n* The remote server ended the connection with a termination code listed in https://tools.ietf.org/html/rfc6455#section-7.4.1\r\n* The Media Stream has received a websocket close event defined by https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent\r\n\r\n#### Possible Solutions\r\n* Verify error logs in the remote websocket server',
    causes:
      '* The remote server ended the connection with a termination code listed in https://tools.ietf.org/html/rfc6455#section-7.4.1\r\n* The Media Stream has received a websocket close event defined by https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent',
    solutions: '* Verify error logs in the remote websocket server',
    description: null,
    product: 'Programmable Voice',
    date_created: '2019-07-31T10:55:41Z',
    last_updated: '2020-08-04T10:00:07.365Z',
  },
  30755: {
    code: 30755,
    message: 'Brand Registration Failure: Unsupported country code',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30755\r\n\r\n### Brand Registration Failure: Unsupported country code\r\n\r\n You have used a country code which is not yet support for US A2P brand registrations.\r\n\r\n#### Possible Causes\r\nYou have used an country code which is not yet support for US A2P brand registrations. Supported list of country codes are : PR,PS,PT,PW,PY,QA,AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,RE,AU,AW,AX,AZ,RO,BA,BB,RS,BD,RU,BE,BF,BG,RW,BH,BI,BJ,BL,BM,BN,BO,SA,SB,BQ,SC,BR,BS,SD,SE,BT,SG,BV,SH,BW,SI,SJ,BY,BZ,SK,SL,SM,SN,SO,CA,SR,CC,SS,ST,CD,CF,SV,CG,SX,CH,CI,SZ,CK,CL,CM,CN,CO,CR,TC,TD,TF,TG,CV,CW,TH,CX,TJ,CY,TK,CZ,TL,TM,TN,TO,TR,TT,DE,TV,TW,DJ,TZ,DK,DM,DO,UA,UG,DZ,UM,EC,US,EE,EG,EH,UY,UZ,VA,ER,VC,ES,VE,ET,VG,VI,VN,VU,FI,FJ,FK,FM,FO,FR,WF,GA,GB,WS,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,XE,GU,GW,GY,XK,HK,HM,HN,HR,YE,HT,HU,YT,ID,IE,IL,IM,IN,IO,ZA,IQ,IS,IT,ZM,JE,ZW,JM,JO,JP,KE,KG,KH,KI,KM,KN,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN\r\n\r\n#### Possible Solutions\r\nPlease use a valid country code.\r\n\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    causes:
      'You have used an country code which is not yet support for US A2P brand registrations. Supported list of country codes are : PR,PS,PT,PW,PY,QA,AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,RE,AU,AW,AX,AZ,RO,BA,BB,RS,BD,RU,BE,BF,BG,RW,BH,BI,BJ,BL,BM,BN,BO,SA,SB,BQ,SC,BR,BS,SD,SE,BT,SG,BV,SH,BW,SI,SJ,BY,BZ,SK,SL,SM,SN,SO,CA,SR,CC,SS,ST,CD,CF,SV,CG,SX,CH,CI,SZ,CK,CL,CM,CN,CO,CR,TC,TD,TF,TG,CV,CW,TH,CX,TJ,CY,TK,CZ,TL,TM,TN,TO,TR,TT,DE,TV,TW,DJ,TZ,DK,DM,DO,UA,UG,DZ,UM,EC,US,EE,EG,EH,UY,UZ,VA,ER,VC,ES,VE,ET,VG,VI,VN,VU,FI,FJ,FK,FM,FO,FR,WF,GA,GB,WS,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,XE,GU,GW,GY,XK,HK,HM,HN,HR,YE,HT,HU,YT,ID,IE,IL,IM,IN,IO,ZA,IQ,IS,IT,ZM,JE,ZW,JM,JO,JP,KE,KG,KH,KI,KM,KN,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN',
    solutions:
      'Please use a valid country code.\r\n\r\n\r\nAdditional help resources\r\n\r\n* [Troubleshooting US A2P Brand registration failures]',
    description:
      'You have used a country code which is not yet support for US A2P brand registrations.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:46:42Z',
    last_updated: '2024-02-13T16:16:30.801912Z',
  },
  25010: {
    code: 25010,
    message: 'The primary email address is missing for the user',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 25010\r\n\r\n### The primary email address is missing for the user\r\n\r\n The primary email address is missing for the user.\r\n\r\n#### Possible Causes\r\n- The request doesn't contain email addresses \r\n- The request contains more than one email address and doesn't specify \"primary\" attribute\r\n\r\n#### Possible Solutions\r\nTo resolve this issue, mark one of the provided emails as the primary email address. Additionally, ensure that at least one of the email addresses matches the user's username. This alignment is necessary to fulfill the primary email address requirement.",
    causes:
      '- The request doesn\'t contain email addresses \r\n- The request contains more than one email address and doesn\'t specify "primary" attribute',
    solutions:
      "To resolve this issue, mark one of the provided emails as the primary email address. Additionally, ensure that at least one of the email addresses matches the user's username. This alignment is necessary to fulfill the primary email address requirement.",
    description: 'The primary email address is missing for the user.',
    product: 'Organizations API',
    date_created: '2023-12-04T09:58:46Z',
    last_updated: '2023-12-04T14:16:02.709176Z',
  },
  23006: {
    code: 23006,
    message: 'Message Redaction Incompatible Configuration: Inbound Webhook GET Requests',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 23006\r\n\r\n### Message Redaction Incompatible Configuration: Inbound Webhook GET Requests\r\n\r\n Message Redaction is enabled for your account. Using GET requests to handle incoming messages is not compatible with either Message Body Redaction or Phone Number Redaction.\r\n\r\n#### Possible Causes\r\n* The Incoming Message Webhook is set to the GET method for your Twilio phone number or Messaging Service.\r\n\r\n#### Possible Solutions\r\n* Ensure all Twilio numbers and Messaging Services on your account are set to use the POST method when handling incoming messages.',
    causes:
      '* The Incoming Message Webhook is set to the GET method for your Twilio phone number or Messaging Service.',
    solutions:
      '* Ensure all Twilio numbers and Messaging Services on your account are set to use the POST method when handling incoming messages.',
    description:
      'Message Redaction is enabled for your account. Using GET requests to handle incoming messages is not compatible with either Message Body Redaction or Phone Number Redaction.',
    product: 'Programmable SMS',
    date_created: '2019-11-21T19:24:40Z',
    last_updated: '2020-08-04T10:00:05.857Z',
  },
  83701: {
    code: 83701,
    message: 'Data Session Establishment Failed Due To Internal Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 83701\r\n\r\n### Data Session Establishment Failed Due To Internal Error\r\n\r\n An unexpected error occurred while establishing a Data Session for your SIM. This is usually a transient error and should resolve itself in time.\r\n\r\n#### Possible Causes\r\n* An unexpected error occurred in setting up a Data Session for your SIM.\r\n\r\n#### Possible Solutions\r\n* Retry connecting to the Network from your device.\r\n* If this issue persists for your SIM, please contact Twilio Support.',
    causes: '* An unexpected error occurred in setting up a Data Session for your SIM.',
    solutions:
      '* Retry connecting to the Network from your device.\r\n* If this issue persists for your SIM, please contact Twilio Support.',
    description:
      'An unexpected error occurred while establishing a Data Session for your SIM. This is usually a transient error and should resolve itself in time.',
    product: 'Super SIM',
    date_created: '2022-07-21T14:21:00Z',
    last_updated: '2022-07-21T14:21:00Z',
  },
  50510: {
    code: 50510,
    message: 'Invalid message media SID',
    log_level: 'ERROR',
    secondary_message: 'An invalid multimedia attachment SID was supplied for this message.',
    log_type: null,
    docs: '\n## Error - 50510\n\n### Conversations: Invalid message media SID\nAn invalid multimedia attachment SID was supplied for this message.\n\n#### Possible Causes\n* MediaSid parameter provided with the request does not match a valid media SID pattern (MExx).\n\n#### Possible Solutions\n* Add a valid MediaSid parameter to the API request and supply a media SID that is uploaded under your service instance.\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.298Z',
  },
  21714: {
    code: 21714,
    message: 'Messaging Service Number Pool size limit reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21714\r\n\r\n### Messaging Service Number Pool size limit reached\r\n\r\n You have attempted to add a Twilio phone number or short code to your Messaging Service Number Pool, but you are already at the limit of phone numbers. By default, a Messaging Service can contain up to a total of 400 Twilio phone numbers and short codes.\r\n\r\n#### Possible Causes\r\n* Your Messaging Service number pool is already full (default: 400 numbers)\r\n\r\n#### Possible Solutions\r\n* If you are sending to the United States and Canada, use a [Toll-Free or short code number](https://support.twilio.com/hc/en-us/articles/360038173654-Comparison-of-SMS-messaging-in-the-US-and-Canada-for-long-codes-short-codes-and-toll-free-phone-numbers) with higher message throughput (MPS), instead of adding more local numbers. Most mobile carriers in the US and Canada do not not permit [Application-to-Person (A2P)](https://support.twilio.com/hc/en-us/articles/223133807-What-is-P2P-and-A2P-messaging-) messaging via long codes, so there is a high risk of [carrier filtering](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-) when sending this type of traffic via long code.\r\n* If you are sending to other countries, you may be eligible to have your Number Pool size limit increased. Please [submit a ticket](https://www.twilio.com/console/support/tickets/create) with a description of your use case and why you need a higher number pool size limit. These requests will be reviewed by our Messaging team.',
    causes: '* Your Messaging Service number pool is already full (default: 400 numbers)',
    solutions:
      '* If you are sending to the United States and Canada, use a [Toll-Free or short code number](https://support.twilio.com/hc/en-us/articles/360038173654-Comparison-of-SMS-messaging-in-the-US-and-Canada-for-long-codes-short-codes-and-toll-free-phone-numbers) with higher message throughput (MPS), instead of adding more local numbers. Most mobile carriers in the US and Canada do not not permit [Application-to-Person (A2P)](https://support.twilio.com/hc/en-us/articles/223133807-What-is-P2P-and-A2P-messaging-) messaging via long codes, so there is a high risk of [carrier filtering](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-) when sending this type of traffic via long code.\r\n* If you are sending to other countries, you may be eligible to have your Number Pool size limit increased. Please [submit a ticket](https://www.twilio.com/console/support/tickets/create) with a description of your use case and why you need a higher number pool size limit. These requests will be reviewed by our Messaging team.',
    description:
      'You have attempted to add a Twilio phone number or short code to your Messaging Service Number Pool, but you are already at the limit of phone numbers. By default, a Messaging Service can contain up to a total of 400 Twilio phone numbers and short codes.',
    product: 'Programmable SMS',
    date_created: '2020-06-24T20:27:13Z',
    last_updated: '2020-08-04T10:00:02.794Z',
  },
  36002: {
    code: 36002,
    message: 'Broadcast Request Limit Reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 36002\r\n\r\n### Broadcast Request Limit Reached\r\n\r\n The limit of the number of Broadcast requests for this account has been reached\r\n\r\n#### Possible Causes\r\n* You are at the limit of Broadcast requests for your account and cannot create any additional Broadcasts\r\n\r\n#### Possible Solutions\r\n* Wait for your existing Broadcasts to process before creating more Broadcasts\r\n* If you have any Broadcasts with status PENDING_UPLOAD, upload a file to those Broadcasts first to resume processing on them',
    causes:
      '* You are at the limit of Broadcast requests for your account and cannot create any additional Broadcasts',
    solutions:
      '* Wait for your existing Broadcasts to process before creating more Broadcasts\r\n* If you have any Broadcasts with status PENDING_UPLOAD, upload a file to those Broadcasts first to resume processing on them',
    description: 'The limit of the number of Broadcast requests for this account has been reached',
    product: 'Programmable Messaging',
    date_created: '2023-12-15T21:48:35Z',
    last_updated: '2023-12-15T21:48:35Z',
  },
  94501: {
    code: 94501,
    message: 'Transcriptions: Status invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94501\r\n\r\n### Transcriptions: Status invalid\r\n\r\n The action could not be performed because the Status provided is not valid.\r\n\r\n#### Possible Causes\r\n * Status value is invalid.\r\n\r\n#### Possible Solutions\r\n * Value must be enqueued, processing, completed, failed or deleted.',
    causes: ' * Status value is invalid.',
    solutions: ' * Value must be enqueued, processing, completed, failed or deleted.',
    description: 'The action could not be performed because the Status provided is not valid.',
    product: null,
    date_created: '2022-05-09T16:04:22Z',
    last_updated: '2022-05-09T16:04:22Z',
  },
  63044: {
    code: 63044,
    message: 'Link to a sample media file returns 404 Not Found',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 63044\r\n\r\n### Link to a sample media file returns 404 Not Found\r\n\r\n The link returned a status code of 404 Not Found, making it impossible to retrieve the file.\r\n\r\n#### Possible Causes\r\n- The file does not exist \r\n- The URL provided is incorrect\r\n\r\n#### Possible Solutions\r\n- Update the provided URL',
    causes: '- The file does not exist \r\n- The URL provided is incorrect',
    solutions: '- Update the provided URL',
    description:
      'The link returned a status code of 404 Not Found, making it impossible to retrieve the file.',
    product: 'Programmable Messaging',
    date_created: '2023-03-24T16:33:58Z',
    last_updated: '2023-03-24T16:33:58Z',
  },
  30792: {
    code: 30792,
    message: 'Brand Registration Failure: General error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30792\r\n\r\n### Brand Registration Failure: General error\r\n\r\n There was a general system error when processing brand registration request.\r\n\r\n#### Possible Causes\r\nThere was a general system error when processing brand registration request.\r\n\r\n#### Possible Solutions\r\nPlease contact Twilio Support.',
    causes: 'There was a general system error when processing brand registration request.',
    solutions: 'Please contact Twilio Support.',
    description: 'There was a general system error when processing brand registration request.',
    product: 'Programmable Messaging',
    date_created: '2024-02-12T08:49:29Z',
    last_updated: '2024-02-12T08:49:29Z',
  },
  80907: {
    code: 80907,
    message: 'Open Interaction Not Found',
    log_level: 'WARNING',
    secondary_message: 'Received a call with no open interaction',
    log_type: null,
    docs: '## Warning\n\n### Open Interaction Not Found\n\nExample Message: Received a call with no open interaction',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:04Z',
    last_updated: '2020-08-04T10:00:15.55Z',
  },
  32018: {
    code: 32018,
    message: 'Twiml size exceeded maximum allowed value',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32018\r\n\r\n### Twiml size exceeded maximum allowed value\r\n\r\n Twiml size exceeded maximum allowed value of 4000 characters\r\n\r\n#### Possible Causes\r\nTwiml size exceeded maximum allowed value of 4000 characters\r\n\r\n#### Possible Solutions\r\nReduce the size of the twiml embedded in the request',
    causes: 'Twiml size exceeded maximum allowed value of 4000 characters',
    solutions: 'Reduce the size of the twiml embedded in the request',
    description: 'Twiml size exceeded maximum allowed value of 4000 characters',
    product: 'Programmable Voice',
    date_created: '2019-08-29T18:31:19Z',
    last_updated: '2021-10-01T03:20:31.841685Z',
  },
  81015: {
    code: 81015,
    message: 'Failed to Create Task',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81015\r\n\r\n### Task was not successfully created\r\nAn error occurred when Studio attempted to create task.\r\n\r\n#### Possible Causes\r\n* Required values are missing from the widget.\r\n* Values are not correctly formatted (e.g. Attributes)\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-08-20T23:43:15Z',
    last_updated: '2020-08-04T10:00:12.823Z',
  },
  50347: {
    code: 50347,
    message: 'Parameters are missing for channel update request',
    log_level: 'ERROR',
    secondary_message: 'There are no parameters specified in this channel update request.',
    log_type: null,
    docs: '\n## Error - 50347\n\n### Programmable Chat: Parameters are missing for channel update request\nThere are no parameters specified in this channel update request.\n\n#### Possible Causes\n* No parameters were set in the channel update request.\n* Parameters specified in the channel update API request have incorrect names.\n\n#### Possible Solutions\n* Verify that at least one parameter is provided to the channel update API.\n* Validate that parameter names are correct according to the [API documentation](https://www.twilio.com/docs/chat/rest/channel-resource#update-a-channel-resource).\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.897Z',
  },
  52173: {
    code: 52173,
    message: 'Unexpected Identifier used for Webhook Credentials request',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 52173\r\n\r\n### Unexpected Binding Type used for Webhook Credentials request\r\n\r\n#### Possible Causes \r\n* Your token endpoint responded with an error indicating that the Identifier used was not correct\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2018-04-04T09:56:23Z',
    last_updated: '2020-08-04T10:00:14.126Z',
  },
  61009: {
    code: 61009,
    message: 'Add-ons: Could not fulfill request with available data',
    log_level: 'ERROR',
    secondary_message:
      ' One of the request fields in the Add-ons specification could not be interpolated with the provided data. The result is an invalid URL, Header value or other parameter that makes the request impossible to execute.',
    log_type: null,
    docs: '## Error - 61009\r\n\r\n### Add-ons: Could not fulfill request with available data\r\n\r\n#### Possible Causes \r\n*   One of the request fields in the Add-ons specification could not be interpolated with the provided data. The result is an invalid URL, Header value or other parameter that makes the request impossible to execute.',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-06-01T00:39:05Z',
    last_updated: '2020-08-04T10:00:21.409Z',
  },
  30900: {
    code: 30900,
    message: 'Campaign rejection - The campaign use case is ineligible for registration.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30900\r\n\r\n### Campaign rejection - The campaign use case is ineligible for registration.\r\n\r\n The campaign use case provided as part of registration request is ineligible for registration.\r\n\r\n#### Possible Causes\r\nReasons for this failure can be: \r\n\r\n* Provided use case is not supported yet.\r\n* Campaign use case not supported by one of the carriers.\r\n* The brand is not qualified to run campaign of provide use case for one of the carriers.\r\n* The brand with use case campaign is not within sub-usecase bounds.\r\n\r\n#### Possible Solutions\r\nTry to select another use case for campaign registration that reflects your A2P Messaging use case with Twilio, or reach out to support with campaign details for resolution. ',
    causes:
      'Reasons for this failure can be: \r\n\r\n* Provided use case is not supported yet.\r\n* Campaign use case not supported by one of the carriers.\r\n* The brand is not qualified to run campaign of provide use case for one of the carriers.\r\n* The brand with use case campaign is not within sub-usecase bounds.',
    solutions:
      'Try to select another use case for campaign registration that reflects your A2P Messaging use case with Twilio, or reach out to support with campaign details for resolution. ',
    description:
      'The campaign use case provided as part of registration request is ineligible for registration.',
    product: 'Programmable Messaging',
    date_created: '2023-05-25T08:29:40Z',
    last_updated: '2023-05-25T08:29:40Z',
  },
  60309: {
    code: 60309,
    message: 'Push notifications limit reached for a Challenge',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60309\r\n\r\n### Push notifications limit reached for a Challenge\r\n\r\n The maximum number of push notifications for the Challenge has been reached\r\n\r\nMax number of notifications: 3\r\n\r\nHTTP status: 429\r\n\r\n#### Possible Causes\r\nToo many calls to the Resend Notification endpoint for a given Challenge\r\n\r\n#### Possible Solutions\r\nCreate a new Challenge and send notifications for it.',
    causes: 'Too many calls to the Resend Notification endpoint for a given Challenge',
    solutions: 'Create a new Challenge and send notifications for it.',
    description:
      'The maximum number of push notifications for the Challenge has been reached\r\n\r\nMax number of notifications: 3\r\n\r\nHTTP status: 429',
    product: 'Verify',
    date_created: '2021-04-30T14:49:42Z',
    last_updated: '2021-06-30T03:42:25.526538Z',
  },
  50210: {
    code: 50210,
    message: 'Programmable Chat: Invalid notification level',
    log_level: 'ERROR',
    secondary_message: 'Request contains unknown notification level value',
    log_type: null,
    docs: '## Error - 50210\r\n\r\n### Programmable Chat: Invalid notification level\r\n\r\n#### Possible Causes \r\n* Specified notification level does not exist.\r\n\r\n#### Possible Solutions\r\n* Confirm a valid notification level is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2018-10-10T11:27:41Z',
    last_updated: '2020-08-04T10:00:12.199Z',
  },
  30004: {
    code: 30004,
    message: 'Message blocked',
    log_level: 'ERROR',
    secondary_message:
      'The destination number you are trying to reach is blocked from receiving this message.',
    log_type: 'CARRIER',
    docs: '## ERROR - 30004\r\n\r\n### Message blocked\r\n\r\nThe destination number you are trying to reach is blocked from receiving this message. ## Error - 30004\r\n\r\n## Message Delivery - Message blocked\r\n\r\n#### Possible Causes\r\n*  The destination number you are trying to reach is blocked from receiving this message.\r\n*  The device you are trying to reach does not have sufficient signal.\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline).\r\n*  The destination number is on India\'s national Do Not Call registry.\r\n*  There is an issue with the mobile carrier.\r\n*  You have sent a message from a US/CA Toll-free number to an end user handset that has previously responded with "STOP" or [another opt-out keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-).\r\n\r\n#### Possible Solutions\r\nThe first step to troubleshooting this issue is to attempt to replicate the problem. Attempt to send another test message to this user via a REST API request or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not, power the device off, then wait 30 seconds and then power it back up.\r\n*  Is the device connected to the home carrier\'s network? We cannot guarantee message delivery to devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (not using an [Alphanumeric Sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id)), or with a shorter one-segment (non-[concatenated](https://support.twilio.com/hc/en-us/articles/223181508-Does-Twilio-support-concatenated-SMS-messages-or-messages-over-160-characters)) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\nIf you can rule out all of the above issues, continue troubleshooting below.\r\n\r\n#### "Undelivered" messages sent to India\r\nError 30004 results on undelivered messages sent to India could be due to the destination number being listed on the national Do Not Call (DNC) registry. \r\n\r\nFor more information on sending messages to India, including links for updating DNC settings, please see our help center article on [limitations for sending SMS to India](https://support.twilio.com/hc/en-us/articles/223134167-Limitations-sending-SMS-messages-to-Indian-mobile-devices).\r\n\r\n#### "Failed" messages\r\nRepeated messages with a `Failed` status and error 30004 results indicate Twilio may be filtering some of your messages internally. \r\n\r\nThis filtering is in place to help protect our customers, and the rules attempt to match what we have observed from the industry. For more details, including potential workarounds, please see our help center article ["How Does Carrier Filtering Work?"](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work)\r\n\r\n#### Continued issues with error 30004\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30004, and [open a support request](https://www.twilio.com/console/support/tickets/create).',
    causes:
      '*  The destination number you are trying to reach is blocked from receiving this message.\r\n*  The device you are trying to reach does not have sufficient signal.\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline).\r\n*  The destination number is on India\'s national Do Not Call registry.\r\n*  There is an issue with the mobile carrier.\r\n*  You have sent a message from a US/CA Toll-free number to an end user handset that has previously responded with "STOP" or [another opt-out keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-).',
    solutions:
      'The first step to troubleshooting this issue is to attempt to replicate the problem. Attempt to send another test message to this user via a REST API request or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not, power the device off, then wait 30 seconds and then power it back up.\r\n*  Is the device connected to the home carrier\'s network? We cannot guarantee message delivery to devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (not using an [Alphanumeric Sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id)), or with a shorter one-segment (non-[concatenated](https://support.twilio.com/hc/en-us/articles/223181508-Does-Twilio-support-concatenated-SMS-messages-or-messages-over-160-characters)) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\nIf you can rule out all of the above issues, continue troubleshooting below.\r\n\r\n#### "Undelivered" messages sent to India\r\nError 30004 results on undelivered messages sent to India could be due to the destination number being listed on the national Do Not Call (DNC) registry. \r\n\r\nFor more information on sending messages to India, including links for updating DNC settings, please see our help center article on [limitations for sending SMS to India](https://support.twilio.com/hc/en-us/articles/223134167-Limitations-sending-SMS-messages-to-Indian-mobile-devices).\r\n\r\n#### "Failed" messages\r\nRepeated messages with a `Failed` status and error 30004 results indicate Twilio may be filtering some of your messages internally. \r\n\r\nThis filtering is in place to help protect our customers, and the rules attempt to match what we have observed from the industry. For more details, including potential workarounds, please see our help center article ["How Does Carrier Filtering Work?"](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work)\r\n\r\n#### Continued issues with error 30004\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30004, and [open a support request](https://www.twilio.com/console/support/tickets/create).',
    description: '## Error - 30004\r\n\r\n## Message Delivery - Message blocked',
    product: 'Programmable SMS',
    date_created: '2016-03-31T17:14:34Z',
    last_updated: '2023-02-10T19:10:35.307931Z',
  },
  53209: {
    code: 53209,
    message: 'Participant status is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 53209\r\n\r\n### Participant status is invalid\r\n\r\n Raised in the REST API when Status is not valid.\r\n\r\n#### Possible Causes\r\nREST API call to Update Participant instance with Status that is invalid.\r\n\r\n#### Possible Solutions\r\nSet Status to disconnected.',
    causes: 'REST API call to Update Participant instance with Status that is invalid.',
    solutions: 'Set Status to disconnected.',
    description: 'Raised in the REST API when Status is not valid.',
    product: 'Programmable Video',
    date_created: '2021-05-28T17:43:56Z',
    last_updated: '2021-05-28T17:43:56Z',
  },
  64003: {
    code: 64003,
    message: 'Pay: Invalid charge amount.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 64003\r\n\r\n### Pay: Invalid charge amount.\r\n\r\n ## Error - 64003\r\n\r\n### Pay: Invalid charge amount.\r\n\r\nA 64003 Error is an indication that the charge amount is invalid. \r\n\r\n#### Possible Causes\r\n* The chargeAmount attribute has a number of decimals that does not conform to the currency type. For example, more than 2 decimals were provided for US Dollars .\r\n* chargeAmount attribute is negative.\r\n\r\n#### Possible Solutions\r\n* Make sure the charge amount has correct number of decimal values.\r\n* Make sure the charge amount is a positive value.',
    causes:
      '* The chargeAmount attribute has a number of decimals that does not conform to the currency type. For example, more than 2 decimals were provided for US Dollars .\r\n* chargeAmount attribute is negative.',
    solutions:
      '* Make sure the charge amount has correct number of decimal values.\r\n* Make sure the charge amount is a positive value.',
    description:
      '## Error - 64003\r\n\r\n### Pay: Invalid charge amount.\r\n\r\nA 64003 Error is an indication that the charge amount is invalid. ',
    product: 'Programmable Voice',
    date_created: '2019-02-26T21:54:09Z',
    last_updated: '2020-08-04T10:00:10.337Z',
  },
  180017: {
    code: 180017,
    message: 'Require domestic emergency address',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 180017\r\n\r\n### Require domestic emergency address\r\n\r\n This phone number type requires a valid domestic emergency address.\r\n\r\n#### Possible Causes\r\n- You may have submitted an international address.\r\n- Your address is not a valid address.\r\n\r\n#### Possible Solutions\r\nPlease resubmit with a valid domestic address or create a new bundle selecting the appropriate phone number type.',
    causes:
      '- You may have submitted an international address.\r\n- Your address is not a valid address.',
    solutions:
      'Please resubmit with a valid domestic address or create a new bundle selecting the appropriate phone number type.',
    description: 'This phone number type requires a valid domestic emergency address.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:07:31Z',
    last_updated: '2024-07-04T10:07:31Z',
  },
  60243: {
    code: 60243,
    message: 'Custom messages are not supported',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60243\r\n\r\n### Custom messages are not supported\r\n\r\n Your verification is using custom messages.\r\n\r\n#### Possible Causes\r\nVerification created using custom message are not supported.\r\n\r\n#### Possible Solutions\r\nEnsure that you pass the OTP code via [custom code](https://www.twilio.com/docs/verify/api/customization-options) parameter in the API request, following which it will be automatically map your incoming message to Verify default templates or migrate your custom messages  to use [Verify Custom Templates](https://www.twilio.com/docs/verify/api/templates)',
    causes: 'Verification created using custom message are not supported.',
    solutions:
      'Ensure that you pass the OTP code via [custom code](https://www.twilio.com/docs/verify/api/customization-options) parameter in the API request, following which it will be automatically map your incoming message to Verify default templates or migrate your custom messages  to use [Verify Custom Templates](https://www.twilio.com/docs/verify/api/templates)',
    description: 'Your verification is using custom messages.',
    product: 'Verify',
    date_created: '2024-02-06T14:26:49Z',
    last_updated: '2024-03-01T14:40:03.131222Z',
  },
  20006: {
    code: 20006,
    message: 'Access Denied',
    log_level: 'ERROR',
    secondary_message:
      "You don't have sufficient privileges to access the requested resource. The user on whose behalf you are attempting to access the API may have revoked your privileges, or you may need to request greater privileges from the user.",
    log_type: null,
    docs: "## Error - 20006\n\n### Access Denied\n\nYou don't have sufficient privileges to access the requested resource. The user\non whose behalf you are attempting to access the API may have revoked your\nprivileges, or you may need to request greater privileges from the user.\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:14Z',
    last_updated: '2020-08-04T10:00:25.964Z',
  },
  25105: {
    code: 25105,
    message: 'The request is not authorized',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 25105\r\n\r\n### The request is not authorized\r\n\r\n The request is not authorized.\r\n\r\n#### Possible Causes\r\nIncorrect credentials.\r\n\r\n#### Possible Solutions\r\nVerify credentials.',
    causes: 'Incorrect credentials.',
    solutions: 'Verify credentials.',
    description: 'The request is not authorized.',
    product: 'Organizations API',
    date_created: '2023-12-04T11:30:59Z',
    last_updated: '2023-12-04T14:25:56.020836Z',
  },
  50501: {
    code: 50501,
    message: 'Programmable Chat: Message SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Message SID parameter.',
    log_type: null,
    docs: '## Error - 50501\r\n\r\n### Programmable Chat: Message SID not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Message SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message SID is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:53Z',
    last_updated: '2020-08-04T10:00:22.974Z',
  },
  63037: {
    code: 63037,
    message: 'Channel Media Upload Error',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'CARRIER',
    docs: '## WARNING - 63037\r\n\r\n### Channel Media Upload Error\r\n\r\n Media failed to upload to provider\r\n\r\n#### Possible Causes\r\nAn attempt by Twilio failed to upload media to the Channel provider. Twilio will retry this operation.\r\n\r\n#### Possible Solutions\r\nTwilio will retry this operation.',
    causes:
      'An attempt by Twilio failed to upload media to the Channel provider. Twilio will retry this operation.',
    solutions: 'Twilio will retry this operation.',
    description: 'Media failed to upload to provider',
    product: 'Programmable SMS',
    date_created: '2020-02-19T22:25:22Z',
    last_updated: '2020-08-04T10:00:04.62Z',
  },
  21715: {
    code: 21715,
    message: 'Phone Number Does Not Have Correct Messaging Service Capabilities',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21715\r\n\r\n### Phone Number Does Not Have Correct Messaging Service Capabilities\r\n\r\n In order for a phone number to work in a Messaging Service it must have at least SMS or MMS capabilities. If it does not have either, it will fail.\r\n\r\n#### Possible Causes\r\n* The phone number you are trying to add to the Messaging Service does not have SMS or MMS capabilities.\r\n\r\n#### Possible Solutions\r\n* The [Active Numbers](https://www.twilio.com/console/phone-numbers/incoming) page in the Twilio Console will display the capabilities of each of the phone numbers in your account.\r\n* Find a new phone number that has SMS and/or MMS capabilities depending on your use case and business needs, and add that phone number to your Messaging Service.',
    causes:
      '* The phone number you are trying to add to the Messaging Service does not have SMS or MMS capabilities.',
    solutions:
      '* The [Active Numbers](https://www.twilio.com/console/phone-numbers/incoming) page in the Twilio Console will display the capabilities of each of the phone numbers in your account.\r\n* Find a new phone number that has SMS and/or MMS capabilities depending on your use case and business needs, and add that phone number to your Messaging Service.',
    description:
      'In order for a phone number to work in a Messaging Service it must have at least SMS or MMS capabilities. If it does not have either, it will fail.',
    product: 'Programmable SMS',
    date_created: '2021-05-27T17:56:03Z',
    last_updated: '2021-05-27T17:56:51.857Z',
  },
  60726: {
    code: 60726,
    message: 'Business status does not allow to have brands',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60726\r\n\r\n### Business status does not allow to have brands\r\n\r\n You are creating a brand for a business in a status does not allow it to have brands\r\n\r\n#### Possible Causes\r\nA business must be verified in order to have any brands\r\n\r\n#### Possible Solutions\r\nMake sure your business already has a verified status before attempting to create brands',
    causes: 'A business must be verified in order to have any brands',
    solutions:
      'Make sure your business already has a verified status before attempting to create brands',
    description:
      'You are creating a brand for a business in a status does not allow it to have brands',
    product: 'Branded Comms',
    date_created: '2020-01-24T21:26:35Z',
    last_updated: '2020-08-04T10:00:04.743Z',
  },
  60724: {
    code: 60724,
    message: 'Brand status does not allow dismissal',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 60724\r\n\r\n### Brand status does not allow dismissal\r\n\r\n Brands can only be dismissed when they have certain status values. Dismissing a brand will set its status to "Draft".\r\n\r\n#### Possible Causes\r\nYou sent a dismiss request for a brand that is in status "Draft" or "Rejected".\r\n\r\n\r\n#### Possible Solutions\r\nYou\'re only interested in dismissing a brand to update its information before being vetted by Twilio\'s vetting team, or if you want to remove its verified status.\r\nTo dismiss the brand its status must be one of "Pending Verification" or "Verified".',
    causes: 'You sent a dismiss request for a brand that is in status "Draft" or "Rejected".\r\n',
    solutions:
      'You\'re only interested in dismissing a brand to update its information before being vetted by Twilio\'s vetting team, or if you want to remove its verified status.\r\nTo dismiss the brand its status must be one of "Pending Verification" or "Verified".',
    description:
      'Brands can only be dismissed when they have certain status values. Dismissing a brand will set its status to "Draft".',
    product: 'Branded Comms',
    date_created: '2020-01-24T21:20:32Z',
    last_updated: '2020-08-04T10:00:04.778Z',
  },
  21647: {
    code: 21647,
    message: 'Regulatory Bundle is not eligible for deletion',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21647\r\n\r\n### Regulatory Bundle is not eligible for deletion\r\n\r\n Regulatory Bundle is in a non-deletable status (PENDING_REVIEW & IN_REVIEW)\r\n\r\n#### Possible Causes\r\nRegulatory Bundle is in a non-deletable status.\r\n\r\n#### Possible Solutions\r\nWait for the Regulatory Bundle to transition to a deletable status (DRAFT, TWILIO_REJECTED, TWILIO_APPROVED).\r\n\r\nIf the Regulatory Bundle is idle for 3 or more business days, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    causes: 'Regulatory Bundle is in a non-deletable status.',
    solutions:
      'Wait for the Regulatory Bundle to transition to a deletable status (DRAFT, TWILIO_REJECTED, TWILIO_APPROVED).\r\n\r\nIf the Regulatory Bundle is idle for 3 or more business days, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com).',
    description: 'Regulatory Bundle is in a non-deletable status (PENDING_REVIEW & IN_REVIEW)',
    product: 'Phone Numbers',
    date_created: '2020-07-17T19:49:52Z',
    last_updated: '2023-11-01T04:48:41.723038Z',
  },
  80625: {
    code: 80625,
    message: 'Unauthorized Request. Signature is missing or is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 80625\r\n\r\n### Unauthorized Request. Signature is missing or is invalid\r\n\r\n A valid signature header needs to be provided for the request to be authenticated.\r\n\r\n#### Possible Causes\r\nHeader - 'X-Twilio-Signature' is missing or is invalid\r\n\r\n#### Possible Solutions\r\nProvide a valid signature value in header 'X-Twilio-Signature'",
    causes: "Header - 'X-Twilio-Signature' is missing or is invalid",
    solutions: "Provide a valid signature value in header 'X-Twilio-Signature'",
    description:
      'A valid signature header needs to be provided for the request to be authenticated.',
    product: 'Proxy',
    date_created: '2024-03-22T03:04:23Z',
    last_updated: '2024-03-22T03:04:30.873561Z',
  },
  14110: {
    code: 14110,
    message: 'Invalid Verb for SMS Reply',
    log_level: 'WARNING',
    secondary_message:
      'An Invalid Verb has been passed back in an SMS reply.  Valid Verbs are Sms and Redirect',
    log_type: null,
    docs: '## Warning - 14110 \n\n### Invalid Verb for Message Reply\n\nAn Invalid Verb has been passed back in a Message reply.  Valid Verbs are Message, Sms and Redirect\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:50Z',
    last_updated: '2020-08-04T10:00:27.5Z',
  },
  83704: {
    code: 83704,
    message: 'Attachment Rejected Due To SIM In New State',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 83704\r\n\r\n### Attachment Rejected Due To SIM In New State\r\n\r\n The SIM was not able to attach to the specified network because your SIM has not been activated yet and is in the `new` state. This is the state that SIMs arrive in when they are shipped and they must be activated first via Console or REST API before they can be used.\r\n\r\n#### Possible Causes\r\n * Your SIM is in the `new` state and is not active.\r\n\r\n#### Possible Solutions\r\n * Use the Twilio Console or REST API to activate your SIM by setting its `status` to `ready` or `active`.',
    causes: ' * Your SIM is in the `new` state and is not active.',
    solutions:
      ' * Use the Twilio Console or REST API to activate your SIM by setting its `status` to `ready` or `active`.',
    description:
      'The SIM was not able to attach to the specified network because your SIM has not been activated yet and is in the `new` state. This is the state that SIMs arrive in when they are shipped and they must be activated first via Console or REST API before they can be used.',
    product: 'Super SIM',
    date_created: '2022-07-21T14:28:53Z',
    last_updated: '2022-07-21T14:28:53Z',
  },
  40110: {
    code: 40110,
    message: 'TaskRouter->Call',
    log_level: 'ERROR',
    secondary_message: "Call Instruction does not have a valid 'to' parameter provided.",
    log_type: null,
    docs: '## Error - 40110\r\n\r\n### Missing or Invalid \'to\' parameter - Call Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "to" parameter on your \'call\' instruction.\r\n*  You provided an invalid format in your "to" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a valid phone number, client URI, or SIP URI. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
    causes: null,
    solutions: null,
    description: null,
    product: 'TaskRouter',
    date_created: '2016-03-31T17:14:40Z',
    last_updated: '2020-08-04T10:00:24.051Z',
  },
  19049: {
    code: 19049,
    message: 'Custom field definition provided is not defined',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19049\r\n\r\n### Custom field definition provided is not defined\r\n\r\n The custom field definition provided in the request does not exist\r\n\r\n#### Possible Causes\r\nRequest with a custom field definition that is not defined\r\n\r\n#### Possible Solutions\r\nUse custom field definition API to define the custom field first',
    causes: 'Request with a custom field definition that is not defined',
    solutions: 'Use custom field definition API to define the custom field first',
    description: 'The custom field definition provided in the request does not exist',
    product: 'Contacts',
    date_created: '2020-08-11T18:00:39Z',
    last_updated: '2020-08-24T18:18:01.112Z',
  },
  22219: {
    code: 22219,
    message: 'An Address is missing',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22219\r\n\r\n### An Address is missing\r\n\r\n An Address is missing from the regulatory Bundle\r\n\r\n#### Possible Causes\r\nThe Regulation requires an Address to be assigned to a Supporting Document in the Regulatory Bundle.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Regulations API to ensure that an AddressSid is assigned to a Supporting Document.',
    causes:
      'The Regulation requires an Address to be assigned to a Supporting Document in the Regulatory Bundle.',
    solutions:
      'Please refer to the Regulations API to ensure that an AddressSid is assigned to a Supporting Document.',
    description: 'An Address is missing from the regulatory Bundle',
    product: 'Phone Numbers',
    date_created: '2020-04-23T22:18:30Z',
    last_updated: '2020-08-04T10:00:03.698Z',
  },
  63039: {
    code: 63039,
    message:
      'Warning! Facebook says your page is engaging in behavior that may be considered bothersome or abusive by users. To avoid messaging restrictions being placed on your Page, Facebook requires you to immediately decrease the rate at which you are sending messages outside the 24-hour window to this person.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 63039\r\n\r\n### Warning! Facebook says your page is engaging in behavior that may be considered bothersome or abusive by users. To avoid messaging restrictions being placed on your Page, Facebook requires you to immediately decrease the rate at which you are sending messages outside the 24-hour window to this person.\r\n\r\n \r\n\r\n#### Possible Causes\r\nFacebook and/or Facebook users consider the messages abusive or bothersome, falling outside of Facebook's policies.\r\n\r\n#### Possible Solutions\r\nSoften the content of your message and decrease the rate at which messages are being sent to the user outside of the 24-hour session.",
    causes:
      "Facebook and/or Facebook users consider the messages abusive or bothersome, falling outside of Facebook's policies.",
    solutions:
      'Soften the content of your message and decrease the rate at which messages are being sent to the user outside of the 24-hour session.',
    description: null,
    product: 'Programmable SMS',
    date_created: '2021-08-20T22:22:14Z',
    last_updated: '2021-08-20T22:22:14Z',
  },
  50001: {
    code: 50001,
    message: 'Programmable Chat: Account SID not provided',
    log_level: 'ERROR',
    secondary_message: 'Request does not contain required Account SID parameter.',
    log_type: null,
    docs: '## Error - 50001\r\n\r\n### Programmable Chat: Account SID not provided \r\n\r\n#### Possible Causes \r\n*  Request does not contain required Account SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Account SID is being passed in request.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:43Z',
    last_updated: '2020-08-04T10:00:23.724Z',
  },
  81020: {
    code: 81020,
    message: 'Unsupported Trigger Type',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 81020\r\n\r\n### Unsupported Trigger Type\r\n\r\n An error occurred when Studio tried to run a widget that is not supported for the trigger type.\r\n\r\n#### Possible Causes\r\n* Flow was triggered by an incoming event that isn't supported for this widget\r\n\r\n#### Possible Solutions\r\n* Flow should be updated to use only the supported trigger types for this widget\r\n* For Send To Flex widget, only incoming call and incoming chat are supported",
    causes: "* Flow was triggered by an incoming event that isn't supported for this widget",
    solutions:
      '* Flow should be updated to use only the supported trigger types for this widget\r\n* For Send To Flex widget, only incoming call and incoming chat are supported',
    description:
      'An error occurred when Studio tried to run a widget that is not supported for the trigger type.',
    product: 'Studio',
    date_created: '2019-11-05T18:40:31Z',
    last_updated: '2023-11-27T16:31:31.802945Z',
  },
  80104: {
    code: 80104,
    message: 'Phone Number Already In Service',
    log_level: 'WARNING',
    secondary_message: 'PhoneNumber has already been added to Service',
    log_type: null,
    docs: '## Warning\n\n### Phone Number Already In Service\n\nExample Message: PhoneNumber has already been added to Service',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.205Z',
  },
  30453: {
    code: 30453,
    message: "Message couldn't be delivered",
    log_level: 'ERROR',
    secondary_message: 'Message delivery blocked',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30453\r\n\r\n### Message couldn\'t be delivered\r\n\r\n Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n\r\n#### Possible Causes\r\n* This is because Twilio has identified potential fraudulent messages being sent to the destination you are trying to reach.\r\n* Hence SMS traffic can not be delivered to the destination phone number used for the next couple of hours. The traffic should return to normalcy post that. However, the SMS traffic could be undelivered for an even longer period if fraudulent activity doesn\'t subside & continues to go on.\r\n\r\n#### Possible Solutions\r\nYou do not need to take any specific action. The disruption in traffic is usually temporary and will resolve in a couple of hours if we do not detect additional fraudulent activity.\r\n\r\n#### Continued issues with error 30453\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30453, and [open a support request.](https://www.twilio.com/console/support/tickets/create)\r\n\r\nAlternatively, you can use the optional <code style="color : name_color">RiskCheck</code> parameter when [creating a Message](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource) with the [Programmable Messaging API](https://www.twilio.com/docs/messaging/api). To prevent a known/legitimate message from getting blocked in future by SMS Pumping Protection, include the <code style="color : name_color">RiskCheck</code> parameter with value <code style="color : name_color">disable</code> when creating the new Message resource.\r\n\r\nYou can also mark known/legitimate phone numbers using the Global Safe List feature so that they don’t face any disruption . This provides an additional safety net against false positives, so that the traffic to this number never faces the above scenario. Add known phone numbers to the Safe List by using the [Global Safe List API.](https://www.twilio.com/docs/usage/global-safe-list)',
    causes:
      "* This is because Twilio has identified potential fraudulent messages being sent to the destination you are trying to reach.\r\n* Hence SMS traffic can not be delivered to the destination phone number used for the next couple of hours. The traffic should return to normalcy post that. However, the SMS traffic could be undelivered for an even longer period if fraudulent activity doesn't subside & continues to go on.",
    solutions:
      'You do not need to take any specific action. The disruption in traffic is usually temporary and will resolve in a couple of hours if we do not detect additional fraudulent activity.\r\n\r\n#### Continued issues with error 30453\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30453, and [open a support request.](https://www.twilio.com/console/support/tickets/create)\r\n\r\nAlternatively, you can use the optional <code style="color : name_color">RiskCheck</code> parameter when [creating a Message](https://www.twilio.com/docs/messaging/api/message-resource#create-a-message-resource) with the [Programmable Messaging API](https://www.twilio.com/docs/messaging/api). To prevent a known/legitimate message from getting blocked in future by SMS Pumping Protection, include the <code style="color : name_color">RiskCheck</code> parameter with value <code style="color : name_color">disable</code> when creating the new Message resource.\r\n\r\nYou can also mark known/legitimate phone numbers using the Global Safe List feature so that they don’t face any disruption . This provides an additional safety net against false positives, so that the traffic to this number never faces the above scenario. Add known phone numbers to the Safe List by using the [Global Safe List API.](https://www.twilio.com/docs/usage/global-safe-list)',
    description:
      'Message couldn’t be delivered to the destination number you are trying to reach temporarily.',
    product: 'Programmable SMS',
    date_created: '2023-10-13T10:51:13Z',
    last_updated: '2024-01-16T13:27:53.159004Z',
  },
  11215: {
    code: 11215,
    message: 'HTTP too many redirects',
    log_level: 'ERROR',
    secondary_message: 'this request has been redirected too many times and may be in a loop.',
    log_type: null,
    docs: '## Error - 11215 \n\n### HTTP too many redirects\n\nthis request has been redirected too many times and may be in a loop.\n\n#### Possible Causes \n*  Twilio received too many HTTP redirect messages in a row for this request.\n\n\n#### Possible Solutions\n*  Make certain your code is not stuck in an infinite loop.\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:25Z',
    last_updated: '2020-08-04T10:00:29.462Z',
  },
  14210: {
    code: 14210,
    message: 'Dial->Queue: Invalid whisper method',
    log_level: 'ERROR',
    secondary_message: "The whisper method is invalid. You must specify one of 'GET' or 'POST'.",
    log_type: null,
    docs: "## Error - 14210\n\n### Dial->Queue: Invalid whisper method\n\nThe whisper method is invalid. You must specify one of 'GET' or 'POST'.\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:11Z',
    last_updated: '2020-08-04T10:00:26.225Z',
  },
  95103: {
    code: 95103,
    message: 'Media file reached maximum size',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 95103\r\n\r\n### Media file reached maximum size\r\n\r\n Twilio failed to transcribe audio due to an issue with the audio file size.  The transcription files have been deleted and the resource has been marked as “failed”\r\n\r\n#### Possible Causes\r\nThe audio file size is larger than 3 GiB.\r\n\r\n#### Possible Solutions\r\nUse a different format that allows the file to be compressed, like mp3.\r\nSplit the file into shorter audio files and process them separately.',
    causes: 'The audio file size is larger than 3 GiB.',
    solutions:
      'Use a different format that allows the file to be compressed, like mp3.\r\nSplit the file into shorter audio files and process them separately.',
    description:
      'Twilio failed to transcribe audio due to an issue with the audio file size.  The transcription files have been deleted and the resource has been marked as “failed”',
    product: 'Voice Intelligence',
    date_created: '2024-04-16T17:31:27Z',
    last_updated: '2024-06-12T18:36:48.762281Z',
  },
  52106: {
    code: 52106,
    message: 'Notification too large for GCM/FCM',
    log_level: 'ERROR',
    secondary_message:
      'Try to send notification through GCM/FCM binding channel with too big payload',
    log_type: null,
    docs: '## Error - 52106\r\n\r\n### Notification too large for GCM/FCM\r\n\r\n#### Possible Causes \r\n*  Payload generated for GCM/FCM exceeded the 4 KB limit.\r\n\r\n#### Possible Solutions\r\n*  Reduce the size of the payload.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:29:41Z',
    last_updated: '2020-08-04T10:00:22.311Z',
  },
  53624: {
    code: 53624,
    message: 'Public key credentials for media tracks encryption could not be loaded',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53624\r\n\r\n### Public key credentials for media tracks encryption could not be loaded\r\n\r\nThe public key credentials configured in your account's composition settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, create and assign a new valid public key or disable the encryption (media will be uploaded in raw).",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-11T14:39:24Z',
    last_updated: '2020-08-04T10:00:13.435Z',
  },
  21205: {
    code: 21205,
    message: 'Invalid URL',
    log_level: 'ERROR',
    secondary_message:
      'You attempted to initiate an outbound phone call, but the URL you specified to handle the call was not a valid URL.',
    log_type: null,
    docs: '## Error - 21205\n\n### Invalid URL\n\nYou attempted to initiate an outbound phone call, but the URL you specified to\nhandle the call was not a valid URL.\n\nIf you specified an Application Sid for your outbound phone call, the\napplication must have a valid VoiceUrl or the call will fail.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:54Z',
    last_updated: '2020-08-04T10:00:27.222Z',
  },
  52110: {
    code: 52110,
    message: 'GCM/FCM service unavailable',
    log_level: 'ERROR',
    secondary_message: 'GCM/FCM service is temporary unavailable',
    log_type: null,
    docs: '## Error - 52110\r\n\r\n### GCM/FCM service unavailable\r\n\r\n#### Possible Causes \r\n*  GCM/FCM service is temporarily unavailable or Twilio cannot connect to it.\r\n\r\n#### Possible Solutions\r\n*  Check our [status page](http://status.twilio.com) to see if we are having an outage. \r\n*  If the problem persists, [contact support](https://www.twilio.com/help/contact) and we will investigate.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:32:38Z',
    last_updated: '2020-08-04T10:00:22.238Z',
  },
  30477: {
    code: 30477,
    message:
      'Toll Free verification rejection - Opt-in - Third party information sharing not allowed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 30477\r\n\r\n### Toll Free verification rejection - Opt-in - Third party information sharing not allowed\r\n\r\n The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n\r\n\r\n#### Possible Causes\r\nThe Terms of Service or Privacy Policy on the business’s website indicates that Opt-in is shared with third parties, affiliates, partners, etc. Any business with a terms of service or privacy policy that mentions sharing or selling consumer opt-in data is considered noncompliant. Consent cannot be bought, sold, shared, transferred, or exchanged. \r\n\r\n#### Possible Solutions\r\nRevise your processes to not share or sell consumer data/opt-in information with anyone. Revise your Terms of Service and Privacy Policy to remove all third party opt-in sharing language. If you have a “reasons we can share your personal information matrix” in your privacy policy that is not modifiable, adding a note below it that Messaging opt-in consent will not be shared is acceptable. Once complete and live on the business website, resubmit the toll free verification. \r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    causes:
      'The Terms of Service or Privacy Policy on the business’s website indicates that Opt-in is shared with third parties, affiliates, partners, etc. Any business with a terms of service or privacy policy that mentions sharing or selling consumer opt-in data is considered noncompliant. Consent cannot be bought, sold, shared, transferred, or exchanged. ',
    solutions:
      'Revise your processes to not share or sell consumer data/opt-in information with anyone. Revise your Terms of Service and Privacy Policy to remove all third party opt-in sharing language. If you have a “reasons we can share your personal information matrix” in your privacy policy that is not modifiable, adding a note below it that Messaging opt-in consent will not be shared is acceptable. Once complete and live on the business website, resubmit the toll free verification. \r\n\r\nResources: \r\n\r\n[CTIA guidelines](https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms)\r\n\r\n[Consent/Opt-In](https://www.twilio.com/en-us/legal/messaging-policy#:~:text=with%20Twilio%20policies.-,Consent%20/%20Opt%2Din,-What%20Is%20Proper) in [Twilio’s Messaging Policy](https://www.twilio.com/en-us/legal/messaging-policy)\r\n\r\n[Why was my Toll Free Verification Rejected?](https://support.twilio.com/hc/en-us/articles/9321443984155-Why-Was-My-Toll-Free-Verification-Rejected) \r\n\r\n[Required information for Toll-free verification](https://support.twilio.com/hc/en-us/articles/13264118705051-Required-Information-for-Toll-Free-Verification)\r\n\r\n[Toll-Free best practices](https://support.twilio.com/hc/en-us/articles/360038172934-Information-and-best-practices-for-using-Toll-Free-SMS-and-MMS-in-the-US-and-Canada)',
    description:
      'The Toll-Free phone number verification submission has been reviewed and it was rejected.Effective Jan 31st, 2024, messaging traffic on this Toll-Free number is blocked until it’s verified.\r\n\r\nVerification is one component of ensuring A2P SMS is used by businesses in a legal and compliant manner. The review process looks at the business sending messaging (not the software powering it), the use case, sample content, the web presence, the opt-in/consent collected and associated website terms and privacy policies.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-02-22T22:06:31Z',
    last_updated: '2024-02-22T22:06:31Z',
  },
  50505: {
    code: 50505,
    message: 'Programmable Chat: Last Updated By parameter is too long',
    log_level: 'ERROR',
    secondary_message: 'Last Updated By parameter is too long',
    log_type: null,
    docs: '## Error - 50505\r\n\r\n### Programmable Chat: Last Updated By parameter is too long\r\n\r\n#### Possible Causes \r\n*  Last Updated By parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Last Updated By is being passed in request. ',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2017-11-06T12:25:24Z',
    last_updated: '2020-08-04T10:00:16.496Z',
  },
  19036: {
    code: 19036,
    message: 'Invalid page token',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19036\r\n\r\n### Invalid page token\r\n\r\n The page token provided in the request is not valid\r\n\r\n#### Possible Causes\r\nPage token provided is not an integer\r\n\r\n#### Possible Solutions\r\nPage token must be an integer',
    causes: 'Page token provided is not an integer',
    solutions: 'Page token must be an integer',
    description: 'The page token provided in the request is not valid',
    product: null,
    date_created: '2020-07-21T20:27:36Z',
    last_updated: '2020-08-04T10:00:01.292Z',
  },
  40146: {
    code: 40146,
    message: 'Failed to issue Supervise Instruction due to invalid Reservation state',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 40146\r\n\r\n### Failed to issue Supervise Instruction due to invalid Reservation state\r\n\r\n The Reservation is not in a valid state for the Supervise instruction to be used, the Reservation cannot be pending or canceled.\r\n\r\n#### Possible Causes\r\n* A Reservation has not yet been accepted by a Worker.\r\n* The Reservation has already been canceled.\r\n\r\n#### Possible Solutions\r\n* Confirm that the Reservation has been accepted by the assigned Worker',
    causes:
      '* A Reservation has not yet been accepted by a Worker.\r\n* The Reservation has already been canceled.',
    solutions: '* Confirm that the Reservation has been accepted by the assigned Worker',
    description:
      'The Reservation is not in a valid state for the Supervise instruction to be used, the Reservation cannot be pending or canceled.',
    product: 'TaskRouter',
    date_created: '2020-08-21T00:35:05Z',
    last_updated: '2020-08-21T00:35:05Z',
  },
  81023: {
    code: 81023,
    message: 'Creating an Execution via REST API failed due to malformed contact parameters',
    log_level: 'ERROR',
    secondary_message:
      'When creating a flow execution via the REST API, the To and From parameters may not collectively exceed 300 bytes.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 81023\r\n\r\n### Creating an Execution via REST API failed due to malformed contact parameters\r\n\r\nWhen creating a flow execution via the REST API, the To and From parameters may not collectively exceed 300 bytes. The Create Execution endpoint was called with To and/or From parameters that could not be processed.\r\n\r\n#### Possible Causes\r\n* Collectively, the To and From parameters exceeded 300 bytes.\r\n\r\n#### Possible Solutions\r\nDouble-check the provided To and From parameters for syntax errors.',
    causes: '* Collectively, the To and From parameters exceeded 300 bytes.',
    solutions: 'Double-check the provided To and From parameters for syntax errors.',
    description:
      'The Create Execution endpoint was called with To and/or From parameters that could not be processed.',
    product: 'Studio',
    date_created: '2020-05-08T22:34:21Z',
    last_updated: '2020-08-04T10:00:03.155Z',
  },
  45350: {
    code: 45350,
    message: 'An unexpected error occurred.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '##  - 45350\r\n\r\n### \r\n\r\n \r\n\r\n#### Possible Causes\r\n\r\n\r\n#### Possible Solutions\r\n',
    causes: 'We encountered an unexpected error processing a request. ',
    solutions:
      'Retry the request.\r\n\r\nCheck our <a href="https://status.twilio.com/">status page</a> to see if we are having an outage.\r\n\r\nIf our <a href="https://status.twilio.com/">status page</a> has no information, <a href="https://support.twilio.com/">contact support</a> with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred.',
    product: 'Flex',
    date_created: '2020-12-14T21:32:45Z',
    last_updated: '2022-03-07T18:19:24.481264Z',
  },
  53121: {
    code: 53121,
    message: 'Approaching room or participant concurrency quota',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## WARNING - 53121\r\n\r\n### Approaching room or participant concurrency quota\r\n\r\n #### 53121: Reached 70% of room or participant concurrency quota\r\n\r\n#### Possible Causes\r\n * Connecting the first Participant in an Ad-hoc Room might exceed the account's concurrent Rooms quota.\r\n * Creating a Room via the REST API might exceed the account's concurrent Rooms quota.\r\n\r\n#### Possible Solutions\r\n* Complete existing Rooms.\r\n* Contact support/sales to increase the concurrent Rooms quota for your account.",
    causes:
      " * Connecting the first Participant in an Ad-hoc Room might exceed the account's concurrent Rooms quota.\r\n * Creating a Room via the REST API might exceed the account's concurrent Rooms quota.",
    solutions:
      '* Complete existing Rooms.\r\n* Contact support/sales to increase the concurrent Rooms quota for your account.',
    description: '#### 53121: Reached 70% of room or participant concurrency quota',
    product: 'Programmable Video',
    date_created: '2020-07-01T20:53:23Z',
    last_updated: '2021-06-08T18:20:28.301Z',
  },
  60001: {
    code: 60001,
    message: 'Downstream Authentication Failed',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 60001\r\n\r\n### Downstream Authentication Failed\r\n\r\n Downstream Authentication Failed\r\n\r\n#### Possible Causes\r\nThe request was received and passed Twilio API authentication, but failed due to a downstream authentication error for the Account SID provided.\r\n\r\n#### Possible Solutions\r\n- Check that the Account SID provided is correct.\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to confirm that access to this endpoint is enabled for the given Account SID.',
    causes:
      'The request was received and passed Twilio API authentication, but failed due to a downstream authentication error for the Account SID provided.',
    solutions:
      '- Check that the Account SID provided is correct.\r\n- [Contact Twilio Support](https://www.twilio.com/help/contact) to confirm that access to this endpoint is enabled for the given Account SID.',
    description: 'Downstream Authentication Failed',
    product: null,
    date_created: '2022-09-06T13:07:06.169569Z',
    last_updated: '2022-09-06T13:07:06.169581Z',
  },
  21644: {
    code: 21644,
    message: 'End-User cannot be deleted due to an active assignment to a Bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21644\r\n\r\n### End-User cannot be deleted due to an active assignment to a Bundle\r\n\r\n The End-User cannot be deleted due to active assignments\r\n\r\n#### Possible Causes\r\nThe End User cannot be deleted due to one or more active assignments to a Bundle\r\n\r\n#### Possible Solutions\r\nReassign a new End-User to all Bundle(s) and then perform the DELETE operation.',
    causes: 'The End User cannot be deleted due to one or more active assignments to a Bundle',
    solutions: 'Reassign a new End-User to all Bundle(s) and then perform the DELETE operation.',
    description: 'The End-User cannot be deleted due to active assignments',
    product: 'Phone Numbers',
    date_created: '2020-07-17T20:00:55Z',
    last_updated: '2020-08-10T23:38:42.917Z',
  },
  32302: {
    code: 32302,
    message: 'Interconnect: Connection (TNX) SID not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: null,
    docs: '#### Possible Causes \r\n*  The Interconnect Connection (TNX) SID was not found.\r\n\r\n\r\n#### Possible Solutions\r\n*  Please verify your Interconnect Connection SID, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Interconnect',
    date_created: '2016-11-16T21:53:40Z',
    last_updated: '2020-08-04T10:00:20.408Z',
  },
  52201: {
    code: 52201,
    message: 'Too many Facebook messenger notification requests',
    log_level: 'ERROR',
    secondary_message:
      'Too many Facebook messenger notifications are sent from the same Facebook page ID',
    log_type: null,
    docs: '## Error - 52201\r\n\r\n### RtdNotification: Too many Facebook notifications from same page ID\r\n\r\n#### Possible Causes \r\n* Customer is trying to broadcast Facebook messenger notifications \r\n\r\n#### Possible Solutions\r\n* Please notify RTD Notifications team if this error starts occurring.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-06-07T15:57:03Z',
    last_updated: '2020-08-04T10:00:21.356Z',
  },
  53606: {
    code: 53606,
    message: 'Internal failure when creating the recording resource',
    log_level: 'WARNING',
    secondary_message: 'A new attempt will be made after a delay',
    log_type: null,
    docs: '## Warning - 53606\r\n\r\n### Internal failure when creating the recording resource\r\n\r\nRaised when an error prevented us from creating an internal resource tracking the media recording.\r\n\r\nThe recording will not be accessible directly from Twilio until we remediate the situation but the media file has probably been stored safely to S3.\r\n\r\n#### Causes\r\n\r\n* An internal error prevented us from creating a resource. We\'ll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-06-29T13:06:14Z',
    last_updated: '2020-08-04T10:00:13.022Z',
  },
  70154: {
    code: 70154,
    message: 'Public Key Is Invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 70154\r\n\r\n### Public Key Is Invalid\r\nThe Public Key provided to Twilio is invalid. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Upload a new, valid Public Key.\r\n* For details on the Credentials Endpoint, see [the documentation](/docs/api/credentials/rest)',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-05-05T16:39:08Z',
    last_updated: '2020-08-04T10:00:18.722Z',
  },
  50365: {
    code: 50365,
    message: 'Invalid conversation webhook filter',
    log_level: 'ERROR',
    secondary_message: 'An invalid conversation webhook filter was supplied.',
    log_type: null,
    docs: '\n## Error - 50365\n\n### Conversations: Invalid conversation webhook filter\nAn invalid conversation webhook filter was supplied.\n\n#### Possible Causes\n* One of Configuration.Filters webhook parameters provided with the request does represent a valid webhook action filter.\n\n#### Possible Solutions\n* Ensure that a list of valid Configuration.Filters parameters are passed to the API request, refer to the list of [supported actions](https://www.twilio.com/docs/conversations/conversations-webhooks#webhook-action-triggers).\n\n',
    causes: 'null',
    solutions: 'null',
    description: 'null',
    product: 'Programmable Chat',
    date_created: '2019-09-24T00:00:00Z',
    last_updated: '2020-08-04T10:00:06.748Z',
  },
  14103: {
    code: 14103,
    message: 'Invalid Body',
    log_level: 'WARNING',
    secondary_message: 'The SMS body does not contain valid text',
    log_type: null,
    docs: "## Warning - 14103 \n\n### Message Invalid Body\n\nThe Message body does not contain valid text or a media URL\n\n#### Possible Causes \n*  Empty SMS body with no media URL specified\n*  SMS Body exceeding 1600 characters \n\n\n#### Possible Solutions\n*  Make sure you're not sending a blank message\n*  Make sure the text of the message you are sending is 1600 characters or less.\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:48Z',
    last_updated: '2020-08-04T10:00:27.639Z',
  },
  32200: {
    code: 32200,
    message: 'SIP: Insufficient permissions',
    log_level: 'ERROR',
    secondary_message: 'Request failed due to insufficient permissions.',
    log_type: null,
    docs: '## Error - 32200\r\n\r\n###  SIP: Insufficient permissions\r\n\r\n#### Possible Causes \r\n*  Request failed due to insufficient permissions.\r\n\r\n#### Possible Solutions\r\n*  Please check that your account is active. Ensure that you have [Authentication details](/docs/api/sip-trunking/getting-started#authentication) configured on your Trunk.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Elastic SIP Trunking',
    date_created: '2016-03-31T17:14:37Z',
    last_updated: '2020-08-04T10:00:24.333Z',
  },
  32020: {
    code: 32020,
    message: 'SHAKEN/STIR call verification failed due to invalid passport from customer',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 32020\r\n\r\n### SHAKEN/STIR call verification failed due to invalid passport from customer\r\n\r\n Twilio cannot verify incoming SHAKEN PASSporT from customer\r\n\r\n#### Possible Causes\r\nSee the error message for details\r\n\r\n#### Possible Solutions\r\nThe call is rejected. Reattempt the call with a new passport.',
    causes: 'See the error message for details',
    solutions: 'The call is rejected. Reattempt the call with a new passport.',
    description: 'Twilio cannot verify incoming SHAKEN PASSporT from customer',
    product: 'Elastic SIP Trunking',
    date_created: '2023-05-26T16:35:49Z',
    last_updated: '2023-05-26T16:35:49Z',
  },
  13201: {
    code: 13201,
    message: 'Dial: Cannot Dial out from a Dial Call Segment',
    log_level: 'ERROR',
    secondary_message:
      "TwiML documents that execute on the called party's end (via the Dial->Number url attribute, before the parties are bridged) cannot issue a new Dial.",
    log_type: null,
    docs: "## Error - 13201 \n\n### Dial: Cannot Dial out from a Dial Call Segment\n\nTwiML documents that execute on the called party's end (via the Dial->Number URL attribute, before the parties are bridged) cannot issue a new Dial.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:31Z',
    last_updated: '2020-08-04T10:00:29.001Z',
  },
  30106: {
    code: 30106,
    message: 'Domain has not been set up for this account',
    log_level: 'ERROR',
    secondary_message: 'Domain has not been set up for this account',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30106\r\n\r\n### Domain has not been set up for this account\r\n\r\nDomain has not been set up for this account Domain has not been setup for click tracking\r\n\r\n#### Possible Causes\r\nOnboarding process is incomplete.\r\n\r\n#### Possible Solutions\r\nFinish onboarding.',
    causes: 'Onboarding process is incomplete.',
    solutions: 'Finish onboarding.',
    description: 'Domain has not been setup for click tracking',
    product: 'Programmable SMS',
    date_created: '2020-05-01T20:10:04Z',
    last_updated: '2022-07-14T23:59:21.47746Z',
  },
  13311: {
    code: 13311,
    message: 'Gather: Invalid finishOnKey value',
    log_level: 'WARNING',
    secondary_message:
      "The value of the finishOnKey attribute must be a single character. See the <a href='/docs/api/twiml/gather#finishOnKey'>Gather Verb</a> API Reference for more information.",
    log_type: null,
    docs: '## Warning - 13311 \n\n### Gather: Invalid finishOnKey value\n\nThe value of the finishOnKey attribute must be one of the following characters "0123456789#*". See the <a href=\'/docs/api/twiml/gather#finishOnKey\'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:40Z',
    last_updated: '2020-08-04T10:00:28.163Z',
  },
  11240: {
    code: 11240,
    message: 'HTTP connection edge location is invalid',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 11240\r\n\r\n### HTTP connection edge location is invalid\r\n\r\n There was an error connecting to the URL due to an invalid edge location parameter.\r\n\r\n#### Possible Causes\r\n* The edge location(s) specified in the 'e' parameter of your connection settings are not valid\r\n\r\n#### Possible Solutions\r\n* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
    causes:
      "* The edge location(s) specified in the 'e' parameter of your connection settings are not valid",
    solutions: "* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
    description:
      'There was an error connecting to the URL due to an invalid edge location parameter.',
    product: null,
    date_created: '2019-02-04T18:34:22Z',
    last_updated: '2020-08-04T10:00:10.796Z',
  },
  16027: {
    code: 16027,
    message: 'Participant to be whispered is on hold',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16027\r\n\r\n### Participant to be whispered is on hold\r\n\r\n The participant to be whispered is on hold, so the coach to the participant cannot be added to the conference.\r\n\r\n#### Possible Causes\r\nThe participant to be whispered is on hold.\r\n\r\n#### Possible Solutions\r\nValidate that this call is connecting to the correct conference and the call SID specified is also in the conference.',
    causes: 'The participant to be whispered is on hold.',
    solutions:
      'Validate that this call is connecting to the correct conference and the call SID specified is also in the conference.',
    description:
      'The participant to be whispered is on hold, so the coach to the participant cannot be added to the conference.',
    product: 'Programmable Voice',
    date_created: '2020-12-03T23:56:30Z',
    last_updated: '2020-12-03T23:56:39.797Z',
  },
  60214: {
    code: 60214,
    message: 'Call channel is not supported when using PSD2',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60214\r\n\r\n### Call channel is not supported when using PSD2\r\n\r\n Call channel is not supported when using PSD2\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\n* Verify Service has PSD2 enabled\r\n\r\n#### Possible Solutions\r\n* Disable PSD2 for this Verify Service\r\n* Use SMS channel',
    causes: '* Verify Service has PSD2 enabled',
    solutions: '* Disable PSD2 for this Verify Service\r\n* Use SMS channel',
    description: 'Call channel is not supported when using PSD2\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-09-19T19:38:52Z',
    last_updated: '2021-05-18T04:46:23.829Z',
  },
  11220: {
    code: 11220,
    message: 'SSL/TLS Handshake Error',
    log_level: 'ERROR',
    secondary_message: 'During SSL/TLS negotiation, Twilio experienced a connection reset.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 11220\r\n\r\n### SSL/TLS Handshake Error\r\n\r\nDuring SSL/TLS negotiation, Twilio experienced a connection reset. \r\n\r\n#### Possible Causes\r\n*  Incompatible cipher suites in use by the client and the server. This would require the client to use (or enable) a cipher suite that is supported by the server.\r\n\r\n#### Possible Solutions\r\n*  Verify cipher suites in-use are up to date. Twilio-supported ciphers can be found [here](https://support.twilio.com/hc/en-us/articles/360007724794-Notice-Twilio-REST-API-s-TLS-and-Cipher-Suite-Security-Changes-for-June-2019)\r\n*  Use compatible version of TLS, Twilio supports TLS 1.2.',
    causes:
      '*  Incompatible cipher suites in use by the client and the server. This would require the client to use (or enable) a cipher suite that is supported by the server.',
    solutions:
      '*  Verify cipher suites in-use are up to date. Twilio-supported ciphers can be found [here](https://support.twilio.com/hc/en-us/articles/360007724794-Notice-Twilio-REST-API-s-TLS-and-Cipher-Suite-Security-Changes-for-June-2019)\r\n*  Use compatible version of TLS, Twilio supports TLS 1.2.',
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:25Z',
    last_updated: '2023-01-25T20:31:40.785868Z',
  },
  93102: {
    code: 93102,
    message: 'There was an error with your AWS role',
    log_level: 'ERROR',
    secondary_message:
      'The role associated with your AWS Sink is not allowing Event Streams to send events',
    log_type: 'APPLICATION',
    docs: '## ERROR - 93102\r\n\r\n### There was an error with your AWS role\r\n\r\nThe role associated with your AWS Sink is not allowing Event Streams to send events There is an issue with your role\r\n\r\n#### Possible Causes\r\nMost likely something has changed with your Role, or this is you first time using this Sink.  See Error Message for more details\r\n\r\n#### Possible Solutions\r\nIf this Role was working check to see if it was changed.  If you need those changes you will need to create a new sink and subscription to receive your events.  If this is the first time using this Sink, verify the config is correct for this sink.',
    causes:
      'Most likely something has changed with your Role, or this is you first time using this Sink.  See Error Message for more details',
    solutions:
      'If this Role was working check to see if it was changed.  If you need those changes you will need to create a new sink and subscription to receive your events.  If this is the first time using this Sink, verify the config is correct for this sink.',
    description: 'There is an issue with your role',
    product: 'Events',
    date_created: '2021-01-13T18:26:33Z',
    last_updated: '2021-02-04T17:31:38.326Z',
  },
  21726: {
    code: 21726,
    message: 'Starter brand registrations and updates are temporarily disabled',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 21726\r\n\r\n### Starter brand registrations and updates are temporarily disabled\r\n\r\n Starter brands cannot be created or updated at this time. Contact support for help.\r\n\r\n#### Possible Causes\r\nThe starter brand you are trying to create/update is a Starter brand. See [New Requirements for A2P 10DLC Registrations](https://www.twilio.com/blog/new-requirements-for-a2p-10dlc-registrations) for more info.\r\n\r\n#### Possible Solutions\r\nContact Twilio support.',
    causes:
      'The starter brand you are trying to create/update is a Starter brand. See [New Requirements for A2P 10DLC Registrations](https://www.twilio.com/blog/new-requirements-for-a2p-10dlc-registrations) for more info.',
    solutions: 'Contact Twilio support.',
    description:
      'Starter brands cannot be created or updated at this time. Contact support for help.',
    product: 'Programmable SMS',
    date_created: '2022-09-13T20:44:33Z',
    last_updated: '2022-09-29T23:23:47.533118Z',
  },
  18019: {
    code: 18019,
    message: 'Invalid or incomplete emergency address provided',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18019\r\n\r\n### Invalid or incomplete emergency address provided\r\n\r\n The emergency address you have provided is not valid.\r\n\r\n#### Possible Causes\r\nThe submitted emergency address does not meet our requirements.\r\n\r\n#### Possible Solutions\r\nPlease resubmit the bundle with the correct address. Please note that we cannot accept PO boxes/Virtual addresses.',
    causes: 'The submitted emergency address does not meet our requirements.',
    solutions:
      'Please resubmit the bundle with the correct address. Please note that we cannot accept PO boxes/Virtual addresses.',
    description: 'The emergency address you have provided is not valid.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T10:11:56Z',
    last_updated: '2024-07-04T10:11:56Z',
  },
  68001: {
    code: 68001,
    message: 'Network Error',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 68001\r\n\r\n### Network Error\r\n\r\n An error occurred while calling the API.\r\n\r\n#### Possible Causes\r\nIt was not possible to communicate properly with the API.\r\n\r\n#### Possible Solutions\r\nCheck parameters and retry',
    causes: 'It was not possible to communicate properly with the API.',
    solutions: 'Check parameters and retry',
    description: 'An error occurred while calling the API.',
    product: 'Verify',
    date_created: '2020-09-15T18:11:22Z',
    last_updated: '2020-09-21T15:05:12.703Z',
  },
  35115: {
    code: 35115,
    message: 'Scheduling does not support this timestamp',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 35115\r\n\r\n### Scheduling does not support this timestamp\r\n\r\n SendAt time must be between 900 seconds and 35 days (3024000 seconds) in the future, inclusive.\r\n\r\n#### Possible Causes\r\nScheduler currently doesn\'t support scheduling a message at a fixed time less that 15 minutes from now, or more than 35 days in the future.\r\n\r\n#### Possible Solutions\r\nVerify that the SendAt parameter is using "[YYYY]-[MM]-[DD]T[HH]:[MM]:[SS]Z" format (in UTC).',
    causes:
      "Scheduler currently doesn't support scheduling a message at a fixed time less that 15 minutes from now, or more than 35 days in the future.",
    solutions:
      'Verify that the SendAt parameter is using "[YYYY]-[MM]-[DD]T[HH]:[MM]:[SS]Z" format (in UTC).',
    description:
      'SendAt time must be between 900 seconds and 35 days (3024000 seconds) in the future, inclusive.',
    product: 'Programmable SMS',
    date_created: '2023-07-27T15:07:19Z',
    last_updated: '2023-07-27T15:07:19Z',
  },
  21470: {
    code: 21470,
    message: 'Invalid AccountSid',
    log_level: 'ERROR',
    secondary_message:
      "The AccountSid you specified was not a valid AccountSid identifier.  AccountSid's are 34 character strings that represent the Twilio Account .  For example, AC44CE4123947237834573457345347567.",
    log_type: null,
    docs: "## Error - 21470\n\n### Invalid AccountSid\n\nThe AccountSid you specified was not a valid AccountSid identifier.  AccountSid's are 34 character strings that represent the Twilio Account .  For example, AC44CE4123947237834573457345347567.\n\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:14:22Z',
    last_updated: '2020-08-04T10:00:25.405Z',
  },
  18039: {
    code: 18039,
    message: 'Information does not match the supporting document.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 18039\r\n\r\n### Information does not match the supporting document.\r\n\r\n The information you shared does not match the supporting document.\r\n\r\n#### Possible Causes\r\nYou may have attached the wrong document or shared inaccurate information.\r\n\r\n#### Possible Solutions\r\nPlease amend the information and resubmit the bundle',
    causes: 'You may have attached the wrong document or shared inaccurate information.',
    solutions: 'Please amend the information and resubmit the bundle',
    description: 'The information you shared does not match the supporting document.',
    product: 'Phone Numbers',
    date_created: '2024-07-04T09:56:55Z',
    last_updated: '2024-07-04T09:56:55Z',
  },
  81011: {
    code: 81011,
    message: 'Failed to send Message',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '## Error - 81011\r\n\r\n### Failed to send Message\r\nStudio was unable to send a Message. This is usually due to incorrect setup of a Message Widget.\r\n\r\n#### Possible Causes\r\n* You have an invalid number.\r\n* You are missing a message body.\r\n* You are missing a Media URL\r\n\r\n#### Possible Solutions\r\n* Ensure the message number is valid.\r\n* Ensure you have set a correct message body in the Widget.\r\n* Ensure you have setup a Media URL.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Studio',
    date_created: '2018-06-26T23:16:46Z',
    last_updated: '2020-08-04T10:00:13.098Z',
  },
  19020: {
    code: 19020,
    message: 'Contact with the provided channel value already exists',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 19020\r\n\r\n### Contact with the provided channel value already exists\r\n\r\n Channel value already exists \r\n\r\n#### Possible Causes\r\nAn existing contact has the same channel value provided in the request \r\n\r\n#### Possible Solutions\r\nChannel value has to be unique for contact, use different channel value or update the existing one',
    causes: 'An existing contact has the same channel value provided in the request ',
    solutions:
      'Channel value has to be unique for contact, use different channel value or update the existing one',
    description: 'Channel value already exists ',
    product: null,
    date_created: '2020-07-21T20:14:25Z',
    last_updated: '2020-08-04T10:00:01.804Z',
  },
  45774: {
    code: 45774,
    message: 'Internal Error. Failed to refresh token.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45774\r\n\r\n### Internal Error. Failed to refresh token.\r\n\r\n An unexpected error occurred when processing refresh token request.\r\n\r\n#### Possible Causes\r\nWe encountered an unexpected error when refreshing token.\r\n\r\n#### Possible Solutions\r\nRetry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'We encountered an unexpected error when refreshing token.',
    solutions:
      'Retry the request.\r\n\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description: 'An unexpected error occurred when processing refresh token request.',
    product: 'Flex',
    date_created: '2023-11-22T15:41:28Z',
    last_updated: '2023-11-22T15:41:28Z',
  },
  52134: {
    code: 52134,
    message: 'Invalid APNs device token',
    log_level: 'ERROR',
    secondary_message: 'APNs rejected notification with InvalidToken reason',
    log_type: null,
    docs: '## Error - 52134\r\n\r\n### Invalid APNs device token\r\n\r\n#### Possible Causes \r\n*  APNs device token format is invalid.\r\n*  Trying to use a development certificate for a production application or vice-versa.\r\n\r\n#### Possible Solutions\r\n*  Make sure you do not modify the device token before providing it to Twilio. If using a command line tool make sure to url-encode the token.\r\n*  Make sure that you are using a development certificate for a development application and a production certificate for a production application.\r\n\t* If you are using a traditional certificate, you can tell its environment by looking at the common name field\r\n\t\t* For a development certificate, it will start with: Apple Development IOS Push Services\r\n\t\t* For a production certificate, it will start with: Apple Push Services\r\n\t* If you are using a universal certificate, you can use it for both development and production applications. However you have to make sure that you have properly indicated the type of application by setting the sandbox parameter when you create the credential. You can check the sandbox flag of your credential via the [REST API](/docs/api/ip-messaging/rest/credentials#action-get).',
    causes: null,
    solutions: null,
    description: null,
    product: 'Notifications',
    date_created: '2016-04-19T15:35:27Z',
    last_updated: '2020-08-04T10:00:22.158Z',
  },
  30013: {
    code: 30013,
    message: 'TTL is too big',
    log_level: 'ERROR',
    secondary_message: 'Message Time To Live is too big',
    log_type: null,
    docs: '## Error - 30013\r\n\r\n## Message Time To Live is too big\r\n\r\n### Possible Causes \r\nTTL specified in the request is too big\r\n\r\n### Possible Solutions\r\nSpecify a smaller TTL\r\n',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-01-22T10:42:13Z',
    last_updated: '2020-08-04T10:00:11.488Z',
  },
  30018: {
    code: 30018,
    message: 'Destination carrier requires sender ID pre-registration',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 30018\r\n\r\n### Destination carrier requires sender ID pre-registration\r\n\r\n You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Alphanumeric Sender ID pre-registration. Our records indicate that you do not have a registered Alphanumeric Sender ID for this country. This can result in lower delivery quality.\r\n\r\nIf you are sending transactional SMS (like OTP/auth codes, account-related alerts) you should pre-register for the best possible delivery quality.\r\n\r\n#### Possible Causes\r\n* The recipient you are sending a message to is on a network that requires alphanumeric sender ID pre-registration, and our records indicate that your sender ID is not registered.\r\n\r\n#### Possible Solutions\r\n* If your message is marked "undelivered," your message was likely rejected by the mobile network and you will need to register an Alpha Sender ID to improve delivery to that network.\r\n* If your message is marked "delivered," it may have been delivered successfully. However, it is still strongly recommended to register an Alpha Sender ID for the destination country if possible.\r\n* Learn more about Alpha Sender ID registration requirements [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Use [this form](https://twiliodoer.secure.force.com/SenderId) to register a Sender ID for the destination country.\r\n* If you are sending OTP/2FA codes consider using [Twilio Verify or Authy](https://www.twilio.com/en-us/trusted-activation/verify) which will automatically take care of all applicable registrations.',
    causes:
      '* The recipient you are sending a message to is on a network that requires alphanumeric sender ID pre-registration, and our records indicate that your sender ID is not registered.',
    solutions:
      '* If your message is marked "undelivered," your message was likely rejected by the mobile network and you will need to register an Alpha Sender ID to improve delivery to that network.\r\n* If your message is marked "delivered," it may have been delivered successfully. However, it is still strongly recommended to register an Alpha Sender ID for the destination country if possible.\r\n* Learn more about Alpha Sender ID registration requirements [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Use [this form](https://twiliodoer.secure.force.com/SenderId) to register a Sender ID for the destination country.\r\n* If you are sending OTP/2FA codes consider using [Twilio Verify or Authy](https://www.twilio.com/en-us/trusted-activation/verify) which will automatically take care of all applicable registrations.',
    description:
      'You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Alphanumeric Sender ID pre-registration. Our records indicate that you do not have a registered Alphanumeric Sender ID for this country. This can result in lower delivery quality.\r\n\r\nIf you are sending transactional SMS (like OTP/auth codes, account-related alerts) you should pre-register for the best possible delivery quality.',
    product: 'Programmable SMS',
    date_created: '2019-12-31T18:59:36Z',
    last_updated: '2023-07-31T21:49:42.889566Z',
  },
  54419: {
    code: 54419,
    message: 'Number of subscriptions per connection is over the limit',
    log_level: 'ERROR',
    secondary_message: 'An SDK attempted to open and listen for updates for more than 2000 objects',
    log_type: null,
    docs: "## Error - 54419\r\n\r\n### Sync: Number of subscriptions per connection is over the limit\r\nAn SDK attempted to open and listen for updates for more than 2000 objects.\r\n\r\n#### Possible Causes\r\n* A programming error has generated many queries in place of one.\r\n* Your app has created too many LiveQueries over time (often a problem in single-page apps).\r\n\r\n#### Possible Solutions\r\n* Make sure you're only issuing queries for information that you need.\r\n* When your UI no longer needs a query, use the `close()` method on the LiveQuery object to unsubscribe and release the corresponding Sync resources. See the [SDK Documentation](https://www.twilio.com/docs/sync/javascript-sdk-changelog) for details.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2019-03-28T08:32:32Z',
    last_updated: '2020-08-04T10:00:09.266Z',
  },
  53665: {
    code: 53665,
    message: 'Invalid AWS credentials to access external S3 bucket in composition settings',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 53665\r\n\r\n### Invalid AWS credentials to access external S3 bucket in composition settings\r\n\r\n The AWS credentials configured in your account's composition settings are not valid.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.\r\n\r\n#### Possible Causes\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the AWS Access Key ID and Secret Access Key are not correct.\r\n\r\n#### Possible Solutions\r\n * In the composition settings section of your account's console, set some valid credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    causes:
      ' * If you have specified your own bucket and access credentials, this is most likely due to the fact that the AWS Access Key ID and Secret Access Key are not correct.',
    solutions:
      " * In the composition settings section of your account's console, set some valid credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
    description:
      "The AWS credentials configured in your account's composition settings are not valid.\r\n\r\nMedia composition has been marked as FAILED and will not be retried.",
    product: 'Programmable Video',
    date_created: '2021-04-13T07:32:36Z',
    last_updated: '2021-04-13T07:32:36Z',
  },
  31484: {
    code: 31484,
    message: 'Address Incomplete',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31484\r\n\r\n### Address Incomplete\r\n\r\n The provided phone number is malformed.\r\n\r\n#### Possible Causes\r\n* The outbound call was made with a phone number that has an invalid format.\r\n\r\n#### Possible Solutions\r\n* Ensure the phone number dialed is formatted correctly.',
    causes: '* The outbound call was made with a phone number that has an invalid format.',
    solutions: '* Ensure the phone number dialed is formatted correctly.',
    description: 'The provided phone number is malformed.',
    product: 'Programmable Voice',
    date_created: '2019-06-13T01:44:53Z',
    last_updated: '2020-08-04T10:00:07.983Z',
  },
  31210: {
    code: 31210,
    message: 'Call Message Event Type is invalid.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 31210\r\n\r\n### Call Message Event Type is invalid.\r\n\r\n The Message Type used for sending Call Message Event is invalid.\r\nPlease see Twilio\'s <a href="/docs/voice/sdks/call-message-events/"> Voice SDK Call Message Events Documentation</a> for more information on valid Message Type.\r\n\r\n\r\n#### Possible Causes\r\nThe Message Type used for sending Call Message Event is invalid.\r\n\r\n#### Possible Solutions\r\n* Verify that Message Type being sent with Call Message Event is a value supported by Twilio Programmable Voice\r\n* Use one of the <a href="/docs/voice/sdks/call-message-events/">supported Message Types</a> to call a Twilio function.',
    causes: 'The Message Type used for sending Call Message Event is invalid.',
    solutions:
      '* Verify that Message Type being sent with Call Message Event is a value supported by Twilio Programmable Voice\r\n* Use one of the <a href="/docs/voice/sdks/call-message-events/">supported Message Types</a> to call a Twilio function.',
    description:
      'The Message Type used for sending Call Message Event is invalid.\r\nPlease see Twilio\'s <a href="/docs/voice/sdks/call-message-events/"> Voice SDK Call Message Events Documentation</a> for more information on valid Message Type.\r\n',
    product: 'Programmable Voice',
    date_created: '2024-04-11T20:08:29Z',
    last_updated: '2024-04-11T20:08:29Z',
  },
  45379: {
    code: 45379,
    message: 'Failed to inactivate Channel. Downstream error.',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## ERROR - 45379\r\n\r\n### Failed to inactivate Channel. Downstream error.\r\n\r\n Failed to inactivate a Channel <channel sid> due to an error from Twilio Conversations API.\r\n\r\n#### Possible Causes\r\nConversations API returned an error\r\n\r\n#### Possible Solutions\r\nCheck our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    causes: 'Conversations API returned an error',
    solutions:
      'Check our status page to see if we are having an outage.\r\n\r\nIf our status page has no information, contact support with details about the requests that are failing, and we will investigate.',
    description:
      'Failed to inactivate a Channel <channel sid> due to an error from Twilio Conversations API.',
    product: 'Flex',
    date_created: '2023-08-28T21:55:10Z',
    last_updated: '2023-08-28T21:55:10Z',
  },
  51101: {
    code: 51101,
    message: 'Twilsock: Service instance not found',
    log_level: 'ERROR',
    secondary_message: 'Service instance specified in the request does not exist.',
    log_type: null,
    docs: '## Error - 51101\r\n\r\n### Service instance not found\r\n\r\n#### Possible Causes \r\nService instance specified in the request does not exist.\r\n\r\n#### Possible Solutions\r\nConfirm a valid service instance is being passed in the request. ',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T11:22:53Z',
    last_updated: '2020-08-04T10:00:09.922Z',
  },
  50301: {
    code: 50301,
    message: 'Programmable Chat: Channel key not provided',
    log_level: 'ERROR',
    secondary_message:
      "Request does not contain required Channel SID or Channel's Unique Name parameters.",
    log_type: null,
    docs: "## Error - 50301\r\n\r\n### Programmable Chat: Channel key not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Channel SID or Channel's Unique Name parameters.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel SID or Channel's Unique Name is being passed in request. ",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Chat',
    date_created: '2016-03-31T17:14:50Z',
    last_updated: '2020-08-04T10:00:23.207Z',
  },
  50385: {
    code: 50385,
    message: 'Conversations are disabled in this region',
    log_level: 'ERROR',
    secondary_message: 'Conversations API is not supported in this Twilio region',
    log_type: 'APPLICATION',
    docs: "## ERROR - 50385\r\n\r\n### Conversations are disabled in this region\r\n\r\nConversations API is not supported in this Twilio region Conversations features do not function in the region you've selected. The API will return this error to indicate that, preventing further activity.\r\n\r\n#### Possible Causes\r\n* You may be using a Programmable Chat service that in the ie1 region (at chat.ie1.twilio.com). While Conversations is backwards compatible with Chat in other respects, the product presently works only in the default region (US East).\r\n* You may have inadvertently specified a region (other than the default) in your Conversations SDKs.\r\n\r\n#### Possible Solutions\r\nIf you need access to Conversations hosted in a Twilio datacenter outside the US, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) so we can prioritize it accordingly. In the meantime, use the default Twilio URLs (e.g. conversations.twilio.com).",
    causes:
      '* You may be using a Programmable Chat service that in the ie1 region (at chat.ie1.twilio.com). While Conversations is backwards compatible with Chat in other respects, the product presently works only in the default region (US East).\r\n* You may have inadvertently specified a region (other than the default) in your Conversations SDKs.',
    solutions:
      'If you need access to Conversations hosted in a Twilio datacenter outside the US, please reach out to Twilio Support through the [Console](https://console.twilio.com) or [Help Center](https://support.twilio.com) so we can prioritize it accordingly. In the meantime, use the default Twilio URLs (e.g. conversations.twilio.com).',
    description:
      "Conversations features do not function in the region you've selected. The API will return this error to indicate that, preventing further activity.",
    product: 'Programmable Chat',
    date_created: '2020-09-24T12:32:24Z',
    last_updated: '2023-11-01T04:43:45.15573Z',
  },
  53615: {
    code: 53615,
    message: 'Access denied to external S3 bucket configured in recording settings',
    log_level: 'WARNING',
    secondary_message: 'The media will not be uploaded until the configuration has been fixed',
    log_type: null,
    docs: "## Warning - 53615\r\n\r\n### Access denied to external S3 bucket configured in recording settings\r\n\r\nWe failed to upload media to the external S3 bucket configured in your account's recording settings.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\nThis is a configuration error that can have different root causes\r\n   * The IAM user referenced in the credentials provided does not have enough permissions to upload to the bucket.\r\n   * The bucket configured in your settings has SSE-S3 enabled. The only default encryption mechanism supported is SSE-KMS. Please review the guides for more informtion\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).\r\n* If SSE-S3 is enabled, please consider switching to SSE-KMS.",
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable Video',
    date_created: '2018-05-24T14:07:13Z',
    last_updated: '2020-08-04T10:00:13.586Z',
  },
  94603: {
    code: 94603,
    message: 'Ttl is out of range',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 94603\r\n\r\n### Ttl is out of range\r\n\r\n The action could not be performed because the TTL provided is out of range.\r\n\r\n#### Possible Causes\r\n * Ttl is smaller than 1 seconds\r\n * Ttl is bigger  than 3600 seconds\r\n\r\n#### Possible Solutions\r\n * Ttl value must be between 1 and 3600 seconds',
    causes: ' * Ttl is smaller than 1 seconds\r\n * Ttl is bigger  than 3600 seconds',
    solutions: ' * Ttl value must be between 1 and 3600 seconds',
    description: 'The action could not be performed because the TTL provided is out of range.',
    product: null,
    date_created: '2022-05-10T10:23:52Z',
    last_updated: '2022-05-10T10:23:52Z',
  },
  62220: {
    code: 62220,
    message: 'Provisioning failure - Requested bandwidth not available on the network device.',
    log_level: 'ERROR',
    secondary_message:
      'Network device does not have the capacity available to perform the provisioning task',
    log_type: 'APPLICATION',
    docs: '## ERROR - 62220\r\n\r\n### Provisioning failure - Requested bandwidth not available on the network device.\r\n\r\nNetwork device does not have the capacity available to perform the provisioning task Bandwidth is not available on the network device due to lack of capacity\r\n\r\n#### Possible Causes\r\nNetwork device is out of capacity\r\n\r\n#### Possible Solutions\r\nUpgrade the capacity on the network device.',
    causes: 'Network device is out of capacity',
    solutions: 'Upgrade the capacity on the network device.',
    description: 'Bandwidth is not available on the network device due to lack of capacity',
    product: 'Interconnect',
    date_created: '2020-04-13T22:27:10Z',
    last_updated: '2020-08-04T10:00:04.054Z',
  },
  51117: {
    code: 51117,
    message: 'Twilsock: Invalid access token signature',
    log_level: 'ERROR',
    secondary_message: 'The token has an invalid signature.',
    log_type: null,
    docs: '## Error - 51117\r\n\r\n### Invalid access token signature\r\n\r\n#### Possible Causes \r\nThe token has an invalid signature.\r\n\r\n#### Possible Solutions\r\nConfirm a valid and signed token is being passed.\r\n\r\nTo check whether signed correctly, you can use the tools available at [jwt.io](https://jwt.io).',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2019-03-27T12:55:10Z',
    last_updated: '2020-08-04T10:00:09.604Z',
  },
  21617: {
    code: 21617,
    message: 'The concatenated message body exceeds the 1600 character limit',
    log_level: 'ERROR',
    secondary_message:
      'The maximum allowable body text length is generally 1600 characters, but some glyphs such as Emoji, Emoticons or other special characters will be counted as multiple characters.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 21617\r\n\r\n### The concatenated message body exceeds the 1600 character limit\r\n\r\n \r\n\r\n\r\n#### Possible Causes\r\nThe maximum allowable body text length is generally 1600 characters, but some special characters such as emojis, emoticons or non-GSM characters will be counted as multiple characters if they have a higher byte count. \r\n\r\n#### Possible Solutions\r\nAn online text to byte calculator can help you understand if certain characters are taking up more character space than others.',
    causes:
      'The maximum allowable body text length is generally 1600 characters, but some special characters such as emojis, emoticons or non-GSM characters will be counted as multiple characters if they have a higher byte count. ',
    solutions:
      'An online text to byte calculator can help you understand if certain characters are taking up more character space than others.',
    description: '\r\n',
    product: null,
    date_created: '2016-03-31T17:14:27Z',
    last_updated: '2024-02-12T11:53:06.839751Z',
  },
  16112: {
    code: 16112,
    message: 'Voice Recording: Upload file to external AWS S3 bucket failed (Access Denied)',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 16112\r\n\r\n### Voice Recording: Upload file to external AWS S3 bucket failed (Access Denied)\r\n\r\n Twilio failed to upload the recording file to the external AWS S3 bucket specified in Voice Settings due to access denied. The recording file has been deleted, and the resource has been marked as “failed”.\r\n\r\n#### Possible Causes\r\n* AWS credentials does not have enough permissions to upload to the bucket\r\n* The external S3 bucket has SSE-S3 enabled, only SSE-KMS is supported\r\n\r\n#### Possible Solutions\r\n* Ensure AWS S3 bucket credentials are valid and have enough permission to access\r\n* If SSE-S3 is enabled, please consider switching to SSE-KMS\r\n* Disable external storage',
    causes:
      '* AWS credentials does not have enough permissions to upload to the bucket\r\n* The external S3 bucket has SSE-S3 enabled, only SSE-KMS is supported',
    solutions:
      '* Ensure AWS S3 bucket credentials are valid and have enough permission to access\r\n* If SSE-S3 is enabled, please consider switching to SSE-KMS\r\n* Disable external storage',
    description:
      'Twilio failed to upload the recording file to the external AWS S3 bucket specified in Voice Settings due to access denied. The recording file has been deleted, and the resource has been marked as “failed”.',
    product: 'Programmable Voice',
    date_created: '2021-11-17T18:53:47Z',
    last_updated: '2022-03-30T17:17:54.377047Z',
  },
  54250: {
    code: 54250,
    message: 'Message Stream not found',
    log_level: 'ERROR',
    secondary_message: 'The specified Message Stream does not exist.',
    log_type: null,
    docs: '\n## Error - 54250\n\n### Sync: Message Stream not found\nThe specified Message Stream does not exist.\n\n#### Possible Causes\n* The supplied Message Stream SID is erroneous.\n* The requested Message Stream has been deleted.\n\n#### Possible Solutions\nConfirm a valid Message Stream SID is being passed in your request.\n',
    causes: null,
    solutions: null,
    description: null,
    product: 'Sync',
    date_created: '2017-09-04T00:00:00Z',
    last_updated: '2020-08-04T10:00:17.382Z',
  },
  13216: {
    code: 13216,
    message: 'Invalid timeLimit value',
    log_level: 'WARNING',
    secondary_message:
      "timeLimit must be a positive integer, in seconds. See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.",
    log_type: 'APPLICATION',
    docs: "## WARNING - 13216\r\n\r\n### Invalid timeLimit value\r\n\r\ntimeLimit must be a positive integer, in seconds. See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information. ## Warning - 13216 \r\n\r\n### Invalid timeLimit value\r\n\r\ntimeLimit must be a positive integer, in seconds. See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\ntimeLimit must be a positive integer, in seconds.\r\n\r\n#### Possible Solutions\r\nSee the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.",
    causes: 'timeLimit must be a positive integer, in seconds.',
    solutions:
      "See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.",
    description:
      "## Warning - 13216 \r\n\r\n### Invalid timeLimit value\r\n\r\ntimeLimit must be a positive integer, in seconds. See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.\r\n\r\n\r\n\r\n\r\n\r\n",
    product: 'Programmable Voice',
    date_created: '2016-03-31T17:13:33Z',
    last_updated: '2021-05-05T21:22:16.561Z',
  },
  30101: {
    code: 30101,
    message: 'Domain is unverified',
    log_level: 'ERROR',
    secondary_message: 'The domain has not been verified to work with Twilio Link Shortening.',
    log_type: 'APPLICATION',
    docs: '## ERROR - 30101\r\n\r\n### Domain is unverified\r\n\r\nThe domain has not been verified to work with Twilio Link Shortening. Domain need to be verified under your Organization through the Admin Center in order use it with Twilio Link Shortening.\r\n\r\n#### Possible Causes\r\nYou have yet to verify your Domain in Organization. You could be using the wrong Domain SID in your current request. \r\n\r\n#### Possible Solutions\r\nPlease verify the Domain you wish to use with Twilio Link Shortening. ',
    causes:
      'You have yet to verify your Domain in Organization. You could be using the wrong Domain SID in your current request. ',
    solutions: 'Please verify the Domain you wish to use with Twilio Link Shortening. ',
    description:
      'Domain need to be verified under your Organization through the Admin Center in order use it with Twilio Link Shortening.',
    product: 'Programmable SMS',
    date_created: '2020-04-22T20:23:26Z',
    last_updated: '2023-05-22T19:54:26.294822Z',
  },
  30630: {
    code: 30630,
    message: "Message couldn't be delivered",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 30630\r\n\r\n### Message couldn't be delivered\r\n\r\n Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n\r\n\r\n#### Possible Causes\r\nTBD\r\n\r\n#### Possible Solutions\r\nTBD",
    causes: 'TBD',
    solutions: 'TBD',
    description:
      'Message couldn’t be delivered to the destination number you are trying to reach temporarily.\r\n',
    product: 'Programmable Messaging',
    date_created: '2024-04-16T06:25:19Z',
    last_updated: '2024-04-16T06:25:19Z',
  },
  60241: {
    code: 60241,
    message: 'Static message required',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: '## WARNING - 60241\r\n\r\n### Static message required\r\n\r\n Your verification requires use static message\r\n\r\n#### Possible Causes\r\nSome countries have special requirements that can override the message to be compliant with the country thus forcing the use of static messages.\r\n\r\n#### Possible Solutions\r\nPlease contact the support team to validate the requirements needed to be compliant with the country and avoid the override of the message.',
    causes:
      'Some countries have special requirements that can override the message to be compliant with the country thus forcing the use of static messages.',
    solutions:
      'Please contact the support team to validate the requirements needed to be compliant with the country and avoid the override of the message.',
    description: 'Your verification requires use static message',
    product: 'Verify',
    date_created: '2023-11-03T19:28:30Z',
    last_updated: '2023-11-03T19:28:30Z',
  },
  90040: {
    code: 90040,
    message: "Broadcast 'MediaUrls' list has too many items",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90040\r\n\r\n### Broadcast 'MediaUrls' list has too many items\r\n\r\n Broadcast 'MediaUrls' list has too many items\r\n\r\n#### Possible Causes\r\nBroadcast request has too many 'MediaUrl' fields \r\n\r\n#### Possible Solutions\r\nUse fewer 'MediaUrl' fields in Broadcast request",
    causes: "Broadcast request has too many 'MediaUrl' fields ",
    solutions: "Use fewer 'MediaUrl' fields in Broadcast request",
    description: "Broadcast 'MediaUrls' list has too many items",
    product: null,
    date_created: '2020-12-11T15:56:24Z',
    last_updated: '2020-12-11T15:56:24Z',
  },
  60600: {
    code: 60600,
    message: 'Unprovisioned or out of coverage',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60600\r\n\r\n### Unprovisioned or out of coverage\r\n\r\n No information returned on the requested phone number\r\n\r\n#### Possible Causes\r\nPhone number provided is not assigned to a carrier based on our data sources; or the phone number is outside of the scope of our data coverage\r\n\r\n#### Possible Solutions\r\nConfirm with authoritative evidence that the phone number is valid and assigned to a carrier; then contact Support and let us know',
    causes:
      'Phone number provided is not assigned to a carrier based on our data sources; or the phone number is outside of the scope of our data coverage',
    solutions:
      'Confirm with authoritative evidence that the phone number is valid and assigned to a carrier; then contact Support and let us know',
    description: 'No information returned on the requested phone number',
    product: 'Lookup',
    date_created: '2017-11-27T20:24:04Z',
    last_updated: '2021-10-18T22:21:16.693335Z',
  },
  30025: {
    code: 30025,
    message: 'US A2P 10DLC - 50% T-Mobile Daily Message Limit Consumed',
    log_level: 'WARNING',
    secondary_message:
      'As part of the US A2P 10DLC initiative, T-Mobile has instituted a daily message limit. We’re sending you this warning to let you know that you have consumed 50% of your T-Mobile daily limit.',
    log_type: 'CARRIER',
    docs: '## WARNING - 30025\r\n\r\n### US A2P 10DLC - 50% T-Mobile Daily Message Limit Consumed\r\n\r\nAs part of the US A2P 10DLC initiative, T-Mobile has instituted a daily message limit. We’re sending you this warning to let you know that you have consumed 50% of your T-Mobile daily limit. Please note that this daily limit is based on the sum of SMS segments and MMS messages you send to T-Mobile subscribers on a 24-hour basis, and is reset daily at midnight PT. When you hit 100% of your daily message limit, you will start to receive error code 30023 for each subsequent message you send to T-Mobile. Those messages will not be delivered, and you must wait until midnight PT to resume message sending.\r\n\r\nFor more information on T-Mobile daily limit, please refer to [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more information on US A2P 10DLC, please refer to [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\nPlease disregard this warning if you have been approved for the unlimited tier via the [T-Mobile Special Business Review process](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC).\r\n\r\nPlease note that if you have multiple providers sending registered SMS or MMS to T-Mobile on your behalf, this warning might not be accurate.\r\n\r\n#### Possible Causes\r\n* You have consumed 50% of your T-Mobile daily message limit for the day.\r\n\r\n#### Possible Solutions\r\n* No action is required from you. \r\n* To view the warning and errors in the debugger, please visit [here](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n* To view your daily T-Mobile message limit, please visit [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1), select your US A2P brand, and view the  details of your TCR trust score (registered customers only).\r\n* To view your daily T-Mobile usage, please use the Messaging Insights tool.',
    causes: '* You have consumed 50% of your T-Mobile daily message limit for the day.',
    solutions:
      '* No action is required from you. \r\n* To view the warning and errors in the debugger, please visit [here](https://console.twilio.com/us1/monitor/logs/debugger/events?frameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26quickDate%3D24%26x-target-region%3Dus1%26bifrost%3Dtrue&currentFrameUrl=%2Fconsole%2Fdebugger%3F__override_layout__%3Dembed%26bifrost%3Dtrue%26quickDate%3D24%26x-target-region%3Dus1).\r\n* To view your daily T-Mobile message limit, please visit [Trust Hub - A2P Messaging](https://console.twilio.com/us1/account/trust-hub/a2p?frameUrl=%2Fconsole%2Ftrust-hub%2Fa2p-messaging%3Fx-target-region%3Dus1), select your US A2P brand, and view the  details of your TCR trust score (registered customers only).\r\n* To view your daily T-Mobile usage, please use the Messaging Insights tool.',
    description:
      'Please note that this daily limit is based on the sum of SMS segments and MMS messages you send to T-Mobile subscribers on a 24-hour basis, and is reset daily at midnight PT. When you hit 100% of your daily message limit, you will start to receive error code 30023 for each subsequent message you send to T-Mobile. Those messages will not be delivered, and you must wait until midnight PT to resume message sending.\r\n\r\nFor more information on T-Mobile daily limit, please refer to [T-Mobile daily message limits for long code messaging with A2P 10DLC](https://support.twilio.com/hc/en-us/articles/1260804800549-T-Mobile-daily-message-limits-for-long-code-messaging-with-A2P-10DLC). For more information on US A2P 10DLC, please refer to [US A2P 10DLC Documentation](https://support.twilio.com/hc/en-us/articles/1260800720410-What-is-A2P-10DLC-).\r\n\r\nPlease disregard this warning if you have been approved for the unlimited tier via the [T-Mobile Special Business Review process](https://support.twilio.com/hc/en-us/articles/4403550579739-T-Mobile-Special-Business-Review-for-A2P-10DLC).\r\n\r\nPlease note that if you have multiple providers sending registered SMS or MMS to T-Mobile on your behalf, this warning might not be accurate.',
    product: 'Programmable SMS',
    date_created: '2021-10-18T19:31:07Z',
    last_updated: '2021-12-08T19:21:39.251951Z',
  },
  60210: {
    code: 60210,
    message: 'Max Buckets per Rate limit reached',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60210\r\n\r\n### Max Buckets per Rate limit reached\r\n\r\n Your Rate limit has reached the max number of Buckets\r\n\r\nHTTP status: 400\r\n\r\n#### Possible Causes\r\nYour Rate limit has reached the max number of Buckets\r\n\r\n#### Possible Solutions\r\n* Delete/update Buckets that you are not using at the moment\r\n* Create a new Rate limit and add the desired Buckets to the new Rate limit',
    causes: 'Your Rate limit has reached the max number of Buckets',
    solutions:
      '* Delete/update Buckets that you are not using at the moment\r\n* Create a new Rate limit and add the desired Buckets to the new Rate limit',
    description: 'Your Rate limit has reached the max number of Buckets\r\n\r\nHTTP status: 400',
    product: 'Verify',
    date_created: '2019-05-08T15:26:21Z',
    last_updated: '2021-05-18T04:42:43.095Z',
  },
  63014: {
    code: 63014,
    message: 'Channel message blocked by user action',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: null,
    docs: '### Channel message blocked by user action\r\n\r\n#### Possible Causes \r\n*   This message failed to be delivered to the user because it was blocked by some action on their part.  Please see Channel specific error message for more information.',
    causes: null,
    solutions: null,
    description: null,
    product: 'Programmable SMS',
    date_created: '2018-03-17T00:28:57Z',
    last_updated: '2020-08-04T10:00:14.399Z',
  },
  90021: {
    code: 90021,
    message: "One of 'TemplateArgs' dictionary key is too long",
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: "## ERROR - 90021\r\n\r\n### One of 'TemplateArgs' dictionary key is too long\r\n\r\n One of 'TemplateArgs' dictionary key is too long\r\n\r\n#### Possible Causes\r\nOne of 'TemplateArgs' dictionary key is too long\r\n\r\n#### Possible Solutions\r\nUse shorter 'TemplateArgs' dictionary keys",
    causes: "One of 'TemplateArgs' dictionary key is too long",
    solutions: "Use shorter 'TemplateArgs' dictionary keys",
    description: "One of 'TemplateArgs' dictionary key is too long",
    product: null,
    date_created: '2020-12-11T08:47:19Z',
    last_updated: '2020-12-11T08:47:19Z',
  },
  84000: {
    code: 84000,
    message: 'Execution has exceeded max steps allowed for a flow.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 84000\r\n\r\n### Execution has exceeded max steps allowed for a flow.\r\n\r\n This limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.\r\n\r\n#### Possible Causes\r\nThere are too many steps in the flow\r\n\r\n#### Possible Solutions\r\nReduce the number of steps in your flow.',
    causes: 'There are too many steps in the flow',
    solutions: 'Reduce the number of steps in your flow.',
    description:
      'This limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.',
    product: null,
    date_created: '2024-01-10T18:07:41Z',
    last_updated: '2024-01-10T18:07:46.689618Z',
  },
  14218: {
    code: 14218,
    message: 'Dial->Queue: Could not update worker to provided activity',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 14218\r\n\r\n### Dial->Queue: Could not update worker to provided activity\r\n\r\n Unable to update external user queue\r\n\r\n#### Possible Causes\r\nUnable to update the external user queue\r\n\r\n#### Possible Solutions\r\nCheck network or connectivity on external queue',
    causes: 'Unable to update the external user queue',
    solutions: 'Check network or connectivity on external queue',
    description: 'Unable to update external user queue',
    product: 'Programmable Voice',
    date_created: '2020-03-10T23:58:24Z',
    last_updated: '2020-08-04T10:00:04.308Z',
  },
  60327: {
    code: 60327,
    message:
      'The provided channel is not supported by the given template. Verify is falling back to the static message.',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'TWILIO',
    docs: "## WARNING - 60327\r\n\r\n### The provided channel is not supported by the given template. Verify is falling back to the static message.\r\n\r\n The template you are using does not support the channel you specified. The static message fallback was used.\r\n\r\n#### Possible Causes\r\nThe template provided doesn't support the specified channel.\r\n\r\n#### Possible Solutions\r\nIf you want to add the provided channel for the given template, please contact support.",
    causes: "The template provided doesn't support the specified channel.",
    solutions:
      'If you want to add the provided channel for the given template, please contact support.',
    description:
      'The template you are using does not support the channel you specified. The static message fallback was used.',
    product: 'Verify',
    date_created: '2023-11-17T12:43:56Z',
    last_updated: '2023-11-17T12:43:56Z',
  },
  80401: {
    code: 80401,
    message: 'Account Sid Invalid',
    log_level: 'WARNING',
    secondary_message: 'Invalid Account Sid',
    log_type: null,
    docs: '## Warning\n\n### Account Sid Invalid\n\nExample Message: Invalid Account Sid',
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2017-12-05T22:32:03Z',
    last_updated: '2020-08-04T10:00:16.035Z',
  },
  13325: {
    code: 13325,
    message: 'Gather->Play: Invalid Content-Type',
    log_level: 'ERROR',
    secondary_message: 'Play requires an audio Content-Type',
    log_type: null,
    docs: "## Error - 13325 \n\n### Gather->Play: Invalid Content-Type\n\nPlay requires an audio Content-Type\n\n#### Possible Causes \n*  Play references a URL that does not return audio or is returning an invalid Content-Type.\n\n\n#### Possible Solutions\n*  Make certain the URL returns an audio file\t\n*   See the <a href='/docs/api/twiml/play'>Play Verb</a> API Reference for more information on valid Content-Types.\t\n\n\n\n\n",
    causes: null,
    solutions: null,
    description: null,
    product: null,
    date_created: '2016-03-31T17:13:42Z',
    last_updated: '2020-08-04T10:00:28.028Z',
  },
  60711: {
    code: 60711,
    message: 'Business status does not allow updates',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 60711\r\n\r\n### Business status does not allow updates\r\n\r\n Businesses (AKA Business Profiles) can only be updated when they have certain status values. \r\n\r\n#### Possible Causes\r\nYou sent a *POST* request to update a business that is in status "Pending Verification" or "Verified"\r\n\r\n#### Possible Solutions\r\nIf you really need to update the business information, you can dismiss its current status (this action will update the status to "Draft") and then you can POST the update ',
    causes:
      'You sent a *POST* request to update a business that is in status "Pending Verification" or "Verified"',
    solutions:
      'If you really need to update the business information, you can dismiss its current status (this action will update the status to "Draft") and then you can POST the update ',
    description:
      'Businesses (AKA Business Profiles) can only be updated when they have certain status values. ',
    product: 'Branded Comms',
    date_created: '2020-01-24T16:11:29Z',
    last_updated: '2020-08-04T10:00:05.014Z',
  },
  45204: {
    code: 45204,
    message: 'Requested Flex Chat Channel is not found',
    log_level: 'WARNING',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## WARNING - 45204\r\n\r\n### Requested Flex Chat Channel is not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nFlex Channel could not be found. \r\n\r\n#### Possible Solutions\r\nPlease check your request details. Flex Channel is created automatically on inbound messages and can be created by developer via Flex API for outbound use cases.\r\n\r\nCheck our [Flex Chat Channel Resource documentation](https://www.twilio.com/docs/flex/developer/messaging/chat-channel), or see how to [add a Custom Chat Channel to Flex](https://www.twilio.com/blog/add-custom-chat-channel-twilio-flex).',
    causes: 'Flex Channel could not be found. ',
    solutions:
      'Please check your request details. Flex Channel is created automatically on inbound messages and can be created by developer via Flex API for outbound use cases.\r\n\r\nCheck our [Flex Chat Channel Resource documentation](https://www.twilio.com/docs/flex/developer/messaging/chat-channel), or see how to [add a Custom Chat Channel to Flex](https://www.twilio.com/blog/add-custom-chat-channel-twilio-flex).',
    description: null,
    product: 'Flex',
    date_created: '2019-07-08T11:50:13Z',
    last_updated: '2023-08-01T13:21:09.470037Z',
  },
  22226: {
    code: 22226,
    message: 'Cannot replace Items from Bundle to same Bundle',
    log_level: 'ERROR',
    secondary_message: null,
    log_type: 'APPLICATION',
    docs: '## ERROR - 22226\r\n\r\n### Cannot replace Items from Bundle to same Bundle\r\n\r\n From FromBundleSid cannot be the same Bundle as in URI request.\r\n\r\n#### Possible Causes\r\nThe same FromBundleSid is being used in both the URI and the From Bundle.\r\n\r\n#### Possible Solutions\r\nPlease ensure From FromBundleSid is Copy of the provisioning Bundle.',
    causes: 'The same FromBundleSid is being used in both the URI and the From Bundle.',
    solutions: 'Please ensure From FromBundleSid is Copy of the provisioning Bundle.',
    description: 'From FromBundleSid cannot be the same Bundle as in URI request.',
    product: 'Phone Numbers',
    date_created: '2022-03-10T23:37:53Z',
    last_updated: '2022-03-10T23:37:53Z',
  },
};
